const epsgs = [
  {
    "srs_id": 1,
    "description": "Anguilla 1957 / British West Indies Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2000,
    "auth_name": "EPSG",
    "auth_id": "2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2,
    "description": "Antigua 1943 / British West Indies Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2001,
    "auth_name": "EPSG",
    "auth_id": "2001",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3,
    "description": "Dominica 1945 / British West Indies Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=725,685,536,0,0,0,0 +units=m +no_defs",
    "srid": 2002,
    "auth_name": "EPSG",
    "auth_id": "2002",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 4,
    "description": "Grenada 1953 / British West Indies Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2003,
    "auth_name": "EPSG",
    "auth_id": "2003",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 5,
    "description": "Montserrat 1958 / British West Indies Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=174,359,365,0,0,0,0 +units=m +no_defs",
    "srid": 2004,
    "auth_name": "EPSG",
    "auth_id": "2004",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 6,
    "description": "St. Kitts 1955 / British West Indies Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2005,
    "auth_name": "EPSG",
    "auth_id": "2005",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 7,
    "description": "St. Lucia 1955 / British West Indies Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2006,
    "auth_name": "EPSG",
    "auth_id": "2006",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 8,
    "description": "St. Vincent 45 / British West Indies Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=195.671,332.517,274.607,0,0,0,0 +units=m +no_defs",
    "srid": 2007,
    "auth_name": "EPSG",
    "auth_id": "2007",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10,
    "description": "NAD27(CGQ77) / SCoPQ zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2009,
    "auth_name": "EPSG",
    "auth_id": "2009",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 11,
    "description": "NAD27(CGQ77) / SCoPQ zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2010,
    "auth_name": "EPSG",
    "auth_id": "2010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 12,
    "description": "NAD27(CGQ77) / SCoPQ zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2011,
    "auth_name": "EPSG",
    "auth_id": "2011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 13,
    "description": "NAD27(CGQ77) / SCoPQ zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2012,
    "auth_name": "EPSG",
    "auth_id": "2012",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 14,
    "description": "NAD27(CGQ77) / SCoPQ zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2013,
    "auth_name": "EPSG",
    "auth_id": "2013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 15,
    "description": "NAD27(CGQ77) / SCoPQ zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2014,
    "auth_name": "EPSG",
    "auth_id": "2014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 16,
    "description": "NAD27(CGQ77) / SCoPQ zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2015,
    "auth_name": "EPSG",
    "auth_id": "2015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 17,
    "description": "NAD27(CGQ77) / SCoPQ zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2016,
    "auth_name": "EPSG",
    "auth_id": "2016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 18,
    "description": "NAD27(76) / MTM zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2017,
    "auth_name": "EPSG",
    "auth_id": "2017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 19,
    "description": "NAD27(76) / MTM zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2018,
    "auth_name": "EPSG",
    "auth_id": "2018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 20,
    "description": "NAD27(76) / MTM zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2019,
    "auth_name": "EPSG",
    "auth_id": "2019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 21,
    "description": "NAD27(76) / MTM zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2020,
    "auth_name": "EPSG",
    "auth_id": "2020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 22,
    "description": "NAD27(76) / MTM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2021,
    "auth_name": "EPSG",
    "auth_id": "2021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 23,
    "description": "NAD27(76) / MTM zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2022,
    "auth_name": "EPSG",
    "auth_id": "2022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 24,
    "description": "NAD27(76) / MTM zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2023,
    "auth_name": "EPSG",
    "auth_id": "2023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 25,
    "description": "NAD27(76) / MTM zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2024,
    "auth_name": "EPSG",
    "auth_id": "2024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 26,
    "description": "NAD27(76) / MTM zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2025,
    "auth_name": "EPSG",
    "auth_id": "2025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27,
    "description": "NAD27(76) / MTM zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2026,
    "auth_name": "EPSG",
    "auth_id": "2026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28,
    "description": "NAD27(76) / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=15 +ellps=clrk66 +units=m +no_defs",
    "srid": 2027,
    "auth_name": "EPSG",
    "auth_id": "2027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29,
    "description": "NAD27(76) / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=16 +ellps=clrk66 +units=m +no_defs",
    "srid": 2028,
    "auth_name": "EPSG",
    "auth_id": "2028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 30,
    "description": "NAD27(76) / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=17 +ellps=clrk66 +units=m +no_defs",
    "srid": 2029,
    "auth_name": "EPSG",
    "auth_id": "2029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 31,
    "description": "NAD27(76) / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=18 +ellps=clrk66 +units=m +no_defs",
    "srid": 2030,
    "auth_name": "EPSG",
    "auth_id": "2030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 32,
    "description": "NAD27(CGQ77) / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=17 +ellps=clrk66 +units=m +no_defs",
    "srid": 2031,
    "auth_name": "EPSG",
    "auth_id": "2031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 33,
    "description": "NAD27(CGQ77) / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=18 +ellps=clrk66 +units=m +no_defs",
    "srid": 2032,
    "auth_name": "EPSG",
    "auth_id": "2032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 34,
    "description": "NAD27(CGQ77) / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=19 +ellps=clrk66 +units=m +no_defs",
    "srid": 2033,
    "auth_name": "EPSG",
    "auth_id": "2033",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 35,
    "description": "NAD27(CGQ77) / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=20 +ellps=clrk66 +units=m +no_defs",
    "srid": 2034,
    "auth_name": "EPSG",
    "auth_id": "2034",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 36,
    "description": "NAD27(CGQ77) / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=21 +ellps=clrk66 +units=m +no_defs",
    "srid": 2035,
    "auth_name": "EPSG",
    "auth_id": "2035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 40,
    "description": "Israel 1993 / Israeli TM Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31.7343936111111 +lon_0=35.2045169444444 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +units=m +no_defs",
    "srid": 2039,
    "auth_name": "EPSG",
    "auth_id": "2039",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 41,
    "description": "Locodjo 1965 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=30 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2040,
    "auth_name": "EPSG",
    "auth_id": "2040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 42,
    "description": "Abidjan 1987 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=30 +a=6378249.145 +rf=293.465 +towgs84=-124.76,53,466.79,0,0,0,0 +units=m +no_defs",
    "srid": 2041,
    "auth_name": "EPSG",
    "auth_id": "2041",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 43,
    "description": "Locodjo 1965 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2042,
    "auth_name": "EPSG",
    "auth_id": "2042",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 44,
    "description": "Abidjan 1987 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +towgs84=-124.76,53,466.79,0,0,0,0 +units=m +no_defs",
    "srid": 2043,
    "auth_name": "EPSG",
    "auth_id": "2043",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 45,
    "description": "Hanoi 1972 / Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2044,
    "auth_name": "EPSG",
    "auth_id": "2044",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 46,
    "description": "Hanoi 1972 / Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2045,
    "auth_name": "EPSG",
    "auth_id": "2045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 47,
    "description": "CH1903+ / LV95",
    "projection_acronym": "somerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=somerc +lat_0=46.9524055555556 +lon_0=7.43958333333333 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs",
    "srid": 2056,
    "auth_name": "EPSG",
    "auth_id": "2056",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 48,
    "description": "Rassadiran / Nakhl e Taqi",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=omerc +lat_0=27.5188288055556 +lonc=52.6035391666667 +alpha=0.571661194444444 +gamma=0.571661194444444 +k=0.999895934 +x_0=658377.437 +y_0=3044969.194 +ellps=intl +towgs84=-133.63,-157.5,-158.62,0,0,0,0 +units=m +no_defs",
    "srid": 2057,
    "auth_name": "EPSG",
    "auth_id": "2057",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 49,
    "description": "ED50(ED77) / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +ellps=intl +units=m +no_defs",
    "srid": 2058,
    "auth_name": "EPSG",
    "auth_id": "2058",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 50,
    "description": "ED50(ED77) / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=39 +ellps=intl +units=m +no_defs",
    "srid": 2059,
    "auth_name": "EPSG",
    "auth_id": "2059",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 51,
    "description": "ED50(ED77) / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=40 +ellps=intl +units=m +no_defs",
    "srid": 2060,
    "auth_name": "EPSG",
    "auth_id": "2060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 52,
    "description": "ED50(ED77) / UTM zone 41N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=41 +ellps=intl +units=m +no_defs",
    "srid": 2061,
    "auth_name": "EPSG",
    "auth_id": "2061",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 53,
    "description": "Madrid 1870 (Madrid) / Spain LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=40 +lat_0=40 +lon_0=0 +k_0=0.9988085293 +x_0=600000 +y_0=600000 +a=6378298.3 +rf=294.73 +pm=-3.687375 +units=m +no_defs",
    "srid": 2062,
    "auth_name": "EPSG",
    "auth_id": "2062",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 56,
    "description": "S-JTSK (Ferro) / Krovak",
    "projection_acronym": "krovak",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=krovak +axis=swu +lat_0=49.5 +lon_0=42.5 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs",
    "srid": 2065,
    "auth_name": "EPSG",
    "auth_id": "2065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 57,
    "description": "Mount Dillon / Tobago Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=11.2521786111111 +lon_0=-60.6860088888889 +x_0=37718.66159325 +y_0=36209.91512952 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.201166195164 +no_defs",
    "srid": 2066,
    "auth_name": "EPSG",
    "auth_id": "2066",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 58,
    "description": "Naparima 1955 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 2067,
    "auth_name": "EPSG",
    "auth_id": "2067",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 59,
    "description": "ELD79 / Libya zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2068,
    "auth_name": "EPSG",
    "auth_id": "2068",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60,
    "description": "ELD79 / Libya zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2069,
    "auth_name": "EPSG",
    "auth_id": "2069",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61,
    "description": "ELD79 / Libya zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2070,
    "auth_name": "EPSG",
    "auth_id": "2070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62,
    "description": "ELD79 / Libya zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2071,
    "auth_name": "EPSG",
    "auth_id": "2071",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63,
    "description": "ELD79 / Libya zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2072,
    "auth_name": "EPSG",
    "auth_id": "2072",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64,
    "description": "ELD79 / Libya zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2073,
    "auth_name": "EPSG",
    "auth_id": "2073",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65,
    "description": "ELD79 / Libya zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2074,
    "auth_name": "EPSG",
    "auth_id": "2074",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66,
    "description": "ELD79 / Libya zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2075,
    "auth_name": "EPSG",
    "auth_id": "2075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67,
    "description": "ELD79 / Libya zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=25 +k=0.9999 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2076,
    "auth_name": "EPSG",
    "auth_id": "2076",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 68,
    "description": "ELD79 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2077,
    "auth_name": "EPSG",
    "auth_id": "2077",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 69,
    "description": "ELD79 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=33 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2078,
    "auth_name": "EPSG",
    "auth_id": "2078",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 70,
    "description": "ELD79 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=34 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2079,
    "auth_name": "EPSG",
    "auth_id": "2079",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 71,
    "description": "ELD79 / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=35 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2080,
    "auth_name": "EPSG",
    "auth_id": "2080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 72,
    "description": "Chos Malal 1914 / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2081,
    "auth_name": "EPSG",
    "auth_id": "2081",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 73,
    "description": "Pampa del Castillo / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2082,
    "auth_name": "EPSG",
    "auth_id": "2082",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 74,
    "description": "Hito XVIII 1963 / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2083,
    "auth_name": "EPSG",
    "auth_id": "2083",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 75,
    "description": "Hito XVIII 1963 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=19 +south +ellps=intl +units=m +no_defs",
    "srid": 2084,
    "auth_name": "EPSG",
    "auth_id": "2084",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 78,
    "description": "ELD79 / TM 12 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-115.8543,-99.0583,-152.4616,0,0,0,0 +units=m +no_defs",
    "srid": 2087,
    "auth_name": "EPSG",
    "auth_id": "2087",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 79,
    "description": "Carthage / TM 11 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +towgs84=-260.1,5.5,432.2,0,0,0,0 +units=m +no_defs",
    "srid": 2088,
    "auth_name": "EPSG",
    "auth_id": "2088",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 80,
    "description": "Yemen NGN96 / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=38 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2089,
    "auth_name": "EPSG",
    "auth_id": "2089",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 81,
    "description": "Yemen NGN96 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=39 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2090,
    "auth_name": "EPSG",
    "auth_id": "2090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 84,
    "description": "Hanoi 1972 / GK 106 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=106 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=-17.51,-108.32,-62.39,0,0,0,0 +units=m +no_defs",
    "srid": 2093,
    "auth_name": "EPSG",
    "auth_id": "2093",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 85,
    "description": "WGS 72BE / TM 106 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 2094,
    "auth_name": "EPSG",
    "auth_id": "2094",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 86,
    "description": "Bissau / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=28 +ellps=intl +towgs84=-173,253,27,0,0,0,0 +units=m +no_defs",
    "srid": 2095,
    "auth_name": "EPSG",
    "auth_id": "2095",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 87,
    "description": "Korean 1985 / East Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 2096,
    "auth_name": "EPSG",
    "auth_id": "2096",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 88,
    "description": "Korean 1985 / Central Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 2097,
    "auth_name": "EPSG",
    "auth_id": "2097",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 89,
    "description": "Korean 1985 / West Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 2098,
    "auth_name": "EPSG",
    "auth_id": "2098",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 90,
    "description": "Qatar 1948 / Qatar Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=cass +lat_0=25.3823611111111 +lon_0=50.7613888888889 +x_0=100000 +y_0=100000 +ellps=helmert +units=m +no_defs",
    "srid": 2099,
    "auth_name": "EPSG",
    "auth_id": "2099",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 91,
    "description": "GGRS87 / Greek Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=-199.87,74.79,246.62,0,0,0,0 +units=m +no_defs",
    "srid": 2100,
    "auth_name": "EPSG",
    "auth_id": "2100",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 92,
    "description": "Lake / Maracaibo Grid M1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_1=10.1666666666667 +lat_0=10.1666666666667 +lon_0=-71.6056177777778 +k_0=1 +x_0=0 +y_0=-52684.972 +ellps=intl +units=m +no_defs",
    "srid": 2101,
    "auth_name": "EPSG",
    "auth_id": "2101",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 93,
    "description": "Lake / Maracaibo Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_1=10.1666666666667 +lat_0=10.1666666666667 +lon_0=-71.6056177777778 +k_0=1 +x_0=200000 +y_0=147315.028 +ellps=intl +units=m +no_defs",
    "srid": 2102,
    "auth_name": "EPSG",
    "auth_id": "2102",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 94,
    "description": "Lake / Maracaibo Grid M3",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_1=10.1666666666667 +lat_0=10.1666666666667 +lon_0=-71.6056177777778 +k_0=1 +x_0=500000 +y_0=447315.028 +ellps=intl +units=m +no_defs",
    "srid": 2103,
    "auth_name": "EPSG",
    "auth_id": "2103",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 95,
    "description": "Lake / Maracaibo La Rosa Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_1=10.1666666666667 +lat_0=10.1666666666667 +lon_0=-71.6056177777778 +k_0=1 +x_0=-17044 +y_0=-23139.97 +ellps=intl +units=m +no_defs",
    "srid": 2104,
    "auth_name": "EPSG",
    "auth_id": "2104",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 96,
    "description": "NZGD2000 / Mount Eden 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-36.8797222222222 +lon_0=174.764166666667 +k=0.9999 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2105,
    "auth_name": "EPSG",
    "auth_id": "2105",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 97,
    "description": "NZGD2000 / Bay of Plenty 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-37.7611111111111 +lon_0=176.466111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2106,
    "auth_name": "EPSG",
    "auth_id": "2106",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 98,
    "description": "NZGD2000 / Poverty Bay 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-38.6244444444444 +lon_0=177.885555555556 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2107,
    "auth_name": "EPSG",
    "auth_id": "2107",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 99,
    "description": "NZGD2000 / Hawkes Bay 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-39.6508333333333 +lon_0=176.673611111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2108,
    "auth_name": "EPSG",
    "auth_id": "2108",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 100,
    "description": "NZGD2000 / Taranaki 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-39.1355555555556 +lon_0=174.227777777778 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2109,
    "auth_name": "EPSG",
    "auth_id": "2109",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 101,
    "description": "NZGD2000 / Tuhirangi 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-39.5122222222222 +lon_0=175.64 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2110,
    "auth_name": "EPSG",
    "auth_id": "2110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 102,
    "description": "NZGD2000 / Wanganui 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-40.2419444444444 +lon_0=175.488055555556 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2111,
    "auth_name": "EPSG",
    "auth_id": "2111",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 103,
    "description": "NZGD2000 / Wairarapa 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-40.9252777777778 +lon_0=175.647222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2112,
    "auth_name": "EPSG",
    "auth_id": "2112",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 104,
    "description": "NZGD2000 / Wellington 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-41.3011111111111 +lon_0=174.776388888889 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2113,
    "auth_name": "EPSG",
    "auth_id": "2113",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 105,
    "description": "NZGD2000 / Collingwood 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-40.7147222222222 +lon_0=172.671944444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2114,
    "auth_name": "EPSG",
    "auth_id": "2114",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 106,
    "description": "NZGD2000 / Nelson 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-41.2744444444444 +lon_0=173.299166666667 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2115,
    "auth_name": "EPSG",
    "auth_id": "2115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 107,
    "description": "NZGD2000 / Karamea 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-41.2897222222222 +lon_0=172.108888888889 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2116,
    "auth_name": "EPSG",
    "auth_id": "2116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 108,
    "description": "NZGD2000 / Buller 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-41.8105555555556 +lon_0=171.581111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2117,
    "auth_name": "EPSG",
    "auth_id": "2117",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 109,
    "description": "NZGD2000 / Grey 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-42.3336111111111 +lon_0=171.549722222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2118,
    "auth_name": "EPSG",
    "auth_id": "2118",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 110,
    "description": "NZGD2000 / Amuri 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-42.6888888888889 +lon_0=173.01 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2119,
    "auth_name": "EPSG",
    "auth_id": "2119",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 111,
    "description": "NZGD2000 / Marlborough 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-41.5444444444444 +lon_0=173.801944444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2120,
    "auth_name": "EPSG",
    "auth_id": "2120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 112,
    "description": "NZGD2000 / Hokitika 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-42.8861111111111 +lon_0=170.979722222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2121,
    "auth_name": "EPSG",
    "auth_id": "2121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 113,
    "description": "NZGD2000 / Okarito 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-43.11 +lon_0=170.260833333333 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2122,
    "auth_name": "EPSG",
    "auth_id": "2122",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 114,
    "description": "NZGD2000 / Jacksons Bay 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-43.9777777777778 +lon_0=168.606111111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2123,
    "auth_name": "EPSG",
    "auth_id": "2123",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 115,
    "description": "NZGD2000 / Mount Pleasant 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-43.5905555555556 +lon_0=172.726944444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2124,
    "auth_name": "EPSG",
    "auth_id": "2124",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 116,
    "description": "NZGD2000 / Gawler 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-43.7486111111111 +lon_0=171.360555555556 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2125,
    "auth_name": "EPSG",
    "auth_id": "2125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 117,
    "description": "NZGD2000 / Timaru 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-44.4019444444444 +lon_0=171.057222222222 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2126,
    "auth_name": "EPSG",
    "auth_id": "2126",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 118,
    "description": "NZGD2000 / Lindis Peak 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-44.735 +lon_0=169.4675 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2127,
    "auth_name": "EPSG",
    "auth_id": "2127",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 119,
    "description": "NZGD2000 / Mount Nicholas 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-45.1327777777778 +lon_0=168.398611111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2128,
    "auth_name": "EPSG",
    "auth_id": "2128",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 120,
    "description": "NZGD2000 / Mount York 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-45.5636111111111 +lon_0=167.738611111111 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2129,
    "auth_name": "EPSG",
    "auth_id": "2129",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 121,
    "description": "NZGD2000 / Observation Point 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-45.8161111111111 +lon_0=170.628333333333 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2130,
    "auth_name": "EPSG",
    "auth_id": "2130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 122,
    "description": "NZGD2000 / North Taieri 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-45.8613888888889 +lon_0=170.2825 +k=0.99996 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2131,
    "auth_name": "EPSG",
    "auth_id": "2131",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 123,
    "description": "NZGD2000 / Bluff 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-46.6 +lon_0=168.342777777778 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2132,
    "auth_name": "EPSG",
    "auth_id": "2132",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 124,
    "description": "NZGD2000 / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2133,
    "auth_name": "EPSG",
    "auth_id": "2133",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 125,
    "description": "NZGD2000 / UTM zone 59S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2134,
    "auth_name": "EPSG",
    "auth_id": "2134",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 126,
    "description": "NZGD2000 / UTM zone 60S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=60 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2135,
    "auth_name": "EPSG",
    "auth_id": "2135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 127,
    "description": "Accra / Ghana National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=4.66666666666667 +lon_0=-1 +k=0.99975 +x_0=274319.739163358 +y_0=0 +a=6378300 +rf=296 +towgs84=-170,33,326,0,0,0,0 +to_meter=0.304799710181509 +no_defs",
    "srid": 2136,
    "auth_name": "EPSG",
    "auth_id": "2136",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 128,
    "description": "Accra / TM 1 NW",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-1 +k=0.9996 +x_0=500000 +y_0=0 +a=6378300 +rf=296 +towgs84=-171.16,17.29,325.21,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 2137,
    "auth_name": "EPSG",
    "auth_id": "2137",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 129,
    "description": "NAD27(CGQ77) / Quebec Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 2138,
    "auth_name": "EPSG",
    "auth_id": "2138",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 145,
    "description": "RGF93 v1 / Lambert-93",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2154,
    "auth_name": "EPSG",
    "auth_id": "2154",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 148,
    "description": "IRENET95 / Irish Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2157,
    "auth_name": "EPSG",
    "auth_id": "2157",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 149,
    "description": "IRENET95 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2158,
    "auth_name": "EPSG",
    "auth_id": "2158",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 150,
    "description": "Sierra Leone 1924 / New Colony Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=6.66666666666667 +lon_0=-12 +k=1 +x_0=152399.855090754 +y_0=0 +a=6378300 +rf=296 +to_meter=0.304799710181509 +no_defs",
    "srid": 2159,
    "auth_name": "EPSG",
    "auth_id": "2159",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 151,
    "description": "Sierra Leone 1924 / New War Office Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=6.66666666666667 +lon_0=-12 +k=1 +x_0=243839.768145207 +y_0=182879.826108905 +a=6378300 +rf=296 +to_meter=0.304799710181509 +no_defs",
    "srid": 2160,
    "auth_name": "EPSG",
    "auth_id": "2160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 152,
    "description": "Sierra Leone 1968 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=28 +a=6378249.145 +rf=293.465 +towgs84=-88,4,101,0,0,0,0 +units=m +no_defs",
    "srid": 2161,
    "auth_name": "EPSG",
    "auth_id": "2161",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 153,
    "description": "Sierra Leone 1968 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +towgs84=-88,4,101,0,0,0,0 +units=m +no_defs",
    "srid": 2162,
    "auth_name": "EPSG",
    "auth_id": "2162",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 155,
    "description": "Locodjo 1965 / TM 5 NW",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-5 +k=0.9996 +x_0=500000 +y_0=0 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2164,
    "auth_name": "EPSG",
    "auth_id": "2164",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 156,
    "description": "Abidjan 1987 / TM 5 NW",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-5 +k=0.9996 +x_0=500000 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=-123.1,53.2,465.4,0,0,0,0 +units=m +no_defs",
    "srid": 2165,
    "auth_name": "EPSG",
    "auth_id": "2165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 160,
    "description": "LUREF / Luxembourg TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +towgs84=-189.6806,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598 +units=m +no_defs",
    "srid": 2169,
    "auth_name": "EPSG",
    "auth_id": "2169",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 163,
    "description": "Pulkovo 1942(58) / Poland zone II",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=sterea +lat_0=53.0019444444444 +lon_0=21.5027777777778 +k=0.9998 +x_0=4603000 +y_0=5806000 +ellps=krass +units=m +no_defs",
    "srid": 2172,
    "auth_name": "EPSG",
    "auth_id": "2172",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 164,
    "description": "Pulkovo 1942(58) / Poland zone III",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=sterea +lat_0=53.5833333333333 +lon_0=17.0083333333333 +k=0.9998 +x_0=3501000 +y_0=5999000 +ellps=krass +units=m +no_defs",
    "srid": 2173,
    "auth_name": "EPSG",
    "auth_id": "2173",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 165,
    "description": "Pulkovo 1942(58) / Poland zone IV",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=sterea +lat_0=51.6708333333333 +lon_0=16.6722222222222 +k=0.9998 +x_0=3703000 +y_0=5627000 +ellps=krass +units=m +no_defs",
    "srid": 2174,
    "auth_name": "EPSG",
    "auth_id": "2174",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 166,
    "description": "Pulkovo 1942(58) / Poland zone V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18.9583333333333 +k=0.999983 +x_0=237000 +y_0=-4700000 +ellps=krass +units=m +no_defs",
    "srid": 2175,
    "auth_name": "EPSG",
    "auth_id": "2175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 167,
    "description": "ETRF2000-PL / CS2000/15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2176,
    "auth_name": "EPSG",
    "auth_id": "2176",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 168,
    "description": "ETRF2000-PL / CS2000/18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2177,
    "auth_name": "EPSG",
    "auth_id": "2177",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 169,
    "description": "ETRF2000-PL / CS2000/21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2178,
    "auth_name": "EPSG",
    "auth_id": "2178",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 170,
    "description": "ETRF2000-PL / CS2000/24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2179,
    "auth_name": "EPSG",
    "auth_id": "2179",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 171,
    "description": "ETRF2000-PL / CS92",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2180,
    "auth_name": "EPSG",
    "auth_id": "2180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 172,
    "description": "Azores Occidental 1939 / UTM zone 25N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=25 +ellps=intl +units=m +no_defs",
    "srid": 2188,
    "auth_name": "EPSG",
    "auth_id": "2188",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 173,
    "description": "Azores Central 1948 / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=26 +ellps=intl +towgs84=-104,167,-38,0,0,0,0 +units=m +no_defs",
    "srid": 2189,
    "auth_name": "EPSG",
    "auth_id": "2189",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 174,
    "description": "Azores Oriental 1940 / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=26 +ellps=intl +towgs84=-203,141,53,0,0,0,0 +units=m +no_defs",
    "srid": 2190,
    "auth_name": "EPSG",
    "auth_id": "2190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 177,
    "description": "NZGD2000 / New Zealand Transverse Mercator 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2193,
    "auth_name": "EPSG",
    "auth_id": "2193",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 179,
    "description": "NAD83(HARN) / UTM zone 2S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=2 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2195,
    "auth_name": "EPSG",
    "auth_id": "2195",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 180,
    "description": "ETRS89 / Kp2000 Jutland",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2196,
    "auth_name": "EPSG",
    "auth_id": "2196",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 181,
    "description": "ETRS89 / Kp2000 Zealand",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2197,
    "auth_name": "EPSG",
    "auth_id": "2197",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 182,
    "description": "ETRS89 / Kp2000 Bornholm",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2198,
    "auth_name": "EPSG",
    "auth_id": "2198",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 184,
    "description": "ATS77 / New Brunswick Stereographic (ATS77)",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "",
    "parameters": "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=300000 +y_0=800000 +a=6378135 +rf=298.257 +units=m +no_defs",
    "srid": 2200,
    "auth_name": "EPSG",
    "auth_id": "2200",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 185,
    "description": "REGVEN / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2201,
    "auth_name": "EPSG",
    "auth_id": "2201",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 186,
    "description": "REGVEN / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2202,
    "auth_name": "EPSG",
    "auth_id": "2202",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 187,
    "description": "REGVEN / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2203,
    "auth_name": "EPSG",
    "auth_id": "2203",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 188,
    "description": "NAD27 / Tennessee",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=34.6666666666667 +lon_0=-86 +lat_1=35.25 +lat_2=36.4166666666667 +x_0=609601.219202438 +y_0=30480.0609601219 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 2204,
    "auth_name": "EPSG",
    "auth_id": "2204",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 189,
    "description": "NAD83 / Kentucky North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2205,
    "auth_name": "EPSG",
    "auth_id": "2205",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 190,
    "description": "ED50 / 3-degree Gauss-Kruger zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2206,
    "auth_name": "EPSG",
    "auth_id": "2206",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 191,
    "description": "ED50 / 3-degree Gauss-Kruger zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2207,
    "auth_name": "EPSG",
    "auth_id": "2207",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 192,
    "description": "ED50 / 3-degree Gauss-Kruger zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2208,
    "auth_name": "EPSG",
    "auth_id": "2208",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 193,
    "description": "ED50 / 3-degree Gauss-Kruger zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2209,
    "auth_name": "EPSG",
    "auth_id": "2209",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 194,
    "description": "ED50 / 3-degree Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2210,
    "auth_name": "EPSG",
    "auth_id": "2210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 195,
    "description": "ED50 / 3-degree Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=intl +towgs84=-84.1,-101.8,-129.7,0,0,0.468,1.05 +units=m +no_defs",
    "srid": 2211,
    "auth_name": "EPSG",
    "auth_id": "2211",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 196,
    "description": "ED50 / 3-degree Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=intl +towgs84=-84.1,-101.8,-129.7,0,0,0.468,1.05 +units=m +no_defs",
    "srid": 2212,
    "auth_name": "EPSG",
    "auth_id": "2212",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 197,
    "description": "ETRS89 / TM 30 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2213,
    "auth_name": "EPSG",
    "auth_id": "2213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 199,
    "description": "Manoca 1962 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=32 +ellps=clrk80ign +towgs84=-70.9,-151.8,-41.4,0,0,0,0 +units=m +no_defs",
    "srid": 2215,
    "auth_name": "EPSG",
    "auth_id": "2215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 200,
    "description": "Qornoq 1927 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +ellps=intl +units=m +no_defs",
    "srid": 2216,
    "auth_name": "EPSG",
    "auth_id": "2216",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 201,
    "description": "Qornoq 1927 / UTM zone 23N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=23 +ellps=intl +units=m +no_defs",
    "srid": 2217,
    "auth_name": "EPSG",
    "auth_id": "2217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 202,
    "description": "ATS77 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=19 +a=6378135 +rf=298.257 +units=m +no_defs",
    "srid": 2219,
    "auth_name": "EPSG",
    "auth_id": "2219",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 203,
    "description": "ATS77 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=20 +a=6378135 +rf=298.257 +units=m +no_defs",
    "srid": 2220,
    "auth_name": "EPSG",
    "auth_id": "2220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 204,
    "description": "NAD83 / Arizona East (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2222,
    "auth_name": "EPSG",
    "auth_id": "2222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 205,
    "description": "NAD83 / Arizona Central (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2223,
    "auth_name": "EPSG",
    "auth_id": "2223",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 206,
    "description": "NAD83 / Arizona West (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2224,
    "auth_name": "EPSG",
    "auth_id": "2224",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 207,
    "description": "NAD83 / California zone 1 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2225,
    "auth_name": "EPSG",
    "auth_id": "2225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 208,
    "description": "NAD83 / California zone 2 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2226,
    "auth_name": "EPSG",
    "auth_id": "2226",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 209,
    "description": "NAD83 / California zone 3 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2227,
    "auth_name": "EPSG",
    "auth_id": "2227",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 210,
    "description": "NAD83 / California zone 4 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2228,
    "auth_name": "EPSG",
    "auth_id": "2228",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 211,
    "description": "NAD83 / California zone 5 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2229,
    "auth_name": "EPSG",
    "auth_id": "2229",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 212,
    "description": "NAD83 / California zone 6 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2230,
    "auth_name": "EPSG",
    "auth_id": "2230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 213,
    "description": "NAD83 / Colorado North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2231,
    "auth_name": "EPSG",
    "auth_id": "2231",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 214,
    "description": "NAD83 / Colorado Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2232,
    "auth_name": "EPSG",
    "auth_id": "2232",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 215,
    "description": "NAD83 / Colorado South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2233,
    "auth_name": "EPSG",
    "auth_id": "2233",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 216,
    "description": "NAD83 / Connecticut (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2234,
    "auth_name": "EPSG",
    "auth_id": "2234",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 217,
    "description": "NAD83 / Delaware (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2235,
    "auth_name": "EPSG",
    "auth_id": "2235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 218,
    "description": "NAD83 / Florida East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2236,
    "auth_name": "EPSG",
    "auth_id": "2236",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 219,
    "description": "NAD83 / Florida West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2237,
    "auth_name": "EPSG",
    "auth_id": "2237",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 220,
    "description": "NAD83 / Florida North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2238,
    "auth_name": "EPSG",
    "auth_id": "2238",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 221,
    "description": "NAD83 / Georgia East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2239,
    "auth_name": "EPSG",
    "auth_id": "2239",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 222,
    "description": "NAD83 / Georgia West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2240,
    "auth_name": "EPSG",
    "auth_id": "2240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 223,
    "description": "NAD83 / Idaho East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2241,
    "auth_name": "EPSG",
    "auth_id": "2241",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 224,
    "description": "NAD83 / Idaho Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2242,
    "auth_name": "EPSG",
    "auth_id": "2242",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 225,
    "description": "NAD83 / Idaho West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2243,
    "auth_name": "EPSG",
    "auth_id": "2243",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 228,
    "description": "NAD83 / Kentucky North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2246,
    "auth_name": "EPSG",
    "auth_id": "2246",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 229,
    "description": "NAD83 / Kentucky South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2247,
    "auth_name": "EPSG",
    "auth_id": "2247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 230,
    "description": "NAD83 / Maryland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2248,
    "auth_name": "EPSG",
    "auth_id": "2248",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 231,
    "description": "NAD83 / Massachusetts Mainland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2249,
    "auth_name": "EPSG",
    "auth_id": "2249",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 232,
    "description": "NAD83 / Massachusetts Island (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2250,
    "auth_name": "EPSG",
    "auth_id": "2250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 233,
    "description": "NAD83 / Michigan North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2251,
    "auth_name": "EPSG",
    "auth_id": "2251",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 234,
    "description": "NAD83 / Michigan Central (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2252,
    "auth_name": "EPSG",
    "auth_id": "2252",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 235,
    "description": "NAD83 / Michigan South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2253,
    "auth_name": "EPSG",
    "auth_id": "2253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 236,
    "description": "NAD83 / Mississippi East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2254,
    "auth_name": "EPSG",
    "auth_id": "2254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 237,
    "description": "NAD83 / Mississippi West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2255,
    "auth_name": "EPSG",
    "auth_id": "2255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 238,
    "description": "NAD83 / Montana (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2256,
    "auth_name": "EPSG",
    "auth_id": "2256",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 239,
    "description": "NAD83 / New Mexico East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2257,
    "auth_name": "EPSG",
    "auth_id": "2257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 240,
    "description": "NAD83 / New Mexico Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2258,
    "auth_name": "EPSG",
    "auth_id": "2258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 241,
    "description": "NAD83 / New Mexico West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2259,
    "auth_name": "EPSG",
    "auth_id": "2259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 242,
    "description": "NAD83 / New York East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2260,
    "auth_name": "EPSG",
    "auth_id": "2260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 243,
    "description": "NAD83 / New York Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2261,
    "auth_name": "EPSG",
    "auth_id": "2261",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 244,
    "description": "NAD83 / New York West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2262,
    "auth_name": "EPSG",
    "auth_id": "2262",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 245,
    "description": "NAD83 / New York Long Island (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2263,
    "auth_name": "EPSG",
    "auth_id": "2263",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 246,
    "description": "NAD83 / North Carolina (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 2264,
    "auth_name": "EPSG",
    "auth_id": "2264",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 247,
    "description": "NAD83 / North Dakota North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2265,
    "auth_name": "EPSG",
    "auth_id": "2265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 248,
    "description": "NAD83 / North Dakota South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2266,
    "auth_name": "EPSG",
    "auth_id": "2266",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 249,
    "description": "NAD83 / Oklahoma North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2267,
    "auth_name": "EPSG",
    "auth_id": "2267",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 250,
    "description": "NAD83 / Oklahoma South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2268,
    "auth_name": "EPSG",
    "auth_id": "2268",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 251,
    "description": "NAD83 / Oregon North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2269,
    "auth_name": "EPSG",
    "auth_id": "2269",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 252,
    "description": "NAD83 / Oregon South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2270,
    "auth_name": "EPSG",
    "auth_id": "2270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 253,
    "description": "NAD83 / Pennsylvania North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2271,
    "auth_name": "EPSG",
    "auth_id": "2271",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 254,
    "description": "NAD83 / Pennsylvania South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2272,
    "auth_name": "EPSG",
    "auth_id": "2272",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 255,
    "description": "NAD83 / South Carolina (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +datum=NAD83 +units=ft +no_defs",
    "srid": 2273,
    "auth_name": "EPSG",
    "auth_id": "2273",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 256,
    "description": "NAD83 / Tennessee (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 2274,
    "auth_name": "EPSG",
    "auth_id": "2274",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 257,
    "description": "NAD83 / Texas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2275,
    "auth_name": "EPSG",
    "auth_id": "2275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 258,
    "description": "NAD83 / Texas North Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2276,
    "auth_name": "EPSG",
    "auth_id": "2276",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 259,
    "description": "NAD83 / Texas Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2277,
    "auth_name": "EPSG",
    "auth_id": "2277",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 260,
    "description": "NAD83 / Texas South Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2278,
    "auth_name": "EPSG",
    "auth_id": "2278",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 261,
    "description": "NAD83 / Texas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2279,
    "auth_name": "EPSG",
    "auth_id": "2279",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 262,
    "description": "NAD83 / Utah North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.0001504 +y_0=999999.999996 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2280,
    "auth_name": "EPSG",
    "auth_id": "2280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 263,
    "description": "NAD83 / Utah Central (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.0001504 +y_0=1999999.999992 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2281,
    "auth_name": "EPSG",
    "auth_id": "2281",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 264,
    "description": "NAD83 / Utah South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.0001504 +y_0=2999999.999988 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2282,
    "auth_name": "EPSG",
    "auth_id": "2282",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 265,
    "description": "NAD83 / Virginia North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2283,
    "auth_name": "EPSG",
    "auth_id": "2283",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 266,
    "description": "NAD83 / Virginia South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2284,
    "auth_name": "EPSG",
    "auth_id": "2284",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 267,
    "description": "NAD83 / Washington North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2285,
    "auth_name": "EPSG",
    "auth_id": "2285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 268,
    "description": "NAD83 / Washington South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2286,
    "auth_name": "EPSG",
    "auth_id": "2286",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 269,
    "description": "NAD83 / Wisconsin North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2287,
    "auth_name": "EPSG",
    "auth_id": "2287",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 270,
    "description": "NAD83 / Wisconsin Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2288,
    "auth_name": "EPSG",
    "auth_id": "2288",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 271,
    "description": "NAD83 / Wisconsin South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2289,
    "auth_name": "EPSG",
    "auth_id": "2289",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 272,
    "description": "ATS77 / Prince Edward Isl. Stereographic (ATS77)",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "",
    "parameters": "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=700000 +y_0=400000 +a=6378135 +rf=298.257 +units=m +no_defs",
    "srid": 2290,
    "auth_name": "EPSG",
    "auth_id": "2290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 275,
    "description": "ATS77 / MTM Nova Scotia zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=4500000 +y_0=0 +a=6378135 +rf=298.257 +units=m +no_defs",
    "srid": 2294,
    "auth_name": "EPSG",
    "auth_id": "2294",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 276,
    "description": "ATS77 / MTM Nova Scotia zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=5500000 +y_0=0 +a=6378135 +rf=298.257 +units=m +no_defs",
    "srid": 2295,
    "auth_name": "EPSG",
    "auth_id": "2295",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 277,
    "description": "Batavia / TM 109 SE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=109 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +towgs84=-378.873,676.002,-46.255,0,0,0,0 +units=m +no_defs",
    "srid": 2308,
    "auth_name": "EPSG",
    "auth_id": "2308",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 278,
    "description": "WGS 84 / TM 116 SE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=116 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs",
    "srid": 2309,
    "auth_name": "EPSG",
    "auth_id": "2309",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 279,
    "description": "WGS 84 / TM 132 SE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs",
    "srid": 2310,
    "auth_name": "EPSG",
    "auth_id": "2310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 280,
    "description": "WGS 84 / TM 6 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=6 +k=0.9996 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 2311,
    "auth_name": "EPSG",
    "auth_id": "2311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 281,
    "description": "Garoua / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=33 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2312,
    "auth_name": "EPSG",
    "auth_id": "2312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 282,
    "description": "Kousseri / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=33 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 2313,
    "auth_name": "EPSG",
    "auth_id": "2313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 283,
    "description": "Trinidad 1903 / Trinidad Grid (ftCla)",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=10.4416666666667 +lon_0=-61.3333333333333 +x_0=86501.46392052 +y_0=65379.0134283 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.3047972654 +no_defs",
    "srid": 2314,
    "auth_name": "EPSG",
    "auth_id": "2314",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 284,
    "description": "Campo Inchauspe / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=19 +south +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs",
    "srid": 2315,
    "auth_name": "EPSG",
    "auth_id": "2315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 285,
    "description": "Campo Inchauspe / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +south +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs",
    "srid": 2316,
    "auth_name": "EPSG",
    "auth_id": "2316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 286,
    "description": "PSAD56 / ICN Regional",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=6 +lon_0=-66 +lat_1=9 +lat_2=3 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=-295,173,-371,0,0,0,0 +units=m +no_defs",
    "srid": 2317,
    "auth_name": "EPSG",
    "auth_id": "2317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 287,
    "description": "Ain el Abd / Aramco Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=25.08951 +lon_0=48 +lat_1=17 +lat_2=33 +x_0=0 +y_0=0 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs",
    "srid": 2318,
    "auth_name": "EPSG",
    "auth_id": "2318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 288,
    "description": "ED50 / TM27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2319,
    "auth_name": "EPSG",
    "auth_id": "2319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 289,
    "description": "ED50 / TM30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2320,
    "auth_name": "EPSG",
    "auth_id": "2320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 290,
    "description": "ED50 / TM33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2321,
    "auth_name": "EPSG",
    "auth_id": "2321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 291,
    "description": "ED50 / TM36",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2322,
    "auth_name": "EPSG",
    "auth_id": "2322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 292,
    "description": "ED50 / TM39",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2323,
    "auth_name": "EPSG",
    "auth_id": "2323",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 293,
    "description": "ED50 / TM42",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-84.1,-101.8,-129.7,0,0,0.468,1.05 +units=m +no_defs",
    "srid": 2324,
    "auth_name": "EPSG",
    "auth_id": "2324",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 294,
    "description": "ED50 / TM45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-84.1,-101.8,-129.7,0,0,0.468,1.05 +units=m +no_defs",
    "srid": 2325,
    "auth_name": "EPSG",
    "auth_id": "2325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 295,
    "description": "Hong Kong 1980 Grid System",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=22.3121333333333 +lon_0=114.178555555556 +k=1 +x_0=836694.05 +y_0=819069.8 +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.243648,-1.158828,-1.094246 +units=m +no_defs",
    "srid": 2326,
    "auth_name": "EPSG",
    "auth_id": "2326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 296,
    "description": "Xian 1980 / Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2327,
    "auth_name": "EPSG",
    "auth_id": "2327",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 297,
    "description": "Xian 1980 / Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2328,
    "auth_name": "EPSG",
    "auth_id": "2328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 298,
    "description": "Xian 1980 / Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2329,
    "auth_name": "EPSG",
    "auth_id": "2329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 299,
    "description": "Xian 1980 / Gauss-Kruger zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2330,
    "auth_name": "EPSG",
    "auth_id": "2330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 300,
    "description": "Xian 1980 / Gauss-Kruger zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2331,
    "auth_name": "EPSG",
    "auth_id": "2331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 301,
    "description": "Xian 1980 / Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2332,
    "auth_name": "EPSG",
    "auth_id": "2332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 302,
    "description": "Xian 1980 / Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2333,
    "auth_name": "EPSG",
    "auth_id": "2333",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 303,
    "description": "Xian 1980 / Gauss-Kruger zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2334,
    "auth_name": "EPSG",
    "auth_id": "2334",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 304,
    "description": "Xian 1980 / Gauss-Kruger zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2335,
    "auth_name": "EPSG",
    "auth_id": "2335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 305,
    "description": "Xian 1980 / Gauss-Kruger zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2336,
    "auth_name": "EPSG",
    "auth_id": "2336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 306,
    "description": "Xian 1980 / Gauss-Kruger zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2337,
    "auth_name": "EPSG",
    "auth_id": "2337",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 307,
    "description": "Xian 1980 / Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2338,
    "auth_name": "EPSG",
    "auth_id": "2338",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 308,
    "description": "Xian 1980 / Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2339,
    "auth_name": "EPSG",
    "auth_id": "2339",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 309,
    "description": "Xian 1980 / Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2340,
    "auth_name": "EPSG",
    "auth_id": "2340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 310,
    "description": "Xian 1980 / Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2341,
    "auth_name": "EPSG",
    "auth_id": "2341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 311,
    "description": "Xian 1980 / Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2342,
    "auth_name": "EPSG",
    "auth_id": "2342",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 312,
    "description": "Xian 1980 / Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2343,
    "auth_name": "EPSG",
    "auth_id": "2343",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 313,
    "description": "Xian 1980 / Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2344,
    "auth_name": "EPSG",
    "auth_id": "2344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 314,
    "description": "Xian 1980 / Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2345,
    "auth_name": "EPSG",
    "auth_id": "2345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 315,
    "description": "Xian 1980 / Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2346,
    "auth_name": "EPSG",
    "auth_id": "2346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 316,
    "description": "Xian 1980 / Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2347,
    "auth_name": "EPSG",
    "auth_id": "2347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 317,
    "description": "Xian 1980 / Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2348,
    "auth_name": "EPSG",
    "auth_id": "2348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 318,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2349,
    "auth_name": "EPSG",
    "auth_id": "2349",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 319,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2350,
    "auth_name": "EPSG",
    "auth_id": "2350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 320,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2351,
    "auth_name": "EPSG",
    "auth_id": "2351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 321,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2352,
    "auth_name": "EPSG",
    "auth_id": "2352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 322,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2353,
    "auth_name": "EPSG",
    "auth_id": "2353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 323,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2354,
    "auth_name": "EPSG",
    "auth_id": "2354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 324,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2355,
    "auth_name": "EPSG",
    "auth_id": "2355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 325,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2356,
    "auth_name": "EPSG",
    "auth_id": "2356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 326,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2357,
    "auth_name": "EPSG",
    "auth_id": "2357",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 327,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2358,
    "auth_name": "EPSG",
    "auth_id": "2358",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 328,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 35",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2359,
    "auth_name": "EPSG",
    "auth_id": "2359",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 329,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 36",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2360,
    "auth_name": "EPSG",
    "auth_id": "2360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 330,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 37",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2361,
    "auth_name": "EPSG",
    "auth_id": "2361",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 331,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 38",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2362,
    "auth_name": "EPSG",
    "auth_id": "2362",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 332,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 39",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2363,
    "auth_name": "EPSG",
    "auth_id": "2363",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 333,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 40",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2364,
    "auth_name": "EPSG",
    "auth_id": "2364",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 334,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 41",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2365,
    "auth_name": "EPSG",
    "auth_id": "2365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 335,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 42",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2366,
    "auth_name": "EPSG",
    "auth_id": "2366",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 336,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 43",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2367,
    "auth_name": "EPSG",
    "auth_id": "2367",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 337,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 44",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2368,
    "auth_name": "EPSG",
    "auth_id": "2368",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 338,
    "description": "Xian 1980 / 3-degree Gauss-Kruger zone 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2369,
    "auth_name": "EPSG",
    "auth_id": "2369",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 339,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2370,
    "auth_name": "EPSG",
    "auth_id": "2370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 340,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 78E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2371,
    "auth_name": "EPSG",
    "auth_id": "2371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 341,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2372,
    "auth_name": "EPSG",
    "auth_id": "2372",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 342,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 84E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2373,
    "auth_name": "EPSG",
    "auth_id": "2373",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 343,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2374,
    "auth_name": "EPSG",
    "auth_id": "2374",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 344,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 90E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2375,
    "auth_name": "EPSG",
    "auth_id": "2375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 345,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2376,
    "auth_name": "EPSG",
    "auth_id": "2376",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 346,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 96E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2377,
    "auth_name": "EPSG",
    "auth_id": "2377",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 347,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2378,
    "auth_name": "EPSG",
    "auth_id": "2378",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 348,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 102E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2379,
    "auth_name": "EPSG",
    "auth_id": "2379",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 349,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2380,
    "auth_name": "EPSG",
    "auth_id": "2380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 350,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 108E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2381,
    "auth_name": "EPSG",
    "auth_id": "2381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 351,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2382,
    "auth_name": "EPSG",
    "auth_id": "2382",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 352,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 114E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2383,
    "auth_name": "EPSG",
    "auth_id": "2383",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 353,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2384,
    "auth_name": "EPSG",
    "auth_id": "2384",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 354,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 120E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2385,
    "auth_name": "EPSG",
    "auth_id": "2385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 355,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2386,
    "auth_name": "EPSG",
    "auth_id": "2386",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 356,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 126E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2387,
    "auth_name": "EPSG",
    "auth_id": "2387",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 357,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2388,
    "auth_name": "EPSG",
    "auth_id": "2388",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 358,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 132E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2389,
    "auth_name": "EPSG",
    "auth_id": "2389",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 359,
    "description": "Xian 1980 / 3-degree Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=IAU76 +units=m +no_defs",
    "srid": 2390,
    "auth_name": "EPSG",
    "auth_id": "2390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 360,
    "description": "KKJ / Finland zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs",
    "srid": 2391,
    "auth_name": "EPSG",
    "auth_id": "2391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 361,
    "description": "KKJ / Finland zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs",
    "srid": 2392,
    "auth_name": "EPSG",
    "auth_id": "2392",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 362,
    "description": "KKJ / Finland Uniform Coordinate System",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 2393,
    "auth_name": "EPSG",
    "auth_id": "2393",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 363,
    "description": "KKJ / Finland zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=4500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs",
    "srid": 2394,
    "auth_name": "EPSG",
    "auth_id": "2394",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 364,
    "description": "South Yemen / Gauss-Kruger zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs",
    "srid": 2395,
    "auth_name": "EPSG",
    "auth_id": "2395",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 365,
    "description": "South Yemen / Gauss-Kruger zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +units=m +no_defs",
    "srid": 2396,
    "auth_name": "EPSG",
    "auth_id": "2396",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 366,
    "description": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=24,-123,-94,0.02,-0.25,-0.13,1.1 +units=m +no_defs",
    "srid": 2397,
    "auth_name": "EPSG",
    "auth_id": "2397",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 367,
    "description": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2398,
    "auth_name": "EPSG",
    "auth_id": "2398",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 368,
    "description": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2399,
    "auth_name": "EPSG",
    "auth_id": "2399",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 370,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2401,
    "auth_name": "EPSG",
    "auth_id": "2401",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 371,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2402,
    "auth_name": "EPSG",
    "auth_id": "2402",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 372,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2403,
    "auth_name": "EPSG",
    "auth_id": "2403",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 373,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2404,
    "auth_name": "EPSG",
    "auth_id": "2404",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 374,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2405,
    "auth_name": "EPSG",
    "auth_id": "2405",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 375,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2406,
    "auth_name": "EPSG",
    "auth_id": "2406",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 376,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2407,
    "auth_name": "EPSG",
    "auth_id": "2407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 377,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2408,
    "auth_name": "EPSG",
    "auth_id": "2408",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 378,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2409,
    "auth_name": "EPSG",
    "auth_id": "2409",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 379,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2410,
    "auth_name": "EPSG",
    "auth_id": "2410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 380,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 35",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2411,
    "auth_name": "EPSG",
    "auth_id": "2411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 381,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 36",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2412,
    "auth_name": "EPSG",
    "auth_id": "2412",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 382,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 37",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2413,
    "auth_name": "EPSG",
    "auth_id": "2413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 383,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 38",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2414,
    "auth_name": "EPSG",
    "auth_id": "2414",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 384,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 39",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2415,
    "auth_name": "EPSG",
    "auth_id": "2415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 385,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 40",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2416,
    "auth_name": "EPSG",
    "auth_id": "2416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 386,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 41",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2417,
    "auth_name": "EPSG",
    "auth_id": "2417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 387,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 42",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2418,
    "auth_name": "EPSG",
    "auth_id": "2418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 388,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 43",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2419,
    "auth_name": "EPSG",
    "auth_id": "2419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 389,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 44",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2420,
    "auth_name": "EPSG",
    "auth_id": "2420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 390,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger zone 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2421,
    "auth_name": "EPSG",
    "auth_id": "2421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 391,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2422,
    "auth_name": "EPSG",
    "auth_id": "2422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 392,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 78E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2423,
    "auth_name": "EPSG",
    "auth_id": "2423",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 393,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2424,
    "auth_name": "EPSG",
    "auth_id": "2424",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 394,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 84E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2425,
    "auth_name": "EPSG",
    "auth_id": "2425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 395,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2426,
    "auth_name": "EPSG",
    "auth_id": "2426",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 396,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 90E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2427,
    "auth_name": "EPSG",
    "auth_id": "2427",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 397,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2428,
    "auth_name": "EPSG",
    "auth_id": "2428",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 398,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 96E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2429,
    "auth_name": "EPSG",
    "auth_id": "2429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 399,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2430,
    "auth_name": "EPSG",
    "auth_id": "2430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 400,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 102E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2431,
    "auth_name": "EPSG",
    "auth_id": "2431",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 401,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2432,
    "auth_name": "EPSG",
    "auth_id": "2432",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 402,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 108E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2433,
    "auth_name": "EPSG",
    "auth_id": "2433",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 403,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2434,
    "auth_name": "EPSG",
    "auth_id": "2434",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 404,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 114E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2435,
    "auth_name": "EPSG",
    "auth_id": "2435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 405,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2436,
    "auth_name": "EPSG",
    "auth_id": "2436",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 406,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 120E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2437,
    "auth_name": "EPSG",
    "auth_id": "2437",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 407,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2438,
    "auth_name": "EPSG",
    "auth_id": "2438",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 408,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 126E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2439,
    "auth_name": "EPSG",
    "auth_id": "2439",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 409,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2440,
    "auth_name": "EPSG",
    "auth_id": "2440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 410,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 132E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2441,
    "auth_name": "EPSG",
    "auth_id": "2441",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 411,
    "description": "Beijing 1954 / 3-degree Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2442,
    "auth_name": "EPSG",
    "auth_id": "2442",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 412,
    "description": "JGD2000 / Japan Plane Rectangular CS I",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2443,
    "auth_name": "EPSG",
    "auth_id": "2443",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 413,
    "description": "JGD2000 / Japan Plane Rectangular CS II",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2444,
    "auth_name": "EPSG",
    "auth_id": "2444",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 414,
    "description": "JGD2000 / Japan Plane Rectangular CS III",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=132.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2445,
    "auth_name": "EPSG",
    "auth_id": "2445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 415,
    "description": "JGD2000 / Japan Plane Rectangular CS IV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2446,
    "auth_name": "EPSG",
    "auth_id": "2446",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 416,
    "description": "JGD2000 / Japan Plane Rectangular CS V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=134.333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2447,
    "auth_name": "EPSG",
    "auth_id": "2447",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 417,
    "description": "JGD2000 / Japan Plane Rectangular CS VI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2448,
    "auth_name": "EPSG",
    "auth_id": "2448",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 418,
    "description": "JGD2000 / Japan Plane Rectangular CS VII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=137.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2449,
    "auth_name": "EPSG",
    "auth_id": "2449",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 419,
    "description": "JGD2000 / Japan Plane Rectangular CS VIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2450,
    "auth_name": "EPSG",
    "auth_id": "2450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 420,
    "description": "JGD2000 / Japan Plane Rectangular CS IX",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=139.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2451,
    "auth_name": "EPSG",
    "auth_id": "2451",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 421,
    "description": "JGD2000 / Japan Plane Rectangular CS X",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=140.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2452,
    "auth_name": "EPSG",
    "auth_id": "2452",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 422,
    "description": "JGD2000 / Japan Plane Rectangular CS XI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2453,
    "auth_name": "EPSG",
    "auth_id": "2453",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 423,
    "description": "JGD2000 / Japan Plane Rectangular CS XII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2454,
    "auth_name": "EPSG",
    "auth_id": "2454",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 424,
    "description": "JGD2000 / Japan Plane Rectangular CS XIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2455,
    "auth_name": "EPSG",
    "auth_id": "2455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 425,
    "description": "JGD2000 / Japan Plane Rectangular CS XIV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2456,
    "auth_name": "EPSG",
    "auth_id": "2456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 426,
    "description": "JGD2000 / Japan Plane Rectangular CS XV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2457,
    "auth_name": "EPSG",
    "auth_id": "2457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 427,
    "description": "JGD2000 / Japan Plane Rectangular CS XVI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2458,
    "auth_name": "EPSG",
    "auth_id": "2458",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 428,
    "description": "JGD2000 / Japan Plane Rectangular CS XVII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2459,
    "auth_name": "EPSG",
    "auth_id": "2459",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 429,
    "description": "JGD2000 / Japan Plane Rectangular CS XVIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2460,
    "auth_name": "EPSG",
    "auth_id": "2460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 430,
    "description": "JGD2000 / Japan Plane Rectangular CS XIX",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2461,
    "auth_name": "EPSG",
    "auth_id": "2461",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 431,
    "description": "Albanian 1987 / Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703 +units=m +no_defs",
    "srid": 2462,
    "auth_name": "EPSG",
    "auth_id": "2462",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 432,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 21E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2463,
    "auth_name": "EPSG",
    "auth_id": "2463",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 433,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 27E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2464,
    "auth_name": "EPSG",
    "auth_id": "2464",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 434,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 33E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2465,
    "auth_name": "EPSG",
    "auth_id": "2465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 435,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 39E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2466,
    "auth_name": "EPSG",
    "auth_id": "2466",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 436,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 45E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2467,
    "auth_name": "EPSG",
    "auth_id": "2467",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 437,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 51E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2468,
    "auth_name": "EPSG",
    "auth_id": "2468",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 438,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 57E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2469,
    "auth_name": "EPSG",
    "auth_id": "2469",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 439,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 63E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2470,
    "auth_name": "EPSG",
    "auth_id": "2470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 440,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 69E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2471,
    "auth_name": "EPSG",
    "auth_id": "2471",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 441,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2472,
    "auth_name": "EPSG",
    "auth_id": "2472",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 442,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2473,
    "auth_name": "EPSG",
    "auth_id": "2473",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 443,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2474,
    "auth_name": "EPSG",
    "auth_id": "2474",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 444,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2475,
    "auth_name": "EPSG",
    "auth_id": "2475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 445,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2476,
    "auth_name": "EPSG",
    "auth_id": "2476",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 446,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2477,
    "auth_name": "EPSG",
    "auth_id": "2477",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 447,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2478,
    "auth_name": "EPSG",
    "auth_id": "2478",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 448,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2479,
    "auth_name": "EPSG",
    "auth_id": "2479",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 449,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2480,
    "auth_name": "EPSG",
    "auth_id": "2480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 450,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2481,
    "auth_name": "EPSG",
    "auth_id": "2481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 451,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2482,
    "auth_name": "EPSG",
    "auth_id": "2482",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 452,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 141E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2483,
    "auth_name": "EPSG",
    "auth_id": "2483",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 453,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 147E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2484,
    "auth_name": "EPSG",
    "auth_id": "2484",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 454,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 153E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2485,
    "auth_name": "EPSG",
    "auth_id": "2485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 455,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 159E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2486,
    "auth_name": "EPSG",
    "auth_id": "2486",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 456,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 165E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2487,
    "auth_name": "EPSG",
    "auth_id": "2487",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 457,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 171E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2488,
    "auth_name": "EPSG",
    "auth_id": "2488",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 458,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 177E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2489,
    "auth_name": "EPSG",
    "auth_id": "2489",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 459,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 177W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2490,
    "auth_name": "EPSG",
    "auth_id": "2490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 460,
    "description": "Pulkovo 1995 / Gauss-Kruger CM 171W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2491,
    "auth_name": "EPSG",
    "auth_id": "2491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 463,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 21E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2494,
    "auth_name": "EPSG",
    "auth_id": "2494",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 464,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 27E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2495,
    "auth_name": "EPSG",
    "auth_id": "2495",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 465,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 33E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2496,
    "auth_name": "EPSG",
    "auth_id": "2496",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 466,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 39E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2497,
    "auth_name": "EPSG",
    "auth_id": "2497",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 467,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 45E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2498,
    "auth_name": "EPSG",
    "auth_id": "2498",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 468,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 51E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2499,
    "auth_name": "EPSG",
    "auth_id": "2499",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 469,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 57E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2500,
    "auth_name": "EPSG",
    "auth_id": "2500",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 470,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 63E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2501,
    "auth_name": "EPSG",
    "auth_id": "2501",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 471,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 69E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2502,
    "auth_name": "EPSG",
    "auth_id": "2502",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 472,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2503,
    "auth_name": "EPSG",
    "auth_id": "2503",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 473,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2504,
    "auth_name": "EPSG",
    "auth_id": "2504",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 474,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2505,
    "auth_name": "EPSG",
    "auth_id": "2505",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 475,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2506,
    "auth_name": "EPSG",
    "auth_id": "2506",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 476,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2507,
    "auth_name": "EPSG",
    "auth_id": "2507",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 477,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2508,
    "auth_name": "EPSG",
    "auth_id": "2508",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 478,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2509,
    "auth_name": "EPSG",
    "auth_id": "2509",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 479,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2510,
    "auth_name": "EPSG",
    "auth_id": "2510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 480,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2511,
    "auth_name": "EPSG",
    "auth_id": "2511",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 481,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2512,
    "auth_name": "EPSG",
    "auth_id": "2512",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 482,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2513,
    "auth_name": "EPSG",
    "auth_id": "2513",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 483,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 141E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2514,
    "auth_name": "EPSG",
    "auth_id": "2514",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 484,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 147E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2515,
    "auth_name": "EPSG",
    "auth_id": "2515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 485,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 153E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2516,
    "auth_name": "EPSG",
    "auth_id": "2516",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 486,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 159E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2517,
    "auth_name": "EPSG",
    "auth_id": "2517",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 487,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 165E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2518,
    "auth_name": "EPSG",
    "auth_id": "2518",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 488,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 171E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2519,
    "auth_name": "EPSG",
    "auth_id": "2519",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 489,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 177E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2520,
    "auth_name": "EPSG",
    "auth_id": "2520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 490,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 177W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2521,
    "auth_name": "EPSG",
    "auth_id": "2521",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 491,
    "description": "Pulkovo 1942 / Gauss-Kruger CM 171W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2522,
    "auth_name": "EPSG",
    "auth_id": "2522",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 492,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2523,
    "auth_name": "EPSG",
    "auth_id": "2523",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 493,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2524,
    "auth_name": "EPSG",
    "auth_id": "2524",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 494,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2525,
    "auth_name": "EPSG",
    "auth_id": "2525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 495,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2526,
    "auth_name": "EPSG",
    "auth_id": "2526",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 496,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2527,
    "auth_name": "EPSG",
    "auth_id": "2527",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 497,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2528,
    "auth_name": "EPSG",
    "auth_id": "2528",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 498,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2529,
    "auth_name": "EPSG",
    "auth_id": "2529",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 499,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2530,
    "auth_name": "EPSG",
    "auth_id": "2530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 500,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2531,
    "auth_name": "EPSG",
    "auth_id": "2531",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 501,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2532,
    "auth_name": "EPSG",
    "auth_id": "2532",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 502,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2533,
    "auth_name": "EPSG",
    "auth_id": "2533",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 503,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2534,
    "auth_name": "EPSG",
    "auth_id": "2534",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 504,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2535,
    "auth_name": "EPSG",
    "auth_id": "2535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 505,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2536,
    "auth_name": "EPSG",
    "auth_id": "2536",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 506,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2537,
    "auth_name": "EPSG",
    "auth_id": "2537",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 507,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2538,
    "auth_name": "EPSG",
    "auth_id": "2538",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 508,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2539,
    "auth_name": "EPSG",
    "auth_id": "2539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 509,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2540,
    "auth_name": "EPSG",
    "auth_id": "2540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 510,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2541,
    "auth_name": "EPSG",
    "auth_id": "2541",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 511,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2542,
    "auth_name": "EPSG",
    "auth_id": "2542",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 512,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2543,
    "auth_name": "EPSG",
    "auth_id": "2543",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 513,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2544,
    "auth_name": "EPSG",
    "auth_id": "2544",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 514,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2545,
    "auth_name": "EPSG",
    "auth_id": "2545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 515,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2546,
    "auth_name": "EPSG",
    "auth_id": "2546",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 516,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2547,
    "auth_name": "EPSG",
    "auth_id": "2547",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 517,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2548,
    "auth_name": "EPSG",
    "auth_id": "2548",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 518,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2549,
    "auth_name": "EPSG",
    "auth_id": "2549",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 520,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2551,
    "auth_name": "EPSG",
    "auth_id": "2551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 521,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 35",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2552,
    "auth_name": "EPSG",
    "auth_id": "2552",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 522,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 36",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2553,
    "auth_name": "EPSG",
    "auth_id": "2553",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 523,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 37",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2554,
    "auth_name": "EPSG",
    "auth_id": "2554",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 524,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 38",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2555,
    "auth_name": "EPSG",
    "auth_id": "2555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 525,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 39",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2556,
    "auth_name": "EPSG",
    "auth_id": "2556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 526,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 40",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2557,
    "auth_name": "EPSG",
    "auth_id": "2557",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 527,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 41",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2558,
    "auth_name": "EPSG",
    "auth_id": "2558",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 528,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 42",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2559,
    "auth_name": "EPSG",
    "auth_id": "2559",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 529,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 43",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2560,
    "auth_name": "EPSG",
    "auth_id": "2560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 530,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 44",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2561,
    "auth_name": "EPSG",
    "auth_id": "2561",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 531,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2562,
    "auth_name": "EPSG",
    "auth_id": "2562",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 532,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 46",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2563,
    "auth_name": "EPSG",
    "auth_id": "2563",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 533,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 47",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2564,
    "auth_name": "EPSG",
    "auth_id": "2564",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 534,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 48",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2565,
    "auth_name": "EPSG",
    "auth_id": "2565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 535,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 49",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2566,
    "auth_name": "EPSG",
    "auth_id": "2566",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 536,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 50",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2567,
    "auth_name": "EPSG",
    "auth_id": "2567",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 537,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 51",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2568,
    "auth_name": "EPSG",
    "auth_id": "2568",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 538,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 52",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2569,
    "auth_name": "EPSG",
    "auth_id": "2569",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 539,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 53",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2570,
    "auth_name": "EPSG",
    "auth_id": "2570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 540,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 54",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2571,
    "auth_name": "EPSG",
    "auth_id": "2571",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 541,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 55",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2572,
    "auth_name": "EPSG",
    "auth_id": "2572",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 542,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 56",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2573,
    "auth_name": "EPSG",
    "auth_id": "2573",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 543,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 57",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2574,
    "auth_name": "EPSG",
    "auth_id": "2574",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 544,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 58",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2575,
    "auth_name": "EPSG",
    "auth_id": "2575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 545,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 59",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2576,
    "auth_name": "EPSG",
    "auth_id": "2576",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 547,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 61",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2578,
    "auth_name": "EPSG",
    "auth_id": "2578",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 548,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 62",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2579,
    "auth_name": "EPSG",
    "auth_id": "2579",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 549,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 63",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2580,
    "auth_name": "EPSG",
    "auth_id": "2580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 550,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 64",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2581,
    "auth_name": "EPSG",
    "auth_id": "2581",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 551,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 21E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2582,
    "auth_name": "EPSG",
    "auth_id": "2582",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 552,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 24E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2583,
    "auth_name": "EPSG",
    "auth_id": "2583",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 553,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 27E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2584,
    "auth_name": "EPSG",
    "auth_id": "2584",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 554,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 30E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2585,
    "auth_name": "EPSG",
    "auth_id": "2585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 555,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 33E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2586,
    "auth_name": "EPSG",
    "auth_id": "2586",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 556,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 36E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2587,
    "auth_name": "EPSG",
    "auth_id": "2587",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 557,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 39E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2588,
    "auth_name": "EPSG",
    "auth_id": "2588",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 558,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 42E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2589,
    "auth_name": "EPSG",
    "auth_id": "2589",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 559,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 45E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2590,
    "auth_name": "EPSG",
    "auth_id": "2590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 560,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 48E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2591,
    "auth_name": "EPSG",
    "auth_id": "2591",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 561,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 51E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2592,
    "auth_name": "EPSG",
    "auth_id": "2592",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 562,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 54E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2593,
    "auth_name": "EPSG",
    "auth_id": "2593",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 563,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 57E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2594,
    "auth_name": "EPSG",
    "auth_id": "2594",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 564,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 60E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2595,
    "auth_name": "EPSG",
    "auth_id": "2595",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 565,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 63E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2596,
    "auth_name": "EPSG",
    "auth_id": "2596",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 566,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 66E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2597,
    "auth_name": "EPSG",
    "auth_id": "2597",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 567,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 69E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2598,
    "auth_name": "EPSG",
    "auth_id": "2598",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 568,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 72E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2599,
    "auth_name": "EPSG",
    "auth_id": "2599",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 570,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2601,
    "auth_name": "EPSG",
    "auth_id": "2601",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 571,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 78E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 2602,
    "auth_name": "EPSG",
    "auth_id": "2602",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 572,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2603,
    "auth_name": "EPSG",
    "auth_id": "2603",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 573,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 84E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2604,
    "auth_name": "EPSG",
    "auth_id": "2604",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 574,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2605,
    "auth_name": "EPSG",
    "auth_id": "2605",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 575,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 90E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2606,
    "auth_name": "EPSG",
    "auth_id": "2606",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 576,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2607,
    "auth_name": "EPSG",
    "auth_id": "2607",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 577,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 96E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2608,
    "auth_name": "EPSG",
    "auth_id": "2608",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 578,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2609,
    "auth_name": "EPSG",
    "auth_id": "2609",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 579,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 102E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2610,
    "auth_name": "EPSG",
    "auth_id": "2610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 580,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2611,
    "auth_name": "EPSG",
    "auth_id": "2611",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 581,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 108E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2612,
    "auth_name": "EPSG",
    "auth_id": "2612",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 582,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2613,
    "auth_name": "EPSG",
    "auth_id": "2613",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 583,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 114E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2614,
    "auth_name": "EPSG",
    "auth_id": "2614",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 584,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2615,
    "auth_name": "EPSG",
    "auth_id": "2615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 585,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 120E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2616,
    "auth_name": "EPSG",
    "auth_id": "2616",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 586,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2617,
    "auth_name": "EPSG",
    "auth_id": "2617",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 587,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 126E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2618,
    "auth_name": "EPSG",
    "auth_id": "2618",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 588,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2619,
    "auth_name": "EPSG",
    "auth_id": "2619",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 589,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 132E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2620,
    "auth_name": "EPSG",
    "auth_id": "2620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 590,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2621,
    "auth_name": "EPSG",
    "auth_id": "2621",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 591,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 138E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2622,
    "auth_name": "EPSG",
    "auth_id": "2622",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 592,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 141E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2623,
    "auth_name": "EPSG",
    "auth_id": "2623",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 593,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 144E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2624,
    "auth_name": "EPSG",
    "auth_id": "2624",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 594,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 147E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2625,
    "auth_name": "EPSG",
    "auth_id": "2625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 595,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 150E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2626,
    "auth_name": "EPSG",
    "auth_id": "2626",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 596,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 153E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2627,
    "auth_name": "EPSG",
    "auth_id": "2627",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 597,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 156E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2628,
    "auth_name": "EPSG",
    "auth_id": "2628",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 598,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 159E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2629,
    "auth_name": "EPSG",
    "auth_id": "2629",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 599,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 162E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2630,
    "auth_name": "EPSG",
    "auth_id": "2630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 600,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 165E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2631,
    "auth_name": "EPSG",
    "auth_id": "2631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 601,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 168E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2632,
    "auth_name": "EPSG",
    "auth_id": "2632",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 602,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 171E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2633,
    "auth_name": "EPSG",
    "auth_id": "2633",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 603,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 174E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2634,
    "auth_name": "EPSG",
    "auth_id": "2634",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 604,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 177E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2635,
    "auth_name": "EPSG",
    "auth_id": "2635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 605,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 180E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2636,
    "auth_name": "EPSG",
    "auth_id": "2636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 606,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 177W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2637,
    "auth_name": "EPSG",
    "auth_id": "2637",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 607,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 174W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2638,
    "auth_name": "EPSG",
    "auth_id": "2638",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 608,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 171W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2639,
    "auth_name": "EPSG",
    "auth_id": "2639",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 609,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger CM 168W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2640,
    "auth_name": "EPSG",
    "auth_id": "2640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 610,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2641,
    "auth_name": "EPSG",
    "auth_id": "2641",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 611,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2642,
    "auth_name": "EPSG",
    "auth_id": "2642",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 612,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2643,
    "auth_name": "EPSG",
    "auth_id": "2643",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 613,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2644,
    "auth_name": "EPSG",
    "auth_id": "2644",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 614,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2645,
    "auth_name": "EPSG",
    "auth_id": "2645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 615,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2646,
    "auth_name": "EPSG",
    "auth_id": "2646",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 616,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2647,
    "auth_name": "EPSG",
    "auth_id": "2647",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 617,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2648,
    "auth_name": "EPSG",
    "auth_id": "2648",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 618,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2649,
    "auth_name": "EPSG",
    "auth_id": "2649",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 619,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2650,
    "auth_name": "EPSG",
    "auth_id": "2650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 620,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2651,
    "auth_name": "EPSG",
    "auth_id": "2651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 621,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2652,
    "auth_name": "EPSG",
    "auth_id": "2652",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 622,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2653,
    "auth_name": "EPSG",
    "auth_id": "2653",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 623,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2654,
    "auth_name": "EPSG",
    "auth_id": "2654",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 624,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2655,
    "auth_name": "EPSG",
    "auth_id": "2655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 625,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2656,
    "auth_name": "EPSG",
    "auth_id": "2656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 626,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2657,
    "auth_name": "EPSG",
    "auth_id": "2657",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 627,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2658,
    "auth_name": "EPSG",
    "auth_id": "2658",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 628,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2659,
    "auth_name": "EPSG",
    "auth_id": "2659",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 629,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2660,
    "auth_name": "EPSG",
    "auth_id": "2660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 630,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2661,
    "auth_name": "EPSG",
    "auth_id": "2661",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 631,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2662,
    "auth_name": "EPSG",
    "auth_id": "2662",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 632,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2663,
    "auth_name": "EPSG",
    "auth_id": "2663",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 633,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2664,
    "auth_name": "EPSG",
    "auth_id": "2664",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 634,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2665,
    "auth_name": "EPSG",
    "auth_id": "2665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 635,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2666,
    "auth_name": "EPSG",
    "auth_id": "2666",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 636,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2667,
    "auth_name": "EPSG",
    "auth_id": "2667",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 637,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2668,
    "auth_name": "EPSG",
    "auth_id": "2668",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 638,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 35",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2669,
    "auth_name": "EPSG",
    "auth_id": "2669",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 639,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 36",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2670,
    "auth_name": "EPSG",
    "auth_id": "2670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 640,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 37",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2671,
    "auth_name": "EPSG",
    "auth_id": "2671",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 641,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 38",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2672,
    "auth_name": "EPSG",
    "auth_id": "2672",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 642,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 39",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2673,
    "auth_name": "EPSG",
    "auth_id": "2673",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 643,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 40",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2674,
    "auth_name": "EPSG",
    "auth_id": "2674",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 644,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 41",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2675,
    "auth_name": "EPSG",
    "auth_id": "2675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 645,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 42",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2676,
    "auth_name": "EPSG",
    "auth_id": "2676",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 646,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 43",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2677,
    "auth_name": "EPSG",
    "auth_id": "2677",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 647,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 44",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2678,
    "auth_name": "EPSG",
    "auth_id": "2678",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 648,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2679,
    "auth_name": "EPSG",
    "auth_id": "2679",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 649,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 46",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2680,
    "auth_name": "EPSG",
    "auth_id": "2680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 650,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 47",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2681,
    "auth_name": "EPSG",
    "auth_id": "2681",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 651,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 48",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2682,
    "auth_name": "EPSG",
    "auth_id": "2682",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 652,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 49",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2683,
    "auth_name": "EPSG",
    "auth_id": "2683",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 653,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 50",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2684,
    "auth_name": "EPSG",
    "auth_id": "2684",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 654,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 51",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2685,
    "auth_name": "EPSG",
    "auth_id": "2685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 655,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 52",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2686,
    "auth_name": "EPSG",
    "auth_id": "2686",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 656,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 53",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2687,
    "auth_name": "EPSG",
    "auth_id": "2687",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 657,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 54",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2688,
    "auth_name": "EPSG",
    "auth_id": "2688",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 658,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 55",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2689,
    "auth_name": "EPSG",
    "auth_id": "2689",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 659,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 56",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2690,
    "auth_name": "EPSG",
    "auth_id": "2690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 660,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 57",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2691,
    "auth_name": "EPSG",
    "auth_id": "2691",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 661,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 58",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2692,
    "auth_name": "EPSG",
    "auth_id": "2692",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 662,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 59",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2693,
    "auth_name": "EPSG",
    "auth_id": "2693",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 664,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 61",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2695,
    "auth_name": "EPSG",
    "auth_id": "2695",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 665,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 62",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2696,
    "auth_name": "EPSG",
    "auth_id": "2696",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 666,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 63",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2697,
    "auth_name": "EPSG",
    "auth_id": "2697",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 667,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 64",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2698,
    "auth_name": "EPSG",
    "auth_id": "2698",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 668,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 21E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2699,
    "auth_name": "EPSG",
    "auth_id": "2699",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 669,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 24E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2700,
    "auth_name": "EPSG",
    "auth_id": "2700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 670,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 27E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2701,
    "auth_name": "EPSG",
    "auth_id": "2701",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 671,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 30E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2702,
    "auth_name": "EPSG",
    "auth_id": "2702",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 672,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 33E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2703,
    "auth_name": "EPSG",
    "auth_id": "2703",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 673,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 36E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2704,
    "auth_name": "EPSG",
    "auth_id": "2704",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 674,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 39E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2705,
    "auth_name": "EPSG",
    "auth_id": "2705",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 675,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 42E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2706,
    "auth_name": "EPSG",
    "auth_id": "2706",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 676,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 45E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2707,
    "auth_name": "EPSG",
    "auth_id": "2707",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 677,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 48E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2708,
    "auth_name": "EPSG",
    "auth_id": "2708",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 678,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 51E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2709,
    "auth_name": "EPSG",
    "auth_id": "2709",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 679,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 54E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2710,
    "auth_name": "EPSG",
    "auth_id": "2710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 680,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 57E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2711,
    "auth_name": "EPSG",
    "auth_id": "2711",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 681,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 60E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2712,
    "auth_name": "EPSG",
    "auth_id": "2712",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 682,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 63E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2713,
    "auth_name": "EPSG",
    "auth_id": "2713",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 683,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 66E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2714,
    "auth_name": "EPSG",
    "auth_id": "2714",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 684,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 69E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2715,
    "auth_name": "EPSG",
    "auth_id": "2715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 685,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 72E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2716,
    "auth_name": "EPSG",
    "auth_id": "2716",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 686,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2717,
    "auth_name": "EPSG",
    "auth_id": "2717",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 687,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 78E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2718,
    "auth_name": "EPSG",
    "auth_id": "2718",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 688,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2719,
    "auth_name": "EPSG",
    "auth_id": "2719",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 689,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 84E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2720,
    "auth_name": "EPSG",
    "auth_id": "2720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 690,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2721,
    "auth_name": "EPSG",
    "auth_id": "2721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 691,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 90E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2722,
    "auth_name": "EPSG",
    "auth_id": "2722",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 692,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2723,
    "auth_name": "EPSG",
    "auth_id": "2723",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 693,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 96E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2724,
    "auth_name": "EPSG",
    "auth_id": "2724",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 694,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2725,
    "auth_name": "EPSG",
    "auth_id": "2725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 695,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 102E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2726,
    "auth_name": "EPSG",
    "auth_id": "2726",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 696,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2727,
    "auth_name": "EPSG",
    "auth_id": "2727",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 697,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 108E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2728,
    "auth_name": "EPSG",
    "auth_id": "2728",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 698,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2729,
    "auth_name": "EPSG",
    "auth_id": "2729",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 699,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 114E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2730,
    "auth_name": "EPSG",
    "auth_id": "2730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 700,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2731,
    "auth_name": "EPSG",
    "auth_id": "2731",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 701,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 120E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2732,
    "auth_name": "EPSG",
    "auth_id": "2732",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 702,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2733,
    "auth_name": "EPSG",
    "auth_id": "2733",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 703,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 126E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2734,
    "auth_name": "EPSG",
    "auth_id": "2734",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 704,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2735,
    "auth_name": "EPSG",
    "auth_id": "2735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 705,
    "description": "Tete / UTM zone 36S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=36 +south +ellps=clrk66 +towgs84=-80,-100,-228,0,0,0,0 +units=m +no_defs",
    "srid": 2736,
    "auth_name": "EPSG",
    "auth_id": "2736",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 706,
    "description": "Tete / UTM zone 37S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=37 +south +ellps=clrk66 +towgs84=-80,-100,-228,0,0,0,0 +units=m +no_defs",
    "srid": 2737,
    "auth_name": "EPSG",
    "auth_id": "2737",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 707,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 132E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2738,
    "auth_name": "EPSG",
    "auth_id": "2738",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 708,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2739,
    "auth_name": "EPSG",
    "auth_id": "2739",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 709,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 138E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2740,
    "auth_name": "EPSG",
    "auth_id": "2740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 710,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 141E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2741,
    "auth_name": "EPSG",
    "auth_id": "2741",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 711,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 144E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2742,
    "auth_name": "EPSG",
    "auth_id": "2742",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 712,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 147E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2743,
    "auth_name": "EPSG",
    "auth_id": "2743",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 713,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 150E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2744,
    "auth_name": "EPSG",
    "auth_id": "2744",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 714,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 153E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2745,
    "auth_name": "EPSG",
    "auth_id": "2745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 715,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 156E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2746,
    "auth_name": "EPSG",
    "auth_id": "2746",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 716,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 159E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2747,
    "auth_name": "EPSG",
    "auth_id": "2747",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 717,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 162E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2748,
    "auth_name": "EPSG",
    "auth_id": "2748",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 718,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 165E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2749,
    "auth_name": "EPSG",
    "auth_id": "2749",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 719,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 168E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2750,
    "auth_name": "EPSG",
    "auth_id": "2750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 720,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 171E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2751,
    "auth_name": "EPSG",
    "auth_id": "2751",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 721,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 174E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2752,
    "auth_name": "EPSG",
    "auth_id": "2752",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 722,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 177E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2753,
    "auth_name": "EPSG",
    "auth_id": "2753",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 723,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 180E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2754,
    "auth_name": "EPSG",
    "auth_id": "2754",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 724,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 177W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2755,
    "auth_name": "EPSG",
    "auth_id": "2755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 725,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 174W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2756,
    "auth_name": "EPSG",
    "auth_id": "2756",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 726,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 171W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2757,
    "auth_name": "EPSG",
    "auth_id": "2757",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 727,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger CM 168W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 2758,
    "auth_name": "EPSG",
    "auth_id": "2758",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 728,
    "description": "NAD83(HARN) / Alabama East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2759,
    "auth_name": "EPSG",
    "auth_id": "2759",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 729,
    "description": "NAD83(HARN) / Alabama West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2760,
    "auth_name": "EPSG",
    "auth_id": "2760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 730,
    "description": "NAD83(HARN) / Arizona East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2761,
    "auth_name": "EPSG",
    "auth_id": "2761",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 731,
    "description": "NAD83(HARN) / Arizona Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2762,
    "auth_name": "EPSG",
    "auth_id": "2762",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 732,
    "description": "NAD83(HARN) / Arizona West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2763,
    "auth_name": "EPSG",
    "auth_id": "2763",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 733,
    "description": "NAD83(HARN) / Arkansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2764,
    "auth_name": "EPSG",
    "auth_id": "2764",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 734,
    "description": "NAD83(HARN) / Arkansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2765,
    "auth_name": "EPSG",
    "auth_id": "2765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 735,
    "description": "NAD83(HARN) / California zone 1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2766,
    "auth_name": "EPSG",
    "auth_id": "2766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 736,
    "description": "NAD83(HARN) / California zone 2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2767,
    "auth_name": "EPSG",
    "auth_id": "2767",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 737,
    "description": "NAD83(HARN) / California zone 3",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2768,
    "auth_name": "EPSG",
    "auth_id": "2768",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 738,
    "description": "NAD83(HARN) / California zone 4",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2769,
    "auth_name": "EPSG",
    "auth_id": "2769",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 739,
    "description": "NAD83(HARN) / California zone 5",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2770,
    "auth_name": "EPSG",
    "auth_id": "2770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 740,
    "description": "NAD83(HARN) / California zone 6",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2771,
    "auth_name": "EPSG",
    "auth_id": "2771",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 741,
    "description": "NAD83(HARN) / Colorado North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs",
    "srid": 2772,
    "auth_name": "EPSG",
    "auth_id": "2772",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 742,
    "description": "NAD83(HARN) / Colorado Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs",
    "srid": 2773,
    "auth_name": "EPSG",
    "auth_id": "2773",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 743,
    "description": "NAD83(HARN) / Colorado South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs",
    "srid": 2774,
    "auth_name": "EPSG",
    "auth_id": "2774",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 744,
    "description": "NAD83(HARN) / Connecticut",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +units=m +no_defs",
    "srid": 2775,
    "auth_name": "EPSG",
    "auth_id": "2775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 745,
    "description": "NAD83(HARN) / Delaware",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2776,
    "auth_name": "EPSG",
    "auth_id": "2776",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 746,
    "description": "NAD83(HARN) / Florida East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2777,
    "auth_name": "EPSG",
    "auth_id": "2777",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 747,
    "description": "NAD83(HARN) / Florida West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2778,
    "auth_name": "EPSG",
    "auth_id": "2778",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 748,
    "description": "NAD83(HARN) / Florida North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2779,
    "auth_name": "EPSG",
    "auth_id": "2779",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 749,
    "description": "NAD83(HARN) / Georgia East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2780,
    "auth_name": "EPSG",
    "auth_id": "2780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 750,
    "description": "NAD83(HARN) / Georgia West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2781,
    "auth_name": "EPSG",
    "auth_id": "2781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 751,
    "description": "NAD83(HARN) / Hawaii zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2782,
    "auth_name": "EPSG",
    "auth_id": "2782",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 752,
    "description": "NAD83(HARN) / Hawaii zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2783,
    "auth_name": "EPSG",
    "auth_id": "2783",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 753,
    "description": "NAD83(HARN) / Hawaii zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2784,
    "auth_name": "EPSG",
    "auth_id": "2784",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 754,
    "description": "NAD83(HARN) / Hawaii zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2785,
    "auth_name": "EPSG",
    "auth_id": "2785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 755,
    "description": "NAD83(HARN) / Hawaii zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2786,
    "auth_name": "EPSG",
    "auth_id": "2786",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 756,
    "description": "NAD83(HARN) / Idaho East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2787,
    "auth_name": "EPSG",
    "auth_id": "2787",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 757,
    "description": "NAD83(HARN) / Idaho Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2788,
    "auth_name": "EPSG",
    "auth_id": "2788",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 758,
    "description": "NAD83(HARN) / Idaho West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2789,
    "auth_name": "EPSG",
    "auth_id": "2789",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 759,
    "description": "NAD83(HARN) / Illinois East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2790,
    "auth_name": "EPSG",
    "auth_id": "2790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 760,
    "description": "NAD83(HARN) / Illinois West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2791,
    "auth_name": "EPSG",
    "auth_id": "2791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 761,
    "description": "NAD83(HARN) / Indiana East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2792,
    "auth_name": "EPSG",
    "auth_id": "2792",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 762,
    "description": "NAD83(HARN) / Indiana West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2793,
    "auth_name": "EPSG",
    "auth_id": "2793",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 763,
    "description": "NAD83(HARN) / Iowa North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2794,
    "auth_name": "EPSG",
    "auth_id": "2794",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 764,
    "description": "NAD83(HARN) / Iowa South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2795,
    "auth_name": "EPSG",
    "auth_id": "2795",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 765,
    "description": "NAD83(HARN) / Kansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2796,
    "auth_name": "EPSG",
    "auth_id": "2796",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 766,
    "description": "NAD83(HARN) / Kansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2797,
    "auth_name": "EPSG",
    "auth_id": "2797",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 767,
    "description": "NAD83(HARN) / Kentucky North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2798,
    "auth_name": "EPSG",
    "auth_id": "2798",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 768,
    "description": "NAD83(HARN) / Kentucky South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2799,
    "auth_name": "EPSG",
    "auth_id": "2799",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 769,
    "description": "NAD83(HARN) / Louisiana North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2800,
    "auth_name": "EPSG",
    "auth_id": "2800",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 770,
    "description": "NAD83(HARN) / Louisiana South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2801,
    "auth_name": "EPSG",
    "auth_id": "2801",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 771,
    "description": "NAD83(HARN) / Maine East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2802,
    "auth_name": "EPSG",
    "auth_id": "2802",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 772,
    "description": "NAD83(HARN) / Maine West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2803,
    "auth_name": "EPSG",
    "auth_id": "2803",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 773,
    "description": "NAD83(HARN) / Maryland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2804,
    "auth_name": "EPSG",
    "auth_id": "2804",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 774,
    "description": "NAD83(HARN) / Massachusetts Mainland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2805,
    "auth_name": "EPSG",
    "auth_id": "2805",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 775,
    "description": "NAD83(HARN) / Massachusetts Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2806,
    "auth_name": "EPSG",
    "auth_id": "2806",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 776,
    "description": "NAD83(HARN) / Michigan North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2807,
    "auth_name": "EPSG",
    "auth_id": "2807",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 777,
    "description": "NAD83(HARN) / Michigan Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2808,
    "auth_name": "EPSG",
    "auth_id": "2808",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 778,
    "description": "NAD83(HARN) / Michigan South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2809,
    "auth_name": "EPSG",
    "auth_id": "2809",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 779,
    "description": "NAD83(HARN) / Minnesota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2810,
    "auth_name": "EPSG",
    "auth_id": "2810",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 780,
    "description": "NAD83(HARN) / Minnesota Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2811,
    "auth_name": "EPSG",
    "auth_id": "2811",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 781,
    "description": "NAD83(HARN) / Minnesota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2812,
    "auth_name": "EPSG",
    "auth_id": "2812",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 782,
    "description": "NAD83(HARN) / Mississippi East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2813,
    "auth_name": "EPSG",
    "auth_id": "2813",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 783,
    "description": "NAD83(HARN) / Mississippi West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2814,
    "auth_name": "EPSG",
    "auth_id": "2814",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 784,
    "description": "NAD83(HARN) / Missouri East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2815,
    "auth_name": "EPSG",
    "auth_id": "2815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 785,
    "description": "NAD83(HARN) / Missouri Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2816,
    "auth_name": "EPSG",
    "auth_id": "2816",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 786,
    "description": "NAD83(HARN) / Missouri West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2817,
    "auth_name": "EPSG",
    "auth_id": "2817",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 787,
    "description": "NAD83(HARN) / Montana",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2818,
    "auth_name": "EPSG",
    "auth_id": "2818",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 788,
    "description": "NAD83(HARN) / Nebraska",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2819,
    "auth_name": "EPSG",
    "auth_id": "2819",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 789,
    "description": "NAD83(HARN) / Nevada East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2820,
    "auth_name": "EPSG",
    "auth_id": "2820",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 790,
    "description": "NAD83(HARN) / Nevada Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2821,
    "auth_name": "EPSG",
    "auth_id": "2821",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 791,
    "description": "NAD83(HARN) / Nevada West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2822,
    "auth_name": "EPSG",
    "auth_id": "2822",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 792,
    "description": "NAD83(HARN) / New Hampshire",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2823,
    "auth_name": "EPSG",
    "auth_id": "2823",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 793,
    "description": "NAD83(HARN) / New Jersey",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2824,
    "auth_name": "EPSG",
    "auth_id": "2824",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 794,
    "description": "NAD83(HARN) / New Mexico East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2825,
    "auth_name": "EPSG",
    "auth_id": "2825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 795,
    "description": "NAD83(HARN) / New Mexico Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2826,
    "auth_name": "EPSG",
    "auth_id": "2826",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 796,
    "description": "NAD83(HARN) / New Mexico West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2827,
    "auth_name": "EPSG",
    "auth_id": "2827",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 797,
    "description": "NAD83(HARN) / New York East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2828,
    "auth_name": "EPSG",
    "auth_id": "2828",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 798,
    "description": "NAD83(HARN) / New York Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2829,
    "auth_name": "EPSG",
    "auth_id": "2829",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 799,
    "description": "NAD83(HARN) / New York West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2830,
    "auth_name": "EPSG",
    "auth_id": "2830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 800,
    "description": "NAD83(HARN) / New York Long Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2831,
    "auth_name": "EPSG",
    "auth_id": "2831",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 801,
    "description": "NAD83(HARN) / North Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2832,
    "auth_name": "EPSG",
    "auth_id": "2832",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 802,
    "description": "NAD83(HARN) / North Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2833,
    "auth_name": "EPSG",
    "auth_id": "2833",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 803,
    "description": "NAD83(HARN) / Ohio North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2834,
    "auth_name": "EPSG",
    "auth_id": "2834",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 804,
    "description": "NAD83(HARN) / Ohio South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2835,
    "auth_name": "EPSG",
    "auth_id": "2835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 805,
    "description": "NAD83(HARN) / Oklahoma North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2836,
    "auth_name": "EPSG",
    "auth_id": "2836",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 806,
    "description": "NAD83(HARN) / Oklahoma South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2837,
    "auth_name": "EPSG",
    "auth_id": "2837",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 807,
    "description": "NAD83(HARN) / Oregon North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2838,
    "auth_name": "EPSG",
    "auth_id": "2838",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 808,
    "description": "NAD83(HARN) / Oregon South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2839,
    "auth_name": "EPSG",
    "auth_id": "2839",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 809,
    "description": "NAD83(HARN) / Rhode Island",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2840,
    "auth_name": "EPSG",
    "auth_id": "2840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 810,
    "description": "NAD83(HARN) / South Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2841,
    "auth_name": "EPSG",
    "auth_id": "2841",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 811,
    "description": "NAD83(HARN) / South Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2842,
    "auth_name": "EPSG",
    "auth_id": "2842",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 812,
    "description": "NAD83(HARN) / Tennessee",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2843,
    "auth_name": "EPSG",
    "auth_id": "2843",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 813,
    "description": "NAD83(HARN) / Texas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2844,
    "auth_name": "EPSG",
    "auth_id": "2844",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 814,
    "description": "NAD83(HARN) / Texas North Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2845,
    "auth_name": "EPSG",
    "auth_id": "2845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 815,
    "description": "NAD83(HARN) / Texas Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2846,
    "auth_name": "EPSG",
    "auth_id": "2846",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 816,
    "description": "NAD83(HARN) / Texas South Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2847,
    "auth_name": "EPSG",
    "auth_id": "2847",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 817,
    "description": "NAD83(HARN) / Texas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2848,
    "auth_name": "EPSG",
    "auth_id": "2848",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 818,
    "description": "NAD83(HARN) / Utah North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2849,
    "auth_name": "EPSG",
    "auth_id": "2849",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 819,
    "description": "NAD83(HARN) / Utah Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2850,
    "auth_name": "EPSG",
    "auth_id": "2850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 820,
    "description": "NAD83(HARN) / Utah South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2851,
    "auth_name": "EPSG",
    "auth_id": "2851",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 821,
    "description": "NAD83(HARN) / Vermont",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2852,
    "auth_name": "EPSG",
    "auth_id": "2852",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 822,
    "description": "NAD83(HARN) / Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2853,
    "auth_name": "EPSG",
    "auth_id": "2853",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 823,
    "description": "NAD83(HARN) / Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2854,
    "auth_name": "EPSG",
    "auth_id": "2854",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 824,
    "description": "NAD83(HARN) / Washington North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2855,
    "auth_name": "EPSG",
    "auth_id": "2855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 825,
    "description": "NAD83(HARN) / Washington South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2856,
    "auth_name": "EPSG",
    "auth_id": "2856",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 826,
    "description": "NAD83(HARN) / West Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2857,
    "auth_name": "EPSG",
    "auth_id": "2857",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 827,
    "description": "NAD83(HARN) / West Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2858,
    "auth_name": "EPSG",
    "auth_id": "2858",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 828,
    "description": "NAD83(HARN) / Wisconsin North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2859,
    "auth_name": "EPSG",
    "auth_id": "2859",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 829,
    "description": "NAD83(HARN) / Wisconsin Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2860,
    "auth_name": "EPSG",
    "auth_id": "2860",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 830,
    "description": "NAD83(HARN) / Wisconsin South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2861,
    "auth_name": "EPSG",
    "auth_id": "2861",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 831,
    "description": "NAD83(HARN) / Wyoming East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2862,
    "auth_name": "EPSG",
    "auth_id": "2862",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 832,
    "description": "NAD83(HARN) / Wyoming East Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2863,
    "auth_name": "EPSG",
    "auth_id": "2863",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 833,
    "description": "NAD83(HARN) / Wyoming West Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2864,
    "auth_name": "EPSG",
    "auth_id": "2864",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 834,
    "description": "NAD83(HARN) / Wyoming West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2865,
    "auth_name": "EPSG",
    "auth_id": "2865",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 835,
    "description": "NAD83(HARN) / Puerto Rico and Virgin Is.",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2866,
    "auth_name": "EPSG",
    "auth_id": "2866",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 836,
    "description": "NAD83(HARN) / Arizona East (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2867,
    "auth_name": "EPSG",
    "auth_id": "2867",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 837,
    "description": "NAD83(HARN) / Arizona Central (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2868,
    "auth_name": "EPSG",
    "auth_id": "2868",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 838,
    "description": "NAD83(HARN) / Arizona West (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2869,
    "auth_name": "EPSG",
    "auth_id": "2869",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 839,
    "description": "NAD83(HARN) / California zone 1 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2870,
    "auth_name": "EPSG",
    "auth_id": "2870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 840,
    "description": "NAD83(HARN) / California zone 2 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2871,
    "auth_name": "EPSG",
    "auth_id": "2871",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 841,
    "description": "NAD83(HARN) / California zone 3 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2872,
    "auth_name": "EPSG",
    "auth_id": "2872",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 842,
    "description": "NAD83(HARN) / California zone 4 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2873,
    "auth_name": "EPSG",
    "auth_id": "2873",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 843,
    "description": "NAD83(HARN) / California zone 5 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2874,
    "auth_name": "EPSG",
    "auth_id": "2874",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 844,
    "description": "NAD83(HARN) / California zone 6 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2875,
    "auth_name": "EPSG",
    "auth_id": "2875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 845,
    "description": "NAD83(HARN) / Colorado North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2876,
    "auth_name": "EPSG",
    "auth_id": "2876",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 846,
    "description": "NAD83(HARN) / Colorado Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2877,
    "auth_name": "EPSG",
    "auth_id": "2877",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 847,
    "description": "NAD83(HARN) / Colorado South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2878,
    "auth_name": "EPSG",
    "auth_id": "2878",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 848,
    "description": "NAD83(HARN) / Connecticut (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2879,
    "auth_name": "EPSG",
    "auth_id": "2879",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 849,
    "description": "NAD83(HARN) / Delaware (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2880,
    "auth_name": "EPSG",
    "auth_id": "2880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 850,
    "description": "NAD83(HARN) / Florida East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2881,
    "auth_name": "EPSG",
    "auth_id": "2881",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 851,
    "description": "NAD83(HARN) / Florida West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2882,
    "auth_name": "EPSG",
    "auth_id": "2882",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 852,
    "description": "NAD83(HARN) / Florida North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2883,
    "auth_name": "EPSG",
    "auth_id": "2883",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 853,
    "description": "NAD83(HARN) / Georgia East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2884,
    "auth_name": "EPSG",
    "auth_id": "2884",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 854,
    "description": "NAD83(HARN) / Georgia West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2885,
    "auth_name": "EPSG",
    "auth_id": "2885",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 855,
    "description": "NAD83(HARN) / Idaho East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2886,
    "auth_name": "EPSG",
    "auth_id": "2886",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 856,
    "description": "NAD83(HARN) / Idaho Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2887,
    "auth_name": "EPSG",
    "auth_id": "2887",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 857,
    "description": "NAD83(HARN) / Idaho West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2888,
    "auth_name": "EPSG",
    "auth_id": "2888",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 860,
    "description": "NAD83(HARN) / Kentucky North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2891,
    "auth_name": "EPSG",
    "auth_id": "2891",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 861,
    "description": "NAD83(HARN) / Kentucky South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2892,
    "auth_name": "EPSG",
    "auth_id": "2892",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 862,
    "description": "NAD83(HARN) / Maryland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2893,
    "auth_name": "EPSG",
    "auth_id": "2893",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 863,
    "description": "NAD83(HARN) / Massachusetts Mainland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2894,
    "auth_name": "EPSG",
    "auth_id": "2894",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 864,
    "description": "NAD83(HARN) / Massachusetts Island (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2895,
    "auth_name": "EPSG",
    "auth_id": "2895",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 865,
    "description": "NAD83(HARN) / Michigan North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2896,
    "auth_name": "EPSG",
    "auth_id": "2896",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 866,
    "description": "NAD83(HARN) / Michigan Central (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2897,
    "auth_name": "EPSG",
    "auth_id": "2897",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 867,
    "description": "NAD83(HARN) / Michigan South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2898,
    "auth_name": "EPSG",
    "auth_id": "2898",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 868,
    "description": "NAD83(HARN) / Mississippi East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2899,
    "auth_name": "EPSG",
    "auth_id": "2899",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 869,
    "description": "NAD83(HARN) / Mississippi West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2900,
    "auth_name": "EPSG",
    "auth_id": "2900",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 870,
    "description": "NAD83(HARN) / Montana (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2901,
    "auth_name": "EPSG",
    "auth_id": "2901",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 871,
    "description": "NAD83(HARN) / New Mexico East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2902,
    "auth_name": "EPSG",
    "auth_id": "2902",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 872,
    "description": "NAD83(HARN) / New Mexico Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2903,
    "auth_name": "EPSG",
    "auth_id": "2903",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 873,
    "description": "NAD83(HARN) / New Mexico West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2904,
    "auth_name": "EPSG",
    "auth_id": "2904",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 874,
    "description": "NAD83(HARN) / New York East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2905,
    "auth_name": "EPSG",
    "auth_id": "2905",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 875,
    "description": "NAD83(HARN) / New York Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2906,
    "auth_name": "EPSG",
    "auth_id": "2906",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 876,
    "description": "NAD83(HARN) / New York West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2907,
    "auth_name": "EPSG",
    "auth_id": "2907",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 877,
    "description": "NAD83(HARN) / New York Long Island (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2908,
    "auth_name": "EPSG",
    "auth_id": "2908",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 878,
    "description": "NAD83(HARN) / North Dakota North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2909,
    "auth_name": "EPSG",
    "auth_id": "2909",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 879,
    "description": "NAD83(HARN) / North Dakota South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2910,
    "auth_name": "EPSG",
    "auth_id": "2910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 880,
    "description": "NAD83(HARN) / Oklahoma North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2911,
    "auth_name": "EPSG",
    "auth_id": "2911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 881,
    "description": "NAD83(HARN) / Oklahoma South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2912,
    "auth_name": "EPSG",
    "auth_id": "2912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 882,
    "description": "NAD83(HARN) / Oregon North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2913,
    "auth_name": "EPSG",
    "auth_id": "2913",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 883,
    "description": "NAD83(HARN) / Oregon South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2914,
    "auth_name": "EPSG",
    "auth_id": "2914",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 884,
    "description": "NAD83(HARN) / Tennessee (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2915,
    "auth_name": "EPSG",
    "auth_id": "2915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 885,
    "description": "NAD83(HARN) / Texas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2916,
    "auth_name": "EPSG",
    "auth_id": "2916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 886,
    "description": "NAD83(HARN) / Texas North Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2917,
    "auth_name": "EPSG",
    "auth_id": "2917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 887,
    "description": "NAD83(HARN) / Texas Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2918,
    "auth_name": "EPSG",
    "auth_id": "2918",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 888,
    "description": "NAD83(HARN) / Texas South Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2919,
    "auth_name": "EPSG",
    "auth_id": "2919",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 889,
    "description": "NAD83(HARN) / Texas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2920,
    "auth_name": "EPSG",
    "auth_id": "2920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 890,
    "description": "NAD83(HARN) / Utah North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.0001504 +y_0=999999.999996 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2921,
    "auth_name": "EPSG",
    "auth_id": "2921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 891,
    "description": "NAD83(HARN) / Utah Central (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.0001504 +y_0=1999999.999992 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2922,
    "auth_name": "EPSG",
    "auth_id": "2922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 892,
    "description": "NAD83(HARN) / Utah South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.0001504 +y_0=2999999.999988 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2923,
    "auth_name": "EPSG",
    "auth_id": "2923",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 893,
    "description": "NAD83(HARN) / Virginia North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2924,
    "auth_name": "EPSG",
    "auth_id": "2924",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 894,
    "description": "NAD83(HARN) / Virginia South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2925,
    "auth_name": "EPSG",
    "auth_id": "2925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 895,
    "description": "NAD83(HARN) / Washington North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2926,
    "auth_name": "EPSG",
    "auth_id": "2926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 896,
    "description": "NAD83(HARN) / Washington South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2927,
    "auth_name": "EPSG",
    "auth_id": "2927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 897,
    "description": "NAD83(HARN) / Wisconsin North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2928,
    "auth_name": "EPSG",
    "auth_id": "2928",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 898,
    "description": "NAD83(HARN) / Wisconsin Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2929,
    "auth_name": "EPSG",
    "auth_id": "2929",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 899,
    "description": "NAD83(HARN) / Wisconsin South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2930,
    "auth_name": "EPSG",
    "auth_id": "2930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 900,
    "description": "Beduaram / TM 13 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +towgs84=-106,-87,188,0,0,0,0 +units=m +no_defs",
    "srid": 2931,
    "auth_name": "EPSG",
    "auth_id": "2931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 901,
    "description": "QND95 / Qatar National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=24.45 +lon_0=51.2166666666667 +k=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +towgs84=-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065 +units=m +no_defs",
    "srid": 2932,
    "auth_name": "EPSG",
    "auth_id": "2932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 902,
    "description": "Segara / UTM zone 50S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=50 +south +ellps=bessel +towgs84=-404.78,685.68,45.47,0,0,0,0 +units=m +no_defs",
    "srid": 2933,
    "auth_name": "EPSG",
    "auth_id": "2933",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 904,
    "description": "Pulkovo 1942 / CS63 zone A1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.116666666666667 +lon_0=41.5333333333333 +k=1 +x_0=1300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2935,
    "auth_name": "EPSG",
    "auth_id": "2935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 905,
    "description": "Pulkovo 1942 / CS63 zone A2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.116666666666667 +lon_0=44.5333333333333 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2936,
    "auth_name": "EPSG",
    "auth_id": "2936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 906,
    "description": "Pulkovo 1942 / CS63 zone A3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.116666666666667 +lon_0=47.5333333333333 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2937,
    "auth_name": "EPSG",
    "auth_id": "2937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 907,
    "description": "Pulkovo 1942 / CS63 zone A4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.116666666666667 +lon_0=50.5333333333333 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2938,
    "auth_name": "EPSG",
    "auth_id": "2938",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 908,
    "description": "Pulkovo 1942 / CS63 zone K2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.133333333333333 +lon_0=50.7666666666667 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2939,
    "auth_name": "EPSG",
    "auth_id": "2939",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 909,
    "description": "Pulkovo 1942 / CS63 zone K3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.133333333333333 +lon_0=53.7666666666667 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2940,
    "auth_name": "EPSG",
    "auth_id": "2940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 910,
    "description": "Pulkovo 1942 / CS63 zone K4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.133333333333333 +lon_0=56.7666666666667 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 2941,
    "auth_name": "EPSG",
    "auth_id": "2941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 911,
    "description": "Porto Santo / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=28 +ellps=intl +towgs84=-499,-249,314,0,0,0,0 +units=m +no_defs",
    "srid": 2942,
    "auth_name": "EPSG",
    "auth_id": "2942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 912,
    "description": "Selvagem Grande / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=28 +ellps=intl +towgs84=-289,-124,60,0,0,0,0 +units=m +no_defs",
    "srid": 2943,
    "auth_name": "EPSG",
    "auth_id": "2943",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 914,
    "description": "NAD83(CSRS) / MTM zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2945,
    "auth_name": "EPSG",
    "auth_id": "2945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 915,
    "description": "NAD83(CSRS) / MTM zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2946,
    "auth_name": "EPSG",
    "auth_id": "2946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 916,
    "description": "NAD83(CSRS) / MTM zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2947,
    "auth_name": "EPSG",
    "auth_id": "2947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 917,
    "description": "NAD83(CSRS) / MTM zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2948,
    "auth_name": "EPSG",
    "auth_id": "2948",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 918,
    "description": "NAD83(CSRS) / MTM zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2949,
    "auth_name": "EPSG",
    "auth_id": "2949",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 919,
    "description": "NAD83(CSRS) / MTM zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2950,
    "auth_name": "EPSG",
    "auth_id": "2950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 920,
    "description": "NAD83(CSRS) / MTM zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2951,
    "auth_name": "EPSG",
    "auth_id": "2951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 921,
    "description": "NAD83(CSRS) / MTM zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2952,
    "auth_name": "EPSG",
    "auth_id": "2952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 922,
    "description": "NAD83(CSRS) / New Brunswick Stereographic",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2953,
    "auth_name": "EPSG",
    "auth_id": "2953",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 923,
    "description": "NAD83(CSRS) / Prince Edward Isl. Stereographic (NAD83)",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs",
    "srid": 2954,
    "auth_name": "EPSG",
    "auth_id": "2954",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 924,
    "description": "NAD83(CSRS) / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs",
    "srid": 2955,
    "auth_name": "EPSG",
    "auth_id": "2955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 925,
    "description": "NAD83(CSRS) / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs",
    "srid": 2956,
    "auth_name": "EPSG",
    "auth_id": "2956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 926,
    "description": "NAD83(CSRS) / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs",
    "srid": 2957,
    "auth_name": "EPSG",
    "auth_id": "2957",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 927,
    "description": "NAD83(CSRS) / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 2958,
    "auth_name": "EPSG",
    "auth_id": "2958",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 928,
    "description": "NAD83(CSRS) / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs",
    "srid": 2959,
    "auth_name": "EPSG",
    "auth_id": "2959",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 929,
    "description": "NAD83(CSRS) / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs",
    "srid": 2960,
    "auth_name": "EPSG",
    "auth_id": "2960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 930,
    "description": "NAD83(CSRS) / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs",
    "srid": 2961,
    "auth_name": "EPSG",
    "auth_id": "2961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 931,
    "description": "NAD83(CSRS) / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs",
    "srid": 2962,
    "auth_name": "EPSG",
    "auth_id": "2962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 932,
    "description": "NAD27 / Alaska Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 2964,
    "auth_name": "EPSG",
    "auth_id": "2964",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 933,
    "description": "NAD83 / Indiana East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2965,
    "auth_name": "EPSG",
    "auth_id": "2965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 934,
    "description": "NAD83 / Indiana West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 2966,
    "auth_name": "EPSG",
    "auth_id": "2966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 935,
    "description": "NAD83(HARN) / Indiana East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2967,
    "auth_name": "EPSG",
    "auth_id": "2967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 936,
    "description": "NAD83(HARN) / Indiana West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 2968,
    "auth_name": "EPSG",
    "auth_id": "2968",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 937,
    "description": "Fort Marigot / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +towgs84=137,248,-430,0,0,0,0 +units=m +no_defs",
    "srid": 2969,
    "auth_name": "EPSG",
    "auth_id": "2969",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 938,
    "description": "Guadeloupe 1948 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 2970,
    "auth_name": "EPSG",
    "auth_id": "2970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 939,
    "description": "CSG67 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs",
    "srid": 2971,
    "auth_name": "EPSG",
    "auth_id": "2971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 940,
    "description": "RGFG95 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2972,
    "auth_name": "EPSG",
    "auth_id": "2972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 941,
    "description": "Martinique 1938 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 2973,
    "auth_name": "EPSG",
    "auth_id": "2973",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 942,
    "description": "RGR92 / UTM zone 40S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=40 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2975,
    "auth_name": "EPSG",
    "auth_id": "2975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 943,
    "description": "Tahiti 52 / UTM zone 6S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=162,117,154,0,0,0,0 +units=m +no_defs",
    "srid": 2976,
    "auth_name": "EPSG",
    "auth_id": "2976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 944,
    "description": "Tahaa 54 / UTM zone 5S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs",
    "srid": 2977,
    "auth_name": "EPSG",
    "auth_id": "2977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 945,
    "description": "IGN72 Nuku Hiva / UTM zone 7S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +towgs84=84,274,65,0,0,0,0 +units=m +no_defs",
    "srid": 2978,
    "auth_name": "EPSG",
    "auth_id": "2978",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 947,
    "description": "Combani 1950 / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +no_defs",
    "srid": 2980,
    "auth_name": "EPSG",
    "auth_id": "2980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 948,
    "description": "IGN56 Lifou / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=335.47,222.58,-230.94,0,0,0,0 +units=m +no_defs",
    "srid": 2981,
    "auth_name": "EPSG",
    "auth_id": "2981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 952,
    "description": "Saint Pierre et Miquelon 1950 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=21 +ellps=clrk66 +towgs84=11.363,424.148,373.13,0,0,0,0 +units=m +no_defs",
    "srid": 2987,
    "auth_name": "EPSG",
    "auth_id": "2987",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 953,
    "description": "MOP78 / UTM zone 1S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=1 +south +ellps=intl +towgs84=253,-132,-127,0,0,0,0 +units=m +no_defs",
    "srid": 2988,
    "auth_name": "EPSG",
    "auth_id": "2988",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 956,
    "description": "NAD83 / Oregon LCC (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2991,
    "auth_name": "EPSG",
    "auth_id": "2991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 957,
    "description": "NAD83 / Oregon GIC Lambert (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 2992,
    "auth_name": "EPSG",
    "auth_id": "2992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 958,
    "description": "NAD83(HARN) / Oregon LCC (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 2993,
    "auth_name": "EPSG",
    "auth_id": "2993",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 959,
    "description": "NAD83(HARN) / Oregon GIC Lambert (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 2994,
    "auth_name": "EPSG",
    "auth_id": "2994",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 960,
    "description": "IGN53 Mare / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=287.58,177.78,-135.41,0,0,0,0 +units=m +no_defs",
    "srid": 2995,
    "auth_name": "EPSG",
    "auth_id": "2995",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 961,
    "description": "ST84 Ile des Pins / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs",
    "srid": 2996,
    "auth_name": "EPSG",
    "auth_id": "2996",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 962,
    "description": "ST71 Belep / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002 +units=m +no_defs",
    "srid": 2997,
    "auth_name": "EPSG",
    "auth_id": "2997",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 963,
    "description": "NEA74 Noumea / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +units=m +no_defs",
    "srid": 2998,
    "auth_name": "EPSG",
    "auth_id": "2998",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 964,
    "description": "Grand Comoros / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-963,510,-359,0,0,0,0 +units=m +no_defs",
    "srid": 2999,
    "auth_name": "EPSG",
    "auth_id": "2999",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 965,
    "description": "Segara / NEIEZ",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +units=m +no_defs",
    "srid": 3000,
    "auth_name": "EPSG",
    "auth_id": "3000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 966,
    "description": "Batavia / NEIEZ",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs",
    "srid": 3001,
    "auth_name": "EPSG",
    "auth_id": "3001",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 967,
    "description": "Makassar / NEIEZ",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=merc +lon_0=110 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +units=m +no_defs",
    "srid": 3002,
    "auth_name": "EPSG",
    "auth_id": "3002",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 968,
    "description": "Monte Mario / Italy zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 3003,
    "auth_name": "EPSG",
    "auth_id": "3003",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 969,
    "description": "Monte Mario / Italy zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 3004,
    "auth_name": "EPSG",
    "auth_id": "3004",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 970,
    "description": "NAD83 / BC Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=45 +lon_0=-126 +lat_1=50 +lat_2=58.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3005,
    "auth_name": "EPSG",
    "auth_id": "3005",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 971,
    "description": "SWEREF99 TM",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3006,
    "auth_name": "EPSG",
    "auth_id": "3006",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 972,
    "description": "SWEREF99 12 00",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3007,
    "auth_name": "EPSG",
    "auth_id": "3007",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 973,
    "description": "SWEREF99 13 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3008,
    "auth_name": "EPSG",
    "auth_id": "3008",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 974,
    "description": "SWEREF99 15 00",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3009,
    "auth_name": "EPSG",
    "auth_id": "3009",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 975,
    "description": "SWEREF99 16 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3010,
    "auth_name": "EPSG",
    "auth_id": "3010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 976,
    "description": "SWEREF99 18 00",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3011,
    "auth_name": "EPSG",
    "auth_id": "3011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 977,
    "description": "SWEREF99 14 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=14.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3012,
    "auth_name": "EPSG",
    "auth_id": "3012",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 978,
    "description": "SWEREF99 15 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3013,
    "auth_name": "EPSG",
    "auth_id": "3013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 979,
    "description": "SWEREF99 17 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=17.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3014,
    "auth_name": "EPSG",
    "auth_id": "3014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 980,
    "description": "SWEREF99 18 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3015,
    "auth_name": "EPSG",
    "auth_id": "3015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 981,
    "description": "SWEREF99 20 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3016,
    "auth_name": "EPSG",
    "auth_id": "3016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 982,
    "description": "SWEREF99 21 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3017,
    "auth_name": "EPSG",
    "auth_id": "3017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 983,
    "description": "SWEREF99 23 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3018,
    "auth_name": "EPSG",
    "auth_id": "3018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 984,
    "description": "RT90 7.5 gon V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11.3082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs",
    "srid": 3019,
    "auth_name": "EPSG",
    "auth_id": "3019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 985,
    "description": "RT90 5 gon V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13.5582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs",
    "srid": 3020,
    "auth_name": "EPSG",
    "auth_id": "3020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 986,
    "description": "RT90 2.5 gon V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15.8082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3021,
    "auth_name": "EPSG",
    "auth_id": "3021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 987,
    "description": "RT90 0 gon",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18.0582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs",
    "srid": 3022,
    "auth_name": "EPSG",
    "auth_id": "3022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 988,
    "description": "RT90 2.5 gon O",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20.3082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs",
    "srid": 3023,
    "auth_name": "EPSG",
    "auth_id": "3023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 989,
    "description": "RT90 5 gon O",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=22.5582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +units=m +no_defs",
    "srid": 3024,
    "auth_name": "EPSG",
    "auth_id": "3024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 990,
    "description": "RT38 7.5 gon V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11.3082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3025,
    "auth_name": "EPSG",
    "auth_id": "3025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 991,
    "description": "RT38 5 gon V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13.5582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3026,
    "auth_name": "EPSG",
    "auth_id": "3026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 992,
    "description": "RT38 2.5 gon V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15.8082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3027,
    "auth_name": "EPSG",
    "auth_id": "3027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 993,
    "description": "RT38 0 gon",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18.0582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3028,
    "auth_name": "EPSG",
    "auth_id": "3028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 994,
    "description": "RT38 2.5 gon O",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20.3082777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3029,
    "auth_name": "EPSG",
    "auth_id": "3029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 995,
    "description": "RT38 5 gon O",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=22.5582777777778 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3030,
    "auth_name": "EPSG",
    "auth_id": "3030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 996,
    "description": "WGS 84 / Antarctic Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3031,
    "auth_name": "EPSG",
    "auth_id": "3031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 997,
    "description": "WGS 84 / Australian Antarctic Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=70 +x_0=6000000 +y_0=6000000 +datum=WGS84 +units=m +no_defs",
    "srid": 3032,
    "auth_name": "EPSG",
    "auth_id": "3032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 998,
    "description": "WGS 84 / Australian Antarctic Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-50 +lon_0=70 +lat_1=-68.5 +lat_2=-74.5 +x_0=6000000 +y_0=6000000 +datum=WGS84 +units=m +no_defs",
    "srid": 3033,
    "auth_name": "EPSG",
    "auth_id": "3033",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 999,
    "description": "ETRS89-extended / LCC Europe",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3034,
    "auth_name": "EPSG",
    "auth_id": "3034",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1000,
    "description": "ETRS89-extended / LAEA Europe",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3035,
    "auth_name": "EPSG",
    "auth_id": "3035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1001,
    "description": "Moznet / UTM zone 36S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=36 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3036,
    "auth_name": "EPSG",
    "auth_id": "3036",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1002,
    "description": "Moznet / UTM zone 37S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=37 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3037,
    "auth_name": "EPSG",
    "auth_id": "3037",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1005,
    "description": "ETRS89 / UTM zone 28N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3040,
    "auth_name": "EPSG",
    "auth_id": "3040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1006,
    "description": "ETRS89 / UTM zone 29N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3041,
    "auth_name": "EPSG",
    "auth_id": "3041",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1007,
    "description": "ETRS89 / UTM zone 30N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3042,
    "auth_name": "EPSG",
    "auth_id": "3042",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1008,
    "description": "ETRS89 / UTM zone 31N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3043,
    "auth_name": "EPSG",
    "auth_id": "3043",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1009,
    "description": "ETRS89 / UTM zone 32N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3044,
    "auth_name": "EPSG",
    "auth_id": "3044",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1010,
    "description": "ETRS89 / UTM zone 33N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3045,
    "auth_name": "EPSG",
    "auth_id": "3045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1011,
    "description": "ETRS89 / UTM zone 34N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3046,
    "auth_name": "EPSG",
    "auth_id": "3046",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1012,
    "description": "ETRS89 / UTM zone 35N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3047,
    "auth_name": "EPSG",
    "auth_id": "3047",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1013,
    "description": "ETRS89 / UTM zone 36N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3048,
    "auth_name": "EPSG",
    "auth_id": "3048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1014,
    "description": "ETRS89 / UTM zone 37N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3049,
    "auth_name": "EPSG",
    "auth_id": "3049",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1017,
    "description": "Hjorsey 1955 / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=26 +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +units=m +no_defs",
    "srid": 3054,
    "auth_name": "EPSG",
    "auth_id": "3054",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1018,
    "description": "Hjorsey 1955 / UTM zone 27N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=27 +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +units=m +no_defs",
    "srid": 3055,
    "auth_name": "EPSG",
    "auth_id": "3055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1019,
    "description": "Hjorsey 1955 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=28 +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +units=m +no_defs",
    "srid": 3056,
    "auth_name": "EPSG",
    "auth_id": "3056",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1020,
    "description": "ISN93 / Lambert 1993",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3057,
    "auth_name": "EPSG",
    "auth_id": "3057",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1021,
    "description": "Helle 1954 / Jan Mayen Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-8.5 +k=1 +x_0=50000 +y_0=-7800000 +ellps=intl +towgs84=982.6087,552.753,-540.873,6.68162662527694,-31.6114924086422,-19.8481610048168,16.805 +units=m +no_defs",
    "srid": 3058,
    "auth_name": "EPSG",
    "auth_id": "3058",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1022,
    "description": "LKS-92 / Latvia TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3059,
    "auth_name": "EPSG",
    "auth_id": "3059",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1023,
    "description": "IGN72 Grande Terre / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-11.64,-348.6,291.98,0,0,0,0 +units=m +no_defs",
    "srid": 3060,
    "auth_name": "EPSG",
    "auth_id": "3060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1024,
    "description": "Porto Santo 1995 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=28 +ellps=intl +units=m +no_defs",
    "srid": 3061,
    "auth_name": "EPSG",
    "auth_id": "3061",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1025,
    "description": "Azores Oriental 1995 / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=26 +ellps=intl +units=m +no_defs",
    "srid": 3062,
    "auth_name": "EPSG",
    "auth_id": "3062",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1026,
    "description": "Azores Central 1995 / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=26 +ellps=intl +units=m +no_defs",
    "srid": 3063,
    "auth_name": "EPSG",
    "auth_id": "3063",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1027,
    "description": "IGM95 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3064,
    "auth_name": "EPSG",
    "auth_id": "3064",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1028,
    "description": "IGM95 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3065,
    "auth_name": "EPSG",
    "auth_id": "3065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1029,
    "description": "ED50 / Jordan TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=37 +k=0.9998 +x_0=500000 +y_0=-3000000 +ellps=intl +towgs84=-112,-110.3,-140.2,0,0,0,0 +units=m +no_defs",
    "srid": 3066,
    "auth_name": "EPSG",
    "auth_id": "3066",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1030,
    "description": "ETRS89 / TM35FIN(E,N)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3067,
    "auth_name": "EPSG",
    "auth_id": "3067",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1031,
    "description": "DHDN / Soldner Berlin",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=cass +lat_0=52.4186482777778 +lon_0=13.6272036666667 +x_0=40000 +y_0=10000 +ellps=bessel +units=m +no_defs",
    "srid": 3068,
    "auth_name": "EPSG",
    "auth_id": "3068",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1032,
    "description": "NAD27 / Wisconsin Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=500000 +y_0=-4500000 +datum=NAD27 +units=m +no_defs",
    "srid": 3069,
    "auth_name": "EPSG",
    "auth_id": "3069",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1033,
    "description": "NAD83 / Wisconsin Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +datum=NAD83 +units=m +no_defs",
    "srid": 3070,
    "auth_name": "EPSG",
    "auth_id": "3070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1034,
    "description": "NAD83(HARN) / Wisconsin Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3071,
    "auth_name": "EPSG",
    "auth_id": "3071",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1035,
    "description": "NAD83 / Maine CS2000 East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3072,
    "auth_name": "EPSG",
    "auth_id": "3072",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1037,
    "description": "NAD83 / Maine CS2000 West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3074,
    "auth_name": "EPSG",
    "auth_id": "3074",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1038,
    "description": "NAD83(HARN) / Maine CS2000 East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3075,
    "auth_name": "EPSG",
    "auth_id": "3075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1040,
    "description": "NAD83(HARN) / Maine CS2000 West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3077,
    "auth_name": "EPSG",
    "auth_id": "3077",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1041,
    "description": "NAD83 / Michigan Oblique Mercator",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +datum=NAD83 +units=m +no_defs",
    "srid": 3078,
    "auth_name": "EPSG",
    "auth_id": "3078",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1042,
    "description": "NAD83(HARN) / Michigan Oblique Mercator",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +ellps=GRS80 +units=m +no_defs",
    "srid": 3079,
    "auth_name": "EPSG",
    "auth_id": "3079",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1043,
    "description": "NAD27 / Shackleford",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=31.1666666666667 +lon_0=-100 +lat_1=27.4166666666667 +lat_2=34.9166666666667 +x_0=914400 +y_0=914400 +datum=NAD27 +units=ft +no_defs",
    "srid": 3080,
    "auth_name": "EPSG",
    "auth_id": "3080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1044,
    "description": "NAD83 / Texas State Mapping System",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.1666666666667 +lon_0=-100 +lat_1=27.4166666666667 +lat_2=34.9166666666667 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3081,
    "auth_name": "EPSG",
    "auth_id": "3081",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1045,
    "description": "NAD83 / Texas Centric Lambert Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3082,
    "auth_name": "EPSG",
    "auth_id": "3082",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1046,
    "description": "NAD83 / Texas Centric Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3083,
    "auth_name": "EPSG",
    "auth_id": "3083",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1047,
    "description": "NAD83(HARN) / Texas Centric Lambert Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3084,
    "auth_name": "EPSG",
    "auth_id": "3084",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1048,
    "description": "NAD83(HARN) / Texas Centric Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3085,
    "auth_name": "EPSG",
    "auth_id": "3085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1049,
    "description": "NAD83 / Florida GDL Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 3086,
    "auth_name": "EPSG",
    "auth_id": "3086",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1050,
    "description": "NAD83(HARN) / Florida GDL Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3087,
    "auth_name": "EPSG",
    "auth_id": "3087",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1051,
    "description": "NAD83 / Kentucky Single Zone",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +datum=NAD83 +units=m +no_defs",
    "srid": 3088,
    "auth_name": "EPSG",
    "auth_id": "3088",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1052,
    "description": "NAD83 / Kentucky Single Zone (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=999999.9998984 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 3089,
    "auth_name": "EPSG",
    "auth_id": "3089",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1053,
    "description": "NAD83(HARN) / Kentucky Single Zone",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3090,
    "auth_name": "EPSG",
    "auth_id": "3090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1054,
    "description": "NAD83(HARN) / Kentucky Single Zone (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=999999.9998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3091,
    "auth_name": "EPSG",
    "auth_id": "3091",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1055,
    "description": "Tokyo / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=51 +ellps=bessel +units=m +no_defs",
    "srid": 3092,
    "auth_name": "EPSG",
    "auth_id": "3092",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1056,
    "description": "Tokyo / UTM zone 52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=52 +ellps=bessel +units=m +no_defs",
    "srid": 3093,
    "auth_name": "EPSG",
    "auth_id": "3093",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1057,
    "description": "Tokyo / UTM zone 53N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=53 +ellps=bessel +units=m +no_defs",
    "srid": 3094,
    "auth_name": "EPSG",
    "auth_id": "3094",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1058,
    "description": "Tokyo / UTM zone 54N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=54 +ellps=bessel +units=m +no_defs",
    "srid": 3095,
    "auth_name": "EPSG",
    "auth_id": "3095",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1059,
    "description": "Tokyo / UTM zone 55N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=55 +ellps=bessel +units=m +no_defs",
    "srid": 3096,
    "auth_name": "EPSG",
    "auth_id": "3096",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1060,
    "description": "JGD2000 / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=51 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3097,
    "auth_name": "EPSG",
    "auth_id": "3097",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1061,
    "description": "JGD2000 / UTM zone 52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=52 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3098,
    "auth_name": "EPSG",
    "auth_id": "3098",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1062,
    "description": "JGD2000 / UTM zone 53N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=53 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3099,
    "auth_name": "EPSG",
    "auth_id": "3099",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1063,
    "description": "JGD2000 / UTM zone 54N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=54 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3100,
    "auth_name": "EPSG",
    "auth_id": "3100",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1064,
    "description": "JGD2000 / UTM zone 55N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=55 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3101,
    "auth_name": "EPSG",
    "auth_id": "3101",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1065,
    "description": "American Samoa 1962 / American Samoa Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=-14.2666666666667 +lat_0=-14.2666666666667 +lon_0=-170 +k_0=1 +x_0=152400.30480061 +y_0=95169.3116586233 +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3102,
    "auth_name": "EPSG",
    "auth_id": "3102",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1069,
    "description": "Gulshan 303 / TM 90 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +units=m +no_defs",
    "srid": 3106,
    "auth_name": "EPSG",
    "auth_id": "3106",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1070,
    "description": "GDA94 / SA Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-32 +lon_0=135 +lat_1=-28 +lat_2=-36 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3107,
    "auth_name": "EPSG",
    "auth_id": "3107",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1071,
    "description": "ETRS89 / Guernsey Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=49.5 +lon_0=-2.41666666666667 +k=0.999997 +x_0=47000 +y_0=50000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3108,
    "auth_name": "EPSG",
    "auth_id": "3108",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1072,
    "description": "ETRS89 / Jersey Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=49.225 +lon_0=-2.135 +k=0.9999999 +x_0=40000 +y_0=70000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3109,
    "auth_name": "EPSG",
    "auth_id": "3109",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1073,
    "description": "AGD66 / Vicgrid66",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=lcc +lat_0=-37 +lon_0=145 +lat_1=-36 +lat_2=-38 +x_0=2500000 +y_0=4500000 +ellps=aust_SA +units=m +no_defs",
    "srid": 3110,
    "auth_name": "EPSG",
    "auth_id": "3110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1074,
    "description": "GDA94 / Vicgrid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-37 +lon_0=145 +lat_1=-36 +lat_2=-38 +x_0=2500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3111,
    "auth_name": "EPSG",
    "auth_id": "3111",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1075,
    "description": "GDA94 / Geoscience Australia Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=134 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3112,
    "auth_name": "EPSG",
    "auth_id": "3112",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1076,
    "description": "GDA94 / BCSG02",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-28 +lon_0=153 +k=0.99999 +x_0=50000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3113,
    "auth_name": "EPSG",
    "auth_id": "3113",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1077,
    "description": "MAGNA-SIRGAS / Colombia Far West zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-80.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3114,
    "auth_name": "EPSG",
    "auth_id": "3114",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1078,
    "description": "MAGNA-SIRGAS / Colombia West zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-77.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3115,
    "auth_name": "EPSG",
    "auth_id": "3115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1079,
    "description": "MAGNA-SIRGAS / Colombia Bogota zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-74.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3116,
    "auth_name": "EPSG",
    "auth_id": "3116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1080,
    "description": "MAGNA-SIRGAS / Colombia East Central zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-71.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3117,
    "auth_name": "EPSG",
    "auth_id": "3117",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1081,
    "description": "MAGNA-SIRGAS / Colombia East zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=4.59620041666667 +lon_0=-68.0775079166667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3118,
    "auth_name": "EPSG",
    "auth_id": "3118",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1082,
    "description": "Douala 1948 / AEF west",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=10.5 +k=0.999 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=-206.1,-174.7,-87.7,0,0,0,0 +units=m +no_defs",
    "srid": 3119,
    "auth_name": "EPSG",
    "auth_id": "3119",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1083,
    "description": "Pulkovo 1942(58) / Poland zone I",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=sterea +lat_0=50.625 +lon_0=21.0833333333333 +k=0.9998 +x_0=4637000 +y_0=5467000 +ellps=krass +units=m +no_defs",
    "srid": 3120,
    "auth_name": "EPSG",
    "auth_id": "3120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1084,
    "description": "PRS92 / Philippines zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs",
    "srid": 3121,
    "auth_name": "EPSG",
    "auth_id": "3121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1085,
    "description": "PRS92 / Philippines zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs",
    "srid": 3122,
    "auth_name": "EPSG",
    "auth_id": "3122",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1086,
    "description": "PRS92 / Philippines zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs",
    "srid": 3123,
    "auth_name": "EPSG",
    "auth_id": "3123",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1087,
    "description": "PRS92 / Philippines zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs",
    "srid": 3124,
    "auth_name": "EPSG",
    "auth_id": "3124",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1088,
    "description": "PRS92 / Philippines zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=125 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs",
    "srid": 3125,
    "auth_name": "EPSG",
    "auth_id": "3125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1089,
    "description": "ETRS89 / ETRS-GK19FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3126,
    "auth_name": "EPSG",
    "auth_id": "3126",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1090,
    "description": "ETRS89 / ETRS-GK20FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3127,
    "auth_name": "EPSG",
    "auth_id": "3127",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1091,
    "description": "ETRS89 / ETRS-GK21FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3128,
    "auth_name": "EPSG",
    "auth_id": "3128",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1092,
    "description": "ETRS89 / ETRS-GK22FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=22 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3129,
    "auth_name": "EPSG",
    "auth_id": "3129",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1093,
    "description": "ETRS89 / ETRS-GK23FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3130,
    "auth_name": "EPSG",
    "auth_id": "3130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1094,
    "description": "ETRS89 / ETRS-GK24FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3131,
    "auth_name": "EPSG",
    "auth_id": "3131",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1095,
    "description": "ETRS89 / ETRS-GK25FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3132,
    "auth_name": "EPSG",
    "auth_id": "3132",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1096,
    "description": "ETRS89 / ETRS-GK26FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=26 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3133,
    "auth_name": "EPSG",
    "auth_id": "3133",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1097,
    "description": "ETRS89 / ETRS-GK27FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3134,
    "auth_name": "EPSG",
    "auth_id": "3134",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1098,
    "description": "ETRS89 / ETRS-GK28FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3135,
    "auth_name": "EPSG",
    "auth_id": "3135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1099,
    "description": "ETRS89 / ETRS-GK29FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3136,
    "auth_name": "EPSG",
    "auth_id": "3136",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1100,
    "description": "ETRS89 / ETRS-GK30FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3137,
    "auth_name": "EPSG",
    "auth_id": "3137",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1101,
    "description": "ETRS89 / ETRS-GK31FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3138,
    "auth_name": "EPSG",
    "auth_id": "3138",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1102,
    "description": "Viti Levu 1912 / Viti Levu Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=-18 +lon_0=178 +x_0=109435.392 +y_0=141622.272 +a=6378306.3696 +b=6356571.996 +towgs84=98,390,-22,0,0,0,0 +units=link +no_defs",
    "srid": 3140,
    "auth_name": "EPSG",
    "auth_id": "3140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1103,
    "description": "Fiji 1956 / UTM zone 60S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=60 +south +ellps=intl +towgs84=265.025,384.929,-194.046,0,0,0,0 +units=m +no_defs",
    "srid": 3141,
    "auth_name": "EPSG",
    "auth_id": "3141",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1104,
    "description": "Fiji 1956 / UTM zone 1S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=1 +south +ellps=intl +towgs84=265.025,384.929,-194.046,0,0,0,0 +units=m +no_defs",
    "srid": 3142,
    "auth_name": "EPSG",
    "auth_id": "3142",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1108,
    "description": "Indian 1960 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=utm +zone=48 +ellps=evrst30 +units=m +no_defs",
    "srid": 3148,
    "auth_name": "EPSG",
    "auth_id": "3148",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1109,
    "description": "Indian 1960 / UTM zone 49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=utm +zone=49 +ellps=evrst30 +units=m +no_defs",
    "srid": 3149,
    "auth_name": "EPSG",
    "auth_id": "3149",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1112,
    "description": "ST74",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18.05779 +k=0.99999425 +x_0=100178.1808 +y_0=-6500614.7836 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3152,
    "auth_name": "EPSG",
    "auth_id": "3152",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1113,
    "description": "NAD83(CSRS) / BC Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=45 +lon_0=-126 +lat_1=50 +lat_2=58.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3153,
    "auth_name": "EPSG",
    "auth_id": "3153",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1114,
    "description": "NAD83(CSRS) / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs",
    "srid": 3154,
    "auth_name": "EPSG",
    "auth_id": "3154",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1115,
    "description": "NAD83(CSRS) / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs",
    "srid": 3155,
    "auth_name": "EPSG",
    "auth_id": "3155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1116,
    "description": "NAD83(CSRS) / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs",
    "srid": 3156,
    "auth_name": "EPSG",
    "auth_id": "3156",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1117,
    "description": "NAD83(CSRS) / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs",
    "srid": 3157,
    "auth_name": "EPSG",
    "auth_id": "3157",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1118,
    "description": "NAD83(CSRS) / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs",
    "srid": 3158,
    "auth_name": "EPSG",
    "auth_id": "3158",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1119,
    "description": "NAD83(CSRS) / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs",
    "srid": 3159,
    "auth_name": "EPSG",
    "auth_id": "3159",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1120,
    "description": "NAD83(CSRS) / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs",
    "srid": 3160,
    "auth_name": "EPSG",
    "auth_id": "3160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1121,
    "description": "NAD83 / Ontario MNR Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=-85 +lat_1=44.5 +lat_2=53.5 +x_0=930000 +y_0=6430000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3161,
    "auth_name": "EPSG",
    "auth_id": "3161",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1122,
    "description": "NAD83(CSRS) / Ontario MNR Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=-85 +lat_1=44.5 +lat_2=53.5 +x_0=930000 +y_0=6430000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3162,
    "auth_name": "EPSG",
    "auth_id": "3162",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1123,
    "description": "RGNC91-93 / Lambert New Caledonia",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3163,
    "auth_name": "EPSG",
    "auth_id": "3163",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1124,
    "description": "ST87 Ouvea / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=58 +south +ellps=WGS84 +towgs84=-56.263,16.136,-22.856,0,0,0,0 +units=m +no_defs",
    "srid": 3164,
    "auth_name": "EPSG",
    "auth_id": "3164",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1125,
    "description": "NEA74 Noumea / Noumea Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-22.26969175 +lon_0=166.44242575 +lat_1=-22.24469175 +lat_2=-22.29469175 +x_0=0.66 +y_0=1.02 +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +units=m +no_defs",
    "srid": 3165,
    "auth_name": "EPSG",
    "auth_id": "3165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1126,
    "description": "NEA74 Noumea / Noumea Lambert 2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-22.2697222222222 +lon_0=166.4425 +lat_1=-22.2447222222222 +lat_2=-22.2947222222222 +x_0=8.313 +y_0=-2.354 +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +units=m +no_defs",
    "srid": 3166,
    "auth_name": "EPSG",
    "auth_id": "3166",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1127,
    "description": "Kertau (RSO) / RSO Malaya (ch)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "evrst69",
    "parameters": "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=323.0257905 +gamma=323.130102361111 +k=0.99984 +x_0=804670.24 +y_0=0 +ellps=evrst69 +to_meter=20.116756 +no_defs",
    "srid": 3167,
    "auth_name": "EPSG",
    "auth_id": "3167",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1128,
    "description": "Kertau (RSO) / RSO Malaya (m)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "evrst69",
    "parameters": "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=323.0257905 +gamma=323.130102361111 +k=0.99984 +x_0=804670.24 +y_0=0 +ellps=evrst69 +units=m +no_defs",
    "srid": 3168,
    "auth_name": "EPSG",
    "auth_id": "3168",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1129,
    "description": "RGNC91-93 / UTM zone 57S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=57 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3169,
    "auth_name": "EPSG",
    "auth_id": "3169",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1130,
    "description": "RGNC91-93 / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3170,
    "auth_name": "EPSG",
    "auth_id": "3170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1131,
    "description": "RGNC91-93 / UTM zone 59S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3171,
    "auth_name": "EPSG",
    "auth_id": "3171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1132,
    "description": "IGN53 Mare / UTM zone 59S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=59 +south +ellps=intl +towgs84=287.58,177.78,-135.41,0,0,0,0 +units=m +no_defs",
    "srid": 3172,
    "auth_name": "EPSG",
    "auth_id": "3172",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1133,
    "description": "NAD83 / Great Lakes Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=45.568977 +lon_0=-84.455955 +lat_1=42.122774 +lat_2=49.01518 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3174,
    "auth_name": "EPSG",
    "auth_id": "3174",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1134,
    "description": "NAD83 / Great Lakes and St Lawrence Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=45.568977 +lon_0=-83.248627 +lat_1=42.122774 +lat_2=49.01518 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3175,
    "auth_name": "EPSG",
    "auth_id": "3175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1135,
    "description": "Indian 1960 / TM 106 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +units=m +no_defs",
    "srid": 3176,
    "auth_name": "EPSG",
    "auth_id": "3176",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1136,
    "description": "LGD2006 / Libya TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.9965 +x_0=1000000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3177,
    "auth_name": "EPSG",
    "auth_id": "3177",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1137,
    "description": "GR96 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3178,
    "auth_name": "EPSG",
    "auth_id": "3178",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1138,
    "description": "GR96 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3179,
    "auth_name": "EPSG",
    "auth_id": "3179",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1139,
    "description": "GR96 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3180,
    "auth_name": "EPSG",
    "auth_id": "3180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1140,
    "description": "GR96 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3181,
    "auth_name": "EPSG",
    "auth_id": "3181",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1141,
    "description": "GR96 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3182,
    "auth_name": "EPSG",
    "auth_id": "3182",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1142,
    "description": "GR96 / UTM zone 23N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=23 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3183,
    "auth_name": "EPSG",
    "auth_id": "3183",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1143,
    "description": "GR96 / UTM zone 24N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=24 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3184,
    "auth_name": "EPSG",
    "auth_id": "3184",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1144,
    "description": "GR96 / UTM zone 25N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=25 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3185,
    "auth_name": "EPSG",
    "auth_id": "3185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1145,
    "description": "GR96 / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3186,
    "auth_name": "EPSG",
    "auth_id": "3186",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1146,
    "description": "GR96 / UTM zone 27N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3187,
    "auth_name": "EPSG",
    "auth_id": "3187",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1147,
    "description": "GR96 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3188,
    "auth_name": "EPSG",
    "auth_id": "3188",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1148,
    "description": "GR96 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3189,
    "auth_name": "EPSG",
    "auth_id": "3189",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1149,
    "description": "LGD2006 / Libya TM zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3190,
    "auth_name": "EPSG",
    "auth_id": "3190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1150,
    "description": "LGD2006 / Libya TM zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3191,
    "auth_name": "EPSG",
    "auth_id": "3191",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1151,
    "description": "LGD2006 / Libya TM zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3192,
    "auth_name": "EPSG",
    "auth_id": "3192",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1152,
    "description": "LGD2006 / Libya TM zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3193,
    "auth_name": "EPSG",
    "auth_id": "3193",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1153,
    "description": "LGD2006 / Libya TM zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=17 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3194,
    "auth_name": "EPSG",
    "auth_id": "3194",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1154,
    "description": "LGD2006 / Libya TM zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3195,
    "auth_name": "EPSG",
    "auth_id": "3195",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1155,
    "description": "LGD2006 / Libya TM zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3196,
    "auth_name": "EPSG",
    "auth_id": "3196",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1156,
    "description": "LGD2006 / Libya TM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3197,
    "auth_name": "EPSG",
    "auth_id": "3197",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1157,
    "description": "LGD2006 / Libya TM zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=25 +k=0.99995 +x_0=200000 +y_0=0 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3198,
    "auth_name": "EPSG",
    "auth_id": "3198",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1158,
    "description": "LGD2006 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3199,
    "auth_name": "EPSG",
    "auth_id": "3199",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1159,
    "description": "FD58 / Iraq zone",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3200,
    "auth_name": "EPSG",
    "auth_id": "3200",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1160,
    "description": "LGD2006 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=33 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3201,
    "auth_name": "EPSG",
    "auth_id": "3201",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1161,
    "description": "LGD2006 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=34 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3202,
    "auth_name": "EPSG",
    "auth_id": "3202",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1162,
    "description": "LGD2006 / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=35 +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +units=m +no_defs",
    "srid": 3203,
    "auth_name": "EPSG",
    "auth_id": "3203",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1163,
    "description": "WGS 84 / SCAR IMW SP19-20",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-66 +lat_1=-60.6666666666667 +lat_2=-63.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3204,
    "auth_name": "EPSG",
    "auth_id": "3204",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1164,
    "description": "WGS 84 / SCAR IMW SP21-22",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-54 +lat_1=-60.6666666666667 +lat_2=-63.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3205,
    "auth_name": "EPSG",
    "auth_id": "3205",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1165,
    "description": "WGS 84 / SCAR IMW SP23-24",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-42 +lat_1=-60.6666666666667 +lat_2=-63.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3206,
    "auth_name": "EPSG",
    "auth_id": "3206",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1166,
    "description": "WGS 84 / SCAR IMW SQ01-02",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-174 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3207,
    "auth_name": "EPSG",
    "auth_id": "3207",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1167,
    "description": "WGS 84 / SCAR IMW SQ19-20",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-66 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3208,
    "auth_name": "EPSG",
    "auth_id": "3208",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1168,
    "description": "WGS 84 / SCAR IMW SQ21-22",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-54 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3209,
    "auth_name": "EPSG",
    "auth_id": "3209",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1169,
    "description": "WGS 84 / SCAR IMW SQ37-38",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=42 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3210,
    "auth_name": "EPSG",
    "auth_id": "3210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1170,
    "description": "WGS 84 / SCAR IMW SQ39-40",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=54 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3211,
    "auth_name": "EPSG",
    "auth_id": "3211",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1171,
    "description": "WGS 84 / SCAR IMW SQ41-42",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=66 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3212,
    "auth_name": "EPSG",
    "auth_id": "3212",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1172,
    "description": "WGS 84 / SCAR IMW SQ43-44",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=78 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3213,
    "auth_name": "EPSG",
    "auth_id": "3213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1173,
    "description": "WGS 84 / SCAR IMW SQ45-46",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=90 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3214,
    "auth_name": "EPSG",
    "auth_id": "3214",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1174,
    "description": "WGS 84 / SCAR IMW SQ47-48",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=102 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3215,
    "auth_name": "EPSG",
    "auth_id": "3215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1175,
    "description": "WGS 84 / SCAR IMW SQ49-50",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=114 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3216,
    "auth_name": "EPSG",
    "auth_id": "3216",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1176,
    "description": "WGS 84 / SCAR IMW SQ51-52",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=126 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3217,
    "auth_name": "EPSG",
    "auth_id": "3217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1177,
    "description": "WGS 84 / SCAR IMW SQ53-54",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=138 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3218,
    "auth_name": "EPSG",
    "auth_id": "3218",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1178,
    "description": "WGS 84 / SCAR IMW SQ55-56",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=150 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3219,
    "auth_name": "EPSG",
    "auth_id": "3219",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1179,
    "description": "WGS 84 / SCAR IMW SQ57-58",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=162 +lat_1=-64.6666666666667 +lat_2=-67.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3220,
    "auth_name": "EPSG",
    "auth_id": "3220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1180,
    "description": "WGS 84 / SCAR IMW SR13-14",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-102 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3221,
    "auth_name": "EPSG",
    "auth_id": "3221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1181,
    "description": "WGS 84 / SCAR IMW SR15-16",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-90 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3222,
    "auth_name": "EPSG",
    "auth_id": "3222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1182,
    "description": "WGS 84 / SCAR IMW SR17-18",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-78 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3223,
    "auth_name": "EPSG",
    "auth_id": "3223",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1183,
    "description": "WGS 84 / SCAR IMW SR19-20",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-66 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3224,
    "auth_name": "EPSG",
    "auth_id": "3224",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1184,
    "description": "WGS 84 / SCAR IMW SR27-28",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-18 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3225,
    "auth_name": "EPSG",
    "auth_id": "3225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1185,
    "description": "WGS 84 / SCAR IMW SR29-30",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-6 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3226,
    "auth_name": "EPSG",
    "auth_id": "3226",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1186,
    "description": "WGS 84 / SCAR IMW SR31-32",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=6 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3227,
    "auth_name": "EPSG",
    "auth_id": "3227",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1187,
    "description": "WGS 84 / SCAR IMW SR33-34",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=18 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3228,
    "auth_name": "EPSG",
    "auth_id": "3228",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1188,
    "description": "WGS 84 / SCAR IMW SR35-36",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=30 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3229,
    "auth_name": "EPSG",
    "auth_id": "3229",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1189,
    "description": "WGS 84 / SCAR IMW SR37-38",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=42 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3230,
    "auth_name": "EPSG",
    "auth_id": "3230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1190,
    "description": "WGS 84 / SCAR IMW SR39-40",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=54 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3231,
    "auth_name": "EPSG",
    "auth_id": "3231",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1191,
    "description": "WGS 84 / SCAR IMW SR41-42",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=66 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3232,
    "auth_name": "EPSG",
    "auth_id": "3232",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1192,
    "description": "WGS 84 / SCAR IMW SR43-44",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=78 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3233,
    "auth_name": "EPSG",
    "auth_id": "3233",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1193,
    "description": "WGS 84 / SCAR IMW SR45-46",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=90 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3234,
    "auth_name": "EPSG",
    "auth_id": "3234",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1194,
    "description": "WGS 84 / SCAR IMW SR47-48",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=102 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3235,
    "auth_name": "EPSG",
    "auth_id": "3235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1195,
    "description": "WGS 84 / SCAR IMW SR49-50",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=114 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3236,
    "auth_name": "EPSG",
    "auth_id": "3236",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1196,
    "description": "WGS 84 / SCAR IMW SR51-52",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=126 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3237,
    "auth_name": "EPSG",
    "auth_id": "3237",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1197,
    "description": "WGS 84 / SCAR IMW SR53-54",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=138 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3238,
    "auth_name": "EPSG",
    "auth_id": "3238",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1198,
    "description": "WGS 84 / SCAR IMW SR55-56",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=150 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3239,
    "auth_name": "EPSG",
    "auth_id": "3239",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1199,
    "description": "WGS 84 / SCAR IMW SR57-58",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=162 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3240,
    "auth_name": "EPSG",
    "auth_id": "3240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1200,
    "description": "WGS 84 / SCAR IMW SR59-60",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=174 +lat_1=-68.6666666666667 +lat_2=-71.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3241,
    "auth_name": "EPSG",
    "auth_id": "3241",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1201,
    "description": "WGS 84 / SCAR IMW SS04-06",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-153 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3242,
    "auth_name": "EPSG",
    "auth_id": "3242",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1202,
    "description": "WGS 84 / SCAR IMW SS07-09",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-135 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3243,
    "auth_name": "EPSG",
    "auth_id": "3243",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1203,
    "description": "WGS 84 / SCAR IMW SS10-12",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-117 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3244,
    "auth_name": "EPSG",
    "auth_id": "3244",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1204,
    "description": "WGS 84 / SCAR IMW SS13-15",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-99 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3245,
    "auth_name": "EPSG",
    "auth_id": "3245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1205,
    "description": "WGS 84 / SCAR IMW SS16-18",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-81 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3246,
    "auth_name": "EPSG",
    "auth_id": "3246",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1206,
    "description": "WGS 84 / SCAR IMW SS19-21",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-63 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3247,
    "auth_name": "EPSG",
    "auth_id": "3247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1207,
    "description": "WGS 84 / SCAR IMW SS25-27",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-27 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3248,
    "auth_name": "EPSG",
    "auth_id": "3248",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1208,
    "description": "WGS 84 / SCAR IMW SS28-30",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-9 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3249,
    "auth_name": "EPSG",
    "auth_id": "3249",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1209,
    "description": "WGS 84 / SCAR IMW SS31-33",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=9 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3250,
    "auth_name": "EPSG",
    "auth_id": "3250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1210,
    "description": "WGS 84 / SCAR IMW SS34-36",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=27 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3251,
    "auth_name": "EPSG",
    "auth_id": "3251",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1211,
    "description": "WGS 84 / SCAR IMW SS37-39",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=45 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3252,
    "auth_name": "EPSG",
    "auth_id": "3252",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1212,
    "description": "WGS 84 / SCAR IMW SS40-42",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=63 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3253,
    "auth_name": "EPSG",
    "auth_id": "3253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1213,
    "description": "WGS 84 / SCAR IMW SS43-45",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=81 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3254,
    "auth_name": "EPSG",
    "auth_id": "3254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1214,
    "description": "WGS 84 / SCAR IMW SS46-48",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=99 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3255,
    "auth_name": "EPSG",
    "auth_id": "3255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1215,
    "description": "WGS 84 / SCAR IMW SS49-51",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=117 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3256,
    "auth_name": "EPSG",
    "auth_id": "3256",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1216,
    "description": "WGS 84 / SCAR IMW SS52-54",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=135 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3257,
    "auth_name": "EPSG",
    "auth_id": "3257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1217,
    "description": "WGS 84 / SCAR IMW SS55-57",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=153 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3258,
    "auth_name": "EPSG",
    "auth_id": "3258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1218,
    "description": "WGS 84 / SCAR IMW SS58-60",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=171 +lat_1=-72.6666666666667 +lat_2=-75.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3259,
    "auth_name": "EPSG",
    "auth_id": "3259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1219,
    "description": "WGS 84 / SCAR IMW ST01-04",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-168 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3260,
    "auth_name": "EPSG",
    "auth_id": "3260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1220,
    "description": "WGS 84 / SCAR IMW ST05-08",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-144 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3261,
    "auth_name": "EPSG",
    "auth_id": "3261",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1221,
    "description": "WGS 84 / SCAR IMW ST09-12",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-120 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3262,
    "auth_name": "EPSG",
    "auth_id": "3262",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1222,
    "description": "WGS 84 / SCAR IMW ST13-16",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-96 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3263,
    "auth_name": "EPSG",
    "auth_id": "3263",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1223,
    "description": "WGS 84 / SCAR IMW ST17-20",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-72 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3264,
    "auth_name": "EPSG",
    "auth_id": "3264",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1224,
    "description": "WGS 84 / SCAR IMW ST21-24",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-48 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3265,
    "auth_name": "EPSG",
    "auth_id": "3265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1225,
    "description": "WGS 84 / SCAR IMW ST25-28",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=-24 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3266,
    "auth_name": "EPSG",
    "auth_id": "3266",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1226,
    "description": "WGS 84 / SCAR IMW ST29-32",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=0 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3267,
    "auth_name": "EPSG",
    "auth_id": "3267",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1227,
    "description": "WGS 84 / SCAR IMW ST33-36",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=24 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3268,
    "auth_name": "EPSG",
    "auth_id": "3268",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1228,
    "description": "WGS 84 / SCAR IMW ST37-40",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=48 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3269,
    "auth_name": "EPSG",
    "auth_id": "3269",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1229,
    "description": "WGS 84 / SCAR IMW ST41-44",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=72 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3270,
    "auth_name": "EPSG",
    "auth_id": "3270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1230,
    "description": "WGS 84 / SCAR IMW ST45-48",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=96 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3271,
    "auth_name": "EPSG",
    "auth_id": "3271",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1231,
    "description": "WGS 84 / SCAR IMW ST49-52",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=120 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3272,
    "auth_name": "EPSG",
    "auth_id": "3272",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1232,
    "description": "WGS 84 / SCAR IMW ST53-56",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=144 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3273,
    "auth_name": "EPSG",
    "auth_id": "3273",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1233,
    "description": "WGS 84 / SCAR IMW ST57-60",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=168 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3274,
    "auth_name": "EPSG",
    "auth_id": "3274",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1234,
    "description": "WGS 84 / SCAR IMW SU01-05",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-165 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3275,
    "auth_name": "EPSG",
    "auth_id": "3275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1235,
    "description": "WGS 84 / SCAR IMW SU06-10",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-135 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3276,
    "auth_name": "EPSG",
    "auth_id": "3276",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1236,
    "description": "WGS 84 / SCAR IMW SU11-15",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3277,
    "auth_name": "EPSG",
    "auth_id": "3277",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1237,
    "description": "WGS 84 / SCAR IMW SU16-20",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-75 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3278,
    "auth_name": "EPSG",
    "auth_id": "3278",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1238,
    "description": "WGS 84 / SCAR IMW SU21-25",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-45 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3279,
    "auth_name": "EPSG",
    "auth_id": "3279",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1239,
    "description": "WGS 84 / SCAR IMW SU26-30",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-15 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3280,
    "auth_name": "EPSG",
    "auth_id": "3280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1240,
    "description": "WGS 84 / SCAR IMW SU31-35",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=15 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3281,
    "auth_name": "EPSG",
    "auth_id": "3281",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1241,
    "description": "WGS 84 / SCAR IMW SU36-40",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=45 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3282,
    "auth_name": "EPSG",
    "auth_id": "3282",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1242,
    "description": "WGS 84 / SCAR IMW SU41-45",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=75 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3283,
    "auth_name": "EPSG",
    "auth_id": "3283",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1243,
    "description": "WGS 84 / SCAR IMW SU46-50",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=105 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3284,
    "auth_name": "EPSG",
    "auth_id": "3284",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1244,
    "description": "WGS 84 / SCAR IMW SU51-55",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=135 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3285,
    "auth_name": "EPSG",
    "auth_id": "3285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1245,
    "description": "WGS 84 / SCAR IMW SU56-60",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=165 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3286,
    "auth_name": "EPSG",
    "auth_id": "3286",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1246,
    "description": "WGS 84 / SCAR IMW SV01-10",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3287,
    "auth_name": "EPSG",
    "auth_id": "3287",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1247,
    "description": "WGS 84 / SCAR IMW SV11-20",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3288,
    "auth_name": "EPSG",
    "auth_id": "3288",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1248,
    "description": "WGS 84 / SCAR IMW SV21-30",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=-30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3289,
    "auth_name": "EPSG",
    "auth_id": "3289",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1249,
    "description": "WGS 84 / SCAR IMW SV31-40",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=30 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3290,
    "auth_name": "EPSG",
    "auth_id": "3290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1250,
    "description": "WGS 84 / SCAR IMW SV41-50",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3291,
    "auth_name": "EPSG",
    "auth_id": "3291",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1251,
    "description": "WGS 84 / SCAR IMW SV51-60",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3292,
    "auth_name": "EPSG",
    "auth_id": "3292",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1252,
    "description": "WGS 84 / SCAR IMW SW01-60",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-80.2386111111111 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3293,
    "auth_name": "EPSG",
    "auth_id": "3293",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1253,
    "description": "WGS 84 / USGS Transantarctic Mountains",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-78 +lon_0=162 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3294,
    "auth_name": "EPSG",
    "auth_id": "3294",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1254,
    "description": "RGPF / UTM zone 5S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 3296,
    "auth_name": "EPSG",
    "auth_id": "3296",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1255,
    "description": "RGPF / UTM zone 6S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=6 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 3297,
    "auth_name": "EPSG",
    "auth_id": "3297",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1256,
    "description": "RGPF / UTM zone 7S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=7 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 3298,
    "auth_name": "EPSG",
    "auth_id": "3298",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1257,
    "description": "RGPF / UTM zone 8S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=8 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 3299,
    "auth_name": "EPSG",
    "auth_id": "3299",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1258,
    "description": "Estonian Coordinate System of 1992",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=57.5175539305556 +lon_0=24 +lat_1=59.3333333333333 +lat_2=58 +x_0=500000 +y_0=6375000 +ellps=GRS80 +towgs84=0.055,-0.541,-0.185,0.0183,-0.0003,-0.007,-0.014 +units=m +no_defs",
    "srid": 3300,
    "auth_name": "EPSG",
    "auth_id": "3300",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1259,
    "description": "Estonian Coordinate System of 1997",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=57.5175539305556 +lon_0=24 +lat_1=59.3333333333333 +lat_2=58 +x_0=500000 +y_0=6375000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3301,
    "auth_name": "EPSG",
    "auth_id": "3301",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1260,
    "description": "IGN63 Hiva Oa / UTM zone 7S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 3302,
    "auth_name": "EPSG",
    "auth_id": "3302",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1261,
    "description": "Fatu Iva 72 / UTM zone 7S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +towgs84=347.175,1077.618,2623.677,33.9058,-70.6776,9.4013,186.0647 +units=m +no_defs",
    "srid": 3303,
    "auth_name": "EPSG",
    "auth_id": "3303",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1262,
    "description": "Tahiti 79 / UTM zone 6S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=221.597,152.441,176.523,2.403,1.3893,0.884,11.4648 +units=m +no_defs",
    "srid": 3304,
    "auth_name": "EPSG",
    "auth_id": "3304",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1263,
    "description": "Moorea 87 / UTM zone 6S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=218.769,150.75,176.75,3.5231,2.0037,1.288,10.9817 +units=m +no_defs",
    "srid": 3305,
    "auth_name": "EPSG",
    "auth_id": "3305",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1264,
    "description": "Maupiti 83 / UTM zone 5S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +towgs84=217.109,86.452,23.711,0.0183,-0.0003,0.007,-0.0093 +units=m +no_defs",
    "srid": 3306,
    "auth_name": "EPSG",
    "auth_id": "3306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1265,
    "description": "Nakhl-e Ghanem / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=39 +ellps=WGS84 +units=m +no_defs",
    "srid": 3307,
    "auth_name": "EPSG",
    "auth_id": "3307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1266,
    "description": "GDA94 / NSW Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-33.25 +lon_0=147 +lat_1=-30.75 +lat_2=-35.75 +x_0=9300000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3308,
    "auth_name": "EPSG",
    "auth_id": "3308",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1267,
    "description": "NAD27 / California Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +datum=NAD27 +units=m +no_defs",
    "srid": 3309,
    "auth_name": "EPSG",
    "auth_id": "3309",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1268,
    "description": "NAD83 / California Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3310,
    "auth_name": "EPSG",
    "auth_id": "3310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1269,
    "description": "NAD83(HARN) / California Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3311,
    "auth_name": "EPSG",
    "auth_id": "3311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1270,
    "description": "CSG67 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs",
    "srid": 3312,
    "auth_name": "EPSG",
    "auth_id": "3312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1271,
    "description": "RGFG95 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3313,
    "auth_name": "EPSG",
    "auth_id": "3313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1274,
    "description": "Kasai 1953 / Congo TM zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3316,
    "auth_name": "EPSG",
    "auth_id": "3316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1275,
    "description": "Kasai 1953 / Congo TM zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3317,
    "auth_name": "EPSG",
    "auth_id": "3317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1276,
    "description": "IGC 1962 / Congo TM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3318,
    "auth_name": "EPSG",
    "auth_id": "3318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1277,
    "description": "IGC 1962 / Congo TM zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3319,
    "auth_name": "EPSG",
    "auth_id": "3319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1278,
    "description": "IGC 1962 / Congo TM zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3320,
    "auth_name": "EPSG",
    "auth_id": "3320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1279,
    "description": "IGC 1962 / Congo TM zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3321,
    "auth_name": "EPSG",
    "auth_id": "3321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1280,
    "description": "IGC 1962 / Congo TM zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3322,
    "auth_name": "EPSG",
    "auth_id": "3322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1281,
    "description": "IGC 1962 / Congo TM zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3323,
    "auth_name": "EPSG",
    "auth_id": "3323",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1282,
    "description": "IGC 1962 / Congo TM zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3324,
    "auth_name": "EPSG",
    "auth_id": "3324",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1283,
    "description": "IGC 1962 / Congo TM zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=26 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3325,
    "auth_name": "EPSG",
    "auth_id": "3325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1284,
    "description": "IGC 1962 / Congo TM zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3326,
    "auth_name": "EPSG",
    "auth_id": "3326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1285,
    "description": "IGC 1962 / Congo TM zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3327,
    "auth_name": "EPSG",
    "auth_id": "3327",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1286,
    "description": "Pulkovo 1942(58) / GUGiK-80",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=sterea +lat_0=52.1666666666667 +lon_0=19.1666666666667 +k=0.999714 +x_0=500000 +y_0=500000 +ellps=krass +units=m +no_defs",
    "srid": 3328,
    "auth_name": "EPSG",
    "auth_id": "3328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1287,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3329,
    "auth_name": "EPSG",
    "auth_id": "3329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1288,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3330,
    "auth_name": "EPSG",
    "auth_id": "3330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1289,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3331,
    "auth_name": "EPSG",
    "auth_id": "3331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1290,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3332,
    "auth_name": "EPSG",
    "auth_id": "3332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1291,
    "description": "Pulkovo 1942(58) / Gauss-Kruger zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3333,
    "auth_name": "EPSG",
    "auth_id": "3333",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1292,
    "description": "Pulkovo 1942(58) / Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3334,
    "auth_name": "EPSG",
    "auth_id": "3334",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1293,
    "description": "Pulkovo 1942(58) / Gauss-Kruger zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3335,
    "auth_name": "EPSG",
    "auth_id": "3335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1294,
    "description": "IGN 1962 Kerguelen / UTM zone 42S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=42 +south +ellps=intl +towgs84=145,-187,103,0,0,0,0 +units=m +no_defs",
    "srid": 3336,
    "auth_name": "EPSG",
    "auth_id": "3336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1295,
    "description": "Le Pouce 1934 / Mauritius Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=-20.1950694444444 +lat_0=-20.1950694444444 +lon_0=57.5218277777778 +k_0=1 +x_0=1000000 +y_0=1000000 +a=6378249.145 +rf=293.465 +towgs84=-770.1,158.4,-498.2,0,0,0,0 +units=m +no_defs",
    "srid": 3337,
    "auth_name": "EPSG",
    "auth_id": "3337",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1296,
    "description": "NAD83 / Alaska Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 3338,
    "auth_name": "EPSG",
    "auth_id": "3338",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1297,
    "description": "IGCB 1955 / Congo TM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs",
    "srid": 3339,
    "auth_name": "EPSG",
    "auth_id": "3339",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1298,
    "description": "IGCB 1955 / Congo TM zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs",
    "srid": 3340,
    "auth_name": "EPSG",
    "auth_id": "3340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1299,
    "description": "IGCB 1955 / Congo TM zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs",
    "srid": 3341,
    "auth_name": "EPSG",
    "auth_id": "3341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1300,
    "description": "IGCB 1955 / UTM zone 33S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=33 +south +a=6378249.145 +rf=293.465 +towgs84=-79.9,-158,-168.9,0,0,0,0 +units=m +no_defs",
    "srid": 3342,
    "auth_name": "EPSG",
    "auth_id": "3342",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1301,
    "description": "Mauritania 1999 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3343,
    "auth_name": "EPSG",
    "auth_id": "3343",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1302,
    "description": "Mauritania 1999 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3344,
    "auth_name": "EPSG",
    "auth_id": "3344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1303,
    "description": "Mauritania 1999 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3345,
    "auth_name": "EPSG",
    "auth_id": "3345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1304,
    "description": "LKS94 / Lithuania TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3346,
    "auth_name": "EPSG",
    "auth_id": "3346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1305,
    "description": "NAD83 / Statistics Canada Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=63.390675 +lon_0=-91.8666666666667 +lat_1=49 +lat_2=77 +x_0=6200000 +y_0=3000000 +datum=NAD83 +units=m +no_defs",
    "srid": 3347,
    "auth_name": "EPSG",
    "auth_id": "3347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1306,
    "description": "NAD83(CSRS) / Statistics Canada Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=63.390675 +lon_0=-91.8666666666667 +lat_1=49 +lat_2=77 +x_0=6200000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3348,
    "auth_name": "EPSG",
    "auth_id": "3348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1308,
    "description": "Pulkovo 1942 / CS63 zone C0",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.1 +lon_0=21.95 +k=1 +x_0=250000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 3350,
    "auth_name": "EPSG",
    "auth_id": "3350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1309,
    "description": "Pulkovo 1942 / CS63 zone C1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.1 +lon_0=24.95 +k=1 +x_0=1250000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3351,
    "auth_name": "EPSG",
    "auth_id": "3351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1310,
    "description": "Pulkovo 1942 / CS63 zone C2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.1 +lon_0=27.95 +k=1 +x_0=2250000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3352,
    "auth_name": "EPSG",
    "auth_id": "3352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1311,
    "description": "Mhast (onshore) / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +south +ellps=intl +units=m +no_defs",
    "srid": 3353,
    "auth_name": "EPSG",
    "auth_id": "3353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1312,
    "description": "Mhast (offshore) / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +south +ellps=intl +units=m +no_defs",
    "srid": 3354,
    "auth_name": "EPSG",
    "auth_id": "3354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1313,
    "description": "Egypt Gulf of Suez S-650 TL / Red Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=31 +k=1 +x_0=615000 +y_0=810000 +ellps=helmert +towgs84=-146.21,112.63,4.05,0,0,0,0 +units=m +no_defs",
    "srid": 3355,
    "auth_name": "EPSG",
    "auth_id": "3355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1316,
    "description": "NAD83(HARN) / North Carolina",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.22 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3358,
    "auth_name": "EPSG",
    "auth_id": "3358",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1318,
    "description": "NAD83(HARN) / South Carolina",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3360,
    "auth_name": "EPSG",
    "auth_id": "3360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1319,
    "description": "NAD83(HARN) / South Carolina (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 3361,
    "auth_name": "EPSG",
    "auth_id": "3361",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1320,
    "description": "NAD83(HARN) / Pennsylvania North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3362,
    "auth_name": "EPSG",
    "auth_id": "3362",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1321,
    "description": "NAD83(HARN) / Pennsylvania North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3363,
    "auth_name": "EPSG",
    "auth_id": "3363",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1322,
    "description": "NAD83(HARN) / Pennsylvania South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3364,
    "auth_name": "EPSG",
    "auth_id": "3364",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1323,
    "description": "NAD83(HARN) / Pennsylvania South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3365,
    "auth_name": "EPSG",
    "auth_id": "3365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1325,
    "description": "IGN Astro 1960 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=28 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3367,
    "auth_name": "EPSG",
    "auth_id": "3367",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1326,
    "description": "IGN Astro 1960 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3368,
    "auth_name": "EPSG",
    "auth_id": "3368",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1327,
    "description": "IGN Astro 1960 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=30 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3369,
    "auth_name": "EPSG",
    "auth_id": "3369",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1328,
    "description": "NAD27 / UTM zone 59N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=59 +datum=NAD27 +units=m +no_defs",
    "srid": 3370,
    "auth_name": "EPSG",
    "auth_id": "3370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1329,
    "description": "NAD27 / UTM zone 60N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=60 +datum=NAD27 +units=m +no_defs",
    "srid": 3371,
    "auth_name": "EPSG",
    "auth_id": "3371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1330,
    "description": "NAD83 / UTM zone 59N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=utm +zone=59 +datum=NAD83 +units=m +no_defs",
    "srid": 3372,
    "auth_name": "EPSG",
    "auth_id": "3372",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1331,
    "description": "NAD83 / UTM zone 60N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=utm +zone=60 +datum=NAD83 +units=m +no_defs",
    "srid": 3373,
    "auth_name": "EPSG",
    "auth_id": "3373",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1332,
    "description": "FD54 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=29 +ellps=intl +units=m +no_defs",
    "srid": 3374,
    "auth_name": "EPSG",
    "auth_id": "3374",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1333,
    "description": "GDM2000 / Peninsula RSO",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=323.025796466667 +gamma=323.130102361111 +k=0.99984 +x_0=804671 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3375,
    "auth_name": "EPSG",
    "auth_id": "3375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1334,
    "description": "GDM2000 / East Malaysia BRSO",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=4 +lonc=115 +alpha=53.31580995 +gamma=53.1301023611111 +k=0.99984 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3376,
    "auth_name": "EPSG",
    "auth_id": "3376",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1335,
    "description": "GDM2000 / Johor Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=cass +lat_0=2.12167974444444 +lon_0=103.427936236111 +x_0=-14810.562 +y_0=8758.32 +ellps=GRS80 +units=m +no_defs",
    "srid": 3377,
    "auth_name": "EPSG",
    "auth_id": "3377",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1336,
    "description": "GDM2000 / Sembilan and Melaka Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=cass +lat_0=2.68234763611111 +lon_0=101.974905041667 +x_0=3673.785 +y_0=-4240.573 +ellps=GRS80 +units=m +no_defs",
    "srid": 3378,
    "auth_name": "EPSG",
    "auth_id": "3378",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1337,
    "description": "GDM2000 / Pahang Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=cass +lat_0=3.76938808888889 +lon_0=102.368298983333 +x_0=-7368.228 +y_0=6485.858 +ellps=GRS80 +units=m +no_defs",
    "srid": 3379,
    "auth_name": "EPSG",
    "auth_id": "3379",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1338,
    "description": "GDM2000 / Selangor Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=cass +lat_0=3.68464905 +lon_0=101.389107913889 +x_0=-34836.161 +y_0=56464.049 +ellps=GRS80 +units=m +no_defs",
    "srid": 3380,
    "auth_name": "EPSG",
    "auth_id": "3380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1339,
    "description": "GDM2000 / Terengganu Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=cass +lat_0=4.9762852 +lon_0=103.070275625 +x_0=19594.245 +y_0=3371.895 +ellps=GRS80 +units=m +no_defs",
    "srid": 3381,
    "auth_name": "EPSG",
    "auth_id": "3381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1340,
    "description": "GDM2000 / Pinang Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=cass +lat_0=5.42151754166667 +lon_0=100.344376963889 +x_0=-23.414 +y_0=62.283 +ellps=GRS80 +units=m +no_defs",
    "srid": 3382,
    "auth_name": "EPSG",
    "auth_id": "3382",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1341,
    "description": "GDM2000 / Kedah and Perlis Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=cass +lat_0=5.96467271388889 +lon_0=100.636371111111 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3383,
    "auth_name": "EPSG",
    "auth_id": "3383",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1342,
    "description": "GDM2000 / Perak Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=cass +lat_0=4.85906302222222 +lon_0=100.815410586111 +x_0=-1.769 +y_0=133454.779 +ellps=GRS80 +units=m +no_defs",
    "srid": 3384,
    "auth_name": "EPSG",
    "auth_id": "3384",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1343,
    "description": "GDM2000 / Kelantan Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=cass +lat_0=5.97254365833333 +lon_0=102.295241669444 +x_0=13227.851 +y_0=8739.894 +ellps=GRS80 +units=m +no_defs",
    "srid": 3385,
    "auth_name": "EPSG",
    "auth_id": "3385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1344,
    "description": "KKJ / Finland zone 0",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs",
    "srid": 3386,
    "auth_name": "EPSG",
    "auth_id": "3386",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1345,
    "description": "KKJ / Finland zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=5500000 +y_0=0 +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +units=m +no_defs",
    "srid": 3387,
    "auth_name": "EPSG",
    "auth_id": "3387",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1346,
    "description": "Pulkovo 1942 / Caspian Sea Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=merc +lat_ts=42 +lon_0=51 +x_0=0 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 3388,
    "auth_name": "EPSG",
    "auth_id": "3388",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1347,
    "description": "Pulkovo 1942 / 3-degree Gauss-Kruger zone 60",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3389,
    "auth_name": "EPSG",
    "auth_id": "3389",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1348,
    "description": "Pulkovo 1995 / 3-degree Gauss-Kruger zone 60",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 3390,
    "auth_name": "EPSG",
    "auth_id": "3390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1349,
    "description": "Karbala 1979 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=37 +a=6378249.145 +rf=293.465 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs",
    "srid": 3391,
    "auth_name": "EPSG",
    "auth_id": "3391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1350,
    "description": "Karbala 1979 / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=38 +a=6378249.145 +rf=293.465 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs",
    "srid": 3392,
    "auth_name": "EPSG",
    "auth_id": "3392",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1351,
    "description": "Karbala 1979 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs",
    "srid": 3393,
    "auth_name": "EPSG",
    "auth_id": "3393",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1352,
    "description": "Nahrwan 1934 / Iraq zone",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 3394,
    "auth_name": "EPSG",
    "auth_id": "3394",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1353,
    "description": "WGS 84 / World Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3395,
    "auth_name": "EPSG",
    "auth_id": "3395",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1354,
    "description": "PD/83 / 3-degree Gauss-Kruger zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3396,
    "auth_name": "EPSG",
    "auth_id": "3396",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1355,
    "description": "PD/83 / 3-degree Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3397,
    "auth_name": "EPSG",
    "auth_id": "3397",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1356,
    "description": "RD/83 / 3-degree Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3398,
    "auth_name": "EPSG",
    "auth_id": "3398",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1357,
    "description": "RD/83 / 3-degree Gauss-Kruger zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 3399,
    "auth_name": "EPSG",
    "auth_id": "3399",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1358,
    "description": "NAD83 / Alberta 10-TM (Forest)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 3400,
    "auth_name": "EPSG",
    "auth_id": "3400",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1359,
    "description": "NAD83 / Alberta 10-TM (Resource)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 3401,
    "auth_name": "EPSG",
    "auth_id": "3401",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1360,
    "description": "NAD83(CSRS) / Alberta 10-TM (Forest)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3402,
    "auth_name": "EPSG",
    "auth_id": "3402",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1361,
    "description": "NAD83(CSRS) / Alberta 10-TM (Resource)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3403,
    "auth_name": "EPSG",
    "auth_id": "3403",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1362,
    "description": "NAD83(HARN) / North Carolina (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3404,
    "auth_name": "EPSG",
    "auth_id": "3404",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1363,
    "description": "VN-2000 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=48 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 3405,
    "auth_name": "EPSG",
    "auth_id": "3405",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1364,
    "description": "VN-2000 / UTM zone 49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=49 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 3406,
    "auth_name": "EPSG",
    "auth_id": "3406",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1365,
    "description": "Hong Kong 1963 Grid System",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=22.3121333333333 +lon_0=114.178555555556 +x_0=40243.5777560424 +y_0=19069.9335151258 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.3047972654 +no_defs",
    "srid": 3407,
    "auth_name": "EPSG",
    "auth_id": "3407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1366,
    "description": "NSIDC EASE-Grid North",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "",
    "parameters": "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +R=6371228 +units=m +no_defs",
    "srid": 3408,
    "auth_name": "EPSG",
    "auth_id": "3408",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1367,
    "description": "NSIDC EASE-Grid South",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "",
    "parameters": "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +R=6371228 +units=m +no_defs",
    "srid": 3409,
    "auth_name": "EPSG",
    "auth_id": "3409",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1368,
    "description": "NSIDC EASE-Grid Global",
    "projection_acronym": "cea",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cea +lat_ts=30 +lon_0=0 +x_0=0 +y_0=0 +R=6371228 +units=m +no_defs",
    "srid": 3410,
    "auth_name": "EPSG",
    "auth_id": "3410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1369,
    "description": "NSIDC Sea Ice Polar Stereographic North",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "",
    "parameters": "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs",
    "srid": 3411,
    "auth_name": "EPSG",
    "auth_id": "3411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1370,
    "description": "NSIDC Sea Ice Polar Stereographic South",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-70 +lon_0=0 +x_0=0 +y_0=0 +a=6378273 +b=6356889.449 +units=m +no_defs",
    "srid": 3412,
    "auth_name": "EPSG",
    "auth_id": "3412",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1371,
    "description": "WGS 84 / NSIDC Sea Ice Polar Stereographic North",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lat_ts=70 +lon_0=-45 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3413,
    "auth_name": "EPSG",
    "auth_id": "3413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1372,
    "description": "SVY21 / Singapore TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=1.36666666666667 +lon_0=103.833333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3414,
    "auth_name": "EPSG",
    "auth_id": "3414",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1373,
    "description": "WGS 72BE / South China Sea Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=lcc +lat_0=21 +lon_0=114 +lat_1=18 +lat_2=24 +x_0=500000 +y_0=500000 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 3415,
    "auth_name": "EPSG",
    "auth_id": "3415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1374,
    "description": "ETRS89 / Austria Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47.5 +lon_0=13.3333333333333 +lat_1=49 +lat_2=46 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3416,
    "auth_name": "EPSG",
    "auth_id": "3416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1375,
    "description": "NAD83 / Iowa North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3417,
    "auth_name": "EPSG",
    "auth_id": "3417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1376,
    "description": "NAD83 / Iowa South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3418,
    "auth_name": "EPSG",
    "auth_id": "3418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1377,
    "description": "NAD83 / Kansas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3419,
    "auth_name": "EPSG",
    "auth_id": "3419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1378,
    "description": "NAD83 / Kansas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3420,
    "auth_name": "EPSG",
    "auth_id": "3420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1379,
    "description": "NAD83 / Nevada East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3421,
    "auth_name": "EPSG",
    "auth_id": "3421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1380,
    "description": "NAD83 / Nevada Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3422,
    "auth_name": "EPSG",
    "auth_id": "3422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1381,
    "description": "NAD83 / Nevada West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3423,
    "auth_name": "EPSG",
    "auth_id": "3423",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1382,
    "description": "NAD83 / New Jersey (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 3424,
    "auth_name": "EPSG",
    "auth_id": "3424",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1383,
    "description": "NAD83(HARN) / Iowa North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3425,
    "auth_name": "EPSG",
    "auth_id": "3425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1384,
    "description": "NAD83(HARN) / Iowa South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3426,
    "auth_name": "EPSG",
    "auth_id": "3426",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1385,
    "description": "NAD83(HARN) / Kansas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3427,
    "auth_name": "EPSG",
    "auth_id": "3427",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1386,
    "description": "NAD83(HARN) / Kansas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3428,
    "auth_name": "EPSG",
    "auth_id": "3428",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1387,
    "description": "NAD83(HARN) / Nevada East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3429,
    "auth_name": "EPSG",
    "auth_id": "3429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1388,
    "description": "NAD83(HARN) / Nevada Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3430,
    "auth_name": "EPSG",
    "auth_id": "3430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1389,
    "description": "NAD83(HARN) / Nevada West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3431,
    "auth_name": "EPSG",
    "auth_id": "3431",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1390,
    "description": "NAD83(HARN) / New Jersey (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3432,
    "auth_name": "EPSG",
    "auth_id": "3432",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1391,
    "description": "NAD83 / Arkansas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3433,
    "auth_name": "EPSG",
    "auth_id": "3433",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1392,
    "description": "NAD83 / Arkansas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3434,
    "auth_name": "EPSG",
    "auth_id": "3434",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1393,
    "description": "NAD83 / Illinois East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3435,
    "auth_name": "EPSG",
    "auth_id": "3435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1394,
    "description": "NAD83 / Illinois West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3436,
    "auth_name": "EPSG",
    "auth_id": "3436",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1395,
    "description": "NAD83 / New Hampshire (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3437,
    "auth_name": "EPSG",
    "auth_id": "3437",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1396,
    "description": "NAD83 / Rhode Island (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3438,
    "auth_name": "EPSG",
    "auth_id": "3438",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1397,
    "description": "PSD93 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +units=m +no_defs",
    "srid": 3439,
    "auth_name": "EPSG",
    "auth_id": "3439",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1398,
    "description": "PSD93 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=40 +a=6378249.145 +rf=293.465 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +units=m +no_defs",
    "srid": 3440,
    "auth_name": "EPSG",
    "auth_id": "3440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1399,
    "description": "NAD83(HARN) / Arkansas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3441,
    "auth_name": "EPSG",
    "auth_id": "3441",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1400,
    "description": "NAD83(HARN) / Arkansas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3442,
    "auth_name": "EPSG",
    "auth_id": "3442",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1401,
    "description": "NAD83(HARN) / Illinois East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3443,
    "auth_name": "EPSG",
    "auth_id": "3443",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1402,
    "description": "NAD83(HARN) / Illinois West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3444,
    "auth_name": "EPSG",
    "auth_id": "3444",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1403,
    "description": "NAD83(HARN) / New Hampshire (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3445,
    "auth_name": "EPSG",
    "auth_id": "3445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1404,
    "description": "NAD83(HARN) / Rhode Island (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3446,
    "auth_name": "EPSG",
    "auth_id": "3446",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1405,
    "description": "ETRS89 / Belgian Lambert 2005",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=50.797815 +lon_0=4.35921583333333 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=150328 +y_0=166262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3447,
    "auth_name": "EPSG",
    "auth_id": "3447",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1406,
    "description": "JAD2001 / Jamaica Metric Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=750000 +y_0=650000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3448,
    "auth_name": "EPSG",
    "auth_id": "3448",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1407,
    "description": "JAD2001 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=17 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3449,
    "auth_name": "EPSG",
    "auth_id": "3449",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1408,
    "description": "JAD2001 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=18 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3450,
    "auth_name": "EPSG",
    "auth_id": "3450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1409,
    "description": "NAD83 / Louisiana North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3451,
    "auth_name": "EPSG",
    "auth_id": "3451",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1410,
    "description": "NAD83 / Louisiana South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3452,
    "auth_name": "EPSG",
    "auth_id": "3452",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1411,
    "description": "NAD83 / Louisiana Offshore (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.5 +lon_0=-91.3333333333333 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=999999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 3453,
    "auth_name": "EPSG",
    "auth_id": "3453",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1413,
    "description": "NAD83 / South Dakota South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3455,
    "auth_name": "EPSG",
    "auth_id": "3455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1414,
    "description": "NAD83(HARN) / Louisiana North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3456,
    "auth_name": "EPSG",
    "auth_id": "3456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1415,
    "description": "NAD83(HARN) / Louisiana South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3457,
    "auth_name": "EPSG",
    "auth_id": "3457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1416,
    "description": "NAD83(HARN) / South Dakota North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3458,
    "auth_name": "EPSG",
    "auth_id": "3458",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1417,
    "description": "NAD83(HARN) / South Dakota South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3459,
    "auth_name": "EPSG",
    "auth_id": "3459",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1418,
    "description": "Fiji 1986 / Fiji Map Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=tmerc +lat_0=-17 +lon_0=178.75 +k=0.99985 +x_0=2000000 +y_0=4000000 +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +units=m +no_defs",
    "srid": 3460,
    "auth_name": "EPSG",
    "auth_id": "3460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1419,
    "description": "Dabola 1981 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=28 +ellps=clrk80ign +towgs84=-83,37,124,0,0,0,0 +units=m +no_defs",
    "srid": 3461,
    "auth_name": "EPSG",
    "auth_id": "3461",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1420,
    "description": "Dabola 1981 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=29 +ellps=clrk80ign +towgs84=-83,37,124,0,0,0,0 +units=m +no_defs",
    "srid": 3462,
    "auth_name": "EPSG",
    "auth_id": "3462",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1421,
    "description": "NAD83 / Maine CS2000 Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3463,
    "auth_name": "EPSG",
    "auth_id": "3463",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1422,
    "description": "NAD83(HARN) / Maine CS2000 Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3464,
    "auth_name": "EPSG",
    "auth_id": "3464",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1423,
    "description": "NAD83(NSRS2007) / Alabama East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3465,
    "auth_name": "EPSG",
    "auth_id": "3465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1424,
    "description": "NAD83(NSRS2007) / Alabama West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3466,
    "auth_name": "EPSG",
    "auth_id": "3466",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1425,
    "description": "NAD83(NSRS2007) / Alaska Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3467,
    "auth_name": "EPSG",
    "auth_id": "3467",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1426,
    "description": "NAD83(NSRS2007) / Alaska zone 1",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3468,
    "auth_name": "EPSG",
    "auth_id": "3468",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1427,
    "description": "NAD83(NSRS2007) / Alaska zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3469,
    "auth_name": "EPSG",
    "auth_id": "3469",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1428,
    "description": "NAD83(NSRS2007) / Alaska zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3470,
    "auth_name": "EPSG",
    "auth_id": "3470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1429,
    "description": "NAD83(NSRS2007) / Alaska zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3471,
    "auth_name": "EPSG",
    "auth_id": "3471",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1430,
    "description": "NAD83(NSRS2007) / Alaska zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3472,
    "auth_name": "EPSG",
    "auth_id": "3472",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1431,
    "description": "NAD83(NSRS2007) / Alaska zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3473,
    "auth_name": "EPSG",
    "auth_id": "3473",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1432,
    "description": "NAD83(NSRS2007) / Alaska zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3474,
    "auth_name": "EPSG",
    "auth_id": "3474",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1433,
    "description": "NAD83(NSRS2007) / Alaska zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3475,
    "auth_name": "EPSG",
    "auth_id": "3475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1434,
    "description": "NAD83(NSRS2007) / Alaska zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3476,
    "auth_name": "EPSG",
    "auth_id": "3476",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1435,
    "description": "NAD83(NSRS2007) / Alaska zone 10",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3477,
    "auth_name": "EPSG",
    "auth_id": "3477",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1436,
    "description": "NAD83(NSRS2007) / Arizona Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3478,
    "auth_name": "EPSG",
    "auth_id": "3478",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1437,
    "description": "NAD83(NSRS2007) / Arizona Central (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3479,
    "auth_name": "EPSG",
    "auth_id": "3479",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1438,
    "description": "NAD83(NSRS2007) / Arizona East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3480,
    "auth_name": "EPSG",
    "auth_id": "3480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1439,
    "description": "NAD83(NSRS2007) / Arizona East (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3481,
    "auth_name": "EPSG",
    "auth_id": "3481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1440,
    "description": "NAD83(NSRS2007) / Arizona West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3482,
    "auth_name": "EPSG",
    "auth_id": "3482",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1441,
    "description": "NAD83(NSRS2007) / Arizona West (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3483,
    "auth_name": "EPSG",
    "auth_id": "3483",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1442,
    "description": "NAD83(NSRS2007) / Arkansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3484,
    "auth_name": "EPSG",
    "auth_id": "3484",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1443,
    "description": "NAD83(NSRS2007) / Arkansas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3485,
    "auth_name": "EPSG",
    "auth_id": "3485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1444,
    "description": "NAD83(NSRS2007) / Arkansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3486,
    "auth_name": "EPSG",
    "auth_id": "3486",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1445,
    "description": "NAD83(NSRS2007) / Arkansas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3487,
    "auth_name": "EPSG",
    "auth_id": "3487",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1446,
    "description": "NAD83(NSRS2007) / California Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3488,
    "auth_name": "EPSG",
    "auth_id": "3488",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1447,
    "description": "NAD83(NSRS2007) / California zone 1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3489,
    "auth_name": "EPSG",
    "auth_id": "3489",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1448,
    "description": "NAD83(NSRS2007) / California zone 1 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3490,
    "auth_name": "EPSG",
    "auth_id": "3490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1449,
    "description": "NAD83(NSRS2007) / California zone 2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3491,
    "auth_name": "EPSG",
    "auth_id": "3491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1450,
    "description": "NAD83(NSRS2007) / California zone 2 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3492,
    "auth_name": "EPSG",
    "auth_id": "3492",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1451,
    "description": "NAD83(NSRS2007) / California zone 3",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3493,
    "auth_name": "EPSG",
    "auth_id": "3493",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1452,
    "description": "NAD83(NSRS2007) / California zone 3 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3494,
    "auth_name": "EPSG",
    "auth_id": "3494",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1453,
    "description": "NAD83(NSRS2007) / California zone 4",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3495,
    "auth_name": "EPSG",
    "auth_id": "3495",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1454,
    "description": "NAD83(NSRS2007) / California zone 4 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3496,
    "auth_name": "EPSG",
    "auth_id": "3496",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1455,
    "description": "NAD83(NSRS2007) / California zone 5",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3497,
    "auth_name": "EPSG",
    "auth_id": "3497",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1456,
    "description": "NAD83(NSRS2007) / California zone 5 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3498,
    "auth_name": "EPSG",
    "auth_id": "3498",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1457,
    "description": "NAD83(NSRS2007) / California zone 6",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3499,
    "auth_name": "EPSG",
    "auth_id": "3499",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1458,
    "description": "NAD83(NSRS2007) / California zone 6 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3500,
    "auth_name": "EPSG",
    "auth_id": "3500",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1459,
    "description": "NAD83(NSRS2007) / Colorado Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3501,
    "auth_name": "EPSG",
    "auth_id": "3501",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1460,
    "description": "NAD83(NSRS2007) / Colorado Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3502,
    "auth_name": "EPSG",
    "auth_id": "3502",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1461,
    "description": "NAD83(NSRS2007) / Colorado North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3503,
    "auth_name": "EPSG",
    "auth_id": "3503",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1462,
    "description": "NAD83(NSRS2007) / Colorado North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3504,
    "auth_name": "EPSG",
    "auth_id": "3504",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1463,
    "description": "NAD83(NSRS2007) / Colorado South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3505,
    "auth_name": "EPSG",
    "auth_id": "3505",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1464,
    "description": "NAD83(NSRS2007) / Colorado South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3506,
    "auth_name": "EPSG",
    "auth_id": "3506",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1465,
    "description": "NAD83(NSRS2007) / Connecticut",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3507,
    "auth_name": "EPSG",
    "auth_id": "3507",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1466,
    "description": "NAD83(NSRS2007) / Connecticut (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3508,
    "auth_name": "EPSG",
    "auth_id": "3508",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1467,
    "description": "NAD83(NSRS2007) / Delaware",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3509,
    "auth_name": "EPSG",
    "auth_id": "3509",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1468,
    "description": "NAD83(NSRS2007) / Delaware (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3510,
    "auth_name": "EPSG",
    "auth_id": "3510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1469,
    "description": "NAD83(NSRS2007) / Florida East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3511,
    "auth_name": "EPSG",
    "auth_id": "3511",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1470,
    "description": "NAD83(NSRS2007) / Florida East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3512,
    "auth_name": "EPSG",
    "auth_id": "3512",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1471,
    "description": "NAD83(NSRS2007) / Florida GDL Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3513,
    "auth_name": "EPSG",
    "auth_id": "3513",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1472,
    "description": "NAD83(NSRS2007) / Florida North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3514,
    "auth_name": "EPSG",
    "auth_id": "3514",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1473,
    "description": "NAD83(NSRS2007) / Florida North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3515,
    "auth_name": "EPSG",
    "auth_id": "3515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1474,
    "description": "NAD83(NSRS2007) / Florida West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3516,
    "auth_name": "EPSG",
    "auth_id": "3516",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1475,
    "description": "NAD83(NSRS2007) / Florida West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3517,
    "auth_name": "EPSG",
    "auth_id": "3517",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1476,
    "description": "NAD83(NSRS2007) / Georgia East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3518,
    "auth_name": "EPSG",
    "auth_id": "3518",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1477,
    "description": "NAD83(NSRS2007) / Georgia East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3519,
    "auth_name": "EPSG",
    "auth_id": "3519",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1478,
    "description": "NAD83(NSRS2007) / Georgia West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3520,
    "auth_name": "EPSG",
    "auth_id": "3520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1479,
    "description": "NAD83(NSRS2007) / Georgia West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3521,
    "auth_name": "EPSG",
    "auth_id": "3521",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1480,
    "description": "NAD83(NSRS2007) / Idaho Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3522,
    "auth_name": "EPSG",
    "auth_id": "3522",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1481,
    "description": "NAD83(NSRS2007) / Idaho Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3523,
    "auth_name": "EPSG",
    "auth_id": "3523",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1482,
    "description": "NAD83(NSRS2007) / Idaho East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3524,
    "auth_name": "EPSG",
    "auth_id": "3524",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1483,
    "description": "NAD83(NSRS2007) / Idaho East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3525,
    "auth_name": "EPSG",
    "auth_id": "3525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1484,
    "description": "NAD83(NSRS2007) / Idaho West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3526,
    "auth_name": "EPSG",
    "auth_id": "3526",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1485,
    "description": "NAD83(NSRS2007) / Idaho West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3527,
    "auth_name": "EPSG",
    "auth_id": "3527",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1486,
    "description": "NAD83(NSRS2007) / Illinois East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3528,
    "auth_name": "EPSG",
    "auth_id": "3528",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1487,
    "description": "NAD83(NSRS2007) / Illinois East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3529,
    "auth_name": "EPSG",
    "auth_id": "3529",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1488,
    "description": "NAD83(NSRS2007) / Illinois West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3530,
    "auth_name": "EPSG",
    "auth_id": "3530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1489,
    "description": "NAD83(NSRS2007) / Illinois West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3531,
    "auth_name": "EPSG",
    "auth_id": "3531",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1490,
    "description": "NAD83(NSRS2007) / Indiana East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3532,
    "auth_name": "EPSG",
    "auth_id": "3532",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1491,
    "description": "NAD83(NSRS2007) / Indiana East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3533,
    "auth_name": "EPSG",
    "auth_id": "3533",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1492,
    "description": "NAD83(NSRS2007) / Indiana West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3534,
    "auth_name": "EPSG",
    "auth_id": "3534",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1493,
    "description": "NAD83(NSRS2007) / Indiana West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3535,
    "auth_name": "EPSG",
    "auth_id": "3535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1494,
    "description": "NAD83(NSRS2007) / Iowa North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3536,
    "auth_name": "EPSG",
    "auth_id": "3536",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1495,
    "description": "NAD83(NSRS2007) / Iowa North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3537,
    "auth_name": "EPSG",
    "auth_id": "3537",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1496,
    "description": "NAD83(NSRS2007) / Iowa South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3538,
    "auth_name": "EPSG",
    "auth_id": "3538",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1497,
    "description": "NAD83(NSRS2007) / Iowa South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3539,
    "auth_name": "EPSG",
    "auth_id": "3539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1498,
    "description": "NAD83(NSRS2007) / Kansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3540,
    "auth_name": "EPSG",
    "auth_id": "3540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1499,
    "description": "NAD83(NSRS2007) / Kansas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3541,
    "auth_name": "EPSG",
    "auth_id": "3541",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1500,
    "description": "NAD83(NSRS2007) / Kansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3542,
    "auth_name": "EPSG",
    "auth_id": "3542",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1501,
    "description": "NAD83(NSRS2007) / Kansas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3543,
    "auth_name": "EPSG",
    "auth_id": "3543",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1502,
    "description": "NAD83(NSRS2007) / Kentucky North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3544,
    "auth_name": "EPSG",
    "auth_id": "3544",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1503,
    "description": "NAD83(NSRS2007) / Kentucky North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3545,
    "auth_name": "EPSG",
    "auth_id": "3545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1504,
    "description": "NAD83(NSRS2007) / Kentucky Single Zone",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3546,
    "auth_name": "EPSG",
    "auth_id": "3546",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1505,
    "description": "NAD83(NSRS2007) / Kentucky Single Zone (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3547,
    "auth_name": "EPSG",
    "auth_id": "3547",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1506,
    "description": "NAD83(NSRS2007) / Kentucky South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3548,
    "auth_name": "EPSG",
    "auth_id": "3548",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1507,
    "description": "NAD83(NSRS2007) / Kentucky South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3549,
    "auth_name": "EPSG",
    "auth_id": "3549",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1508,
    "description": "NAD83(NSRS2007) / Louisiana North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3550,
    "auth_name": "EPSG",
    "auth_id": "3550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1509,
    "description": "NAD83(NSRS2007) / Louisiana North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3551,
    "auth_name": "EPSG",
    "auth_id": "3551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1510,
    "description": "NAD83(NSRS2007) / Louisiana South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3552,
    "auth_name": "EPSG",
    "auth_id": "3552",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1511,
    "description": "NAD83(NSRS2007) / Louisiana South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3553,
    "auth_name": "EPSG",
    "auth_id": "3553",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1512,
    "description": "NAD83(NSRS2007) / Maine CS2000 Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3554,
    "auth_name": "EPSG",
    "auth_id": "3554",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1513,
    "description": "NAD83(NSRS2007) / Maine CS2000 East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3555,
    "auth_name": "EPSG",
    "auth_id": "3555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1514,
    "description": "NAD83(NSRS2007) / Maine CS2000 West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3556,
    "auth_name": "EPSG",
    "auth_id": "3556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1515,
    "description": "NAD83(NSRS2007) / Maine East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3557,
    "auth_name": "EPSG",
    "auth_id": "3557",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1516,
    "description": "NAD83(NSRS2007) / Maine West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3558,
    "auth_name": "EPSG",
    "auth_id": "3558",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1517,
    "description": "NAD83(NSRS2007) / Maryland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3559,
    "auth_name": "EPSG",
    "auth_id": "3559",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1518,
    "description": "NAD83 / Utah North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3560,
    "auth_name": "EPSG",
    "auth_id": "3560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1519,
    "description": "Old Hawaiian / Hawaii zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=89,-279,-183,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3561,
    "auth_name": "EPSG",
    "auth_id": "3561",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1520,
    "description": "Old Hawaiian / Hawaii zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=65,-290,-190,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3562,
    "auth_name": "EPSG",
    "auth_id": "3562",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1521,
    "description": "Old Hawaiian / Hawaii zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=58,-283,-182,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3563,
    "auth_name": "EPSG",
    "auth_id": "3563",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1522,
    "description": "Old Hawaiian / Hawaii zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=45,-290,-172,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3564,
    "auth_name": "EPSG",
    "auth_id": "3564",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1523,
    "description": "Old Hawaiian / Hawaii zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3565,
    "auth_name": "EPSG",
    "auth_id": "3565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1524,
    "description": "NAD83 / Utah Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3566,
    "auth_name": "EPSG",
    "auth_id": "3566",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1525,
    "description": "NAD83 / Utah South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3567,
    "auth_name": "EPSG",
    "auth_id": "3567",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1526,
    "description": "NAD83(HARN) / Utah North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3568,
    "auth_name": "EPSG",
    "auth_id": "3568",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1527,
    "description": "NAD83(HARN) / Utah Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3569,
    "auth_name": "EPSG",
    "auth_id": "3569",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1528,
    "description": "NAD83(HARN) / Utah South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3570,
    "auth_name": "EPSG",
    "auth_id": "3570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1529,
    "description": "WGS 84 / North Pole LAEA Bering Sea",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=90 +lon_0=180 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3571,
    "auth_name": "EPSG",
    "auth_id": "3571",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1530,
    "description": "WGS 84 / North Pole LAEA Alaska",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=90 +lon_0=-150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3572,
    "auth_name": "EPSG",
    "auth_id": "3572",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1531,
    "description": "WGS 84 / North Pole LAEA Canada",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=90 +lon_0=-100 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3573,
    "auth_name": "EPSG",
    "auth_id": "3573",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1532,
    "description": "WGS 84 / North Pole LAEA Atlantic",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=90 +lon_0=-40 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3574,
    "auth_name": "EPSG",
    "auth_id": "3574",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1533,
    "description": "WGS 84 / North Pole LAEA Europe",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=90 +lon_0=10 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3575,
    "auth_name": "EPSG",
    "auth_id": "3575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1534,
    "description": "WGS 84 / North Pole LAEA Russia",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=90 +lon_0=90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3576,
    "auth_name": "EPSG",
    "auth_id": "3576",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1535,
    "description": "GDA94 / Australian Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=0 +lon_0=132 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3577,
    "auth_name": "EPSG",
    "auth_id": "3577",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1536,
    "description": "NAD83 / Yukon Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=59 +lon_0=-132.5 +lat_1=61.6666666666667 +lat_2=68 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3578,
    "auth_name": "EPSG",
    "auth_id": "3578",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1537,
    "description": "NAD83(CSRS) / Yukon Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=59 +lon_0=-132.5 +lat_1=61.6666666666667 +lat_2=68 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3579,
    "auth_name": "EPSG",
    "auth_id": "3579",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1538,
    "description": "NAD83 / NWT Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=-112 +lat_1=62 +lat_2=70 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3580,
    "auth_name": "EPSG",
    "auth_id": "3580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1539,
    "description": "NAD83(CSRS) / NWT Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=-112 +lat_1=62 +lat_2=70 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3581,
    "auth_name": "EPSG",
    "auth_id": "3581",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1540,
    "description": "NAD83(NSRS2007) / Maryland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3582,
    "auth_name": "EPSG",
    "auth_id": "3582",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1541,
    "description": "NAD83(NSRS2007) / Massachusetts Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3583,
    "auth_name": "EPSG",
    "auth_id": "3583",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1542,
    "description": "NAD83(NSRS2007) / Massachusetts Island (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3584,
    "auth_name": "EPSG",
    "auth_id": "3584",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1543,
    "description": "NAD83(NSRS2007) / Massachusetts Mainland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3585,
    "auth_name": "EPSG",
    "auth_id": "3585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1544,
    "description": "NAD83(NSRS2007) / Massachusetts Mainland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3586,
    "auth_name": "EPSG",
    "auth_id": "3586",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1545,
    "description": "NAD83(NSRS2007) / Michigan Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3587,
    "auth_name": "EPSG",
    "auth_id": "3587",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1546,
    "description": "NAD83(NSRS2007) / Michigan Central (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3588,
    "auth_name": "EPSG",
    "auth_id": "3588",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1547,
    "description": "NAD83(NSRS2007) / Michigan North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3589,
    "auth_name": "EPSG",
    "auth_id": "3589",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1548,
    "description": "NAD83(NSRS2007) / Michigan North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3590,
    "auth_name": "EPSG",
    "auth_id": "3590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1549,
    "description": "NAD83(NSRS2007) / Michigan Oblique Mercator",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3591,
    "auth_name": "EPSG",
    "auth_id": "3591",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1550,
    "description": "NAD83(NSRS2007) / Michigan South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3592,
    "auth_name": "EPSG",
    "auth_id": "3592",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1551,
    "description": "NAD83(NSRS2007) / Michigan South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3593,
    "auth_name": "EPSG",
    "auth_id": "3593",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1552,
    "description": "NAD83(NSRS2007) / Minnesota Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3594,
    "auth_name": "EPSG",
    "auth_id": "3594",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1553,
    "description": "NAD83(NSRS2007) / Minnesota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3595,
    "auth_name": "EPSG",
    "auth_id": "3595",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1554,
    "description": "NAD83(NSRS2007) / Minnesota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3596,
    "auth_name": "EPSG",
    "auth_id": "3596",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1555,
    "description": "NAD83(NSRS2007) / Mississippi East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3597,
    "auth_name": "EPSG",
    "auth_id": "3597",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1556,
    "description": "NAD83(NSRS2007) / Mississippi East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3598,
    "auth_name": "EPSG",
    "auth_id": "3598",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1557,
    "description": "NAD83(NSRS2007) / Mississippi West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3599,
    "auth_name": "EPSG",
    "auth_id": "3599",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1558,
    "description": "NAD83(NSRS2007) / Mississippi West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3600,
    "auth_name": "EPSG",
    "auth_id": "3600",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1559,
    "description": "NAD83(NSRS2007) / Missouri Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3601,
    "auth_name": "EPSG",
    "auth_id": "3601",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1560,
    "description": "NAD83(NSRS2007) / Missouri East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3602,
    "auth_name": "EPSG",
    "auth_id": "3602",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1561,
    "description": "NAD83(NSRS2007) / Missouri West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3603,
    "auth_name": "EPSG",
    "auth_id": "3603",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1562,
    "description": "NAD83(NSRS2007) / Montana",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3604,
    "auth_name": "EPSG",
    "auth_id": "3604",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1563,
    "description": "NAD83(NSRS2007) / Montana (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3605,
    "auth_name": "EPSG",
    "auth_id": "3605",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1564,
    "description": "NAD83(NSRS2007) / Nebraska",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3606,
    "auth_name": "EPSG",
    "auth_id": "3606",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1565,
    "description": "NAD83(NSRS2007) / Nevada Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3607,
    "auth_name": "EPSG",
    "auth_id": "3607",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1566,
    "description": "NAD83(NSRS2007) / Nevada Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3608,
    "auth_name": "EPSG",
    "auth_id": "3608",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1567,
    "description": "NAD83(NSRS2007) / Nevada East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3609,
    "auth_name": "EPSG",
    "auth_id": "3609",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1568,
    "description": "NAD83(NSRS2007) / Nevada East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3610,
    "auth_name": "EPSG",
    "auth_id": "3610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1569,
    "description": "NAD83(NSRS2007) / Nevada West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3611,
    "auth_name": "EPSG",
    "auth_id": "3611",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1570,
    "description": "NAD83(NSRS2007) / Nevada West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3612,
    "auth_name": "EPSG",
    "auth_id": "3612",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1571,
    "description": "NAD83(NSRS2007) / New Hampshire",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3613,
    "auth_name": "EPSG",
    "auth_id": "3613",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1572,
    "description": "NAD83(NSRS2007) / New Hampshire (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3614,
    "auth_name": "EPSG",
    "auth_id": "3614",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1573,
    "description": "NAD83(NSRS2007) / New Jersey",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3615,
    "auth_name": "EPSG",
    "auth_id": "3615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1574,
    "description": "NAD83(NSRS2007) / New Jersey (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3616,
    "auth_name": "EPSG",
    "auth_id": "3616",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1575,
    "description": "NAD83(NSRS2007) / New Mexico Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3617,
    "auth_name": "EPSG",
    "auth_id": "3617",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1576,
    "description": "NAD83(NSRS2007) / New Mexico Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3618,
    "auth_name": "EPSG",
    "auth_id": "3618",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1577,
    "description": "NAD83(NSRS2007) / New Mexico East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3619,
    "auth_name": "EPSG",
    "auth_id": "3619",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1578,
    "description": "NAD83(NSRS2007) / New Mexico East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3620,
    "auth_name": "EPSG",
    "auth_id": "3620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1579,
    "description": "NAD83(NSRS2007) / New Mexico West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3621,
    "auth_name": "EPSG",
    "auth_id": "3621",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1580,
    "description": "NAD83(NSRS2007) / New Mexico West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3622,
    "auth_name": "EPSG",
    "auth_id": "3622",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1581,
    "description": "NAD83(NSRS2007) / New York Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3623,
    "auth_name": "EPSG",
    "auth_id": "3623",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1582,
    "description": "NAD83(NSRS2007) / New York Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3624,
    "auth_name": "EPSG",
    "auth_id": "3624",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1583,
    "description": "NAD83(NSRS2007) / New York East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3625,
    "auth_name": "EPSG",
    "auth_id": "3625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1584,
    "description": "NAD83(NSRS2007) / New York East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3626,
    "auth_name": "EPSG",
    "auth_id": "3626",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1585,
    "description": "NAD83(NSRS2007) / New York Long Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3627,
    "auth_name": "EPSG",
    "auth_id": "3627",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1586,
    "description": "NAD83(NSRS2007) / New York Long Island (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3628,
    "auth_name": "EPSG",
    "auth_id": "3628",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1587,
    "description": "NAD83(NSRS2007) / New York West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3629,
    "auth_name": "EPSG",
    "auth_id": "3629",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1588,
    "description": "NAD83(NSRS2007) / New York West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3630,
    "auth_name": "EPSG",
    "auth_id": "3630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1589,
    "description": "NAD83(NSRS2007) / North Carolina",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.22 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3631,
    "auth_name": "EPSG",
    "auth_id": "3631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1590,
    "description": "NAD83(NSRS2007) / North Carolina (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3632,
    "auth_name": "EPSG",
    "auth_id": "3632",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1591,
    "description": "NAD83(NSRS2007) / North Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3633,
    "auth_name": "EPSG",
    "auth_id": "3633",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1592,
    "description": "NAD83(NSRS2007) / North Dakota North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3634,
    "auth_name": "EPSG",
    "auth_id": "3634",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1593,
    "description": "NAD83(NSRS2007) / North Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3635,
    "auth_name": "EPSG",
    "auth_id": "3635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1594,
    "description": "NAD83(NSRS2007) / North Dakota South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3636,
    "auth_name": "EPSG",
    "auth_id": "3636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1595,
    "description": "NAD83(NSRS2007) / Ohio North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3637,
    "auth_name": "EPSG",
    "auth_id": "3637",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1596,
    "description": "NAD83(NSRS2007) / Ohio South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3638,
    "auth_name": "EPSG",
    "auth_id": "3638",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1597,
    "description": "NAD83(NSRS2007) / Oklahoma North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3639,
    "auth_name": "EPSG",
    "auth_id": "3639",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1598,
    "description": "NAD83(NSRS2007) / Oklahoma North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3640,
    "auth_name": "EPSG",
    "auth_id": "3640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1599,
    "description": "NAD83(NSRS2007) / Oklahoma South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3641,
    "auth_name": "EPSG",
    "auth_id": "3641",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1600,
    "description": "NAD83(NSRS2007) / Oklahoma South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3642,
    "auth_name": "EPSG",
    "auth_id": "3642",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1601,
    "description": "NAD83(NSRS2007) / Oregon LCC (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3643,
    "auth_name": "EPSG",
    "auth_id": "3643",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1602,
    "description": "NAD83(NSRS2007) / Oregon GIC Lambert (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3644,
    "auth_name": "EPSG",
    "auth_id": "3644",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1603,
    "description": "NAD83(NSRS2007) / Oregon North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3645,
    "auth_name": "EPSG",
    "auth_id": "3645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1604,
    "description": "NAD83(NSRS2007) / Oregon North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3646,
    "auth_name": "EPSG",
    "auth_id": "3646",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1605,
    "description": "NAD83(NSRS2007) / Oregon South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3647,
    "auth_name": "EPSG",
    "auth_id": "3647",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1606,
    "description": "NAD83(NSRS2007) / Oregon South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3648,
    "auth_name": "EPSG",
    "auth_id": "3648",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1607,
    "description": "NAD83(NSRS2007) / Pennsylvania North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3649,
    "auth_name": "EPSG",
    "auth_id": "3649",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1608,
    "description": "NAD83(NSRS2007) / Pennsylvania North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3650,
    "auth_name": "EPSG",
    "auth_id": "3650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1609,
    "description": "NAD83(NSRS2007) / Pennsylvania South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3651,
    "auth_name": "EPSG",
    "auth_id": "3651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1610,
    "description": "NAD83(NSRS2007) / Pennsylvania South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3652,
    "auth_name": "EPSG",
    "auth_id": "3652",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1611,
    "description": "NAD83(NSRS2007) / Rhode Island",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3653,
    "auth_name": "EPSG",
    "auth_id": "3653",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1612,
    "description": "NAD83(NSRS2007) / Rhode Island (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3654,
    "auth_name": "EPSG",
    "auth_id": "3654",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1613,
    "description": "NAD83(NSRS2007) / South Carolina",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3655,
    "auth_name": "EPSG",
    "auth_id": "3655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1614,
    "description": "NAD83(NSRS2007) / South Carolina (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3656,
    "auth_name": "EPSG",
    "auth_id": "3656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1615,
    "description": "NAD83(NSRS2007) / South Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3657,
    "auth_name": "EPSG",
    "auth_id": "3657",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1616,
    "description": "NAD83(NSRS2007) / South Dakota North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3658,
    "auth_name": "EPSG",
    "auth_id": "3658",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1617,
    "description": "NAD83(NSRS2007) / South Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3659,
    "auth_name": "EPSG",
    "auth_id": "3659",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1618,
    "description": "NAD83(NSRS2007) / South Dakota South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3660,
    "auth_name": "EPSG",
    "auth_id": "3660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1619,
    "description": "NAD83(NSRS2007) / Tennessee",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3661,
    "auth_name": "EPSG",
    "auth_id": "3661",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1620,
    "description": "NAD83(NSRS2007) / Tennessee (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3662,
    "auth_name": "EPSG",
    "auth_id": "3662",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1621,
    "description": "NAD83(NSRS2007) / Texas Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3663,
    "auth_name": "EPSG",
    "auth_id": "3663",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1622,
    "description": "NAD83(NSRS2007) / Texas Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3664,
    "auth_name": "EPSG",
    "auth_id": "3664",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1623,
    "description": "NAD83(NSRS2007) / Texas Centric Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3665,
    "auth_name": "EPSG",
    "auth_id": "3665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1624,
    "description": "NAD83(NSRS2007) / Texas Centric Lambert Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3666,
    "auth_name": "EPSG",
    "auth_id": "3666",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1625,
    "description": "NAD83(NSRS2007) / Texas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3667,
    "auth_name": "EPSG",
    "auth_id": "3667",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1626,
    "description": "NAD83(NSRS2007) / Texas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3668,
    "auth_name": "EPSG",
    "auth_id": "3668",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1627,
    "description": "NAD83(NSRS2007) / Texas North Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3669,
    "auth_name": "EPSG",
    "auth_id": "3669",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1628,
    "description": "NAD83(NSRS2007) / Texas North Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3670,
    "auth_name": "EPSG",
    "auth_id": "3670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1629,
    "description": "NAD83(NSRS2007) / Texas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3671,
    "auth_name": "EPSG",
    "auth_id": "3671",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1630,
    "description": "NAD83(NSRS2007) / Texas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3672,
    "auth_name": "EPSG",
    "auth_id": "3672",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1631,
    "description": "NAD83(NSRS2007) / Texas South Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3673,
    "auth_name": "EPSG",
    "auth_id": "3673",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1632,
    "description": "NAD83(NSRS2007) / Texas South Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3674,
    "auth_name": "EPSG",
    "auth_id": "3674",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1633,
    "description": "NAD83(NSRS2007) / Utah Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3675,
    "auth_name": "EPSG",
    "auth_id": "3675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1634,
    "description": "NAD83(NSRS2007) / Utah Central (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.0001504 +y_0=1999999.999992 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3676,
    "auth_name": "EPSG",
    "auth_id": "3676",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1635,
    "description": "NAD83(NSRS2007) / Utah Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3677,
    "auth_name": "EPSG",
    "auth_id": "3677",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1636,
    "description": "NAD83(NSRS2007) / Utah North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3678,
    "auth_name": "EPSG",
    "auth_id": "3678",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1637,
    "description": "NAD83(NSRS2007) / Utah North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.0001504 +y_0=999999.999996 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3679,
    "auth_name": "EPSG",
    "auth_id": "3679",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1638,
    "description": "NAD83(NSRS2007) / Utah North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3680,
    "auth_name": "EPSG",
    "auth_id": "3680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1639,
    "description": "NAD83(NSRS2007) / Utah South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3681,
    "auth_name": "EPSG",
    "auth_id": "3681",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1640,
    "description": "NAD83(NSRS2007) / Utah South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.0001504 +y_0=2999999.999988 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 3682,
    "auth_name": "EPSG",
    "auth_id": "3682",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1641,
    "description": "NAD83(NSRS2007) / Utah South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3683,
    "auth_name": "EPSG",
    "auth_id": "3683",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1642,
    "description": "NAD83(NSRS2007) / Vermont",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3684,
    "auth_name": "EPSG",
    "auth_id": "3684",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1643,
    "description": "NAD83(NSRS2007) / Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3685,
    "auth_name": "EPSG",
    "auth_id": "3685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1644,
    "description": "NAD83(NSRS2007) / Virginia North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3686,
    "auth_name": "EPSG",
    "auth_id": "3686",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1645,
    "description": "NAD83(NSRS2007) / Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3687,
    "auth_name": "EPSG",
    "auth_id": "3687",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1646,
    "description": "NAD83(NSRS2007) / Virginia South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3688,
    "auth_name": "EPSG",
    "auth_id": "3688",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1647,
    "description": "NAD83(NSRS2007) / Washington North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3689,
    "auth_name": "EPSG",
    "auth_id": "3689",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1648,
    "description": "NAD83(NSRS2007) / Washington North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3690,
    "auth_name": "EPSG",
    "auth_id": "3690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1649,
    "description": "NAD83(NSRS2007) / Washington South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3691,
    "auth_name": "EPSG",
    "auth_id": "3691",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1650,
    "description": "NAD83(NSRS2007) / Washington South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3692,
    "auth_name": "EPSG",
    "auth_id": "3692",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1651,
    "description": "NAD83(NSRS2007) / West Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3693,
    "auth_name": "EPSG",
    "auth_id": "3693",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1652,
    "description": "NAD83(NSRS2007) / West Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3694,
    "auth_name": "EPSG",
    "auth_id": "3694",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1653,
    "description": "NAD83(NSRS2007) / Wisconsin Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3695,
    "auth_name": "EPSG",
    "auth_id": "3695",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1654,
    "description": "NAD83(NSRS2007) / Wisconsin Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3696,
    "auth_name": "EPSG",
    "auth_id": "3696",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1655,
    "description": "NAD83(NSRS2007) / Wisconsin North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3697,
    "auth_name": "EPSG",
    "auth_id": "3697",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1656,
    "description": "NAD83(NSRS2007) / Wisconsin North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3698,
    "auth_name": "EPSG",
    "auth_id": "3698",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1657,
    "description": "NAD83(NSRS2007) / Wisconsin South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3699,
    "auth_name": "EPSG",
    "auth_id": "3699",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1658,
    "description": "NAD83(NSRS2007) / Wisconsin South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3700,
    "auth_name": "EPSG",
    "auth_id": "3700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1659,
    "description": "NAD83(NSRS2007) / Wisconsin Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3701,
    "auth_name": "EPSG",
    "auth_id": "3701",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1660,
    "description": "NAD83(NSRS2007) / Wyoming East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3702,
    "auth_name": "EPSG",
    "auth_id": "3702",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1661,
    "description": "NAD83(NSRS2007) / Wyoming East Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3703,
    "auth_name": "EPSG",
    "auth_id": "3703",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1662,
    "description": "NAD83(NSRS2007) / Wyoming West Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3704,
    "auth_name": "EPSG",
    "auth_id": "3704",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1663,
    "description": "NAD83(NSRS2007) / Wyoming West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3705,
    "auth_name": "EPSG",
    "auth_id": "3705",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1664,
    "description": "NAD83(NSRS2007) / UTM zone 59N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=59 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3706,
    "auth_name": "EPSG",
    "auth_id": "3706",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1665,
    "description": "NAD83(NSRS2007) / UTM zone 60N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=60 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3707,
    "auth_name": "EPSG",
    "auth_id": "3707",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1666,
    "description": "NAD83(NSRS2007) / UTM zone 1N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=1 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3708,
    "auth_name": "EPSG",
    "auth_id": "3708",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1667,
    "description": "NAD83(NSRS2007) / UTM zone 2N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=2 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3709,
    "auth_name": "EPSG",
    "auth_id": "3709",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1668,
    "description": "NAD83(NSRS2007) / UTM zone 3N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=3 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3710,
    "auth_name": "EPSG",
    "auth_id": "3710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1669,
    "description": "NAD83(NSRS2007) / UTM zone 4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=4 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3711,
    "auth_name": "EPSG",
    "auth_id": "3711",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1670,
    "description": "NAD83(NSRS2007) / UTM zone 5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3712,
    "auth_name": "EPSG",
    "auth_id": "3712",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1671,
    "description": "NAD83(NSRS2007) / UTM zone 6N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=6 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3713,
    "auth_name": "EPSG",
    "auth_id": "3713",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1672,
    "description": "NAD83(NSRS2007) / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3714,
    "auth_name": "EPSG",
    "auth_id": "3714",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1673,
    "description": "NAD83(NSRS2007) / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3715,
    "auth_name": "EPSG",
    "auth_id": "3715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1674,
    "description": "NAD83(NSRS2007) / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3716,
    "auth_name": "EPSG",
    "auth_id": "3716",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1675,
    "description": "NAD83(NSRS2007) / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3717,
    "auth_name": "EPSG",
    "auth_id": "3717",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1676,
    "description": "NAD83(NSRS2007) / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3718,
    "auth_name": "EPSG",
    "auth_id": "3718",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1677,
    "description": "NAD83(NSRS2007) / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3719,
    "auth_name": "EPSG",
    "auth_id": "3719",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1678,
    "description": "NAD83(NSRS2007) / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3720,
    "auth_name": "EPSG",
    "auth_id": "3720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1679,
    "description": "NAD83(NSRS2007) / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3721,
    "auth_name": "EPSG",
    "auth_id": "3721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1680,
    "description": "NAD83(NSRS2007) / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3722,
    "auth_name": "EPSG",
    "auth_id": "3722",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1681,
    "description": "NAD83(NSRS2007) / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3723,
    "auth_name": "EPSG",
    "auth_id": "3723",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1682,
    "description": "NAD83(NSRS2007) / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3724,
    "auth_name": "EPSG",
    "auth_id": "3724",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1683,
    "description": "NAD83(NSRS2007) / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3725,
    "auth_name": "EPSG",
    "auth_id": "3725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1684,
    "description": "NAD83(NSRS2007) / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3726,
    "auth_name": "EPSG",
    "auth_id": "3726",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1685,
    "description": "Reunion 1947 / TM Reunion",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k=1 +x_0=160000 +y_0=50000 +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +no_defs",
    "srid": 3727,
    "auth_name": "EPSG",
    "auth_id": "3727",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1686,
    "description": "NAD83(NSRS2007) / Ohio North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3728,
    "auth_name": "EPSG",
    "auth_id": "3728",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1687,
    "description": "NAD83(NSRS2007) / Ohio South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3729,
    "auth_name": "EPSG",
    "auth_id": "3729",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1688,
    "description": "NAD83(NSRS2007) / Wyoming East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3730,
    "auth_name": "EPSG",
    "auth_id": "3730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1689,
    "description": "NAD83(NSRS2007) / Wyoming East Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3731,
    "auth_name": "EPSG",
    "auth_id": "3731",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1690,
    "description": "NAD83(NSRS2007) / Wyoming West Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3732,
    "auth_name": "EPSG",
    "auth_id": "3732",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1691,
    "description": "NAD83(NSRS2007) / Wyoming West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3733,
    "auth_name": "EPSG",
    "auth_id": "3733",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1692,
    "description": "NAD83 / Ohio North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3734,
    "auth_name": "EPSG",
    "auth_id": "3734",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1693,
    "description": "NAD83 / Ohio South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3735,
    "auth_name": "EPSG",
    "auth_id": "3735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1694,
    "description": "NAD83 / Wyoming East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3736,
    "auth_name": "EPSG",
    "auth_id": "3736",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1695,
    "description": "NAD83 / Wyoming East Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3737,
    "auth_name": "EPSG",
    "auth_id": "3737",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1696,
    "description": "NAD83 / Wyoming West Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3738,
    "auth_name": "EPSG",
    "auth_id": "3738",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1697,
    "description": "NAD83 / Wyoming West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3739,
    "auth_name": "EPSG",
    "auth_id": "3739",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1698,
    "description": "NAD83(HARN) / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs",
    "srid": 3740,
    "auth_name": "EPSG",
    "auth_id": "3740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1699,
    "description": "NAD83(HARN) / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs",
    "srid": 3741,
    "auth_name": "EPSG",
    "auth_id": "3741",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1700,
    "description": "NAD83(HARN) / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs",
    "srid": 3742,
    "auth_name": "EPSG",
    "auth_id": "3742",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1701,
    "description": "NAD83(HARN) / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs",
    "srid": 3743,
    "auth_name": "EPSG",
    "auth_id": "3743",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1702,
    "description": "NAD83(HARN) / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs",
    "srid": 3744,
    "auth_name": "EPSG",
    "auth_id": "3744",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1703,
    "description": "NAD83(HARN) / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs",
    "srid": 3745,
    "auth_name": "EPSG",
    "auth_id": "3745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1704,
    "description": "NAD83(HARN) / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs",
    "srid": 3746,
    "auth_name": "EPSG",
    "auth_id": "3746",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1705,
    "description": "NAD83(HARN) / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 3747,
    "auth_name": "EPSG",
    "auth_id": "3747",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1706,
    "description": "NAD83(HARN) / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs",
    "srid": 3748,
    "auth_name": "EPSG",
    "auth_id": "3748",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1707,
    "description": "NAD83(HARN) / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs",
    "srid": 3749,
    "auth_name": "EPSG",
    "auth_id": "3749",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1708,
    "description": "NAD83(HARN) / UTM zone 4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=4 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3750,
    "auth_name": "EPSG",
    "auth_id": "3750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1709,
    "description": "NAD83(HARN) / UTM zone 5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3751,
    "auth_name": "EPSG",
    "auth_id": "3751",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1711,
    "description": "NAD83(HARN) / Ohio North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3753,
    "auth_name": "EPSG",
    "auth_id": "3753",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1712,
    "description": "NAD83(HARN) / Ohio South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3754,
    "auth_name": "EPSG",
    "auth_id": "3754",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1713,
    "description": "NAD83(HARN) / Wyoming East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3755,
    "auth_name": "EPSG",
    "auth_id": "3755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1714,
    "description": "NAD83(HARN) / Wyoming East Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3756,
    "auth_name": "EPSG",
    "auth_id": "3756",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1715,
    "description": "NAD83(HARN) / Wyoming West Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3757,
    "auth_name": "EPSG",
    "auth_id": "3757",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1716,
    "description": "NAD83(HARN) / Wyoming West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 3758,
    "auth_name": "EPSG",
    "auth_id": "3758",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1717,
    "description": "NAD83 / Hawaii zone 3 (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=1,1,-1,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3759,
    "auth_name": "EPSG",
    "auth_id": "3759",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1718,
    "description": "NAD83(HARN) / Hawaii zone 3 (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3760,
    "auth_name": "EPSG",
    "auth_id": "3760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1719,
    "description": "NAD83(CSRS) / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs",
    "srid": 3761,
    "auth_name": "EPSG",
    "auth_id": "3761",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1720,
    "description": "WGS 84 / South Georgia Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-55 +lon_0=-37 +lat_1=-54 +lat_2=-54.75 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3762,
    "auth_name": "EPSG",
    "auth_id": "3762",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1721,
    "description": "ETRS89 / Portugal TM06",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.6682583333333 +lon_0=-8.13310833333333 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3763,
    "auth_name": "EPSG",
    "auth_id": "3763",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1722,
    "description": "NZGD2000 / Chatham Island Circuit 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3764,
    "auth_name": "EPSG",
    "auth_id": "3764",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1723,
    "description": "HTRS96 / Croatia TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3765,
    "auth_name": "EPSG",
    "auth_id": "3765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1724,
    "description": "HTRS96 / Croatia LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=16.5 +lat_1=45.9166666666667 +lat_2=43.0833333333333 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3766,
    "auth_name": "EPSG",
    "auth_id": "3766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1725,
    "description": "HTRS96 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3767,
    "auth_name": "EPSG",
    "auth_id": "3767",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1726,
    "description": "HTRS96 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3768,
    "auth_name": "EPSG",
    "auth_id": "3768",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1727,
    "description": "Bermuda 1957 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=20 +ellps=clrk66 +units=m +no_defs",
    "srid": 3769,
    "auth_name": "EPSG",
    "auth_id": "3769",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1728,
    "description": "BDA2000 / Bermuda 2000 National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=32 +lon_0=-64.75 +k=1 +x_0=550000 +y_0=100000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3770,
    "auth_name": "EPSG",
    "auth_id": "3770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1729,
    "description": "NAD27 / Alberta 3TM ref merid 111 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 3771,
    "auth_name": "EPSG",
    "auth_id": "3771",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1730,
    "description": "NAD27 / Alberta 3TM ref merid 114 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 3772,
    "auth_name": "EPSG",
    "auth_id": "3772",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1731,
    "description": "NAD27 / Alberta 3TM ref merid 117 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 3773,
    "auth_name": "EPSG",
    "auth_id": "3773",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1733,
    "description": "NAD83 / Alberta 3TM ref merid 111 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3775,
    "auth_name": "EPSG",
    "auth_id": "3775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1734,
    "description": "NAD83 / Alberta 3TM ref merid 114 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3776,
    "auth_name": "EPSG",
    "auth_id": "3776",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1735,
    "description": "NAD83 / Alberta 3TM ref merid 117 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3777,
    "auth_name": "EPSG",
    "auth_id": "3777",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1737,
    "description": "NAD83(CSRS) / Alberta 3TM ref merid 111 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3779,
    "auth_name": "EPSG",
    "auth_id": "3779",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1738,
    "description": "NAD83(CSRS) / Alberta 3TM ref merid 114 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3780,
    "auth_name": "EPSG",
    "auth_id": "3780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1739,
    "description": "NAD83(CSRS) / Alberta 3TM ref merid 117 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3781,
    "auth_name": "EPSG",
    "auth_id": "3781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1741,
    "description": "Pitcairn 2006 / Pitcairn TM 2006",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=-25.0685526111111 +lon_0=-130.112967111111 +k=1 +x_0=14200 +y_0=15500 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3783,
    "auth_name": "EPSG",
    "auth_id": "3783",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1742,
    "description": "Pitcairn 1967 / UTM zone 9S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=9 +south +ellps=intl +towgs84=185,165,42,0,0,0,0 +units=m +no_defs",
    "srid": 3784,
    "auth_name": "EPSG",
    "auth_id": "3784",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1746,
    "description": "NZGD2000 / Auckland Islands TM 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=166 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3788,
    "auth_name": "EPSG",
    "auth_id": "3788",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1747,
    "description": "NZGD2000 / Campbell Island TM 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=169 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3789,
    "auth_name": "EPSG",
    "auth_id": "3789",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1748,
    "description": "NZGD2000 / Antipodes Islands TM 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=179 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3790,
    "auth_name": "EPSG",
    "auth_id": "3790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1749,
    "description": "NZGD2000 / Raoul Island TM 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-178 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3791,
    "auth_name": "EPSG",
    "auth_id": "3791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1750,
    "description": "NZGD2000 / Chatham Islands TM 2000",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-176.5 +k=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3793,
    "auth_name": "EPSG",
    "auth_id": "3793",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1751,
    "description": "Slovenia 1996 / Slovene National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3794,
    "auth_name": "EPSG",
    "auth_id": "3794",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1752,
    "description": "NAD27 / Cuba Norte",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=22.35 +lon_0=-81 +lat_1=23 +lat_2=21.7 +x_0=500000 +y_0=280296.016 +datum=NAD27 +units=m +no_defs",
    "srid": 3795,
    "auth_name": "EPSG",
    "auth_id": "3795",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1753,
    "description": "NAD27 / Cuba Sur",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=20.7166666666667 +lon_0=-76.8333333333333 +lat_1=21.3 +lat_2=20.1333333333333 +x_0=500000 +y_0=229126.939 +datum=NAD27 +units=m +no_defs",
    "srid": 3796,
    "auth_name": "EPSG",
    "auth_id": "3796",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1754,
    "description": "NAD27 / MTQ Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=-70 +lat_1=50 +lat_2=46 +x_0=800000 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 3797,
    "auth_name": "EPSG",
    "auth_id": "3797",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1755,
    "description": "NAD83 / MTQ Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=-70 +lat_1=50 +lat_2=46 +x_0=800000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 3798,
    "auth_name": "EPSG",
    "auth_id": "3798",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1756,
    "description": "NAD83(CSRS) / MTQ Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=-70 +lat_1=50 +lat_2=46 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3799,
    "auth_name": "EPSG",
    "auth_id": "3799",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1757,
    "description": "NAD27 / Alberta 3TM ref merid 120 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 3800,
    "auth_name": "EPSG",
    "auth_id": "3800",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1758,
    "description": "NAD83 / Alberta 3TM ref merid 120 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3801,
    "auth_name": "EPSG",
    "auth_id": "3801",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1759,
    "description": "NAD83(CSRS) / Alberta 3TM ref merid 120 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3802,
    "auth_name": "EPSG",
    "auth_id": "3802",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1760,
    "description": "Puerto Rico / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=20 +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +units=m +no_defs",
    "srid": 3920,
    "auth_name": "EPSG",
    "auth_id": "3920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1761,
    "description": "RGF93 v1 / CC42",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3942,
    "auth_name": "EPSG",
    "auth_id": "3942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1762,
    "description": "RGF93 v1 / CC43",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3943,
    "auth_name": "EPSG",
    "auth_id": "3943",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1763,
    "description": "RGF93 v1 / CC44",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=3 +lat_1=43.25 +lat_2=44.75 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3944,
    "auth_name": "EPSG",
    "auth_id": "3944",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1764,
    "description": "RGF93 v1 / CC45",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=3 +lat_1=44.25 +lat_2=45.75 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3945,
    "auth_name": "EPSG",
    "auth_id": "3945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1765,
    "description": "RGF93 v1 / CC46",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46 +lon_0=3 +lat_1=45.25 +lat_2=46.75 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3946,
    "auth_name": "EPSG",
    "auth_id": "3946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1766,
    "description": "RGF93 v1 / CC47",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=3 +lat_1=46.25 +lat_2=47.75 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3947,
    "auth_name": "EPSG",
    "auth_id": "3947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1767,
    "description": "RGF93 v1 / CC48",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=48 +lon_0=3 +lat_1=47.25 +lat_2=48.75 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3948,
    "auth_name": "EPSG",
    "auth_id": "3948",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1768,
    "description": "RGF93 v1 / CC49",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=49 +lon_0=3 +lat_1=48.25 +lat_2=49.75 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3949,
    "auth_name": "EPSG",
    "auth_id": "3949",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1769,
    "description": "RGF93 v1 / CC50",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=50 +lon_0=3 +lat_1=49.25 +lat_2=50.75 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3950,
    "auth_name": "EPSG",
    "auth_id": "3950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1770,
    "description": "Puerto Rico State Plane CS of 1927",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +units=us-ft +no_defs",
    "srid": 3991,
    "auth_name": "EPSG",
    "auth_id": "3991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1771,
    "description": "Puerto Rico / St. Croix",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +units=us-ft +no_defs",
    "srid": 3992,
    "auth_name": "EPSG",
    "auth_id": "3992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1772,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20004,
    "auth_name": "EPSG",
    "auth_id": "20004",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1773,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20005,
    "auth_name": "EPSG",
    "auth_id": "20005",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1774,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20006,
    "auth_name": "EPSG",
    "auth_id": "20006",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1775,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20007,
    "auth_name": "EPSG",
    "auth_id": "20007",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1776,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20008,
    "auth_name": "EPSG",
    "auth_id": "20008",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1777,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20009,
    "auth_name": "EPSG",
    "auth_id": "20009",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1778,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20010,
    "auth_name": "EPSG",
    "auth_id": "20010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1779,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20011,
    "auth_name": "EPSG",
    "auth_id": "20011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1780,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20012,
    "auth_name": "EPSG",
    "auth_id": "20012",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1781,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20013,
    "auth_name": "EPSG",
    "auth_id": "20013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1782,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20014,
    "auth_name": "EPSG",
    "auth_id": "20014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1783,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20015,
    "auth_name": "EPSG",
    "auth_id": "20015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1784,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20016,
    "auth_name": "EPSG",
    "auth_id": "20016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1785,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20017,
    "auth_name": "EPSG",
    "auth_id": "20017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1786,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20018,
    "auth_name": "EPSG",
    "auth_id": "20018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1787,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20019,
    "auth_name": "EPSG",
    "auth_id": "20019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1788,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20020,
    "auth_name": "EPSG",
    "auth_id": "20020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1789,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20021,
    "auth_name": "EPSG",
    "auth_id": "20021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1790,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20022,
    "auth_name": "EPSG",
    "auth_id": "20022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1791,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20023,
    "auth_name": "EPSG",
    "auth_id": "20023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1792,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20024,
    "auth_name": "EPSG",
    "auth_id": "20024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1793,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20025,
    "auth_name": "EPSG",
    "auth_id": "20025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1794,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20026,
    "auth_name": "EPSG",
    "auth_id": "20026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1795,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20027,
    "auth_name": "EPSG",
    "auth_id": "20027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1796,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20028,
    "auth_name": "EPSG",
    "auth_id": "20028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1797,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20029,
    "auth_name": "EPSG",
    "auth_id": "20029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1798,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20030,
    "auth_name": "EPSG",
    "auth_id": "20030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1799,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20031,
    "auth_name": "EPSG",
    "auth_id": "20031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1800,
    "description": "Pulkovo 1995 / Gauss-Kruger zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +units=m +no_defs",
    "srid": 20032,
    "auth_name": "EPSG",
    "auth_id": "20032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1830,
    "description": "Adindan / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=35 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 20135,
    "auth_name": "EPSG",
    "auth_id": "20135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1831,
    "description": "Adindan / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=36 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 20136,
    "auth_name": "EPSG",
    "auth_id": "20136",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1832,
    "description": "Adindan / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=37 +a=6378249.145 +rf=293.465 +towgs84=-166,-15,204,0,0,0,0 +units=m +no_defs",
    "srid": 20137,
    "auth_name": "EPSG",
    "auth_id": "20137",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1833,
    "description": "Adindan / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=38 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 20138,
    "auth_name": "EPSG",
    "auth_id": "20138",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1835,
    "description": "AGD66 / AMG zone 49",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=49 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 20249,
    "auth_name": "EPSG",
    "auth_id": "20249",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1836,
    "description": "AGD66 / AMG zone 50",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=50 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20250,
    "auth_name": "EPSG",
    "auth_id": "20250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1837,
    "description": "AGD66 / AMG zone 51",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=51 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20251,
    "auth_name": "EPSG",
    "auth_id": "20251",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1838,
    "description": "AGD66 / AMG zone 52",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=52 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 20252,
    "auth_name": "EPSG",
    "auth_id": "20252",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1839,
    "description": "AGD66 / AMG zone 53",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=53 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 20253,
    "auth_name": "EPSG",
    "auth_id": "20253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1840,
    "description": "AGD66 / AMG zone 54",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=54 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20254,
    "auth_name": "EPSG",
    "auth_id": "20254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1841,
    "description": "AGD66 / AMG zone 55",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=55 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20255,
    "auth_name": "EPSG",
    "auth_id": "20255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1842,
    "description": "AGD66 / AMG zone 56",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=56 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20256,
    "auth_name": "EPSG",
    "auth_id": "20256",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1843,
    "description": "AGD66 / AMG zone 57",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=57 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 20257,
    "auth_name": "EPSG",
    "auth_id": "20257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1844,
    "description": "AGD66 / AMG zone 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=58 +south +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 20258,
    "auth_name": "EPSG",
    "auth_id": "20258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1846,
    "description": "AGD84 / AMG zone 49",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=49 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20349,
    "auth_name": "EPSG",
    "auth_id": "20349",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1847,
    "description": "AGD84 / AMG zone 50",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=50 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20350,
    "auth_name": "EPSG",
    "auth_id": "20350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1848,
    "description": "AGD84 / AMG zone 51",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=51 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20351,
    "auth_name": "EPSG",
    "auth_id": "20351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1849,
    "description": "AGD84 / AMG zone 52",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=52 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20352,
    "auth_name": "EPSG",
    "auth_id": "20352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1850,
    "description": "AGD84 / AMG zone 53",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=53 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20353,
    "auth_name": "EPSG",
    "auth_id": "20353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1851,
    "description": "AGD84 / AMG zone 54",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=54 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20354,
    "auth_name": "EPSG",
    "auth_id": "20354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1852,
    "description": "AGD84 / AMG zone 55",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=55 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20355,
    "auth_name": "EPSG",
    "auth_id": "20355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1853,
    "description": "AGD84 / AMG zone 56",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=56 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 20356,
    "auth_name": "EPSG",
    "auth_id": "20356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1856,
    "description": "Ain el Abd / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=36 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs",
    "srid": 20436,
    "auth_name": "EPSG",
    "auth_id": "20436",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1857,
    "description": "Ain el Abd / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=37 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs",
    "srid": 20437,
    "auth_name": "EPSG",
    "auth_id": "20437",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1858,
    "description": "Ain el Abd / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs",
    "srid": 20438,
    "auth_name": "EPSG",
    "auth_id": "20438",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1859,
    "description": "Ain el Abd / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=39 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs",
    "srid": 20439,
    "auth_name": "EPSG",
    "auth_id": "20439",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1860,
    "description": "Ain el Abd / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=40 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs",
    "srid": 20440,
    "auth_name": "EPSG",
    "auth_id": "20440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1861,
    "description": "Ain el Abd / Bahrain Grid",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=39 +ellps=intl +towgs84=-150,-250,-1,0,0,0,0 +units=m +no_defs",
    "srid": 20499,
    "auth_name": "EPSG",
    "auth_id": "20499",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1862,
    "description": "Afgooye / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=utm +zone=38 +ellps=krass +towgs84=-43,-163,45,0,0,0,0 +units=m +no_defs",
    "srid": 20538,
    "auth_name": "EPSG",
    "auth_id": "20538",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1863,
    "description": "Afgooye / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=utm +zone=39 +ellps=krass +towgs84=-43,-163,45,0,0,0,0 +units=m +no_defs",
    "srid": 20539,
    "auth_name": "EPSG",
    "auth_id": "20539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1864,
    "description": "Lisbon (Lisbon) / Portuguese National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=39.6666666666667 +lon_0=1 +k=1 +x_0=200000 +y_0=300000 +ellps=intl +pm=lisbon +towgs84=-288.885,-91.744,126.244,-1.691,0.41,-0.211,-4.598 +units=m +no_defs",
    "srid": 20790,
    "auth_name": "EPSG",
    "auth_id": "20790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1865,
    "description": "Lisbon (Lisbon) / Portuguese Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=39.6666666666667 +lon_0=1 +k=1 +x_0=0 +y_0=0 +ellps=intl +pm=lisbon +towgs84=-288.885,-91.744,126.244,-1.691,0.41,-0.211,-4.598 +units=m +no_defs",
    "srid": 20791,
    "auth_name": "EPSG",
    "auth_id": "20791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1866,
    "description": "Aratu / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +south +ellps=intl +towgs84=-157.84,308.54,-146.6,0,0,0,0 +units=m +no_defs",
    "srid": 20822,
    "auth_name": "EPSG",
    "auth_id": "20822",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1867,
    "description": "Aratu / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=23 +south +ellps=intl +units=m +no_defs",
    "srid": 20823,
    "auth_name": "EPSG",
    "auth_id": "20823",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1868,
    "description": "Aratu / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=24 +south +ellps=intl +units=m +no_defs",
    "srid": 20824,
    "auth_name": "EPSG",
    "auth_id": "20824",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1869,
    "description": "Arc 1950 / UTM zone 34S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=34 +south +a=6378249.145 +rf=293.4663077 +towgs84=-143,-90,-294,0,0,0,0 +units=m +no_defs",
    "srid": 20934,
    "auth_name": "EPSG",
    "auth_id": "20934",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1870,
    "description": "Arc 1950 / UTM zone 35S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=35 +south +a=6378249.145 +rf=293.4663077 +towgs84=-143,-90,-294,0,0,0,0 +units=m +no_defs",
    "srid": 20935,
    "auth_name": "EPSG",
    "auth_id": "20935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1871,
    "description": "Arc 1950 / UTM zone 36S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=36 +south +a=6378249.145 +rf=293.4663077 +towgs84=-143,-90,-294,0,0,0,0 +units=m +no_defs",
    "srid": 20936,
    "auth_name": "EPSG",
    "auth_id": "20936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1872,
    "description": "Arc 1960 / UTM zone 35S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=35 +south +a=6378249.145 +rf=293.465 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs",
    "srid": 21035,
    "auth_name": "EPSG",
    "auth_id": "21035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1873,
    "description": "Arc 1960 / UTM zone 36S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=36 +south +a=6378249.145 +rf=293.465 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs",
    "srid": 21036,
    "auth_name": "EPSG",
    "auth_id": "21036",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1874,
    "description": "Arc 1960 / UTM zone 37S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=37 +south +a=6378249.145 +rf=293.465 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs",
    "srid": 21037,
    "auth_name": "EPSG",
    "auth_id": "21037",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1875,
    "description": "Arc 1960 / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=35 +a=6378249.145 +rf=293.465 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs",
    "srid": 21095,
    "auth_name": "EPSG",
    "auth_id": "21095",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1876,
    "description": "Arc 1960 / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=36 +a=6378249.145 +rf=293.465 +towgs84=-160,-6,-302,0,0,0,0 +units=m +no_defs",
    "srid": 21096,
    "auth_name": "EPSG",
    "auth_id": "21096",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1877,
    "description": "Arc 1960 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=37 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 21097,
    "auth_name": "EPSG",
    "auth_id": "21097",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1879,
    "description": "Batavia / UTM zone 48S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=48 +south +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs",
    "srid": 21148,
    "auth_name": "EPSG",
    "auth_id": "21148",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1880,
    "description": "Batavia / UTM zone 49S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=49 +south +ellps=bessel +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs",
    "srid": 21149,
    "auth_name": "EPSG",
    "auth_id": "21149",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1881,
    "description": "Batavia / UTM zone 50S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=50 +south +ellps=bessel +units=m +no_defs",
    "srid": 21150,
    "auth_name": "EPSG",
    "auth_id": "21150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1882,
    "description": "Barbados 1938 / British West Indies Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-62 +k=0.9995 +x_0=400000 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=31.95,300.99,419.19,0,0,0,0 +units=m +no_defs",
    "srid": 21291,
    "auth_name": "EPSG",
    "auth_id": "21291",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1883,
    "description": "Barbados 1938 / Barbados National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=13.1763888888889 +lon_0=-59.5597222222222 +k=0.9999986 +x_0=30000 +y_0=75000 +a=6378249.145 +rf=293.465 +towgs84=31.95,300.99,419.19,0,0,0,0 +units=m +no_defs",
    "srid": 21292,
    "auth_name": "EPSG",
    "auth_id": "21292",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1884,
    "description": "Beijing 1954 / Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21413,
    "auth_name": "EPSG",
    "auth_id": "21413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1885,
    "description": "Beijing 1954 / Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21414,
    "auth_name": "EPSG",
    "auth_id": "21414",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1886,
    "description": "Beijing 1954 / Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21415,
    "auth_name": "EPSG",
    "auth_id": "21415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1887,
    "description": "Beijing 1954 / Gauss-Kruger zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21416,
    "auth_name": "EPSG",
    "auth_id": "21416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1888,
    "description": "Beijing 1954 / Gauss-Kruger zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21417,
    "auth_name": "EPSG",
    "auth_id": "21417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1889,
    "description": "Beijing 1954 / Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21418,
    "auth_name": "EPSG",
    "auth_id": "21418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1890,
    "description": "Beijing 1954 / Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21419,
    "auth_name": "EPSG",
    "auth_id": "21419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1891,
    "description": "Beijing 1954 / Gauss-Kruger zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21420,
    "auth_name": "EPSG",
    "auth_id": "21420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1892,
    "description": "Beijing 1954 / Gauss-Kruger zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21421,
    "auth_name": "EPSG",
    "auth_id": "21421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1893,
    "description": "Beijing 1954 / Gauss-Kruger zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21422,
    "auth_name": "EPSG",
    "auth_id": "21422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1894,
    "description": "Beijing 1954 / Gauss-Kruger zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21423,
    "auth_name": "EPSG",
    "auth_id": "21423",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1895,
    "description": "Beijing 1954 / Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21453,
    "auth_name": "EPSG",
    "auth_id": "21453",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1896,
    "description": "Beijing 1954 / Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21454,
    "auth_name": "EPSG",
    "auth_id": "21454",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1897,
    "description": "Beijing 1954 / Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21455,
    "auth_name": "EPSG",
    "auth_id": "21455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1898,
    "description": "Beijing 1954 / Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21456,
    "auth_name": "EPSG",
    "auth_id": "21456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1899,
    "description": "Beijing 1954 / Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21457,
    "auth_name": "EPSG",
    "auth_id": "21457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1900,
    "description": "Beijing 1954 / Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21458,
    "auth_name": "EPSG",
    "auth_id": "21458",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1901,
    "description": "Beijing 1954 / Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21459,
    "auth_name": "EPSG",
    "auth_id": "21459",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1902,
    "description": "Beijing 1954 / Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21460,
    "auth_name": "EPSG",
    "auth_id": "21460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1903,
    "description": "Beijing 1954 / Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21461,
    "auth_name": "EPSG",
    "auth_id": "21461",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1904,
    "description": "Beijing 1954 / Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21462,
    "auth_name": "EPSG",
    "auth_id": "21462",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1905,
    "description": "Beijing 1954 / Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 21463,
    "auth_name": "EPSG",
    "auth_id": "21463",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1917,
    "description": "BD50 (Brussels) / Belge Lambert 50",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=90 +lon_0=0 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=150000 +y_0=5400000 +ellps=intl +pm=brussels +units=m +no_defs",
    "srid": 21500,
    "auth_name": "EPSG",
    "auth_id": "21500",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1918,
    "description": "Bern 1898 (Bern) / LV03C",
    "projection_acronym": "somerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=somerc +lat_0=46.9524055555556 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +pm=bern +units=m +no_defs",
    "srid": 21780,
    "auth_name": "EPSG",
    "auth_id": "21780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1919,
    "description": "CH1903 / LV03",
    "projection_acronym": "somerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=somerc +lat_0=46.9524055555556 +lon_0=7.43958333333333 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs",
    "srid": 21781,
    "auth_name": "EPSG",
    "auth_id": "21781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1921,
    "description": "Bogota 1975 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=18 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs",
    "srid": 21818,
    "auth_name": "EPSG",
    "auth_id": "21818",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1926,
    "description": "Bogota 1975 / Colombia West zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-77.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs",
    "srid": 21896,
    "auth_name": "EPSG",
    "auth_id": "21896",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1927,
    "description": "Bogota 1975 / Colombia Bogota zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-74.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs",
    "srid": 21897,
    "auth_name": "EPSG",
    "auth_id": "21897",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1928,
    "description": "Bogota 1975 / Colombia East Central zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-71.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +towgs84=307,304,-318,0,0,0,0 +units=m +no_defs",
    "srid": 21898,
    "auth_name": "EPSG",
    "auth_id": "21898",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1929,
    "description": "Bogota 1975 / Colombia East zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-68.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +units=m +no_defs",
    "srid": 21899,
    "auth_name": "EPSG",
    "auth_id": "21899",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1930,
    "description": "Camacupa 1948 / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=32 +south +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 22032,
    "auth_name": "EPSG",
    "auth_id": "22032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1931,
    "description": "Camacupa 1948 / UTM zone 33S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=33 +south +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 22033,
    "auth_name": "EPSG",
    "auth_id": "22033",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1932,
    "description": "Camacupa 1948 / TM 11.30 SE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=0.9996 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +towgs84=-50.9,-347.6,-231,0,0,0,0 +units=m +no_defs",
    "srid": 22091,
    "auth_name": "EPSG",
    "auth_id": "22091",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1933,
    "description": "Camacupa 1948 / TM 12 SE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 22092,
    "auth_name": "EPSG",
    "auth_id": "22092",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1934,
    "description": "POSGAR 98 / Argentina 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22171,
    "auth_name": "EPSG",
    "auth_id": "22171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1935,
    "description": "POSGAR 98 / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22172,
    "auth_name": "EPSG",
    "auth_id": "22172",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1936,
    "description": "POSGAR 98 / Argentina 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22173,
    "auth_name": "EPSG",
    "auth_id": "22173",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1937,
    "description": "POSGAR 98 / Argentina 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22174,
    "auth_name": "EPSG",
    "auth_id": "22174",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1938,
    "description": "POSGAR 98 / Argentina 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22175,
    "auth_name": "EPSG",
    "auth_id": "22175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1939,
    "description": "POSGAR 98 / Argentina 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22176,
    "auth_name": "EPSG",
    "auth_id": "22176",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1940,
    "description": "POSGAR 98 / Argentina 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22177,
    "auth_name": "EPSG",
    "auth_id": "22177",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1941,
    "description": "POSGAR 94 / Argentina 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22181,
    "auth_name": "EPSG",
    "auth_id": "22181",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1942,
    "description": "POSGAR 94 / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22182,
    "auth_name": "EPSG",
    "auth_id": "22182",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1943,
    "description": "POSGAR 94 / Argentina 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22183,
    "auth_name": "EPSG",
    "auth_id": "22183",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1944,
    "description": "POSGAR 94 / Argentina 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22184,
    "auth_name": "EPSG",
    "auth_id": "22184",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1945,
    "description": "POSGAR 94 / Argentina 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22185,
    "auth_name": "EPSG",
    "auth_id": "22185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1946,
    "description": "POSGAR 94 / Argentina 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22186,
    "auth_name": "EPSG",
    "auth_id": "22186",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1947,
    "description": "POSGAR 94 / Argentina 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 22187,
    "auth_name": "EPSG",
    "auth_id": "22187",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1948,
    "description": "Campo Inchauspe / Argentina 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs",
    "srid": 22191,
    "auth_name": "EPSG",
    "auth_id": "22191",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1949,
    "description": "Campo Inchauspe / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs",
    "srid": 22192,
    "auth_name": "EPSG",
    "auth_id": "22192",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1950,
    "description": "Campo Inchauspe / Argentina 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs",
    "srid": 22193,
    "auth_name": "EPSG",
    "auth_id": "22193",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1951,
    "description": "Campo Inchauspe / Argentina 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs",
    "srid": 22194,
    "auth_name": "EPSG",
    "auth_id": "22194",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1952,
    "description": "Campo Inchauspe / Argentina 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs",
    "srid": 22195,
    "auth_name": "EPSG",
    "auth_id": "22195",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1953,
    "description": "Campo Inchauspe / Argentina 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs",
    "srid": 22196,
    "auth_name": "EPSG",
    "auth_id": "22196",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1954,
    "description": "Campo Inchauspe / Argentina 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=intl +towgs84=-148,136,90,0,0,0,0 +units=m +no_defs",
    "srid": 22197,
    "auth_name": "EPSG",
    "auth_id": "22197",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1955,
    "description": "Cape / UTM zone 34S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=34 +south +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22234,
    "auth_name": "EPSG",
    "auth_id": "22234",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1956,
    "description": "Cape / UTM zone 35S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=35 +south +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22235,
    "auth_name": "EPSG",
    "auth_id": "22235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1958,
    "description": "Carthage / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=32 +ellps=clrk80ign +towgs84=-260.1,5.5,432.2,0,0,0,0 +units=m +no_defs",
    "srid": 22332,
    "auth_name": "EPSG",
    "auth_id": "22332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1959,
    "description": "Carthage / Nord Tunisie",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=9.9 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs",
    "srid": 22391,
    "auth_name": "EPSG",
    "auth_id": "22391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1960,
    "description": "Carthage / Sud Tunisie",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=9.9 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +towgs84=-263,6,431,0,0,0,0 +units=m +no_defs",
    "srid": 22392,
    "auth_name": "EPSG",
    "auth_id": "22392",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1961,
    "description": "Corrego Alegre 1970-72 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs",
    "srid": 22521,
    "auth_name": "EPSG",
    "auth_id": "22521",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1962,
    "description": "Corrego Alegre 1970-72 / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +south +ellps=intl +units=m +no_defs",
    "srid": 22522,
    "auth_name": "EPSG",
    "auth_id": "22522",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1963,
    "description": "Corrego Alegre 1970-72 / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=23 +south +ellps=intl +units=m +no_defs",
    "srid": 22523,
    "auth_name": "EPSG",
    "auth_id": "22523",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1964,
    "description": "Corrego Alegre 1970-72 / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=24 +south +ellps=intl +units=m +no_defs",
    "srid": 22524,
    "auth_name": "EPSG",
    "auth_id": "22524",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1965,
    "description": "Corrego Alegre 1970-72 / UTM zone 25S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=25 +south +ellps=intl +units=m +no_defs",
    "srid": 22525,
    "auth_name": "EPSG",
    "auth_id": "22525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1966,
    "description": "Deir ez Zor / Levant Zone",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 22700,
    "auth_name": "EPSG",
    "auth_id": "22700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1967,
    "description": "Deir ez Zor / Syria Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=34.65 +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs",
    "srid": 22770,
    "auth_name": "EPSG",
    "auth_id": "22770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1968,
    "description": "Deir ez Zor / Levant Stereographic",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=sterea +lat_0=34.2 +lon_0=39.15 +k=0.9995341 +x_0=0 +y_0=0 +ellps=clrk80ign +units=m +no_defs",
    "srid": 22780,
    "auth_name": "EPSG",
    "auth_id": "22780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1970,
    "description": "Egypt 1907 / Blue Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=35 +k=1 +x_0=300000 +y_0=1100000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs",
    "srid": 22991,
    "auth_name": "EPSG",
    "auth_id": "22991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1971,
    "description": "Egypt 1907 / Red Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=31 +k=1 +x_0=615000 +y_0=810000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs",
    "srid": 22992,
    "auth_name": "EPSG",
    "auth_id": "22992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1972,
    "description": "Egypt 1907 / Purple Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=27 +k=1 +x_0=700000 +y_0=200000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs",
    "srid": 22993,
    "auth_name": "EPSG",
    "auth_id": "22993",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1973,
    "description": "Egypt 1907 / Extended Purple Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=27 +k=1 +x_0=700000 +y_0=1200000 +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +units=m +no_defs",
    "srid": 22994,
    "auth_name": "EPSG",
    "auth_id": "22994",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1974,
    "description": "ED50 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=28 +ellps=intl +towgs84=-89.5,-93.8,-123.1,0,0,-0.156,1.2 +units=m +no_defs",
    "srid": 23028,
    "auth_name": "EPSG",
    "auth_id": "23028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1975,
    "description": "ED50 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=29 +ellps=intl +units=m +no_defs",
    "srid": 23029,
    "auth_name": "EPSG",
    "auth_id": "23029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1976,
    "description": "ED50 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=30 +ellps=intl +units=m +no_defs",
    "srid": 23030,
    "auth_name": "EPSG",
    "auth_id": "23030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1977,
    "description": "ED50 / UTM zone 31N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=31 +ellps=intl +units=m +no_defs",
    "srid": 23031,
    "auth_name": "EPSG",
    "auth_id": "23031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1978,
    "description": "ED50 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +ellps=intl +units=m +no_defs",
    "srid": 23032,
    "auth_name": "EPSG",
    "auth_id": "23032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1979,
    "description": "ED50 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=33 +ellps=intl +units=m +no_defs",
    "srid": 23033,
    "auth_name": "EPSG",
    "auth_id": "23033",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1980,
    "description": "ED50 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=34 +ellps=intl +units=m +no_defs",
    "srid": 23034,
    "auth_name": "EPSG",
    "auth_id": "23034",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1981,
    "description": "ED50 / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=35 +ellps=intl +units=m +no_defs",
    "srid": 23035,
    "auth_name": "EPSG",
    "auth_id": "23035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1982,
    "description": "ED50 / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=36 +ellps=intl +units=m +no_defs",
    "srid": 23036,
    "auth_name": "EPSG",
    "auth_id": "23036",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1983,
    "description": "ED50 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=37 +ellps=intl +units=m +no_defs",
    "srid": 23037,
    "auth_name": "EPSG",
    "auth_id": "23037",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1984,
    "description": "ED50 / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +ellps=intl +towgs84=-84.1,-101.8,-129.7,0,0,0.468,1.05 +units=m +no_defs",
    "srid": 23038,
    "auth_name": "EPSG",
    "auth_id": "23038",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1985,
    "description": "ED50 / TM 0 N",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 23090,
    "auth_name": "EPSG",
    "auth_id": "23090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1986,
    "description": "ED50 / TM 5 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=5 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-83.11,-97.38,-117.22,0.00569290865241986,-0.0446975835137458,0.0442850539012516,0.1218 +units=m +no_defs",
    "srid": 23095,
    "auth_name": "EPSG",
    "auth_id": "23095",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1987,
    "description": "Fahud / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 23239,
    "auth_name": "EPSG",
    "auth_id": "23239",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1988,
    "description": "Fahud / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=40 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 23240,
    "auth_name": "EPSG",
    "auth_id": "23240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1990,
    "description": "HD72 / EOV",
    "projection_acronym": "somerc",
    "ellipsoid_acronym": "GRS67",
    "parameters": "+proj=somerc +lat_0=47.1443937222222 +lon_0=19.0485717777778 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +units=m +no_defs",
    "srid": 23700,
    "auth_name": "EPSG",
    "auth_id": "23700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1991,
    "description": "DGN95 / Indonesia TM-3 zone 46.2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=94.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23830,
    "auth_name": "EPSG",
    "auth_id": "23830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1992,
    "description": "DGN95 / Indonesia TM-3 zone 47.1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=97.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23831,
    "auth_name": "EPSG",
    "auth_id": "23831",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1993,
    "description": "DGN95 / Indonesia TM-3 zone 47.2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=100.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23832,
    "auth_name": "EPSG",
    "auth_id": "23832",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1994,
    "description": "DGN95 / Indonesia TM-3 zone 48.1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=103.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23833,
    "auth_name": "EPSG",
    "auth_id": "23833",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1995,
    "description": "DGN95 / Indonesia TM-3 zone 48.2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23834,
    "auth_name": "EPSG",
    "auth_id": "23834",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1996,
    "description": "DGN95 / Indonesia TM-3 zone 49.1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=109.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23835,
    "auth_name": "EPSG",
    "auth_id": "23835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1997,
    "description": "DGN95 / Indonesia TM-3 zone 49.2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=112.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23836,
    "auth_name": "EPSG",
    "auth_id": "23836",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1998,
    "description": "DGN95 / Indonesia TM-3 zone 50.1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23837,
    "auth_name": "EPSG",
    "auth_id": "23837",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 1999,
    "description": "DGN95 / Indonesia TM-3 zone 50.2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=118.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23838,
    "auth_name": "EPSG",
    "auth_id": "23838",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2000,
    "description": "DGN95 / Indonesia TM-3 zone 51.1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=121.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23839,
    "auth_name": "EPSG",
    "auth_id": "23839",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2001,
    "description": "DGN95 / Indonesia TM-3 zone 51.2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=124.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23840,
    "auth_name": "EPSG",
    "auth_id": "23840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2002,
    "description": "DGN95 / Indonesia TM-3 zone 52.1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=127.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23841,
    "auth_name": "EPSG",
    "auth_id": "23841",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2003,
    "description": "DGN95 / Indonesia TM-3 zone 52.2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=130.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23842,
    "auth_name": "EPSG",
    "auth_id": "23842",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2004,
    "description": "DGN95 / Indonesia TM-3 zone 53.1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=133.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23843,
    "auth_name": "EPSG",
    "auth_id": "23843",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2005,
    "description": "DGN95 / Indonesia TM-3 zone 53.2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=136.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23844,
    "auth_name": "EPSG",
    "auth_id": "23844",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2006,
    "description": "DGN95 / Indonesia TM-3 zone 54.1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=139.5 +k=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23845,
    "auth_name": "EPSG",
    "auth_id": "23845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2007,
    "description": "ID74 / UTM zone 46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=46 +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23846,
    "auth_name": "EPSG",
    "auth_id": "23846",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2008,
    "description": "ID74 / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=47 +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23847,
    "auth_name": "EPSG",
    "auth_id": "23847",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2009,
    "description": "ID74 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=48 +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23848,
    "auth_name": "EPSG",
    "auth_id": "23848",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2010,
    "description": "ID74 / UTM zone 49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=49 +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23849,
    "auth_name": "EPSG",
    "auth_id": "23849",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2011,
    "description": "ID74 / UTM zone 50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=50 +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23850,
    "auth_name": "EPSG",
    "auth_id": "23850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2012,
    "description": "ID74 / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=51 +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23851,
    "auth_name": "EPSG",
    "auth_id": "23851",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2013,
    "description": "ID74 / UTM zone 52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=52 +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23852,
    "auth_name": "EPSG",
    "auth_id": "23852",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2015,
    "description": "DGN95 / UTM zone 46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=46 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23866,
    "auth_name": "EPSG",
    "auth_id": "23866",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2016,
    "description": "DGN95 / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=47 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23867,
    "auth_name": "EPSG",
    "auth_id": "23867",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2017,
    "description": "DGN95 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=48 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23868,
    "auth_name": "EPSG",
    "auth_id": "23868",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2018,
    "description": "DGN95 / UTM zone 49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=49 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23869,
    "auth_name": "EPSG",
    "auth_id": "23869",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2019,
    "description": "DGN95 / UTM zone 50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=50 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23870,
    "auth_name": "EPSG",
    "auth_id": "23870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2020,
    "description": "DGN95 / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=51 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23871,
    "auth_name": "EPSG",
    "auth_id": "23871",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2021,
    "description": "DGN95 / UTM zone 52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=52 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23872,
    "auth_name": "EPSG",
    "auth_id": "23872",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2022,
    "description": "DGN95 / UTM zone 47S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=47 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23877,
    "auth_name": "EPSG",
    "auth_id": "23877",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2023,
    "description": "DGN95 / UTM zone 48S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=48 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23878,
    "auth_name": "EPSG",
    "auth_id": "23878",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2024,
    "description": "DGN95 / UTM zone 49S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=49 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23879,
    "auth_name": "EPSG",
    "auth_id": "23879",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2025,
    "description": "DGN95 / UTM zone 50S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=50 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23880,
    "auth_name": "EPSG",
    "auth_id": "23880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2026,
    "description": "DGN95 / UTM zone 51S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=51 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23881,
    "auth_name": "EPSG",
    "auth_id": "23881",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2027,
    "description": "DGN95 / UTM zone 52S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=52 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23882,
    "auth_name": "EPSG",
    "auth_id": "23882",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2028,
    "description": "DGN95 / UTM zone 53S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=53 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23883,
    "auth_name": "EPSG",
    "auth_id": "23883",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2029,
    "description": "DGN95 / UTM zone 54S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=54 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 23884,
    "auth_name": "EPSG",
    "auth_id": "23884",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2031,
    "description": "ID74 / UTM zone 47S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=47 +south +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23887,
    "auth_name": "EPSG",
    "auth_id": "23887",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2032,
    "description": "ID74 / UTM zone 48S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=48 +south +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23888,
    "auth_name": "EPSG",
    "auth_id": "23888",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2033,
    "description": "ID74 / UTM zone 49S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=49 +south +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23889,
    "auth_name": "EPSG",
    "auth_id": "23889",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2034,
    "description": "ID74 / UTM zone 50S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=50 +south +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23890,
    "auth_name": "EPSG",
    "auth_id": "23890",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2035,
    "description": "ID74 / UTM zone 51S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=51 +south +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23891,
    "auth_name": "EPSG",
    "auth_id": "23891",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2036,
    "description": "ID74 / UTM zone 52S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=52 +south +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23892,
    "auth_name": "EPSG",
    "auth_id": "23892",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2037,
    "description": "ID74 / UTM zone 53S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=53 +south +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23893,
    "auth_name": "EPSG",
    "auth_id": "23893",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2038,
    "description": "ID74 / UTM zone 54S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=54 +south +a=6378160 +rf=298.247 +units=m +no_defs",
    "srid": 23894,
    "auth_name": "EPSG",
    "auth_id": "23894",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2039,
    "description": "Indian 1954 / UTM zone 46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=utm +zone=46 +ellps=evrst30 +units=m +no_defs",
    "srid": 23946,
    "auth_name": "EPSG",
    "auth_id": "23946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2040,
    "description": "Indian 1954 / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=utm +zone=47 +ellps=evrst30 +units=m +no_defs",
    "srid": 23947,
    "auth_name": "EPSG",
    "auth_id": "23947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2041,
    "description": "Indian 1954 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=utm +zone=48 +ellps=evrst30 +towgs84=217,823,299,0,0,0,0 +units=m +no_defs",
    "srid": 23948,
    "auth_name": "EPSG",
    "auth_id": "23948",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2042,
    "description": "Indian 1975 / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=utm +zone=47 +ellps=evrst30 +units=m +no_defs",
    "srid": 24047,
    "auth_name": "EPSG",
    "auth_id": "24047",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2043,
    "description": "Indian 1975 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=utm +zone=48 +ellps=evrst30 +units=m +no_defs",
    "srid": 24048,
    "auth_name": "EPSG",
    "auth_id": "24048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2044,
    "description": "Jamaica 1875 / Jamaica (Old Grid)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=167638.49597 +y_0=121918.90616 +a=6378249.14480801 +b=6356514.96620413 +to_meter=0.3047972654 +no_defs",
    "srid": 24100,
    "auth_name": "EPSG",
    "auth_id": "24100",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2045,
    "description": "JAD69 / Jamaica National Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=18 +lat_0=18 +lon_0=-77 +k_0=1 +x_0=250000 +y_0=150000 +ellps=clrk66 +units=m +no_defs",
    "srid": 24200,
    "auth_name": "EPSG",
    "auth_id": "24200",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2046,
    "description": "Kalianpur 1937 / UTM zone 45N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=utm +zone=45 +ellps=evrst30 +towgs84=282,726,254,0,0,0,0 +units=m +no_defs",
    "srid": 24305,
    "auth_name": "EPSG",
    "auth_id": "24305",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2047,
    "description": "Kalianpur 1937 / UTM zone 46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=utm +zone=46 +ellps=evrst30 +towgs84=282,726,254,0,0,0,0 +units=m +no_defs",
    "srid": 24306,
    "auth_name": "EPSG",
    "auth_id": "24306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2048,
    "description": "Kalianpur 1962 / UTM zone 41N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=41 +a=6377301.243 +rf=300.8017255 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs",
    "srid": 24311,
    "auth_name": "EPSG",
    "auth_id": "24311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2049,
    "description": "Kalianpur 1962 / UTM zone 42N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=42 +a=6377301.243 +rf=300.8017255 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs",
    "srid": 24312,
    "auth_name": "EPSG",
    "auth_id": "24312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2050,
    "description": "Kalianpur 1962 / UTM zone 43N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=43 +a=6377301.243 +rf=300.8017255 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs",
    "srid": 24313,
    "auth_name": "EPSG",
    "auth_id": "24313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2051,
    "description": "Kalianpur 1975 / UTM zone 42N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=42 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24342,
    "auth_name": "EPSG",
    "auth_id": "24342",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2052,
    "description": "Kalianpur 1975 / UTM zone 43N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=43 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24343,
    "auth_name": "EPSG",
    "auth_id": "24343",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2053,
    "description": "Kalianpur 1975 / UTM zone 44N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=44 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24344,
    "auth_name": "EPSG",
    "auth_id": "24344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2054,
    "description": "Kalianpur 1975 / UTM zone 45N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=45 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24345,
    "auth_name": "EPSG",
    "auth_id": "24345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2055,
    "description": "Kalianpur 1975 / UTM zone 46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=46 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24346,
    "auth_name": "EPSG",
    "auth_id": "24346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2056,
    "description": "Kalianpur 1975 / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=47 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24347,
    "auth_name": "EPSG",
    "auth_id": "24347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2057,
    "description": "Kalianpur 1880 / India zone 0",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=39.5 +lat_0=39.5 +lon_0=68 +k_0=0.99846154 +x_0=2153865.73916853 +y_0=2368292.1946281 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs",
    "srid": 24370,
    "auth_name": "EPSG",
    "auth_id": "24370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2058,
    "description": "Kalianpur 1880 / India zone I",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs",
    "srid": 24371,
    "auth_name": "EPSG",
    "auth_id": "24371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2059,
    "description": "Kalianpur 1880 / India zone IIa",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs",
    "srid": 24372,
    "auth_name": "EPSG",
    "auth_id": "24372",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2060,
    "description": "Kalianpur 1880 / India zone IIIa",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=19 +lat_0=19 +lon_0=80 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs",
    "srid": 24373,
    "auth_name": "EPSG",
    "auth_id": "24373",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2061,
    "description": "Kalianpur 1880 / India zone IVa",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=12 +lat_0=12 +lon_0=80 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs",
    "srid": 24374,
    "auth_name": "EPSG",
    "auth_id": "24374",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2062,
    "description": "Kalianpur 1937 / India zone IIb",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743185.69 +y_0=914395.23 +ellps=evrst30 +towgs84=282,726,254,0,0,0,0 +units=m +no_defs",
    "srid": 24375,
    "auth_name": "EPSG",
    "auth_id": "24375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2063,
    "description": "Kalianpur 1962 / India zone I",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +a=6377301.243 +rf=300.8017255 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs",
    "srid": 24376,
    "auth_name": "EPSG",
    "auth_id": "24376",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2064,
    "description": "Kalianpur 1962 / India zone IIa",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +a=6377301.243 +rf=300.8017255 +towgs84=283,682,231,0,0,0,0 +units=m +no_defs",
    "srid": 24377,
    "auth_name": "EPSG",
    "auth_id": "24377",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2065,
    "description": "Kalianpur 1975 / India zone I",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24378,
    "auth_name": "EPSG",
    "auth_id": "24378",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2066,
    "description": "Kalianpur 1975 / India zone IIa",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=74 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24379,
    "auth_name": "EPSG",
    "auth_id": "24379",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2067,
    "description": "Kalianpur 1975 / India zone IIb",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24380,
    "auth_name": "EPSG",
    "auth_id": "24380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2068,
    "description": "Kalianpur 1975 / India zone IIIa",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=19 +lat_0=19 +lon_0=80 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24381,
    "auth_name": "EPSG",
    "auth_id": "24381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2069,
    "description": "Kalianpur 1880 / India zone IIb",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=26 +lat_0=26 +lon_0=90 +k_0=0.99878641 +x_0=2743195.59223332 +y_0=914398.530744441 +a=6377299.36559538 +b=6356098.35900516 +to_meter=0.914398530744441 +no_defs",
    "srid": 24382,
    "auth_name": "EPSG",
    "auth_id": "24382",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2070,
    "description": "Kalianpur 1975 / India zone IVa",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=12 +lat_0=12 +lon_0=80 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +units=m +no_defs",
    "srid": 24383,
    "auth_name": "EPSG",
    "auth_id": "24383",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2071,
    "description": "Kertau 1968 / Singapore Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=1.28764666666667 +lon_0=103.853002222222 +x_0=30000 +y_0=30000 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 24500,
    "auth_name": "EPSG",
    "auth_id": "24500",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2072,
    "description": "Kertau 1968 / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=utm +zone=47 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 24547,
    "auth_name": "EPSG",
    "auth_id": "24547",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2073,
    "description": "Kertau 1968 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=utm +zone=48 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 24548,
    "auth_name": "EPSG",
    "auth_id": "24548",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2075,
    "description": "KOC Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=32.5 +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200 +a=6378249.145 +rf=293.465 +towgs84=-294.7,-200.1,525.5,0,0,0,0 +units=m +no_defs",
    "srid": 24600,
    "auth_name": "EPSG",
    "auth_id": "24600",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2076,
    "description": "La Canoa / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=18 +ellps=intl +units=m +no_defs",
    "srid": 24718,
    "auth_name": "EPSG",
    "auth_id": "24718",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2077,
    "description": "La Canoa / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=19 +ellps=intl +units=m +no_defs",
    "srid": 24719,
    "auth_name": "EPSG",
    "auth_id": "24719",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2078,
    "description": "La Canoa / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 24720,
    "auth_name": "EPSG",
    "auth_id": "24720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2079,
    "description": "PSAD56 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=17 +ellps=intl +units=m +no_defs",
    "srid": 24817,
    "auth_name": "EPSG",
    "auth_id": "24817",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2080,
    "description": "PSAD56 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=18 +ellps=intl +units=m +no_defs",
    "srid": 24818,
    "auth_name": "EPSG",
    "auth_id": "24818",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2081,
    "description": "PSAD56 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=19 +ellps=intl +units=m +no_defs",
    "srid": 24819,
    "auth_name": "EPSG",
    "auth_id": "24819",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2082,
    "description": "PSAD56 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 24820,
    "auth_name": "EPSG",
    "auth_id": "24820",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2083,
    "description": "PSAD56 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +ellps=intl +units=m +no_defs",
    "srid": 24821,
    "auth_name": "EPSG",
    "auth_id": "24821",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2084,
    "description": "PSAD56 / UTM zone 17S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=17 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs",
    "srid": 24877,
    "auth_name": "EPSG",
    "auth_id": "24877",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2085,
    "description": "PSAD56 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=18 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs",
    "srid": 24878,
    "auth_name": "EPSG",
    "auth_id": "24878",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2086,
    "description": "PSAD56 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=19 +south +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs",
    "srid": 24879,
    "auth_name": "EPSG",
    "auth_id": "24879",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2087,
    "description": "PSAD56 / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +south +ellps=intl +units=m +no_defs",
    "srid": 24880,
    "auth_name": "EPSG",
    "auth_id": "24880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2088,
    "description": "PSAD56 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs",
    "srid": 24881,
    "auth_name": "EPSG",
    "auth_id": "24881",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2089,
    "description": "PSAD56 / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +south +ellps=intl +towgs84=-291.87,106.37,-364.52,0,0,0,0 +units=m +no_defs",
    "srid": 24882,
    "auth_name": "EPSG",
    "auth_id": "24882",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2090,
    "description": "PSAD56 / Peru west zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-6 +lon_0=-80.5 +k=0.99983008 +x_0=222000 +y_0=1426834.743 +ellps=intl +units=m +no_defs",
    "srid": 24891,
    "auth_name": "EPSG",
    "auth_id": "24891",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2091,
    "description": "PSAD56 / Peru central zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-9.5 +lon_0=-76 +k=0.99932994 +x_0=720000 +y_0=1039979.159 +ellps=intl +units=m +no_defs",
    "srid": 24892,
    "auth_name": "EPSG",
    "auth_id": "24892",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2092,
    "description": "PSAD56 / Peru east zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-9.5 +lon_0=-70.5 +k=0.99952992 +x_0=1324000 +y_0=1040084.558 +ellps=intl +towgs84=-288,175,-376,0,0,0,0 +units=m +no_defs",
    "srid": 24893,
    "auth_name": "EPSG",
    "auth_id": "24893",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2093,
    "description": "Leigon / Ghana Metre Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=4.66666666666667 +lon_0=-1 +k=0.99975 +x_0=274319.51 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=-130,29,364,0,0,0,0 +units=m +no_defs",
    "srid": 25000,
    "auth_name": "EPSG",
    "auth_id": "25000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2094,
    "description": "Lome / UTM zone 31N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=31 +ellps=clrk80ign +units=m +no_defs",
    "srid": 25231,
    "auth_name": "EPSG",
    "auth_id": "25231",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2095,
    "description": "Luzon 1911 / Philippines zone I",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs",
    "srid": 25391,
    "auth_name": "EPSG",
    "auth_id": "25391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2096,
    "description": "Luzon 1911 / Philippines zone II",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +towgs84=-133,-77,-51,0,0,0,0 +units=m +no_defs",
    "srid": 25392,
    "auth_name": "EPSG",
    "auth_id": "25392",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2097,
    "description": "Luzon 1911 / Philippines zone III",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 25393,
    "auth_name": "EPSG",
    "auth_id": "25393",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2098,
    "description": "Luzon 1911 / Philippines zone IV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 25394,
    "auth_name": "EPSG",
    "auth_id": "25394",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2099,
    "description": "Luzon 1911 / Philippines zone V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=125 +k=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +units=m +no_defs",
    "srid": 25395,
    "auth_name": "EPSG",
    "auth_id": "25395",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2101,
    "description": "ETRS89 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25828,
    "auth_name": "EPSG",
    "auth_id": "25828",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2102,
    "description": "ETRS89 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25829,
    "auth_name": "EPSG",
    "auth_id": "25829",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2103,
    "description": "ETRS89 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25830,
    "auth_name": "EPSG",
    "auth_id": "25830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2104,
    "description": "ETRS89 / UTM zone 31N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25831,
    "auth_name": "EPSG",
    "auth_id": "25831",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2105,
    "description": "ETRS89 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25832,
    "auth_name": "EPSG",
    "auth_id": "25832",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2106,
    "description": "ETRS89 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25833,
    "auth_name": "EPSG",
    "auth_id": "25833",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2107,
    "description": "ETRS89 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25834,
    "auth_name": "EPSG",
    "auth_id": "25834",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2108,
    "description": "ETRS89 / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25835,
    "auth_name": "EPSG",
    "auth_id": "25835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2109,
    "description": "ETRS89 / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25836,
    "auth_name": "EPSG",
    "auth_id": "25836",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2110,
    "description": "ETRS89 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25837,
    "auth_name": "EPSG",
    "auth_id": "25837",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2112,
    "description": "ETRS89 / TM Baltic93",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 25884,
    "auth_name": "EPSG",
    "auth_id": "25884",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2113,
    "description": "Malongo 1987 / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +south +ellps=intl +towgs84=-254.1,-5.36,-100.29,0,0,0,0 +units=m +no_defs",
    "srid": 25932,
    "auth_name": "EPSG",
    "auth_id": "25932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2114,
    "description": "Merchich / Nord Maroc",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=-5.4 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +towgs84=31,146,47,0,0,0,0 +units=m +no_defs",
    "srid": 26191,
    "auth_name": "EPSG",
    "auth_id": "26191",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2115,
    "description": "Merchich / Sud Maroc",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=29.7 +lat_0=29.7 +lon_0=-5.4 +k_0=0.999615596 +x_0=500000 +y_0=300000 +ellps=clrk80ign +towgs84=31,146,47,0,0,0,0 +units=m +no_defs",
    "srid": 26192,
    "auth_name": "EPSG",
    "auth_id": "26192",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2117,
    "description": "Merchich / Sahara Nord",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=26.1 +lat_0=26.1 +lon_0=-5.4 +k_0=0.999616304 +x_0=1200000 +y_0=400000 +ellps=clrk80ign +units=m +no_defs",
    "srid": 26194,
    "auth_name": "EPSG",
    "auth_id": "26194",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2118,
    "description": "Merchich / Sahara Sud",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=22.5 +lat_0=22.5 +lon_0=-5.4 +k_0=0.999616437 +x_0=1500000 +y_0=400000 +ellps=clrk80ign +units=m +no_defs",
    "srid": 26195,
    "auth_name": "EPSG",
    "auth_id": "26195",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2119,
    "description": "Massawa / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=37 +ellps=bessel +towgs84=639,405,60,0,0,0,0 +units=m +no_defs",
    "srid": 26237,
    "auth_name": "EPSG",
    "auth_id": "26237",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2120,
    "description": "Minna / UTM zone 31N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=31 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 26331,
    "auth_name": "EPSG",
    "auth_id": "26331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2121,
    "description": "Minna / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=32 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 26332,
    "auth_name": "EPSG",
    "auth_id": "26332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2122,
    "description": "Minna / Nigeria West Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=4 +lon_0=4.5 +k=0.99975 +x_0=230738.26 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs",
    "srid": 26391,
    "auth_name": "EPSG",
    "auth_id": "26391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2123,
    "description": "Minna / Nigeria Mid Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=4 +lon_0=8.5 +k=0.99975 +x_0=670553.98 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs",
    "srid": 26392,
    "auth_name": "EPSG",
    "auth_id": "26392",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2124,
    "description": "Minna / Nigeria East Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=4 +lon_0=12.5 +k=0.99975 +x_0=1110369.7 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=-92,-93,122,0,0,0,0 +units=m +no_defs",
    "srid": 26393,
    "auth_name": "EPSG",
    "auth_id": "26393",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2128,
    "description": "M'poraloko / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=32 +ellps=clrk80ign +units=m +no_defs",
    "srid": 26632,
    "auth_name": "EPSG",
    "auth_id": "26632",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2129,
    "description": "M'poraloko / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=32 +south +ellps=clrk80ign +units=m +no_defs",
    "srid": 26692,
    "auth_name": "EPSG",
    "auth_id": "26692",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2130,
    "description": "NAD27 / UTM zone 1N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=1 +datum=NAD27 +units=m +no_defs",
    "srid": 26701,
    "auth_name": "EPSG",
    "auth_id": "26701",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2131,
    "description": "NAD27 / UTM zone 2N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=2 +datum=NAD27 +units=m +no_defs",
    "srid": 26702,
    "auth_name": "EPSG",
    "auth_id": "26702",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2132,
    "description": "NAD27 / UTM zone 3N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=3 +datum=NAD27 +units=m +no_defs",
    "srid": 26703,
    "auth_name": "EPSG",
    "auth_id": "26703",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2133,
    "description": "NAD27 / UTM zone 4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=4 +datum=NAD27 +units=m +no_defs",
    "srid": 26704,
    "auth_name": "EPSG",
    "auth_id": "26704",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2134,
    "description": "NAD27 / UTM zone 5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=5 +datum=NAD27 +units=m +no_defs",
    "srid": 26705,
    "auth_name": "EPSG",
    "auth_id": "26705",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2135,
    "description": "NAD27 / UTM zone 6N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=6 +datum=NAD27 +units=m +no_defs",
    "srid": 26706,
    "auth_name": "EPSG",
    "auth_id": "26706",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2136,
    "description": "NAD27 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=7 +datum=NAD27 +units=m +no_defs",
    "srid": 26707,
    "auth_name": "EPSG",
    "auth_id": "26707",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2137,
    "description": "NAD27 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=8 +ellps=clrk66 +towgs84=-10,158,187,0,0,0,0 +units=m +no_defs",
    "srid": 26708,
    "auth_name": "EPSG",
    "auth_id": "26708",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2138,
    "description": "NAD27 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=9 +datum=NAD27 +units=m +no_defs",
    "srid": 26709,
    "auth_name": "EPSG",
    "auth_id": "26709",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2139,
    "description": "NAD27 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=10 +datum=NAD27 +units=m +no_defs",
    "srid": 26710,
    "auth_name": "EPSG",
    "auth_id": "26710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2140,
    "description": "NAD27 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=11 +datum=NAD27 +units=m +no_defs",
    "srid": 26711,
    "auth_name": "EPSG",
    "auth_id": "26711",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2141,
    "description": "NAD27 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=12 +datum=NAD27 +units=m +no_defs",
    "srid": 26712,
    "auth_name": "EPSG",
    "auth_id": "26712",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2142,
    "description": "NAD27 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=13 +datum=NAD27 +units=m +no_defs",
    "srid": 26713,
    "auth_name": "EPSG",
    "auth_id": "26713",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2143,
    "description": "NAD27 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=14 +datum=NAD27 +units=m +no_defs",
    "srid": 26714,
    "auth_name": "EPSG",
    "auth_id": "26714",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2144,
    "description": "NAD27 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=15 +datum=NAD27 +units=m +no_defs",
    "srid": 26715,
    "auth_name": "EPSG",
    "auth_id": "26715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2145,
    "description": "NAD27 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=16 +datum=NAD27 +units=m +no_defs",
    "srid": 26716,
    "auth_name": "EPSG",
    "auth_id": "26716",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2146,
    "description": "NAD27 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=17 +datum=NAD27 +units=m +no_defs",
    "srid": 26717,
    "auth_name": "EPSG",
    "auth_id": "26717",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2147,
    "description": "NAD27 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=18 +datum=NAD27 +units=m +no_defs",
    "srid": 26718,
    "auth_name": "EPSG",
    "auth_id": "26718",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2148,
    "description": "NAD27 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=19 +datum=NAD27 +units=m +no_defs",
    "srid": 26719,
    "auth_name": "EPSG",
    "auth_id": "26719",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2149,
    "description": "NAD27 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=utm +zone=20 +datum=NAD27 +units=m +no_defs",
    "srid": 26720,
    "auth_name": "EPSG",
    "auth_id": "26720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2150,
    "description": "NAD27 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=21 +ellps=clrk66 +towgs84=-10,158,187,0,0,0,0 +units=m +no_defs",
    "srid": 26721,
    "auth_name": "EPSG",
    "auth_id": "26721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2151,
    "description": "NAD27 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=22 +datum=NAD27 +units=m +no_defs",
    "srid": 26722,
    "auth_name": "EPSG",
    "auth_id": "26722",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2152,
    "description": "NAD27 / Alabama East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26729,
    "auth_name": "EPSG",
    "auth_id": "26729",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2153,
    "description": "NAD27 / Alabama West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26730,
    "auth_name": "EPSG",
    "auth_id": "26730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2154,
    "description": "NAD27 / Alaska zone 1",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000.001016 +y_0=-5000000.001016 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26731,
    "auth_name": "EPSG",
    "auth_id": "26731",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2155,
    "description": "NAD27 / Alaska zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=-5,135,172,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26732,
    "auth_name": "EPSG",
    "auth_id": "26732",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2156,
    "description": "NAD27 / Alaska zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=-5,135,172,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26733,
    "auth_name": "EPSG",
    "auth_id": "26733",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2157,
    "description": "NAD27 / Alaska zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=-5,135,172,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26734,
    "auth_name": "EPSG",
    "auth_id": "26734",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2158,
    "description": "NAD27 / Alaska zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=-5,135,172,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26735,
    "auth_name": "EPSG",
    "auth_id": "26735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2159,
    "description": "NAD27 / Alaska zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=-5,135,172,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26736,
    "auth_name": "EPSG",
    "auth_id": "26736",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2160,
    "description": "NAD27 / Alaska zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=213360.426720853 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26737,
    "auth_name": "EPSG",
    "auth_id": "26737",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2161,
    "description": "NAD27 / Alaska zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=-5,135,172,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26738,
    "auth_name": "EPSG",
    "auth_id": "26738",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2162,
    "description": "NAD27 / Alaska zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=182880.365760732 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26739,
    "auth_name": "EPSG",
    "auth_id": "26739",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2163,
    "description": "NAD27 / Alaska zone 10",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=914401.828803658 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26740,
    "auth_name": "EPSG",
    "auth_id": "26740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2164,
    "description": "NAD27 / California zone I",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26741,
    "auth_name": "EPSG",
    "auth_id": "26741",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2165,
    "description": "NAD27 / California zone II",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26742,
    "auth_name": "EPSG",
    "auth_id": "26742",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2166,
    "description": "NAD27 / California zone III",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26743,
    "auth_name": "EPSG",
    "auth_id": "26743",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2167,
    "description": "NAD27 / California zone IV",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26744,
    "auth_name": "EPSG",
    "auth_id": "26744",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2168,
    "description": "NAD27 / California zone V",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26745,
    "auth_name": "EPSG",
    "auth_id": "26745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2169,
    "description": "NAD27 / California zone VI",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26746,
    "auth_name": "EPSG",
    "auth_id": "26746",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2171,
    "description": "NAD27 / Arizona East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26748,
    "auth_name": "EPSG",
    "auth_id": "26748",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2172,
    "description": "NAD27 / Arizona Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26749,
    "auth_name": "EPSG",
    "auth_id": "26749",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2173,
    "description": "NAD27 / Arizona West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26750,
    "auth_name": "EPSG",
    "auth_id": "26750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2174,
    "description": "NAD27 / Arkansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26751,
    "auth_name": "EPSG",
    "auth_id": "26751",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2175,
    "description": "NAD27 / Arkansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26752,
    "auth_name": "EPSG",
    "auth_id": "26752",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2176,
    "description": "NAD27 / Colorado North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=39.7166666666667 +lat_2=40.7833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26753,
    "auth_name": "EPSG",
    "auth_id": "26753",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2177,
    "description": "NAD27 / Colorado Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26754,
    "auth_name": "EPSG",
    "auth_id": "26754",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2178,
    "description": "NAD27 / Colorado South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26755,
    "auth_name": "EPSG",
    "auth_id": "26755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2179,
    "description": "NAD27 / Connecticut",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=182880.365760732 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26756,
    "auth_name": "EPSG",
    "auth_id": "26756",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2180,
    "description": "NAD27 / Delaware",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26757,
    "auth_name": "EPSG",
    "auth_id": "26757",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2181,
    "description": "NAD27 / Florida East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26758,
    "auth_name": "EPSG",
    "auth_id": "26758",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2182,
    "description": "NAD27 / Florida West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26759,
    "auth_name": "EPSG",
    "auth_id": "26759",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2183,
    "description": "NAD27 / Florida North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26760,
    "auth_name": "EPSG",
    "auth_id": "26760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2184,
    "description": "NAD27 / Georgia East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26766,
    "auth_name": "EPSG",
    "auth_id": "26766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2185,
    "description": "NAD27 / Georgia West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26767,
    "auth_name": "EPSG",
    "auth_id": "26767",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2186,
    "description": "NAD27 / Idaho East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26768,
    "auth_name": "EPSG",
    "auth_id": "26768",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2187,
    "description": "NAD27 / Idaho Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26769,
    "auth_name": "EPSG",
    "auth_id": "26769",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2188,
    "description": "NAD27 / Idaho West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26770,
    "auth_name": "EPSG",
    "auth_id": "26770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2189,
    "description": "NAD27 / Illinois East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26771,
    "auth_name": "EPSG",
    "auth_id": "26771",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2190,
    "description": "NAD27 / Illinois West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26772,
    "auth_name": "EPSG",
    "auth_id": "26772",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2191,
    "description": "NAD27 / Indiana East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26773,
    "auth_name": "EPSG",
    "auth_id": "26773",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2192,
    "description": "NAD27 / Indiana West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26774,
    "auth_name": "EPSG",
    "auth_id": "26774",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2193,
    "description": "NAD27 / Iowa North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26775,
    "auth_name": "EPSG",
    "auth_id": "26775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2194,
    "description": "NAD27 / Iowa South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26776,
    "auth_name": "EPSG",
    "auth_id": "26776",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2195,
    "description": "NAD27 / Kansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26777,
    "auth_name": "EPSG",
    "auth_id": "26777",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2196,
    "description": "NAD27 / Kansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26778,
    "auth_name": "EPSG",
    "auth_id": "26778",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2197,
    "description": "NAD27 / Kentucky North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26779,
    "auth_name": "EPSG",
    "auth_id": "26779",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2198,
    "description": "NAD27 / Kentucky South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=36.7333333333333 +lat_2=37.9333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26780,
    "auth_name": "EPSG",
    "auth_id": "26780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2199,
    "description": "NAD27 / Louisiana North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=30.6666666666667 +lon_0=-92.5 +lat_1=31.1666666666667 +lat_2=32.6666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26781,
    "auth_name": "EPSG",
    "auth_id": "26781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2200,
    "description": "NAD27 / Louisiana South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=28.6666666666667 +lon_0=-91.3333333333333 +lat_1=29.3 +lat_2=30.7 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26782,
    "auth_name": "EPSG",
    "auth_id": "26782",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2201,
    "description": "NAD27 / Maine East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-68.5 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26783,
    "auth_name": "EPSG",
    "auth_id": "26783",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2202,
    "description": "NAD27 / Maine West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26784,
    "auth_name": "EPSG",
    "auth_id": "26784",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2203,
    "description": "NAD27 / Maryland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-77 +lat_1=38.3 +lat_2=39.45 +x_0=243840.487680975 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26785,
    "auth_name": "EPSG",
    "auth_id": "26785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2204,
    "description": "NAD27 / Massachusetts Mainland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=41.7166666666667 +lat_2=42.6833333333333 +x_0=182880.365760732 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26786,
    "auth_name": "EPSG",
    "auth_id": "26786",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2205,
    "description": "NAD27 / Massachusetts Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.2833333333333 +lat_2=41.4833333333333 +x_0=60960.1219202439 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26787,
    "auth_name": "EPSG",
    "auth_id": "26787",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2206,
    "description": "NAD27 / Minnesota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=47.0333333333333 +lat_2=48.6333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26791,
    "auth_name": "EPSG",
    "auth_id": "26791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2207,
    "description": "NAD27 / Minnesota Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=45.6166666666667 +lat_2=47.05 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26792,
    "auth_name": "EPSG",
    "auth_id": "26792",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2208,
    "description": "NAD27 / Minnesota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=43.7833333333333 +lat_2=45.2166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26793,
    "auth_name": "EPSG",
    "auth_id": "26793",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2209,
    "description": "NAD27 / Mississippi East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=29.6666666666667 +lon_0=-88.8333333333333 +k=0.99996 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26794,
    "auth_name": "EPSG",
    "auth_id": "26794",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2210,
    "description": "NAD27 / Mississippi West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-90.3333333333333 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26795,
    "auth_name": "EPSG",
    "auth_id": "26795",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2211,
    "description": "NAD27 / Missouri East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26796,
    "auth_name": "EPSG",
    "auth_id": "26796",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2212,
    "description": "NAD27 / Missouri Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26797,
    "auth_name": "EPSG",
    "auth_id": "26797",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2213,
    "description": "NAD27 / Missouri West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26798,
    "auth_name": "EPSG",
    "auth_id": "26798",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2214,
    "description": "NAD27 / California zone VII",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=34.1333333333333 +lon_0=-118.333333333333 +lat_1=34.4166666666667 +lat_2=33.8666666666667 +x_0=1276106.4505969 +y_0=1268253.00685801 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 26799,
    "auth_name": "EPSG",
    "auth_id": "26799",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2245,
    "description": "NAD83 / Maine East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26847,
    "auth_name": "EPSG",
    "auth_id": "26847",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2246,
    "description": "NAD83 / Maine West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26848,
    "auth_name": "EPSG",
    "auth_id": "26848",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2247,
    "description": "NAD83 / Minnesota North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26849,
    "auth_name": "EPSG",
    "auth_id": "26849",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2248,
    "description": "NAD83 / Minnesota Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26850,
    "auth_name": "EPSG",
    "auth_id": "26850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2249,
    "description": "NAD83 / Minnesota South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26851,
    "auth_name": "EPSG",
    "auth_id": "26851",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2250,
    "description": "NAD83 / Nebraska (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 26852,
    "auth_name": "EPSG",
    "auth_id": "26852",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2251,
    "description": "NAD83 / West Virginia North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26853,
    "auth_name": "EPSG",
    "auth_id": "26853",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2252,
    "description": "NAD83 / West Virginia South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26854,
    "auth_name": "EPSG",
    "auth_id": "26854",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2253,
    "description": "NAD83(HARN) / Maine East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 26855,
    "auth_name": "EPSG",
    "auth_id": "26855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2254,
    "description": "NAD83(HARN) / Maine West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 26856,
    "auth_name": "EPSG",
    "auth_id": "26856",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2255,
    "description": "NAD83(HARN) / Minnesota North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 26857,
    "auth_name": "EPSG",
    "auth_id": "26857",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2256,
    "description": "NAD83(HARN) / Minnesota Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 26858,
    "auth_name": "EPSG",
    "auth_id": "26858",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2257,
    "description": "NAD83(HARN) / Minnesota South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 26859,
    "auth_name": "EPSG",
    "auth_id": "26859",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2258,
    "description": "NAD83(HARN) / Nebraska (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 26860,
    "auth_name": "EPSG",
    "auth_id": "26860",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2259,
    "description": "NAD83(HARN) / West Virginia North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 26861,
    "auth_name": "EPSG",
    "auth_id": "26861",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2260,
    "description": "NAD83(HARN) / West Virginia South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 26862,
    "auth_name": "EPSG",
    "auth_id": "26862",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2261,
    "description": "NAD83(NSRS2007) / Maine East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26863,
    "auth_name": "EPSG",
    "auth_id": "26863",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2262,
    "description": "NAD83(NSRS2007) / Maine West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26864,
    "auth_name": "EPSG",
    "auth_id": "26864",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2263,
    "description": "NAD83(NSRS2007) / Minnesota North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26865,
    "auth_name": "EPSG",
    "auth_id": "26865",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2264,
    "description": "NAD83(NSRS2007) / Minnesota Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26866,
    "auth_name": "EPSG",
    "auth_id": "26866",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2265,
    "description": "NAD83(NSRS2007) / Minnesota South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26867,
    "auth_name": "EPSG",
    "auth_id": "26867",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2266,
    "description": "NAD83(NSRS2007) / Nebraska (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26868,
    "auth_name": "EPSG",
    "auth_id": "26868",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2267,
    "description": "NAD83(NSRS2007) / West Virginia North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26869,
    "auth_name": "EPSG",
    "auth_id": "26869",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2268,
    "description": "NAD83(NSRS2007) / West Virginia South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 26870,
    "auth_name": "EPSG",
    "auth_id": "26870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2269,
    "description": "NAD83(CSRS) / MTM zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 26891,
    "auth_name": "EPSG",
    "auth_id": "26891",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2270,
    "description": "NAD83(CSRS) / MTM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 26892,
    "auth_name": "EPSG",
    "auth_id": "26892",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2271,
    "description": "NAD83(CSRS) / MTM zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 26893,
    "auth_name": "EPSG",
    "auth_id": "26893",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2272,
    "description": "NAD83(CSRS) / MTM zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 26894,
    "auth_name": "EPSG",
    "auth_id": "26894",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2273,
    "description": "NAD83(CSRS) / MTM zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 26895,
    "auth_name": "EPSG",
    "auth_id": "26895",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2274,
    "description": "NAD83(CSRS) / MTM zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 26896,
    "auth_name": "EPSG",
    "auth_id": "26896",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2275,
    "description": "NAD83(CSRS) / MTM zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 26897,
    "auth_name": "EPSG",
    "auth_id": "26897",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2276,
    "description": "NAD83(CSRS) / MTM zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 26898,
    "auth_name": "EPSG",
    "auth_id": "26898",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2277,
    "description": "NAD83(CSRS) / MTM zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 26899,
    "auth_name": "EPSG",
    "auth_id": "26899",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2278,
    "description": "NAD83 / UTM zone 1N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=utm +zone=1 +datum=NAD83 +units=m +no_defs",
    "srid": 26901,
    "auth_name": "EPSG",
    "auth_id": "26901",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2279,
    "description": "NAD83 / UTM zone 2N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=utm +zone=2 +datum=NAD83 +units=m +no_defs",
    "srid": 26902,
    "auth_name": "EPSG",
    "auth_id": "26902",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2280,
    "description": "NAD83 / UTM zone 3N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=3 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26903,
    "auth_name": "EPSG",
    "auth_id": "26903",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2281,
    "description": "NAD83 / UTM zone 4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=utm +zone=4 +datum=NAD83 +units=m +no_defs",
    "srid": 26904,
    "auth_name": "EPSG",
    "auth_id": "26904",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2282,
    "description": "NAD83 / UTM zone 5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=utm +zone=5 +datum=NAD83 +units=m +no_defs",
    "srid": 26905,
    "auth_name": "EPSG",
    "auth_id": "26905",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2283,
    "description": "NAD83 / UTM zone 6N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=6 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26906,
    "auth_name": "EPSG",
    "auth_id": "26906",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2284,
    "description": "NAD83 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26907,
    "auth_name": "EPSG",
    "auth_id": "26907",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2285,
    "description": "NAD83 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26908,
    "auth_name": "EPSG",
    "auth_id": "26908",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2286,
    "description": "NAD83 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26909,
    "auth_name": "EPSG",
    "auth_id": "26909",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2287,
    "description": "NAD83 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26910,
    "auth_name": "EPSG",
    "auth_id": "26910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2288,
    "description": "NAD83 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26911,
    "auth_name": "EPSG",
    "auth_id": "26911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2289,
    "description": "NAD83 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26912,
    "auth_name": "EPSG",
    "auth_id": "26912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2290,
    "description": "NAD83 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26913,
    "auth_name": "EPSG",
    "auth_id": "26913",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2291,
    "description": "NAD83 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26914,
    "auth_name": "EPSG",
    "auth_id": "26914",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2292,
    "description": "NAD83 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26915,
    "auth_name": "EPSG",
    "auth_id": "26915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2293,
    "description": "NAD83 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26916,
    "auth_name": "EPSG",
    "auth_id": "26916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2294,
    "description": "NAD83 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26917,
    "auth_name": "EPSG",
    "auth_id": "26917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2295,
    "description": "NAD83 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26918,
    "auth_name": "EPSG",
    "auth_id": "26918",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2296,
    "description": "NAD83 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=utm +zone=19 +datum=NAD83 +units=m +no_defs",
    "srid": 26919,
    "auth_name": "EPSG",
    "auth_id": "26919",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2297,
    "description": "NAD83 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=utm +zone=20 +datum=NAD83 +units=m +no_defs",
    "srid": 26920,
    "auth_name": "EPSG",
    "auth_id": "26920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2298,
    "description": "NAD83 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26921,
    "auth_name": "EPSG",
    "auth_id": "26921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2299,
    "description": "NAD83 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26922,
    "auth_name": "EPSG",
    "auth_id": "26922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2300,
    "description": "NAD83 / UTM zone 23N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=23 +datum=NAD83 +units=m +no_defs",
    "srid": 26923,
    "auth_name": "EPSG",
    "auth_id": "26923",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2301,
    "description": "NAD83 / Alabama East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26929,
    "auth_name": "EPSG",
    "auth_id": "26929",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2302,
    "description": "NAD83 / Alabama West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26930,
    "auth_name": "EPSG",
    "auth_id": "26930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2303,
    "description": "NAD83 / Alaska zone 1",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26931,
    "auth_name": "EPSG",
    "auth_id": "26931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2304,
    "description": "NAD83 / Alaska zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26932,
    "auth_name": "EPSG",
    "auth_id": "26932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2305,
    "description": "NAD83 / Alaska zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26933,
    "auth_name": "EPSG",
    "auth_id": "26933",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2306,
    "description": "NAD83 / Alaska zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26934,
    "auth_name": "EPSG",
    "auth_id": "26934",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2307,
    "description": "NAD83 / Alaska zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26935,
    "auth_name": "EPSG",
    "auth_id": "26935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2308,
    "description": "NAD83 / Alaska zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26936,
    "auth_name": "EPSG",
    "auth_id": "26936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2309,
    "description": "NAD83 / Alaska zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26937,
    "auth_name": "EPSG",
    "auth_id": "26937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2310,
    "description": "NAD83 / Alaska zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26938,
    "auth_name": "EPSG",
    "auth_id": "26938",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2311,
    "description": "NAD83 / Alaska zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 26939,
    "auth_name": "EPSG",
    "auth_id": "26939",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2312,
    "description": "NAD83 / Alaska zone 10",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=-2,0,4,0,0,0,0 +units=m +no_defs",
    "srid": 26940,
    "auth_name": "EPSG",
    "auth_id": "26940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2313,
    "description": "NAD83 / California zone 1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26941,
    "auth_name": "EPSG",
    "auth_id": "26941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2314,
    "description": "NAD83 / California zone 2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26942,
    "auth_name": "EPSG",
    "auth_id": "26942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2315,
    "description": "NAD83 / California zone 3",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26943,
    "auth_name": "EPSG",
    "auth_id": "26943",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2316,
    "description": "NAD83 / California zone 4",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26944,
    "auth_name": "EPSG",
    "auth_id": "26944",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2317,
    "description": "NAD83 / California zone 5",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26945,
    "auth_name": "EPSG",
    "auth_id": "26945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2318,
    "description": "NAD83 / California zone 6",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26946,
    "auth_name": "EPSG",
    "auth_id": "26946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2319,
    "description": "NAD83 / Arizona East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26948,
    "auth_name": "EPSG",
    "auth_id": "26948",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2320,
    "description": "NAD83 / Arizona Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26949,
    "auth_name": "EPSG",
    "auth_id": "26949",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2321,
    "description": "NAD83 / Arizona West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26950,
    "auth_name": "EPSG",
    "auth_id": "26950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2322,
    "description": "NAD83 / Arkansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26951,
    "auth_name": "EPSG",
    "auth_id": "26951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2323,
    "description": "NAD83 / Arkansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26952,
    "auth_name": "EPSG",
    "auth_id": "26952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2324,
    "description": "NAD83 / Colorado North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26953,
    "auth_name": "EPSG",
    "auth_id": "26953",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2325,
    "description": "NAD83 / Colorado Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26954,
    "auth_name": "EPSG",
    "auth_id": "26954",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2326,
    "description": "NAD83 / Colorado South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26955,
    "auth_name": "EPSG",
    "auth_id": "26955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2327,
    "description": "NAD83 / Connecticut",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26956,
    "auth_name": "EPSG",
    "auth_id": "26956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2328,
    "description": "NAD83 / Delaware",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26957,
    "auth_name": "EPSG",
    "auth_id": "26957",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2329,
    "description": "NAD83 / Florida East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26958,
    "auth_name": "EPSG",
    "auth_id": "26958",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2330,
    "description": "NAD83 / Florida West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26959,
    "auth_name": "EPSG",
    "auth_id": "26959",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2331,
    "description": "NAD83 / Florida North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26960,
    "auth_name": "EPSG",
    "auth_id": "26960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2332,
    "description": "NAD83 / Hawaii zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=1,1,-1,0,0,0,0 +units=m +no_defs",
    "srid": 26961,
    "auth_name": "EPSG",
    "auth_id": "26961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2333,
    "description": "NAD83 / Hawaii zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=1,1,-1,0,0,0,0 +units=m +no_defs",
    "srid": 26962,
    "auth_name": "EPSG",
    "auth_id": "26962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2334,
    "description": "NAD83 / Hawaii zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=1,1,-1,0,0,0,0 +units=m +no_defs",
    "srid": 26963,
    "auth_name": "EPSG",
    "auth_id": "26963",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2335,
    "description": "NAD83 / Hawaii zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=1,1,-1,0,0,0,0 +units=m +no_defs",
    "srid": 26964,
    "auth_name": "EPSG",
    "auth_id": "26964",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2336,
    "description": "NAD83 / Hawaii zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=1,1,-1,0,0,0,0 +units=m +no_defs",
    "srid": 26965,
    "auth_name": "EPSG",
    "auth_id": "26965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2337,
    "description": "NAD83 / Georgia East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26966,
    "auth_name": "EPSG",
    "auth_id": "26966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2338,
    "description": "NAD83 / Georgia West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26967,
    "auth_name": "EPSG",
    "auth_id": "26967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2339,
    "description": "NAD83 / Idaho East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26968,
    "auth_name": "EPSG",
    "auth_id": "26968",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2340,
    "description": "NAD83 / Idaho Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26969,
    "auth_name": "EPSG",
    "auth_id": "26969",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2341,
    "description": "NAD83 / Idaho West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26970,
    "auth_name": "EPSG",
    "auth_id": "26970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2342,
    "description": "NAD83 / Illinois East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26971,
    "auth_name": "EPSG",
    "auth_id": "26971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2343,
    "description": "NAD83 / Illinois West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26972,
    "auth_name": "EPSG",
    "auth_id": "26972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2344,
    "description": "NAD83 / Indiana East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26973,
    "auth_name": "EPSG",
    "auth_id": "26973",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2345,
    "description": "NAD83 / Indiana West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26974,
    "auth_name": "EPSG",
    "auth_id": "26974",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2346,
    "description": "NAD83 / Iowa North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26975,
    "auth_name": "EPSG",
    "auth_id": "26975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2347,
    "description": "NAD83 / Iowa South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26976,
    "auth_name": "EPSG",
    "auth_id": "26976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2348,
    "description": "NAD83 / Kansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26977,
    "auth_name": "EPSG",
    "auth_id": "26977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2349,
    "description": "NAD83 / Kansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26978,
    "auth_name": "EPSG",
    "auth_id": "26978",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2351,
    "description": "NAD83 / Kentucky South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26980,
    "auth_name": "EPSG",
    "auth_id": "26980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2352,
    "description": "NAD83 / Louisiana North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26981,
    "auth_name": "EPSG",
    "auth_id": "26981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2353,
    "description": "NAD83 / Louisiana South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26982,
    "auth_name": "EPSG",
    "auth_id": "26982",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2354,
    "description": "NAD83 / Maine East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26983,
    "auth_name": "EPSG",
    "auth_id": "26983",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2355,
    "description": "NAD83 / Maine West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26984,
    "auth_name": "EPSG",
    "auth_id": "26984",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2356,
    "description": "NAD83 / Maryland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26985,
    "auth_name": "EPSG",
    "auth_id": "26985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2357,
    "description": "NAD83 / Massachusetts Mainland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26986,
    "auth_name": "EPSG",
    "auth_id": "26986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2358,
    "description": "NAD83 / Massachusetts Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26987,
    "auth_name": "EPSG",
    "auth_id": "26987",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2359,
    "description": "NAD83 / Michigan North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26988,
    "auth_name": "EPSG",
    "auth_id": "26988",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2360,
    "description": "NAD83 / Michigan Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26989,
    "auth_name": "EPSG",
    "auth_id": "26989",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2361,
    "description": "NAD83 / Michigan South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26990,
    "auth_name": "EPSG",
    "auth_id": "26990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2362,
    "description": "NAD83 / Minnesota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26991,
    "auth_name": "EPSG",
    "auth_id": "26991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2363,
    "description": "NAD83 / Minnesota Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26992,
    "auth_name": "EPSG",
    "auth_id": "26992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2364,
    "description": "NAD83 / Minnesota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26993,
    "auth_name": "EPSG",
    "auth_id": "26993",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2365,
    "description": "NAD83 / Mississippi East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26994,
    "auth_name": "EPSG",
    "auth_id": "26994",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2366,
    "description": "NAD83 / Mississippi West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26995,
    "auth_name": "EPSG",
    "auth_id": "26995",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2367,
    "description": "NAD83 / Missouri East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26996,
    "auth_name": "EPSG",
    "auth_id": "26996",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2368,
    "description": "NAD83 / Missouri Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26997,
    "auth_name": "EPSG",
    "auth_id": "26997",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2369,
    "description": "NAD83 / Missouri West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 26998,
    "auth_name": "EPSG",
    "auth_id": "26998",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2372,
    "description": "Nahrwan 1967 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 27039,
    "auth_name": "EPSG",
    "auth_id": "27039",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2373,
    "description": "Nahrwan 1967 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=40 +a=6378249.145 +rf=293.465 +towgs84=-249,-156,381,0,0,0,0 +units=m +no_defs",
    "srid": 27040,
    "auth_name": "EPSG",
    "auth_id": "27040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2374,
    "description": "Naparima 1972 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 27120,
    "auth_name": "EPSG",
    "auth_id": "27120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2375,
    "description": "NZGD49 / New Zealand Map Grid",
    "projection_acronym": "nzmg",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=nzmg +lat_0=-41 +lon_0=173 +x_0=2510000 +y_0=6023150 +ellps=intl +units=m +no_defs",
    "srid": 27200,
    "auth_name": "EPSG",
    "auth_id": "27200",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2376,
    "description": "NZGD49 / Mount Eden Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-36.8798652777778 +lon_0=174.764339361111 +k=0.9999 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27205,
    "auth_name": "EPSG",
    "auth_id": "27205",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2377,
    "description": "NZGD49 / Bay of Plenty Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-37.7612498055556 +lon_0=176.46619725 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27206,
    "auth_name": "EPSG",
    "auth_id": "27206",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2378,
    "description": "NZGD49 / Poverty Bay Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-38.6247027777778 +lon_0=177.885636277778 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27207,
    "auth_name": "EPSG",
    "auth_id": "27207",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2379,
    "description": "NZGD49 / Hawkes Bay Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-39.6509293055556 +lon_0=176.673680527778 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27208,
    "auth_name": "EPSG",
    "auth_id": "27208",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2380,
    "description": "NZGD49 / Taranaki Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-39.1357583055556 +lon_0=174.22801175 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27209,
    "auth_name": "EPSG",
    "auth_id": "27209",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2381,
    "description": "NZGD49 / Tuhirangi Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-39.5124703888889 +lon_0=175.640036805556 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27210,
    "auth_name": "EPSG",
    "auth_id": "27210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2382,
    "description": "NZGD49 / Wanganui Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-40.2419471388889 +lon_0=175.488099611111 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27211,
    "auth_name": "EPSG",
    "auth_id": "27211",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2383,
    "description": "NZGD49 / Wairarapa Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-40.9255326388889 +lon_0=175.647349666667 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27212,
    "auth_name": "EPSG",
    "auth_id": "27212",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2384,
    "description": "NZGD49 / Wellington Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-41.3013196388889 +lon_0=174.776623111111 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27213,
    "auth_name": "EPSG",
    "auth_id": "27213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2385,
    "description": "NZGD49 / Collingwood Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-40.7147590555556 +lon_0=172.6720465 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27214,
    "auth_name": "EPSG",
    "auth_id": "27214",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2386,
    "description": "NZGD49 / Nelson Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-41.2745447222222 +lon_0=173.299316805556 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27215,
    "auth_name": "EPSG",
    "auth_id": "27215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2387,
    "description": "NZGD49 / Karamea Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-41.2899115277778 +lon_0=172.109028194444 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27216,
    "auth_name": "EPSG",
    "auth_id": "27216",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2388,
    "description": "NZGD49 / Buller Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-41.8108028611111 +lon_0=171.581260055556 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27217,
    "auth_name": "EPSG",
    "auth_id": "27217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2389,
    "description": "NZGD49 / Grey Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-42.3336942777778 +lon_0=171.549771305556 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27218,
    "auth_name": "EPSG",
    "auth_id": "27218",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2390,
    "description": "NZGD49 / Amuri Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-42.6891165833333 +lon_0=173.010133388889 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27219,
    "auth_name": "EPSG",
    "auth_id": "27219",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2391,
    "description": "NZGD49 / Marlborough Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-41.5444866666667 +lon_0=173.802074111111 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27220,
    "auth_name": "EPSG",
    "auth_id": "27220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2392,
    "description": "NZGD49 / Hokitika Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-42.8863223611111 +lon_0=170.9799935 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27221,
    "auth_name": "EPSG",
    "auth_id": "27221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2393,
    "description": "NZGD49 / Okarito Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-43.1101281388889 +lon_0=170.260925833333 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27222,
    "auth_name": "EPSG",
    "auth_id": "27222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2394,
    "description": "NZGD49 / Jacksons Bay Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-43.9778028888889 +lon_0=168.606267 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27223,
    "auth_name": "EPSG",
    "auth_id": "27223",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2395,
    "description": "NZGD49 / Mount Pleasant Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-43.5906375833333 +lon_0=172.727193583333 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27224,
    "auth_name": "EPSG",
    "auth_id": "27224",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2396,
    "description": "NZGD49 / Gawler Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-43.7487115555556 +lon_0=171.360748472222 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27225,
    "auth_name": "EPSG",
    "auth_id": "27225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2397,
    "description": "NZGD49 / Timaru Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-44.4022203611111 +lon_0=171.057250833333 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27226,
    "auth_name": "EPSG",
    "auth_id": "27226",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2398,
    "description": "NZGD49 / Lindis Peak Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-44.7352679722222 +lon_0=169.467755083333 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27227,
    "auth_name": "EPSG",
    "auth_id": "27227",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2399,
    "description": "NZGD49 / Mount Nicholas Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-45.1329025833333 +lon_0=168.398641194444 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27228,
    "auth_name": "EPSG",
    "auth_id": "27228",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2400,
    "description": "NZGD49 / Mount York Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-45.5637261666667 +lon_0=167.738861777778 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27229,
    "auth_name": "EPSG",
    "auth_id": "27229",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2401,
    "description": "NZGD49 / Observation Point Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-45.8161966111111 +lon_0=170.628595166667 +k=1 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27230,
    "auth_name": "EPSG",
    "auth_id": "27230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2402,
    "description": "NZGD49 / North Taieri Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-45.8615133611111 +lon_0=170.282589111111 +k=0.99996 +x_0=300000 +y_0=700000 +ellps=intl +units=m +no_defs",
    "srid": 27231,
    "auth_name": "EPSG",
    "auth_id": "27231",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2403,
    "description": "NZGD49 / Bluff Circuit",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-46.6000096111111 +lon_0=168.342872 +k=1 +x_0=300002.66 +y_0=699999.58 +ellps=intl +units=m +no_defs",
    "srid": 27232,
    "auth_name": "EPSG",
    "auth_id": "27232",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2404,
    "description": "NZGD49 / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs",
    "srid": 27258,
    "auth_name": "EPSG",
    "auth_id": "27258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2405,
    "description": "NZGD49 / UTM zone 59S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=59 +south +ellps=intl +units=m +no_defs",
    "srid": 27259,
    "auth_name": "EPSG",
    "auth_id": "27259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2406,
    "description": "NZGD49 / UTM zone 60S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=60 +south +ellps=intl +units=m +no_defs",
    "srid": 27260,
    "auth_name": "EPSG",
    "auth_id": "27260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2407,
    "description": "NZGD49 / North Island Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-39 +lon_0=175.5 +k=1 +x_0=274319.524384809 +y_0=365759.365846411 +ellps=intl +to_meter=0.914398414616029 +no_defs",
    "srid": 27291,
    "auth_name": "EPSG",
    "auth_id": "27291",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2408,
    "description": "NZGD49 / South Island Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-44 +lon_0=171.5 +k=1 +x_0=457199.207308014 +y_0=457199.207308014 +ellps=intl +to_meter=0.914398414616029 +no_defs",
    "srid": 27292,
    "auth_name": "EPSG",
    "auth_id": "27292",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2409,
    "description": "NGO 1948 (Oslo) / NGO zone I",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=-4.66666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 27391,
    "auth_name": "EPSG",
    "auth_id": "27391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2410,
    "description": "NGO 1948 (Oslo) / NGO zone II",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=-2.33333333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 27392,
    "auth_name": "EPSG",
    "auth_id": "27392",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2411,
    "description": "NGO 1948 (Oslo) / NGO zone III",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 27393,
    "auth_name": "EPSG",
    "auth_id": "27393",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2412,
    "description": "NGO 1948 (Oslo) / NGO zone IV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=2.5 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 27394,
    "auth_name": "EPSG",
    "auth_id": "27394",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2413,
    "description": "NGO 1948 (Oslo) / NGO zone V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=6.16666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 27395,
    "auth_name": "EPSG",
    "auth_id": "27395",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2414,
    "description": "NGO 1948 (Oslo) / NGO zone VI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=10.1666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 27396,
    "auth_name": "EPSG",
    "auth_id": "27396",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2415,
    "description": "NGO 1948 (Oslo) / NGO zone VII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=14.1666666666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 27397,
    "auth_name": "EPSG",
    "auth_id": "27397",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2416,
    "description": "NGO 1948 (Oslo) / NGO zone VIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=18.3333333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 27398,
    "auth_name": "EPSG",
    "auth_id": "27398",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2417,
    "description": "Datum 73 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=29 +ellps=intl +units=m +no_defs",
    "srid": 27429,
    "auth_name": "EPSG",
    "auth_id": "27429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2419,
    "description": "Datum 73 / Modified Portuguese Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=180.598 +y_0=-86.99 +ellps=intl +units=m +no_defs",
    "srid": 27493,
    "auth_name": "EPSG",
    "auth_id": "27493",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2420,
    "description": "ATF (Paris) / Nord de Guerre",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=5.4 +k_0=0.99950908 +x_0=500000 +y_0=300000 +a=6376523 +rf=308.64 +pm=2.33720833333333 +units=m +no_defs",
    "srid": 27500,
    "auth_name": "EPSG",
    "auth_id": "27500",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2421,
    "description": "NTF (Paris) / Lambert Nord France",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 27561,
    "auth_name": "EPSG",
    "auth_id": "27561",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2422,
    "description": "NTF (Paris) / Lambert Centre France",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 27562,
    "auth_name": "EPSG",
    "auth_id": "27562",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2423,
    "description": "NTF (Paris) / Lambert Sud France",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 27563,
    "auth_name": "EPSG",
    "auth_id": "27563",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2424,
    "description": "NTF (Paris) / Lambert Corse",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 27564,
    "auth_name": "EPSG",
    "auth_id": "27564",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2425,
    "description": "NTF (Paris) / Lambert zone I",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 27571,
    "auth_name": "EPSG",
    "auth_id": "27571",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2426,
    "description": "NTF (Paris) / Lambert zone II",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 27572,
    "auth_name": "EPSG",
    "auth_id": "27572",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2427,
    "description": "NTF (Paris) / Lambert zone III",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 27573,
    "auth_name": "EPSG",
    "auth_id": "27573",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2428,
    "description": "NTF (Paris) / Lambert zone IV",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 27574,
    "auth_name": "EPSG",
    "auth_id": "27574",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2437,
    "description": "OSGB36 / British National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "airy",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +units=m +no_defs",
    "srid": 27700,
    "auth_name": "EPSG",
    "auth_id": "27700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2438,
    "description": "Palestine 1923 / Palestine Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=31.7340969444444 +lon_0=35.2120805555556 +x_0=170251.555 +y_0=126867.909 +a=6378300.789 +b=6356566.435 +units=m +no_defs",
    "srid": 28191,
    "auth_name": "EPSG",
    "auth_id": "28191",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2439,
    "description": "Palestine 1923 / Palestine Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=31.7340969444444 +lon_0=35.2120805555556 +k=1 +x_0=170251.555 +y_0=1126867.909 +a=6378300.789 +b=6356566.435 +units=m +no_defs",
    "srid": 28192,
    "auth_name": "EPSG",
    "auth_id": "28192",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2440,
    "description": "Palestine 1923 / Israeli CS Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=31.7340969444444 +lon_0=35.2120805555556 +x_0=170251.555 +y_0=1126867.909 +a=6378300.789 +b=6356566.435 +towgs84=-275.7224,94.7824,340.8944,-8.001,-4.42,-11.821,1 +units=m +no_defs",
    "srid": 28193,
    "auth_name": "EPSG",
    "auth_id": "28193",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2441,
    "description": "Pointe Noire / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=32 +south +ellps=clrk80ign +towgs84=-148,51,-291,0,0,0,0 +units=m +no_defs",
    "srid": 28232,
    "auth_name": "EPSG",
    "auth_id": "28232",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2442,
    "description": "GDA94 / MGA zone 48",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=48 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28348,
    "auth_name": "EPSG",
    "auth_id": "28348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2443,
    "description": "GDA94 / MGA zone 49",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=49 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28349,
    "auth_name": "EPSG",
    "auth_id": "28349",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2444,
    "description": "GDA94 / MGA zone 50",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=50 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28350,
    "auth_name": "EPSG",
    "auth_id": "28350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2445,
    "description": "GDA94 / MGA zone 51",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=51 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28351,
    "auth_name": "EPSG",
    "auth_id": "28351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2446,
    "description": "GDA94 / MGA zone 52",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=52 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28352,
    "auth_name": "EPSG",
    "auth_id": "28352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2447,
    "description": "GDA94 / MGA zone 53",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=53 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28353,
    "auth_name": "EPSG",
    "auth_id": "28353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2448,
    "description": "GDA94 / MGA zone 54",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=54 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28354,
    "auth_name": "EPSG",
    "auth_id": "28354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2449,
    "description": "GDA94 / MGA zone 55",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=55 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28355,
    "auth_name": "EPSG",
    "auth_id": "28355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2450,
    "description": "GDA94 / MGA zone 56",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=56 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28356,
    "auth_name": "EPSG",
    "auth_id": "28356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2451,
    "description": "GDA94 / MGA zone 57",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=57 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28357,
    "auth_name": "EPSG",
    "auth_id": "28357",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2452,
    "description": "GDA94 / MGA zone 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=58 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 28358,
    "auth_name": "EPSG",
    "auth_id": "28358",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2455,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 28404,
    "auth_name": "EPSG",
    "auth_id": "28404",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2456,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28405,
    "auth_name": "EPSG",
    "auth_id": "28405",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2457,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28406,
    "auth_name": "EPSG",
    "auth_id": "28406",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2458,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28407,
    "auth_name": "EPSG",
    "auth_id": "28407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2459,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 28408,
    "auth_name": "EPSG",
    "auth_id": "28408",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2460,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 28409,
    "auth_name": "EPSG",
    "auth_id": "28409",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2461,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 28410,
    "auth_name": "EPSG",
    "auth_id": "28410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2462,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 28411,
    "auth_name": "EPSG",
    "auth_id": "28411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2463,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 28412,
    "auth_name": "EPSG",
    "auth_id": "28412",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2464,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 28413,
    "auth_name": "EPSG",
    "auth_id": "28413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2465,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +units=m +no_defs",
    "srid": 28414,
    "auth_name": "EPSG",
    "auth_id": "28414",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2466,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28415,
    "auth_name": "EPSG",
    "auth_id": "28415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2467,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28416,
    "auth_name": "EPSG",
    "auth_id": "28416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2468,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28417,
    "auth_name": "EPSG",
    "auth_id": "28417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2469,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28418,
    "auth_name": "EPSG",
    "auth_id": "28418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2470,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28419,
    "auth_name": "EPSG",
    "auth_id": "28419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2471,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28420,
    "auth_name": "EPSG",
    "auth_id": "28420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2472,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28421,
    "auth_name": "EPSG",
    "auth_id": "28421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2473,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28422,
    "auth_name": "EPSG",
    "auth_id": "28422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2474,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28423,
    "auth_name": "EPSG",
    "auth_id": "28423",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2475,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28424,
    "auth_name": "EPSG",
    "auth_id": "28424",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2476,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28425,
    "auth_name": "EPSG",
    "auth_id": "28425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2477,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28426,
    "auth_name": "EPSG",
    "auth_id": "28426",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2478,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28427,
    "auth_name": "EPSG",
    "auth_id": "28427",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2479,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28428,
    "auth_name": "EPSG",
    "auth_id": "28428",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2480,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28429,
    "auth_name": "EPSG",
    "auth_id": "28429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2481,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28430,
    "auth_name": "EPSG",
    "auth_id": "28430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2482,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28431,
    "auth_name": "EPSG",
    "auth_id": "28431",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2483,
    "description": "Pulkovo 1942 / Gauss-Kruger zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 28432,
    "auth_name": "EPSG",
    "auth_id": "28432",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2515,
    "description": "Qatar 1974 / Qatar National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=24.45 +lon_0=51.2166666666667 +k=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +units=m +no_defs",
    "srid": 28600,
    "auth_name": "EPSG",
    "auth_id": "28600",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2516,
    "description": "Amersfoort / RD Old",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=sterea +lat_0=52.1561605555556 +lon_0=5.38763888888889 +k=0.9999079 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 28991,
    "auth_name": "EPSG",
    "auth_id": "28991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2517,
    "description": "Amersfoort / RD New",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=sterea +lat_0=52.1561605555556 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +no_defs",
    "srid": 28992,
    "auth_name": "EPSG",
    "auth_id": "28992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2519,
    "description": "SAD69 / Brazil Polyconic",
    "projection_acronym": "poly",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=aust_SA +units=m +no_defs",
    "srid": 29101,
    "auth_name": "EPSG",
    "auth_id": "29101",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2525,
    "description": "SAD69 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=18 +ellps=aust_SA +units=m +no_defs",
    "srid": 29168,
    "auth_name": "EPSG",
    "auth_id": "29168",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2526,
    "description": "SAD69 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=19 +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs",
    "srid": 29169,
    "auth_name": "EPSG",
    "auth_id": "29169",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2527,
    "description": "SAD69 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=20 +ellps=aust_SA +units=m +no_defs",
    "srid": 29170,
    "auth_name": "EPSG",
    "auth_id": "29170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2528,
    "description": "SAD69 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=21 +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs",
    "srid": 29171,
    "auth_name": "EPSG",
    "auth_id": "29171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2529,
    "description": "SAD69 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=22 +ellps=aust_SA +units=m +no_defs",
    "srid": 29172,
    "auth_name": "EPSG",
    "auth_id": "29172",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2539,
    "description": "SAD69 / UTM zone 17S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=17 +south +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs",
    "srid": 29187,
    "auth_name": "EPSG",
    "auth_id": "29187",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2540,
    "description": "SAD69 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=18 +south +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs",
    "srid": 29188,
    "auth_name": "EPSG",
    "auth_id": "29188",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2541,
    "description": "SAD69 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=19 +south +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs",
    "srid": 29189,
    "auth_name": "EPSG",
    "auth_id": "29189",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2542,
    "description": "SAD69 / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=20 +south +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs",
    "srid": 29190,
    "auth_name": "EPSG",
    "auth_id": "29190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2543,
    "description": "SAD69 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=21 +south +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs",
    "srid": 29191,
    "auth_name": "EPSG",
    "auth_id": "29191",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2544,
    "description": "SAD69 / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=22 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 29192,
    "auth_name": "EPSG",
    "auth_id": "29192",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2545,
    "description": "SAD69 / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=23 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 29193,
    "auth_name": "EPSG",
    "auth_id": "29193",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2546,
    "description": "SAD69 / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=24 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 29194,
    "auth_name": "EPSG",
    "auth_id": "29194",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2547,
    "description": "SAD69 / UTM zone 25S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=25 +south +ellps=aust_SA +units=m +no_defs",
    "srid": 29195,
    "auth_name": "EPSG",
    "auth_id": "29195",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2548,
    "description": "Sapper Hill 1943 / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +south +ellps=intl +units=m +no_defs",
    "srid": 29220,
    "auth_name": "EPSG",
    "auth_id": "29220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2549,
    "description": "Sapper Hill 1943 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs",
    "srid": 29221,
    "auth_name": "EPSG",
    "auth_id": "29221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2550,
    "description": "Schwarzeck / UTM zone 33S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=utm +zone=33 +south +ellps=bess_nam +units=m +no_defs",
    "srid": 29333,
    "auth_name": "EPSG",
    "auth_id": "29333",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2554,
    "description": "Tananarive (Paris) / Laborde Grid approximation",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=omerc +lat_0=-18.9 +lonc=44.1 +alpha=18.9 +gamma=18.9 +k=0.9995 +x_0=400000 +y_0=800000 +ellps=intl +pm=paris +units=m +no_defs",
    "srid": 29702,
    "auth_name": "EPSG",
    "auth_id": "29702",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2555,
    "description": "Tananarive / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs",
    "srid": 29738,
    "auth_name": "EPSG",
    "auth_id": "29738",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2556,
    "description": "Tananarive / UTM zone 39S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=39 +south +ellps=intl +units=m +no_defs",
    "srid": 29739,
    "auth_name": "EPSG",
    "auth_id": "29739",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2557,
    "description": "Timbalai 1948 / UTM zone 49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrstSS",
    "parameters": "+proj=utm +zone=49 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs",
    "srid": 29849,
    "auth_name": "EPSG",
    "auth_id": "29849",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2558,
    "description": "Timbalai 1948 / UTM zone 50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "evrstSS",
    "parameters": "+proj=utm +zone=50 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs",
    "srid": 29850,
    "auth_name": "EPSG",
    "auth_id": "29850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2559,
    "description": "Timbalai 1948 / RSO Borneo (ch)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "evrstSS",
    "parameters": "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.3158204722222 +gamma=53.1301023611111 +k=0.99984 +x_0=590476.87146304 +y_0=442857.653094361 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +to_meter=20.1167651215526 +no_defs",
    "srid": 29871,
    "auth_name": "EPSG",
    "auth_id": "29871",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2560,
    "description": "Timbalai 1948 / RSO Borneo (ftSe)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "evrstSS",
    "parameters": "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.3158204722222 +gamma=53.1301023611111 +k=0.99984 +x_0=590476.872743198 +y_0=442857.654557398 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +to_meter=0.304799471538676 +no_defs",
    "srid": 29872,
    "auth_name": "EPSG",
    "auth_id": "29872",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2561,
    "description": "Timbalai 1948 / RSO Borneo (m)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "evrstSS",
    "parameters": "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.3158204722222 +gamma=53.1301023611111 +k=0.99984 +x_0=590476.87 +y_0=442857.65 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs",
    "srid": 29873,
    "auth_name": "EPSG",
    "auth_id": "29873",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2563,
    "description": "OSNI 1952 / Irish National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "airy",
    "parameters": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1 +x_0=200000 +y_0=250000 +ellps=airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +units=m +no_defs",
    "srid": 29901,
    "auth_name": "EPSG",
    "auth_id": "29901",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2564,
    "description": "TM65 / Irish Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +a=6377340.189 +rf=299.3249646 +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +units=m +no_defs",
    "srid": 29902,
    "auth_name": "EPSG",
    "auth_id": "29902",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2565,
    "description": "TM75 / Irish Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=1.000035 +x_0=200000 +y_0=250000 +a=6377340.189 +rf=299.3249646 +units=m +no_defs",
    "srid": 29903,
    "auth_name": "EPSG",
    "auth_id": "29903",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2566,
    "description": "Tokyo / Japan Plane Rectangular CS I",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30161,
    "auth_name": "EPSG",
    "auth_id": "30161",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2567,
    "description": "Tokyo / Japan Plane Rectangular CS II",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30162,
    "auth_name": "EPSG",
    "auth_id": "30162",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2568,
    "description": "Tokyo / Japan Plane Rectangular CS III",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=132.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30163,
    "auth_name": "EPSG",
    "auth_id": "30163",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2569,
    "description": "Tokyo / Japan Plane Rectangular CS IV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30164,
    "auth_name": "EPSG",
    "auth_id": "30164",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2570,
    "description": "Tokyo / Japan Plane Rectangular CS V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=134.333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30165,
    "auth_name": "EPSG",
    "auth_id": "30165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2571,
    "description": "Tokyo / Japan Plane Rectangular CS VI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30166,
    "auth_name": "EPSG",
    "auth_id": "30166",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2572,
    "description": "Tokyo / Japan Plane Rectangular CS VII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=137.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30167,
    "auth_name": "EPSG",
    "auth_id": "30167",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2573,
    "description": "Tokyo / Japan Plane Rectangular CS VIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30168,
    "auth_name": "EPSG",
    "auth_id": "30168",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2574,
    "description": "Tokyo / Japan Plane Rectangular CS IX",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=139.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30169,
    "auth_name": "EPSG",
    "auth_id": "30169",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2575,
    "description": "Tokyo / Japan Plane Rectangular CS X",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=140.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30170,
    "auth_name": "EPSG",
    "auth_id": "30170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2576,
    "description": "Tokyo / Japan Plane Rectangular CS XI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30171,
    "auth_name": "EPSG",
    "auth_id": "30171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2577,
    "description": "Tokyo / Japan Plane Rectangular CS XII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30172,
    "auth_name": "EPSG",
    "auth_id": "30172",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2578,
    "description": "Tokyo / Japan Plane Rectangular CS XIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30173,
    "auth_name": "EPSG",
    "auth_id": "30173",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2579,
    "description": "Tokyo / Japan Plane Rectangular CS XIV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30174,
    "auth_name": "EPSG",
    "auth_id": "30174",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2580,
    "description": "Tokyo / Japan Plane Rectangular CS XV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30175,
    "auth_name": "EPSG",
    "auth_id": "30175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2581,
    "description": "Tokyo / Japan Plane Rectangular CS XVI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30176,
    "auth_name": "EPSG",
    "auth_id": "30176",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2582,
    "description": "Tokyo / Japan Plane Rectangular CS XVII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30177,
    "auth_name": "EPSG",
    "auth_id": "30177",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2583,
    "description": "Tokyo / Japan Plane Rectangular CS XVIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 30178,
    "auth_name": "EPSG",
    "auth_id": "30178",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2584,
    "description": "Tokyo / Japan Plane Rectangular CS XIX",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +units=m +no_defs",
    "srid": 30179,
    "auth_name": "EPSG",
    "auth_id": "30179",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2585,
    "description": "Trinidad 1903 / Trinidad Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=10.4416666666667 +lon_0=-61.3333333333333 +x_0=86501.46392052 +y_0=65379.0134283 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.201166195164 +no_defs",
    "srid": 30200,
    "auth_name": "EPSG",
    "auth_id": "30200",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2586,
    "description": "TC(1948) / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=utm +zone=39 +ellps=helmert +units=m +no_defs",
    "srid": 30339,
    "auth_name": "EPSG",
    "auth_id": "30339",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2587,
    "description": "TC(1948) / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=utm +zone=40 +ellps=helmert +units=m +no_defs",
    "srid": 30340,
    "auth_name": "EPSG",
    "auth_id": "30340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2588,
    "description": "Voirol 1875 / Nord Algerie (ancienne)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +towgs84=-73,-247,227,0,0,0,0 +units=m +no_defs",
    "srid": 30491,
    "auth_name": "EPSG",
    "auth_id": "30491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2589,
    "description": "Voirol 1875 / Sud Algerie (ancienne)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +towgs84=-73,-247,227,0,0,0,0 +units=m +no_defs",
    "srid": 30492,
    "auth_name": "EPSG",
    "auth_id": "30492",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2590,
    "description": "Voirol 1879 / Nord Algerie (ancienne)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs",
    "srid": 30493,
    "auth_name": "EPSG",
    "auth_id": "30493",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2591,
    "description": "Voirol 1879 / Sud Algerie (ancienne)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +units=m +no_defs",
    "srid": 30494,
    "auth_name": "EPSG",
    "auth_id": "30494",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2592,
    "description": "Nord Sahara 1959 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=29 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 30729,
    "auth_name": "EPSG",
    "auth_id": "30729",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2593,
    "description": "Nord Sahara 1959 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=30 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 30730,
    "auth_name": "EPSG",
    "auth_id": "30730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2594,
    "description": "Nord Sahara 1959 / UTM zone 31N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=31 +a=6378249.145 +rf=293.465 +towgs84=-267.407,-47.068,446.357,-0.179423,5.577661,-1.27762,1.204866 +units=m +no_defs",
    "srid": 30731,
    "auth_name": "EPSG",
    "auth_id": "30731",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2595,
    "description": "Nord Sahara 1959 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=32 +a=6378249.145 +rf=293.465 +towgs84=-267.407,-47.068,446.357,-0.179423,5.577661,-1.27762,1.204866 +units=m +no_defs",
    "srid": 30732,
    "auth_name": "EPSG",
    "auth_id": "30732",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2596,
    "description": "Nord Sahara 1959 / Nord Algerie",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500135 +y_0=300090 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 30791,
    "auth_name": "EPSG",
    "auth_id": "30791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2597,
    "description": "Nord Sahara 1959 / Sud Algerie",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500135 +y_0=300090 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 30792,
    "auth_name": "EPSG",
    "auth_id": "30792",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2599,
    "description": "Yoff / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=28 +ellps=clrk80ign +towgs84=-30,190,89,0,0,0,0 +units=m +no_defs",
    "srid": 31028,
    "auth_name": "EPSG",
    "auth_id": "31028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2600,
    "description": "Zanderij / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs",
    "srid": 31121,
    "auth_name": "EPSG",
    "auth_id": "31121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2601,
    "description": "Zanderij / TM 54 NW",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-54 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs",
    "srid": 31154,
    "auth_name": "EPSG",
    "auth_id": "31154",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2602,
    "description": "Zanderij / Suriname Old TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-55.6833333333333 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs",
    "srid": 31170,
    "auth_name": "EPSG",
    "auth_id": "31170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2603,
    "description": "Zanderij / Suriname TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-55.6833333333333 +k=0.9999 +x_0=500000 +y_0=0 +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +units=m +no_defs",
    "srid": 31171,
    "auth_name": "EPSG",
    "auth_id": "31171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2604,
    "description": "MGI (Ferro) / Austria GK West Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +pm=ferro +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31251,
    "auth_name": "EPSG",
    "auth_id": "31251",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2605,
    "description": "MGI (Ferro) / Austria GK Central Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +pm=ferro +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31252,
    "auth_name": "EPSG",
    "auth_id": "31252",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2606,
    "description": "MGI (Ferro) / Austria GK East Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +pm=ferro +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31253,
    "auth_name": "EPSG",
    "auth_id": "31253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2607,
    "description": "MGI / Austria GK West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=10.3333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31254,
    "auth_name": "EPSG",
    "auth_id": "31254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2608,
    "description": "MGI / Austria GK Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13.3333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31255,
    "auth_name": "EPSG",
    "auth_id": "31255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2609,
    "description": "MGI / Austria GK East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16.3333333333333 +k=1 +x_0=0 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31256,
    "auth_name": "EPSG",
    "auth_id": "31256",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2610,
    "description": "MGI / Austria GK M28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=10.3333333333333 +k=1 +x_0=150000 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31257,
    "auth_name": "EPSG",
    "auth_id": "31257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2611,
    "description": "MGI / Austria GK M31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13.3333333333333 +k=1 +x_0=450000 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31258,
    "auth_name": "EPSG",
    "auth_id": "31258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2612,
    "description": "MGI / Austria GK M34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16.3333333333333 +k=1 +x_0=750000 +y_0=-5000000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31259,
    "auth_name": "EPSG",
    "auth_id": "31259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2622,
    "description": "MGI (Ferro) / Austria West Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31281,
    "auth_name": "EPSG",
    "auth_id": "31281",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2623,
    "description": "MGI (Ferro) / Austria Central Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31282,
    "auth_name": "EPSG",
    "auth_id": "31282",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2624,
    "description": "MGI (Ferro) / Austria East Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31283,
    "auth_name": "EPSG",
    "auth_id": "31283",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2625,
    "description": "MGI / Austria M28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=10.3333333333333 +k=1 +x_0=150000 +y_0=0 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31284,
    "auth_name": "EPSG",
    "auth_id": "31284",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2626,
    "description": "MGI / Austria M31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13.3333333333333 +k=1 +x_0=450000 +y_0=0 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31285,
    "auth_name": "EPSG",
    "auth_id": "31285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2627,
    "description": "MGI / Austria M34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16.3333333333333 +k=1 +x_0=750000 +y_0=0 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31286,
    "auth_name": "EPSG",
    "auth_id": "31286",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2628,
    "description": "MGI / Austria Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=lcc +lat_0=47.5 +lon_0=13.3333333333333 +lat_1=49 +lat_2=46 +x_0=400000 +y_0=400000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31287,
    "auth_name": "EPSG",
    "auth_id": "31287",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2629,
    "description": "MGI (Ferro) / Austria zone M28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=150000 +y_0=0 +ellps=bessel +pm=ferro +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31288,
    "auth_name": "EPSG",
    "auth_id": "31288",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2630,
    "description": "MGI (Ferro) / Austria zone M31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=450000 +y_0=0 +ellps=bessel +pm=ferro +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31289,
    "auth_name": "EPSG",
    "auth_id": "31289",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2631,
    "description": "MGI (Ferro) / Austria zone M34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=34 +k=1 +x_0=750000 +y_0=0 +ellps=bessel +pm=ferro +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 31290,
    "auth_name": "EPSG",
    "auth_id": "31290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2639,
    "description": "BD72 / Belge Lambert 72",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=90 +lon_0=4.35693972222222 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=150000.01256 +y_0=5400088.4378 +ellps=intl +units=m +no_defs",
    "srid": 31300,
    "auth_name": "EPSG",
    "auth_id": "31300",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2640,
    "description": "BD72 / Belgian Lambert 72",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=90 +lon_0=4.36748666666667 +lat_1=51.1666672333333 +lat_2=49.8333339 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +units=m +no_defs",
    "srid": 31370,
    "auth_name": "EPSG",
    "auth_id": "31370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2646,
    "description": "DHDN / 3-degree Gauss-Kruger zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 31466,
    "auth_name": "EPSG",
    "auth_id": "31466",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2647,
    "description": "DHDN / 3-degree Gauss-Kruger zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 31467,
    "auth_name": "EPSG",
    "auth_id": "31467",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2648,
    "description": "DHDN / 3-degree Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 31468,
    "auth_name": "EPSG",
    "auth_id": "31468",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2649,
    "description": "DHDN / 3-degree Gauss-Kruger zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 31469,
    "auth_name": "EPSG",
    "auth_id": "31469",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2650,
    "description": "Conakry 1905 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=28 +ellps=clrk80ign +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs",
    "srid": 31528,
    "auth_name": "EPSG",
    "auth_id": "31528",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2651,
    "description": "Conakry 1905 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=29 +ellps=clrk80ign +towgs84=-23,259,-9,0,0,0,0 +units=m +no_defs",
    "srid": 31529,
    "auth_name": "EPSG",
    "auth_id": "31529",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2652,
    "description": "Dealul Piscului 1930 / Stereo 33",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=sterea +lat_0=45.9 +lon_0=25.3924658888889 +k=0.9996667 +x_0=500000 +y_0=500000 +ellps=intl +towgs84=103.25,-100.4,-307.19,0,0,0,0 +units=m +no_defs",
    "srid": 31600,
    "auth_name": "EPSG",
    "auth_id": "31600",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2654,
    "description": "NGN / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=38 +ellps=WGS84 +towgs84=-3.2,-5.7,2.8,0,0,0,0 +units=m +no_defs",
    "srid": 31838,
    "auth_name": "EPSG",
    "auth_id": "31838",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2655,
    "description": "NGN / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=39 +ellps=WGS84 +towgs84=-3.2,-5.7,2.8,0,0,0,0 +units=m +no_defs",
    "srid": 31839,
    "auth_name": "EPSG",
    "auth_id": "31839",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2657,
    "description": "KUDAMS / KTM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 31901,
    "auth_name": "EPSG",
    "auth_id": "31901",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2658,
    "description": "SIRGAS 2000 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31965,
    "auth_name": "EPSG",
    "auth_id": "31965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2659,
    "description": "SIRGAS 2000 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31966,
    "auth_name": "EPSG",
    "auth_id": "31966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2660,
    "description": "SIRGAS 2000 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31967,
    "auth_name": "EPSG",
    "auth_id": "31967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2661,
    "description": "SIRGAS 2000 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31968,
    "auth_name": "EPSG",
    "auth_id": "31968",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2662,
    "description": "SIRGAS 2000 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31969,
    "auth_name": "EPSG",
    "auth_id": "31969",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2663,
    "description": "SIRGAS 2000 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31970,
    "auth_name": "EPSG",
    "auth_id": "31970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2664,
    "description": "SIRGAS 2000 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31971,
    "auth_name": "EPSG",
    "auth_id": "31971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2665,
    "description": "SIRGAS 2000 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31972,
    "auth_name": "EPSG",
    "auth_id": "31972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2666,
    "description": "SIRGAS 2000 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31973,
    "auth_name": "EPSG",
    "auth_id": "31973",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2667,
    "description": "SIRGAS 2000 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31974,
    "auth_name": "EPSG",
    "auth_id": "31974",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2668,
    "description": "SIRGAS 2000 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31975,
    "auth_name": "EPSG",
    "auth_id": "31975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2669,
    "description": "SIRGAS 2000 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31976,
    "auth_name": "EPSG",
    "auth_id": "31976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2670,
    "description": "SIRGAS 2000 / UTM zone 17S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31977,
    "auth_name": "EPSG",
    "auth_id": "31977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2671,
    "description": "SIRGAS 2000 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31978,
    "auth_name": "EPSG",
    "auth_id": "31978",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2672,
    "description": "SIRGAS 2000 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31979,
    "auth_name": "EPSG",
    "auth_id": "31979",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2673,
    "description": "SIRGAS 2000 / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31980,
    "auth_name": "EPSG",
    "auth_id": "31980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2674,
    "description": "SIRGAS 2000 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31981,
    "auth_name": "EPSG",
    "auth_id": "31981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2675,
    "description": "SIRGAS 2000 / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31982,
    "auth_name": "EPSG",
    "auth_id": "31982",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2676,
    "description": "SIRGAS 2000 / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=23 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31983,
    "auth_name": "EPSG",
    "auth_id": "31983",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2677,
    "description": "SIRGAS 2000 / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=24 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31984,
    "auth_name": "EPSG",
    "auth_id": "31984",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2678,
    "description": "SIRGAS 2000 / UTM zone 25S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=25 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31985,
    "auth_name": "EPSG",
    "auth_id": "31985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2679,
    "description": "SIRGAS 1995 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31986,
    "auth_name": "EPSG",
    "auth_id": "31986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2680,
    "description": "SIRGAS 1995 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31987,
    "auth_name": "EPSG",
    "auth_id": "31987",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2681,
    "description": "SIRGAS 1995 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31988,
    "auth_name": "EPSG",
    "auth_id": "31988",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2682,
    "description": "SIRGAS 1995 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31989,
    "auth_name": "EPSG",
    "auth_id": "31989",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2683,
    "description": "SIRGAS 1995 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31990,
    "auth_name": "EPSG",
    "auth_id": "31990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2684,
    "description": "SIRGAS 1995 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31991,
    "auth_name": "EPSG",
    "auth_id": "31991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2685,
    "description": "SIRGAS 1995 / UTM zone 17S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31992,
    "auth_name": "EPSG",
    "auth_id": "31992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2686,
    "description": "SIRGAS 1995 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31993,
    "auth_name": "EPSG",
    "auth_id": "31993",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2687,
    "description": "SIRGAS 1995 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31994,
    "auth_name": "EPSG",
    "auth_id": "31994",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2688,
    "description": "SIRGAS 1995 / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31995,
    "auth_name": "EPSG",
    "auth_id": "31995",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2689,
    "description": "SIRGAS 1995 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31996,
    "auth_name": "EPSG",
    "auth_id": "31996",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2690,
    "description": "SIRGAS 1995 / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31997,
    "auth_name": "EPSG",
    "auth_id": "31997",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2691,
    "description": "SIRGAS 1995 / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=23 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31998,
    "auth_name": "EPSG",
    "auth_id": "31998",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2692,
    "description": "SIRGAS 1995 / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=24 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 31999,
    "auth_name": "EPSG",
    "auth_id": "31999",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2693,
    "description": "SIRGAS 1995 / UTM zone 25S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=25 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32000,
    "auth_name": "EPSG",
    "auth_id": "32000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2694,
    "description": "NAD27 / Montana North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-109.5 +lat_1=48.7166666666667 +lat_2=47.85 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32001,
    "auth_name": "EPSG",
    "auth_id": "32001",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2695,
    "description": "NAD27 / Montana Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=45.8333333333333 +lon_0=-109.5 +lat_1=47.8833333333333 +lat_2=46.45 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32002,
    "auth_name": "EPSG",
    "auth_id": "32002",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2696,
    "description": "NAD27 / Montana South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=-109.5 +lat_1=46.4 +lat_2=44.8666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32003,
    "auth_name": "EPSG",
    "auth_id": "32003",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2697,
    "description": "NAD27 / Nebraska North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=41.3333333333333 +lon_0=-100 +lat_1=41.85 +lat_2=42.8166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32005,
    "auth_name": "EPSG",
    "auth_id": "32005",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2698,
    "description": "NAD27 / Nebraska South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-99.5 +lat_1=40.2833333333333 +lat_2=41.7166666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32006,
    "auth_name": "EPSG",
    "auth_id": "32006",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2699,
    "description": "NAD27 / Nevada East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32007,
    "auth_name": "EPSG",
    "auth_id": "32007",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2700,
    "description": "NAD27 / Nevada Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32008,
    "auth_name": "EPSG",
    "auth_id": "32008",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2701,
    "description": "NAD27 / Nevada West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32009,
    "auth_name": "EPSG",
    "auth_id": "32009",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2702,
    "description": "NAD27 / New Hampshire",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32010,
    "auth_name": "EPSG",
    "auth_id": "32010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2703,
    "description": "NAD27 / New Jersey",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.6666666666667 +k=0.999975 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32011,
    "auth_name": "EPSG",
    "auth_id": "32011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2704,
    "description": "NAD27 / New Mexico East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32012,
    "auth_name": "EPSG",
    "auth_id": "32012",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2705,
    "description": "NAD27 / New Mexico Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32013,
    "auth_name": "EPSG",
    "auth_id": "32013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2706,
    "description": "NAD27 / New Mexico West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32014,
    "auth_name": "EPSG",
    "auth_id": "32014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2707,
    "description": "NAD27 / New York East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-74.3333333333333 +k=0.999966667 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32015,
    "auth_name": "EPSG",
    "auth_id": "32015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2708,
    "description": "NAD27 / New York Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32016,
    "auth_name": "EPSG",
    "auth_id": "32016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2709,
    "description": "NAD27 / New York West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32017,
    "auth_name": "EPSG",
    "auth_id": "32017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2711,
    "description": "NAD27 / North Carolina",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=34.3333333333333 +lat_2=36.1666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32019,
    "auth_name": "EPSG",
    "auth_id": "32019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2712,
    "description": "NAD27 / North Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.4333333333333 +lat_2=48.7333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32020,
    "auth_name": "EPSG",
    "auth_id": "32020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2713,
    "description": "NAD27 / North Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=46.1833333333333 +lat_2=47.4833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32021,
    "auth_name": "EPSG",
    "auth_id": "32021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2714,
    "description": "NAD27 / Ohio North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=40.4333333333333 +lat_2=41.7 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32022,
    "auth_name": "EPSG",
    "auth_id": "32022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2715,
    "description": "NAD27 / Ohio South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=38.7333333333333 +lat_2=40.0333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32023,
    "auth_name": "EPSG",
    "auth_id": "32023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2716,
    "description": "NAD27 / Oklahoma North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=35.5666666666667 +lat_2=36.7666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32024,
    "auth_name": "EPSG",
    "auth_id": "32024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2717,
    "description": "NAD27 / Oklahoma South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=33.9333333333333 +lat_2=35.2333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32025,
    "auth_name": "EPSG",
    "auth_id": "32025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2718,
    "description": "NAD27 / Oregon North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=44.3333333333333 +lat_2=46 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32026,
    "auth_name": "EPSG",
    "auth_id": "32026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2719,
    "description": "NAD27 / Oregon South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=42.3333333333333 +lat_2=44 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32027,
    "auth_name": "EPSG",
    "auth_id": "32027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2720,
    "description": "NAD27 / Pennsylvania North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=40.8833333333333 +lat_2=41.95 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32028,
    "auth_name": "EPSG",
    "auth_id": "32028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2722,
    "description": "NAD27 / Rhode Island",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.9999938 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32030,
    "auth_name": "EPSG",
    "auth_id": "32030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2723,
    "description": "NAD27 / South Carolina North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=33 +lon_0=-81 +lat_1=33.7666666666667 +lat_2=34.9666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32031,
    "auth_name": "EPSG",
    "auth_id": "32031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2724,
    "description": "NAD27 / South Carolina South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=32.3333333333333 +lat_2=33.6666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32033,
    "auth_name": "EPSG",
    "auth_id": "32033",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2725,
    "description": "NAD27 / South Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=44.4166666666667 +lat_2=45.6833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32034,
    "auth_name": "EPSG",
    "auth_id": "32034",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2726,
    "description": "NAD27 / South Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=42.8333333333333 +lat_2=44.4 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32035,
    "auth_name": "EPSG",
    "auth_id": "32035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2728,
    "description": "NAD27 / Texas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.1833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32037,
    "auth_name": "EPSG",
    "auth_id": "32037",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2729,
    "description": "NAD27 / Texas North Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-97.5 +lat_1=32.1333333333333 +lat_2=33.9666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32038,
    "auth_name": "EPSG",
    "auth_id": "32038",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2730,
    "description": "NAD27 / Texas Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=30.1166666666667 +lat_2=31.8833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32039,
    "auth_name": "EPSG",
    "auth_id": "32039",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2731,
    "description": "NAD27 / Texas South Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=28.3833333333333 +lat_2=30.2833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32040,
    "auth_name": "EPSG",
    "auth_id": "32040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2732,
    "description": "NAD27 / Texas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=26.1666666666667 +lat_2=27.8333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32041,
    "auth_name": "EPSG",
    "auth_id": "32041",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2733,
    "description": "NAD27 / Utah North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32042,
    "auth_name": "EPSG",
    "auth_id": "32042",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2734,
    "description": "NAD27 / Utah Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32043,
    "auth_name": "EPSG",
    "auth_id": "32043",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2735,
    "description": "NAD27 / Utah South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32044,
    "auth_name": "EPSG",
    "auth_id": "32044",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2736,
    "description": "NAD27 / Vermont",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32045,
    "auth_name": "EPSG",
    "auth_id": "32045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2737,
    "description": "NAD27 / Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=38.0333333333333 +lat_2=39.2 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32046,
    "auth_name": "EPSG",
    "auth_id": "32046",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2738,
    "description": "NAD27 / Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=36.7666666666667 +lat_2=37.9666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32047,
    "auth_name": "EPSG",
    "auth_id": "32047",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2739,
    "description": "NAD27 / Washington North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=47.5 +lat_2=48.7333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32048,
    "auth_name": "EPSG",
    "auth_id": "32048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2740,
    "description": "NAD27 / Washington South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=45.8333333333333 +lat_2=47.3333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32049,
    "auth_name": "EPSG",
    "auth_id": "32049",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2741,
    "description": "NAD27 / West Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=39 +lat_2=40.25 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32050,
    "auth_name": "EPSG",
    "auth_id": "32050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2742,
    "description": "NAD27 / West Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=37.4833333333333 +lat_2=38.8833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32051,
    "auth_name": "EPSG",
    "auth_id": "32051",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2743,
    "description": "NAD27 / Wisconsin North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=45.5666666666667 +lat_2=46.7666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32052,
    "auth_name": "EPSG",
    "auth_id": "32052",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2744,
    "description": "NAD27 / Wisconsin Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=44.25 +lat_2=45.5 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32053,
    "auth_name": "EPSG",
    "auth_id": "32053",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2745,
    "description": "NAD27 / Wisconsin South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=42.7333333333333 +lat_2=44.0666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32054,
    "auth_name": "EPSG",
    "auth_id": "32054",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2746,
    "description": "NAD27 / Wyoming East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=40.6666666666667 +lon_0=-105.166666666667 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32055,
    "auth_name": "EPSG",
    "auth_id": "32055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2747,
    "description": "NAD27 / Wyoming East Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=40.6666666666667 +lon_0=-107.333333333333 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32056,
    "auth_name": "EPSG",
    "auth_id": "32056",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2748,
    "description": "NAD27 / Wyoming West Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=40.6666666666667 +lon_0=-108.75 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32057,
    "auth_name": "EPSG",
    "auth_id": "32057",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2749,
    "description": "NAD27 / Wyoming West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=40.6666666666667 +lon_0=-110.083333333333 +k=0.999941177 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32058,
    "auth_name": "EPSG",
    "auth_id": "32058",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2752,
    "description": "NAD27 / BLM 14N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32064,
    "auth_name": "EPSG",
    "auth_id": "32064",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2753,
    "description": "NAD27 / BLM 15N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32065,
    "auth_name": "EPSG",
    "auth_id": "32065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2754,
    "description": "NAD27 / BLM 16N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32066,
    "auth_name": "EPSG",
    "auth_id": "32066",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2755,
    "description": "NAD27 / BLM 17N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32067,
    "auth_name": "EPSG",
    "auth_id": "32067",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2760,
    "description": "NAD27 / MTM zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 32081,
    "auth_name": "EPSG",
    "auth_id": "32081",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2761,
    "description": "NAD27 / MTM zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 32082,
    "auth_name": "EPSG",
    "auth_id": "32082",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2762,
    "description": "NAD27 / MTM zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 32083,
    "auth_name": "EPSG",
    "auth_id": "32083",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2763,
    "description": "NAD27 / MTM zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 32084,
    "auth_name": "EPSG",
    "auth_id": "32084",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2764,
    "description": "NAD27 / MTM zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 32085,
    "auth_name": "EPSG",
    "auth_id": "32085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2765,
    "description": "NAD27 / MTM zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 32086,
    "auth_name": "EPSG",
    "auth_id": "32086",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2766,
    "description": "NAD27 / Quebec Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 32098,
    "auth_name": "EPSG",
    "auth_id": "32098",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2767,
    "description": "NAD27 / Louisiana Offshore",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-91.3333333333333 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 32099,
    "auth_name": "EPSG",
    "auth_id": "32099",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2768,
    "description": "NAD83 / Montana",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32100,
    "auth_name": "EPSG",
    "auth_id": "32100",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2769,
    "description": "NAD83 / Nebraska",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 32104,
    "auth_name": "EPSG",
    "auth_id": "32104",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2770,
    "description": "NAD83 / Nevada East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32107,
    "auth_name": "EPSG",
    "auth_id": "32107",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2771,
    "description": "NAD83 / Nevada Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32108,
    "auth_name": "EPSG",
    "auth_id": "32108",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2772,
    "description": "NAD83 / Nevada West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32109,
    "auth_name": "EPSG",
    "auth_id": "32109",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2773,
    "description": "NAD83 / New Hampshire",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32110,
    "auth_name": "EPSG",
    "auth_id": "32110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2774,
    "description": "NAD83 / New Jersey",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 32111,
    "auth_name": "EPSG",
    "auth_id": "32111",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2775,
    "description": "NAD83 / New Mexico East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32112,
    "auth_name": "EPSG",
    "auth_id": "32112",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2776,
    "description": "NAD83 / New Mexico Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32113,
    "auth_name": "EPSG",
    "auth_id": "32113",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2777,
    "description": "NAD83 / New Mexico West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32114,
    "auth_name": "EPSG",
    "auth_id": "32114",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2778,
    "description": "NAD83 / New York East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32115,
    "auth_name": "EPSG",
    "auth_id": "32115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2779,
    "description": "NAD83 / New York Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32116,
    "auth_name": "EPSG",
    "auth_id": "32116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2780,
    "description": "NAD83 / New York West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32117,
    "auth_name": "EPSG",
    "auth_id": "32117",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2781,
    "description": "NAD83 / New York Long Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32118,
    "auth_name": "EPSG",
    "auth_id": "32118",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2782,
    "description": "NAD83 / North Carolina",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.22 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 32119,
    "auth_name": "EPSG",
    "auth_id": "32119",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2783,
    "description": "NAD83 / North Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32120,
    "auth_name": "EPSG",
    "auth_id": "32120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2784,
    "description": "NAD83 / North Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32121,
    "auth_name": "EPSG",
    "auth_id": "32121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2785,
    "description": "NAD83 / Ohio North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32122,
    "auth_name": "EPSG",
    "auth_id": "32122",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2786,
    "description": "NAD83 / Ohio South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32123,
    "auth_name": "EPSG",
    "auth_id": "32123",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2787,
    "description": "NAD83 / Oklahoma North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32124,
    "auth_name": "EPSG",
    "auth_id": "32124",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2788,
    "description": "NAD83 / Oklahoma South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32125,
    "auth_name": "EPSG",
    "auth_id": "32125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2789,
    "description": "NAD83 / Oregon North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32126,
    "auth_name": "EPSG",
    "auth_id": "32126",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2790,
    "description": "NAD83 / Oregon South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32127,
    "auth_name": "EPSG",
    "auth_id": "32127",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2791,
    "description": "NAD83 / Pennsylvania North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32128,
    "auth_name": "EPSG",
    "auth_id": "32128",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2792,
    "description": "NAD83 / Pennsylvania South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32129,
    "auth_name": "EPSG",
    "auth_id": "32129",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2793,
    "description": "NAD83 / Rhode Island",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32130,
    "auth_name": "EPSG",
    "auth_id": "32130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2794,
    "description": "NAD83 / South Carolina",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 32133,
    "auth_name": "EPSG",
    "auth_id": "32133",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2795,
    "description": "NAD83 / South Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32134,
    "auth_name": "EPSG",
    "auth_id": "32134",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2796,
    "description": "NAD83 / South Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32135,
    "auth_name": "EPSG",
    "auth_id": "32135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2797,
    "description": "NAD83 / Tennessee",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 32136,
    "auth_name": "EPSG",
    "auth_id": "32136",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2798,
    "description": "NAD83 / Texas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32137,
    "auth_name": "EPSG",
    "auth_id": "32137",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2799,
    "description": "NAD83 / Texas North Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32138,
    "auth_name": "EPSG",
    "auth_id": "32138",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2800,
    "description": "NAD83 / Texas Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32139,
    "auth_name": "EPSG",
    "auth_id": "32139",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2801,
    "description": "NAD83 / Texas South Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32140,
    "auth_name": "EPSG",
    "auth_id": "32140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2802,
    "description": "NAD83 / Texas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32141,
    "auth_name": "EPSG",
    "auth_id": "32141",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2803,
    "description": "NAD83 / Utah North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32142,
    "auth_name": "EPSG",
    "auth_id": "32142",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2804,
    "description": "NAD83 / Utah Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32143,
    "auth_name": "EPSG",
    "auth_id": "32143",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2805,
    "description": "NAD83 / Utah South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32144,
    "auth_name": "EPSG",
    "auth_id": "32144",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2806,
    "description": "NAD83 / Vermont",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32145,
    "auth_name": "EPSG",
    "auth_id": "32145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2807,
    "description": "NAD83 / Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32146,
    "auth_name": "EPSG",
    "auth_id": "32146",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2808,
    "description": "NAD83 / Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32147,
    "auth_name": "EPSG",
    "auth_id": "32147",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2809,
    "description": "NAD83 / Washington North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32148,
    "auth_name": "EPSG",
    "auth_id": "32148",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2810,
    "description": "NAD83 / Washington South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32149,
    "auth_name": "EPSG",
    "auth_id": "32149",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2811,
    "description": "NAD83 / West Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32150,
    "auth_name": "EPSG",
    "auth_id": "32150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2812,
    "description": "NAD83 / West Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32151,
    "auth_name": "EPSG",
    "auth_id": "32151",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2813,
    "description": "NAD83 / Wisconsin North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32152,
    "auth_name": "EPSG",
    "auth_id": "32152",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2814,
    "description": "NAD83 / Wisconsin Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32153,
    "auth_name": "EPSG",
    "auth_id": "32153",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2815,
    "description": "NAD83 / Wisconsin South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32154,
    "auth_name": "EPSG",
    "auth_id": "32154",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2816,
    "description": "NAD83 / Wyoming East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32155,
    "auth_name": "EPSG",
    "auth_id": "32155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2817,
    "description": "NAD83 / Wyoming East Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32156,
    "auth_name": "EPSG",
    "auth_id": "32156",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2818,
    "description": "NAD83 / Wyoming West Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32157,
    "auth_name": "EPSG",
    "auth_id": "32157",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2819,
    "description": "NAD83 / Wyoming West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32158,
    "auth_name": "EPSG",
    "auth_id": "32158",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2820,
    "description": "NAD83 / Puerto Rico & Virgin Is.",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +datum=NAD83 +units=m +no_defs",
    "srid": 32161,
    "auth_name": "EPSG",
    "auth_id": "32161",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2821,
    "description": "NAD83 / BLM 14N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 32164,
    "auth_name": "EPSG",
    "auth_id": "32164",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2822,
    "description": "NAD83 / BLM 15N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 32165,
    "auth_name": "EPSG",
    "auth_id": "32165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2823,
    "description": "NAD83 / BLM 16N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 32166,
    "auth_name": "EPSG",
    "auth_id": "32166",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2824,
    "description": "NAD83 / BLM 17N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 32167,
    "auth_name": "EPSG",
    "auth_id": "32167",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2826,
    "description": "NAD83 / MTM zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32181,
    "auth_name": "EPSG",
    "auth_id": "32181",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2827,
    "description": "NAD83 / MTM zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32182,
    "auth_name": "EPSG",
    "auth_id": "32182",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2828,
    "description": "NAD83 / MTM zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32183,
    "auth_name": "EPSG",
    "auth_id": "32183",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2829,
    "description": "NAD83 / MTM zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32184,
    "auth_name": "EPSG",
    "auth_id": "32184",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2830,
    "description": "NAD83 / MTM zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32185,
    "auth_name": "EPSG",
    "auth_id": "32185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2831,
    "description": "NAD83 / MTM zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32186,
    "auth_name": "EPSG",
    "auth_id": "32186",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2832,
    "description": "NAD83 / MTM zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32187,
    "auth_name": "EPSG",
    "auth_id": "32187",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2833,
    "description": "NAD83 / MTM zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32188,
    "auth_name": "EPSG",
    "auth_id": "32188",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2834,
    "description": "NAD83 / MTM zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32189,
    "auth_name": "EPSG",
    "auth_id": "32189",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2835,
    "description": "NAD83 / MTM zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32190,
    "auth_name": "EPSG",
    "auth_id": "32190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2836,
    "description": "NAD83 / MTM zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32191,
    "auth_name": "EPSG",
    "auth_id": "32191",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2837,
    "description": "NAD83 / MTM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32192,
    "auth_name": "EPSG",
    "auth_id": "32192",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2838,
    "description": "NAD83 / MTM zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32193,
    "auth_name": "EPSG",
    "auth_id": "32193",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2839,
    "description": "NAD83 / MTM zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32194,
    "auth_name": "EPSG",
    "auth_id": "32194",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2840,
    "description": "NAD83 / MTM zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32195,
    "auth_name": "EPSG",
    "auth_id": "32195",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2841,
    "description": "NAD83 / MTM zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32196,
    "auth_name": "EPSG",
    "auth_id": "32196",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2842,
    "description": "NAD83 / MTM zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 32197,
    "auth_name": "EPSG",
    "auth_id": "32197",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2843,
    "description": "NAD83 / Quebec Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 32198,
    "auth_name": "EPSG",
    "auth_id": "32198",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2844,
    "description": "NAD83 / Louisiana Offshore",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.5 +lon_0=-91.3333333333333 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=1000000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 32199,
    "auth_name": "EPSG",
    "auth_id": "32199",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2845,
    "description": "WGS 72 / UTM zone 1N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=1 +ellps=WGS72 +units=m +no_defs",
    "srid": 32201,
    "auth_name": "EPSG",
    "auth_id": "32201",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2846,
    "description": "WGS 72 / UTM zone 2N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=2 +ellps=WGS72 +units=m +no_defs",
    "srid": 32202,
    "auth_name": "EPSG",
    "auth_id": "32202",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2847,
    "description": "WGS 72 / UTM zone 3N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=3 +ellps=WGS72 +units=m +no_defs",
    "srid": 32203,
    "auth_name": "EPSG",
    "auth_id": "32203",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2848,
    "description": "WGS 72 / UTM zone 4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=4 +ellps=WGS72 +units=m +no_defs",
    "srid": 32204,
    "auth_name": "EPSG",
    "auth_id": "32204",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2849,
    "description": "WGS 72 / UTM zone 5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=5 +ellps=WGS72 +units=m +no_defs",
    "srid": 32205,
    "auth_name": "EPSG",
    "auth_id": "32205",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2850,
    "description": "WGS 72 / UTM zone 6N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=6 +ellps=WGS72 +units=m +no_defs",
    "srid": 32206,
    "auth_name": "EPSG",
    "auth_id": "32206",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2851,
    "description": "WGS 72 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=7 +ellps=WGS72 +units=m +no_defs",
    "srid": 32207,
    "auth_name": "EPSG",
    "auth_id": "32207",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2852,
    "description": "WGS 72 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=8 +ellps=WGS72 +units=m +no_defs",
    "srid": 32208,
    "auth_name": "EPSG",
    "auth_id": "32208",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2853,
    "description": "WGS 72 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=9 +ellps=WGS72 +units=m +no_defs",
    "srid": 32209,
    "auth_name": "EPSG",
    "auth_id": "32209",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2854,
    "description": "WGS 72 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=10 +ellps=WGS72 +units=m +no_defs",
    "srid": 32210,
    "auth_name": "EPSG",
    "auth_id": "32210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2855,
    "description": "WGS 72 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=11 +ellps=WGS72 +units=m +no_defs",
    "srid": 32211,
    "auth_name": "EPSG",
    "auth_id": "32211",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2856,
    "description": "WGS 72 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=12 +ellps=WGS72 +units=m +no_defs",
    "srid": 32212,
    "auth_name": "EPSG",
    "auth_id": "32212",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2857,
    "description": "WGS 72 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=13 +ellps=WGS72 +units=m +no_defs",
    "srid": 32213,
    "auth_name": "EPSG",
    "auth_id": "32213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2858,
    "description": "WGS 72 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=14 +ellps=WGS72 +units=m +no_defs",
    "srid": 32214,
    "auth_name": "EPSG",
    "auth_id": "32214",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2859,
    "description": "WGS 72 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=15 +ellps=WGS72 +units=m +no_defs",
    "srid": 32215,
    "auth_name": "EPSG",
    "auth_id": "32215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2860,
    "description": "WGS 72 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=16 +ellps=WGS72 +units=m +no_defs",
    "srid": 32216,
    "auth_name": "EPSG",
    "auth_id": "32216",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2861,
    "description": "WGS 72 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=17 +ellps=WGS72 +units=m +no_defs",
    "srid": 32217,
    "auth_name": "EPSG",
    "auth_id": "32217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2862,
    "description": "WGS 72 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=18 +ellps=WGS72 +units=m +no_defs",
    "srid": 32218,
    "auth_name": "EPSG",
    "auth_id": "32218",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2863,
    "description": "WGS 72 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=19 +ellps=WGS72 +units=m +no_defs",
    "srid": 32219,
    "auth_name": "EPSG",
    "auth_id": "32219",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2864,
    "description": "WGS 72 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=20 +ellps=WGS72 +units=m +no_defs",
    "srid": 32220,
    "auth_name": "EPSG",
    "auth_id": "32220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2865,
    "description": "WGS 72 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=21 +ellps=WGS72 +units=m +no_defs",
    "srid": 32221,
    "auth_name": "EPSG",
    "auth_id": "32221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2866,
    "description": "WGS 72 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=22 +ellps=WGS72 +units=m +no_defs",
    "srid": 32222,
    "auth_name": "EPSG",
    "auth_id": "32222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2867,
    "description": "WGS 72 / UTM zone 23N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=23 +ellps=WGS72 +units=m +no_defs",
    "srid": 32223,
    "auth_name": "EPSG",
    "auth_id": "32223",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2868,
    "description": "WGS 72 / UTM zone 24N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=24 +ellps=WGS72 +units=m +no_defs",
    "srid": 32224,
    "auth_name": "EPSG",
    "auth_id": "32224",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2869,
    "description": "WGS 72 / UTM zone 25N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=25 +ellps=WGS72 +units=m +no_defs",
    "srid": 32225,
    "auth_name": "EPSG",
    "auth_id": "32225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2870,
    "description": "WGS 72 / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=26 +ellps=WGS72 +units=m +no_defs",
    "srid": 32226,
    "auth_name": "EPSG",
    "auth_id": "32226",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2871,
    "description": "WGS 72 / UTM zone 27N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=27 +ellps=WGS72 +units=m +no_defs",
    "srid": 32227,
    "auth_name": "EPSG",
    "auth_id": "32227",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2872,
    "description": "WGS 72 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=28 +ellps=WGS72 +units=m +no_defs",
    "srid": 32228,
    "auth_name": "EPSG",
    "auth_id": "32228",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2873,
    "description": "WGS 72 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=29 +ellps=WGS72 +units=m +no_defs",
    "srid": 32229,
    "auth_name": "EPSG",
    "auth_id": "32229",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2874,
    "description": "WGS 72 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=30 +ellps=WGS72 +units=m +no_defs",
    "srid": 32230,
    "auth_name": "EPSG",
    "auth_id": "32230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2875,
    "description": "WGS 72 / UTM zone 31N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=31 +ellps=WGS72 +units=m +no_defs",
    "srid": 32231,
    "auth_name": "EPSG",
    "auth_id": "32231",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2876,
    "description": "WGS 72 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=32 +ellps=WGS72 +units=m +no_defs",
    "srid": 32232,
    "auth_name": "EPSG",
    "auth_id": "32232",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2877,
    "description": "WGS 72 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=33 +ellps=WGS72 +units=m +no_defs",
    "srid": 32233,
    "auth_name": "EPSG",
    "auth_id": "32233",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2878,
    "description": "WGS 72 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=34 +ellps=WGS72 +units=m +no_defs",
    "srid": 32234,
    "auth_name": "EPSG",
    "auth_id": "32234",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2879,
    "description": "WGS 72 / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=35 +ellps=WGS72 +units=m +no_defs",
    "srid": 32235,
    "auth_name": "EPSG",
    "auth_id": "32235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2880,
    "description": "WGS 72 / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=36 +ellps=WGS72 +units=m +no_defs",
    "srid": 32236,
    "auth_name": "EPSG",
    "auth_id": "32236",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2881,
    "description": "WGS 72 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=37 +ellps=WGS72 +units=m +no_defs",
    "srid": 32237,
    "auth_name": "EPSG",
    "auth_id": "32237",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2882,
    "description": "WGS 72 / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=38 +ellps=WGS72 +units=m +no_defs",
    "srid": 32238,
    "auth_name": "EPSG",
    "auth_id": "32238",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2883,
    "description": "WGS 72 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=39 +ellps=WGS72 +units=m +no_defs",
    "srid": 32239,
    "auth_name": "EPSG",
    "auth_id": "32239",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2884,
    "description": "WGS 72 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=40 +ellps=WGS72 +units=m +no_defs",
    "srid": 32240,
    "auth_name": "EPSG",
    "auth_id": "32240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2885,
    "description": "WGS 72 / UTM zone 41N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=41 +ellps=WGS72 +units=m +no_defs",
    "srid": 32241,
    "auth_name": "EPSG",
    "auth_id": "32241",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2886,
    "description": "WGS 72 / UTM zone 42N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=42 +ellps=WGS72 +units=m +no_defs",
    "srid": 32242,
    "auth_name": "EPSG",
    "auth_id": "32242",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2887,
    "description": "WGS 72 / UTM zone 43N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=43 +ellps=WGS72 +units=m +no_defs",
    "srid": 32243,
    "auth_name": "EPSG",
    "auth_id": "32243",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2888,
    "description": "WGS 72 / UTM zone 44N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=44 +ellps=WGS72 +units=m +no_defs",
    "srid": 32244,
    "auth_name": "EPSG",
    "auth_id": "32244",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2889,
    "description": "WGS 72 / UTM zone 45N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=45 +ellps=WGS72 +units=m +no_defs",
    "srid": 32245,
    "auth_name": "EPSG",
    "auth_id": "32245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2890,
    "description": "WGS 72 / UTM zone 46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=46 +ellps=WGS72 +units=m +no_defs",
    "srid": 32246,
    "auth_name": "EPSG",
    "auth_id": "32246",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2891,
    "description": "WGS 72 / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=47 +ellps=WGS72 +units=m +no_defs",
    "srid": 32247,
    "auth_name": "EPSG",
    "auth_id": "32247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2892,
    "description": "WGS 72 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=48 +ellps=WGS72 +units=m +no_defs",
    "srid": 32248,
    "auth_name": "EPSG",
    "auth_id": "32248",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2893,
    "description": "WGS 72 / UTM zone 49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=49 +ellps=WGS72 +units=m +no_defs",
    "srid": 32249,
    "auth_name": "EPSG",
    "auth_id": "32249",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2894,
    "description": "WGS 72 / UTM zone 50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=50 +ellps=WGS72 +units=m +no_defs",
    "srid": 32250,
    "auth_name": "EPSG",
    "auth_id": "32250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2895,
    "description": "WGS 72 / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=51 +ellps=WGS72 +units=m +no_defs",
    "srid": 32251,
    "auth_name": "EPSG",
    "auth_id": "32251",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2896,
    "description": "WGS 72 / UTM zone 52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=52 +ellps=WGS72 +units=m +no_defs",
    "srid": 32252,
    "auth_name": "EPSG",
    "auth_id": "32252",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2897,
    "description": "WGS 72 / UTM zone 53N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=53 +ellps=WGS72 +units=m +no_defs",
    "srid": 32253,
    "auth_name": "EPSG",
    "auth_id": "32253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2898,
    "description": "WGS 72 / UTM zone 54N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=54 +ellps=WGS72 +units=m +no_defs",
    "srid": 32254,
    "auth_name": "EPSG",
    "auth_id": "32254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2899,
    "description": "WGS 72 / UTM zone 55N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=55 +ellps=WGS72 +units=m +no_defs",
    "srid": 32255,
    "auth_name": "EPSG",
    "auth_id": "32255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2900,
    "description": "WGS 72 / UTM zone 56N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=56 +ellps=WGS72 +units=m +no_defs",
    "srid": 32256,
    "auth_name": "EPSG",
    "auth_id": "32256",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2901,
    "description": "WGS 72 / UTM zone 57N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=57 +ellps=WGS72 +units=m +no_defs",
    "srid": 32257,
    "auth_name": "EPSG",
    "auth_id": "32257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2902,
    "description": "WGS 72 / UTM zone 58N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=58 +ellps=WGS72 +units=m +no_defs",
    "srid": 32258,
    "auth_name": "EPSG",
    "auth_id": "32258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2903,
    "description": "WGS 72 / UTM zone 59N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=59 +ellps=WGS72 +units=m +no_defs",
    "srid": 32259,
    "auth_name": "EPSG",
    "auth_id": "32259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2904,
    "description": "WGS 72 / UTM zone 60N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=60 +ellps=WGS72 +units=m +no_defs",
    "srid": 32260,
    "auth_name": "EPSG",
    "auth_id": "32260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2905,
    "description": "WGS 72 / UTM zone 1S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=1 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32301,
    "auth_name": "EPSG",
    "auth_id": "32301",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2906,
    "description": "WGS 72 / UTM zone 2S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=2 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32302,
    "auth_name": "EPSG",
    "auth_id": "32302",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2907,
    "description": "WGS 72 / UTM zone 3S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=3 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32303,
    "auth_name": "EPSG",
    "auth_id": "32303",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2908,
    "description": "WGS 72 / UTM zone 4S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=4 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32304,
    "auth_name": "EPSG",
    "auth_id": "32304",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2909,
    "description": "WGS 72 / UTM zone 5S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=5 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32305,
    "auth_name": "EPSG",
    "auth_id": "32305",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2910,
    "description": "WGS 72 / UTM zone 6S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=6 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32306,
    "auth_name": "EPSG",
    "auth_id": "32306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2911,
    "description": "WGS 72 / UTM zone 7S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=7 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32307,
    "auth_name": "EPSG",
    "auth_id": "32307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2912,
    "description": "WGS 72 / UTM zone 8S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=8 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32308,
    "auth_name": "EPSG",
    "auth_id": "32308",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2913,
    "description": "WGS 72 / UTM zone 9S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=9 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32309,
    "auth_name": "EPSG",
    "auth_id": "32309",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2914,
    "description": "WGS 72 / UTM zone 10S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=10 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32310,
    "auth_name": "EPSG",
    "auth_id": "32310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2915,
    "description": "WGS 72 / UTM zone 11S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=11 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32311,
    "auth_name": "EPSG",
    "auth_id": "32311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2916,
    "description": "WGS 72 / UTM zone 12S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=12 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32312,
    "auth_name": "EPSG",
    "auth_id": "32312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2917,
    "description": "WGS 72 / UTM zone 13S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=13 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32313,
    "auth_name": "EPSG",
    "auth_id": "32313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2918,
    "description": "WGS 72 / UTM zone 14S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=14 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32314,
    "auth_name": "EPSG",
    "auth_id": "32314",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2919,
    "description": "WGS 72 / UTM zone 15S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=15 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32315,
    "auth_name": "EPSG",
    "auth_id": "32315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2920,
    "description": "WGS 72 / UTM zone 16S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=16 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32316,
    "auth_name": "EPSG",
    "auth_id": "32316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2921,
    "description": "WGS 72 / UTM zone 17S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=17 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32317,
    "auth_name": "EPSG",
    "auth_id": "32317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2922,
    "description": "WGS 72 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=18 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32318,
    "auth_name": "EPSG",
    "auth_id": "32318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2923,
    "description": "WGS 72 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=19 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32319,
    "auth_name": "EPSG",
    "auth_id": "32319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2924,
    "description": "WGS 72 / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=20 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32320,
    "auth_name": "EPSG",
    "auth_id": "32320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2925,
    "description": "WGS 72 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=21 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32321,
    "auth_name": "EPSG",
    "auth_id": "32321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2926,
    "description": "WGS 72 / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=22 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32322,
    "auth_name": "EPSG",
    "auth_id": "32322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2927,
    "description": "WGS 72 / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=23 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32323,
    "auth_name": "EPSG",
    "auth_id": "32323",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2928,
    "description": "WGS 72 / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=24 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32324,
    "auth_name": "EPSG",
    "auth_id": "32324",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2929,
    "description": "WGS 72 / UTM zone 25S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=25 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32325,
    "auth_name": "EPSG",
    "auth_id": "32325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2930,
    "description": "WGS 72 / UTM zone 26S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=26 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32326,
    "auth_name": "EPSG",
    "auth_id": "32326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2931,
    "description": "WGS 72 / UTM zone 27S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=27 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32327,
    "auth_name": "EPSG",
    "auth_id": "32327",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2932,
    "description": "WGS 72 / UTM zone 28S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=28 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32328,
    "auth_name": "EPSG",
    "auth_id": "32328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2933,
    "description": "WGS 72 / UTM zone 29S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=29 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32329,
    "auth_name": "EPSG",
    "auth_id": "32329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2934,
    "description": "WGS 72 / UTM zone 30S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=30 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32330,
    "auth_name": "EPSG",
    "auth_id": "32330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2935,
    "description": "WGS 72 / UTM zone 31S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=31 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32331,
    "auth_name": "EPSG",
    "auth_id": "32331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2936,
    "description": "WGS 72 / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=32 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32332,
    "auth_name": "EPSG",
    "auth_id": "32332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2937,
    "description": "WGS 72 / UTM zone 33S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=33 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32333,
    "auth_name": "EPSG",
    "auth_id": "32333",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2938,
    "description": "WGS 72 / UTM zone 34S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=34 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32334,
    "auth_name": "EPSG",
    "auth_id": "32334",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2939,
    "description": "WGS 72 / UTM zone 35S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=35 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32335,
    "auth_name": "EPSG",
    "auth_id": "32335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2940,
    "description": "WGS 72 / UTM zone 36S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=36 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32336,
    "auth_name": "EPSG",
    "auth_id": "32336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2941,
    "description": "WGS 72 / UTM zone 37S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=37 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32337,
    "auth_name": "EPSG",
    "auth_id": "32337",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2942,
    "description": "WGS 72 / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=38 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32338,
    "auth_name": "EPSG",
    "auth_id": "32338",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2943,
    "description": "WGS 72 / UTM zone 39S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=39 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32339,
    "auth_name": "EPSG",
    "auth_id": "32339",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2944,
    "description": "WGS 72 / UTM zone 40S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=40 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32340,
    "auth_name": "EPSG",
    "auth_id": "32340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2945,
    "description": "WGS 72 / UTM zone 41S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=41 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32341,
    "auth_name": "EPSG",
    "auth_id": "32341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2946,
    "description": "WGS 72 / UTM zone 42S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=42 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32342,
    "auth_name": "EPSG",
    "auth_id": "32342",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2947,
    "description": "WGS 72 / UTM zone 43S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=43 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32343,
    "auth_name": "EPSG",
    "auth_id": "32343",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2948,
    "description": "WGS 72 / UTM zone 44S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=44 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32344,
    "auth_name": "EPSG",
    "auth_id": "32344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2949,
    "description": "WGS 72 / UTM zone 45S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=45 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32345,
    "auth_name": "EPSG",
    "auth_id": "32345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2950,
    "description": "WGS 72 / UTM zone 46S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=46 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32346,
    "auth_name": "EPSG",
    "auth_id": "32346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2951,
    "description": "WGS 72 / UTM zone 47S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=47 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32347,
    "auth_name": "EPSG",
    "auth_id": "32347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2952,
    "description": "WGS 72 / UTM zone 48S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=48 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32348,
    "auth_name": "EPSG",
    "auth_id": "32348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2953,
    "description": "WGS 72 / UTM zone 49S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=49 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32349,
    "auth_name": "EPSG",
    "auth_id": "32349",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2954,
    "description": "WGS 72 / UTM zone 50S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=50 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32350,
    "auth_name": "EPSG",
    "auth_id": "32350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2955,
    "description": "WGS 72 / UTM zone 51S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=51 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32351,
    "auth_name": "EPSG",
    "auth_id": "32351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2956,
    "description": "WGS 72 / UTM zone 52S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=52 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32352,
    "auth_name": "EPSG",
    "auth_id": "32352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2957,
    "description": "WGS 72 / UTM zone 53S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=53 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32353,
    "auth_name": "EPSG",
    "auth_id": "32353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2958,
    "description": "WGS 72 / UTM zone 54S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=54 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32354,
    "auth_name": "EPSG",
    "auth_id": "32354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2959,
    "description": "WGS 72 / UTM zone 55S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=55 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32355,
    "auth_name": "EPSG",
    "auth_id": "32355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2960,
    "description": "WGS 72 / UTM zone 56S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=56 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32356,
    "auth_name": "EPSG",
    "auth_id": "32356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2961,
    "description": "WGS 72 / UTM zone 57S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=57 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32357,
    "auth_name": "EPSG",
    "auth_id": "32357",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2962,
    "description": "WGS 72 / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=58 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32358,
    "auth_name": "EPSG",
    "auth_id": "32358",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2963,
    "description": "WGS 72 / UTM zone 59S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=59 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32359,
    "auth_name": "EPSG",
    "auth_id": "32359",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2964,
    "description": "WGS 72 / UTM zone 60S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=60 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 32360,
    "auth_name": "EPSG",
    "auth_id": "32360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2965,
    "description": "WGS 72BE / UTM zone 1N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=1 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32401,
    "auth_name": "EPSG",
    "auth_id": "32401",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2966,
    "description": "WGS 72BE / UTM zone 2N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=2 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32402,
    "auth_name": "EPSG",
    "auth_id": "32402",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2967,
    "description": "WGS 72BE / UTM zone 3N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=3 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32403,
    "auth_name": "EPSG",
    "auth_id": "32403",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2968,
    "description": "WGS 72BE / UTM zone 4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=4 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32404,
    "auth_name": "EPSG",
    "auth_id": "32404",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2969,
    "description": "WGS 72BE / UTM zone 5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=5 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32405,
    "auth_name": "EPSG",
    "auth_id": "32405",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2970,
    "description": "WGS 72BE / UTM zone 6N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=6 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32406,
    "auth_name": "EPSG",
    "auth_id": "32406",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2971,
    "description": "WGS 72BE / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=7 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32407,
    "auth_name": "EPSG",
    "auth_id": "32407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2972,
    "description": "WGS 72BE / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=8 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32408,
    "auth_name": "EPSG",
    "auth_id": "32408",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2973,
    "description": "WGS 72BE / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=9 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32409,
    "auth_name": "EPSG",
    "auth_id": "32409",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2974,
    "description": "WGS 72BE / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=10 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32410,
    "auth_name": "EPSG",
    "auth_id": "32410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2975,
    "description": "WGS 72BE / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=11 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32411,
    "auth_name": "EPSG",
    "auth_id": "32411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2976,
    "description": "WGS 72BE / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=12 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32412,
    "auth_name": "EPSG",
    "auth_id": "32412",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2977,
    "description": "WGS 72BE / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=13 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32413,
    "auth_name": "EPSG",
    "auth_id": "32413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2978,
    "description": "WGS 72BE / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=14 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32414,
    "auth_name": "EPSG",
    "auth_id": "32414",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2979,
    "description": "WGS 72BE / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=15 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32415,
    "auth_name": "EPSG",
    "auth_id": "32415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2980,
    "description": "WGS 72BE / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=16 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32416,
    "auth_name": "EPSG",
    "auth_id": "32416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2981,
    "description": "WGS 72BE / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=17 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32417,
    "auth_name": "EPSG",
    "auth_id": "32417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2982,
    "description": "WGS 72BE / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=18 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32418,
    "auth_name": "EPSG",
    "auth_id": "32418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2983,
    "description": "WGS 72BE / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=19 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32419,
    "auth_name": "EPSG",
    "auth_id": "32419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2984,
    "description": "WGS 72BE / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=20 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32420,
    "auth_name": "EPSG",
    "auth_id": "32420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2985,
    "description": "WGS 72BE / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=21 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32421,
    "auth_name": "EPSG",
    "auth_id": "32421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2986,
    "description": "WGS 72BE / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=22 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32422,
    "auth_name": "EPSG",
    "auth_id": "32422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2987,
    "description": "WGS 72BE / UTM zone 23N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=23 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32423,
    "auth_name": "EPSG",
    "auth_id": "32423",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2988,
    "description": "WGS 72BE / UTM zone 24N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=24 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32424,
    "auth_name": "EPSG",
    "auth_id": "32424",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2989,
    "description": "WGS 72BE / UTM zone 25N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=25 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32425,
    "auth_name": "EPSG",
    "auth_id": "32425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2990,
    "description": "WGS 72BE / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=26 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32426,
    "auth_name": "EPSG",
    "auth_id": "32426",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2991,
    "description": "WGS 72BE / UTM zone 27N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=27 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32427,
    "auth_name": "EPSG",
    "auth_id": "32427",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2992,
    "description": "WGS 72BE / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=28 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32428,
    "auth_name": "EPSG",
    "auth_id": "32428",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2993,
    "description": "WGS 72BE / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=29 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32429,
    "auth_name": "EPSG",
    "auth_id": "32429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2994,
    "description": "WGS 72BE / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=30 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32430,
    "auth_name": "EPSG",
    "auth_id": "32430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2995,
    "description": "WGS 72BE / UTM zone 31N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=31 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32431,
    "auth_name": "EPSG",
    "auth_id": "32431",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2996,
    "description": "WGS 72BE / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=32 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32432,
    "auth_name": "EPSG",
    "auth_id": "32432",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2997,
    "description": "WGS 72BE / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=33 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32433,
    "auth_name": "EPSG",
    "auth_id": "32433",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2998,
    "description": "WGS 72BE / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=34 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32434,
    "auth_name": "EPSG",
    "auth_id": "32434",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 2999,
    "description": "WGS 72BE / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=35 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32435,
    "auth_name": "EPSG",
    "auth_id": "32435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3000,
    "description": "WGS 72BE / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=36 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32436,
    "auth_name": "EPSG",
    "auth_id": "32436",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3001,
    "description": "WGS 72BE / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=37 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32437,
    "auth_name": "EPSG",
    "auth_id": "32437",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3002,
    "description": "WGS 72BE / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=38 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32438,
    "auth_name": "EPSG",
    "auth_id": "32438",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3003,
    "description": "WGS 72BE / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=39 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32439,
    "auth_name": "EPSG",
    "auth_id": "32439",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3004,
    "description": "WGS 72BE / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=40 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32440,
    "auth_name": "EPSG",
    "auth_id": "32440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3005,
    "description": "WGS 72BE / UTM zone 41N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=41 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32441,
    "auth_name": "EPSG",
    "auth_id": "32441",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3006,
    "description": "WGS 72BE / UTM zone 42N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=42 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32442,
    "auth_name": "EPSG",
    "auth_id": "32442",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3007,
    "description": "WGS 72BE / UTM zone 43N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=43 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32443,
    "auth_name": "EPSG",
    "auth_id": "32443",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3008,
    "description": "WGS 72BE / UTM zone 44N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=44 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32444,
    "auth_name": "EPSG",
    "auth_id": "32444",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3009,
    "description": "WGS 72BE / UTM zone 45N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=45 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32445,
    "auth_name": "EPSG",
    "auth_id": "32445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3010,
    "description": "WGS 72BE / UTM zone 46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=46 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32446,
    "auth_name": "EPSG",
    "auth_id": "32446",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3011,
    "description": "WGS 72BE / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=47 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32447,
    "auth_name": "EPSG",
    "auth_id": "32447",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3012,
    "description": "WGS 72BE / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=48 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32448,
    "auth_name": "EPSG",
    "auth_id": "32448",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3013,
    "description": "WGS 72BE / UTM zone 49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=49 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32449,
    "auth_name": "EPSG",
    "auth_id": "32449",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3014,
    "description": "WGS 72BE / UTM zone 50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=50 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32450,
    "auth_name": "EPSG",
    "auth_id": "32450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3015,
    "description": "WGS 72BE / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=51 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32451,
    "auth_name": "EPSG",
    "auth_id": "32451",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3016,
    "description": "WGS 72BE / UTM zone 52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=52 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32452,
    "auth_name": "EPSG",
    "auth_id": "32452",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3017,
    "description": "WGS 72BE / UTM zone 53N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=53 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32453,
    "auth_name": "EPSG",
    "auth_id": "32453",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3018,
    "description": "WGS 72BE / UTM zone 54N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=54 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32454,
    "auth_name": "EPSG",
    "auth_id": "32454",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3019,
    "description": "WGS 72BE / UTM zone 55N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=55 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32455,
    "auth_name": "EPSG",
    "auth_id": "32455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3020,
    "description": "WGS 72BE / UTM zone 56N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=56 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32456,
    "auth_name": "EPSG",
    "auth_id": "32456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3021,
    "description": "WGS 72BE / UTM zone 57N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=57 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32457,
    "auth_name": "EPSG",
    "auth_id": "32457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3022,
    "description": "WGS 72BE / UTM zone 58N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=58 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32458,
    "auth_name": "EPSG",
    "auth_id": "32458",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3023,
    "description": "WGS 72BE / UTM zone 59N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=59 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32459,
    "auth_name": "EPSG",
    "auth_id": "32459",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3024,
    "description": "WGS 72BE / UTM zone 60N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=60 +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32460,
    "auth_name": "EPSG",
    "auth_id": "32460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3025,
    "description": "WGS 72BE / UTM zone 1S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=1 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32501,
    "auth_name": "EPSG",
    "auth_id": "32501",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3026,
    "description": "WGS 72BE / UTM zone 2S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=2 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32502,
    "auth_name": "EPSG",
    "auth_id": "32502",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3027,
    "description": "WGS 72BE / UTM zone 3S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=3 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32503,
    "auth_name": "EPSG",
    "auth_id": "32503",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3028,
    "description": "WGS 72BE / UTM zone 4S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=4 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32504,
    "auth_name": "EPSG",
    "auth_id": "32504",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3029,
    "description": "WGS 72BE / UTM zone 5S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=5 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32505,
    "auth_name": "EPSG",
    "auth_id": "32505",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3030,
    "description": "WGS 72BE / UTM zone 6S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=6 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32506,
    "auth_name": "EPSG",
    "auth_id": "32506",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3031,
    "description": "WGS 72BE / UTM zone 7S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=7 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32507,
    "auth_name": "EPSG",
    "auth_id": "32507",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3032,
    "description": "WGS 72BE / UTM zone 8S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=8 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32508,
    "auth_name": "EPSG",
    "auth_id": "32508",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3033,
    "description": "WGS 72BE / UTM zone 9S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=9 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32509,
    "auth_name": "EPSG",
    "auth_id": "32509",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3034,
    "description": "WGS 72BE / UTM zone 10S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=10 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32510,
    "auth_name": "EPSG",
    "auth_id": "32510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3035,
    "description": "WGS 72BE / UTM zone 11S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=11 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32511,
    "auth_name": "EPSG",
    "auth_id": "32511",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3036,
    "description": "WGS 72BE / UTM zone 12S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=12 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32512,
    "auth_name": "EPSG",
    "auth_id": "32512",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3037,
    "description": "WGS 72BE / UTM zone 13S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=13 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32513,
    "auth_name": "EPSG",
    "auth_id": "32513",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3038,
    "description": "WGS 72BE / UTM zone 14S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=14 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32514,
    "auth_name": "EPSG",
    "auth_id": "32514",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3039,
    "description": "WGS 72BE / UTM zone 15S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=15 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32515,
    "auth_name": "EPSG",
    "auth_id": "32515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3040,
    "description": "WGS 72BE / UTM zone 16S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=16 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32516,
    "auth_name": "EPSG",
    "auth_id": "32516",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3041,
    "description": "WGS 72BE / UTM zone 17S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=17 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32517,
    "auth_name": "EPSG",
    "auth_id": "32517",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3042,
    "description": "WGS 72BE / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=18 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32518,
    "auth_name": "EPSG",
    "auth_id": "32518",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3043,
    "description": "WGS 72BE / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=19 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32519,
    "auth_name": "EPSG",
    "auth_id": "32519",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3044,
    "description": "WGS 72BE / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=20 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32520,
    "auth_name": "EPSG",
    "auth_id": "32520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3045,
    "description": "WGS 72BE / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=21 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32521,
    "auth_name": "EPSG",
    "auth_id": "32521",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3046,
    "description": "WGS 72BE / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=22 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32522,
    "auth_name": "EPSG",
    "auth_id": "32522",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3047,
    "description": "WGS 72BE / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=23 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32523,
    "auth_name": "EPSG",
    "auth_id": "32523",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3048,
    "description": "WGS 72BE / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=24 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32524,
    "auth_name": "EPSG",
    "auth_id": "32524",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3049,
    "description": "WGS 72BE / UTM zone 25S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=25 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32525,
    "auth_name": "EPSG",
    "auth_id": "32525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3050,
    "description": "WGS 72BE / UTM zone 26S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=26 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32526,
    "auth_name": "EPSG",
    "auth_id": "32526",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3051,
    "description": "WGS 72BE / UTM zone 27S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=27 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32527,
    "auth_name": "EPSG",
    "auth_id": "32527",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3052,
    "description": "WGS 72BE / UTM zone 28S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=28 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32528,
    "auth_name": "EPSG",
    "auth_id": "32528",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3053,
    "description": "WGS 72BE / UTM zone 29S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=29 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32529,
    "auth_name": "EPSG",
    "auth_id": "32529",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3054,
    "description": "WGS 72BE / UTM zone 30S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=30 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32530,
    "auth_name": "EPSG",
    "auth_id": "32530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3055,
    "description": "WGS 72BE / UTM zone 31S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=31 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32531,
    "auth_name": "EPSG",
    "auth_id": "32531",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3056,
    "description": "WGS 72BE / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=32 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32532,
    "auth_name": "EPSG",
    "auth_id": "32532",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3057,
    "description": "WGS 72BE / UTM zone 33S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=33 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32533,
    "auth_name": "EPSG",
    "auth_id": "32533",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3058,
    "description": "WGS 72BE / UTM zone 34S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=34 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32534,
    "auth_name": "EPSG",
    "auth_id": "32534",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3059,
    "description": "WGS 72BE / UTM zone 35S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=35 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32535,
    "auth_name": "EPSG",
    "auth_id": "32535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3060,
    "description": "WGS 72BE / UTM zone 36S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=36 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32536,
    "auth_name": "EPSG",
    "auth_id": "32536",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3061,
    "description": "WGS 72BE / UTM zone 37S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=37 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32537,
    "auth_name": "EPSG",
    "auth_id": "32537",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3062,
    "description": "WGS 72BE / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=38 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32538,
    "auth_name": "EPSG",
    "auth_id": "32538",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3063,
    "description": "WGS 72BE / UTM zone 39S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=39 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32539,
    "auth_name": "EPSG",
    "auth_id": "32539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3064,
    "description": "WGS 72BE / UTM zone 40S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=40 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32540,
    "auth_name": "EPSG",
    "auth_id": "32540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3065,
    "description": "WGS 72BE / UTM zone 41S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=41 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32541,
    "auth_name": "EPSG",
    "auth_id": "32541",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3066,
    "description": "WGS 72BE / UTM zone 42S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=42 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32542,
    "auth_name": "EPSG",
    "auth_id": "32542",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3067,
    "description": "WGS 72BE / UTM zone 43S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=43 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32543,
    "auth_name": "EPSG",
    "auth_id": "32543",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3068,
    "description": "WGS 72BE / UTM zone 44S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=44 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32544,
    "auth_name": "EPSG",
    "auth_id": "32544",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3069,
    "description": "WGS 72BE / UTM zone 45S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=45 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32545,
    "auth_name": "EPSG",
    "auth_id": "32545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3070,
    "description": "WGS 72BE / UTM zone 46S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=46 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32546,
    "auth_name": "EPSG",
    "auth_id": "32546",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3071,
    "description": "WGS 72BE / UTM zone 47S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=47 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32547,
    "auth_name": "EPSG",
    "auth_id": "32547",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3072,
    "description": "WGS 72BE / UTM zone 48S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=48 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32548,
    "auth_name": "EPSG",
    "auth_id": "32548",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3073,
    "description": "WGS 72BE / UTM zone 49S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=49 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32549,
    "auth_name": "EPSG",
    "auth_id": "32549",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3074,
    "description": "WGS 72BE / UTM zone 50S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=50 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32550,
    "auth_name": "EPSG",
    "auth_id": "32550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3075,
    "description": "WGS 72BE / UTM zone 51S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=51 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32551,
    "auth_name": "EPSG",
    "auth_id": "32551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3076,
    "description": "WGS 72BE / UTM zone 52S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=52 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32552,
    "auth_name": "EPSG",
    "auth_id": "32552",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3077,
    "description": "WGS 72BE / UTM zone 53S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=53 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32553,
    "auth_name": "EPSG",
    "auth_id": "32553",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3078,
    "description": "WGS 72BE / UTM zone 54S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=54 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32554,
    "auth_name": "EPSG",
    "auth_id": "32554",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3079,
    "description": "WGS 72BE / UTM zone 55S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=55 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32555,
    "auth_name": "EPSG",
    "auth_id": "32555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3080,
    "description": "WGS 72BE / UTM zone 56S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=56 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32556,
    "auth_name": "EPSG",
    "auth_id": "32556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3081,
    "description": "WGS 72BE / UTM zone 57S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=57 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32557,
    "auth_name": "EPSG",
    "auth_id": "32557",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3082,
    "description": "WGS 72BE / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=58 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32558,
    "auth_name": "EPSG",
    "auth_id": "32558",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3083,
    "description": "WGS 72BE / UTM zone 59S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=59 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32559,
    "auth_name": "EPSG",
    "auth_id": "32559",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3084,
    "description": "WGS 72BE / UTM zone 60S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=60 +south +ellps=WGS72 +towgs84=0,0,1.9,0,0,0.814,-0.38 +units=m +no_defs",
    "srid": 32560,
    "auth_name": "EPSG",
    "auth_id": "32560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3085,
    "description": "WGS 84 / UTM zone 1N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=1 +datum=WGS84 +units=m +no_defs",
    "srid": 32601,
    "auth_name": "EPSG",
    "auth_id": "32601",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3086,
    "description": "WGS 84 / UTM zone 2N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=2 +datum=WGS84 +units=m +no_defs",
    "srid": 32602,
    "auth_name": "EPSG",
    "auth_id": "32602",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3087,
    "description": "WGS 84 / UTM zone 3N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=3 +datum=WGS84 +units=m +no_defs",
    "srid": 32603,
    "auth_name": "EPSG",
    "auth_id": "32603",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3088,
    "description": "WGS 84 / UTM zone 4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=4 +datum=WGS84 +units=m +no_defs",
    "srid": 32604,
    "auth_name": "EPSG",
    "auth_id": "32604",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3089,
    "description": "WGS 84 / UTM zone 5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=5 +datum=WGS84 +units=m +no_defs",
    "srid": 32605,
    "auth_name": "EPSG",
    "auth_id": "32605",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3090,
    "description": "WGS 84 / UTM zone 6N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=6 +datum=WGS84 +units=m +no_defs",
    "srid": 32606,
    "auth_name": "EPSG",
    "auth_id": "32606",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3091,
    "description": "WGS 84 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=7 +datum=WGS84 +units=m +no_defs",
    "srid": 32607,
    "auth_name": "EPSG",
    "auth_id": "32607",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3092,
    "description": "WGS 84 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=8 +datum=WGS84 +units=m +no_defs",
    "srid": 32608,
    "auth_name": "EPSG",
    "auth_id": "32608",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3093,
    "description": "WGS 84 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=9 +datum=WGS84 +units=m +no_defs",
    "srid": 32609,
    "auth_name": "EPSG",
    "auth_id": "32609",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3094,
    "description": "WGS 84 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=10 +datum=WGS84 +units=m +no_defs",
    "srid": 32610,
    "auth_name": "EPSG",
    "auth_id": "32610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3095,
    "description": "WGS 84 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=11 +datum=WGS84 +units=m +no_defs",
    "srid": 32611,
    "auth_name": "EPSG",
    "auth_id": "32611",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3096,
    "description": "WGS 84 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=12 +datum=WGS84 +units=m +no_defs",
    "srid": 32612,
    "auth_name": "EPSG",
    "auth_id": "32612",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3097,
    "description": "WGS 84 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=13 +datum=WGS84 +units=m +no_defs",
    "srid": 32613,
    "auth_name": "EPSG",
    "auth_id": "32613",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3098,
    "description": "WGS 84 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=14 +datum=WGS84 +units=m +no_defs",
    "srid": 32614,
    "auth_name": "EPSG",
    "auth_id": "32614",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3099,
    "description": "WGS 84 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=15 +datum=WGS84 +units=m +no_defs",
    "srid": 32615,
    "auth_name": "EPSG",
    "auth_id": "32615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3100,
    "description": "WGS 84 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=16 +datum=WGS84 +units=m +no_defs",
    "srid": 32616,
    "auth_name": "EPSG",
    "auth_id": "32616",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3101,
    "description": "WGS 84 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=17 +datum=WGS84 +units=m +no_defs",
    "srid": 32617,
    "auth_name": "EPSG",
    "auth_id": "32617",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3102,
    "description": "WGS 84 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=18 +datum=WGS84 +units=m +no_defs",
    "srid": 32618,
    "auth_name": "EPSG",
    "auth_id": "32618",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3103,
    "description": "WGS 84 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=19 +datum=WGS84 +units=m +no_defs",
    "srid": 32619,
    "auth_name": "EPSG",
    "auth_id": "32619",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3104,
    "description": "WGS 84 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +datum=WGS84 +units=m +no_defs",
    "srid": 32620,
    "auth_name": "EPSG",
    "auth_id": "32620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3105,
    "description": "WGS 84 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=21 +datum=WGS84 +units=m +no_defs",
    "srid": 32621,
    "auth_name": "EPSG",
    "auth_id": "32621",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3106,
    "description": "WGS 84 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=22 +datum=WGS84 +units=m +no_defs",
    "srid": 32622,
    "auth_name": "EPSG",
    "auth_id": "32622",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3107,
    "description": "WGS 84 / UTM zone 23N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=23 +datum=WGS84 +units=m +no_defs",
    "srid": 32623,
    "auth_name": "EPSG",
    "auth_id": "32623",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3108,
    "description": "WGS 84 / UTM zone 24N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=24 +datum=WGS84 +units=m +no_defs",
    "srid": 32624,
    "auth_name": "EPSG",
    "auth_id": "32624",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3109,
    "description": "WGS 84 / UTM zone 25N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=25 +datum=WGS84 +units=m +no_defs",
    "srid": 32625,
    "auth_name": "EPSG",
    "auth_id": "32625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3110,
    "description": "WGS 84 / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=26 +datum=WGS84 +units=m +no_defs",
    "srid": 32626,
    "auth_name": "EPSG",
    "auth_id": "32626",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3111,
    "description": "WGS 84 / UTM zone 27N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=27 +datum=WGS84 +units=m +no_defs",
    "srid": 32627,
    "auth_name": "EPSG",
    "auth_id": "32627",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3112,
    "description": "WGS 84 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=28 +datum=WGS84 +units=m +no_defs",
    "srid": 32628,
    "auth_name": "EPSG",
    "auth_id": "32628",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3113,
    "description": "WGS 84 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs",
    "srid": 32629,
    "auth_name": "EPSG",
    "auth_id": "32629",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3114,
    "description": "WGS 84 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs",
    "srid": 32630,
    "auth_name": "EPSG",
    "auth_id": "32630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3115,
    "description": "WGS 84 / UTM zone 31N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs",
    "srid": 32631,
    "auth_name": "EPSG",
    "auth_id": "32631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3116,
    "description": "WGS 84 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs",
    "srid": 32632,
    "auth_name": "EPSG",
    "auth_id": "32632",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3117,
    "description": "WGS 84 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=33 +datum=WGS84 +units=m +no_defs",
    "srid": 32633,
    "auth_name": "EPSG",
    "auth_id": "32633",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3118,
    "description": "WGS 84 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=34 +datum=WGS84 +units=m +no_defs",
    "srid": 32634,
    "auth_name": "EPSG",
    "auth_id": "32634",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3119,
    "description": "WGS 84 / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs",
    "srid": 32635,
    "auth_name": "EPSG",
    "auth_id": "32635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3120,
    "description": "WGS 84 / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs",
    "srid": 32636,
    "auth_name": "EPSG",
    "auth_id": "32636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3121,
    "description": "WGS 84 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=37 +datum=WGS84 +units=m +no_defs",
    "srid": 32637,
    "auth_name": "EPSG",
    "auth_id": "32637",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3122,
    "description": "WGS 84 / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=38 +datum=WGS84 +units=m +no_defs",
    "srid": 32638,
    "auth_name": "EPSG",
    "auth_id": "32638",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3123,
    "description": "WGS 84 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=39 +datum=WGS84 +units=m +no_defs",
    "srid": 32639,
    "auth_name": "EPSG",
    "auth_id": "32639",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3124,
    "description": "WGS 84 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=40 +datum=WGS84 +units=m +no_defs",
    "srid": 32640,
    "auth_name": "EPSG",
    "auth_id": "32640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3125,
    "description": "WGS 84 / UTM zone 41N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=41 +datum=WGS84 +units=m +no_defs",
    "srid": 32641,
    "auth_name": "EPSG",
    "auth_id": "32641",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3126,
    "description": "WGS 84 / UTM zone 42N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=42 +datum=WGS84 +units=m +no_defs",
    "srid": 32642,
    "auth_name": "EPSG",
    "auth_id": "32642",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3127,
    "description": "WGS 84 / UTM zone 43N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=43 +datum=WGS84 +units=m +no_defs",
    "srid": 32643,
    "auth_name": "EPSG",
    "auth_id": "32643",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3128,
    "description": "WGS 84 / UTM zone 44N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=44 +datum=WGS84 +units=m +no_defs",
    "srid": 32644,
    "auth_name": "EPSG",
    "auth_id": "32644",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3129,
    "description": "WGS 84 / UTM zone 45N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=45 +datum=WGS84 +units=m +no_defs",
    "srid": 32645,
    "auth_name": "EPSG",
    "auth_id": "32645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3130,
    "description": "WGS 84 / UTM zone 46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=46 +datum=WGS84 +units=m +no_defs",
    "srid": 32646,
    "auth_name": "EPSG",
    "auth_id": "32646",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3131,
    "description": "WGS 84 / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=47 +datum=WGS84 +units=m +no_defs",
    "srid": 32647,
    "auth_name": "EPSG",
    "auth_id": "32647",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3132,
    "description": "WGS 84 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs",
    "srid": 32648,
    "auth_name": "EPSG",
    "auth_id": "32648",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3133,
    "description": "WGS 84 / UTM zone 49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=49 +datum=WGS84 +units=m +no_defs",
    "srid": 32649,
    "auth_name": "EPSG",
    "auth_id": "32649",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3134,
    "description": "WGS 84 / UTM zone 50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs",
    "srid": 32650,
    "auth_name": "EPSG",
    "auth_id": "32650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3135,
    "description": "WGS 84 / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=51 +datum=WGS84 +units=m +no_defs",
    "srid": 32651,
    "auth_name": "EPSG",
    "auth_id": "32651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3136,
    "description": "WGS 84 / UTM zone 52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=52 +datum=WGS84 +units=m +no_defs",
    "srid": 32652,
    "auth_name": "EPSG",
    "auth_id": "32652",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3137,
    "description": "WGS 84 / UTM zone 53N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=53 +datum=WGS84 +units=m +no_defs",
    "srid": 32653,
    "auth_name": "EPSG",
    "auth_id": "32653",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3138,
    "description": "WGS 84 / UTM zone 54N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=54 +datum=WGS84 +units=m +no_defs",
    "srid": 32654,
    "auth_name": "EPSG",
    "auth_id": "32654",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3139,
    "description": "WGS 84 / UTM zone 55N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=55 +datum=WGS84 +units=m +no_defs",
    "srid": 32655,
    "auth_name": "EPSG",
    "auth_id": "32655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3140,
    "description": "WGS 84 / UTM zone 56N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=56 +datum=WGS84 +units=m +no_defs",
    "srid": 32656,
    "auth_name": "EPSG",
    "auth_id": "32656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3141,
    "description": "WGS 84 / UTM zone 57N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=57 +datum=WGS84 +units=m +no_defs",
    "srid": 32657,
    "auth_name": "EPSG",
    "auth_id": "32657",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3142,
    "description": "WGS 84 / UTM zone 58N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=58 +datum=WGS84 +units=m +no_defs",
    "srid": 32658,
    "auth_name": "EPSG",
    "auth_id": "32658",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3143,
    "description": "WGS 84 / UTM zone 59N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=59 +datum=WGS84 +units=m +no_defs",
    "srid": 32659,
    "auth_name": "EPSG",
    "auth_id": "32659",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3144,
    "description": "WGS 84 / UTM zone 60N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=60 +datum=WGS84 +units=m +no_defs",
    "srid": 32660,
    "auth_name": "EPSG",
    "auth_id": "32660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3145,
    "description": "WGS 84 / UPS North (N,E)",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs",
    "srid": 32661,
    "auth_name": "EPSG",
    "auth_id": "32661",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3147,
    "description": "WGS 84 / BLM 14N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-99 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs",
    "srid": 32664,
    "auth_name": "EPSG",
    "auth_id": "32664",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3148,
    "description": "WGS 84 / BLM 15N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs",
    "srid": 32665,
    "auth_name": "EPSG",
    "auth_id": "32665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3149,
    "description": "WGS 84 / BLM 16N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs",
    "srid": 32666,
    "auth_name": "EPSG",
    "auth_id": "32666",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3150,
    "description": "WGS 84 / BLM 17N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=WGS84 +units=us-ft +no_defs",
    "srid": 32667,
    "auth_name": "EPSG",
    "auth_id": "32667",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3151,
    "description": "WGS 84 / UTM zone 1S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=1 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32701,
    "auth_name": "EPSG",
    "auth_id": "32701",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3152,
    "description": "WGS 84 / UTM zone 2S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=2 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32702,
    "auth_name": "EPSG",
    "auth_id": "32702",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3153,
    "description": "WGS 84 / UTM zone 3S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=3 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32703,
    "auth_name": "EPSG",
    "auth_id": "32703",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3154,
    "description": "WGS 84 / UTM zone 4S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=4 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32704,
    "auth_name": "EPSG",
    "auth_id": "32704",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3155,
    "description": "WGS 84 / UTM zone 5S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=5 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32705,
    "auth_name": "EPSG",
    "auth_id": "32705",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3156,
    "description": "WGS 84 / UTM zone 6S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=6 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32706,
    "auth_name": "EPSG",
    "auth_id": "32706",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3157,
    "description": "WGS 84 / UTM zone 7S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=7 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32707,
    "auth_name": "EPSG",
    "auth_id": "32707",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3158,
    "description": "WGS 84 / UTM zone 8S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=8 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32708,
    "auth_name": "EPSG",
    "auth_id": "32708",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3159,
    "description": "WGS 84 / UTM zone 9S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=9 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32709,
    "auth_name": "EPSG",
    "auth_id": "32709",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3160,
    "description": "WGS 84 / UTM zone 10S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=10 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32710,
    "auth_name": "EPSG",
    "auth_id": "32710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3161,
    "description": "WGS 84 / UTM zone 11S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=11 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32711,
    "auth_name": "EPSG",
    "auth_id": "32711",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3162,
    "description": "WGS 84 / UTM zone 12S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=12 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32712,
    "auth_name": "EPSG",
    "auth_id": "32712",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3163,
    "description": "WGS 84 / UTM zone 13S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=13 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32713,
    "auth_name": "EPSG",
    "auth_id": "32713",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3164,
    "description": "WGS 84 / UTM zone 14S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=14 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32714,
    "auth_name": "EPSG",
    "auth_id": "32714",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3165,
    "description": "WGS 84 / UTM zone 15S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=15 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32715,
    "auth_name": "EPSG",
    "auth_id": "32715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3166,
    "description": "WGS 84 / UTM zone 16S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=16 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32716,
    "auth_name": "EPSG",
    "auth_id": "32716",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3167,
    "description": "WGS 84 / UTM zone 17S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=17 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32717,
    "auth_name": "EPSG",
    "auth_id": "32717",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3168,
    "description": "WGS 84 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=18 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32718,
    "auth_name": "EPSG",
    "auth_id": "32718",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3169,
    "description": "WGS 84 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=19 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32719,
    "auth_name": "EPSG",
    "auth_id": "32719",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3170,
    "description": "WGS 84 / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32720,
    "auth_name": "EPSG",
    "auth_id": "32720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3171,
    "description": "WGS 84 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=21 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32721,
    "auth_name": "EPSG",
    "auth_id": "32721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3172,
    "description": "WGS 84 / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=22 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32722,
    "auth_name": "EPSG",
    "auth_id": "32722",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3173,
    "description": "WGS 84 / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=23 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32723,
    "auth_name": "EPSG",
    "auth_id": "32723",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3174,
    "description": "WGS 84 / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=24 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32724,
    "auth_name": "EPSG",
    "auth_id": "32724",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3175,
    "description": "WGS 84 / UTM zone 25S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=25 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32725,
    "auth_name": "EPSG",
    "auth_id": "32725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3176,
    "description": "WGS 84 / UTM zone 26S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=26 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32726,
    "auth_name": "EPSG",
    "auth_id": "32726",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3177,
    "description": "WGS 84 / UTM zone 27S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=27 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32727,
    "auth_name": "EPSG",
    "auth_id": "32727",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3178,
    "description": "WGS 84 / UTM zone 28S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=28 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32728,
    "auth_name": "EPSG",
    "auth_id": "32728",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3179,
    "description": "WGS 84 / UTM zone 29S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=29 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32729,
    "auth_name": "EPSG",
    "auth_id": "32729",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3180,
    "description": "WGS 84 / UTM zone 30S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=30 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32730,
    "auth_name": "EPSG",
    "auth_id": "32730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3181,
    "description": "WGS 84 / UTM zone 31S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=31 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32731,
    "auth_name": "EPSG",
    "auth_id": "32731",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3182,
    "description": "WGS 84 / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=32 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32732,
    "auth_name": "EPSG",
    "auth_id": "32732",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3183,
    "description": "WGS 84 / UTM zone 33S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=33 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32733,
    "auth_name": "EPSG",
    "auth_id": "32733",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3184,
    "description": "WGS 84 / UTM zone 34S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=34 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32734,
    "auth_name": "EPSG",
    "auth_id": "32734",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3185,
    "description": "WGS 84 / UTM zone 35S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=35 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32735,
    "auth_name": "EPSG",
    "auth_id": "32735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3186,
    "description": "WGS 84 / UTM zone 36S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=36 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32736,
    "auth_name": "EPSG",
    "auth_id": "32736",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3187,
    "description": "WGS 84 / UTM zone 37S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=37 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32737,
    "auth_name": "EPSG",
    "auth_id": "32737",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3188,
    "description": "WGS 84 / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=38 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32738,
    "auth_name": "EPSG",
    "auth_id": "32738",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3189,
    "description": "WGS 84 / UTM zone 39S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32739,
    "auth_name": "EPSG",
    "auth_id": "32739",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3190,
    "description": "WGS 84 / UTM zone 40S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=40 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32740,
    "auth_name": "EPSG",
    "auth_id": "32740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3191,
    "description": "WGS 84 / UTM zone 41S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=41 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32741,
    "auth_name": "EPSG",
    "auth_id": "32741",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3192,
    "description": "WGS 84 / UTM zone 42S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32742,
    "auth_name": "EPSG",
    "auth_id": "32742",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3193,
    "description": "WGS 84 / UTM zone 43S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32743,
    "auth_name": "EPSG",
    "auth_id": "32743",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3194,
    "description": "WGS 84 / UTM zone 44S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=44 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32744,
    "auth_name": "EPSG",
    "auth_id": "32744",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3195,
    "description": "WGS 84 / UTM zone 45S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=45 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32745,
    "auth_name": "EPSG",
    "auth_id": "32745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3196,
    "description": "WGS 84 / UTM zone 46S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=46 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32746,
    "auth_name": "EPSG",
    "auth_id": "32746",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3197,
    "description": "WGS 84 / UTM zone 47S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=47 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32747,
    "auth_name": "EPSG",
    "auth_id": "32747",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3198,
    "description": "WGS 84 / UTM zone 48S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=48 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32748,
    "auth_name": "EPSG",
    "auth_id": "32748",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3199,
    "description": "WGS 84 / UTM zone 49S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=49 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32749,
    "auth_name": "EPSG",
    "auth_id": "32749",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3200,
    "description": "WGS 84 / UTM zone 50S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=50 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32750,
    "auth_name": "EPSG",
    "auth_id": "32750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3201,
    "description": "WGS 84 / UTM zone 51S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=51 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32751,
    "auth_name": "EPSG",
    "auth_id": "32751",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3202,
    "description": "WGS 84 / UTM zone 52S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=52 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32752,
    "auth_name": "EPSG",
    "auth_id": "32752",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3203,
    "description": "WGS 84 / UTM zone 53S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=53 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32753,
    "auth_name": "EPSG",
    "auth_id": "32753",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3204,
    "description": "WGS 84 / UTM zone 54S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=54 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32754,
    "auth_name": "EPSG",
    "auth_id": "32754",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3205,
    "description": "WGS 84 / UTM zone 55S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=55 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32755,
    "auth_name": "EPSG",
    "auth_id": "32755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3206,
    "description": "WGS 84 / UTM zone 56S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=56 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32756,
    "auth_name": "EPSG",
    "auth_id": "32756",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3207,
    "description": "WGS 84 / UTM zone 57S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=57 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32757,
    "auth_name": "EPSG",
    "auth_id": "32757",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3208,
    "description": "WGS 84 / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=58 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32758,
    "auth_name": "EPSG",
    "auth_id": "32758",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3209,
    "description": "WGS 84 / UTM zone 59S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=59 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32759,
    "auth_name": "EPSG",
    "auth_id": "32759",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3210,
    "description": "WGS 84 / UTM zone 60S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=60 +south +datum=WGS84 +units=m +no_defs",
    "srid": 32760,
    "auth_name": "EPSG",
    "auth_id": "32760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3211,
    "description": "WGS 84 / UPS South (N,E)",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs",
    "srid": 32761,
    "auth_name": "EPSG",
    "auth_id": "32761",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3212,
    "description": "WGS 84 / TM 36 SE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs",
    "srid": 32766,
    "auth_name": "EPSG",
    "auth_id": "32766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 3256,
    "description": "Greek",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4120,
    "auth_name": "EPSG",
    "auth_id": "4120",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3257,
    "description": "GGRS87",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=-199.87,74.79,246.62,0,0,0,0 +no_defs",
    "srid": 4121,
    "auth_name": "EPSG",
    "auth_id": "4121",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3258,
    "description": "ATS77",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378135 +rf=298.257 +no_defs",
    "srid": 4122,
    "auth_name": "EPSG",
    "auth_id": "4122",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3259,
    "description": "KKJ",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-96.062,-82.428,-121.753,4.801,0.345,-1.376,1.496 +no_defs",
    "srid": 4123,
    "auth_name": "EPSG",
    "auth_id": "4123",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3260,
    "description": "RT90",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +no_defs",
    "srid": 4124,
    "auth_name": "EPSG",
    "auth_id": "4124",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3263,
    "description": "Tete",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=-80,-100,-228,0,0,0,0 +no_defs",
    "srid": 4127,
    "auth_name": "EPSG",
    "auth_id": "4127",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3264,
    "description": "Madzansua",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4128,
    "auth_name": "EPSG",
    "auth_id": "4128",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3265,
    "description": "Observatario",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=-132,-110,-335,0,0,0,0 +no_defs",
    "srid": 4129,
    "auth_name": "EPSG",
    "auth_id": "4129",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3266,
    "description": "Moznet",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4130,
    "auth_name": "EPSG",
    "auth_id": "4130",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3267,
    "description": "Indian 1960",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=longlat +ellps=evrst30 +no_defs",
    "srid": 4131,
    "auth_name": "EPSG",
    "auth_id": "4131",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3268,
    "description": "FD58",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4132,
    "auth_name": "EPSG",
    "auth_id": "4132",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3269,
    "description": "EST92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0.055,-0.541,-0.185,0.0183,-0.0003,-0.007,-0.014 +no_defs",
    "srid": 4133,
    "auth_name": "EPSG",
    "auth_id": "4133",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3270,
    "description": "PSD93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +no_defs",
    "srid": 4134,
    "auth_name": "EPSG",
    "auth_id": "4134",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3271,
    "description": "Old Hawaiian",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +no_defs",
    "srid": 4135,
    "auth_name": "EPSG",
    "auth_id": "4135",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3272,
    "description": "St. Lawrence Island",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4136,
    "auth_name": "EPSG",
    "auth_id": "4136",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3273,
    "description": "St. Paul Island",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4137,
    "auth_name": "EPSG",
    "auth_id": "4137",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3274,
    "description": "St. George Island",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4138,
    "auth_name": "EPSG",
    "auth_id": "4138",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3275,
    "description": "Puerto Rico",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=11,72,-101,0,0,0,0 +no_defs",
    "srid": 4139,
    "auth_name": "EPSG",
    "auth_id": "4139",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3277,
    "description": "Israel 1993",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 4141,
    "auth_name": "EPSG",
    "auth_id": "4141",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3278,
    "description": "Locodjo 1965",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4142,
    "auth_name": "EPSG",
    "auth_id": "4142",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3279,
    "description": "Abidjan 1987",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-124.76,53,466.79,0,0,0,0 +no_defs",
    "srid": 4143,
    "auth_name": "EPSG",
    "auth_id": "4143",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3280,
    "description": "Kalianpur 1937",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=longlat +ellps=evrst30 +no_defs",
    "srid": 4144,
    "auth_name": "EPSG",
    "auth_id": "4144",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3281,
    "description": "Kalianpur 1962",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6377301.243 +rf=300.8017255 +no_defs",
    "srid": 4145,
    "auth_name": "EPSG",
    "auth_id": "4145",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3282,
    "description": "Kalianpur 1975",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6377299.151 +rf=300.8017255 +towgs84=295,736,257,0,0,0,0 +no_defs",
    "srid": 4146,
    "auth_name": "EPSG",
    "auth_id": "4146",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3283,
    "description": "Hanoi 1972",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 4147,
    "auth_name": "EPSG",
    "auth_id": "4147",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3284,
    "description": "Hartebeesthoek94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4148,
    "auth_name": "EPSG",
    "auth_id": "4148",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3285,
    "description": "CH1903",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +no_defs",
    "srid": 4149,
    "auth_name": "EPSG",
    "auth_id": "4149",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3286,
    "description": "CH1903+",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +no_defs",
    "srid": 4150,
    "auth_name": "EPSG",
    "auth_id": "4150",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3287,
    "description": "CHTRS95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4151,
    "auth_name": "EPSG",
    "auth_id": "4151",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3288,
    "description": "NAD83(HARN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4152,
    "auth_name": "EPSG",
    "auth_id": "4152",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3289,
    "description": "Rassadiran",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-133.63,-157.5,-158.62,0,0,0,0 +no_defs",
    "srid": 4153,
    "auth_name": "EPSG",
    "auth_id": "4153",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3290,
    "description": "ED50(ED77)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4154,
    "auth_name": "EPSG",
    "auth_id": "4154",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3291,
    "description": "Dabola 1981",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-83,37,124,0,0,0,0 +no_defs",
    "srid": 4155,
    "auth_name": "EPSG",
    "auth_id": "4155",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3292,
    "description": "S-JTSK",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=589,76,480,0,0,0,0 +no_defs",
    "srid": 4156,
    "auth_name": "EPSG",
    "auth_id": "4156",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3293,
    "description": "Mount Dillon",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378293.64520876 +b=6356617.98767984 +no_defs",
    "srid": 4157,
    "auth_name": "EPSG",
    "auth_id": "4157",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3294,
    "description": "Naparima 1955",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4158,
    "auth_name": "EPSG",
    "auth_id": "4158",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3295,
    "description": "ELD79",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4159,
    "auth_name": "EPSG",
    "auth_id": "4159",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3296,
    "description": "Chos Malal 1914",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4160,
    "auth_name": "EPSG",
    "auth_id": "4160",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3297,
    "description": "Pampa del Castillo",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4161,
    "auth_name": "EPSG",
    "auth_id": "4161",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3298,
    "description": "Korean 1985",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4162,
    "auth_name": "EPSG",
    "auth_id": "4162",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3299,
    "description": "Yemen NGN96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4163,
    "auth_name": "EPSG",
    "auth_id": "4163",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3300,
    "description": "South Yemen",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +towgs84=-76,-138,67,0,0,0,0 +no_defs",
    "srid": 4164,
    "auth_name": "EPSG",
    "auth_id": "4164",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3301,
    "description": "Bissau",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-173,253,27,0,0,0,0 +no_defs",
    "srid": 4165,
    "auth_name": "EPSG",
    "auth_id": "4165",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3302,
    "description": "Korean 1995",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4166,
    "auth_name": "EPSG",
    "auth_id": "4166",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3303,
    "description": "NZGD2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4167,
    "auth_name": "EPSG",
    "auth_id": "4167",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3304,
    "description": "Accra",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378300 +rf=296 +towgs84=-199,32,322,0,0,0,0 +no_defs",
    "srid": 4168,
    "auth_name": "EPSG",
    "auth_id": "4168",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3305,
    "description": "American Samoa 1962",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=-115,118,426,0,0,0,0 +no_defs",
    "srid": 4169,
    "auth_name": "EPSG",
    "auth_id": "4169",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3306,
    "description": "SIRGAS 1995",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4170,
    "auth_name": "EPSG",
    "auth_id": "4170",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3307,
    "description": "RGF93 v1",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4171,
    "auth_name": "EPSG",
    "auth_id": "4171",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3309,
    "description": "IRENET95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4173,
    "auth_name": "EPSG",
    "auth_id": "4173",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3310,
    "description": "Sierra Leone 1924",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378300 +rf=296 +no_defs",
    "srid": 4174,
    "auth_name": "EPSG",
    "auth_id": "4174",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3311,
    "description": "Sierra Leone 1968",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-88,4,101,0,0,0,0 +no_defs",
    "srid": 4175,
    "auth_name": "EPSG",
    "auth_id": "4175",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3312,
    "description": "Australian Antarctic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4176,
    "auth_name": "EPSG",
    "auth_id": "4176",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3313,
    "description": "Pulkovo 1942(83)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 4178,
    "auth_name": "EPSG",
    "auth_id": "4178",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3314,
    "description": "Pulkovo 1942(58)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 4179,
    "auth_name": "EPSG",
    "auth_id": "4179",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3315,
    "description": "EST97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4180,
    "auth_name": "EPSG",
    "auth_id": "4180",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3316,
    "description": "LUREF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-189.6806,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598 +no_defs",
    "srid": 4181,
    "auth_name": "EPSG",
    "auth_id": "4181",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3317,
    "description": "Azores Occidental 1939",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4182,
    "auth_name": "EPSG",
    "auth_id": "4182",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3318,
    "description": "Azores Central 1948",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-104,167,-38,0,0,0,0 +no_defs",
    "srid": 4183,
    "auth_name": "EPSG",
    "auth_id": "4183",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3319,
    "description": "Azores Oriental 1940",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-203,141,53,0,0,0,0 +no_defs",
    "srid": 4184,
    "auth_name": "EPSG",
    "auth_id": "4184",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3321,
    "description": "OSNI 1952",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "airy",
    "parameters": "+proj=longlat +ellps=airy +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +no_defs",
    "srid": 4188,
    "auth_name": "EPSG",
    "auth_id": "4188",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3322,
    "description": "REGVEN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4189,
    "auth_name": "EPSG",
    "auth_id": "4189",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3323,
    "description": "POSGAR 98",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4190,
    "auth_name": "EPSG",
    "auth_id": "4190",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3324,
    "description": "Albanian 1987",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +towgs84=-44.183,-0.58,-38.489,2.3867,2.7072,-3.5196,-8.2703 +no_defs",
    "srid": 4191,
    "auth_name": "EPSG",
    "auth_id": "4191",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3325,
    "description": "Douala 1948",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-206.1,-174.7,-87.7,0,0,0,0 +no_defs",
    "srid": 4192,
    "auth_name": "EPSG",
    "auth_id": "4192",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3326,
    "description": "Manoca 1962",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-70.9,-151.8,-41.4,0,0,0,0 +no_defs",
    "srid": 4193,
    "auth_name": "EPSG",
    "auth_id": "4193",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3327,
    "description": "Qornoq 1927",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4194,
    "auth_name": "EPSG",
    "auth_id": "4194",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3328,
    "description": "Scoresbysund 1952",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=105,326,-102.5,0,0,0.814,-0.6 +no_defs",
    "srid": 4195,
    "auth_name": "EPSG",
    "auth_id": "4195",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3329,
    "description": "Ammassalik 1958",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-45,417,-3.5,0,0,0.814,-0.6 +no_defs",
    "srid": 4196,
    "auth_name": "EPSG",
    "auth_id": "4196",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3330,
    "description": "Garoua",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4197,
    "auth_name": "EPSG",
    "auth_id": "4197",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3331,
    "description": "Kousseri",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4198,
    "auth_name": "EPSG",
    "auth_id": "4198",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3332,
    "description": "Egypt 1930",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4199,
    "auth_name": "EPSG",
    "auth_id": "4199",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3333,
    "description": "Pulkovo 1995",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +towgs84=24.47,-130.89,-81.56,0,0,0.13,-0.22 +no_defs",
    "srid": 4200,
    "auth_name": "EPSG",
    "auth_id": "4200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3334,
    "description": "Adindan",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-166,-15,204,0,0,0,0 +no_defs",
    "srid": 4201,
    "auth_name": "EPSG",
    "auth_id": "4201",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3335,
    "description": "AGD66",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=longlat +ellps=aust_SA +no_defs",
    "srid": 4202,
    "auth_name": "EPSG",
    "auth_id": "4202",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3336,
    "description": "AGD84",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=longlat +ellps=aust_SA +no_defs",
    "srid": 4203,
    "auth_name": "EPSG",
    "auth_id": "4203",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3337,
    "description": "Ain el Abd",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +no_defs",
    "srid": 4204,
    "auth_name": "EPSG",
    "auth_id": "4204",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3338,
    "description": "Afgooye",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +towgs84=-43,-163,45,0,0,0,0 +no_defs",
    "srid": 4205,
    "auth_name": "EPSG",
    "auth_id": "4205",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3339,
    "description": "Agadez",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +no_defs",
    "srid": 4206,
    "auth_name": "EPSG",
    "auth_id": "4206",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3340,
    "description": "Lisbon",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4207,
    "auth_name": "EPSG",
    "auth_id": "4207",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3341,
    "description": "Aratu",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4208,
    "auth_name": "EPSG",
    "auth_id": "4208",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3342,
    "description": "Arc 1950",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.4663077 +towgs84=-143,-90,-294,0,0,0,0 +no_defs",
    "srid": 4209,
    "auth_name": "EPSG",
    "auth_id": "4209",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3343,
    "description": "Arc 1960",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4210,
    "auth_name": "EPSG",
    "auth_id": "4210",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3344,
    "description": "Batavia",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4211,
    "auth_name": "EPSG",
    "auth_id": "4211",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3345,
    "description": "Barbados 1938",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=31.95,300.99,419.19,0,0,0,0 +no_defs",
    "srid": 4212,
    "auth_name": "EPSG",
    "auth_id": "4212",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3346,
    "description": "Beduaram",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-106,-87,188,0,0,0,0 +no_defs",
    "srid": 4213,
    "auth_name": "EPSG",
    "auth_id": "4213",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3347,
    "description": "Beijing 1954",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 4214,
    "auth_name": "EPSG",
    "auth_id": "4214",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3348,
    "description": "BD50",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4215,
    "auth_name": "EPSG",
    "auth_id": "4215",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3349,
    "description": "Bermuda 1957",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4216,
    "auth_name": "EPSG",
    "auth_id": "4216",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3350,
    "description": "Bogota 1975",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=307,304,-318,0,0,0,0 +no_defs",
    "srid": 4218,
    "auth_name": "EPSG",
    "auth_id": "4218",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3351,
    "description": "Bukit Rimpah",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=-384,664,-48,0,0,0,0 +no_defs",
    "srid": 4219,
    "auth_name": "EPSG",
    "auth_id": "4219",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3352,
    "description": "Camacupa 1948",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4220,
    "auth_name": "EPSG",
    "auth_id": "4220",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3353,
    "description": "Campo Inchauspe",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-148,136,90,0,0,0,0 +no_defs",
    "srid": 4221,
    "auth_name": "EPSG",
    "auth_id": "4221",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3354,
    "description": "Cape",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.4663077 +no_defs",
    "srid": 4222,
    "auth_name": "EPSG",
    "auth_id": "4222",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3355,
    "description": "Carthage",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-263,6,431,0,0,0,0 +no_defs",
    "srid": 4223,
    "auth_name": "EPSG",
    "auth_id": "4223",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3356,
    "description": "Chua",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4224,
    "auth_name": "EPSG",
    "auth_id": "4224",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3357,
    "description": "Corrego Alegre 1970-72",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4225,
    "auth_name": "EPSG",
    "auth_id": "4225",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3359,
    "description": "Deir ez Zor",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +no_defs",
    "srid": 4227,
    "auth_name": "EPSG",
    "auth_id": "4227",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3361,
    "description": "Egypt 1907",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=longlat +ellps=helmert +towgs84=-130,110,-13,0,0,0,0 +no_defs",
    "srid": 4229,
    "auth_name": "EPSG",
    "auth_id": "4229",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3362,
    "description": "ED50",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4230,
    "auth_name": "EPSG",
    "auth_id": "4230",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3363,
    "description": "ED87",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-83.11,-97.38,-117.22,0.00569290865241986,-0.0446975835137458,0.0442850539012516,0.1218 +no_defs",
    "srid": 4231,
    "auth_name": "EPSG",
    "auth_id": "4231",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3364,
    "description": "Fahud",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4232,
    "auth_name": "EPSG",
    "auth_id": "4232",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3368,
    "description": "Hu Tzu Shan 1950",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-637,-549,-203,0,0,0,0 +no_defs",
    "srid": 4236,
    "auth_name": "EPSG",
    "auth_id": "4236",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3369,
    "description": "HD72",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS67",
    "parameters": "+proj=longlat +ellps=GRS67 +no_defs",
    "srid": 4237,
    "auth_name": "EPSG",
    "auth_id": "4237",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3370,
    "description": "ID74",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378160 +rf=298.247 +no_defs",
    "srid": 4238,
    "auth_name": "EPSG",
    "auth_id": "4238",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3371,
    "description": "Indian 1954",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=longlat +ellps=evrst30 +no_defs",
    "srid": 4239,
    "auth_name": "EPSG",
    "auth_id": "4239",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3372,
    "description": "Indian 1975",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=longlat +ellps=evrst30 +towgs84=210,814,289,0,0,0,0 +no_defs",
    "srid": 4240,
    "auth_name": "EPSG",
    "auth_id": "4240",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3373,
    "description": "Jamaica 1875",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.14480801 +b=6356514.96620413 +no_defs",
    "srid": 4241,
    "auth_name": "EPSG",
    "auth_id": "4241",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3374,
    "description": "JAD69",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4242,
    "auth_name": "EPSG",
    "auth_id": "4242",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3375,
    "description": "Kalianpur 1880",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6377299.36559538 +b=6356098.35900516 +no_defs",
    "srid": 4243,
    "auth_name": "EPSG",
    "auth_id": "4243",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3376,
    "description": "Kandawala",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=longlat +ellps=evrst30 +towgs84=-97,787,86,0,0,0,0 +no_defs",
    "srid": 4244,
    "auth_name": "EPSG",
    "auth_id": "4244",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3377,
    "description": "Kertau 1968",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=longlat +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +no_defs",
    "srid": 4245,
    "auth_name": "EPSG",
    "auth_id": "4245",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3378,
    "description": "KOC",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-294.7,-200.1,525.5,0,0,0,0 +no_defs",
    "srid": 4246,
    "auth_name": "EPSG",
    "auth_id": "4246",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3379,
    "description": "La Canoa",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4247,
    "auth_name": "EPSG",
    "auth_id": "4247",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3380,
    "description": "PSAD56",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4248,
    "auth_name": "EPSG",
    "auth_id": "4248",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3381,
    "description": "Lake",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4249,
    "auth_name": "EPSG",
    "auth_id": "4249",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3382,
    "description": "Leigon",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-130,29,364,0,0,0,0 +no_defs",
    "srid": 4250,
    "auth_name": "EPSG",
    "auth_id": "4250",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3383,
    "description": "Liberia 1964",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-90,40,88,0,0,0,0 +no_defs",
    "srid": 4251,
    "auth_name": "EPSG",
    "auth_id": "4251",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3384,
    "description": "Lome",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +no_defs",
    "srid": 4252,
    "auth_name": "EPSG",
    "auth_id": "4252",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3385,
    "description": "Luzon 1911",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4253,
    "auth_name": "EPSG",
    "auth_id": "4253",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3386,
    "description": "Hito XVIII 1963",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4254,
    "auth_name": "EPSG",
    "auth_id": "4254",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3387,
    "description": "Herat North",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-333,-222,114,0,0,0,0 +no_defs",
    "srid": 4255,
    "auth_name": "EPSG",
    "auth_id": "4255",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3388,
    "description": "Mahe 1971",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=41,-220,-134,0,0,0,0 +no_defs",
    "srid": 4256,
    "auth_name": "EPSG",
    "auth_id": "4256",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3389,
    "description": "Makassar",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=-587.8,519.75,145.76,0,0,0,0 +no_defs",
    "srid": 4257,
    "auth_name": "EPSG",
    "auth_id": "4257",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3390,
    "description": "ETRS89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4258,
    "auth_name": "EPSG",
    "auth_id": "4258",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3391,
    "description": "Malongo 1987",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-254.1,-5.36,-100.29,0,0,0,0 +no_defs",
    "srid": 4259,
    "auth_name": "EPSG",
    "auth_id": "4259",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3393,
    "description": "Merchich",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +no_defs",
    "srid": 4261,
    "auth_name": "EPSG",
    "auth_id": "4261",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3394,
    "description": "Massawa",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=639,405,60,0,0,0,0 +no_defs",
    "srid": 4262,
    "auth_name": "EPSG",
    "auth_id": "4262",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3395,
    "description": "Minna",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-92,-93,122,0,0,0,0 +no_defs",
    "srid": 4263,
    "auth_name": "EPSG",
    "auth_id": "4263",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3397,
    "description": "Monte Mario",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4265,
    "auth_name": "EPSG",
    "auth_id": "4265",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3398,
    "description": "M'poraloko",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +no_defs",
    "srid": 4266,
    "auth_name": "EPSG",
    "auth_id": "4266",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3399,
    "description": "NAD27",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=longlat +datum=NAD27 +no_defs",
    "srid": 4267,
    "auth_name": "EPSG",
    "auth_id": "4267",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3401,
    "description": "NAD83",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=longlat +datum=NAD83 +no_defs",
    "srid": 4269,
    "auth_name": "EPSG",
    "auth_id": "4269",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3402,
    "description": "Nahrwan 1967",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4270,
    "auth_name": "EPSG",
    "auth_id": "4270",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3403,
    "description": "Naparima 1972",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4271,
    "auth_name": "EPSG",
    "auth_id": "4271",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3404,
    "description": "NZGD49",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4272,
    "auth_name": "EPSG",
    "auth_id": "4272",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3405,
    "description": "NGO 1948",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6377492.018 +rf=299.1528128 +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +no_defs",
    "srid": 4273,
    "auth_name": "EPSG",
    "auth_id": "4273",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3406,
    "description": "Datum 73",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4274,
    "auth_name": "EPSG",
    "auth_id": "4274",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3407,
    "description": "NTF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +no_defs",
    "srid": 4275,
    "auth_name": "EPSG",
    "auth_id": "4275",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3408,
    "description": "NSWC 9Z-2",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "NWL9D",
    "parameters": "+proj=longlat +ellps=NWL9D +no_defs",
    "srid": 4276,
    "auth_name": "EPSG",
    "auth_id": "4276",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3409,
    "description": "OSGB36",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "airy",
    "parameters": "+proj=longlat +ellps=airy +no_defs",
    "srid": 4277,
    "auth_name": "EPSG",
    "auth_id": "4277",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3410,
    "description": "OSGB70",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "airy",
    "parameters": "+proj=longlat +ellps=airy +no_defs",
    "srid": 4278,
    "auth_name": "EPSG",
    "auth_id": "4278",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3411,
    "description": "OS(SN)80",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "airy",
    "parameters": "+proj=longlat +ellps=airy +no_defs",
    "srid": 4279,
    "auth_name": "EPSG",
    "auth_id": "4279",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3413,
    "description": "Palestine 1923",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378300.789 +b=6356566.435 +no_defs",
    "srid": 4281,
    "auth_name": "EPSG",
    "auth_id": "4281",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3414,
    "description": "Pointe Noire",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-148,51,-291,0,0,0,0 +no_defs",
    "srid": 4282,
    "auth_name": "EPSG",
    "auth_id": "4282",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3415,
    "description": "GDA94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 4283,
    "auth_name": "EPSG",
    "auth_id": "4283",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3416,
    "description": "Pulkovo 1942",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +towgs84=25,-141,-78.5,0,0.35,0.736,0 +no_defs",
    "srid": 4284,
    "auth_name": "EPSG",
    "auth_id": "4284",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3417,
    "description": "Qatar 1974",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4285,
    "auth_name": "EPSG",
    "auth_id": "4285",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3418,
    "description": "Qatar 1948",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=longlat +ellps=helmert +no_defs",
    "srid": 4286,
    "auth_name": "EPSG",
    "auth_id": "4286",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3420,
    "description": "Loma Quintana",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4288,
    "auth_name": "EPSG",
    "auth_id": "4288",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3421,
    "description": "Amersfoort",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4289,
    "auth_name": "EPSG",
    "auth_id": "4289",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3423,
    "description": "Sapper Hill 1943",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4292,
    "auth_name": "EPSG",
    "auth_id": "4292",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3424,
    "description": "Schwarzeck",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=longlat +ellps=bess_nam +no_defs",
    "srid": 4293,
    "auth_name": "EPSG",
    "auth_id": "4293",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3426,
    "description": "Serindung",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4295,
    "auth_name": "EPSG",
    "auth_id": "4295",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3428,
    "description": "Tananarive",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4297,
    "auth_name": "EPSG",
    "auth_id": "4297",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3429,
    "description": "Timbalai 1948",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrstSS",
    "parameters": "+proj=longlat +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +no_defs",
    "srid": 4298,
    "auth_name": "EPSG",
    "auth_id": "4298",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3430,
    "description": "TM65",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6377340.189 +rf=299.3249646 +towgs84=482.5,-130.6,564.6,-1.042,-0.214,-0.631,8.15 +no_defs",
    "srid": 4299,
    "auth_name": "EPSG",
    "auth_id": "4299",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3431,
    "description": "TM75",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6377340.189 +rf=299.3249646 +no_defs",
    "srid": 4300,
    "auth_name": "EPSG",
    "auth_id": "4300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3432,
    "description": "Tokyo",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +no_defs",
    "srid": 4301,
    "auth_name": "EPSG",
    "auth_id": "4301",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3433,
    "description": "Trinidad 1903",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378293.64520876 +b=6356617.98767984 +no_defs",
    "srid": 4302,
    "auth_name": "EPSG",
    "auth_id": "4302",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3434,
    "description": "TC(1948)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=longlat +ellps=helmert +no_defs",
    "srid": 4303,
    "auth_name": "EPSG",
    "auth_id": "4303",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3435,
    "description": "Voirol 1875",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-73,-247,227,0,0,0,0 +no_defs",
    "srid": 4304,
    "auth_name": "EPSG",
    "auth_id": "4304",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3436,
    "description": "Bern 1938",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4306,
    "auth_name": "EPSG",
    "auth_id": "4306",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3437,
    "description": "Nord Sahara 1959",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-267.407,-47.068,446.357,-0.179423,5.577661,-1.27762,1.204866 +no_defs",
    "srid": 4307,
    "auth_name": "EPSG",
    "auth_id": "4307",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3438,
    "description": "RT38",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4308,
    "auth_name": "EPSG",
    "auth_id": "4308",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3439,
    "description": "Yacare",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4309,
    "auth_name": "EPSG",
    "auth_id": "4309",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3440,
    "description": "Yoff",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-30,190,89,0,0,0,0 +no_defs",
    "srid": 4310,
    "auth_name": "EPSG",
    "auth_id": "4310",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3441,
    "description": "Zanderij",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-265,120,-358,0,0,0,0 +no_defs",
    "srid": 4311,
    "auth_name": "EPSG",
    "auth_id": "4311",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3442,
    "description": "MGI",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +no_defs",
    "srid": 4312,
    "auth_name": "EPSG",
    "auth_id": "4312",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3443,
    "description": "BD72",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4313,
    "auth_name": "EPSG",
    "auth_id": "4313",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3444,
    "description": "DHDN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +no_defs",
    "srid": 4314,
    "auth_name": "EPSG",
    "auth_id": "4314",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3445,
    "description": "Conakry 1905",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-23,259,-9,0,0,0,0 +no_defs",
    "srid": 4315,
    "auth_name": "EPSG",
    "auth_id": "4315",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3446,
    "description": "Dealul Piscului 1930",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=103.25,-100.4,-307.19,0,0,0,0 +no_defs",
    "srid": 4316,
    "auth_name": "EPSG",
    "auth_id": "4316",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3448,
    "description": "NGN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=-3.2,-5.7,2.8,0,0,0,0 +no_defs",
    "srid": 4318,
    "auth_name": "EPSG",
    "auth_id": "4318",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3449,
    "description": "KUDAMS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 4319,
    "auth_name": "EPSG",
    "auth_id": "4319",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3450,
    "description": "WGS 72",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +no_defs",
    "srid": 4322,
    "auth_name": "EPSG",
    "auth_id": "4322",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3451,
    "description": "WGS 72BE",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +no_defs",
    "srid": 4324,
    "auth_name": "EPSG",
    "auth_id": "4324",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3452,
    "description": "WGS 84",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +no_defs",
    "srid": 4326,
    "auth_name": "EPSG",
    "auth_id": "4326",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3453,
    "description": "Anguilla 1957",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4600,
    "auth_name": "EPSG",
    "auth_id": "4600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3454,
    "description": "Antigua 1943",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4601,
    "auth_name": "EPSG",
    "auth_id": "4601",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3455,
    "description": "Dominica 1945",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=725,685,536,0,0,0,0 +no_defs",
    "srid": 4602,
    "auth_name": "EPSG",
    "auth_id": "4602",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3456,
    "description": "Grenada 1953",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4603,
    "auth_name": "EPSG",
    "auth_id": "4603",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3457,
    "description": "Montserrat 1958",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=174,359,365,0,0,0,0 +no_defs",
    "srid": 4604,
    "auth_name": "EPSG",
    "auth_id": "4604",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3458,
    "description": "St. Kitts 1955",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4605,
    "auth_name": "EPSG",
    "auth_id": "4605",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3459,
    "description": "St. Lucia 1955",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4606,
    "auth_name": "EPSG",
    "auth_id": "4606",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3460,
    "description": "St. Vincent 1945",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=195.671,332.517,274.607,0,0,0,0 +no_defs",
    "srid": 4607,
    "auth_name": "EPSG",
    "auth_id": "4607",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3461,
    "description": "NAD27(76)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4608,
    "auth_name": "EPSG",
    "auth_id": "4608",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3462,
    "description": "NAD27(CGQ77)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4609,
    "auth_name": "EPSG",
    "auth_id": "4609",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3463,
    "description": "Xian 1980",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "IAU76",
    "parameters": "+proj=longlat +ellps=IAU76 +no_defs",
    "srid": 4610,
    "auth_name": "EPSG",
    "auth_id": "4610",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3464,
    "description": "Hong Kong 1980",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.243648,-1.158828,-1.094246 +no_defs",
    "srid": 4611,
    "auth_name": "EPSG",
    "auth_id": "4611",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3465,
    "description": "JGD2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4612,
    "auth_name": "EPSG",
    "auth_id": "4612",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3466,
    "description": "Segara",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=-403,684,41,0,0,0,0 +no_defs",
    "srid": 4613,
    "auth_name": "EPSG",
    "auth_id": "4613",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3467,
    "description": "QND95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-119.4248,-303.65872,-11.00061,1.164298,0.174458,1.096259,3.657065 +no_defs",
    "srid": 4614,
    "auth_name": "EPSG",
    "auth_id": "4614",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3468,
    "description": "Porto Santo",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-499,-249,314,0,0,0,0 +no_defs",
    "srid": 4615,
    "auth_name": "EPSG",
    "auth_id": "4615",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3469,
    "description": "Selvagem Grande",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-289,-124,60,0,0,0,0 +no_defs",
    "srid": 4616,
    "auth_name": "EPSG",
    "auth_id": "4616",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3470,
    "description": "NAD83(CSRS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 4617,
    "auth_name": "EPSG",
    "auth_id": "4617",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3471,
    "description": "SAD69",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=longlat +ellps=aust_SA +no_defs",
    "srid": 4618,
    "auth_name": "EPSG",
    "auth_id": "4618",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3472,
    "description": "SWEREF99",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4619,
    "auth_name": "EPSG",
    "auth_id": "4619",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3473,
    "description": "Point 58",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4620,
    "auth_name": "EPSG",
    "auth_id": "4620",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3474,
    "description": "Fort Marigot",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=137,248,-430,0,0,0,0 +no_defs",
    "srid": 4621,
    "auth_name": "EPSG",
    "auth_id": "4621",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3475,
    "description": "Guadeloupe 1948",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4622,
    "auth_name": "EPSG",
    "auth_id": "4622",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3476,
    "description": "CSG67",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-186,230,110,0,0,0,0 +no_defs",
    "srid": 4623,
    "auth_name": "EPSG",
    "auth_id": "4623",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3477,
    "description": "RGFG95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4624,
    "auth_name": "EPSG",
    "auth_id": "4624",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3478,
    "description": "Martinique 1938",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4625,
    "auth_name": "EPSG",
    "auth_id": "4625",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3479,
    "description": "Reunion 1947",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +no_defs",
    "srid": 4626,
    "auth_name": "EPSG",
    "auth_id": "4626",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3480,
    "description": "RGR92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4627,
    "auth_name": "EPSG",
    "auth_id": "4627",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3481,
    "description": "Tahiti 52",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=162,117,154,0,0,0,0 +no_defs",
    "srid": 4628,
    "auth_name": "EPSG",
    "auth_id": "4628",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3482,
    "description": "Tahaa 54",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4629,
    "auth_name": "EPSG",
    "auth_id": "4629",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3483,
    "description": "IGN72 Nuku Hiva",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=84,274,65,0,0,0,0 +no_defs",
    "srid": 4630,
    "auth_name": "EPSG",
    "auth_id": "4630",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3485,
    "description": "Combani 1950",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +no_defs",
    "srid": 4632,
    "auth_name": "EPSG",
    "auth_id": "4632",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3486,
    "description": "IGN56 Lifou",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=335.47,222.58,-230.94,0,0,0,0 +no_defs",
    "srid": 4633,
    "auth_name": "EPSG",
    "auth_id": "4633",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3489,
    "description": "Petrels 1972",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=365,194,166,0,0,0,0 +no_defs",
    "srid": 4636,
    "auth_name": "EPSG",
    "auth_id": "4636",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3490,
    "description": "Perroud 1950",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=325,154,172,0,0,0,0 +no_defs",
    "srid": 4637,
    "auth_name": "EPSG",
    "auth_id": "4637",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3491,
    "description": "Saint Pierre et Miquelon 1950",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=11.363,424.148,373.13,0,0,0,0 +no_defs",
    "srid": 4638,
    "auth_name": "EPSG",
    "auth_id": "4638",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3492,
    "description": "MOP78",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=253,-132,-127,0,0,0,0 +no_defs",
    "srid": 4639,
    "auth_name": "EPSG",
    "auth_id": "4639",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3494,
    "description": "IGN53 Mare",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=287.58,177.78,-135.41,0,0,0,0 +no_defs",
    "srid": 4641,
    "auth_name": "EPSG",
    "auth_id": "4641",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3495,
    "description": "ST84 Ile des Pins",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +no_defs",
    "srid": 4642,
    "auth_name": "EPSG",
    "auth_id": "4642",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3496,
    "description": "ST71 Belep",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-480.26,-438.32,-643.429,16.3119,20.1721,-4.0349,-111.7002 +no_defs",
    "srid": 4643,
    "auth_name": "EPSG",
    "auth_id": "4643",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3497,
    "description": "NEA74 Noumea",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-10.18,-350.43,291.37,0,0,0,0 +no_defs",
    "srid": 4644,
    "auth_name": "EPSG",
    "auth_id": "4644",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3499,
    "description": "Grand Comoros",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-963,510,-359,0,0,0,0 +no_defs",
    "srid": 4646,
    "auth_name": "EPSG",
    "auth_id": "4646",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3500,
    "description": "Reykjavik 1900",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6377019.27 +rf=300 +towgs84=-28,199,5,0,0,0,0 +no_defs",
    "srid": 4657,
    "auth_name": "EPSG",
    "auth_id": "4657",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3501,
    "description": "Hjorsey 1955",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-73,47,-83,0,0,0,0 +no_defs",
    "srid": 4658,
    "auth_name": "EPSG",
    "auth_id": "4658",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3502,
    "description": "ISN93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4659,
    "auth_name": "EPSG",
    "auth_id": "4659",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3503,
    "description": "Helle 1954",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=982.6087,552.753,-540.873,6.68162662527694,-31.6114924086422,-19.8481610048168,16.805 +no_defs",
    "srid": 4660,
    "auth_name": "EPSG",
    "auth_id": "4660",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3504,
    "description": "LKS-92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4661,
    "auth_name": "EPSG",
    "auth_id": "4661",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3505,
    "description": "IGN72 Grande Terre",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-11.64,-348.6,291.98,0,0,0,0 +no_defs",
    "srid": 4662,
    "auth_name": "EPSG",
    "auth_id": "4662",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3506,
    "description": "Porto Santo 1995",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4663,
    "auth_name": "EPSG",
    "auth_id": "4663",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3507,
    "description": "Azores Oriental 1995",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4664,
    "auth_name": "EPSG",
    "auth_id": "4664",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3508,
    "description": "Azores Central 1995",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4665,
    "auth_name": "EPSG",
    "auth_id": "4665",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3509,
    "description": "Lisbon 1890",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4666,
    "auth_name": "EPSG",
    "auth_id": "4666",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3510,
    "description": "IKBD-92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4667,
    "auth_name": "EPSG",
    "auth_id": "4667",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3511,
    "description": "ED79",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-86,-98,-119,0,0,0,0 +no_defs",
    "srid": 4668,
    "auth_name": "EPSG",
    "auth_id": "4668",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3512,
    "description": "LKS94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4669,
    "auth_name": "EPSG",
    "auth_id": "4669",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3513,
    "description": "IGM95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4670,
    "auth_name": "EPSG",
    "auth_id": "4670",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3514,
    "description": "Voirol 1879",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +no_defs",
    "srid": 4671,
    "auth_name": "EPSG",
    "auth_id": "4671",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3515,
    "description": "Chatham Islands 1971",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=175,-38,113,0,0,0,0 +no_defs",
    "srid": 4672,
    "auth_name": "EPSG",
    "auth_id": "4672",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3516,
    "description": "Chatham Islands 1979",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=174.05,-25.49,112.57,0,0,0.554,0.2263 +no_defs",
    "srid": 4673,
    "auth_name": "EPSG",
    "auth_id": "4673",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3517,
    "description": "SIRGAS 2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4674,
    "auth_name": "EPSG",
    "auth_id": "4674",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3518,
    "description": "Guam 1963",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4675,
    "auth_name": "EPSG",
    "auth_id": "4675",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3519,
    "description": "Vientiane 1982",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 4676,
    "auth_name": "EPSG",
    "auth_id": "4676",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3520,
    "description": "Lao 1993",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 4677,
    "auth_name": "EPSG",
    "auth_id": "4677",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3521,
    "description": "Lao 1997",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +towgs84=44.585,-131.212,-39.544,0,0,0,0 +no_defs",
    "srid": 4678,
    "auth_name": "EPSG",
    "auth_id": "4678",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3522,
    "description": "Jouik 1961",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-80.01,253.26,291.19,0,0,0,0 +no_defs",
    "srid": 4679,
    "auth_name": "EPSG",
    "auth_id": "4679",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3523,
    "description": "Nouakchott 1965",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4680,
    "auth_name": "EPSG",
    "auth_id": "4680",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3525,
    "description": "Gulshan 303",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=longlat +ellps=evrst30 +towgs84=283.729,735.942,261.143,0,0,0,0 +no_defs",
    "srid": 4682,
    "auth_name": "EPSG",
    "auth_id": "4682",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3526,
    "description": "PRS92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +no_defs",
    "srid": 4683,
    "auth_name": "EPSG",
    "auth_id": "4683",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3527,
    "description": "Gan 1970",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-133,-321,50,0,0,0,0 +no_defs",
    "srid": 4684,
    "auth_name": "EPSG",
    "auth_id": "4684",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3529,
    "description": "MAGNA-SIRGAS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4686,
    "auth_name": "EPSG",
    "auth_id": "4686",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3530,
    "description": "RGPF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 4687,
    "auth_name": "EPSG",
    "auth_id": "4687",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3531,
    "description": "Fatu Iva 72",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=347.175,1077.618,2623.677,33.9058,-70.6776,9.4013,186.0647 +no_defs",
    "srid": 4688,
    "auth_name": "EPSG",
    "auth_id": "4688",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3532,
    "description": "IGN63 Hiva Oa",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4689,
    "auth_name": "EPSG",
    "auth_id": "4689",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3533,
    "description": "Tahiti 79",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=221.597,152.441,176.523,2.403,1.3893,0.884,11.4648 +no_defs",
    "srid": 4690,
    "auth_name": "EPSG",
    "auth_id": "4690",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3534,
    "description": "Moorea 87",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=218.769,150.75,176.75,3.5231,2.0037,1.288,10.9817 +no_defs",
    "srid": 4691,
    "auth_name": "EPSG",
    "auth_id": "4691",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3535,
    "description": "Maupiti 83",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=217.109,86.452,23.711,0.0183,-0.0003,0.007,-0.0093 +no_defs",
    "srid": 4692,
    "auth_name": "EPSG",
    "auth_id": "4692",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3536,
    "description": "Nakhl-e Ghanem",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 4693,
    "auth_name": "EPSG",
    "auth_id": "4693",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3537,
    "description": "POSGAR 94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4694,
    "auth_name": "EPSG",
    "auth_id": "4694",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3538,
    "description": "Katanga 1955",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4695,
    "auth_name": "EPSG",
    "auth_id": "4695",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3539,
    "description": "Kasai 1953",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4696,
    "auth_name": "EPSG",
    "auth_id": "4696",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3540,
    "description": "IGC 1962 6th Parallel South",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4697,
    "auth_name": "EPSG",
    "auth_id": "4697",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3541,
    "description": "IGN 1962 Kerguelen",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=145,-187,103,0,0,0,0 +no_defs",
    "srid": 4698,
    "auth_name": "EPSG",
    "auth_id": "4698",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3542,
    "description": "Le Pouce 1934",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-770.1,158.4,-498.2,0,0,0,0 +no_defs",
    "srid": 4699,
    "auth_name": "EPSG",
    "auth_id": "4699",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3543,
    "description": "IGN Astro 1960",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4700,
    "auth_name": "EPSG",
    "auth_id": "4700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3544,
    "description": "IGCB 1955",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-79.9,-158,-168.9,0,0,0,0 +no_defs",
    "srid": 4701,
    "auth_name": "EPSG",
    "auth_id": "4701",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3545,
    "description": "Mauritania 1999",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4702,
    "auth_name": "EPSG",
    "auth_id": "4702",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3546,
    "description": "Mhast 1951",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4703,
    "auth_name": "EPSG",
    "auth_id": "4703",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3547,
    "description": "Mhast (onshore)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4704,
    "auth_name": "EPSG",
    "auth_id": "4704",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3548,
    "description": "Mhast (offshore)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4705,
    "auth_name": "EPSG",
    "auth_id": "4705",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3549,
    "description": "Egypt Gulf of Suez S-650 TL",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "helmert",
    "parameters": "+proj=longlat +ellps=helmert +towgs84=-146.21,112.63,4.05,0,0,0,0 +no_defs",
    "srid": 4706,
    "auth_name": "EPSG",
    "auth_id": "4706",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3550,
    "description": "Tern Island 1961",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=114,-116,-333,0,0,0,0 +no_defs",
    "srid": 4707,
    "auth_name": "EPSG",
    "auth_id": "4707",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3551,
    "description": "Cocos Islands 1965",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=longlat +ellps=aust_SA +towgs84=-491,-22,435,0,0,0,0 +no_defs",
    "srid": 4708,
    "auth_name": "EPSG",
    "auth_id": "4708",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3552,
    "description": "Iwo Jima 1945",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=145,75,-272,0,0,0,0 +no_defs",
    "srid": 4709,
    "auth_name": "EPSG",
    "auth_id": "4709",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3553,
    "description": "Astro DOS 71",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4710,
    "auth_name": "EPSG",
    "auth_id": "4710",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3554,
    "description": "Marcus Island 1952",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=124,-234,-25,0,0,0,0 +no_defs",
    "srid": 4711,
    "auth_name": "EPSG",
    "auth_id": "4711",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3555,
    "description": "Ascension Island 1958",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-205,107,53,0,0,0,0 +no_defs",
    "srid": 4712,
    "auth_name": "EPSG",
    "auth_id": "4712",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3556,
    "description": "Ayabelle Lighthouse",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4713,
    "auth_name": "EPSG",
    "auth_id": "4713",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3557,
    "description": "Bellevue",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-127,-769,472,0,0,0,0 +no_defs",
    "srid": 4714,
    "auth_name": "EPSG",
    "auth_id": "4714",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3558,
    "description": "Camp Area Astro",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-104,-129,239,0,0,0,0 +no_defs",
    "srid": 4715,
    "auth_name": "EPSG",
    "auth_id": "4715",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3559,
    "description": "Phoenix Islands 1966",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=298,-304,-375,0,0,0,0 +no_defs",
    "srid": 4716,
    "auth_name": "EPSG",
    "auth_id": "4716",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3560,
    "description": "Cape Canaveral",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=-2,151,181,0,0,0,0 +no_defs",
    "srid": 4717,
    "auth_name": "EPSG",
    "auth_id": "4717",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3561,
    "description": "Solomon 1968",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4718,
    "auth_name": "EPSG",
    "auth_id": "4718",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3562,
    "description": "Easter Island 1967",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=211,147,111,0,0,0,0 +no_defs",
    "srid": 4719,
    "auth_name": "EPSG",
    "auth_id": "4719",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3563,
    "description": "Fiji 1986",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +towgs84=0,0,4.5,0,0,0.554,0.2263 +no_defs",
    "srid": 4720,
    "auth_name": "EPSG",
    "auth_id": "4720",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3564,
    "description": "Fiji 1956",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=265.025,384.929,-194.046,0,0,0,0 +no_defs",
    "srid": 4721,
    "auth_name": "EPSG",
    "auth_id": "4721",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3565,
    "description": "South Georgia 1968",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-794,119,-298,0,0,0,0 +no_defs",
    "srid": 4722,
    "auth_name": "EPSG",
    "auth_id": "4722",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3566,
    "description": "GCGD59",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4723,
    "auth_name": "EPSG",
    "auth_id": "4723",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3567,
    "description": "Diego Garcia 1969",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=208,-435,-229,0,0,0,0 +no_defs",
    "srid": 4724,
    "auth_name": "EPSG",
    "auth_id": "4724",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3568,
    "description": "Johnston Island 1961",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=189,-79,-202,0,0,0,0 +no_defs",
    "srid": 4725,
    "auth_name": "EPSG",
    "auth_id": "4725",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3569,
    "description": "SIGD61",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 4726,
    "auth_name": "EPSG",
    "auth_id": "4726",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3570,
    "description": "Midway 1961",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=403,-81,277,0,0,0,0 +no_defs",
    "srid": 4727,
    "auth_name": "EPSG",
    "auth_id": "4727",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3571,
    "description": "PN84",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-307,-92,127,0,0,0,0 +no_defs",
    "srid": 4728,
    "auth_name": "EPSG",
    "auth_id": "4728",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3572,
    "description": "Pitcairn 1967",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=185,165,42,0,0,0,0 +no_defs",
    "srid": 4729,
    "auth_name": "EPSG",
    "auth_id": "4729",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3573,
    "description": "Santo 1965",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=170,42,84,0,0,0,0 +no_defs",
    "srid": 4730,
    "auth_name": "EPSG",
    "auth_id": "4730",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3575,
    "description": "Marshall Islands 1960",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "hough",
    "parameters": "+proj=longlat +ellps=hough +towgs84=102,52,-38,0,0,0,0 +no_defs",
    "srid": 4732,
    "auth_name": "EPSG",
    "auth_id": "4732",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3576,
    "description": "Wake Island 1952",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=276,-57,149,0,0,0,0 +no_defs",
    "srid": 4733,
    "auth_name": "EPSG",
    "auth_id": "4733",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3577,
    "description": "Tristan 1968",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-632,438,-609,0,0,0,0 +no_defs",
    "srid": 4734,
    "auth_name": "EPSG",
    "auth_id": "4734",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3578,
    "description": "Kusaie 1951",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=647,1777,-1124,0,0,0,0 +no_defs",
    "srid": 4735,
    "auth_name": "EPSG",
    "auth_id": "4735",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3579,
    "description": "Deception Island",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=260,12,-147,0,0,0,0 +no_defs",
    "srid": 4736,
    "auth_name": "EPSG",
    "auth_id": "4736",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3580,
    "description": "KGD2002",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4737,
    "auth_name": "EPSG",
    "auth_id": "4737",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3581,
    "description": "Hong Kong 1963",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378293.64520876 +b=6356617.98767984 +no_defs",
    "srid": 4738,
    "auth_name": "EPSG",
    "auth_id": "4738",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3582,
    "description": "Hong Kong 1963(67)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-156,-271,-189,0,0,0,0 +no_defs",
    "srid": 4739,
    "auth_name": "EPSG",
    "auth_id": "4739",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3583,
    "description": "PZ-90",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378136 +rf=298.257839303 +towgs84=0,0,1.5,0,0,0.076,0 +no_defs",
    "srid": 4740,
    "auth_name": "EPSG",
    "auth_id": "4740",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3584,
    "description": "FD54",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4741,
    "auth_name": "EPSG",
    "auth_id": "4741",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3585,
    "description": "GDM2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 4742,
    "auth_name": "EPSG",
    "auth_id": "4742",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3586,
    "description": "Karbala 1979",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=70.995,-335.916,262.898,0,0,0,0 +no_defs",
    "srid": 4743,
    "auth_name": "EPSG",
    "auth_id": "4743",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3587,
    "description": "Nahrwan 1934",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 4744,
    "auth_name": "EPSG",
    "auth_id": "4744",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3588,
    "description": "RD/83",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4745,
    "auth_name": "EPSG",
    "auth_id": "4745",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3589,
    "description": "PD/83",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 4746,
    "auth_name": "EPSG",
    "auth_id": "4746",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3590,
    "description": "GR96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4747,
    "auth_name": "EPSG",
    "auth_id": "4747",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3591,
    "description": "Vanua Levu 1915",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378306.3696 +b=6356571.996 +towgs84=51,391,-36,0,0,0,0 +no_defs",
    "srid": 4748,
    "auth_name": "EPSG",
    "auth_id": "4748",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3592,
    "description": "RGNC91-93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4749,
    "auth_name": "EPSG",
    "auth_id": "4749",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3593,
    "description": "ST87 Ouvea",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=-56.263,16.136,-22.856,0,0,0,0 +no_defs",
    "srid": 4750,
    "auth_name": "EPSG",
    "auth_id": "4750",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3594,
    "description": "Kertau (RSO)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst69",
    "parameters": "+proj=longlat +ellps=evrst69 +no_defs",
    "srid": 4751,
    "auth_name": "EPSG",
    "auth_id": "4751",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3595,
    "description": "Viti Levu 1912",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378306.3696 +b=6356571.996 +towgs84=98,390,-22,0,0,0,0 +no_defs",
    "srid": 4752,
    "auth_name": "EPSG",
    "auth_id": "4752",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3596,
    "description": "fk89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4753,
    "auth_name": "EPSG",
    "auth_id": "4753",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3597,
    "description": "LGD2006",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +no_defs",
    "srid": 4754,
    "auth_name": "EPSG",
    "auth_id": "4754",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3598,
    "description": "DGN95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4755,
    "auth_name": "EPSG",
    "auth_id": "4755",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3599,
    "description": "VN-2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +no_defs",
    "srid": 4756,
    "auth_name": "EPSG",
    "auth_id": "4756",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3600,
    "description": "SVY21",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4757,
    "auth_name": "EPSG",
    "auth_id": "4757",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3601,
    "description": "JAD2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4758,
    "auth_name": "EPSG",
    "auth_id": "4758",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3602,
    "description": "NAD83(NSRS2007)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4759,
    "auth_name": "EPSG",
    "auth_id": "4759",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3603,
    "description": "WGS 66",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "NWL9D",
    "parameters": "+proj=longlat +ellps=NWL9D +no_defs",
    "srid": 4760,
    "auth_name": "EPSG",
    "auth_id": "4760",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3604,
    "description": "HTRS96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4761,
    "auth_name": "EPSG",
    "auth_id": "4761",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3605,
    "description": "BDA2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4762,
    "auth_name": "EPSG",
    "auth_id": "4762",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3606,
    "description": "Pitcairn 2006",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4763,
    "auth_name": "EPSG",
    "auth_id": "4763",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3607,
    "description": "RSRGD2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4764,
    "auth_name": "EPSG",
    "auth_id": "4764",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3608,
    "description": "Slovenia 1996",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4765,
    "auth_name": "EPSG",
    "auth_id": "4765",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3609,
    "description": "Bern 1898 (Bern)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=bern +no_defs",
    "srid": 4801,
    "auth_name": "EPSG",
    "auth_id": "4801",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3610,
    "description": "Bogota 1975 (Bogota)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +pm=bogota +towgs84=307,304,-318,0,0,0,0 +no_defs",
    "srid": 4802,
    "auth_name": "EPSG",
    "auth_id": "4802",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3611,
    "description": "Lisbon (Lisbon)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +pm=lisbon +towgs84=-288.885,-91.744,126.244,-1.691,0.41,-0.211,-4.598 +no_defs",
    "srid": 4803,
    "auth_name": "EPSG",
    "auth_id": "4803",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3612,
    "description": "Makassar (Jakarta)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=jakarta +towgs84=-587.8,519.75,145.76,0,0,0,0 +no_defs",
    "srid": 4804,
    "auth_name": "EPSG",
    "auth_id": "4804",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3613,
    "description": "MGI (Ferro)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=ferro +no_defs",
    "srid": 4805,
    "auth_name": "EPSG",
    "auth_id": "4805",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3614,
    "description": "Monte Mario (Rome)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +pm=rome +no_defs",
    "srid": 4806,
    "auth_name": "EPSG",
    "auth_id": "4806",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3615,
    "description": "NTF (Paris)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +no_defs",
    "srid": 4807,
    "auth_name": "EPSG",
    "auth_id": "4807",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3617,
    "description": "BD50 (Brussels)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +pm=brussels +no_defs",
    "srid": 4809,
    "auth_name": "EPSG",
    "auth_id": "4809",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3618,
    "description": "Tananarive (Paris)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +pm=paris +no_defs",
    "srid": 4810,
    "auth_name": "EPSG",
    "auth_id": "4810",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3619,
    "description": "Voirol 1875 (Paris)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-73,-247,227,0,0,0,0 +no_defs",
    "srid": 4811,
    "auth_name": "EPSG",
    "auth_id": "4811",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3620,
    "description": "Batavia (Jakarta)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=jakarta +towgs84=-377,681,-50,0,0,0,0 +no_defs",
    "srid": 4813,
    "auth_name": "EPSG",
    "auth_id": "4813",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3621,
    "description": "RT38 (Stockholm)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=stockholm +no_defs",
    "srid": 4814,
    "auth_name": "EPSG",
    "auth_id": "4814",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3622,
    "description": "Greek (Athens)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=athens +no_defs",
    "srid": 4815,
    "auth_name": "EPSG",
    "auth_id": "4815",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3623,
    "description": "Carthage (Paris)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-263,6,431,0,0,0,0 +no_defs",
    "srid": 4816,
    "auth_name": "EPSG",
    "auth_id": "4816",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3624,
    "description": "NGO 1948 (Oslo)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +no_defs",
    "srid": 4817,
    "auth_name": "EPSG",
    "auth_id": "4817",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3625,
    "description": "S-JTSK (Ferro)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=ferro +no_defs",
    "srid": 4818,
    "auth_name": "EPSG",
    "auth_id": "4818",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3627,
    "description": "Segara (Jakarta)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=jakarta +towgs84=-403,684,41,0,0,0,0 +no_defs",
    "srid": 4820,
    "auth_name": "EPSG",
    "auth_id": "4820",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3628,
    "description": "Voirol 1879 (Paris)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +no_defs",
    "srid": 4821,
    "auth_name": "EPSG",
    "auth_id": "4821",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3629,
    "description": "ATF (Paris)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6376523 +rf=308.64 +pm=2.33720833333333 +no_defs",
    "srid": 4901,
    "auth_name": "EPSG",
    "auth_id": "4901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3631,
    "description": "Madrid 1870 (Madrid)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378298.3 +rf=294.73 +pm=-3.687375 +no_defs",
    "srid": 4903,
    "auth_name": "EPSG",
    "auth_id": "4903",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3632,
    "description": "Lisbon 1890 (Lisbon)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=lisbon +no_defs",
    "srid": 4904,
    "auth_name": "EPSG",
    "auth_id": "4904",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 3857,
    "description": "WGS 84 / Pseudo-Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs",
    "srid": 3857,
    "auth_name": "EPSG",
    "auth_id": "3857",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10001,
    "description": "Anaa (MOP92) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=1.5,3.84,4.81,0,0,0,0 +no_defs",
    "srid": 210598000,
    "auth_name": "IGNF",
    "auth_id": "ANAA92GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10004,
    "description": "Cadastre 1997 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210701000,
    "auth_name": "IGNF",
    "auth_id": "CAD97GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10005,
    "description": "Crozet - Possession 1963 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210013000,
    "auth_name": "IGNF",
    "auth_id": "CROZ63GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10006,
    "description": "CSG67 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-186,230,110,0,0,0,0 +no_defs",
    "srid": 210407000,
    "auth_name": "IGNF",
    "auth_id": "CSG67GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10007,
    "description": "ED50 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210101000,
    "auth_name": "IGNF",
    "auth_id": "ED50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 10008,
    "description": "Efate geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-127,-769,472,0,0,0,0 +no_defs",
    "srid": 210505000,
    "auth_name": "IGNF",
    "auth_id": "EFATE57GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10010,
    "description": "Guadeloupe Sainte-Anne geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210425000,
    "auth_name": "IGNF",
    "auth_id": "GUAD48GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10011,
    "description": "Guadeloupe Fort-Marigot geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210426000,
    "auth_name": "IGNF",
    "auth_id": "GUADFM49GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10012,
    "description": "IGN63 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210563000,
    "auth_name": "IGNF",
    "auth_id": "IGN63GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10013,
    "description": "IGN72 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +no_defs",
    "srid": 210548000,
    "auth_name": "IGNF",
    "auth_id": "IGN72GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10015,
    "description": "Kerguelen - K0 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210006000,
    "auth_name": "IGNF",
    "auth_id": "KERG62GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10017,
    "description": "NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43 +no_defs",
    "srid": 210113000,
    "auth_name": "IGNF",
    "auth_id": "LUXGEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 10020,
    "description": "Martinique Fort-Desaix geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210424000,
    "auth_name": "IGNF",
    "auth_id": "MART38GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10021,
    "description": "Combani geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210318000,
    "auth_name": "IGNF",
    "auth_id": "MAYO50GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10024,
    "description": "Moorea 1987 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210033000,
    "auth_name": "IGNF",
    "auth_id": "MOOREA87GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10026,
    "description": "NTF GEOGRAPHIQUES GREENWICH (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +no_defs",
    "srid": 210002000,
    "auth_name": "IGNF",
    "auth_id": "NTFG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 10027,
    "description": "NTF geographiques Paris (gr)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +no_defs",
    "srid": 220002000,
    "auth_name": "IGNF",
    "auth_id": "NTFP",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 10028,
    "description": "Nuku Hiva 1972 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=84,274,65,0,0,0,0 +no_defs",
    "srid": 210552000,
    "auth_name": "IGNF",
    "auth_id": "NUKU72GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10032,
    "description": "Reunion Piton des Neiges geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +no_defs",
    "srid": 210317000,
    "auth_name": "IGNF",
    "auth_id": "REUN47GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10033,
    "description": "RGF93 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 210024000,
    "auth_name": "IGNF",
    "auth_id": "RGF93G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 10034,
    "description": "RGFG95 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 210486000,
    "auth_name": "IGNF",
    "auth_id": "RGFG95GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10035,
    "description": "RGM04 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 210702000,
    "auth_name": "IGNF",
    "auth_id": "RGM04GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10036,
    "description": "RGNC geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 210547000,
    "auth_name": "IGNF",
    "auth_id": "RGNCGEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10037,
    "description": "RGPF geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 210032000,
    "auth_name": "IGNF",
    "auth_id": "RGPFGEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10038,
    "description": "RGR92 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 210700000,
    "auth_name": "IGNF",
    "auth_id": "RGR92GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10039,
    "description": "RGSPM06 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 210706000,
    "auth_name": "IGNF",
    "auth_id": "RGSPM06GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10042,
    "description": "St Pierre Miquelon 1950 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=11.363,424.148,373.13,0,0,0,0 +no_defs",
    "srid": 210423000,
    "auth_name": "IGNF",
    "auth_id": "STPM50GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10043,
    "description": "Tahaa geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=65,342,77,0,0,0,0 +no_defs",
    "srid": 210526000,
    "auth_name": "IGNF",
    "auth_id": "TAHAAGEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10045,
    "description": "Tahiti (IGN79) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=160.61,116.05,153.69,0,0,0,0 +no_defs",
    "srid": 210026000,
    "auth_name": "IGNF",
    "auth_id": "TAHI79GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10047,
    "description": "Pointe Geologie Perroud 1950 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=324.8,153.6,172.1,0,0,0,0 +no_defs",
    "srid": 210009000,
    "auth_name": "IGNF",
    "auth_id": "TERA50GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10049,
    "description": "MOP 1978 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 210017000,
    "auth_name": "IGNF",
    "auth_id": "WALL78GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10050,
    "description": "WGS72 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +no_defs",
    "srid": 210603000,
    "auth_name": "IGNF",
    "auth_id": "WGS72G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 10051,
    "description": "WGS84 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +no_defs",
    "srid": 210642000,
    "auth_name": "IGNF",
    "auth_id": "WGS84G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 10052,
    "description": "WGS84 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +no_defs",
    "srid": 210495000,
    "auth_name": "IGNF",
    "auth_id": "WGS84RRAFGEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 10054,
    "description": "Anaa (MOP92) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=6 +south +ellps=WGS84 +towgs84=1.5,3.84,4.81,0,0,0,0 +units=m +no_defs",
    "srid": 310598306,
    "auth_name": "IGNF",
    "auth_id": "ANAA92UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10055,
    "description": "Tuamotu (MOP86) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 310596306,
    "auth_name": "IGNF",
    "auth_id": "APAT86UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10056,
    "description": "Tuamotu (MOP86) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 310596307,
    "auth_name": "IGNF",
    "auth_id": "APAT86UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10057,
    "description": "Cadastre 1997 UTM Sud fuseau 38",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs",
    "srid": 310701338,
    "auth_name": "IGNF",
    "auth_id": "CAD97UTM38S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10058,
    "description": "CROZET POSSESSION 1963 UTM SUD FUSEAU 39",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=39 +south +ellps=intl +units=m +no_defs",
    "srid": 310013339,
    "auth_name": "IGNF",
    "auth_id": "CROZ63UTM39S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10059,
    "description": "CSG67 UTM Nord fuseau 21",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs",
    "srid": 310407221,
    "auth_name": "IGNF",
    "auth_id": "CSG67UTM21",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10060,
    "description": "CSG67 UTM Nord fuseau 22",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs",
    "srid": 310407222,
    "auth_name": "IGNF",
    "auth_id": "CSG67UTM22",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10061,
    "description": "Efate UTM Sud fuseau 59",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=59 +south +ellps=intl +towgs84=-127,-769,472,0,0,0,0 +units=m +no_defs",
    "srid": 310505359,
    "auth_name": "IGNF",
    "auth_id": "EFATE57UT59S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10062,
    "description": "Fangataufa (MOP84) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +towgs84=150.57,158.33,118.32,0,0,0,0 +units=m +no_defs",
    "srid": 310572307,
    "auth_name": "IGNF",
    "auth_id": "FANGA84UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10063,
    "description": "ANTILLES FRANCAISES PROJECTION GEOPORTAIL",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=15 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 310495002,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALANF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10064,
    "description": "Crozet projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-46 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 310642011,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALCRZ",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10065,
    "description": "France Metropolitaine projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=46.5 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024001,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALFXX",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10066,
    "description": "Guyane Francaise projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=4 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310486003,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALGUF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10067,
    "description": "Kerguelen projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-49.5 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 310642010,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALKER",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10068,
    "description": "Mayotte projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=-12 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310702005,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALMYT",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10069,
    "description": "Nouvelle Caledonie projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=eqc +lat_ts=-22 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310547007,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALNCL",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10070,
    "description": "Polynesie Francaise projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=-15 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310032009,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALPYF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10071,
    "description": "Reunion projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=-21 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310700004,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALREU",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10072,
    "description": "Saint-Pierre-et-Miquelon Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=47 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310706006,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALSPM",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10073,
    "description": "Wallis et Futuna projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-14 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 310642008,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALWLF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10074,
    "description": "Guadeloupe Ste Anne UTM Nord fuseau 20",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 310425220,
    "auth_name": "IGNF",
    "auth_id": "GUAD48UTM20",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10075,
    "description": "Guadeloupe Fort-Marigot UTM Nord fuseau 20",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 310426220,
    "auth_name": "IGNF",
    "auth_id": "GUADFM49U20",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10076,
    "description": "IGN 1963 UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 310563307,
    "auth_name": "IGNF",
    "auth_id": "IGN63UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10077,
    "description": "IGN72 Lambert Nouvelle-Caledonie",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs",
    "srid": 310548149,
    "auth_name": "IGNF",
    "auth_id": "IGN72LAM",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10078,
    "description": "IGN72 UTM Sud fuseau 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs",
    "srid": 310548358,
    "auth_name": "IGNF",
    "auth_id": "IGN72UTM58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10079,
    "description": "Kauehi (MHPF70) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=126.74,300.1,-75.49,0,0,0,0 +units=m +no_defs",
    "srid": 310029306,
    "auth_name": "IGNF",
    "auth_id": "KAUE70UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10080,
    "description": "KERGUELEN K0 IGN 1962 UTM SUD FUSEAU 42",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=42 +south +ellps=intl +units=m +no_defs",
    "srid": 310006342,
    "auth_name": "IGNF",
    "auth_id": "KERG62UTM42S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10081,
    "description": "NTF Lambert I",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002101,
    "auth_name": "IGNF",
    "auth_id": "LAMB1",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10082,
    "description": "NTF Lambert I carto",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002131,
    "auth_name": "IGNF",
    "auth_id": "LAMB1C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10083,
    "description": "NTF Lambert II",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002102,
    "auth_name": "IGNF",
    "auth_id": "LAMB2",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10084,
    "description": "NTF Lambert II carto",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002132,
    "auth_name": "IGNF",
    "auth_id": "LAMB2C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10085,
    "description": "NTF Lambert III",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002103,
    "auth_name": "IGNF",
    "auth_id": "LAMB3",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10086,
    "description": "NTF Lambert III carto",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002133,
    "auth_name": "IGNF",
    "auth_id": "LAMB3C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10087,
    "description": "NTF Lambert IV",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002104,
    "auth_name": "IGNF",
    "auth_id": "LAMB4",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10088,
    "description": "NTF Lambert IV carto",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002134,
    "auth_name": "IGNF",
    "auth_id": "LAMB4C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10089,
    "description": "RGF93 Lambert 93",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=44 +lat_2=49 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024140,
    "auth_name": "IGNF",
    "auth_id": "LAMB93",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10090,
    "description": "NTF Lambert II etendu",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002120,
    "auth_name": "IGNF",
    "auth_id": "LAMBE",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10091,
    "description": "NTF Lambert Grand Champ",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=0 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=600000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 320002118,
    "auth_name": "IGNF",
    "auth_id": "LAMBGC",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10092,
    "description": "NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GAUSS KRUGER LUXEMBOURG",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +towgs84=-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43 +units=m +no_defs",
    "srid": 310113406,
    "auth_name": "IGNF",
    "auth_id": "LUXGAUSSK",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10093,
    "description": "Mare IGN53 UTM Sud fuseau 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs",
    "srid": 310524358,
    "auth_name": "IGNF",
    "auth_id": "MARE53UTM58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10094,
    "description": "Martinique Fort-Desaix UTM Nord fuseau 20",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 310424220,
    "auth_name": "IGNF",
    "auth_id": "MART38UTM20",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10095,
    "description": "Combani UTM Sud fuseau 38",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +no_defs",
    "srid": 310318338,
    "auth_name": "IGNF",
    "auth_id": "MAYO50UTM38S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10096,
    "description": "MHPF 1967 UTM SUD FUSEAU 8",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=8 +south +ellps=intl +towgs84=338.08,212.58,-296.17,0,0,0,0 +units=m +no_defs",
    "srid": 310027308,
    "auth_name": "IGNF",
    "auth_id": "MHPF67UTM8S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10097,
    "description": "WGS84 PROJECTION MILLER GEOPORTAIL",
    "projection_acronym": "mill",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=mill +datum=WGS84 +units=m +no_defs",
    "srid": 310642012,
    "auth_name": "IGNF",
    "auth_id": "MILLER",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10098,
    "description": "Moorea 1987 UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 310033306,
    "auth_name": "IGNF",
    "auth_id": "MOOREA87U6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10099,
    "description": "Tetiaroa (MOP90) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=-10.8,-1.8,12.77,0,0,0,0 +units=m +no_defs",
    "srid": 310028306,
    "auth_name": "IGNF",
    "auth_id": "MOP90UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10100,
    "description": "Nuku Hiva UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +towgs84=84,274,65,0,0,0,0 +units=m +no_defs",
    "srid": 310552307,
    "auth_name": "IGNF",
    "auth_id": "NUKU72U7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10102,
    "description": "Ouvea MHNC 1972 UTM Sud fuseau 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-11.64,-348.6,291.98,0,0,0,0 +units=m +no_defs",
    "srid": 310527358,
    "auth_name": "IGNF",
    "auth_id": "OUVEA72U58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10103,
    "description": "IGN53 Societe UTM Sud fuseau 5",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs",
    "srid": 310030305,
    "auth_name": "IGNF",
    "auth_id": "RAIA53UTM5S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10104,
    "description": "Reunion Piton des Neiges Gauss Laborde",
    "projection_acronym": "gstmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +no_defs",
    "srid": 310317508,
    "auth_name": "IGNF",
    "auth_id": "REUN47GAUSSL",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10105,
    "description": "RGF93 CC42 zone 1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024142,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC42",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10106,
    "description": "RGF93 CC43 zone 2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024143,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC43",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10107,
    "description": "RGF93 CC44 zone 3",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=3 +lat_1=43.25 +lat_2=44.75 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024144,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC44",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10108,
    "description": "RGF93 CC45 zone 4",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=3 +lat_1=44.25 +lat_2=45.75 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024145,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC45",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10109,
    "description": "RGF93 CC46 zone 5",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46 +lon_0=3 +lat_1=45.25 +lat_2=46.75 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024146,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC46",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10110,
    "description": "RGF93 CC47 zone 6",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=3 +lat_1=46.25 +lat_2=47.75 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024147,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC47",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10111,
    "description": "RGF93 CC48 zone 7",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=48 +lon_0=3 +lat_1=47.25 +lat_2=48.75 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024148,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC48",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10112,
    "description": "RGF93 CC49 zone 8",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=49 +lon_0=3 +lat_1=48.25 +lat_2=49.75 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024149,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC49",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10113,
    "description": "RGF93 CC50 zone 9",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=50 +lon_0=3 +lat_1=49.25 +lat_2=50.75 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024150,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10114,
    "description": "RGM04 UTM Sud fuseau 38",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=38 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310702338,
    "auth_name": "IGNF",
    "auth_id": "RGM04UTM38S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10115,
    "description": "RGNC Lambert Nouvelle-Caledonie",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310547149,
    "auth_name": "IGNF",
    "auth_id": "RGNCLAM",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10116,
    "description": "RGNC UTM Sud fuseau 57",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=57 +south +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310547357,
    "auth_name": "IGNF",
    "auth_id": "RGNCUTM57S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10117,
    "description": "RGNC UTM Sud fuseau 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310547358,
    "auth_name": "IGNF",
    "auth_id": "RGNCUTM58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10118,
    "description": "RGNC UTM Sud fuseau 59",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=59 +south +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310547359,
    "auth_name": "IGNF",
    "auth_id": "RGNCUTM59S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10119,
    "description": "RGPF UTM Sud fuseau 5",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310032305,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM5S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10120,
    "description": "RGPF UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=6 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310032306,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10121,
    "description": "RGPF UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=7 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310032307,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10122,
    "description": "RGR92 UTM 40 Sud",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=40 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310700340,
    "auth_name": "IGNF",
    "auth_id": "RGR92UTM40S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10123,
    "description": "RGSPM06 UTM Nord fuseau 21",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310706221,
    "auth_name": "IGNF",
    "auth_id": "RGSPM06U21",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10124,
    "description": "Rurutu (SAT84) UTM Sud fuseau 5",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +towgs84=202.13,174.6,-15.74,0,0,0,0 +units=m +no_defs",
    "srid": 310031305,
    "auth_name": "IGNF",
    "auth_id": "SAT84UTM5S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10126,
    "description": "St-Pierre-et-Miquelon UTM Nord f.21",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=21 +ellps=clrk66 +towgs84=11.363,424.148,373.13,0,0,0,0 +units=m +no_defs",
    "srid": 310423221,
    "auth_name": "IGNF",
    "auth_id": "STPM50UTM21",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10127,
    "description": "Tahaa UTM Sud fuseau 5",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +towgs84=65,342,77,0,0,0,0 +units=m +no_defs",
    "srid": 310526305,
    "auth_name": "IGNF",
    "auth_id": "TAHAAUTM05S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10128,
    "description": "TAHITI TERME NORD UTM SUD FUSEAU 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=162,117,154,0,0,0,0 +units=m +no_defs",
    "srid": 310503306,
    "auth_name": "IGNF",
    "auth_id": "TAHI51UTM06S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10129,
    "description": "Tahiti (IGN79) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=160.61,116.05,153.69,0,0,0,0 +units=m +no_defs",
    "srid": 310026306,
    "auth_name": "IGNF",
    "auth_id": "TAHI79UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10130,
    "description": "Tanna UTM Sud fuseau 59",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=59 +south +ellps=intl +towgs84=-139,-967,436,0,0,0,0 +units=m +no_defs",
    "srid": 310525359,
    "auth_name": "IGNF",
    "auth_id": "TANNAUTM59S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10132,
    "description": "TERRE ADELIE POINTE GEOLOGIE PERROUD STEREO POLAIRE SUD (TANGENTE)",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=140 +k=0.960272946 +x_0=300000 +y_0=-2299363.482 +ellps=intl +towgs84=324.8,153.6,172.1,0,0,0,0 +units=m +no_defs",
    "srid": 310009901,
    "auth_name": "IGNF",
    "auth_id": "TERA50STEREO",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10133,
    "description": "Tubuai (MHPF 1969) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=237.17,171.61,-77.84,0,0,0,0 +units=m +no_defs",
    "srid": 310558306,
    "auth_name": "IGNF",
    "auth_id": "TUBU69UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10135,
    "description": "WGS84 UTM Sud Fuseau 1",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=1 +south +datum=WGS84 +units=m +no_defs",
    "srid": 310642301,
    "auth_name": "IGNF",
    "auth_id": "UTM01SW84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10176,
    "description": "RRAF UTM Nord fuseau 20",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +ellps=WGS84 +units=m +no_defs",
    "srid": 310495221,
    "auth_name": "IGNF",
    "auth_id": "UTM20W84MART",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10179,
    "description": "RGFG95 UTM Nord f.22",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310486222,
    "auth_name": "IGNF",
    "auth_id": "UTM22RGFG95",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10196,
    "description": "ED50 UTM fuseau 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=30 +ellps=intl +units=m +no_defs",
    "srid": 310101230,
    "auth_name": "IGNF",
    "auth_id": "UTM30",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10197,
    "description": "RGF93 UTM NORD FUSEAU 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024230,
    "auth_name": "IGNF",
    "auth_id": "UTM30RGF93",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10199,
    "description": "WGS72 UTM fuseau 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=30 +ellps=WGS72 +units=m +no_defs",
    "srid": 310603230,
    "auth_name": "IGNF",
    "auth_id": "UTM30W72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10200,
    "description": "WGS84 UTM fuseau 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs",
    "srid": 310642230,
    "auth_name": "IGNF",
    "auth_id": "UTM30W84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10201,
    "description": "ED50 UTM NORD FUSEAU 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=31 +ellps=intl +units=m +no_defs",
    "srid": 310101231,
    "auth_name": "IGNF",
    "auth_id": "UTM31",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10202,
    "description": "RGF93 UTM fuseau 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024231,
    "auth_name": "IGNF",
    "auth_id": "UTM31RGF93",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10204,
    "description": "WGS72 UTM fuseau 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=31 +ellps=WGS72 +units=m +no_defs",
    "srid": 310603231,
    "auth_name": "IGNF",
    "auth_id": "UTM31W72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10205,
    "description": "WGS84 UTM fuseau 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs",
    "srid": 310642231,
    "auth_name": "IGNF",
    "auth_id": "UTM31W84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10206,
    "description": "ED50 UTM fuseau 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +ellps=intl +units=m +no_defs",
    "srid": 310101232,
    "auth_name": "IGNF",
    "auth_id": "UTM32",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10207,
    "description": "RGF93 UTM fuseau 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 310024232,
    "auth_name": "IGNF",
    "auth_id": "UTM32RGF93",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10209,
    "description": "WGS72 UTM fuseau 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=32 +ellps=WGS72 +units=m +no_defs",
    "srid": 310603232,
    "auth_name": "IGNF",
    "auth_id": "UTM32W72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10210,
    "description": "WGS84 UTM NORD FUSEAU 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs",
    "srid": 310642232,
    "auth_name": "IGNF",
    "auth_id": "UTM32W84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10223,
    "description": "WGS84 UTM SUD FUSEAU 39",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs",
    "srid": 310642339,
    "auth_name": "IGNF",
    "auth_id": "UTM39SW84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10229,
    "description": "WGS84 UTM SUD FUSEAU 42",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs",
    "srid": 310642342,
    "auth_name": "IGNF",
    "auth_id": "UTM42SW84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10231,
    "description": "WGS84 UTM SUD FUSEAU 43",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs",
    "srid": 310642343,
    "auth_name": "IGNF",
    "auth_id": "UTM43SW84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 10267,
    "description": "Wallis (MOP 1978) UTM Sud fuseau 1",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=1 +south +ellps=intl +towgs84=253,-133,-127,0,0,0,0 +units=m +no_defs",
    "srid": 310017301,
    "auth_name": "IGNF",
    "auth_id": "WALL78UTM1S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 26811,
    "description": "S-JTSK / Krovak",
    "projection_acronym": "krovak",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=krovak +axis=swu +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs",
    "srid": 5513,
    "auth_name": "EPSG",
    "auth_id": "5513",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 26812,
    "description": "S-JTSK / Krovak East North",
    "projection_acronym": "krovak",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=krovak +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs",
    "srid": 5514,
    "auth_name": "EPSG",
    "auth_id": "5514",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 26813,
    "description": "S-JTSK (Ferro) / Krovak East North",
    "projection_acronym": "krovak",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=krovak +lat_0=49.5 +lon_0=42.5 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +pm=ferro +units=m +no_defs",
    "srid": 5221,
    "auth_name": "EPSG",
    "auth_id": "5221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27114,
    "description": "Hartebeesthoek94 / Lo15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=15 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2046,
    "auth_name": "EPSG",
    "auth_id": "2046",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27115,
    "description": "Hartebeesthoek94 / Lo17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=17 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2047,
    "auth_name": "EPSG",
    "auth_id": "2047",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27116,
    "description": "Hartebeesthoek94 / Lo19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2048,
    "auth_name": "EPSG",
    "auth_id": "2048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27117,
    "description": "Hartebeesthoek94 / Lo21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2049,
    "auth_name": "EPSG",
    "auth_id": "2049",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27118,
    "description": "Hartebeesthoek94 / Lo23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2050,
    "auth_name": "EPSG",
    "auth_id": "2050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27119,
    "description": "Hartebeesthoek94 / Lo25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2051,
    "auth_name": "EPSG",
    "auth_id": "2051",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27120,
    "description": "Hartebeesthoek94 / Lo27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2052,
    "auth_name": "EPSG",
    "auth_id": "2052",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27121,
    "description": "Hartebeesthoek94 / Lo29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2053,
    "auth_name": "EPSG",
    "auth_id": "2053",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27122,
    "description": "Hartebeesthoek94 / Lo31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2054,
    "auth_name": "EPSG",
    "auth_id": "2054",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27123,
    "description": "Hartebeesthoek94 / Lo33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=33 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 2055,
    "auth_name": "EPSG",
    "auth_id": "2055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27124,
    "description": "Canada_Albers_Equal_Area_Conic",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=40 +lon_0=-96 +lat_1=50 +lat_2=70 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 102001,
    "auth_name": "ESRI",
    "auth_id": "102001",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27125,
    "description": "Canada_Lambert_Conformal_Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-96 +lat_1=50 +lat_2=70 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 102002,
    "auth_name": "ESRI",
    "auth_id": "102002",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27126,
    "description": "USA_Contiguous_Albers_Equal_Area_Conic",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=37.5 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 102003,
    "auth_name": "ESRI",
    "auth_id": "102003",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27127,
    "description": "USA_Contiguous_Lambert_Conformal_Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39 +lon_0=-96 +lat_1=33 +lat_2=45 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 102004,
    "auth_name": "ESRI",
    "auth_id": "102004",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27128,
    "description": "USA_Contiguous_Equidistant_Conic",
    "projection_acronym": "eqdc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqdc +lat_0=39 +lon_0=-96 +lat_1=33 +lat_2=45 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 102005,
    "auth_name": "ESRI",
    "auth_id": "102005",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27130,
    "description": "Hawaii_Albers_Equal_Area_Conic",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=13 +lon_0=-157 +lat_1=8 +lat_2=18 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 102007,
    "auth_name": "ESRI",
    "auth_id": "102007",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27131,
    "description": "North_America_Albers_Equal_Area_Conic",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=40 +lon_0=-96 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 102008,
    "auth_name": "ESRI",
    "auth_id": "102008",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27132,
    "description": "North_America_Lambert_Conformal_Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-96 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 102009,
    "auth_name": "ESRI",
    "auth_id": "102009",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27133,
    "description": "North_America_Equidistant_Conic",
    "projection_acronym": "eqdc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqdc +lat_0=40 +lon_0=-96 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 102010,
    "auth_name": "ESRI",
    "auth_id": "102010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27134,
    "description": "Africa_Sinusoidal",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=sinu +lon_0=15 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102011,
    "auth_name": "ESRI",
    "auth_id": "102011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27135,
    "description": "Asia_Lambert_Conformal_Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=105 +lat_1=30 +lat_2=62 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102012,
    "auth_name": "ESRI",
    "auth_id": "102012",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27136,
    "description": "Europe_Albers_Equal_Area_Conic",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=aea +lat_0=30 +lon_0=10 +lat_1=43 +lat_2=62 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 102013,
    "auth_name": "ESRI",
    "auth_id": "102013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27137,
    "description": "Europe_Lambert_Conformal_Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=30 +lon_0=10 +lat_1=43 +lat_2=62 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 102014,
    "auth_name": "ESRI",
    "auth_id": "102014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27138,
    "description": "South_America_Lambert_Conformal_Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=lcc +lat_0=-32 +lon_0=-60 +lat_1=-5 +lat_2=-42 +x_0=0 +y_0=0 +ellps=aust_SA +units=m +no_defs",
    "srid": 102015,
    "auth_name": "ESRI",
    "auth_id": "102015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27139,
    "description": "North_Pole_Azimuthal_Equidistant",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aeqd +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102016,
    "auth_name": "ESRI",
    "auth_id": "102016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27140,
    "description": "North_Pole_Lambert_Azimuthal_Equal_Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102017,
    "auth_name": "ESRI",
    "auth_id": "102017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27141,
    "description": "North_Pole_Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102018,
    "auth_name": "ESRI",
    "auth_id": "102018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27142,
    "description": "South_Pole_Azimuthal_Equidistant",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aeqd +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102019,
    "auth_name": "ESRI",
    "auth_id": "102019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27143,
    "description": "South_Pole_Lambert_Azimuthal_Equal_Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102020,
    "auth_name": "ESRI",
    "auth_id": "102020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27144,
    "description": "South_Pole_Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102021,
    "auth_name": "ESRI",
    "auth_id": "102021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27145,
    "description": "Africa_Albers_Equal_Area_Conic",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aea +lat_0=0 +lon_0=25 +lat_1=20 +lat_2=-23 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102022,
    "auth_name": "ESRI",
    "auth_id": "102022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27146,
    "description": "Africa_Equidistant_Conic",
    "projection_acronym": "eqdc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqdc +lat_0=0 +lon_0=25 +lat_1=20 +lat_2=-23 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102023,
    "auth_name": "ESRI",
    "auth_id": "102023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27147,
    "description": "Africa_Lambert_Conformal_Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=25 +lat_1=20 +lat_2=-23 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102024,
    "auth_name": "ESRI",
    "auth_id": "102024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27148,
    "description": "Asia_North_Albers_Equal_Area_Conic",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aea +lat_0=30 +lon_0=95 +lat_1=15 +lat_2=65 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102025,
    "auth_name": "ESRI",
    "auth_id": "102025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27149,
    "description": "Asia_North_Equidistant_Conic",
    "projection_acronym": "eqdc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqdc +lat_0=30 +lon_0=95 +lat_1=15 +lat_2=65 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102026,
    "auth_name": "ESRI",
    "auth_id": "102026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27150,
    "description": "Asia_North_Lambert_Conformal_Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=30 +lon_0=95 +lat_1=15 +lat_2=65 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102027,
    "auth_name": "ESRI",
    "auth_id": "102027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27151,
    "description": "Asia_South_Albers_Equal_Area_Conic",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aea +lat_0=-15 +lon_0=125 +lat_1=7 +lat_2=-32 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102028,
    "auth_name": "ESRI",
    "auth_id": "102028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27152,
    "description": "Asia_South_Equidistant_Conic",
    "projection_acronym": "eqdc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqdc +lat_0=-15 +lon_0=125 +lat_1=7 +lat_2=-32 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102029,
    "auth_name": "ESRI",
    "auth_id": "102029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27153,
    "description": "Asia_South_Lambert_Conformal_Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-15 +lon_0=125 +lat_1=7 +lat_2=-32 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 102030,
    "auth_name": "ESRI",
    "auth_id": "102030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27154,
    "description": "Europe_Equidistant_Conic",
    "projection_acronym": "eqdc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=eqdc +lat_0=30 +lon_0=10 +lat_1=43 +lat_2=62 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 102031,
    "auth_name": "ESRI",
    "auth_id": "102031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27155,
    "description": "South_America_Equidistant_Conic",
    "projection_acronym": "eqdc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=eqdc +lat_0=-32 +lon_0=-60 +lat_1=-5 +lat_2=-42 +x_0=0 +y_0=0 +ellps=aust_SA +units=m +no_defs",
    "srid": 102032,
    "auth_name": "ESRI",
    "auth_id": "102032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27156,
    "description": "South_America_Albers_Equal_Area_Conic",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=aea +lat_0=-32 +lon_0=-60 +lat_1=-5 +lat_2=-42 +x_0=0 +y_0=0 +ellps=aust_SA +units=m +no_defs",
    "srid": 102033,
    "auth_name": "ESRI",
    "auth_id": "102033",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27161,
    "description": "NGO_1948_Norway_Zone_1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=6.05625 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102101,
    "auth_name": "ESRI",
    "auth_id": "102101",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27162,
    "description": "NGO_1948_Norway_Zone_2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=8.38958333333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102102,
    "auth_name": "ESRI",
    "auth_id": "102102",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27163,
    "description": "NGO_1948_Norway_Zone_3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=10.7229166666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102103,
    "auth_name": "ESRI",
    "auth_id": "102103",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27164,
    "description": "NGO_1948_Norway_Zone_4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=13.2229166666667 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102104,
    "auth_name": "ESRI",
    "auth_id": "102104",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27165,
    "description": "NGO_1948_Norway_Zone_5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=16.8895833333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102105,
    "auth_name": "ESRI",
    "auth_id": "102105",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27166,
    "description": "NGO_1948_Norway_Zone_6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=20.8895833333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102106,
    "auth_name": "ESRI",
    "auth_id": "102106",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27167,
    "description": "NGO_1948_Norway_Zone_7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=24.8895833333333 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102107,
    "auth_name": "ESRI",
    "auth_id": "102107",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27168,
    "description": "NGO_1948_Norway_Zone_8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=29.05625 +k=1 +x_0=0 +y_0=0 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102108,
    "auth_name": "ESRI",
    "auth_id": "102108",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27170,
    "description": "Old_Hawaiian_UTM_Zone_4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=4 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=m +no_defs",
    "srid": 102114,
    "auth_name": "ESRI",
    "auth_id": "102114",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27171,
    "description": "Old_Hawaiian_UTM_Zone_5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=5 +ellps=clrk66 +towgs84=61,-285,-181,0,0,0,0 +units=m +no_defs",
    "srid": 102115,
    "auth_name": "ESRI",
    "auth_id": "102115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27172,
    "description": "NAD_1927_Michigan_GeoRef_Feet_US",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.49596139 +y_0=-4354009.81600203 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 102120,
    "auth_name": "ESRI",
    "auth_id": "102120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27173,
    "description": "NAD_1983_Michigan_GeoRef_Feet_US",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.49596139 +y_0=-4354009.81600203 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102121,
    "auth_name": "ESRI",
    "auth_id": "102121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27174,
    "description": "NAD_1927_Michigan_GeoRef_Meters",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +datum=NAD27 +units=m +no_defs",
    "srid": 102122,
    "auth_name": "ESRI",
    "auth_id": "102122",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27176,
    "description": "NGO_1948_UTM_Zone_32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=32 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102132,
    "auth_name": "ESRI",
    "auth_id": "102132",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27177,
    "description": "NGO_1948_UTM_Zone_33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=33 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102133,
    "auth_name": "ESRI",
    "auth_id": "102133",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27178,
    "description": "NGO_1948_UTM_Zone_34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=34 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102134,
    "auth_name": "ESRI",
    "auth_id": "102134",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27179,
    "description": "NGO_1948_UTM_Zone_35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=35 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 102135,
    "auth_name": "ESRI",
    "auth_id": "102135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27181,
    "description": "Hong_Kong_1980_UTM_Zone_49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=49 +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.243648,-1.158828,-1.094246 +units=m +no_defs",
    "srid": 102141,
    "auth_name": "ESRI",
    "auth_id": "102141",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27182,
    "description": "Hong_Kong_1980_UTM_Zone_50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=50 +ellps=intl +towgs84=-162.619,-276.959,-161.764,0.067753,-2.243648,-1.158828,-1.094246 +units=m +no_defs",
    "srid": 102142,
    "auth_name": "ESRI",
    "auth_id": "102142",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27188,
    "description": "Tokyo_UTM_Zone_56N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=utm +zone=56 +ellps=bessel +units=m +no_defs",
    "srid": 102156,
    "auth_name": "ESRI",
    "auth_id": "102156",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27189,
    "description": "Datum_73_Hayford_Gauss_IGeoE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=200180.598 +y_0=299913.01 +ellps=intl +units=m +no_defs",
    "srid": 102160,
    "auth_name": "ESRI",
    "auth_id": "102160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27190,
    "description": "Datum_73_Hayford_Gauss_IPCC",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=180.598 +y_0=-86.99 +ellps=intl +units=m +no_defs",
    "srid": 102161,
    "auth_name": "ESRI",
    "auth_id": "102161",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27191,
    "description": "Graciosa_Base_SW_1948_UTM_Zone_26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=26 +ellps=intl +units=m +no_defs",
    "srid": 102162,
    "auth_name": "ESRI",
    "auth_id": "102162",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27192,
    "description": "Lisboa_Bessel_Bonne",
    "projection_acronym": "bonne",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=bonne +lat_1=39.6666666666667 +lon_0=-8.13190611111111 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 102163,
    "auth_name": "ESRI",
    "auth_id": "102163",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27193,
    "description": "Lisboa_Hayford_Gauss_IGeoE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=200000 +y_0=300000 +ellps=intl +units=m +no_defs",
    "srid": 102164,
    "auth_name": "ESRI",
    "auth_id": "102164",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27194,
    "description": "Lisboa_Hayford_Gauss_IPCC",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 102165,
    "auth_name": "ESRI",
    "auth_id": "102165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27195,
    "description": "Observatorio_Meteorologico_1939_UTM_Zone_25N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=25 +ellps=intl +units=m +no_defs",
    "srid": 102166,
    "auth_name": "ESRI",
    "auth_id": "102166",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27197,
    "description": "Sao_Braz_UTM_Zone_26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=26 +ellps=intl +units=m +no_defs",
    "srid": 102168,
    "auth_name": "ESRI",
    "auth_id": "102168",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27202,
    "description": "Sphere_Equidistant_Cylindrical",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eqc +lat_ts=60 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53002,
    "auth_name": "ESRI",
    "auth_id": "53002",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27203,
    "description": "Sphere_Miller_Cylindrical",
    "projection_acronym": "mill",
    "ellipsoid_acronym": "",
    "parameters": "+proj=mill +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53003,
    "auth_name": "ESRI",
    "auth_id": "53003",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27204,
    "description": "Sphere_Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53004,
    "auth_name": "ESRI",
    "auth_id": "53004",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27205,
    "description": "Sphere_Sinusoidal",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53008,
    "auth_name": "ESRI",
    "auth_id": "53008",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27206,
    "description": "Sphere_Mollweide",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53009,
    "auth_name": "ESRI",
    "auth_id": "53009",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27207,
    "description": "Sphere_Eckert_VI",
    "projection_acronym": "eck6",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eck6 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53010,
    "auth_name": "ESRI",
    "auth_id": "53010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27208,
    "description": "Sphere_Eckert_V",
    "projection_acronym": "eck5",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eck5 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53011,
    "auth_name": "ESRI",
    "auth_id": "53011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27209,
    "description": "Sphere_Eckert_IV",
    "projection_acronym": "eck4",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eck4 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53012,
    "auth_name": "ESRI",
    "auth_id": "53012",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27210,
    "description": "Sphere_Eckert_III",
    "projection_acronym": "eck3",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eck3 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53013,
    "auth_name": "ESRI",
    "auth_id": "53013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27211,
    "description": "Sphere_Eckert_II",
    "projection_acronym": "eck2",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eck2 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53014,
    "auth_name": "ESRI",
    "auth_id": "53014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27212,
    "description": "Sphere_Eckert_I",
    "projection_acronym": "eck1",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eck1 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53015,
    "auth_name": "ESRI",
    "auth_id": "53015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27213,
    "description": "Sphere_Gall_Stereographic",
    "projection_acronym": "gall",
    "ellipsoid_acronym": "",
    "parameters": "+proj=gall +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53016,
    "auth_name": "ESRI",
    "auth_id": "53016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27214,
    "description": "ETRS89 / Belgian Lambert 2008",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=50.797815 +lon_0=4.35921583333333 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3812,
    "auth_name": "EPSG",
    "auth_id": "3812",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27215,
    "description": "NAD83 / Mississippi TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +datum=NAD83 +units=m +no_defs",
    "srid": 3814,
    "auth_name": "EPSG",
    "auth_id": "3814",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27216,
    "description": "NAD83(HARN) / Mississippi TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +units=m +no_defs",
    "srid": 3815,
    "auth_name": "EPSG",
    "auth_id": "3815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27217,
    "description": "Sphere_Polyconic",
    "projection_acronym": "poly",
    "ellipsoid_acronym": "",
    "parameters": "+proj=poly +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53021,
    "auth_name": "ESRI",
    "auth_id": "53021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27218,
    "description": "NAD83(NSRS2007) / Mississippi TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3816,
    "auth_name": "EPSG",
    "auth_id": "3816",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27220,
    "description": "Sphere_Bonne",
    "projection_acronym": "bonne",
    "ellipsoid_acronym": "",
    "parameters": "+proj=bonne +lat_1=60 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53024,
    "auth_name": "ESRI",
    "auth_id": "53024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27222,
    "description": "HD1909",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=595.48,121.69,515.35,4.115,-2.9383,0.853,-3.408 +no_defs",
    "srid": 3819,
    "auth_name": "EPSG",
    "auth_id": "3819",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27223,
    "description": "Sphere_Hotine",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=omerc +lat_0=40 +lat_1=0 +lon_1=0 +lat_2=60 +lon_2=60 +k=1 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53025,
    "auth_name": "ESRI",
    "auth_id": "53025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27224,
    "description": "Sphere_Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "",
    "parameters": "+proj=stere +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53026,
    "auth_name": "ESRI",
    "auth_id": "53026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27225,
    "description": "TWD67",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=longlat +ellps=aust_SA +no_defs",
    "srid": 3821,
    "auth_name": "EPSG",
    "auth_id": "3821",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27226,
    "description": "Sphere_Equidistant_Conic",
    "projection_acronym": "eqdc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=60 +lat_2=60 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53027,
    "auth_name": "ESRI",
    "auth_id": "53027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27227,
    "description": "TWD97",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 3822,
    "auth_name": "EPSG",
    "auth_id": "3822",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27228,
    "description": "Sphere_Cassini",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53028,
    "auth_name": "ESRI",
    "auth_id": "53028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27229,
    "description": "Sphere_Van_der_Grinten_I",
    "projection_acronym": "vandg",
    "ellipsoid_acronym": "",
    "parameters": "+proj=vandg +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53029,
    "auth_name": "ESRI",
    "auth_id": "53029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27230,
    "description": "TWD97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 3824,
    "auth_name": "EPSG",
    "auth_id": "3824",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27231,
    "description": "Sphere_Robinson",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53030,
    "auth_name": "ESRI",
    "auth_id": "53030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27232,
    "description": "TWD97 / TM2 zone 119",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3825,
    "auth_name": "EPSG",
    "auth_id": "3825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27233,
    "description": "Sphere_Two_Point_Equidistant",
    "projection_acronym": "tpeqd",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tpeqd +lat_1=0 +lon_1=0 +lat_2=60 +lon_2=60 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53031,
    "auth_name": "ESRI",
    "auth_id": "53031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27234,
    "description": "TWD97 / TM2 zone 121",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3826,
    "auth_name": "EPSG",
    "auth_id": "3826",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27235,
    "description": "Sphere_Azimuthal_Equidistant",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "",
    "parameters": "+proj=aeqd +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 53032,
    "auth_name": "ESRI",
    "auth_id": "53032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27236,
    "description": "TWD67 / TM2 zone 119",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=119 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs",
    "srid": 3827,
    "auth_name": "EPSG",
    "auth_id": "3827",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27237,
    "description": "TWD67 / TM2 zone 121",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=121 +k=0.9999 +x_0=250000 +y_0=0 +ellps=aust_SA +units=m +no_defs",
    "srid": 3828,
    "auth_name": "EPSG",
    "auth_id": "3828",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27238,
    "description": "Hu Tzu Shan 1950 / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=51 +ellps=intl +towgs84=-637,-549,-203,0,0,0,0 +units=m +no_defs",
    "srid": 3829,
    "auth_name": "EPSG",
    "auth_id": "3829",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27242,
    "description": "WGS 84 / PDC Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=merc +lon_0=150 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3832,
    "auth_name": "EPSG",
    "auth_id": "3832",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27244,
    "description": "Pulkovo 1942(58) / Gauss-Kruger zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3833,
    "auth_name": "EPSG",
    "auth_id": "3833",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27246,
    "description": "Pulkovo 1942(83) / Gauss-Kruger zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=24,-123,-94,0.02,-0.25,-0.13,1.1 +units=m +no_defs",
    "srid": 3834,
    "auth_name": "EPSG",
    "auth_id": "3834",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27248,
    "description": "Pulkovo 1942(83) / Gauss-Kruger zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3835,
    "auth_name": "EPSG",
    "auth_id": "3835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27249,
    "description": "Pulkovo 1942(83) / Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3836,
    "auth_name": "EPSG",
    "auth_id": "3836",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27251,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3837,
    "auth_name": "EPSG",
    "auth_id": "3837",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27253,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3838,
    "auth_name": "EPSG",
    "auth_id": "3838",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27255,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3839,
    "auth_name": "EPSG",
    "auth_id": "3839",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27257,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3840,
    "auth_name": "EPSG",
    "auth_id": "3840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27259,
    "description": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 3841,
    "auth_name": "EPSG",
    "auth_id": "3841",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27265,
    "description": "Pulkovo 1942(58) / Stereo70",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=sterea +lat_0=46 +lon_0=25 +k=0.99975 +x_0=500000 +y_0=500000 +ellps=krass +units=m +no_defs",
    "srid": 3844,
    "auth_name": "EPSG",
    "auth_id": "3844",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27267,
    "description": "SWEREF99 / RT90 7.5 gon V emulation",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11.30625 +k=1.000006 +x_0=1500025.141 +y_0=-667.282 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3845,
    "auth_name": "EPSG",
    "auth_id": "3845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27269,
    "description": "SWEREF99 / RT90 5 gon V emulation",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13.5562666666667 +k=1.0000058 +x_0=1500044.695 +y_0=-667.13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3846,
    "auth_name": "EPSG",
    "auth_id": "3846",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27271,
    "description": "SWEREF99 / RT90 2.5 gon V emulation",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15.8062845294444 +k=1.00000561024 +x_0=1500064.274 +y_0=-667.711 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3847,
    "auth_name": "EPSG",
    "auth_id": "3847",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27273,
    "description": "SWEREF99 / RT90 0 gon emulation",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18.0563 +k=1.0000054 +x_0=1500083.521 +y_0=-668.844 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3848,
    "auth_name": "EPSG",
    "auth_id": "3848",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27275,
    "description": "SWEREF99 / RT90 2.5 gon O emulation",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20.3063166666667 +k=1.0000052 +x_0=1500102.765 +y_0=-670.706 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3849,
    "auth_name": "EPSG",
    "auth_id": "3849",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27277,
    "description": "SWEREF99 / RT90 5 gon O emulation",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=22.5563333333333 +k=1.0000049 +x_0=1500121.846 +y_0=-672.557 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3850,
    "auth_name": "EPSG",
    "auth_id": "3850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27279,
    "description": "NZGD2000 / NZCS2000",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-41 +lon_0=173 +lat_1=-37.5 +lat_2=-44.5 +x_0=3000000 +y_0=7000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3851,
    "auth_name": "EPSG",
    "auth_id": "3851",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27281,
    "description": "RSRGD2000 / DGLC2000",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-90 +lon_0=157 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3852,
    "auth_name": "EPSG",
    "auth_id": "3852",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27284,
    "description": "County ST74",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18.05787 +k=0.99999506 +x_0=100182.7406 +y_0=-6500620.1207 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3854,
    "auth_name": "EPSG",
    "auth_id": "3854",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27302,
    "description": "ETRS89 / GK19FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=19500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3873,
    "auth_name": "EPSG",
    "auth_id": "3873",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27304,
    "description": "ETRS89 / GK20FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=20500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3874,
    "auth_name": "EPSG",
    "auth_id": "3874",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27306,
    "description": "ETRS89 / GK21FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=21500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3875,
    "auth_name": "EPSG",
    "auth_id": "3875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27308,
    "description": "ETRS89 / GK22FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=22 +k=1 +x_0=22500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3876,
    "auth_name": "EPSG",
    "auth_id": "3876",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27310,
    "description": "ETRS89 / GK23FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=23500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3877,
    "auth_name": "EPSG",
    "auth_id": "3877",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27312,
    "description": "ETRS89 / GK24FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=24500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3878,
    "auth_name": "EPSG",
    "auth_id": "3878",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27314,
    "description": "ETRS89 / GK25FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3879,
    "auth_name": "EPSG",
    "auth_id": "3879",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27316,
    "description": "ETRS89 / GK26FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=26 +k=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3880,
    "auth_name": "EPSG",
    "auth_id": "3880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27318,
    "description": "ETRS89 / GK27FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=27500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3881,
    "auth_name": "EPSG",
    "auth_id": "3881",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27320,
    "description": "ETRS89 / GK28FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28 +k=1 +x_0=28500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3882,
    "auth_name": "EPSG",
    "auth_id": "3882",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27322,
    "description": "ETRS89 / GK29FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=29500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3883,
    "auth_name": "EPSG",
    "auth_id": "3883",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27324,
    "description": "ETRS89 / GK30FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=30500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3884,
    "auth_name": "EPSG",
    "auth_id": "3884",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27326,
    "description": "ETRS89 / GK31FIN",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=31500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3885,
    "auth_name": "EPSG",
    "auth_id": "3885",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27329,
    "description": "IGRS",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 3887,
    "auth_name": "EPSG",
    "auth_id": "3887",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27331,
    "description": "IGRS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 3889,
    "auth_name": "EPSG",
    "auth_id": "3889",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27332,
    "description": "IGRS / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3890,
    "auth_name": "EPSG",
    "auth_id": "3890",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27333,
    "description": "IGRS / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3891,
    "auth_name": "EPSG",
    "auth_id": "3891",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27334,
    "description": "IGRS / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3892,
    "auth_name": "EPSG",
    "auth_id": "3892",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27336,
    "description": "ED50 / Iraq National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=29.0262683333333 +lon_0=46.5 +k=0.9994 +x_0=800000 +y_0=0 +ellps=intl +towgs84=-103,-106,-141,0,0,0,0 +units=m +no_defs",
    "srid": 3893,
    "auth_name": "EPSG",
    "auth_id": "3893",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27343,
    "description": "KKJ / Finland Uniform Coordinate System + N60 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 3901,
    "auth_name": "EPSG",
    "auth_id": "3901",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 27345,
    "description": "ETRS89 / TM35FIN(N,E) + N60 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 3902,
    "auth_name": "EPSG",
    "auth_id": "3902",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 27347,
    "description": "ETRS89 / TM35FIN(N,E) + N2000 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 3903,
    "auth_name": "EPSG",
    "auth_id": "3903",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 27351,
    "description": "MGI 1901",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +no_defs",
    "srid": 3906,
    "auth_name": "EPSG",
    "auth_id": "3906",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27362,
    "description": "MGI 1901 / Slovene National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +units=m +no_defs",
    "srid": 3912,
    "auth_name": "EPSG",
    "auth_id": "3912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27394,
    "description": "NAD83 / Virginia Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36 +lon_0=-79.5 +lat_1=37 +lat_2=39.5 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 3968,
    "auth_name": "EPSG",
    "auth_id": "3968",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27395,
    "description": "NAD83(HARN) / Virginia Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36 +lon_0=-79.5 +lat_1=37 +lat_2=39.5 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3969,
    "auth_name": "EPSG",
    "auth_id": "3969",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27396,
    "description": "NAD83(NSRS2007) / Virginia Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36 +lon_0=-79.5 +lat_1=37 +lat_2=39.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 3970,
    "auth_name": "EPSG",
    "auth_id": "3970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27400,
    "description": "WGS 84 / NSIDC Sea Ice Polar Stereographic South",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-70 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3976,
    "auth_name": "EPSG",
    "auth_id": "3976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27401,
    "description": "NAD83 / Canada Atlas Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=49 +lon_0=-95 +lat_1=49 +lat_2=77 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 3978,
    "auth_name": "EPSG",
    "auth_id": "3978",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27402,
    "description": "NAD83(CSRS) / Canada Atlas Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=49 +lon_0=-95 +lat_1=49 +lat_2=77 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 3979,
    "auth_name": "EPSG",
    "auth_id": "3979",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27404,
    "description": "Katanga 1955 / Katanga Gauss zone A",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=-9 +lon_0=30 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +units=m +no_defs",
    "srid": 3986,
    "auth_name": "EPSG",
    "auth_id": "3986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27405,
    "description": "Katanga 1955 / Katanga Gauss zone B",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=-9 +lon_0=28 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +units=m +no_defs",
    "srid": 3987,
    "auth_name": "EPSG",
    "auth_id": "3987",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27406,
    "description": "Katanga 1955 / Katanga Gauss zone C",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=-9 +lon_0=26 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +units=m +no_defs",
    "srid": 3988,
    "auth_name": "EPSG",
    "auth_id": "3988",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27407,
    "description": "Katanga 1955 / Katanga Gauss zone D",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=-9 +lon_0=24 +k=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +units=m +no_defs",
    "srid": 3989,
    "auth_name": "EPSG",
    "auth_id": "3989",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27408,
    "description": "WGS 84 / Mercator 41",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=merc +lat_ts=-41 +lon_0=100 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3994,
    "auth_name": "EPSG",
    "auth_id": "3994",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27409,
    "description": "WGS 84 / Arctic Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lat_ts=71 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3995,
    "auth_name": "EPSG",
    "auth_id": "3995",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27410,
    "description": "WGS 84 / IBCAO Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lat_ts=75 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3996,
    "auth_name": "EPSG",
    "auth_id": "3996",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27411,
    "description": "WGS 84 / Dubai Local TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=55.3333333333333 +k=1 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 3997,
    "auth_name": "EPSG",
    "auth_id": "3997",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27412,
    "description": "MOLDREF99",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4000,
    "auth_name": "EPSG",
    "auth_id": "4000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27413,
    "description": "MOLDREF99",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4023,
    "auth_name": "EPSG",
    "auth_id": "4023",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27414,
    "description": "MOLDREF99 / Moldova TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28.4 +k=0.99994 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4026,
    "auth_name": "EPSG",
    "auth_id": "4026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27415,
    "description": "WGS 84 / TMzn35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs",
    "srid": 4037,
    "auth_name": "EPSG",
    "auth_id": "4037",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27416,
    "description": "WGS 84 / TMzn36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=36 +datum=WGS84 +units=m +no_defs",
    "srid": 4038,
    "auth_name": "EPSG",
    "auth_id": "4038",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27417,
    "description": "RGRDC 2005",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4039,
    "auth_name": "EPSG",
    "auth_id": "4039",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27418,
    "description": "RGRDC 2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4046,
    "auth_name": "EPSG",
    "auth_id": "4046",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27419,
    "description": "RGRDC 2005 / Congo TM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4048,
    "auth_name": "EPSG",
    "auth_id": "4048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27420,
    "description": "RGRDC 2005 / Congo TM zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=14 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4049,
    "auth_name": "EPSG",
    "auth_id": "4049",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27421,
    "description": "RGRDC 2005 / Congo TM zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4050,
    "auth_name": "EPSG",
    "auth_id": "4050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27422,
    "description": "RGRDC 2005 / Congo TM zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4051,
    "auth_name": "EPSG",
    "auth_id": "4051",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27423,
    "description": "RGRDC 2005 / Congo TM zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4056,
    "auth_name": "EPSG",
    "auth_id": "4056",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27424,
    "description": "RGRDC 2005 / Congo TM zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=22 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4057,
    "auth_name": "EPSG",
    "auth_id": "4057",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27425,
    "description": "RGRDC 2005 / Congo TM zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4058,
    "auth_name": "EPSG",
    "auth_id": "4058",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27426,
    "description": "RGRDC 2005 / Congo TM zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=26 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4059,
    "auth_name": "EPSG",
    "auth_id": "4059",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27427,
    "description": "RGRDC 2005 / Congo TM zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4060,
    "auth_name": "EPSG",
    "auth_id": "4060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27428,
    "description": "RGRDC 2005 / UTM zone 33S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4061,
    "auth_name": "EPSG",
    "auth_id": "4061",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27429,
    "description": "RGRDC 2005 / UTM zone 34S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4062,
    "auth_name": "EPSG",
    "auth_id": "4062",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27430,
    "description": "RGRDC 2005 / UTM zone 35S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4063,
    "auth_name": "EPSG",
    "auth_id": "4063",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27431,
    "description": "Chua / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=23 +south +ellps=intl +towgs84=-144.35,242.88,-33.2,0,0,0,0 +units=m +no_defs",
    "srid": 4071,
    "auth_name": "EPSG",
    "auth_id": "4071",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27432,
    "description": "SREF98",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4073,
    "auth_name": "EPSG",
    "auth_id": "4073",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27433,
    "description": "SREF98",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4075,
    "auth_name": "EPSG",
    "auth_id": "4075",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27434,
    "description": "REGCAN95",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4079,
    "auth_name": "EPSG",
    "auth_id": "4079",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27435,
    "description": "Nord_Algerie_Ancienne_Degree",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +towgs84=-73,-247,227,0,0,0,0 +units=m +no_defs",
    "srid": 102491,
    "auth_name": "ESRI",
    "auth_id": "102491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27436,
    "description": "Sud_Algerie_Ancienne_Degree",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +towgs84=-73,-247,227,0,0,0,0 +units=m +no_defs",
    "srid": 102492,
    "auth_name": "ESRI",
    "auth_id": "102492",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27437,
    "description": "REGCAN95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4081,
    "auth_name": "EPSG",
    "auth_id": "4081",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27438,
    "description": "REGCAN95 / UTM zone 27N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4082,
    "auth_name": "EPSG",
    "auth_id": "4082",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27439,
    "description": "REGCAN95 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4083,
    "auth_name": "EPSG",
    "auth_id": "4083",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27440,
    "description": "ETRS89 / DKTM1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4093,
    "auth_name": "EPSG",
    "auth_id": "4093",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27441,
    "description": "ETRS89 / DKTM2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=10 +k=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4094,
    "auth_name": "EPSG",
    "auth_id": "4094",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27442,
    "description": "ETRS89 / DKTM3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11.75 +k=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4095,
    "auth_name": "EPSG",
    "auth_id": "4095",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27443,
    "description": "ETRS89 / DKTM4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4096,
    "auth_name": "EPSG",
    "auth_id": "4096",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27444,
    "description": "ETRS89 / DKTM1 + DVR90 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 4097,
    "auth_name": "EPSG",
    "auth_id": "4097",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 27445,
    "description": "ETRS89 / DKTM2 + DVR90 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=10 +k=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 4098,
    "auth_name": "EPSG",
    "auth_id": "4098",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 27446,
    "description": "ETRS89 / DKTM3 + DVR90 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11.75 +k=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 4099,
    "auth_name": "EPSG",
    "auth_id": "4099",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 27447,
    "description": "ETRS89 / DKTM4 + DVR90 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 4100,
    "auth_name": "EPSG",
    "auth_id": "4100",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 27448,
    "description": "NTF_France_I_degrees",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=2.33722916666667 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 102581,
    "auth_name": "ESRI",
    "auth_id": "102581",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27449,
    "description": "NTF_France_II_degrees",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=2.33722916666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 102582,
    "auth_name": "ESRI",
    "auth_id": "102582",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27450,
    "description": "NTF_France_III_degrees",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=2.33722916666667 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 102583,
    "auth_name": "ESRI",
    "auth_id": "102583",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27451,
    "description": "NTF_France_IV_degrees",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=2.33722916666667 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 102584,
    "auth_name": "ESRI",
    "auth_id": "102584",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27455,
    "description": "GCS_Fischer_1960",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "fschr60",
    "parameters": "+proj=longlat +ellps=fschr60 +no_defs",
    "srid": 37002,
    "auth_name": "ESRI",
    "auth_id": "37002",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27456,
    "description": "GCS_Fischer_1968",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "fschr68",
    "parameters": "+proj=longlat +ellps=fschr68 +no_defs",
    "srid": 37003,
    "auth_name": "ESRI",
    "auth_id": "37003",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27457,
    "description": "GCS_Fischer_Modified",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "fschr60m",
    "parameters": "+proj=longlat +ellps=fschr60m +no_defs",
    "srid": 37004,
    "auth_name": "ESRI",
    "auth_id": "37004",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27458,
    "description": "GCS_Hough_1960",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "hough",
    "parameters": "+proj=longlat +ellps=hough +no_defs",
    "srid": 37005,
    "auth_name": "ESRI",
    "auth_id": "37005",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27459,
    "description": "GCS_Everest_Modified_1969",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst69",
    "parameters": "+proj=longlat +ellps=evrst69 +no_defs",
    "srid": 37006,
    "auth_name": "ESRI",
    "auth_id": "37006",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27460,
    "description": "GCS_Walbeck",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "walbeck",
    "parameters": "+proj=longlat +ellps=walbeck +no_defs",
    "srid": 37007,
    "auth_name": "ESRI",
    "auth_id": "37007",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27461,
    "description": "GCS_Sphere_ARC_INFO",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "sphere",
    "parameters": "+proj=longlat +ellps=sphere +no_defs",
    "srid": 37008,
    "auth_name": "ESRI",
    "auth_id": "37008",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27462,
    "description": "NAD83 / BLM 59N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 4217,
    "auth_name": "EPSG",
    "auth_id": "4217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27463,
    "description": "NAD_1983_StatePlane_Alabama_East_FIPS_0101_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102629,
    "auth_name": "ESRI",
    "auth_id": "102629",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27464,
    "description": "NAD_1983_StatePlane_Alabama_West_FIPS_0102_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102630,
    "auth_name": "ESRI",
    "auth_id": "102630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27465,
    "description": "NAD_1983_StatePlane_Alaska_1_FIPS_5001_Feet",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=-36.8698976458333 +gamma=-36.8698976458333 +k=0.9999 +x_0=5000000.00000001 +y_0=-5000000.00000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102631,
    "auth_name": "ESRI",
    "auth_id": "102631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27466,
    "description": "NAD_1983_StatePlane_Alaska_2_FIPS_5002_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102632,
    "auth_name": "ESRI",
    "auth_id": "102632",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27467,
    "description": "NAD_1983_StatePlane_Alaska_3_FIPS_5003_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102633,
    "auth_name": "ESRI",
    "auth_id": "102633",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27468,
    "description": "NAD_1983_StatePlane_Alaska_4_FIPS_5004_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102634,
    "auth_name": "ESRI",
    "auth_id": "102634",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27469,
    "description": "NAD_1983_StatePlane_Alaska_5_FIPS_5005_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102635,
    "auth_name": "ESRI",
    "auth_id": "102635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27470,
    "description": "NAD_1983_StatePlane_Alaska_6_FIPS_5006_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102636,
    "auth_name": "ESRI",
    "auth_id": "102636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27471,
    "description": "NAD_1983_StatePlane_Alaska_7_FIPS_5007_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102637,
    "auth_name": "ESRI",
    "auth_id": "102637",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27472,
    "description": "NAD_1983_StatePlane_Alaska_8_FIPS_5008_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102638,
    "auth_name": "ESRI",
    "auth_id": "102638",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27473,
    "description": "NAD_1983_StatePlane_Alaska_9_FIPS_5009_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102639,
    "auth_name": "ESRI",
    "auth_id": "102639",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27474,
    "description": "NAD_1983_StatePlane_Alaska_10_FIPS_5010_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=51.8333333333333 +lat_2=53.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102640,
    "auth_name": "ESRI",
    "auth_id": "102640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27481,
    "description": "NAD_1983_StatePlane_Arizona_East_FIPS_0201_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102648,
    "auth_name": "ESRI",
    "auth_id": "102648",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27482,
    "description": "NAD_1983_StatePlane_Arizona_Central_FIPS_0202_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102649,
    "auth_name": "ESRI",
    "auth_id": "102649",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27483,
    "description": "NAD_1983_StatePlane_Arizona_West_FIPS_0203_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333333333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102650,
    "auth_name": "ESRI",
    "auth_id": "102650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27494,
    "description": "NAD_1983_StatePlane_Hawaii_1_FIPS_5101_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102661,
    "auth_name": "ESRI",
    "auth_id": "102661",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27495,
    "description": "NAD_1983_StatePlane_Hawaii_2_FIPS_5102_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102662,
    "auth_name": "ESRI",
    "auth_id": "102662",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27497,
    "description": "NAD_1983_StatePlane_Hawaii_4_FIPS_5104_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102664,
    "auth_name": "ESRI",
    "auth_id": "102664",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27498,
    "description": "NAD_1983_StatePlane_Hawaii_5_FIPS_5105_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102665,
    "auth_name": "ESRI",
    "auth_id": "102665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27521,
    "description": "NAD_1983_StatePlane_Michigan_North_FIPS_2111_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=8000000.00000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102688,
    "auth_name": "ESRI",
    "auth_id": "102688",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27522,
    "description": "NAD_1983_StatePlane_Michigan_Central_FIPS_2112_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=6000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102689,
    "auth_name": "ESRI",
    "auth_id": "102689",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27523,
    "description": "NAD_1983_StatePlane_Michigan_South_FIPS_2113_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=3999999.99999999 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102690,
    "auth_name": "ESRI",
    "auth_id": "102690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27529,
    "description": "NAD_1983_StatePlane_Missouri_East_FIPS_2401_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333333333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102696,
    "auth_name": "ESRI",
    "auth_id": "102696",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27530,
    "description": "NAD_1983_StatePlane_Missouri_Central_FIPS_2402_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333333333 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102697,
    "auth_name": "ESRI",
    "auth_id": "102697",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27531,
    "description": "NAD_1983_StatePlane_Missouri_West_FIPS_2403_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941176470588 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102698,
    "auth_name": "ESRI",
    "auth_id": "102698",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27532,
    "description": "NAD_1983_StatePlane_Montana_FIPS_2500_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102700,
    "auth_name": "ESRI",
    "auth_id": "102700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27547,
    "description": "NAD_1983_StatePlane_North_Dakota_North_FIPS_3301_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.4333333333333 +lat_2=48.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102720,
    "auth_name": "ESRI",
    "auth_id": "102720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27548,
    "description": "NAD_1983_StatePlane_North_Dakota_South_FIPS_3302_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=46.1833333333333 +lat_2=47.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102721,
    "auth_name": "ESRI",
    "auth_id": "102721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27553,
    "description": "NAD_1983_StatePlane_Oregon_North_FIPS_3601_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=44.3333333333333 +lat_2=46 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102726,
    "auth_name": "ESRI",
    "auth_id": "102726",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27554,
    "description": "NAD_1983_StatePlane_Oregon_South_FIPS_3602_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=42.3333333333333 +lat_2=44 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102727,
    "auth_name": "ESRI",
    "auth_id": "102727",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27558,
    "description": "NAD_1983_StatePlane_South_Carolina_FIPS_3900_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=32.5 +lat_2=34.8333333333333 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102733,
    "auth_name": "ESRI",
    "auth_id": "102733",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27599,
    "description": "NAD_1983_StatePlane_Puerto_Rico_Virgin_Islands_FIPS_5200_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.0333333333333 +lat_2=18.4333333333333 +x_0=200000 +y_0=200000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 102761,
    "auth_name": "ESRI",
    "auth_id": "102761",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27603,
    "description": "NAD_1983_StatePlane_Guam_FIPS_5400_Feet",
    "projection_acronym": "poly",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=poly +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 102766,
    "auth_name": "ESRI",
    "auth_id": "102766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27623,
    "description": "GCS_Everest_Bangladesh",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=longlat +ellps=evrst30 +no_defs",
    "srid": 37202,
    "auth_name": "ESRI",
    "auth_id": "37202",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27624,
    "description": "NAD27 / BLM 59N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4399,
    "auth_name": "EPSG",
    "auth_id": "4399",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27625,
    "description": "GCS_Everest_India_Nepal",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6377301.243 +rf=300.8017255 +no_defs",
    "srid": 37203,
    "auth_name": "ESRI",
    "auth_id": "37203",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27626,
    "description": "NAD27 / BLM 60N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4400,
    "auth_name": "EPSG",
    "auth_id": "4400",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27628,
    "description": "NAD27 / BLM 1N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4401,
    "auth_name": "EPSG",
    "auth_id": "4401",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27630,
    "description": "NAD27 / BLM 2N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4402,
    "auth_name": "EPSG",
    "auth_id": "4402",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27631,
    "description": "GCS_Oman",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 37206,
    "auth_name": "ESRI",
    "auth_id": "37206",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27632,
    "description": "NAD27 / BLM 3N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-165 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4403,
    "auth_name": "EPSG",
    "auth_id": "4403",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27633,
    "description": "GCS_South_Asia_Singapore",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "fschr60m",
    "parameters": "+proj=longlat +ellps=fschr60m +towgs84=7,-10,-26,0,0,0,0 +no_defs",
    "srid": 37207,
    "auth_name": "ESRI",
    "auth_id": "37207",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27634,
    "description": "NAD27 / BLM 4N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-159 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4404,
    "auth_name": "EPSG",
    "auth_id": "4404",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27636,
    "description": "NAD27 / BLM 5N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-153 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4405,
    "auth_name": "EPSG",
    "auth_id": "4405",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27637,
    "description": "NAD27 / BLM 6N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-147 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4406,
    "auth_name": "EPSG",
    "auth_id": "4406",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27638,
    "description": "NAD27 / BLM 7N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-141 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4407,
    "auth_name": "EPSG",
    "auth_id": "4407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27640,
    "description": "NAD27 / BLM 8N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-135 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=clrk66 +towgs84=-10,158,187,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4408,
    "auth_name": "EPSG",
    "auth_id": "4408",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27642,
    "description": "NAD27 / BLM 9N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-129 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4409,
    "auth_name": "EPSG",
    "auth_id": "4409",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27644,
    "description": "NAD27 / BLM 10N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-123 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4410,
    "auth_name": "EPSG",
    "auth_id": "4410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27646,
    "description": "NAD27 / BLM 11N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4411,
    "auth_name": "EPSG",
    "auth_id": "4411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27648,
    "description": "NAD27 / BLM 12N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4412,
    "auth_name": "EPSG",
    "auth_id": "4412",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27650,
    "description": "NAD27 / BLM 13N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-105 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4413,
    "auth_name": "EPSG",
    "auth_id": "4413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27652,
    "description": "NAD83(HARN) / Guam Map Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4414,
    "auth_name": "EPSG",
    "auth_id": "4414",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27653,
    "description": "GCS_DOS_1968",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=230,-199,-752,0,0,0,0 +no_defs",
    "srid": 37218,
    "auth_name": "ESRI",
    "auth_id": "37218",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27654,
    "description": "Katanga 1955 / Katanga Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=-9 +lon_0=26 +lat_1=-6.5 +lat_2=-11.5 +x_0=500000 +y_0=500000 +ellps=clrk66 +units=m +no_defs",
    "srid": 4415,
    "auth_name": "EPSG",
    "auth_id": "4415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27657,
    "description": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4417,
    "auth_name": "EPSG",
    "auth_id": "4417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27658,
    "description": "GCS_GUX_1",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=252,-209,-751,0,0,0,0 +no_defs",
    "srid": 37221,
    "auth_name": "ESRI",
    "auth_id": "37221",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27659,
    "description": "NAD27 / BLM 18N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-75 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4418,
    "auth_name": "EPSG",
    "auth_id": "4418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27661,
    "description": "NAD27 / BLM 19N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-69 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4419,
    "auth_name": "EPSG",
    "auth_id": "4419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27663,
    "description": "NAD83 / BLM 60N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 4420,
    "auth_name": "EPSG",
    "auth_id": "4420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27665,
    "description": "NAD83 / BLM 1N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 4421,
    "auth_name": "EPSG",
    "auth_id": "4421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27666,
    "description": "NAD83 / BLM 2N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=0.9996 +x_0=500000.001016002 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 4422,
    "auth_name": "EPSG",
    "auth_id": "4422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27668,
    "description": "NAD83 / BLM 3N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-165 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4423,
    "auth_name": "EPSG",
    "auth_id": "4423",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27670,
    "description": "NAD83 / BLM 4N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-159 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4424,
    "auth_name": "EPSG",
    "auth_id": "4424",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27672,
    "description": "NAD83 / BLM 5N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-153 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4425,
    "auth_name": "EPSG",
    "auth_id": "4425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27674,
    "description": "NAD83 / BLM 6N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-147 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4426,
    "auth_name": "EPSG",
    "auth_id": "4426",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27676,
    "description": "NAD83 / BLM 7N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-141 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4427,
    "auth_name": "EPSG",
    "auth_id": "4427",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27678,
    "description": "NAD83 / BLM 8N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-135 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4428,
    "auth_name": "EPSG",
    "auth_id": "4428",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27680,
    "description": "NAD83 / BLM 9N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-129 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4429,
    "auth_name": "EPSG",
    "auth_id": "4429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27682,
    "description": "NAD83 / BLM 10N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-123 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4430,
    "auth_name": "EPSG",
    "auth_id": "4430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27684,
    "description": "NAD83 / BLM 11N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4431,
    "auth_name": "EPSG",
    "auth_id": "4431",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27686,
    "description": "NAD83 / BLM 12N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4432,
    "auth_name": "EPSG",
    "auth_id": "4432",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27687,
    "description": "NAD83 / BLM 13N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-105 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4433,
    "auth_name": "EPSG",
    "auth_id": "4433",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27689,
    "description": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4434,
    "auth_name": "EPSG",
    "auth_id": "4434",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27692,
    "description": "GCS_Fort_Thomas_1955",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-7,215,225,0,0,0,0 +no_defs",
    "srid": 37240,
    "auth_name": "ESRI",
    "auth_id": "37240",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27693,
    "description": "NAD83(NSRS2007) / Puerto Rico and Virgin Is.",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4437,
    "auth_name": "EPSG",
    "auth_id": "4437",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27694,
    "description": "GCS_Graciosa_Base_SW_1948",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 37241,
    "auth_name": "ESRI",
    "auth_id": "37241",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27695,
    "description": "NAD83 / BLM 18N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-75 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4438,
    "auth_name": "EPSG",
    "auth_id": "4438",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27697,
    "description": "NAD83 / BLM 19N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-69 +k=0.9996 +x_0=500000.001016002 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4439,
    "auth_name": "EPSG",
    "auth_id": "4439",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27698,
    "description": "GCS_LC5_1961",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 37243,
    "auth_name": "ESRI",
    "auth_id": "37243",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27699,
    "description": "GCS_Observatorio_Meteorologico_1939",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 37245,
    "auth_name": "ESRI",
    "auth_id": "37245",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27702,
    "description": "GCS_Sao_Braz",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 37249,
    "auth_name": "ESRI",
    "auth_id": "37249",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27709,
    "description": "GCS_S42_Hungary",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 37257,
    "auth_name": "ESRI",
    "auth_id": "37257",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27710,
    "description": "NAD27 / Pennsylvania South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4455,
    "auth_name": "EPSG",
    "auth_id": "4455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27712,
    "description": "NAD27 / New York Long Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=40.5 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=609601.219202438 +y_0=30480.0609601219 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 4456,
    "auth_name": "EPSG",
    "auth_id": "4456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27713,
    "description": "GCS_Alaskan_Islands",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 37260,
    "auth_name": "ESRI",
    "auth_id": "37260",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27714,
    "description": "NAD83 / South Dakota North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 4457,
    "auth_name": "EPSG",
    "auth_id": "4457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27715,
    "description": "WGS 84 / Australian Centre for Remote Sensing Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=-27 +lon_0=132 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 4462,
    "auth_name": "EPSG",
    "auth_id": "4462",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27716,
    "description": "RGSPM06",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4463,
    "auth_name": "EPSG",
    "auth_id": "4463",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27717,
    "description": "RGSPM06",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4465,
    "auth_name": "EPSG",
    "auth_id": "4465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27718,
    "description": "RGSPM06 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4467,
    "auth_name": "EPSG",
    "auth_id": "4467",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27719,
    "description": "RGM04",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4468,
    "auth_name": "EPSG",
    "auth_id": "4468",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27720,
    "description": "RGM04",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4470,
    "auth_name": "EPSG",
    "auth_id": "4470",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27721,
    "description": "RGM04 / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=38 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4471,
    "auth_name": "EPSG",
    "auth_id": "4471",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27722,
    "description": "Cadastre 1997",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 4473,
    "auth_name": "EPSG",
    "auth_id": "4473",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27724,
    "description": "Cadastre 1997",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-381.788,-57.501,-256.673,0,0,0,0 +no_defs",
    "srid": 4475,
    "auth_name": "EPSG",
    "auth_id": "4475",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27725,
    "description": "China Geodetic Coordinate System 2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4479,
    "auth_name": "EPSG",
    "auth_id": "4479",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27726,
    "description": "Mexico ITRF92",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4481,
    "auth_name": "EPSG",
    "auth_id": "4481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27727,
    "description": "Mexico ITRF92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4483,
    "auth_name": "EPSG",
    "auth_id": "4483",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27728,
    "description": "Mexico ITRF92 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4484,
    "auth_name": "EPSG",
    "auth_id": "4484",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27729,
    "description": "Mexico ITRF92 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4485,
    "auth_name": "EPSG",
    "auth_id": "4485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27730,
    "description": "Mexico ITRF92 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4486,
    "auth_name": "EPSG",
    "auth_id": "4486",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27731,
    "description": "Mexico ITRF92 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4487,
    "auth_name": "EPSG",
    "auth_id": "4487",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27732,
    "description": "Mexico ITRF92 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4488,
    "auth_name": "EPSG",
    "auth_id": "4488",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27733,
    "description": "Mexico ITRF92 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4489,
    "auth_name": "EPSG",
    "auth_id": "4489",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27734,
    "description": "China Geodetic Coordinate System 2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 4490,
    "auth_name": "EPSG",
    "auth_id": "4490",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27735,
    "description": "CGCS2000 / Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4491,
    "auth_name": "EPSG",
    "auth_id": "4491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27736,
    "description": "CGCS2000 / Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4492,
    "auth_name": "EPSG",
    "auth_id": "4492",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27737,
    "description": "CGCS2000 / Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4493,
    "auth_name": "EPSG",
    "auth_id": "4493",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27738,
    "description": "CGCS2000 / Gauss-Kruger zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4494,
    "auth_name": "EPSG",
    "auth_id": "4494",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27739,
    "description": "CGCS2000 / Gauss-Kruger zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4495,
    "auth_name": "EPSG",
    "auth_id": "4495",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27740,
    "description": "CGCS2000 / Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4496,
    "auth_name": "EPSG",
    "auth_id": "4496",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27741,
    "description": "CGCS2000 / Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4497,
    "auth_name": "EPSG",
    "auth_id": "4497",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27742,
    "description": "CGCS2000 / Gauss-Kruger zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4498,
    "auth_name": "EPSG",
    "auth_id": "4498",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27743,
    "description": "CGCS2000 / Gauss-Kruger zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4499,
    "auth_name": "EPSG",
    "auth_id": "4499",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27744,
    "description": "CGCS2000 / Gauss-Kruger zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4500,
    "auth_name": "EPSG",
    "auth_id": "4500",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27745,
    "description": "CGCS2000 / Gauss-Kruger zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4501,
    "auth_name": "EPSG",
    "auth_id": "4501",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27746,
    "description": "CGCS2000 / Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4502,
    "auth_name": "EPSG",
    "auth_id": "4502",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27747,
    "description": "CGCS2000 / Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4503,
    "auth_name": "EPSG",
    "auth_id": "4503",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27748,
    "description": "CGCS2000 / Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4504,
    "auth_name": "EPSG",
    "auth_id": "4504",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27749,
    "description": "CGCS2000 / Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4505,
    "auth_name": "EPSG",
    "auth_id": "4505",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27750,
    "description": "CGCS2000 / Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4506,
    "auth_name": "EPSG",
    "auth_id": "4506",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27751,
    "description": "CGCS2000 / Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4507,
    "auth_name": "EPSG",
    "auth_id": "4507",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27752,
    "description": "CGCS2000 / Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4508,
    "auth_name": "EPSG",
    "auth_id": "4508",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27753,
    "description": "CGCS2000 / Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4509,
    "auth_name": "EPSG",
    "auth_id": "4509",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27754,
    "description": "CGCS2000 / Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4510,
    "auth_name": "EPSG",
    "auth_id": "4510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27755,
    "description": "CGCS2000 / Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4511,
    "auth_name": "EPSG",
    "auth_id": "4511",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27756,
    "description": "CGCS2000 / Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4512,
    "auth_name": "EPSG",
    "auth_id": "4512",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27757,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4513,
    "auth_name": "EPSG",
    "auth_id": "4513",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27758,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4514,
    "auth_name": "EPSG",
    "auth_id": "4514",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27759,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4515,
    "auth_name": "EPSG",
    "auth_id": "4515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27760,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4516,
    "auth_name": "EPSG",
    "auth_id": "4516",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27761,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4517,
    "auth_name": "EPSG",
    "auth_id": "4517",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27762,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4518,
    "auth_name": "EPSG",
    "auth_id": "4518",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27763,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4519,
    "auth_name": "EPSG",
    "auth_id": "4519",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27764,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4520,
    "auth_name": "EPSG",
    "auth_id": "4520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27765,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4521,
    "auth_name": "EPSG",
    "auth_id": "4521",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27766,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4522,
    "auth_name": "EPSG",
    "auth_id": "4522",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27767,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 35",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4523,
    "auth_name": "EPSG",
    "auth_id": "4523",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27768,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 36",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4524,
    "auth_name": "EPSG",
    "auth_id": "4524",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27769,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 37",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4525,
    "auth_name": "EPSG",
    "auth_id": "4525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27770,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 38",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4526,
    "auth_name": "EPSG",
    "auth_id": "4526",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27771,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 39",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4527,
    "auth_name": "EPSG",
    "auth_id": "4527",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27772,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 40",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4528,
    "auth_name": "EPSG",
    "auth_id": "4528",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27773,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 41",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4529,
    "auth_name": "EPSG",
    "auth_id": "4529",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27774,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 42",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4530,
    "auth_name": "EPSG",
    "auth_id": "4530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27775,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 43",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4531,
    "auth_name": "EPSG",
    "auth_id": "4531",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27776,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 44",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4532,
    "auth_name": "EPSG",
    "auth_id": "4532",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27777,
    "description": "CGCS2000 / 3-degree Gauss-Kruger zone 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4533,
    "auth_name": "EPSG",
    "auth_id": "4533",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27778,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4534,
    "auth_name": "EPSG",
    "auth_id": "4534",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27779,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 78E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4535,
    "auth_name": "EPSG",
    "auth_id": "4535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27780,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4536,
    "auth_name": "EPSG",
    "auth_id": "4536",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27781,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 84E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4537,
    "auth_name": "EPSG",
    "auth_id": "4537",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27782,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4538,
    "auth_name": "EPSG",
    "auth_id": "4538",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27783,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 90E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4539,
    "auth_name": "EPSG",
    "auth_id": "4539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27784,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4540,
    "auth_name": "EPSG",
    "auth_id": "4540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27785,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 96E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4541,
    "auth_name": "EPSG",
    "auth_id": "4541",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27786,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4542,
    "auth_name": "EPSG",
    "auth_id": "4542",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27787,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 102E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4543,
    "auth_name": "EPSG",
    "auth_id": "4543",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27788,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4544,
    "auth_name": "EPSG",
    "auth_id": "4544",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27789,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 108E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4545,
    "auth_name": "EPSG",
    "auth_id": "4545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27790,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4546,
    "auth_name": "EPSG",
    "auth_id": "4546",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27791,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 114E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4547,
    "auth_name": "EPSG",
    "auth_id": "4547",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27792,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4548,
    "auth_name": "EPSG",
    "auth_id": "4548",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27793,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 120E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4549,
    "auth_name": "EPSG",
    "auth_id": "4549",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27794,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4550,
    "auth_name": "EPSG",
    "auth_id": "4550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27795,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 126E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4551,
    "auth_name": "EPSG",
    "auth_id": "4551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27796,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4552,
    "auth_name": "EPSG",
    "auth_id": "4552",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27797,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 132E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4553,
    "auth_name": "EPSG",
    "auth_id": "4553",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27798,
    "description": "CGCS2000 / 3-degree Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 4554,
    "auth_name": "EPSG",
    "auth_id": "4554",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27799,
    "description": "New Beijing",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 4555,
    "auth_name": "EPSG",
    "auth_id": "4555",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27800,
    "description": "RRAF 1991",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4556,
    "auth_name": "EPSG",
    "auth_id": "4556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27801,
    "description": "RRAF 1991",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 4558,
    "auth_name": "EPSG",
    "auth_id": "4558",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27802,
    "description": "RRAF 1991 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4559,
    "auth_name": "EPSG",
    "auth_id": "4559",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27803,
    "description": "New Beijing / Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4568,
    "auth_name": "EPSG",
    "auth_id": "4568",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27804,
    "description": "New Beijing / Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4569,
    "auth_name": "EPSG",
    "auth_id": "4569",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27805,
    "description": "New Beijing / Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4570,
    "auth_name": "EPSG",
    "auth_id": "4570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27806,
    "description": "New Beijing / Gauss-Kruger zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4571,
    "auth_name": "EPSG",
    "auth_id": "4571",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27807,
    "description": "New Beijing / Gauss-Kruger zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4572,
    "auth_name": "EPSG",
    "auth_id": "4572",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27808,
    "description": "New Beijing / Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4573,
    "auth_name": "EPSG",
    "auth_id": "4573",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27809,
    "description": "New Beijing / Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4574,
    "auth_name": "EPSG",
    "auth_id": "4574",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27810,
    "description": "New Beijing / Gauss-Kruger zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4575,
    "auth_name": "EPSG",
    "auth_id": "4575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27811,
    "description": "New Beijing / Gauss-Kruger zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4576,
    "auth_name": "EPSG",
    "auth_id": "4576",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27812,
    "description": "New Beijing / Gauss-Kruger zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4577,
    "auth_name": "EPSG",
    "auth_id": "4577",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27813,
    "description": "New Beijing / Gauss-Kruger zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4578,
    "auth_name": "EPSG",
    "auth_id": "4578",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27814,
    "description": "New Beijing / Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4579,
    "auth_name": "EPSG",
    "auth_id": "4579",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27815,
    "description": "New Beijing / Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4580,
    "auth_name": "EPSG",
    "auth_id": "4580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27816,
    "description": "New Beijing / Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4581,
    "auth_name": "EPSG",
    "auth_id": "4581",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27817,
    "description": "New Beijing / Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4582,
    "auth_name": "EPSG",
    "auth_id": "4582",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27818,
    "description": "New Beijing / Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4583,
    "auth_name": "EPSG",
    "auth_id": "4583",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27819,
    "description": "New Beijing / Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4584,
    "auth_name": "EPSG",
    "auth_id": "4584",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27820,
    "description": "New Beijing / Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4585,
    "auth_name": "EPSG",
    "auth_id": "4585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27821,
    "description": "New Beijing / Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4586,
    "auth_name": "EPSG",
    "auth_id": "4586",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27822,
    "description": "New Beijing / Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4587,
    "auth_name": "EPSG",
    "auth_id": "4587",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27823,
    "description": "New Beijing / Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4588,
    "auth_name": "EPSG",
    "auth_id": "4588",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27824,
    "description": "New Beijing / Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4589,
    "auth_name": "EPSG",
    "auth_id": "4589",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27825,
    "description": "ETRS89 / UTM zone 32N (zE-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4647,
    "auth_name": "EPSG",
    "auth_id": "4647",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27826,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4652,
    "auth_name": "EPSG",
    "auth_id": "4652",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27827,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4653,
    "auth_name": "EPSG",
    "auth_id": "4653",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27828,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4654,
    "auth_name": "EPSG",
    "auth_id": "4654",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27829,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4655,
    "auth_name": "EPSG",
    "auth_id": "4655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27830,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4656,
    "auth_name": "EPSG",
    "auth_id": "4656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27831,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4766,
    "auth_name": "EPSG",
    "auth_id": "4766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27832,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4767,
    "auth_name": "EPSG",
    "auth_id": "4767",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27833,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4768,
    "auth_name": "EPSG",
    "auth_id": "4768",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27834,
    "description": "Schwarzeck / Lo22/11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=11 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs",
    "srid": 29371,
    "auth_name": "EPSG",
    "auth_id": "29371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27835,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4769,
    "auth_name": "EPSG",
    "auth_id": "4769",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27836,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4770,
    "auth_name": "EPSG",
    "auth_id": "4770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27837,
    "description": "Schwarzeck / Lo22/13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=13 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs",
    "srid": 29373,
    "auth_name": "EPSG",
    "auth_id": "29373",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27838,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 35",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4771,
    "auth_name": "EPSG",
    "auth_id": "4771",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27839,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 36",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4772,
    "auth_name": "EPSG",
    "auth_id": "4772",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27840,
    "description": "Schwarzeck / Lo22/15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=15 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs",
    "srid": 29375,
    "auth_name": "EPSG",
    "auth_id": "29375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27841,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 37",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4773,
    "auth_name": "EPSG",
    "auth_id": "4773",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27842,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 38",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4774,
    "auth_name": "EPSG",
    "auth_id": "4774",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27843,
    "description": "Schwarzeck / Lo22/17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=17 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs",
    "srid": 29377,
    "auth_name": "EPSG",
    "auth_id": "29377",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27844,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 39",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4775,
    "auth_name": "EPSG",
    "auth_id": "4775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27845,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 40",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4776,
    "auth_name": "EPSG",
    "auth_id": "4776",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27846,
    "description": "Schwarzeck / Lo22/19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=19 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs",
    "srid": 29379,
    "auth_name": "EPSG",
    "auth_id": "29379",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27847,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 41",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4777,
    "auth_name": "EPSG",
    "auth_id": "4777",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27848,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 42",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4778,
    "auth_name": "EPSG",
    "auth_id": "4778",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27849,
    "description": "Schwarzeck / Lo22/21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=21 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs",
    "srid": 29381,
    "auth_name": "EPSG",
    "auth_id": "29381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27850,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 43",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4779,
    "auth_name": "EPSG",
    "auth_id": "4779",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27851,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 44",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4780,
    "auth_name": "EPSG",
    "auth_id": "4780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27852,
    "description": "Schwarzeck / Lo22/23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=23 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs",
    "srid": 29383,
    "auth_name": "EPSG",
    "auth_id": "29383",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27853,
    "description": "New Beijing / 3-degree Gauss-Kruger zone 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4781,
    "auth_name": "EPSG",
    "auth_id": "4781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27854,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4782,
    "auth_name": "EPSG",
    "auth_id": "4782",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27855,
    "description": "Schwarzeck / Lo22/25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bess_nam",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=-22 +lon_0=25 +k=1 +x_0=0 +y_0=0 +ellps=bess_nam +to_meter=1.0000135965 +no_defs",
    "srid": 29385,
    "auth_name": "EPSG",
    "auth_id": "29385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27856,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 78E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4783,
    "auth_name": "EPSG",
    "auth_id": "4783",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27857,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4784,
    "auth_name": "EPSG",
    "auth_id": "4784",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27858,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 84E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4785,
    "auth_name": "EPSG",
    "auth_id": "4785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27859,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4786,
    "auth_name": "EPSG",
    "auth_id": "4786",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27860,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 90E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4787,
    "auth_name": "EPSG",
    "auth_id": "4787",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27861,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4788,
    "auth_name": "EPSG",
    "auth_id": "4788",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27862,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 96E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4789,
    "auth_name": "EPSG",
    "auth_id": "4789",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27863,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4790,
    "auth_name": "EPSG",
    "auth_id": "4790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27864,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 102E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4791,
    "auth_name": "EPSG",
    "auth_id": "4791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27865,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4792,
    "auth_name": "EPSG",
    "auth_id": "4792",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27866,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 108E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4793,
    "auth_name": "EPSG",
    "auth_id": "4793",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27867,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4794,
    "auth_name": "EPSG",
    "auth_id": "4794",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27868,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 114E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4795,
    "auth_name": "EPSG",
    "auth_id": "4795",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27869,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4796,
    "auth_name": "EPSG",
    "auth_id": "4796",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27870,
    "description": "World_Equidistant_Cylindrical",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=60 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54002,
    "auth_name": "ESRI",
    "auth_id": "54002",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27871,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 120E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4797,
    "auth_name": "EPSG",
    "auth_id": "4797",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27872,
    "description": "World_Miller_Cylindrical",
    "projection_acronym": "mill",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=mill +R_A +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54003,
    "auth_name": "ESRI",
    "auth_id": "54003",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27873,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4798,
    "auth_name": "EPSG",
    "auth_id": "4798",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27874,
    "description": "World_Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=merc +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54004,
    "auth_name": "ESRI",
    "auth_id": "54004",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27875,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 126E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4799,
    "auth_name": "EPSG",
    "auth_id": "4799",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27876,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4800,
    "auth_name": "EPSG",
    "auth_id": "4800",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27877,
    "description": "World_Sinusoidal",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54008,
    "auth_name": "ESRI",
    "auth_id": "54008",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27878,
    "description": "World_Mollweide",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54009,
    "auth_name": "ESRI",
    "auth_id": "54009",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27879,
    "description": "World_Eckert_VI",
    "projection_acronym": "eck6",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eck6 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54010,
    "auth_name": "ESRI",
    "auth_id": "54010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27880,
    "description": "World_Eckert_V",
    "projection_acronym": "eck5",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eck5 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54011,
    "auth_name": "ESRI",
    "auth_id": "54011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27881,
    "description": "World_Eckert_IV",
    "projection_acronym": "eck4",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eck4 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54012,
    "auth_name": "ESRI",
    "auth_id": "54012",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27882,
    "description": "World_Eckert_III",
    "projection_acronym": "eck3",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eck3 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54013,
    "auth_name": "ESRI",
    "auth_id": "54013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27883,
    "description": "World_Eckert_II",
    "projection_acronym": "eck2",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eck2 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54014,
    "auth_name": "ESRI",
    "auth_id": "54014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27884,
    "description": "World_Eckert_I",
    "projection_acronym": "eck1",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eck1 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54015,
    "auth_name": "ESRI",
    "auth_id": "54015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27885,
    "description": "World_Gall_Stereographic",
    "projection_acronym": "gall",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=gall +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54016,
    "auth_name": "ESRI",
    "auth_id": "54016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27886,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 132E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4812,
    "auth_name": "EPSG",
    "auth_id": "4812",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27887,
    "description": "World_Polyconic",
    "projection_acronym": "poly",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=poly +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54021,
    "auth_name": "ESRI",
    "auth_id": "54021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27888,
    "description": "World_Bonne",
    "projection_acronym": "bonne",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=bonne +lat_1=60 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54024,
    "auth_name": "ESRI",
    "auth_id": "54024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27889,
    "description": "World_Hotine",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=omerc +lat_0=40 +lat_1=0 +lon_1=0 +lat_2=60 +lon_2=60 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54025,
    "auth_name": "ESRI",
    "auth_id": "54025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27890,
    "description": "World_Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54026,
    "auth_name": "ESRI",
    "auth_id": "54026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27891,
    "description": "World_Equidistant_Conic",
    "projection_acronym": "eqdc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=60 +lat_2=60 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54027,
    "auth_name": "ESRI",
    "auth_id": "54027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27892,
    "description": "New Beijing / 3-degree Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 4822,
    "auth_name": "EPSG",
    "auth_id": "4822",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27893,
    "description": "World_Cassini",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=cass +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54028,
    "auth_name": "ESRI",
    "auth_id": "54028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27894,
    "description": "Sao Tome",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4823,
    "auth_name": "EPSG",
    "auth_id": "4823",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27895,
    "description": "World_Van_der_Grinten_I",
    "projection_acronym": "vandg",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=vandg +R_A +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54029,
    "auth_name": "ESRI",
    "auth_id": "54029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27896,
    "description": "Principe",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 4824,
    "auth_name": "EPSG",
    "auth_id": "4824",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27897,
    "description": "World_Robinson",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54030,
    "auth_name": "ESRI",
    "auth_id": "54030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27898,
    "description": "World_Two_Point_Equidistant",
    "projection_acronym": "tpeqd",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tpeqd +lat_1=0 +lon_1=0 +lat_2=60 +lon_2=60 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54031,
    "auth_name": "ESRI",
    "auth_id": "54031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27899,
    "description": "WGS 84 / Cape Verde National",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=15.8333333333333 +lon_0=-24 +lat_1=15 +lat_2=16.6666666666667 +x_0=161587.83 +y_0=128511.202 +datum=WGS84 +units=m +no_defs",
    "srid": 4826,
    "auth_name": "EPSG",
    "auth_id": "4826",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27900,
    "description": "World_Azimuthal_Equidistant",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aeqd +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 54032,
    "auth_name": "ESRI",
    "auth_id": "54032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27901,
    "description": "ETRS89 / LCC Germany (N-E)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=10.5 +lat_1=48.6666666666667 +lat_2=53.6666666666667 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 4839,
    "auth_name": "EPSG",
    "auth_id": "4839",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27928,
    "description": "Slovenia 1996",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4882,
    "auth_name": "EPSG",
    "auth_id": "4882",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27929,
    "description": "RSRGD2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4884,
    "auth_name": "EPSG",
    "auth_id": "4884",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27930,
    "description": "BDA2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 4886,
    "auth_name": "EPSG",
    "auth_id": "4886",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27931,
    "description": "HTRS96",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4888,
    "auth_name": "EPSG",
    "auth_id": "4888",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27932,
    "description": "NAD_1983_HARN_WISCRS_Adams_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 103300,
    "auth_name": "ESRI",
    "auth_id": "103300",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27933,
    "description": "WGS 66",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "NWL9D",
    "parameters": "+proj=geocent +ellps=NWL9D +units=m +no_defs",
    "srid": 4890,
    "auth_name": "EPSG",
    "auth_id": "4890",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27934,
    "description": "NAD83(NSRS2007)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4892,
    "auth_name": "EPSG",
    "auth_id": "4892",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27935,
    "description": "JAD2001",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 4894,
    "auth_name": "EPSG",
    "auth_id": "4894",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27936,
    "description": "ITRF2005",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4896,
    "auth_name": "EPSG",
    "auth_id": "4896",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27937,
    "description": "DGN95",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 4897,
    "auth_name": "EPSG",
    "auth_id": "4897",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27938,
    "description": "LGD2006",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 4899,
    "auth_name": "EPSG",
    "auth_id": "4899",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27939,
    "description": "RGNC91-93",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4906,
    "auth_name": "EPSG",
    "auth_id": "4906",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27940,
    "description": "GR96",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4908,
    "auth_name": "EPSG",
    "auth_id": "4908",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27941,
    "description": "ITRF88",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4910,
    "auth_name": "EPSG",
    "auth_id": "4910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27942,
    "description": "ITRF89",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4911,
    "auth_name": "EPSG",
    "auth_id": "4911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27943,
    "description": "ITRF90",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4912,
    "auth_name": "EPSG",
    "auth_id": "4912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27944,
    "description": "ITRF91",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4913,
    "auth_name": "EPSG",
    "auth_id": "4913",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27945,
    "description": "ITRF92",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4914,
    "auth_name": "EPSG",
    "auth_id": "4914",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27946,
    "description": "ITRF93",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4915,
    "auth_name": "EPSG",
    "auth_id": "4915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27947,
    "description": "ITRF94",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4916,
    "auth_name": "EPSG",
    "auth_id": "4916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27948,
    "description": "ITRF96",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4917,
    "auth_name": "EPSG",
    "auth_id": "4917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27949,
    "description": "ITRF97",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4918,
    "auth_name": "EPSG",
    "auth_id": "4918",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27950,
    "description": "ITRF2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4919,
    "auth_name": "EPSG",
    "auth_id": "4919",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27951,
    "description": "GDM2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4920,
    "auth_name": "EPSG",
    "auth_id": "4920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27952,
    "description": "PZ-90",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "",
    "parameters": "+proj=geocent +a=6378136 +rf=298.257839303 +units=m +no_defs",
    "srid": 4922,
    "auth_name": "EPSG",
    "auth_id": "4922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27953,
    "description": "Mauritania 1999",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4924,
    "auth_name": "EPSG",
    "auth_id": "4924",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27954,
    "description": "KGD2002",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4926,
    "auth_name": "EPSG",
    "auth_id": "4926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27955,
    "description": "POSGAR 94",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 4928,
    "auth_name": "EPSG",
    "auth_id": "4928",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27956,
    "description": "Australian Antarctic",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4930,
    "auth_name": "EPSG",
    "auth_id": "4930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27957,
    "description": "CHTRS95",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4932,
    "auth_name": "EPSG",
    "auth_id": "4932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27958,
    "description": "EST97",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4934,
    "auth_name": "EPSG",
    "auth_id": "4934",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27959,
    "description": "ETRS89",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4936,
    "auth_name": "EPSG",
    "auth_id": "4936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27960,
    "description": "GDA94",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4938,
    "auth_name": "EPSG",
    "auth_id": "4938",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27961,
    "description": "Hartebeesthoek94",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 4940,
    "auth_name": "EPSG",
    "auth_id": "4940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27962,
    "description": "IRENET95",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4942,
    "auth_name": "EPSG",
    "auth_id": "4942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27963,
    "description": "ISN93",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4944,
    "auth_name": "EPSG",
    "auth_id": "4944",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27964,
    "description": "JGD2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4946,
    "auth_name": "EPSG",
    "auth_id": "4946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27965,
    "description": "LKS-92",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4948,
    "auth_name": "EPSG",
    "auth_id": "4948",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27966,
    "description": "LKS94",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4950,
    "auth_name": "EPSG",
    "auth_id": "4950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27967,
    "description": "Moznet",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 4952,
    "auth_name": "EPSG",
    "auth_id": "4952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27968,
    "description": "NAD83(CSRS)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4954,
    "auth_name": "EPSG",
    "auth_id": "4954",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27969,
    "description": "NAD83(HARN)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4956,
    "auth_name": "EPSG",
    "auth_id": "4956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27970,
    "description": "NZGD2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4958,
    "auth_name": "EPSG",
    "auth_id": "4958",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27971,
    "description": "POSGAR 98",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4960,
    "auth_name": "EPSG",
    "auth_id": "4960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27972,
    "description": "REGVEN",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4962,
    "auth_name": "EPSG",
    "auth_id": "4962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27973,
    "description": "RGF93 v1",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4964,
    "auth_name": "EPSG",
    "auth_id": "4964",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27974,
    "description": "RGFG95",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4966,
    "auth_name": "EPSG",
    "auth_id": "4966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27976,
    "description": "RGR92",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4970,
    "auth_name": "EPSG",
    "auth_id": "4970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27978,
    "description": "SIRGAS 1995",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4974,
    "auth_name": "EPSG",
    "auth_id": "4974",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27979,
    "description": "SWEREF99",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4976,
    "auth_name": "EPSG",
    "auth_id": "4976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27980,
    "description": "WGS 84",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +datum=WGS84 +units=m +no_defs",
    "srid": 4978,
    "auth_name": "EPSG",
    "auth_id": "4978",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27981,
    "description": "Yemen NGN96",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 4980,
    "auth_name": "EPSG",
    "auth_id": "4980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27982,
    "description": "IGM95",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4982,
    "auth_name": "EPSG",
    "auth_id": "4982",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27983,
    "description": "WGS 72",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=geocent +ellps=WGS72 +units=m +no_defs",
    "srid": 4984,
    "auth_name": "EPSG",
    "auth_id": "4984",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27984,
    "description": "WGS 72BE",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=geocent +ellps=WGS72 +units=m +no_defs",
    "srid": 4986,
    "auth_name": "EPSG",
    "auth_id": "4986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27985,
    "description": "SIRGAS 2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4988,
    "auth_name": "EPSG",
    "auth_id": "4988",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27986,
    "description": "Lao 1993",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=geocent +ellps=krass +units=m +no_defs",
    "srid": 4990,
    "auth_name": "EPSG",
    "auth_id": "4990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27987,
    "description": "Lao 1997",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=geocent +ellps=krass +units=m +no_defs",
    "srid": 4992,
    "auth_name": "EPSG",
    "auth_id": "4992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27988,
    "description": "PRS92",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=geocent +ellps=clrk66 +units=m +no_defs",
    "srid": 4994,
    "auth_name": "EPSG",
    "auth_id": "4994",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27989,
    "description": "MAGNA-SIRGAS",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4996,
    "auth_name": "EPSG",
    "auth_id": "4996",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27990,
    "description": "RGPF",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 4998,
    "auth_name": "EPSG",
    "auth_id": "4998",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27991,
    "description": "PTRA08",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5011,
    "auth_name": "EPSG",
    "auth_id": "5011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 27992,
    "description": "PTRA08",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5013,
    "auth_name": "EPSG",
    "auth_id": "5013",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 27993,
    "description": "PTRA08 / UTM zone 25N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=25 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5014,
    "auth_name": "EPSG",
    "auth_id": "5014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27994,
    "description": "PTRA08 / UTM zone 26N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5015,
    "auth_name": "EPSG",
    "auth_id": "5015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27995,
    "description": "PTRA08 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5016,
    "auth_name": "EPSG",
    "auth_id": "5016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27996,
    "description": "Lisbon / Portuguese Grid New",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=39.6666666666667 +lon_0=-8.13190611111111 +k=1 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 5018,
    "auth_name": "EPSG",
    "auth_id": "5018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27997,
    "description": "WGS 84 / UPS North (E,N)",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs",
    "srid": 5041,
    "auth_name": "EPSG",
    "auth_id": "5041",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27998,
    "description": "WGS 84 / UPS South (E,N)",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs",
    "srid": 5042,
    "auth_name": "EPSG",
    "auth_id": "5042",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 27999,
    "description": "ETRS89 / TM35FIN(N,E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5048,
    "auth_name": "EPSG",
    "auth_id": "5048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28000,
    "description": "NAD27 / Conus Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=clrk66 +towgs84=-8,160,176,0,0,0,0 +units=m +no_defs",
    "srid": 5069,
    "auth_name": "EPSG",
    "auth_id": "5069",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28001,
    "description": "NAD83 / Conus Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5070,
    "auth_name": "EPSG",
    "auth_id": "5070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28002,
    "description": "NAD83(HARN) / Conus Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=-0.991,1.9072,0.5129,0.0257899075194932,0.0096500989602704,0.0116599432323421,0 +units=m +no_defs",
    "srid": 5071,
    "auth_name": "EPSG",
    "auth_id": "5071",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28003,
    "description": "NAD83(NSRS2007) / Conus Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5072,
    "auth_name": "EPSG",
    "auth_id": "5072",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28004,
    "description": "ETRS89 / NTM zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5105,
    "auth_name": "EPSG",
    "auth_id": "5105",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28005,
    "description": "ETRS89 / NTM zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5106,
    "auth_name": "EPSG",
    "auth_id": "5106",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28006,
    "description": "ETRS89 / NTM zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5107,
    "auth_name": "EPSG",
    "auth_id": "5107",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28007,
    "description": "ETRS89 / NTM zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5108,
    "auth_name": "EPSG",
    "auth_id": "5108",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28008,
    "description": "ETRS89 / NTM zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5109,
    "auth_name": "EPSG",
    "auth_id": "5109",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28009,
    "description": "ETRS89 / NTM zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5110,
    "auth_name": "EPSG",
    "auth_id": "5110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28010,
    "description": "ETRS89 / NTM zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5111,
    "auth_name": "EPSG",
    "auth_id": "5111",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28011,
    "description": "ETRS89 / NTM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5112,
    "auth_name": "EPSG",
    "auth_id": "5112",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28012,
    "description": "ETRS89 / NTM zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5113,
    "auth_name": "EPSG",
    "auth_id": "5113",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28013,
    "description": "ETRS89 / NTM zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5114,
    "auth_name": "EPSG",
    "auth_id": "5114",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28014,
    "description": "ETRS89 / NTM zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5115,
    "auth_name": "EPSG",
    "auth_id": "5115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28015,
    "description": "ETRS89 / NTM zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5116,
    "auth_name": "EPSG",
    "auth_id": "5116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28016,
    "description": "ETRS89 / NTM zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5117,
    "auth_name": "EPSG",
    "auth_id": "5117",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28017,
    "description": "ETRS89 / NTM zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5118,
    "auth_name": "EPSG",
    "auth_id": "5118",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28018,
    "description": "ETRS89 / NTM zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5119,
    "auth_name": "EPSG",
    "auth_id": "5119",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28019,
    "description": "ETRS89 / NTM zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5120,
    "auth_name": "EPSG",
    "auth_id": "5120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28020,
    "description": "ETRS89 / NTM zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5121,
    "auth_name": "EPSG",
    "auth_id": "5121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28021,
    "description": "ETRS89 / NTM zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5122,
    "auth_name": "EPSG",
    "auth_id": "5122",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28022,
    "description": "ETRS89 / NTM zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5123,
    "auth_name": "EPSG",
    "auth_id": "5123",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28023,
    "description": "ETRS89 / NTM zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5124,
    "auth_name": "EPSG",
    "auth_id": "5124",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28024,
    "description": "ETRS89 / NTM zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5125,
    "auth_name": "EPSG",
    "auth_id": "5125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28025,
    "description": "ETRS89 / NTM zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5126,
    "auth_name": "EPSG",
    "auth_id": "5126",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28026,
    "description": "ETRS89 / NTM zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5127,
    "auth_name": "EPSG",
    "auth_id": "5127",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28027,
    "description": "ETRS89 / NTM zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5128,
    "auth_name": "EPSG",
    "auth_id": "5128",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28028,
    "description": "ETRS89 / NTM zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5129,
    "auth_name": "EPSG",
    "auth_id": "5129",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28029,
    "description": "ETRS89 / NTM zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5130,
    "auth_name": "EPSG",
    "auth_id": "5130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28030,
    "description": "Tokyo 1892",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 5132,
    "auth_name": "EPSG",
    "auth_id": "5132",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28031,
    "description": "Korean 1985 / East Sea Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 5167,
    "auth_name": "EPSG",
    "auth_id": "5167",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28032,
    "description": "Korean 1985 / Central Belt Jeju",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=550000 +ellps=bessel +units=m +no_defs",
    "srid": 5168,
    "auth_name": "EPSG",
    "auth_id": "5168",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28033,
    "description": "Tokyo 1892 / Korea West Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 5169,
    "auth_name": "EPSG",
    "auth_id": "5169",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28034,
    "description": "Tokyo 1892 / Korea Central Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 5170,
    "auth_name": "EPSG",
    "auth_id": "5170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28035,
    "description": "Tokyo 1892 / Korea East Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 5171,
    "auth_name": "EPSG",
    "auth_id": "5171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28036,
    "description": "Tokyo 1892 / Korea East Sea Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 5172,
    "auth_name": "EPSG",
    "auth_id": "5172",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28037,
    "description": "Korean 1985 / Modified West Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=125.002890277778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 5173,
    "auth_name": "EPSG",
    "auth_id": "5173",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28038,
    "description": "Korean 1985 / Modified Central Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127.002890277778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 5174,
    "auth_name": "EPSG",
    "auth_id": "5174",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28039,
    "description": "Korean 1985 / Modified Central Belt Jeju",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127.002890277778 +k=1 +x_0=200000 +y_0=550000 +ellps=bessel +units=m +no_defs",
    "srid": 5175,
    "auth_name": "EPSG",
    "auth_id": "5175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28040,
    "description": "Korean 1985 / Modified East Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=129.002890277778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 5176,
    "auth_name": "EPSG",
    "auth_id": "5176",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28041,
    "description": "Korean 1985 / Modified East Sea Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=131.002890277778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs",
    "srid": 5177,
    "auth_name": "EPSG",
    "auth_id": "5177",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28042,
    "description": "Korean 1985 / Unified CS",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=bessel +units=m +no_defs",
    "srid": 5178,
    "auth_name": "EPSG",
    "auth_id": "5178",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28043,
    "description": "KGD2002 / Unified CS",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5179,
    "auth_name": "EPSG",
    "auth_id": "5179",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28044,
    "description": "KGD2002 / West Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5180,
    "auth_name": "EPSG",
    "auth_id": "5180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28045,
    "description": "KGD2002 / Central Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5181,
    "auth_name": "EPSG",
    "auth_id": "5181",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28046,
    "description": "KGD2002 / Central Belt Jeju",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=550000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5182,
    "auth_name": "EPSG",
    "auth_id": "5182",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28047,
    "description": "KGD2002 / East Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5183,
    "auth_name": "EPSG",
    "auth_id": "5183",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28048,
    "description": "KGD2002 / East Sea Belt",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5184,
    "auth_name": "EPSG",
    "auth_id": "5184",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28049,
    "description": "KGD2002 / West Belt 2010",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5185,
    "auth_name": "EPSG",
    "auth_id": "5185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28050,
    "description": "KGD2002 / Central Belt 2010",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5186,
    "auth_name": "EPSG",
    "auth_id": "5186",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28051,
    "description": "KGD2002 / East Belt 2010",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5187,
    "auth_name": "EPSG",
    "auth_id": "5187",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28052,
    "description": "KGD2002 / East Sea Belt 2010",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5188,
    "auth_name": "EPSG",
    "auth_id": "5188",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28053,
    "description": "WGS 84 / Gabon TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=500000 +datum=WGS84 +units=m +no_defs",
    "srid": 5223,
    "auth_name": "EPSG",
    "auth_id": "5223",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28054,
    "description": "S-JTSK/05",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378 +no_defs",
    "srid": 5228,
    "auth_name": "EPSG",
    "auth_id": "5228",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28055,
    "description": "S-JTSK/05 (Ferro)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +pm=ferro +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378 +no_defs",
    "srid": 5229,
    "auth_name": "EPSG",
    "auth_id": "5229",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28056,
    "description": "SLD99",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=longlat +ellps=evrst30 +towgs84=-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338 +no_defs",
    "srid": 5233,
    "auth_name": "EPSG",
    "auth_id": "5233",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28057,
    "description": "Kandawala / Sri Lanka Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=tmerc +lat_0=7.00048027777778 +lon_0=80.7717111111111 +k=0.9999238418 +x_0=200000 +y_0=200000 +ellps=evrst30 +towgs84=-97,787,86,0,0,0,0 +units=m +no_defs",
    "srid": 5234,
    "auth_name": "EPSG",
    "auth_id": "5234",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28058,
    "description": "SLD99 / Sri Lanka Grid 1999",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=tmerc +lat_0=7.00047152777778 +lon_0=80.7717130833333 +k=0.9999238418 +x_0=500000 +y_0=500000 +ellps=evrst30 +towgs84=-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338 +units=m +no_defs",
    "srid": 5235,
    "auth_name": "EPSG",
    "auth_id": "5235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28059,
    "description": "ETRS89 / LCC Germany (E-N)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=10.5 +lat_1=48.6666666666667 +lat_2=53.6666666666667 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5243,
    "auth_name": "EPSG",
    "auth_id": "5243",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28060,
    "description": "GDBD2009",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5244,
    "auth_name": "EPSG",
    "auth_id": "5244",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28061,
    "description": "GDBD2009",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5246,
    "auth_name": "EPSG",
    "auth_id": "5246",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28062,
    "description": "GDBD2009 / Brunei BRSO",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=4 +lonc=115 +alpha=53.31580995 +gamma=53.1301023611111 +k=0.99984 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5247,
    "auth_name": "EPSG",
    "auth_id": "5247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28063,
    "description": "TUREF",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5250,
    "auth_name": "EPSG",
    "auth_id": "5250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28064,
    "description": "TUREF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5252,
    "auth_name": "EPSG",
    "auth_id": "5252",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28065,
    "description": "TUREF / TM27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5253,
    "auth_name": "EPSG",
    "auth_id": "5253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28066,
    "description": "TUREF / TM30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5254,
    "auth_name": "EPSG",
    "auth_id": "5254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28067,
    "description": "TUREF / TM33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5255,
    "auth_name": "EPSG",
    "auth_id": "5255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28068,
    "description": "TUREF / TM36",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5256,
    "auth_name": "EPSG",
    "auth_id": "5256",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28069,
    "description": "TUREF / TM39",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5257,
    "auth_name": "EPSG",
    "auth_id": "5257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28070,
    "description": "TUREF / TM42",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5258,
    "auth_name": "EPSG",
    "auth_id": "5258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28071,
    "description": "TUREF / TM45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5259,
    "auth_name": "EPSG",
    "auth_id": "5259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28072,
    "description": "DRUKREF 03",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5262,
    "auth_name": "EPSG",
    "auth_id": "5262",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28073,
    "description": "DRUKREF 03",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5264,
    "auth_name": "EPSG",
    "auth_id": "5264",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28074,
    "description": "DRUKREF 03 / Bhutan National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5266,
    "auth_name": "EPSG",
    "auth_id": "5266",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28075,
    "description": "TUREF / 3-degree Gauss-Kruger zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5269,
    "auth_name": "EPSG",
    "auth_id": "5269",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28076,
    "description": "TUREF / 3-degree Gauss-Kruger zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5270,
    "auth_name": "EPSG",
    "auth_id": "5270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28077,
    "description": "TUREF / 3-degree Gauss-Kruger zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5271,
    "auth_name": "EPSG",
    "auth_id": "5271",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28078,
    "description": "TUREF / 3-degree Gauss-Kruger zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5272,
    "auth_name": "EPSG",
    "auth_id": "5272",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28079,
    "description": "TUREF / 3-degree Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5273,
    "auth_name": "EPSG",
    "auth_id": "5273",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28080,
    "description": "TUREF / 3-degree Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5274,
    "auth_name": "EPSG",
    "auth_id": "5274",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28081,
    "description": "TUREF / 3-degree Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5275,
    "auth_name": "EPSG",
    "auth_id": "5275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28082,
    "description": "DRUKREF 03 / Bumthang TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90.7333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5292,
    "auth_name": "EPSG",
    "auth_id": "5292",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28083,
    "description": "DRUKREF 03 / Chhukha TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=89.55 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5293,
    "auth_name": "EPSG",
    "auth_id": "5293",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28084,
    "description": "DRUKREF 03 / Dagana TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=89.85 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5294,
    "auth_name": "EPSG",
    "auth_id": "5294",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28085,
    "description": "DRUKREF 03 / Gasa TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90.0333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5295,
    "auth_name": "EPSG",
    "auth_id": "5295",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28086,
    "description": "DRUKREF 03 / Ha TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90.15 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5296,
    "auth_name": "EPSG",
    "auth_id": "5296",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28087,
    "description": "DRUKREF 03 / Lhuentse TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=91.1333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5297,
    "auth_name": "EPSG",
    "auth_id": "5297",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28088,
    "description": "DRUKREF 03 / Mongar TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=91.2333333333333 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5298,
    "auth_name": "EPSG",
    "auth_id": "5298",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28089,
    "description": "DRUKREF 03 / Paro TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=89.35 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5299,
    "auth_name": "EPSG",
    "auth_id": "5299",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28090,
    "description": "DRUKREF 03 / Pemagatshel TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=91.35 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5300,
    "auth_name": "EPSG",
    "auth_id": "5300",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28091,
    "description": "DRUKREF 03 / Punakha TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=89.85 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5301,
    "auth_name": "EPSG",
    "auth_id": "5301",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28092,
    "description": "DRUKREF 03 / Samdrup Jongkhar TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=91.5666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5302,
    "auth_name": "EPSG",
    "auth_id": "5302",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28093,
    "description": "DRUKREF 03 / Samtse TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=89.0666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5303,
    "auth_name": "EPSG",
    "auth_id": "5303",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28094,
    "description": "DRUKREF 03 / Sarpang TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90.2666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5304,
    "auth_name": "EPSG",
    "auth_id": "5304",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28095,
    "description": "DRUKREF 03 / Thimphu TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=89.55 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5305,
    "auth_name": "EPSG",
    "auth_id": "5305",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28096,
    "description": "DRUKREF 03 / Trashigang TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=91.75 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5306,
    "auth_name": "EPSG",
    "auth_id": "5306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28097,
    "description": "DRUKREF 03 / Trongsa TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90.5 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5307,
    "auth_name": "EPSG",
    "auth_id": "5307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28098,
    "description": "DRUKREF 03 / Tsirang TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90.1666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5308,
    "auth_name": "EPSG",
    "auth_id": "5308",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28099,
    "description": "DRUKREF 03 / Wangdue Phodrang TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90.1166666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5309,
    "auth_name": "EPSG",
    "auth_id": "5309",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28100,
    "description": "DRUKREF 03 / Yangtse TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=91.5666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5310,
    "auth_name": "EPSG",
    "auth_id": "5310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28101,
    "description": "DRUKREF 03 / Zhemgang TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90.8666666666667 +k=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5311,
    "auth_name": "EPSG",
    "auth_id": "5311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28102,
    "description": "ETRS89 / Faroe TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-7 +k=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5316,
    "auth_name": "EPSG",
    "auth_id": "5316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28103,
    "description": "ETRS89 / Faroe TM + FVR09 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-7 +k=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5318,
    "auth_name": "EPSG",
    "auth_id": "5318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28104,
    "description": "NAD83 / Teranet Ontario Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=-84 +lat_1=44.5 +lat_2=54.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5320,
    "auth_name": "EPSG",
    "auth_id": "5320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28105,
    "description": "NAD83(CSRS) / Teranet Ontario Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=-84 +lat_1=44.5 +lat_2=54.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 5321,
    "auth_name": "EPSG",
    "auth_id": "5321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28106,
    "description": "ISN2004",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5324,
    "auth_name": "EPSG",
    "auth_id": "5324",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28107,
    "description": "ISN2004 / Lambert 2004",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=1700000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5325,
    "auth_name": "EPSG",
    "auth_id": "5325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28108,
    "description": "Segara (Jakarta) / NEIEZ",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=merc +lon_0=3.19228055555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +pm=jakarta +towgs84=-403,684,41,0,0,0,0 +units=m +no_defs",
    "srid": 5329,
    "auth_name": "EPSG",
    "auth_id": "5329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28109,
    "description": "Batavia (Jakarta) / NEIEZ",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=merc +lon_0=3.19228055555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +pm=jakarta +towgs84=-377,681,-50,0,0,0,0 +units=m +no_defs",
    "srid": 5330,
    "auth_name": "EPSG",
    "auth_id": "5330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28110,
    "description": "Makassar (Jakarta) / NEIEZ",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=merc +lon_0=3.19228055555556 +k=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +pm=jakarta +towgs84=-587.8,519.75,145.76,0,0,0,0 +units=m +no_defs",
    "srid": 5331,
    "auth_name": "EPSG",
    "auth_id": "5331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28111,
    "description": "Aratu / UTM zone 25S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=25 +south +ellps=intl +units=m +no_defs",
    "srid": 5337,
    "auth_name": "EPSG",
    "auth_id": "5337",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28112,
    "description": "POSGAR 2007",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 5340,
    "auth_name": "EPSG",
    "auth_id": "5340",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28113,
    "description": "POSGAR 2007 / Argentina 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 5343,
    "auth_name": "EPSG",
    "auth_id": "5343",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28114,
    "description": "POSGAR 2007 / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 5344,
    "auth_name": "EPSG",
    "auth_id": "5344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28115,
    "description": "POSGAR 2007 / Argentina 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 5345,
    "auth_name": "EPSG",
    "auth_id": "5345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28116,
    "description": "POSGAR 2007 / Argentina 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-63 +k=1 +x_0=4500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 5346,
    "auth_name": "EPSG",
    "auth_id": "5346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28117,
    "description": "POSGAR 2007 / Argentina 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-60 +k=1 +x_0=5500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 5347,
    "auth_name": "EPSG",
    "auth_id": "5347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28118,
    "description": "POSGAR 2007 / Argentina 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-57 +k=1 +x_0=6500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 5348,
    "auth_name": "EPSG",
    "auth_id": "5348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28119,
    "description": "POSGAR 2007 / Argentina 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-54 +k=1 +x_0=7500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 5349,
    "auth_name": "EPSG",
    "auth_id": "5349",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28120,
    "description": "MARGEN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5354,
    "auth_name": "EPSG",
    "auth_id": "5354",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28121,
    "description": "MARGEN / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5355,
    "auth_name": "EPSG",
    "auth_id": "5355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28122,
    "description": "MARGEN / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5356,
    "auth_name": "EPSG",
    "auth_id": "5356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28123,
    "description": "MARGEN / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5357,
    "auth_name": "EPSG",
    "auth_id": "5357",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28124,
    "description": "SIRGAS-Chile 2002",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 5360,
    "auth_name": "EPSG",
    "auth_id": "5360",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28125,
    "description": "SIRGAS-Chile 2002 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 5361,
    "auth_name": "EPSG",
    "auth_id": "5361",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28126,
    "description": "SIRGAS-Chile 2002 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 5362,
    "auth_name": "EPSG",
    "auth_id": "5362",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28127,
    "description": "CR05",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 5365,
    "auth_name": "EPSG",
    "auth_id": "5365",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28128,
    "description": "CR05 / CRTM05",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 5367,
    "auth_name": "EPSG",
    "auth_id": "5367",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28129,
    "description": "MACARIO SOLIS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5371,
    "auth_name": "EPSG",
    "auth_id": "5371",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28130,
    "description": "Peru96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5373,
    "auth_name": "EPSG",
    "auth_id": "5373",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28131,
    "description": "CH1903 / LV03C-G",
    "projection_acronym": "somerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=somerc +lat_0=46.9524055555556 +lon_0=7.43958333333333 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs",
    "srid": 21782,
    "auth_name": "EPSG",
    "auth_id": "21782",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28132,
    "description": "SIRGAS-ROU98",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5381,
    "auth_name": "EPSG",
    "auth_id": "5381",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28133,
    "description": "SIRGAS-ROU98 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=21 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5382,
    "auth_name": "EPSG",
    "auth_id": "5382",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28134,
    "description": "SIRGAS-ROU98 / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=22 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5383,
    "auth_name": "EPSG",
    "auth_id": "5383",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28135,
    "description": "Peru96 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5387,
    "auth_name": "EPSG",
    "auth_id": "5387",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28137,
    "description": "Peru96 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5389,
    "auth_name": "EPSG",
    "auth_id": "5389",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28138,
    "description": "SIRGAS_ES2007.8",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5393,
    "auth_name": "EPSG",
    "auth_id": "5393",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28139,
    "description": "SIRGAS 2000 / UTM zone 26S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=26 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5396,
    "auth_name": "EPSG",
    "auth_id": "5396",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28140,
    "description": "Ocotepeque 1935",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +no_defs",
    "srid": 5451,
    "auth_name": "EPSG",
    "auth_id": "5451",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28141,
    "description": "Ocotepeque 1935 / Costa Rica Norte",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=10.4666666666667 +lat_0=10.4666666666667 +lon_0=-84.3333333333333 +k_0=0.99995696 +x_0=500000 +y_0=271820.522 +ellps=clrk66 +units=m +no_defs",
    "srid": 5456,
    "auth_name": "EPSG",
    "auth_id": "5456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28142,
    "description": "Ocotepeque 1935 / Costa Rica Sur",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=9 +lat_0=9 +lon_0=-83.6666666666667 +k_0=0.99995696 +x_0=500000 +y_0=327987.436 +ellps=clrk66 +units=m +no_defs",
    "srid": 5457,
    "auth_name": "EPSG",
    "auth_id": "5457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28144,
    "description": "Ocotepeque 1935 / Guatemala Sur",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=14.9 +lat_0=14.9 +lon_0=-90.3333333333333 +k_0=0.99989906 +x_0=500000 +y_0=325992.681 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs",
    "srid": 5459,
    "auth_name": "EPSG",
    "auth_id": "5459",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28145,
    "description": "Ocotepeque 1935 / El Salvador Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=13.7833333333333 +lat_0=13.7833333333333 +lon_0=-89 +k_0=0.99996704 +x_0=500000 +y_0=295809.184 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs",
    "srid": 5460,
    "auth_name": "EPSG",
    "auth_id": "5460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28146,
    "description": "Ocotepeque 1935 / Nicaragua Norte",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=13.8666666666667 +lat_0=13.8666666666667 +lon_0=-85.5 +k_0=0.99990314 +x_0=500000 +y_0=359891.816 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs",
    "srid": 5461,
    "auth_name": "EPSG",
    "auth_id": "5461",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28147,
    "description": "Ocotepeque 1935 / Nicaragua Sur",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=11.7333333333333 +lat_0=11.7333333333333 +lon_0=-85.5 +k_0=0.99992228 +x_0=500000 +y_0=288876.327 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs",
    "srid": 5462,
    "auth_name": "EPSG",
    "auth_id": "5462",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28148,
    "description": "SAD69 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=17 +ellps=aust_SA +towgs84=-57,1,-41,0,0,0,0 +units=m +no_defs",
    "srid": 5463,
    "auth_name": "EPSG",
    "auth_id": "5463",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28149,
    "description": "Sibun Gorge 1922",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378293.64520876 +b=6356617.98767984 +no_defs",
    "srid": 5464,
    "auth_name": "EPSG",
    "auth_id": "5464",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28151,
    "description": "Panama-Colon 1911",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +no_defs",
    "srid": 5467,
    "auth_name": "EPSG",
    "auth_id": "5467",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28152,
    "description": "Panama-Colon 1911 / Panama Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=8.41666666666667 +lat_0=8.41666666666667 +lon_0=-80 +k_0=0.99989909 +x_0=500000 +y_0=294865.303 +ellps=clrk66 +units=m +no_defs",
    "srid": 5469,
    "auth_name": "EPSG",
    "auth_id": "5469",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28153,
    "description": "Panama-Colon 1911 / Panama Polyconic",
    "projection_acronym": "poly",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=poly +lat_0=8.25 +lon_0=-81 +x_0=914391.7962 +y_0=999404.721715486 +ellps=clrk66 +to_meter=0.9143917962 +no_defs",
    "srid": 5472,
    "auth_name": "EPSG",
    "auth_id": "5472",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28154,
    "description": "RSRGD2000 / MSLC2000",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-78 +lon_0=163 +lat_1=-76.6666666666667 +lat_2=-79.3333333333333 +x_0=7000000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5479,
    "auth_name": "EPSG",
    "auth_id": "5479",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28155,
    "description": "RSRGD2000 / BCLC2000",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-74.5 +lon_0=165 +lat_1=-73.6666666666667 +lat_2=-75.3333333333333 +x_0=5000000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5480,
    "auth_name": "EPSG",
    "auth_id": "5480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28156,
    "description": "RSRGD2000 / PCLC2000",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-71.5 +lon_0=166 +lat_1=-70.6666666666667 +lat_2=-72.3333333333333 +x_0=3000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5481,
    "auth_name": "EPSG",
    "auth_id": "5481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28157,
    "description": "RSRGD2000 / RSPS2000",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=180 +k=0.994 +x_0=5000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5482,
    "auth_name": "EPSG",
    "auth_id": "5482",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28158,
    "description": "RGAF09",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5489,
    "auth_name": "EPSG",
    "auth_id": "5489",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28159,
    "description": "RGAF09 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5490,
    "auth_name": "EPSG",
    "auth_id": "5490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28160,
    "description": "CI1971 / Chatham Islands Map Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=350000 +y_0=650000 +ellps=intl +towgs84=175,-38,113,0,0,0,0 +units=m +no_defs",
    "srid": 5518,
    "auth_name": "EPSG",
    "auth_id": "5518",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28161,
    "description": "CI1979 / Chatham Islands Map Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k=1 +x_0=350000 +y_0=650000 +ellps=intl +towgs84=174.05,-25.49,112.57,0,0,0.554,0.2263 +units=m +no_defs",
    "srid": 5519,
    "auth_name": "EPSG",
    "auth_id": "5519",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28162,
    "description": "DHDN / 3-degree Gauss-Kruger zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5520,
    "auth_name": "EPSG",
    "auth_id": "5520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28163,
    "description": "WGS 84 / Gabon TM 2011",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11.5 +k=0.9996 +x_0=1500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs",
    "srid": 5523,
    "auth_name": "EPSG",
    "auth_id": "5523",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28164,
    "description": "Corrego Alegre 1961",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 5524,
    "auth_name": "EPSG",
    "auth_id": "5524",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28165,
    "description": "SAD69(96)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=longlat +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +no_defs",
    "srid": 5527,
    "auth_name": "EPSG",
    "auth_id": "5527",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28166,
    "description": "SAD69(96) / Brazil Polyconic",
    "projection_acronym": "poly",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs",
    "srid": 5530,
    "auth_name": "EPSG",
    "auth_id": "5530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28167,
    "description": "SAD69(96) / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=21 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs",
    "srid": 5531,
    "auth_name": "EPSG",
    "auth_id": "5531",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28169,
    "description": "SAD69(96) / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=23 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs",
    "srid": 5533,
    "auth_name": "EPSG",
    "auth_id": "5533",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28170,
    "description": "SAD69(96) / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=24 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs",
    "srid": 5534,
    "auth_name": "EPSG",
    "auth_id": "5534",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28171,
    "description": "SAD69(96) / UTM zone 25S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=25 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs",
    "srid": 5535,
    "auth_name": "EPSG",
    "auth_id": "5535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28172,
    "description": "Corrego Alegre 1961 / UTM zone 21S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +south +ellps=intl +units=m +no_defs",
    "srid": 5536,
    "auth_name": "EPSG",
    "auth_id": "5536",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28173,
    "description": "Corrego Alegre 1961 / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +south +ellps=intl +units=m +no_defs",
    "srid": 5537,
    "auth_name": "EPSG",
    "auth_id": "5537",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28174,
    "description": "Corrego Alegre 1961 / UTM zone 23S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=23 +south +ellps=intl +units=m +no_defs",
    "srid": 5538,
    "auth_name": "EPSG",
    "auth_id": "5538",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28175,
    "description": "Corrego Alegre 1961 / UTM zone 24S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=24 +south +ellps=intl +units=m +no_defs",
    "srid": 5539,
    "auth_name": "EPSG",
    "auth_id": "5539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28176,
    "description": "PNG94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5546,
    "auth_name": "EPSG",
    "auth_id": "5546",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28177,
    "description": "PNG94 / PNGMG94 zone 54",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=54 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5550,
    "auth_name": "EPSG",
    "auth_id": "5550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28178,
    "description": "PNG94 / PNGMG94 zone 55",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=55 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5551,
    "auth_name": "EPSG",
    "auth_id": "5551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28179,
    "description": "PNG94 / PNGMG94 zone 56",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=56 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5552,
    "auth_name": "EPSG",
    "auth_id": "5552",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28180,
    "description": "Ocotepeque 1935 / Guatemala Norte",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=16.8166666666667 +lat_0=16.8166666666667 +lon_0=-90.3333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +ellps=clrk66 +towgs84=205,96,-98,0,0,0,0 +units=m +no_defs",
    "srid": 5559,
    "auth_name": "EPSG",
    "auth_id": "5559",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28182,
    "description": "GCS_Estonia_1937",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=374,150,588,0,0,0,0 +no_defs",
    "srid": 104101,
    "auth_name": "ESRI",
    "auth_id": "104101",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28183,
    "description": "GCS_Hermannskogel",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 104102,
    "auth_name": "ESRI",
    "auth_id": "104102",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28184,
    "description": "GCS_Sierra_Leone_1960",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 104103,
    "auth_name": "ESRI",
    "auth_id": "104103",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28186,
    "description": "GCS_Datum_Lisboa_Bessel",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 104105,
    "auth_name": "ESRI",
    "auth_id": "104105",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28187,
    "description": "GCS_Datum_Lisboa_Hayford",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 104106,
    "auth_name": "ESRI",
    "auth_id": "104106",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28191,
    "description": "Cape / Lo15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=15 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22275,
    "auth_name": "EPSG",
    "auth_id": "22275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28192,
    "description": "Cape / Lo17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=17 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22277,
    "auth_name": "EPSG",
    "auth_id": "22277",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28193,
    "description": "Cape / Lo19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22279,
    "auth_name": "EPSG",
    "auth_id": "22279",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28194,
    "description": "Cape / Lo21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22281,
    "auth_name": "EPSG",
    "auth_id": "22281",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28195,
    "description": "Cape / Lo23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22283,
    "auth_name": "EPSG",
    "auth_id": "22283",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28196,
    "description": "Cape / Lo25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22285,
    "auth_name": "EPSG",
    "auth_id": "22285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28197,
    "description": "Cape / Lo27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22287,
    "auth_name": "EPSG",
    "auth_id": "22287",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28198,
    "description": "Cape / Lo29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22289,
    "auth_name": "EPSG",
    "auth_id": "22289",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28199,
    "description": "Cape / Lo31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22291,
    "auth_name": "EPSG",
    "auth_id": "22291",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28200,
    "description": "Cape / Lo33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +axis=wsu +lat_0=0 +lon_0=33 +k=1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 22293,
    "auth_name": "EPSG",
    "auth_id": "22293",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28208,
    "description": "NTF (Paris) + NGF IGN69 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +vunits=m +no_defs",
    "srid": 7400,
    "auth_name": "EPSG",
    "auth_id": "7400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28212,
    "description": "RT90 + RH70 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=414.1,41.3,603.1,-0.855,2.141,-7.023,0 +vunits=m +no_defs",
    "srid": 7404,
    "auth_name": "EPSG",
    "auth_id": "7404",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28213,
    "description": "OSGB36 / British National Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "airy",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 7405,
    "auth_name": "EPSG",
    "auth_id": "7405",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28214,
    "description": "NAD27 + NGVD29 height (ftUS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=longlat +datum=NAD27 +vunits=us-ft +no_defs",
    "srid": 7406,
    "auth_name": "EPSG",
    "auth_id": "7406",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28215,
    "description": "NAD27 / Texas North + NGVD29 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.1833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 7407,
    "auth_name": "EPSG",
    "auth_id": "7407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28217,
    "description": "ETRS89 + EVRF2000 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 7409,
    "auth_name": "EPSG",
    "auth_id": "7409",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28218,
    "description": "PSHD93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-180.624,-225.516,173.919,-0.81,-1.898,8.336,16.71006 +vunits=m +no_defs",
    "srid": 7410,
    "auth_name": "EPSG",
    "auth_id": "7410",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28219,
    "description": "NTF (Paris) / Lambert zone II + NGF Lallemand height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 7411,
    "auth_name": "EPSG",
    "auth_id": "7411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28222,
    "description": "Tokyo + JSLD69 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +vunits=m +no_defs",
    "srid": 7414,
    "auth_name": "EPSG",
    "auth_id": "7414",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28223,
    "description": "Amersfoort / RD New + NAP height",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=sterea +lat_0=52.1561605555556 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +vunits=m +no_defs",
    "srid": 7415,
    "auth_name": "EPSG",
    "auth_id": "7415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28224,
    "description": "ETRS89 / UTM zone 32N + DVR90 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 7416,
    "auth_name": "EPSG",
    "auth_id": "7416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28225,
    "description": "ETRS89 / UTM zone 33N + DVR90 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 7417,
    "auth_name": "EPSG",
    "auth_id": "7417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28226,
    "description": "ETRS89 / Kp2000 Jutland + DVR90 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9.5 +k=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 7418,
    "auth_name": "EPSG",
    "auth_id": "7418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28227,
    "description": "ETRS89 / Kp2000 Zealand + DVR90 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 7419,
    "auth_name": "EPSG",
    "auth_id": "7419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28228,
    "description": "ETRS89 / Kp2000 Bornholm + DVR90 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 7420,
    "auth_name": "EPSG",
    "auth_id": "7420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28229,
    "description": "NTF (Paris) / Lambert zone II + NGF-IGN69 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 7421,
    "auth_name": "EPSG",
    "auth_id": "7421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28230,
    "description": "NTF (Paris) / Lambert zone III + NGF-IGN69 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 7422,
    "auth_name": "EPSG",
    "auth_id": "7422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28231,
    "description": "ETRS89 + EVRF2007 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 7423,
    "auth_name": "EPSG",
    "auth_id": "7423",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28232,
    "description": "NAD_1927_StatePlane_Guam_FIPS_5400",
    "projection_acronym": "poly",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=poly +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 65061,
    "auth_name": "ESRI",
    "auth_id": "65061",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28233,
    "description": "NAD_1983_StatePlane_Guam_FIPS_5400",
    "projection_acronym": "poly",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=poly +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +datum=NAD83 +units=m +no_defs",
    "srid": 65161,
    "auth_name": "ESRI",
    "auth_id": "65161",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28235,
    "description": "ETRS89 / Albania LCC 2010",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=20 +lat_1=39 +lat_2=43 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6962,
    "auth_name": "EPSG",
    "auth_id": "6962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28240,
    "description": "IGS08",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6934,
    "auth_name": "EPSG",
    "auth_id": "6934",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28241,
    "description": "WGS 84 / NSIDC EASE-Grid 2.0 South",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 6932,
    "auth_name": "EPSG",
    "auth_id": "6932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28242,
    "description": "WGS 84 / NSIDC EASE-Grid 2.0 Global",
    "projection_acronym": "cea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=cea +lat_ts=30 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 6933,
    "auth_name": "EPSG",
    "auth_id": "6933",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28243,
    "description": "WGS 84 / NSIDC EASE-Grid 2.0 North",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 6931,
    "auth_name": "EPSG",
    "auth_id": "6931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28244,
    "description": "SVY21 / Singapore TM + SHD height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=1.36666666666667 +lon_0=103.833333333333 +k=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 6927,
    "auth_name": "EPSG",
    "auth_id": "6927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28245,
    "description": "NAD83(2011) / Kansas LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6924,
    "auth_name": "EPSG",
    "auth_id": "6924",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28246,
    "description": "NAD83(2011) / Kansas LCC (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6925,
    "auth_name": "EPSG",
    "auth_id": "6925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28247,
    "description": "NAD83 / Kansas LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=400000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 6922,
    "auth_name": "EPSG",
    "auth_id": "6922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28248,
    "description": "NAD83 / Kansas LCC (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=399999.99998984 +y_0=0 +datum=NAD83 +units=us-ft +no_defs",
    "srid": 6923,
    "auth_name": "EPSG",
    "auth_id": "6923",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28249,
    "description": "SVY21 + SHD height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 6917,
    "auth_name": "EPSG",
    "auth_id": "6917",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28250,
    "description": "South East Island 1943 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=40 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 6915,
    "auth_name": "EPSG",
    "auth_id": "6915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28251,
    "description": "RGM04 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 7039,
    "auth_name": "EPSG",
    "auth_id": "7039",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28252,
    "description": "RGR92 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 7037,
    "auth_name": "EPSG",
    "auth_id": "7037",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28253,
    "description": "RGSPM06 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 7035,
    "auth_name": "EPSG",
    "auth_id": "7035",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28254,
    "description": "Nahrwan 1934 / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=38 +a=6378249.145 +rf=293.465 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs",
    "srid": 7006,
    "auth_name": "EPSG",
    "auth_id": "7006",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28255,
    "description": "Nahrwan 1934 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=39 +a=6378249.145 +rf=293.465 +units=m +no_defs",
    "srid": 7007,
    "auth_name": "EPSG",
    "auth_id": "7007",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28256,
    "description": "Nahrwan 1934 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=37 +a=6378249.145 +rf=293.465 +towgs84=-242.2,-144.9,370.3,0,0,0,0 +units=m +no_defs",
    "srid": 7005,
    "auth_name": "EPSG",
    "auth_id": "7005",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28259,
    "description": "IG05/12 Intermediate CRS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=-23.772,-17.49,-17.859,0.3132,1.85274,-1.67299,5.4262 +no_defs",
    "srid": 6990,
    "auth_name": "EPSG",
    "auth_id": "6990",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28260,
    "description": "Israeli Grid 05/12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31.7343936111111 +lon_0=35.2045169444444 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +towgs84=-23.772,-17.49,-17.859,0.3132,1.85274,-1.67299,5.4262 +units=m +no_defs",
    "srid": 6991,
    "auth_name": "EPSG",
    "auth_id": "6991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28261,
    "description": "IG05/12 Intermediate CRS",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6988,
    "auth_name": "EPSG",
    "auth_id": "6988",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28263,
    "description": "Israeli Grid 05",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31.7343936111111 +lon_0=35.2045169444444 +k=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +units=m +no_defs",
    "srid": 6984,
    "auth_name": "EPSG",
    "auth_id": "6984",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28265,
    "description": "IG05 Intermediate CRS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 6983,
    "auth_name": "EPSG",
    "auth_id": "6983",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28267,
    "description": "IG05 Intermediate CRS",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6981,
    "auth_name": "EPSG",
    "auth_id": "6981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28270,
    "description": "RGAF09 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 7086,
    "auth_name": "EPSG",
    "auth_id": "7086",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28271,
    "description": "RGF93 v1 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 7084,
    "auth_name": "EPSG",
    "auth_id": "7084",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28272,
    "description": "RGTAAF07 / UTM zone 43S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=43 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7080,
    "auth_name": "EPSG",
    "auth_id": "7080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28273,
    "description": "RGTAAF07 / UTM zone 44S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=44 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7081,
    "auth_name": "EPSG",
    "auth_id": "7081",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28274,
    "description": "RGTAAF07 / UTM zone 41S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=41 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7078,
    "auth_name": "EPSG",
    "auth_id": "7078",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28275,
    "description": "RGTAAF07 / UTM zone 42S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=42 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7079,
    "auth_name": "EPSG",
    "auth_id": "7079",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28276,
    "description": "RGTAAF07 / UTM zone 39S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=39 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7076,
    "auth_name": "EPSG",
    "auth_id": "7076",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28277,
    "description": "RGTAAF07 / UTM zone 40S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=40 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7077,
    "auth_name": "EPSG",
    "auth_id": "7077",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28278,
    "description": "RGTAAF07 / UTM zone 37S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=37 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7074,
    "auth_name": "EPSG",
    "auth_id": "7074",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28279,
    "description": "RGTAAF07 / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=38 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7075,
    "auth_name": "EPSG",
    "auth_id": "7075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28280,
    "description": "RGTAAF07",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 7073,
    "auth_name": "EPSG",
    "auth_id": "7073",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28281,
    "description": "NAD83(2011) / IaRCS zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.25 +lon_0=-91.25 +k=1.000018 +x_0=7467614.93522987 +y_0=1889763.77952756 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7070,
    "auth_name": "EPSG",
    "auth_id": "7070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28282,
    "description": "RGTAAF07",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7071,
    "auth_name": "EPSG",
    "auth_id": "7071",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28283,
    "description": "NAD83(2011) / IaRCS zone 12",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=40.9166666666667 +lat_0=40.9166666666667 +lon_0=-93.75 +k_0=1.000037 +x_0=6858013.71602743 +y_0=1889763.77952756 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7068,
    "auth_name": "EPSG",
    "auth_id": "7068",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28284,
    "description": "NAD83(2011) / IaRCS zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.25 +lon_0=-91.9166666666667 +k=1.00002 +x_0=7162814.32562865 +y_0=1950723.9014478 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7069,
    "auth_name": "EPSG",
    "auth_id": "7069",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28285,
    "description": "NAD83(2011) / IaRCS zone 10",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=41.8333333333333 +lat_0=41.8333333333333 +lon_0=-91.6666666666667 +k_0=1.00002 +x_0=6248412.49682499 +y_0=2438404.87680975 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7066,
    "auth_name": "EPSG",
    "auth_id": "7066",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28286,
    "description": "NAD83(2011) / IaRCS zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.25 +lon_0=-90.5333333333333 +k=1.000027 +x_0=6553213.10642621 +y_0=2316484.63296927 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7067,
    "auth_name": "EPSG",
    "auth_id": "7067",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28287,
    "description": "NAD83(2011) / IaRCS zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.25 +lon_0=-93.7166666666667 +k=1.000033 +x_0=5638811.27762256 +y_0=2133604.26720853 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7064,
    "auth_name": "EPSG",
    "auth_id": "7064",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28288,
    "description": "NAD83(2011) / IaRCS zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.25 +lon_0=-92.8166666666667 +k=1.000027 +x_0=5943611.88722378 +y_0=2194564.38912878 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7065,
    "auth_name": "EPSG",
    "auth_id": "7065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28289,
    "description": "NAD83(2011) / IaRCS zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.25 +lon_0=-95.7333333333333 +k=1.000039 +x_0=5029210.05842012 +y_0=2011684.02336805 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7062,
    "auth_name": "EPSG",
    "auth_id": "7062",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28290,
    "description": "NAD83(2011) / IaRCS zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.25 +lon_0=-94.6333333333333 +k=1.000045 +x_0=5334010.66802134 +y_0=2072644.14528829 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7063,
    "auth_name": "EPSG",
    "auth_id": "7063",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28291,
    "description": "NAD83(2011) / IaRCS zone 4",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.5333333333333 +lat_0=42.5333333333333 +lon_0=-94.8333333333333 +k_0=1.000045 +x_0=4419608.83921768 +y_0=2621285.24257049 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7060,
    "auth_name": "EPSG",
    "auth_id": "7060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28292,
    "description": "NAD83(2011) / IaRCS zone 5",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.65 +lat_0=42.65 +lon_0=-92.25 +k_0=1.000032 +x_0=4724409.4488189 +y_0=2712725.42545085 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7061,
    "auth_name": "EPSG",
    "auth_id": "7061",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28293,
    "description": "NAD83(2011) / IaRCS zone 2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.1666666666667 +lat_0=43.1666666666667 +lon_0=-92.75 +k_0=1.000043 +x_0=3810007.62001524 +y_0=2987045.97409195 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7058,
    "auth_name": "EPSG",
    "auth_id": "7058",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28294,
    "description": "NAD83(2011) / IaRCS zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.25 +lon_0=-91.2 +k=1.000035 +x_0=4114808.22961646 +y_0=2529845.05969012 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7059,
    "auth_name": "EPSG",
    "auth_id": "7059",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28295,
    "description": "NAD83(2011) / IaRCS zone 1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.2 +lat_0=43.2 +lon_0=-95.25 +k_0=1.000052 +x_0=3505207.01041402 +y_0=2926085.8521717 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7057,
    "auth_name": "EPSG",
    "auth_id": "7057",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28296,
    "description": "RGFG95 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 7041,
    "auth_name": "EPSG",
    "auth_id": "7041",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28297,
    "description": "Palestine 1923 / Palestine Grid modified",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=31.7340969444444 +lon_0=35.2120805555556 +k=1 +x_0=170251.555 +y_0=126867.909 +a=6378300.789 +b=6356566.435 +units=m +no_defs",
    "srid": 7142,
    "auth_name": "EPSG",
    "auth_id": "7142",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28298,
    "description": "IGD05/12",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 7139,
    "auth_name": "EPSG",
    "auth_id": "7139",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28299,
    "description": "IGD05",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 7136,
    "auth_name": "EPSG",
    "auth_id": "7136",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28300,
    "description": "IGD05/12",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 7137,
    "auth_name": "EPSG",
    "auth_id": "7137",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28301,
    "description": "IGD05",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 7134,
    "auth_name": "EPSG",
    "auth_id": "7134",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28302,
    "description": "NAD83(2011) / San Francisco CS13 (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7132,
    "auth_name": "EPSG",
    "auth_id": "7132",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28303,
    "description": "RGTAAF07 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 7133,
    "auth_name": "EPSG",
    "auth_id": "7133",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28304,
    "description": "NAD83(2011) / San Francisco CS13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.75 +lon_0=-122.45 +k=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7131,
    "auth_name": "EPSG",
    "auth_id": "7131",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28305,
    "description": "NAD83(2011) / RMTCRS Wind River (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.6666666666667 +lon_0=-108.333333333333 +k=1.00024 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7128,
    "auth_name": "EPSG",
    "auth_id": "7128",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28306,
    "description": "NAD83(2011) / RMTCRS Bobcat (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.25 +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=99999.9999996 +y_0=99999.9999996 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 7126,
    "auth_name": "EPSG",
    "auth_id": "7126",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28307,
    "description": "NAD83(2011) / RMTCRS Billings (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.7833333333333 +lat_0=45.7833333333333 +lon_0=-108.416666666667 +k_0=1.0001515 +x_0=199999.9999992 +y_0=50000.00001504 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 7127,
    "auth_name": "EPSG",
    "auth_id": "7127",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28308,
    "description": "NAD83(2011) / RMTCRS Fort Peck Sioux (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=48.3333333333333 +lat_0=48.3333333333333 +lon_0=-105.5 +k_0=1.00009 +x_0=99999.9999996 +y_0=49999.99971024 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 7124,
    "auth_name": "EPSG",
    "auth_id": "7124",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28309,
    "description": "NAD83(2011) / RMTCRS Crow (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k=1.000148 +x_0=199999.9999992 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 7125,
    "auth_name": "EPSG",
    "auth_id": "7125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28310,
    "description": "NAD83(2011) / RMTCRS Fort Belknap (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=199999.9999992 +y_0=150000.00001464 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 7122,
    "auth_name": "EPSG",
    "auth_id": "7122",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28311,
    "description": "NAD83(2011) / RMTCRS Fort Peck Assiniboine (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=48.3333333333333 +lat_0=48.3333333333333 +lon_0=-105.5 +k_0=1.00012 +x_0=199999.9999992 +y_0=99999.9999996 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 7123,
    "auth_name": "EPSG",
    "auth_id": "7123",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28312,
    "description": "NAD83(2011) / RMTCRS Blackfeet (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k=1.00019 +x_0=99999.9999996 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 7120,
    "auth_name": "EPSG",
    "auth_id": "7120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28313,
    "description": "NAD83(2011) / RMTCRS Milk River (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000.00001464 +y_0=199999.9999992 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 7121,
    "auth_name": "EPSG",
    "auth_id": "7121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28314,
    "description": "NAD83(2011) / RMTCRS Wind River (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.6666666666667 +lon_0=-108.333333333333 +k=1.00024 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7118,
    "auth_name": "EPSG",
    "auth_id": "7118",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28315,
    "description": "NAD83(2011) / RMTCRS St Mary (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k=1.00016 +x_0=150000.00001464 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 7119,
    "auth_name": "EPSG",
    "auth_id": "7119",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28316,
    "description": "NAD83(2011) / RMTCRS Bobcat (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.25 +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=100000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7116,
    "auth_name": "EPSG",
    "auth_id": "7116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28317,
    "description": "NAD83(2011) / RMTCRS Billings (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.7833333333333 +lat_0=45.7833333333333 +lon_0=-108.416666666667 +k_0=1.0001515 +x_0=200000 +y_0=50000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7117,
    "auth_name": "EPSG",
    "auth_id": "7117",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28318,
    "description": "NAD83(2011) / RMTCRS Fort Peck Sioux (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=48.3333333333333 +lat_0=48.3333333333333 +lon_0=-105.5 +k_0=1.00009 +x_0=100000 +y_0=50000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7114,
    "auth_name": "EPSG",
    "auth_id": "7114",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28319,
    "description": "NAD83(2011) / RMTCRS Crow (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k=1.000148 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7115,
    "auth_name": "EPSG",
    "auth_id": "7115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28320,
    "description": "NAD83(2011) / RMTCRS Fort Belknap (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=200000 +y_0=150000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7112,
    "auth_name": "EPSG",
    "auth_id": "7112",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28321,
    "description": "NAD83(2011) / RMTCRS Fort Peck Assiniboine (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=48.3333333333333 +lat_0=48.3333333333333 +lon_0=-105.5 +k_0=1.00012 +x_0=200000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7113,
    "auth_name": "EPSG",
    "auth_id": "7113",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28322,
    "description": "NAD83(2011) / RMTCRS Blackfeet (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k=1.00019 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7110,
    "auth_name": "EPSG",
    "auth_id": "7110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28323,
    "description": "NAD83(2011) / RMTCRS Milk River (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=48.5 +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7111,
    "auth_name": "EPSG",
    "auth_id": "7111",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28324,
    "description": "NAD83(2011) / RMTCRS St Mary (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k=1.00016 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7109,
    "auth_name": "EPSG",
    "auth_id": "7109",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28325,
    "description": "RDN2008 / UTM zone 33N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6708,
    "auth_name": "EPSG",
    "auth_id": "6708",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28326,
    "description": "RDN2008 / UTM zone 34N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6709,
    "auth_name": "EPSG",
    "auth_id": "6709",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28327,
    "description": "RDN2008",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 6706,
    "auth_name": "EPSG",
    "auth_id": "6706",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28328,
    "description": "RDN2008 / UTM zone 32N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6707,
    "auth_name": "EPSG",
    "auth_id": "6707",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28329,
    "description": "RDN2008",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6704,
    "auth_name": "EPSG",
    "auth_id": "6704",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28330,
    "description": "WGS 84 / TM 60 SW",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-60 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs",
    "srid": 6703,
    "auth_name": "EPSG",
    "auth_id": "6703",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28331,
    "description": "Tokyo + JSLD72 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=-146.414,507.337,680.507,0,0,0,0 +vunits=m +no_defs",
    "srid": 6700,
    "auth_name": "EPSG",
    "auth_id": "6700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28332,
    "description": "JGD2000 + JGD2000 (vertical) height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 6696,
    "auth_name": "EPSG",
    "auth_id": "6696",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28333,
    "description": "JGD2011 + JGD2011 (vertical) height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 6697,
    "auth_name": "EPSG",
    "auth_id": "6697",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28334,
    "description": "JGD2011 / UTM zone 55N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=55 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6692,
    "auth_name": "EPSG",
    "auth_id": "6692",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28335,
    "description": "JGD2011 / UTM zone 53N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=53 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6690,
    "auth_name": "EPSG",
    "auth_id": "6690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28336,
    "description": "JGD2011 / UTM zone 54N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=54 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6691,
    "auth_name": "EPSG",
    "auth_id": "6691",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28337,
    "description": "JGD2011 / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=51 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6688,
    "auth_name": "EPSG",
    "auth_id": "6688",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28338,
    "description": "JGD2011 / UTM zone 52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=52 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6689,
    "auth_name": "EPSG",
    "auth_id": "6689",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28339,
    "description": "JGD2011 / Japan Plane Rectangular CS XVIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=20 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6686,
    "auth_name": "EPSG",
    "auth_id": "6686",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28340,
    "description": "JGD2011 / Japan Plane Rectangular CS XIX",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=154 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6687,
    "auth_name": "EPSG",
    "auth_id": "6687",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28341,
    "description": "JGD2011 / Japan Plane Rectangular CS XVI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=124 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6684,
    "auth_name": "EPSG",
    "auth_id": "6684",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28342,
    "description": "JGD2011 / Japan Plane Rectangular CS XVII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6685,
    "auth_name": "EPSG",
    "auth_id": "6685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28343,
    "description": "JGD2011 / Japan Plane Rectangular CS XIV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=142 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6682,
    "auth_name": "EPSG",
    "auth_id": "6682",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28344,
    "description": "JGD2011 / Japan Plane Rectangular CS XV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=26 +lon_0=127.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6683,
    "auth_name": "EPSG",
    "auth_id": "6683",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28345,
    "description": "JGD2011 / Japan Plane Rectangular CS XII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6680,
    "auth_name": "EPSG",
    "auth_id": "6680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28346,
    "description": "JGD2011 / Japan Plane Rectangular CS XIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6681,
    "auth_name": "EPSG",
    "auth_id": "6681",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28347,
    "description": "JGD2011 / Japan Plane Rectangular CS X",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=140.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6678,
    "auth_name": "EPSG",
    "auth_id": "6678",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28348,
    "description": "JGD2011 / Japan Plane Rectangular CS XI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6679,
    "auth_name": "EPSG",
    "auth_id": "6679",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28349,
    "description": "JGD2011 / Japan Plane Rectangular CS VIII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6676,
    "auth_name": "EPSG",
    "auth_id": "6676",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28350,
    "description": "JGD2011 / Japan Plane Rectangular CS IX",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=139.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6677,
    "auth_name": "EPSG",
    "auth_id": "6677",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28351,
    "description": "JGD2011 / Japan Plane Rectangular CS VI",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6674,
    "auth_name": "EPSG",
    "auth_id": "6674",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28352,
    "description": "JGD2011 / Japan Plane Rectangular CS VII",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=137.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6675,
    "auth_name": "EPSG",
    "auth_id": "6675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28353,
    "description": "JGD2011 / Japan Plane Rectangular CS IV",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6672,
    "auth_name": "EPSG",
    "auth_id": "6672",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28354,
    "description": "JGD2011 / Japan Plane Rectangular CS V",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=134.333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6673,
    "auth_name": "EPSG",
    "auth_id": "6673",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28355,
    "description": "JGD2011 / Japan Plane Rectangular CS II",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6670,
    "auth_name": "EPSG",
    "auth_id": "6670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28356,
    "description": "JGD2011 / Japan Plane Rectangular CS III",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=132.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6671,
    "auth_name": "EPSG",
    "auth_id": "6671",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28357,
    "description": "JGD2011",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 6668,
    "auth_name": "EPSG",
    "auth_id": "6668",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28358,
    "description": "JGD2011 / Japan Plane Rectangular CS I",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6669,
    "auth_name": "EPSG",
    "auth_id": "6669",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28359,
    "description": "JGD2011",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6666,
    "auth_name": "EPSG",
    "auth_id": "6666",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28360,
    "description": "NAD83(CSRS) / UTM zone 21N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6664,
    "auth_name": "EPSG",
    "auth_id": "6664",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28361,
    "description": "NAD83(CSRS) / UTM zone 22N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6665,
    "auth_name": "EPSG",
    "auth_id": "6665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28362,
    "description": "NAD83(CSRS) / UTM zone 19N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6662,
    "auth_name": "EPSG",
    "auth_id": "6662",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28363,
    "description": "NAD83(CSRS) / UTM zone 20N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6663,
    "auth_name": "EPSG",
    "auth_id": "6663",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28364,
    "description": "NAD83(CSRS) / UTM zone 17N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6660,
    "auth_name": "EPSG",
    "auth_id": "6660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28365,
    "description": "NAD83(CSRS) / UTM zone 18N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6661,
    "auth_name": "EPSG",
    "auth_id": "6661",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28366,
    "description": "NAD83(CSRS) / UTM zone 15N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6658,
    "auth_name": "EPSG",
    "auth_id": "6658",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28367,
    "description": "NAD83(CSRS) / UTM zone 16N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6659,
    "auth_name": "EPSG",
    "auth_id": "6659",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28368,
    "description": "NAD83(CSRS) / UTM zone 13N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6656,
    "auth_name": "EPSG",
    "auth_id": "6656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28369,
    "description": "NAD83(CSRS) / UTM zone 14N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6657,
    "auth_name": "EPSG",
    "auth_id": "6657",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28370,
    "description": "NAD83(CORS96)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 6783,
    "auth_name": "EPSG",
    "auth_id": "6783",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28371,
    "description": "NAD83(CORS96)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6781,
    "auth_name": "EPSG",
    "auth_id": "6781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28372,
    "description": "GDA94 / MGA zone 59",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=59 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 6738,
    "auth_name": "EPSG",
    "auth_id": "6738",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28373,
    "description": "GDA94 / MGA zone 46",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=46 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 6736,
    "auth_name": "EPSG",
    "auth_id": "6736",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28374,
    "description": "GDA94 / MGA zone 47",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=47 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 6737,
    "auth_name": "EPSG",
    "auth_id": "6737",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28379,
    "description": "WGS 84 / CKIG92",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=1 +x_0=50000 +y_0=1400000 +datum=WGS84 +units=m +no_defs",
    "srid": 6722,
    "auth_name": "EPSG",
    "auth_id": "6722",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28380,
    "description": "GDA94 / CKIG94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=0.99999387 +x_0=50000 +y_0=1500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6723,
    "auth_name": "EPSG",
    "auth_id": "6723",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28381,
    "description": "WGS 84 / CIG92",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.000024 +x_0=50000 +y_0=1300000 +datum=WGS84 +units=m +no_defs",
    "srid": 6720,
    "auth_name": "EPSG",
    "auth_id": "6720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28382,
    "description": "GDA94 / CIG94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.00002514 +x_0=50000 +y_0=1300000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6721,
    "auth_name": "EPSG",
    "auth_id": "6721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28383,
    "description": "NAD83(2011) / Oregon Pendleton zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.25 +lon_0=-119.166666666667 +k=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6846,
    "auth_name": "EPSG",
    "auth_id": "6846",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28384,
    "description": "NAD83(2011) / Oregon Pendleton zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.25 +lon_0=-119.166666666667 +k=1.000045 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6847,
    "auth_name": "EPSG",
    "auth_id": "6847",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28385,
    "description": "NAD83(CORS96) / Oregon Pendleton zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.25 +lon_0=-119.166666666667 +k=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6844,
    "auth_name": "EPSG",
    "auth_id": "6844",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28386,
    "description": "NAD83(CORS96) / Oregon Pendleton zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.25 +lon_0=-119.166666666667 +k=1.000045 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6845,
    "auth_name": "EPSG",
    "auth_id": "6845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28387,
    "description": "NAD83(2011) / Oregon Coast zone (m)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=44.75 +lonc=-124.05 +alpha=5 +gamma=5 +k=1 +x_0=-300000 +y_0=-4600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6842,
    "auth_name": "EPSG",
    "auth_id": "6842",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28388,
    "description": "NAD83(2011) / Oregon Coast zone (ft)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=44.75 +lonc=-124.05 +alpha=5 +gamma=5 +k=1 +x_0=-299999.9999988 +y_0=-4600000.00001208 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6843,
    "auth_name": "EPSG",
    "auth_id": "6843",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28389,
    "description": "NAD83(CORS96) / Oregon Coast zone (m)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=44.75 +lonc=-124.05 +alpha=5 +gamma=5 +k=1 +x_0=-300000 +y_0=-4600000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6840,
    "auth_name": "EPSG",
    "auth_id": "6840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28390,
    "description": "NAD83(CORS96) / Oregon Coast zone (ft)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=44.75 +lonc=-124.05 +alpha=5 +gamma=5 +k=1 +x_0=-299999.9999988 +y_0=-4600000.00001208 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6841,
    "auth_name": "EPSG",
    "auth_id": "6841",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28391,
    "description": "NAD83(2011) / Oregon Ontario zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6838,
    "auth_name": "EPSG",
    "auth_id": "6838",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28392,
    "description": "NAD83(2011) / Oregon Ontario zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6839,
    "auth_name": "EPSG",
    "auth_id": "6839",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28393,
    "description": "NAD83(CORS96) / Oregon Ontario zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6836,
    "auth_name": "EPSG",
    "auth_id": "6836",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28394,
    "description": "NAD83(CORS96) / Oregon Ontario zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6837,
    "auth_name": "EPSG",
    "auth_id": "6837",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28395,
    "description": "NAD83(2011) / Oregon La Grande zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6834,
    "auth_name": "EPSG",
    "auth_id": "6834",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28396,
    "description": "NAD83(2011) / Oregon La Grande zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6835,
    "auth_name": "EPSG",
    "auth_id": "6835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28397,
    "description": "NAD83(CORS96) / Oregon La Grande zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6832,
    "auth_name": "EPSG",
    "auth_id": "6832",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28398,
    "description": "NAD83(CORS96) / Oregon La Grande zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45 +lon_0=-118 +k=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6833,
    "auth_name": "EPSG",
    "auth_id": "6833",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28399,
    "description": "NAD83(2011) / Oregon Gresham-Warm Springs zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45 +lon_0=-122.333333333333 +k=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6830,
    "auth_name": "EPSG",
    "auth_id": "6830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28400,
    "description": "NAD83(2011) / Oregon Gresham-Warm Springs zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45 +lon_0=-122.333333333333 +k=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6831,
    "auth_name": "EPSG",
    "auth_id": "6831",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28401,
    "description": "NAD83(CORS96) / Oregon Gresham-Warm Springs zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45 +lon_0=-122.333333333333 +k=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6828,
    "auth_name": "EPSG",
    "auth_id": "6828",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28402,
    "description": "NAD83(CORS96) / Oregon Gresham-Warm Springs zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45 +lon_0=-122.333333333333 +k=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6829,
    "auth_name": "EPSG",
    "auth_id": "6829",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28403,
    "description": "NAD83(2011) / Oregon Grants Pass-Ashland zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-123.333333333333 +k=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6826,
    "auth_name": "EPSG",
    "auth_id": "6826",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28404,
    "description": "NAD83(2011) / Oregon Grants Pass-Ashland zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-123.333333333333 +k=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6827,
    "auth_name": "EPSG",
    "auth_id": "6827",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28405,
    "description": "NAD83(CORS96) / Oregon Grants Pass-Ashland zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-123.333333333333 +k=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6824,
    "auth_name": "EPSG",
    "auth_id": "6824",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28406,
    "description": "NAD83(CORS96) / Oregon Grants Pass-Ashland zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-123.333333333333 +k=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6825,
    "auth_name": "EPSG",
    "auth_id": "6825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28407,
    "description": "NAD83(2011) / Oregon Eugene zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.75 +lon_0=-123.166666666667 +k=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6822,
    "auth_name": "EPSG",
    "auth_id": "6822",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28408,
    "description": "NAD83(2011) / Oregon Eugene zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.75 +lon_0=-123.166666666667 +k=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6823,
    "auth_name": "EPSG",
    "auth_id": "6823",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28409,
    "description": "NAD83(CORS96) / Oregon Eugene zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.75 +lon_0=-123.166666666667 +k=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6820,
    "auth_name": "EPSG",
    "auth_id": "6820",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28410,
    "description": "NAD83(CORS96) / Oregon Eugene zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.75 +lon_0=-123.166666666667 +k=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6821,
    "auth_name": "EPSG",
    "auth_id": "6821",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28411,
    "description": "NAD83(2011) / Oregon Dufur-Madras zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6818,
    "auth_name": "EPSG",
    "auth_id": "6818",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28412,
    "description": "NAD83(2011) / Oregon Dufur-Madras zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6819,
    "auth_name": "EPSG",
    "auth_id": "6819",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28413,
    "description": "NAD83(CORS96) / Oregon Dufur-Madras zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6816,
    "auth_name": "EPSG",
    "auth_id": "6816",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28414,
    "description": "NAD83(CORS96) / Oregon Dufur-Madras zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6817,
    "auth_name": "EPSG",
    "auth_id": "6817",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28415,
    "description": "NAD83(2011) / Oregon Cottage Grove-Canyonville zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-123.333333333333 +k=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6814,
    "auth_name": "EPSG",
    "auth_id": "6814",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28416,
    "description": "NAD83(2011) / Oregon Cottage Grove-Canyonville zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-123.333333333333 +k=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6815,
    "auth_name": "EPSG",
    "auth_id": "6815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28417,
    "description": "NAD83(CORS96) / Oregon Cottage Grove-Canyonville zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-123.333333333333 +k=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6812,
    "auth_name": "EPSG",
    "auth_id": "6812",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28418,
    "description": "NAD83(CORS96) / Oregon Cottage Grove-Canyonville zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-123.333333333333 +k=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6813,
    "auth_name": "EPSG",
    "auth_id": "6813",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28419,
    "description": "NAD83(2011) / Oregon Columbia River West zone (m)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.9166666666667 +lonc=-123 +alpha=295 +gamma=295 +k=1 +x_0=7000000 +y_0=-3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6810,
    "auth_name": "EPSG",
    "auth_id": "6810",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28420,
    "description": "NAD83(2011) / Oregon Columbia River West zone (ft)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.9166666666667 +lonc=-123 +alpha=295 +gamma=295 +k=1 +x_0=7000000.00000248 +y_0=-2999999.999988 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6811,
    "auth_name": "EPSG",
    "auth_id": "6811",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28421,
    "description": "NAD83(CORS96) / Oregon Columbia River West zone (m)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.9166666666667 +lonc=-123 +alpha=295 +gamma=295 +k=1 +x_0=7000000 +y_0=-3000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6808,
    "auth_name": "EPSG",
    "auth_id": "6808",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28422,
    "description": "NAD83(CORS96) / Oregon Columbia River West zone (ft)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.9166666666667 +lonc=-123 +alpha=295 +gamma=295 +k=1 +x_0=7000000.00000248 +y_0=-2999999.999988 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6809,
    "auth_name": "EPSG",
    "auth_id": "6809",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28423,
    "description": "NAD83(2011) / Oregon Columbia River East zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.6666666666667 +lat_0=45.6666666666667 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6806,
    "auth_name": "EPSG",
    "auth_id": "6806",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28424,
    "description": "NAD83(2011) / Oregon Columbia River East zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.6666666666667 +lat_0=45.6666666666667 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6807,
    "auth_name": "EPSG",
    "auth_id": "6807",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28425,
    "description": "NAD83(CORS96) / Oregon Columbia River East zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.6666666666667 +lat_0=45.6666666666667 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6804,
    "auth_name": "EPSG",
    "auth_id": "6804",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28426,
    "description": "NAD83(CORS96) / Oregon Columbia River East zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.6666666666667 +lat_0=45.6666666666667 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6805,
    "auth_name": "EPSG",
    "auth_id": "6805",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28427,
    "description": "NAD83(2011) / Oregon Canyonville-Grants Pass zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-123.333333333333 +k=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6802,
    "auth_name": "EPSG",
    "auth_id": "6802",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28428,
    "description": "NAD83(2011) / Oregon Canyonville-Grants Pass zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-123.333333333333 +k=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6803,
    "auth_name": "EPSG",
    "auth_id": "6803",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28429,
    "description": "NAD83(CORS96) / Oregon Canyonville-Grants Pass zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-123.333333333333 +k=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6800,
    "auth_name": "EPSG",
    "auth_id": "6800",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28430,
    "description": "NAD83(CORS96) / Oregon Canyonville-Grants Pass zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-123.333333333333 +k=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6801,
    "auth_name": "EPSG",
    "auth_id": "6801",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28431,
    "description": "NAD83(2011) / Oregon Bend-Burns zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.6666666666667 +lat_0=43.6666666666667 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6798,
    "auth_name": "EPSG",
    "auth_id": "6798",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28432,
    "description": "NAD83(2011) / Oregon Bend-Burns zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.6666666666667 +lat_0=43.6666666666667 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999952 +y_0=59999.99999976 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6799,
    "auth_name": "EPSG",
    "auth_id": "6799",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28433,
    "description": "NAD83(CORS96) / Oregon Bend-Burns zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.6666666666667 +lat_0=43.6666666666667 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6796,
    "auth_name": "EPSG",
    "auth_id": "6796",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28434,
    "description": "NAD83(CORS96) / Oregon Bend-Burns zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.6666666666667 +lat_0=43.6666666666667 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999952 +y_0=59999.99999976 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6797,
    "auth_name": "EPSG",
    "auth_id": "6797",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28435,
    "description": "NAD83(2011) / Oregon Bend-Redmond-Prineville zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6666666666667 +lat_0=44.6666666666667 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6794,
    "auth_name": "EPSG",
    "auth_id": "6794",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28436,
    "description": "NAD83(2011) / Oregon Bend-Redmond-Prineville zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6666666666667 +lat_0=44.6666666666667 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6795,
    "auth_name": "EPSG",
    "auth_id": "6795",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28437,
    "description": "NAD83(CORS96) / Oregon Bend-Redmond-Prineville zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6666666666667 +lat_0=44.6666666666667 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6792,
    "auth_name": "EPSG",
    "auth_id": "6792",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28438,
    "description": "NAD83(CORS96) / Oregon Bend-Redmond-Prineville zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6666666666667 +lat_0=44.6666666666667 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6793,
    "auth_name": "EPSG",
    "auth_id": "6793",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28439,
    "description": "NAD83(2011) / Oregon Bend-Klamath Falls zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6790,
    "auth_name": "EPSG",
    "auth_id": "6790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28440,
    "description": "NAD83(2011) / Oregon Bend-Klamath Falls zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6791,
    "auth_name": "EPSG",
    "auth_id": "6791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28441,
    "description": "NAD83(CORS96) / Oregon Bend-Klamath Falls zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6788,
    "auth_name": "EPSG",
    "auth_id": "6788",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28442,
    "description": "NAD83(CORS96) / Oregon Bend-Klamath Falls zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6789,
    "auth_name": "EPSG",
    "auth_id": "6789",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28443,
    "description": "NAD83(2011) / Oregon Baker zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5 +lon_0=-117.833333333333 +k=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6786,
    "auth_name": "EPSG",
    "auth_id": "6786",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28444,
    "description": "NAD83(2011) / Oregon Baker zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5 +lon_0=-117.833333333333 +k=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6787,
    "auth_name": "EPSG",
    "auth_id": "6787",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28445,
    "description": "NAD83(CORS96) / Oregon Baker zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5 +lon_0=-117.833333333333 +k=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6784,
    "auth_name": "EPSG",
    "auth_id": "6784",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28446,
    "description": "NAD83(CORS96) / Oregon Baker zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5 +lon_0=-117.833333333333 +k=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6785,
    "auth_name": "EPSG",
    "auth_id": "6785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28447,
    "description": "Gambia",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-63,176,185,0,0,0,0 +no_defs",
    "srid": 6894,
    "auth_name": "EPSG",
    "auth_id": "6894",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28448,
    "description": "South East Island 1943",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +no_defs",
    "srid": 6892,
    "auth_name": "EPSG",
    "auth_id": "6892",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28449,
    "description": "WGS 84 / World Mercator + EGM2008 height",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +geoidgrids=us_nga_egm08_25.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6893,
    "auth_name": "EPSG",
    "auth_id": "6893",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28450,
    "description": "NAD83(CORS96) / Oregon South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6886,
    "auth_name": "EPSG",
    "auth_id": "6886",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28451,
    "description": "NAD83(CORS96) / Oregon South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6887,
    "auth_name": "EPSG",
    "auth_id": "6887",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28452,
    "description": "NAD83(CORS96) / Oregon North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6884,
    "auth_name": "EPSG",
    "auth_id": "6884",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28453,
    "description": "NAD83(CORS96) / Oregon North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6885,
    "auth_name": "EPSG",
    "auth_id": "6885",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28454,
    "description": "Bekaa Valley 1920",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-183,-15,273,0,0,0,0 +no_defs",
    "srid": 6882,
    "auth_name": "EPSG",
    "auth_id": "6882",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28455,
    "description": "Bioko",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-235,-110,393,0,0,0,0 +no_defs",
    "srid": 6883,
    "auth_name": "EPSG",
    "auth_id": "6883",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28456,
    "description": "NAD83(2011) / Nebraska (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6880,
    "auth_name": "EPSG",
    "auth_id": "6880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28457,
    "description": "Aden 1925",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-24,-203,268,0,0,0,0 +no_defs",
    "srid": 6881,
    "auth_name": "EPSG",
    "auth_id": "6881",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28458,
    "description": "NAD83(2011) / Wisconsin Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6879,
    "auth_name": "EPSG",
    "auth_id": "6879",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28459,
    "description": "RDN2008 / Zone 12 (N-E)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=3000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6876,
    "auth_name": "EPSG",
    "auth_id": "6876",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28460,
    "description": "RDN2008 / Italy zone (N-E)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9985 +x_0=7000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6875,
    "auth_name": "EPSG",
    "auth_id": "6875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28461,
    "description": "ETRS89 / Albania TM 2010",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6870,
    "auth_name": "EPSG",
    "auth_id": "6870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28463,
    "description": "NAD83(CORS96) / Oregon GIC Lambert (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6868,
    "auth_name": "EPSG",
    "auth_id": "6868",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28464,
    "description": "NAD83(CORS96) / Oregon LCC (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6867,
    "auth_name": "EPSG",
    "auth_id": "6867",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28465,
    "description": "NAD83(2011) / Oregon Santiam Pass zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0833333333333 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6862,
    "auth_name": "EPSG",
    "auth_id": "6862",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28466,
    "description": "NAD83(2011) / Oregon Santiam Pass zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0833333333333 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6863,
    "auth_name": "EPSG",
    "auth_id": "6863",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28467,
    "description": "NAD83(CORS96) / Oregon Santiam Pass zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0833333333333 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6860,
    "auth_name": "EPSG",
    "auth_id": "6860",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28468,
    "description": "NAD83(CORS96) / Oregon Santiam Pass zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0833333333333 +lon_0=-122.5 +k=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6861,
    "auth_name": "EPSG",
    "auth_id": "6861",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28469,
    "description": "NAD83(2011) / Oregon Salem zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.3333333333333 +lon_0=-123.083333333333 +k=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6858,
    "auth_name": "EPSG",
    "auth_id": "6858",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28470,
    "description": "NAD83(2011) / Oregon Salem zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.3333333333333 +lon_0=-123.083333333333 +k=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6859,
    "auth_name": "EPSG",
    "auth_id": "6859",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28471,
    "description": "NAD83(CORS96) / Oregon Salem zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.3333333333333 +lon_0=-123.083333333333 +k=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6856,
    "auth_name": "EPSG",
    "auth_id": "6856",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28472,
    "description": "NAD83(CORS96) / Oregon Salem zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.3333333333333 +lon_0=-123.083333333333 +k=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6857,
    "auth_name": "EPSG",
    "auth_id": "6857",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28473,
    "description": "NAD83(2011) / Oregon Portland zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6854,
    "auth_name": "EPSG",
    "auth_id": "6854",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28474,
    "description": "NAD83(2011) / Oregon Portland zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.9999996 +y_0=50000.00001504 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6855,
    "auth_name": "EPSG",
    "auth_id": "6855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28475,
    "description": "NAD83(CORS96) / Oregon Portland zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6852,
    "auth_name": "EPSG",
    "auth_id": "6852",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28476,
    "description": "NAD83(CORS96) / Oregon Portland zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.5 +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.9999996 +y_0=50000.00001504 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6853,
    "auth_name": "EPSG",
    "auth_id": "6853",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28477,
    "description": "NAD83(2011) / Oregon Pendleton-La Grande zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.0833333333333 +lon_0=-118.333333333333 +k=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6850,
    "auth_name": "EPSG",
    "auth_id": "6850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28478,
    "description": "NAD83(2011) / Oregon Pendleton-La Grande zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.0833333333333 +lon_0=-118.333333333333 +k=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6851,
    "auth_name": "EPSG",
    "auth_id": "6851",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28479,
    "description": "NAD83(CORS96) / Oregon Pendleton-La Grande zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.0833333333333 +lon_0=-118.333333333333 +k=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6848,
    "auth_name": "EPSG",
    "auth_id": "6848",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28480,
    "description": "NAD83(CORS96) / Oregon Pendleton-La Grande zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.0833333333333 +lon_0=-118.333333333333 +k=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +units=ft +no_defs",
    "srid": 6849,
    "auth_name": "EPSG",
    "auth_id": "6849",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28481,
    "description": "NAD83(2011) / Iowa North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6462,
    "auth_name": "EPSG",
    "auth_id": "6462",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28482,
    "description": "NAD83(2011) / Iowa North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6463,
    "auth_name": "EPSG",
    "auth_id": "6463",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28483,
    "description": "NAD83(2011) / Indiana West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6460,
    "auth_name": "EPSG",
    "auth_id": "6460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28484,
    "description": "NAD83(2011) / Indiana West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6461,
    "auth_name": "EPSG",
    "auth_id": "6461",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28485,
    "description": "NAD83(2011) / Indiana East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6458,
    "auth_name": "EPSG",
    "auth_id": "6458",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28486,
    "description": "NAD83(2011) / Indiana East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6459,
    "auth_name": "EPSG",
    "auth_id": "6459",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28487,
    "description": "NAD83(2011) / Illinois West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6456,
    "auth_name": "EPSG",
    "auth_id": "6456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28488,
    "description": "NAD83(2011) / Illinois West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6457,
    "auth_name": "EPSG",
    "auth_id": "6457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28489,
    "description": "NAD83(2011) / Illinois East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6454,
    "auth_name": "EPSG",
    "auth_id": "6454",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28490,
    "description": "NAD83(2011) / Illinois East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6455,
    "auth_name": "EPSG",
    "auth_id": "6455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28491,
    "description": "NAD83(2011) / Idaho West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6452,
    "auth_name": "EPSG",
    "auth_id": "6452",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28492,
    "description": "NAD83(2011) / Idaho West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6453,
    "auth_name": "EPSG",
    "auth_id": "6453",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28493,
    "description": "NAD83(2011) / Idaho East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6450,
    "auth_name": "EPSG",
    "auth_id": "6450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28494,
    "description": "NAD83(2011) / Idaho East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6451,
    "auth_name": "EPSG",
    "auth_id": "6451",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28495,
    "description": "NAD83(2011) / Idaho Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6448,
    "auth_name": "EPSG",
    "auth_id": "6448",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28496,
    "description": "NAD83(2011) / Idaho Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6449,
    "auth_name": "EPSG",
    "auth_id": "6449",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28497,
    "description": "NAD83(2011) / Georgia West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6446,
    "auth_name": "EPSG",
    "auth_id": "6446",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28498,
    "description": "NAD83(2011) / Georgia West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6447,
    "auth_name": "EPSG",
    "auth_id": "6447",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28499,
    "description": "NAD83(2011) / Georgia East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6444,
    "auth_name": "EPSG",
    "auth_id": "6444",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28500,
    "description": "NAD83(2011) / Georgia East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6445,
    "auth_name": "EPSG",
    "auth_id": "6445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28501,
    "description": "NAD83(2011) / Florida West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6442,
    "auth_name": "EPSG",
    "auth_id": "6442",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28502,
    "description": "NAD83(2011) / Florida West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6443,
    "auth_name": "EPSG",
    "auth_id": "6443",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28503,
    "description": "NAD83(2011) / Florida North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6440,
    "auth_name": "EPSG",
    "auth_id": "6440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28504,
    "description": "NAD83(2011) / Florida North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6441,
    "auth_name": "EPSG",
    "auth_id": "6441",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28505,
    "description": "NAD83(2011) / Florida East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6438,
    "auth_name": "EPSG",
    "auth_id": "6438",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28506,
    "description": "NAD83(2011) / Florida GDL Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6439,
    "auth_name": "EPSG",
    "auth_id": "6439",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28507,
    "description": "NAD83(2011) / Delaware (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6436,
    "auth_name": "EPSG",
    "auth_id": "6436",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28508,
    "description": "NAD83(2011) / Florida East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6437,
    "auth_name": "EPSG",
    "auth_id": "6437",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28509,
    "description": "NAD83(2011) / Connecticut (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6434,
    "auth_name": "EPSG",
    "auth_id": "6434",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28510,
    "description": "NAD83(2011) / Delaware",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6435,
    "auth_name": "EPSG",
    "auth_id": "6435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28511,
    "description": "NAD83(2011) / Colorado South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6432,
    "auth_name": "EPSG",
    "auth_id": "6432",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28512,
    "description": "NAD83(2011) / Connecticut",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6433,
    "auth_name": "EPSG",
    "auth_id": "6433",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28513,
    "description": "NAD83(2011) / Colorado North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6430,
    "auth_name": "EPSG",
    "auth_id": "6430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28514,
    "description": "NAD83(2011) / Colorado South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6431,
    "auth_name": "EPSG",
    "auth_id": "6431",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28515,
    "description": "NAD83(2011) / Colorado Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6428,
    "auth_name": "EPSG",
    "auth_id": "6428",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28516,
    "description": "NAD83(2011) / Colorado North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6429,
    "auth_name": "EPSG",
    "auth_id": "6429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28517,
    "description": "NAD83(2011) / California zone 6 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6426,
    "auth_name": "EPSG",
    "auth_id": "6426",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28518,
    "description": "NAD83(2011) / Colorado Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6427,
    "auth_name": "EPSG",
    "auth_id": "6427",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28519,
    "description": "NAD83(2011) / California zone 5 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6424,
    "auth_name": "EPSG",
    "auth_id": "6424",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28520,
    "description": "NAD83(2011) / California zone 6",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6425,
    "auth_name": "EPSG",
    "auth_id": "6425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28521,
    "description": "NAD83(2011) / California zone 4 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6422,
    "auth_name": "EPSG",
    "auth_id": "6422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28522,
    "description": "NAD83(2011) / California zone 5",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6423,
    "auth_name": "EPSG",
    "auth_id": "6423",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28523,
    "description": "NAD83(2011) / California zone 3 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6420,
    "auth_name": "EPSG",
    "auth_id": "6420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28524,
    "description": "NAD83(2011) / California zone 4",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6421,
    "auth_name": "EPSG",
    "auth_id": "6421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28525,
    "description": "NAD83(2011) / California zone 2 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6418,
    "auth_name": "EPSG",
    "auth_id": "6418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28526,
    "description": "NAD83(2011) / California zone 3",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6419,
    "auth_name": "EPSG",
    "auth_id": "6419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28527,
    "description": "NAD83(2011) / California zone 1 (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6416,
    "auth_name": "EPSG",
    "auth_id": "6416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28528,
    "description": "NAD83(2011) / California zone 2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6417,
    "auth_name": "EPSG",
    "auth_id": "6417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28529,
    "description": "NAD83(2011) / California Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6414,
    "auth_name": "EPSG",
    "auth_id": "6414",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28530,
    "description": "NAD83(2011) / California zone 1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6415,
    "auth_name": "EPSG",
    "auth_id": "6415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28531,
    "description": "NAD83(2011) / Arkansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6412,
    "auth_name": "EPSG",
    "auth_id": "6412",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28532,
    "description": "NAD83(2011) / Arkansas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6413,
    "auth_name": "EPSG",
    "auth_id": "6413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28533,
    "description": "NAD83(2011) / Arkansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6410,
    "auth_name": "EPSG",
    "auth_id": "6410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28534,
    "description": "NAD83(2011) / Arkansas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6411,
    "auth_name": "EPSG",
    "auth_id": "6411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28535,
    "description": "NAD83(2011) / Arizona West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6408,
    "auth_name": "EPSG",
    "auth_id": "6408",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28536,
    "description": "NAD83(2011) / Arizona West (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6409,
    "auth_name": "EPSG",
    "auth_id": "6409",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28537,
    "description": "NAD83(2011) / Arizona East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6406,
    "auth_name": "EPSG",
    "auth_id": "6406",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28538,
    "description": "NAD83(2011) / Arizona East (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6407,
    "auth_name": "EPSG",
    "auth_id": "6407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28539,
    "description": "NAD83(2011) / Arizona Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6404,
    "auth_name": "EPSG",
    "auth_id": "6404",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28540,
    "description": "NAD83(2011) / Arizona Central (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6405,
    "auth_name": "EPSG",
    "auth_id": "6405",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28541,
    "description": "NAD83(2011) / Alaska zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6402,
    "auth_name": "EPSG",
    "auth_id": "6402",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28542,
    "description": "NAD83(2011) / Alaska zone 10",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6403,
    "auth_name": "EPSG",
    "auth_id": "6403",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28543,
    "description": "NAD83(2011) / Alaska zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6400,
    "auth_name": "EPSG",
    "auth_id": "6400",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28544,
    "description": "NAD83(2011) / Alaska zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6401,
    "auth_name": "EPSG",
    "auth_id": "6401",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28545,
    "description": "NAD83(2011) / New Jersey",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6526,
    "auth_name": "EPSG",
    "auth_id": "6526",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28546,
    "description": "NAD83(2011) / New Jersey (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6527,
    "auth_name": "EPSG",
    "auth_id": "6527",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28547,
    "description": "NAD83(2011) / New Hampshire",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6524,
    "auth_name": "EPSG",
    "auth_id": "6524",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28548,
    "description": "NAD83(2011) / New Hampshire (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6525,
    "auth_name": "EPSG",
    "auth_id": "6525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28549,
    "description": "NAD83(2011) / Nevada West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6522,
    "auth_name": "EPSG",
    "auth_id": "6522",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28550,
    "description": "NAD83(2011) / Nevada West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6523,
    "auth_name": "EPSG",
    "auth_id": "6523",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28551,
    "description": "NAD83(2011) / Nevada East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6520,
    "auth_name": "EPSG",
    "auth_id": "6520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28552,
    "description": "NAD83(2011) / Nevada East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6521,
    "auth_name": "EPSG",
    "auth_id": "6521",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28553,
    "description": "NAD83(2011) / Nevada Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6518,
    "auth_name": "EPSG",
    "auth_id": "6518",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28554,
    "description": "NAD83(2011) / Nevada Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6519,
    "auth_name": "EPSG",
    "auth_id": "6519",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28555,
    "description": "NAD83(2011) / Nebraska",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6516,
    "auth_name": "EPSG",
    "auth_id": "6516",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28557,
    "description": "NAD83(2011) / Montana",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6514,
    "auth_name": "EPSG",
    "auth_id": "6514",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28558,
    "description": "NAD83(2011) / Montana (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6515,
    "auth_name": "EPSG",
    "auth_id": "6515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28559,
    "description": "NAD83(2011) / Missouri East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6512,
    "auth_name": "EPSG",
    "auth_id": "6512",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28560,
    "description": "NAD83(2011) / Missouri West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6513,
    "auth_name": "EPSG",
    "auth_id": "6513",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28561,
    "description": "NAD83(2011) / Mississippi West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6510,
    "auth_name": "EPSG",
    "auth_id": "6510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28562,
    "description": "NAD83(2011) / Missouri Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6511,
    "auth_name": "EPSG",
    "auth_id": "6511",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28563,
    "description": "NAD83(2011) / Mississippi TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6508,
    "auth_name": "EPSG",
    "auth_id": "6508",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28564,
    "description": "NAD83(2011) / Mississippi West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6509,
    "auth_name": "EPSG",
    "auth_id": "6509",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28565,
    "description": "NAD83(2011) / Mississippi East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6506,
    "auth_name": "EPSG",
    "auth_id": "6506",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28566,
    "description": "NAD83(2011) / Mississippi East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6507,
    "auth_name": "EPSG",
    "auth_id": "6507",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28567,
    "description": "NAD83(2011) / Minnesota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6504,
    "auth_name": "EPSG",
    "auth_id": "6504",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28568,
    "description": "NAD83(2011) / Minnesota South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6505,
    "auth_name": "EPSG",
    "auth_id": "6505",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28569,
    "description": "NAD83(2011) / Minnesota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6502,
    "auth_name": "EPSG",
    "auth_id": "6502",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28570,
    "description": "NAD83(2011) / Minnesota North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6503,
    "auth_name": "EPSG",
    "auth_id": "6503",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28571,
    "description": "NAD83(2011) / Minnesota Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6500,
    "auth_name": "EPSG",
    "auth_id": "6500",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28572,
    "description": "NAD83(2011) / Minnesota Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6501,
    "auth_name": "EPSG",
    "auth_id": "6501",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28573,
    "description": "NAD83(2011) / Michigan South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6498,
    "auth_name": "EPSG",
    "auth_id": "6498",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28574,
    "description": "NAD83(2011) / Michigan South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6499,
    "auth_name": "EPSG",
    "auth_id": "6499",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28575,
    "description": "NAD83(2011) / Michigan North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6496,
    "auth_name": "EPSG",
    "auth_id": "6496",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28576,
    "description": "NAD83(2011) / Michigan Oblique Mercator",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=45.3091666666667 +lonc=-86 +alpha=337.25556 +gamma=337.25556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6497,
    "auth_name": "EPSG",
    "auth_id": "6497",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28577,
    "description": "NAD83(2011) / Michigan Central (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6494,
    "auth_name": "EPSG",
    "auth_id": "6494",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28578,
    "description": "NAD83(2011) / Michigan North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6495,
    "auth_name": "EPSG",
    "auth_id": "6495",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28579,
    "description": "NAD83(2011) / Massachusetts Mainland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6492,
    "auth_name": "EPSG",
    "auth_id": "6492",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28580,
    "description": "NAD83(2011) / Michigan Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6493,
    "auth_name": "EPSG",
    "auth_id": "6493",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28581,
    "description": "NAD83(2011) / Massachusetts Island (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6490,
    "auth_name": "EPSG",
    "auth_id": "6490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28582,
    "description": "NAD83(2011) / Massachusetts Mainland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6491,
    "auth_name": "EPSG",
    "auth_id": "6491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28583,
    "description": "NAD83(2011) / Maryland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6488,
    "auth_name": "EPSG",
    "auth_id": "6488",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28584,
    "description": "NAD83(2011) / Massachusetts Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6489,
    "auth_name": "EPSG",
    "auth_id": "6489",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28585,
    "description": "NAD83(2011) / Maine West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6486,
    "auth_name": "EPSG",
    "auth_id": "6486",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28586,
    "description": "NAD83(2011) / Maryland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6487,
    "auth_name": "EPSG",
    "auth_id": "6487",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28587,
    "description": "NAD83(2011) / Maine East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6484,
    "auth_name": "EPSG",
    "auth_id": "6484",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28588,
    "description": "NAD83(2011) / Maine West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6485,
    "auth_name": "EPSG",
    "auth_id": "6485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28589,
    "description": "NAD83(2011) / Maine CS2000 West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6482,
    "auth_name": "EPSG",
    "auth_id": "6482",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28590,
    "description": "NAD83(2011) / Maine East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6483,
    "auth_name": "EPSG",
    "auth_id": "6483",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28591,
    "description": "NAD83(2011) / Maine CS2000 Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6480,
    "auth_name": "EPSG",
    "auth_id": "6480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28592,
    "description": "NAD83(2011) / Maine CS2000 East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6481,
    "auth_name": "EPSG",
    "auth_id": "6481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28593,
    "description": "NAD83(2011) / Louisiana South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6478,
    "auth_name": "EPSG",
    "auth_id": "6478",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28594,
    "description": "NAD83(2011) / Louisiana South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6479,
    "auth_name": "EPSG",
    "auth_id": "6479",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28595,
    "description": "NAD83(2011) / Louisiana North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6476,
    "auth_name": "EPSG",
    "auth_id": "6476",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28596,
    "description": "NAD83(2011) / Louisiana North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6477,
    "auth_name": "EPSG",
    "auth_id": "6477",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28597,
    "description": "NAD83(2011) / Kentucky South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6474,
    "auth_name": "EPSG",
    "auth_id": "6474",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28598,
    "description": "NAD83(2011) / Kentucky South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6475,
    "auth_name": "EPSG",
    "auth_id": "6475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28599,
    "description": "NAD83(2011) / Kentucky Single Zone",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6472,
    "auth_name": "EPSG",
    "auth_id": "6472",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28600,
    "description": "NAD83(2011) / Kentucky Single Zone (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6473,
    "auth_name": "EPSG",
    "auth_id": "6473",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28601,
    "description": "NAD83(2011) / Kentucky North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6470,
    "auth_name": "EPSG",
    "auth_id": "6470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28602,
    "description": "NAD83(2011) / Kentucky North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6471,
    "auth_name": "EPSG",
    "auth_id": "6471",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28603,
    "description": "NAD83(2011) / Kansas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6468,
    "auth_name": "EPSG",
    "auth_id": "6468",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28604,
    "description": "NAD83(2011) / Kansas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6469,
    "auth_name": "EPSG",
    "auth_id": "6469",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28605,
    "description": "NAD83(2011) / Kansas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6466,
    "auth_name": "EPSG",
    "auth_id": "6466",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28606,
    "description": "NAD83(2011) / Kansas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6467,
    "auth_name": "EPSG",
    "auth_id": "6467",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28607,
    "description": "NAD83(2011) / Iowa South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6464,
    "auth_name": "EPSG",
    "auth_id": "6464",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28608,
    "description": "NAD83(2011) / Iowa South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6465,
    "auth_name": "EPSG",
    "auth_id": "6465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28609,
    "description": "NAD83(2011) / Vermont (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6590,
    "auth_name": "EPSG",
    "auth_id": "6590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28610,
    "description": "NAD83(2011) / Virginia Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36 +lon_0=-79.5 +lat_1=37 +lat_2=39.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6591,
    "auth_name": "EPSG",
    "auth_id": "6591",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28611,
    "description": "NAD83(2011) / Texas South Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6588,
    "auth_name": "EPSG",
    "auth_id": "6588",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28612,
    "description": "NAD83(2011) / Vermont",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6589,
    "auth_name": "EPSG",
    "auth_id": "6589",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28613,
    "description": "NAD83(2011) / Texas South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6586,
    "auth_name": "EPSG",
    "auth_id": "6586",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28614,
    "description": "NAD83(2011) / Texas South Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6587,
    "auth_name": "EPSG",
    "auth_id": "6587",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28615,
    "description": "NAD83(2011) / Texas North Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6584,
    "auth_name": "EPSG",
    "auth_id": "6584",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28616,
    "description": "NAD83(2011) / Texas South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6585,
    "auth_name": "EPSG",
    "auth_id": "6585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28617,
    "description": "NAD83(2011) / Texas North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6582,
    "auth_name": "EPSG",
    "auth_id": "6582",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28618,
    "description": "NAD83(2011) / Texas North Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6583,
    "auth_name": "EPSG",
    "auth_id": "6583",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28619,
    "description": "NAD83(2011) / Texas Centric Lambert Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6580,
    "auth_name": "EPSG",
    "auth_id": "6580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28620,
    "description": "NAD83(2011) / Texas North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6581,
    "auth_name": "EPSG",
    "auth_id": "6581",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28621,
    "description": "NAD83(2011) / Texas Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6578,
    "auth_name": "EPSG",
    "auth_id": "6578",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28622,
    "description": "NAD83(2011) / Texas Centric Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6579,
    "auth_name": "EPSG",
    "auth_id": "6579",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28623,
    "description": "NAD83(2011) / Tennessee (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6576,
    "auth_name": "EPSG",
    "auth_id": "6576",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28624,
    "description": "NAD83(2011) / Texas Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6577,
    "auth_name": "EPSG",
    "auth_id": "6577",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28625,
    "description": "NAD83(2011) / South Dakota South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6574,
    "auth_name": "EPSG",
    "auth_id": "6574",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28626,
    "description": "NAD83(2011) / Tennessee",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6575,
    "auth_name": "EPSG",
    "auth_id": "6575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28627,
    "description": "NAD83(2011) / South Dakota North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6572,
    "auth_name": "EPSG",
    "auth_id": "6572",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28628,
    "description": "NAD83(2011) / South Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6573,
    "auth_name": "EPSG",
    "auth_id": "6573",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28629,
    "description": "NAD83(2011) / South Carolina (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6570,
    "auth_name": "EPSG",
    "auth_id": "6570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28630,
    "description": "NAD83(2011) / South Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6571,
    "auth_name": "EPSG",
    "auth_id": "6571",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28631,
    "description": "NAD83(2011) / Rhode Island (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6568,
    "auth_name": "EPSG",
    "auth_id": "6568",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28632,
    "description": "NAD83(2011) / South Carolina",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6569,
    "auth_name": "EPSG",
    "auth_id": "6569",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28633,
    "description": "NAD83(2011) / Puerto Rico and Virgin Is.",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6566,
    "auth_name": "EPSG",
    "auth_id": "6566",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28634,
    "description": "NAD83(2011) / Rhode Island",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6567,
    "auth_name": "EPSG",
    "auth_id": "6567",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28635,
    "description": "NAD83(2011) / Pennsylvania South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6564,
    "auth_name": "EPSG",
    "auth_id": "6564",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28636,
    "description": "NAD83(2011) / Pennsylvania South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6565,
    "auth_name": "EPSG",
    "auth_id": "6565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28637,
    "description": "NAD83(2011) / Pennsylvania North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6562,
    "auth_name": "EPSG",
    "auth_id": "6562",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28638,
    "description": "NAD83(2011) / Pennsylvania North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6563,
    "auth_name": "EPSG",
    "auth_id": "6563",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28639,
    "description": "NAD83(2011) / Oregon South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6560,
    "auth_name": "EPSG",
    "auth_id": "6560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28640,
    "description": "NAD83(2011) / Oregon South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6561,
    "auth_name": "EPSG",
    "auth_id": "6561",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28641,
    "description": "NAD83(2011) / Oregon North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6558,
    "auth_name": "EPSG",
    "auth_id": "6558",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28642,
    "description": "NAD83(2011) / Oregon North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6559,
    "auth_name": "EPSG",
    "auth_id": "6559",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28643,
    "description": "NAD83(2011) / Oregon LCC (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6556,
    "auth_name": "EPSG",
    "auth_id": "6556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28644,
    "description": "NAD83(2011) / Oregon GIC Lambert (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.9999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6557,
    "auth_name": "EPSG",
    "auth_id": "6557",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28645,
    "description": "NAD83(2011) / Oklahoma South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6554,
    "auth_name": "EPSG",
    "auth_id": "6554",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28646,
    "description": "NAD83(2011) / Oklahoma South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6555,
    "auth_name": "EPSG",
    "auth_id": "6555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28647,
    "description": "NAD83(2011) / Oklahoma North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6552,
    "auth_name": "EPSG",
    "auth_id": "6552",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28648,
    "description": "NAD83(2011) / Oklahoma North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6553,
    "auth_name": "EPSG",
    "auth_id": "6553",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28649,
    "description": "NAD83(2011) / Ohio South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6550,
    "auth_name": "EPSG",
    "auth_id": "6550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28650,
    "description": "NAD83(2011) / Ohio South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6551,
    "auth_name": "EPSG",
    "auth_id": "6551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28651,
    "description": "NAD83(2011) / Ohio North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6548,
    "auth_name": "EPSG",
    "auth_id": "6548",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28652,
    "description": "NAD83(2011) / Ohio North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6549,
    "auth_name": "EPSG",
    "auth_id": "6549",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28653,
    "description": "NAD83(2011) / North Dakota South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6546,
    "auth_name": "EPSG",
    "auth_id": "6546",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28654,
    "description": "NAD83(2011) / North Dakota South (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6547,
    "auth_name": "EPSG",
    "auth_id": "6547",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28655,
    "description": "NAD83(2011) / North Dakota North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6544,
    "auth_name": "EPSG",
    "auth_id": "6544",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28656,
    "description": "NAD83(2011) / North Dakota North (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6545,
    "auth_name": "EPSG",
    "auth_id": "6545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28657,
    "description": "NAD83(2011) / North Carolina",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.22 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6542,
    "auth_name": "EPSG",
    "auth_id": "6542",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28658,
    "description": "NAD83(2011) / North Carolina (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6543,
    "auth_name": "EPSG",
    "auth_id": "6543",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28659,
    "description": "NAD83(2011) / New York West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6540,
    "auth_name": "EPSG",
    "auth_id": "6540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28660,
    "description": "NAD83(2011) / New York West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6541,
    "auth_name": "EPSG",
    "auth_id": "6541",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28661,
    "description": "NAD83(2011) / New York Long Island",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6538,
    "auth_name": "EPSG",
    "auth_id": "6538",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28662,
    "description": "NAD83(2011) / New York Long Island (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6539,
    "auth_name": "EPSG",
    "auth_id": "6539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28663,
    "description": "NAD83(2011) / New York East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6536,
    "auth_name": "EPSG",
    "auth_id": "6536",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28664,
    "description": "NAD83(2011) / New York East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6537,
    "auth_name": "EPSG",
    "auth_id": "6537",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28665,
    "description": "NAD83(2011) / New York Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6534,
    "auth_name": "EPSG",
    "auth_id": "6534",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28666,
    "description": "NAD83(2011) / New York Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6535,
    "auth_name": "EPSG",
    "auth_id": "6535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28667,
    "description": "NAD83(2011) / New Mexico West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6532,
    "auth_name": "EPSG",
    "auth_id": "6532",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28668,
    "description": "NAD83(2011) / New Mexico West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6533,
    "auth_name": "EPSG",
    "auth_id": "6533",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28669,
    "description": "NAD83(2011) / New Mexico East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6530,
    "auth_name": "EPSG",
    "auth_id": "6530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28670,
    "description": "NAD83(2011) / New Mexico East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6531,
    "auth_name": "EPSG",
    "auth_id": "6531",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28671,
    "description": "NAD83(2011) / New Mexico Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6528,
    "auth_name": "EPSG",
    "auth_id": "6528",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28672,
    "description": "NAD83(2011) / New Mexico Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6529,
    "auth_name": "EPSG",
    "auth_id": "6529",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28673,
    "description": "NAD83(CSRS) / UTM zone 11N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6654,
    "auth_name": "EPSG",
    "auth_id": "6654",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28674,
    "description": "NAD83(CSRS) / UTM zone 12N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6655,
    "auth_name": "EPSG",
    "auth_id": "6655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28675,
    "description": "NAD83(CSRS) / UTM zone 9N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6652,
    "auth_name": "EPSG",
    "auth_id": "6652",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28676,
    "description": "NAD83(CSRS) / UTM zone 10N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6653,
    "auth_name": "EPSG",
    "auth_id": "6653",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28677,
    "description": "NAD83(CSRS) / UTM zone 7N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6650,
    "auth_name": "EPSG",
    "auth_id": "6650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28678,
    "description": "NAD83(CSRS) / UTM zone 8N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 6651,
    "auth_name": "EPSG",
    "auth_id": "6651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28679,
    "description": "NAD83(CSRS) + CGVD2013(CGG2013) height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 6649,
    "auth_name": "EPSG",
    "auth_id": "6649",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28680,
    "description": "Karbala 1979 / Iraq National Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=29.0262683333333 +lon_0=46.5 +k=0.9994 +x_0=800000 +y_0=0 +a=6378249.145 +rf=293.465 +towgs84=70.995,-335.916,262.898,0,0,0,0 +units=m +no_defs",
    "srid": 6646,
    "auth_name": "EPSG",
    "auth_id": "6646",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28681,
    "description": "NAD83(PA11) / UTM zone 2S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=2 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 6636,
    "auth_name": "EPSG",
    "auth_id": "6636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28682,
    "description": "NAD83(MA11) / Guam Map Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6637,
    "auth_name": "EPSG",
    "auth_id": "6637",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28683,
    "description": "NAD83(PA11) / UTM zone 4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=4 +ellps=GRS80 +units=m +no_defs",
    "srid": 6634,
    "auth_name": "EPSG",
    "auth_id": "6634",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28684,
    "description": "NAD83(PA11) / UTM zone 5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +ellps=GRS80 +units=m +no_defs",
    "srid": 6635,
    "auth_name": "EPSG",
    "auth_id": "6635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28685,
    "description": "NAD83(PA11) / Hawaii zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6632,
    "auth_name": "EPSG",
    "auth_id": "6632",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28686,
    "description": "NAD83(PA11) / Hawaii zone 3 (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 6633,
    "auth_name": "EPSG",
    "auth_id": "6633",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28687,
    "description": "NAD83(PA11) / Hawaii zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.1666666666667 +lon_0=-158 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6630,
    "auth_name": "EPSG",
    "auth_id": "6630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28688,
    "description": "NAD83(PA11) / Hawaii zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6631,
    "auth_name": "EPSG",
    "auth_id": "6631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28689,
    "description": "NAD83(PA11) / Hawaii zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6628,
    "auth_name": "EPSG",
    "auth_id": "6628",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28690,
    "description": "NAD83(PA11) / Hawaii zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6629,
    "auth_name": "EPSG",
    "auth_id": "6629",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28691,
    "description": "NAD83(2011) / Utah North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6626,
    "auth_name": "EPSG",
    "auth_id": "6626",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28692,
    "description": "NAD83(2011) / Utah South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6627,
    "auth_name": "EPSG",
    "auth_id": "6627",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28693,
    "description": "NAD83(CSRS)v2 / Quebec Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6624,
    "auth_name": "EPSG",
    "auth_id": "6624",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28694,
    "description": "NAD83(2011) / Utah Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6625,
    "auth_name": "EPSG",
    "auth_id": "6625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28695,
    "description": "NAD83(CSRS)v2 / Quebec Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 6622,
    "auth_name": "EPSG",
    "auth_id": "6622",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28696,
    "description": "NAD83 / Quebec Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 6623,
    "auth_name": "EPSG",
    "auth_id": "6623",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28697,
    "description": "NAD83(2011) / Utah North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6620,
    "auth_name": "EPSG",
    "auth_id": "6620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28698,
    "description": "NAD83(2011) / Utah South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6621,
    "auth_name": "EPSG",
    "auth_id": "6621",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28699,
    "description": "NAD83(2011) / Wyoming West Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6618,
    "auth_name": "EPSG",
    "auth_id": "6618",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28700,
    "description": "NAD83(2011) / Utah Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6619,
    "auth_name": "EPSG",
    "auth_id": "6619",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28701,
    "description": "NAD83(2011) / Wyoming West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6616,
    "auth_name": "EPSG",
    "auth_id": "6616",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28702,
    "description": "NAD83(2011) / Wyoming West Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6617,
    "auth_name": "EPSG",
    "auth_id": "6617",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28703,
    "description": "NAD83(2011) / Wyoming East Central (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6614,
    "auth_name": "EPSG",
    "auth_id": "6614",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28704,
    "description": "NAD83(2011) / Wyoming West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6615,
    "auth_name": "EPSG",
    "auth_id": "6615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28705,
    "description": "NAD83(2011) / Wyoming East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6612,
    "auth_name": "EPSG",
    "auth_id": "6612",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28706,
    "description": "NAD83(2011) / Wyoming East Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6613,
    "auth_name": "EPSG",
    "auth_id": "6613",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28707,
    "description": "NAD83(2011) / Wisconsin Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6610,
    "auth_name": "EPSG",
    "auth_id": "6610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28708,
    "description": "NAD83(2011) / Wyoming East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6611,
    "auth_name": "EPSG",
    "auth_id": "6611",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28709,
    "description": "NAD83(2011) / Wisconsin South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6608,
    "auth_name": "EPSG",
    "auth_id": "6608",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28710,
    "description": "NAD83(2011) / Wisconsin South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6609,
    "auth_name": "EPSG",
    "auth_id": "6609",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28711,
    "description": "NAD83(2011) / Wisconsin North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6606,
    "auth_name": "EPSG",
    "auth_id": "6606",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28712,
    "description": "NAD83(2011) / Wisconsin North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6607,
    "auth_name": "EPSG",
    "auth_id": "6607",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28714,
    "description": "NAD83(2011) / Wisconsin Central (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6605,
    "auth_name": "EPSG",
    "auth_id": "6605",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28715,
    "description": "NAD83(2011) / West Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6602,
    "auth_name": "EPSG",
    "auth_id": "6602",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28716,
    "description": "NAD83(2011) / West Virginia South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6603,
    "auth_name": "EPSG",
    "auth_id": "6603",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28717,
    "description": "NAD83(2011) / West Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6600,
    "auth_name": "EPSG",
    "auth_id": "6600",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28718,
    "description": "NAD83(2011) / West Virginia North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6601,
    "auth_name": "EPSG",
    "auth_id": "6601",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28719,
    "description": "NAD83(2011) / Washington South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6598,
    "auth_name": "EPSG",
    "auth_id": "6598",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28720,
    "description": "NAD83(2011) / Washington South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6599,
    "auth_name": "EPSG",
    "auth_id": "6599",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28721,
    "description": "NAD83(2011) / Washington North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6596,
    "auth_name": "EPSG",
    "auth_id": "6596",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28722,
    "description": "NAD83(2011) / Washington North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6597,
    "auth_name": "EPSG",
    "auth_id": "6597",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28723,
    "description": "NAD83(2011) / Virginia South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6594,
    "auth_name": "EPSG",
    "auth_id": "6594",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28724,
    "description": "NAD83(2011) / Virginia South (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6595,
    "auth_name": "EPSG",
    "auth_id": "6595",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28725,
    "description": "NAD83(2011) / Virginia North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6592,
    "auth_name": "EPSG",
    "auth_id": "6592",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28726,
    "description": "NAD83(2011) / Virginia North (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 6593,
    "auth_name": "EPSG",
    "auth_id": "6593",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28727,
    "description": "Nepal 1981",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=longlat +ellps=evrst30 +towgs84=293.17,726.18,245.36,0,0,0,0 +no_defs",
    "srid": 6207,
    "auth_name": "EPSG",
    "auth_id": "6207",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28728,
    "description": "Macedonia State Coordinate System",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +towgs84=521.748,229.489,590.921,4.029,4.488,-15.521,-9.78 +units=m +no_defs",
    "srid": 6204,
    "auth_name": "EPSG",
    "auth_id": "6204",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28729,
    "description": "BD72 / Belgian Lambert 72 + Ostend height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=90 +lon_0=4.36748666666667 +lat_1=51.1666672333333 +lat_2=49.8333339 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +units=m +geoidgrids=be_ign_hBG18.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6190,
    "auth_name": "EPSG",
    "auth_id": "6190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28730,
    "description": "ETRS89 / UTM zone 36N + NN54 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6176,
    "auth_name": "EPSG",
    "auth_id": "6176",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28731,
    "description": "ETRS89 / UTM zone 34N + NN54 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6174,
    "auth_name": "EPSG",
    "auth_id": "6174",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28732,
    "description": "ETRS89 / UTM zone 35N + NN54 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6175,
    "auth_name": "EPSG",
    "auth_id": "6175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28733,
    "description": "ETRS89 / UTM zone 32N + NN54 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6172,
    "auth_name": "EPSG",
    "auth_id": "6172",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28734,
    "description": "ETRS89 / UTM zone 33N + NN54 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6173,
    "auth_name": "EPSG",
    "auth_id": "6173",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28735,
    "description": "ETRS89 / NTM zone 30 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6170,
    "auth_name": "EPSG",
    "auth_id": "6170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28736,
    "description": "ETRS89 / UTM zone 31N + NN54 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6171,
    "auth_name": "EPSG",
    "auth_id": "6171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28737,
    "description": "ETRS89 / NTM zone 28 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6168,
    "auth_name": "EPSG",
    "auth_id": "6168",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28738,
    "description": "ETRS89 / NTM zone 29 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6169,
    "auth_name": "EPSG",
    "auth_id": "6169",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28739,
    "description": "ETRS89 / NTM zone 26 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6166,
    "auth_name": "EPSG",
    "auth_id": "6166",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28740,
    "description": "ETRS89 / NTM zone 27 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6167,
    "auth_name": "EPSG",
    "auth_id": "6167",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28741,
    "description": "ETRS89 / NTM zone 24 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6164,
    "auth_name": "EPSG",
    "auth_id": "6164",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28742,
    "description": "ETRS89 / NTM zone 25 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6165,
    "auth_name": "EPSG",
    "auth_id": "6165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28743,
    "description": "ETRS89 / NTM zone 22 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6162,
    "auth_name": "EPSG",
    "auth_id": "6162",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28744,
    "description": "ETRS89 / NTM zone 23 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6163,
    "auth_name": "EPSG",
    "auth_id": "6163",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28745,
    "description": "ETRS89 / NTM zone 20 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6160,
    "auth_name": "EPSG",
    "auth_id": "6160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28746,
    "description": "ETRS89 / NTM zone 21 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6161,
    "auth_name": "EPSG",
    "auth_id": "6161",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28747,
    "description": "ETRS89 / NTM zone 18 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6158,
    "auth_name": "EPSG",
    "auth_id": "6158",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28748,
    "description": "ETRS89 / NTM zone 19 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6159,
    "auth_name": "EPSG",
    "auth_id": "6159",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28749,
    "description": "ETRS89 / NTM zone 16 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6156,
    "auth_name": "EPSG",
    "auth_id": "6156",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28750,
    "description": "ETRS89 / NTM zone 17 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6157,
    "auth_name": "EPSG",
    "auth_id": "6157",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28751,
    "description": "ETRS89 / NTM zone 14 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6154,
    "auth_name": "EPSG",
    "auth_id": "6154",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28752,
    "description": "ETRS89 / NTM zone 15 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6155,
    "auth_name": "EPSG",
    "auth_id": "6155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28753,
    "description": "ETRS89 / NTM zone 12 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6152,
    "auth_name": "EPSG",
    "auth_id": "6152",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28754,
    "description": "ETRS89 / NTM zone 13 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6153,
    "auth_name": "EPSG",
    "auth_id": "6153",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28755,
    "description": "ETRS89 / NTM zone 10 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6150,
    "auth_name": "EPSG",
    "auth_id": "6150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28756,
    "description": "ETRS89 / NTM zone 11 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6151,
    "auth_name": "EPSG",
    "auth_id": "6151",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28757,
    "description": "ETRS89 / NTM zone 8 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6148,
    "auth_name": "EPSG",
    "auth_id": "6148",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28758,
    "description": "ETRS89 / NTM zone 9 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6149,
    "auth_name": "EPSG",
    "auth_id": "6149",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28759,
    "description": "ETRS89 / NTM zone 6 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6146,
    "auth_name": "EPSG",
    "auth_id": "6146",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28760,
    "description": "ETRS89 / NTM zone 7 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6147,
    "auth_name": "EPSG",
    "auth_id": "6147",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28761,
    "description": "ETRS89 + NN54 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6144,
    "auth_name": "EPSG",
    "auth_id": "6144",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28762,
    "description": "ETRS89 / NTM zone 5 + NN54 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_href2008a.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 6145,
    "auth_name": "EPSG",
    "auth_id": "6145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28763,
    "description": "SIRGAS 2000 / UTM zone 23N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=23 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6210,
    "auth_name": "EPSG",
    "auth_id": "6210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28764,
    "description": "SIRGAS 2000 / UTM zone 24N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=24 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6211,
    "auth_name": "EPSG",
    "auth_id": "6211",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28765,
    "description": "NAD83(2011) / UTM zone 5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6334,
    "auth_name": "EPSG",
    "auth_id": "6334",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28766,
    "description": "NAD83(2011) / UTM zone 6N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=6 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6335,
    "auth_name": "EPSG",
    "auth_id": "6335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28767,
    "description": "NAD83(2011) / UTM zone 3N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=3 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6332,
    "auth_name": "EPSG",
    "auth_id": "6332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28768,
    "description": "NAD83(2011) / UTM zone 4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=4 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6333,
    "auth_name": "EPSG",
    "auth_id": "6333",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28769,
    "description": "NAD83(2011) / UTM zone 1N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=1 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6330,
    "auth_name": "EPSG",
    "auth_id": "6330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28770,
    "description": "NAD83(2011) / UTM zone 2N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=2 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6331,
    "auth_name": "EPSG",
    "auth_id": "6331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28771,
    "description": "NAD83(2011) / UTM zone 59N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=59 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6328,
    "auth_name": "EPSG",
    "auth_id": "6328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28772,
    "description": "NAD83(2011) / UTM zone 60N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=60 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6329,
    "auth_name": "EPSG",
    "auth_id": "6329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28773,
    "description": "NAD83(MA11)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 6325,
    "auth_name": "EPSG",
    "auth_id": "6325",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28774,
    "description": "NAD83(PA11)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 6322,
    "auth_name": "EPSG",
    "auth_id": "6322",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28775,
    "description": "NAD83(MA11)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6323,
    "auth_name": "EPSG",
    "auth_id": "6323",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28776,
    "description": "NAD83(PA11)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6320,
    "auth_name": "EPSG",
    "auth_id": "6320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28777,
    "description": "NAD83(2011)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 6318,
    "auth_name": "EPSG",
    "auth_id": "6318",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28778,
    "description": "MGI 1901 / Balkans zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 6316,
    "auth_name": "EPSG",
    "auth_id": "6316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28779,
    "description": "NAD83(2011)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6317,
    "auth_name": "EPSG",
    "auth_id": "6317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28780,
    "description": "CGRS93 / Cyprus Local Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=0.99995 +x_0=200000 +y_0=-3500000 +ellps=WGS84 +towgs84=8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926 +units=m +no_defs",
    "srid": 6312,
    "auth_name": "EPSG",
    "auth_id": "6312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28781,
    "description": "CGRS93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926 +no_defs",
    "srid": 6311,
    "auth_name": "EPSG",
    "auth_id": "6311",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28782,
    "description": "CGRS93",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 6309,
    "auth_name": "EPSG",
    "auth_id": "6309",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28783,
    "description": "NAD83(CORS96) / Puerto Rico and Virgin Is.",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.4333333333333 +lat_2=18.0333333333333 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6307,
    "auth_name": "EPSG",
    "auth_id": "6307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28784,
    "description": "NAD83(2011) / Alaska zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6398,
    "auth_name": "EPSG",
    "auth_id": "6398",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28785,
    "description": "NAD83(2011) / Alaska zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6399,
    "auth_name": "EPSG",
    "auth_id": "6399",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28786,
    "description": "NAD83(2011) / Alaska zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6396,
    "auth_name": "EPSG",
    "auth_id": "6396",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28787,
    "description": "NAD83(2011) / Alaska zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6397,
    "auth_name": "EPSG",
    "auth_id": "6397",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28788,
    "description": "NAD83(2011) / Alaska zone 1",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6394,
    "auth_name": "EPSG",
    "auth_id": "6394",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28789,
    "description": "NAD83(2011) / Alaska zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6395,
    "auth_name": "EPSG",
    "auth_id": "6395",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28790,
    "description": "NAD83(2011) / Alaska Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6393,
    "auth_name": "EPSG",
    "auth_id": "6393",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28791,
    "description": "Cayman Islands National Grid 2011",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=19.3333333333333 +lon_0=-80.5666666666667 +lat_1=19.3333333333333 +lat_2=19.7 +x_0=899160 +y_0=579120 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 6391,
    "auth_name": "EPSG",
    "auth_id": "6391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28792,
    "description": "UCS-2000 / Ukraine TM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 6386,
    "auth_name": "EPSG",
    "auth_id": "6386",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28793,
    "description": "UCS-2000 / Ukraine TM zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 6387,
    "auth_name": "EPSG",
    "auth_id": "6387",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28794,
    "description": "UCS-2000 / Ukraine TM zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 6384,
    "auth_name": "EPSG",
    "auth_id": "6384",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28795,
    "description": "UCS-2000 / Ukraine TM zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 6385,
    "auth_name": "EPSG",
    "auth_id": "6385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28796,
    "description": "UCS-2000 / Ukraine TM zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 6382,
    "auth_name": "EPSG",
    "auth_id": "6382",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28797,
    "description": "UCS-2000 / Ukraine TM zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 6383,
    "auth_name": "EPSG",
    "auth_id": "6383",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28798,
    "description": "UCS-2000 / Ukraine TM zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 6381,
    "auth_name": "EPSG",
    "auth_id": "6381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28799,
    "description": "Mexico ITRF2008 / LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=12 +lon_0=-102 +lat_1=17.5 +lat_2=29.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6372,
    "auth_name": "EPSG",
    "auth_id": "6372",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28800,
    "description": "Mexico ITRF2008 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6370,
    "auth_name": "EPSG",
    "auth_id": "6370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28801,
    "description": "Mexico ITRF2008 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6371,
    "auth_name": "EPSG",
    "auth_id": "6371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28802,
    "description": "Mexico ITRF2008 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6368,
    "auth_name": "EPSG",
    "auth_id": "6368",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28803,
    "description": "Mexico ITRF2008 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6369,
    "auth_name": "EPSG",
    "auth_id": "6369",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28804,
    "description": "Mexico ITRF2008 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6366,
    "auth_name": "EPSG",
    "auth_id": "6366",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28805,
    "description": "Mexico ITRF2008 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6367,
    "auth_name": "EPSG",
    "auth_id": "6367",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28806,
    "description": "Mexico ITRF2008",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 6365,
    "auth_name": "EPSG",
    "auth_id": "6365",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28807,
    "description": "Mexico ITRF92 / LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=12 +lon_0=-102 +lat_1=17.5 +lat_2=29.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6362,
    "auth_name": "EPSG",
    "auth_id": "6362",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28808,
    "description": "Mexico ITRF2008",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6363,
    "auth_name": "EPSG",
    "auth_id": "6363",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28809,
    "description": "NAD83(2011) / Alabama West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6356,
    "auth_name": "EPSG",
    "auth_id": "6356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28810,
    "description": "NAD83(2011) / EPSG Arctic zone 6-16",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-147 +lat_1=70.3333333333333 +lat_2=67 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6354,
    "auth_name": "EPSG",
    "auth_id": "6354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28811,
    "description": "NAD83(2011) / Alabama East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6355,
    "auth_name": "EPSG",
    "auth_id": "6355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28812,
    "description": "NAD83(2011) / EPSG Arctic zone 5-31",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-147 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6352,
    "auth_name": "EPSG",
    "auth_id": "6352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28813,
    "description": "NAD83(2011) / EPSG Arctic zone 6-14",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-165 +lat_1=70.3333333333333 +lat_2=67 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6353,
    "auth_name": "EPSG",
    "auth_id": "6353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28814,
    "description": "NAD83(2011) / Conus Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6350,
    "auth_name": "EPSG",
    "auth_id": "6350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28815,
    "description": "NAD83(2011) / EPSG Arctic zone 5-29",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-163 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6351,
    "auth_name": "EPSG",
    "auth_id": "6351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28816,
    "description": "NAD83(2011) / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6348,
    "auth_name": "EPSG",
    "auth_id": "6348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28817,
    "description": "NAD83(2011) + NAVD88 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 6349,
    "auth_name": "EPSG",
    "auth_id": "6349",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28818,
    "description": "NAD83(2011) / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6346,
    "auth_name": "EPSG",
    "auth_id": "6346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28819,
    "description": "NAD83(2011) / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6347,
    "auth_name": "EPSG",
    "auth_id": "6347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28820,
    "description": "NAD83(2011) / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6344,
    "auth_name": "EPSG",
    "auth_id": "6344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28821,
    "description": "NAD83(2011) / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6345,
    "auth_name": "EPSG",
    "auth_id": "6345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28822,
    "description": "NAD83(2011) / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6342,
    "auth_name": "EPSG",
    "auth_id": "6342",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28823,
    "description": "NAD83(2011) / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6343,
    "auth_name": "EPSG",
    "auth_id": "6343",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28824,
    "description": "NAD83(2011) / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6340,
    "auth_name": "EPSG",
    "auth_id": "6340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28825,
    "description": "NAD83(2011) / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6341,
    "auth_name": "EPSG",
    "auth_id": "6341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28826,
    "description": "NAD83(2011) / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6338,
    "auth_name": "EPSG",
    "auth_id": "6338",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28827,
    "description": "NAD83(2011) / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6339,
    "auth_name": "EPSG",
    "auth_id": "6339",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28828,
    "description": "NAD83(2011) / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6336,
    "auth_name": "EPSG",
    "auth_id": "6336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28829,
    "description": "NAD83(2011) / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6337,
    "auth_name": "EPSG",
    "auth_id": "6337",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28830,
    "description": "Malongo 1987 / UTM zone 33S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=33 +south +ellps=intl +towgs84=-254.1,-5.36,-100.29,0,0,0,0 +units=m +no_defs",
    "srid": 7992,
    "auth_name": "EPSG",
    "auth_id": "7992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28831,
    "description": "NAD27 / MTM zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 7991,
    "auth_name": "EPSG",
    "auth_id": "7991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28832,
    "description": "SHMG2015 + SHVD2015 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=us_nga_egm08_25.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 7956,
    "auth_name": "EPSG",
    "auth_id": "7956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28833,
    "description": "Astro DOS 71 / UTM zone 30S + Jamestown 1971 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=30 +south +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 7954,
    "auth_name": "EPSG",
    "auth_id": "7954",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28834,
    "description": "St. Helena Tritan / UTM zone 30S + Tritan 2011 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=30 +south +ellps=WGS84 +towgs84=-0.077,0.079,0.086,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 7955,
    "auth_name": "EPSG",
    "auth_id": "7955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 28835,
    "description": "GDA2020 / NSW Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-33.25 +lon_0=147 +lat_1=-30.75 +lat_2=-35.75 +x_0=9300000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8058,
    "auth_name": "EPSG",
    "auth_id": "8058",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28836,
    "description": "GDA2020 / SA Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-32 +lon_0=135 +lat_1=-28 +lat_2=-36 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8059,
    "auth_name": "EPSG",
    "auth_id": "8059",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28837,
    "description": "Gusterberg Grid (Ferro)",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=48.0384638888889 +lon_0=31.8041805555556 +x_0=0 +y_0=0 +a=6376045 +rf=310 +pm=ferro +units=m +no_defs",
    "srid": 8044,
    "auth_name": "EPSG",
    "auth_id": "8044",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28838,
    "description": "St. Stephen Grid (Ferro)",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +lat_0=48.2087611111111 +lon_0=34.0409222222222 +x_0=0 +y_0=0 +a=6376045 +rf=310 +pm=ferro +units=m +no_defs",
    "srid": 8045,
    "auth_name": "EPSG",
    "auth_id": "8045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28839,
    "description": "Gusterberg (Ferro)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6376045 +rf=310 +pm=ferro +no_defs",
    "srid": 8042,
    "auth_name": "EPSG",
    "auth_id": "8042",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28840,
    "description": "St. Stephen (Ferro)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6376045 +rf=310 +pm=ferro +no_defs",
    "srid": 8043,
    "auth_name": "EPSG",
    "auth_id": "8043",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28841,
    "description": "WGS 84 / TM Zone 21N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-57 +k=0.9996 +x_0=500000.0001016 +y_0=0 +datum=WGS84 +units=us-ft +no_defs",
    "srid": 8036,
    "auth_name": "EPSG",
    "auth_id": "8036",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28842,
    "description": "WGS 84 / TM Zone 20N (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-63 +k=0.9996 +x_0=500000.0001016 +y_0=0 +datum=WGS84 +units=us-ft +no_defs",
    "srid": 8035,
    "auth_name": "EPSG",
    "auth_id": "8035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28843,
    "description": "GDA2020 / PHG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=118.6 +k=1.00000135 +x_0=50000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8032,
    "auth_name": "EPSG",
    "auth_id": "8032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28844,
    "description": "GDA2020 / MRCG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.166666666667 +k=1.0000055 +x_0=50000 +y_0=4050000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8030,
    "auth_name": "EPSG",
    "auth_id": "8030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28845,
    "description": "GDA2020 / PCG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.816666666667 +k=0.99999906 +x_0=50000 +y_0=3900000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8031,
    "auth_name": "EPSG",
    "auth_id": "8031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28846,
    "description": "GDA2020 / KUN2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=128.75 +k=1.0000165 +x_0=50000 +y_0=2100000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8028,
    "auth_name": "EPSG",
    "auth_id": "8028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28847,
    "description": "GDA2020 / LCG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.366666666667 +k=1.00000157 +x_0=50000 +y_0=3750000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8029,
    "auth_name": "EPSG",
    "auth_id": "8029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28848,
    "description": "GDA2020 / KALB2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114.315277777778 +k=1.000014 +x_0=55000 +y_0=3700000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8026,
    "auth_name": "EPSG",
    "auth_id": "8026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28849,
    "description": "GDA2020 / KAR2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=116.933333333333 +k=0.9999989 +x_0=50000 +y_0=2550000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8027,
    "auth_name": "EPSG",
    "auth_id": "8027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28850,
    "description": "GDA2020 / GOLD2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=121.5 +k=1.00004949 +x_0=60000 +y_0=3800000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8024,
    "auth_name": "EPSG",
    "auth_id": "8024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28851,
    "description": "GDA2020 / JCG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114.983333333333 +k=1.00000314 +x_0=50000 +y_0=3650000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8025,
    "auth_name": "EPSG",
    "auth_id": "8025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28852,
    "description": "GDA2020 / EXM2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114.066666666667 +k=1.00000236 +x_0=50000 +y_0=2750000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8022,
    "auth_name": "EPSG",
    "auth_id": "8022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28853,
    "description": "GDA2020 / GCG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114.583333333333 +k=1.00000628 +x_0=50000 +y_0=3450000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8023,
    "auth_name": "EPSG",
    "auth_id": "8023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28854,
    "description": "GDA2020 / COL2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.933333333333 +k=1.000019 +x_0=40000 +y_0=4100000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8020,
    "auth_name": "EPSG",
    "auth_id": "8020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28855,
    "description": "GDA2020 / ESP2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=121.883333333333 +k=1.0000055 +x_0=50000 +y_0=4050000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8021,
    "auth_name": "EPSG",
    "auth_id": "8021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28856,
    "description": "GDA2020 / CIG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105.625 +k=1.00002514 +x_0=50000 +y_0=1400000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8018,
    "auth_name": "EPSG",
    "auth_id": "8018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28857,
    "description": "GDA2020 / CKIG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96.875 +k=0.99999387 +x_0=50000 +y_0=1600000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8019,
    "auth_name": "EPSG",
    "auth_id": "8019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28858,
    "description": "GDA2020 / BCG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.433333333333 +k=0.99999592 +x_0=50000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8016,
    "auth_name": "EPSG",
    "auth_id": "8016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28859,
    "description": "GDA2020 / CARN2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=113.666666666667 +k=0.99999796 +x_0=50000 +y_0=3050000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8017,
    "auth_name": "EPSG",
    "auth_id": "8017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28860,
    "description": "GDA2020 / BIO2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.25 +k=1.0000022 +x_0=60000 +y_0=2700000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8014,
    "auth_name": "EPSG",
    "auth_id": "8014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28861,
    "description": "GDA2020 / BRO2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=122.333333333333 +k=1.00000298 +x_0=50000 +y_0=2300000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8015,
    "auth_name": "EPSG",
    "auth_id": "8015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28862,
    "description": "GDA2020 / ALB2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117.883333333333 +k=1.0000044 +x_0=50000 +y_0=4100000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8013,
    "auth_name": "EPSG",
    "auth_id": "8013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28863,
    "description": "NAD83(HARN) / WISCRS Rusk (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.9194444444444 +lon_0=-91.0666666666667 +k=1.0000495976 +x_0=250546.101397003 +y_0=0.0234696469392939 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8126,
    "auth_name": "EPSG",
    "auth_id": "8126",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28864,
    "description": "NAD83(HARN) / WISCRS Rock (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.9444444444444 +lon_0=-89.0722222222222 +k=1.0000337311 +x_0=146304.2926 +y_0=0.0068 +ellps=GRS80 +units=m +no_defs",
    "srid": 8127,
    "auth_name": "EPSG",
    "auth_id": "8127",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28865,
    "description": "NAD83(HARN) / WISCRS Sauk (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8194444444444 +lon_0=-89.9 +k=1.0000373868 +x_0=185623.571551943 +y_0=0.00518161036322073 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8124,
    "auth_name": "EPSG",
    "auth_id": "8124",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28866,
    "description": "NAD83(HARN) / WISCRS Rusk (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.9194444444444 +lon_0=-91.0666666666667 +k=1.0000495976 +x_0=250546.1013 +y_0=0.0234 +ellps=GRS80 +units=m +no_defs",
    "srid": 8125,
    "auth_name": "EPSG",
    "auth_id": "8125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28867,
    "description": "NAD83(HARN) / WISCRS Sawyer (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.9000991313889 +lat_0=45.9000991313889 +lon_0=-91.1166666666667 +k_0=1.0000573461 +x_0=216713.233731268 +y_0=120734.163169926 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8122,
    "auth_name": "EPSG",
    "auth_id": "8122",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28868,
    "description": "NAD83(HARN) / WISCRS Sauk (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8194444444444 +lon_0=-89.9 +k=1.0000373868 +x_0=185623.5716 +y_0=0.0051 +ellps=GRS80 +units=m +no_defs",
    "srid": 8123,
    "auth_name": "EPSG",
    "auth_id": "8123",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28869,
    "description": "NAD83(HARN) / WISCRS Shawano (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-88.6055555555556 +k=1.000032144 +x_0=262433.32517145 +y_0=0.0094488188976378 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8120,
    "auth_name": "EPSG",
    "auth_id": "8120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28870,
    "description": "NAD83(HARN) / WISCRS Sawyer (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.9000991313889 +lat_0=45.9000991313889 +lon_0=-91.1166666666667 +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631 +ellps=GRS80 +units=m +no_defs",
    "srid": 8121,
    "auth_name": "EPSG",
    "auth_id": "8121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28871,
    "description": "NAD83(HARN) / WISCRS St. Croix (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-92.6333333333333 +k=1.0000381803 +x_0=165506.73009906 +y_0=0.0103632207264415 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8118,
    "auth_name": "EPSG",
    "auth_id": "8118",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28872,
    "description": "NAD83(HARN) / WISCRS Shawano (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-88.6055555555556 +k=1.000032144 +x_0=262433.3253 +y_0=0.0096 +ellps=GRS80 +units=m +no_defs",
    "srid": 8119,
    "auth_name": "EPSG",
    "auth_id": "8119",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28873,
    "description": "NAD83(HARN) / WISCRS Taylor (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.1778220858333 +lat_0=45.1778220858333 +lon_0=-90.4833333333333 +k_0=1.0000597566 +x_0=187147.574295149 +y_0=107746.752146304 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8116,
    "auth_name": "EPSG",
    "auth_id": "8116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28874,
    "description": "NAD83(HARN) / WISCRS St. Croix (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-92.6333333333333 +k=1.0000381803 +x_0=165506.7302 +y_0=0.0103 +ellps=GRS80 +units=m +no_defs",
    "srid": 8117,
    "auth_name": "EPSG",
    "auth_id": "8117",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28875,
    "description": "NAD83(HARN) / WISCRS Trempealeau (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.1611111111111 +lon_0=-91.3666666666667 +k=1.0000361538 +x_0=256946.913893828 +y_0=0.00396240792481585 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8114,
    "auth_name": "EPSG",
    "auth_id": "8114",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28876,
    "description": "NAD83(HARN) / WISCRS Taylor (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.1778220858333 +lat_0=45.1778220858333 +lon_0=-90.4833333333333 +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522 +ellps=GRS80 +units=m +no_defs",
    "srid": 8115,
    "auth_name": "EPSG",
    "auth_id": "8115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28877,
    "description": "NAD83(HARN) / WISCRS Vernon (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.5750329397222 +lat_0=43.5750329397222 +lon_0=-90.7833333333333 +k_0=1.0000408158 +x_0=222504.44500889 +y_0=47532.0603505207 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8112,
    "auth_name": "EPSG",
    "auth_id": "8112",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28878,
    "description": "NAD83(HARN) / WISCRS Trempealeau (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.1611111111111 +lon_0=-91.3666666666667 +k=1.0000361538 +x_0=256946.9138 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs",
    "srid": 8113,
    "auth_name": "EPSG",
    "auth_id": "8113",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28879,
    "description": "NAD83(HARN) / WISCRS Vilas (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.0778440905556 +lat_0=46.0778440905556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.068834138 +y_0=50337.1092710185 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8110,
    "auth_name": "EPSG",
    "auth_id": "8110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28880,
    "description": "NAD83(HARN) / WISCRS Vernon (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.5750329397222 +lat_0=43.5750329397222 +lon_0=-90.7833333333333 +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602 +ellps=GRS80 +units=m +no_defs",
    "srid": 8111,
    "auth_name": "EPSG",
    "auth_id": "8111",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28881,
    "description": "NAD83(HARN) / WISCRS Walworth (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6694620969444 +lat_0=42.6694620969444 +lon_0=-88.5416666666667 +k_0=1.0000367192 +x_0=232562.86512573 +y_0=111088.222402845 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8108,
    "auth_name": "EPSG",
    "auth_id": "8108",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28882,
    "description": "NAD83(HARN) / WISCRS Vilas (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.0778440905556 +lat_0=46.0778440905556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092 +ellps=GRS80 +units=m +no_defs",
    "srid": 8109,
    "auth_name": "EPSG",
    "auth_id": "8109",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28883,
    "description": "NAD83(HARN) / WISCRS Washburn (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.9612198333333 +lat_0=45.9612198333333 +lon_0=-91.7833333333333 +k_0=1.0000475376 +x_0=234086.868173736 +y_0=188358.605943612 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8106,
    "auth_name": "EPSG",
    "auth_id": "8106",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28884,
    "description": "NAD83(HARN) / WISCRS Walworth (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6694620969444 +lat_0=42.6694620969444 +lon_0=-88.5416666666667 +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224 +ellps=GRS80 +units=m +no_defs",
    "srid": 8107,
    "auth_name": "EPSG",
    "auth_id": "8107",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28885,
    "description": "NAD83(HARN) / WISCRS Washington (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.9180555555556 +lon_0=-88.0638888888889 +k=1.00003738 +x_0=120091.441402083 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8104,
    "auth_name": "EPSG",
    "auth_id": "8104",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28886,
    "description": "NAD83(HARN) / WISCRS Washburn (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.9612198333333 +lat_0=45.9612198333333 +lon_0=-91.7833333333333 +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058 +ellps=GRS80 +units=m +no_defs",
    "srid": 8105,
    "auth_name": "EPSG",
    "auth_id": "8105",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28887,
    "description": "NAD83(HARN) / WISCRS Waukesha (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5694444444444 +lon_0=-88.225 +k=1.0000346179 +x_0=208788.417881636 +y_0=0.00335280670561341 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8102,
    "auth_name": "EPSG",
    "auth_id": "8102",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28888,
    "description": "NAD83(HARN) / WISCRS Washington (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.9180555555556 +lon_0=-88.0638888888889 +k=1.00003738 +x_0=120091.4415 +y_0=0.003 +ellps=GRS80 +units=m +no_defs",
    "srid": 8103,
    "auth_name": "EPSG",
    "auth_id": "8103",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28889,
    "description": "NAD83(HARN) / WISCRS Waupaca (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4202777777778 +lon_0=-88.8166666666667 +k=1.0000333645 +x_0=185013.970942342 +y_0=0.00701041402082804 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8100,
    "auth_name": "EPSG",
    "auth_id": "8100",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28890,
    "description": "NAD83(HARN) / WISCRS Waukesha (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5694444444444 +lon_0=-88.225 +k=1.0000346179 +x_0=208788.418 +y_0=0.0034 +ellps=GRS80 +units=m +no_defs",
    "srid": 8101,
    "auth_name": "EPSG",
    "auth_id": "8101",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28891,
    "description": "NAD83(HARN) / WISCRS Waushara (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.1139440458333 +lat_0=44.1139440458333 +lon_0=-89.2416666666667 +k_0=1.0000392096 +x_0=120091.44018288 +y_0=45069.7588011176 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8098,
    "auth_name": "EPSG",
    "auth_id": "8098",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28892,
    "description": "NAD83(HARN) / WISCRS Waupaca (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4202777777778 +lon_0=-88.8166666666667 +k=1.0000333645 +x_0=185013.9709 +y_0=0.007 +ellps=GRS80 +units=m +no_defs",
    "srid": 8099,
    "auth_name": "EPSG",
    "auth_id": "8099",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28893,
    "description": "NAD83(HARN) / WISCRS Wood (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.3625954694444 +lat_0=44.3625954694444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.617272035 +y_0=134589.753924308 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8096,
    "auth_name": "EPSG",
    "auth_id": "8096",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28894,
    "description": "NAD83(HARN) / WISCRS Waushara (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.1139440458333 +lat_0=44.1139440458333 +lon_0=-89.2416666666667 +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587 +ellps=GRS80 +units=m +no_defs",
    "srid": 8097,
    "auth_name": "EPSG",
    "auth_id": "8097",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28895,
    "description": "NAD83(HARN) / WISCRS Wood (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.3625954694444 +lat_0=44.3625954694444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754 +ellps=GRS80 +units=m +no_defs",
    "srid": 8095,
    "auth_name": "EPSG",
    "auth_id": "8095",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28896,
    "description": "NAD83(HARN) / WISCRS Eau Claire (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.8722811263889 +lat_0=44.8722811263889 +lon_0=-91.2888888888889 +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.9239 +ellps=GRS80 +units=m +no_defs",
    "srid": 8092,
    "auth_name": "EPSG",
    "auth_id": "8092",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28897,
    "description": "NAD83(HARN) / WISCRS Eau Claire (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.8722811263889 +lat_0=44.8722811263889 +lon_0=-91.2888888888889 +k_0=1.000035079 +x_0=120091.44018288 +y_0=91687.9239014478 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8093,
    "auth_name": "EPSG",
    "auth_id": "8093",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28898,
    "description": "NAD83(HARN) / WISCRS Florence (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.4388888888889 +lon_0=-88.1416666666667 +k=1.0000552095 +x_0=133502.6683 +y_0=0.0063 +ellps=GRS80 +units=m +no_defs",
    "srid": 8090,
    "auth_name": "EPSG",
    "auth_id": "8090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28899,
    "description": "NAD83(HARN) / WISCRS Florence (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.4388888888889 +lon_0=-88.1416666666667 +k=1.0000552095 +x_0=133502.668224536 +y_0=0.0064008128016256 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8091,
    "auth_name": "EPSG",
    "auth_id": "8091",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28900,
    "description": "ISN2016 / Lambert 2016",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=2700000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8088,
    "auth_name": "EPSG",
    "auth_id": "8088",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28901,
    "description": "ISN2016",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 8086,
    "auth_name": "EPSG",
    "auth_id": "8086",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28902,
    "description": "ISN2016",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 8084,
    "auth_name": "EPSG",
    "auth_id": "8084",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28903,
    "description": "NAD83(CSRS)v6 / MTM NS 2010 zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=24500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 8082,
    "auth_name": "EPSG",
    "auth_id": "8082",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28904,
    "description": "NAD83(CSRS)v6 / MTM NS 2010 zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=25500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 8083,
    "auth_name": "EPSG",
    "auth_id": "8083",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28905,
    "description": "NAD83(2011) / PCCS zone 4 (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=30.5 +lat_0=30.5 +lon_0=-110.75 +k_0=0.9998 +x_0=9144 +y_0=-188976 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8068,
    "auth_name": "EPSG",
    "auth_id": "8068",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28906,
    "description": "NAD83(2011) / PCCS zone 2 (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31.25 +lon_0=-112.166666666667 +k=1.00009 +x_0=548640 +y_0=304800 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8066,
    "auth_name": "EPSG",
    "auth_id": "8066",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28907,
    "description": "NAD83(2011) / PCCS zone 3 (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31.5 +lon_0=-113.166666666667 +k=1.000055 +x_0=182880 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8067,
    "auth_name": "EPSG",
    "auth_id": "8067",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28908,
    "description": "NAD83(2011) / PCCS zone 1 (ft)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +lat_0=32.25 +lonc=-111.4 +alpha=45 +gamma=45 +k=1.00011 +x_0=48768 +y_0=243840 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8065,
    "auth_name": "EPSG",
    "auth_id": "8065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28909,
    "description": "NAD83(HARN) / WISCRS Dane (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.4222222222222 +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896 +ellps=GRS80 +units=m +no_defs",
    "srid": 8191,
    "auth_name": "EPSG",
    "auth_id": "8191",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28910,
    "description": "NAD83(HARN) / WISCRS Dodge and Jefferson (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.726390653 +y_0=0.00762001524003048 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8189,
    "auth_name": "EPSG",
    "auth_id": "8189",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28911,
    "description": "NAD83(HARN) / WISCRS Dodge and Jefferson (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +units=m +no_defs",
    "srid": 8187,
    "auth_name": "EPSG",
    "auth_id": "8187",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28912,
    "description": "NAD83(HARN) / WISCRS Door (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.4 +lon_0=-87.2722222222222 +k=1.0000187521 +x_0=158801.1176 +y_0=0.0023 +ellps=GRS80 +units=m +no_defs",
    "srid": 8184,
    "auth_name": "EPSG",
    "auth_id": "8184",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28913,
    "description": "NAD83(HARN) / WISCRS Door (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.4 +lon_0=-87.2722222222222 +k=1.0000187521 +x_0=158801.117602235 +y_0=0.00243840487680975 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8185,
    "auth_name": "EPSG",
    "auth_id": "8185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28914,
    "description": "NAD83(HARN) / WISCRS Douglas (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.8833333333333 +lon_0=-91.9166666666667 +k=1.0000385418 +x_0=59131.3182626365 +y_0=0.00396240792481585 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8182,
    "auth_name": "EPSG",
    "auth_id": "8182",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28915,
    "description": "NAD83(HARN) / WISCRS Dunn (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.4083333333333 +lon_0=-91.8944444444444 +k=1.0000410324 +x_0=51816.1039370079 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8180,
    "auth_name": "EPSG",
    "auth_id": "8180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28916,
    "description": "NAD83(HARN) / WISCRS Douglas (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.8833333333333 +lon_0=-91.9166666666667 +k=1.0000385418 +x_0=59131.3183 +y_0=0.0041 +ellps=GRS80 +units=m +no_defs",
    "srid": 8181,
    "auth_name": "EPSG",
    "auth_id": "8181",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28917,
    "description": "NAD83(HARN) / WISCRS Dunn (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.4083333333333 +lon_0=-91.8944444444444 +k=1.0000410324 +x_0=51816.104 +y_0=0.003 +ellps=GRS80 +units=m +no_defs",
    "srid": 8179,
    "auth_name": "EPSG",
    "auth_id": "8179",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28918,
    "description": "NAD83(HARN) / WISCRS Forest (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0055555555556 +lon_0=-88.6333333333333 +k=1.0000673004 +x_0=275844.553213106 +y_0=0.0158496316992634 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8177,
    "auth_name": "EPSG",
    "auth_id": "8177",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28919,
    "description": "NAD83(HARN) / WISCRS Grant (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.484023368 +y_0=0.0100584201168402 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8172,
    "auth_name": "EPSG",
    "auth_id": "8172",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28920,
    "description": "NAD83(HARN) / WISCRS Forest (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0055555555556 +lon_0=-88.6333333333333 +k=1.0000673004 +x_0=275844.5533 +y_0=0.0157 +ellps=GRS80 +units=m +no_defs",
    "srid": 8173,
    "auth_name": "EPSG",
    "auth_id": "8173",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28921,
    "description": "NAD83(HARN) / WISCRS Green and Lafayette (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.74015748 +y_0=45830.2948437897 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8170,
    "auth_name": "EPSG",
    "auth_id": "8170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28922,
    "description": "NAD83(HARN) / WISCRS Grant (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.4841 +y_0=0.01 +ellps=GRS80 +units=m +no_defs",
    "srid": 8171,
    "auth_name": "EPSG",
    "auth_id": "8171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28923,
    "description": "NAD83(HARN) / WISCRS Green Lake and Marquette (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.301752604 +y_0=79170.7793751588 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8168,
    "auth_name": "EPSG",
    "auth_id": "8168",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28924,
    "description": "NAD83(HARN) / WISCRS Green and Lafayette (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +units=m +no_defs",
    "srid": 8169,
    "auth_name": "EPSG",
    "auth_id": "8169",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28925,
    "description": "NAD83(HARN) / WISCRS Iowa (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5388888888889 +lon_0=-90.1611111111111 +k=1.0000394961 +x_0=113081.026162052 +y_0=0.00457200914401829 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8166,
    "auth_name": "EPSG",
    "auth_id": "8166",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28926,
    "description": "NAD83(HARN) / WISCRS Green Lake and Marquette (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +units=m +no_defs",
    "srid": 8167,
    "auth_name": "EPSG",
    "auth_id": "8167",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28927,
    "description": "NAD83(HARN) / WISCRS Iron (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.4333333333333 +lon_0=-90.2555555555556 +k=1.0000677153 +x_0=220980.441960884 +y_0=0.00853441706883414 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8164,
    "auth_name": "EPSG",
    "auth_id": "8164",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28928,
    "description": "NAD83(HARN) / WISCRS Iowa (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5388888888889 +lon_0=-90.1611111111111 +k=1.0000394961 +x_0=113081.0261 +y_0=0.0045 +ellps=GRS80 +units=m +no_defs",
    "srid": 8165,
    "auth_name": "EPSG",
    "auth_id": "8165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28929,
    "description": "NAD83(HARN) / WISCRS Jackson (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.2533351277778 +lon_0=-90.8442965194444 +k=1.0000353 +x_0=27000 +y_0=24999.9998983998 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8162,
    "auth_name": "EPSG",
    "auth_id": "8162",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28930,
    "description": "NAD83(HARN) / WISCRS Iron (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.4333333333333 +lon_0=-90.2555555555556 +k=1.0000677153 +x_0=220980.4419 +y_0=0.0085 +ellps=GRS80 +units=m +no_defs",
    "srid": 8163,
    "auth_name": "EPSG",
    "auth_id": "8163",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28931,
    "description": "NAD83(HARN) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8160,
    "auth_name": "EPSG",
    "auth_id": "8160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28932,
    "description": "NAD83(HARN) / WISCRS Jackson (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.2533351277778 +lon_0=-90.8442965194444 +k=1.0000353 +x_0=27000 +y_0=25000 +ellps=GRS80 +units=m +no_defs",
    "srid": 8161,
    "auth_name": "EPSG",
    "auth_id": "8161",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28933,
    "description": "NAD83(HARN) / WISCRS Kewaunee, Manitowoc and Sheboygan (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8158,
    "auth_name": "EPSG",
    "auth_id": "8158",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28934,
    "description": "NAD83(HARN) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +units=m +no_defs",
    "srid": 8159,
    "auth_name": "EPSG",
    "auth_id": "8159",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28935,
    "description": "NAD83(HARN) / WISCRS La Crosse (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4511111111111 +lon_0=-91.3166666666667 +k=1.0000319985 +x_0=130454.659690119 +y_0=0.00335280670561341 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8156,
    "auth_name": "EPSG",
    "auth_id": "8156",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28936,
    "description": "NAD83(HARN) / WISCRS Kewaunee, Manitowoc and Sheboygan (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +units=m +no_defs",
    "srid": 8157,
    "auth_name": "EPSG",
    "auth_id": "8157",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28937,
    "description": "NAD83(HARN) / WISCRS Langlade (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.1542371052778 +lat_0=45.1542371052778 +lon_0=-89.0333333333333 +k_0=1.0000627024 +x_0=198425.196850394 +y_0=105279.782880366 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8154,
    "auth_name": "EPSG",
    "auth_id": "8154",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28938,
    "description": "NAD83(HARN) / WISCRS La Crosse (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4511111111111 +lon_0=-91.3166666666667 +k=1.0000319985 +x_0=130454.6598 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs",
    "srid": 8155,
    "auth_name": "EPSG",
    "auth_id": "8155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28939,
    "description": "NAD83(HARN) / WISCRS Lincoln (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.8444444444444 +lon_0=-89.7333333333333 +k=1.0000599003 +x_0=116129.032258065 +y_0=0.00579121158242317 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8152,
    "auth_name": "EPSG",
    "auth_id": "8152",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28940,
    "description": "NAD83(HARN) / WISCRS Langlade (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.1542371052778 +lat_0=45.1542371052778 +lon_0=-89.0333333333333 +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829 +ellps=GRS80 +units=m +no_defs",
    "srid": 8153,
    "auth_name": "EPSG",
    "auth_id": "8153",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28941,
    "description": "NAD83(HARN) / WISCRS Marathon (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.9009044236111 +lat_0=44.9009044236111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493522987 +y_0=55049.2669545339 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8150,
    "auth_name": "EPSG",
    "auth_id": "8150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28942,
    "description": "NAD83(HARN) / WISCRS Lincoln (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.8444444444444 +lon_0=-89.7333333333333 +k=1.0000599003 +x_0=116129.0323 +y_0=0.0058 +ellps=GRS80 +units=m +no_defs",
    "srid": 8151,
    "auth_name": "EPSG",
    "auth_id": "8151",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28943,
    "description": "NAD83(HARN) / WISCRS Marinette (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.6916666666667 +lon_0=-87.7111111111111 +k=1.0000234982 +x_0=238658.879451359 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8148,
    "auth_name": "EPSG",
    "auth_id": "8148",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28944,
    "description": "NAD83(HARN) / WISCRS Marathon (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.9009044236111 +lat_0=44.9009044236111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669 +ellps=GRS80 +units=m +no_defs",
    "srid": 8149,
    "auth_name": "EPSG",
    "auth_id": "8149",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28945,
    "description": "NAD83(HARN) / WISCRS Menominee (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.7166666666667 +lon_0=-88.4166666666667 +k=1.0000362499 +x_0=105461.012141224 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8146,
    "auth_name": "EPSG",
    "auth_id": "8146",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28946,
    "description": "NAD83(HARN) / WISCRS Marinette (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.6916666666667 +lon_0=-87.7111111111111 +k=1.0000234982 +x_0=238658.8794 +y_0=0.0032 +ellps=GRS80 +units=m +no_defs",
    "srid": 8147,
    "auth_name": "EPSG",
    "auth_id": "8147",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28947,
    "description": "NAD83(HARN) / WISCRS Monroe (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.0000739286111 +lat_0=44.0000739286111 +lon_0=-90.6416666666667 +k_0=1.0000434122 +x_0=204521.209042418 +y_0=121923.986182372 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8144,
    "auth_name": "EPSG",
    "auth_id": "8144",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28948,
    "description": "NAD83(HARN) / WISCRS Menominee (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.7166666666667 +lon_0=-88.4166666666667 +k=1.0000362499 +x_0=105461.0121 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs",
    "srid": 8145,
    "auth_name": "EPSG",
    "auth_id": "8145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28949,
    "description": "NAD83(HARN) / WISCRS Oconto (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.3972222222222 +lon_0=-87.9083333333333 +k=1.0000236869 +x_0=182880.367589535 +y_0=0.00335280670561341 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8142,
    "auth_name": "EPSG",
    "auth_id": "8142",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28950,
    "description": "NAD83(HARN) / WISCRS Monroe (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.0000739286111 +lat_0=44.0000739286111 +lon_0=-90.6416666666667 +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861 +ellps=GRS80 +units=m +no_defs",
    "srid": 8143,
    "auth_name": "EPSG",
    "auth_id": "8143",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28951,
    "description": "NAD83(HARN) / WISCRS Oneida (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.7042237702778 +lat_0=45.7042237702778 +lon_0=-89.5444444444444 +k_0=1.0000686968 +x_0=70104.1402082804 +y_0=57588.0347472695 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8140,
    "auth_name": "EPSG",
    "auth_id": "8140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28952,
    "description": "NAD83(HARN) / WISCRS Oconto (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.3972222222222 +lon_0=-87.9083333333333 +k=1.0000236869 +x_0=182880.3676 +y_0=0.0033 +ellps=GRS80 +units=m +no_defs",
    "srid": 8141,
    "auth_name": "EPSG",
    "auth_id": "8141",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28953,
    "description": "NAD83(HARN) / WISCRS Pepin and Pierce (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.335280671 +y_0=86033.0877317755 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8138,
    "auth_name": "EPSG",
    "auth_id": "8138",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28954,
    "description": "NAD83(HARN) / WISCRS Oneida (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.7042237702778 +lat_0=45.7042237702778 +lon_0=-89.5444444444444 +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346 +ellps=GRS80 +units=m +no_defs",
    "srid": 8139,
    "auth_name": "EPSG",
    "auth_id": "8139",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28955,
    "description": "NAD83(HARN) / WISCRS Polk (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.6611111111111 +lon_0=-92.6333333333333 +k=1.0000433849 +x_0=141732.282245365 +y_0=0.00579121158242317 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8136,
    "auth_name": "EPSG",
    "auth_id": "8136",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28956,
    "description": "NAD83(HARN) / WISCRS Pepin and Pierce (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +units=m +no_defs",
    "srid": 8137,
    "auth_name": "EPSG",
    "auth_id": "8137",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28957,
    "description": "NAD83(HARN) / WISCRS Portage (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.4168239752778 +lat_0=44.4168239752778 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1127762256 +y_0=50022.1874523749 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8134,
    "auth_name": "EPSG",
    "auth_id": "8134",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28958,
    "description": "NAD83(HARN) / WISCRS Polk (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.6611111111111 +lon_0=-92.6333333333333 +k=1.0000433849 +x_0=141732.2823 +y_0=0.0059 +ellps=GRS80 +units=m +no_defs",
    "srid": 8135,
    "auth_name": "EPSG",
    "auth_id": "8135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28959,
    "description": "NAD83(HARN) / WISCRS Price (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5555555555556 +lon_0=-90.4888888888889 +k=1.0000649554 +x_0=227990.854457709 +y_0=0.0109728219456439 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8132,
    "auth_name": "EPSG",
    "auth_id": "8132",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28960,
    "description": "NAD83(HARN) / WISCRS Portage (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.4168239752778 +lat_0=44.4168239752778 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874 +ellps=GRS80 +units=m +no_defs",
    "srid": 8133,
    "auth_name": "EPSG",
    "auth_id": "8133",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28961,
    "description": "NAD83(HARN) / WISCRS Richland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.4305555555556 +k_0=1.0000375653 +x_0=202387.60477521 +y_0=134255.425450851 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8130,
    "auth_name": "EPSG",
    "auth_id": "8130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28962,
    "description": "NAD83(HARN) / WISCRS Price (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5555555555556 +lon_0=-90.4888888888889 +k=1.0000649554 +x_0=227990.8546 +y_0=0.0109 +ellps=GRS80 +units=m +no_defs",
    "srid": 8131,
    "auth_name": "EPSG",
    "auth_id": "8131",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28963,
    "description": "NAD83(HARN) / WISCRS Rock (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.9444444444444 +lon_0=-89.0722222222222 +k=1.0000337311 +x_0=146304.292608585 +y_0=0.00670561341122682 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8128,
    "auth_name": "EPSG",
    "auth_id": "8128",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28964,
    "description": "NAD83(HARN) / WISCRS Richland (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.4305555555556 +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253 +ellps=GRS80 +units=m +no_defs",
    "srid": 8129,
    "auth_name": "EPSG",
    "auth_id": "8129",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28965,
    "description": "Kyrg-06 / zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=80.5166666666667 +k=1 +x_0=5300000 +y_0=14743.5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7696,
    "auth_name": "EPSG",
    "auth_id": "7696",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28966,
    "description": "Kyrg-06 / zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=74.5166666666667 +k=1 +x_0=3300000 +y_0=14743.5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7694,
    "auth_name": "EPSG",
    "auth_id": "7694",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28967,
    "description": "Kyrg-06 / zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=77.5166666666667 +k=1 +x_0=4300000 +y_0=14743.5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7695,
    "auth_name": "EPSG",
    "auth_id": "7695",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28968,
    "description": "Kyrg-06 / zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=68.5166666666667 +k=1 +x_0=1300000 +y_0=14743.5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7692,
    "auth_name": "EPSG",
    "auth_id": "7692",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28969,
    "description": "Kyrg-06 / zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=71.5166666666667 +k=1 +x_0=2300000 +y_0=14743.5 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7693,
    "auth_name": "EPSG",
    "auth_id": "7693",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28970,
    "description": "Kyrg-06",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 7686,
    "auth_name": "EPSG",
    "auth_id": "7686",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28971,
    "description": "Kyrg-06",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7684,
    "auth_name": "EPSG",
    "auth_id": "7684",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28972,
    "description": "GSK-2011",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GSK2011",
    "parameters": "+proj=longlat +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 7683,
    "auth_name": "EPSG",
    "auth_id": "7683",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28973,
    "description": "GSK-2011",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GSK2011",
    "parameters": "+proj=geocent +ellps=GSK2011 +units=m +no_defs",
    "srid": 7681,
    "auth_name": "EPSG",
    "auth_id": "7681",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28975,
    "description": "BGS2005 / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7805,
    "auth_name": "EPSG",
    "auth_id": "7805",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28976,
    "description": "BGS2005 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7803,
    "auth_name": "EPSG",
    "auth_id": "7803",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28977,
    "description": "BGS2005 / UTM zone 35N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7800,
    "auth_name": "EPSG",
    "auth_id": "7800",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28978,
    "description": "BGS2005 / CCS2005",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.6678756833333 +lon_0=25.5 +lat_1=42 +lat_2=43.3333333333333 +x_0=500000 +y_0=4725824.3591 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7801,
    "auth_name": "EPSG",
    "auth_id": "7801",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28979,
    "description": "BGS2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 7798,
    "auth_name": "EPSG",
    "auth_id": "7798",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 28980,
    "description": "BGS2005 / UTM zone 34N (N-E)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7799,
    "auth_name": "EPSG",
    "auth_id": "7799",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28981,
    "description": "BGS2005",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7796,
    "auth_name": "EPSG",
    "auth_id": "7796",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28982,
    "description": "RDN2008 / Italy zone (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9985 +x_0=7000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7794,
    "auth_name": "EPSG",
    "auth_id": "7794",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28983,
    "description": "RDN2008 / Zone 12 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=3000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7795,
    "auth_name": "EPSG",
    "auth_id": "7795",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28984,
    "description": "RDN2008 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7792,
    "auth_name": "EPSG",
    "auth_id": "7792",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28985,
    "description": "RDN2008 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7793,
    "auth_name": "EPSG",
    "auth_id": "7793",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28986,
    "description": "RDN2008 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7791,
    "auth_name": "EPSG",
    "auth_id": "7791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28987,
    "description": "ITRF2014",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7789,
    "auth_name": "EPSG",
    "auth_id": "7789",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 28988,
    "description": "WGS 84 / Tripura",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=23.75 +lon_0=91.75 +k=0.9999822 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7786,
    "auth_name": "EPSG",
    "auth_id": "7786",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28989,
    "description": "WGS 84 / West Bengal",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=24.375 +lon_0=87.875 +k=0.9998584 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7787,
    "auth_name": "EPSG",
    "auth_id": "7787",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28990,
    "description": "WGS 84 / Sikkim",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=27.625 +lon_0=88.5 +k=0.9999926 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7784,
    "auth_name": "EPSG",
    "auth_id": "7784",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28991,
    "description": "WGS 84 / Tamil Nadu",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=10.875 +lon_0=78.375 +k=0.9997942 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7785,
    "auth_name": "EPSG",
    "auth_id": "7785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28992,
    "description": "WGS 84 / Lakshadweep",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=10 +lon_0=73.125 +k=0.9999536 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7782,
    "auth_name": "EPSG",
    "auth_id": "7782",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28993,
    "description": "WGS 84 / Mizoram",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=23.125 +lon_0=92.75 +k=0.9999821 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7783,
    "auth_name": "EPSG",
    "auth_id": "7783",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28994,
    "description": "WGS 84 / Karnataka",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=15.125 +lon_0=76.375 +k=0.9998012 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7780,
    "auth_name": "EPSG",
    "auth_id": "7780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28995,
    "description": "WGS 84 / Kerala",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=10.5 +lon_0=76 +k=0.9999177 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7781,
    "auth_name": "EPSG",
    "auth_id": "7781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28996,
    "description": "WGS 84 / Chhattisgarh",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=21 +lon_0=82.25 +k=0.9998332 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7778,
    "auth_name": "EPSG",
    "auth_id": "7778",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28997,
    "description": "WGS 84 / Goa",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=15.375 +lon_0=74 +k=0.9999913 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7779,
    "auth_name": "EPSG",
    "auth_id": "7779",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28998,
    "description": "WGS 84 / Uttaranchal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=30.0017132 +lon_0=79.375 +lat_1=29 +lat_2=31 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7776,
    "auth_name": "EPSG",
    "auth_id": "7776",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 28999,
    "description": "WGS 84 / Andaman and Nicobar",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=10.25 +lon_0=93.25 +k=0.9999428 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7777,
    "auth_name": "EPSG",
    "auth_id": "7777",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29000,
    "description": "WGS 84 / Rajasthan",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=26.88505546 +lon_0=73.875 +lat_1=24.2916666666667 +lat_2=29.4583333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7774,
    "auth_name": "EPSG",
    "auth_id": "7774",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29001,
    "description": "WGS 84 / Uttar Pradesh",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=27.13270823 +lon_0=80.875 +lat_1=24.875 +lat_2=29.375 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7775,
    "auth_name": "EPSG",
    "auth_id": "7775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29002,
    "description": "WGS 84 / Orissa",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=20.25305174 +lon_0=84.375 +lat_1=18.5833333333333 +lat_2=21.9166666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7772,
    "auth_name": "EPSG",
    "auth_id": "7772",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29003,
    "description": "WGS 84 / Punjab",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=31.00178226 +lon_0=75.375 +lat_1=30 +lat_2=32 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7773,
    "auth_name": "EPSG",
    "auth_id": "7773",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29004,
    "description": "WGS 84 / Nagaland",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=26.12581974 +lon_0=94.375 +lat_1=25.375 +lat_2=26.875 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7770,
    "auth_name": "EPSG",
    "auth_id": "7770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29005,
    "description": "WGS 84 / India Northeast",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=25.63452135 +lon_0=93.5 +lat_1=23.0416666666667 +lat_2=28.2083333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7771,
    "auth_name": "EPSG",
    "auth_id": "7771",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29006,
    "description": "WGS 84 / Manipur",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=24.75060911 +lon_0=94 +lat_1=24.0833333333333 +lat_2=25.4166666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7768,
    "auth_name": "EPSG",
    "auth_id": "7768",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29007,
    "description": "WGS 84 / Meghalaya",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=25.62524747 +lon_0=91.375 +lat_1=25.2083333333333 +lat_2=26.0416666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7769,
    "auth_name": "EPSG",
    "auth_id": "7769",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29008,
    "description": "WGS 84 / Madhya Pradesh",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=24.00529821 +lon_0=78.375 +lat_1=22 +lat_2=26 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7766,
    "auth_name": "EPSG",
    "auth_id": "7766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29009,
    "description": "WGS 84 / Maharashtra",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=18.88015774 +lon_0=76.75 +lat_1=16.625 +lat_2=21.125 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7767,
    "auth_name": "EPSG",
    "auth_id": "7767",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29010,
    "description": "WGS 84 / Jammu and Kashmir",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=34.75570874 +lon_0=76.5 +lat_1=33.0833333333333 +lat_2=36.4166666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7764,
    "auth_name": "EPSG",
    "auth_id": "7764",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29011,
    "description": "WGS 84 / Jharkhand",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=23.62652682 +lon_0=85.625 +lat_1=22.5416666666667 +lat_2=24.7083333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7765,
    "auth_name": "EPSG",
    "auth_id": "7765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29012,
    "description": "WGS 84 / Haryana",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=29.25226266 +lon_0=76 +lat_1=28.0833333333333 +lat_2=30.4166666666667 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7762,
    "auth_name": "EPSG",
    "auth_id": "7762",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29013,
    "description": "WGS 84 / Himachal Pradesh",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=31.75183497 +lon_0=77.375 +lat_1=30.75 +lat_2=32.75 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7763,
    "auth_name": "EPSG",
    "auth_id": "7763",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29014,
    "description": "WGS 84 / Delhi",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=28.62510126 +lon_0=77 +lat_1=28.375 +lat_2=28.875 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7760,
    "auth_name": "EPSG",
    "auth_id": "7760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29015,
    "description": "WGS 84 / Gujarat",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=22.37807121 +lon_0=71.375 +lat_1=20.7916666666667 +lat_2=23.9583333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7761,
    "auth_name": "EPSG",
    "auth_id": "7761",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29016,
    "description": "WGS 84 / Assam",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=26.00257703 +lon_0=92.75 +lat_1=24.6666666666667 +lat_2=27.3333333333333 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7758,
    "auth_name": "EPSG",
    "auth_id": "7758",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29017,
    "description": "WGS 84 / Bihar",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=25.87725247 +lon_0=85.875 +lat_1=24.625 +lat_2=27.125 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7759,
    "auth_name": "EPSG",
    "auth_id": "7759",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29018,
    "description": "WGS 84 / Andhra Pradesh",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=16.25543298 +lon_0=80.875 +lat_1=13.75 +lat_2=18.75 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7756,
    "auth_name": "EPSG",
    "auth_id": "7756",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29019,
    "description": "WGS 84 / Arunachal Pradesh",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=28.00157897 +lon_0=94.5 +lat_1=27 +lat_2=29 +x_0=1000000 +y_0=1000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7757,
    "auth_name": "EPSG",
    "auth_id": "7757",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29020,
    "description": "WGS 84 / India NSF LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=24 +lon_0=80 +lat_1=12.472955 +lat_2=35.1728044444444 +x_0=4000000 +y_0=4000000 +datum=WGS84 +units=m +no_defs",
    "srid": 7755,
    "auth_name": "EPSG",
    "auth_id": "7755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29021,
    "description": "GDA2020 / MGA zone 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=58 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7858,
    "auth_name": "EPSG",
    "auth_id": "7858",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29022,
    "description": "GDA2020 / MGA zone 59",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=59 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7859,
    "auth_name": "EPSG",
    "auth_id": "7859",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29023,
    "description": "GDA2020 / MGA zone 56",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=56 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7856,
    "auth_name": "EPSG",
    "auth_id": "7856",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29024,
    "description": "GDA2020 / MGA zone 57",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=57 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7857,
    "auth_name": "EPSG",
    "auth_id": "7857",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29025,
    "description": "GDA2020 / MGA zone 54",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=54 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7854,
    "auth_name": "EPSG",
    "auth_id": "7854",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29026,
    "description": "GDA2020 / MGA zone 55",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=55 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7855,
    "auth_name": "EPSG",
    "auth_id": "7855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29027,
    "description": "GDA2020 / MGA zone 52",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=52 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7852,
    "auth_name": "EPSG",
    "auth_id": "7852",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29028,
    "description": "GDA2020 / MGA zone 53",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=53 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7853,
    "auth_name": "EPSG",
    "auth_id": "7853",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29029,
    "description": "GDA2020 / MGA zone 50",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=50 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7850,
    "auth_name": "EPSG",
    "auth_id": "7850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29030,
    "description": "GDA2020 / MGA zone 51",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=51 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7851,
    "auth_name": "EPSG",
    "auth_id": "7851",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29031,
    "description": "GDA2020 / MGA zone 48",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=48 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7848,
    "auth_name": "EPSG",
    "auth_id": "7848",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29032,
    "description": "GDA2020 / MGA zone 49",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=49 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7849,
    "auth_name": "EPSG",
    "auth_id": "7849",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29033,
    "description": "GDA2020 / MGA zone 46",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=46 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7846,
    "auth_name": "EPSG",
    "auth_id": "7846",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29034,
    "description": "GDA2020 / MGA zone 47",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=47 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 7847,
    "auth_name": "EPSG",
    "auth_id": "7847",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29035,
    "description": "GDA2020",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 7844,
    "auth_name": "EPSG",
    "auth_id": "7844",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29036,
    "description": "GDA2020 / GA LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=134 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 7845,
    "auth_name": "EPSG",
    "auth_id": "7845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29037,
    "description": "GDA2020",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7842,
    "auth_name": "EPSG",
    "auth_id": "7842",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29038,
    "description": "Pulkovo 1942 / CS63 zone X6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=38.5 +k=1 +x_0=6300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 7830,
    "auth_name": "EPSG",
    "auth_id": "7830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29039,
    "description": "Pulkovo 1942 / CS63 zone X7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=41.5 +k=1 +x_0=7300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 7831,
    "auth_name": "EPSG",
    "auth_id": "7831",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29040,
    "description": "Pulkovo 1942 / CS63 zone X4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=32.5 +k=1 +x_0=4300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 7828,
    "auth_name": "EPSG",
    "auth_id": "7828",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29041,
    "description": "Pulkovo 1942 / CS63 zone X5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=35.5 +k=1 +x_0=5300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 7829,
    "auth_name": "EPSG",
    "auth_id": "7829",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29042,
    "description": "Pulkovo 1942 / CS63 zone X2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=26.5 +k=1 +x_0=2300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 7826,
    "auth_name": "EPSG",
    "auth_id": "7826",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29043,
    "description": "Pulkovo 1942 / CS63 zone X3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=29.5 +k=1 +x_0=3300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 7827,
    "auth_name": "EPSG",
    "auth_id": "7827",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29044,
    "description": "Pulkovo 1942 / CS63 zone X1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0.0833333333333333 +lon_0=23.5 +k=1 +x_0=1300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 7825,
    "auth_name": "EPSG",
    "auth_id": "7825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29045,
    "description": "WGS 84 (Transit)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 7815,
    "auth_name": "EPSG",
    "auth_id": "7815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29046,
    "description": "ETRF2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7930,
    "auth_name": "EPSG",
    "auth_id": "7930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29047,
    "description": "ETRF97",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7928,
    "auth_name": "EPSG",
    "auth_id": "7928",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29048,
    "description": "ETRF96",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7926,
    "auth_name": "EPSG",
    "auth_id": "7926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29049,
    "description": "ETRF94",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7924,
    "auth_name": "EPSG",
    "auth_id": "7924",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29050,
    "description": "ETRF93",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7922,
    "auth_name": "EPSG",
    "auth_id": "7922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29051,
    "description": "ETRF92",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7920,
    "auth_name": "EPSG",
    "auth_id": "7920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29052,
    "description": "ETRF91",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7918,
    "auth_name": "EPSG",
    "auth_id": "7918",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29053,
    "description": "ETRF90",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7916,
    "auth_name": "EPSG",
    "auth_id": "7916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29054,
    "description": "ETRF89",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7914,
    "auth_name": "EPSG",
    "auth_id": "7914",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29055,
    "description": "GDA2020 / Vicgrid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=-37 +lon_0=145 +lat_1=-36 +lat_2=-38 +x_0=2500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 7899,
    "auth_name": "EPSG",
    "auth_id": "7899",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29056,
    "description": "SHGD2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 7886,
    "auth_name": "EPSG",
    "auth_id": "7886",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29057,
    "description": "SHMG2015",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7887,
    "auth_name": "EPSG",
    "auth_id": "7887",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29058,
    "description": "SHGD2015",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 7884,
    "auth_name": "EPSG",
    "auth_id": "7884",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29059,
    "description": "St. Helena Tritan / SHLG(Tritan)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=-15.9666666666667 +lon_0=-5.71666666666667 +k=1 +x_0=299483.737 +y_0=2000527.879 +ellps=WGS84 +towgs84=-0.077,0.079,0.086,0,0,0,0 +units=m +no_defs",
    "srid": 7882,
    "auth_name": "EPSG",
    "auth_id": "7882",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29060,
    "description": "St. Helena Tritan / UTM zone 30S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=30 +south +ellps=WGS84 +towgs84=-0.077,0.079,0.086,0,0,0,0 +units=m +no_defs",
    "srid": 7883,
    "auth_name": "EPSG",
    "auth_id": "7883",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29061,
    "description": "St. Helena Tritan",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=-0.077,0.079,0.086,0,0,0,0 +no_defs",
    "srid": 7881,
    "auth_name": "EPSG",
    "auth_id": "7881",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29062,
    "description": "Astro DOS 71 / UTM zone 30S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=30 +south +ellps=intl +units=m +no_defs",
    "srid": 7878,
    "auth_name": "EPSG",
    "auth_id": "7878",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29063,
    "description": "St. Helena Tritan",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 7879,
    "auth_name": "EPSG",
    "auth_id": "7879",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29064,
    "description": "Astro DOS 71 / SHLG71",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-15.9666666666667 +lon_0=-5.71666666666667 +k=1 +x_0=300000 +y_0=2000000 +ellps=intl +units=m +no_defs",
    "srid": 7877,
    "auth_name": "EPSG",
    "auth_id": "7877",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29065,
    "description": "NAD83(2011) / WISCRS Green Lake and Marquette (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7550,
    "auth_name": "EPSG",
    "auth_id": "7550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29066,
    "description": "NAD83(2011) / WISCRS Iowa (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5388888888889 +lon_0=-90.1611111111111 +k=1.0000394961 +x_0=113081.0261 +y_0=0.0045 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7551,
    "auth_name": "EPSG",
    "auth_id": "7551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29067,
    "description": "NAD83(2011) / WISCRS Grant (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.4841 +y_0=0.01 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7548,
    "auth_name": "EPSG",
    "auth_id": "7548",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29068,
    "description": "NAD83(2011) / WISCRS Green and Lafayette (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7549,
    "auth_name": "EPSG",
    "auth_id": "7549",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29069,
    "description": "NAD83(2011) / WISCRS Florence (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.4388888888889 +lon_0=-88.1416666666667 +k=1.0000552095 +x_0=133502.6683 +y_0=0.0063 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7546,
    "auth_name": "EPSG",
    "auth_id": "7546",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29070,
    "description": "NAD83(2011) / WISCRS Forest (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0055555555556 +lon_0=-88.6333333333333 +k=1.0000673004 +x_0=275844.5533 +y_0=0.0157 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7547,
    "auth_name": "EPSG",
    "auth_id": "7547",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29071,
    "description": "NAD83(2011) / WISCRS Dunn (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.4083333333333 +lon_0=-91.8944444444444 +k=1.0000410324 +x_0=51816.104 +y_0=0.003 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7544,
    "auth_name": "EPSG",
    "auth_id": "7544",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29072,
    "description": "NAD83(2011) / WISCRS Eau Claire (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.8722811263889 +lat_0=44.8722811263889 +lon_0=-91.2888888888889 +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.9239 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7545,
    "auth_name": "EPSG",
    "auth_id": "7545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29073,
    "description": "NAD83(2011) / WISCRS Door (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.4 +lon_0=-87.2722222222222 +k=1.0000187521 +x_0=158801.1176 +y_0=0.0023 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7542,
    "auth_name": "EPSG",
    "auth_id": "7542",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29074,
    "description": "NAD83(2011) / WISCRS Douglas (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.8833333333333 +lon_0=-91.9166666666667 +k=1.0000385418 +x_0=59131.3183 +y_0=0.0041 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7543,
    "auth_name": "EPSG",
    "auth_id": "7543",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29075,
    "description": "NAD83(2011) / WISCRS Dane (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.4222222222222 +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7540,
    "auth_name": "EPSG",
    "auth_id": "7540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29076,
    "description": "NAD83(2011) / WISCRS Dodge and Jefferson (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7541,
    "auth_name": "EPSG",
    "auth_id": "7541",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29077,
    "description": "NAD83(2011) / WISCRS Columbia (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.4625466458333 +lat_0=43.4625466458333 +lon_0=-89.3944444444444 +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7538,
    "auth_name": "EPSG",
    "auth_id": "7538",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29078,
    "description": "NAD83(2011) / WISCRS Crawford (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7539,
    "auth_name": "EPSG",
    "auth_id": "7539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29079,
    "description": "NAD83(2011) / WISCRS Chippewa (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.9778568986111 +lat_0=44.9778568986111 +lon_0=-91.2944444444444 +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7536,
    "auth_name": "EPSG",
    "auth_id": "7536",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29080,
    "description": "NAD83(2011) / WISCRS Clark (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6 +lon_0=-90.7083333333333 +k=1.0000463003 +x_0=199949.1989 +y_0=0.0086 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7537,
    "auth_name": "EPSG",
    "auth_id": "7537",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29081,
    "description": "NAD83(2011) / WISCRS Burnett (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.8987148658333 +lat_0=45.8987148658333 +lon_0=-92.4577777777778 +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7534,
    "auth_name": "EPSG",
    "auth_id": "7534",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29082,
    "description": "NAD83(2011) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7535,
    "auth_name": "EPSG",
    "auth_id": "7535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29083,
    "description": "NAD83(2011) / WISCRS Brown (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31600 +y_0=4600 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7532,
    "auth_name": "EPSG",
    "auth_id": "7532",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29084,
    "description": "NAD83(2011) / WISCRS Buffalo (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4813888888889 +lon_0=-91.7972222222222 +k=1.0000382778 +x_0=175260.3502 +y_0=0.0048 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7533,
    "auth_name": "EPSG",
    "auth_id": "7533",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29085,
    "description": "NAD83(2011) / WISCRS Barron (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.1333333333333 +lon_0=-91.85 +k=1.0000486665 +x_0=93150 +y_0=0.0029 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7530,
    "auth_name": "EPSG",
    "auth_id": "7530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29086,
    "description": "NAD83(2011) / WISCRS Bayfield (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.6696483772222 +lat_0=46.6696483772222 +lon_0=-91.1527777777778 +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7531,
    "auth_name": "EPSG",
    "auth_id": "7531",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29087,
    "description": "NAD83(2011) / WISCRS Adams and Juneau (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7528,
    "auth_name": "EPSG",
    "auth_id": "7528",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29088,
    "description": "NAD83(2011) / WISCRS Ashland (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.7061111111111 +lon_0=-90.6222222222222 +k=1.0000495683 +x_0=172821.9461 +y_0=0.0017 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7529,
    "auth_name": "EPSG",
    "auth_id": "7529",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29089,
    "description": "NAD83(2011) / WISCRS Kewaunee, Manitowoc and Sheboygan (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7614,
    "auth_name": "EPSG",
    "auth_id": "7614",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29090,
    "description": "NAD83(2011) / WISCRS La Crosse (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4511111111111 +lon_0=-91.3166666666667 +k=1.0000319985 +x_0=130454.659690119 +y_0=0.00335280670561341 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7615,
    "auth_name": "EPSG",
    "auth_id": "7615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29091,
    "description": "NAD83(2011) / WISCRS Jackson (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.2533351277778 +lon_0=-90.8442965194444 +k=1.0000353 +x_0=27000 +y_0=24999.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7612,
    "auth_name": "EPSG",
    "auth_id": "7612",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29092,
    "description": "NAD83(2011) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7613,
    "auth_name": "EPSG",
    "auth_id": "7613",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29093,
    "description": "NAD83(2011) / WISCRS Iowa (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5388888888889 +lon_0=-90.1611111111111 +k=1.0000394961 +x_0=113081.026162052 +y_0=0.00457200914401829 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7610,
    "auth_name": "EPSG",
    "auth_id": "7610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29094,
    "description": "NAD83(2011) / WISCRS Iron (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.4333333333333 +lon_0=-90.2555555555556 +k=1.0000677153 +x_0=220980.441960884 +y_0=0.00853441706883414 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7611,
    "auth_name": "EPSG",
    "auth_id": "7611",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29095,
    "description": "NAD83(2011) / WISCRS Green and Lafayette (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.74015748 +y_0=45830.2948437897 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7608,
    "auth_name": "EPSG",
    "auth_id": "7608",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29096,
    "description": "NAD83(2011) / WISCRS Green Lake and Marquette (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.301752604 +y_0=79170.7793751588 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7609,
    "auth_name": "EPSG",
    "auth_id": "7609",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29097,
    "description": "NAD83(2011) / WISCRS Forest (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0055555555556 +lon_0=-88.6333333333333 +k=1.0000673004 +x_0=275844.553213106 +y_0=0.0158496316992634 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7606,
    "auth_name": "EPSG",
    "auth_id": "7606",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29098,
    "description": "NAD83(2011) / WISCRS Grant (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4111111111111 +lon_0=-90.8 +k=1.0000349452 +x_0=242316.484023368 +y_0=0.0100584201168402 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7607,
    "auth_name": "EPSG",
    "auth_id": "7607",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29099,
    "description": "NAD83(2011) / WISCRS Eau Claire (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.8722811263889 +lat_0=44.8722811263889 +lon_0=-91.2888888888889 +k_0=1.000035079 +x_0=120091.44018288 +y_0=91687.9239014478 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7604,
    "auth_name": "EPSG",
    "auth_id": "7604",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29100,
    "description": "NAD83(2011) / WISCRS Florence (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.4388888888889 +lon_0=-88.1416666666667 +k=1.0000552095 +x_0=133502.668224536 +y_0=0.0064008128016256 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7605,
    "auth_name": "EPSG",
    "auth_id": "7605",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29101,
    "description": "NAD83(2011) / WISCRS Douglas (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.8833333333333 +lon_0=-91.9166666666667 +k=1.0000385418 +x_0=59131.3182626365 +y_0=0.00396240792481585 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7602,
    "auth_name": "EPSG",
    "auth_id": "7602",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29102,
    "description": "NAD83(2011) / WISCRS Dunn (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.4083333333333 +lon_0=-91.8944444444444 +k=1.0000410324 +x_0=51816.1039370079 +y_0=0.00304800609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7603,
    "auth_name": "EPSG",
    "auth_id": "7603",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29103,
    "description": "NAD83(2011) / WISCRS Dodge and Jefferson (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.726390653 +y_0=0.00762001524003048 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7600,
    "auth_name": "EPSG",
    "auth_id": "7600",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29104,
    "description": "NAD83(2011) / WISCRS Door (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.4 +lon_0=-87.2722222222222 +k=1.0000187521 +x_0=158801.117602235 +y_0=0.00243840487680975 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7601,
    "auth_name": "EPSG",
    "auth_id": "7601",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29105,
    "description": "NAD83(2011) / WISCRS Crawford (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.627381255 +y_0=53703.1202438405 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7598,
    "auth_name": "EPSG",
    "auth_id": "7598",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29106,
    "description": "NAD83(2011) / WISCRS Dane (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.4222222222222 +k_0=1.0000384786 +x_0=247193.294386589 +y_0=146591.989636779 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7599,
    "auth_name": "EPSG",
    "auth_id": "7599",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29107,
    "description": "NAD83(2011) / WISCRS Clark (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6 +lon_0=-90.7083333333333 +k=1.0000463003 +x_0=199949.198983998 +y_0=0.00853441706883414 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7596,
    "auth_name": "EPSG",
    "auth_id": "7596",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29108,
    "description": "NAD83(2011) / WISCRS Columbia (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.4625466458333 +lat_0=43.4625466458333 +lon_0=-89.3944444444444 +k_0=1.00003498 +x_0=169164.338023876 +y_0=111569.613512827 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7597,
    "auth_name": "EPSG",
    "auth_id": "7597",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29109,
    "description": "NAD83(2011) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7594,
    "auth_name": "EPSG",
    "auth_id": "7594",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29110,
    "description": "NAD83(2011) / WISCRS Chippewa (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.9778568986111 +lat_0=44.9778568986111 +lon_0=-91.2944444444444 +k_0=1.0000391127 +x_0=60045.7200914402 +y_0=44091.434493269 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7595,
    "auth_name": "EPSG",
    "auth_id": "7595",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29111,
    "description": "NAD83(2011) / WISCRS Buffalo (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4813888888889 +lon_0=-91.7972222222222 +k=1.0000382778 +x_0=175260.3502159 +y_0=0.00487680975361951 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7592,
    "auth_name": "EPSG",
    "auth_id": "7592",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29112,
    "description": "NAD83(2011) / WISCRS Burnett (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.8987148658333 +lat_0=45.8987148658333 +lon_0=-92.4577777777778 +k_0=1.0000383841 +x_0=64008.1277114554 +y_0=59445.9041910084 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7593,
    "auth_name": "EPSG",
    "auth_id": "7593",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29113,
    "description": "NAD83(2011) / WISCRS Bayfield (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.6696483772222 +lat_0=46.6696483772222 +lon_0=-91.1527777777778 +k_0=1.0000331195 +x_0=228600.457505715 +y_0=148551.483566167 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7590,
    "auth_name": "EPSG",
    "auth_id": "7590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29114,
    "description": "NAD83(2011) / WISCRS Brown (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31599.9998983998 +y_0=4599.9998983998 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7591,
    "auth_name": "EPSG",
    "auth_id": "7591",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29115,
    "description": "NAD83(2011) / WISCRS Ashland (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.7061111111111 +lon_0=-90.6222222222222 +k=1.0000495683 +x_0=172821.945948692 +y_0=0.00182880365760732 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7588,
    "auth_name": "EPSG",
    "auth_id": "7588",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29116,
    "description": "NAD83(2011) / WISCRS Barron (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.1333333333333 +lon_0=-91.85 +k=1.0000486665 +x_0=93150 +y_0=0.00304800609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7589,
    "auth_name": "EPSG",
    "auth_id": "7589",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29117,
    "description": "NAD83(2011) / WISCRS Wood (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.3625954694444 +lat_0=44.3625954694444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7586,
    "auth_name": "EPSG",
    "auth_id": "7586",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29118,
    "description": "NAD83(2011) / WISCRS Adams and Juneau (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.694132588 +y_0=0.00365760731521463 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7587,
    "auth_name": "EPSG",
    "auth_id": "7587",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29119,
    "description": "NAD83(2011) / WISCRS Waupaca (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4202777777778 +lon_0=-88.8166666666667 +k=1.0000333645 +x_0=185013.9709 +y_0=0.007 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7584,
    "auth_name": "EPSG",
    "auth_id": "7584",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29120,
    "description": "NAD83(2011) / WISCRS Waushara (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.1139440458333 +lat_0=44.1139440458333 +lon_0=-89.2416666666667 +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7585,
    "auth_name": "EPSG",
    "auth_id": "7585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29121,
    "description": "NAD83(2011) / WISCRS Washington (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.9180555555556 +lon_0=-88.0638888888889 +k=1.00003738 +x_0=120091.4415 +y_0=0.003 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7582,
    "auth_name": "EPSG",
    "auth_id": "7582",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29122,
    "description": "NAD83(2011) / WISCRS Waukesha (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5694444444444 +lon_0=-88.225 +k=1.0000346179 +x_0=208788.418 +y_0=0.0034 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7583,
    "auth_name": "EPSG",
    "auth_id": "7583",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29123,
    "description": "NAD83(2011) / WISCRS Walworth (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6694620969444 +lat_0=42.6694620969444 +lon_0=-88.5416666666667 +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7580,
    "auth_name": "EPSG",
    "auth_id": "7580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29124,
    "description": "NAD83(2011) / WISCRS Washburn (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.9612198333333 +lat_0=45.9612198333333 +lon_0=-91.7833333333333 +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7581,
    "auth_name": "EPSG",
    "auth_id": "7581",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29125,
    "description": "NAD83(2011) / WISCRS Vernon (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.5750329397222 +lat_0=43.5750329397222 +lon_0=-90.7833333333333 +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7578,
    "auth_name": "EPSG",
    "auth_id": "7578",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29126,
    "description": "NAD83(2011) / WISCRS Vilas (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.0778440905556 +lat_0=46.0778440905556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7579,
    "auth_name": "EPSG",
    "auth_id": "7579",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29127,
    "description": "NAD83(2011) / WISCRS Taylor (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.1778220858333 +lat_0=45.1778220858333 +lon_0=-90.4833333333333 +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7576,
    "auth_name": "EPSG",
    "auth_id": "7576",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29128,
    "description": "NAD83(2011) / WISCRS Trempealeau (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.1611111111111 +lon_0=-91.3666666666667 +k=1.0000361538 +x_0=256946.9138 +y_0=0.0041 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7577,
    "auth_name": "EPSG",
    "auth_id": "7577",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29129,
    "description": "NAD83(2011) / WISCRS Shawano (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-88.6055555555556 +k=1.000032144 +x_0=262433.3253 +y_0=0.0096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7574,
    "auth_name": "EPSG",
    "auth_id": "7574",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29130,
    "description": "NAD83(2011) / WISCRS St. Croix (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-92.6333333333333 +k=1.0000381803 +x_0=165506.7302 +y_0=0.0103 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7575,
    "auth_name": "EPSG",
    "auth_id": "7575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29131,
    "description": "NAD83(2011) / WISCRS Sauk (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8194444444444 +lon_0=-89.9 +k=1.0000373868 +x_0=185623.5716 +y_0=0.0051 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7572,
    "auth_name": "EPSG",
    "auth_id": "7572",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29132,
    "description": "NAD83(2011) / WISCRS Sawyer (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.9000991313889 +lat_0=45.9000991313889 +lon_0=-91.1166666666667 +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7573,
    "auth_name": "EPSG",
    "auth_id": "7573",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29133,
    "description": "NAD83(2011) / WISCRS Rock (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.9444444444444 +lon_0=-89.0722222222222 +k=1.0000337311 +x_0=146304.2926 +y_0=0.0068 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7570,
    "auth_name": "EPSG",
    "auth_id": "7570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29134,
    "description": "NAD83(2011) / WISCRS Rusk (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.9194444444444 +lon_0=-91.0666666666667 +k=1.0000495976 +x_0=250546.1013 +y_0=0.0234 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7571,
    "auth_name": "EPSG",
    "auth_id": "7571",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29135,
    "description": "NAD83(2011) / WISCRS Price (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5555555555556 +lon_0=-90.4888888888889 +k=1.0000649554 +x_0=227990.8546 +y_0=0.0109 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7568,
    "auth_name": "EPSG",
    "auth_id": "7568",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29136,
    "description": "NAD83(2011) / WISCRS Richland (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.4305555555556 +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7569,
    "auth_name": "EPSG",
    "auth_id": "7569",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29137,
    "description": "NAD83(2011) / WISCRS Polk (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.6611111111111 +lon_0=-92.6333333333333 +k=1.0000433849 +x_0=141732.2823 +y_0=0.0059 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7566,
    "auth_name": "EPSG",
    "auth_id": "7566",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29138,
    "description": "NAD83(2011) / WISCRS Portage (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.4168239752778 +lat_0=44.4168239752778 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7567,
    "auth_name": "EPSG",
    "auth_id": "7567",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29139,
    "description": "NAD83(2011) / WISCRS Oneida (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.7042237702778 +lat_0=45.7042237702778 +lon_0=-89.5444444444444 +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7564,
    "auth_name": "EPSG",
    "auth_id": "7564",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29140,
    "description": "NAD83(2011) / WISCRS Pepin and Pierce (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7565,
    "auth_name": "EPSG",
    "auth_id": "7565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29141,
    "description": "NAD83(2011) / WISCRS Monroe (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.0000739286111 +lat_0=44.0000739286111 +lon_0=-90.6416666666667 +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7562,
    "auth_name": "EPSG",
    "auth_id": "7562",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29142,
    "description": "NAD83(2011) / WISCRS Oconto (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.3972222222222 +lon_0=-87.9083333333333 +k=1.0000236869 +x_0=182880.3676 +y_0=0.0033 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7563,
    "auth_name": "EPSG",
    "auth_id": "7563",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29143,
    "description": "NAD83(2011) / WISCRS Marinette (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.6916666666667 +lon_0=-87.7111111111111 +k=1.0000234982 +x_0=238658.8794 +y_0=0.0032 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7560,
    "auth_name": "EPSG",
    "auth_id": "7560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29144,
    "description": "NAD83(2011) / WISCRS Menominee (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.7166666666667 +lon_0=-88.4166666666667 +k=1.0000362499 +x_0=105461.0121 +y_0=0.0029 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7561,
    "auth_name": "EPSG",
    "auth_id": "7561",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29145,
    "description": "NAD83(2011) / WISCRS Lincoln (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.8444444444444 +lon_0=-89.7333333333333 +k=1.0000599003 +x_0=116129.0323 +y_0=0.0058 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7558,
    "auth_name": "EPSG",
    "auth_id": "7558",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29146,
    "description": "NAD83(2011) / WISCRS Marathon (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.9009044236111 +lat_0=44.9009044236111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7559,
    "auth_name": "EPSG",
    "auth_id": "7559",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29147,
    "description": "NAD83(2011) / WISCRS La Crosse (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4511111111111 +lon_0=-91.3166666666667 +k=1.0000319985 +x_0=130454.6598 +y_0=0.0033 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7556,
    "auth_name": "EPSG",
    "auth_id": "7556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29148,
    "description": "NAD83(2011) / WISCRS Langlade (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.1542371052778 +lat_0=45.1542371052778 +lon_0=-89.0333333333333 +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7557,
    "auth_name": "EPSG",
    "auth_id": "7557",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29149,
    "description": "NAD83(2011) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444444 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7554,
    "auth_name": "EPSG",
    "auth_id": "7554",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29150,
    "description": "NAD83(2011) / WISCRS Kewaunee, Manitowoc and Sheboygan (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7555,
    "auth_name": "EPSG",
    "auth_id": "7555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29151,
    "description": "NAD83(2011) / WISCRS Iron (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.4333333333333 +lon_0=-90.2555555555556 +k=1.0000677153 +x_0=220980.4419 +y_0=0.0085 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7552,
    "auth_name": "EPSG",
    "auth_id": "7552",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29152,
    "description": "NAD83(2011) / WISCRS Jackson (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.2533351277778 +lon_0=-90.8442965194444 +k=1.0000353 +x_0=27000 +y_0=25000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7553,
    "auth_name": "EPSG",
    "auth_id": "7553",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29153,
    "description": "PZ-90.11",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "",
    "parameters": "+proj=geocent +a=6378136 +rf=298.257839303 +units=m +no_defs",
    "srid": 7679,
    "auth_name": "EPSG",
    "auth_id": "7679",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29154,
    "description": "PZ-90.02",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "",
    "parameters": "+proj=geocent +a=6378136 +rf=298.257839303 +units=m +no_defs",
    "srid": 7677,
    "auth_name": "EPSG",
    "auth_id": "7677",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29155,
    "description": "WGS 84 (G1762)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 7664,
    "auth_name": "EPSG",
    "auth_id": "7664",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29156,
    "description": "WGS 84 (G1674)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 7662,
    "auth_name": "EPSG",
    "auth_id": "7662",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29157,
    "description": "WGS 84 (G1150)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 7660,
    "auth_name": "EPSG",
    "auth_id": "7660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29158,
    "description": "WGS 84 (G873)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 7658,
    "auth_name": "EPSG",
    "auth_id": "7658",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29159,
    "description": "WGS 84 (G730)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 7656,
    "auth_name": "EPSG",
    "auth_id": "7656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29160,
    "description": "NAD83(2011) / WISCRS Waushara (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.1139440458333 +lat_0=44.1139440458333 +lon_0=-89.2416666666667 +k_0=1.0000392096 +x_0=120091.44018288 +y_0=45069.7588011176 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7644,
    "auth_name": "EPSG",
    "auth_id": "7644",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29161,
    "description": "NAD83(2011) / WISCRS Wood (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.3625954694444 +lat_0=44.3625954694444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.617272035 +y_0=134589.753924308 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7645,
    "auth_name": "EPSG",
    "auth_id": "7645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29162,
    "description": "NAD83(2011) / WISCRS Waukesha (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5694444444444 +lon_0=-88.225 +k=1.0000346179 +x_0=208788.417881636 +y_0=0.00335280670561341 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7642,
    "auth_name": "EPSG",
    "auth_id": "7642",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29163,
    "description": "NAD83(2011) / WISCRS Waupaca (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4202777777778 +lon_0=-88.8166666666667 +k=1.0000333645 +x_0=185013.970942342 +y_0=0.00701041402082804 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7643,
    "auth_name": "EPSG",
    "auth_id": "7643",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29164,
    "description": "NAD83(2011) / WISCRS Washburn (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.9612198333333 +lat_0=45.9612198333333 +lon_0=-91.7833333333333 +k_0=1.0000475376 +x_0=234086.868173736 +y_0=188358.605943612 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7640,
    "auth_name": "EPSG",
    "auth_id": "7640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29165,
    "description": "NAD83(2011) / WISCRS Washington (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.9180555555556 +lon_0=-88.0638888888889 +k=1.00003738 +x_0=120091.441402083 +y_0=0.00304800609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7641,
    "auth_name": "EPSG",
    "auth_id": "7641",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29166,
    "description": "NAD83(2011) / WISCRS Vilas (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.0778440905556 +lat_0=46.0778440905556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.068834138 +y_0=50337.1092710185 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7638,
    "auth_name": "EPSG",
    "auth_id": "7638",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29167,
    "description": "NAD83(2011) / WISCRS Walworth (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6694620969444 +lat_0=42.6694620969444 +lon_0=-88.5416666666667 +k_0=1.0000367192 +x_0=232562.86512573 +y_0=111088.222402845 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7639,
    "auth_name": "EPSG",
    "auth_id": "7639",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29168,
    "description": "NAD83(2011) / WISCRS Trempealeau (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.1611111111111 +lon_0=-91.3666666666667 +k=1.0000361538 +x_0=256946.913893828 +y_0=0.00396240792481585 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7636,
    "auth_name": "EPSG",
    "auth_id": "7636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29169,
    "description": "NAD83(2011) / WISCRS Vernon (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.5750329397222 +lat_0=43.5750329397222 +lon_0=-90.7833333333333 +k_0=1.0000408158 +x_0=222504.44500889 +y_0=47532.0603505207 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7637,
    "auth_name": "EPSG",
    "auth_id": "7637",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29170,
    "description": "NAD83(2011) / WISCRS St. Croix (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-92.6333333333333 +k=1.0000381803 +x_0=165506.73009906 +y_0=0.0103632207264415 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7634,
    "auth_name": "EPSG",
    "auth_id": "7634",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29171,
    "description": "NAD83(2011) / WISCRS Taylor (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.1778220858333 +lat_0=45.1778220858333 +lon_0=-90.4833333333333 +k_0=1.0000597566 +x_0=187147.574295149 +y_0=107746.752146304 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7635,
    "auth_name": "EPSG",
    "auth_id": "7635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29172,
    "description": "NAD83(2011) / WISCRS Sawyer (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.9000991313889 +lat_0=45.9000991313889 +lon_0=-91.1166666666667 +k_0=1.0000573461 +x_0=216713.233731268 +y_0=120734.163169926 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7632,
    "auth_name": "EPSG",
    "auth_id": "7632",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29173,
    "description": "NAD83(2011) / WISCRS Shawano (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.0361111111111 +lon_0=-88.6055555555556 +k=1.000032144 +x_0=262433.32517145 +y_0=0.0094488188976378 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7633,
    "auth_name": "EPSG",
    "auth_id": "7633",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29174,
    "description": "NAD83(2011) / WISCRS Rusk (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.9194444444444 +lon_0=-91.0666666666667 +k=1.0000495976 +x_0=250546.101397003 +y_0=0.0234696469392939 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7630,
    "auth_name": "EPSG",
    "auth_id": "7630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29175,
    "description": "NAD83(2011) / WISCRS Sauk (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8194444444444 +lon_0=-89.9 +k=1.0000373868 +x_0=185623.571551943 +y_0=0.00518161036322073 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7631,
    "auth_name": "EPSG",
    "auth_id": "7631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29176,
    "description": "NAD83(2011) / WISCRS Richland (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.3223129275 +lat_0=43.3223129275 +lon_0=-90.4305555555556 +k_0=1.0000375653 +x_0=202387.60477521 +y_0=134255.425450851 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7628,
    "auth_name": "EPSG",
    "auth_id": "7628",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29177,
    "description": "NAD83(2011) / WISCRS Rock (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.9444444444444 +lon_0=-89.0722222222222 +k=1.0000337311 +x_0=146304.292608585 +y_0=0.00670561341122682 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7629,
    "auth_name": "EPSG",
    "auth_id": "7629",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29178,
    "description": "NAD83(2011) / WISCRS Portage (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.4168239752778 +lat_0=44.4168239752778 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1127762256 +y_0=50022.1874523749 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7626,
    "auth_name": "EPSG",
    "auth_id": "7626",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29179,
    "description": "NAD83(2011) / WISCRS Price (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.5555555555556 +lon_0=-90.4888888888889 +k=1.0000649554 +x_0=227990.854457709 +y_0=0.0109728219456439 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7627,
    "auth_name": "EPSG",
    "auth_id": "7627",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29180,
    "description": "NAD83(2011) / WISCRS Pepin and Pierce (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.335280671 +y_0=86033.0877317755 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7624,
    "auth_name": "EPSG",
    "auth_id": "7624",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29181,
    "description": "NAD83(2011) / WISCRS Polk (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.6611111111111 +lon_0=-92.6333333333333 +k=1.0000433849 +x_0=141732.282245365 +y_0=0.00579121158242317 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7625,
    "auth_name": "EPSG",
    "auth_id": "7625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29182,
    "description": "NAD83(2011) / WISCRS Oconto (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.3972222222222 +lon_0=-87.9083333333333 +k=1.0000236869 +x_0=182880.367589535 +y_0=0.00335280670561341 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7622,
    "auth_name": "EPSG",
    "auth_id": "7622",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29183,
    "description": "NAD83(2011) / WISCRS Oneida (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.7042237702778 +lat_0=45.7042237702778 +lon_0=-89.5444444444444 +k_0=1.0000686968 +x_0=70104.1402082804 +y_0=57588.0347472695 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7623,
    "auth_name": "EPSG",
    "auth_id": "7623",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29184,
    "description": "NAD83(2011) / WISCRS Menominee (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.7166666666667 +lon_0=-88.4166666666667 +k=1.0000362499 +x_0=105461.012141224 +y_0=0.00304800609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7620,
    "auth_name": "EPSG",
    "auth_id": "7620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29185,
    "description": "NAD83(2011) / WISCRS Monroe (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.0000739286111 +lat_0=44.0000739286111 +lon_0=-90.6416666666667 +k_0=1.0000434122 +x_0=204521.209042418 +y_0=121923.986182372 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7621,
    "auth_name": "EPSG",
    "auth_id": "7621",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29186,
    "description": "NAD83(2011) / WISCRS Marathon (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.9009044236111 +lat_0=44.9009044236111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493522987 +y_0=55049.2669545339 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7618,
    "auth_name": "EPSG",
    "auth_id": "7618",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29187,
    "description": "NAD83(2011) / WISCRS Marinette (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.6916666666667 +lon_0=-87.7111111111111 +k=1.0000234982 +x_0=238658.879451359 +y_0=0.00304800609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7619,
    "auth_name": "EPSG",
    "auth_id": "7619",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29188,
    "description": "NAD83(2011) / WISCRS Langlade (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.1542371052778 +lat_0=45.1542371052778 +lon_0=-89.0333333333333 +k_0=1.0000627024 +x_0=198425.196850394 +y_0=105279.782880366 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7616,
    "auth_name": "EPSG",
    "auth_id": "7616",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29189,
    "description": "NAD83(2011) / WISCRS Lincoln (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.8444444444444 +lon_0=-89.7333333333333 +k=1.0000599003 +x_0=116129.032258065 +y_0=0.00579121158242317 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7617,
    "auth_name": "EPSG",
    "auth_id": "7617",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29190,
    "description": "NAD83(2011) / InGCS Elkhart-Kosciusko-Wabash (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.65 +lon_0=-85.85 +k=1.000033 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7294,
    "auth_name": "EPSG",
    "auth_id": "7294",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29191,
    "description": "NAD83(2011) / InGCS Fayette-Franklin-Union (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7295,
    "auth_name": "EPSG",
    "auth_id": "7295",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29192,
    "description": "NAD83(2011) / InGCS Dubois-Martin (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7292,
    "auth_name": "EPSG",
    "auth_id": "7292",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29193,
    "description": "NAD83(2011) / InGCS Elkhart-Kosciusko-Wabash (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.65 +lon_0=-85.85 +k=1.000033 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7293,
    "auth_name": "EPSG",
    "auth_id": "7293",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29194,
    "description": "NAD83(2011) / InGCS DeKalb (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7290,
    "auth_name": "EPSG",
    "auth_id": "7290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29195,
    "description": "NAD83(2011) / InGCS Dubois-Martin (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7291,
    "auth_name": "EPSG",
    "auth_id": "7291",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29196,
    "description": "NAD83(2011) / InGCS Decatur-Rush (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.1 +lon_0=-85.65 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7288,
    "auth_name": "EPSG",
    "auth_id": "7288",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29197,
    "description": "NAD83(2011) / InGCS DeKalb (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7289,
    "auth_name": "EPSG",
    "auth_id": "7289",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29198,
    "description": "NAD83(2011) / InGCS Dearborn-Ohio-Switzerland (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.65 +lon_0=-84.9 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7286,
    "auth_name": "EPSG",
    "auth_id": "7286",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29199,
    "description": "NAD83(2011) / InGCS Decatur-Rush (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.1 +lon_0=-85.65 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7287,
    "auth_name": "EPSG",
    "auth_id": "7287",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29200,
    "description": "NAD83(2011) / InGCS Daviess-Greene (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.45 +lon_0=-87.1 +k=1.000018 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7284,
    "auth_name": "EPSG",
    "auth_id": "7284",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29201,
    "description": "NAD83(2011) / InGCS Dearborn-Ohio-Switzerland (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.65 +lon_0=-84.9 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7285,
    "auth_name": "EPSG",
    "auth_id": "7285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29202,
    "description": "NAD83(2011) / InGCS Crawford-Lawrence-Orange (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7282,
    "auth_name": "EPSG",
    "auth_id": "7282",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29203,
    "description": "NAD83(2011) / InGCS Daviess-Greene (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.45 +lon_0=-87.1 +k=1.000018 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7283,
    "auth_name": "EPSG",
    "auth_id": "7283",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29204,
    "description": "NAD83(2011) / InGCS Clinton (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.15 +lon_0=-86.6 +k=1.000032 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7280,
    "auth_name": "EPSG",
    "auth_id": "7280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29205,
    "description": "NAD83(2011) / InGCS Crawford-Lawrence-Orange (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7281,
    "auth_name": "EPSG",
    "auth_id": "7281",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29206,
    "description": "NAD83(2011) / InGCS Clay (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.15 +lon_0=-87.15 +k=1.000024 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7278,
    "auth_name": "EPSG",
    "auth_id": "7278",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29207,
    "description": "NAD83(2011) / InGCS Clinton (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.15 +lon_0=-86.6 +k=1.000032 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7279,
    "auth_name": "EPSG",
    "auth_id": "7279",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29208,
    "description": "NAD83(2011) / InGCS Clark-Floyd-Scott (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.15 +lon_0=-85.6 +k=1.000021 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7276,
    "auth_name": "EPSG",
    "auth_id": "7276",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29209,
    "description": "NAD83(2011) / InGCS Clay (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.15 +lon_0=-87.15 +k=1.000024 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7277,
    "auth_name": "EPSG",
    "auth_id": "7277",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29210,
    "description": "NAD83(2011) / InGCS Cass (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.55 +lon_0=-86.4 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7274,
    "auth_name": "EPSG",
    "auth_id": "7274",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29211,
    "description": "NAD83(2011) / InGCS Clark-Floyd-Scott (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.15 +lon_0=-85.6 +k=1.000021 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7275,
    "auth_name": "EPSG",
    "auth_id": "7275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29212,
    "description": "NAD83(2011) / InGCS Carroll (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.4 +lon_0=-86.65 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7272,
    "auth_name": "EPSG",
    "auth_id": "7272",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29213,
    "description": "NAD83(2011) / InGCS Cass (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.55 +lon_0=-86.4 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7273,
    "auth_name": "EPSG",
    "auth_id": "7273",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29214,
    "description": "NAD83(2011) / InGCS Brown (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7270,
    "auth_name": "EPSG",
    "auth_id": "7270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29215,
    "description": "NAD83(2011) / InGCS Carroll (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.4 +lon_0=-86.65 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7271,
    "auth_name": "EPSG",
    "auth_id": "7271",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29216,
    "description": "NAD83(2011) / InGCS Boone-Hendricks (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7268,
    "auth_name": "EPSG",
    "auth_id": "7268",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29217,
    "description": "NAD83(2011) / InGCS Brown (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7269,
    "auth_name": "EPSG",
    "auth_id": "7269",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29218,
    "description": "NAD83(2011) / InGCS Blackford-Delaware (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.05 +lon_0=-85.4 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7266,
    "auth_name": "EPSG",
    "auth_id": "7266",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29219,
    "description": "NAD83(2011) / InGCS Boone-Hendricks (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7267,
    "auth_name": "EPSG",
    "auth_id": "7267",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29220,
    "description": "NAD83(2011) / InGCS Benton (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7264,
    "auth_name": "EPSG",
    "auth_id": "7264",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29221,
    "description": "NAD83(2011) / InGCS Blackford-Delaware (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.05 +lon_0=-85.4 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7265,
    "auth_name": "EPSG",
    "auth_id": "7265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29222,
    "description": "NAD83(2011) / InGCS Bartholomew (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39 +lon_0=-85.85 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7262,
    "auth_name": "EPSG",
    "auth_id": "7262",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29223,
    "description": "NAD83(2011) / InGCS Benton (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7263,
    "auth_name": "EPSG",
    "auth_id": "7263",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29224,
    "description": "NAD83(2011) / InGCS Allen (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7260,
    "auth_name": "EPSG",
    "auth_id": "7260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29225,
    "description": "NAD83(2011) / InGCS Bartholomew (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39 +lon_0=-85.85 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7261,
    "auth_name": "EPSG",
    "auth_id": "7261",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29226,
    "description": "NAD83(2011) / InGCS Adams (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7258,
    "auth_name": "EPSG",
    "auth_id": "7258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29227,
    "description": "NAD83(2011) / InGCS Allen (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7259,
    "auth_name": "EPSG",
    "auth_id": "7259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29228,
    "description": "NAD83(2011) / InGCS Adams (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7257,
    "auth_name": "EPSG",
    "auth_id": "7257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29229,
    "description": "NAD83(2011) / InGCS Spencer (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k=1.000014 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7358,
    "auth_name": "EPSG",
    "auth_id": "7358",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29230,
    "description": "NAD83(2011) / InGCS Steuben (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k=1.000041 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7359,
    "auth_name": "EPSG",
    "auth_id": "7359",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29231,
    "description": "NAD83(2011) / InGCS Shelby (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.3 +lon_0=-85.9 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7356,
    "auth_name": "EPSG",
    "auth_id": "7356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29232,
    "description": "NAD83(2011) / InGCS Spencer (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k=1.000014 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7357,
    "auth_name": "EPSG",
    "auth_id": "7357",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29233,
    "description": "NAD83(2011) / InGCS Ripley (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7354,
    "auth_name": "EPSG",
    "auth_id": "7354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29234,
    "description": "NAD83(2011) / InGCS Shelby (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.3 +lon_0=-85.9 +k=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7355,
    "auth_name": "EPSG",
    "auth_id": "7355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29235,
    "description": "NAD83(2011) / InGCS Randolph-Wayne (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k=1.000044 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7352,
    "auth_name": "EPSG",
    "auth_id": "7352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29236,
    "description": "NAD83(2011) / InGCS Ripley (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7353,
    "auth_name": "EPSG",
    "auth_id": "7353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29237,
    "description": "NAD83(2011) / InGCS Posey (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7350,
    "auth_name": "EPSG",
    "auth_id": "7350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29238,
    "description": "NAD83(2011) / InGCS Randolph-Wayne (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k=1.000044 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7351,
    "auth_name": "EPSG",
    "auth_id": "7351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29239,
    "description": "NAD83(2011) / InGCS Pike-Warrick (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7348,
    "auth_name": "EPSG",
    "auth_id": "7348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29240,
    "description": "NAD83(2011) / InGCS Posey (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7349,
    "auth_name": "EPSG",
    "auth_id": "7349",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29241,
    "description": "NAD83(2011) / InGCS Perry (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7346,
    "auth_name": "EPSG",
    "auth_id": "7346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29242,
    "description": "NAD83(2011) / InGCS Pike-Warrick (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7347,
    "auth_name": "EPSG",
    "auth_id": "7347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29243,
    "description": "NAD83(2011) / InGCS Parke-Vermillion (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.6 +lon_0=-87.35 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7344,
    "auth_name": "EPSG",
    "auth_id": "7344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29244,
    "description": "NAD83(2011) / InGCS Perry (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7345,
    "auth_name": "EPSG",
    "auth_id": "7345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29245,
    "description": "NAD83(2011) / InGCS Owen (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.15 +lon_0=-86.9 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7342,
    "auth_name": "EPSG",
    "auth_id": "7342",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29246,
    "description": "NAD83(2011) / InGCS Parke-Vermillion (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.6 +lon_0=-87.35 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7343,
    "auth_name": "EPSG",
    "auth_id": "7343",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29247,
    "description": "NAD83(2011) / InGCS Montgomery-Putnam (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7340,
    "auth_name": "EPSG",
    "auth_id": "7340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29248,
    "description": "NAD83(2011) / InGCS Owen (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.15 +lon_0=-86.9 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7341,
    "auth_name": "EPSG",
    "auth_id": "7341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29249,
    "description": "NAD83(2011) / InGCS Monroe-Morgan (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7338,
    "auth_name": "EPSG",
    "auth_id": "7338",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29250,
    "description": "NAD83(2011) / InGCS Montgomery-Putnam (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7339,
    "auth_name": "EPSG",
    "auth_id": "7339",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29251,
    "description": "NAD83(2011) / InGCS LaPorte-Pulaski-Starke (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7336,
    "auth_name": "EPSG",
    "auth_id": "7336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29252,
    "description": "NAD83(2011) / InGCS Monroe-Morgan (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7337,
    "auth_name": "EPSG",
    "auth_id": "7337",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29253,
    "description": "NAD83(2011) / InGCS Lake-Newton (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.7 +lon_0=-87.4 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7334,
    "auth_name": "EPSG",
    "auth_id": "7334",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29254,
    "description": "NAD83(2011) / InGCS LaPorte-Pulaski-Starke (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7335,
    "auth_name": "EPSG",
    "auth_id": "7335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29255,
    "description": "NAD83(2011) / InGCS LaGrange-Noble (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k=1.000037 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7332,
    "auth_name": "EPSG",
    "auth_id": "7332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29256,
    "description": "NAD83(2011) / InGCS Lake-Newton (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.7 +lon_0=-87.4 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7333,
    "auth_name": "EPSG",
    "auth_id": "7333",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29257,
    "description": "NAD83(2011) / InGCS Knox (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7330,
    "auth_name": "EPSG",
    "auth_id": "7330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29258,
    "description": "NAD83(2011) / InGCS LaGrange-Noble (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k=1.000037 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7331,
    "auth_name": "EPSG",
    "auth_id": "7331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29259,
    "description": "NAD83(2011) / InGCS Johnson-Marion (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.3 +lon_0=-86.15 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7328,
    "auth_name": "EPSG",
    "auth_id": "7328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29260,
    "description": "NAD83(2011) / InGCS Knox (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7329,
    "auth_name": "EPSG",
    "auth_id": "7329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29261,
    "description": "NAD83(2011) / InGCS Jennings (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7326,
    "auth_name": "EPSG",
    "auth_id": "7326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29262,
    "description": "NAD83(2011) / InGCS Johnson-Marion (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.3 +lon_0=-86.15 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7327,
    "auth_name": "EPSG",
    "auth_id": "7327",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29263,
    "description": "NAD83(2011) / InGCS Jefferson (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.55 +lon_0=-85.35 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7324,
    "auth_name": "EPSG",
    "auth_id": "7324",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29264,
    "description": "NAD83(2011) / InGCS Jennings (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7325,
    "auth_name": "EPSG",
    "auth_id": "7325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29265,
    "description": "NAD83(2011) / InGCS Jay (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7322,
    "auth_name": "EPSG",
    "auth_id": "7322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29266,
    "description": "NAD83(2011) / InGCS Jefferson (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.55 +lon_0=-85.35 +k=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7323,
    "auth_name": "EPSG",
    "auth_id": "7323",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29267,
    "description": "NAD83(2011) / InGCS Jasper-Porter (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.7 +lon_0=-87.1 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7320,
    "auth_name": "EPSG",
    "auth_id": "7320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29268,
    "description": "NAD83(2011) / InGCS Jay (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7321,
    "auth_name": "EPSG",
    "auth_id": "7321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29269,
    "description": "NAD83(2011) / InGCS Jackson (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7318,
    "auth_name": "EPSG",
    "auth_id": "7318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29270,
    "description": "NAD83(2011) / InGCS Jasper-Porter (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.7 +lon_0=-87.1 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7319,
    "auth_name": "EPSG",
    "auth_id": "7319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29271,
    "description": "NAD83(2011) / InGCS Huntington-Whitley (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7316,
    "auth_name": "EPSG",
    "auth_id": "7316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29272,
    "description": "NAD83(2011) / InGCS Jackson (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7317,
    "auth_name": "EPSG",
    "auth_id": "7317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29273,
    "description": "NAD83(2011) / InGCS Howard-Miami (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.35 +lon_0=-86.15 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7314,
    "auth_name": "EPSG",
    "auth_id": "7314",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29274,
    "description": "NAD83(2011) / InGCS Huntington-Whitley (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7315,
    "auth_name": "EPSG",
    "auth_id": "7315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29275,
    "description": "NAD83(2011) / InGCS Henry (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k=1.000043 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7312,
    "auth_name": "EPSG",
    "auth_id": "7312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29276,
    "description": "NAD83(2011) / InGCS Howard-Miami (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.35 +lon_0=-86.15 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7313,
    "auth_name": "EPSG",
    "auth_id": "7313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29277,
    "description": "NAD83(2011) / InGCS Harrison-Washington (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.95 +lon_0=-86.15 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7310,
    "auth_name": "EPSG",
    "auth_id": "7310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29278,
    "description": "NAD83(2011) / InGCS Henry (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k=1.000043 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7311,
    "auth_name": "EPSG",
    "auth_id": "7311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29279,
    "description": "NAD83(2011) / InGCS Hancock-Madison (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7308,
    "auth_name": "EPSG",
    "auth_id": "7308",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29280,
    "description": "NAD83(2011) / InGCS Harrison-Washington (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.95 +lon_0=-86.15 +k=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7309,
    "auth_name": "EPSG",
    "auth_id": "7309",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29281,
    "description": "NAD83(2011) / InGCS Hamilton-Tipton (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7306,
    "auth_name": "EPSG",
    "auth_id": "7306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29282,
    "description": "NAD83(2011) / InGCS Hancock-Madison (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7307,
    "auth_name": "EPSG",
    "auth_id": "7307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29283,
    "description": "NAD83(2011) / InGCS Grant (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7304,
    "auth_name": "EPSG",
    "auth_id": "7304",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29284,
    "description": "NAD83(2011) / InGCS Hamilton-Tipton (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7305,
    "auth_name": "EPSG",
    "auth_id": "7305",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29285,
    "description": "NAD83(2011) / InGCS Gibson (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.15 +lon_0=-87.65 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7302,
    "auth_name": "EPSG",
    "auth_id": "7302",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29286,
    "description": "NAD83(2011) / InGCS Grant (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7303,
    "auth_name": "EPSG",
    "auth_id": "7303",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29287,
    "description": "NAD83(2011) / InGCS Fulton-Marshall-St. Joseph (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7300,
    "auth_name": "EPSG",
    "auth_id": "7300",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29288,
    "description": "NAD83(2011) / InGCS Gibson (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.15 +lon_0=-87.65 +k=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7301,
    "auth_name": "EPSG",
    "auth_id": "7301",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29289,
    "description": "NAD83(2011) / InGCS Fountain-Warren (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7298,
    "auth_name": "EPSG",
    "auth_id": "7298",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29290,
    "description": "NAD83(2011) / InGCS Fulton-Marshall-St. Joseph (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7299,
    "auth_name": "EPSG",
    "auth_id": "7299",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29291,
    "description": "NAD83(2011) / InGCS Fayette-Franklin-Union (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7296,
    "auth_name": "EPSG",
    "auth_id": "7296",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29292,
    "description": "NAD83(2011) / InGCS Fountain-Warren (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7297,
    "auth_name": "EPSG",
    "auth_id": "7297",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29293,
    "description": "ONGD14 / UTM zone 41N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=41 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7376,
    "auth_name": "EPSG",
    "auth_id": "7376",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29294,
    "description": "ONGD14 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7374,
    "auth_name": "EPSG",
    "auth_id": "7374",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29295,
    "description": "ONGD14 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=40 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7375,
    "auth_name": "EPSG",
    "auth_id": "7375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29296,
    "description": "ONGD14",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 7373,
    "auth_name": "EPSG",
    "auth_id": "7373",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29297,
    "description": "NAD83(2011) / InGCS Wells (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7370,
    "auth_name": "EPSG",
    "auth_id": "7370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29298,
    "description": "ONGD14",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=0.819,-0.5762,-1.6446,-0.00378,-0.03317,0.00318,0.0693 +units=m +no_defs",
    "srid": 7371,
    "auth_name": "EPSG",
    "auth_id": "7371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29299,
    "description": "NAD83(2011) / InGCS Vigo (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7368,
    "auth_name": "EPSG",
    "auth_id": "7368",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29300,
    "description": "NAD83(2011) / InGCS Wells (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7369,
    "auth_name": "EPSG",
    "auth_id": "7369",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29301,
    "description": "NAD83(2011) / InGCS Vanderburgh (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7366,
    "auth_name": "EPSG",
    "auth_id": "7366",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29302,
    "description": "NAD83(2011) / InGCS Vigo (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7367,
    "auth_name": "EPSG",
    "auth_id": "7367",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29303,
    "description": "NAD83(2011) / InGCS Tippecanoe-White (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.2 +lon_0=-86.9 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7364,
    "auth_name": "EPSG",
    "auth_id": "7364",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29304,
    "description": "NAD83(2011) / InGCS Vanderburgh (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7365,
    "auth_name": "EPSG",
    "auth_id": "7365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29305,
    "description": "NAD83(2011) / InGCS Sullivan (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k=1.000017 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7362,
    "auth_name": "EPSG",
    "auth_id": "7362",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29306,
    "description": "NAD83(2011) / InGCS Tippecanoe-White (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.2 +lon_0=-86.9 +k=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7363,
    "auth_name": "EPSG",
    "auth_id": "7363",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29307,
    "description": "NAD83(2011) / InGCS Steuben (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k=1.000041 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 7360,
    "auth_name": "EPSG",
    "auth_id": "7360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29308,
    "description": "NAD83(2011) / InGCS Sullivan (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k=1.000017 +x_0=240000 +y_0=36000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 7361,
    "auth_name": "EPSG",
    "auth_id": "7361",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29309,
    "description": "Kertau 1968 / Kelantan Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=5.89392222222222 +lon_0=102.177291666667 +x_0=0 +y_0=0 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 4398,
    "auth_name": "EPSG",
    "auth_id": "4398",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29310,
    "description": "Kertau 1968 / Kedah and Perlis Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=5.96514722222222 +lon_0=100.637594444444 +x_0=0 +y_0=0 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 4396,
    "auth_name": "EPSG",
    "auth_id": "4396",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29311,
    "description": "Kertau 1968 / Perak Revised Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=4.85938055555556 +lon_0=100.816766666667 +x_0=0 +y_0=133453.669 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 4397,
    "auth_name": "EPSG",
    "auth_id": "4397",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29312,
    "description": "Kertau 1968 / Terengganu Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=4.94614166666667 +lon_0=102.895208333333 +x_0=0 +y_0=0 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 4394,
    "auth_name": "EPSG",
    "auth_id": "4394",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29313,
    "description": "Kertau 1968 / Pinang Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=5.421325 +lon_0=100.345869444444 +x_0=0 +y_0=0 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 4395,
    "auth_name": "EPSG",
    "auth_id": "4395",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29314,
    "description": "Kertau 1968 / Pahang Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=3.71097222222222 +lon_0=102.436177777778 +x_0=0 +y_0=0 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 4392,
    "auth_name": "EPSG",
    "auth_id": "4392",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29315,
    "description": "Kertau 1968 / Selangor Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=3.68034444444444 +lon_0=101.508244444444 +x_0=-21759.438 +y_0=55960.906 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 4393,
    "auth_name": "EPSG",
    "auth_id": "4393",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29316,
    "description": "Kertau 1968 / Johor Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=2.04258333333333 +lon_0=103.562758333333 +x_0=0 +y_0=0 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 4390,
    "auth_name": "EPSG",
    "auth_id": "4390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29317,
    "description": "Kertau 1968 / Sembilan and Melaka Grid",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=cass +lat_0=2.71228333333333 +lon_0=101.941166666667 +x_0=-242.005 +y_0=-948.547 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 4391,
    "auth_name": "EPSG",
    "auth_id": "4391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29318,
    "description": "ETRS89 / NTM zone 10 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=10.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5950,
    "auth_name": "EPSG",
    "auth_id": "5950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29319,
    "description": "ETRS89 / NTM zone 11 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=11.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5951,
    "auth_name": "EPSG",
    "auth_id": "5951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29320,
    "description": "ETRS89 / NTM zone 8 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=8.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5948,
    "auth_name": "EPSG",
    "auth_id": "5948",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29321,
    "description": "ETRS89 / NTM zone 9 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=9.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5949,
    "auth_name": "EPSG",
    "auth_id": "5949",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29322,
    "description": "ETRS89 / NTM zone 6 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=6.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5946,
    "auth_name": "EPSG",
    "auth_id": "5946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29323,
    "description": "ETRS89 / NTM zone 7 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=7.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5947,
    "auth_name": "EPSG",
    "auth_id": "5947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29324,
    "description": "ETRS89 / NTM zone 5 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=5.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5945,
    "auth_name": "EPSG",
    "auth_id": "5945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29325,
    "description": "ETRS89 + NN2000 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5942,
    "auth_name": "EPSG",
    "auth_id": "5942",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29326,
    "description": "WGS 84 / EPSG Russia Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lon_0=105 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs",
    "srid": 5940,
    "auth_name": "EPSG",
    "auth_id": "5940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29327,
    "description": "WGS 84 / EPSG Greenland Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lon_0=-33 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs",
    "srid": 5938,
    "auth_name": "EPSG",
    "auth_id": "5938",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29328,
    "description": "WGS 84 / EPSG Norway Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lon_0=18 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs",
    "srid": 5939,
    "auth_name": "EPSG",
    "auth_id": "5939",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29329,
    "description": "WGS 84 / EPSG Alaska Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lon_0=-150 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs",
    "srid": 5936,
    "auth_name": "EPSG",
    "auth_id": "5936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29330,
    "description": "WGS 84 / EPSG Canada Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=stere +lat_0=90 +lon_0=-100 +k=0.994 +x_0=2000000 +y_0=2000000 +datum=WGS84 +units=m +no_defs",
    "srid": 5937,
    "auth_name": "EPSG",
    "auth_id": "5937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29331,
    "description": "WGS 84 / EPSG Arctic Regional zone C4",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=65.1012708888889 +lon_0=105 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5934,
    "auth_name": "EPSG",
    "auth_id": "5934",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29332,
    "description": "WGS 84 / EPSG Arctic Regional zone C5",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=65.1012708888889 +lon_0=177 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5935,
    "auth_name": "EPSG",
    "auth_id": "5935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29333,
    "description": "WGS 84 / EPSG Arctic Regional zone C2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=65.1012708888889 +lon_0=-39 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5932,
    "auth_name": "EPSG",
    "auth_id": "5932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29334,
    "description": "WGS 84 / EPSG Arctic Regional zone C3",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=65.1012708888889 +lon_0=33 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5933,
    "auth_name": "EPSG",
    "auth_id": "5933",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29335,
    "description": "WGS 84 / EPSG Arctic Regional zone B5",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=73.1557408611111 +lon_0=177 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5930,
    "auth_name": "EPSG",
    "auth_id": "5930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29336,
    "description": "WGS 84 / EPSG Arctic Regional zone C1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=65.1012708888889 +lon_0=-111 +lat_1=69 +lat_2=61 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5931,
    "auth_name": "EPSG",
    "auth_id": "5931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29337,
    "description": "WGS 84 / EPSG Arctic Regional zone B3",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=73.1557408611111 +lon_0=33 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5928,
    "auth_name": "EPSG",
    "auth_id": "5928",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29338,
    "description": "WGS 84 / EPSG Arctic Regional zone B4",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=73.1557408611111 +lon_0=105 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5929,
    "auth_name": "EPSG",
    "auth_id": "5929",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29339,
    "description": "WGS 84 / EPSG Arctic Regional zone B1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=73.1557408611111 +lon_0=-111 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5926,
    "auth_name": "EPSG",
    "auth_id": "5926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29340,
    "description": "WGS 84 / EPSG Arctic Regional zone B2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=73.1557408611111 +lon_0=-39 +lat_1=77 +lat_2=69 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5927,
    "auth_name": "EPSG",
    "auth_id": "5927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29341,
    "description": "WGS 84 / EPSG Arctic Regional zone A4",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=81.317226 +lon_0=105 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5924,
    "auth_name": "EPSG",
    "auth_id": "5924",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29342,
    "description": "WGS 84 / EPSG Arctic Regional zone A5",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=81.317226 +lon_0=177 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5925,
    "auth_name": "EPSG",
    "auth_id": "5925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29343,
    "description": "WGS 84 / EPSG Arctic Regional zone A2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=81.317226 +lon_0=-39 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5922,
    "auth_name": "EPSG",
    "auth_id": "5922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29344,
    "description": "WGS 84 / EPSG Arctic Regional zone A3",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=81.317226 +lon_0=33 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5923,
    "auth_name": "EPSG",
    "auth_id": "5923",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29345,
    "description": "WGS 84 / EPSG Arctic Regional zone A1",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=81.317226 +lon_0=-111 +lat_1=85 +lat_2=77 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 5921,
    "auth_name": "EPSG",
    "auth_id": "5921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29347,
    "description": "ETRS89 / UTM zone 36N + NN2000 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5976,
    "auth_name": "EPSG",
    "auth_id": "5976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29348,
    "description": "ETRS89 / UTM zone 34N + NN2000 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5974,
    "auth_name": "EPSG",
    "auth_id": "5974",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29349,
    "description": "ETRS89 / UTM zone 35N + NN2000 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5975,
    "auth_name": "EPSG",
    "auth_id": "5975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29350,
    "description": "ETRS89 / UTM zone 32N + NN2000 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5972,
    "auth_name": "EPSG",
    "auth_id": "5972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29351,
    "description": "ETRS89 / UTM zone 33N + NN2000 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5973,
    "auth_name": "EPSG",
    "auth_id": "5973",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29352,
    "description": "ETRS89 / NTM zone 30 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=30.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5970,
    "auth_name": "EPSG",
    "auth_id": "5970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29353,
    "description": "ETRS89 / UTM zone 31N + NN2000 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5971,
    "auth_name": "EPSG",
    "auth_id": "5971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29354,
    "description": "ETRS89 / NTM zone 28 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=28.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5968,
    "auth_name": "EPSG",
    "auth_id": "5968",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29355,
    "description": "ETRS89 / NTM zone 29 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=29.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5969,
    "auth_name": "EPSG",
    "auth_id": "5969",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29356,
    "description": "ETRS89 / NTM zone 26 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=26.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5966,
    "auth_name": "EPSG",
    "auth_id": "5966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29357,
    "description": "ETRS89 / NTM zone 27 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=27.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5967,
    "auth_name": "EPSG",
    "auth_id": "5967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29358,
    "description": "ETRS89 / NTM zone 24 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=24.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5964,
    "auth_name": "EPSG",
    "auth_id": "5964",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29359,
    "description": "ETRS89 / NTM zone 25 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=25.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5965,
    "auth_name": "EPSG",
    "auth_id": "5965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29360,
    "description": "ETRS89 / NTM zone 22 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=22.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5962,
    "auth_name": "EPSG",
    "auth_id": "5962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29361,
    "description": "ETRS89 / NTM zone 23 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=23.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5963,
    "auth_name": "EPSG",
    "auth_id": "5963",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29362,
    "description": "ETRS89 / NTM zone 20 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=20.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5960,
    "auth_name": "EPSG",
    "auth_id": "5960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29363,
    "description": "ETRS89 / NTM zone 21 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=21.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5961,
    "auth_name": "EPSG",
    "auth_id": "5961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29364,
    "description": "ETRS89 / NTM zone 18 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=18.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5958,
    "auth_name": "EPSG",
    "auth_id": "5958",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29365,
    "description": "ETRS89 / NTM zone 19 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=19.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5959,
    "auth_name": "EPSG",
    "auth_id": "5959",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29366,
    "description": "ETRS89 / NTM zone 16 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=16.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5956,
    "auth_name": "EPSG",
    "auth_id": "5956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29367,
    "description": "ETRS89 / NTM zone 17 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=17.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5957,
    "auth_name": "EPSG",
    "auth_id": "5957",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29368,
    "description": "ETRS89 / NTM zone 14 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=14.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5954,
    "auth_name": "EPSG",
    "auth_id": "5954",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29369,
    "description": "ETRS89 / NTM zone 15 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=15.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5955,
    "auth_name": "EPSG",
    "auth_id": "5955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29370,
    "description": "ETRS89 / NTM zone 12 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=12.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5952,
    "auth_name": "EPSG",
    "auth_id": "5952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29371,
    "description": "ETRS89 / NTM zone 13 + NN2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=13.5 +k=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=no_kv_HREF2018B_NN2000_EUREF89.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5953,
    "auth_name": "EPSG",
    "auth_id": "5953",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29372,
    "description": "WGS 84 / EPSG Arctic zone 3-15",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=83 +lat_1=80.3333333333333 +lat_2=77 +x_0=15500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6078,
    "auth_name": "EPSG",
    "auth_id": "6078",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29373,
    "description": "WGS 84 / EPSG Arctic zone 3-17",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=114 +lat_1=80.3333333333333 +lat_2=77 +x_0=17500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6079,
    "auth_name": "EPSG",
    "auth_id": "6079",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29374,
    "description": "WGS 84 / EPSG Arctic zone 2-26",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=93 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=26500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6076,
    "auth_name": "EPSG",
    "auth_id": "6076",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29375,
    "description": "WGS 84 / EPSG Arctic zone 3-13",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=52 +lat_1=80.3333333333333 +lat_2=77 +x_0=13500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6077,
    "auth_name": "EPSG",
    "auth_id": "6077",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29376,
    "description": "ETRS89 / EPSG Arctic zone 5-13",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=34 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=13500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6074,
    "auth_name": "EPSG",
    "auth_id": "6074",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29377,
    "description": "WGS 84 / EPSG Arctic zone 2-24",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=53 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=24500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6075,
    "auth_name": "EPSG",
    "auth_id": "6075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29378,
    "description": "ETRS89 / EPSG Arctic zone 4-28",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=34 +lat_1=77 +lat_2=73.6666666666667 +x_0=28500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6072,
    "auth_name": "EPSG",
    "auth_id": "6072",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29379,
    "description": "ETRS89 / EPSG Arctic zone 5-11",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=14 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=11500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6073,
    "auth_name": "EPSG",
    "auth_id": "6073",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29380,
    "description": "ETRS89 / EPSG Arctic zone 3-11",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=21 +lat_1=80.3333333333333 +lat_2=77 +x_0=11500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6070,
    "auth_name": "EPSG",
    "auth_id": "6070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29381,
    "description": "ETRS89 / EPSG Arctic zone 4-26",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=10 +lat_1=77 +lat_2=73.6666666666667 +x_0=26500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6071,
    "auth_name": "EPSG",
    "auth_id": "6071",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29382,
    "description": "GR96 / EPSG Arctic zone 8-22",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=62.0153068888889 +lon_0=-37 +lat_1=63.6666666666667 +lat_2=60.3333333333333 +x_0=22500000 +y_0=8500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6068,
    "auth_name": "EPSG",
    "auth_id": "6068",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29383,
    "description": "ETRS89 / EPSG Arctic zone 2-22",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=16 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=22500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6069,
    "auth_name": "EPSG",
    "auth_id": "6069",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29384,
    "description": "GR96 / EPSG Arctic zone 7-13",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=65.3510393055555 +lon_0=-34 +lat_1=67 +lat_2=63.6666666666667 +x_0=13500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6066,
    "auth_name": "EPSG",
    "auth_id": "6066",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29385,
    "description": "GR96 / EPSG Arctic zone 8-20",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=62.0153068888889 +lon_0=-52 +lat_1=63.6666666666667 +lat_2=60.3333333333333 +x_0=20500000 +y_0=8500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6067,
    "auth_name": "EPSG",
    "auth_id": "6067",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29386,
    "description": "GR96 / EPSG Arctic zone 6-30",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-20 +lat_1=70.3333333333333 +lat_2=67 +x_0=30500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6064,
    "auth_name": "EPSG",
    "auth_id": "6064",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29387,
    "description": "GR96 / EPSG Arctic zone 7-11",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=65.3510393055555 +lon_0=-51 +lat_1=67 +lat_2=63.6666666666667 +x_0=11500000 +y_0=7500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6065,
    "auth_name": "EPSG",
    "auth_id": "6065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29388,
    "description": "GR96 / EPSG Arctic zone 6-26",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-56 +lat_1=70.3333333333333 +lat_2=67 +x_0=26500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6062,
    "auth_name": "EPSG",
    "auth_id": "6062",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29389,
    "description": "GR96 / EPSG Arctic zone 6-28",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-38 +lat_1=70.3333333333333 +lat_2=67 +x_0=28500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6063,
    "auth_name": "EPSG",
    "auth_id": "6063",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29390,
    "description": "GR96 / EPSG Arctic zone 5-43",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-42 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=43500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6060,
    "auth_name": "EPSG",
    "auth_id": "6060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29391,
    "description": "GR96 / EPSG Arctic zone 5-45",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-22 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=45500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6061,
    "auth_name": "EPSG",
    "auth_id": "6061",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29392,
    "description": "GR96 / EPSG Arctic zone 4-24",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=-14 +lat_1=77 +lat_2=73.6666666666667 +x_0=24500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6058,
    "auth_name": "EPSG",
    "auth_id": "6058",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29393,
    "description": "GR96 / EPSG Arctic zone 5-41",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-62 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=41500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6059,
    "auth_name": "EPSG",
    "auth_id": "6059",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29394,
    "description": "GR96 / EPSG Arctic zone 4-20",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=-64 +lat_1=77 +lat_2=73.6666666666667 +x_0=20500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6056,
    "auth_name": "EPSG",
    "auth_id": "6056",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29395,
    "description": "GR96 / EPSG Arctic zone 4-22",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=-39 +lat_1=77 +lat_2=73.6666666666667 +x_0=22500000 +y_0=4500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6057,
    "auth_name": "EPSG",
    "auth_id": "6057",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29396,
    "description": "GR96 / EPSG Arctic zone 3-31",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=-39 +lat_1=80.3333333333333 +lat_2=77 +x_0=31500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6054,
    "auth_name": "EPSG",
    "auth_id": "6054",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29397,
    "description": "GR96 / EPSG Arctic zone 3-33",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=-10 +lat_1=80.3333333333333 +lat_2=77 +x_0=33500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6055,
    "auth_name": "EPSG",
    "auth_id": "6055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29398,
    "description": "GR96 / EPSG Arctic zone 2-20",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=-12 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=20500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6052,
    "auth_name": "EPSG",
    "auth_id": "6052",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29399,
    "description": "GR96 / EPSG Arctic zone 3-29",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=-69 +lat_1=80.3333333333333 +lat_2=77 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6053,
    "auth_name": "EPSG",
    "auth_id": "6053",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29400,
    "description": "GR96 / EPSG Arctic zone 1-25",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=85.4371183333333 +lon_0=-30 +lat_1=87 +lat_2=83.6666666666667 +x_0=25500000 +y_0=1500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6050,
    "auth_name": "EPSG",
    "auth_id": "6050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29401,
    "description": "GR96 / EPSG Arctic zone 2-18",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=-52 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=18500000 +y_0=2500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6051,
    "auth_name": "EPSG",
    "auth_id": "6051",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29403,
    "description": "CIGD11",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 6135,
    "auth_name": "EPSG",
    "auth_id": "6135",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29404,
    "description": "CIGD11",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 6133,
    "auth_name": "EPSG",
    "auth_id": "6133",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29405,
    "description": "Grand Cayman National Grid 1959",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=499999.999998 +y_0=0 +ellps=clrk66 +units=ft +no_defs",
    "srid": 6128,
    "auth_name": "EPSG",
    "auth_id": "6128",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29406,
    "description": "Sister Islands National Grid 1961",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9996 +x_0=499999.999998 +y_0=0 +ellps=clrk66 +units=ft +no_defs",
    "srid": 6129,
    "auth_name": "EPSG",
    "auth_id": "6129",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29407,
    "description": "WGS 84 / EPSG Arctic zone 4-12",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=-155 +lat_1=77 +lat_2=73.6666666666667 +x_0=12500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6124,
    "auth_name": "EPSG",
    "auth_id": "6124",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29408,
    "description": "ETRS89 / EPSG Arctic zone 5-47",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-5 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=47500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6125,
    "auth_name": "EPSG",
    "auth_id": "6125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29409,
    "description": "WGS 84 / EPSG Arctic zone 3-21",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=176 +lat_1=80.3333333333333 +lat_2=77 +x_0=21500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6122,
    "auth_name": "EPSG",
    "auth_id": "6122",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29410,
    "description": "WGS 84 / EPSG Arctic zone 3-23",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=-153 +lat_1=80.3333333333333 +lat_2=77 +x_0=23500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6123,
    "auth_name": "EPSG",
    "auth_id": "6123",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29411,
    "description": "WGS 84 / EPSG Arctic zone 2-10",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=166 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=10500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6120,
    "auth_name": "EPSG",
    "auth_id": "6120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29412,
    "description": "WGS 84 / EPSG Arctic zone 2-12",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=-154 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=12500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6121,
    "auth_name": "EPSG",
    "auth_id": "6121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29413,
    "description": "WGS 84 / EPSG Arctic zone 1-21",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=85.4371183333333 +lon_0=-150 +lat_1=87 +lat_2=83.6666666666667 +x_0=21500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6118,
    "auth_name": "EPSG",
    "auth_id": "6118",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29414,
    "description": "WGS 84 / EPSG Arctic zone 2-28",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=133 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=28500000 +y_0=2500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6119,
    "auth_name": "EPSG",
    "auth_id": "6119",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29415,
    "description": "WGS 84 / EPSG Arctic zone 1-29",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=85.4371183333333 +lon_0=90 +lat_1=87 +lat_2=83.6666666666667 +x_0=29500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6116,
    "auth_name": "EPSG",
    "auth_id": "6116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29416,
    "description": "WGS 84 / EPSG Arctic zone 1-31",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=85.4371183333333 +lon_0=150 +lat_1=87 +lat_2=83.6666666666667 +x_0=31500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6117,
    "auth_name": "EPSG",
    "auth_id": "6117",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29417,
    "description": "NAD83(CSRS) / EPSG Arctic zone 6-24",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-75 +lat_1=70.3333333333333 +lat_2=67 +x_0=24500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6114,
    "auth_name": "EPSG",
    "auth_id": "6114",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29418,
    "description": "WGS 84 / EPSG Arctic zone 1-27",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=85.4371183333333 +lon_0=30 +lat_1=87 +lat_2=83.6666666666667 +x_0=27500000 +y_0=1500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6115,
    "auth_name": "EPSG",
    "auth_id": "6115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29419,
    "description": "NAD83(CSRS) / EPSG Arctic zone 6-20",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-113 +lat_1=70.3333333333333 +lat_2=67 +x_0=20500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6112,
    "auth_name": "EPSG",
    "auth_id": "6112",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29420,
    "description": "NAD83(CSRS) / EPSG Arctic zone 6-22",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-94 +lat_1=70.3333333333333 +lat_2=67 +x_0=22500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6113,
    "auth_name": "EPSG",
    "auth_id": "6113",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29421,
    "description": "NAD83(CSRS) / EPSG Arctic zone 5-39",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-71 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=39500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6110,
    "auth_name": "EPSG",
    "auth_id": "6110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29422,
    "description": "NAD83(CSRS) / EPSG Arctic zone 6-18",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-132 +lat_1=70.3333333333333 +lat_2=67 +x_0=18500000 +y_0=6500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6111,
    "auth_name": "EPSG",
    "auth_id": "6111",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29423,
    "description": "NAD83(CSRS) / EPSG Arctic zone 5-35",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-111 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=35500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6108,
    "auth_name": "EPSG",
    "auth_id": "6108",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29424,
    "description": "NAD83(CSRS) / EPSG Arctic zone 5-37",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-91 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=37500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6109,
    "auth_name": "EPSG",
    "auth_id": "6109",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29425,
    "description": "NAD83(CSRS) / EPSG Arctic zone 4-18",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=-79 +lat_1=77 +lat_2=73.6666666666667 +x_0=18500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6106,
    "auth_name": "EPSG",
    "auth_id": "6106",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29426,
    "description": "NAD83(CSRS) / EPSG Arctic zone 5-33",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-131 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=33500000 +y_0=5500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6107,
    "auth_name": "EPSG",
    "auth_id": "6107",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29427,
    "description": "NAD83(CSRS) / EPSG Arctic zone 4-14",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=-129 +lat_1=77 +lat_2=73.6666666666667 +x_0=14500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6104,
    "auth_name": "EPSG",
    "auth_id": "6104",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29428,
    "description": "NAD83(CSRS) / EPSG Arctic zone 4-16",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=-104 +lat_1=77 +lat_2=73.6666666666667 +x_0=16500000 +y_0=4500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6105,
    "auth_name": "EPSG",
    "auth_id": "6105",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29429,
    "description": "NAD83(CSRS) / EPSG Arctic zone 3-27",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=-99 +lat_1=80.3333333333333 +lat_2=77 +x_0=27500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6102,
    "auth_name": "EPSG",
    "auth_id": "6102",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29430,
    "description": "NAD83(CSRS) / EPSG Arctic zone 3-29",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=-69 +lat_1=80.3333333333333 +lat_2=77 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6103,
    "auth_name": "EPSG",
    "auth_id": "6103",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29431,
    "description": "NAD83(CSRS) / EPSG Arctic zone 2-16",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=-75 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=16500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6100,
    "auth_name": "EPSG",
    "auth_id": "6100",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29432,
    "description": "NAD83(CSRS) / EPSG Arctic zone 3-25",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=-129 +lat_1=80.3333333333333 +lat_2=77 +x_0=25500000 +y_0=3500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6101,
    "auth_name": "EPSG",
    "auth_id": "6101",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29433,
    "description": "NAD83(CSRS) / EPSG Arctic zone 1-23",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=85.4371183333333 +lon_0=-90 +lat_1=87 +lat_2=83.6666666666667 +x_0=23500000 +y_0=1500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6098,
    "auth_name": "EPSG",
    "auth_id": "6098",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29434,
    "description": "NAD83(CSRS) / EPSG Arctic zone 2-14",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=82.0584248888889 +lon_0=-115 +lat_1=83.6666666666667 +lat_2=80.3333333333333 +x_0=14500000 +y_0=2500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 6099,
    "auth_name": "EPSG",
    "auth_id": "6099",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29435,
    "description": "NAD83(NSRS2007) / EPSG Arctic zone 6-14",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-165 +lat_1=70.3333333333333 +lat_2=67 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6096,
    "auth_name": "EPSG",
    "auth_id": "6096",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29436,
    "description": "NAD83(NSRS2007) / EPSG Arctic zone 6-16",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=68.6874755555556 +lon_0=-147 +lat_1=70.3333333333333 +lat_2=67 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6097,
    "auth_name": "EPSG",
    "auth_id": "6097",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29437,
    "description": "NAD83(NSRS2007) / EPSG Arctic zone 5-29",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-163 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6094,
    "auth_name": "EPSG",
    "auth_id": "6094",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29438,
    "description": "NAD83(NSRS2007) / EPSG Arctic zone 5-31",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=-147 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 6095,
    "auth_name": "EPSG",
    "auth_id": "6095",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29439,
    "description": "WGS 84 / EPSG Arctic zone 5-25",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=158 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=25500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6092,
    "auth_name": "EPSG",
    "auth_id": "6092",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29440,
    "description": "WGS 84 / EPSG Arctic zone 5-27",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=179 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=27500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6093,
    "auth_name": "EPSG",
    "auth_id": "6093",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29441,
    "description": "WGS 84 / EPSG Arctic zone 5-21",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=116 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=21500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6090,
    "auth_name": "EPSG",
    "auth_id": "6090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29442,
    "description": "WGS 84 / EPSG Arctic zone 5-23",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=137 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=23500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6091,
    "auth_name": "EPSG",
    "auth_id": "6091",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29443,
    "description": "WGS 84 / EPSG Arctic zone 5-17",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=74 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=17500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6088,
    "auth_name": "EPSG",
    "auth_id": "6088",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29444,
    "description": "WGS 84 / EPSG Arctic zone 5-19",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=95 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=19500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6089,
    "auth_name": "EPSG",
    "auth_id": "6089",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29445,
    "description": "WGS 84 / EPSG Arctic zone 4-40",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=179 +lat_1=77 +lat_2=73.6666666666667 +x_0=40500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6086,
    "auth_name": "EPSG",
    "auth_id": "6086",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29446,
    "description": "WGS 84 / EPSG Arctic zone 5-15",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=72.0250091944445 +lon_0=54 +lat_1=73.6666666666667 +lat_2=70.3333333333333 +x_0=15500000 +y_0=5500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6087,
    "auth_name": "EPSG",
    "auth_id": "6087",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29447,
    "description": "WGS 84 / EPSG Arctic zone 4-36",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=130 +lat_1=77 +lat_2=73.6666666666667 +x_0=36500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6084,
    "auth_name": "EPSG",
    "auth_id": "6084",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29448,
    "description": "WGS 84 / EPSG Arctic zone 4-38",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=154 +lat_1=77 +lat_2=73.6666666666667 +x_0=38500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6085,
    "auth_name": "EPSG",
    "auth_id": "6085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29449,
    "description": "WGS 84 / EPSG Arctic zone 4-32",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=82 +lat_1=77 +lat_2=73.6666666666667 +x_0=32500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6082,
    "auth_name": "EPSG",
    "auth_id": "6082",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29450,
    "description": "WGS 84 / EPSG Arctic zone 4-34",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=106 +lat_1=77 +lat_2=73.6666666666667 +x_0=34500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6083,
    "auth_name": "EPSG",
    "auth_id": "6083",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29451,
    "description": "WGS 84 / EPSG Arctic zone 3-19",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=78.7073375277778 +lon_0=145 +lat_1=80.3333333333333 +lat_2=77 +x_0=19500000 +y_0=3500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6080,
    "auth_name": "EPSG",
    "auth_id": "6080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29452,
    "description": "WGS 84 / EPSG Arctic zone 4-30",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=75.3644033055556 +lon_0=58 +lat_1=77 +lat_2=73.6666666666667 +x_0=30500000 +y_0=4500000 +datum=WGS84 +units=m +no_defs",
    "srid": 6081,
    "auth_name": "EPSG",
    "auth_id": "6081",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29453,
    "description": "DB_REF / 3-degree Gauss-Kruger zone 4 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5684,
    "auth_name": "EPSG",
    "auth_id": "5684",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29454,
    "description": "DB_REF / 3-degree Gauss-Kruger zone 5 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5685,
    "auth_name": "EPSG",
    "auth_id": "5685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29455,
    "description": "DB_REF / 3-degree Gauss-Kruger zone 2 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5682,
    "auth_name": "EPSG",
    "auth_id": "5682",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29456,
    "description": "DB_REF / 3-degree Gauss-Kruger zone 3 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5683,
    "auth_name": "EPSG",
    "auth_id": "5683",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29457,
    "description": "DHDN / 3-degree Gauss-Kruger zone 1 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5680,
    "auth_name": "EPSG",
    "auth_id": "5680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29458,
    "description": "DB_REF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 5681,
    "auth_name": "EPSG",
    "auth_id": "5681",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29459,
    "description": "DHDN / 3-degree Gauss-Kruger zone 4 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 5678,
    "auth_name": "EPSG",
    "auth_id": "5678",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29460,
    "description": "DHDN / 3-degree Gauss-Kruger zone 5 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 5679,
    "auth_name": "EPSG",
    "auth_id": "5679",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29461,
    "description": "DHDN / 3-degree Gauss-Kruger zone 2 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 5676,
    "auth_name": "EPSG",
    "auth_id": "5676",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29462,
    "description": "DHDN / 3-degree Gauss-Kruger zone 3 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 5677,
    "auth_name": "EPSG",
    "auth_id": "5677",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29463,
    "description": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 4 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5674,
    "auth_name": "EPSG",
    "auth_id": "5674",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29464,
    "description": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 5 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5675,
    "auth_name": "EPSG",
    "auth_id": "5675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29465,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 5 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5672,
    "auth_name": "EPSG",
    "auth_id": "5672",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29466,
    "description": "Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 3 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +towgs84=24,-123,-94,0.02,-0.25,-0.13,1.1 +units=m +no_defs",
    "srid": 5673,
    "auth_name": "EPSG",
    "auth_id": "5673",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29467,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 3 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5670,
    "auth_name": "EPSG",
    "auth_id": "5670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29468,
    "description": "Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 4 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5671,
    "auth_name": "EPSG",
    "auth_id": "5671",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29469,
    "description": "RD/83 / 3-degree Gauss-Kruger zone 4 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5668,
    "auth_name": "EPSG",
    "auth_id": "5668",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29470,
    "description": "RD/83 / 3-degree Gauss-Kruger zone 5 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5669,
    "auth_name": "EPSG",
    "auth_id": "5669",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29471,
    "description": "PD/83 / 3-degree Gauss-Kruger zone 3 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5666,
    "auth_name": "EPSG",
    "auth_id": "5666",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29472,
    "description": "PD/83 / 3-degree Gauss-Kruger zone 4 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 5667,
    "auth_name": "EPSG",
    "auth_id": "5667",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29473,
    "description": "Pulkovo 1942(83) / Gauss-Kruger zone 2 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +towgs84=24,-123,-94,0.02,-0.25,-0.13,1.1 +units=m +no_defs",
    "srid": 5664,
    "auth_name": "EPSG",
    "auth_id": "5664",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29474,
    "description": "Pulkovo 1942(83) / Gauss-Kruger zone 3 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5665,
    "auth_name": "EPSG",
    "auth_id": "5665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29475,
    "description": "Pulkovo 1942(58) / Gauss-Kruger zone 3 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=3500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5663,
    "auth_name": "EPSG",
    "auth_id": "5663",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29476,
    "description": "Monte Mario / TM Emilia-Romagna",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=500053 +y_0=-3999820 +ellps=intl +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68 +units=m +no_defs",
    "srid": 5659,
    "auth_name": "EPSG",
    "auth_id": "5659",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29477,
    "description": "NAD83(HARN) / Vermont (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 5654,
    "auth_name": "EPSG",
    "auth_id": "5654",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29478,
    "description": "NAD83(NSRS2007) / Vermont (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 5655,
    "auth_name": "EPSG",
    "auth_id": "5655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29479,
    "description": "ETRS89 / UTM zone 32N (N-zE)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5652,
    "auth_name": "EPSG",
    "auth_id": "5652",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29480,
    "description": "ETRS89 / UTM zone 33N (N-zE)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5653,
    "auth_name": "EPSG",
    "auth_id": "5653",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29481,
    "description": "ETRS89 / UTM zone 33N (zE-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5650,
    "auth_name": "EPSG",
    "auth_id": "5650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29482,
    "description": "ETRS89 / UTM zone 31N (N-zE)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5651,
    "auth_name": "EPSG",
    "auth_id": "5651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29483,
    "description": "ETRS89 / UTM zone 31N (zE-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5649,
    "auth_name": "EPSG",
    "auth_id": "5649",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29484,
    "description": "NAD83 / Vermont (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 5646,
    "auth_name": "EPSG",
    "auth_id": "5646",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29485,
    "description": "RGR92 / UTM zone 39S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=39 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5644,
    "auth_name": "EPSG",
    "auth_id": "5644",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29486,
    "description": "ED50 / SPBA LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=48 +lon_0=10 +lat_1=52.6666666666667 +lat_2=54.3333333333333 +x_0=815000 +y_0=0 +ellps=intl +towgs84=-87,-98,-121,0,0,0,0 +units=m +no_defs",
    "srid": 5643,
    "auth_name": "EPSG",
    "auth_id": "5643",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29487,
    "description": "SIRGAS 2000 / Brazil Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=merc +lat_ts=-2 +lon_0=-43 +x_0=5000000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5641,
    "auth_name": "EPSG",
    "auth_id": "5641",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29488,
    "description": "ISN2004 / LAEA Europe",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5638,
    "auth_name": "EPSG",
    "auth_id": "5638",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29489,
    "description": "ISN2004 / LCC Europe",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5639,
    "auth_name": "EPSG",
    "auth_id": "5639",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29490,
    "description": "TUREF / LAEA Europe",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5636,
    "auth_name": "EPSG",
    "auth_id": "5636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29491,
    "description": "TUREF / LCC Europe",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5637,
    "auth_name": "EPSG",
    "auth_id": "5637",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29492,
    "description": "REGCAN95 / LCC Europe",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5634,
    "auth_name": "EPSG",
    "auth_id": "5634",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29493,
    "description": "REGCAN95 / LAEA Europe",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5635,
    "auth_name": "EPSG",
    "auth_id": "5635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29494,
    "description": "PTRA08 / LCC Europe",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5632,
    "auth_name": "EPSG",
    "auth_id": "5632",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29495,
    "description": "PTRA08 / LAEA Europe",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5633,
    "auth_name": "EPSG",
    "auth_id": "5633",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29496,
    "description": "NTF (Paris) / Lambert zone IV + NGF-IGN78 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5708,
    "auth_name": "EPSG",
    "auth_id": "5708",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29497,
    "description": "NTF (Paris) / Lambert zone I + NGF-IGN69 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5707,
    "auth_name": "EPSG",
    "auth_id": "5707",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29498,
    "description": "NZGD2000 / UTM zone 1S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=1 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5700,
    "auth_name": "EPSG",
    "auth_id": "5700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29499,
    "description": "RGF93 v1 / Lambert-93 + NGF-IGN69 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5698,
    "auth_name": "EPSG",
    "auth_id": "5698",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29500,
    "description": "RGF93 v1 / Lambert-93 + NGF-IGN78 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 5699,
    "auth_name": "EPSG",
    "auth_id": "5699",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29501,
    "description": "TGD2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5886,
    "auth_name": "EPSG",
    "auth_id": "5886",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29502,
    "description": "TGD2005 / Tonga Map Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=0.9996 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5887,
    "auth_name": "EPSG",
    "auth_id": "5887",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29503,
    "description": "TGD2005",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5884,
    "auth_name": "EPSG",
    "auth_id": "5884",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29504,
    "description": "SIRGAS 2000 / Brazil Polyconic",
    "projection_acronym": "poly",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=poly +lat_0=0 +lon_0=-54 +x_0=5000000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5880,
    "auth_name": "EPSG",
    "auth_id": "5880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29505,
    "description": "Cadastre 1997 / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-381.788,-57.501,-256.673,0,0,0,0 +units=m +no_defs",
    "srid": 5879,
    "auth_name": "EPSG",
    "auth_id": "5879",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29506,
    "description": "SAD69(96) / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=19 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs",
    "srid": 5876,
    "auth_name": "EPSG",
    "auth_id": "5876",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29507,
    "description": "SAD69(96) / UTM zone 20S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=20 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs",
    "srid": 5877,
    "auth_name": "EPSG",
    "auth_id": "5877",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29508,
    "description": "SAD69(96) / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=18 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs",
    "srid": 5875,
    "auth_name": "EPSG",
    "auth_id": "5875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29509,
    "description": "SAD69(96) / UTM zone 22S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=utm +zone=22 +south +ellps=aust_SA +towgs84=-67.35,3.88,-38.22,0,0,0,0 +units=m +no_defs",
    "srid": 5858,
    "auth_name": "EPSG",
    "auth_id": "5858",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29510,
    "description": "SWEREF99 21 45 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5856,
    "auth_name": "EPSG",
    "auth_id": "5856",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29511,
    "description": "SWEREF99 23 15 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5857,
    "auth_name": "EPSG",
    "auth_id": "5857",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29512,
    "description": "SWEREF99 18 45 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5854,
    "auth_name": "EPSG",
    "auth_id": "5854",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29513,
    "description": "SWEREF99 20 15 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=20.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5855,
    "auth_name": "EPSG",
    "auth_id": "5855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29514,
    "description": "SWEREF99 15 45 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15.75 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5852,
    "auth_name": "EPSG",
    "auth_id": "5852",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29515,
    "description": "SWEREF99 17 15 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=17.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5853,
    "auth_name": "EPSG",
    "auth_id": "5853",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29516,
    "description": "SWEREF99 18 00 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5850,
    "auth_name": "EPSG",
    "auth_id": "5850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29517,
    "description": "SWEREF99 14 15 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=14.25 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5851,
    "auth_name": "EPSG",
    "auth_id": "5851",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29518,
    "description": "SWEREF99 15 00 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5848,
    "auth_name": "EPSG",
    "auth_id": "5848",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29519,
    "description": "SWEREF99 16 30 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5849,
    "auth_name": "EPSG",
    "auth_id": "5849",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29520,
    "description": "SWEREF99 12 00 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5846,
    "auth_name": "EPSG",
    "auth_id": "5846",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29521,
    "description": "SWEREF99 13 30 + RH2000 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13.5 +k=1 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5847,
    "auth_name": "EPSG",
    "auth_id": "5847",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29522,
    "description": "RGRDC 2005 / Congo TM zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5844,
    "auth_name": "EPSG",
    "auth_id": "5844",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29523,
    "description": "SWEREF99 TM + RH2000 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5845,
    "auth_name": "EPSG",
    "auth_id": "5845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29524,
    "description": "WGS 84 / TM 12 SE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +datum=WGS84 +units=m +no_defs",
    "srid": 5842,
    "auth_name": "EPSG",
    "auth_id": "5842",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29525,
    "description": "Peru96 / UTM zone 17S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5839,
    "auth_name": "EPSG",
    "auth_id": "5839",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29526,
    "description": "Yemen NGN96 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=37 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5836,
    "auth_name": "EPSG",
    "auth_id": "5836",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29527,
    "description": "Yemen NGN96 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=40 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5837,
    "auth_name": "EPSG",
    "auth_id": "5837",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29532,
    "description": "DB_REF",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=geocent +ellps=bessel +units=m +no_defs",
    "srid": 5828,
    "auth_name": "EPSG",
    "auth_id": "5828",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29533,
    "description": "AGD66 / ACT Standard Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=-35.3177362777778 +lon_0=149.009294830556 +k=1.000086 +x_0=200000 +y_0=600000 +ellps=aust_SA +towgs84=-129.193,-41.212,130.73,0.246,0.374,0.329,-2.955 +units=m +no_defs",
    "srid": 5825,
    "auth_name": "EPSG",
    "auth_id": "5825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29534,
    "description": "SIRGAS_ES2007.8",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5391,
    "auth_name": "EPSG",
    "auth_id": "5391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29535,
    "description": "SIRGAS-ROU98",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 5379,
    "auth_name": "EPSG",
    "auth_id": "5379",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29536,
    "description": "NAD83(NSRS2007) + NAVD88 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 5500,
    "auth_name": "EPSG",
    "auth_id": "5500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29537,
    "description": "NAD83 + NAVD88 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=longlat +datum=NAD83 +vunits=m +no_defs",
    "srid": 5498,
    "auth_name": "EPSG",
    "auth_id": "5498",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29538,
    "description": "NAD83(HARN) + NAVD88 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 5499,
    "auth_name": "EPSG",
    "auth_id": "5499",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29539,
    "description": "RGAF09",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5487,
    "auth_name": "EPSG",
    "auth_id": "5487",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29540,
    "description": "UCS-2000 / Gauss-Kruger CM 21E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5566,
    "auth_name": "EPSG",
    "auth_id": "5566",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29541,
    "description": "UCS-2000 / Gauss-Kruger CM 27E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5567,
    "auth_name": "EPSG",
    "auth_id": "5567",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29542,
    "description": "UCS-2000 / Gauss-Kruger zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5564,
    "auth_name": "EPSG",
    "auth_id": "5564",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29543,
    "description": "UCS-2000 / Gauss-Kruger zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5565,
    "auth_name": "EPSG",
    "auth_id": "5565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29544,
    "description": "UCS-2000 / Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5562,
    "auth_name": "EPSG",
    "auth_id": "5562",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29545,
    "description": "UCS-2000 / Gauss-Kruger zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5563,
    "auth_name": "EPSG",
    "auth_id": "5563",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29546,
    "description": "UCS-2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 5561,
    "auth_name": "EPSG",
    "auth_id": "5561",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29547,
    "description": "UCS-2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=geocent +ellps=krass +units=m +no_defs",
    "srid": 5558,
    "auth_name": "EPSG",
    "auth_id": "5558",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29548,
    "description": "ETRS89 / UTM zone 33N + DHHN92 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5556,
    "auth_name": "EPSG",
    "auth_id": "5556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29549,
    "description": "ETRS89 / UTM zone 31N + DHHN92 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5554,
    "auth_name": "EPSG",
    "auth_id": "5554",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29550,
    "description": "ETRS89 / UTM zone 32N + DHHN92 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5555,
    "auth_name": "EPSG",
    "auth_id": "5555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29551,
    "description": "PNG94",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5544,
    "auth_name": "EPSG",
    "auth_id": "5544",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29552,
    "description": "Pulkovo 1942(58) / Gauss-Kruger zone 2 (E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=2500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5631,
    "auth_name": "EPSG",
    "auth_id": "5631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29553,
    "description": "SWEREF99 + RH2000 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 5628,
    "auth_name": "EPSG",
    "auth_id": "5628",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29554,
    "description": "Moznet / UTM zone 38S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=38 +south +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5629,
    "auth_name": "EPSG",
    "auth_id": "5629",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29555,
    "description": "ED50 / TM 6 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=6 +k=0.9996 +x_0=500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 5627,
    "auth_name": "EPSG",
    "auth_id": "5627",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29556,
    "description": "NAD27 / Michigan Old Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=41.5 +lon_0=-85.75 +k=0.999909091 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 5624,
    "auth_name": "EPSG",
    "auth_id": "5624",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29557,
    "description": "NAD27 / Michigan West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=41.5 +lon_0=-88.75 +k=0.999909091 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 5625,
    "auth_name": "EPSG",
    "auth_id": "5625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29558,
    "description": "NAD27 / Michigan East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=41.5 +lon_0=-83.6666666666667 +k=0.999942857 +x_0=152400.30480061 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 5623,
    "auth_name": "EPSG",
    "auth_id": "5623",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29559,
    "description": "FEH2010 / Fehmarnbelt TM + FCSVR10 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11.3333333333333 +k=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 5598,
    "auth_name": "EPSG",
    "auth_id": "5598",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29560,
    "description": "FEH2010 / Fehmarnbelt TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=11.3333333333333 +k=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 5596,
    "auth_name": "EPSG",
    "auth_id": "5596",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29561,
    "description": "FEH2010",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 5593,
    "auth_name": "EPSG",
    "auth_id": "5593",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29562,
    "description": "FEH2010",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5591,
    "auth_name": "EPSG",
    "auth_id": "5591",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29563,
    "description": "NAD27 / New Brunswick Stereographic (NAD27)",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=304800 +y_0=304800 +datum=NAD27 +units=ft +no_defs",
    "srid": 5588,
    "auth_name": "EPSG",
    "auth_id": "5588",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29564,
    "description": "Sibun Gorge 1922 / Colony Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=17.0612419444444 +lon_0=-88.6318575 +k=1 +x_0=66220.0283308276 +y_0=135779.50998853 +a=6378293.64520876 +b=6356617.98767984 +to_meter=0.3047972654 +no_defs",
    "srid": 5589,
    "auth_name": "EPSG",
    "auth_id": "5589",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29579,
    "description": "UCS-2000 / Gauss-Kruger CM 33E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5568,
    "auth_name": "EPSG",
    "auth_id": "5568",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29580,
    "description": "UCS-2000 / Gauss-Kruger CM 39E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 5569,
    "auth_name": "EPSG",
    "auth_id": "5569",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29581,
    "description": "MACARIO SOLIS",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5368,
    "auth_name": "EPSG",
    "auth_id": "5368",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29582,
    "description": "Peru96",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5369,
    "auth_name": "EPSG",
    "auth_id": "5369",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29583,
    "description": "CR05",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 5363,
    "auth_name": "EPSG",
    "auth_id": "5363",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29584,
    "description": "SIRGAS-Chile 2002",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5358,
    "auth_name": "EPSG",
    "auth_id": "5358",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29585,
    "description": "MARGEN",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5352,
    "auth_name": "EPSG",
    "auth_id": "5352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29586,
    "description": "POSGAR 2007",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 5341,
    "auth_name": "EPSG",
    "auth_id": "5341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29587,
    "description": "ITRF2008",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5332,
    "auth_name": "EPSG",
    "auth_id": "5332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29588,
    "description": "ISN2004",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 5322,
    "auth_name": "EPSG",
    "auth_id": "5322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29589,
    "description": "NAD83(CSRS)v7",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 8255,
    "auth_name": "EPSG",
    "auth_id": "8255",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29590,
    "description": "NAD83(CSRS)v6",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 8252,
    "auth_name": "EPSG",
    "auth_id": "8252",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29591,
    "description": "NAD83(CSRS)v7",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 8253,
    "auth_name": "EPSG",
    "auth_id": "8253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29592,
    "description": "NAD83(CSRS)v6",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 8250,
    "auth_name": "EPSG",
    "auth_id": "8250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29593,
    "description": "NAD83(CSRS)v5",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 8249,
    "auth_name": "EPSG",
    "auth_id": "8249",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29594,
    "description": "NAD83(CSRS)v4",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 8246,
    "auth_name": "EPSG",
    "auth_id": "8246",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29595,
    "description": "NAD83(CSRS)v5",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 8247,
    "auth_name": "EPSG",
    "auth_id": "8247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29596,
    "description": "NAD83(CSRS)v4",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 8242,
    "auth_name": "EPSG",
    "auth_id": "8242",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29597,
    "description": "NAD83(CSRS)v3",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 8240,
    "auth_name": "EPSG",
    "auth_id": "8240",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29598,
    "description": "NAD83(CSRS)v3",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 8238,
    "auth_name": "EPSG",
    "auth_id": "8238",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29599,
    "description": "NAD83(CSRS)v2",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 8237,
    "auth_name": "EPSG",
    "auth_id": "8237",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29600,
    "description": "NAD83(CSRS96)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 8232,
    "auth_name": "EPSG",
    "auth_id": "8232",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 29601,
    "description": "NAD83(CSRS)v2",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 8233,
    "auth_name": "EPSG",
    "auth_id": "8233",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29602,
    "description": "NAD83(CSRS96)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 8230,
    "auth_name": "EPSG",
    "auth_id": "8230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29603,
    "description": "NAD83(HARN) / WISCRS Adams and Juneau (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.694132588 +y_0=0.00365760731521463 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8226,
    "auth_name": "EPSG",
    "auth_id": "8226",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29604,
    "description": "IGS14",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 8227,
    "auth_name": "EPSG",
    "auth_id": "8227",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 29605,
    "description": "NAD83(HARN) / WISCRS Ashland (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.7061111111111 +lon_0=-90.6222222222222 +k=1.0000495683 +x_0=172821.945948692 +y_0=0.00182880365760732 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8224,
    "auth_name": "EPSG",
    "auth_id": "8224",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29606,
    "description": "NAD83(HARN) / WISCRS Adams and Juneau (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +units=m +no_defs",
    "srid": 8225,
    "auth_name": "EPSG",
    "auth_id": "8225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29607,
    "description": "NAD83(HARN) / WISCRS Ashland (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.7061111111111 +lon_0=-90.6222222222222 +k=1.0000495683 +x_0=172821.9461 +y_0=0.0017 +ellps=GRS80 +units=m +no_defs",
    "srid": 8222,
    "auth_name": "EPSG",
    "auth_id": "8222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29608,
    "description": "NAD83(HARN) / WISCRS Barron (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.1333333333333 +lon_0=-91.85 +k=1.0000486665 +x_0=93150 +y_0=0.00304800609601219 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8220,
    "auth_name": "EPSG",
    "auth_id": "8220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29609,
    "description": "NAD83(HARN) / WISCRS Barron (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.1333333333333 +lon_0=-91.85 +k=1.0000486665 +x_0=93150 +y_0=0.0029 +ellps=GRS80 +units=m +no_defs",
    "srid": 8218,
    "auth_name": "EPSG",
    "auth_id": "8218",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29610,
    "description": "NAD83(HARN) / WISCRS Bayfield (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.6696483772222 +lat_0=46.6696483772222 +lon_0=-91.1527777777778 +k_0=1.0000331195 +x_0=228600.457505715 +y_0=148551.483566167 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8216,
    "auth_name": "EPSG",
    "auth_id": "8216",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29611,
    "description": "NAD83(HARN) / WISCRS Bayfield (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.6696483772222 +lat_0=46.6696483772222 +lon_0=-91.1527777777778 +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837 +ellps=GRS80 +units=m +no_defs",
    "srid": 8214,
    "auth_name": "EPSG",
    "auth_id": "8214",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29612,
    "description": "NAD83(HARN) / WISCRS Brown (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31600 +y_0=4600 +ellps=GRS80 +units=m +no_defs",
    "srid": 8212,
    "auth_name": "EPSG",
    "auth_id": "8212",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29613,
    "description": "NAD83(HARN) / WISCRS Brown (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43 +lon_0=-88 +k=1.00002 +x_0=31599.9998983998 +y_0=4599.9998983998 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8213,
    "auth_name": "EPSG",
    "auth_id": "8213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29614,
    "description": "NAD83(HARN) / WISCRS Buffalo (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4813888888889 +lon_0=-91.7972222222222 +k=1.0000382778 +x_0=175260.3502159 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8210,
    "auth_name": "EPSG",
    "auth_id": "8210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29615,
    "description": "NAD83(HARN) / WISCRS Burnett (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.8987148658333 +lat_0=45.8987148658333 +lon_0=-92.4577777777778 +k_0=1.0000383841 +x_0=64008.1277114554 +y_0=59445.9041910084 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8208,
    "auth_name": "EPSG",
    "auth_id": "8208",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29616,
    "description": "NAD83(HARN) / WISCRS Buffalo (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.4813888888889 +lon_0=-91.7972222222222 +k=1.0000382778 +x_0=175260.3502 +y_0=0.0048 +ellps=GRS80 +units=m +no_defs",
    "srid": 8209,
    "auth_name": "EPSG",
    "auth_id": "8209",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29617,
    "description": "NAD83(HARN) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8206,
    "auth_name": "EPSG",
    "auth_id": "8206",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29618,
    "description": "NAD83(HARN) / WISCRS Burnett (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.8987148658333 +lat_0=45.8987148658333 +lon_0=-92.4577777777778 +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043 +ellps=GRS80 +units=m +no_defs",
    "srid": 8207,
    "auth_name": "EPSG",
    "auth_id": "8207",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29619,
    "description": "NAD83(HARN) / WISCRS Chippewa (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.9778568986111 +lat_0=44.9778568986111 +lon_0=-91.2944444444444 +k_0=1.0000391127 +x_0=60045.7200914402 +y_0=44091.434493269 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8204,
    "auth_name": "EPSG",
    "auth_id": "8204",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29620,
    "description": "NAD83(HARN) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444444 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +units=m +no_defs",
    "srid": 8205,
    "auth_name": "EPSG",
    "auth_id": "8205",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29621,
    "description": "NAD83(HARN) / WISCRS Clark (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6 +lon_0=-90.7083333333333 +k=1.0000463003 +x_0=199949.198983998 +y_0=0.00853441706883414 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8202,
    "auth_name": "EPSG",
    "auth_id": "8202",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29622,
    "description": "NAD83(HARN) / WISCRS Chippewa (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.9778568986111 +lat_0=44.9778568986111 +lon_0=-91.2944444444444 +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346 +ellps=GRS80 +units=m +no_defs",
    "srid": 8203,
    "auth_name": "EPSG",
    "auth_id": "8203",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29623,
    "description": "NAD83(HARN) / WISCRS Columbia (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.4625466458333 +lat_0=43.4625466458333 +lon_0=-89.3944444444444 +k_0=1.00003498 +x_0=169164.338023876 +y_0=111569.613512827 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8200,
    "auth_name": "EPSG",
    "auth_id": "8200",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29624,
    "description": "NAD83(HARN) / WISCRS Clark (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6 +lon_0=-90.7083333333333 +k=1.0000463003 +x_0=199949.1989 +y_0=0.0086 +ellps=GRS80 +units=m +no_defs",
    "srid": 8201,
    "auth_name": "EPSG",
    "auth_id": "8201",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29625,
    "description": "NAD83(HARN) / WISCRS Columbia (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.4625466458333 +lat_0=43.4625466458333 +lon_0=-89.3944444444444 +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134 +ellps=GRS80 +units=m +no_defs",
    "srid": 8198,
    "auth_name": "EPSG",
    "auth_id": "8198",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29626,
    "description": "NAD83(HARN) / WISCRS Crawford (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201 +ellps=GRS80 +units=m +no_defs",
    "srid": 8196,
    "auth_name": "EPSG",
    "auth_id": "8196",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29627,
    "description": "NAD83(HARN) / WISCRS Crawford (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.200055605 +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.627381255 +y_0=53703.1202438405 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8197,
    "auth_name": "EPSG",
    "auth_id": "8197",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29628,
    "description": "NAD83(HARN) / WISCRS Dane (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.0695160375 +lat_0=43.0695160375 +lon_0=-89.4222222222222 +k_0=1.0000384786 +x_0=247193.294386589 +y_0=146591.989636779 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 8193,
    "auth_name": "EPSG",
    "auth_id": "8193",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29629,
    "description": "NAD83(2011) / Oregon Dayville-Prairie City zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.25 +lon_0=-119.633333333333 +k=1.00012 +x_0=19999.99999992 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8318,
    "auth_name": "EPSG",
    "auth_id": "8318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29630,
    "description": "NAD83(2011) / Oregon Denio-Burns zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-118.416666666667 +k=1.00019 +x_0=80000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8319,
    "auth_name": "EPSG",
    "auth_id": "8319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29631,
    "description": "NAD83(2011) / Oregon Coast Range North zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.5833333333333 +lat_0=45.5833333333333 +lon_0=-123.416666666667 +k_0=1.000045 +x_0=30000.00001512 +y_0=19999.99999992 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8316,
    "auth_name": "EPSG",
    "auth_id": "8316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29632,
    "description": "NAD83(2011) / Oregon Dayville-Prairie City zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.25 +lon_0=-119.633333333333 +k=1.00012 +x_0=20000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8317,
    "auth_name": "EPSG",
    "auth_id": "8317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29633,
    "description": "NAD83(2011) / Oregon Canyon City-Burns zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.5 +lon_0=-119 +k=1.00022 +x_0=19999.99999992 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8314,
    "auth_name": "EPSG",
    "auth_id": "8314",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29634,
    "description": "NAD83(2011) / Oregon Coast Range North zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.5833333333333 +lat_0=45.5833333333333 +lon_0=-123.416666666667 +k_0=1.000045 +x_0=30000 +y_0=20000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8315,
    "auth_name": "EPSG",
    "auth_id": "8315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29635,
    "description": "NAD83(2011) / Oregon Burns-Harper zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.5 +lon_0=-117.666666666667 +k=1.00014 +x_0=90000.00001488 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8312,
    "auth_name": "EPSG",
    "auth_id": "8312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29636,
    "description": "NAD83(2011) / Oregon Canyon City-Burns zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.5 +lon_0=-119 +k=1.00022 +x_0=20000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8313,
    "auth_name": "EPSG",
    "auth_id": "8313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29637,
    "description": "NAD83(2011) / Oregon Burns-Harper zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.5 +lon_0=-117.666666666667 +k=1.00014 +x_0=90000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8311,
    "auth_name": "EPSG",
    "auth_id": "8311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29638,
    "description": "GR96 + GVR2016 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=dk_sdfe_gvr2016.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 8350,
    "auth_name": "EPSG",
    "auth_id": "8350",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29639,
    "description": "NAD83(2011) / Oregon Willamette Pass zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43 +lon_0=-122 +k=1.000223 +x_0=19999.99999992 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8348,
    "auth_name": "EPSG",
    "auth_id": "8348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29640,
    "description": "GR96 + GVR2000 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=dk_sdfe_gvr2000.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 8349,
    "auth_name": "EPSG",
    "auth_id": "8349",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 29641,
    "description": "NAD83(2011) / Oregon Warner Highway zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.5 +lat_0=42.5 +lon_0=-120 +k_0=1.000245 +x_0=39999.99999984 +y_0=59999.99999976 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8346,
    "auth_name": "EPSG",
    "auth_id": "8346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29642,
    "description": "NAD83(2011) / Oregon Willamette Pass zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43 +lon_0=-122 +k=1.000223 +x_0=20000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8347,
    "auth_name": "EPSG",
    "auth_id": "8347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29643,
    "description": "NAD83(2011) / Oregon Wallowa zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.25 +lon_0=-117.5 +k=1.000195 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8344,
    "auth_name": "EPSG",
    "auth_id": "8344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29644,
    "description": "NAD83(2011) / Oregon Warner Highway zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.5 +lat_0=42.5 +lon_0=-120 +k_0=1.000245 +x_0=40000 +y_0=60000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8345,
    "auth_name": "EPSG",
    "auth_id": "8345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29645,
    "description": "NAD83(2011) / Oregon Ukiah-Fox zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.25 +lat_0=45.25 +lon_0=-119 +k_0=1.00014 +x_0=30000.00001512 +y_0=90000.00001488 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8342,
    "auth_name": "EPSG",
    "auth_id": "8342",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29646,
    "description": "NAD83(2011) / Oregon Wallowa zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.25 +lon_0=-117.5 +k=1.000195 +x_0=60000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8343,
    "auth_name": "EPSG",
    "auth_id": "8343",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29647,
    "description": "NAD83(2011) / Oregon Siskiyou Pass zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.5 +lat_0=42.5 +lon_0=-122.583333333333 +k_0=1.00015 +x_0=10000.0000152 +y_0=59999.99999976 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8340,
    "auth_name": "EPSG",
    "auth_id": "8340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29648,
    "description": "NAD83(2011) / Oregon Ukiah-Fox zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.25 +lat_0=45.25 +lon_0=-119 +k_0=1.00014 +x_0=30000 +y_0=90000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8341,
    "auth_name": "EPSG",
    "auth_id": "8341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29649,
    "description": "NAD83(2011) / Oregon Riley-Lakeview zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-120.333333333333 +k=1.000215 +x_0=70000.00001496 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8338,
    "auth_name": "EPSG",
    "auth_id": "8338",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29650,
    "description": "NAD83(2011) / Oregon Siskiyou Pass zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.5 +lat_0=42.5 +lon_0=-122.583333333333 +k_0=1.00015 +x_0=10000 +y_0=60000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8339,
    "auth_name": "EPSG",
    "auth_id": "8339",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29651,
    "description": "NAD83(2011) / Oregon Prairie City-Brogan zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44 +lat_0=44 +lon_0=-118 +k_0=1.00017 +x_0=59999.99999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8336,
    "auth_name": "EPSG",
    "auth_id": "8336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29652,
    "description": "NAD83(2011) / Oregon Riley-Lakeview zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-120.333333333333 +k=1.000215 +x_0=70000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8337,
    "auth_name": "EPSG",
    "auth_id": "8337",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29653,
    "description": "NAD83(2011) / Oregon Pilot Rock-Ukiah zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.1666666666667 +lat_0=46.1666666666667 +lon_0=-119 +k_0=1.000025 +x_0=50000.00001504 +y_0=130000.00001472 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8334,
    "auth_name": "EPSG",
    "auth_id": "8334",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29654,
    "description": "NAD83(2011) / Oregon Prairie City-Brogan zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44 +lat_0=44 +lon_0=-118 +k_0=1.00017 +x_0=60000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8335,
    "auth_name": "EPSG",
    "auth_id": "8335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29655,
    "description": "NAD83(2011) / Oregon Owyhee zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-117.583333333333 +k=1.00018 +x_0=70000.00001496 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8332,
    "auth_name": "EPSG",
    "auth_id": "8332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29656,
    "description": "NAD83(2011) / Oregon Pilot Rock-Ukiah zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.1666666666667 +lat_0=46.1666666666667 +lon_0=-119 +k_0=1.000025 +x_0=50000 +y_0=130000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8333,
    "auth_name": "EPSG",
    "auth_id": "8333",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29657,
    "description": "NAD83(2011) / Oregon Ochoco Summit zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.5 +lat_0=43.5 +lon_0=-120.5 +k_0=1.00006 +x_0=39999.99999984 +y_0=-79999.99999968 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8330,
    "auth_name": "EPSG",
    "auth_id": "8330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29658,
    "description": "NAD83(2011) / Oregon Owyhee zone (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-117.583333333333 +k=1.00018 +x_0=70000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8331,
    "auth_name": "EPSG",
    "auth_id": "8331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29659,
    "description": "NAD83(2011) / Oregon North Central zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.1666666666667 +lat_0=46.1666666666667 +lon_0=-120.5 +k_0=1 +x_0=99999.9999996 +y_0=139999.99999944 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8328,
    "auth_name": "EPSG",
    "auth_id": "8328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29660,
    "description": "NAD83(2011) / Oregon Ochoco Summit zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.5 +lat_0=43.5 +lon_0=-120.5 +k_0=1.00006 +x_0=40000 +y_0=-80000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8329,
    "auth_name": "EPSG",
    "auth_id": "8329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29661,
    "description": "NAD83(2011) / Oregon Mitchell zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=47 +lat_0=47 +lon_0=-120.25 +k_0=0.99927 +x_0=30000.00001512 +y_0=290000.00001408 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8326,
    "auth_name": "EPSG",
    "auth_id": "8326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29662,
    "description": "NAD83(2011) / Oregon North Central zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=46.1666666666667 +lat_0=46.1666666666667 +lon_0=-120.5 +k_0=1 +x_0=100000 +y_0=140000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8327,
    "auth_name": "EPSG",
    "auth_id": "8327",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29663,
    "description": "NAD83(2011) / Oregon Medford-Diamond Lake zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42 +lat_0=42 +lon_0=-122.25 +k_0=1.00004 +x_0=59999.99999976 +y_0=-59999.99999976 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8324,
    "auth_name": "EPSG",
    "auth_id": "8324",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29664,
    "description": "NAD83(2011) / Oregon Mitchell zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=47 +lat_0=47 +lon_0=-120.25 +k_0=0.99927 +x_0=30000 +y_0=290000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8325,
    "auth_name": "EPSG",
    "auth_id": "8325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29665,
    "description": "NAD83(2011) / Oregon Halfway zone (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.25 +lat_0=45.25 +lon_0=-117.25 +k_0=1.000085 +x_0=39999.99999984 +y_0=70000.00001496 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8322,
    "auth_name": "EPSG",
    "auth_id": "8322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29666,
    "description": "NAD83(2011) / Oregon Medford-Diamond Lake zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42 +lat_0=42 +lon_0=-122.25 +k_0=1.00004 +x_0=60000 +y_0=-60000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8323,
    "auth_name": "EPSG",
    "auth_id": "8323",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29667,
    "description": "NAD83(2011) / Oregon Denio-Burns zone (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.75 +lon_0=-118.416666666667 +k=1.00019 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 8320,
    "auth_name": "EPSG",
    "auth_id": "8320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 29668,
    "description": "NAD83(2011) / Oregon Halfway zone (m)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=45.25 +lat_0=45.25 +lon_0=-117.25 +k_0=1.000085 +x_0=40000 +y_0=70000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 8321,
    "auth_name": "EPSG",
    "auth_id": "8321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60000,
    "description": "Scoresbysund 1952 / Greenland zone 5 east",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000000,
    "auth_name": "EPSG",
    "auth_id": "2218",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60001,
    "description": "Scoresbysund 1952 / Greenland zone 6 east",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000001,
    "auth_name": "EPSG",
    "auth_id": "2221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60002,
    "description": "Carthage (Paris) / Tunisia Mining Grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000002,
    "auth_name": "EPSG",
    "auth_id": "22300",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60003,
    "description": "Ammassalik 1958 / Greenland zone 7 east",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000003,
    "auth_name": "EPSG",
    "auth_id": "2296",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60006,
    "description": "Qornoq 1927 / Greenland zone 2 west",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000006,
    "auth_name": "EPSG",
    "auth_id": "2299",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60008,
    "description": "Qornoq 1927 / Greenland zone 3 west",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000008,
    "auth_name": "EPSG",
    "auth_id": "2301",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60010,
    "description": "Qornoq 1927 / Greenland zone 4 west",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000010,
    "auth_name": "EPSG",
    "auth_id": "2303",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60011,
    "description": "Qornoq 1927 / Greenland zone 5 west",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000011,
    "auth_name": "EPSG",
    "auth_id": "2304",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60012,
    "description": "Qornoq 1927 / Greenland zone 6 west",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000012,
    "auth_name": "EPSG",
    "auth_id": "2305",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60013,
    "description": "Qornoq 1927 / Greenland zone 7 west",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000013,
    "auth_name": "EPSG",
    "auth_id": "2306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60014,
    "description": "Qornoq 1927 / Greenland zone 8 east",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000014,
    "auth_name": "EPSG",
    "auth_id": "2307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60015,
    "description": "Lisbon 1890 (Lisbon) / Portugal Bonne",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000015,
    "auth_name": "EPSG",
    "auth_id": "2963",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60016,
    "description": "Tananarive (Paris) / Laborde Grid",
    "projection_acronym": "labrd",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=labrd +lat_0=-18.9 +lon_0=44.1 +azi=18.9 +k=0.9995 +x_0=400000 +y_0=800000 +ellps=intl +pm=paris +units=m +no_defs",
    "srid": 520000016,
    "auth_name": "EPSG",
    "auth_id": "29701",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60017,
    "description": "Petrels 1972 / Terre Adelie Polar Stereographic",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000017,
    "auth_name": "EPSG",
    "auth_id": "2985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60018,
    "description": "Perroud 1950 / Terre Adelie Polar Stereographic",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000018,
    "auth_name": "EPSG",
    "auth_id": "2986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60019,
    "description": "Reykjavik 1900 / Lambert 1900",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000019,
    "auth_name": "EPSG",
    "auth_id": "3052",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60020,
    "description": "Hjorsey 1955 / Lambert 1955",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000020,
    "auth_name": "EPSG",
    "auth_id": "3053",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60021,
    "description": "Vanua Levu 1915 / Vanua Levu Grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cass +hyperbolic +lat_0=-16.25 +lon_0=179.333333333333 +x_0=251727.9155424 +y_0=334519.953768 +a=6378306.3696 +b=6356571.996 +towgs84=51,391,-36,0,0,0,0 +units=link +no_defs",
    "srid": 520000021,
    "auth_name": "EPSG",
    "auth_id": "3139",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60022,
    "description": "FD54 / Faroe Lambert",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000022,
    "auth_name": "EPSG",
    "auth_id": "3144",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60023,
    "description": "ETRS89 / Faroe Lambert",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000023,
    "auth_name": "EPSG",
    "auth_id": "3145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60024,
    "description": "fk89 / Faroe Lambert FK89",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000024,
    "auth_name": "EPSG",
    "auth_id": "3173",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60025,
    "description": "WGS 84 / UTM grid system (northern hemisphere)",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000025,
    "auth_name": "EPSG",
    "auth_id": "32600",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60027,
    "description": "WGS 84 / UTM grid system (southern hemisphere)",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000027,
    "auth_name": "EPSG",
    "auth_id": "32700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60028,
    "description": "Guam 1963 / Yap Islands",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=aeqd +lat_0=9.54670833333333 +lon_0=138.168744444444 +x_0=40000 +y_0=60000 +ellps=clrk66 +units=m +no_defs",
    "srid": 520000028,
    "auth_name": "EPSG",
    "auth_id": "3295",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60029,
    "description": "TWD97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000029,
    "auth_name": "EPSG",
    "auth_id": "3823",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60030,
    "description": "IGRS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000030,
    "auth_name": "EPSG",
    "auth_id": "3888",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60031,
    "description": "Guam 1963 / Guam SPCS",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=aeqd +guam +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +ellps=clrk66 +towgs84=-100,-248,259,0,0,0,0 +units=m +no_defs",
    "srid": 520000031,
    "auth_name": "EPSG",
    "auth_id": "3993",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60032,
    "description": "MOLDREF99",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000032,
    "auth_name": "EPSG",
    "auth_id": "4017",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60033,
    "description": "RGRDC 2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000033,
    "auth_name": "EPSG",
    "auth_id": "4040",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60034,
    "description": "SREF98",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000034,
    "auth_name": "EPSG",
    "auth_id": "4074",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60035,
    "description": "REGCAN95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000035,
    "auth_name": "EPSG",
    "auth_id": "4080",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60036,
    "description": "WGS 84 / World Equidistant Cylindrical",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000036,
    "auth_name": "EPSG",
    "auth_id": "4087",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60065,
    "description": "RGSPM06",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000065,
    "auth_name": "EPSG",
    "auth_id": "4466",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60066,
    "description": "RGM04",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000066,
    "auth_name": "EPSG",
    "auth_id": "4469",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60067,
    "description": "Cadastre 1997",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-381.788,-57.501,-256.673,0,0,0,0 +no_defs",
    "srid": 520000067,
    "auth_name": "EPSG",
    "auth_id": "4472",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60068,
    "description": "China Geodetic Coordinate System 2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000068,
    "auth_name": "EPSG",
    "auth_id": "4480",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60069,
    "description": "Mexico ITRF92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000069,
    "auth_name": "EPSG",
    "auth_id": "4482",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60070,
    "description": "RRAF 1991",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000070,
    "auth_name": "EPSG",
    "auth_id": "4557",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60071,
    "description": "Slovenia 1996",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000071,
    "auth_name": "EPSG",
    "auth_id": "4883",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60072,
    "description": "RSRGD2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000072,
    "auth_name": "EPSG",
    "auth_id": "4885",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60073,
    "description": "BDA2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000073,
    "auth_name": "EPSG",
    "auth_id": "4887",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60074,
    "description": "HTRS96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000074,
    "auth_name": "EPSG",
    "auth_id": "4889",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60075,
    "description": "WGS 66",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "NWL9D",
    "parameters": "+proj=longlat +ellps=NWL9D +no_defs",
    "srid": 520000075,
    "auth_name": "EPSG",
    "auth_id": "4891",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60076,
    "description": "NAD83(NSRS2007)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000076,
    "auth_name": "EPSG",
    "auth_id": "4893",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60077,
    "description": "JAD2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000077,
    "auth_name": "EPSG",
    "auth_id": "4895",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60078,
    "description": "DGN95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000078,
    "auth_name": "EPSG",
    "auth_id": "4898",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60079,
    "description": "LGD2006",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-208.4058,-109.8777,-2.5764,0,0,0,0 +no_defs",
    "srid": 520000079,
    "auth_name": "EPSG",
    "auth_id": "4900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60080,
    "description": "RGNC91-93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000080,
    "auth_name": "EPSG",
    "auth_id": "4907",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60081,
    "description": "GR96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000081,
    "auth_name": "EPSG",
    "auth_id": "4909",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60082,
    "description": "GDM2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000082,
    "auth_name": "EPSG",
    "auth_id": "4921",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60083,
    "description": "PZ-90",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378136 +rf=298.257839303 +towgs84=0,0,1.5,0,0,0.076,0 +no_defs",
    "srid": 520000083,
    "auth_name": "EPSG",
    "auth_id": "4923",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60084,
    "description": "Mauritania 1999",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000084,
    "auth_name": "EPSG",
    "auth_id": "4925",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60085,
    "description": "KGD2002",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000085,
    "auth_name": "EPSG",
    "auth_id": "4927",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60086,
    "description": "POSGAR 94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000086,
    "auth_name": "EPSG",
    "auth_id": "4929",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60087,
    "description": "Australian Antarctic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000087,
    "auth_name": "EPSG",
    "auth_id": "4931",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60088,
    "description": "CHTRS95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000088,
    "auth_name": "EPSG",
    "auth_id": "4933",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60089,
    "description": "EST97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000089,
    "auth_name": "EPSG",
    "auth_id": "4935",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60090,
    "description": "ETRS89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000090,
    "auth_name": "EPSG",
    "auth_id": "4937",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60091,
    "description": "GDA94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000091,
    "auth_name": "EPSG",
    "auth_id": "4939",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60092,
    "description": "Hartebeesthoek94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000092,
    "auth_name": "EPSG",
    "auth_id": "4941",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60093,
    "description": "IRENET95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000093,
    "auth_name": "EPSG",
    "auth_id": "4943",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60094,
    "description": "ISN93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000094,
    "auth_name": "EPSG",
    "auth_id": "4945",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60095,
    "description": "JGD2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000095,
    "auth_name": "EPSG",
    "auth_id": "4947",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60096,
    "description": "LKS-92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000096,
    "auth_name": "EPSG",
    "auth_id": "4949",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60097,
    "description": "LKS94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000097,
    "auth_name": "EPSG",
    "auth_id": "4951",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60098,
    "description": "Moznet",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000098,
    "auth_name": "EPSG",
    "auth_id": "4953",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60099,
    "description": "NAD83(CSRS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000099,
    "auth_name": "EPSG",
    "auth_id": "4955",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60100,
    "description": "NAD83(HARN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000100,
    "auth_name": "EPSG",
    "auth_id": "4957",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60101,
    "description": "NZGD2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000101,
    "auth_name": "EPSG",
    "auth_id": "4959",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60102,
    "description": "POSGAR 98",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000102,
    "auth_name": "EPSG",
    "auth_id": "4961",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60103,
    "description": "REGVEN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000103,
    "auth_name": "EPSG",
    "auth_id": "4963",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60104,
    "description": "RGF93 v1",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000104,
    "auth_name": "EPSG",
    "auth_id": "4965",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60105,
    "description": "RGFG95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000105,
    "auth_name": "EPSG",
    "auth_id": "4967",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60107,
    "description": "RGR92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000107,
    "auth_name": "EPSG",
    "auth_id": "4971",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60109,
    "description": "SIRGAS 1995",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000109,
    "auth_name": "EPSG",
    "auth_id": "4975",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60110,
    "description": "SWEREF99",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000110,
    "auth_name": "EPSG",
    "auth_id": "4977",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60111,
    "description": "WGS 84",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +no_defs",
    "srid": 520000111,
    "auth_name": "EPSG",
    "auth_id": "4979",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60112,
    "description": "Yemen NGN96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000112,
    "auth_name": "EPSG",
    "auth_id": "4981",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60113,
    "description": "IGM95",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000113,
    "auth_name": "EPSG",
    "auth_id": "4983",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60114,
    "description": "WGS 72",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +no_defs",
    "srid": 520000114,
    "auth_name": "EPSG",
    "auth_id": "4985",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60115,
    "description": "WGS 72BE",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +no_defs",
    "srid": 520000115,
    "auth_name": "EPSG",
    "auth_id": "4987",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60116,
    "description": "SIRGAS 2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000116,
    "auth_name": "EPSG",
    "auth_id": "4989",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60117,
    "description": "Lao 1993",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 520000117,
    "auth_name": "EPSG",
    "auth_id": "4991",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60118,
    "description": "Lao 1997",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +towgs84=44.585,-131.212,-39.544,0,0,0,0 +no_defs",
    "srid": 520000118,
    "auth_name": "EPSG",
    "auth_id": "4993",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60119,
    "description": "PRS92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +no_defs",
    "srid": 520000119,
    "auth_name": "EPSG",
    "auth_id": "4995",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60120,
    "description": "MAGNA-SIRGAS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000120,
    "auth_name": "EPSG",
    "auth_id": "4997",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60121,
    "description": "RGPF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000121,
    "auth_name": "EPSG",
    "auth_id": "4999",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60122,
    "description": "PTRA08",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000122,
    "auth_name": "EPSG",
    "auth_id": "5012",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60123,
    "description": "Lisbon 1890 / Portugal Bonne New",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000123,
    "auth_name": "EPSG",
    "auth_id": "5017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60124,
    "description": "S-JTSK/05 (Ferro) / Modified Krovak",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000124,
    "auth_name": "EPSG",
    "auth_id": "5224",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60125,
    "description": "S-JTSK/05 (Ferro) / Modified Krovak East North",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000125,
    "auth_name": "EPSG",
    "auth_id": "5225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60126,
    "description": "GDBD2009",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000126,
    "auth_name": "EPSG",
    "auth_id": "5245",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60127,
    "description": "TUREF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000127,
    "auth_name": "EPSG",
    "auth_id": "5251",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60128,
    "description": "DRUKREF 03",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000128,
    "auth_name": "EPSG",
    "auth_id": "5263",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60129,
    "description": "ISN2004",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000129,
    "auth_name": "EPSG",
    "auth_id": "5323",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60130,
    "description": "POSGAR 2007",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000130,
    "auth_name": "EPSG",
    "auth_id": "5342",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60131,
    "description": "MARGEN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000131,
    "auth_name": "EPSG",
    "auth_id": "5353",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60132,
    "description": "SIRGAS-Chile 2002",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000132,
    "auth_name": "EPSG",
    "auth_id": "5359",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60133,
    "description": "CR05",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000133,
    "auth_name": "EPSG",
    "auth_id": "5364",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60134,
    "description": "MACARIO SOLIS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000134,
    "auth_name": "EPSG",
    "auth_id": "5370",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60135,
    "description": "Peru96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000135,
    "auth_name": "EPSG",
    "auth_id": "5372",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60136,
    "description": "SIRGAS-ROU98",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000136,
    "auth_name": "EPSG",
    "auth_id": "5380",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60137,
    "description": "SIRGAS_ES2007.8",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000137,
    "auth_name": "EPSG",
    "auth_id": "5392",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60138,
    "description": "RGAF09",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000138,
    "auth_name": "EPSG",
    "auth_id": "5488",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60139,
    "description": "S-JTSK/05 / Modified Krovak",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000139,
    "auth_name": "EPSG",
    "auth_id": "5515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60140,
    "description": "S-JTSK/05 / Modified Krovak East North",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000140,
    "auth_name": "EPSG",
    "auth_id": "5516",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60141,
    "description": "PNG94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000141,
    "auth_name": "EPSG",
    "auth_id": "5545",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60142,
    "description": "UCS-2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +no_defs",
    "srid": 520000142,
    "auth_name": "EPSG",
    "auth_id": "5560",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60143,
    "description": "FEH2010",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000143,
    "auth_name": "EPSG",
    "auth_id": "5592",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60146,
    "description": "DB_REF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 520000146,
    "auth_name": "EPSG",
    "auth_id": "5830",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60147,
    "description": "TGD2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000147,
    "auth_name": "EPSG",
    "auth_id": "5885",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60148,
    "description": "VN-2000 / TM-3 zone 481",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520000148,
    "auth_name": "EPSG",
    "auth_id": "5896",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60149,
    "description": "VN-2000 / TM-3 zone 482",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 520000149,
    "auth_name": "EPSG",
    "auth_id": "5897",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60150,
    "description": "VN-2000 / TM-3 zone 491",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +units=m +no_defs",
    "srid": 520000150,
    "auth_name": "EPSG",
    "auth_id": "5898",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60151,
    "description": "VN-2000 / TM-3 107-45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520000151,
    "auth_name": "EPSG",
    "auth_id": "5899",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60152,
    "description": "CIGD11",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000152,
    "auth_name": "EPSG",
    "auth_id": "6134",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60154,
    "description": "NAD27 / Michigan Central",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3333333333333 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=609601.219202438 +y_0=0 +k_0=1.0000382 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 520000154,
    "auth_name": "EPSG",
    "auth_id": "6201",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60155,
    "description": "NAD27 / Michigan South",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3333333333333 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=609601.219202438 +y_0=0 +k_0=1.0000382 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 520000155,
    "auth_name": "EPSG",
    "auth_id": "6202",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60156,
    "description": "MAGNA-SIRGAS / Arauca urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=7.08760639166667 +lon_0=-70.7583096555555 +x_0=1035263.443 +y_0=1275526.621 +h_0=100 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000156,
    "auth_name": "EPSG",
    "auth_id": "6244",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60157,
    "description": "MAGNA-SIRGAS / Armenia urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=4.532325 +lon_0=-75.6734891666667 +x_0=1155824.666 +y_0=993087.465 +h_0=1470 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000157,
    "auth_name": "EPSG",
    "auth_id": "6245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60158,
    "description": "MAGNA-SIRGAS / Barranquilla urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=10.9231830833333 +lon_0=-74.8343313333333 +x_0=917264.406 +y_0=1699839.935 +h_0=100 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000158,
    "auth_name": "EPSG",
    "auth_id": "6246",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60159,
    "description": "MAGNA-SIRGAS / Bogota urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=4.68048611111111 +lon_0=-74.1465916666667 +x_0=92334.879 +y_0=109320.965 +h_0=2550 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000159,
    "auth_name": "EPSG",
    "auth_id": "6247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60160,
    "description": "MAGNA-SIRGAS / Bucaramanga urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=7.07888714166667 +lon_0=-73.1973432222222 +x_0=1097241.305 +y_0=1274642.278 +h_0=931 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000160,
    "auth_name": "EPSG",
    "auth_id": "6248",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60161,
    "description": "MAGNA-SIRGAS / Cali urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=3.44188333333333 +lon_0=-76.5205625 +x_0=1061900.18 +y_0=872364.63 +h_0=1000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000161,
    "auth_name": "EPSG",
    "auth_id": "6249",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60162,
    "description": "MAGNA-SIRGAS / Cartagena urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=10.3970475 +lon_0=-75.5112069444444 +x_0=842981.41 +y_0=1641887.09 +h_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000162,
    "auth_name": "EPSG",
    "auth_id": "6250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60163,
    "description": "MAGNA-SIRGAS / Cucuta urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=7.88893673611111 +lon_0=-72.50287095 +x_0=842805.406 +y_0=1364404.57 +h_0=308 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000163,
    "auth_name": "EPSG",
    "auth_id": "6251",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60164,
    "description": "MAGNA-SIRGAS / Florencia urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=1.62101229444444 +lon_0=-75.6191176027778 +x_0=1162300.348 +y_0=671068.716 +h_0=300 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000164,
    "auth_name": "EPSG",
    "auth_id": "6252",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60165,
    "description": "MAGNA-SIRGAS / Ibague urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=4.41941282777778 +lon_0=-75.1799259333333 +x_0=877634.33 +y_0=980541.348 +h_0=1100 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000165,
    "auth_name": "EPSG",
    "auth_id": "6253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60166,
    "description": "MAGNA-SIRGAS / Inirida urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=3.84543818333333 +lon_0=-67.9052320888889 +x_0=1019177.687 +y_0=491791.326 +h_0=96 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000166,
    "auth_name": "EPSG",
    "auth_id": "6254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60167,
    "description": "MAGNA-SIRGAS / Leticia urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=-4.19768404722222 +lon_0=-69.9428110583333 +x_0=25978.217 +y_0=27501.365 +h_0=89.7 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000167,
    "auth_name": "EPSG",
    "auth_id": "6255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60168,
    "description": "MAGNA-SIRGAS / Manizales urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=5.06815388888889 +lon_0=-75.5110947222222 +x_0=1173727.04 +y_0=1052391.13 +h_0=2100 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000168,
    "auth_name": "EPSG",
    "auth_id": "6256",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60169,
    "description": "MAGNA-SIRGAS / Medellin urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=6.22920888888889 +lon_0=-75.5648869444444 +x_0=835378.647 +y_0=1180816.875 +h_0=1510 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000169,
    "auth_name": "EPSG",
    "auth_id": "6257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60170,
    "description": "MAGNA-SIRGAS / Mitu urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=1.24996936666667 +lon_0=-70.2354616555556 +x_0=1093717.398 +y_0=629997.236 +h_0=170 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000170,
    "auth_name": "EPSG",
    "auth_id": "6258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60171,
    "description": "MAGNA-SIRGAS / Mocoa urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=1.14002335833333 +lon_0=-76.6510212194444 +x_0=1047467.388 +y_0=617828.474 +h_0=655.2 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000171,
    "auth_name": "EPSG",
    "auth_id": "6259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60172,
    "description": "MAGNA-SIRGAS / Monteria urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=8.77308575555556 +lon_0=-75.8795533305556 +x_0=1131814.934 +y_0=1462131.119 +h_0=15 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000172,
    "auth_name": "EPSG",
    "auth_id": "6260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60173,
    "description": "MAGNA-SIRGAS / Neiva urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=2.94241505555556 +lon_0=-75.2964367222222 +x_0=864476.923 +y_0=817199.827 +h_0=430 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000173,
    "auth_name": "EPSG",
    "auth_id": "6261",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60174,
    "description": "MAGNA-SIRGAS / Pasto urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=1.20098951388889 +lon_0=-77.2531256333333 +x_0=980469.695 +y_0=624555.332 +h_0=2530 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000174,
    "auth_name": "EPSG",
    "auth_id": "6262",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60175,
    "description": "MAGNA-SIRGAS / Pereira urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=4.81359361111111 +lon_0=-75.6939513888889 +x_0=1153492.012 +y_0=1024195.255 +h_0=1500 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000175,
    "auth_name": "EPSG",
    "auth_id": "6263",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60176,
    "description": "MAGNA-SIRGAS / Popayan urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=2.45615988333333 +lon_0=-76.6060916361111 +x_0=1052430.525 +y_0=763366.548 +h_0=1740 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000176,
    "auth_name": "EPSG",
    "auth_id": "6264",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60177,
    "description": "MAGNA-SIRGAS / Puerto Carreno urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=6.18072141388889 +lon_0=-67.5007502472222 +x_0=1063834.703 +y_0=1175257.481 +h_0=51.58 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000177,
    "auth_name": "EPSG",
    "auth_id": "6265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60178,
    "description": "MAGNA-SIRGAS / Quibdo urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=5.69424766111111 +lon_0=-76.6507538583333 +x_0=1047273.617 +y_0=1121443.09 +h_0=44 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000178,
    "auth_name": "EPSG",
    "auth_id": "6266",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60179,
    "description": "MAGNA-SIRGAS / Riohacha urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=11.5369133277778 +lon_0=-72.9027688694444 +x_0=1128154.73 +y_0=1767887.914 +h_0=6 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000179,
    "auth_name": "EPSG",
    "auth_id": "6267",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60180,
    "description": "MAGNA-SIRGAS / San Andres urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=12.523794325 +lon_0=-81.72937595 +x_0=820439.298 +y_0=1877357.828 +h_0=6 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000180,
    "auth_name": "EPSG",
    "auth_id": "6268",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60181,
    "description": "MAGNA-SIRGAS / San Jose del Guaviare urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=2.56407894166667 +lon_0=-72.640033325 +x_0=1159876.62 +y_0=775380.342 +h_0=185 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000181,
    "auth_name": "EPSG",
    "auth_id": "6269",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60182,
    "description": "MAGNA-SIRGAS / Santa Marta urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=11.2196430555556 +lon_0=-74.2250052777778 +x_0=983892.409 +y_0=1732533.518 +h_0=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000182,
    "auth_name": "EPSG",
    "auth_id": "6270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60183,
    "description": "MAGNA-SIRGAS / Sucre urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=8.81055036666667 +lon_0=-74.722466825 +x_0=929043.607 +y_0=1466125.658 +h_0=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000183,
    "auth_name": "EPSG",
    "auth_id": "6271",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60184,
    "description": "MAGNA-SIRGAS / Tunja urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=5.53419473888889 +lon_0=-73.3519389 +x_0=1080514.91 +y_0=1103772.028 +h_0=2800 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000184,
    "auth_name": "EPSG",
    "auth_id": "6272",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60185,
    "description": "MAGNA-SIRGAS / Valledupar urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=10.4472611111111 +lon_0=-73.2465713888889 +x_0=1090979.66 +y_0=1647208.93 +h_0=200 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000185,
    "auth_name": "EPSG",
    "auth_id": "6273",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60186,
    "description": "MAGNA-SIRGAS / Villavicencio urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=4.1553751 +lon_0=-73.6244859861111 +x_0=1050678.757 +y_0=950952.124 +h_0=427.19 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000186,
    "auth_name": "EPSG",
    "auth_id": "6274",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60187,
    "description": "MAGNA-SIRGAS / Yopal urban grid",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=col_urban +lat_0=5.35392722222222 +lon_0=-72.4200402777778 +x_0=851184.177 +y_0=1083954.137 +h_0=300 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000187,
    "auth_name": "EPSG",
    "auth_id": "6275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60188,
    "description": "CGRS93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926 +no_defs",
    "srid": 520000188,
    "auth_name": "EPSG",
    "auth_id": "6310",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60189,
    "description": "NAD83(2011)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000189,
    "auth_name": "EPSG",
    "auth_id": "6319",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60190,
    "description": "NAD83(PA11)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000190,
    "auth_name": "EPSG",
    "auth_id": "6321",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60191,
    "description": "NAD83(MA11)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000191,
    "auth_name": "EPSG",
    "auth_id": "6324",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60192,
    "description": "Mexico ITRF2008",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000192,
    "auth_name": "EPSG",
    "auth_id": "6364",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60193,
    "description": "JGD2011",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000193,
    "auth_name": "EPSG",
    "auth_id": "6667",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60194,
    "description": "RDN2008",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000194,
    "auth_name": "EPSG",
    "auth_id": "6705",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60195,
    "description": "NAD83(CORS96)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000195,
    "auth_name": "EPSG",
    "auth_id": "6782",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60196,
    "description": "NAD27 / Michigan North",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=609601.219202438 +y_0=0 +k_0=1.0000382 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 520000196,
    "auth_name": "EPSG",
    "auth_id": "6966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60198,
    "description": "IG05 Intermediate CRS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000198,
    "auth_name": "EPSG",
    "auth_id": "6982",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60200,
    "description": "IG05/12 Intermediate CRS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=-23.772,-17.49,-17.859,0.3132,1.85274,-1.67299,5.4262 +no_defs",
    "srid": 520000200,
    "auth_name": "EPSG",
    "auth_id": "6989",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60201,
    "description": "RGSPM06 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000201,
    "auth_name": "EPSG",
    "auth_id": "7034",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60202,
    "description": "RGR92 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000202,
    "auth_name": "EPSG",
    "auth_id": "7036",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60203,
    "description": "RGM04 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000203,
    "auth_name": "EPSG",
    "auth_id": "7038",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60204,
    "description": "RGFG95 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000204,
    "auth_name": "EPSG",
    "auth_id": "7040",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60205,
    "description": "RGF93 v1 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000205,
    "auth_name": "EPSG",
    "auth_id": "7042",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60206,
    "description": "RGTAAF07",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000206,
    "auth_name": "EPSG",
    "auth_id": "7072",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60208,
    "description": "RGAF09 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000208,
    "auth_name": "EPSG",
    "auth_id": "7085",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60209,
    "description": "RGTAAF07 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000209,
    "auth_name": "EPSG",
    "auth_id": "7087",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60210,
    "description": "IGD05",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000210,
    "auth_name": "EPSG",
    "auth_id": "7135",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60211,
    "description": "IGD05/12",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000211,
    "auth_name": "EPSG",
    "auth_id": "7138",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60212,
    "description": "ONGD14",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000212,
    "auth_name": "EPSG",
    "auth_id": "7372",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60213,
    "description": "WGS 84 (G730)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000213,
    "auth_name": "EPSG",
    "auth_id": "7657",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60214,
    "description": "WGS 84 (G873)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000214,
    "auth_name": "EPSG",
    "auth_id": "7659",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60215,
    "description": "WGS 84 (G1150)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000215,
    "auth_name": "EPSG",
    "auth_id": "7661",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60216,
    "description": "WGS 84 (G1674)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000216,
    "auth_name": "EPSG",
    "auth_id": "7663",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60217,
    "description": "WGS 84 (G1762)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000217,
    "auth_name": "EPSG",
    "auth_id": "7665",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60218,
    "description": "PZ-90.02",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs",
    "srid": 520000218,
    "auth_name": "EPSG",
    "auth_id": "7678",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60219,
    "description": "PZ-90.11",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs",
    "srid": 520000219,
    "auth_name": "EPSG",
    "auth_id": "7680",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60220,
    "description": "GSK-2011",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GSK2011",
    "parameters": "+proj=longlat +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000220,
    "auth_name": "EPSG",
    "auth_id": "7682",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60221,
    "description": "Kyrg-06",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000221,
    "auth_name": "EPSG",
    "auth_id": "7685",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60222,
    "description": "BGS2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000222,
    "auth_name": "EPSG",
    "auth_id": "7797",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60223,
    "description": "WGS 84 (Transit)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520000223,
    "auth_name": "EPSG",
    "auth_id": "7816",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60224,
    "description": "GDA2020",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000224,
    "auth_name": "EPSG",
    "auth_id": "7843",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60225,
    "description": "St. Helena Tritan",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=-0.077,0.079,0.086,0,0,0,0 +no_defs",
    "srid": 520000225,
    "auth_name": "EPSG",
    "auth_id": "7880",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60226,
    "description": "SHGD2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000226,
    "auth_name": "EPSG",
    "auth_id": "7885",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60227,
    "description": "ITRF88",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000227,
    "auth_name": "EPSG",
    "auth_id": "7900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60228,
    "description": "ITRF89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000228,
    "auth_name": "EPSG",
    "auth_id": "7901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60229,
    "description": "ITRF90",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000229,
    "auth_name": "EPSG",
    "auth_id": "7902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60230,
    "description": "ITRF91",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000230,
    "auth_name": "EPSG",
    "auth_id": "7903",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60231,
    "description": "ITRF92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000231,
    "auth_name": "EPSG",
    "auth_id": "7904",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60232,
    "description": "ITRF93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000232,
    "auth_name": "EPSG",
    "auth_id": "7905",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60233,
    "description": "ITRF94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000233,
    "auth_name": "EPSG",
    "auth_id": "7906",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60234,
    "description": "ITRF96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000234,
    "auth_name": "EPSG",
    "auth_id": "7907",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60235,
    "description": "ITRF97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000235,
    "auth_name": "EPSG",
    "auth_id": "7908",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60236,
    "description": "ITRF2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000236,
    "auth_name": "EPSG",
    "auth_id": "7909",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60237,
    "description": "ITRF2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000237,
    "auth_name": "EPSG",
    "auth_id": "7910",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60238,
    "description": "ITRF2008",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000238,
    "auth_name": "EPSG",
    "auth_id": "7911",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60239,
    "description": "ITRF2014",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000239,
    "auth_name": "EPSG",
    "auth_id": "7912",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60240,
    "description": "ETRF89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000240,
    "auth_name": "EPSG",
    "auth_id": "7915",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60241,
    "description": "ETRF90",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000241,
    "auth_name": "EPSG",
    "auth_id": "7917",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60242,
    "description": "ETRF91",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000242,
    "auth_name": "EPSG",
    "auth_id": "7919",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60243,
    "description": "ETRF92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000243,
    "auth_name": "EPSG",
    "auth_id": "7921",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60244,
    "description": "ETRF93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000244,
    "auth_name": "EPSG",
    "auth_id": "7923",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60245,
    "description": "ETRF94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000245,
    "auth_name": "EPSG",
    "auth_id": "7925",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60246,
    "description": "ETRF96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000246,
    "auth_name": "EPSG",
    "auth_id": "7927",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60247,
    "description": "ETRF97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000247,
    "auth_name": "EPSG",
    "auth_id": "7929",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60248,
    "description": "ETRF2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000248,
    "auth_name": "EPSG",
    "auth_id": "7931",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60249,
    "description": "ISN2016",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000249,
    "auth_name": "EPSG",
    "auth_id": "8085",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60250,
    "description": "NAD83(CSRS96)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000250,
    "auth_name": "EPSG",
    "auth_id": "8231",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60251,
    "description": "NAD83(CSRS)v2",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000251,
    "auth_name": "EPSG",
    "auth_id": "8235",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60252,
    "description": "NAD83(CSRS)v3",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000252,
    "auth_name": "EPSG",
    "auth_id": "8239",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60253,
    "description": "NAD83(CSRS)v4",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000253,
    "auth_name": "EPSG",
    "auth_id": "8244",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60254,
    "description": "NAD83(CSRS)v5",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000254,
    "auth_name": "EPSG",
    "auth_id": "8248",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60255,
    "description": "NAD83(CSRS)v6",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000255,
    "auth_name": "EPSG",
    "auth_id": "8251",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60256,
    "description": "NAD83(CSRS)v7",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000256,
    "auth_name": "EPSG",
    "auth_id": "8254",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60257,
    "description": "S-JTSK [JTSK03]",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=485.021,169.465,483.839,7.786342,4.397554,4.102655,0 +no_defs",
    "srid": 520000257,
    "auth_name": "EPSG",
    "auth_id": "8351",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60258,
    "description": "S-JTSK [JTSK03] / Krovak",
    "projection_acronym": "krovak",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=krovak +axis=swu +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=485.021,169.465,483.839,7.786342,4.397554,4.102655,0 +units=m +no_defs",
    "srid": 520000258,
    "auth_name": "EPSG",
    "auth_id": "8352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60259,
    "description": "S-JTSK [JTSK03] / Krovak East North",
    "projection_acronym": "krovak",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=krovak +lat_0=49.5 +lon_0=24.8333333333333 +alpha=30.2881397527778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=485.021,169.465,483.839,7.786342,4.397554,4.102655,0 +units=m +no_defs",
    "srid": 520000259,
    "auth_name": "EPSG",
    "auth_id": "8353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60260,
    "description": "ETRS89 + Baltic 1957 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520000260,
    "auth_name": "EPSG",
    "auth_id": "8360",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60261,
    "description": "ETRS89 / Belgian Lambert 2008 + Ostend height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=50.797815 +lon_0=4.35921583333333 +lat_1=49.8333333333333 +lat_2=51.1666666666667 +x_0=649328 +y_0=665262 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=be_ign_hBG18.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520000261,
    "auth_name": "EPSG",
    "auth_id": "8370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60262,
    "description": "NAD83 / NCRS Las Vegas (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.0001 +x_0=100000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000262,
    "auth_name": "EPSG",
    "auth_id": "8379",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60263,
    "description": "NAD83 / NCRS Las Vegas (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.0001 +x_0=99999.99998984 +y_0=200000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000263,
    "auth_name": "EPSG",
    "auth_id": "8380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60264,
    "description": "NAD83 / NCRS Las Vegas high (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.000135 +x_0=300000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000264,
    "auth_name": "EPSG",
    "auth_id": "8381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60265,
    "description": "NAD83 / NCRS Las Vegas high (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.000135 +x_0=300000 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000265,
    "auth_name": "EPSG",
    "auth_id": "8382",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60266,
    "description": "NAD83(2011) / NCRS Las Vegas (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.0001 +x_0=100000 +y_0=200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000266,
    "auth_name": "EPSG",
    "auth_id": "8383",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60267,
    "description": "NAD83(2011) / NCRS Las Vegas (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.0001 +x_0=99999.99998984 +y_0=200000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000267,
    "auth_name": "EPSG",
    "auth_id": "8384",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60268,
    "description": "NAD83(2011) / NCRS Las Vegas high (m)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.000135 +x_0=300000 +y_0=400000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000268,
    "auth_name": "EPSG",
    "auth_id": "8385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60269,
    "description": "NAD83(2011) / NCRS Las Vegas high (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.25 +lon_0=-114.966666666667 +k=1.000135 +x_0=300000 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000269,
    "auth_name": "EPSG",
    "auth_id": "8387",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60270,
    "description": "GDA94 / WEIPA94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=0.999929 +x_0=300000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000270,
    "auth_name": "EPSG",
    "auth_id": "8391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60272,
    "description": "ETRF2005",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000272,
    "auth_name": "EPSG",
    "auth_id": "8397",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60273,
    "description": "ETRF2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000273,
    "auth_name": "EPSG",
    "auth_id": "8399",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60274,
    "description": "ETRF2014",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000274,
    "auth_name": "EPSG",
    "auth_id": "8401",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60275,
    "description": "ETRF2014",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000275,
    "auth_name": "EPSG",
    "auth_id": "8403",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60276,
    "description": "Hong Kong Geodetic CS",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000276,
    "auth_name": "EPSG",
    "auth_id": "8425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60277,
    "description": "Hong Kong Geodetic CS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000277,
    "auth_name": "EPSG",
    "auth_id": "8426",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60278,
    "description": "Hong Kong Geodetic CS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000278,
    "auth_name": "EPSG",
    "auth_id": "8427",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60279,
    "description": "Macao 1920",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520000279,
    "auth_name": "EPSG",
    "auth_id": "8428",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60280,
    "description": "Macao 2008",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000280,
    "auth_name": "EPSG",
    "auth_id": "8429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60281,
    "description": "Macao 2008",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000281,
    "auth_name": "EPSG",
    "auth_id": "8430",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60282,
    "description": "Macao 2008",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000282,
    "auth_name": "EPSG",
    "auth_id": "8431",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60283,
    "description": "Macao 1920 / Macao Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=22.2123972222222 +lon_0=113.536469444444 +k=1 +x_0=20000 +y_0=20000 +ellps=intl +units=m +no_defs",
    "srid": 520000283,
    "auth_name": "EPSG",
    "auth_id": "8433",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60284,
    "description": "Tananarive / Laborde Grid",
    "projection_acronym": "labrd",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=labrd +lat_0=-18.9 +lon_0=46.4372291666667 +azi=18.9 +k=0.9995 +x_0=400000 +y_0=800000 +ellps=intl +units=m +no_defs",
    "srid": 520000284,
    "auth_name": "EPSG",
    "auth_id": "8441",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60286,
    "description": "RGTAAF07 / UTM zone 53S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=53 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000286,
    "auth_name": "EPSG",
    "auth_id": "8455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60287,
    "description": "RGTAAF07 / UTM zone 54S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=54 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000287,
    "auth_name": "EPSG",
    "auth_id": "8456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60288,
    "description": "NAD83(2011) / KS RCS zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-101.6 +k=1.000156 +x_0=457200.914401829 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000288,
    "auth_name": "EPSG",
    "auth_id": "8518",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60289,
    "description": "NAD83(2011) / KS RCS zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-100.95 +k=1.000134 +x_0=762001.524003048 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000289,
    "auth_name": "EPSG",
    "auth_id": "8519",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60290,
    "description": "NAD83(2011) / KS RCS zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-100.35 +k=1.000116 +x_0=1066802.13360427 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000290,
    "auth_name": "EPSG",
    "auth_id": "8520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60291,
    "description": "NAD83(2011) / KS RCS zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-99.45 +k=1.000082 +x_0=1371602.74320549 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000291,
    "auth_name": "EPSG",
    "auth_id": "8521",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60292,
    "description": "NAD83(2011) / KS RCS zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-98.6666666666667 +k=1.000078 +x_0=1676403.35280671 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000292,
    "auth_name": "EPSG",
    "auth_id": "8522",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60293,
    "description": "NAD83(2011) / KS RCS zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-98.15 +k=1.000068 +x_0=1981203.96240793 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000293,
    "auth_name": "EPSG",
    "auth_id": "8523",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60294,
    "description": "NAD83(2011) / KS RCS zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-97.3333333333333 +k=1.000049 +x_0=2286004.57200914 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000294,
    "auth_name": "EPSG",
    "auth_id": "8524",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60295,
    "description": "NAD83(2011) / KS RCS zone 8",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=39.1666666666667 +lat_0=39.1666666666667 +lon_0=-96.5 +k_0=1.000044 +x_0=2590805.18161036 +y_0=182880.365760732 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000295,
    "auth_name": "EPSG",
    "auth_id": "8525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60296,
    "description": "NAD83(2011) / KS RCS zone 9",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=38.5 +lat_0=38.5 +lon_0=-96.5 +k_0=1.00005 +x_0=2895605.79121158 +y_0=91440.1828803658 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000296,
    "auth_name": "EPSG",
    "auth_id": "8526",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60297,
    "description": "NAD83(2011) / KS RCS zone 10",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=39.6333333333333 +lat_0=39.6333333333333 +lon_0=-95.75 +k_0=1.00004 +x_0=3200406.4008128 +y_0=213360.426720853 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000297,
    "auth_name": "EPSG",
    "auth_id": "8527",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60298,
    "description": "NAD83(2011) / KS RCS zone 11",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=39.1 +lat_0=39.1 +lon_0=-95.25 +k_0=1.000033 +x_0=3505207.01041402 +y_0=182880.365760732 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000298,
    "auth_name": "EPSG",
    "auth_id": "8528",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60299,
    "description": "NAD83(2011) / KS RCS zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.75 +lon_0=-101.416666666667 +k=1.00014 +x_0=3810007.62001524 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000299,
    "auth_name": "EPSG",
    "auth_id": "8529",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60300,
    "description": "NAD83(2011) / KS RCS zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.75 +lon_0=-100.4 +k=1.000109 +x_0=4114808.22961646 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000300,
    "auth_name": "EPSG",
    "auth_id": "8531",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60301,
    "description": "NAD83(2011) / KS RCS zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.75 +lon_0=-99.6666666666667 +k=1.000097 +x_0=4419608.83921768 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000301,
    "auth_name": "EPSG",
    "auth_id": "8533",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60302,
    "description": "NAD83(2011) / KS RCS zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.75 +lon_0=-99.2 +k=1.000087 +x_0=4724409.4488189 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000302,
    "auth_name": "EPSG",
    "auth_id": "8534",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60303,
    "description": "NAD83(2011) / KS RCS zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.75 +lon_0=-98.55 +k=1.000069 +x_0=5029210.05842012 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000303,
    "auth_name": "EPSG",
    "auth_id": "8535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60304,
    "description": "NAD83(2011) / KS RCS zone 17",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=37.7666666666667 +lat_0=37.7666666666667 +lon_0=-97.5 +k_0=1.000059 +x_0=5334010.66802134 +y_0=121920.243840488 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000304,
    "auth_name": "EPSG",
    "auth_id": "8536",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60305,
    "description": "NAD83(2011) / KS RCS zone 18",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=37.1833333333333 +lat_0=37.1833333333333 +lon_0=-97.5 +k_0=1.000055 +x_0=5638811.27762256 +y_0=60960.1219202439 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000305,
    "auth_name": "EPSG",
    "auth_id": "8538",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60306,
    "description": "NAD83(2011) / KS RCS zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.75 +lon_0=-95.9666666666667 +k=1.000034 +x_0=5943611.88722378 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000306,
    "auth_name": "EPSG",
    "auth_id": "8539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60307,
    "description": "NAD83(2011) / KS RCS zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.75 +lon_0=-95.0833333333333 +k=1.000031 +x_0=6248412.49682499 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000307,
    "auth_name": "EPSG",
    "auth_id": "8540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60308,
    "description": "NAD83(FBN)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000308,
    "auth_name": "EPSG",
    "auth_id": "8541",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60309,
    "description": "NAD83(FBN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000309,
    "auth_name": "EPSG",
    "auth_id": "8542",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60310,
    "description": "NAD83(HARN Corrected)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000310,
    "auth_name": "EPSG",
    "auth_id": "8543",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60311,
    "description": "NAD83(HARN Corrected)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000311,
    "auth_name": "EPSG",
    "auth_id": "8544",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60312,
    "description": "NAD83(HARN Corrected)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000312,
    "auth_name": "EPSG",
    "auth_id": "8545",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60313,
    "description": "MGI 1901 / Balkans zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=5500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs",
    "srid": 520000313,
    "auth_name": "EPSG",
    "auth_id": "8677",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60314,
    "description": "MGI 1901 / Balkans zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs",
    "srid": 520000314,
    "auth_name": "EPSG",
    "auth_id": "8678",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60315,
    "description": "MGI 1901 / Balkans zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9999 +x_0=8500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs",
    "srid": 520000315,
    "auth_name": "EPSG",
    "auth_id": "8679",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60316,
    "description": "SRB_ETRS89 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000316,
    "auth_name": "EPSG",
    "auth_id": "8682",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60317,
    "description": "SRB_ETRS89",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000317,
    "auth_name": "EPSG",
    "auth_id": "8683",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60318,
    "description": "SRB_ETRS89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000318,
    "auth_name": "EPSG",
    "auth_id": "8684",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60319,
    "description": "SRB_ETRS89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000319,
    "auth_name": "EPSG",
    "auth_id": "8685",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60320,
    "description": "MGI 1901 / Slovenia Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 520000320,
    "auth_name": "EPSG",
    "auth_id": "8686",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60321,
    "description": "Slovenia 1996 / UTM zone 33N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000321,
    "auth_name": "EPSG",
    "auth_id": "8687",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60322,
    "description": "NAD83(MA11) / UTM zone 54N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=54 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000322,
    "auth_name": "EPSG",
    "auth_id": "8692",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60323,
    "description": "NAD83(MA11) / UTM zone 55N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=55 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000323,
    "auth_name": "EPSG",
    "auth_id": "8693",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60324,
    "description": "NAD83 / Arizona East (ft) + NAVD88 height (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000324,
    "auth_name": "EPSG",
    "auth_id": "8700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60325,
    "description": "NAD83 / Arizona Central (ft) + NAVD88 height (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000325,
    "auth_name": "EPSG",
    "auth_id": "8701",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60326,
    "description": "NAD83 / Arizona West (ft) + NAVD88 height (ft)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000326,
    "auth_name": "EPSG",
    "auth_id": "8702",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60327,
    "description": "NAD83 / Michigan North (ft) + NAVD88 height (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=47.0833333333333 +lat_2=45.4833333333333 +x_0=7999999.999968 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000327,
    "auth_name": "EPSG",
    "auth_id": "8703",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60328,
    "description": "NAD83 / Michigan Central (ft) + NAVD88 height (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=45.7 +lat_2=44.1833333333333 +x_0=5999999.999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000328,
    "auth_name": "EPSG",
    "auth_id": "8704",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60329,
    "description": "NAD83 / Michigan South (ft) + NAVD88 height (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=43.6666666666667 +lat_2=42.1 +x_0=3999999.999984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000329,
    "auth_name": "EPSG",
    "auth_id": "8705",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60330,
    "description": "NAD83 / Montana (ft) + NAVD88 height (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000330,
    "auth_name": "EPSG",
    "auth_id": "8706",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60331,
    "description": "NAD83 / North Dakota North (ft) + NAVD88 height (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.7333333333333 +lat_2=47.4333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000331,
    "auth_name": "EPSG",
    "auth_id": "8707",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60332,
    "description": "NAD83 / North Dakota South (ft) + NAVD88 height (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=47.4833333333333 +lat_2=46.1833333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000332,
    "auth_name": "EPSG",
    "auth_id": "8708",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60333,
    "description": "NAD83 / Oregon North (ft) + NAVD88 height (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.6666666666667 +lon_0=-120.5 +lat_1=46 +lat_2=44.3333333333333 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000333,
    "auth_name": "EPSG",
    "auth_id": "8709",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60334,
    "description": "NAD83 / Oregon South (ft) + NAVD88 height (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.6666666666667 +lon_0=-120.5 +lat_1=44 +lat_2=42.3333333333333 +x_0=1500000.0001464 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +vunits=ft +no_defs",
    "srid": 520000334,
    "auth_name": "EPSG",
    "auth_id": "8710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60335,
    "description": "NAD83 / South Carolina (ft) + NAVD88 height (ft)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=34.8333333333333 +lat_2=32.5 +x_0=609600 +y_0=0 +datum=NAD83 +units=ft +vunits=ft +no_defs",
    "srid": 520000335,
    "auth_name": "EPSG",
    "auth_id": "8711",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60336,
    "description": "NAD83 / Arkansas North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=36.2333333333333 +lat_2=34.9333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000336,
    "auth_name": "EPSG",
    "auth_id": "8712",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60337,
    "description": "NAD83 / Arkansas South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=34.7666666666667 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000337,
    "auth_name": "EPSG",
    "auth_id": "8713",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60338,
    "description": "NAD83 / California zone 1 (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=41.6666666666667 +lat_2=40 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000338,
    "auth_name": "EPSG",
    "auth_id": "8714",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60339,
    "description": "NAD83 / California zone 2 (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=39.8333333333333 +lat_2=38.3333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000339,
    "auth_name": "EPSG",
    "auth_id": "8715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60340,
    "description": "NAD83 / California zone 3 (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.4333333333333 +lat_2=37.0666666666667 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000340,
    "auth_name": "EPSG",
    "auth_id": "8716",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60341,
    "description": "NAD83 / California zone 4 (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000341,
    "auth_name": "EPSG",
    "auth_id": "8717",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60342,
    "description": "NAD83 / California zone 5 (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000342,
    "auth_name": "EPSG",
    "auth_id": "8718",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60343,
    "description": "NAD83 / California zone 6 (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=33.8833333333333 +lat_2=32.7833333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000343,
    "auth_name": "EPSG",
    "auth_id": "8719",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60344,
    "description": "NAD83 / Colorado North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=40.7833333333333 +lat_2=39.7166666666667 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000344,
    "auth_name": "EPSG",
    "auth_id": "8720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60345,
    "description": "NAD83 / Colorado Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000345,
    "auth_name": "EPSG",
    "auth_id": "8721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60346,
    "description": "NAD83 / Colorado South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=38.4333333333333 +lat_2=37.2333333333333 +x_0=914401.828803658 +y_0=304800.609601219 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000346,
    "auth_name": "EPSG",
    "auth_id": "8722",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60347,
    "description": "NAD83 / Connecticut (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.8666666666667 +lat_2=41.2 +x_0=304800.609601219 +y_0=152400.30480061 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000347,
    "auth_name": "EPSG",
    "auth_id": "8723",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60348,
    "description": "NAD83 / Delaware (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000348,
    "auth_name": "EPSG",
    "auth_id": "8724",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60349,
    "description": "NAD83 / Florida North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.5833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000349,
    "auth_name": "EPSG",
    "auth_id": "8725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60350,
    "description": "NAD83 / Florida East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000350,
    "auth_name": "EPSG",
    "auth_id": "8726",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60351,
    "description": "NAD83 / Florida West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941177 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000351,
    "auth_name": "EPSG",
    "auth_id": "8727",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60352,
    "description": "NAD83 / Georgia East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000352,
    "auth_name": "EPSG",
    "auth_id": "8728",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60353,
    "description": "NAD83 / Georgia West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000353,
    "auth_name": "EPSG",
    "auth_id": "8729",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60354,
    "description": "NAD83 / Idaho East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000354,
    "auth_name": "EPSG",
    "auth_id": "8730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60355,
    "description": "NAD83 / Idaho Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000355,
    "auth_name": "EPSG",
    "auth_id": "8731",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60356,
    "description": "NAD83 / Idaho West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333 +x_0=800000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000356,
    "auth_name": "EPSG",
    "auth_id": "8732",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60357,
    "description": "NAD83 / Illinois East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000357,
    "auth_name": "EPSG",
    "auth_id": "8733",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60358,
    "description": "NAD83 / Illinois West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941177 +x_0=699999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000358,
    "auth_name": "EPSG",
    "auth_id": "8734",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60359,
    "description": "NAD83 / Indiana East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966667 +x_0=99999.9998983998 +y_0=249999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000359,
    "auth_name": "EPSG",
    "auth_id": "8735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60360,
    "description": "NAD83 / Indiana West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966667 +x_0=900000 +y_0=249999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000360,
    "auth_name": "EPSG",
    "auth_id": "8736",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60361,
    "description": "NAD83 / Iowa North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.2666666666667 +lat_2=42.0666666666667 +x_0=1500000 +y_0=999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000361,
    "auth_name": "EPSG",
    "auth_id": "8737",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60362,
    "description": "NAD83 / Iowa South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.7833333333333 +lat_2=40.6166666666667 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000362,
    "auth_name": "EPSG",
    "auth_id": "8738",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60363,
    "description": "NAD83 / Kansas North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=39.7833333333333 +lat_2=38.7166666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000363,
    "auth_name": "EPSG",
    "auth_id": "8739",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60364,
    "description": "NAD83 / Kansas South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=38.5666666666667 +lat_2=37.2666666666667 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000364,
    "auth_name": "EPSG",
    "auth_id": "8740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60365,
    "description": "NAD83 / Kentucky North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000365,
    "auth_name": "EPSG",
    "auth_id": "8741",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60366,
    "description": "NAD83 / Kentucky South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.9333333333333 +lat_2=36.7333333333333 +x_0=500000.0001016 +y_0=500000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000366,
    "auth_name": "EPSG",
    "auth_id": "8742",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60367,
    "description": "NAD83 / Louisiana North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.6666666666667 +lat_2=31.1666666666667 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000367,
    "auth_name": "EPSG",
    "auth_id": "8743",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60368,
    "description": "NAD83 / Louisiana South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000368,
    "auth_name": "EPSG",
    "auth_id": "8744",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60369,
    "description": "NAD83 / Maine East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000369,
    "auth_name": "EPSG",
    "auth_id": "8745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60370,
    "description": "NAD83 / Maine West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000370,
    "auth_name": "EPSG",
    "auth_id": "8746",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60371,
    "description": "NAD83 / Maryland (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000371,
    "auth_name": "EPSG",
    "auth_id": "8747",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60372,
    "description": "NAD83 / Massachusetts Mainland (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.6833333333333 +lat_2=41.7166666666667 +x_0=200000.0001016 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000372,
    "auth_name": "EPSG",
    "auth_id": "8748",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60373,
    "description": "NAD83 / Massachusetts Island (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.4833333333333 +lat_2=41.2833333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000373,
    "auth_name": "EPSG",
    "auth_id": "8749",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60374,
    "description": "NAD83 / Minnesota North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.6333333333333 +lat_2=47.0333333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000374,
    "auth_name": "EPSG",
    "auth_id": "8750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60375,
    "description": "NAD83 / Minnesota Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.6166666666667 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000375,
    "auth_name": "EPSG",
    "auth_id": "8751",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60376,
    "description": "NAD83 / Minnesota South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.2166666666667 +lat_2=43.7833333333333 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000376,
    "auth_name": "EPSG",
    "auth_id": "8752",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60377,
    "description": "NAD83 / Mississippi East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000377,
    "auth_name": "EPSG",
    "auth_id": "8753",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60378,
    "description": "NAD83 / Mississippi West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000378,
    "auth_name": "EPSG",
    "auth_id": "8754",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60379,
    "description": "NAD83 / Nebraska (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.00001016 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000379,
    "auth_name": "EPSG",
    "auth_id": "8755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60380,
    "description": "NAD83 / Nevada East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000.00001016 +y_0=8000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000380,
    "auth_name": "EPSG",
    "auth_id": "8756",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60381,
    "description": "NAD83 / Nevada Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.00001016 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000381,
    "auth_name": "EPSG",
    "auth_id": "8757",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60382,
    "description": "NAD83 / Nevada West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.00001016 +y_0=3999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000382,
    "auth_name": "EPSG",
    "auth_id": "8758",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60383,
    "description": "NAD83 / New Hampshire (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000383,
    "auth_name": "EPSG",
    "auth_id": "8759",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60384,
    "description": "NAD83 / New Jersey (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000384,
    "auth_name": "EPSG",
    "auth_id": "8760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60385,
    "description": "NAD83 / New Mexico East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000385,
    "auth_name": "EPSG",
    "auth_id": "8761",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60386,
    "description": "NAD83 / New Mexico Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000386,
    "auth_name": "EPSG",
    "auth_id": "8762",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60387,
    "description": "NAD83 / New Mexico West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916667 +x_0=830000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000387,
    "auth_name": "EPSG",
    "auth_id": "8763",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60388,
    "description": "NAD83 / New York East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000388,
    "auth_name": "EPSG",
    "auth_id": "8764",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60389,
    "description": "NAD83 / New York Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=249999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000389,
    "auth_name": "EPSG",
    "auth_id": "8765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60390,
    "description": "NAD83 / New York West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000390,
    "auth_name": "EPSG",
    "auth_id": "8766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60391,
    "description": "NAD83 / New York Long Island (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=41.0333333333333 +lat_2=40.6666666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000391,
    "auth_name": "EPSG",
    "auth_id": "8767",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60392,
    "description": "NAD83 / North Carolina (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.1666666666667 +lat_2=34.3333333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000392,
    "auth_name": "EPSG",
    "auth_id": "8768",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60393,
    "description": "NAD83 / Ohio North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.4333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000393,
    "auth_name": "EPSG",
    "auth_id": "8769",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60394,
    "description": "NAD83 / Ohio South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.0333333333333 +lat_2=38.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000394,
    "auth_name": "EPSG",
    "auth_id": "8770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60395,
    "description": "NAD83 / Oklahoma North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.7666666666667 +lat_2=35.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000395,
    "auth_name": "EPSG",
    "auth_id": "8771",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60396,
    "description": "NAD83 / Oklahoma South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=35.2333333333333 +lat_2=33.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000396,
    "auth_name": "EPSG",
    "auth_id": "8772",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60397,
    "description": "NAD83 / Pennsylvania North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000397,
    "auth_name": "EPSG",
    "auth_id": "8773",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60398,
    "description": "NAD83 / Pennsylvania South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=40.9666666666667 +lat_2=39.9333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000398,
    "auth_name": "EPSG",
    "auth_id": "8774",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60399,
    "description": "NAD83 / Rhode Island (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000399,
    "auth_name": "EPSG",
    "auth_id": "8775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60400,
    "description": "NAD83 / South Dakota North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=45.6833333333333 +lat_2=44.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000400,
    "auth_name": "EPSG",
    "auth_id": "8776",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60401,
    "description": "NAD83 / South Dakota South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=44.4 +lat_2=42.8333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000401,
    "auth_name": "EPSG",
    "auth_id": "8777",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60402,
    "description": "NAD83 / Tennessee (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=36.4166666666667 +lat_2=35.25 +x_0=600000 +y_0=0 +datum=NAD83 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000402,
    "auth_name": "EPSG",
    "auth_id": "8778",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60403,
    "description": "NAD83 / Texas North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.1833333333333 +lat_2=34.65 +x_0=200000.0001016 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000403,
    "auth_name": "EPSG",
    "auth_id": "8779",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60404,
    "description": "NAD83 / Texas North Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=33.9666666666667 +lat_2=32.1333333333333 +x_0=600000 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000404,
    "auth_name": "EPSG",
    "auth_id": "8780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60405,
    "description": "NAD83 / Texas Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=31.8833333333333 +lat_2=30.1166666666667 +x_0=699999.9998984 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000405,
    "auth_name": "EPSG",
    "auth_id": "8781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60406,
    "description": "NAD83 / Texas South Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=30.2833333333333 +lat_2=28.3833333333333 +x_0=600000 +y_0=3999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000406,
    "auth_name": "EPSG",
    "auth_id": "8782",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60407,
    "description": "NAD83 / Texas South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=27.8333333333333 +lat_2=26.1666666666667 +x_0=300000 +y_0=5000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000407,
    "auth_name": "EPSG",
    "auth_id": "8783",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60408,
    "description": "NAD83 / Utah North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=41.7833333333333 +lat_2=40.7166666666667 +x_0=500000.00001016 +y_0=999999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000408,
    "auth_name": "EPSG",
    "auth_id": "8784",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60409,
    "description": "NAD83 / Utah Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.0166666666667 +x_0=500000.00001016 +y_0=2000000.00001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000409,
    "auth_name": "EPSG",
    "auth_id": "8785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60410,
    "description": "NAD83 / Utah South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.2166666666667 +x_0=500000.00001016 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000410,
    "auth_name": "EPSG",
    "auth_id": "8786",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60411,
    "description": "NAD83 / Vermont (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964286 +x_0=500000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000411,
    "auth_name": "EPSG",
    "auth_id": "8787",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60412,
    "description": "NAD83 / Virginia North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.0333333333333 +x_0=3500000.0001016 +y_0=2000000.0001016 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000412,
    "auth_name": "EPSG",
    "auth_id": "8788",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60413,
    "description": "NAD83 / Virginia South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=37.9666666666667 +lat_2=36.7666666666667 +x_0=3500000.0001016 +y_0=999999.9998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000413,
    "auth_name": "EPSG",
    "auth_id": "8789",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60414,
    "description": "NAD83 / Washington North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=48.7333333333333 +lat_2=47.5 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000414,
    "auth_name": "EPSG",
    "auth_id": "8790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60415,
    "description": "NAD83 / Washington South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=47.3333333333333 +lat_2=45.8333333333333 +x_0=500000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000415,
    "auth_name": "EPSG",
    "auth_id": "8791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60416,
    "description": "NAD83 / West Virginia North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000416,
    "auth_name": "EPSG",
    "auth_id": "8792",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60417,
    "description": "NAD83 / West Virginia South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.8833333333333 +lat_2=37.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000417,
    "auth_name": "EPSG",
    "auth_id": "8793",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60418,
    "description": "NAD83 / Wisconsin North (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=46.7666666666667 +lat_2=45.5666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000418,
    "auth_name": "EPSG",
    "auth_id": "8794",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60419,
    "description": "NAD83 / Wisconsin Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000419,
    "auth_name": "EPSG",
    "auth_id": "8795",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60420,
    "description": "NAD83 / Wisconsin South (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.0666666666667 +lat_2=42.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000420,
    "auth_name": "EPSG",
    "auth_id": "8796",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60421,
    "description": "NAD83 / Wyoming East (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000.00001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000421,
    "auth_name": "EPSG",
    "auth_id": "8797",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60422,
    "description": "NAD83 / Wyoming East Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000422,
    "auth_name": "EPSG",
    "auth_id": "8798",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60423,
    "description": "NAD83 / Wyoming West Central (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000423,
    "auth_name": "EPSG",
    "auth_id": "8799",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60424,
    "description": "NAD83 / Wyoming West (ftUS) + NAVD88 height (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.00001016 +y_0=99999.99998984 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +vunits=us-ft +no_defs",
    "srid": 520000424,
    "auth_name": "EPSG",
    "auth_id": "8800",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60425,
    "description": "NAD83 / Alabama East + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000425,
    "auth_name": "EPSG",
    "auth_id": "8801",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60426,
    "description": "NAD83 / Alabama West + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000426,
    "auth_name": "EPSG",
    "auth_id": "8802",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60427,
    "description": "NAD83 / Alaska zone 1 + NAVD88 height",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=323.130102361111 +gamma=323.130102361111 +k=0.9999 +x_0=5000000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000427,
    "auth_name": "EPSG",
    "auth_id": "8803",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60428,
    "description": "NAD83 / Alaska zone 2 + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000428,
    "auth_name": "EPSG",
    "auth_id": "8804",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60429,
    "description": "NAD83 / Alaska zone 3 + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000429,
    "auth_name": "EPSG",
    "auth_id": "8805",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60430,
    "description": "NAD83 / Alaska zone 4 + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000430,
    "auth_name": "EPSG",
    "auth_id": "8806",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60431,
    "description": "NAD83 / Alaska zone 5 + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000431,
    "auth_name": "EPSG",
    "auth_id": "8807",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60432,
    "description": "NAD83 / Alaska zone 6 + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000432,
    "auth_name": "EPSG",
    "auth_id": "8808",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60433,
    "description": "NAD83 / Alaska zone 7 + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000433,
    "auth_name": "EPSG",
    "auth_id": "8809",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60434,
    "description": "NAD83 / Alaska zone 8 + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000434,
    "auth_name": "EPSG",
    "auth_id": "8810",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60435,
    "description": "NAD83 / Alaska zone 9 + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +datum=NAD83 +units=m +vunits=m +no_defs",
    "srid": 520000435,
    "auth_name": "EPSG",
    "auth_id": "8811",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60436,
    "description": "NAD83 / Alaska zone 10 + NAVD88 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.8333333333333 +lat_2=51.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=-2,0,4,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000436,
    "auth_name": "EPSG",
    "auth_id": "8812",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60437,
    "description": "NAD83 / Missouri East + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000437,
    "auth_name": "EPSG",
    "auth_id": "8813",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60438,
    "description": "NAD83 / Missouri Central + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000438,
    "auth_name": "EPSG",
    "auth_id": "8814",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60439,
    "description": "NAD83 / Missouri West + NAVD88 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520000439,
    "auth_name": "EPSG",
    "auth_id": "8815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60440,
    "description": "MTRF-2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000440,
    "auth_name": "EPSG",
    "auth_id": "8816",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60441,
    "description": "MTRF-2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000441,
    "auth_name": "EPSG",
    "auth_id": "8817",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60442,
    "description": "MTRF-2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000442,
    "auth_name": "EPSG",
    "auth_id": "8818",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60443,
    "description": "NAD83 / Idaho Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42 +lon_0=-114 +k=0.9996 +x_0=2500000 +y_0=1200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000443,
    "auth_name": "EPSG",
    "auth_id": "8826",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60444,
    "description": "MTRF-2000 / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000444,
    "auth_name": "EPSG",
    "auth_id": "8836",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60445,
    "description": "MTRF-2000 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000445,
    "auth_name": "EPSG",
    "auth_id": "8837",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60446,
    "description": "MTRF-2000 / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000446,
    "auth_name": "EPSG",
    "auth_id": "8838",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60447,
    "description": "MTRF-2000 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000447,
    "auth_name": "EPSG",
    "auth_id": "8839",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60448,
    "description": "MTRF-2000 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=40 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000448,
    "auth_name": "EPSG",
    "auth_id": "8840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60449,
    "description": "WGS 84 / Equal Earth Greenwich",
    "projection_acronym": "eqearth",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqearth +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000449,
    "auth_name": "EPSG",
    "auth_id": "8857",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60450,
    "description": "WGS 84 / Equal Earth Americas",
    "projection_acronym": "eqearth",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqearth +lon_0=-90 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000450,
    "auth_name": "EPSG",
    "auth_id": "8858",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60451,
    "description": "WGS 84 / Equal Earth Asia-Pacific",
    "projection_acronym": "eqearth",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqearth +lon_0=150 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000451,
    "auth_name": "EPSG",
    "auth_id": "8859",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60452,
    "description": "NAD83(FBN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000452,
    "auth_name": "EPSG",
    "auth_id": "8860",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60453,
    "description": "RGWF96",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000453,
    "auth_name": "EPSG",
    "auth_id": "8898",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60454,
    "description": "RGWF96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000454,
    "auth_name": "EPSG",
    "auth_id": "8899",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60455,
    "description": "RGWF96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520000455,
    "auth_name": "EPSG",
    "auth_id": "8900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60456,
    "description": "RGWF96 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000456,
    "auth_name": "EPSG",
    "auth_id": "8901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60457,
    "description": "RGWF96 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000457,
    "auth_name": "EPSG",
    "auth_id": "8902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60458,
    "description": "RGWF96 / UTM zone 1S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=1 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000458,
    "auth_name": "EPSG",
    "auth_id": "8903",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60459,
    "description": "CR-SIRGAS",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000459,
    "auth_name": "EPSG",
    "auth_id": "8905",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60460,
    "description": "CR-SIRGAS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000460,
    "auth_name": "EPSG",
    "auth_id": "8906",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60461,
    "description": "CR-SIRGAS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000461,
    "auth_name": "EPSG",
    "auth_id": "8907",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60462,
    "description": "CR-SIRGAS / CRTM05",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000462,
    "auth_name": "EPSG",
    "auth_id": "8908",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60463,
    "description": "CR-SIRGAS / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000463,
    "auth_name": "EPSG",
    "auth_id": "8909",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60464,
    "description": "CR-SIRGAS / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000464,
    "auth_name": "EPSG",
    "auth_id": "8910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60465,
    "description": "CR-SIRGAS / CRTM05 + DACR52 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 520000465,
    "auth_name": "EPSG",
    "auth_id": "8912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 60466,
    "description": "ITRF88",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000466,
    "auth_name": "EPSG",
    "auth_id": "8988",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60467,
    "description": "ITRF89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000467,
    "auth_name": "EPSG",
    "auth_id": "8989",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60468,
    "description": "ITRF90",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000468,
    "auth_name": "EPSG",
    "auth_id": "8990",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60469,
    "description": "ITRF91",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000469,
    "auth_name": "EPSG",
    "auth_id": "8991",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60470,
    "description": "ITRF92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000470,
    "auth_name": "EPSG",
    "auth_id": "8992",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60471,
    "description": "ITRF93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000471,
    "auth_name": "EPSG",
    "auth_id": "8993",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60472,
    "description": "ITRF94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000472,
    "auth_name": "EPSG",
    "auth_id": "8994",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60473,
    "description": "ITRF96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000473,
    "auth_name": "EPSG",
    "auth_id": "8995",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60474,
    "description": "ITRF97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000474,
    "auth_name": "EPSG",
    "auth_id": "8996",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60475,
    "description": "ITRF2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000475,
    "auth_name": "EPSG",
    "auth_id": "8997",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60476,
    "description": "ITRF2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000476,
    "auth_name": "EPSG",
    "auth_id": "8998",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60477,
    "description": "ITRF2008",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000477,
    "auth_name": "EPSG",
    "auth_id": "8999",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60478,
    "description": "ITRF2014",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000478,
    "auth_name": "EPSG",
    "auth_id": "9000",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60479,
    "description": "IGS97",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000479,
    "auth_name": "EPSG",
    "auth_id": "9001",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60480,
    "description": "IGS97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000480,
    "auth_name": "EPSG",
    "auth_id": "9002",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60481,
    "description": "IGS97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000481,
    "auth_name": "EPSG",
    "auth_id": "9003",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60482,
    "description": "IGS00",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000482,
    "auth_name": "EPSG",
    "auth_id": "9004",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60483,
    "description": "IGS00",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000483,
    "auth_name": "EPSG",
    "auth_id": "9005",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60484,
    "description": "IGS00",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000484,
    "auth_name": "EPSG",
    "auth_id": "9006",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60485,
    "description": "IGb00",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000485,
    "auth_name": "EPSG",
    "auth_id": "9007",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60486,
    "description": "IGb00",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000486,
    "auth_name": "EPSG",
    "auth_id": "9008",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60487,
    "description": "IGb00",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000487,
    "auth_name": "EPSG",
    "auth_id": "9009",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60488,
    "description": "IGS05",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000488,
    "auth_name": "EPSG",
    "auth_id": "9010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60489,
    "description": "IGS05",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000489,
    "auth_name": "EPSG",
    "auth_id": "9011",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60490,
    "description": "IGS05",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000490,
    "auth_name": "EPSG",
    "auth_id": "9012",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60491,
    "description": "IGS08",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000491,
    "auth_name": "EPSG",
    "auth_id": "9013",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60492,
    "description": "IGS08",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000492,
    "auth_name": "EPSG",
    "auth_id": "9014",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60493,
    "description": "IGb08",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520000493,
    "auth_name": "EPSG",
    "auth_id": "9015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 60494,
    "description": "IGb08",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000494,
    "auth_name": "EPSG",
    "auth_id": "9016",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60495,
    "description": "IGb08",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000495,
    "auth_name": "EPSG",
    "auth_id": "9017",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60496,
    "description": "IGS14",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000496,
    "auth_name": "EPSG",
    "auth_id": "9018",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 60497,
    "description": "IGS14",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520000497,
    "auth_name": "EPSG",
    "auth_id": "9019",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 60498,
    "description": "North_Pole_Gnomonic",
    "projection_acronym": "gnom",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=gnom +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000498,
    "auth_name": "ESRI",
    "auth_id": "102034",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60499,
    "description": "North_Pole_Orthographic",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=ortho +f=0 +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000499,
    "auth_name": "ESRI",
    "auth_id": "102035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60500,
    "description": "South_Pole_Gnomonic",
    "projection_acronym": "gnom",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=gnom +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000500,
    "auth_name": "ESRI",
    "auth_id": "102036",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60501,
    "description": "South_Pole_Orthographic",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=ortho +f=0 +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000501,
    "auth_name": "ESRI",
    "auth_id": "102037",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60502,
    "description": "The_World_From_Space",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "sphere",
    "parameters": "+proj=ortho +lat_0=42.5333333333 +lon_0=-72.5333333334 +x_0=0 +y_0=0 +ellps=sphere +units=m +no_defs",
    "srid": 520000502,
    "auth_name": "ESRI",
    "auth_id": "102038",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60503,
    "description": "USA_Contiguous_Albers_Equal_Area_Conic_USGS_version",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=23 +lon_0=-96 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000503,
    "auth_name": "ESRI",
    "auth_id": "102039",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60505,
    "description": "COB_NAD83_2007",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=47.5 +lat_2=48.7333333333333 +x_0=500000.070104141 +y_0=0.0731521463042926 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520000505,
    "auth_name": "ESRI",
    "auth_id": "102041",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60506,
    "description": "NAD_1983_USFS_R9_Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=35 +lon_0=-82.25 +lat_1=38.25 +lat_2=47.25 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000506,
    "auth_name": "ESRI",
    "auth_id": "102042",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60507,
    "description": "NAD_1983_CORS96_UTM_Zone_20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000507,
    "auth_name": "ESRI",
    "auth_id": "102043",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60508,
    "description": "NAD_1983_NSRS2007_UTM_Zone_20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000508,
    "auth_name": "ESRI",
    "auth_id": "102044",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60509,
    "description": "NAD_1983_2011_UTM_Zone_20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000509,
    "auth_name": "ESRI",
    "auth_id": "102045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60524,
    "description": "D48_Slovenia_TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +towgs84=426.62,142.62,460.09,4.98,4.49,-12.42,-17.1 +units=m +no_defs",
    "srid": 520000524,
    "auth_name": "ESRI",
    "auth_id": "102060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60525,
    "description": "Everest_Modified_1969_RSO_Malaya_Meters",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "evrst69",
    "parameters": "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=-36.974209437118 +gamma=-36.869897645844 +k=0.99984 +x_0=804670.24 +y_0=0 +ellps=evrst69 +units=m +no_defs",
    "srid": 520000525,
    "auth_name": "ESRI",
    "auth_id": "102061",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60526,
    "description": "Kertau_RSO_Malaya_Meters",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "evrst48",
    "parameters": "+proj=omerc +no_uoff +lat_0=4 +lonc=102.25 +alpha=-36.974209437118 +gamma=-36.869897645844 +k=0.99984 +x_0=804671.299775 +y_0=0 +ellps=evrst48 +towgs84=-11,851,5,0,0,0,0 +units=m +no_defs",
    "srid": 520000526,
    "auth_name": "ESRI",
    "auth_id": "102062",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60527,
    "description": "Kandawala_Ceylon_Belt_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=tmerc +lat_0=7.00048027777778 +lon_0=80.7717111111111 +k=1 +x_0=160933.56048 +y_0=160933.56048 +ellps=evrst30 +towgs84=-97,787,86,0,0,0,0 +units=m +no_defs",
    "srid": 520000527,
    "auth_name": "ESRI",
    "auth_id": "102063",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60528,
    "description": "Kandawala_Ceylon_Belt_Indian_Yards_1937",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=tmerc +lat_0=7.00048027777778 +lon_0=80.7717111111111 +k=1 +x_0=160933.56048 +y_0=160933.56048 +ellps=evrst30 +towgs84=-97,787,86,0,0,0,0 +units=ind-yd +no_defs",
    "srid": 520000528,
    "auth_name": "ESRI",
    "auth_id": "102064",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60529,
    "description": "EMEP_50_Kilometer_Grid",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "",
    "parameters": "+proj=stere +lat_0=90 +lat_ts=60 +lon_0=-32 +x_0=400000 +y_0=5500000 +R=6370000 +to_meter=50000 +no_defs",
    "srid": 520000529,
    "auth_name": "ESRI",
    "auth_id": "102068",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60530,
    "description": "EMEP_150_Kilometer_Grid",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "",
    "parameters": "+proj=stere +lat_0=90 +lat_ts=60 +lon_0=-32 +x_0=450000 +y_0=5550000 +R=6370000 +to_meter=150000 +no_defs",
    "srid": 520000530,
    "auth_name": "ESRI",
    "auth_id": "102069",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60531,
    "description": "Guernsey_Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=49.5 +lon_0=-2.41666666666667 +k=0.999997 +x_0=47000 +y_0=50000 +datum=WGS84 +units=m +no_defs",
    "srid": 520000531,
    "auth_name": "ESRI",
    "auth_id": "102070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60532,
    "description": "AGD_1966_ACT_Grid_AGC_Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=149.009294833333 +k=1.000086 +x_0=200000 +y_0=4510193.4939 +ellps=aust_SA +towgs84=-129.193,-41.212,130.73,0.246,0.374,0.329,-2.955 +units=m +no_defs",
    "srid": 520000532,
    "auth_name": "ESRI",
    "auth_id": "102071",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60533,
    "description": "AGD_1966_ISG_54_2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 520000533,
    "auth_name": "ESRI",
    "auth_id": "102072",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60534,
    "description": "AGD_1966_ISG_54_3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=143 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 520000534,
    "auth_name": "ESRI",
    "auth_id": "102073",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60535,
    "description": "AGD_1966_ISG_55_1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=145 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 520000535,
    "auth_name": "ESRI",
    "auth_id": "102074",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60536,
    "description": "AGD_1966_ISG_55_2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 520000536,
    "auth_name": "ESRI",
    "auth_id": "102075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60537,
    "description": "AGD_1966_ISG_55_3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=149 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 520000537,
    "auth_name": "ESRI",
    "auth_id": "102076",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60538,
    "description": "AGD_1966_ISG_56_1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=151 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 520000538,
    "auth_name": "ESRI",
    "auth_id": "102077",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60539,
    "description": "AGD_1966_ISG_56_2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 520000539,
    "auth_name": "ESRI",
    "auth_id": "102078",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60540,
    "description": "AGD_1966_ISG_56_3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "aust_SA",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=155 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 520000540,
    "auth_name": "ESRI",
    "auth_id": "102079",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60552,
    "description": "Roma_1940_Gauss_Boaga_Est",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 520000552,
    "auth_name": "ESRI",
    "auth_id": "102093",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60553,
    "description": "Roma_1940_Gauss_Boaga_Ovest",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 520000553,
    "auth_name": "ESRI",
    "auth_id": "102094",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60555,
    "description": "Bab_South_Palau_Azimuthal_Equidistant",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=aeqd +lat_0=7.35122211111111 +lon_0=134.450444861111 +x_0=50000 +y_0=150000 +ellps=clrk66 +towgs84=-185.583,-230.096,281.361,0,0,0,0 +units=m +no_defs",
    "srid": 520000555,
    "auth_name": "ESRI",
    "auth_id": "102096",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60560,
    "description": "ETRS_1989_Slovenia_TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000560,
    "auth_name": "ESRI",
    "auth_id": "102109",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60564,
    "description": "American_Samoa_1962_UTM_Zone_2S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=2 +south +ellps=clrk66 +units=m +no_defs",
    "srid": 520000564,
    "auth_name": "ESRI",
    "auth_id": "102116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60565,
    "description": "NAD_1927_Alaska_Albers_Meters",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "NAD27",
    "parameters": "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 520000565,
    "auth_name": "ESRI",
    "auth_id": "102117",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60566,
    "description": "NAD_1927_Georgia_Statewide_Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=aea +lat_0=23 +lon_0=-83.5 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 520000566,
    "auth_name": "ESRI",
    "auth_id": "102118",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60576,
    "description": "NGO_1948_Baerum_Kommune",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=10.7229166666667 +k=1 +x_0=19999.32 +y_0=-202977.79 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 520000576,
    "auth_name": "ESRI",
    "auth_id": "102136",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60577,
    "description": "NGO_1948_Bergenhalvoen",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=6.05625 +k=1 +x_0=100000 +y_0=-200000 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 520000577,
    "auth_name": "ESRI",
    "auth_id": "102137",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60578,
    "description": "NGO_1948_Oslo_Kommune",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=10.7229166666667 +k=1 +x_0=0 +y_0=-212979.18 +a=6377492.018 +rf=299.1528128 +towgs84=319.08,37.81,463.57,6.2970588,-1.2903926,-5.712916338,10.819 +units=m +no_defs",
    "srid": 520000578,
    "auth_name": "ESRI",
    "auth_id": "102138",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60580,
    "description": "QND_1995_UTM_39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=39 +ellps=intl +units=m +no_defs",
    "srid": 520000580,
    "auth_name": "ESRI",
    "auth_id": "102143",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60581,
    "description": "Merchich_UTM_Zone_28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=utm +zone=28 +ellps=clrk80ign +units=m +no_defs",
    "srid": 520000581,
    "auth_name": "ESRI",
    "auth_id": "102144",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60587,
    "description": "JGD_2000_UTM_Zone_56N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=56 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000587,
    "auth_name": "ESRI",
    "auth_id": "102150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60588,
    "description": "ETRS_1989_Kosovo_Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000588,
    "auth_name": "ESRI",
    "auth_id": "102157",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60589,
    "description": "Jordan_JTM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=37 +k=0.9998 +x_0=500000 +y_0=-3000000 +ellps=intl +towgs84=-86,-98,-119,0,0,0,0 +units=m +no_defs",
    "srid": 520000589,
    "auth_name": "ESRI",
    "auth_id": "102158",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60590,
    "description": "Observatorio_Meteorologico_1965_Macau_Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=22.2123972222222 +lon_0=113.536469444444 +k=1 +x_0=20000 +y_0=20000 +ellps=intl +towgs84=148.635396,339.470115,157.265381,-32.87685,76.963371,32.622853,-8.204889 +units=m +no_defs",
    "srid": 520000590,
    "auth_name": "ESRI",
    "auth_id": "102159",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60594,
    "description": "ETRS_1989_UWPP_1992",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000594,
    "auth_name": "ESRI",
    "auth_id": "102173",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60595,
    "description": "ETRS_1989_UWPP_2000_PAS_5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000595,
    "auth_name": "ESRI",
    "auth_id": "102174",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60596,
    "description": "ETRS_1989_UWPP_2000_PAS_6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000596,
    "auth_name": "ESRI",
    "auth_id": "102175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60597,
    "description": "ETRS_1989_UWPP_2000_PAS_7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000597,
    "auth_name": "ESRI",
    "auth_id": "102176",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60598,
    "description": "ETRS_1989_UWPP_2000_PAS_8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000598,
    "auth_name": "ESRI",
    "auth_id": "102177",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60599,
    "description": "NAD_1927_10TM_AEP_Forest",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=500000 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 520000599,
    "auth_name": "ESRI",
    "auth_id": "102178",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60600,
    "description": "NAD_1927_10TM_AEP_Resource",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-115 +k=0.9992 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 520000600,
    "auth_name": "ESRI",
    "auth_id": "102179",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60612,
    "description": "UWPP_1992",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000612,
    "auth_name": "ESRI",
    "auth_id": "102194",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60613,
    "description": "UWPP_2000_PAS_5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000613,
    "auth_name": "ESRI",
    "auth_id": "102195",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60614,
    "description": "UWPP_2000_PAS_6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000614,
    "auth_name": "ESRI",
    "auth_id": "102196",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60615,
    "description": "UWPP_2000_PAS_7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000615,
    "auth_name": "ESRI",
    "auth_id": "102197",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60616,
    "description": "UWPP_2000_PAS_8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000616,
    "auth_name": "ESRI",
    "auth_id": "102198",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60622,
    "description": "Ain_el_Abd_1970_Aramco_Lambert_2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=24 +lon_0=45 +lat_1=21 +lat_2=27 +x_0=1000000 +y_0=3000000 +ellps=intl +towgs84=-143,-236,7,0,0,0,0 +units=m +no_defs",
    "srid": 520000622,
    "auth_name": "ESRI",
    "auth_id": "102204",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60631,
    "description": "NAD_1983_UTM_Zone_58N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=utm +zone=58 +datum=NAD83 +units=m +no_defs",
    "srid": 520000631,
    "auth_name": "ESRI",
    "auth_id": "102213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60633,
    "description": "WGS_1984_Canada_Atlas_LCC",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=-95 +lat_1=49 +lat_2=77 +x_0=0 +y_0=-8000000 +datum=WGS84 +units=m +no_defs",
    "srid": 520000633,
    "auth_name": "ESRI",
    "auth_id": "102215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60634,
    "description": "GDA_1994_Perth_Coastal_Grid_1994",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.816666666667 +k=0.99999906 +x_0=50000 +y_0=3800000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000634,
    "auth_name": "ESRI",
    "auth_id": "102216",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60635,
    "description": "NAD_1983_NSRS2007_Wisconsin_TM_US_Ft",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4479999.99999999 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000635,
    "auth_name": "ESRI",
    "auth_id": "102217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60637,
    "description": "NAD_1983_Wisconsin_TM_US_Ft",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4479999.99999999 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520000637,
    "auth_name": "ESRI",
    "auth_id": "102219",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60638,
    "description": "NAD_1983_HARN_Wisconsin_TM_US_Ft",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4479999.99999999 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520000638,
    "auth_name": "ESRI",
    "auth_id": "102220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60639,
    "description": "Ocotepeque_1935_Costa_Rica_Lambert_Norte",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=10.4666666666667 +lon_0=-84.3333333333333 +lat_1=9.93333333333333 +lat_2=11 +x_0=500000 +y_0=271820.522 +ellps=clrk66 +towgs84=6.41,-49.05,-11.28,1.5657,0.5242,6.9718,-5.7649 +units=m +no_defs",
    "srid": 520000639,
    "auth_name": "ESRI",
    "auth_id": "102221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60640,
    "description": "Ocotepeque_1935_Costa_Rica_Lambert_Sur",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=9 +lon_0=-83.6666666666667 +lat_1=8.46666666666667 +lat_2=9.53333333333333 +x_0=500000 +y_0=327987.436 +ellps=clrk66 +towgs84=6.41,-49.05,-11.28,1.5657,0.5242,6.9718,-5.7649 +units=m +no_defs",
    "srid": 520000640,
    "auth_name": "ESRI",
    "auth_id": "102222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60641,
    "description": "WGS_1984_Costa_Rica_TM_90",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9996 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000641,
    "auth_name": "ESRI",
    "auth_id": "102223",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60642,
    "description": "MONREF_1997_UTM_Zone_46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=46 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000642,
    "auth_name": "ESRI",
    "auth_id": "102224",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60643,
    "description": "MONREF_1997_UTM_Zone_47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=47 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000643,
    "auth_name": "ESRI",
    "auth_id": "102225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60644,
    "description": "MONREF_1997_UTM_Zone_48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=48 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000644,
    "auth_name": "ESRI",
    "auth_id": "102226",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60645,
    "description": "MONREF_1997_UTM_Zone_49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=49 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000645,
    "auth_name": "ESRI",
    "auth_id": "102227",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60646,
    "description": "MONREF_1997_UTM_Zone_50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=50 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000646,
    "auth_name": "ESRI",
    "auth_id": "102228",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60647,
    "description": "Colombia_West_West_Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=4.59904722222222 +lon_0=-80.0809166666667 +k=1 +x_0=1000000 +y_0=1000000 +ellps=intl +units=m +no_defs",
    "srid": 520000647,
    "auth_name": "ESRI",
    "auth_id": "102231",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60648,
    "description": "Bogota_Ciudad_Bogota",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=4.68333333333333 +lon_0=-74.15 +k=1.00039978753252 +x_0=92334.879 +y_0=109320.965 +ellps=intl +towgs84=221.899,274.136,-397.554,-2.80844591036278,0.44850858891268,2.81017234679107,-2.199943 +units=m +no_defs",
    "srid": 520000648,
    "auth_name": "ESRI",
    "auth_id": "102232",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60649,
    "description": "MAGNA_Ciudad_Bogota",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=4.68048611111111 +lon_0=-74.1465916666667 +k=1.00039980326544 +x_0=92334.879 +y_0=109320.965 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000649,
    "auth_name": "ESRI",
    "auth_id": "102233",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60653,
    "description": "Pohnpei_Az_Eq_1971",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=aeqd +lat_0=6.96507569444444 +lon_0=158.209299222222 +x_0=80122.82 +y_0=80747.24 +ellps=clrk66 +towgs84=-89.121,-348.182,260.871,0,0,0,0 +units=m +no_defs",
    "srid": 520000653,
    "auth_name": "ESRI",
    "auth_id": "102237",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60654,
    "description": "Saipan_Az_Eq_1969",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=aeqd +lat_0=15.1675572222222 +lon_0=145.711286944444 +x_0=50000 +y_0=50000 +ellps=clrk66 +units=m +no_defs",
    "srid": 520000654,
    "auth_name": "ESRI",
    "auth_id": "102238",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60655,
    "description": "Guam_Geodetic_Triangulation_Network_1963",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=aeqd +lat_0=13.4724663527778 +lon_0=144.748750705556 +x_0=50000 +y_0=50000 +ellps=clrk66 +units=m +no_defs",
    "srid": 520000655,
    "auth_name": "ESRI",
    "auth_id": "102239",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60656,
    "description": "Guam_Geodetic_Network_1993",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +towgs84=-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0 +units=m +no_defs",
    "srid": 520000656,
    "auth_name": "ESRI",
    "auth_id": "102240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60657,
    "description": "NAD_1983_CORS96_Alaska_Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=50 +lon_0=-154 +lat_1=55 +lat_2=65 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000657,
    "auth_name": "ESRI",
    "auth_id": "102247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60660,
    "description": "Berghaus_Star_AAG",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000660,
    "auth_name": "ESRI",
    "auth_id": "102299",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60662,
    "description": "Nepal_Nagarkot_TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "evrst30",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=0.9999 +x_0=500000 +y_0=0 +ellps=evrst30 +towgs84=293.17,726.18,245.36,0,0,0,0 +units=m +no_defs",
    "srid": 520000662,
    "auth_name": "ESRI",
    "auth_id": "102306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60663,
    "description": "CGRS_1993_LTM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=0.99995 +x_0=200000 +y_0=-3500000 +ellps=WGS84 +towgs84=8.846,-4.394,-1.122,-0.00237,-0.146528,0.130428,0.783926 +units=m +no_defs",
    "srid": 520000663,
    "auth_name": "ESRI",
    "auth_id": "102319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60664,
    "description": "ETRS_1989_UTM_Zone_32N_7stellen",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=2500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000664,
    "auth_name": "ESRI",
    "auth_id": "102328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60665,
    "description": "ETRS_1989_UTM_Zone_32N_8stellen",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000665,
    "auth_name": "ESRI",
    "auth_id": "102329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60669,
    "description": "ETRS_1989_UTM_Zone_33N_7stellen",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=3500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000669,
    "auth_name": "ESRI",
    "auth_id": "102359",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60670,
    "description": "ETRS_1989_UTM_Zone_33N_8stellen",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000670,
    "auth_name": "ESRI",
    "auth_id": "102360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60673,
    "description": "NAD_1983_CORS96_UTM_Zone_59N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=59 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000673,
    "auth_name": "ESRI",
    "auth_id": "102364",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60674,
    "description": "NAD_1983_CORS96_UTM_Zone_60N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=60 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000674,
    "auth_name": "ESRI",
    "auth_id": "102365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60675,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_1_FIPS_5001",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=-36.8698976458333 +gamma=-36.8698976458333 +k=0.9999 +x_0=5000000 +y_0=-5000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000675,
    "auth_name": "ESRI",
    "auth_id": "102366",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60676,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_2_FIPS_5002",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000676,
    "auth_name": "ESRI",
    "auth_id": "102367",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60677,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_3_FIPS_5003",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000677,
    "auth_name": "ESRI",
    "auth_id": "102368",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60678,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_4_FIPS_5004",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000678,
    "auth_name": "ESRI",
    "auth_id": "102369",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60679,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_5_FIPS_5005",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000679,
    "auth_name": "ESRI",
    "auth_id": "102370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60680,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_6_FIPS_5006",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000680,
    "auth_name": "ESRI",
    "auth_id": "102371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60681,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_7_FIPS_5007",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000681,
    "auth_name": "ESRI",
    "auth_id": "102372",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60682,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_8_FIPS_5008",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000682,
    "auth_name": "ESRI",
    "auth_id": "102373",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60683,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_9_FIPS_5009",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000683,
    "auth_name": "ESRI",
    "auth_id": "102374",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60684,
    "description": "NAD_1983_CORS96_StatePlane_Alaska_10_FIPS_5010",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=51.8333333333333 +lat_2=53.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000684,
    "auth_name": "ESRI",
    "auth_id": "102375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60698,
    "description": "NAD_1983_Fargo_Ground_Coordinate_System",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=46.9916361111111 +lonc=-96.8888638888889 +alpha=2.63389226 +gamma=0 +k=1.000038773618 +x_0=874578.083820168 +y_0=-5077268.7778918 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000698,
    "auth_name": "ESRI",
    "auth_id": "102389",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60699,
    "description": "NAD_1983_HARN_Fargo_Ground_Coordinate_System",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=46.9916361111111 +lonc=-96.8888638888889 +alpha=2.63389226 +gamma=0 +k=1.000038773618 +x_0=874578.083820168 +y_0=-5077268.7778918 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 520000699,
    "auth_name": "ESRI",
    "auth_id": "102390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60700,
    "description": "NAD_1983_2011_Fargo_Ground_Coordinate_System",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=46.9916361111111 +lonc=-96.8888638888889 +alpha=2.63389226 +gamma=0 +k=1.000038773618 +x_0=874578.083820168 +y_0=-5077268.7778918 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000700,
    "auth_name": "ESRI",
    "auth_id": "102391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60701,
    "description": "NAD_1983_2011_StatePlane_Alaska_4_FIPS_5004_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000701,
    "auth_name": "ESRI",
    "auth_id": "102392",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60702,
    "description": "NAD_1983_2011_StatePlane_Alaska_5_FIPS_5005_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000702,
    "auth_name": "ESRI",
    "auth_id": "102393",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60703,
    "description": "NAD_1983_2011_StatePlane_Alaska_6_FIPS_5006_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000703,
    "auth_name": "ESRI",
    "auth_id": "102394",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60704,
    "description": "NAD_1983_2011_StatePlane_Alaska_7_FIPS_5007_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000704,
    "auth_name": "ESRI",
    "auth_id": "102395",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60705,
    "description": "NAD_1983_2011_StatePlane_Alaska_8_FIPS_5008_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000705,
    "auth_name": "ESRI",
    "auth_id": "102396",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60706,
    "description": "NAD_1983_2011_StatePlane_Alaska_9_FIPS_5009_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000706,
    "auth_name": "ESRI",
    "auth_id": "102397",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60707,
    "description": "NAD_1983_2011_StatePlane_Alaska_10_FIPS_5010_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=51.8333333333333 +lat_2=53.8333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000707,
    "auth_name": "ESRI",
    "auth_id": "102398",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60708,
    "description": "NAD_1983_Albers_BLM_MT_ND_SD",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=42.5 +lon_0=-106 +lat_1=43.5 +lat_2=48 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000708,
    "auth_name": "ESRI",
    "auth_id": "102399",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60709,
    "description": "London_Survey_Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=51.1666666666667 +lon_0=-0.158333333333333 +k=0.9999999 +x_0=78250 +y_0=-2800 +ellps=WGS84 +towgs84=19.019,115.122,-97.287,3.577824,-3.484437,-2.767646,18.6084754 +units=m +no_defs",
    "srid": 520000709,
    "auth_name": "ESRI",
    "auth_id": "102400",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60710,
    "description": "NAD_1983_CORS96_UTM_Zone_1N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=1 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000710,
    "auth_name": "ESRI",
    "auth_id": "102401",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60711,
    "description": "NAD_1983_CORS96_UTM_Zone_2N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=2 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000711,
    "auth_name": "ESRI",
    "auth_id": "102402",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60712,
    "description": "NAD_1983_CORS96_UTM_Zone_3N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=3 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000712,
    "auth_name": "ESRI",
    "auth_id": "102403",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60713,
    "description": "NAD_1983_CORS96_UTM_Zone_4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=4 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000713,
    "auth_name": "ESRI",
    "auth_id": "102404",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60714,
    "description": "NAD_1983_CORS96_UTM_Zone_5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000714,
    "auth_name": "ESRI",
    "auth_id": "102405",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60715,
    "description": "NAD_1983_CORS96_UTM_Zone_6N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=6 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000715,
    "auth_name": "ESRI",
    "auth_id": "102406",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60716,
    "description": "NAD_1983_CORS96_UTM_Zone_7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000716,
    "auth_name": "ESRI",
    "auth_id": "102407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60717,
    "description": "NAD_1983_CORS96_UTM_Zone_8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000717,
    "auth_name": "ESRI",
    "auth_id": "102408",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60718,
    "description": "NAD_1983_CORS96_UTM_Zone_9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000718,
    "auth_name": "ESRI",
    "auth_id": "102409",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60719,
    "description": "NAD_1983_CORS96_UTM_Zone_10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000719,
    "auth_name": "ESRI",
    "auth_id": "102410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60720,
    "description": "NAD_1983_CORS96_UTM_Zone_11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000720,
    "auth_name": "ESRI",
    "auth_id": "102411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60721,
    "description": "NAD_1983_CORS96_UTM_Zone_12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000721,
    "auth_name": "ESRI",
    "auth_id": "102412",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60722,
    "description": "NAD_1983_CORS96_UTM_Zone_13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000722,
    "auth_name": "ESRI",
    "auth_id": "102413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60723,
    "description": "NAD_1983_CORS96_UTM_Zone_14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000723,
    "auth_name": "ESRI",
    "auth_id": "102414",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60724,
    "description": "NAD_1983_CORS96_UTM_Zone_15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000724,
    "auth_name": "ESRI",
    "auth_id": "102415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60725,
    "description": "NAD_1983_CORS96_UTM_Zone_16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000725,
    "auth_name": "ESRI",
    "auth_id": "102416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60726,
    "description": "NAD_1983_CORS96_UTM_Zone_17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000726,
    "auth_name": "ESRI",
    "auth_id": "102417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60727,
    "description": "NAD_1983_CORS96_UTM_Zone_18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000727,
    "auth_name": "ESRI",
    "auth_id": "102418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60728,
    "description": "NAD_1983_CORS96_UTM_Zone_19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520000728,
    "auth_name": "ESRI",
    "auth_id": "102419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60730,
    "description": "WGS_1984_ARC_System_Zone_01",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=22.94791772 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000730,
    "auth_name": "ESRI",
    "auth_id": "102421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60731,
    "description": "WGS_1984_ARC_System_Zone_02",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=41.12682127 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000731,
    "auth_name": "ESRI",
    "auth_id": "102422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60732,
    "description": "WGS_1984_ARC_System_Zone_03",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=52.28859923 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000732,
    "auth_name": "ESRI",
    "auth_id": "102423",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60733,
    "description": "WGS_1984_ARC_System_Zone_04",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=60.32378942 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000733,
    "auth_name": "ESRI",
    "auth_id": "102424",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60734,
    "description": "WGS_1984_ARC_System_Zone_05",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=66.09421768 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000734,
    "auth_name": "ESRI",
    "auth_id": "102425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60735,
    "description": "WGS_1984_ARC_System_Zone_06",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=70.10896259 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000735,
    "auth_name": "ESRI",
    "auth_id": "102426",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60736,
    "description": "WGS_1984_ARC_System_Zone_07",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=74.13230145 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000736,
    "auth_name": "ESRI",
    "auth_id": "102427",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60737,
    "description": "WGS_1984_ARC_System_Zone_08",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=78.1728375 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000737,
    "auth_name": "ESRI",
    "auth_id": "102428",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60738,
    "description": "WGS_1984_ARC_System_Zone_09",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aeqd +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000738,
    "auth_name": "ESRI",
    "auth_id": "102429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60739,
    "description": "WGS_1984_ARC_System_Zone_10",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-22.94791772 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000739,
    "auth_name": "ESRI",
    "auth_id": "102430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60740,
    "description": "WGS_1984_ARC_System_Zone_11",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-41.12682127 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000740,
    "auth_name": "ESRI",
    "auth_id": "102431",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60741,
    "description": "WGS_1984_ARC_System_Zone_12",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-52.28859923 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000741,
    "auth_name": "ESRI",
    "auth_id": "102432",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60742,
    "description": "WGS_1984_ARC_System_Zone_13",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-60.32378942 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000742,
    "auth_name": "ESRI",
    "auth_id": "102433",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60743,
    "description": "WGS_1984_ARC_System_Zone_14",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-66.09421768 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000743,
    "auth_name": "ESRI",
    "auth_id": "102434",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60744,
    "description": "WGS_1984_ARC_System_Zone_15",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-70.10896259 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000744,
    "auth_name": "ESRI",
    "auth_id": "102435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60745,
    "description": "WGS_1984_ARC_System_Zone_16",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-74.13230145 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000745,
    "auth_name": "ESRI",
    "auth_id": "102436",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60746,
    "description": "WGS_1984_ARC_System_Zone_17",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-78.1728375 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000746,
    "auth_name": "ESRI",
    "auth_id": "102437",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60747,
    "description": "WGS_1984_ARC_System_Zone_18",
    "projection_acronym": "aeqd",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aeqd +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520000747,
    "auth_name": "ESRI",
    "auth_id": "102438",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60749,
    "description": "LKS_1992_Latvia_TM_0",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000749,
    "auth_name": "ESRI",
    "auth_id": "102440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60754,
    "description": "NAD_1983_2011_StatePlane_Alaska_1_FIPS_5001_Feet",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=omerc +no_uoff +lat_0=57 +lonc=-133.666666666667 +alpha=-36.8698976458333 +gamma=-36.8698976458333 +k=0.9999 +x_0=5000000.00000001 +y_0=-5000000.00000001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000754,
    "auth_name": "ESRI",
    "auth_id": "102445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60755,
    "description": "NAD_1983_2011_StatePlane_Alaska_2_FIPS_5002_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000755,
    "auth_name": "ESRI",
    "auth_id": "102446",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60756,
    "description": "NAD_1983_2011_StatePlane_Alaska_3_FIPS_5003_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000756,
    "auth_name": "ESRI",
    "auth_id": "102447",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60757,
    "description": "Macao_2008_Macao_Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=22.2123972222222 +lon_0=113.536469444444 +k=1 +x_0=20000 +y_0=20000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000757,
    "auth_name": "ESRI",
    "auth_id": "102448",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60759,
    "description": "NGO_1948_Oslo_Baerum_Kommune",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=0 +k=1 +x_0=19999.32 +y_0=-202977.79 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 520000759,
    "auth_name": "ESRI",
    "auth_id": "102450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60760,
    "description": "NGO_1948_Oslo_Bergenhalvoen",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=-4.66666666666667 +k=1 +x_0=100000 +y_0=-200000 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 520000760,
    "auth_name": "ESRI",
    "auth_id": "102451",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60761,
    "description": "NGO_1948_Oslo_Oslo_Kommune",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=0 +k=1 +x_0=0 +y_0=-212979.18 +a=6377492.018 +rf=299.1528128 +pm=oslo +towgs84=278.3,93,474.5,7.889,0.05,-6.61,6.21 +units=m +no_defs",
    "srid": 520000761,
    "auth_name": "ESRI",
    "auth_id": "102452",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60762,
    "description": "Luzon_1911_UTM_Zone_50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=50 +ellps=clrk66 +units=m +no_defs",
    "srid": 520000762,
    "auth_name": "ESRI",
    "auth_id": "102453",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60763,
    "description": "Luzon_1911_UTM_Zone_51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=51 +ellps=clrk66 +units=m +no_defs",
    "srid": 520000763,
    "auth_name": "ESRI",
    "auth_id": "102454",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60764,
    "description": "Luzon_1911_UTM_Zone_52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=52 +ellps=clrk66 +units=m +no_defs",
    "srid": 520000764,
    "auth_name": "ESRI",
    "auth_id": "102455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60765,
    "description": "PRS_1992_UTM_Zone_50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=50 +ellps=clrk66 +units=m +no_defs",
    "srid": 520000765,
    "auth_name": "ESRI",
    "auth_id": "102456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60766,
    "description": "PRS_1992_UTM_Zone_51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=51 +ellps=clrk66 +towgs84=-127.62,-67.24,-47.04,-3.068,4.903,1.578,-1.06 +units=m +no_defs",
    "srid": 520000766,
    "auth_name": "ESRI",
    "auth_id": "102457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60767,
    "description": "PRS_1992_UTM_Zone_52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=52 +ellps=clrk66 +units=m +no_defs",
    "srid": 520000767,
    "auth_name": "ESRI",
    "auth_id": "102458",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60768,
    "description": "NAD_1983_Idaho-Ada_County",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=1.00011328 +x_0=800143.966400001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520000768,
    "auth_name": "ESRI",
    "auth_id": "102459",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60769,
    "description": "HJAIA_AirportGrid_2Mar10",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520000769,
    "auth_name": "ESRI",
    "auth_id": "102460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60770,
    "description": "NAD_1983_HARN_StatePlane_Hawaii_1_FIPS_5101_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000770,
    "auth_name": "ESRI",
    "auth_id": "102461",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60771,
    "description": "NAD_1983_HARN_StatePlane_Hawaii_2_FIPS_5102_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000771,
    "auth_name": "ESRI",
    "auth_id": "102462",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60773,
    "description": "NAD_1983_HARN_StatePlane_Hawaii_4_FIPS_5104_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000773,
    "auth_name": "ESRI",
    "auth_id": "102464",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60774,
    "description": "NAD_1983_HARN_StatePlane_Hawaii_5_FIPS_5105_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520000774,
    "auth_name": "ESRI",
    "auth_id": "102465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60779,
    "description": "Cape_Lo15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000779,
    "auth_name": "ESRI",
    "auth_id": "102470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60780,
    "description": "Cape_Lo17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=17 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000780,
    "auth_name": "ESRI",
    "auth_id": "102471",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60781,
    "description": "Cape_Lo19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000781,
    "auth_name": "ESRI",
    "auth_id": "102472",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60782,
    "description": "Cape_Lo21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000782,
    "auth_name": "ESRI",
    "auth_id": "102473",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60783,
    "description": "Cape_Lo23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000783,
    "auth_name": "ESRI",
    "auth_id": "102474",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60784,
    "description": "Cape_Lo25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=25 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000784,
    "auth_name": "ESRI",
    "auth_id": "102475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60785,
    "description": "Cape_Lo27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000785,
    "auth_name": "ESRI",
    "auth_id": "102476",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60786,
    "description": "Cape_Lo29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=29 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000786,
    "auth_name": "ESRI",
    "auth_id": "102477",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60787,
    "description": "Cape_Lo31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000787,
    "auth_name": "ESRI",
    "auth_id": "102478",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60788,
    "description": "Cape_Lo33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=-1 +x_0=0 +y_0=0 +a=6378249.145 +rf=293.4663077 +units=m +no_defs",
    "srid": 520000788,
    "auth_name": "ESRI",
    "auth_id": "102479",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60789,
    "description": "Hartebeesthoek94_Lo15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000789,
    "auth_name": "ESRI",
    "auth_id": "102480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60790,
    "description": "Hartebeesthoek94_Lo17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=17 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000790,
    "auth_name": "ESRI",
    "auth_id": "102481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60791,
    "description": "Hartebeesthoek94_Lo19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000791,
    "auth_name": "ESRI",
    "auth_id": "102482",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60792,
    "description": "Hartebeesthoek94_Lo21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000792,
    "auth_name": "ESRI",
    "auth_id": "102483",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60793,
    "description": "Hartebeesthoek94_Lo23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000793,
    "auth_name": "ESRI",
    "auth_id": "102484",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60794,
    "description": "Hartebeesthoek94_Lo25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=25 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000794,
    "auth_name": "ESRI",
    "auth_id": "102485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60795,
    "description": "Hartebeesthoek94_Lo27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000795,
    "auth_name": "ESRI",
    "auth_id": "102486",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60796,
    "description": "Hartebeesthoek94_Lo29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=29 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000796,
    "auth_name": "ESRI",
    "auth_id": "102487",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60797,
    "description": "Hartebeesthoek94_Lo31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000797,
    "auth_name": "ESRI",
    "auth_id": "102488",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60798,
    "description": "Hartebeesthoek94_Lo33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=-1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000798,
    "auth_name": "ESRI",
    "auth_id": "102489",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60805,
    "description": "GOES-16_East_ABI_Fixed_Grid_ITRF2008",
    "projection_acronym": "geos",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geos +lon_0=-75 +h=35786023 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520000805,
    "auth_name": "ESRI",
    "auth_id": "102498",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60806,
    "description": "Belge_Lambert_1972_bad_FE_FN",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=90 +lon_0=4.36748666666667 +lat_1=49.8333339 +lat_2=51.1666672333333 +x_0=150000.01256 +y_0=5400088.4378 +ellps=intl +units=m +no_defs",
    "srid": 520000806,
    "auth_name": "ESRI",
    "auth_id": "102499",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60832,
    "description": "NAD_1983_PA11_StatePlane_Hawaii_1_FIPS_5101_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=18.8333333333333 +lon_0=-155.5 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.908,-2.0161,-0.5653,-0.027741,-0.013469,-0.002712,0.0011 +units=us-ft +no_defs",
    "srid": 520000832,
    "auth_name": "ESRI",
    "auth_id": "102525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60833,
    "description": "NAD_1983_PA11_StatePlane_Hawaii_2_FIPS_5102_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=20.3333333333333 +lon_0=-156.666666666667 +k=0.999966666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.908,-2.0161,-0.5653,-0.027741,-0.013469,-0.002712,0.0011 +units=us-ft +no_defs",
    "srid": 520000833,
    "auth_name": "ESRI",
    "auth_id": "102526",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60835,
    "description": "NAD_1983_PA11_StatePlane_Hawaii_4_FIPS_5104_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.8333333333333 +lon_0=-159.5 +k=0.99999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.908,-2.0161,-0.5653,-0.027741,-0.013469,-0.002712,0.0011 +units=us-ft +no_defs",
    "srid": 520000835,
    "auth_name": "ESRI",
    "auth_id": "102528",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60836,
    "description": "NAD_1983_PA11_StatePlane_Hawaii_5_FIPS_5105_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=21.6666666666667 +lon_0=-160.166666666667 +k=1 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.908,-2.0161,-0.5653,-0.027741,-0.013469,-0.002712,0.0011 +units=us-ft +no_defs",
    "srid": 520000836,
    "auth_name": "ESRI",
    "auth_id": "102529",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60857,
    "description": "ED_1950_Turkey_9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=0.9996 +x_0=9500000 +y_0=0 +ellps=intl +towgs84=-102,-102,-129,-0.413,0.184,-0.385,2.4664 +units=m +no_defs",
    "srid": 520000857,
    "auth_name": "ESRI",
    "auth_id": "102550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60858,
    "description": "ED_1950_Turkey_10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=0.9996 +x_0=10500000 +y_0=0 +ellps=intl +towgs84=-102,-102,-129,-0.413,0.184,-0.385,2.4664 +units=m +no_defs",
    "srid": 520000858,
    "auth_name": "ESRI",
    "auth_id": "102551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60859,
    "description": "ED_1950_Turkey_11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=0.9996 +x_0=11500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 520000859,
    "auth_name": "ESRI",
    "auth_id": "102552",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60860,
    "description": "ED_1950_Turkey_12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=0.9996 +x_0=12500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 520000860,
    "auth_name": "ESRI",
    "auth_id": "102553",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60861,
    "description": "ED_1950_Turkey_13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=0.9996 +x_0=13500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 520000861,
    "auth_name": "ESRI",
    "auth_id": "102554",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60862,
    "description": "ED_1950_Turkey_14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=0.9996 +x_0=14500000 +y_0=0 +ellps=intl +towgs84=-84.1,-101.8,-129.7,0,0,0.468,1.05 +units=m +no_defs",
    "srid": 520000862,
    "auth_name": "ESRI",
    "auth_id": "102555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60863,
    "description": "ED_1950_Turkey_15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=0.9996 +x_0=15500000 +y_0=0 +ellps=intl +towgs84=-84.1,-101.8,-129.7,0,0,0.468,1.05 +units=m +no_defs",
    "srid": 520000863,
    "auth_name": "ESRI",
    "auth_id": "102556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60869,
    "description": "Hartebeesthoek94_Lo19_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=19 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000869,
    "auth_name": "ESRI",
    "auth_id": "102562",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60870,
    "description": "Hartebeesthoek94_Lo21_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000870,
    "auth_name": "ESRI",
    "auth_id": "102563",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60871,
    "description": "Hartebeesthoek94_Lo23_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000871,
    "auth_name": "ESRI",
    "auth_id": "102564",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60872,
    "description": "Hartebeesthoek94_Lo25_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=25 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000872,
    "auth_name": "ESRI",
    "auth_id": "102565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60873,
    "description": "Hartebeesthoek94_Lo27_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000873,
    "auth_name": "ESRI",
    "auth_id": "102566",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60874,
    "description": "Hartebeesthoek94_Lo29_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=29 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000874,
    "auth_name": "ESRI",
    "auth_id": "102567",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60875,
    "description": "Hartebeesthoek94_Lo31_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000875,
    "auth_name": "ESRI",
    "auth_id": "102568",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60876,
    "description": "New_Beijing_3_Degree_Gauss_Kruger_CM_132E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520000876,
    "auth_name": "ESRI",
    "auth_id": "102569",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60877,
    "description": "WGS_1984_Complex_UTM_Zone_20N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=20 +datum=WGS84 +units=m +no_defs",
    "srid": 520000877,
    "auth_name": "ESRI",
    "auth_id": "102570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60878,
    "description": "WGS_1984_Complex_UTM_Zone_21N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=21 +datum=WGS84 +units=m +no_defs",
    "srid": 520000878,
    "auth_name": "ESRI",
    "auth_id": "102571",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60879,
    "description": "WGS_1984_Complex_UTM_Zone_22N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=22 +datum=WGS84 +units=m +no_defs",
    "srid": 520000879,
    "auth_name": "ESRI",
    "auth_id": "102572",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60880,
    "description": "WGS_1984_Complex_UTM_Zone_23N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=23 +datum=WGS84 +units=m +no_defs",
    "srid": 520000880,
    "auth_name": "ESRI",
    "auth_id": "102573",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60881,
    "description": "WGS_1984_Complex_UTM_Zone_24N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=24 +datum=WGS84 +units=m +no_defs",
    "srid": 520000881,
    "auth_name": "ESRI",
    "auth_id": "102574",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60882,
    "description": "WGS_1984_Complex_UTM_Zone_25N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=25 +datum=WGS84 +units=m +no_defs",
    "srid": 520000882,
    "auth_name": "ESRI",
    "auth_id": "102575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60883,
    "description": "WGS_1984_Complex_UTM_Zone_26N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=26 +datum=WGS84 +units=m +no_defs",
    "srid": 520000883,
    "auth_name": "ESRI",
    "auth_id": "102576",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60884,
    "description": "WGS_1984_Complex_UTM_Zone_27N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=27 +datum=WGS84 +units=m +no_defs",
    "srid": 520000884,
    "auth_name": "ESRI",
    "auth_id": "102577",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60885,
    "description": "WGS_1984_Complex_UTM_Zone_28N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=28 +datum=WGS84 +units=m +no_defs",
    "srid": 520000885,
    "auth_name": "ESRI",
    "auth_id": "102578",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60886,
    "description": "WGS_1984_Complex_UTM_Zone_29N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=29 +datum=WGS84 +units=m +no_defs",
    "srid": 520000886,
    "auth_name": "ESRI",
    "auth_id": "102579",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60887,
    "description": "WGS_1984_Complex_UTM_Zone_30N",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs",
    "srid": 520000887,
    "auth_name": "ESRI",
    "auth_id": "102580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60888,
    "description": "NTF_Lambert_Zone_I",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=2.33722916666667 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520000888,
    "auth_name": "ESRI",
    "auth_id": "102585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60889,
    "description": "NTF_Lambert_Zone_II",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=2.33722916666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520000889,
    "auth_name": "ESRI",
    "auth_id": "102586",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60890,
    "description": "NTF_Lambert_Zone_III",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=2.33722916666667 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520000890,
    "auth_name": "ESRI",
    "auth_id": "102587",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60891,
    "description": "NTF_Lambert_Zone_IV",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=2.33722916666667 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520000891,
    "auth_name": "ESRI",
    "auth_id": "102588",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60892,
    "description": "Panhandle_Energy_Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "NAD83",
    "parameters": "+proj=aea +lat_0=25 +lon_0=-86 +lat_1=31 +lat_2=41 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520000892,
    "auth_name": "ESRI",
    "auth_id": "102589",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60899,
    "description": "JGD_2011_UTM_Zone_56N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=56 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520000899,
    "auth_name": "ESRI",
    "auth_id": "102598",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60900,
    "description": "WGS_1984_California_Teale_Albers_FtUS",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-1219202.43840488 +datum=WGS84 +units=us-ft +no_defs",
    "srid": 520000900,
    "auth_name": "ESRI",
    "auth_id": "102599",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60901,
    "description": "NAD_1983_California_Teale_Albers_FtUS",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-1219202.43840488 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520000901,
    "auth_name": "ESRI",
    "auth_id": "102600",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60905,
    "description": "NAD_1983_Georgia_Statewide_Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=0 +lon_0=-83.5 +lat_1=31.4166666666667 +lat_2=34.2833333333333 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520000905,
    "auth_name": "ESRI",
    "auth_id": "102604",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60931,
    "description": "NAD_1927_StatePlane_California_V_Ventura",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=124358.648717297 +y_0=-81076.9621539243 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 520000931,
    "auth_name": "ESRI",
    "auth_id": "102699",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60932,
    "description": "NAD_1983_PACP00_UTM_Zone_4N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=4 +ellps=GRS80 +towgs84=-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0 +units=m +no_defs",
    "srid": 520000932,
    "auth_name": "ESRI",
    "auth_id": "102701",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60933,
    "description": "NAD_1983_PACP00_UTM_Zone_5N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +ellps=GRS80 +towgs84=-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0 +units=m +no_defs",
    "srid": 520000933,
    "auth_name": "ESRI",
    "auth_id": "102702",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60934,
    "description": "NAD_1983_PACP00_UTM_Zone_2S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=2 +south +ellps=GRS80 +towgs84=-0.9102,2.0141,0.5602,0.029039,0.010065,0.010101,0 +units=m +no_defs",
    "srid": 520000934,
    "auth_name": "ESRI",
    "auth_id": "102703",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 60935,
    "description": "NAD_1983_Nebraska_Lancaster_County_FtUS",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.25 +lon_0=-96.6880555555556 +k=1.000054615 +x_0=50000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520000935,
    "auth_name": "ESRI",
    "auth_id": "102705",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61086,
    "description": "NAD_1983_2011_Wisconsin_TM_US_Ft",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9996 +x_0=520000 +y_0=-4479999.99999999 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520001086,
    "auth_name": "ESRI",
    "auth_id": "102974",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61278,
    "description": "NAD_1983_2011_StatePlane_Utah_North_FIPS_4301_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 520001278,
    "auth_name": "ESRI",
    "auth_id": "103166",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61279,
    "description": "NAD_1983_2011_StatePlane_Utah_Central_FIPS_4302_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 520001279,
    "auth_name": "ESRI",
    "auth_id": "103167",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61280,
    "description": "NAD_1983_2011_StatePlane_Utah_South_FIPS_4303_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 520001280,
    "auth_name": "ESRI",
    "auth_id": "103168",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61332,
    "description": "NAD_1983_CORS96_StatePlane_Alabama_East_FIPS_0101",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001332,
    "auth_name": "ESRI",
    "auth_id": "103220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61333,
    "description": "NAD_1983_CORS96_StatePlane_Alabama_West_FIPS_0102",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001333,
    "auth_name": "ESRI",
    "auth_id": "103221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61334,
    "description": "NAD_1983_CORS96_StatePlane_Arizona_East_FIPS_0201",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001334,
    "auth_name": "ESRI",
    "auth_id": "103222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61335,
    "description": "NAD_1983_CORS96_StatePlane_Arizona_Central_FIPS_0202",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001335,
    "auth_name": "ESRI",
    "auth_id": "103223",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61336,
    "description": "NAD_1983_CORS96_StatePlane_Arizona_West_FIPS_0203",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333333333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001336,
    "auth_name": "ESRI",
    "auth_id": "103224",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61337,
    "description": "NAD_1983_CORS96_StatePlane_Arizona_East_FIPS_0201_Ft_Intl",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-110.166666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001337,
    "auth_name": "ESRI",
    "auth_id": "103225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61338,
    "description": "NAD_1983_CORS96_StatePlane_Arizona_Central_FIPS_0202_Ft_Intl",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-111.916666666667 +k=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001338,
    "auth_name": "ESRI",
    "auth_id": "103226",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61339,
    "description": "NAD_1983_CORS96_StatePlane_Arizona_West_FIPS_0203_Ft_Intl",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933333333333 +x_0=213360 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001339,
    "auth_name": "ESRI",
    "auth_id": "103227",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61340,
    "description": "NAD_1983_CORS96_StatePlane_Arkansas_North_FIPS_0301",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=34.9333333333333 +lat_2=36.2333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001340,
    "auth_name": "ESRI",
    "auth_id": "103228",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61341,
    "description": "NAD_1983_CORS96_StatePlane_Arkansas_South_FIPS_0302",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=33.3 +lat_2=34.7666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001341,
    "auth_name": "ESRI",
    "auth_id": "103229",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61342,
    "description": "NAD_1983_CORS96_StatePlane_Arkansas_North_FIPS_0301_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-92 +lat_1=34.9333333333333 +lat_2=36.2333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001342,
    "auth_name": "ESRI",
    "auth_id": "103230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61343,
    "description": "NAD_1983_CORS96_StatePlane_Arkansas_South_FIPS_0302_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.6666666666667 +lon_0=-92 +lat_1=33.3 +lat_2=34.7666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001343,
    "auth_name": "ESRI",
    "auth_id": "103231",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61344,
    "description": "NAD_1983_CORS96_StatePlane_California_I_FIPS_0401",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=40 +lat_2=41.6666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001344,
    "auth_name": "ESRI",
    "auth_id": "103232",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61345,
    "description": "NAD_1983_CORS96_StatePlane_California_II_FIPS_0402",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=38.3333333333333 +lat_2=39.8333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001345,
    "auth_name": "ESRI",
    "auth_id": "103233",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61346,
    "description": "NAD_1983_CORS96_StatePlane_California_III_FIPS_0403",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001346,
    "auth_name": "ESRI",
    "auth_id": "103234",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61347,
    "description": "NAD_1983_CORS96_StatePlane_California_IV_FIPS_0404",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=36 +lat_2=37.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001347,
    "auth_name": "ESRI",
    "auth_id": "103235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61348,
    "description": "NAD_1983_CORS96_StatePlane_California_V_FIPS_0405",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001348,
    "auth_name": "ESRI",
    "auth_id": "103236",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61349,
    "description": "NAD_1983_CORS96_StatePlane_California_VI_FIPS_0406",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=32.7833333333333 +lat_2=33.8833333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001349,
    "auth_name": "ESRI",
    "auth_id": "103237",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61350,
    "description": "NAD_1983_CORS96_StatePlane_California_I_FIPS_0401_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=40 +lat_2=41.6666666666667 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001350,
    "auth_name": "ESRI",
    "auth_id": "103238",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61351,
    "description": "NAD_1983_CORS96_StatePlane_California_II_FIPS_0402_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=38.3333333333333 +lat_2=39.8333333333333 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001351,
    "auth_name": "ESRI",
    "auth_id": "103239",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61352,
    "description": "NAD_1983_CORS96_StatePlane_California_III_FIPS_0403_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001352,
    "auth_name": "ESRI",
    "auth_id": "103240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61353,
    "description": "NAD_1983_CORS96_StatePlane_California_IV_FIPS_0404_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=36 +lat_2=37.25 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001353,
    "auth_name": "ESRI",
    "auth_id": "103241",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61354,
    "description": "NAD_1983_CORS96_StatePlane_California_V_FIPS_0405_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001354,
    "auth_name": "ESRI",
    "auth_id": "103242",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61355,
    "description": "NAD_1983_CORS96_StatePlane_California_VI_FIPS_0406_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=32.7833333333333 +lat_2=33.8833333333333 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001355,
    "auth_name": "ESRI",
    "auth_id": "103243",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61356,
    "description": "NAD_1983_CORS96_StatePlane_Colorado_North_FIPS_0501",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=39.7166666666667 +lat_2=40.7833333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001356,
    "auth_name": "ESRI",
    "auth_id": "103244",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61357,
    "description": "NAD_1983_CORS96_StatePlane_Colorado_Central_FIPS_0502",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=38.45 +lat_2=39.75 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001357,
    "auth_name": "ESRI",
    "auth_id": "103245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61358,
    "description": "NAD_1983_CORS96_StatePlane_Colorado_South_FIPS_0503",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=37.2333333333333 +lat_2=38.4333333333333 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001358,
    "auth_name": "ESRI",
    "auth_id": "103246",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61359,
    "description": "NAD_1983_CORS96_StatePlane_Colorado_North_FIPS_0501_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-105.5 +lat_1=39.7166666666667 +lat_2=40.7833333333333 +x_0=914401.828899999 +y_0=304800.6096 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001359,
    "auth_name": "ESRI",
    "auth_id": "103247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61360,
    "description": "NAD_1983_CORS96_StatePlane_Colorado_Central_FIPS_0502_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.8333333333333 +lon_0=-105.5 +lat_1=38.45 +lat_2=39.75 +x_0=914401.828899999 +y_0=304800.6096 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001360,
    "auth_name": "ESRI",
    "auth_id": "103248",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61361,
    "description": "NAD_1983_CORS96_StatePlane_Colorado_South_FIPS_0503_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-105.5 +lat_1=37.2333333333333 +lat_2=38.4333333333333 +x_0=914401.828899999 +y_0=304800.6096 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001361,
    "auth_name": "ESRI",
    "auth_id": "103249",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61362,
    "description": "NAD_1983_CORS96_StatePlane_Connecticut_FIPS_0600",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.2 +lat_2=41.8666666666667 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001362,
    "auth_name": "ESRI",
    "auth_id": "103250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61363,
    "description": "NAD_1983_CORS96_StatePlane_Connecticut_FIPS_0600_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.8333333333333 +lon_0=-72.75 +lat_1=41.2 +lat_2=41.8666666666667 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001363,
    "auth_name": "ESRI",
    "auth_id": "103251",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61364,
    "description": "NAD_1983_CORS96_StatePlane_Delaware_FIPS_0700",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001364,
    "auth_name": "ESRI",
    "auth_id": "103252",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61365,
    "description": "NAD_1983_CORS96_StatePlane_Delaware_FIPS_0700_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38 +lon_0=-75.4166666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001365,
    "auth_name": "ESRI",
    "auth_id": "103253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61366,
    "description": "NAD_1983_CORS96_StatePlane_Florida_East_FIPS_0901",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941176470588 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001366,
    "auth_name": "ESRI",
    "auth_id": "103254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61367,
    "description": "NAD_1983_CORS96_StatePlane_Florida_West_FIPS_0902",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941176470588 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001367,
    "auth_name": "ESRI",
    "auth_id": "103255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61368,
    "description": "NAD_1983_CORS96_StatePlane_Florida_North_FIPS_0903",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=29.5833333333333 +lat_2=30.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001368,
    "auth_name": "ESRI",
    "auth_id": "103256",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61369,
    "description": "NAD_1983_CORS96_StatePlane_Florida_East_FIPS_0901_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-81 +k=0.999941176470588 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001369,
    "auth_name": "ESRI",
    "auth_id": "103257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61370,
    "description": "NAD_1983_CORS96_StatePlane_Florida_West_FIPS_0902_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=24.3333333333333 +lon_0=-82 +k=0.999941176470588 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001370,
    "auth_name": "ESRI",
    "auth_id": "103258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61371,
    "description": "NAD_1983_CORS96_StatePlane_Florida_North_FIPS_0903_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=29.5833333333333 +lat_2=30.75 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001371,
    "auth_name": "ESRI",
    "auth_id": "103259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61372,
    "description": "NAD_1983_CORS96_StatePlane_Georgia_East_FIPS_1001",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001372,
    "auth_name": "ESRI",
    "auth_id": "103260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61373,
    "description": "NAD_1983_CORS96_StatePlane_Georgia_West_FIPS_1002",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001373,
    "auth_name": "ESRI",
    "auth_id": "103261",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61374,
    "description": "NAD_1983_CORS96_StatePlane_Georgia_East_FIPS_1001_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-82.1666666666667 +k=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001374,
    "auth_name": "ESRI",
    "auth_id": "103262",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61375,
    "description": "NAD_1983_CORS96_StatePlane_Georgia_West_FIPS_1002_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001375,
    "auth_name": "ESRI",
    "auth_id": "103263",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61376,
    "description": "NAD_1983_CORS96_StatePlane_Idaho_East_FIPS_1101",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368421053 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001376,
    "auth_name": "ESRI",
    "auth_id": "103264",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61377,
    "description": "NAD_1983_CORS96_StatePlane_Idaho_Central_FIPS_1102",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368421053 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001377,
    "auth_name": "ESRI",
    "auth_id": "103265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61378,
    "description": "NAD_1983_CORS96_StatePlane_Idaho_West_FIPS_1103",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333333333 +x_0=800000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001378,
    "auth_name": "ESRI",
    "auth_id": "103266",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61379,
    "description": "NAD_1983_CORS96_StatePlane_Idaho_East_FIPS_1101_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-112.166666666667 +k=0.999947368421053 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001379,
    "auth_name": "ESRI",
    "auth_id": "103267",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61380,
    "description": "NAD_1983_CORS96_StatePlane_Idaho_Central_FIPS_1102_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-114 +k=0.999947368421053 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001380,
    "auth_name": "ESRI",
    "auth_id": "103268",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61381,
    "description": "NAD_1983_CORS96_StatePlane_Idaho_West_FIPS_1103_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.6666666666667 +lon_0=-115.75 +k=0.999933333333333 +x_0=800000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001381,
    "auth_name": "ESRI",
    "auth_id": "103269",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61382,
    "description": "NAD_1983_CORS96_StatePlane_Illinois_East_FIPS_1201",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001382,
    "auth_name": "ESRI",
    "auth_id": "103270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61383,
    "description": "NAD_1983_CORS96_StatePlane_Illinois_West_FIPS_1202",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941176470588 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001383,
    "auth_name": "ESRI",
    "auth_id": "103271",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61384,
    "description": "NAD_1983_CORS96_StatePlane_Illinois_East_FIPS_1201_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-88.3333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001384,
    "auth_name": "ESRI",
    "auth_id": "103272",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61385,
    "description": "NAD_1983_CORS96_StatePlane_Illinois_West_FIPS_1202_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.6666666666667 +lon_0=-90.1666666666667 +k=0.999941176470588 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001385,
    "auth_name": "ESRI",
    "auth_id": "103273",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61386,
    "description": "NAD_1983_CORS96_StatePlane_Indiana_East_FIPS_1301",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966666666667 +x_0=100000 +y_0=250000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001386,
    "auth_name": "ESRI",
    "auth_id": "103274",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61387,
    "description": "NAD_1983_CORS96_StatePlane_Indiana_West_FIPS_1302",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966666666667 +x_0=900000 +y_0=250000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001387,
    "auth_name": "ESRI",
    "auth_id": "103275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61388,
    "description": "NAD_1983_CORS96_StatePlane_Indiana_East_FIPS_1301_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-85.6666666666667 +k=0.999966666666667 +x_0=100000 +y_0=250000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001388,
    "auth_name": "ESRI",
    "auth_id": "103276",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61389,
    "description": "NAD_1983_CORS96_StatePlane_Indiana_West_FIPS_1302_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=37.5 +lon_0=-87.0833333333333 +k=0.999966666666667 +x_0=900000 +y_0=250000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001389,
    "auth_name": "ESRI",
    "auth_id": "103277",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61390,
    "description": "NAD_1983_CORS96_StatePlane_Iowa_North_FIPS_1401",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=42.0666666666667 +lat_2=43.2666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001390,
    "auth_name": "ESRI",
    "auth_id": "103278",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61391,
    "description": "NAD_1983_CORS96_StatePlane_Iowa_South_FIPS_1402",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=40.6166666666667 +lat_2=41.7833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001391,
    "auth_name": "ESRI",
    "auth_id": "103279",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61392,
    "description": "NAD_1983_CORS96_StatePlane_Iowa_North_FIPS_1401_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=42.0666666666667 +lat_2=43.2666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001392,
    "auth_name": "ESRI",
    "auth_id": "103280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61393,
    "description": "NAD_1983_CORS96_StatePlane_Iowa_South_FIPS_1402_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=40.6166666666667 +lat_2=41.7833333333333 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001393,
    "auth_name": "ESRI",
    "auth_id": "103281",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61394,
    "description": "NAD_1983_CORS96_StatePlane_Kansas_North_FIPS_1501",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=38.7166666666667 +lat_2=39.7833333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001394,
    "auth_name": "ESRI",
    "auth_id": "103282",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61395,
    "description": "NAD_1983_CORS96_StatePlane_Kansas_South_FIPS_1502",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=37.2666666666667 +lat_2=38.5666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001395,
    "auth_name": "ESRI",
    "auth_id": "103283",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61396,
    "description": "NAD_1983_CORS96_StatePlane_Kansas_North_FIPS_1501_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-98 +lat_1=38.7166666666667 +lat_2=39.7833333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001396,
    "auth_name": "ESRI",
    "auth_id": "103284",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61397,
    "description": "NAD_1983_CORS96_StatePlane_Kansas_South_FIPS_1502_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-98.5 +lat_1=37.2666666666667 +lat_2=38.5666666666667 +x_0=400000 +y_0=400000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001397,
    "auth_name": "ESRI",
    "auth_id": "103285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61398,
    "description": "NAD_1983_CORS96_StatePlane_Kentucky_North_FIPS_1601",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001398,
    "auth_name": "ESRI",
    "auth_id": "103286",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61399,
    "description": "NAD_1983_CORS96_StatePlane_Kentucky_North_FIPS_1601_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.9666666666667 +lat_2=38.9666666666667 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001399,
    "auth_name": "ESRI",
    "auth_id": "103287",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61400,
    "description": "NAD_1983_CORS96_StatePlane_Kentucky_FIPS_1600",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001400,
    "auth_name": "ESRI",
    "auth_id": "103288",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61401,
    "description": "NAD_1983_CORS96_StatePlane_Kentucky_FIPS_1600_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=37.0833333333333 +lat_2=38.6666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001401,
    "auth_name": "ESRI",
    "auth_id": "103289",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61402,
    "description": "NAD_1983_CORS96_StatePlane_Kentucky_South_FIPS_1602",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=36.7333333333333 +lat_2=37.9333333333333 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001402,
    "auth_name": "ESRI",
    "auth_id": "103290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61403,
    "description": "NAD_1983_CORS96_StatePlane_Kentucky_South_FIPS_1602_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-85.75 +lat_1=36.7333333333333 +lat_2=37.9333333333333 +x_0=500000.000000001 +y_0=500000.000000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001403,
    "auth_name": "ESRI",
    "auth_id": "103291",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61404,
    "description": "NAD_1983_CORS96_StatePlane_Louisiana_North_FIPS_1701",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=31.1666666666667 +lat_2=32.6666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001404,
    "auth_name": "ESRI",
    "auth_id": "103292",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61405,
    "description": "NAD_1983_CORS96_StatePlane_Louisiana_South_FIPS_1702",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=29.3 +lat_2=30.7 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001405,
    "auth_name": "ESRI",
    "auth_id": "103293",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61406,
    "description": "NAD_1983_CORS96_StatePlane_Louisiana_North_FIPS_1701_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=31.1666666666667 +lat_2=32.6666666666667 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001406,
    "auth_name": "ESRI",
    "auth_id": "103294",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61407,
    "description": "NAD_1983_CORS96_StatePlane_Louisiana_South_FIPS_1702_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=28.5 +lon_0=-91.3333333333333 +lat_1=29.3 +lat_2=30.7 +x_0=1000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001407,
    "auth_name": "ESRI",
    "auth_id": "103295",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61408,
    "description": "NAD_1983_CORS96_StatePlane_Maine_East_FIPS_1801",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001408,
    "auth_name": "ESRI",
    "auth_id": "103296",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61409,
    "description": "NAD_1983_CORS96_StatePlane_Maine_West_FIPS_1802",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966666666667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001409,
    "auth_name": "ESRI",
    "auth_id": "103297",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61410,
    "description": "NAD_1983_CORS96_StatePlane_Maine_East_FIPS_1801_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.6666666666667 +lon_0=-68.5 +k=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001410,
    "auth_name": "ESRI",
    "auth_id": "103298",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61411,
    "description": "NAD_1983_CORS96_StatePlane_Maine_West_FIPS_1802_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.1666666666667 +k=0.999966666666667 +x_0=900000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001411,
    "auth_name": "ESRI",
    "auth_id": "103299",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61418,
    "description": "NAD_1983_HARN_WISCRS_Calumet_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001418,
    "auth_name": "ESRI",
    "auth_id": "103307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61424,
    "description": "NAD_1983_HARN_WISCRS_Dodge_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001424,
    "auth_name": "ESRI",
    "auth_id": "103313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61430,
    "description": "NAD_1983_HARN_WISCRS_Fond_du_Lac_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001430,
    "auth_name": "ESRI",
    "auth_id": "103319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61433,
    "description": "NAD_1983_HARN_WISCRS_Green_County_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001433,
    "auth_name": "ESRI",
    "auth_id": "103322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61434,
    "description": "NAD_1983_HARN_WISCRS_GreenLake_County_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001434,
    "auth_name": "ESRI",
    "auth_id": "103323",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61438,
    "description": "NAD_1983_HARN_WISCRS_Jefferson_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001438,
    "auth_name": "ESRI",
    "auth_id": "103327",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61439,
    "description": "NAD_1983_HARN_WISCRS_Juneau_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001439,
    "auth_name": "ESRI",
    "auth_id": "103328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61440,
    "description": "NAD_1983_HARN_WISCRS_Kenosha_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444445 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001440,
    "auth_name": "ESRI",
    "auth_id": "103329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61441,
    "description": "NAD_1983_HARN_WISCRS_Kewaunee_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001441,
    "auth_name": "ESRI",
    "auth_id": "103330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61443,
    "description": "NAD_1983_HARN_WISCRS_Lafayette_County_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001443,
    "auth_name": "ESRI",
    "auth_id": "103332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61446,
    "description": "NAD_1983_HARN_WISCRS_Manitowoc_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001446,
    "auth_name": "ESRI",
    "auth_id": "103335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61449,
    "description": "NAD_1983_HARN_WISCRS_Marquette_County_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001449,
    "auth_name": "ESRI",
    "auth_id": "103338",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61451,
    "description": "NAD_1983_HARN_WISCRS_Milwaukee_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444445 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001451,
    "auth_name": "ESRI",
    "auth_id": "103340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61455,
    "description": "NAD_1983_HARN_WISCRS_Outagamie_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001455,
    "auth_name": "ESRI",
    "auth_id": "103344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61456,
    "description": "NAD_1983_HARN_WISCRS_Ozaukee_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444445 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001456,
    "auth_name": "ESRI",
    "auth_id": "103345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61457,
    "description": "NAD_1983_HARN_WISCRS_Pepin_County_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001457,
    "auth_name": "ESRI",
    "auth_id": "103346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61458,
    "description": "NAD_1983_HARN_WISCRS_Pierce_County_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001458,
    "auth_name": "ESRI",
    "auth_id": "103347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61462,
    "description": "NAD_1983_HARN_WISCRS_Racine_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444445 +k=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001462,
    "auth_name": "ESRI",
    "auth_id": "103351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61469,
    "description": "NAD_1983_HARN_WISCRS_Sheboygan_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001469,
    "auth_name": "ESRI",
    "auth_id": "103358",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61481,
    "description": "NAD_1983_HARN_WISCRS_Winnebago_County_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001481,
    "auth_name": "ESRI",
    "auth_id": "103370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61483,
    "description": "NAD_1983_CORS96_Maine_2000_East_Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.8333333333333 +lon_0=-67.875 +k=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001483,
    "auth_name": "ESRI",
    "auth_id": "103372",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61484,
    "description": "NAD_1983_CORS96_Maine_2000_Central_Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001484,
    "auth_name": "ESRI",
    "auth_id": "103373",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61485,
    "description": "NAD_1983_CORS96_Maine_2000_West_Zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.8333333333333 +lon_0=-70.375 +k=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001485,
    "auth_name": "ESRI",
    "auth_id": "103374",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61486,
    "description": "NAD_1983_CORS96_StatePlane_Maryland_FIPS_1900",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=38.3 +lat_2=39.45 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001486,
    "auth_name": "ESRI",
    "auth_id": "103375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61487,
    "description": "NAD_1983_CORS96_StatePlane_Maryland_FIPS_1900_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-77 +lat_1=38.3 +lat_2=39.45 +x_0=400000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001487,
    "auth_name": "ESRI",
    "auth_id": "103376",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61488,
    "description": "NAD_1983_CORS96_StatePlane_Massachusetts_Mainland_FIPS_2001",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=41.7166666666667 +lat_2=42.6833333333333 +x_0=200000 +y_0=750000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001488,
    "auth_name": "ESRI",
    "auth_id": "103377",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61489,
    "description": "NAD_1983_CORS96_StatePlane_Massachusetts_Island_FIPS_2002",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.2833333333333 +lat_2=41.4833333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001489,
    "auth_name": "ESRI",
    "auth_id": "103378",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61490,
    "description": "NAD_1983_CORS96_StatePlane_Massachusetts_Mnld_FIPS_2001_FtUS",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=41.7166666666667 +lat_2=42.6833333333333 +x_0=200000 +y_0=750000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001490,
    "auth_name": "ESRI",
    "auth_id": "103379",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61491,
    "description": "NAD_1983_CORS96_StatePlane_Massachusetts_Isl_FIPS_2002_FtUS",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.2833333333333 +lat_2=41.4833333333333 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001491,
    "auth_name": "ESRI",
    "auth_id": "103380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61492,
    "description": "NAD_1983_CORS96_StatePlane_Michigan_North_FIPS_2111",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001492,
    "auth_name": "ESRI",
    "auth_id": "103381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61493,
    "description": "NAD_1983_CORS96_StatePlane_Michigan_Central_FIPS_2112",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=6000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001493,
    "auth_name": "ESRI",
    "auth_id": "103382",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61494,
    "description": "NAD_1983_CORS96_StatePlane_Michigan_South_FIPS_2113",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=4000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001494,
    "auth_name": "ESRI",
    "auth_id": "103383",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61495,
    "description": "NAD_1983_CORS96_StatePlane_Michigan_North_FIPS_2111_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=8000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001495,
    "auth_name": "ESRI",
    "auth_id": "103384",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61496,
    "description": "NAD_1983_CORS96_StatePlane_Michigan_Central_FIPS_2112_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3666666666667 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=5999999.99999999 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001496,
    "auth_name": "ESRI",
    "auth_id": "103385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61497,
    "description": "NAD_1983_CORS96_StatePlane_Michigan_South_FIPS_2113_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3666666666667 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=4000000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001497,
    "auth_name": "ESRI",
    "auth_id": "103386",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61498,
    "description": "NAD_1983_CORS96_StatePlane_Minnesota_North_FIPS_2201",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=47.0333333333333 +lat_2=48.6333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001498,
    "auth_name": "ESRI",
    "auth_id": "103387",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61499,
    "description": "NAD_1983_CORS96_StatePlane_Minnesota_Central_FIPS_2202",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=45.6166666666667 +lat_2=47.05 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001499,
    "auth_name": "ESRI",
    "auth_id": "103388",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61500,
    "description": "NAD_1983_CORS96_StatePlane_Minnesota_South_FIPS_2203",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=43.7833333333333 +lat_2=45.2166666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001500,
    "auth_name": "ESRI",
    "auth_id": "103389",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61501,
    "description": "NAD_1983_CORS96_StatePlane_Minnesota_North_FIPS_2201_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=47.0333333333333 +lat_2=48.6333333333333 +x_0=800000.000000001 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001501,
    "auth_name": "ESRI",
    "auth_id": "103390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61502,
    "description": "NAD_1983_CORS96_StatePlane_Minnesota_Central_FIPS_2202_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=45.6166666666667 +lat_2=47.05 +x_0=800000.000000001 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001502,
    "auth_name": "ESRI",
    "auth_id": "103391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61503,
    "description": "NAD_1983_CORS96_StatePlane_Minnesota_South_FIPS_2203_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=43.7833333333333 +lat_2=45.2166666666667 +x_0=800000.000000001 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001503,
    "auth_name": "ESRI",
    "auth_id": "103392",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61504,
    "description": "NAD_1983_CORS96_StatePlane_Mississippi_East_FIPS_2301",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001504,
    "auth_name": "ESRI",
    "auth_id": "103393",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61505,
    "description": "NAD_1983_CORS96_StatePlane_Mississippi_West_FIPS_2302",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001505,
    "auth_name": "ESRI",
    "auth_id": "103394",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61506,
    "description": "NAD_1983_CORS96_StatePlane_Mississippi_East_FIPS_2301_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-88.8333333333333 +k=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001506,
    "auth_name": "ESRI",
    "auth_id": "103395",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61507,
    "description": "NAD_1983_CORS96_StatePlane_Mississippi_West_FIPS_2302_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=29.5 +lon_0=-90.3333333333333 +k=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001507,
    "auth_name": "ESRI",
    "auth_id": "103396",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61508,
    "description": "NAD_1983_CORS96_StatePlane_Missouri_East_FIPS_2401",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-90.5 +k=0.999933333333333 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001508,
    "auth_name": "ESRI",
    "auth_id": "103397",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61509,
    "description": "NAD_1983_CORS96_StatePlane_Missouri_Central_FIPS_2402",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001509,
    "auth_name": "ESRI",
    "auth_id": "103398",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61510,
    "description": "NAD_1983_CORS96_StatePlane_Missouri_West_FIPS_2403",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=36.1666666666667 +lon_0=-94.5 +k=0.999941176470588 +x_0=850000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001510,
    "auth_name": "ESRI",
    "auth_id": "103399",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61511,
    "description": "NAD_1983_HARN_WISCRS_Adams_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.694132588 +y_0=0.00365760731521463 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001511,
    "auth_name": "ESRI",
    "auth_id": "103400",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61518,
    "description": "NAD_1983_HARN_WISCRS_Calumet_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001518,
    "auth_name": "ESRI",
    "auth_id": "103407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61524,
    "description": "NAD_1983_HARN_WISCRS_Dodge_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.726390653 +y_0=0.00762001524003048 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001524,
    "auth_name": "ESRI",
    "auth_id": "103413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61530,
    "description": "NAD_1983_HARN_WISCRS_Fond_du_Lac_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001530,
    "auth_name": "ESRI",
    "auth_id": "103419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61533,
    "description": "NAD_1983_HARN_WISCRS_Green_County_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.74015748 +y_0=45830.2948437897 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001533,
    "auth_name": "ESRI",
    "auth_id": "103422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61534,
    "description": "NAD_1983_HARN_WISCRS_GreenLake_County_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.301752604 +y_0=79170.7793751588 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001534,
    "auth_name": "ESRI",
    "auth_id": "103423",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61538,
    "description": "NAD_1983_HARN_WISCRS_Jefferson_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.4722222222222 +lon_0=-88.775 +k=1.0000346418 +x_0=263347.726390653 +y_0=0.00762001524003048 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001538,
    "auth_name": "ESRI",
    "auth_id": "103427",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61539,
    "description": "NAD_1983_HARN_WISCRS_Juneau_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.3666666666667 +lon_0=-90 +k=1.0000365285 +x_0=147218.694132588 +y_0=0.00365760731521463 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001539,
    "auth_name": "ESRI",
    "auth_id": "103428",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61540,
    "description": "NAD_1983_HARN_WISCRS_Kenosha_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444445 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001540,
    "auth_name": "ESRI",
    "auth_id": "103429",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61541,
    "description": "NAD_1983_HARN_WISCRS_Kewaunee_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001541,
    "auth_name": "ESRI",
    "auth_id": "103430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61543,
    "description": "NAD_1983_HARN_WISCRS_Lafayette_County_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=42.6375622769444 +lat_0=42.6375622769444 +lon_0=-89.8388888888889 +k_0=1.0000390487 +x_0=170078.74015748 +y_0=45830.2948437897 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001543,
    "auth_name": "ESRI",
    "auth_id": "103432",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61546,
    "description": "NAD_1983_HARN_WISCRS_Manitowoc_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001546,
    "auth_name": "ESRI",
    "auth_id": "103435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61549,
    "description": "NAD_1983_HARN_WISCRS_Marquette_County_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=43.8070001177778 +lat_0=43.8070001177778 +lon_0=-89.2416666666667 +k_0=1.0000344057 +x_0=150876.301752604 +y_0=79170.7793751588 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001549,
    "auth_name": "ESRI",
    "auth_id": "103438",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61551,
    "description": "NAD_1983_HARN_WISCRS_Milwaukee_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444445 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001551,
    "auth_name": "ESRI",
    "auth_id": "103440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61555,
    "description": "NAD_1983_HARN_WISCRS_Outagamie_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001555,
    "auth_name": "ESRI",
    "auth_id": "103444",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61556,
    "description": "NAD_1983_HARN_WISCRS_Ozaukee_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444445 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001556,
    "auth_name": "ESRI",
    "auth_id": "103445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61557,
    "description": "NAD_1983_HARN_WISCRS_Pepin_County_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.335280671 +y_0=86033.0877317755 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001557,
    "auth_name": "ESRI",
    "auth_id": "103446",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61558,
    "description": "NAD_1983_HARN_WISCRS_Pierce_County_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=44.6361488719444 +lat_0=44.6361488719444 +lon_0=-92.2277777777778 +k_0=1.0000362977 +x_0=167640.335280671 +y_0=86033.0877317755 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001558,
    "auth_name": "ESRI",
    "auth_id": "103447",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61562,
    "description": "NAD_1983_HARN_WISCRS_Racine_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.2166666666667 +lon_0=-87.8944444444445 +k=1.0000260649 +x_0=185928.372771146 +y_0=0.000914401828803658 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001562,
    "auth_name": "ESRI",
    "auth_id": "103451",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61569,
    "description": "NAD_1983_HARN_WISCRS_Sheboygan_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=43.2666666666667 +lon_0=-87.55 +k=1.0000233704 +x_0=79857.7615443231 +y_0=0.00121920243840488 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001569,
    "auth_name": "ESRI",
    "auth_id": "103458",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61581,
    "description": "NAD_1983_HARN_WISCRS_Winnebago_County_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.7194444444445 +lon_0=-88.5 +k=1.0000286569 +x_0=244754.889204978 +y_0=0.00487680975361951 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001581,
    "auth_name": "ESRI",
    "auth_id": "103470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61583,
    "description": "NAD_1983_CORS96_StatePlane_Montana_FIPS_2500",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001583,
    "auth_name": "ESRI",
    "auth_id": "103472",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61584,
    "description": "NAD_1983_CORS96_StatePlane_Montana_FIPS_2500_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=45 +lat_2=49 +x_0=599999.999999999 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001584,
    "auth_name": "ESRI",
    "auth_id": "103473",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61585,
    "description": "NAD_1983_CORS96_StatePlane_Nebraska_FIPS_2600",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=40 +lat_2=43 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001585,
    "auth_name": "ESRI",
    "auth_id": "103474",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61586,
    "description": "NAD_1983_CORS96_StatePlane_Nebraska_FIPS_2600_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.8333333333333 +lon_0=-100 +lat_1=40 +lat_2=43 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001586,
    "auth_name": "ESRI",
    "auth_id": "103475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61587,
    "description": "NAD_1983_CORS96_StatePlane_Nevada_East_FIPS_2701",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001587,
    "auth_name": "ESRI",
    "auth_id": "103476",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61588,
    "description": "NAD_1983_CORS96_StatePlane_Nevada_Central_FIPS_2702",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001588,
    "auth_name": "ESRI",
    "auth_id": "103477",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61589,
    "description": "NAD_1983_CORS96_StatePlane_Nevada_West_FIPS_2703",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001589,
    "auth_name": "ESRI",
    "auth_id": "103478",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61590,
    "description": "NAD_1983_CORS96_StatePlane_Nevada_East_FIPS_2701_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-115.583333333333 +k=0.9999 +x_0=200000 +y_0=8000000.00000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001590,
    "auth_name": "ESRI",
    "auth_id": "103479",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61591,
    "description": "NAD_1983_CORS96_StatePlane_Nevada_Central_FIPS_2702_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-116.666666666667 +k=0.9999 +x_0=500000.000000001 +y_0=6000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001591,
    "auth_name": "ESRI",
    "auth_id": "103480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61592,
    "description": "NAD_1983_CORS96_StatePlane_Nevada_West_FIPS_2703_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=34.75 +lon_0=-118.583333333333 +k=0.9999 +x_0=800000.000000001 +y_0=3999999.99999999 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001592,
    "auth_name": "ESRI",
    "auth_id": "103481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61593,
    "description": "NAD_1983_CORS96_StatePlane_New_Hampshire_FIPS_2800",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001593,
    "auth_name": "ESRI",
    "auth_id": "103482",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61594,
    "description": "NAD_1983_CORS96_StatePlane_New_Hampshire_FIPS_2800_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-71.6666666666667 +k=0.999966666666667 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001594,
    "auth_name": "ESRI",
    "auth_id": "103483",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61595,
    "description": "NAD_1983_CORS96_StatePlane_New_Jersey_FIPS_2900",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001595,
    "auth_name": "ESRI",
    "auth_id": "103484",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61596,
    "description": "NAD_1983_CORS96_StatePlane_New_Jersey_FIPS_2900_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001596,
    "auth_name": "ESRI",
    "auth_id": "103485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61597,
    "description": "NAD_1983_CORS96_StatePlane_New_Mexico_East_FIPS_3001",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909090909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001597,
    "auth_name": "ESRI",
    "auth_id": "103486",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61598,
    "description": "NAD_1983_CORS96_StatePlane_New_Mexico_Central_FIPS_3002",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001598,
    "auth_name": "ESRI",
    "auth_id": "103487",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61599,
    "description": "NAD_1983_CORS96_StatePlane_New_Mexico_West_FIPS_3003",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916666666667 +x_0=830000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001599,
    "auth_name": "ESRI",
    "auth_id": "103488",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61600,
    "description": "NAD_1983_CORS96_StatePlane_New_Mexico_East_FIPS_3001_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-104.333333333333 +k=0.999909090909091 +x_0=165000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001600,
    "auth_name": "ESRI",
    "auth_id": "103489",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61601,
    "description": "NAD_1983_CORS96_StatePlane_New_Mexico_Central_FIPS_3002_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.9999 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001601,
    "auth_name": "ESRI",
    "auth_id": "103490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61602,
    "description": "NAD_1983_CORS96_StatePlane_New_Mexico_West_FIPS_3003_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=31 +lon_0=-107.833333333333 +k=0.999916666666667 +x_0=830000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001602,
    "auth_name": "ESRI",
    "auth_id": "103491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61603,
    "description": "NAD_1983_CORS96_StatePlane_New_York_East_FIPS_3101",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001603,
    "auth_name": "ESRI",
    "auth_id": "103492",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61604,
    "description": "NAD_1983_CORS96_StatePlane_New_York_Central_FIPS_3102",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001604,
    "auth_name": "ESRI",
    "auth_id": "103493",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61605,
    "description": "NAD_1983_CORS96_StatePlane_New_York_West_FIPS_3103",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001605,
    "auth_name": "ESRI",
    "auth_id": "103494",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61606,
    "description": "NAD_1983_CORS96_StatePlane_New_York_Long_Island_FIPS_3104",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=40.6666666666667 +lat_2=41.0333333333333 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001606,
    "auth_name": "ESRI",
    "auth_id": "103495",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61607,
    "description": "NAD_1983_CORS96_StatePlane_New_York_East_FIPS_3101_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=38.8333333333333 +lon_0=-74.5 +k=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001607,
    "auth_name": "ESRI",
    "auth_id": "103496",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61608,
    "description": "NAD_1983_CORS96_StatePlane_New_York_Central_FIPS_3102_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-76.5833333333333 +k=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001608,
    "auth_name": "ESRI",
    "auth_id": "103497",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61609,
    "description": "NAD_1983_CORS96_StatePlane_New_York_West_FIPS_3103_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=-78.5833333333333 +k=0.9999375 +x_0=350000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001609,
    "auth_name": "ESRI",
    "auth_id": "103498",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61610,
    "description": "NAD_1983_CORS96_StatePlane_New_York_Long_Isl_FIPS_3104_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-74 +lat_1=40.6666666666667 +lat_2=41.0333333333333 +x_0=300000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001610,
    "auth_name": "ESRI",
    "auth_id": "103499",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61611,
    "description": "NAD_1983_CORS96_StatePlane_North_Carolina_FIPS_3200",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=34.3333333333333 +lat_2=36.1666666666667 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001611,
    "auth_name": "ESRI",
    "auth_id": "103500",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61612,
    "description": "NAD_1983_CORS96_StatePlane_North_Carolina_FIPS_3200_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=34.3333333333333 +lat_2=36.1666666666667 +x_0=609601.219202438 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001612,
    "auth_name": "ESRI",
    "auth_id": "103501",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61613,
    "description": "NAD_1983_CORS96_StatePlane_North_Dakota_North_FIPS_3301",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.4333333333333 +lat_2=48.7333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001613,
    "auth_name": "ESRI",
    "auth_id": "103502",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61614,
    "description": "NAD_1983_CORS96_StatePlane_North_Dakota_South_FIPS_3302",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=46.1833333333333 +lat_2=47.4833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001614,
    "auth_name": "ESRI",
    "auth_id": "103503",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61615,
    "description": "NAD_1983_CORS96_StatePlane_North_Dakota_North_FIPS_3301_FtI",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.4333333333333 +lat_2=48.7333333333333 +x_0=599999.999999999 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001615,
    "auth_name": "ESRI",
    "auth_id": "103504",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61616,
    "description": "NAD_1983_CORS96_StatePlane_North_Dakota_South_FIPS_3302_FtI",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.6666666666667 +lon_0=-100.5 +lat_1=46.1833333333333 +lat_2=47.4833333333333 +x_0=599999.999999999 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001616,
    "auth_name": "ESRI",
    "auth_id": "103505",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61617,
    "description": "NAD_1983_CORS96_StatePlane_Ohio_North_FIPS_3401",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=40.4333333333333 +lat_2=41.7 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001617,
    "auth_name": "ESRI",
    "auth_id": "103506",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61618,
    "description": "NAD_1983_CORS96_StatePlane_Ohio_South_FIPS_3402",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=38.7333333333333 +lat_2=40.0333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001618,
    "auth_name": "ESRI",
    "auth_id": "103507",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61619,
    "description": "NAD_1983_CORS96_StatePlane_Ohio_North_FIPS_3401_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.6666666666667 +lon_0=-82.5 +lat_1=40.4333333333333 +lat_2=41.7 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001619,
    "auth_name": "ESRI",
    "auth_id": "103508",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61620,
    "description": "NAD_1983_CORS96_StatePlane_Ohio_South_FIPS_3402_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=38.7333333333333 +lat_2=40.0333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001620,
    "auth_name": "ESRI",
    "auth_id": "103509",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61621,
    "description": "NAD_1983_CORS96_StatePlane_Oklahoma_North_FIPS_3501",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=35.5666666666667 +lat_2=36.7666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001621,
    "auth_name": "ESRI",
    "auth_id": "103510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61622,
    "description": "NAD_1983_CORS96_StatePlane_Oklahoma_South_FIPS_3502",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=33.9333333333333 +lat_2=35.2333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001622,
    "auth_name": "ESRI",
    "auth_id": "103511",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61623,
    "description": "NAD_1983_CORS96_StatePlane_Oklahoma_North_FIPS_3501_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=35.5666666666667 +lat_2=36.7666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001623,
    "auth_name": "ESRI",
    "auth_id": "103512",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61624,
    "description": "NAD_1983_CORS96_StatePlane_Oklahoma_South_FIPS_3502_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=33.3333333333333 +lon_0=-98 +lat_1=33.9333333333333 +lat_2=35.2333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001624,
    "auth_name": "ESRI",
    "auth_id": "103513",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61625,
    "description": "NAD_1983_CORS96_StatePlane_Pennsylvania_North_FIPS_3701",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=40.8833333333333 +lat_2=41.95 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001625,
    "auth_name": "ESRI",
    "auth_id": "103514",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61626,
    "description": "NAD_1983_CORS96_StatePlane_Pennsylvania_North_FIPS_3701_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.1666666666667 +lon_0=-77.75 +lat_1=40.8833333333333 +lat_2=41.95 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001626,
    "auth_name": "ESRI",
    "auth_id": "103515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61627,
    "description": "NAD_1983_CORS96_StatePlane_Pennsylvania_South_FIPS_3702",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=39.9333333333333 +lat_2=40.9666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001627,
    "auth_name": "ESRI",
    "auth_id": "103516",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61628,
    "description": "NAD_1983_CORS96_StatePlane_Pennsylvania_South_FIPS_3702_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-77.75 +lat_1=39.9333333333333 +lat_2=40.9666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001628,
    "auth_name": "ESRI",
    "auth_id": "103517",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61629,
    "description": "NAD_1983_CORS96_StatePlane_Rhode_Island_FIPS_3800",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001629,
    "auth_name": "ESRI",
    "auth_id": "103518",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61630,
    "description": "NAD_1983_CORS96_StatePlane_Rhode_Island_FIPS_3800_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=41.0833333333333 +lon_0=-71.5 +k=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001630,
    "auth_name": "ESRI",
    "auth_id": "103519",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61631,
    "description": "NAD_1983_CORS96_StatePlane_South_Carolina_FIPS_3900",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=32.5 +lat_2=34.8333333333333 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001631,
    "auth_name": "ESRI",
    "auth_id": "103520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61632,
    "description": "NAD_1983_CORS96_StatePlane_South_Carolina_FIPS_3900_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.8333333333333 +lon_0=-81 +lat_1=32.5 +lat_2=34.8333333333333 +x_0=609600 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001632,
    "auth_name": "ESRI",
    "auth_id": "103521",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61633,
    "description": "NAD_1983_CORS96_StatePlane_South_Dakota_North_FIPS_4001",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=44.4166666666667 +lat_2=45.6833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001633,
    "auth_name": "ESRI",
    "auth_id": "103522",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61634,
    "description": "NAD_1983_CORS96_StatePlane_South_Dakota_South_FIPS_4002",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=42.8333333333333 +lat_2=44.4 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001634,
    "auth_name": "ESRI",
    "auth_id": "103523",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61635,
    "description": "NAD_1983_CORS96_StatePlane_South_Dakota_North_FIPS_4001_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-100 +lat_1=44.4166666666667 +lat_2=45.6833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001635,
    "auth_name": "ESRI",
    "auth_id": "103524",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61636,
    "description": "NAD_1983_CORS96_StatePlane_South_Dakota_South_FIPS_4002_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42.3333333333333 +lon_0=-100.333333333333 +lat_1=42.8333333333333 +lat_2=44.4 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001636,
    "auth_name": "ESRI",
    "auth_id": "103525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61637,
    "description": "NAD_1983_CORS96_StatePlane_Tennessee_FIPS_4100",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=35.25 +lat_2=36.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001637,
    "auth_name": "ESRI",
    "auth_id": "103526",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61638,
    "description": "NAD_1983_CORS96_StatePlane_Tennessee_FIPS_4100_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34.3333333333333 +lon_0=-86 +lat_1=35.25 +lat_2=36.4166666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001638,
    "auth_name": "ESRI",
    "auth_id": "103527",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61650,
    "description": "NAD_1983_CORS96_StatePlane_Texas_North_FIPS_4201",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.1833333333333 +x_0=200000 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001650,
    "auth_name": "ESRI",
    "auth_id": "103539",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61651,
    "description": "NAD_1983_CORS96_StatePlane_Texas_North_Central_FIPS_4202",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=32.1333333333333 +lat_2=33.9666666666667 +x_0=600000 +y_0=2000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001651,
    "auth_name": "ESRI",
    "auth_id": "103540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61652,
    "description": "NAD_1983_CORS96_StatePlane_Texas_Central_FIPS_4203",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=30.1166666666667 +lat_2=31.8833333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001652,
    "auth_name": "ESRI",
    "auth_id": "103541",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61653,
    "description": "NAD_1983_CORS96_StatePlane_Texas_South_Central_FIPS_4204",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=28.3833333333333 +lat_2=30.2833333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001653,
    "auth_name": "ESRI",
    "auth_id": "103542",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61654,
    "description": "NAD_1983_CORS96_StatePlane_Texas_South_FIPS_4205",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=26.1666666666667 +lat_2=27.8333333333333 +x_0=300000 +y_0=5000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001654,
    "auth_name": "ESRI",
    "auth_id": "103543",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61655,
    "description": "NAD_1983_CORS96_StatePlane_Texas_North_FIPS_4201_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.1833333333333 +x_0=200000 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001655,
    "auth_name": "ESRI",
    "auth_id": "103544",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61656,
    "description": "NAD_1983_CORS96_StatePlane_Texas_North_Central_FIPS_4202_FtUS",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=31.6666666666667 +lon_0=-98.5 +lat_1=32.1333333333333 +lat_2=33.9666666666667 +x_0=600000 +y_0=2000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001656,
    "auth_name": "ESRI",
    "auth_id": "103545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61657,
    "description": "NAD_1983_CORS96_StatePlane_Texas_Central_FIPS_4203_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=29.6666666666667 +lon_0=-100.333333333333 +lat_1=30.1166666666667 +lat_2=31.8833333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001657,
    "auth_name": "ESRI",
    "auth_id": "103546",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61658,
    "description": "NAD_1983_CORS96_StatePlane_Texas_South_Central_FIPS_4204_FtUS",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=27.8333333333333 +lon_0=-99 +lat_1=28.3833333333333 +lat_2=30.2833333333333 +x_0=600000 +y_0=3999999.99999999 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001658,
    "auth_name": "ESRI",
    "auth_id": "103547",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61659,
    "description": "NAD_1983_CORS96_StatePlane_Texas_South_FIPS_4205_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=25.6666666666667 +lon_0=-98.5 +lat_1=26.1666666666667 +lat_2=27.8333333333333 +x_0=300000 +y_0=5000000.00000001 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001659,
    "auth_name": "ESRI",
    "auth_id": "103548",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61660,
    "description": "NAD_1983_CORS96_StatePlane_Utah_North_FIPS_4301",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001660,
    "auth_name": "ESRI",
    "auth_id": "103549",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61661,
    "description": "NAD_1983_CORS96_StatePlane_Utah_Central_FIPS_4302",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001661,
    "auth_name": "ESRI",
    "auth_id": "103550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61662,
    "description": "NAD_1983_CORS96_StatePlane_Utah_South_FIPS_4303",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001662,
    "auth_name": "ESRI",
    "auth_id": "103551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61663,
    "description": "NAD_1983_CORS96_StatePlane_Utah_North_FIPS_4301_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=500000 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001663,
    "auth_name": "ESRI",
    "auth_id": "103552",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61664,
    "description": "NAD_1983_CORS96_StatePlane_Utah_Central_FIPS_4302_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=500000 +y_0=2000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001664,
    "auth_name": "ESRI",
    "auth_id": "103553",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61665,
    "description": "NAD_1983_CORS96_StatePlane_Utah_South_FIPS_4303_Ft_Intl",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=500000 +y_0=3000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520001665,
    "auth_name": "ESRI",
    "auth_id": "103554",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61666,
    "description": "NAD_1983_CORS96_StatePlane_Utah_North_FIPS_4301_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=40.3333333333333 +lon_0=-111.5 +lat_1=40.7166666666667 +lat_2=41.7833333333333 +x_0=500000.000000001 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001666,
    "auth_name": "ESRI",
    "auth_id": "103555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61667,
    "description": "NAD_1983_CORS96_StatePlane_Utah_Central_FIPS_4302_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.3333333333333 +lon_0=-111.5 +lat_1=39.0166666666667 +lat_2=40.65 +x_0=500000.000000001 +y_0=2000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001667,
    "auth_name": "ESRI",
    "auth_id": "103556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61668,
    "description": "NAD_1983_CORS96_StatePlane_Utah_South_FIPS_4303_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.6666666666667 +lon_0=-111.5 +lat_1=37.2166666666667 +lat_2=38.35 +x_0=500000.000000001 +y_0=3000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001668,
    "auth_name": "ESRI",
    "auth_id": "103557",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61669,
    "description": "NAD_1983_CORS96_StatePlane_Vermont_FIPS_4400",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964285714286 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001669,
    "auth_name": "ESRI",
    "auth_id": "103558",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61670,
    "description": "NAD_1983_CORS96_StatePlane_Virginia_North_FIPS_4501",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=38.0333333333333 +lat_2=39.2 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001670,
    "auth_name": "ESRI",
    "auth_id": "103559",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61671,
    "description": "NAD_1983_CORS96_StatePlane_Virginia_South_FIPS_4502",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=36.7666666666667 +lat_2=37.9666666666667 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001671,
    "auth_name": "ESRI",
    "auth_id": "103560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61672,
    "description": "NAD_1983_CORS96_StatePlane_Virginia_North_FIPS_4501_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-78.5 +lat_1=38.0333333333333 +lat_2=39.2 +x_0=3500000.00000001 +y_0=2000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001672,
    "auth_name": "ESRI",
    "auth_id": "103561",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61673,
    "description": "NAD_1983_CORS96_StatePlane_Virginia_South_FIPS_4502_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=36.3333333333333 +lon_0=-78.5 +lat_1=36.7666666666667 +lat_2=37.9666666666667 +x_0=3500000.00000001 +y_0=1000000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001673,
    "auth_name": "ESRI",
    "auth_id": "103562",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61674,
    "description": "NAD_1983_CORS96_StatePlane_Washington_North_FIPS_4601",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=47.5 +lat_2=48.7333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001674,
    "auth_name": "ESRI",
    "auth_id": "103563",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61675,
    "description": "NAD_1983_CORS96_StatePlane_Washington_South_FIPS_4602",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=45.8333333333333 +lat_2=47.3333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001675,
    "auth_name": "ESRI",
    "auth_id": "103564",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61676,
    "description": "NAD_1983_CORS96_StatePlane_Washington_North_FIPS_4601_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=-120.833333333333 +lat_1=47.5 +lat_2=48.7333333333333 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001676,
    "auth_name": "ESRI",
    "auth_id": "103565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61677,
    "description": "NAD_1983_CORS96_StatePlane_Washington_South_FIPS_4602_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.3333333333333 +lon_0=-120.5 +lat_1=45.8333333333333 +lat_2=47.3333333333333 +x_0=500000.000000001 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001677,
    "auth_name": "ESRI",
    "auth_id": "103566",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61678,
    "description": "NAD_1983_CORS96_StatePlane_West_Virginia_North_FIPS_4701",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=39 +lat_2=40.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001678,
    "auth_name": "ESRI",
    "auth_id": "103567",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61679,
    "description": "NAD_1983_CORS96_StatePlane_West_Virginia_South_FIPS_4702",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=37.4833333333333 +lat_2=38.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001679,
    "auth_name": "ESRI",
    "auth_id": "103568",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61680,
    "description": "NAD_1983_CORS96_StatePlane_West_Virginia_North_FIPS_4701_FtUS",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=39 +lat_2=40.25 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001680,
    "auth_name": "ESRI",
    "auth_id": "103569",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61681,
    "description": "NAD_1983_CORS96_StatePlane_West_Virginia_South_FIPS_4702_FtUS",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=37.4833333333333 +lat_2=38.8833333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001681,
    "auth_name": "ESRI",
    "auth_id": "103570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61682,
    "description": "NAD_1983_CORS96_StatePlane_Wisconsin_North_FIPS_4801",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=45.5666666666667 +lat_2=46.7666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001682,
    "auth_name": "ESRI",
    "auth_id": "103571",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61683,
    "description": "NAD_1983_CORS96_StatePlane_Wisconsin_Central_FIPS_4802",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=44.25 +lat_2=45.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001683,
    "auth_name": "ESRI",
    "auth_id": "103572",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61684,
    "description": "NAD_1983_CORS96_StatePlane_Wisconsin_South_FIPS_4803",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=42.7333333333333 +lat_2=44.0666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001684,
    "auth_name": "ESRI",
    "auth_id": "103573",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61685,
    "description": "NAD_1983_CORS96_StatePlane_Wisconsin_North_FIPS_4801_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45.1666666666667 +lon_0=-90 +lat_1=45.5666666666667 +lat_2=46.7666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001685,
    "auth_name": "ESRI",
    "auth_id": "103574",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61686,
    "description": "NAD_1983_CORS96_StatePlane_Wisconsin_Central_FIPS_4802_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43.8333333333333 +lon_0=-90 +lat_1=44.25 +lat_2=45.5 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001686,
    "auth_name": "ESRI",
    "auth_id": "103575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61687,
    "description": "NAD_1983_CORS96_StatePlane_Wisconsin_South_FIPS_4803_Ft_US",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=42.7333333333333 +lat_2=44.0666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001687,
    "auth_name": "ESRI",
    "auth_id": "103576",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61688,
    "description": "NAD_1983_CORS96_StatePlane_Wyoming_East_FIPS_4901",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001688,
    "auth_name": "ESRI",
    "auth_id": "103577",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61689,
    "description": "NAD_1983_CORS96_StatePlane_Wyoming_East_Central_FIPS_4902",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001689,
    "auth_name": "ESRI",
    "auth_id": "103578",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61690,
    "description": "NAD_1983_CORS96_StatePlane_Wyoming_West_Central_FIPS_4903",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001690,
    "auth_name": "ESRI",
    "auth_id": "103579",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61691,
    "description": "NAD_1983_CORS96_StatePlane_Wyoming_West_FIPS_4904",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001691,
    "auth_name": "ESRI",
    "auth_id": "103580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61692,
    "description": "NAD_1983_CORS96_StatePlane_Wyoming_East_FIPS_4901_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-105.166666666667 +k=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001692,
    "auth_name": "ESRI",
    "auth_id": "103581",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61693,
    "description": "NAD_1983_CORS96_StatePlane_Wyoming_E_Central_FIPS_4902_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-107.333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001693,
    "auth_name": "ESRI",
    "auth_id": "103582",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61694,
    "description": "NAD_1983_CORS96_StatePlane_Wyoming_W_Central_FIPS_4903_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001694,
    "auth_name": "ESRI",
    "auth_id": "103583",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61696,
    "description": "NAD_1983_CORS96_StatePlane_Wyoming_West_FIPS_4904_Ft_US",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=40.5 +lon_0=-110.083333333333 +k=0.9999375 +x_0=800000.000000001 +y_0=100000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001696,
    "auth_name": "ESRI",
    "auth_id": "103585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61697,
    "description": "NAD_1983_HARN_Adj_MN_Aitkin_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=46.1541666666667 +lon_0=-93.4325 +k=1.000059152669 +x_0=152409.319685395 +y_0=30481.863937079 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001697,
    "auth_name": "ESRI",
    "auth_id": "103600",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61698,
    "description": "NAD_1983_HARN_Adj_MN_Clay_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=46.63 +lon_0=-96.7 +k=1.000045317862 +x_0=152407.211256591 +y_0=30481.4422513183 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001698,
    "auth_name": "ESRI",
    "auth_id": "103601",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61699,
    "description": "NAD_1983_HARN_Adj_MN_Clearwater_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=47.1516666666667 +lon_0=-95.3758333333333 +k=1.000072505661 +x_0=152411.354685446 +y_0=30482.2709370892 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001699,
    "auth_name": "ESRI",
    "auth_id": "103602",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61700,
    "description": "NAD_1983_HARN_Adj_MN_Hubbard_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=46.8036111111111 +lon_0=-94.9205555555556 +k=1.000071553661 +x_0=152411.209600356 +y_0=30482.2419200711 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001700,
    "auth_name": "ESRI",
    "auth_id": "103603",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61701,
    "description": "NAD_1983_HARN_Adj_MN_Lake_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=47.0666666666667 +lon_0=-91.4091666666667 +k=1.000075844621 +x_0=152411.863543968 +y_0=30482.3727087935 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001701,
    "auth_name": "ESRI",
    "auth_id": "103604",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61702,
    "description": "NAD_1983_HARN_Adj_MN_Mille_Lacs_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.5588888888889 +lon_0=-93.6205555555556 +k=1.000054146138 +x_0=152408.556688545 +y_0=30481.7113377089 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001702,
    "auth_name": "ESRI",
    "auth_id": "103605",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61703,
    "description": "NAD_1983_HARN_Adj_MN_Washington_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.7458333333333 +lon_0=-92.8333333333333 +k=1.000039836799 +x_0=152406.37594092 +y_0=30481.2751881839 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001703,
    "auth_name": "ESRI",
    "auth_id": "103606",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61704,
    "description": "NAD_1983_HARN_Adj_MN_Wilkin_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=46.0216666666667 +lon_0=-96.5244444444445 +k=1.000048901066 +x_0=152407.757337973 +y_0=30481.5514675946 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520001704,
    "auth_name": "ESRI",
    "auth_id": "103607",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61705,
    "description": "NAD_1983_HARN_Adj_MN_Anoka_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.0352777777778 +lon_0=-93.2666666666667 +lat_1=45.0666666666667 +lat_2=45.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001705,
    "auth_name": "ESRI",
    "auth_id": "103608",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61706,
    "description": "NAD_1983_HARN_Adj_MN_Becker_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.7177777777778 +lon_0=-95.6833333333333 +lat_1=46.7833333333333 +lat_2=47.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378586.581 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001706,
    "auth_name": "ESRI",
    "auth_id": "103609",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61707,
    "description": "NAD_1983_HARN_Adj_MN_Beltrami_North_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.02 +lon_0=-95.0166666666667 +lat_1=48.1166666666667 +lat_2=48.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378505.809 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001707,
    "auth_name": "ESRI",
    "auth_id": "103610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61708,
    "description": "NAD_1983_HARN_Adj_MN_Beltrami_South_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4125 +lon_0=-94.85 +lat_1=47.5 +lat_2=47.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378544.823 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001708,
    "auth_name": "ESRI",
    "auth_id": "103611",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61709,
    "description": "NAD_1983_HARN_Adj_MN_Benton_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.5591666666667 +lon_0=-94.05 +lat_1=45.5833333333333 +lat_2=45.7833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378490.569 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001709,
    "auth_name": "ESRI",
    "auth_id": "103612",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61710,
    "description": "NAD_1983_HARN_Adj_MN_Big_Stone_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.1522222222222 +lon_0=-96.05 +lat_1=45.2166666666667 +lat_2=45.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378470.757 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001710,
    "auth_name": "ESRI",
    "auth_id": "103613",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61711,
    "description": "NAD_1983_HARN_Adj_MN_Blue_Earth_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.2666666666667 +lat_1=43.9333333333333 +lat_2=44.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378403.701 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001711,
    "auth_name": "ESRI",
    "auth_id": "103614",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61712,
    "description": "NAD_1983_HARN_Adj_MN_Brown_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1080555555556 +lon_0=-94.7333333333333 +lat_1=44.1666666666667 +lat_2=44.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001712,
    "auth_name": "ESRI",
    "auth_id": "103615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61713,
    "description": "NAD_1983_HARN_Adj_MN_Carlton_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.4172222222222 +lon_0=-92.6833333333333 +lat_1=46.4666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378454.907 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001713,
    "auth_name": "ESRI",
    "auth_id": "103616",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61714,
    "description": "NAD_1983_HARN_Adj_MN_Carver_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.6397222222222 +lon_0=-93.7666666666667 +lat_1=44.6833333333333 +lat_2=44.9 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378400.653 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001714,
    "auth_name": "ESRI",
    "auth_id": "103617",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61715,
    "description": "NAD_1983_HARN_Adj_MN_Cass_North_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.8036111111111 +lon_0=-94.2166666666667 +lat_1=46.9166666666667 +lat_2=47.3166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378567.378 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001715,
    "auth_name": "ESRI",
    "auth_id": "103618",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61716,
    "description": "NAD_1983_HARN_Adj_MN_Cass_South_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001716,
    "auth_name": "ESRI",
    "auth_id": "103619",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61717,
    "description": "NAD_1983_HARN_Adj_MN_Chippewa_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.7527777777778 +lon_0=-95.85 +lat_1=44.8333333333333 +lat_2=45.2 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378476.853 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001717,
    "auth_name": "ESRI",
    "auth_id": "103620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61718,
    "description": "NAD_1983_HARN_Adj_MN_Chisago_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2963888888889 +lon_0=-93.0833333333333 +lat_1=45.3333333333333 +lat_2=45.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378411.321 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001718,
    "auth_name": "ESRI",
    "auth_id": "103621",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61719,
    "description": "NAD_1983_HARN_Adj_MN_Cook_North_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.8833333333333 +lon_0=-90.25 +lat_1=47.9333333333333 +lat_2=48.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378647.541 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001719,
    "auth_name": "ESRI",
    "auth_id": "103622",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61720,
    "description": "NAD_1983_HARN_Adj_MN_Cook_South_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4388888888889 +lon_0=-90.25 +lat_1=47.55 +lat_2=47.8166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378647.541 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001720,
    "auth_name": "ESRI",
    "auth_id": "103623",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61721,
    "description": "NAD_1983_HARN_Adj_MN_Cottonwood_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.9166666666667 +lat_1=43.9 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378514.953 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001721,
    "auth_name": "ESRI",
    "auth_id": "103624",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61722,
    "description": "NAD_1983_HARN_Adj_MN_Crow_Wing_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001722,
    "auth_name": "ESRI",
    "auth_id": "103625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61723,
    "description": "NAD_1983_HARN_Adj_MN_Dakota_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4719444444445 +lon_0=-93.3166666666667 +lat_1=44.5166666666667 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378421.989 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001723,
    "auth_name": "ESRI",
    "auth_id": "103626",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61724,
    "description": "NAD_1983_HARN_Adj_MN_Dodge_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001724,
    "auth_name": "ESRI",
    "auth_id": "103627",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61725,
    "description": "NAD_1983_HARN_Adj_MN_Douglas_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.7588888888889 +lon_0=-96.05 +lat_1=45.8 +lat_2=46.05 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378518.001 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001725,
    "auth_name": "ESRI",
    "auth_id": "103628",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61726,
    "description": "NAD_1983_HARN_Adj_MN_Faribault_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001726,
    "auth_name": "ESRI",
    "auth_id": "103629",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61727,
    "description": "NAD_1983_HARN_Adj_MN_Fillmore_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-92.0833333333333 +lat_1=43.55 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378464.661 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001727,
    "auth_name": "ESRI",
    "auth_id": "103630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61728,
    "description": "NAD_1983_HARN_Adj_MN_Freeborn_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001728,
    "auth_name": "ESRI",
    "auth_id": "103631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61729,
    "description": "NAD_1983_HARN_Adj_MN_Goodhue_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001729,
    "auth_name": "ESRI",
    "auth_id": "103632",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61730,
    "description": "NAD_1983_HARN_Adj_MN_Grant_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.7588888888889 +lon_0=-96.05 +lat_1=45.8 +lat_2=46.05 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378518.001 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001730,
    "auth_name": "ESRI",
    "auth_id": "103633",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61731,
    "description": "NAD_1983_HARN_Adj_MN_Hennepin_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.7911111111111 +lon_0=-93.3833333333334 +lat_1=44.8833333333333 +lat_2=45.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001731,
    "auth_name": "ESRI",
    "auth_id": "103634",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61732,
    "description": "NAD_1983_HARN_Adj_MN_Houston_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-91.4666666666667 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378436.619 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001732,
    "auth_name": "ESRI",
    "auth_id": "103635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61733,
    "description": "NAD_1983_HARN_Adj_MN_Isanti_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2963888888889 +lon_0=-93.0833333333333 +lat_1=45.3333333333333 +lat_2=45.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378411.321 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001733,
    "auth_name": "ESRI",
    "auth_id": "103636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61734,
    "description": "NAD_1983_HARN_Adj_MN_Itasca_North_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.5 +lon_0=-93.7333333333333 +lat_1=47.5666666666667 +lat_2=47.8166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378574.389 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001734,
    "auth_name": "ESRI",
    "auth_id": "103637",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61735,
    "description": "NAD_1983_HARN_Adj_MN_Itasca_South_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.0263888888889 +lon_0=-93.7333333333333 +lat_1=47.0833333333333 +lat_2=47.4166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378574.389 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001735,
    "auth_name": "ESRI",
    "auth_id": "103638",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61736,
    "description": "NAD_1983_HARN_Adj_MN_Jackson_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001736,
    "auth_name": "ESRI",
    "auth_id": "103639",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61737,
    "description": "NAD_1983_HARN_Adj_MN_Kanabec_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.73 +lon_0=-92.9 +lat_1=45.8166666666667 +lat_2=46.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378472.281 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001737,
    "auth_name": "ESRI",
    "auth_id": "103640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61738,
    "description": "NAD_1983_HARN_Adj_MN_Kandiyohi_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.8913888888889 +lon_0=-94.75 +lat_1=44.9666666666667 +lat_2=45.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378498.189 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001738,
    "auth_name": "ESRI",
    "auth_id": "103641",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61739,
    "description": "NAD_1983_HARN_Adj_MN_Kittson_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.5438888888889 +lon_0=-96.15 +lat_1=48.6 +lat_2=48.9333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378449.421 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001739,
    "auth_name": "ESRI",
    "auth_id": "103642",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61740,
    "description": "NAD_1983_HARN_Adj_MN_Koochiching_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.8458333333333 +lon_0=-93.75 +lat_1=48 +lat_2=48.6166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378525.621 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001740,
    "auth_name": "ESRI",
    "auth_id": "103643",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61741,
    "description": "NAD_1983_HARN_Adj_MN_Lac_Qui_Parle_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.7527777777778 +lon_0=-95.85 +lat_1=44.8333333333333 +lat_2=45.2 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378476.853 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001741,
    "auth_name": "ESRI",
    "auth_id": "103644",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61742,
    "description": "NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_North_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=49.15 +lon_0=-94.9833333333333 +lat_1=49.1833333333333 +lat_2=49.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378466.185 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001742,
    "auth_name": "ESRI",
    "auth_id": "103645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61743,
    "description": "NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_South_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.3661111111111 +lon_0=-94.8833333333333 +lat_1=48.45 +lat_2=48.8833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378496.665 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001743,
    "auth_name": "ESRI",
    "auth_id": "103646",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61744,
    "description": "NAD_1983_HARN_Adj_MN_Le_Sueur_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001744,
    "auth_name": "ESRI",
    "auth_id": "103647",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61745,
    "description": "NAD_1983_HARN_Adj_MN_Lincoln_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1966666666667 +lon_0=-96.2666666666667 +lat_1=44.2833333333333 +lat_2=44.6166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378643.579 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001745,
    "auth_name": "ESRI",
    "auth_id": "103648",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61746,
    "description": "NAD_1983_HARN_Adj_MN_Lyon_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1955555555556 +lon_0=-95.85 +lat_1=44.25 +lat_2=44.5833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378559.758 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001746,
    "auth_name": "ESRI",
    "auth_id": "103649",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61747,
    "description": "NAD_1983_HARN_Adj_MN_McLeod_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333334 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001747,
    "auth_name": "ESRI",
    "auth_id": "103650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61748,
    "description": "NAD_1983_HARN_Adj_MN_Mahnomen_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.1516666666667 +lon_0=-95.8166666666667 +lat_1=47.2 +lat_2=47.45 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378586.581 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001748,
    "auth_name": "ESRI",
    "auth_id": "103651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61749,
    "description": "NAD_1983_HARN_Adj_MN_Marshall_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.1730555555555 +lon_0=-96.3833333333333 +lat_1=48.2333333333333 +lat_2=48.4833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378441.801 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001749,
    "auth_name": "ESRI",
    "auth_id": "103652",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61750,
    "description": "NAD_1983_HARN_Adj_MN_Martin_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001750,
    "auth_name": "ESRI",
    "auth_id": "103653",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61751,
    "description": "NAD_1983_HARN_Adj_MN_Meeker_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.8913888888889 +lon_0=-94.75 +lat_1=44.9666666666667 +lat_2=45.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378498.189 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001751,
    "auth_name": "ESRI",
    "auth_id": "103654",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61752,
    "description": "NAD_1983_HARN_Adj_MN_Morrison_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.7738888888889 +lon_0=-94.2 +lat_1=45.85 +lat_2=46.2666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001752,
    "auth_name": "ESRI",
    "auth_id": "103655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61753,
    "description": "NAD_1983_HARN_Adj_MN_Mower_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001753,
    "auth_name": "ESRI",
    "auth_id": "103656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61754,
    "description": "NAD_1983_HARN_Adj_MN_Murray_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-95.7666666666667 +lat_1=43.9166666666667 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378617.061 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001754,
    "auth_name": "ESRI",
    "auth_id": "103657",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61755,
    "description": "NAD_1983_HARN_Adj_MN_Nicollet_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.2666666666667 +lat_1=43.9333333333333 +lat_2=44.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378403.701 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001755,
    "auth_name": "ESRI",
    "auth_id": "103658",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61756,
    "description": "NAD_1983_HARN_Adj_MN_Nobles_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-95.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378624.681 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001756,
    "auth_name": "ESRI",
    "auth_id": "103659",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61757,
    "description": "NAD_1983_HARN_Adj_MN_Norman_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.1505555555556 +lon_0=-96.45 +lat_1=47.2 +lat_2=47.45 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378468.623 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001757,
    "auth_name": "ESRI",
    "auth_id": "103660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61758,
    "description": "NAD_1983_HARN_Adj_MN_Olmsted_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001758,
    "auth_name": "ESRI",
    "auth_id": "103661",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61759,
    "description": "NAD_1983_HARN_Adj_MN_Ottertail_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.1063888888889 +lon_0=-95.7166666666667 +lat_1=46.1833333333333 +lat_2=46.65 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378525.621 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001759,
    "auth_name": "ESRI",
    "auth_id": "103662",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61760,
    "description": "NAD_1983_HARN_Adj_MN_Pennington_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001760,
    "auth_name": "ESRI",
    "auth_id": "103663",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61761,
    "description": "NAD_1983_HARN_Adj_MN_Pine_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.73 +lon_0=-92.9 +lat_1=45.8166666666667 +lat_2=46.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378472.281 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001761,
    "auth_name": "ESRI",
    "auth_id": "103664",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61762,
    "description": "NAD_1983_HARN_Adj_MN_Pipestone_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8491666666667 +lon_0=-96.25 +lat_1=43.8833333333333 +lat_2=44.15 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378670.401 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001762,
    "auth_name": "ESRI",
    "auth_id": "103665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61763,
    "description": "NAD_1983_HARN_Adj_MN_Polk_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001763,
    "auth_name": "ESRI",
    "auth_id": "103666",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61764,
    "description": "NAD_1983_HARN_Adj_MN_Pope_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001764,
    "auth_name": "ESRI",
    "auth_id": "103667",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61765,
    "description": "NAD_1983_HARN_Adj_MN_Ramsey_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.7911111111111 +lon_0=-93.3833333333334 +lat_1=44.8833333333333 +lat_2=45.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001765,
    "auth_name": "ESRI",
    "auth_id": "103668",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61766,
    "description": "NAD_1983_HARN_Adj_MN_Red_Lake_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001766,
    "auth_name": "ESRI",
    "auth_id": "103669",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61767,
    "description": "NAD_1983_HARN_Adj_MN_Redwood_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1947222222222 +lon_0=-95.2333333333333 +lat_1=44.2666666666667 +lat_2=44.5666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378438.753 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001767,
    "auth_name": "ESRI",
    "auth_id": "103670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61768,
    "description": "NAD_1983_HARN_Adj_MN_Renville_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333334 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001768,
    "auth_name": "ESRI",
    "auth_id": "103671",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61769,
    "description": "NAD_1983_HARN_Adj_MN_Rice_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001769,
    "auth_name": "ESRI",
    "auth_id": "103672",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61770,
    "description": "NAD_1983_HARN_Adj_MN_Rock_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-95.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378624.681 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001770,
    "auth_name": "ESRI",
    "auth_id": "103673",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61771,
    "description": "NAD_1983_HARN_Adj_MN_Roseau_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.5438888888889 +lon_0=-96.15 +lat_1=48.6 +lat_2=48.9333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378449.421 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001771,
    "auth_name": "ESRI",
    "auth_id": "103674",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61772,
    "description": "NAD_1983_HARN_Adj_MN_St_Louis_North_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.8333333333333 +lon_0=-92.45 +lat_1=47.9833333333333 +lat_2=48.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378543.909 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001772,
    "auth_name": "ESRI",
    "auth_id": "103675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61773,
    "description": "NAD_1983_HARN_Adj_MN_St_Louis_Central_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.25 +lon_0=-92.45 +lat_1=47.3333333333333 +lat_2=47.75 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378605.783 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001773,
    "auth_name": "ESRI",
    "auth_id": "103676",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61774,
    "description": "NAD_1983_HARN_Adj_MN_St_Louis_South_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.65 +lon_0=-92.45 +lat_1=46.7833333333333 +lat_2=47.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378540.861 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001774,
    "auth_name": "ESRI",
    "auth_id": "103677",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61775,
    "description": "NAD_1983_HARN_Adj_MN_Scott_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4719444444445 +lon_0=-93.3166666666667 +lat_1=44.5166666666667 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378421.989 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001775,
    "auth_name": "ESRI",
    "auth_id": "103678",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61776,
    "description": "NAD_1983_HARN_Adj_MN_Sherburne_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.9775 +lon_0=-93.8833333333333 +lat_1=45.0333333333333 +lat_2=45.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378443.325 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001776,
    "auth_name": "ESRI",
    "auth_id": "103679",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61777,
    "description": "NAD_1983_HARN_Adj_MN_Sibley_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333334 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001777,
    "auth_name": "ESRI",
    "auth_id": "103680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61778,
    "description": "NAD_1983_HARN_Adj_MN_Stearns_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001778,
    "auth_name": "ESRI",
    "auth_id": "103681",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61779,
    "description": "NAD_1983_HARN_Adj_MN_Steele_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001779,
    "auth_name": "ESRI",
    "auth_id": "103682",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61780,
    "description": "NAD_1983_HARN_Adj_MN_Stevens_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001780,
    "auth_name": "ESRI",
    "auth_id": "103683",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61781,
    "description": "NAD_1983_HARN_Adj_MN_Swift_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.1522222222222 +lon_0=-96.05 +lat_1=45.2166666666667 +lat_2=45.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378470.757 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001781,
    "auth_name": "ESRI",
    "auth_id": "103684",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61782,
    "description": "NAD_1983_HARN_Adj_MN_Todd_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.7733333333333 +lon_0=-94.9 +lat_1=45.8666666666667 +lat_2=46.2833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378548.481 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001782,
    "auth_name": "ESRI",
    "auth_id": "103685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61783,
    "description": "NAD_1983_HARN_Adj_MN_Traverse_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.5855555555556 +lon_0=-96.55 +lat_1=45.6333333333333 +lat_2=45.9666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378463.746 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001783,
    "auth_name": "ESRI",
    "auth_id": "103686",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61784,
    "description": "NAD_1983_HARN_Adj_MN_Wabasha_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1069444444444 +lon_0=-92.2666666666667 +lat_1=44.15 +lat_2=44.4166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378426.561 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001784,
    "auth_name": "ESRI",
    "auth_id": "103687",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61785,
    "description": "NAD_1983_HARN_Adj_MN_Wadena_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001785,
    "auth_name": "ESRI",
    "auth_id": "103688",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61786,
    "description": "NAD_1983_HARN_Adj_MN_Waseca_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001786,
    "auth_name": "ESRI",
    "auth_id": "103689",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61787,
    "description": "NAD_1983_HARN_Adj_MN_Watonwan_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.9166666666667 +lat_1=43.9 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378514.953 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001787,
    "auth_name": "ESRI",
    "auth_id": "103690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61788,
    "description": "NAD_1983_HARN_Adj_MN_Winona_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8472222222222 +lon_0=-91.6166666666667 +lat_1=43.9 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378453.688 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001788,
    "auth_name": "ESRI",
    "auth_id": "103691",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61789,
    "description": "NAD_1983_HARN_Adj_MN_Wright_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.9775 +lon_0=-93.8833333333333 +lat_1=45.0333333333333 +lat_2=45.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378443.325 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001789,
    "auth_name": "ESRI",
    "auth_id": "103692",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61790,
    "description": "NAD_1983_HARN_Adj_MN_Yellow_Medicine_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.5416666666667 +lon_0=-95.9 +lat_1=44.6666666666667 +lat_2=44.95 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378530.193 +rf=298.257222100883 +units=m +no_defs",
    "srid": 520001790,
    "auth_name": "ESRI",
    "auth_id": "103693",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61791,
    "description": "NAD_1983_HARN_Adj_MN_St_Louis_CS96_Meters",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=46.6166666666667 +lon_0=-92.45 +k=0.99998529 +x_0=1450000 +y_0=1000000 +a=6378523 +rf=298.2752724 +units=m +no_defs",
    "srid": 520001791,
    "auth_name": "ESRI",
    "auth_id": "103694",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61792,
    "description": "NAD_1983_HARN_Adj_MN_St_Louis_CS96_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=tmerc +lat_0=46.6166666666667 +lon_0=-92.45 +k=0.99998529 +x_0=1449999.9999999 +y_0=999999.999999899 +a=6378523 +rf=298.2752724 +units=us-ft +no_defs",
    "srid": 520001792,
    "auth_name": "ESRI",
    "auth_id": "103695",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61793,
    "description": "NAD_1983_HARN_Adj_MN_Aitkin_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=46.1541666666667 +lon_0=-93.4325 +k=1.000059152669 +x_0=152409.319685395 +y_0=30481.863937079 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001793,
    "auth_name": "ESRI",
    "auth_id": "103700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61794,
    "description": "NAD_1983_HARN_Adj_MN_Clay_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=46.63 +lon_0=-96.7 +k=1.000045317862 +x_0=152407.211256591 +y_0=30481.4422513183 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001794,
    "auth_name": "ESRI",
    "auth_id": "103701",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61795,
    "description": "NAD_1983_HARN_Adj_MN_Clearwater_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=47.1516666666667 +lon_0=-95.3758333333333 +k=1.000072505661 +x_0=152411.354685446 +y_0=30482.2709370892 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001795,
    "auth_name": "ESRI",
    "auth_id": "103702",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61796,
    "description": "NAD_1983_HARN_Adj_MN_Hubbard_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=46.8036111111111 +lon_0=-94.9205555555556 +k=1.000071553661 +x_0=152411.209600356 +y_0=30482.2419200711 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001796,
    "auth_name": "ESRI",
    "auth_id": "103703",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61797,
    "description": "NAD_1983_HARN_Adj_MN_Lake_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=47.0666666666667 +lon_0=-91.4091666666667 +k=1.000075844621 +x_0=152411.863543968 +y_0=30482.3727087935 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001797,
    "auth_name": "ESRI",
    "auth_id": "103704",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61798,
    "description": "NAD_1983_HARN_Adj_MN_Mille_Lacs_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=45.5588888888889 +lon_0=-93.6205555555556 +k=1.000054146138 +x_0=152408.556688545 +y_0=30481.7113377089 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001798,
    "auth_name": "ESRI",
    "auth_id": "103705",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61799,
    "description": "NAD_1983_HARN_Adj_MN_Washington_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=44.7458333333333 +lon_0=-92.8333333333333 +k=1.000039836799 +x_0=152406.37594092 +y_0=30481.2751881839 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001799,
    "auth_name": "ESRI",
    "auth_id": "103706",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61800,
    "description": "NAD_1983_HARN_Adj_MN_Wilkin_Feet",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=46.0216666666667 +lon_0=-96.5244444444445 +k=1.000048901066 +x_0=152407.757337973 +y_0=30481.5514675946 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520001800,
    "auth_name": "ESRI",
    "auth_id": "103707",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61801,
    "description": "NAD_1983_HARN_Adj_MN_Anoka_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.0352777777778 +lon_0=-93.2666666666667 +lat_1=45.0666666666667 +lat_2=45.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001801,
    "auth_name": "ESRI",
    "auth_id": "103708",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61802,
    "description": "NAD_1983_HARN_Adj_MN_Becker_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.7177777777778 +lon_0=-95.6833333333333 +lat_1=46.7833333333333 +lat_2=47.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378586.581 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001802,
    "auth_name": "ESRI",
    "auth_id": "103709",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61803,
    "description": "NAD_1983_HARN_Adj_MN_Beltrami_North_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.02 +lon_0=-95.0166666666667 +lat_1=48.1166666666667 +lat_2=48.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378505.809 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001803,
    "auth_name": "ESRI",
    "auth_id": "103710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61804,
    "description": "NAD_1983_HARN_Adj_MN_Beltrami_South_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4125 +lon_0=-94.85 +lat_1=47.5 +lat_2=47.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378544.823 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001804,
    "auth_name": "ESRI",
    "auth_id": "103711",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61805,
    "description": "NAD_1983_HARN_Adj_MN_Benton_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.5591666666667 +lon_0=-94.05 +lat_1=45.5833333333333 +lat_2=45.7833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378490.569 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001805,
    "auth_name": "ESRI",
    "auth_id": "103712",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61806,
    "description": "NAD_1983_HARN_Adj_MN_Big_Stone_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.1522222222222 +lon_0=-96.05 +lat_1=45.2166666666667 +lat_2=45.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378470.757 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001806,
    "auth_name": "ESRI",
    "auth_id": "103713",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61807,
    "description": "NAD_1983_HARN_Adj_MN_Blue_Earth_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.2666666666667 +lat_1=43.9333333333333 +lat_2=44.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378403.701 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001807,
    "auth_name": "ESRI",
    "auth_id": "103714",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61808,
    "description": "NAD_1983_HARN_Adj_MN_Brown_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1080555555556 +lon_0=-94.7333333333333 +lat_1=44.1666666666667 +lat_2=44.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001808,
    "auth_name": "ESRI",
    "auth_id": "103715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61809,
    "description": "NAD_1983_HARN_Adj_MN_Carlton_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.4172222222222 +lon_0=-92.6833333333333 +lat_1=46.4666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378454.907 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001809,
    "auth_name": "ESRI",
    "auth_id": "103716",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61810,
    "description": "NAD_1983_HARN_Adj_MN_Carver_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.6397222222222 +lon_0=-93.7666666666667 +lat_1=44.6833333333333 +lat_2=44.9 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378400.653 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001810,
    "auth_name": "ESRI",
    "auth_id": "103717",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61811,
    "description": "NAD_1983_HARN_Adj_MN_Cass_North_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.8036111111111 +lon_0=-94.2166666666667 +lat_1=46.9166666666667 +lat_2=47.3166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378567.378 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001811,
    "auth_name": "ESRI",
    "auth_id": "103718",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61812,
    "description": "NAD_1983_HARN_Adj_MN_Cass_South_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001812,
    "auth_name": "ESRI",
    "auth_id": "103719",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61813,
    "description": "NAD_1983_HARN_Adj_MN_Chippewa_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.7527777777778 +lon_0=-95.85 +lat_1=44.8333333333333 +lat_2=45.2 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378476.853 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001813,
    "auth_name": "ESRI",
    "auth_id": "103720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61814,
    "description": "NAD_1983_HARN_Adj_MN_Chisago_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2963888888889 +lon_0=-93.0833333333333 +lat_1=45.3333333333333 +lat_2=45.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378411.321 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001814,
    "auth_name": "ESRI",
    "auth_id": "103721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61815,
    "description": "NAD_1983_HARN_Adj_MN_Cook_North_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.8833333333333 +lon_0=-90.25 +lat_1=47.9333333333333 +lat_2=48.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378647.541 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001815,
    "auth_name": "ESRI",
    "auth_id": "103722",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61816,
    "description": "NAD_1983_HARN_Adj_MN_Cook_South_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4388888888889 +lon_0=-90.25 +lat_1=47.55 +lat_2=47.8166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378647.541 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001816,
    "auth_name": "ESRI",
    "auth_id": "103723",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61817,
    "description": "NAD_1983_HARN_Adj_MN_Cottonwood_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.9166666666667 +lat_1=43.9 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378514.953 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001817,
    "auth_name": "ESRI",
    "auth_id": "103724",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61818,
    "description": "NAD_1983_HARN_Adj_MN_Crow_Wing_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001818,
    "auth_name": "ESRI",
    "auth_id": "103725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61819,
    "description": "NAD_1983_HARN_Adj_MN_Dakota_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4719444444445 +lon_0=-93.3166666666667 +lat_1=44.5166666666667 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378421.989 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001819,
    "auth_name": "ESRI",
    "auth_id": "103726",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61820,
    "description": "NAD_1983_HARN_Adj_MN_Dodge_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001820,
    "auth_name": "ESRI",
    "auth_id": "103727",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61821,
    "description": "NAD_1983_HARN_Adj_MN_Douglas_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.7588888888889 +lon_0=-96.05 +lat_1=45.8 +lat_2=46.05 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378518.001 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001821,
    "auth_name": "ESRI",
    "auth_id": "103728",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61822,
    "description": "NAD_1983_HARN_Adj_MN_Faribault_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001822,
    "auth_name": "ESRI",
    "auth_id": "103729",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61823,
    "description": "NAD_1983_HARN_Adj_MN_Fillmore_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-92.0833333333333 +lat_1=43.55 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378464.661 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001823,
    "auth_name": "ESRI",
    "auth_id": "103730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61824,
    "description": "NAD_1983_HARN_Adj_MN_Freeborn_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001824,
    "auth_name": "ESRI",
    "auth_id": "103731",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61825,
    "description": "NAD_1983_HARN_Adj_MN_Goodhue_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001825,
    "auth_name": "ESRI",
    "auth_id": "103732",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61826,
    "description": "NAD_1983_HARN_Adj_MN_Grant_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.7588888888889 +lon_0=-96.05 +lat_1=45.8 +lat_2=46.05 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378518.001 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001826,
    "auth_name": "ESRI",
    "auth_id": "103733",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61827,
    "description": "NAD_1983_HARN_Adj_MN_Hennepin_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.7911111111111 +lon_0=-93.3833333333334 +lat_1=44.8833333333333 +lat_2=45.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001827,
    "auth_name": "ESRI",
    "auth_id": "103734",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61828,
    "description": "NAD_1983_HARN_Adj_MN_Houston_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-91.4666666666667 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378436.619 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001828,
    "auth_name": "ESRI",
    "auth_id": "103735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61829,
    "description": "NAD_1983_HARN_Adj_MN_Isanti_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2963888888889 +lon_0=-93.0833333333333 +lat_1=45.3333333333333 +lat_2=45.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378411.321 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001829,
    "auth_name": "ESRI",
    "auth_id": "103736",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61830,
    "description": "NAD_1983_HARN_Adj_MN_Itasca_North_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.5 +lon_0=-93.7333333333333 +lat_1=47.5666666666667 +lat_2=47.8166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378574.389 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001830,
    "auth_name": "ESRI",
    "auth_id": "103737",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61831,
    "description": "NAD_1983_HARN_Adj_MN_Itasca_South_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.0263888888889 +lon_0=-93.7333333333333 +lat_1=47.0833333333333 +lat_2=47.4166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378574.389 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001831,
    "auth_name": "ESRI",
    "auth_id": "103738",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61832,
    "description": "NAD_1983_HARN_Adj_MN_Jackson_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001832,
    "auth_name": "ESRI",
    "auth_id": "103739",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61833,
    "description": "NAD_1983_HARN_Adj_MN_Kanabec_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.73 +lon_0=-92.9 +lat_1=45.8166666666667 +lat_2=46.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378472.281 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001833,
    "auth_name": "ESRI",
    "auth_id": "103740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61834,
    "description": "NAD_1983_HARN_Adj_MN_Kandiyohi_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.8913888888889 +lon_0=-94.75 +lat_1=44.9666666666667 +lat_2=45.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378498.189 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001834,
    "auth_name": "ESRI",
    "auth_id": "103741",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61835,
    "description": "NAD_1983_HARN_Adj_MN_Kittson_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.5438888888889 +lon_0=-96.15 +lat_1=48.6 +lat_2=48.9333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378449.421 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001835,
    "auth_name": "ESRI",
    "auth_id": "103742",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61836,
    "description": "NAD_1983_HARN_Adj_MN_Koochiching_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.8458333333333 +lon_0=-93.75 +lat_1=48 +lat_2=48.6166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378525.621 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001836,
    "auth_name": "ESRI",
    "auth_id": "103743",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61837,
    "description": "NAD_1983_HARN_Adj_MN_Lac_Qui_Parle_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.7527777777778 +lon_0=-95.85 +lat_1=44.8333333333333 +lat_2=45.2 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378476.853 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001837,
    "auth_name": "ESRI",
    "auth_id": "103744",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61838,
    "description": "NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_North_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=49.15 +lon_0=-94.9833333333333 +lat_1=49.1833333333333 +lat_2=49.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378466.185 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001838,
    "auth_name": "ESRI",
    "auth_id": "103745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61839,
    "description": "NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_South_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.3661111111111 +lon_0=-94.8833333333333 +lat_1=48.45 +lat_2=48.8833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378496.665 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001839,
    "auth_name": "ESRI",
    "auth_id": "103746",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61840,
    "description": "NAD_1983_HARN_Adj_MN_Le_Sueur_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001840,
    "auth_name": "ESRI",
    "auth_id": "103747",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61841,
    "description": "NAD_1983_HARN_Adj_MN_Lincoln_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1966666666667 +lon_0=-96.2666666666667 +lat_1=44.2833333333333 +lat_2=44.6166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378643.579 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001841,
    "auth_name": "ESRI",
    "auth_id": "103748",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61842,
    "description": "NAD_1983_HARN_Adj_MN_Lyon_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1955555555556 +lon_0=-95.85 +lat_1=44.25 +lat_2=44.5833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378559.758 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001842,
    "auth_name": "ESRI",
    "auth_id": "103749",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61843,
    "description": "NAD_1983_HARN_Adj_MN_McLeod_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333334 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001843,
    "auth_name": "ESRI",
    "auth_id": "103750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61844,
    "description": "NAD_1983_HARN_Adj_MN_Mahnomen_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.1516666666667 +lon_0=-95.8166666666667 +lat_1=47.2 +lat_2=47.45 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378586.581 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001844,
    "auth_name": "ESRI",
    "auth_id": "103751",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61845,
    "description": "NAD_1983_HARN_Adj_MN_Marshall_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.1730555555555 +lon_0=-96.3833333333333 +lat_1=48.2333333333333 +lat_2=48.4833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378441.801 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001845,
    "auth_name": "ESRI",
    "auth_id": "103752",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61846,
    "description": "NAD_1983_HARN_Adj_MN_Martin_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001846,
    "auth_name": "ESRI",
    "auth_id": "103753",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61847,
    "description": "NAD_1983_HARN_Adj_MN_Meeker_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.8913888888889 +lon_0=-94.75 +lat_1=44.9666666666667 +lat_2=45.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378498.189 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001847,
    "auth_name": "ESRI",
    "auth_id": "103754",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61848,
    "description": "NAD_1983_HARN_Adj_MN_Morrison_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.7738888888889 +lon_0=-94.2 +lat_1=45.85 +lat_2=46.2666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001848,
    "auth_name": "ESRI",
    "auth_id": "103755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61849,
    "description": "NAD_1983_HARN_Adj_MN_Mower_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-93.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378521.049 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001849,
    "auth_name": "ESRI",
    "auth_id": "103756",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61850,
    "description": "NAD_1983_HARN_Adj_MN_Murray_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-95.7666666666667 +lat_1=43.9166666666667 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378617.061 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001850,
    "auth_name": "ESRI",
    "auth_id": "103757",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61851,
    "description": "NAD_1983_HARN_Adj_MN_Nicollet_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.2666666666667 +lat_1=43.9333333333333 +lat_2=44.3666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378403.701 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001851,
    "auth_name": "ESRI",
    "auth_id": "103758",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61852,
    "description": "NAD_1983_HARN_Adj_MN_Nobles_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-95.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378624.681 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001852,
    "auth_name": "ESRI",
    "auth_id": "103759",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61853,
    "description": "NAD_1983_HARN_Adj_MN_Norman_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.1505555555556 +lon_0=-96.45 +lat_1=47.2 +lat_2=47.45 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378468.623 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001853,
    "auth_name": "ESRI",
    "auth_id": "103760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61854,
    "description": "NAD_1983_HARN_Adj_MN_Olmsted_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001854,
    "auth_name": "ESRI",
    "auth_id": "103761",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61855,
    "description": "NAD_1983_HARN_Adj_MN_Ottertail_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.1063888888889 +lon_0=-95.7166666666667 +lat_1=46.1833333333333 +lat_2=46.65 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378525.621 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001855,
    "auth_name": "ESRI",
    "auth_id": "103762",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61856,
    "description": "NAD_1983_HARN_Adj_MN_Pennington_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001856,
    "auth_name": "ESRI",
    "auth_id": "103763",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61857,
    "description": "NAD_1983_HARN_Adj_MN_Pine_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.73 +lon_0=-92.9 +lat_1=45.8166666666667 +lat_2=46.3333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378472.281 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001857,
    "auth_name": "ESRI",
    "auth_id": "103764",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61858,
    "description": "NAD_1983_HARN_Adj_MN_Pipestone_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8491666666667 +lon_0=-96.25 +lat_1=43.8833333333333 +lat_2=44.15 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378670.401 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001858,
    "auth_name": "ESRI",
    "auth_id": "103765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61859,
    "description": "NAD_1983_HARN_Adj_MN_Polk_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001859,
    "auth_name": "ESRI",
    "auth_id": "103766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61860,
    "description": "NAD_1983_HARN_Adj_MN_Pope_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001860,
    "auth_name": "ESRI",
    "auth_id": "103767",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61861,
    "description": "NAD_1983_HARN_Adj_MN_Ramsey_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.7911111111111 +lon_0=-93.3833333333334 +lat_1=44.8833333333333 +lat_2=45.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378418.941 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001861,
    "auth_name": "ESRI",
    "auth_id": "103768",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61862,
    "description": "NAD_1983_HARN_Adj_MN_Red_Lake_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.4988888888889 +lon_0=-96.3666666666667 +lat_1=47.6 +lat_2=48.0833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378445.763 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001862,
    "auth_name": "ESRI",
    "auth_id": "103769",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61863,
    "description": "NAD_1983_HARN_Adj_MN_Redwood_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1947222222222 +lon_0=-95.2333333333333 +lat_1=44.2666666666667 +lat_2=44.5666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378438.753 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001863,
    "auth_name": "ESRI",
    "auth_id": "103770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61864,
    "description": "NAD_1983_HARN_Adj_MN_Renville_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333334 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001864,
    "auth_name": "ESRI",
    "auth_id": "103771",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61865,
    "description": "NAD_1983_HARN_Adj_MN_Rice_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1947222222222 +lon_0=-93.1333333333333 +lat_1=44.3 +lat_2=44.6666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378434.181 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001865,
    "auth_name": "ESRI",
    "auth_id": "103772",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61866,
    "description": "NAD_1983_HARN_Adj_MN_Rock_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.5 +lon_0=-95.95 +lat_1=43.5666666666667 +lat_2=43.8 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378624.681 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001866,
    "auth_name": "ESRI",
    "auth_id": "103773",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61867,
    "description": "NAD_1983_HARN_Adj_MN_Roseau_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=48.5438888888889 +lon_0=-96.15 +lat_1=48.6 +lat_2=48.9333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378449.421 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001867,
    "auth_name": "ESRI",
    "auth_id": "103774",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61868,
    "description": "NAD_1983_HARN_Adj_MN_St_Louis_North_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.8333333333333 +lon_0=-92.45 +lat_1=47.9833333333333 +lat_2=48.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378543.909 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001868,
    "auth_name": "ESRI",
    "auth_id": "103775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61869,
    "description": "NAD_1983_HARN_Adj_MN_St_Louis_Central_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=47.25 +lon_0=-92.45 +lat_1=47.3333333333333 +lat_2=47.75 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378605.783 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001869,
    "auth_name": "ESRI",
    "auth_id": "103776",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61870,
    "description": "NAD_1983_HARN_Adj_MN_St_Louis_South_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.65 +lon_0=-92.45 +lat_1=46.7833333333333 +lat_2=47.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378540.861 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001870,
    "auth_name": "ESRI",
    "auth_id": "103777",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61871,
    "description": "NAD_1983_HARN_Adj_MN_Scott_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4719444444445 +lon_0=-93.3166666666667 +lat_1=44.5166666666667 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378421.989 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001871,
    "auth_name": "ESRI",
    "auth_id": "103778",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61872,
    "description": "NAD_1983_HARN_Adj_MN_Sherburne_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.9775 +lon_0=-93.8833333333333 +lat_1=45.0333333333333 +lat_2=45.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378443.325 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001872,
    "auth_name": "ESRI",
    "auth_id": "103779",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61873,
    "description": "NAD_1983_HARN_Adj_MN_Sibley_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.4561111111111 +lon_0=-94.6333333333334 +lat_1=44.5333333333333 +lat_2=44.9166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378414.369 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001873,
    "auth_name": "ESRI",
    "auth_id": "103780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61874,
    "description": "NAD_1983_HARN_Adj_MN_Stearns_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001874,
    "auth_name": "ESRI",
    "auth_id": "103781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61875,
    "description": "NAD_1983_HARN_Adj_MN_Steele_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001875,
    "auth_name": "ESRI",
    "auth_id": "103782",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61876,
    "description": "NAD_1983_HARN_Adj_MN_Stevens_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.2827777777778 +lon_0=-95.15 +lat_1=45.35 +lat_2=45.7 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378502.761 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001876,
    "auth_name": "ESRI",
    "auth_id": "103783",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61877,
    "description": "NAD_1983_HARN_Adj_MN_Swift_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.1522222222222 +lon_0=-96.05 +lat_1=45.2166666666667 +lat_2=45.5333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378470.757 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001877,
    "auth_name": "ESRI",
    "auth_id": "103784",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61878,
    "description": "NAD_1983_HARN_Adj_MN_Todd_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.7733333333333 +lon_0=-94.9 +lat_1=45.8666666666667 +lat_2=46.2833333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378548.481 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001878,
    "auth_name": "ESRI",
    "auth_id": "103785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61879,
    "description": "NAD_1983_HARN_Adj_MN_Traverse_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=45.5855555555556 +lon_0=-96.55 +lat_1=45.6333333333333 +lat_2=45.9666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378463.746 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001879,
    "auth_name": "ESRI",
    "auth_id": "103786",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61880,
    "description": "NAD_1983_HARN_Adj_MN_Wabasha_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.1069444444444 +lon_0=-92.2666666666667 +lat_1=44.15 +lat_2=44.4166666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378426.561 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001880,
    "auth_name": "ESRI",
    "auth_id": "103787",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61881,
    "description": "NAD_1983_HARN_Adj_MN_Wadena_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=46.1563888888889 +lon_0=-94.4666666666667 +lat_1=46.2666666666667 +lat_2=46.7333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378546.957 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001881,
    "auth_name": "ESRI",
    "auth_id": "103788",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61882,
    "description": "NAD_1983_HARN_Adj_MN_Waseca_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8338888888889 +lon_0=-92.9166666666667 +lat_1=43.8833333333333 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378481.425 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001882,
    "auth_name": "ESRI",
    "auth_id": "103789",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61883,
    "description": "NAD_1983_HARN_Adj_MN_Watonwan_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8480555555556 +lon_0=-94.9166666666667 +lat_1=43.9 +lat_2=44.1666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378514.953 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001883,
    "auth_name": "ESRI",
    "auth_id": "103790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61884,
    "description": "NAD_1983_HARN_Adj_MN_Winona_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=43.8472222222222 +lon_0=-91.6166666666667 +lat_1=43.9 +lat_2=44.1333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378453.688 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001884,
    "auth_name": "ESRI",
    "auth_id": "103791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61885,
    "description": "NAD_1983_HARN_Adj_MN_Wright_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.9775 +lon_0=-93.8833333333333 +lat_1=45.0333333333333 +lat_2=45.4666666666667 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378443.325 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001885,
    "auth_name": "ESRI",
    "auth_id": "103792",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61886,
    "description": "NAD_1983_HARN_Adj_MN_Yellow_Medicine_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.5416666666667 +lon_0=-95.9 +lat_1=44.6666666666667 +lat_2=44.95 +x_0=152400.30480061 +y_0=30480.0609601219 +a=6378530.193 +rf=298.257222100883 +units=us-ft +no_defs",
    "srid": 520001886,
    "auth_name": "ESRI",
    "auth_id": "103793",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 61939,
    "description": "NAD_1983_HARN_Adj_WI_Chippewa_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.5811111111111 +lon_0=-91.2944444444444 +lat_1=44.8138888888889 +lat_2=45.1416666666667 +x_0=60045.7200914402 +y_0=0 +a=6378412.542 +rf=298.270107115315 +units=m +no_defs",
    "srid": 520001939,
    "auth_name": "ESRI",
    "auth_id": "103846",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62011,
    "description": "NAD_1983_HARN_Adj_WI_Chippewa_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_0=44.5811111111111 +lon_0=-91.2944444444444 +lat_1=44.8138888888889 +lat_2=45.1416666666667 +x_0=60045.7200914402 +y_0=0 +a=6378412.542 +rf=298.270107115315 +units=us-ft +no_defs",
    "srid": 520002011,
    "auth_name": "ESRI",
    "auth_id": "103946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62050,
    "description": "GGD",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520002050,
    "auth_name": "ESRI",
    "auth_id": "104022",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62052,
    "description": "California_SRS_Epoch_2017.50_(NAD83)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520002052,
    "auth_name": "ESRI",
    "auth_id": "104024",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62055,
    "description": "GCS_Sphere_GRS_1980_Mean_Radius",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=6371008.7714 +no_defs",
    "srid": 520002055,
    "auth_name": "ESRI",
    "auth_id": "104047",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62056,
    "description": "GCS_Xrail84",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=19.019,115.122,-97.287,3.577824,-3.484437,-2.767646,18.6084754 +no_defs",
    "srid": 520002056,
    "auth_name": "ESRI",
    "auth_id": "104050",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62058,
    "description": "GCS_Pohnpei",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=-89.121,-348.182,260.871,0,0,0,0 +no_defs",
    "srid": 520002058,
    "auth_name": "ESRI",
    "auth_id": "104109",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62061,
    "description": "GCS_Bab_South",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=-185.583,-230.096,281.361,0,0,0,0 +no_defs",
    "srid": 520002061,
    "auth_name": "ESRI",
    "auth_id": "104112",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62062,
    "description": "GCS_Majuro",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=25.1,-275.6,222.6,0,0,0,0 +no_defs",
    "srid": 520002062,
    "auth_name": "ESRI",
    "auth_id": "104113",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62075,
    "description": "GCS_Observatorio_Meteorologico_1965",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=148.635396,339.470115,157.265381,-32.87685,76.963371,32.622853,-8.204889 +no_defs",
    "srid": 520002075,
    "auth_name": "ESRI",
    "auth_id": "104126",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62076,
    "description": "GCS_Roma_1940",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002076,
    "auth_name": "ESRI",
    "auth_id": "104127",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62077,
    "description": "GCS_Sphere_EMEP",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=6370000 +no_defs",
    "srid": 520002077,
    "auth_name": "ESRI",
    "auth_id": "104128",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62078,
    "description": "GCS_EUREF_FIN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002078,
    "auth_name": "ESRI",
    "auth_id": "104129",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62079,
    "description": "GCS_Jordan",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-86,-98,-119,0,0,0,0 +no_defs",
    "srid": 520002079,
    "auth_name": "ESRI",
    "auth_id": "104130",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62080,
    "description": "GCS_D48",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=426.62,142.62,460.09,4.98,4.49,-12.42,-17.1 +no_defs",
    "srid": 520002080,
    "auth_name": "ESRI",
    "auth_id": "104131",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62083,
    "description": "GCS_MONREF_1997",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520002083,
    "auth_name": "ESRI",
    "auth_id": "104134",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62084,
    "description": "GCS_MSK_1942",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "krass",
    "parameters": "+proj=longlat +ellps=krass +towgs84=78.0421780299,204.5186132514,77.449861533,1.7736709695,-3.3197917322,1.0426077127,-4.95105766 +no_defs",
    "srid": 520002084,
    "auth_name": "ESRI",
    "auth_id": "104135",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62087,
    "description": "GCS_Old_Hawaiian_Intl_1924",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=201,-228,-346,0,0,0,0 +no_defs",
    "srid": 520002087,
    "auth_name": "ESRI",
    "auth_id": "104138",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62088,
    "description": "GCS_Voirol_1875_Grad",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-73,-247,227,0,0,0,0 +no_defs",
    "srid": 520002088,
    "auth_name": "ESRI",
    "auth_id": "104139",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62089,
    "description": "GCS_Voirol_1879_Grad",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +no_defs",
    "srid": 520002089,
    "auth_name": "ESRI",
    "auth_id": "104140",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62113,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Anoka",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378418.941 +rf=298.257222100883 +no_defs",
    "srid": 520002113,
    "auth_name": "ESRI",
    "auth_id": "104700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62114,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Becker",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378586.581 +rf=298.257222100883 +no_defs",
    "srid": 520002114,
    "auth_name": "ESRI",
    "auth_id": "104701",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62115,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Beltrami_North",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378505.809 +rf=298.257222100883 +no_defs",
    "srid": 520002115,
    "auth_name": "ESRI",
    "auth_id": "104702",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62116,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Beltrami_South",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378544.823 +rf=298.257222100883 +no_defs",
    "srid": 520002116,
    "auth_name": "ESRI",
    "auth_id": "104703",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62117,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Benton",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378490.569 +rf=298.257222100883 +no_defs",
    "srid": 520002117,
    "auth_name": "ESRI",
    "auth_id": "104704",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62118,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Big_Stone",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378470.757 +rf=298.257222100883 +no_defs",
    "srid": 520002118,
    "auth_name": "ESRI",
    "auth_id": "104705",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62119,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Blue_Earth",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378403.701 +rf=298.257222100883 +no_defs",
    "srid": 520002119,
    "auth_name": "ESRI",
    "auth_id": "104706",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62120,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Brown",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378434.181 +rf=298.257222100883 +no_defs",
    "srid": 520002120,
    "auth_name": "ESRI",
    "auth_id": "104707",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62121,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Carlton",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378454.907 +rf=298.257222100883 +no_defs",
    "srid": 520002121,
    "auth_name": "ESRI",
    "auth_id": "104708",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62122,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Carver",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378400.653 +rf=298.257222100883 +no_defs",
    "srid": 520002122,
    "auth_name": "ESRI",
    "auth_id": "104709",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62123,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Cass_North",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378567.378 +rf=298.257222100883 +no_defs",
    "srid": 520002123,
    "auth_name": "ESRI",
    "auth_id": "104710",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62124,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Cass_South",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378546.957 +rf=298.257222100883 +no_defs",
    "srid": 520002124,
    "auth_name": "ESRI",
    "auth_id": "104711",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62125,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Chippewa",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378476.853 +rf=298.257222100883 +no_defs",
    "srid": 520002125,
    "auth_name": "ESRI",
    "auth_id": "104712",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62126,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Chisago",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378411.321 +rf=298.257222100883 +no_defs",
    "srid": 520002126,
    "auth_name": "ESRI",
    "auth_id": "104713",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62127,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Cook_North",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378647.541 +rf=298.257222100883 +no_defs",
    "srid": 520002127,
    "auth_name": "ESRI",
    "auth_id": "104714",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62128,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Cook_South",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378647.541 +rf=298.257222100883 +no_defs",
    "srid": 520002128,
    "auth_name": "ESRI",
    "auth_id": "104715",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62129,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Cottonwood",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378514.953 +rf=298.257222100883 +no_defs",
    "srid": 520002129,
    "auth_name": "ESRI",
    "auth_id": "104716",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62130,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Crow_Wing",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378546.957 +rf=298.257222100883 +no_defs",
    "srid": 520002130,
    "auth_name": "ESRI",
    "auth_id": "104717",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62131,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Dakota",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378421.989 +rf=298.257222100883 +no_defs",
    "srid": 520002131,
    "auth_name": "ESRI",
    "auth_id": "104718",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62132,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Dodge",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378481.425 +rf=298.257222100883 +no_defs",
    "srid": 520002132,
    "auth_name": "ESRI",
    "auth_id": "104719",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62133,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Douglas",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378518.001 +rf=298.257222100883 +no_defs",
    "srid": 520002133,
    "auth_name": "ESRI",
    "auth_id": "104720",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62134,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Faribault",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs",
    "srid": 520002134,
    "auth_name": "ESRI",
    "auth_id": "104721",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62135,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Fillmore",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378464.661 +rf=298.257222100883 +no_defs",
    "srid": 520002135,
    "auth_name": "ESRI",
    "auth_id": "104722",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62136,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Freeborn",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs",
    "srid": 520002136,
    "auth_name": "ESRI",
    "auth_id": "104723",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62137,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Goodhue",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378434.181 +rf=298.257222100883 +no_defs",
    "srid": 520002137,
    "auth_name": "ESRI",
    "auth_id": "104724",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62138,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Grant",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378518.001 +rf=298.257222100883 +no_defs",
    "srid": 520002138,
    "auth_name": "ESRI",
    "auth_id": "104725",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62139,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Hennepin",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378418.941 +rf=298.257222100883 +no_defs",
    "srid": 520002139,
    "auth_name": "ESRI",
    "auth_id": "104726",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62140,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Houston",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378436.619 +rf=298.257222100883 +no_defs",
    "srid": 520002140,
    "auth_name": "ESRI",
    "auth_id": "104727",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62141,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Isanti",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378411.321 +rf=298.257222100883 +no_defs",
    "srid": 520002141,
    "auth_name": "ESRI",
    "auth_id": "104728",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62142,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Itasca_North",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378574.389 +rf=298.257222100883 +no_defs",
    "srid": 520002142,
    "auth_name": "ESRI",
    "auth_id": "104729",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62143,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Itasca_South",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378574.389 +rf=298.257222100883 +no_defs",
    "srid": 520002143,
    "auth_name": "ESRI",
    "auth_id": "104730",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62144,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Jackson",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs",
    "srid": 520002144,
    "auth_name": "ESRI",
    "auth_id": "104731",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62145,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Kanabec",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378472.281 +rf=298.257222100883 +no_defs",
    "srid": 520002145,
    "auth_name": "ESRI",
    "auth_id": "104732",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62146,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Kandiyohi",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378498.189 +rf=298.257222100883 +no_defs",
    "srid": 520002146,
    "auth_name": "ESRI",
    "auth_id": "104733",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62147,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Kittson",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378449.421 +rf=298.257222100883 +no_defs",
    "srid": 520002147,
    "auth_name": "ESRI",
    "auth_id": "104734",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62148,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Koochiching",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378525.621 +rf=298.257222100883 +no_defs",
    "srid": 520002148,
    "auth_name": "ESRI",
    "auth_id": "104735",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62149,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Lac_Qui_Parle",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378476.853 +rf=298.257222100883 +no_defs",
    "srid": 520002149,
    "auth_name": "ESRI",
    "auth_id": "104736",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62150,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_North",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378466.185 +rf=298.257222100883 +no_defs",
    "srid": 520002150,
    "auth_name": "ESRI",
    "auth_id": "104737",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62151,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_South",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378496.665 +rf=298.257222100883 +no_defs",
    "srid": 520002151,
    "auth_name": "ESRI",
    "auth_id": "104738",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62152,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Le_Sueur",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378434.181 +rf=298.257222100883 +no_defs",
    "srid": 520002152,
    "auth_name": "ESRI",
    "auth_id": "104739",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62153,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Lincoln",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378643.579 +rf=298.257222100883 +no_defs",
    "srid": 520002153,
    "auth_name": "ESRI",
    "auth_id": "104740",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62154,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Lyon",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378559.758 +rf=298.257222100883 +no_defs",
    "srid": 520002154,
    "auth_name": "ESRI",
    "auth_id": "104741",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62155,
    "description": "GCS_NAD_1983_HARN_Adj_MN_McLeod",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378414.369 +rf=298.257222100883 +no_defs",
    "srid": 520002155,
    "auth_name": "ESRI",
    "auth_id": "104742",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62156,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Mahnomen",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378586.581 +rf=298.257222100883 +no_defs",
    "srid": 520002156,
    "auth_name": "ESRI",
    "auth_id": "104743",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62157,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Marshall",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378441.801 +rf=298.257222100883 +no_defs",
    "srid": 520002157,
    "auth_name": "ESRI",
    "auth_id": "104744",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62158,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Martin",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs",
    "srid": 520002158,
    "auth_name": "ESRI",
    "auth_id": "104745",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62159,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Meeker",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378498.189 +rf=298.257222100883 +no_defs",
    "srid": 520002159,
    "auth_name": "ESRI",
    "auth_id": "104746",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62160,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Morrison",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378502.761 +rf=298.257222100883 +no_defs",
    "srid": 520002160,
    "auth_name": "ESRI",
    "auth_id": "104747",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62161,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Mower",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378521.049 +rf=298.257222100883 +no_defs",
    "srid": 520002161,
    "auth_name": "ESRI",
    "auth_id": "104748",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62162,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Murray",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378617.061 +rf=298.257222100883 +no_defs",
    "srid": 520002162,
    "auth_name": "ESRI",
    "auth_id": "104749",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62163,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Nicollet",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378403.701 +rf=298.257222100883 +no_defs",
    "srid": 520002163,
    "auth_name": "ESRI",
    "auth_id": "104750",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62164,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Nobles",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378624.681 +rf=298.257222100883 +no_defs",
    "srid": 520002164,
    "auth_name": "ESRI",
    "auth_id": "104751",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62165,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Norman",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378468.623 +rf=298.257222100883 +no_defs",
    "srid": 520002165,
    "auth_name": "ESRI",
    "auth_id": "104752",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62166,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Olmsted",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378481.425 +rf=298.257222100883 +no_defs",
    "srid": 520002166,
    "auth_name": "ESRI",
    "auth_id": "104753",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62167,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Ottertail",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378525.621 +rf=298.257222100883 +no_defs",
    "srid": 520002167,
    "auth_name": "ESRI",
    "auth_id": "104754",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62168,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Pennington",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378445.763 +rf=298.257222100883 +no_defs",
    "srid": 520002168,
    "auth_name": "ESRI",
    "auth_id": "104755",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62169,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Pine",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378472.281 +rf=298.257222100883 +no_defs",
    "srid": 520002169,
    "auth_name": "ESRI",
    "auth_id": "104756",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62170,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Pipestone",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378670.401 +rf=298.257222100883 +no_defs",
    "srid": 520002170,
    "auth_name": "ESRI",
    "auth_id": "104757",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62171,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Polk",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378445.763 +rf=298.257222100883 +no_defs",
    "srid": 520002171,
    "auth_name": "ESRI",
    "auth_id": "104758",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62172,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Pope",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378502.761 +rf=298.257222100883 +no_defs",
    "srid": 520002172,
    "auth_name": "ESRI",
    "auth_id": "104759",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62173,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Ramsey",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378418.941 +rf=298.257222100883 +no_defs",
    "srid": 520002173,
    "auth_name": "ESRI",
    "auth_id": "104760",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62174,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Red_Lake",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378445.763 +rf=298.257222100883 +no_defs",
    "srid": 520002174,
    "auth_name": "ESRI",
    "auth_id": "104761",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62175,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Redwood",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378438.753 +rf=298.257222100883 +no_defs",
    "srid": 520002175,
    "auth_name": "ESRI",
    "auth_id": "104762",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62176,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Renville",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378414.369 +rf=298.257222100883 +no_defs",
    "srid": 520002176,
    "auth_name": "ESRI",
    "auth_id": "104763",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62177,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Rice",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378434.181 +rf=298.257222100883 +no_defs",
    "srid": 520002177,
    "auth_name": "ESRI",
    "auth_id": "104764",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62178,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Rock",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378624.681 +rf=298.257222100883 +no_defs",
    "srid": 520002178,
    "auth_name": "ESRI",
    "auth_id": "104765",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62179,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Roseau",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378449.421 +rf=298.257222100883 +no_defs",
    "srid": 520002179,
    "auth_name": "ESRI",
    "auth_id": "104766",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62180,
    "description": "GCS_NAD_1983_HARN_Adj_MN_St_Louis_North",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378543.909 +rf=298.257222100883 +no_defs",
    "srid": 520002180,
    "auth_name": "ESRI",
    "auth_id": "104767",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62181,
    "description": "GCS_NAD_1983_HARN_Adj_MN_St_Louis_Central",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378605.783 +rf=298.257222100883 +no_defs",
    "srid": 520002181,
    "auth_name": "ESRI",
    "auth_id": "104768",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62182,
    "description": "GCS_NAD_1983_HARN_Adj_MN_St_Louis_South",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378540.861 +rf=298.257222100883 +no_defs",
    "srid": 520002182,
    "auth_name": "ESRI",
    "auth_id": "104769",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62183,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Scott",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378421.989 +rf=298.257222100883 +no_defs",
    "srid": 520002183,
    "auth_name": "ESRI",
    "auth_id": "104770",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62184,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Sherburne",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378443.325 +rf=298.257222100883 +no_defs",
    "srid": 520002184,
    "auth_name": "ESRI",
    "auth_id": "104771",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62185,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Sibley",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378414.369 +rf=298.257222100883 +no_defs",
    "srid": 520002185,
    "auth_name": "ESRI",
    "auth_id": "104772",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62186,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Stearns",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378502.761 +rf=298.257222100883 +no_defs",
    "srid": 520002186,
    "auth_name": "ESRI",
    "auth_id": "104773",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62187,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Steele",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378481.425 +rf=298.257222100883 +no_defs",
    "srid": 520002187,
    "auth_name": "ESRI",
    "auth_id": "104774",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62188,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Stevens",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378502.761 +rf=298.257222100883 +no_defs",
    "srid": 520002188,
    "auth_name": "ESRI",
    "auth_id": "104775",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62189,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Swift",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378470.757 +rf=298.257222100883 +no_defs",
    "srid": 520002189,
    "auth_name": "ESRI",
    "auth_id": "104776",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62190,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Todd",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378548.481 +rf=298.257222100883 +no_defs",
    "srid": 520002190,
    "auth_name": "ESRI",
    "auth_id": "104777",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62191,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Traverse",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378463.746 +rf=298.257222100883 +no_defs",
    "srid": 520002191,
    "auth_name": "ESRI",
    "auth_id": "104778",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62192,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Wabasha",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378426.561 +rf=298.257222100883 +no_defs",
    "srid": 520002192,
    "auth_name": "ESRI",
    "auth_id": "104779",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62193,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Wadena",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378546.957 +rf=298.257222100883 +no_defs",
    "srid": 520002193,
    "auth_name": "ESRI",
    "auth_id": "104780",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62194,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Waseca",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378481.425 +rf=298.257222100883 +no_defs",
    "srid": 520002194,
    "auth_name": "ESRI",
    "auth_id": "104781",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62195,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Watonwan",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378514.953 +rf=298.257222100883 +no_defs",
    "srid": 520002195,
    "auth_name": "ESRI",
    "auth_id": "104782",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62196,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Winona",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378453.688 +rf=298.257222100883 +no_defs",
    "srid": 520002196,
    "auth_name": "ESRI",
    "auth_id": "104783",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62197,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Wright",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378443.325 +rf=298.257222100883 +no_defs",
    "srid": 520002197,
    "auth_name": "ESRI",
    "auth_id": "104784",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62198,
    "description": "GCS_NAD_1983_HARN_Adj_MN_Yellow_Medicine",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378530.193 +rf=298.257222100883 +no_defs",
    "srid": 520002198,
    "auth_name": "ESRI",
    "auth_id": "104785",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62199,
    "description": "GCS_NAD_1983_HARN_Adj_MN_St_Louis",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378523 +rf=298.2752724 +no_defs",
    "srid": 520002199,
    "auth_name": "ESRI",
    "auth_id": "104786",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62208,
    "description": "GCS_NAD_1983_HARN_Adj_WI_Chippewa",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378412.542 +rf=298.270107115315 +no_defs",
    "srid": 520002208,
    "auth_name": "ESRI",
    "auth_id": "104808",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62273,
    "description": "GCS_Mercury_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=2439700 +no_defs",
    "srid": 520002273,
    "auth_name": "ESRI",
    "auth_id": "104900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62274,
    "description": "GCS_Venus_1985",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=6051000 +no_defs",
    "srid": 520002274,
    "auth_name": "ESRI",
    "auth_id": "104901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62275,
    "description": "GCS_Venus_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=6051800 +no_defs",
    "srid": 520002275,
    "auth_name": "ESRI",
    "auth_id": "104902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62276,
    "description": "GCS_Moon_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=1737400 +no_defs",
    "srid": 520002276,
    "auth_name": "ESRI",
    "auth_id": "104903",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62277,
    "description": "GCS_Mars_1979",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=3393400 +rf=192.043010752688 +no_defs",
    "srid": 520002277,
    "auth_name": "ESRI",
    "auth_id": "104904",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62278,
    "description": "GCS_Mars_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=3396190 +rf=169.894447223612 +no_defs",
    "srid": 520002278,
    "auth_name": "ESRI",
    "auth_id": "104905",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62279,
    "description": "GCS_Deimos_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=6200 +no_defs",
    "srid": 520002279,
    "auth_name": "ESRI",
    "auth_id": "104906",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62280,
    "description": "GCS_Phobos_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=11100 +no_defs",
    "srid": 520002280,
    "auth_name": "ESRI",
    "auth_id": "104907",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62281,
    "description": "GCS_Jupiter_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=71492000 +rf=15.4144027598103 +no_defs",
    "srid": 520002281,
    "auth_name": "ESRI",
    "auth_id": "104908",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62282,
    "description": "GCS_Adrastea_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=8200 +no_defs",
    "srid": 520002282,
    "auth_name": "ESRI",
    "auth_id": "104909",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62283,
    "description": "GCS_Amalthea_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=83500 +no_defs",
    "srid": 520002283,
    "auth_name": "ESRI",
    "auth_id": "104910",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62284,
    "description": "GCS_Ananke_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=10000 +no_defs",
    "srid": 520002284,
    "auth_name": "ESRI",
    "auth_id": "104911",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62285,
    "description": "GCS_Callisto_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=2409300 +no_defs",
    "srid": 520002285,
    "auth_name": "ESRI",
    "auth_id": "104912",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62286,
    "description": "GCS_Carme_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=15000 +no_defs",
    "srid": 520002286,
    "auth_name": "ESRI",
    "auth_id": "104913",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62287,
    "description": "GCS_Elara_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=40000 +no_defs",
    "srid": 520002287,
    "auth_name": "ESRI",
    "auth_id": "104914",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62288,
    "description": "GCS_Europa_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=1562090 +no_defs",
    "srid": 520002288,
    "auth_name": "ESRI",
    "auth_id": "104915",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62289,
    "description": "GCS_Ganymede_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=2632345 +no_defs",
    "srid": 520002289,
    "auth_name": "ESRI",
    "auth_id": "104916",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62290,
    "description": "GCS_Himalia_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=85000 +no_defs",
    "srid": 520002290,
    "auth_name": "ESRI",
    "auth_id": "104917",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62291,
    "description": "GCS_Io_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=1821460 +no_defs",
    "srid": 520002291,
    "auth_name": "ESRI",
    "auth_id": "104918",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62292,
    "description": "GCS_Leda_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=5000 +no_defs",
    "srid": 520002292,
    "auth_name": "ESRI",
    "auth_id": "104919",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62293,
    "description": "GCS_Lysithea_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=12000 +no_defs",
    "srid": 520002293,
    "auth_name": "ESRI",
    "auth_id": "104920",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62294,
    "description": "GCS_Metis_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=30000 +rf=3 +no_defs",
    "srid": 520002294,
    "auth_name": "ESRI",
    "auth_id": "104921",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62295,
    "description": "GCS_Pasiphae_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=18000 +no_defs",
    "srid": 520002295,
    "auth_name": "ESRI",
    "auth_id": "104922",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62296,
    "description": "GCS_Sinope_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=14000 +no_defs",
    "srid": 520002296,
    "auth_name": "ESRI",
    "auth_id": "104923",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62297,
    "description": "GCS_Thebe_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=49300 +no_defs",
    "srid": 520002297,
    "auth_name": "ESRI",
    "auth_id": "104924",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62298,
    "description": "GCS_Saturn_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=60268000 +rf=10.2079945799458 +no_defs",
    "srid": 520002298,
    "auth_name": "ESRI",
    "auth_id": "104925",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62299,
    "description": "GCS_Atlas_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=16000 +no_defs",
    "srid": 520002299,
    "auth_name": "ESRI",
    "auth_id": "104926",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62300,
    "description": "GCS_Calypso_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=9500 +no_defs",
    "srid": 520002300,
    "auth_name": "ESRI",
    "auth_id": "104927",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62301,
    "description": "GCS_Dione_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=560000 +no_defs",
    "srid": 520002301,
    "auth_name": "ESRI",
    "auth_id": "104928",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62302,
    "description": "GCS_Enceladus_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=249400 +no_defs",
    "srid": 520002302,
    "auth_name": "ESRI",
    "auth_id": "104929",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62303,
    "description": "GCS_Epimetheus_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=59500 +no_defs",
    "srid": 520002303,
    "auth_name": "ESRI",
    "auth_id": "104930",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62304,
    "description": "GCS_Helene_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=16000 +no_defs",
    "srid": 520002304,
    "auth_name": "ESRI",
    "auth_id": "104931",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62305,
    "description": "GCS_Hyperion_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=133000 +no_defs",
    "srid": 520002305,
    "auth_name": "ESRI",
    "auth_id": "104932",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62306,
    "description": "GCS_Iapetus_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=718000 +no_defs",
    "srid": 520002306,
    "auth_name": "ESRI",
    "auth_id": "104933",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62307,
    "description": "GCS_Janus_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=88800 +no_defs",
    "srid": 520002307,
    "auth_name": "ESRI",
    "auth_id": "104934",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62308,
    "description": "GCS_Mimas_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=198630 +no_defs",
    "srid": 520002308,
    "auth_name": "ESRI",
    "auth_id": "104935",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62309,
    "description": "GCS_Pan_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=10000 +no_defs",
    "srid": 520002309,
    "auth_name": "ESRI",
    "auth_id": "104936",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62310,
    "description": "GCS_Pandora_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=41900 +no_defs",
    "srid": 520002310,
    "auth_name": "ESRI",
    "auth_id": "104937",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62311,
    "description": "GCS_Phoebe_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=110000 +no_defs",
    "srid": 520002311,
    "auth_name": "ESRI",
    "auth_id": "104938",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62312,
    "description": "GCS_Prometheus_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=50100 +no_defs",
    "srid": 520002312,
    "auth_name": "ESRI",
    "auth_id": "104939",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62313,
    "description": "GCS_Rhea_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=764000 +no_defs",
    "srid": 520002313,
    "auth_name": "ESRI",
    "auth_id": "104940",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62314,
    "description": "GCS_Telesto_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=11000 +no_defs",
    "srid": 520002314,
    "auth_name": "ESRI",
    "auth_id": "104941",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62315,
    "description": "GCS_Tethys_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=529800 +no_defs",
    "srid": 520002315,
    "auth_name": "ESRI",
    "auth_id": "104942",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62316,
    "description": "GCS_Titan_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=2575000 +no_defs",
    "srid": 520002316,
    "auth_name": "ESRI",
    "auth_id": "104943",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62317,
    "description": "GCS_Uranus_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=25559000 +rf=43.6160409556314 +no_defs",
    "srid": 520002317,
    "auth_name": "ESRI",
    "auth_id": "104944",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62318,
    "description": "GCS_Ariel_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=578900 +no_defs",
    "srid": 520002318,
    "auth_name": "ESRI",
    "auth_id": "104945",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62319,
    "description": "GCS_Belinda_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=33000 +no_defs",
    "srid": 520002319,
    "auth_name": "ESRI",
    "auth_id": "104946",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62320,
    "description": "GCS_Bianca_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=21000 +no_defs",
    "srid": 520002320,
    "auth_name": "ESRI",
    "auth_id": "104947",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62321,
    "description": "GCS_Cordelia_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=13000 +no_defs",
    "srid": 520002321,
    "auth_name": "ESRI",
    "auth_id": "104948",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62322,
    "description": "GCS_Cressida_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=31000 +no_defs",
    "srid": 520002322,
    "auth_name": "ESRI",
    "auth_id": "104949",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62323,
    "description": "GCS_Desdemona_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=27000 +no_defs",
    "srid": 520002323,
    "auth_name": "ESRI",
    "auth_id": "104950",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62324,
    "description": "GCS_Juliet_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=42000 +no_defs",
    "srid": 520002324,
    "auth_name": "ESRI",
    "auth_id": "104951",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62325,
    "description": "GCS_Miranda_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=235800 +no_defs",
    "srid": 520002325,
    "auth_name": "ESRI",
    "auth_id": "104952",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62326,
    "description": "GCS_Oberon_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=761400 +no_defs",
    "srid": 520002326,
    "auth_name": "ESRI",
    "auth_id": "104953",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62327,
    "description": "GCS_Ophelia_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=15000 +no_defs",
    "srid": 520002327,
    "auth_name": "ESRI",
    "auth_id": "104954",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62328,
    "description": "GCS_Portia_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=54000 +no_defs",
    "srid": 520002328,
    "auth_name": "ESRI",
    "auth_id": "104955",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62329,
    "description": "GCS_Puck_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=77000 +no_defs",
    "srid": 520002329,
    "auth_name": "ESRI",
    "auth_id": "104956",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62330,
    "description": "GCS_Rosalind_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=27000 +no_defs",
    "srid": 520002330,
    "auth_name": "ESRI",
    "auth_id": "104957",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62331,
    "description": "GCS_Titania_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=788900 +no_defs",
    "srid": 520002331,
    "auth_name": "ESRI",
    "auth_id": "104958",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62332,
    "description": "GCS_Umbriel_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=584700 +no_defs",
    "srid": 520002332,
    "auth_name": "ESRI",
    "auth_id": "104959",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62333,
    "description": "GCS_Neptune_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=24764000 +rf=58.5437352245863 +no_defs",
    "srid": 520002333,
    "auth_name": "ESRI",
    "auth_id": "104960",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62334,
    "description": "GCS_Despina_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=74000 +no_defs",
    "srid": 520002334,
    "auth_name": "ESRI",
    "auth_id": "104961",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62335,
    "description": "GCS_Galatea_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=79000 +no_defs",
    "srid": 520002335,
    "auth_name": "ESRI",
    "auth_id": "104962",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62336,
    "description": "GCS_Larissa_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=104000 +rf=6.93333333333333 +no_defs",
    "srid": 520002336,
    "auth_name": "ESRI",
    "auth_id": "104963",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62337,
    "description": "GCS_Naiad_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=29000 +no_defs",
    "srid": 520002337,
    "auth_name": "ESRI",
    "auth_id": "104964",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62338,
    "description": "GCS_Nereid_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=170000 +no_defs",
    "srid": 520002338,
    "auth_name": "ESRI",
    "auth_id": "104965",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62339,
    "description": "GCS_Proteus_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=208000 +no_defs",
    "srid": 520002339,
    "auth_name": "ESRI",
    "auth_id": "104966",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62340,
    "description": "GCS_Thalassa_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=40000 +no_defs",
    "srid": 520002340,
    "auth_name": "ESRI",
    "auth_id": "104967",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62341,
    "description": "GCS_Triton_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=1352600 +no_defs",
    "srid": 520002341,
    "auth_name": "ESRI",
    "auth_id": "104968",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62342,
    "description": "GCS_Pluto_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=1195000 +no_defs",
    "srid": 520002342,
    "auth_name": "ESRI",
    "auth_id": "104969",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62343,
    "description": "GCS_Charon_2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=593000 +no_defs",
    "srid": 520002343,
    "auth_name": "ESRI",
    "auth_id": "104970",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62344,
    "description": "Mars_2000_(Sphere)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=3396190 +no_defs",
    "srid": 520002344,
    "auth_name": "ESRI",
    "auth_id": "104971",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62345,
    "description": "1_Ceres_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=470000 +no_defs",
    "srid": 520002345,
    "auth_name": "ESRI",
    "auth_id": "104972",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62346,
    "description": "4_Vesta_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=255000 +no_defs",
    "srid": 520002346,
    "auth_name": "ESRI",
    "auth_id": "104973",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62347,
    "description": "Mercury_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=2439400 +no_defs",
    "srid": 520002347,
    "auth_name": "ESRI",
    "auth_id": "104974",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62348,
    "description": "Sun_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +R=695700000 +no_defs",
    "srid": 520002348,
    "auth_name": "ESRI",
    "auth_id": "104975",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62369,
    "description": "NAD_1927_StatePlane_Michigan_North_FIPS_2111",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=44.7833333333333 +lon_0=-87 +lat_1=45.4833333333333 +lat_2=47.0833333333333 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 520002369,
    "auth_name": "ESRI",
    "auth_id": "26788",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62370,
    "description": "NAD_1927_StatePlane_Michigan_Central_FIPS_2112",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=43.3166666666667 +lon_0=-84.3333333333333 +lat_1=44.1833333333333 +lat_2=45.7 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 520002370,
    "auth_name": "ESRI",
    "auth_id": "26789",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62371,
    "description": "NAD_1927_StatePlane_Michigan_South_FIPS_2113",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=41.5 +lon_0=-84.3333333333333 +lat_1=42.1 +lat_2=43.6666666666667 +x_0=609601.219202438 +y_0=0 +datum=NAD27 +units=us-ft +no_defs",
    "srid": 520002371,
    "auth_name": "ESRI",
    "auth_id": "26790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62380,
    "description": "NAD_1927_StatePlane_Puerto_Rico_FIPS_5201",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.0333333333333 +lat_2=18.4333333333333 +x_0=152400.30480061 +y_0=0 +ellps=clrk66 +towgs84=-3,142,183,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520002380,
    "auth_name": "ESRI",
    "auth_id": "32059",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62381,
    "description": "NAD_1927_StatePlane_Virgin_Islands_St_Croix_FIPS_5202",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_0=17.8333333333333 +lon_0=-66.4333333333333 +lat_1=18.0333333333333 +lat_2=18.4333333333333 +x_0=152400.30480061 +y_0=30480.0609601219 +ellps=clrk66 +towgs84=-3,142,183,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520002381,
    "auth_name": "ESRI",
    "auth_id": "32060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62382,
    "description": "GCS_Carthage_Grad",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +towgs84=-263,6,431,0,0,0,0 +no_defs",
    "srid": 520002382,
    "auth_name": "ESRI",
    "auth_id": "37225",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62387,
    "description": "Sphere_Plate_Carree",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002387,
    "auth_name": "ESRI",
    "auth_id": "53001",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62388,
    "description": "Sphere_Behrmann",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cea +lat_ts=30 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002388,
    "auth_name": "ESRI",
    "auth_id": "53017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62389,
    "description": "Sphere_Winkel_I",
    "projection_acronym": "wink1",
    "ellipsoid_acronym": "",
    "parameters": "+proj=wink1 +lon_0=0 +lat_ts=50.4597762521898 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002389,
    "auth_name": "ESRI",
    "auth_id": "53018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62390,
    "description": "Sphere_Winkel_II",
    "projection_acronym": "wink2",
    "ellipsoid_acronym": "",
    "parameters": "+proj=wink2 +lon_0=0 +lat_1=50.4597762521898 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002390,
    "auth_name": "ESRI",
    "auth_id": "53019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62391,
    "description": "Sphere_Quartic_Authalic",
    "projection_acronym": "qua_aut",
    "ellipsoid_acronym": "",
    "parameters": "+proj=qua_aut +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002391,
    "auth_name": "ESRI",
    "auth_id": "53022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62392,
    "description": "Sphere_Loximuthal",
    "projection_acronym": "loxim",
    "ellipsoid_acronym": "",
    "parameters": "+proj=loxim +lat_1=40 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002392,
    "auth_name": "ESRI",
    "auth_id": "53023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62393,
    "description": "Sphere_Cylindrical_Equal_Area",
    "projection_acronym": "cea",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cea +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002393,
    "auth_name": "ESRI",
    "auth_id": "53034",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62394,
    "description": "Sphere_Equal_Earth_Greenwich",
    "projection_acronym": "eqearth",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eqearth +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs",
    "srid": 520002394,
    "auth_name": "ESRI",
    "auth_id": "53035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62395,
    "description": "Sphere_Equal_Earth_Americas",
    "projection_acronym": "eqearth",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eqearth +lon_0=-90 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs",
    "srid": 520002395,
    "auth_name": "ESRI",
    "auth_id": "53036",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62396,
    "description": "Sphere_Equal_Earth_Asia_Pacific",
    "projection_acronym": "eqearth",
    "ellipsoid_acronym": "",
    "parameters": "+proj=eqearth +lon_0=150 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs",
    "srid": 520002396,
    "auth_name": "ESRI",
    "auth_id": "53037",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62397,
    "description": "Sphere_Winkel_Tripel_NGS",
    "projection_acronym": "wintri",
    "ellipsoid_acronym": "",
    "parameters": "+proj=wintri +lon_0=0 +lat_1=50.467 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002397,
    "auth_name": "ESRI",
    "auth_id": "53042",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62398,
    "description": "Sphere_Aitoff",
    "projection_acronym": "aitoff",
    "ellipsoid_acronym": "",
    "parameters": "+proj=aitoff +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002398,
    "auth_name": "ESRI",
    "auth_id": "53043",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62399,
    "description": "Sphere_Hammer_Aitoff",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520002399,
    "auth_name": "ESRI",
    "auth_id": "53044",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62400,
    "description": "Sphere_Flat_Polar_Quartic",
    "projection_acronym": "mbtfpq",
    "ellipsoid_acronym": "",
    "parameters": "+proj=mbtfpq +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002400,
    "auth_name": "ESRI",
    "auth_id": "53045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62401,
    "description": "Sphere_Craster_Parabolic",
    "projection_acronym": "crast",
    "ellipsoid_acronym": "",
    "parameters": "+proj=crast +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002401,
    "auth_name": "ESRI",
    "auth_id": "53046",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62402,
    "description": "Sphere_Times",
    "projection_acronym": "times",
    "ellipsoid_acronym": "",
    "parameters": "+proj=times +lon_0=0 +x_0=0 +y_0=0 +R=6371000 +units=m +no_defs",
    "srid": 520002402,
    "auth_name": "ESRI",
    "auth_id": "53048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62403,
    "description": "Sphere_Vertical_Perspective",
    "projection_acronym": "nsper",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=nsper +lat_0=0 +lon_0=0 +h=35800000 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002403,
    "auth_name": "ESRI",
    "auth_id": "53049",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62404,
    "description": "Sphere_Wagner_IV",
    "projection_acronym": "wag4",
    "ellipsoid_acronym": "",
    "parameters": "+proj=wag4 +lon_0=0 +x_0=0 +y_0=0 +R=6371007 +units=m +no_defs",
    "srid": 520002404,
    "auth_name": "ESRI",
    "auth_id": "53074",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62405,
    "description": "Sphere_Wagner_V",
    "projection_acronym": "wag5",
    "ellipsoid_acronym": "",
    "parameters": "+proj=wag5 +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs",
    "srid": 520002405,
    "auth_name": "ESRI",
    "auth_id": "53075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62406,
    "description": "Sphere_Wagner_VII",
    "projection_acronym": "wag7",
    "ellipsoid_acronym": "",
    "parameters": "+proj=wag7 +lon_0=0 +x_0=0 +y_0=0 +R=6371007 +units=m +no_defs",
    "srid": 520002406,
    "auth_name": "ESRI",
    "auth_id": "53076",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62407,
    "description": "Sphere_Natural_Earth",
    "projection_acronym": "natearth",
    "ellipsoid_acronym": "",
    "parameters": "+proj=natearth +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs",
    "srid": 520002407,
    "auth_name": "ESRI",
    "auth_id": "53077",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62408,
    "description": "Sphere_Natural_Earth_II",
    "projection_acronym": "natearth2",
    "ellipsoid_acronym": "",
    "parameters": "+proj=natearth2 +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs",
    "srid": 520002408,
    "auth_name": "ESRI",
    "auth_id": "53078",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62409,
    "description": "Sphere_Patterson",
    "projection_acronym": "patterson",
    "ellipsoid_acronym": "",
    "parameters": "+proj=patterson +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs",
    "srid": 520002409,
    "auth_name": "ESRI",
    "auth_id": "53079",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62410,
    "description": "Sphere_Compact_Miller",
    "projection_acronym": "comill",
    "ellipsoid_acronym": "",
    "parameters": "+proj=comill +lon_0=0 +x_0=0 +y_0=0 +R=6371008.7714 +units=m +no_defs",
    "srid": 520002410,
    "auth_name": "ESRI",
    "auth_id": "53080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62411,
    "description": "World_Plate_Carree",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002411,
    "auth_name": "ESRI",
    "auth_id": "54001",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62412,
    "description": "World_Behrmann",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=cea +lat_ts=30 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002412,
    "auth_name": "ESRI",
    "auth_id": "54017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62413,
    "description": "World_Winkel_I",
    "projection_acronym": "wink1",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=wink1 +lon_0=0 +lat_ts=50.4597762521898 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002413,
    "auth_name": "ESRI",
    "auth_id": "54018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62414,
    "description": "World_Winkel_II",
    "projection_acronym": "wink2",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=wink2 +lon_0=0 +lat_1=50.4597762521898 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002414,
    "auth_name": "ESRI",
    "auth_id": "54019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62415,
    "description": "World_Quartic_Authalic",
    "projection_acronym": "qua_aut",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=qua_aut +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002415,
    "auth_name": "ESRI",
    "auth_id": "54022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62416,
    "description": "World_Loximuthal",
    "projection_acronym": "loxim",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=loxim +lat_1=40 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002416,
    "auth_name": "ESRI",
    "auth_id": "54023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62417,
    "description": "World_Cylindrical_Equal_Area",
    "projection_acronym": "cea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=cea +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002417,
    "auth_name": "ESRI",
    "auth_id": "54034",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62421,
    "description": "World_Winkel_Tripel_NGS",
    "projection_acronym": "wintri",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=wintri +lon_0=0 +lat_1=50.467 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002421,
    "auth_name": "ESRI",
    "auth_id": "54042",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62422,
    "description": "World_Aitoff",
    "projection_acronym": "aitoff",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aitoff +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002422,
    "auth_name": "ESRI",
    "auth_id": "54043",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62423,
    "description": "World_Hammer_Aitoff",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520002423,
    "auth_name": "ESRI",
    "auth_id": "54044",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62424,
    "description": "World_Flat_Polar_Quartic",
    "projection_acronym": "mbtfpq",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=mbtfpq +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002424,
    "auth_name": "ESRI",
    "auth_id": "54045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62425,
    "description": "World_Craster_Parabolic",
    "projection_acronym": "crast",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=crast +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002425,
    "auth_name": "ESRI",
    "auth_id": "54046",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62426,
    "description": "World_Times",
    "projection_acronym": "times",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=times +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002426,
    "auth_name": "ESRI",
    "auth_id": "54048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62427,
    "description": "World_Vertical_Perspective",
    "projection_acronym": "nsper",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=nsper +lat_0=0 +lon_0=0 +h=35800000 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002427,
    "auth_name": "ESRI",
    "auth_id": "54049",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62428,
    "description": "World_Fuller",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520002428,
    "auth_name": "ESRI",
    "auth_id": "54050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62429,
    "description": "World_Cube",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520002429,
    "auth_name": "ESRI",
    "auth_id": "54051",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62430,
    "description": "World_Goode_Homolosine_Land",
    "projection_acronym": "goode",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=igh +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002430,
    "auth_name": "ESRI",
    "auth_id": "54052",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62431,
    "description": "World_Goode_Homolosine_Ocean",
    "projection_acronym": "goode",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=igh_o +lon_0=-160 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002431,
    "auth_name": "ESRI",
    "auth_id": "54053",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62432,
    "description": "World_Wagner_IV",
    "projection_acronym": "wag4",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=wag4 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002432,
    "auth_name": "ESRI",
    "auth_id": "54074",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62433,
    "description": "World_Wagner_V",
    "projection_acronym": "wag5",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=wag5 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002433,
    "auth_name": "ESRI",
    "auth_id": "54075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62434,
    "description": "World_Wagner_VII",
    "projection_acronym": "wag7",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=wag7 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002434,
    "auth_name": "ESRI",
    "auth_id": "54076",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62435,
    "description": "World_Natural_Earth",
    "projection_acronym": "natearth",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=natearth +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002435,
    "auth_name": "ESRI",
    "auth_id": "54077",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62436,
    "description": "World_Natural_Earth_II",
    "projection_acronym": "natearth2",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=natearth2 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002436,
    "auth_name": "ESRI",
    "auth_id": "54078",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62437,
    "description": "World_Patterson",
    "projection_acronym": "patterson",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=patterson +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002437,
    "auth_name": "ESRI",
    "auth_id": "54079",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62438,
    "description": "World_Compact_Miller",
    "projection_acronym": "comill",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=comill +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002438,
    "auth_name": "ESRI",
    "auth_id": "54080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62439,
    "description": "WGS_1984_Peirce_quincuncial_North_Pole_square",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=peirce_q +shape=square +lat_0=90 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002439,
    "auth_name": "ESRI",
    "auth_id": "54090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62440,
    "description": "WGS_1984_Peirce_quincuncial_North_Pole_diamond",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=peirce_q +shape=diamond +lat_0=90 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002440,
    "auth_name": "ESRI",
    "auth_id": "54091",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62441,
    "description": "American_Samoa_1962_StatePlane_American_Samoa_FIPS_5300",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=lcc +lat_1=-14.2666666666667 +lat_0=-14.2666666666667 +lon_0=-170 +k_0=1 +x_0=152400.30480061 +y_0=95169.3116586233 +ellps=clrk66 +units=us-ft +no_defs",
    "srid": 520002441,
    "auth_name": "ESRI",
    "auth_id": "65062",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62466,
    "description": "Amanu NGT 1949 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002466,
    "auth_name": "IGNF",
    "auth_id": "AMANU49",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62467,
    "description": "Amanu (NGT 1949) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002467,
    "auth_name": "IGNF",
    "auth_id": "AMANU49G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62468,
    "description": "Amanu MHPF 1963 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002468,
    "auth_name": "IGNF",
    "auth_id": "AMANU63",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62469,
    "description": "Amanu (MHPF 1963) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002469,
    "auth_name": "IGNF",
    "auth_id": "AMANU63G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62470,
    "description": "Amanu (MHPF 1963) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002470,
    "auth_name": "IGNF",
    "auth_id": "AMANU63UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62471,
    "description": "Ile Amsterdam 1963 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002471,
    "auth_name": "IGNF",
    "auth_id": "AMST63",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62472,
    "description": "Amsterdam 1963 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002472,
    "auth_name": "IGNF",
    "auth_id": "AMST63G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62473,
    "description": "Ile Amsterdam 1963 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002473,
    "auth_name": "IGNF",
    "auth_id": "AMST63GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62474,
    "description": "Amsterdam 1963 UTM Sud fuseau 43",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=43 +south +ellps=intl +units=m +no_defs",
    "srid": 520002474,
    "auth_name": "IGNF",
    "auth_id": "AMST63UTM43S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62475,
    "description": "Anaa SHM 1947 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002475,
    "auth_name": "IGNF",
    "auth_id": "ANAA47",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62476,
    "description": "Anaa (SHM 1947) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002476,
    "auth_name": "IGNF",
    "auth_id": "ANAA47G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62477,
    "description": "Anaa (SHM 1947) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002477,
    "auth_name": "IGNF",
    "auth_id": "ANAA47UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62478,
    "description": "Anaa (MOP92) cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +towgs84=1.5,3.84,4.81,0,0,0,0 +units=m +no_defs",
    "srid": 520002478,
    "auth_name": "IGNF",
    "auth_id": "ANAA92",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62479,
    "description": "Anaa (MOP92) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=1.5,3.84,4.81,0,0,0,0 +no_defs",
    "srid": 520002479,
    "auth_name": "IGNF",
    "auth_id": "ANAA92G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62480,
    "description": "Apataki MGT 1948 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002480,
    "auth_name": "IGNF",
    "auth_id": "APAT48",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62481,
    "description": "Apataki (MGT 1948) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002481,
    "auth_name": "IGNF",
    "auth_id": "APAT48G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62482,
    "description": "Apataki FG 1949 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002482,
    "auth_name": "IGNF",
    "auth_id": "APAT49",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62483,
    "description": "Apataki (FG 1949) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002483,
    "auth_name": "IGNF",
    "auth_id": "APAT49G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62484,
    "description": "Apataki Cadastre 1980 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002484,
    "auth_name": "IGNF",
    "auth_id": "APAT80",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62485,
    "description": "Apataki (Cadastre 1980) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002485,
    "auth_name": "IGNF",
    "auth_id": "APAT80G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62486,
    "description": "Apataki (Cadastre 1980) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002486,
    "auth_name": "IGNF",
    "auth_id": "APAT80UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62487,
    "description": "TUAMOTU (MOP86) CARTESIENNES",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002487,
    "auth_name": "IGNF",
    "auth_id": "APAT86",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62488,
    "description": "Tuamotu (MOP86) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002488,
    "auth_name": "IGNF",
    "auth_id": "APAT86G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62489,
    "description": "ATIG cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "",
    "parameters": "+proj=geocent +a=6376523 +rf=308.64 +pm=2.33720833333333 +towgs84=1118,23,66,0,0,0,0 +units=m +no_defs",
    "srid": 520002489,
    "auth_name": "IGNF",
    "auth_id": "ATI",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62490,
    "description": "ATIG cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "",
    "parameters": "+proj=geocent +a=6376523 +rf=308.64 +pm=2.33720833333333 +towgs84=1118,23,66,0,0,0,0 +units=m +no_defs",
    "srid": 520002490,
    "auth_name": "IGNF",
    "auth_id": "ATIG",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62491,
    "description": "ATIG Bonne France Etat Major",
    "projection_acronym": "bonne",
    "ellipsoid_acronym": "",
    "parameters": "+proj=bonne +lat_1=45 +lon_0=0 +x_0=0 +y_0=0 +a=6376523 +rf=308.64 +pm=2.33720833333333 +towgs84=1118,23,66,0,0,0,0 +units=m +no_defs",
    "srid": 520002491,
    "auth_name": "IGNF",
    "auth_id": "ATIGBONNE",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62492,
    "description": "ATIG Bonne France Etat Major et NGF-BOURDALOUE",
    "projection_acronym": "bonne",
    "ellipsoid_acronym": "",
    "parameters": "+proj=bonne +lat_1=45 +lon_0=0 +x_0=0 +y_0=0 +a=6376523 +rf=308.64 +pm=2.33720833333333 +towgs84=1118,23,66,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002492,
    "auth_name": "IGNF",
    "auth_id": "ATIGBONNE.BOURD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62493,
    "description": "ATIG Bonne France Etat Major et NGF-LALLEMAND",
    "projection_acronym": "bonne",
    "ellipsoid_acronym": "",
    "parameters": "+proj=bonne +lat_1=45 +lon_0=0 +x_0=0 +y_0=0 +a=6376523 +rf=308.64 +pm=2.33720833333333 +towgs84=1118,23,66,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002493,
    "auth_name": "IGNF",
    "auth_id": "ATIGBONNE.NGF84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62494,
    "description": "ATIG geographiques grades Paris (gr)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6376523 +rf=308.64 +pm=2.33720833333333 +towgs84=1118,23,66,0,0,0,0 +no_defs",
    "srid": 520002494,
    "auth_name": "IGNF",
    "auth_id": "ATIGG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62495,
    "description": "ATIG geographiques grades Paris (gr) et NGF-BOURDALOUE",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6376523 +rf=308.64 +pm=2.33720833333333 +towgs84=1118,23,66,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002495,
    "auth_name": "IGNF",
    "auth_id": "ATIGG.BOURD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62496,
    "description": "ATIG geographiques grades Paris (gr) et NGF-LALLEMAND",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6376523 +rf=308.64 +pm=2.33720833333333 +towgs84=1118,23,66,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002496,
    "auth_name": "IGNF",
    "auth_id": "ATIGG.NGF84",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62497,
    "description": "Hiva Oa Tahuata Motohani IGN 1963 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002497,
    "auth_name": "IGNF",
    "auth_id": "ATUO63",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62498,
    "description": "IGN 1963 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002498,
    "auth_name": "IGNF",
    "auth_id": "ATUO63G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62499,
    "description": "IGN 1963 UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002499,
    "auth_name": "IGNF",
    "auth_id": "ATUO63UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62500,
    "description": "Cap Bienvenue - Perroud 1955 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002500,
    "auth_name": "IGNF",
    "auth_id": "BIEN55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62501,
    "description": "Cap Bienvenue geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002501,
    "auth_name": "IGNF",
    "auth_id": "BIEN55G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62502,
    "description": "CSG67 (IGN 1995) CARTESIENNES GEOCENTRIQUES",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002502,
    "auth_name": "IGNF",
    "auth_id": "C67I95",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62503,
    "description": "CSG67 (IGN 1995) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002503,
    "auth_name": "IGNF",
    "auth_id": "C67IG95G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62504,
    "description": "CSG67 (IGN 1995) geographiques (dms) et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002504,
    "auth_name": "IGNF",
    "auth_id": "C67IG95G.GUYA77",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62505,
    "description": "CSG67(IGN 1995) UTM Nord fuseau 21",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +ellps=intl +units=m +no_defs",
    "srid": 520002505,
    "auth_name": "IGNF",
    "auth_id": "C67IG95UTM21",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62506,
    "description": "CSG67(IGN 1995) UTM Nord fuseau 21 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +ellps=intl +units=m +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002506,
    "auth_name": "IGNF",
    "auth_id": "C67IG95UTM21.GUYA77",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62507,
    "description": "CSG67 (IGN 1995) UTM Nord fuseau 22",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +ellps=intl +units=m +no_defs",
    "srid": 520002507,
    "auth_name": "IGNF",
    "auth_id": "C67IG95UTM22",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62508,
    "description": "CSG67 (IGN 1995) UTM Nord fuseau 22 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +ellps=intl +units=m +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002508,
    "auth_name": "IGNF",
    "auth_id": "C67IG95UTM22.GUYA77",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62509,
    "description": "Cadastre 1997 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002509,
    "auth_name": "IGNF",
    "auth_id": "CAD97",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62510,
    "description": "Cadastre 1997 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002510,
    "auth_name": "IGNF",
    "auth_id": "CAD97G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62511,
    "description": "Cadastre 1997 geographiques (dms) et SHOM 1953 (MAYOTTE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +geoidgrids=fr_ign_ggm04v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002511,
    "auth_name": "IGNF",
    "auth_id": "CAD97G.MAYO53",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62512,
    "description": "Cadastre 1997 UTM Sud fuseau 38 et SHOM 1953 (MAYOTTE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +units=m +geoidgrids=fr_ign_ggm04v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002512,
    "auth_name": "IGNF",
    "auth_id": "CAD97UTM38S.MAYO53",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62513,
    "description": "Apataki Cadastre 1980 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002513,
    "auth_name": "IGNF",
    "auth_id": "CADA80",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62514,
    "description": "Apataki (Cadastre 1980) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002514,
    "auth_name": "IGNF",
    "auth_id": "CADA80G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62515,
    "description": "Cap Bienvenue - Perroud 1955 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002515,
    "auth_name": "IGNF",
    "auth_id": "CAPBP55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62516,
    "description": "Cap Bienvenue geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002516,
    "auth_name": "IGNF",
    "auth_id": "CAPBP55G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62517,
    "description": "Cap Jules - Perroud 1955 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002517,
    "auth_name": "IGNF",
    "auth_id": "CAPJP55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62518,
    "description": "Cap Jules geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002518,
    "auth_name": "IGNF",
    "auth_id": "CAPJP55G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62519,
    "description": "Clipperton 1967 UTM Nord fuseau 12",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=12 +ellps=intl +units=m +no_defs",
    "srid": 520002519,
    "auth_name": "IGNF",
    "auth_id": "CLIP57UTM12",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62520,
    "description": "Clipperton (Marine 1967) cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002520,
    "auth_name": "IGNF",
    "auth_id": "CLIP67",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62521,
    "description": "Clipperton 1967 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002521,
    "auth_name": "IGNF",
    "auth_id": "CLIP67G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62522,
    "description": "Clipperton 1967 UTM Nord fuseau 12",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=12 +ellps=intl +units=m +no_defs",
    "srid": 520002522,
    "auth_name": "IGNF",
    "auth_id": "CLIP67UTM12",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62523,
    "description": "Crozet-Possession 1963 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002523,
    "auth_name": "IGNF",
    "auth_id": "CROZ63",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62524,
    "description": "Crozet Possession 1963 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002524,
    "auth_name": "IGNF",
    "auth_id": "CROZ63G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62525,
    "description": "CSG 1967 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +no_defs",
    "srid": 520002525,
    "auth_name": "IGNF",
    "auth_id": "CSG67",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62526,
    "description": "CSG67 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-186,230,110,0,0,0,0 +no_defs",
    "srid": 520002526,
    "auth_name": "IGNF",
    "auth_id": "CSG67G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62527,
    "description": "CSG67 geographiques (dms) et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-186,230,110,0,0,0,0 +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002527,
    "auth_name": "IGNF",
    "auth_id": "CSG67G.GUYA77",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62528,
    "description": "CSG67 UTM Nord fuseau 21 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=21 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002528,
    "auth_name": "IGNF",
    "auth_id": "CSG67UTM21.GUYA77",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62529,
    "description": "CSG67 UTM Nord fuseau 22 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=22 +ellps=intl +towgs84=-186,230,110,0,0,0,0 +units=m +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002529,
    "auth_name": "IGNF",
    "auth_id": "CSG67UTM22.GUYA77",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62530,
    "description": "ED50 CARTESIENNES GEOCENTRIQUES",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002530,
    "auth_name": "IGNF",
    "auth_id": "ED50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62531,
    "description": "ED50 geographiques (dms) et NGF-IGN 1969",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002531,
    "auth_name": "IGNF",
    "auth_id": "ED50G.IGN69",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62532,
    "description": "ED50 geographiques (dms) et NGF-IGN 1978",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002532,
    "auth_name": "IGNF",
    "auth_id": "ED50G.IGN78C",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62533,
    "description": "ED50 geographiques (dms) et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002533,
    "auth_name": "IGNF",
    "auth_id": "ED50G.NGC48",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62534,
    "description": "ED50 geographiques (dms) et NGF-LALLEMAND",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002534,
    "auth_name": "IGNF",
    "auth_id": "ED50G.NGF84",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62535,
    "description": "ED50 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002535,
    "auth_name": "IGNF",
    "auth_id": "ED50GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62536,
    "description": "ED50 UTM fuseau 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=30 +ellps=intl +units=m +no_defs",
    "srid": 520002536,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM30",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62537,
    "description": "ED50 UTM fuseau 30 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=30 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002537,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM30.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62538,
    "description": "ED50 UTM fuseau 30 et NGF-LALLEMAND",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=30 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002538,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM30.NGF84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62539,
    "description": "ED50 UTM NORD FUSEAU 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=31 +ellps=intl +units=m +no_defs",
    "srid": 520002539,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM31",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62540,
    "description": "ED50 UTM NORD FUSEAU 31 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=31 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002540,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM31.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62541,
    "description": "ED50 UTM NORD FUSEAU 31 et NGF-LALLEMAND",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=31 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002541,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM31.NGF84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62542,
    "description": "ED50 UTM fuseau 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +ellps=intl +units=m +no_defs",
    "srid": 520002542,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM32",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62543,
    "description": "ED50 UTM fuseau 32 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002543,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM32.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62544,
    "description": "ED50 UTM fuseau 32 et NGF-IGN 1978",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +ellps=intl +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002544,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM32.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62545,
    "description": "ED50 UTM fuseau 32 et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002545,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM32.NGC48",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62546,
    "description": "ED50 UTM fuseau 32 et NGF-LALLEMAND",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=32 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002546,
    "auth_name": "IGNF",
    "auth_id": "ED50UTM32.NGF84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62547,
    "description": "Efate UTM Sud fuseau 59",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=59 +south +ellps=intl +towgs84=-127,-769,472,0,0,0,0 +units=m +no_defs",
    "srid": 520002547,
    "auth_name": "IGNF",
    "auth_id": "EFAT57UTM59S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62548,
    "description": "Efate - IGN 1957 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-127,-769,472,0,0,0,0 +units=m +no_defs",
    "srid": 520002548,
    "auth_name": "IGNF",
    "auth_id": "EFATE57",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62549,
    "description": "Efate geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-127,-769,472,0,0,0,0 +no_defs",
    "srid": 520002549,
    "auth_name": "IGNF",
    "auth_id": "EFATE57G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62550,
    "description": "ETRS89 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002550,
    "auth_name": "IGNF",
    "auth_id": "ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62551,
    "description": "ETRS89 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002551,
    "auth_name": "IGNF",
    "auth_id": "ETRS89G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62552,
    "description": "ETRS89 geographiques (dms) et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002552,
    "auth_name": "IGNF",
    "auth_id": "ETRS89G.EVRF2000",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62553,
    "description": "ETRS89 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002553,
    "auth_name": "IGNF",
    "auth_id": "ETRS89GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62554,
    "description": "ETRS89 Lambert Azimutal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002554,
    "auth_name": "IGNF",
    "auth_id": "ETRS89LAEA",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62555,
    "description": "ETRS89 Lambert Azimutal Equal Area et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002555,
    "auth_name": "IGNF",
    "auth_id": "ETRS89LAEA.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62556,
    "description": "ETRS89 Lambert Conformal Conic",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002556,
    "auth_name": "IGNF",
    "auth_id": "ETRS89LCC",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62557,
    "description": "ETRS89 Lambert Conformal Conic et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002557,
    "auth_name": "IGNF",
    "auth_id": "ETRS89LCC.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62558,
    "description": "ETRS89 UTM Nord fuseau 26",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002558,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM26",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62559,
    "description": "ETRS89 UTM Nord fuseau 27",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002559,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM27",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62560,
    "description": "ETRS89 UTM Nord fuseau 28",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002560,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM28",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62561,
    "description": "ETRS89 UTM Nord fuseau 29",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002561,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM29",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62562,
    "description": "ETRS89 UTM Nord fuseau 29 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002562,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM29.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62563,
    "description": "ETRS89 UTM Nord fuseau 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002563,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM30",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62564,
    "description": "ETRS89 UTM Nord fuseau 30 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002564,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM30.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62565,
    "description": "ETRS89 UTM Nord fuseau 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002565,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM31",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62566,
    "description": "ETRS89 UTM Nord fuseau 31 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002566,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM31.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62567,
    "description": "ETRS89 UTM Nord fuseau 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002567,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM32",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62568,
    "description": "ETRS89 UTM Nord fuseau 32 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002568,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM32.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62569,
    "description": "ETRS89 UTM Nord fuseau 33",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002569,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM33",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62570,
    "description": "ETRS89 UTM Nord fuseau 33 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002570,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM33.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62571,
    "description": "ETRS89 UTM Nord fuseau 34",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002571,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM34",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62572,
    "description": "ETRS89 UTM Nord fuseau 34 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002572,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM34.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62573,
    "description": "ETRS89 UTM Nord fuseau 35",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002573,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM35",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62574,
    "description": "ETRS89 UTM Nord fuseau 35 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002574,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM35.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62575,
    "description": "ETRS89 UTM Nord fuseau 36",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002575,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM36",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62576,
    "description": "ETRS89 UTM Nord fuseau 36 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002576,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM36.EVRF2000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62577,
    "description": "ETRS89 UTM Nord fuseau 37",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002577,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM37",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62578,
    "description": "ETRS89 UTM Nord fuseau 38",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002578,
    "auth_name": "IGNF",
    "auth_id": "ETRS89UTM38",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62579,
    "description": "EUROPA MHM 1954 UTM SUD FUSEAU 37",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=37 +south +ellps=intl +units=m +no_defs",
    "srid": 520002579,
    "auth_name": "IGNF",
    "auth_id": "EURO54UTM37S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62580,
    "description": "Europa MHM 1954 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002580,
    "auth_name": "IGNF",
    "auth_id": "EUROPA54",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62581,
    "description": "Europa geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002581,
    "auth_name": "IGNF",
    "auth_id": "EUROPA54G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62582,
    "description": "Europa Mercator directe",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=merc +lon_0=0 +k=1 +x_0=20000000 +y_0=10000000 +ellps=intl +units=m +no_defs",
    "srid": 520002582,
    "auth_name": "IGNF",
    "auth_id": "EUROPA54MD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62583,
    "description": "Fakarava SHM 1947-1950 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002583,
    "auth_name": "IGNF",
    "auth_id": "FAKA50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62584,
    "description": "Fakarava (SHM 1947-1950) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002584,
    "auth_name": "IGNF",
    "auth_id": "FAKA50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62585,
    "description": "Fakarava (SHM 1947-1950) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002585,
    "auth_name": "IGNF",
    "auth_id": "FAKA50UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62586,
    "description": "Fangataufa (MHPF 1965-1) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002586,
    "auth_name": "IGNF",
    "auth_id": "FANG651G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62587,
    "description": "Fangataufa (MHPF 1965-1) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002587,
    "auth_name": "IGNF",
    "auth_id": "FANG651UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62588,
    "description": "Fangataufa (MHPF 1965-2) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002588,
    "auth_name": "IGNF",
    "auth_id": "FANG652G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62589,
    "description": "Fangataufa (MHPF 1965-2) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002589,
    "auth_name": "IGNF",
    "auth_id": "FANG652UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62590,
    "description": "Fangataufa MGT 1950 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002590,
    "auth_name": "IGNF",
    "auth_id": "FANGA50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62591,
    "description": "Fangataufa (MGT 1950) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002591,
    "auth_name": "IGNF",
    "auth_id": "FANGA50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62592,
    "description": "Fangataufa MHPF 1964 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002592,
    "auth_name": "IGNF",
    "auth_id": "FANGA64",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62593,
    "description": "Fangataufa (MHPF 1964) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002593,
    "auth_name": "IGNF",
    "auth_id": "FANGA64G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62594,
    "description": "Fangataufa (MHPF 1964) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002594,
    "auth_name": "IGNF",
    "auth_id": "FANGA64UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62595,
    "description": "Fangataufa MHPF 1965-1 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002595,
    "auth_name": "IGNF",
    "auth_id": "FANGA651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62596,
    "description": "Fangataufa (MHPF 1965-1) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002596,
    "auth_name": "IGNF",
    "auth_id": "FANGA651G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62597,
    "description": "Fangataufa (MHPF 1965-1) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002597,
    "auth_name": "IGNF",
    "auth_id": "FANGA651U7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62598,
    "description": "Fangataufa MHPF 1965-2 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002598,
    "auth_name": "IGNF",
    "auth_id": "FANGA652",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62599,
    "description": "Fangataufa (MHPF 1965-2) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002599,
    "auth_name": "IGNF",
    "auth_id": "FANGA652G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62600,
    "description": "Fangataufa (MHPF 1965-2) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002600,
    "auth_name": "IGNF",
    "auth_id": "FANGA652U7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62601,
    "description": "Fangataufa MHPF 1966 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002601,
    "auth_name": "IGNF",
    "auth_id": "FANGA66",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62602,
    "description": "Fangataufa (MHPF 1966) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002602,
    "auth_name": "IGNF",
    "auth_id": "FANGA66G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62603,
    "description": "Fangataufa (MHPF 1966) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002603,
    "auth_name": "IGNF",
    "auth_id": "FANGA66UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62604,
    "description": "Fangataufa MOP 1984 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=150.57,158.33,118.32,0,0,0,0 +units=m +no_defs",
    "srid": 520002604,
    "auth_name": "IGNF",
    "auth_id": "FANGA84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62605,
    "description": "Fangataufa (MOP84) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=150.57,158.33,118.32,0,0,0,0 +no_defs",
    "srid": 520002605,
    "auth_name": "IGNF",
    "auth_id": "FANGA84G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62606,
    "description": "Fatu Huku MHEFO 1955 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002606,
    "auth_name": "IGNF",
    "auth_id": "FATU55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62607,
    "description": "Fatu Huku (MHEFO 1955) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002607,
    "auth_name": "IGNF",
    "auth_id": "FATU55FG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62608,
    "description": "Amsterdam Saint-Paul projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-38 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520002608,
    "auth_name": "IGNF",
    "auth_id": "GEOPORTALASP",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62609,
    "description": "Glorieuses (MHG 1977) cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002609,
    "auth_name": "IGNF",
    "auth_id": "GLOR77CAR",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62610,
    "description": "Glorieuses geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002610,
    "auth_name": "IGNF",
    "auth_id": "GLOR77G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62611,
    "description": "Glorieuses geographiques (dms) et SHOM 1977 (ILES GLORIEUSES - CANAL DE MOZAMBIQUE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002611,
    "auth_name": "IGNF",
    "auth_id": "GLOR77G.GLOR77",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62612,
    "description": "Glorieuses Mercator directe",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=merc +lon_0=0 +k=1 +x_0=20000000 +y_0=10000000 +ellps=intl +units=m +no_defs",
    "srid": 520002612,
    "auth_name": "IGNF",
    "auth_id": "GLOR77MD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62613,
    "description": "Glorieuses Mercator directe et SHOM 1977 (ILES GLORIEUSES - CANAL DE MOZAMBIQUE)",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=merc +lon_0=0 +k=1 +x_0=20000000 +y_0=10000000 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002613,
    "auth_name": "IGNF",
    "auth_id": "GLOR77MD.GLOR77",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62614,
    "description": "Glorieuses (MHG 1977) cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002614,
    "auth_name": "IGNF",
    "auth_id": "GLOR77MHG",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62615,
    "description": "GLORIEUSES MHG 1977 UTM SUD FUSEAU 38",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs",
    "srid": 520002615,
    "auth_name": "IGNF",
    "auth_id": "GLOR77UTM38S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62616,
    "description": "GLORIEUSES MHG 1977 UTM SUD FUSEAU 38 et SHOM 1977 (ILES GLORIEUSES - CANAL DE MOZAMBIQUE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002616,
    "auth_name": "IGNF",
    "auth_id": "GLOR77UTM38S.GLOR77",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62617,
    "description": "GOMEN TERME NORD 1951 CARTESIENNES",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002617,
    "auth_name": "IGNF",
    "auth_id": "GTN51",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62618,
    "description": "Gomen Terme Nord 1951 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002618,
    "auth_name": "IGNF",
    "auth_id": "GTN51G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62619,
    "description": "GOMEN TERME NORD 1951 UTM SUD FUSEAU 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs",
    "srid": 520002619,
    "auth_name": "IGNF",
    "auth_id": "GTN51UTM58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62620,
    "description": "Guadeloupe Sainte-Anne cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002620,
    "auth_name": "IGNF",
    "auth_id": "GUAD48",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62621,
    "description": "Guadeloupe Sainte-Anne geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002621,
    "auth_name": "IGNF",
    "auth_id": "GUAD48G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62622,
    "description": "Guadeloupe Sainte-Anne cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002622,
    "auth_name": "IGNF",
    "auth_id": "GUADANN",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62623,
    "description": "Guadeloupe Sainte-Anne geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002623,
    "auth_name": "IGNF",
    "auth_id": "GUADANNG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62624,
    "description": "Guadeloupe Sainte-Anne geographiques (dms) et IGN 1988 (GUADELOUPE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002624,
    "auth_name": "IGNF",
    "auth_id": "GUADANNG.GUAD88",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62625,
    "description": "Guadeloupe Sainte-Anne geographiques (dms) et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002625,
    "auth_name": "IGNF",
    "auth_id": "GUADANNG.GUAD88LS",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62626,
    "description": "Guadeloupe Sainte-Anne geographiques (dms) et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002626,
    "auth_name": "IGNF",
    "auth_id": "GUADANNG.GUAD88MG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62627,
    "description": "Guadeloupe Sainte-Anne geographiques (dms) et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002627,
    "auth_name": "IGNF",
    "auth_id": "GUADANNG.GUAD92LD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62628,
    "description": "Guadeloupe Ste Anne UTM Nord fuseau 20",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 520002628,
    "auth_name": "IGNF",
    "auth_id": "GUADANNUTM20",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62629,
    "description": "Guadeloupe Ste Anne UTM Nord fuseau 20 et IGN 1988 (GUADELOUPE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002629,
    "auth_name": "IGNF",
    "auth_id": "GUADANNUTM20.GUAD88",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62630,
    "description": "Guadeloupe Ste Anne UTM Nord fuseau 20 et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002630,
    "auth_name": "IGNF",
    "auth_id": "GUADANNUTM20.GUAD88LS",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62631,
    "description": "Guadeloupe Ste Anne UTM Nord fuseau 20 et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002631,
    "auth_name": "IGNF",
    "auth_id": "GUADANNUTM20.GUAD88MG",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62632,
    "description": "Guadeloupe Ste Anne UTM Nord fuseau 20 et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002632,
    "auth_name": "IGNF",
    "auth_id": "GUADANNUTM20.GUAD92LD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62633,
    "description": "Guadeloupe Fort Marigot cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002633,
    "auth_name": "IGNF",
    "auth_id": "GUADFM",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62634,
    "description": "Guadeloupe Fort Marigot cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002634,
    "auth_name": "IGNF",
    "auth_id": "GUADFM49",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62635,
    "description": "Guadeloupe Fort-Marigot geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002635,
    "auth_name": "IGNF",
    "auth_id": "GUADFMG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62636,
    "description": "Guadeloupe Fort-Marigot geographiques (dms) et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002636,
    "auth_name": "IGNF",
    "auth_id": "GUADFMG.GUAD88SB",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62637,
    "description": "Guadeloupe Fort-Marigot geographiques (dms) et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002637,
    "auth_name": "IGNF",
    "auth_id": "GUADFMG.GUAD88SM",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62638,
    "description": "Guadeloupe Fort-Marigot UTM Nord fuseau 20",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 520002638,
    "auth_name": "IGNF",
    "auth_id": "GUADFMUTM20",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62639,
    "description": "Guadeloupe Fort-Marigot UTM Nord fuseau 20 et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002639,
    "auth_name": "IGNF",
    "auth_id": "GUADFMUTM20.GUAD88SB",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62640,
    "description": "Guadeloupe Fort-Marigot UTM Nord fuseau 20 et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002640,
    "auth_name": "IGNF",
    "auth_id": "GUADFMUTM20.GUAD88SM",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62641,
    "description": "Guadeloupe Fort-Marigot geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002641,
    "auth_name": "IGNF",
    "auth_id": "GUAFM48G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62642,
    "description": "Hao MGT 1949 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002642,
    "auth_name": "IGNF",
    "auth_id": "HAO49",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62643,
    "description": "Hao (MGT 1949) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002643,
    "auth_name": "IGNF",
    "auth_id": "HAO49G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62644,
    "description": "Hao MHPF 1958 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002644,
    "auth_name": "IGNF",
    "auth_id": "HAO58",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62645,
    "description": "Hao (MHPF 1958) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002645,
    "auth_name": "IGNF",
    "auth_id": "HAO58G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62646,
    "description": "Hao (MHPF 1958) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002646,
    "auth_name": "IGNF",
    "auth_id": "HAO58UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62647,
    "description": "Hao Amanu MHPF 1967 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002647,
    "auth_name": "IGNF",
    "auth_id": "HAO67",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62648,
    "description": "Hao Amanu (MHPF 1967) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002648,
    "auth_name": "IGNF",
    "auth_id": "HAO67UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62649,
    "description": "Hao Amanu MHPF 1967 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002649,
    "auth_name": "IGNF",
    "auth_id": "HAOAM67",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62650,
    "description": "Hao Amanu (MHPF 1967) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002650,
    "auth_name": "IGNF",
    "auth_id": "HAOAM67G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62651,
    "description": "Hao Amanu (MHPF 1967) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002651,
    "auth_name": "IGNF",
    "auth_id": "HAOAM67UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62652,
    "description": "Hao Amanu (MHPF 1967) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002652,
    "auth_name": "IGNF",
    "auth_id": "HAOAMA67G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62653,
    "description": "Haraiki SHM 1949 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002653,
    "auth_name": "IGNF",
    "auth_id": "HARA49",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62654,
    "description": "Haraiki (SHM 1949) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002654,
    "auth_name": "IGNF",
    "auth_id": "HARA49G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62655,
    "description": "Haraiki (SHM 1949) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002655,
    "auth_name": "IGNF",
    "auth_id": "HARA49UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62656,
    "description": "Hikureu SHM 1947-1950 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002656,
    "auth_name": "IGNF",
    "auth_id": "HIKU50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62657,
    "description": "Hikueru (SHM 1947-1950) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002657,
    "auth_name": "IGNF",
    "auth_id": "HIKU50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62658,
    "description": "Hikueru (SHM 1947-1950) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002658,
    "auth_name": "IGNF",
    "auth_id": "HIKU50UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62659,
    "description": "Hiva Oa MHPF 1960 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002659,
    "auth_name": "IGNF",
    "auth_id": "HIVA60",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62660,
    "description": "Hiva Oa (MHPF 1960) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002660,
    "auth_name": "IGNF",
    "auth_id": "HIVA60G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62661,
    "description": "Hiva Oa (MHPF 1960) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002661,
    "auth_name": "IGNF",
    "auth_id": "HIVA60UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62662,
    "description": "Hiva Oa MHPF 1967 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002662,
    "auth_name": "IGNF",
    "auth_id": "HIVA67",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62663,
    "description": "Hiva Oa (MHPF 1967) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002663,
    "auth_name": "IGNF",
    "auth_id": "HIVA67G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62664,
    "description": "Hiva Oa (MHPF 1967) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002664,
    "auth_name": "IGNF",
    "auth_id": "HIVA67UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62665,
    "description": "Hiva Oa Tahuata Motohani IGN 1963 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002665,
    "auth_name": "IGNF",
    "auth_id": "IGN63",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62666,
    "description": "IGN 1963 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002666,
    "auth_name": "IGNF",
    "auth_id": "IGN63G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62667,
    "description": "Grande Terre - Ile des Pins IGN 72 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs",
    "srid": 520002667,
    "auth_name": "IGNF",
    "auth_id": "IGN72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62668,
    "description": "IGN72 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +no_defs",
    "srid": 520002668,
    "auth_name": "IGNF",
    "auth_id": "IGN72G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62669,
    "description": "IGN72 geographiques (dms) et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002669,
    "auth_name": "IGNF",
    "auth_id": "IGN72G.NCAL69",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62670,
    "description": "IGN72 Lambert Nouvelle-Caledonie",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs",
    "srid": 520002670,
    "auth_name": "IGNF",
    "auth_id": "IGN72LAMBNC",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62671,
    "description": "IGN72 UTM Sud fuseau 58 et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002671,
    "auth_name": "IGNF",
    "auth_id": "IGN72UTM58S.NCAL69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62672,
    "description": "Cap Jules - Perroud 1955 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002672,
    "auth_name": "IGNF",
    "auth_id": "JULES55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62673,
    "description": "Cap Jules geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002673,
    "auth_name": "IGNF",
    "auth_id": "JULES55G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62674,
    "description": "Kauehi MHPF70 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=126.74,300.1,-75.49,0,0,0,0 +units=m +no_defs",
    "srid": 520002674,
    "auth_name": "IGNF",
    "auth_id": "KAUE70",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62675,
    "description": "Kauehi (MHPF70) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=126.74,300.1,-75.49,0,0,0,0 +no_defs",
    "srid": 520002675,
    "auth_name": "IGNF",
    "auth_id": "KAUE70G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62676,
    "description": "Kerguelen - K0 IGN 1962 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002676,
    "auth_name": "IGNF",
    "auth_id": "KERG62CAR",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62677,
    "description": "Kerguelen geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002677,
    "auth_name": "IGNF",
    "auth_id": "KERG62G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62678,
    "description": "Kerguelen geographiques (dms) et IGN 1962 (KERGUELEN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +geoidgrids=fr_ign_ggker08v2.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002678,
    "auth_name": "IGNF",
    "auth_id": "KERG62G.KERG62",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62679,
    "description": "Kerguelen - K0 IGN 1962 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002679,
    "auth_name": "IGNF",
    "auth_id": "KERG62K0",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62680,
    "description": "KERGUELEN K0 IGN 1962 UTM SUD FUSEAU 42 et IGN 1962 (KERGUELEN)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=42 +south +ellps=intl +units=m +geoidgrids=fr_ign_ggker08v2.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002680,
    "auth_name": "IGNF",
    "auth_id": "KERG62UTM42S.KERG62",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62681,
    "description": "Lifou IGN 1956 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002681,
    "auth_name": "IGNF",
    "auth_id": "LIFOU56",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62682,
    "description": "Lifou IGN 56 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002682,
    "auth_name": "IGNF",
    "auth_id": "LIFOU56G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62683,
    "description": "Lifou IGN 56 geographiques (dms) et NIVELLEMENT GENERAL DE LIFOU (IGN 1991 LF)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002683,
    "auth_name": "IGNF",
    "auth_id": "LIFOU56G.LIFOU91",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62684,
    "description": "Lifou IGN 56 UTM Sud fuseau 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs",
    "srid": 520002684,
    "auth_name": "IGNF",
    "auth_id": "LIFOU56UT58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62685,
    "description": "Lifou IGN 56 UTM Sud fuseau 58 et NIVELLEMENT GENERAL DE LIFOU (IGN 1991 LF)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002685,
    "auth_name": "IGNF",
    "auth_id": "LIFOU56UT58S.LIFOU91",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62686,
    "description": "Lambert Nord de Guerre Lambert Nord de Guerre",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=5.4 +k_0=0.99950908 +x_0=500000 +y_0=300000 +a=6376523 +rf=308.64 +pm=paris +units=m +no_defs",
    "srid": 520002686,
    "auth_name": "IGNF",
    "auth_id": "LNGLNG",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62687,
    "description": "Lambert Nord de Guerre grades Paris",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6376523 +rf=308.64 +pm=paris +no_defs",
    "srid": 520002687,
    "auth_name": "IGNF",
    "auth_id": "LNGPGG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62688,
    "description": "Nouvelle Triangulation Luxembourg cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43 +units=m +no_defs",
    "srid": 520002688,
    "auth_name": "IGNF",
    "auth_id": "LUREF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62689,
    "description": "Nouvelle Triangulation Luxembourg cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43 +units=m +no_defs",
    "srid": 520002689,
    "auth_name": "IGNF",
    "auth_id": "LURES",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62690,
    "description": "NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43 +no_defs",
    "srid": 520002690,
    "auth_name": "IGNF",
    "auth_id": "LURESG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62691,
    "description": "NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GAUSS KRUGER LUXEMBOURG",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +towgs84=-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43 +units=m +no_defs",
    "srid": 520002691,
    "auth_name": "IGNF",
    "auth_id": "LURESGKL",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62692,
    "description": "NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GAUSS KRUGER LUXEMBOURG et NIVELLEMENT GENERAL DU LUXEMBOURG",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +towgs84=-192.986,13.673,-39.309,-0.4099,-2.9332,2.6881,0.43 +units=m +vunits=m +no_defs",
    "srid": 520002692,
    "auth_name": "IGNF",
    "auth_id": "LURESGKL.NNLUX",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62693,
    "description": "Makemo SHM 1947-1950 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002693,
    "auth_name": "IGNF",
    "auth_id": "MAKE50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62694,
    "description": "Makemo (SHM 1947-1950) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002694,
    "auth_name": "IGNF",
    "auth_id": "MAKE50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62695,
    "description": "Makemo (SHM 1947-1950) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002695,
    "auth_name": "IGNF",
    "auth_id": "MAKE50UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62696,
    "description": "Mangareva 1951 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002696,
    "auth_name": "IGNF",
    "auth_id": "MANGA51",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62697,
    "description": "Mangareva 1951 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002697,
    "auth_name": "IGNF",
    "auth_id": "MANGA51G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62698,
    "description": "Mangareva 1951 UTM Sud fuseau 8",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=8 +south +ellps=intl +units=m +no_defs",
    "srid": 520002698,
    "auth_name": "IGNF",
    "auth_id": "MANGA51U8S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62699,
    "description": "Mangareva 1951 UTM Sud fuseau 8",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=8 +south +ellps=intl +units=m +no_defs",
    "srid": 520002699,
    "auth_name": "IGNF",
    "auth_id": "MANGA51UTM8S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62700,
    "description": "Mare IGN 1953 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002700,
    "auth_name": "IGNF",
    "auth_id": "MARE53",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62701,
    "description": "Mare IGN53 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002701,
    "auth_name": "IGNF",
    "auth_id": "MARE53G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62702,
    "description": "Mare IGN53 geographiques (dms) et NIVELLEMENT GENERAL DE MARE (IGN 1991 MR)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002702,
    "auth_name": "IGNF",
    "auth_id": "MARE53G.MARE91",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62703,
    "description": "Mare IGN53 UTM Sud fuseau 58 et NIVELLEMENT GENERAL DE MARE (IGN 1991 MR)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002703,
    "auth_name": "IGNF",
    "auth_id": "MARE53UTM58S.MARE91",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62704,
    "description": "Eiao Hiva Oa Motohani cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002704,
    "auth_name": "IGNF",
    "auth_id": "MARQUI72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62705,
    "description": "Marquises (IGN72) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002705,
    "auth_name": "IGNF",
    "auth_id": "MARQUI72G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62706,
    "description": "Martinique Fort-Desaix cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002706,
    "auth_name": "IGNF",
    "auth_id": "MART38",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62707,
    "description": "Martinique Fort-Desaix geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002707,
    "auth_name": "IGNF",
    "auth_id": "MART38G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62708,
    "description": "Martinique Fort-Desaix cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002708,
    "auth_name": "IGNF",
    "auth_id": "MARTFD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62709,
    "description": "Martinique Fort-Desaix geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002709,
    "auth_name": "IGNF",
    "auth_id": "MARTFDG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62710,
    "description": "Martinique Fort-Desaix geographiques (dms) et IGN 1987 (MARTINIQUE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002710,
    "auth_name": "IGNF",
    "auth_id": "MARTFDG.MART87",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62711,
    "description": "Martinique Fort-Desaix UTM Nord fuseau 20",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +no_defs",
    "srid": 520002711,
    "auth_name": "IGNF",
    "auth_id": "MARTFDUTM20",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62712,
    "description": "Martinique Fort-Desaix UTM Nord fuseau 20 et IGN 1987 (MARTINIQUE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=20 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002712,
    "auth_name": "IGNF",
    "auth_id": "MARTFDUTM20.MART87",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62713,
    "description": "Maupiti MOP 1983 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002713,
    "auth_name": "IGNF",
    "auth_id": "MAUPITI",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62714,
    "description": "Maupiti (MOP 1983) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002714,
    "auth_name": "IGNF",
    "auth_id": "MAUPITIG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62715,
    "description": "Maupiti (MOP 1983) geographiques (dms) et MAUPITI_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +geoidgrids=fr_ign_ggpf02-Maupiti.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002715,
    "auth_name": "IGNF",
    "auth_id": "MAUPITIG.MAUPITI01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62716,
    "description": "Maupiti (MOP 1983) UTM Sud fuseau 5",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs",
    "srid": 520002716,
    "auth_name": "IGNF",
    "auth_id": "MAUPITIUTM5S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62717,
    "description": "Maupiti (MOP 1983) UTM Sud fuseau 5 et MAUPITI_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +units=m +geoidgrids=fr_ign_ggpf02-Maupiti.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002717,
    "auth_name": "IGNF",
    "auth_id": "MAUPITIUTM5S.MAUPITI01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62718,
    "description": "Combani cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +no_defs",
    "srid": 520002718,
    "auth_name": "IGNF",
    "auth_id": "MAYO50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62719,
    "description": "Combani triangulation IGN 1950 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +no_defs",
    "srid": 520002719,
    "auth_name": "IGNF",
    "auth_id": "MAYO50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62720,
    "description": "Combani triangulation IGN 1950 geographiques (dms) et SHOM 1953 (MAYOTTE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +geoidgrids=fr_ign_ggm04v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002720,
    "auth_name": "IGNF",
    "auth_id": "MAYO50G.MAYO53",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62721,
    "description": "Combani UTM Sud fuseau 38 et SHOM 1953 (MAYOTTE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +towgs84=-382,-59,-262,0,0,0,0 +units=m +geoidgrids=fr_ign_ggm04v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002721,
    "auth_name": "IGNF",
    "auth_id": "MAYO50UTM38S.MAYO53",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62722,
    "description": "Fatu Huku MHEFO 1955 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002722,
    "auth_name": "IGNF",
    "auth_id": "MHEFO55F",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62723,
    "description": "Fatu Huku (MHEFO 1955) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002723,
    "auth_name": "IGNF",
    "auth_id": "MHEFO55FG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62724,
    "description": "Mohotani MHEFO 1955 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002724,
    "auth_name": "IGNF",
    "auth_id": "MHEFO55M",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62725,
    "description": "Mohotani (MHEFO 1955) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002725,
    "auth_name": "IGNF",
    "auth_id": "MHEFO55MG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62726,
    "description": "Gambier MHPF 1967 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=338.08,212.58,-296.17,0,0,0,0 +units=m +no_defs",
    "srid": 520002726,
    "auth_name": "IGNF",
    "auth_id": "MHPF67",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62727,
    "description": "MHPF 1967 GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=338.08,212.58,-296.17,0,0,0,0 +no_defs",
    "srid": 520002727,
    "auth_name": "IGNF",
    "auth_id": "MHPF67G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62728,
    "description": "Mohotani MHEFO 1955 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002728,
    "auth_name": "IGNF",
    "auth_id": "MOHO55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62729,
    "description": "Mohotani (MHEFO 1955) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002729,
    "auth_name": "IGNF",
    "auth_id": "MOHO55G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62730,
    "description": "Moorea 1987 UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002730,
    "auth_name": "IGNF",
    "auth_id": "MOORE87UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62731,
    "description": "Moorea 1987 UTM Sud fuseau 6 et MOOREA 1981 (MOOREA_SAU 2001)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002731,
    "auth_name": "IGNF",
    "auth_id": "MOORE87UTM6S.MOOREA81",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62732,
    "description": "MOOREA 1987 CARTESIENNES GEOCENTRIQUES",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002732,
    "auth_name": "IGNF",
    "auth_id": "MOOREA87",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62733,
    "description": "Moorea 1987 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002733,
    "auth_name": "IGNF",
    "auth_id": "MOOREA87G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62734,
    "description": "Moorea 1987 geographiques (dms) et MOOREA 1981 (MOOREA_SAU 2001)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002734,
    "auth_name": "IGNF",
    "auth_id": "MOOREA87G.MOOREA81",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62735,
    "description": "Tetiaroa (MOP90) cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-10.8,-1.8,12.77,0,0,0,0 +units=m +no_defs",
    "srid": 520002735,
    "auth_name": "IGNF",
    "auth_id": "MOP90",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62736,
    "description": "Tetiaroa (MOP90) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-10.8,-1.8,12.77,0,0,0,0 +no_defs",
    "srid": 520002736,
    "auth_name": "IGNF",
    "auth_id": "MOP90G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62737,
    "description": "Mururoa MGT 1951 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002737,
    "auth_name": "IGNF",
    "auth_id": "MURU51",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62738,
    "description": "Mururoa (MGT 1951) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002738,
    "auth_name": "IGNF",
    "auth_id": "MURU51G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62739,
    "description": "Mururoa MHPF 1959 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002739,
    "auth_name": "IGNF",
    "auth_id": "MURU59",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62740,
    "description": "Mururoa (MHPF 1959) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002740,
    "auth_name": "IGNF",
    "auth_id": "MURU59G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62741,
    "description": "Mururoa (MHPF 1959) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002741,
    "auth_name": "IGNF",
    "auth_id": "MURU59UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62742,
    "description": "Mururoa MHOI 1962 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002742,
    "auth_name": "IGNF",
    "auth_id": "MURU62",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62743,
    "description": "Mururoa (MHOI 1962) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002743,
    "auth_name": "IGNF",
    "auth_id": "MURU62G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62744,
    "description": "Mururoa (MHOI 1962) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002744,
    "auth_name": "IGNF",
    "auth_id": "MURU62UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62745,
    "description": "Mururoa IGN 1978 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002745,
    "auth_name": "IGNF",
    "auth_id": "MURU78",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62746,
    "description": "Mururoa (IGN 1978) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002746,
    "auth_name": "IGNF",
    "auth_id": "MURU78G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62747,
    "description": "Mururoa (IGN 1978) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520002747,
    "auth_name": "IGNF",
    "auth_id": "MURU78UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62748,
    "description": "GOMEN TERME NORD 1951 CARTESIENNES",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002748,
    "auth_name": "IGNF",
    "auth_id": "NC51",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62749,
    "description": "Gomen Terme Nord 1951 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002749,
    "auth_name": "IGNF",
    "auth_id": "NC51G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62750,
    "description": "GOMEN TERME NORD 1951 UTM SUD FUSEAU 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs",
    "srid": 520002750,
    "auth_name": "IGNF",
    "auth_id": "NC51UTM58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62751,
    "description": "Noumea 1974 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002751,
    "auth_name": "IGNF",
    "auth_id": "NEA74",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62752,
    "description": "NEA74 NOUMEA geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002752,
    "auth_name": "IGNF",
    "auth_id": "NEA74G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62753,
    "description": "NEA74 NOUMEA geographiques (dms) et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520002753,
    "auth_name": "IGNF",
    "auth_id": "NEA74G.NCAL69",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62754,
    "description": "NEA74 NOUMEA Lambert Noumea 2",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-22.2697222222222 +lon_0=166.4425 +lat_1=-22.2447222222222 +lat_2=-22.2947222222222 +x_0=8.313 +y_0=-2.354 +ellps=intl +units=m +no_defs",
    "srid": 520002754,
    "auth_name": "IGNF",
    "auth_id": "NEA74LBTNM2",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62755,
    "description": "NEA74 NOUMEA Lambert Noumea 2 et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-22.2697222222222 +lon_0=166.4425 +lat_1=-22.2447222222222 +lat_2=-22.2947222222222 +x_0=8.313 +y_0=-2.354 +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520002755,
    "auth_name": "IGNF",
    "auth_id": "NEA74LBTNM2.NCAL69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62756,
    "description": "Juan de Nova MHM 1953 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002756,
    "auth_name": "IGNF",
    "auth_id": "NOVA53",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62757,
    "description": "Juan de Nova  geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002757,
    "auth_name": "IGNF",
    "auth_id": "NOVA53G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62758,
    "description": "JUAN DE NOVA MHM 1953 UTM SUD FUSEAU 38",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=38 +south +ellps=intl +units=m +no_defs",
    "srid": 520002758,
    "auth_name": "IGNF",
    "auth_id": "NOVA53UTM38S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62759,
    "description": "NTF cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=geocent +ellps=clrk80ign +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002759,
    "auth_name": "IGNF",
    "auth_id": "NTF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62760,
    "description": "NTF Lambert I",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002760,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB1",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62761,
    "description": "NTF Lambert I et NGF-BOURDALOUE",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002761,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB1.BOURD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62762,
    "description": "NTF Lambert I et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002762,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB1.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62763,
    "description": "NTF Lambert I et NGF-LALLEMAND",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002763,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB1.NGF84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62764,
    "description": "NTF Lambert I carto",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002764,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB1C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62765,
    "description": "NTF Lambert I carto et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=0 +k_0=0.99987734 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002765,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB1C.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62766,
    "description": "NTF Lambert II",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002766,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62767,
    "description": "NTF Lambert II et NGF-BOURDALOUE",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002767,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2.BOURD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62768,
    "description": "NTF Lambert II et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002768,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62769,
    "description": "NTF Lambert II et NGF-LALLEMAND",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002769,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2.NGF84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62770,
    "description": "NTF Lambert II carto",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002770,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62771,
    "description": "NTF Lambert II carto et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002771,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2C.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62772,
    "description": "NTF Lambert II etendu",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002772,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2E",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62773,
    "description": "NTF Lambert II etendu et NGF-BOURDALOUE",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002773,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2E.BOURD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62774,
    "description": "NTF Lambert II etendu et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002774,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2E.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62775,
    "description": "NTF Lambert II etendu et NGF-IGN 1978",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002775,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2E.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62776,
    "description": "NTF Lambert II etendu et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002776,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2E.NGC48",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62777,
    "description": "NTF Lambert II etendu et NGF-LALLEMAND",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002777,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB2E.NGF84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62778,
    "description": "NTF Lambert III",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002778,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB3",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62779,
    "description": "NTF Lambert III et NGF-BOURDALOUE",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002779,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB3.BOURD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62780,
    "description": "NTF Lambert III et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002780,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB3.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62781,
    "description": "NTF Lambert III et NGF-LALLEMAND",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002781,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB3.NGF84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62782,
    "description": "NTF Lambert III carto",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002782,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB3C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62783,
    "description": "NTF Lambert III carto et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=0 +k_0=0.9998775 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002783,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB3C.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62784,
    "description": "NTF Lambert IV",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002784,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB4",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62785,
    "description": "NTF Lambert IV et NGF-IGN 1978",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002785,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB4.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62786,
    "description": "NTF Lambert IV et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002786,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB4.NGC48",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62787,
    "description": "NTF Lambert IV carto",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002787,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB4C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62788,
    "description": "NTF Lambert IV carto et NGF-IGN 1978",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002788,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMB4C.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62789,
    "description": "NTF Lambert Grand Champ",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=0 +lat_1=45 +lat_2=49 +x_0=600000 +y_0=600000 +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +units=m +no_defs",
    "srid": 520002789,
    "auth_name": "IGNF",
    "auth_id": "NTFLAMBGC",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62790,
    "description": "NTF geographiques Paris (gr)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +no_defs",
    "srid": 520002790,
    "auth_name": "IGNF",
    "auth_id": "NTFPGRAD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62791,
    "description": "NTF geographiques Paris (gr) et NGF-BOURDALOUE",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002791,
    "auth_name": "IGNF",
    "auth_id": "NTFPGRAD.BOURD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62792,
    "description": "NTF geographiques Paris (gr) et NGF-IGN 1969",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002792,
    "auth_name": "IGNF",
    "auth_id": "NTFPGRAD.IGN69",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62793,
    "description": "NTF geographiques Paris (gr) et NGF-IGN 1978",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002793,
    "auth_name": "IGNF",
    "auth_id": "NTFPGRAD.IGN78C",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62794,
    "description": "NTF geographiques Paris (gr) et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002794,
    "auth_name": "IGNF",
    "auth_id": "NTFPGRAD.NGC48",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62795,
    "description": "NTF geographiques Paris (gr) et NGF-LALLEMAND",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk80ign",
    "parameters": "+proj=longlat +ellps=clrk80ign +pm=paris +towgs84=-168,-60,320,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002795,
    "auth_name": "IGNF",
    "auth_id": "NTFPGRAD.NGF84",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62796,
    "description": "Nuku Hiva IGN 1972 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=84,274,65,0,0,0,0 +units=m +no_defs",
    "srid": 520002796,
    "auth_name": "IGNF",
    "auth_id": "NUKU72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62797,
    "description": "Nuku Hiva 1972 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=84,274,65,0,0,0,0 +no_defs",
    "srid": 520002797,
    "auth_name": "IGNF",
    "auth_id": "NUKU72G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62798,
    "description": "Nuku Hiva UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +towgs84=84,274,65,0,0,0,0 +units=m +no_defs",
    "srid": 520002798,
    "auth_name": "IGNF",
    "auth_id": "NUKU72UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62799,
    "description": "Ouvea MHNC 1972 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs",
    "srid": 520002799,
    "auth_name": "IGNF",
    "auth_id": "OUVE72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62800,
    "description": "Ouvea MHNC 1972 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002800,
    "auth_name": "IGNF",
    "auth_id": "OUVE72G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62801,
    "description": "Ouvea MHNC 1972 UTM Sud fuseau 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +towgs84=-11.64,-348.6,291.98,0,0,0,0 +units=m +no_defs",
    "srid": 520002801,
    "auth_name": "IGNF",
    "auth_id": "OUVE72UTM58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62802,
    "description": "Ouvea MHNC 1972 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-13,-348,292,0,0,0,0 +units=m +no_defs",
    "srid": 520002802,
    "auth_name": "IGNF",
    "auth_id": "OUVEA72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62803,
    "description": "Ouvea MHNC 1972 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002803,
    "auth_name": "IGNF",
    "auth_id": "OUVEA72G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62804,
    "description": "PITON DES NEIGES (2008) GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002804,
    "auth_name": "IGNF",
    "auth_id": "PDN08G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62805,
    "description": "Piton des Neiges (2008) Gauss Laborde Reunion",
    "projection_acronym": "gstmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +no_defs",
    "srid": 520002805,
    "auth_name": "IGNF",
    "auth_id": "PDN08GAUSSL",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62806,
    "description": "Piton des Neiges (2008) Gauss Laborde Reunion et IGN 1989 (REUNION)",
    "projection_acronym": "gstmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +geoidgrids=fr_ign_RAR07_bl.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002806,
    "auth_name": "IGNF",
    "auth_id": "PDN08GAUSSL.REUN89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62807,
    "description": "PITON DES NEIGES (1992) GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002807,
    "auth_name": "IGNF",
    "auth_id": "PDN92G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62808,
    "description": "Piton des Neiges (1992) Gauss Laborde Reunion",
    "projection_acronym": "gstmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +no_defs",
    "srid": 520002808,
    "auth_name": "IGNF",
    "auth_id": "PDN92GAUSSL",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62809,
    "description": "Piton des Neiges (1992) Gauss Laborde Reunion et IGN 1989 (REUNION)",
    "projection_acronym": "gstmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +units=m +geoidgrids=fr_ign_RAR07_bl.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002809,
    "auth_name": "IGNF",
    "auth_id": "PDN92GAUSSL.REUN89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62810,
    "description": "Petrels IGN 1972 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=365,194,166,0,0,0,0 +units=m +no_defs",
    "srid": 520002810,
    "auth_name": "IGNF",
    "auth_id": "PETRELS72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62811,
    "description": "Petrels geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=365,194,166,0,0,0,0 +no_defs",
    "srid": 520002811,
    "auth_name": "IGNF",
    "auth_id": "PETRELS72G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62812,
    "description": "Pointe Geologie Perroud 1950 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=324.8,153.6,172.1,0,0,0,0 +units=m +no_defs",
    "srid": 520002812,
    "auth_name": "IGNF",
    "auth_id": "PGP50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62813,
    "description": "Pointe Geologie Perroud 1950 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=324.8,153.6,172.1,0,0,0,0 +no_defs",
    "srid": 520002813,
    "auth_name": "IGNF",
    "auth_id": "PGP50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62814,
    "description": "TERRE ADELIE POINTE GEOLOGIE PERROUD STEREO POLAIRE SUD (TANGENTE)",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=140 +k=0.960272946 +x_0=300000 +y_0=-2299363.482 +ellps=intl +towgs84=324.8,153.6,172.1,0,0,0,0 +units=m +no_defs",
    "srid": 520002814,
    "auth_name": "IGNF",
    "auth_id": "PGP50STEREPS",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62815,
    "description": "Port Martin Perroud 1955 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002815,
    "auth_name": "IGNF",
    "auth_id": "PMAR55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62816,
    "description": "Port Martin geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002816,
    "auth_name": "IGNF",
    "auth_id": "PMAR55G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62817,
    "description": "Port Martin Perroud 1955 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002817,
    "auth_name": "IGNF",
    "auth_id": "PMARP55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62818,
    "description": "Port Martin geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002818,
    "auth_name": "IGNF",
    "auth_id": "PMARP55G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62819,
    "description": "Raiatea Tahaa Bora Bora Huahine 1953 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002819,
    "auth_name": "IGNF",
    "auth_id": "RAIA53",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62820,
    "description": "IGN53 Societe geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002820,
    "auth_name": "IGNF",
    "auth_id": "RAIA53G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62821,
    "description": "Raivavae cadastre 1953-1954 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002821,
    "auth_name": "IGNF",
    "auth_id": "RAIV54",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62822,
    "description": "Raivavae (Cadastre) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002822,
    "auth_name": "IGNF",
    "auth_id": "RAIV54G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62823,
    "description": "Raivavae (Cadastre) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002823,
    "auth_name": "IGNF",
    "auth_id": "RAIV54UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62824,
    "description": "Raivavae MHPF 1966 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002824,
    "auth_name": "IGNF",
    "auth_id": "RAIV66",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62825,
    "description": "Raivavae (MHPF 1966) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002825,
    "auth_name": "IGNF",
    "auth_id": "RAIV66G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62826,
    "description": "Raivavae (MHPF 1966) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002826,
    "auth_name": "IGNF",
    "auth_id": "RAIV66UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62827,
    "description": "Rangiroa MGT 1947 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002827,
    "auth_name": "IGNF",
    "auth_id": "RANGI47",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62828,
    "description": "Rangiroa (MGT 1947) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002828,
    "auth_name": "IGNF",
    "auth_id": "RANGI47G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62829,
    "description": "MGT 1947 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002829,
    "auth_name": "IGNF",
    "auth_id": "RANGI47GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62830,
    "description": "Rangiroa (MGT 1947) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002830,
    "auth_name": "IGNF",
    "auth_id": "RANGI47U6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62831,
    "description": "Rangiroa (MGT 1947) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002831,
    "auth_name": "IGNF",
    "auth_id": "RANGI47UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62832,
    "description": "Rangiroa MHPF 1959 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002832,
    "auth_name": "IGNF",
    "auth_id": "RANGI59",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62833,
    "description": "Rangiroa (MHPF 1959) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002833,
    "auth_name": "IGNF",
    "auth_id": "RANGI59G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62834,
    "description": "Rangiroa (MHPF 1959) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002834,
    "auth_name": "IGNF",
    "auth_id": "RANGI59U6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62835,
    "description": "Rangiroa (MHPF 1959) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002835,
    "auth_name": "IGNF",
    "auth_id": "RANGI59UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62836,
    "description": "Rangiroa MHPF 1966-1968 cartesiennes geocent.",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002836,
    "auth_name": "IGNF",
    "auth_id": "RANGI68",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62837,
    "description": "Rangiroa (MHPF 1966-68) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002837,
    "auth_name": "IGNF",
    "auth_id": "RANGI68G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62838,
    "description": "Rangiroa (MHPF 1966-68) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002838,
    "auth_name": "IGNF",
    "auth_id": "RANGI68U6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62839,
    "description": "Rangiroa (MHPF 1966-68) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520002839,
    "auth_name": "IGNF",
    "auth_id": "RANGI68UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62840,
    "description": "Rapa MHEFO 1955 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002840,
    "auth_name": "IGNF",
    "auth_id": "RAPA55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62841,
    "description": "Rapa (MHEFO 1955) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002841,
    "auth_name": "IGNF",
    "auth_id": "RAPA55G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62842,
    "description": "Rapa SEQ 1980 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520002842,
    "auth_name": "IGNF",
    "auth_id": "RAPA80",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62843,
    "description": "Rapa (SEQ 1980) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002843,
    "auth_name": "IGNF",
    "auth_id": "RAPA80G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62844,
    "description": "Reunion Piton des Neiges 1949 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +no_defs",
    "srid": 520002844,
    "auth_name": "IGNF",
    "auth_id": "REUN47",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62845,
    "description": "Reunion Piton des Neiges geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +no_defs",
    "srid": 520002845,
    "auth_name": "IGNF",
    "auth_id": "REUN47G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62846,
    "description": "Reunion Piton des Neiges 1949 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +no_defs",
    "srid": 520002846,
    "auth_name": "IGNF",
    "auth_id": "REUN49",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62847,
    "description": "Reunion Piton des Neiges geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +no_defs",
    "srid": 520002847,
    "auth_name": "IGNF",
    "auth_id": "REUN49G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62848,
    "description": "Reunion Piton des Neiges geographiques (dms) et IGN 1989 (REUNION)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +geoidgrids=fr_ign_RAR07_bl.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002848,
    "auth_name": "IGNF",
    "auth_id": "REUN49G.REUN89",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62849,
    "description": "Reunion Piton des Neiges Gauss Laborde",
    "projection_acronym": "gstmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +no_defs",
    "srid": 520002849,
    "auth_name": "IGNF",
    "auth_id": "REUN49GAUSSL",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62850,
    "description": "Reunion Piton des Neiges Gauss Laborde et IGN 1989 (REUNION)",
    "projection_acronym": "gstmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=gstmerc +lat_0=-21.1166666666667 +lon_0=55.5333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +towgs84=94,-948,-1262,0,0,0,0 +units=m +geoidgrids=fr_ign_RAR07_bl.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002850,
    "auth_name": "IGNF",
    "auth_id": "REUN49GAUSSL.REUN89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62851,
    "description": "RGAF09 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520002851,
    "auth_name": "IGNF",
    "auth_id": "RGAF09",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62852,
    "description": "RGAF09 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520002852,
    "auth_name": "IGNF",
    "auth_id": "RGAF09G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62853,
    "description": "RGAF09 geographiques (dms) et IGN 2008 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002853,
    "auth_name": "IGNF",
    "auth_id": "RGAF09G.GUAD2008LD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62854,
    "description": "RGAF09 geographiques (dms) et IGN 1988 (GUADELOUPE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002854,
    "auth_name": "IGNF",
    "auth_id": "RGAF09G.GUAD88",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62855,
    "description": "RGAF09 geographiques (dms) et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002855,
    "auth_name": "IGNF",
    "auth_id": "RGAF09G.GUAD88LS",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62856,
    "description": "RGAF09 geographiques (dms) et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002856,
    "auth_name": "IGNF",
    "auth_id": "RGAF09G.GUAD88MG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62857,
    "description": "RGAF09 geographiques (dms) et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002857,
    "auth_name": "IGNF",
    "auth_id": "RGAF09G.GUAD88SB",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62858,
    "description": "RGAF09 geographiques (dms) et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002858,
    "auth_name": "IGNF",
    "auth_id": "RGAF09G.GUAD88SM",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62859,
    "description": "RGAF09 geographiques (dms) et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002859,
    "auth_name": "IGNF",
    "auth_id": "RGAF09G.GUAD92LD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62860,
    "description": "RGAF09 geographiques (dms) et IGN 1987 (MARTINIQUE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002860,
    "auth_name": "IGNF",
    "auth_id": "RGAF09G.MART87",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62861,
    "description": "RGAF09 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520002861,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62862,
    "description": "RGAF09 geographiques (dd) et IGN 2008 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002862,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GDD.GUAD2008LD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62863,
    "description": "RGAF09 geographiques (dd) et IGN 1988 (GUADELOUPE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002863,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GDD.GUAD88",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62864,
    "description": "RGAF09 geographiques (dd) et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002864,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GDD.GUAD88LS",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62865,
    "description": "RGAF09 geographiques (dd) et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002865,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GDD.GUAD88MG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62866,
    "description": "RGAF09 geographiques (dd) et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002866,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GDD.GUAD88SB",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62867,
    "description": "RGAF09 geographiques (dd) et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002867,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GDD.GUAD88SM",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62868,
    "description": "RGAF09 geographiques (dd) et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002868,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GDD.GUAD92LD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62869,
    "description": "RGAF09 geographiques (dd) et IGN 1987 (MARTINIQUE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002869,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GDD.MART87",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62870,
    "description": "RGAF09 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520002870,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62871,
    "description": "RGAF09 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520002871,
    "auth_name": "IGNF",
    "auth_id": "RGAF09GEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62872,
    "description": "RGAF09 UTM Nord Fuseau 20",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002872,
    "auth_name": "IGNF",
    "auth_id": "RGAF09UTM20",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62873,
    "description": "RGAF09 UTM Nord Fuseau 20 et IGN 2008 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002873,
    "auth_name": "IGNF",
    "auth_id": "RGAF09UTM20.GUAD2008LD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62874,
    "description": "RGAF09 UTM Nord Fuseau 20 et IGN 1988 (GUADELOUPE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002874,
    "auth_name": "IGNF",
    "auth_id": "RGAF09UTM20.GUAD88",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62875,
    "description": "RGAF09 UTM Nord Fuseau 20 et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002875,
    "auth_name": "IGNF",
    "auth_id": "RGAF09UTM20.GUAD88LS",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62876,
    "description": "RGAF09 UTM Nord Fuseau 20 et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002876,
    "auth_name": "IGNF",
    "auth_id": "RGAF09UTM20.GUAD88MG",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62877,
    "description": "RGAF09 UTM Nord Fuseau 20 et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002877,
    "auth_name": "IGNF",
    "auth_id": "RGAF09UTM20.GUAD88SB",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62878,
    "description": "RGAF09 UTM Nord Fuseau 20 et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002878,
    "auth_name": "IGNF",
    "auth_id": "RGAF09UTM20.GUAD88SM",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62879,
    "description": "RGAF09 UTM Nord Fuseau 20 et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002879,
    "auth_name": "IGNF",
    "auth_id": "RGAF09UTM20.GUAD92LD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62880,
    "description": "RGAF09 UTM Nord Fuseau 20 et IGN 1987 (MARTINIQUE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002880,
    "auth_name": "IGNF",
    "auth_id": "RGAF09UTM20.MART87",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62881,
    "description": "RGF93 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002881,
    "auth_name": "IGNF",
    "auth_id": "RGF93",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62882,
    "description": "RGF93 CC42 zone 1 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002882,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC42.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62883,
    "description": "RGF93 CC42 zone 1 et NGF-IGN 1978",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002883,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC42.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62884,
    "description": "RGF93 CC43 zone 2 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002884,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC43.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62885,
    "description": "RGF93 CC43 zone 2 et NGF-IGN 1978",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002885,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC43.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62886,
    "description": "RGF93 CC44 zone 3 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=3 +lat_1=43.25 +lat_2=44.75 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002886,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC44.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62887,
    "description": "RGF93 CC45 zone 4 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=3 +lat_1=44.25 +lat_2=45.75 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002887,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC45.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62888,
    "description": "RGF93 CC46 zone 5 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46 +lon_0=3 +lat_1=45.25 +lat_2=46.75 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002888,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC46.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62889,
    "description": "RGF93 CC47 zone 6 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=3 +lat_1=46.25 +lat_2=47.75 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002889,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC47.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62890,
    "description": "RGF93 CC48 zone 7 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=48 +lon_0=3 +lat_1=47.25 +lat_2=48.75 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002890,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC48.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62891,
    "description": "RGF93 CC49 zone 8 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=49 +lon_0=3 +lat_1=48.25 +lat_2=49.75 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002891,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC49.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62892,
    "description": "RGF93 CC50 zone 9 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=50 +lon_0=3 +lat_1=49.25 +lat_2=50.75 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002892,
    "auth_name": "IGNF",
    "auth_id": "RGF93CC50.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62893,
    "description": "France Metropolitaine projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=46.5 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002893,
    "auth_name": "IGNF",
    "auth_id": "RGF93EQGPFR",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62894,
    "description": "RGF93 geographiques (dms) et NGF-IGN 1969",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002894,
    "auth_name": "IGNF",
    "auth_id": "RGF93G.IGN69",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62895,
    "description": "RGF93 geographiques (dms) et NGF-IGN 1978",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002895,
    "auth_name": "IGNF",
    "auth_id": "RGF93G.IGN78C",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62896,
    "description": "RGF93 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002896,
    "auth_name": "IGNF",
    "auth_id": "RGF93GDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62897,
    "description": "RGF93 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002897,
    "auth_name": "IGNF",
    "auth_id": "RGF93GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62898,
    "description": "RGF93 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002898,
    "auth_name": "IGNF",
    "auth_id": "RGF93GEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62899,
    "description": "RGF93 Lambert 93",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=44 +lat_2=49 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002899,
    "auth_name": "IGNF",
    "auth_id": "RGF93LAMB93",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62900,
    "description": "RGF93 Lambert 93 et NGF-IGN 1969",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=44 +lat_2=49 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002900,
    "auth_name": "IGNF",
    "auth_id": "RGF93LAMB93.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62901,
    "description": "RGF93 Lambert 93 et NGF-IGN 1978",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=44 +lat_2=49 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002901,
    "auth_name": "IGNF",
    "auth_id": "RGF93LAMB93.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62902,
    "description": "RGF93 UTM NORD FUSEAU 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002902,
    "auth_name": "IGNF",
    "auth_id": "RGF93UTM30",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62903,
    "description": "RGF93 UTM NORD FUSEAU 30 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002903,
    "auth_name": "IGNF",
    "auth_id": "RGF93UTM30.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62904,
    "description": "RGF93 UTM fuseau 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002904,
    "auth_name": "IGNF",
    "auth_id": "RGF93UTM31",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62905,
    "description": "RGF93 UTM fuseau 31 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002905,
    "auth_name": "IGNF",
    "auth_id": "RGF93UTM31.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62906,
    "description": "RGF93 UTM fuseau 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002906,
    "auth_name": "IGNF",
    "auth_id": "RGF93UTM32",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62907,
    "description": "RGF93 UTM fuseau 32 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002907,
    "auth_name": "IGNF",
    "auth_id": "RGF93UTM32.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62908,
    "description": "RGF93 UTM fuseau 32 et NGF-IGN 1978",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002908,
    "auth_name": "IGNF",
    "auth_id": "RGF93UTM32.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62909,
    "description": "RGFG95 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002909,
    "auth_name": "IGNF",
    "auth_id": "RGFG95",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62910,
    "description": "Guyane Francaise projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=4 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002910,
    "auth_name": "IGNF",
    "auth_id": "RGFG95EQGPGU",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62911,
    "description": "RGFG95 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002911,
    "auth_name": "IGNF",
    "auth_id": "RGFG95G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62912,
    "description": "RGFG95 geographiques (dms) et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002912,
    "auth_name": "IGNF",
    "auth_id": "RGFG95G.GUYA77",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62913,
    "description": "RGFG95 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002913,
    "auth_name": "IGNF",
    "auth_id": "RGFG95GDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62914,
    "description": "RGFG95 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002914,
    "auth_name": "IGNF",
    "auth_id": "RGFG95GEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62915,
    "description": "RGFG95 UTM Nord f.21",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002915,
    "auth_name": "IGNF",
    "auth_id": "RGFG95UTM21",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62916,
    "description": "RGFG95 UTM Nord f.21 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002916,
    "auth_name": "IGNF",
    "auth_id": "RGFG95UTM21.GUYA77",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62917,
    "description": "RGFG95 UTM Nord f.22",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002917,
    "auth_name": "IGNF",
    "auth_id": "RGFG95UTM22",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62918,
    "description": "RGFG95 UTM Nord f.22 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002918,
    "auth_name": "IGNF",
    "auth_id": "RGFG95UTM22.GUYA77",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62919,
    "description": "RGM04 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002919,
    "auth_name": "IGNF",
    "auth_id": "RGM04",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62920,
    "description": "Mayotte projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=-12 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002920,
    "auth_name": "IGNF",
    "auth_id": "RGM04EQGPMYT",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62921,
    "description": "RGM04 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002921,
    "auth_name": "IGNF",
    "auth_id": "RGM04G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62922,
    "description": "RGM04 geographiques (dms) et SHOM 1953 (MAYOTTE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggm04v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002922,
    "auth_name": "IGNF",
    "auth_id": "RGM04G.MAYO53",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62923,
    "description": "RGM04 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002923,
    "auth_name": "IGNF",
    "auth_id": "RGM04GDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62924,
    "description": "RGM04 geographiques (dd) et SHOM 1953 (MAYOTTE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggm04v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002924,
    "auth_name": "IGNF",
    "auth_id": "RGM04GDD.MAYO53",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62925,
    "description": "RGM04 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002925,
    "auth_name": "IGNF",
    "auth_id": "RGM04GEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62926,
    "description": "RGM04 UTM Sud fuseau 38 et SHOM 1953 (MAYOTTE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=38 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggm04v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002926,
    "auth_name": "IGNF",
    "auth_id": "RGM04UTM38S.MAYO53",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62927,
    "description": "RGNC cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002927,
    "auth_name": "IGNF",
    "auth_id": "RGNC",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62928,
    "description": "Nouvelle Caledonie projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=eqc +lat_ts=-22 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002928,
    "auth_name": "IGNF",
    "auth_id": "RGNC91EQGPNC",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62929,
    "description": "RGNC geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002929,
    "auth_name": "IGNF",
    "auth_id": "RGNCG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62930,
    "description": "RGNC geographiques (dms) et NIVELLEMENT GENERAL DE LIFOU (IGN 1991 LF)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002930,
    "auth_name": "IGNF",
    "auth_id": "RGNCG.LIFOU91",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62931,
    "description": "RGNC geographiques (dms) et NIVELLEMENT GENERAL DE MARE (IGN 1991 MR)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002931,
    "auth_name": "IGNF",
    "auth_id": "RGNCG.MARE91",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62932,
    "description": "RGNC geographiques (dms) et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002932,
    "auth_name": "IGNF",
    "auth_id": "RGNCG.NCAL69",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62933,
    "description": "RGNC geographiques (dms) et SHOM 1978 (ILE DES PINS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002933,
    "auth_name": "IGNF",
    "auth_id": "RGNCG.PINS78",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62934,
    "description": "RGNC GEOGRAPHIQUES (DD)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520002934,
    "auth_name": "IGNF",
    "auth_id": "RGNCGEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62935,
    "description": "RGNC Lambert Nouvelle-Caledonie",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002935,
    "auth_name": "IGNF",
    "auth_id": "RGNCLAMBNC",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62936,
    "description": "RGNC Lambert Nouvelle-Caledonie et NIVELLEMENT GENERAL DE LIFOU (IGN 1991 LF)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002936,
    "auth_name": "IGNF",
    "auth_id": "RGNCLAMBNC.LIFOU91",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62937,
    "description": "RGNC Lambert Nouvelle-Caledonie et NIVELLEMENT GENERAL DE MARE (IGN 1991 MR)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002937,
    "auth_name": "IGNF",
    "auth_id": "RGNCLAMBNC.MARE91",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62938,
    "description": "RGNC Lambert Nouvelle-Caledonie et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002938,
    "auth_name": "IGNF",
    "auth_id": "RGNCLAMBNC.NCAL69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62939,
    "description": "RGNC Lambert Nouvelle-Caledonie et SHOM 1978 (ILE DES PINS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=400000 +y_0=300000 +ellps=intl +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002939,
    "auth_name": "IGNF",
    "auth_id": "RGNCLAMBNC.PINS78",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62940,
    "description": "RGPF cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002940,
    "auth_name": "IGNF",
    "auth_id": "RGPF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62941,
    "description": "Polynesie Francaise projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=-15 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002941,
    "auth_name": "IGNF",
    "auth_id": "RGPFEQGPPF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62942,
    "description": "RGPF geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002942,
    "auth_name": "IGNF",
    "auth_id": "RGPFG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62943,
    "description": "RGPF geographiques (dms) et BORA_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggpf02-Bora.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002943,
    "auth_name": "IGNF",
    "auth_id": "RGPFG.BORA01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62944,
    "description": "RGPF geographiques (dms) et HUAHINE_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggpf02-Huahine.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002944,
    "auth_name": "IGNF",
    "auth_id": "RGPFG.HUAH01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62945,
    "description": "RGPF geographiques (dms) et MAUPITI_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggpf02-Maupiti.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002945,
    "auth_name": "IGNF",
    "auth_id": "RGPFG.MAUPITI01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62946,
    "description": "RGPF geographiques (dms) et MOOREA 1981 (MOOREA_SAU 2001)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520002946,
    "auth_name": "IGNF",
    "auth_id": "RGPFG.MOOREA81",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62947,
    "description": "RGPF geographiques (dms) et RAIATEA_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggpf02-Raiatea.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002947,
    "auth_name": "IGNF",
    "auth_id": "RGPFG.RAIA01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62948,
    "description": "RGPF geographiques (dms) et TAHAA_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggpf02-Tahaa.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002948,
    "auth_name": "IGNF",
    "auth_id": "RGPFG.TAHAA01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62949,
    "description": "RGPF geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002949,
    "auth_name": "IGNF",
    "auth_id": "RGPFGDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62950,
    "description": "RGPF UTM Sud fuseau 5 et BORA_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggpf02-Bora.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002950,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM5S.BORA01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62951,
    "description": "RGPF UTM Sud fuseau 5 et HUAHINE_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggpf02-Huahine.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002951,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM5S.HUAH01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62952,
    "description": "RGPF UTM Sud fuseau 5 et MAUPITI_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggpf02-Maupiti.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002952,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM5S.MAUPITI01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62953,
    "description": "RGPF UTM Sud fuseau 5 et RAIATEA_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggpf02-Raiatea.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002953,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM5S.RAIA01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62954,
    "description": "RGPF UTM Sud fuseau 5 et TAHAA_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=5 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggpf02-Tahaa.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002954,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM5S.TAHAA01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62955,
    "description": "RGPF UTM Sud fuseau 6 et MOOREA 1981 (MOOREA_SAU 2001)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=6 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002955,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM6S.MOOREA81",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62956,
    "description": "RGPF UTM SUD FUSEAU 8",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=8 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002956,
    "auth_name": "IGNF",
    "auth_id": "RGPFUTM8S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62957,
    "description": "RGR92 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002957,
    "auth_name": "IGNF",
    "auth_id": "RGR92",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62958,
    "description": "Reunion projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=-21 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002958,
    "auth_name": "IGNF",
    "auth_id": "RGR92EQGPREU",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62959,
    "description": "RGR92 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002959,
    "auth_name": "IGNF",
    "auth_id": "RGR92G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62960,
    "description": "RGR92 geographiques (dms) et IGN 1989 (REUNION)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_RAR07_bl.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002960,
    "auth_name": "IGNF",
    "auth_id": "RGR92G.REUN89",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62961,
    "description": "RGR92 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002961,
    "auth_name": "IGNF",
    "auth_id": "RGR92GDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62962,
    "description": "RGR92 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002962,
    "auth_name": "IGNF",
    "auth_id": "RGR92GEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62963,
    "description": "RGR92 UTM 40 Sud et IGN 1989 (REUNION)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=40 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_RAR07_bl.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002963,
    "auth_name": "IGNF",
    "auth_id": "RGR92UTM40S.REUN89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62964,
    "description": "RGSPM06 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002964,
    "auth_name": "IGNF",
    "auth_id": "RGSPM06",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62965,
    "description": "Saint-Pierre-et-Miquelon Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=eqc +lat_ts=47 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002965,
    "auth_name": "IGNF",
    "auth_id": "RGSPM06EQGP",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62966,
    "description": "RGSPM06 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002966,
    "auth_name": "IGNF",
    "auth_id": "RGSPM06G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62967,
    "description": "RGSPM06 geographiques (dms) et DANGER 1950 (SAINT-PIERRE-ET-MIQUELON)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggspm06v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002967,
    "auth_name": "IGNF",
    "auth_id": "RGSPM06G.STPM50",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62968,
    "description": "RGSPM06 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002968,
    "auth_name": "IGNF",
    "auth_id": "RGSPM06GDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62969,
    "description": "RGSPM06 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002969,
    "auth_name": "IGNF",
    "auth_id": "RGSPM06GEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62970,
    "description": "RGSPM06 UTM Nord fuseau 21 et DANGER 1950 (SAINT-PIERRE-ET-MIQUELON)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggspm06v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002970,
    "auth_name": "IGNF",
    "auth_id": "RGSPM06U21.STPM50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62971,
    "description": "RGTAAF07 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002971,
    "auth_name": "IGNF",
    "auth_id": "RGTAAF07",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62972,
    "description": "RGTAAF07 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002972,
    "auth_name": "IGNF",
    "auth_id": "RGTAAF07G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62973,
    "description": "RGTAAF07 geographiques (dms) et IGN 1962 (KERGUELEN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggker08v2.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002973,
    "auth_name": "IGNF",
    "auth_id": "RGTAAF07G.KERG62",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62974,
    "description": "RGTAAF07 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002974,
    "auth_name": "IGNF",
    "auth_id": "RGTAAF07GDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62975,
    "description": "RGTAAF07 geographiques (dd) et IGN 1962 (KERGUELEN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggker08v2.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002975,
    "auth_name": "IGNF",
    "auth_id": "RGTAAF07GDD.KERG62",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62976,
    "description": "RGTAAF07 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002976,
    "auth_name": "IGNF",
    "auth_id": "RGTAAFGEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62977,
    "description": "RGTAAF07 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520002977,
    "auth_name": "IGNF",
    "auth_id": "RGTAAFGEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62978,
    "description": "RGTAAF07 UTM Sud fuseau 37",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=37 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002978,
    "auth_name": "IGNF",
    "auth_id": "RGTAAFUTM37S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62979,
    "description": "RGTAAF07 UTM Sud fuseau 39",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=39 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002979,
    "auth_name": "IGNF",
    "auth_id": "RGTAAFUTM39S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62980,
    "description": "RGTAAF07 UTM Sud fuseau 42",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=42 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002980,
    "auth_name": "IGNF",
    "auth_id": "RGTAAFUTM42S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62981,
    "description": "RGTAAF07 UTM Sud fuseau 42 et IGN 1962 (KERGUELEN)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=42 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_ggker08v2.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520002981,
    "auth_name": "IGNF",
    "auth_id": "RGTAAFUTM42S.KERG62",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62982,
    "description": "RGTAAF07 UTM Sud fuseau 43",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=43 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002982,
    "auth_name": "IGNF",
    "auth_id": "RGTAAFUTM43S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62983,
    "description": "RGTAAF07 UTM SUD FUSEAU 53",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=53 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002983,
    "auth_name": "IGNF",
    "auth_id": "RGTAAFUTM53S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62984,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520002984,
    "auth_name": "IGNF",
    "auth_id": "RGWF96G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62985,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520002985,
    "auth_name": "IGNF",
    "auth_id": "RGWF96GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 62986,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DMS) et NGWF ILES HORN (FUTUNA ET ALOFI)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002986,
    "auth_name": "IGNF",
    "auth_id": "RGWF96GEO.FUTUNA1997",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62987,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DMS) et NGWF WALLIS (MOP 1996)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520002987,
    "auth_name": "IGNF",
    "auth_id": "RGWF96GEO.WALLIS96",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62988,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 UTM SUD FUSEAU 1",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=1 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520002988,
    "auth_name": "IGNF",
    "auth_id": "RGWF96UTM1S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 62989,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 UTM SUD FUSEAU 1 et NGWF ILES HORN (FUTUNA ET ALOFI)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=1 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002989,
    "auth_name": "IGNF",
    "auth_id": "RGWF96UTM1S.FUTUNA1997",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62990,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 UTM SUD FUSEAU 1 et NGWF WALLIS (MOP 1996)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=1 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520002990,
    "auth_name": "IGNF",
    "auth_id": "RGWF96UTM1S.WALLIS96",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62991,
    "description": "RRAF cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 520002991,
    "auth_name": "IGNF",
    "auth_id": "RRAF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62992,
    "description": "WGS84 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +datum=WGS84 +units=m +no_defs",
    "srid": 520002992,
    "auth_name": "IGNF",
    "auth_id": "RRAF91",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 62993,
    "description": "RRAF geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520002993,
    "auth_name": "IGNF",
    "auth_id": "RRAFG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 62994,
    "description": "RRAF geographiques (dms) et IGN 1988 (GUADELOUPE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs",
    "srid": 520002994,
    "auth_name": "IGNF",
    "auth_id": "RRAFG.GUAD88",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62995,
    "description": "RRAF geographiques (dms) et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs",
    "srid": 520002995,
    "auth_name": "IGNF",
    "auth_id": "RRAFG.GUAD88LS",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62996,
    "description": "RRAF geographiques (dms) et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs",
    "srid": 520002996,
    "auth_name": "IGNF",
    "auth_id": "RRAFG.GUAD88MG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62997,
    "description": "RRAF geographiques (dms) et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs",
    "srid": 520002997,
    "auth_name": "IGNF",
    "auth_id": "RRAFG.GUAD88SB",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62998,
    "description": "RRAF geographiques (dms) et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs",
    "srid": 520002998,
    "auth_name": "IGNF",
    "auth_id": "RRAFG.GUAD88SM",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 62999,
    "description": "RRAF geographiques (dms) et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs",
    "srid": 520002999,
    "auth_name": "IGNF",
    "auth_id": "RRAFG.GUAD92LD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63000,
    "description": "RRAF geographiques (dms) et IGN 1987 (MARTINIQUE)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs",
    "srid": 520003000,
    "auth_name": "IGNF",
    "auth_id": "RRAFG.MART87",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63001,
    "description": "RRAF geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003001,
    "auth_name": "IGNF",
    "auth_id": "RRAFGDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63002,
    "description": "RRAF geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003002,
    "auth_name": "IGNF",
    "auth_id": "RRAFGEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63003,
    "description": "RRAF geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003003,
    "auth_name": "IGNF",
    "auth_id": "RRAFGEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63004,
    "description": "RRAF UTM Nord fuseau 20",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +ellps=WGS84 +units=m +no_defs",
    "srid": 520003004,
    "auth_name": "IGNF",
    "auth_id": "RRAFUTM20",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63005,
    "description": "RRAF UTM Nord fuseau 20 et IGN 1988 (GUADELOUPE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003005,
    "auth_name": "IGNF",
    "auth_id": "RRAFUTM20.GUAD88",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63006,
    "description": "RRAF UTM Nord fuseau 20 et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003006,
    "auth_name": "IGNF",
    "auth_id": "RRAFUTM20.GUAD88LS",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63007,
    "description": "RRAF UTM Nord fuseau 20 et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003007,
    "auth_name": "IGNF",
    "auth_id": "RRAFUTM20.GUAD88MG",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63008,
    "description": "RRAF UTM Nord fuseau 20 et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003008,
    "auth_name": "IGNF",
    "auth_id": "RRAFUTM20.GUAD88SB",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63009,
    "description": "RRAF UTM Nord fuseau 20 et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003009,
    "auth_name": "IGNF",
    "auth_id": "RRAFUTM20.GUAD88SM",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63010,
    "description": "RRAF UTM Nord fuseau 20 et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003010,
    "auth_name": "IGNF",
    "auth_id": "RRAFUTM20.GUAD92LD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63011,
    "description": "RRAF UTM Nord fuseau 20 et IGN 1987 (MARTINIQUE)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=20 +ellps=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003011,
    "auth_name": "IGNF",
    "auth_id": "RRAFUTM20.MART87",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63012,
    "description": "Rurutu SAT84 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=202.13,174.6,-15.74,0,0,0,0 +units=m +no_defs",
    "srid": 520003012,
    "auth_name": "IGNF",
    "auth_id": "RUSAT84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63013,
    "description": "Rurutu (SAT84) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=202.13,174.6,-15.74,0,0,0,0 +no_defs",
    "srid": 520003013,
    "auth_name": "IGNF",
    "auth_id": "RUSAT84G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63014,
    "description": "Rurutu (SAT84) UTM Sud fuseau 5",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +towgs84=202.13,174.6,-15.74,0,0,0,0 +units=m +no_defs",
    "srid": 520003014,
    "auth_name": "IGNF",
    "auth_id": "RUSAT84UTM5S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63015,
    "description": "Rurutu SAT84 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=202.13,174.6,-15.74,0,0,0,0 +units=m +no_defs",
    "srid": 520003015,
    "auth_name": "IGNF",
    "auth_id": "SAT84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63016,
    "description": "Rurutu (SAT84) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=202.13,174.6,-15.74,0,0,0,0 +no_defs",
    "srid": 520003016,
    "auth_name": "IGNF",
    "auth_id": "SAT84G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63017,
    "description": "Ile des Pins ST84 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003017,
    "auth_name": "IGNF",
    "auth_id": "ST84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63018,
    "description": "ST 84 ILE DES PINS geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003018,
    "auth_name": "IGNF",
    "auth_id": "ST84G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63019,
    "description": "ST 84 ILE DES PINS geographiques (dms) et SHOM 1978 (ILE DES PINS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520003019,
    "auth_name": "IGNF",
    "auth_id": "ST84G.PINS78",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63020,
    "description": "ST 84 ILE DES PINS UTM Sud fuseau 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +units=m +no_defs",
    "srid": 520003020,
    "auth_name": "IGNF",
    "auth_id": "ST84UTM58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63021,
    "description": "ST 84 ILE DES PINS UTM Sud fuseau 58 et SHOM 1978 (ILE DES PINS)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=58 +south +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520003021,
    "auth_name": "IGNF",
    "auth_id": "ST84UTM58S.PINS78",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63022,
    "description": "ST 87 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 520003022,
    "auth_name": "IGNF",
    "auth_id": "ST87",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63023,
    "description": "ST 87 OUVEA geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003023,
    "auth_name": "IGNF",
    "auth_id": "ST87G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63024,
    "description": "ST 87 OUVEA geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003024,
    "auth_name": "IGNF",
    "auth_id": "ST87GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63025,
    "description": "ST 87 OUVEA UTM Sud fuseau 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=58 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003025,
    "auth_name": "IGNF",
    "auth_id": "ST87UTM58S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63026,
    "description": "Saint-Paul 1969 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003026,
    "auth_name": "IGNF",
    "auth_id": "STPL69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63027,
    "description": "Saint-Paul geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003027,
    "auth_name": "IGNF",
    "auth_id": "STPL69G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63028,
    "description": "Ile Saint-Paul 1969 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003028,
    "auth_name": "IGNF",
    "auth_id": "STPL69GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63029,
    "description": "Saint-Paul UTM Sud fuseau 43",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=43 +south +ellps=intl +units=m +no_defs",
    "srid": 520003029,
    "auth_name": "IGNF",
    "auth_id": "STPL69UTM43S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63030,
    "description": "St Pierre Miquelon 1950 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=geocent +ellps=clrk66 +towgs84=11.363,424.148,373.13,0,0,0,0 +units=m +no_defs",
    "srid": 520003030,
    "auth_name": "IGNF",
    "auth_id": "STPM50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63031,
    "description": "St Pierre Miquelon 1950 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=11.363,424.148,373.13,0,0,0,0 +no_defs",
    "srid": 520003031,
    "auth_name": "IGNF",
    "auth_id": "STPM50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63032,
    "description": "St Pierre Miquelon 1950 geographiques (dms) et DANGER 1950 (SAINT-PIERRE-ET-MIQUELON)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=longlat +ellps=clrk66 +towgs84=11.363,424.148,373.13,0,0,0,0 +geoidgrids=fr_ign_ggspm06v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003032,
    "auth_name": "IGNF",
    "auth_id": "STPM50G.STPM50",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63033,
    "description": "St-Pierre-et-Miquelon UTM Nord f.21 et DANGER 1950 (SAINT-PIERRE-ET-MIQUELON)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "clrk66",
    "parameters": "+proj=utm +zone=21 +ellps=clrk66 +towgs84=11.363,424.148,373.13,0,0,0,0 +units=m +geoidgrids=fr_ign_ggspm06v1.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003033,
    "auth_name": "IGNF",
    "auth_id": "STPM50UTM21.STPM50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63034,
    "description": "Lambert Nord de Guerre Lambert Nord de Guerre",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=5.4 +k_0=0.99950908 +x_0=500000 +y_0=300000 +a=6376523 +rf=308.64 +pm=paris +units=m +no_defs",
    "srid": 520003034,
    "auth_name": "IGNF",
    "auth_id": "SYSLN",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63035,
    "description": "Lambert Nord de Guerre grades Paris",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6376523 +rf=308.64 +pm=paris +no_defs",
    "srid": 520003035,
    "auth_name": "IGNF",
    "auth_id": "SYSLNG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63036,
    "description": "Tahaa 1951 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=65,342,77,0,0,0,0 +units=m +no_defs",
    "srid": 520003036,
    "auth_name": "IGNF",
    "auth_id": "TAHAA",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63037,
    "description": "Raiatea Tahaa Bora Bora Huahine 1953 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003037,
    "auth_name": "IGNF",
    "auth_id": "TAHAA53",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63038,
    "description": "IGN53 Societe geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003038,
    "auth_name": "IGNF",
    "auth_id": "TAHAA53G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63039,
    "description": "IGN53 Societe geographiques (dms) et BORA_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +geoidgrids=fr_ign_ggpf02-Bora.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003039,
    "auth_name": "IGNF",
    "auth_id": "TAHAA53G.BORA01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63040,
    "description": "IGN53 Societe geographiques (dms) et HUAHINE_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +geoidgrids=fr_ign_ggpf02-Huahine.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003040,
    "auth_name": "IGNF",
    "auth_id": "TAHAA53G.HUAH01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63041,
    "description": "IGN53 Societe geographiques (dms) et RAIATEA_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +geoidgrids=fr_ign_ggpf02-Raiatea.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003041,
    "auth_name": "IGNF",
    "auth_id": "TAHAA53G.RAIA01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63042,
    "description": "IGN53 Societe UTM Sud fuseau 5",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +units=m +no_defs",
    "srid": 520003042,
    "auth_name": "IGNF",
    "auth_id": "TAHAA53UTM5S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63043,
    "description": "IGN53 Societe UTM Sud fuseau 5 et BORA_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +units=m +geoidgrids=fr_ign_ggpf02-Bora.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003043,
    "auth_name": "IGNF",
    "auth_id": "TAHAA53UTM5S.BORA01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63044,
    "description": "IGN53 Societe UTM Sud fuseau 5 et HUAHINE_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +units=m +geoidgrids=fr_ign_ggpf02-Huahine.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003044,
    "auth_name": "IGNF",
    "auth_id": "TAHAA53UTM5S.HUAH01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63045,
    "description": "IGN53 Societe UTM Sud fuseau 5 et RAIATEA_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +units=m +geoidgrids=fr_ign_ggpf02-Raiatea.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003045,
    "auth_name": "IGNF",
    "auth_id": "TAHAA53UTM5S.RAIA01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63046,
    "description": "Tahaa geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=65,342,77,0,0,0,0 +no_defs",
    "srid": 520003046,
    "auth_name": "IGNF",
    "auth_id": "TAHAAG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63047,
    "description": "Tahaa geographiques (dms) et TAHAA_SAU 2001",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=65,342,77,0,0,0,0 +geoidgrids=fr_ign_ggpf02-Tahaa.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003047,
    "auth_name": "IGNF",
    "auth_id": "TAHAAG.TAHAA01",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63048,
    "description": "Tahaa UTM Sud fuseau 5",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +towgs84=65,342,77,0,0,0,0 +units=m +no_defs",
    "srid": 520003048,
    "auth_name": "IGNF",
    "auth_id": "TAHAAUTM5S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63049,
    "description": "Tahaa UTM Sud fuseau 5 et TAHAA_SAU 2001",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=5 +south +ellps=intl +towgs84=65,342,77,0,0,0,0 +units=m +geoidgrids=fr_ign_ggpf02-Tahaa.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003049,
    "auth_name": "IGNF",
    "auth_id": "TAHAAUTM5S.TAHAA01",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63050,
    "description": "TAHITI TERME NORD CARTESIENNES GEOCENTRIQUES",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=162,117,154,0,0,0,0 +units=m +no_defs",
    "srid": 520003050,
    "auth_name": "IGNF",
    "auth_id": "TAHI51",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63051,
    "description": "TAHITI TERME NORD GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=162,117,154,0,0,0,0 +no_defs",
    "srid": 520003051,
    "auth_name": "IGNF",
    "auth_id": "TAHI51G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63052,
    "description": "TAHITI TERME NORD UTM SUD FUSEAU 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=162,117,154,0,0,0,0 +units=m +no_defs",
    "srid": 520003052,
    "auth_name": "IGNF",
    "auth_id": "TAHI51UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63053,
    "description": "TAHITI TERME NORD UTM SUD FUSEAU 6 et IGN 1966 (TAHITI)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=162,117,154,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520003053,
    "auth_name": "IGNF",
    "auth_id": "TAHI51UTM6S.TAHITI66",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63054,
    "description": "Tahiti IGN 1979 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=160.61,116.05,153.69,0,0,0,0 +units=m +no_defs",
    "srid": 520003054,
    "auth_name": "IGNF",
    "auth_id": "TAHI79",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63055,
    "description": "Tahiti (IGN79) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=160.61,116.05,153.69,0,0,0,0 +no_defs",
    "srid": 520003055,
    "auth_name": "IGNF",
    "auth_id": "TAHI79G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63056,
    "description": "Tahiti (IGN79) geographiques (dms) et IGN 1966 (TAHITI)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=160.61,116.05,153.69,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003056,
    "auth_name": "IGNF",
    "auth_id": "TAHI79G.TAHITI66",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63057,
    "description": "Tahiti (IGN79) UTM Sud fuseau 6 et IGN 1966 (TAHITI)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=160.61,116.05,153.69,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520003057,
    "auth_name": "IGNF",
    "auth_id": "TAHI79UTM6S.TAHITI66",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63058,
    "description": "Takaroa Takapoto SHM 1969 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003058,
    "auth_name": "IGNF",
    "auth_id": "TAKA69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63059,
    "description": "Takaroa Takapoto (SHM 1969) geo. (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003059,
    "auth_name": "IGNF",
    "auth_id": "TAKA69G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63060,
    "description": "Takaroa Takapoto (SHM 1969) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520003060,
    "auth_name": "IGNF",
    "auth_id": "TAKA69UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63061,
    "description": "Tanna Bloc Sud 1957 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-139,-967,436,0,0,0,0 +units=m +no_defs",
    "srid": 520003061,
    "auth_name": "IGNF",
    "auth_id": "TANNA",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63062,
    "description": "Tanna geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-139,-967,436,0,0,0,0 +no_defs",
    "srid": 520003062,
    "auth_name": "IGNF",
    "auth_id": "TANNAG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63063,
    "description": "Pointe Geologie Perroud 1950 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=324.8,153.6,172.1,0,0,0,0 +units=m +no_defs",
    "srid": 520003063,
    "auth_name": "IGNF",
    "auth_id": "TERA50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63064,
    "description": "Pointe Geologie Perroud 1950 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=324.8,153.6,172.1,0,0,0,0 +no_defs",
    "srid": 520003064,
    "auth_name": "IGNF",
    "auth_id": "TERA50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63065,
    "description": "Tetiaroa (MOP90) cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=-10.8,-1.8,12.77,0,0,0,0 +units=m +no_defs",
    "srid": 520003065,
    "auth_name": "IGNF",
    "auth_id": "TETIA90",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63066,
    "description": "Tetiaroa (MOP90) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-10.8,-1.8,12.77,0,0,0,0 +no_defs",
    "srid": 520003066,
    "auth_name": "IGNF",
    "auth_id": "TETIA90G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63067,
    "description": "Tetiaroa (MOP90) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +towgs84=-10.8,-1.8,12.77,0,0,0,0 +units=m +no_defs",
    "srid": 520003067,
    "auth_name": "IGNF",
    "auth_id": "TETIA90UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63068,
    "description": "Tikehau SHM 1947-1950 cartesiennes",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003068,
    "auth_name": "IGNF",
    "auth_id": "TIKE50",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63069,
    "description": "Tikehau (SHM 1947-1950) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003069,
    "auth_name": "IGNF",
    "auth_id": "TIKE50G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63070,
    "description": "Tikehau (SHM 1947-1950) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520003070,
    "auth_name": "IGNF",
    "auth_id": "TIKE50UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63071,
    "description": "Tikehau MHPF 1960 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003071,
    "auth_name": "IGNF",
    "auth_id": "TIKE60",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63072,
    "description": "Tikehau (MHPF 1960) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003072,
    "auth_name": "IGNF",
    "auth_id": "TIKE60G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63073,
    "description": "Tikehau (MHPF 1960) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520003073,
    "auth_name": "IGNF",
    "auth_id": "TIKE60UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63074,
    "description": "TIKEHAU (MOP88) GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +no_defs",
    "srid": 520003074,
    "auth_name": "IGNF",
    "auth_id": "TIKE88G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63075,
    "description": "TIKEHAU (MOP88) GEOGRAPHIQUES (DMS)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +no_defs",
    "srid": 520003075,
    "auth_name": "IGNF",
    "auth_id": "TIKE88GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63076,
    "description": "TIKEHAU (MOP88) UTM SUD FUSEAU 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=6 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 520003076,
    "auth_name": "IGNF",
    "auth_id": "TIKE88UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63077,
    "description": "Tromelin SGM 1956 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003077,
    "auth_name": "IGNF",
    "auth_id": "TROM56",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63078,
    "description": "Tromelin geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003078,
    "auth_name": "IGNF",
    "auth_id": "TROM56G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63079,
    "description": "TROMELIN SGM 1956 MERCATOR DIRECTE",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=merc +lon_0=0 +k=1 +x_0=20000000 +y_0=10000000 +ellps=intl +units=m +no_defs",
    "srid": 520003079,
    "auth_name": "IGNF",
    "auth_id": "TROM56MD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63080,
    "description": "TUAMOTU (MOP86) CARTESIENNES",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003080,
    "auth_name": "IGNF",
    "auth_id": "TUAM86",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63081,
    "description": "Tuamotu (MOP86) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003081,
    "auth_name": "IGNF",
    "auth_id": "TUAM86G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63082,
    "description": "Tuamotu (MOP86) UTM Sud fuseau 6",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=6 +south +ellps=intl +units=m +no_defs",
    "srid": 520003082,
    "auth_name": "IGNF",
    "auth_id": "TUAM86UTM6S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63083,
    "description": "Tuamotu (MOP86) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520003083,
    "auth_name": "IGNF",
    "auth_id": "TUAM86UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63084,
    "description": "Tubuai MGT 1955 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003084,
    "auth_name": "IGNF",
    "auth_id": "TUBU55",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63085,
    "description": "Tubuai (MGT 1955) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003085,
    "auth_name": "IGNF",
    "auth_id": "TUBU55G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63086,
    "description": "Tubuai MHPF 1969 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=237.17,171.61,-77.84,0,0,0,0 +units=m +no_defs",
    "srid": 520003086,
    "auth_name": "IGNF",
    "auth_id": "TUBU69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63087,
    "description": "Tubuai (MHPF 1969) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=237.17,171.61,-77.84,0,0,0,0 +no_defs",
    "srid": 520003087,
    "auth_name": "IGNF",
    "auth_id": "TUBU69G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63088,
    "description": "Tureia SHM 1969 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003088,
    "auth_name": "IGNF",
    "auth_id": "TURI69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63089,
    "description": "Tureia (SHM 1969) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003089,
    "auth_name": "IGNF",
    "auth_id": "TURI69G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63090,
    "description": "Tureia (SHM 1969) UTM Sud fuseau 7",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=7 +south +ellps=intl +units=m +no_defs",
    "srid": 520003090,
    "auth_name": "IGNF",
    "auth_id": "TURI69UTM7S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63091,
    "description": "RGFG95 UTM Nord f.21",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003091,
    "auth_name": "IGNF",
    "auth_id": "UTM21RGFG95",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63092,
    "description": "ETRS89 UTM Nord fuseau 26",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=26 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003092,
    "auth_name": "IGNF",
    "auth_id": "UTM26ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63093,
    "description": "ETRS89 UTM Nord fuseau 27",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=27 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003093,
    "auth_name": "IGNF",
    "auth_id": "UTM27ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63094,
    "description": "ETRS89 UTM Nord fuseau 28",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=28 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003094,
    "auth_name": "IGNF",
    "auth_id": "UTM28ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63095,
    "description": "ETRS89 UTM Nord fuseau 29",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003095,
    "auth_name": "IGNF",
    "auth_id": "UTM29ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63096,
    "description": "ETRS89 UTM Nord fuseau 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003096,
    "auth_name": "IGNF",
    "auth_id": "UTM30ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63097,
    "description": "ETRS89 UTM Nord fuseau 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003097,
    "auth_name": "IGNF",
    "auth_id": "UTM31ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63098,
    "description": "ETRS89 UTM Nord fuseau 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003098,
    "auth_name": "IGNF",
    "auth_id": "UTM32ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63099,
    "description": "ETRS89 UTM Nord fuseau 33",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003099,
    "auth_name": "IGNF",
    "auth_id": "UTM33ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63100,
    "description": "ETRS89 UTM Nord fuseau 34",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003100,
    "auth_name": "IGNF",
    "auth_id": "UTM34ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63101,
    "description": "ETRS89 UTM Nord fuseau 35",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003101,
    "auth_name": "IGNF",
    "auth_id": "UTM35ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63102,
    "description": "ETRS89 UTM Nord fuseau 36",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003102,
    "auth_name": "IGNF",
    "auth_id": "UTM36ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63103,
    "description": "ETRS89 UTM Nord fuseau 37",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003103,
    "auth_name": "IGNF",
    "auth_id": "UTM37ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63104,
    "description": "ETRS89 UTM Nord fuseau 38",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003104,
    "auth_name": "IGNF",
    "auth_id": "UTM38ETRS89",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63105,
    "description": "RRAF geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003105,
    "auth_name": "IGNF",
    "auth_id": "W84MARTGEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63106,
    "description": "Wallis - Uvea MOP 1976 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520003106,
    "auth_name": "IGNF",
    "auth_id": "WALL76",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63107,
    "description": "Wallis (MOP 1976) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520003107,
    "auth_name": "IGNF",
    "auth_id": "WALL76G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63108,
    "description": "Wallis (MOP 1976) geographiques (dms) et NGWF WALLIS (MOP 1996)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +vunits=m +no_defs",
    "srid": 520003108,
    "auth_name": "IGNF",
    "auth_id": "WALL76G.WALLIS96",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63109,
    "description": "Wallis (MOP 1976) UTM Sud fuseau 1",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=1 +south +ellps=intl +units=m +no_defs",
    "srid": 520003109,
    "auth_name": "IGNF",
    "auth_id": "WALL76UTM1S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63110,
    "description": "Wallis (MOP 1976) UTM Sud fuseau 1 et NGWF WALLIS (MOP 1996)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=1 +south +ellps=intl +units=m +vunits=m +no_defs",
    "srid": 520003110,
    "auth_name": "IGNF",
    "auth_id": "WALL76UTM1S.WALLIS96",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63111,
    "description": "Wallis - Uvea Shom 1978 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=geocent +ellps=intl +towgs84=253,-133,-127,0,0,0,0 +units=m +no_defs",
    "srid": 520003111,
    "auth_name": "IGNF",
    "auth_id": "WALL78",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63112,
    "description": "Wallis (MOP 1978) geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=253,-133,-127,0,0,0,0 +no_defs",
    "srid": 520003112,
    "auth_name": "IGNF",
    "auth_id": "WALL78G",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63113,
    "description": "Wallis (MOP 1978) geographiques (dms) et NGWF WALLIS (MOP 1996)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=253,-133,-127,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003113,
    "auth_name": "IGNF",
    "auth_id": "WALL78G.WALLIS96",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63114,
    "description": "Wallis (MOP 1978) UTM Sud fuseau 1 et NGWF WALLIS (MOP 1996)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=utm +zone=1 +south +ellps=intl +towgs84=253,-133,-127,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520003114,
    "auth_name": "IGNF",
    "auth_id": "WALL78UTM1S.WALLIS96",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63115,
    "description": "WGS72 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=geocent +ellps=WGS72 +units=m +no_defs",
    "srid": 520003115,
    "auth_name": "IGNF",
    "auth_id": "WGS72",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63116,
    "description": "WGS72 geographiques (dms) et NGF-IGN 1969",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +vunits=m +no_defs",
    "srid": 520003116,
    "auth_name": "IGNF",
    "auth_id": "WGS72G.IGN69",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63117,
    "description": "WGS72 geographiques (dms) et NGF-IGN 1978",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003117,
    "auth_name": "IGNF",
    "auth_id": "WGS72G.IGN78C",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63118,
    "description": "WGS72 geographiques (dms) et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +vunits=m +no_defs",
    "srid": 520003118,
    "auth_name": "IGNF",
    "auth_id": "WGS72G.NGC48",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63119,
    "description": "WGS72 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=longlat +ellps=WGS72 +no_defs",
    "srid": 520003119,
    "auth_name": "IGNF",
    "auth_id": "WGS72GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63120,
    "description": "WGS72 UTM Sud Fuseau 1",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=1 +south +ellps=WGS72 +units=m +no_defs",
    "srid": 520003120,
    "auth_name": "IGNF",
    "auth_id": "WGS72UTM1S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63121,
    "description": "WGS72 UTM fuseau 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=30 +ellps=WGS72 +units=m +no_defs",
    "srid": 520003121,
    "auth_name": "IGNF",
    "auth_id": "WGS72UTM30",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63122,
    "description": "WGS72 UTM fuseau 30 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=30 +ellps=WGS72 +units=m +vunits=m +no_defs",
    "srid": 520003122,
    "auth_name": "IGNF",
    "auth_id": "WGS72UTM30.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63123,
    "description": "WGS72 UTM fuseau 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=31 +ellps=WGS72 +units=m +no_defs",
    "srid": 520003123,
    "auth_name": "IGNF",
    "auth_id": "WGS72UTM31",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63124,
    "description": "WGS72 UTM fuseau 31 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=31 +ellps=WGS72 +units=m +vunits=m +no_defs",
    "srid": 520003124,
    "auth_name": "IGNF",
    "auth_id": "WGS72UTM31.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63125,
    "description": "WGS72 UTM fuseau 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=32 +ellps=WGS72 +units=m +no_defs",
    "srid": 520003125,
    "auth_name": "IGNF",
    "auth_id": "WGS72UTM32",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63126,
    "description": "WGS72 UTM fuseau 32 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=32 +ellps=WGS72 +units=m +vunits=m +no_defs",
    "srid": 520003126,
    "auth_name": "IGNF",
    "auth_id": "WGS72UTM32.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63127,
    "description": "WGS72 UTM fuseau 32 et NGF-IGN 1978",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=32 +ellps=WGS72 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003127,
    "auth_name": "IGNF",
    "auth_id": "WGS72UTM32.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63128,
    "description": "WGS72 UTM fuseau 32 et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS72",
    "parameters": "+proj=utm +zone=32 +ellps=WGS72 +units=m +vunits=m +no_defs",
    "srid": 520003128,
    "auth_name": "IGNF",
    "auth_id": "WGS72UTM32.NGC48",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63129,
    "description": "WGS84 cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +datum=WGS84 +units=m +no_defs",
    "srid": 520003129,
    "auth_name": "IGNF",
    "auth_id": "WGS84",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63130,
    "description": "Amsterdam Saint-Paul projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-38 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003130,
    "auth_name": "IGNF",
    "auth_id": "WGS84EQGPASP",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63131,
    "description": "Crozet projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-46 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003131,
    "auth_name": "IGNF",
    "auth_id": "WGS84EQGPCRZ",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63132,
    "description": "Kerguelen projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-49.5 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003132,
    "auth_name": "IGNF",
    "auth_id": "WGS84EQGPKER",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63133,
    "description": "Wallis et Futuna projection Geoportail",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=-14 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003133,
    "auth_name": "IGNF",
    "auth_id": "WGS84EQGPWF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63134,
    "description": "WGS84 geographiques (dms) et NGF-IGN 1969",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +vunits=m +no_defs",
    "srid": 520003134,
    "auth_name": "IGNF",
    "auth_id": "WGS84G.IGN69",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63135,
    "description": "WGS84 geographiques (dms) et NGF-IGN 1978",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003135,
    "auth_name": "IGNF",
    "auth_id": "WGS84G.IGN78C",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63136,
    "description": "WGS84 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +no_defs",
    "srid": 520003136,
    "auth_name": "IGNF",
    "auth_id": "WGS84GDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63137,
    "description": "WGS84 geographiques (dd) et NGF-IGN 1969",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +vunits=m +no_defs",
    "srid": 520003137,
    "auth_name": "IGNF",
    "auth_id": "WGS84GDD.IGN69",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63138,
    "description": "WGS84 geographiques (dd) et NGF-IGN 1978",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003138,
    "auth_name": "IGNF",
    "auth_id": "WGS84GDD.IGN78C",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63139,
    "description": "WGS84 geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +no_defs",
    "srid": 520003139,
    "auth_name": "IGNF",
    "auth_id": "WGS84GEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63140,
    "description": "WGS84 geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +no_defs",
    "srid": 520003140,
    "auth_name": "IGNF",
    "auth_id": "WGS84GEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63141,
    "description": "ANTILLES FRANCAISES PROJECTION GEOPORTAIL",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=eqc +lat_ts=15 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003141,
    "auth_name": "IGNF",
    "auth_id": "WGS84GPAF",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63142,
    "description": "RRAF cartesiennes geocentriques",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 520003142,
    "auth_name": "IGNF",
    "auth_id": "WGS84GUAD",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63143,
    "description": "RRAF geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003143,
    "auth_name": "IGNF",
    "auth_id": "WGS84GUADGEO",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63144,
    "description": "RRAF geographiques (dms)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003144,
    "auth_name": "IGNF",
    "auth_id": "WGS84MARTG",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63145,
    "description": "RRAF geographiques (dd)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003145,
    "auth_name": "IGNF",
    "auth_id": "WGS84MARTGDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63146,
    "description": "WGS84 PROJECTION MILLER GEOPORTAIL",
    "projection_acronym": "mill",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=mill +datum=WGS84 +units=m +no_defs",
    "srid": 520003146,
    "auth_name": "IGNF",
    "auth_id": "WGS84MILLGP",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63147,
    "description": "WGS84 UTM Sud Fuseau 1",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=1 +south +datum=WGS84 +units=m +no_defs",
    "srid": 520003147,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM1S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63148,
    "description": "WGS84 UTM fuseau 30",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=30 +datum=WGS84 +units=m +no_defs",
    "srid": 520003148,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM30",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63149,
    "description": "WGS84 UTM fuseau 30 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=30 +datum=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003149,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM30.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63150,
    "description": "WGS84 UTM fuseau 31",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=31 +datum=WGS84 +units=m +no_defs",
    "srid": 520003150,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM31",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63151,
    "description": "WGS84 UTM fuseau 31 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=31 +datum=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003151,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM31.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63152,
    "description": "WGS84 UTM NORD FUSEAU 32",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs",
    "srid": 520003152,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM32",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63153,
    "description": "WGS84 UTM NORD FUSEAU 32 et NGF-IGN 1969",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=32 +datum=WGS84 +units=m +vunits=m +no_defs",
    "srid": 520003153,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM32.IGN69",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63154,
    "description": "WGS84 UTM NORD FUSEAU 32 et NGF-IGN 1978",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=32 +datum=WGS84 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003154,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM32.IGN78C",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63155,
    "description": "WGS84 UTM SUD FUSEAU 39",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=39 +south +datum=WGS84 +units=m +no_defs",
    "srid": 520003155,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM39S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63156,
    "description": "WGS84 UTM SUD FUSEAU 42",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=42 +south +datum=WGS84 +units=m +no_defs",
    "srid": 520003156,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM42S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63157,
    "description": "WGS84 UTM SUD FUSEAU 43",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=utm +zone=43 +south +datum=WGS84 +units=m +no_defs",
    "srid": 520003157,
    "auth_name": "IGNF",
    "auth_id": "WGS84UTM43S",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63158,
    "description": "WGS84 WEB MERCATOR SPHERIQUE (VISUALISATION)",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs",
    "srid": 520003158,
    "auth_name": "IGNF",
    "auth_id": "WGS84WMSV",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63159,
    "description": "WGS 84 (CRS84)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +datum=WGS84 +no_defs",
    "srid": 520003159,
    "auth_name": "OGC",
    "auth_id": "CRS84",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63160,
    "description": "Camacupa 2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "",
    "parameters": "+proj=longlat +a=6378249.145 +rf=293.465 +towgs84=-93.799,-132.737,-219.073,-1.844,0.648,-6.37,-0.169 +no_defs",
    "srid": 520003160,
    "auth_name": "EPSG",
    "auth_id": "8694",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63161,
    "description": "RSAO13",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003161,
    "auth_name": "EPSG",
    "auth_id": "8697",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63162,
    "description": "RSAO13",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520003162,
    "auth_name": "EPSG",
    "auth_id": "8698",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63163,
    "description": "RSAO13",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520003163,
    "auth_name": "EPSG",
    "auth_id": "8699",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63164,
    "description": "WGS 84 (Transit)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003164,
    "auth_name": "EPSG",
    "auth_id": "8888",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63165,
    "description": "SIRGAS-CON DGF00P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003165,
    "auth_name": "EPSG",
    "auth_id": "8915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63166,
    "description": "SIRGAS-CON DGF00P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003166,
    "auth_name": "EPSG",
    "auth_id": "8916",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63167,
    "description": "SIRGAS-CON DGF01P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003167,
    "auth_name": "EPSG",
    "auth_id": "8917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63168,
    "description": "SIRGAS-CON DGF01P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003168,
    "auth_name": "EPSG",
    "auth_id": "8918",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63169,
    "description": "SIRGAS-CON DGF01P02",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003169,
    "auth_name": "EPSG",
    "auth_id": "8919",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63170,
    "description": "SIRGAS-CON DGF01P02",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003170,
    "auth_name": "EPSG",
    "auth_id": "8920",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63171,
    "description": "SIRGAS-CON DGF02P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003171,
    "auth_name": "EPSG",
    "auth_id": "8921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63172,
    "description": "SIRGAS-CON DGF02P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003172,
    "auth_name": "EPSG",
    "auth_id": "8922",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63173,
    "description": "SIRGAS-CON DGF04P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003173,
    "auth_name": "EPSG",
    "auth_id": "8923",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63174,
    "description": "SIRGAS-CON DGF04P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003174,
    "auth_name": "EPSG",
    "auth_id": "8924",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63175,
    "description": "SIRGAS-CON DGF05P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003175,
    "auth_name": "EPSG",
    "auth_id": "8925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63176,
    "description": "SIRGAS-CON DGF05P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003176,
    "auth_name": "EPSG",
    "auth_id": "8926",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63177,
    "description": "SIRGAS-CON DGF06P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003177,
    "auth_name": "EPSG",
    "auth_id": "8927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63178,
    "description": "SIRGAS-CON DGF06P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003178,
    "auth_name": "EPSG",
    "auth_id": "8928",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63179,
    "description": "SIRGAS-CON DGF07P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003179,
    "auth_name": "EPSG",
    "auth_id": "8929",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63180,
    "description": "SIRGAS-CON DGF07P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003180,
    "auth_name": "EPSG",
    "auth_id": "8930",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63181,
    "description": "SIRGAS-CON DGF08P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003181,
    "auth_name": "EPSG",
    "auth_id": "8931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63182,
    "description": "SIRGAS-CON DGF08P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003182,
    "auth_name": "EPSG",
    "auth_id": "8932",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63183,
    "description": "SIRGAS-CON SIR09P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003183,
    "auth_name": "EPSG",
    "auth_id": "8933",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63184,
    "description": "SIRGAS-CON SIR09P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003184,
    "auth_name": "EPSG",
    "auth_id": "8934",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63185,
    "description": "SIRGAS-CON SIR10P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003185,
    "auth_name": "EPSG",
    "auth_id": "8935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63186,
    "description": "SIRGAS-CON SIR10P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003186,
    "auth_name": "EPSG",
    "auth_id": "8936",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63187,
    "description": "SIRGAS-CON SIR11P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003187,
    "auth_name": "EPSG",
    "auth_id": "8937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63188,
    "description": "SIRGAS-CON SIR11P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003188,
    "auth_name": "EPSG",
    "auth_id": "8938",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63189,
    "description": "SIRGAS-CON SIR13P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003189,
    "auth_name": "EPSG",
    "auth_id": "8939",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63190,
    "description": "SIRGAS-CON SIR13P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003190,
    "auth_name": "EPSG",
    "auth_id": "8940",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63191,
    "description": "SIRGAS-CON SIR14P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003191,
    "auth_name": "EPSG",
    "auth_id": "8941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63192,
    "description": "SIRGAS-CON SIR14P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003192,
    "auth_name": "EPSG",
    "auth_id": "8942",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63193,
    "description": "SIRGAS-CON SIR15P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003193,
    "auth_name": "EPSG",
    "auth_id": "8943",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63194,
    "description": "SIRGAS-CON SIR15P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003194,
    "auth_name": "EPSG",
    "auth_id": "8944",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63195,
    "description": "SIRGAS-CON SIR17P01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003195,
    "auth_name": "EPSG",
    "auth_id": "8945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63196,
    "description": "SIRGAS-CON SIR17P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003196,
    "auth_name": "EPSG",
    "auth_id": "8946",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63197,
    "description": "SIRGAS-Chile 2010",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003197,
    "auth_name": "EPSG",
    "auth_id": "8947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63198,
    "description": "SIRGAS-Chile 2010",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003198,
    "auth_name": "EPSG",
    "auth_id": "8948",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63199,
    "description": "SIRGAS-Chile 2010",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003199,
    "auth_name": "EPSG",
    "auth_id": "8949",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63200,
    "description": "SIRGAS-Chile 2010 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003200,
    "auth_name": "EPSG",
    "auth_id": "8950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63201,
    "description": "SIRGAS-Chile 2010 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003201,
    "auth_name": "EPSG",
    "auth_id": "8951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63202,
    "description": "SIRGAS-CON DGF00P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003202,
    "auth_name": "EPSG",
    "auth_id": "8972",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63203,
    "description": "SIRGAS-CON DGF01P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003203,
    "auth_name": "EPSG",
    "auth_id": "8973",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63204,
    "description": "SIRGAS-CON DGF01P02",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003204,
    "auth_name": "EPSG",
    "auth_id": "8974",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63205,
    "description": "SIRGAS-CON DGF02P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003205,
    "auth_name": "EPSG",
    "auth_id": "8975",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63206,
    "description": "SIRGAS-CON DGF04P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003206,
    "auth_name": "EPSG",
    "auth_id": "8976",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63207,
    "description": "SIRGAS-CON DGF05P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003207,
    "auth_name": "EPSG",
    "auth_id": "8977",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63208,
    "description": "SIRGAS-CON DGF06P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003208,
    "auth_name": "EPSG",
    "auth_id": "8978",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63209,
    "description": "SIRGAS-CON DGF07P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003209,
    "auth_name": "EPSG",
    "auth_id": "8979",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63210,
    "description": "SIRGAS-CON DGF08P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003210,
    "auth_name": "EPSG",
    "auth_id": "8980",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63211,
    "description": "SIRGAS-CON SIR09P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003211,
    "auth_name": "EPSG",
    "auth_id": "8981",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63212,
    "description": "SIRGAS-CON SIR10P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003212,
    "auth_name": "EPSG",
    "auth_id": "8982",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63213,
    "description": "SIRGAS-CON SIR11P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003213,
    "auth_name": "EPSG",
    "auth_id": "8983",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63214,
    "description": "SIRGAS-CON SIR13P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003214,
    "auth_name": "EPSG",
    "auth_id": "8984",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63215,
    "description": "SIRGAS-CON SIR14P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003215,
    "auth_name": "EPSG",
    "auth_id": "8985",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63216,
    "description": "SIRGAS-CON SIR15P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003216,
    "auth_name": "EPSG",
    "auth_id": "8986",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63217,
    "description": "SIRGAS-CON SIR17P01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003217,
    "auth_name": "EPSG",
    "auth_id": "8987",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63218,
    "description": "ISN2016 / LAEA Europe",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=laea +lat_0=52 +lon_0=10 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003218,
    "auth_name": "EPSG",
    "auth_id": "9039",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63219,
    "description": "ISN2016 / LCC Europe",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_0=52 +lon_0=10 +lat_1=35 +lat_2=65 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003219,
    "auth_name": "EPSG",
    "auth_id": "9040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63220,
    "description": "WGS 84 (G730)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003220,
    "auth_name": "EPSG",
    "auth_id": "9053",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63221,
    "description": "WGS 84 (G873)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003221,
    "auth_name": "EPSG",
    "auth_id": "9054",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63222,
    "description": "WGS 84 (G1150)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003222,
    "auth_name": "EPSG",
    "auth_id": "9055",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63223,
    "description": "WGS 84 (G1674)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003223,
    "auth_name": "EPSG",
    "auth_id": "9056",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63224,
    "description": "WGS 84 (G1762)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003224,
    "auth_name": "EPSG",
    "auth_id": "9057",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63225,
    "description": "ETRF89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003225,
    "auth_name": "EPSG",
    "auth_id": "9059",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63226,
    "description": "ETRF90",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003226,
    "auth_name": "EPSG",
    "auth_id": "9060",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63227,
    "description": "ETRF91",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003227,
    "auth_name": "EPSG",
    "auth_id": "9061",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63228,
    "description": "ETRF92",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003228,
    "auth_name": "EPSG",
    "auth_id": "9062",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63229,
    "description": "ETRF93",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003229,
    "auth_name": "EPSG",
    "auth_id": "9063",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63230,
    "description": "ETRF94",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003230,
    "auth_name": "EPSG",
    "auth_id": "9064",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63231,
    "description": "ETRF96",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003231,
    "auth_name": "EPSG",
    "auth_id": "9065",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63232,
    "description": "ETRF97",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003232,
    "auth_name": "EPSG",
    "auth_id": "9066",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63233,
    "description": "ETRF2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003233,
    "auth_name": "EPSG",
    "auth_id": "9067",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63234,
    "description": "ETRF2005",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003234,
    "auth_name": "EPSG",
    "auth_id": "9068",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63235,
    "description": "ETRF2014",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003235,
    "auth_name": "EPSG",
    "auth_id": "9069",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63236,
    "description": "NAD83(MARP00)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003236,
    "auth_name": "EPSG",
    "auth_id": "9070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63237,
    "description": "NAD83(MARP00)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003237,
    "auth_name": "EPSG",
    "auth_id": "9071",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63238,
    "description": "NAD83(MARP00)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003238,
    "auth_name": "EPSG",
    "auth_id": "9072",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63239,
    "description": "NAD83(PACP00)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003239,
    "auth_name": "EPSG",
    "auth_id": "9073",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63240,
    "description": "NAD83(PACP00)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003240,
    "auth_name": "EPSG",
    "auth_id": "9074",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63241,
    "description": "NAD83(PACP00)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003241,
    "auth_name": "EPSG",
    "auth_id": "9075",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63242,
    "description": "KOSOVAREF01",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003242,
    "auth_name": "EPSG",
    "auth_id": "9138",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63243,
    "description": "KOSOVAREF01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520003243,
    "auth_name": "EPSG",
    "auth_id": "9139",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63244,
    "description": "KOSOVAREF01",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520003244,
    "auth_name": "EPSG",
    "auth_id": "9140",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63245,
    "description": "KOSOVAREF01 / Balkans zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=7500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003245,
    "auth_name": "EPSG",
    "auth_id": "9141",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63246,
    "description": "SIRGAS-Chile 2013",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003246,
    "auth_name": "EPSG",
    "auth_id": "9146",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63247,
    "description": "SIRGAS-Chile 2013",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003247,
    "auth_name": "EPSG",
    "auth_id": "9147",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63248,
    "description": "SIRGAS-Chile 2013",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003248,
    "auth_name": "EPSG",
    "auth_id": "9148",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63249,
    "description": "SIRGAS-Chile 2013 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003249,
    "auth_name": "EPSG",
    "auth_id": "9149",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63250,
    "description": "SIRGAS-Chile 2013 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003250,
    "auth_name": "EPSG",
    "auth_id": "9150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63251,
    "description": "SIRGAS-Chile 2016",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003251,
    "auth_name": "EPSG",
    "auth_id": "9151",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63252,
    "description": "SIRGAS-Chile 2016",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003252,
    "auth_name": "EPSG",
    "auth_id": "9152",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63253,
    "description": "SIRGAS-Chile 2016",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003253,
    "auth_name": "EPSG",
    "auth_id": "9153",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63254,
    "description": "SIRGAS-Chile 2016 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003254,
    "auth_name": "EPSG",
    "auth_id": "9154",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63255,
    "description": "SIRGAS-Chile 2016 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003255,
    "auth_name": "EPSG",
    "auth_id": "9155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63256,
    "description": "RSAO13 / UTM zone 32S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=32 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003256,
    "auth_name": "EPSG",
    "auth_id": "9156",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63257,
    "description": "RSAO13 / UTM zone 33S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=33 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003257,
    "auth_name": "EPSG",
    "auth_id": "9157",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63258,
    "description": "RSAO13 / UTM zone 34S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=34 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003258,
    "auth_name": "EPSG",
    "auth_id": "9158",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63259,
    "description": "RSAO13 / TM 12 SE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003259,
    "auth_name": "EPSG",
    "auth_id": "9159",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63263,
    "description": "WGS 84 / NIWA Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aea +lat_0=-40 +lon_0=175 +lat_1=-30 +lat_2=-50 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003263,
    "auth_name": "EPSG",
    "auth_id": "9191",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63264,
    "description": "VN-2000 / TM-3 103-00",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=103 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003264,
    "auth_name": "EPSG",
    "auth_id": "9205",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63265,
    "description": "VN-2000 / TM-3 104-00",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=104 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003265,
    "auth_name": "EPSG",
    "auth_id": "9206",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63266,
    "description": "VN-2000 / TM-3 104-30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=104.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003266,
    "auth_name": "EPSG",
    "auth_id": "9207",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63267,
    "description": "VN-2000 / TM-3 104-45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=104.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003267,
    "auth_name": "EPSG",
    "auth_id": "9208",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63268,
    "description": "VN-2000 / TM-3 105-30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003268,
    "auth_name": "EPSG",
    "auth_id": "9209",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63269,
    "description": "VN-2000 / TM-3 105-45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003269,
    "auth_name": "EPSG",
    "auth_id": "9210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63270,
    "description": "VN-2000 / TM-3 106-00",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=106 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003270,
    "auth_name": "EPSG",
    "auth_id": "9211",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63271,
    "description": "VN-2000 / TM-3 106-15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=106.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003271,
    "auth_name": "EPSG",
    "auth_id": "9212",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63272,
    "description": "VN-2000 / TM-3 106-30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=106.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003272,
    "auth_name": "EPSG",
    "auth_id": "9213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63273,
    "description": "VN-2000 / TM-3 107-00",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=107 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003273,
    "auth_name": "EPSG",
    "auth_id": "9214",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63274,
    "description": "VN-2000 / TM-3 107-15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=107.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003274,
    "auth_name": "EPSG",
    "auth_id": "9215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63275,
    "description": "VN-2000 / TM-3 107-30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=107.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003275,
    "auth_name": "EPSG",
    "auth_id": "9216",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63276,
    "description": "VN-2000 / TM-3 108-15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108.25 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003276,
    "auth_name": "EPSG",
    "auth_id": "9217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63277,
    "description": "VN-2000 / TM-3 108-30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108.5 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs",
    "srid": 520003277,
    "auth_name": "EPSG",
    "auth_id": "9218",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63278,
    "description": "Hartebeesthoek94 / ZAF BSU Albers 25E",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aea +lat_0=-30 +lon_0=25 +lat_1=-22 +lat_2=-38 +x_0=1400000 +y_0=1300000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003278,
    "auth_name": "EPSG",
    "auth_id": "9221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63279,
    "description": "Hartebeesthoek94 / ZAF BSU Albers 44E",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "WGS84",
    "parameters": "+proj=aea +lat_0=-42 +lon_0=44 +lat_1=-34 +lat_2=-50 +x_0=1200000 +y_0=1300000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003279,
    "auth_name": "EPSG",
    "auth_id": "9222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63280,
    "description": "Tapi Aike",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-192.26,65.72,132.08,0,0,0,0 +no_defs",
    "srid": 520003280,
    "auth_name": "EPSG",
    "auth_id": "9248",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63281,
    "description": "Tapi Aike / Argentina 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +towgs84=-192.26,65.72,132.08,0,0,0,0 +units=m +no_defs",
    "srid": 520003281,
    "auth_name": "EPSG",
    "auth_id": "9249",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63282,
    "description": "Tapi Aike / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=-192.26,65.72,132.08,0,0,0,0 +units=m +no_defs",
    "srid": 520003282,
    "auth_name": "EPSG",
    "auth_id": "9250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63283,
    "description": "MMN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-9.5,122.9,138.2,0,0,0,0 +no_defs",
    "srid": 520003283,
    "auth_name": "EPSG",
    "auth_id": "9251",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63284,
    "description": "MMN / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=-9.5,122.9,138.2,0,0,0,0 +units=m +no_defs",
    "srid": 520003284,
    "auth_name": "EPSG",
    "auth_id": "9252",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63285,
    "description": "MMS",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-78.1,101.6,133.3,0,0,0,0 +no_defs",
    "srid": 520003285,
    "auth_name": "EPSG",
    "auth_id": "9253",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63286,
    "description": "MMS / Argentina 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-69 +k=1 +x_0=2500000 +y_0=0 +ellps=intl +towgs84=-78.1,101.6,133.3,0,0,0,0 +units=m +no_defs",
    "srid": 520003286,
    "auth_name": "EPSG",
    "auth_id": "9254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63287,
    "description": "POSGAR 2007 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=utm +zone=19 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003287,
    "auth_name": "EPSG",
    "auth_id": "9265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63288,
    "description": "MGI",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=geocent +ellps=bessel +units=m +no_defs",
    "srid": 520003288,
    "auth_name": "EPSG",
    "auth_id": "9266",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63289,
    "description": "MGI",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +no_defs",
    "srid": 520003289,
    "auth_name": "EPSG",
    "auth_id": "9267",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63290,
    "description": "MGI / Austria West",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=10.3333333333333 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 520003290,
    "auth_name": "EPSG",
    "auth_id": "9271",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63291,
    "description": "MGI / Austria Central",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=13.3333333333333 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 520003291,
    "auth_name": "EPSG",
    "auth_id": "9272",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63292,
    "description": "MGI / Austria East",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "bessel",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=16.3333333333333 +k=1 +x_0=0 +y_0=0 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs",
    "srid": 520003292,
    "auth_name": "EPSG",
    "auth_id": "9273",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63293,
    "description": "Pampa del Castillo / Argentina 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-72 +k=1 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 520003293,
    "auth_name": "EPSG",
    "auth_id": "9284",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63294,
    "description": "Pampa del Castillo / Argentina 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "intl",
    "parameters": "+proj=tmerc +lat_0=-90 +lon_0=-66 +k=1 +x_0=3500000 +y_0=0 +ellps=intl +units=m +no_defs",
    "srid": 520003294,
    "auth_name": "EPSG",
    "auth_id": "9285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63295,
    "description": "KSA-GRF17",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003295,
    "auth_name": "EPSG",
    "auth_id": "9331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63296,
    "description": "KSA-GRF17",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,-0.008393,0.000749,-0.010276,0 +no_defs",
    "srid": 520003296,
    "auth_name": "EPSG",
    "auth_id": "9332",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63297,
    "description": "KSA-GRF17",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,-0.008393,0.000749,-0.010276,0 +no_defs",
    "srid": 520003297,
    "auth_name": "EPSG",
    "auth_id": "9333",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63298,
    "description": "NAD_1983_HARN_Navajo_Nation_Coordinate_System_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=m +no_defs",
    "srid": 520003298,
    "auth_name": "ESRI",
    "auth_id": "103586",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63299,
    "description": "NAD_1983_HARN_Navajo_Nation_Coordinate_System_US_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=us-ft +no_defs",
    "srid": 520003299,
    "auth_name": "ESRI",
    "auth_id": "103587",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63300,
    "description": "NAD_1983_HARN_Navajo_Nation_Coordinate_System_Intl_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=599999.999999999 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520003300,
    "auth_name": "ESRI",
    "auth_id": "103588",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63301,
    "description": "NAD_1983_NSRS2007_Navajo_Nation_Coordinate_System_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003301,
    "auth_name": "ESRI",
    "auth_id": "103589",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63302,
    "description": "NAD_1983_NSRS2007_Navajo_Nation_Coordinate_System_US_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520003302,
    "auth_name": "ESRI",
    "auth_id": "103590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63303,
    "description": "NAD_1983_NSRS2007_Navajo_Nation_Coordinate_System_Intl_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=599999.999999999 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 520003303,
    "auth_name": "ESRI",
    "auth_id": "103591",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63304,
    "description": "NAD_1983_(2011)_Navajo_Nation_Coordinate_System_Meters",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003304,
    "auth_name": "ESRI",
    "auth_id": "103592",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63305,
    "description": "NAD_1983_(2011)_Navajo_Nation_Coordinate_System_US_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520003305,
    "auth_name": "ESRI",
    "auth_id": "103593",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63306,
    "description": "NAD_1983_(2011)_Navajo_Nation_Coordinate_System_Intl_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=-109.5 +k_0=1.00023 +x_0=300000 +y_0=599999.999999999 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 520003306,
    "auth_name": "ESRI",
    "auth_id": "103594",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63314,
    "description": "WGS_1984_Adams_Square_II",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=adams_ws2 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003314,
    "auth_name": "ESRI",
    "auth_id": "54098",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63315,
    "description": "WGS_1984_Spilhaus_Ocean_Map_in_Square",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520003315,
    "auth_name": "ESRI",
    "auth_id": "54099",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63316,
    "description": "WGS_1984_Tobler_Cylindrical_I",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520003316,
    "auth_name": "ESRI",
    "auth_id": "54100",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63317,
    "description": "WGS_1984_Tobler_Cylindrical_II",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520003317,
    "auth_name": "ESRI",
    "auth_id": "54101",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63318,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 CARTESIENNES GEOCENTRIQUES",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003318,
    "auth_name": "IGNF",
    "auth_id": "RGWF96",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63319,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DD)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003319,
    "auth_name": "IGNF",
    "auth_id": "RGWF96GDD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63320,
    "description": "RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DD)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "GRS80",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003320,
    "auth_name": "IGNF",
    "auth_id": "RGWF96GEODD",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63322,
    "description": "GSK-2011 / Gauss-Kruger zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=5500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003322,
    "auth_name": "EPSG",
    "auth_id": "20905",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63323,
    "description": "GSK-2011 / Gauss-Kruger zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=6500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003323,
    "auth_name": "EPSG",
    "auth_id": "20906",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63324,
    "description": "GSK-2011 / Gauss-Kruger zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=7500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003324,
    "auth_name": "EPSG",
    "auth_id": "20907",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63325,
    "description": "GSK-2011 / Gauss-Kruger zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=8500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003325,
    "auth_name": "EPSG",
    "auth_id": "20908",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63326,
    "description": "GSK-2011 / Gauss-Kruger zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=9500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003326,
    "auth_name": "EPSG",
    "auth_id": "20909",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63327,
    "description": "GSK-2011 / Gauss-Kruger zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=10500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003327,
    "auth_name": "EPSG",
    "auth_id": "20910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63328,
    "description": "GSK-2011 / Gauss-Kruger zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=11500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003328,
    "auth_name": "EPSG",
    "auth_id": "20911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63329,
    "description": "GSK-2011 / Gauss-Kruger zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=12500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003329,
    "auth_name": "EPSG",
    "auth_id": "20912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63330,
    "description": "GSK-2011 / Gauss-Kruger zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=13500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003330,
    "auth_name": "EPSG",
    "auth_id": "20913",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63331,
    "description": "GSK-2011 / Gauss-Kruger zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=14500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003331,
    "auth_name": "EPSG",
    "auth_id": "20914",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63332,
    "description": "GSK-2011 / Gauss-Kruger zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=15500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003332,
    "auth_name": "EPSG",
    "auth_id": "20915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63333,
    "description": "GSK-2011 / Gauss-Kruger zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=16500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003333,
    "auth_name": "EPSG",
    "auth_id": "20916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63334,
    "description": "GSK-2011 / Gauss-Kruger zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=17500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003334,
    "auth_name": "EPSG",
    "auth_id": "20917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63335,
    "description": "GSK-2011 / Gauss-Kruger zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=18500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003335,
    "auth_name": "EPSG",
    "auth_id": "20918",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63336,
    "description": "GSK-2011 / Gauss-Kruger zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=19500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003336,
    "auth_name": "EPSG",
    "auth_id": "20919",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63337,
    "description": "GSK-2011 / Gauss-Kruger zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=20500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003337,
    "auth_name": "EPSG",
    "auth_id": "20920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63338,
    "description": "GSK-2011 / Gauss-Kruger zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=21500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003338,
    "auth_name": "EPSG",
    "auth_id": "20921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63339,
    "description": "GSK-2011 / Gauss-Kruger zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=22500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003339,
    "auth_name": "EPSG",
    "auth_id": "20922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63340,
    "description": "GSK-2011 / Gauss-Kruger zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=23500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003340,
    "auth_name": "EPSG",
    "auth_id": "20923",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63341,
    "description": "GSK-2011 / Gauss-Kruger zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=24500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003341,
    "auth_name": "EPSG",
    "auth_id": "20924",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63342,
    "description": "GSK-2011 / Gauss-Kruger zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=25500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003342,
    "auth_name": "EPSG",
    "auth_id": "20925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63343,
    "description": "GSK-2011 / Gauss-Kruger zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=26500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003343,
    "auth_name": "EPSG",
    "auth_id": "20926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63344,
    "description": "GSK-2011 / Gauss-Kruger zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=27500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003344,
    "auth_name": "EPSG",
    "auth_id": "20927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63345,
    "description": "GSK-2011 / Gauss-Kruger zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=28500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003345,
    "auth_name": "EPSG",
    "auth_id": "20928",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63346,
    "description": "GSK-2011 / Gauss-Kruger zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=29500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003346,
    "auth_name": "EPSG",
    "auth_id": "20929",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63347,
    "description": "GSK-2011 / Gauss-Kruger zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=30500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003347,
    "auth_name": "EPSG",
    "auth_id": "20930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63348,
    "description": "GSK-2011 / Gauss-Kruger zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=31500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003348,
    "auth_name": "EPSG",
    "auth_id": "20931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63349,
    "description": "GSK-2011 / Gauss-Kruger zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=32500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003349,
    "auth_name": "EPSG",
    "auth_id": "20932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63350,
    "description": "GSK-2011 / Gauss-Kruger CM 21E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003350,
    "auth_name": "EPSG",
    "auth_id": "21004",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63351,
    "description": "GSK-2011 / Gauss-Kruger CM 27E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003351,
    "auth_name": "EPSG",
    "auth_id": "21005",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63352,
    "description": "GSK-2011 / Gauss-Kruger CM 33E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003352,
    "auth_name": "EPSG",
    "auth_id": "21006",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63353,
    "description": "GSK-2011 / Gauss-Kruger CM 39E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003353,
    "auth_name": "EPSG",
    "auth_id": "21007",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63354,
    "description": "GSK-2011 / Gauss-Kruger CM 45E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003354,
    "auth_name": "EPSG",
    "auth_id": "21008",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63355,
    "description": "GSK-2011 / Gauss-Kruger CM 51E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003355,
    "auth_name": "EPSG",
    "auth_id": "21009",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63356,
    "description": "GSK-2011 / Gauss-Kruger CM 57E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003356,
    "auth_name": "EPSG",
    "auth_id": "21010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63357,
    "description": "GSK-2011 / Gauss-Kruger CM 63E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003357,
    "auth_name": "EPSG",
    "auth_id": "21011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63358,
    "description": "GSK-2011 / Gauss-Kruger CM 69E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003358,
    "auth_name": "EPSG",
    "auth_id": "21012",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63359,
    "description": "GSK-2011 / Gauss-Kruger CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003359,
    "auth_name": "EPSG",
    "auth_id": "21013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63360,
    "description": "GSK-2011 / Gauss-Kruger CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003360,
    "auth_name": "EPSG",
    "auth_id": "21014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63361,
    "description": "GSK-2011 / Gauss-Kruger CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003361,
    "auth_name": "EPSG",
    "auth_id": "21015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63362,
    "description": "GSK-2011 / Gauss-Kruger CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003362,
    "auth_name": "EPSG",
    "auth_id": "21016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63363,
    "description": "GSK-2011 / Gauss-Kruger CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003363,
    "auth_name": "EPSG",
    "auth_id": "21017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63364,
    "description": "GSK-2011 / Gauss-Kruger CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003364,
    "auth_name": "EPSG",
    "auth_id": "21018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63365,
    "description": "GSK-2011 / Gauss-Kruger CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003365,
    "auth_name": "EPSG",
    "auth_id": "21019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63366,
    "description": "GSK-2011 / Gauss-Kruger CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003366,
    "auth_name": "EPSG",
    "auth_id": "21020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63367,
    "description": "GSK-2011 / Gauss-Kruger CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003367,
    "auth_name": "EPSG",
    "auth_id": "21021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63368,
    "description": "GSK-2011 / Gauss-Kruger CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003368,
    "auth_name": "EPSG",
    "auth_id": "21022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63369,
    "description": "GSK-2011 / Gauss-Kruger CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003369,
    "auth_name": "EPSG",
    "auth_id": "21023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63370,
    "description": "GSK-2011 / Gauss-Kruger CM 141E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003370,
    "auth_name": "EPSG",
    "auth_id": "21024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63371,
    "description": "GSK-2011 / Gauss-Kruger CM 147E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003371,
    "auth_name": "EPSG",
    "auth_id": "21025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63372,
    "description": "GSK-2011 / Gauss-Kruger CM 153E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003372,
    "auth_name": "EPSG",
    "auth_id": "21026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63373,
    "description": "GSK-2011 / Gauss-Kruger CM 159E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003373,
    "auth_name": "EPSG",
    "auth_id": "21027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63374,
    "description": "GSK-2011 / Gauss-Kruger CM 165E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003374,
    "auth_name": "EPSG",
    "auth_id": "21028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63375,
    "description": "GSK-2011 / Gauss-Kruger CM 171E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003375,
    "auth_name": "EPSG",
    "auth_id": "21029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63376,
    "description": "GSK-2011 / Gauss-Kruger CM 177E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003376,
    "auth_name": "EPSG",
    "auth_id": "21030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63377,
    "description": "GSK-2011 / Gauss-Kruger CM 177W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003377,
    "auth_name": "EPSG",
    "auth_id": "21031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63378,
    "description": "GSK-2011 / Gauss-Kruger CM 171W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003378,
    "auth_name": "EPSG",
    "auth_id": "21032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63379,
    "description": "Timbalai 1948 / RSO Sarawak LSD (m)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "omerc",
    "parameters": "+proj=omerc +no_uoff +lat_0=4 +lonc=115 +alpha=53.3158204722222 +gamma=53.1301023611111 +k=0.99984 +x_0=2000000 +y_0=5000000 +ellps=evrstSS +towgs84=-679,669,-48,0,0,0,0 +units=m +no_defs",
    "srid": 520003379,
    "auth_name": "EPSG",
    "auth_id": "29874",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63380,
    "description": "ETRS89 + NAP height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003380,
    "auth_name": "EPSG",
    "auth_id": "9286",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63381,
    "description": "ETRS89 + LAT NL depth",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003381,
    "auth_name": "EPSG",
    "auth_id": "9289",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63382,
    "description": "ETRS89 + MSL NL depth",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003382,
    "auth_name": "EPSG",
    "auth_id": "9290",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63383,
    "description": "ONGD17",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +towgs84=1.16835,-1.42001,-2.24431,-0.00822,-0.05508,0.01818,0.23388 +units=m +no_defs",
    "srid": 520003383,
    "auth_name": "EPSG",
    "auth_id": "9292",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63384,
    "description": "ONGD17",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003384,
    "auth_name": "EPSG",
    "auth_id": "9293",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63385,
    "description": "ONGD17",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003385,
    "auth_name": "EPSG",
    "auth_id": "9294",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63386,
    "description": "ONGD17 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=39 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003386,
    "auth_name": "EPSG",
    "auth_id": "9295",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63387,
    "description": "ONGD17 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=40 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003387,
    "auth_name": "EPSG",
    "auth_id": "9296",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63388,
    "description": "ONGD17 / UTM zone 41N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=41 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003388,
    "auth_name": "EPSG",
    "auth_id": "9297",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63389,
    "description": "HS2-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003389,
    "auth_name": "EPSG",
    "auth_id": "9299",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63390,
    "description": "HS2 Survey Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.3 +lon_0=-1.5 +k=1 +x_0=198873.0046 +y_0=375064.3871 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003390,
    "auth_name": "EPSG",
    "auth_id": "9300",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63391,
    "description": "HS2 Survey Grid + HS2-VRF height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.3 +lon_0=-1.5 +k=1 +x_0=198873.0046 +y_0=375064.3871 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 520003391,
    "auth_name": "EPSG",
    "auth_id": "9306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63392,
    "description": "ATRF2014",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003392,
    "auth_name": "EPSG",
    "auth_id": "9307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63393,
    "description": "ATRF2014",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003393,
    "auth_name": "EPSG",
    "auth_id": "9308",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63394,
    "description": "ATRF2014",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003394,
    "auth_name": "EPSG",
    "auth_id": "9309",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63395,
    "description": "NAD27 / US National Atlas Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +R_A +lat_0=45 +lon_0=-100 +x_0=0 +y_0=0 +datum=NAD27 +units=m +no_defs",
    "srid": 520003395,
    "auth_name": "EPSG",
    "auth_id": "9311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63396,
    "description": "WGS 84 / IBCSO Polar Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lat_ts=-65 +lon_0=0 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003396,
    "auth_name": "EPSG",
    "auth_id": "9354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63397,
    "description": "KSA-GRF17 / UTM zone 36N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=36 +ellps=GRS80 +towgs84=0,0,0,-0.008393,0.000749,-0.010276,0 +units=m +no_defs",
    "srid": 520003397,
    "auth_name": "EPSG",
    "auth_id": "9356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63398,
    "description": "KSA-GRF17 / UTM zone 37N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=37 +ellps=GRS80 +towgs84=0,0,0,-0.008393,0.000749,-0.010276,0 +units=m +no_defs",
    "srid": 520003398,
    "auth_name": "EPSG",
    "auth_id": "9357",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63399,
    "description": "KSA-GRF17 / UTM zone 38N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=38 +ellps=GRS80 +towgs84=0,0,0,-0.008393,0.000749,-0.010276,0 +units=m +no_defs",
    "srid": 520003399,
    "auth_name": "EPSG",
    "auth_id": "9358",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63400,
    "description": "KSA-GRF17 / UTM zone 39N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=39 +ellps=GRS80 +towgs84=0,0,0,-0.008393,0.000749,-0.010276,0 +units=m +no_defs",
    "srid": 520003400,
    "auth_name": "EPSG",
    "auth_id": "9359",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63401,
    "description": "KSA-GRF17 / UTM zone 40N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=40 +ellps=GRS80 +towgs84=0,0,0,-0.008393,0.000749,-0.010276,0 +units=m +no_defs",
    "srid": 520003401,
    "auth_name": "EPSG",
    "auth_id": "9360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63402,
    "description": "TPEN11-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003402,
    "auth_name": "EPSG",
    "auth_id": "9364",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63403,
    "description": "TPEN11 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=53.5 +lon_0=-2.25 +k=1 +x_0=203252.175 +y_0=407512.765 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003403,
    "auth_name": "EPSG",
    "auth_id": "9367",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63404,
    "description": "TPEN11 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=53.5 +lon_0=-2.25 +k=1 +x_0=203252.175 +y_0=407512.765 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003404,
    "auth_name": "EPSG",
    "auth_id": "9368",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63405,
    "description": "MML07-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003405,
    "auth_name": "EPSG",
    "auth_id": "9372",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63406,
    "description": "MML07 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.45 +lon_0=-0.85 +k=1 +x_0=49350.157 +y_0=108398.212 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003406,
    "auth_name": "EPSG",
    "auth_id": "9373",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63407,
    "description": "MML07 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.45 +lon_0=-0.85 +k=1 +x_0=49350.157 +y_0=108398.212 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003407,
    "auth_name": "EPSG",
    "auth_id": "9374",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63408,
    "description": "MAGNA-SIRGAS 2018 / Origen-Nacional",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=4 +lon_0=-73 +k=0.9992 +x_0=5000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003408,
    "auth_name": "EPSG",
    "auth_id": "9377",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63409,
    "description": "IGb14",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003409,
    "auth_name": "EPSG",
    "auth_id": "9378",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63410,
    "description": "IGb14",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003410,
    "auth_name": "EPSG",
    "auth_id": "9379",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63411,
    "description": "IGb14",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003411,
    "auth_name": "EPSG",
    "auth_id": "9380",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63412,
    "description": "AbInvA96_2020-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003412,
    "auth_name": "EPSG",
    "auth_id": "9384",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63413,
    "description": "AbInvA96_2020 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=57.4 +lon_0=-3.2 +k=1 +x_0=155828.702 +y_0=115225.707 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003413,
    "auth_name": "EPSG",
    "auth_id": "9387",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63414,
    "description": "AbInvA96_2020 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=57.4 +lon_0=-3.2 +k=1 +x_0=155828.702 +y_0=115225.707 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003414,
    "auth_name": "EPSG",
    "auth_id": "9388",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63415,
    "description": "BGS2005 / UTM zone 35N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003415,
    "auth_name": "EPSG",
    "auth_id": "9391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63416,
    "description": "PN68",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-307,-92,127,0,0,0,0 +no_defs",
    "srid": 520003416,
    "auth_name": "EPSG",
    "auth_id": "9403",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63417,
    "description": "PN68 / UTM zone 27N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=27 +ellps=intl +towgs84=-307,-92,127,0,0,0,0 +units=m +no_defs",
    "srid": 520003417,
    "auth_name": "EPSG",
    "auth_id": "9404",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63418,
    "description": "PN68 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=28 +ellps=intl +towgs84=-307,-92,127,0,0,0,0 +units=m +no_defs",
    "srid": 520003418,
    "auth_name": "EPSG",
    "auth_id": "9405",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63419,
    "description": "PN84 / UTM zone 27N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=27 +ellps=intl +towgs84=-307,-92,127,0,0,0,0 +units=m +no_defs",
    "srid": 520003419,
    "auth_name": "EPSG",
    "auth_id": "9406",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63420,
    "description": "PN84 / UTM zone 28N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=28 +ellps=intl +towgs84=-307,-92,127,0,0,0,0 +units=m +no_defs",
    "srid": 520003420,
    "auth_name": "EPSG",
    "auth_id": "9407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63421,
    "description": "ETRS89 + EVRF2019 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003421,
    "auth_name": "EPSG",
    "auth_id": "9422",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63422,
    "description": "ETRS89 + EVRF2019 mean-tide height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003422,
    "auth_name": "EPSG",
    "auth_id": "9423",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63423,
    "description": "ETRS89 + ODN height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003423,
    "auth_name": "EPSG",
    "auth_id": "9424",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63424,
    "description": "ETRS89 + ODN (Offshore) height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003424,
    "auth_name": "EPSG",
    "auth_id": "9425",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63425,
    "description": "ETRS89 + ODN Orkney height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003425,
    "auth_name": "EPSG",
    "auth_id": "9426",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63426,
    "description": "ETRS89 + Lerwick height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003426,
    "auth_name": "EPSG",
    "auth_id": "9427",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63427,
    "description": "ETRS89 + Stornoway height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003427,
    "auth_name": "EPSG",
    "auth_id": "9428",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63428,
    "description": "ETRS89 + Douglas height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003428,
    "auth_name": "EPSG",
    "auth_id": "9429",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63429,
    "description": "ETRS89 + St. Marys height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003429,
    "auth_name": "EPSG",
    "auth_id": "9430",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63430,
    "description": "ETRS89 + Malin Head height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=uk_os_OSGM15_Malin.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003430,
    "auth_name": "EPSG",
    "auth_id": "9449",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63431,
    "description": "ETRS89 + Belfast height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=uk_os_OSGM15_Belfast.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003431,
    "auth_name": "EPSG",
    "auth_id": "9450",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63432,
    "description": "ETRS89 + BI height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003432,
    "auth_name": "EPSG",
    "auth_id": "9452",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63433,
    "description": "GBK19-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003433,
    "auth_name": "EPSG",
    "auth_id": "9453",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63434,
    "description": "GBK19 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=55.75 +lon_0=-4.35 +k=1 +x_0=93720.394 +y_0=113870.493 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003434,
    "auth_name": "EPSG",
    "auth_id": "9456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63435,
    "description": "GBK19 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=55.75 +lon_0=-4.35 +k=1 +x_0=93720.394 +y_0=113870.493 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003435,
    "auth_name": "EPSG",
    "auth_id": "9457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63436,
    "description": "GDA2020 + AVWS height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +geoidgrids=au_ga_AGQG_20201120.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003436,
    "auth_name": "EPSG",
    "auth_id": "9462",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63437,
    "description": "GDA2020 + AHD height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +geoidgrids=au_ga_AUSGeoid2020_20180201.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003437,
    "auth_name": "EPSG",
    "auth_id": "9463",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63438,
    "description": "GDA94 + AHD height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +geoidgrids=au_ga_AUSGeoid2020_20180201.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003438,
    "auth_name": "EPSG",
    "auth_id": "9464",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63439,
    "description": "SRGI2013",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 520003439,
    "auth_name": "EPSG",
    "auth_id": "9468",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63440,
    "description": "SRGI2013",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003440,
    "auth_name": "EPSG",
    "auth_id": "9469",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63441,
    "description": "SRGI2013",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520003441,
    "auth_name": "EPSG",
    "auth_id": "9470",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63442,
    "description": "GDA2020 / Australian Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=0 +lon_0=132 +lat_1=-18 +lat_2=-36 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003442,
    "auth_name": "EPSG",
    "auth_id": "9473",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63443,
    "description": "PZ-90.02",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs",
    "srid": 520003443,
    "auth_name": "EPSG",
    "auth_id": "9474",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63444,
    "description": "PZ-90.11",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=6378136 +rf=298.257839303 +no_defs",
    "srid": 520003444,
    "auth_name": "EPSG",
    "auth_id": "9475",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63445,
    "description": "SRGI2013 / UTM zone 46N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=46 +ellps=WGS84 +units=m +no_defs",
    "srid": 520003445,
    "auth_name": "EPSG",
    "auth_id": "9476",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63446,
    "description": "SRGI2013 / UTM zone 47N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=47 +ellps=WGS84 +units=m +no_defs",
    "srid": 520003446,
    "auth_name": "EPSG",
    "auth_id": "9477",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63447,
    "description": "SRGI2013 / UTM zone 48N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=48 +ellps=WGS84 +units=m +no_defs",
    "srid": 520003447,
    "auth_name": "EPSG",
    "auth_id": "9478",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63448,
    "description": "SRGI2013 / UTM zone 49N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=49 +ellps=WGS84 +units=m +no_defs",
    "srid": 520003448,
    "auth_name": "EPSG",
    "auth_id": "9479",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63449,
    "description": "SRGI2013 / UTM zone 50N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=50 +ellps=WGS84 +units=m +no_defs",
    "srid": 520003449,
    "auth_name": "EPSG",
    "auth_id": "9480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63450,
    "description": "SRGI2013 / UTM zone 51N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=51 +ellps=WGS84 +units=m +no_defs",
    "srid": 520003450,
    "auth_name": "EPSG",
    "auth_id": "9481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63451,
    "description": "SRGI2013 / UTM zone 52N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=52 +ellps=WGS84 +units=m +no_defs",
    "srid": 520003451,
    "auth_name": "EPSG",
    "auth_id": "9482",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63452,
    "description": "SRGI2013 / UTM zone 47S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=47 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003452,
    "auth_name": "EPSG",
    "auth_id": "9487",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63453,
    "description": "SRGI2013 / UTM zone 48S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=48 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003453,
    "auth_name": "EPSG",
    "auth_id": "9488",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63454,
    "description": "SRGI2013 / UTM zone 49S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=49 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003454,
    "auth_name": "EPSG",
    "auth_id": "9489",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63455,
    "description": "SRGI2013 / UTM zone 50S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=50 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003455,
    "auth_name": "EPSG",
    "auth_id": "9490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63456,
    "description": "SRGI2013 / UTM zone 51S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=51 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003456,
    "auth_name": "EPSG",
    "auth_id": "9491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63457,
    "description": "SRGI2013 / UTM zone 52S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=52 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003457,
    "auth_name": "EPSG",
    "auth_id": "9492",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63458,
    "description": "SRGI2013 / UTM zone 53S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=53 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003458,
    "auth_name": "EPSG",
    "auth_id": "9493",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63459,
    "description": "SRGI2013 / UTM zone 54S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=54 +south +ellps=WGS84 +units=m +no_defs",
    "srid": 520003459,
    "auth_name": "EPSG",
    "auth_id": "9494",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63460,
    "description": "POSGAR 2007 / CABA 2019",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=-34.6292666666667 +lon_0=-58.4633083333333 +k=1 +x_0=20000 +y_0=70000 +ellps=WGS84 +units=m +no_defs",
    "srid": 520003460,
    "auth_name": "EPSG",
    "auth_id": "9498",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63461,
    "description": "ETRS89 + EVRF2000 Austria height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003461,
    "auth_name": "EPSG",
    "auth_id": "9500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63462,
    "description": "MGI + EVRF2000 Austria height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +vunits=m +no_defs",
    "srid": 520003462,
    "auth_name": "EPSG",
    "auth_id": "9501",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63463,
    "description": "CIGD11 + CBVD61 height (ft)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=ft +no_defs",
    "srid": 520003463,
    "auth_name": "EPSG",
    "auth_id": "9502",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63464,
    "description": "CIGD11 + GCVD54 height (ft)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=ft +no_defs",
    "srid": 520003464,
    "auth_name": "EPSG",
    "auth_id": "9503",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63465,
    "description": "CIGD11 + LCVD61 height (ft)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=ft +no_defs",
    "srid": 520003465,
    "auth_name": "EPSG",
    "auth_id": "9504",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63466,
    "description": "ETRS89 + Alicante height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003466,
    "auth_name": "EPSG",
    "auth_id": "9505",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63467,
    "description": "ETRS89 + Ceuta 2 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003467,
    "auth_name": "EPSG",
    "auth_id": "9506",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63468,
    "description": "ETRS89 + Ibiza height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003468,
    "auth_name": "EPSG",
    "auth_id": "9507",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63469,
    "description": "ETRS89 + Mallorca height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003469,
    "auth_name": "EPSG",
    "auth_id": "9508",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63470,
    "description": "ETRS89 + Menorca height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003470,
    "auth_name": "EPSG",
    "auth_id": "9509",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63471,
    "description": "REGCAN95 + El Hierro height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap-canarias.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003471,
    "auth_name": "EPSG",
    "auth_id": "9510",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63472,
    "description": "REGCAN95 + Fuerteventura height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap-canarias.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003472,
    "auth_name": "EPSG",
    "auth_id": "9511",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63473,
    "description": "REGCAN95 + Gran Canaria height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap-canarias.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003473,
    "auth_name": "EPSG",
    "auth_id": "9512",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63474,
    "description": "REGCAN95 + La Gomera height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap-canarias.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003474,
    "auth_name": "EPSG",
    "auth_id": "9513",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63475,
    "description": "REGCAN95 + La Palma height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap-canarias.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003475,
    "auth_name": "EPSG",
    "auth_id": "9514",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63476,
    "description": "REGCAN95 + Lanzarote height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap-canarias.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003476,
    "auth_name": "EPSG",
    "auth_id": "9515",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63477,
    "description": "REGCAN95 + Tenerife height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap-canarias.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003477,
    "auth_name": "EPSG",
    "auth_id": "9516",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63478,
    "description": "SHGD2015 + SHVD2015 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=us_nga_egm08_25.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003478,
    "auth_name": "EPSG",
    "auth_id": "9517",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63479,
    "description": "WGS 84 + EGM2008 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +datum=WGS84 +geoidgrids=us_nga_egm08_25.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003479,
    "auth_name": "EPSG",
    "auth_id": "9518",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63480,
    "description": "FEH2010 + FCSVR10 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003480,
    "auth_name": "EPSG",
    "auth_id": "9519",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63481,
    "description": "KSA-GRF17 + KSA-VRF14 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,-0.008393,0.000749,-0.010276,0 +vunits=m +no_defs",
    "srid": 520003481,
    "auth_name": "EPSG",
    "auth_id": "9520",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63482,
    "description": "POSGAR 2007 + SRVN16 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=WGS84 +geoidgrids=ar_ign_GEOIDE-Ar16.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003482,
    "auth_name": "EPSG",
    "auth_id": "9521",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63483,
    "description": "NAD83(2011) + PRVD02 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003483,
    "auth_name": "EPSG",
    "auth_id": "9522",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63484,
    "description": "NAD83(2011) + VIVD09 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003484,
    "auth_name": "EPSG",
    "auth_id": "9523",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63485,
    "description": "NAD83(MA11) + GUVD04 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520003485,
    "auth_name": "EPSG",
    "auth_id": "9524",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63486,
    "description": "NAD83(MA11) + NMVD03 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520003486,
    "auth_name": "EPSG",
    "auth_id": "9525",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63487,
    "description": "NAD83(PA11) + ASVD02 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520003487,
    "auth_name": "EPSG",
    "auth_id": "9526",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63488,
    "description": "NZGD2000 + NZVD2009 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=nz_linz_nzgeoid2009.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003488,
    "auth_name": "EPSG",
    "auth_id": "9527",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63489,
    "description": "NZGD2000 + NZVD2016 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=nz_linz_nzgeoid2016.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003489,
    "auth_name": "EPSG",
    "auth_id": "9528",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63490,
    "description": "SRGI2013 + INAGeoid2020 v1 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs",
    "srid": 520003490,
    "auth_name": "EPSG",
    "auth_id": "9529",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63491,
    "description": "RGFG95 + NGG1977 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_ggguy15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003491,
    "auth_name": "EPSG",
    "auth_id": "9530",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63492,
    "description": "RGAF09 + Guadeloupe 1988 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003492,
    "auth_name": "EPSG",
    "auth_id": "9531",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63493,
    "description": "RGAF09 + IGN 1988 LS height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003493,
    "auth_name": "EPSG",
    "auth_id": "9532",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63494,
    "description": "RGAF09 + IGN 1988 MG height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003494,
    "auth_name": "EPSG",
    "auth_id": "9533",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63495,
    "description": "RGAF09 + IGN 1988 SB height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003495,
    "auth_name": "EPSG",
    "auth_id": "9534",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63496,
    "description": "RGAF09 + IGN 1988 SM height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003496,
    "auth_name": "EPSG",
    "auth_id": "9535",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63497,
    "description": "RGAF09 + IGN 2008 LD height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003497,
    "auth_name": "EPSG",
    "auth_id": "9536",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63498,
    "description": "RGAF09 + Martinique 1987 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003498,
    "auth_name": "EPSG",
    "auth_id": "9537",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63499,
    "description": "RGF93 v2 + NGF-IGN69 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003499,
    "auth_name": "EPSG",
    "auth_id": "9538",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63500,
    "description": "RGF93 v2 + NGF-IGN78 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003500,
    "auth_name": "EPSG",
    "auth_id": "9539",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63501,
    "description": "RGNC91-93 + NGNC08 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003501,
    "auth_name": "EPSG",
    "auth_id": "9540",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63502,
    "description": "RGSPM06 + Danger 1950 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=fr_ign_RASPM2018.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003502,
    "auth_name": "EPSG",
    "auth_id": "9541",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63503,
    "description": "RRAF 1991 + IGN 2008 LD height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003503,
    "auth_name": "EPSG",
    "auth_id": "9542",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63504,
    "description": "ITRF2005 + SA LLD height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +geoidgrids=za_cdngi_sageoid2010.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003504,
    "auth_name": "EPSG",
    "auth_id": "9543",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63505,
    "description": "NAD83(CSRS)v6 + CGVD2013a(2010) height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520003505,
    "auth_name": "EPSG",
    "auth_id": "9544",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63506,
    "description": "LTF2004(G)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003506,
    "auth_name": "EPSG",
    "auth_id": "9545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63507,
    "description": "LTF2004(G)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003507,
    "auth_name": "EPSG",
    "auth_id": "9546",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63508,
    "description": "LTF2004(G)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003508,
    "auth_name": "EPSG",
    "auth_id": "9547",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63509,
    "description": "ETRF2000-PL + Baltic 1986 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=pl_gugik_geoid2011-PL-KRON86-NH.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003509,
    "auth_name": "EPSG",
    "auth_id": "9656",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63510,
    "description": "ETRF2000-PL + EVRF2007-PL height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=pl_gugik_geoid2021-PL-EVRF2007-NH.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003510,
    "auth_name": "EPSG",
    "auth_id": "9657",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63511,
    "description": "NAD83 / USFS R6 Albers",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=34 +lon_0=-120 +lat_1=43 +lat_2=48 +x_0=600000 +y_0=0 +datum=NAD83 +units=m +no_defs",
    "srid": 520003511,
    "auth_name": "EPSG",
    "auth_id": "9674",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63512,
    "description": "Gulshan 303 / Bangladesh Transverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=-2000000 +ellps=evrst30 +towgs84=283.729,735.942,261.143,0,0,0,0 +units=m +no_defs",
    "srid": 520003512,
    "auth_name": "EPSG",
    "auth_id": "9678",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63513,
    "description": "WGS 84 / TM 90 NE",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003513,
    "auth_name": "EPSG",
    "auth_id": "9680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63514,
    "description": "REDGEOMIN",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003514,
    "auth_name": "EPSG",
    "auth_id": "9694",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63515,
    "description": "REDGEOMIN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003515,
    "auth_name": "EPSG",
    "auth_id": "9695",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63516,
    "description": "REDGEOMIN",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003516,
    "auth_name": "EPSG",
    "auth_id": "9696",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63517,
    "description": "REDGEOMIN / UTM zone 12S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=12 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003517,
    "auth_name": "EPSG",
    "auth_id": "9697",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63518,
    "description": "REDGEOMIN / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003518,
    "auth_name": "EPSG",
    "auth_id": "9698",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63519,
    "description": "REDGEOMIN / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003519,
    "auth_name": "EPSG",
    "auth_id": "9699",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63520,
    "description": "ETRF2000-PL",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003520,
    "auth_name": "EPSG",
    "auth_id": "9700",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63521,
    "description": "ETRF2000-PL",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520003521,
    "auth_name": "EPSG",
    "auth_id": "9701",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63522,
    "description": "ETRF2000-PL",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520003522,
    "auth_name": "EPSG",
    "auth_id": "9702",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63523,
    "description": "WGS 84 + MSL height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +datum=WGS84 +vunits=m +no_defs",
    "srid": 520003523,
    "auth_name": "EPSG",
    "auth_id": "9705",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63524,
    "description": "WGS 84 + EGM96 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +datum=WGS84 +geoidgrids=us_nga_egm96_15.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003524,
    "auth_name": "EPSG",
    "auth_id": "9707",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63525,
    "description": "NAD83(CSRS) / UTM zone 23N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=23 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003525,
    "auth_name": "EPSG",
    "auth_id": "9709",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63526,
    "description": "NAD83(CSRS) / UTM zone 23N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=23 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 520003526,
    "auth_name": "EPSG",
    "auth_id": "9711",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63527,
    "description": "NAD83 / UTM zone 24N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=24 +datum=NAD83 +units=m +no_defs",
    "srid": 520003527,
    "auth_name": "EPSG",
    "auth_id": "9712",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63528,
    "description": "NAD83(CSRS) / UTM zone 24N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=24 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003528,
    "auth_name": "EPSG",
    "auth_id": "9713",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63529,
    "description": "NAD83(CSRS) / UTM zone 24N + CGVD2013 height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=24 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 520003529,
    "auth_name": "EPSG",
    "auth_id": "9714",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63530,
    "description": "NAD83(CSRS) / UTM zone 15N + CGVD2013a(2010) height",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +vunits=m +no_defs",
    "srid": 520003530,
    "auth_name": "EPSG",
    "auth_id": "9715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63531,
    "description": "IGM95 / UTM zone 34N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=34 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003531,
    "auth_name": "EPSG",
    "auth_id": "9716",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63532,
    "description": "ETRS89 + Genoa 1942 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003532,
    "auth_name": "EPSG",
    "auth_id": "9723",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63533,
    "description": "ETRS89 + Catania 1965 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003533,
    "auth_name": "EPSG",
    "auth_id": "9724",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63534,
    "description": "ETRS89 + Cagliari 1956 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520003534,
    "auth_name": "EPSG",
    "auth_id": "9725",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63535,
    "description": "EOS21-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003535,
    "auth_name": "EPSG",
    "auth_id": "9739",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63536,
    "description": "EOS21 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=56.35 +lon_0=-2.75 +k=1 +x_0=74996.927 +y_0=133508.35 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003536,
    "auth_name": "EPSG",
    "auth_id": "9741",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63537,
    "description": "EOS21 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=56.35 +lon_0=-2.75 +k=1 +x_0=74996.927 +y_0=133508.35 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003537,
    "auth_name": "EPSG",
    "auth_id": "9742",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63538,
    "description": "NAD83(2011) / Alabama East (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=30.5 +lon_0=-85.8333333333333 +k=0.99996 +x_0=200000.0001016 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520003538,
    "auth_name": "EPSG",
    "auth_id": "9748",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63539,
    "description": "NAD83(2011) / Alabama West (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520003539,
    "auth_name": "EPSG",
    "auth_id": "9749",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63540,
    "description": "GTM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90.5 +k=0.9998 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520003540,
    "auth_name": "ESRI",
    "auth_id": "103598",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63541,
    "description": "MAGNA-SIRGAS_CMT12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=4 +lon_0=-73 +k=0.9992 +x_0=5000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003541,
    "auth_name": "ESRI",
    "auth_id": "103599",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63542,
    "description": "Palestine_Grid_1923_Modified_TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=31.7343936111111 +lon_0=35.2045169444444 +k=1.0000067 +x_0=169529.584 +y_0=126907.39 +ellps=GRS80 +towgs84=-24.0024,-17.1032,-17.8444,0.33009,1.85269,-1.66969,5.4248 +units=m +no_defs",
    "srid": 520003542,
    "auth_name": "ESRI",
    "auth_id": "103699",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63543,
    "description": "GDM2008_LGM2012",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=-20.2755163 +lon_0=57.5645566222222 +lat_1=-20.0611111111111 +lat_2=-20.4444444444445 +x_0=250000 +y_0=350000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003543,
    "auth_name": "ESRI",
    "auth_id": "103872",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63544,
    "description": "GDM2008",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003544,
    "auth_name": "ESRI",
    "auth_id": "104028",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63545,
    "description": "North_American_1983_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +datum=NAD83 +no_defs",
    "srid": 520003545,
    "auth_name": "ESRI",
    "auth_id": "104602",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63546,
    "description": "EUREF_FIN_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520003546,
    "auth_name": "ESRI",
    "auth_id": "104613",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63547,
    "description": "California_SRS_Epoch_2017.50_(NAD83)_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003547,
    "auth_name": "ESRI",
    "auth_id": "104644",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63548,
    "description": "GGD_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003548,
    "auth_name": "ESRI",
    "auth_id": "104645",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63550,
    "description": "S-JTSK_[JTSK03]_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=485.021,169.465,483.839,7.786342,4.397554,4.102655,0 +no_defs",
    "srid": 520003550,
    "auth_name": "ESRI",
    "auth_id": "104648",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63551,
    "description": "MONREF_1997_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003551,
    "auth_name": "ESRI",
    "auth_id": "104653",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63552,
    "description": "Nepal_Nagarkot_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=evrst30 +no_defs",
    "srid": 520003552,
    "auth_name": "ESRI",
    "auth_id": "104664",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63553,
    "description": "SLD99_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=evrst30 +towgs84=-0.293,766.95,87.713,0.195704,1.695068,3.473016,-0.039338 +no_defs",
    "srid": 520003553,
    "auth_name": "ESRI",
    "auth_id": "104693",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63554,
    "description": "S_JTSK/05_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378 +no_defs",
    "srid": 520003554,
    "auth_name": "ESRI",
    "auth_id": "104696",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63555,
    "description": "S_JTSK/05_Ferro_3D",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=bessel +towgs84=572.213,85.334,461.94,4.9732,1.529,5.2484,3.5378 +no_defs",
    "srid": 520003555,
    "auth_name": "ESRI",
    "auth_id": "104697",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63556,
    "description": "NKG_ETRF00",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003556,
    "auth_name": "NKG",
    "auth_id": "ETRF00",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63557,
    "description": "NKG_ETRF14",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003557,
    "auth_name": "NKG",
    "auth_id": "ETRF14",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63558,
    "description": "NAD27 (CRS27)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +datum=NAD27 +no_defs",
    "srid": 520003558,
    "auth_name": "OGC",
    "auth_id": "CRS27",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63559,
    "description": "NAD83 (CRS83)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +datum=NAD83 +no_defs",
    "srid": 520003559,
    "auth_name": "OGC",
    "auth_id": "CRS83",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63560,
    "description": "GSK-2011 / Gauss-Kruger zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=4500000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003560,
    "auth_name": "EPSG",
    "auth_id": "20904",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63562,
    "description": "ETRS89 + SVD2006 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=no_kv_arcgp-2006-sk.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003562,
    "auth_name": "EPSG",
    "auth_id": "20001",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63563,
    "description": "MWC18 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=53.35 +lon_0=-2.55 +k=1 +x_0=171975.9382 +y_0=116744.6938 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003563,
    "auth_name": "EPSG",
    "auth_id": "20002",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63564,
    "description": "MWC18 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=53.35 +lon_0=-2.55 +k=1 +x_0=171975.9382 +y_0=116744.6938 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003564,
    "auth_name": "EPSG",
    "auth_id": "20003",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63565,
    "description": "MWC18-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003565,
    "auth_name": "EPSG",
    "auth_id": "20033",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63569,
    "description": "NAD83(CSRS)v4 + CGVD2013a(2002) height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +geoidgrids=ca_nrc_CGG2013an83.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003569,
    "auth_name": "EPSG",
    "auth_id": "20037",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63570,
    "description": "NAD83(CSRS)v3 + CGVD2013a(1997) height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +geoidgrids=ca_nrc_CGG2013an83.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520003570,
    "auth_name": "EPSG",
    "auth_id": "20038",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63571,
    "description": "SIRGAS-Chile 2021",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520003571,
    "auth_name": "EPSG",
    "auth_id": "20039",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 63572,
    "description": "SIRGAS-Chile 2021",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003572,
    "auth_name": "EPSG",
    "auth_id": "20040",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 63573,
    "description": "SIRGAS-Chile 2021",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520003573,
    "auth_name": "EPSG",
    "auth_id": "20041",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 63574,
    "description": "SIRGAS-Chile 2021 / UTM zone 12S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=12 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003574,
    "auth_name": "EPSG",
    "auth_id": "20042",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63575,
    "description": "SRGI2013 + INAGeoid2020 v2 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=WGS84 +vunits=m +no_defs",
    "srid": 520003575,
    "auth_name": "EPSG",
    "auth_id": "20043",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 63576,
    "description": "GDA2020 / BCSG2020",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=-28 +lon_0=153 +k=0.99999 +x_0=150000 +y_0=200000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003576,
    "auth_name": "EPSG",
    "auth_id": "20047",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63577,
    "description": "SIRGAS-Chile 2021 / UTM zone 18S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=18 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003577,
    "auth_name": "EPSG",
    "auth_id": "20048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63578,
    "description": "SIRGAS-Chile 2021 / UTM zone 19S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=19 +south +ellps=GRS80 +units=m +no_defs",
    "srid": 520003578,
    "auth_name": "EPSG",
    "auth_id": "20049",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63579,
    "description": "NAD83(2011) / Amtrak NECCS21 (ft)",
    "projection_acronym": "omerc",
    "ellipsoid_acronym": "omerc",
    "parameters": "+proj=omerc +lat_0=40.8333333333333 +lonc=-74 +alpha=58 +gamma=58 +k=0.99999 +x_0=457200 +y_0=457200 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 520003579,
    "auth_name": "EPSG",
    "auth_id": "20050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63580,
    "description": "GSK-2011 / GSK 3GK zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=7250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003580,
    "auth_name": "EPSG",
    "auth_id": "21207",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63581,
    "description": "GSK-2011 / GSK 3GK zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=8250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003581,
    "auth_name": "EPSG",
    "auth_id": "21208",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63582,
    "description": "GSK-2011 / GSK 3GK zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=9250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003582,
    "auth_name": "EPSG",
    "auth_id": "21209",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63583,
    "description": "GSK-2011 / GSK 3GK zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=10250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003583,
    "auth_name": "EPSG",
    "auth_id": "21210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63584,
    "description": "GSK-2011 / GSK 3GK zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=11250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003584,
    "auth_name": "EPSG",
    "auth_id": "21211",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63585,
    "description": "GSK-2011 / GSK 3GK zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=12250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003585,
    "auth_name": "EPSG",
    "auth_id": "21212",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63586,
    "description": "GSK-2011 / GSK 3GK zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=13250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003586,
    "auth_name": "EPSG",
    "auth_id": "21213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63587,
    "description": "GSK-2011 / GSK 3GK zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=14250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003587,
    "auth_name": "EPSG",
    "auth_id": "21214",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63588,
    "description": "GSK-2011 / GSK 3GK zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=15250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003588,
    "auth_name": "EPSG",
    "auth_id": "21215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63589,
    "description": "GSK-2011 / GSK 3GK zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=16250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003589,
    "auth_name": "EPSG",
    "auth_id": "21216",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63590,
    "description": "GSK-2011 / GSK 3GK zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=17250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003590,
    "auth_name": "EPSG",
    "auth_id": "21217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63591,
    "description": "GSK-2011 / GSK 3GK zone 18",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=18250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003591,
    "auth_name": "EPSG",
    "auth_id": "21218",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63592,
    "description": "GSK-2011 / GSK 3GK zone 19",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=19250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003592,
    "auth_name": "EPSG",
    "auth_id": "21219",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63593,
    "description": "GSK-2011 / GSK 3GK zone 20",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=20250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003593,
    "auth_name": "EPSG",
    "auth_id": "21220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63594,
    "description": "GSK-2011 / GSK 3GK zone 21",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=21250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003594,
    "auth_name": "EPSG",
    "auth_id": "21221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63595,
    "description": "GSK-2011 / GSK 3GK zone 22",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=22250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003595,
    "auth_name": "EPSG",
    "auth_id": "21222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63596,
    "description": "GSK-2011 / GSK 3GK zone 23",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=23250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003596,
    "auth_name": "EPSG",
    "auth_id": "21223",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63597,
    "description": "GSK-2011 / GSK 3GK zone 24",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=24250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003597,
    "auth_name": "EPSG",
    "auth_id": "21224",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63598,
    "description": "GSK-2011 / GSK 3GK zone 25",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=25250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003598,
    "auth_name": "EPSG",
    "auth_id": "21225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63599,
    "description": "GSK-2011 / GSK 3GK zone 26",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=26250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003599,
    "auth_name": "EPSG",
    "auth_id": "21226",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63600,
    "description": "GSK-2011 / GSK 3GK zone 27",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=27250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003600,
    "auth_name": "EPSG",
    "auth_id": "21227",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63601,
    "description": "GSK-2011 / GSK 3GK zone 28",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=28250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003601,
    "auth_name": "EPSG",
    "auth_id": "21228",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63602,
    "description": "GSK-2011 / GSK 3GK zone 29",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=29250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003602,
    "auth_name": "EPSG",
    "auth_id": "21229",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63603,
    "description": "GSK-2011 / GSK 3GK zone 30",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=30250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003603,
    "auth_name": "EPSG",
    "auth_id": "21230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63604,
    "description": "GSK-2011 / GSK 3GK zone 31",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=31250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003604,
    "auth_name": "EPSG",
    "auth_id": "21231",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63605,
    "description": "GSK-2011 / GSK 3GK zone 32",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=32250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003605,
    "auth_name": "EPSG",
    "auth_id": "21232",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63606,
    "description": "GSK-2011 / GSK 3GK zone 33",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=33250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003606,
    "auth_name": "EPSG",
    "auth_id": "21233",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63607,
    "description": "GSK-2011 / GSK 3GK zone 34",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=34250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003607,
    "auth_name": "EPSG",
    "auth_id": "21234",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63608,
    "description": "GSK-2011 / GSK 3GK zone 35",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=35250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003608,
    "auth_name": "EPSG",
    "auth_id": "21235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63609,
    "description": "GSK-2011 / GSK 3GK zone 36",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=36250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003609,
    "auth_name": "EPSG",
    "auth_id": "21236",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63610,
    "description": "GSK-2011 / GSK 3GK zone 37",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=37250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003610,
    "auth_name": "EPSG",
    "auth_id": "21237",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63611,
    "description": "GSK-2011 / GSK 3GK zone 38",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=38250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003611,
    "auth_name": "EPSG",
    "auth_id": "21238",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63612,
    "description": "GSK-2011 / GSK 3GK zone 39",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=39250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003612,
    "auth_name": "EPSG",
    "auth_id": "21239",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63613,
    "description": "GSK-2011 / GSK 3GK zone 40",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003613,
    "auth_name": "EPSG",
    "auth_id": "21240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63614,
    "description": "GSK-2011 / GSK 3GK zone 41",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=41250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003614,
    "auth_name": "EPSG",
    "auth_id": "21241",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63615,
    "description": "GSK-2011 / GSK 3GK zone 42",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=42250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003615,
    "auth_name": "EPSG",
    "auth_id": "21242",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63616,
    "description": "GSK-2011 / GSK 3GK zone 43",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=43250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003616,
    "auth_name": "EPSG",
    "auth_id": "21243",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63617,
    "description": "GSK-2011 / GSK 3GK zone 44",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=44250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003617,
    "auth_name": "EPSG",
    "auth_id": "21244",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63618,
    "description": "GSK-2011 / GSK 3GK zone 45",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=45250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003618,
    "auth_name": "EPSG",
    "auth_id": "21245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63619,
    "description": "GSK-2011 / GSK 3GK zone 46",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=46250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003619,
    "auth_name": "EPSG",
    "auth_id": "21246",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63620,
    "description": "GSK-2011 / GSK 3GK zone 47",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=47250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003620,
    "auth_name": "EPSG",
    "auth_id": "21247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63621,
    "description": "GSK-2011 / GSK 3GK zone 48",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=48250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003621,
    "auth_name": "EPSG",
    "auth_id": "21248",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63622,
    "description": "GSK-2011 / GSK 3GK zone 49",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=49250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003622,
    "auth_name": "EPSG",
    "auth_id": "21249",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63623,
    "description": "GSK-2011 / GSK 3GK zone 50",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=50250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003623,
    "auth_name": "EPSG",
    "auth_id": "21250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63624,
    "description": "GSK-2011 / GSK 3GK zone 51",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=51250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003624,
    "auth_name": "EPSG",
    "auth_id": "21251",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63625,
    "description": "GSK-2011 / GSK 3GK zone 52",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=52250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003625,
    "auth_name": "EPSG",
    "auth_id": "21252",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63626,
    "description": "GSK-2011 / GSK 3GK zone 53",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=53250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003626,
    "auth_name": "EPSG",
    "auth_id": "21253",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63627,
    "description": "GSK-2011 / GSK 3GK zone 54",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=54250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003627,
    "auth_name": "EPSG",
    "auth_id": "21254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63628,
    "description": "GSK-2011 / GSK 3GK zone 55",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=55250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003628,
    "auth_name": "EPSG",
    "auth_id": "21255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63629,
    "description": "GSK-2011 / GSK 3GK zone 56",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=56250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003629,
    "auth_name": "EPSG",
    "auth_id": "21256",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63630,
    "description": "GSK-2011 / GSK 3GK zone 57",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=57250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003630,
    "auth_name": "EPSG",
    "auth_id": "21257",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63631,
    "description": "GSK-2011 / GSK 3GK zone 58",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=58250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003631,
    "auth_name": "EPSG",
    "auth_id": "21258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63632,
    "description": "GSK-2011 / GSK 3GK zone 59",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=59250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003632,
    "auth_name": "EPSG",
    "auth_id": "21259",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63633,
    "description": "GSK-2011 / GSK 3GK zone 60",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=60250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003633,
    "auth_name": "EPSG",
    "auth_id": "21260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63634,
    "description": "GSK-2011 / GSK 3GK zone 61",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=61250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003634,
    "auth_name": "EPSG",
    "auth_id": "21261",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63635,
    "description": "GSK-2011 / GSK 3GK zone 62",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=62250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003635,
    "auth_name": "EPSG",
    "auth_id": "21262",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63636,
    "description": "GSK-2011 / GSK 3GK zone 63",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=63250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003636,
    "auth_name": "EPSG",
    "auth_id": "21263",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63637,
    "description": "GSK-2011 / GSK 3GK zone 64",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=64250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003637,
    "auth_name": "EPSG",
    "auth_id": "21264",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63638,
    "description": "GSK-2011 / GSK 3GK CM 21E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003638,
    "auth_name": "EPSG",
    "auth_id": "21307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63639,
    "description": "GSK-2011 / GSK 3GK CM 24E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003639,
    "auth_name": "EPSG",
    "auth_id": "21308",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63640,
    "description": "GSK-2011 / GSK 3GK CM 27E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003640,
    "auth_name": "EPSG",
    "auth_id": "21309",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63641,
    "description": "GSK-2011 / GSK 3GK CM 30E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003641,
    "auth_name": "EPSG",
    "auth_id": "21310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63642,
    "description": "GSK-2011 / GSK 3GK CM 33E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003642,
    "auth_name": "EPSG",
    "auth_id": "21311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63643,
    "description": "GSK-2011 / GSK 3GK CM 36E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003643,
    "auth_name": "EPSG",
    "auth_id": "21312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63644,
    "description": "GSK-2011 / GSK 3GK CM 39E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003644,
    "auth_name": "EPSG",
    "auth_id": "21313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63645,
    "description": "GSK-2011 / GSK 3GK CM 42E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=42 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003645,
    "auth_name": "EPSG",
    "auth_id": "21314",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63646,
    "description": "GSK-2011 / GSK 3GK CM 45E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=45 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003646,
    "auth_name": "EPSG",
    "auth_id": "21315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63647,
    "description": "GSK-2011 / GSK 3GK CM 48E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=48 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003647,
    "auth_name": "EPSG",
    "auth_id": "21316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63648,
    "description": "GSK-2011 / GSK 3GK CM 51E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=51 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003648,
    "auth_name": "EPSG",
    "auth_id": "21317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63649,
    "description": "GSK-2011 / GSK 3GK CM 54E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=54 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003649,
    "auth_name": "EPSG",
    "auth_id": "21318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63650,
    "description": "GSK-2011 / GSK 3GK CM 57E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=57 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003650,
    "auth_name": "EPSG",
    "auth_id": "21319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63651,
    "description": "GSK-2011 / GSK 3GK CM 60E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=60 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003651,
    "auth_name": "EPSG",
    "auth_id": "21320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63652,
    "description": "GSK-2011 / GSK 3GK CM 63E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=63 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003652,
    "auth_name": "EPSG",
    "auth_id": "21321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63653,
    "description": "GSK-2011 / GSK 3GK CM 66E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=66 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003653,
    "auth_name": "EPSG",
    "auth_id": "21322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63654,
    "description": "GSK-2011 / GSK 3GK CM 69E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=69 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003654,
    "auth_name": "EPSG",
    "auth_id": "21323",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63655,
    "description": "GSK-2011 / GSK 3GK CM 72E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=72 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003655,
    "auth_name": "EPSG",
    "auth_id": "21324",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63656,
    "description": "GSK-2011 / GSK 3GK CM 75E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=75 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003656,
    "auth_name": "EPSG",
    "auth_id": "21325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63657,
    "description": "GSK-2011 / GSK 3GK CM 78E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=78 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003657,
    "auth_name": "EPSG",
    "auth_id": "21326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63658,
    "description": "GSK-2011 / GSK 3GK CM 81E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=81 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003658,
    "auth_name": "EPSG",
    "auth_id": "21327",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63659,
    "description": "GSK-2011 / GSK 3GK CM 84E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=84 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003659,
    "auth_name": "EPSG",
    "auth_id": "21328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63660,
    "description": "GSK-2011 / GSK 3GK CM 87E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=87 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003660,
    "auth_name": "EPSG",
    "auth_id": "21329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63661,
    "description": "GSK-2011 / GSK 3GK CM 90E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003661,
    "auth_name": "EPSG",
    "auth_id": "21330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63662,
    "description": "GSK-2011 / GSK 3GK CM 93E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=93 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003662,
    "auth_name": "EPSG",
    "auth_id": "21331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63663,
    "description": "GSK-2011 / GSK 3GK CM 96E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=96 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003663,
    "auth_name": "EPSG",
    "auth_id": "21332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63664,
    "description": "GSK-2011 / GSK 3GK CM 99E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=99 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003664,
    "auth_name": "EPSG",
    "auth_id": "21333",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63665,
    "description": "GSK-2011 / GSK 3GK CM 102E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=102 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003665,
    "auth_name": "EPSG",
    "auth_id": "21334",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63666,
    "description": "GSK-2011 / GSK 3GK CM 105E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=105 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003666,
    "auth_name": "EPSG",
    "auth_id": "21335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63667,
    "description": "GSK-2011 / GSK 3GK CM 108E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=108 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003667,
    "auth_name": "EPSG",
    "auth_id": "21336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63668,
    "description": "GSK-2011 / GSK 3GK CM 111E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=111 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003668,
    "auth_name": "EPSG",
    "auth_id": "21337",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63669,
    "description": "GSK-2011 / GSK 3GK CM 114E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003669,
    "auth_name": "EPSG",
    "auth_id": "21338",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63670,
    "description": "GSK-2011 / GSK 3GK CM 117E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003670,
    "auth_name": "EPSG",
    "auth_id": "21339",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63671,
    "description": "GSK-2011 / GSK 3GK CM 120E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003671,
    "auth_name": "EPSG",
    "auth_id": "21340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63672,
    "description": "GSK-2011 / GSK 3GK CM 123E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=123 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003672,
    "auth_name": "EPSG",
    "auth_id": "21341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63673,
    "description": "GSK-2011 / GSK 3GK CM 126E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=126 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003673,
    "auth_name": "EPSG",
    "auth_id": "21342",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63674,
    "description": "GSK-2011 / GSK 3GK CM 129E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=129 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003674,
    "auth_name": "EPSG",
    "auth_id": "21343",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63675,
    "description": "GSK-2011 / GSK 3GK CM 132E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=132 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003675,
    "auth_name": "EPSG",
    "auth_id": "21344",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63676,
    "description": "GSK-2011 / GSK 3GK CM 135E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=135 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003676,
    "auth_name": "EPSG",
    "auth_id": "21345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63677,
    "description": "GSK-2011 / GSK 3GK CM 138E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=138 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003677,
    "auth_name": "EPSG",
    "auth_id": "21346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63678,
    "description": "GSK-2011 / GSK 3GK CM 141E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=141 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003678,
    "auth_name": "EPSG",
    "auth_id": "21347",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63679,
    "description": "GSK-2011 / GSK 3GK CM 144E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=144 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003679,
    "auth_name": "EPSG",
    "auth_id": "21348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63680,
    "description": "GSK-2011 / GSK 3GK CM 147E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=147 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003680,
    "auth_name": "EPSG",
    "auth_id": "21349",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63681,
    "description": "GSK-2011 / GSK 3GK CM 150E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=150 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003681,
    "auth_name": "EPSG",
    "auth_id": "21350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63682,
    "description": "GSK-2011 / GSK 3GK CM 153E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=153 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003682,
    "auth_name": "EPSG",
    "auth_id": "21351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63683,
    "description": "GSK-2011 / GSK 3GK CM 156E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=156 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003683,
    "auth_name": "EPSG",
    "auth_id": "21352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63684,
    "description": "GSK-2011 / GSK 3GK CM 159E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003684,
    "auth_name": "EPSG",
    "auth_id": "21353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63685,
    "description": "GSK-2011 / GSK 3GK CM 162E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=162 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003685,
    "auth_name": "EPSG",
    "auth_id": "21354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63686,
    "description": "GSK-2011 / GSK 3GK CM 165E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=165 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003686,
    "auth_name": "EPSG",
    "auth_id": "21355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63687,
    "description": "GSK-2011 / GSK 3GK CM 168E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=168 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003687,
    "auth_name": "EPSG",
    "auth_id": "21356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63688,
    "description": "GSK-2011 / GSK 3GK CM 171E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=171 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003688,
    "auth_name": "EPSG",
    "auth_id": "21357",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63689,
    "description": "GSK-2011 / GSK 3GK CM 174E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=174 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003689,
    "auth_name": "EPSG",
    "auth_id": "21358",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63690,
    "description": "GSK-2011 / GSK 3GK CM 177E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=177 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003690,
    "auth_name": "EPSG",
    "auth_id": "21359",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63691,
    "description": "GSK-2011 / GSK 3GK CM 180E",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=180 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003691,
    "auth_name": "EPSG",
    "auth_id": "21360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63692,
    "description": "GSK-2011 / GSK 3GK CM 177W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-177 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003692,
    "auth_name": "EPSG",
    "auth_id": "21361",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63693,
    "description": "GSK-2011 / GSK 3GK CM 174W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-174 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003693,
    "auth_name": "EPSG",
    "auth_id": "21362",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63694,
    "description": "GSK-2011 / GSK 3GK CM 171W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-171 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003694,
    "auth_name": "EPSG",
    "auth_id": "21363",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63695,
    "description": "GSK-2011 / GSK 3GK CM 168W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-168 +k=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520003695,
    "auth_name": "EPSG",
    "auth_id": "21364",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63696,
    "description": "NAD83(CSRS)v2 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003696,
    "auth_name": "EPSG",
    "auth_id": "22207",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63697,
    "description": "NAD83(CSRS)v2 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003697,
    "auth_name": "EPSG",
    "auth_id": "22208",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63698,
    "description": "NAD83(CSRS)v2 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003698,
    "auth_name": "EPSG",
    "auth_id": "22209",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63699,
    "description": "NAD83(CSRS)v2 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003699,
    "auth_name": "EPSG",
    "auth_id": "22210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63700,
    "description": "NAD83(CSRS)v2 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003700,
    "auth_name": "EPSG",
    "auth_id": "22211",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63701,
    "description": "NAD83(CSRS)v2 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003701,
    "auth_name": "EPSG",
    "auth_id": "22212",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63702,
    "description": "NAD83(CSRS)v2 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003702,
    "auth_name": "EPSG",
    "auth_id": "22213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63703,
    "description": "NAD83(CSRS)v2 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003703,
    "auth_name": "EPSG",
    "auth_id": "22214",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63704,
    "description": "NAD83(CSRS)v2 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003704,
    "auth_name": "EPSG",
    "auth_id": "22215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63705,
    "description": "NAD83(CSRS)v2 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003705,
    "auth_name": "EPSG",
    "auth_id": "22216",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63706,
    "description": "NAD83(CSRS)v2 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003706,
    "auth_name": "EPSG",
    "auth_id": "22217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63707,
    "description": "NAD83(CSRS)v2 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003707,
    "auth_name": "EPSG",
    "auth_id": "22218",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63708,
    "description": "NAD83(CSRS)v2 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003708,
    "auth_name": "EPSG",
    "auth_id": "22219",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63709,
    "description": "NAD83(CSRS)v2 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003709,
    "auth_name": "EPSG",
    "auth_id": "22220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63710,
    "description": "NAD83(CSRS)v2 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003710,
    "auth_name": "EPSG",
    "auth_id": "22221",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63711,
    "description": "NAD83(CSRS)v2 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003711,
    "auth_name": "EPSG",
    "auth_id": "22222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63712,
    "description": "NAD83(CSRS)v2 / PEI Stereographic",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "sterea",
    "parameters": "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003712,
    "auth_name": "EPSG",
    "auth_id": "22239",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63713,
    "description": "NAD83(CSRS)v2 / NB Stereographic",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "sterea",
    "parameters": "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003713,
    "auth_name": "EPSG",
    "auth_id": "22240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63714,
    "description": "NAD83(CSRS)v2 / SCoPQ zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003714,
    "auth_name": "EPSG",
    "auth_id": "22243",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63715,
    "description": "NAD83(CSRS)v2 / SCoPQ zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003715,
    "auth_name": "EPSG",
    "auth_id": "22244",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63716,
    "description": "NAD83(CSRS)v2 / SCoPQ zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003716,
    "auth_name": "EPSG",
    "auth_id": "22245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63717,
    "description": "NAD83(CSRS)v2 / SCoPQ zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003717,
    "auth_name": "EPSG",
    "auth_id": "22246",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63718,
    "description": "NAD83(CSRS)v2 / SCoPQ zone 7",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003718,
    "auth_name": "EPSG",
    "auth_id": "22247",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63719,
    "description": "NAD83(CSRS)v2 / SCoPQ zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003719,
    "auth_name": "EPSG",
    "auth_id": "22248",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63720,
    "description": "NAD83(CSRS)v2 / SCoPQ zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003720,
    "auth_name": "EPSG",
    "auth_id": "22249",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63721,
    "description": "NAD83(CSRS)v2 / SCoPQ zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003721,
    "auth_name": "EPSG",
    "auth_id": "22250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63722,
    "description": "NAD83(CSRS)v2 / Alberta 3TM ref merid 111 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003722,
    "auth_name": "EPSG",
    "auth_id": "22262",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63723,
    "description": "NAD83(CSRS)v2 / Alberta 3TM ref merid 114 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003723,
    "auth_name": "EPSG",
    "auth_id": "22263",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63724,
    "description": "NAD83(CSRS)v2 / Alberta 3TM ref merid 117 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003724,
    "auth_name": "EPSG",
    "auth_id": "22264",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63725,
    "description": "NAD83(CSRS)v2 / Alberta 3TM ref merid 120 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003725,
    "auth_name": "EPSG",
    "auth_id": "22265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63726,
    "description": "NAD83(CSRS)v3 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003726,
    "auth_name": "EPSG",
    "auth_id": "22307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63727,
    "description": "NAD83(CSRS)v3 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003727,
    "auth_name": "EPSG",
    "auth_id": "22308",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63728,
    "description": "NAD83(CSRS)v3 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003728,
    "auth_name": "EPSG",
    "auth_id": "22309",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63729,
    "description": "NAD83(CSRS)v3 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003729,
    "auth_name": "EPSG",
    "auth_id": "22310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63730,
    "description": "NAD83(CSRS)v3 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003730,
    "auth_name": "EPSG",
    "auth_id": "22311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63731,
    "description": "NAD83(CSRS)v3 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003731,
    "auth_name": "EPSG",
    "auth_id": "22312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63732,
    "description": "NAD83(CSRS)v3 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003732,
    "auth_name": "EPSG",
    "auth_id": "22313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63733,
    "description": "NAD83(CSRS)v3 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003733,
    "auth_name": "EPSG",
    "auth_id": "22314",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63734,
    "description": "NAD83(CSRS)v3 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003734,
    "auth_name": "EPSG",
    "auth_id": "22315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63735,
    "description": "NAD83(CSRS)v3 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003735,
    "auth_name": "EPSG",
    "auth_id": "22316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63736,
    "description": "NAD83(CSRS)v3 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003736,
    "auth_name": "EPSG",
    "auth_id": "22317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63737,
    "description": "NAD83(CSRS)v3 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003737,
    "auth_name": "EPSG",
    "auth_id": "22318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63738,
    "description": "NAD83(CSRS)v3 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003738,
    "auth_name": "EPSG",
    "auth_id": "22319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63739,
    "description": "NAD83(CSRS)v3 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003739,
    "auth_name": "EPSG",
    "auth_id": "22320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63740,
    "description": "NAD83(CSRS)v3 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003740,
    "auth_name": "EPSG",
    "auth_id": "22321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63741,
    "description": "NAD83(CSRS)v3 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003741,
    "auth_name": "EPSG",
    "auth_id": "22322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63742,
    "description": "NAD83(CSRS)v3 / MTM NS 1997 zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=15500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003742,
    "auth_name": "EPSG",
    "auth_id": "22337",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63743,
    "description": "NAD83(CSRS)v3 / MTM NS 1997 zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=14500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003743,
    "auth_name": "EPSG",
    "auth_id": "22338",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63744,
    "description": "NAD83(CSRS)v3 / MTM zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003744,
    "auth_name": "EPSG",
    "auth_id": "22348",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63745,
    "description": "NAD83(CSRS)v3 / MTM zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003745,
    "auth_name": "EPSG",
    "auth_id": "22349",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63746,
    "description": "NAD83(CSRS)v3 / MTM zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003746,
    "auth_name": "EPSG",
    "auth_id": "22350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63747,
    "description": "NAD83(CSRS)v3 / MTM zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003747,
    "auth_name": "EPSG",
    "auth_id": "22351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63748,
    "description": "NAD83(CSRS)v3 / MTM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003748,
    "auth_name": "EPSG",
    "auth_id": "22352",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63749,
    "description": "NAD83(CSRS)v3 / MTM zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003749,
    "auth_name": "EPSG",
    "auth_id": "22353",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63750,
    "description": "NAD83(CSRS)v3 / MTM zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003750,
    "auth_name": "EPSG",
    "auth_id": "22354",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63751,
    "description": "NAD83(CSRS)v3 / MTM zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003751,
    "auth_name": "EPSG",
    "auth_id": "22355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63752,
    "description": "NAD83(CSRS)v3 / MTM zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003752,
    "auth_name": "EPSG",
    "auth_id": "22356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63753,
    "description": "NAD83(CSRS)v3 / MTM zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003753,
    "auth_name": "EPSG",
    "auth_id": "22357",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63754,
    "description": "NAD83(CSRS)v4 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003754,
    "auth_name": "EPSG",
    "auth_id": "22407",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63755,
    "description": "NAD83(CSRS)v4 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003755,
    "auth_name": "EPSG",
    "auth_id": "22408",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63756,
    "description": "NAD83(CSRS)v4 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003756,
    "auth_name": "EPSG",
    "auth_id": "22409",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63757,
    "description": "NAD83(CSRS)v4 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003757,
    "auth_name": "EPSG",
    "auth_id": "22410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63758,
    "description": "NAD83(CSRS)v4 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003758,
    "auth_name": "EPSG",
    "auth_id": "22411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63759,
    "description": "NAD83(CSRS)v4 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003759,
    "auth_name": "EPSG",
    "auth_id": "22412",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63760,
    "description": "NAD83(CSRS)v4 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003760,
    "auth_name": "EPSG",
    "auth_id": "22413",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63761,
    "description": "NAD83(CSRS)v4 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003761,
    "auth_name": "EPSG",
    "auth_id": "22414",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63762,
    "description": "NAD83(CSRS)v4 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003762,
    "auth_name": "EPSG",
    "auth_id": "22415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63763,
    "description": "NAD83(CSRS)v4 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003763,
    "auth_name": "EPSG",
    "auth_id": "22416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63764,
    "description": "NAD83(CSRS)v4 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003764,
    "auth_name": "EPSG",
    "auth_id": "22417",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63765,
    "description": "NAD83(CSRS)v4 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003765,
    "auth_name": "EPSG",
    "auth_id": "22418",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63766,
    "description": "NAD83(CSRS)v4 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003766,
    "auth_name": "EPSG",
    "auth_id": "22419",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63767,
    "description": "NAD83(CSRS)v4 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003767,
    "auth_name": "EPSG",
    "auth_id": "22420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63768,
    "description": "NAD83(CSRS)v4 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003768,
    "auth_name": "EPSG",
    "auth_id": "22421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63769,
    "description": "NAD83(CSRS)v4 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003769,
    "auth_name": "EPSG",
    "auth_id": "22422",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63770,
    "description": "NAD83(CSRS)v4 / Alberta 3TM ref merid 111 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003770,
    "auth_name": "EPSG",
    "auth_id": "22462",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63771,
    "description": "NAD83(CSRS)v4 / Alberta 3TM ref merid 114 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003771,
    "auth_name": "EPSG",
    "auth_id": "22463",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63772,
    "description": "NAD83(CSRS)v4 / Alberta 3TM ref merid 117 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003772,
    "auth_name": "EPSG",
    "auth_id": "22464",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63773,
    "description": "NAD83(CSRS)v4 / Alberta 3TM ref merid 120 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003773,
    "auth_name": "EPSG",
    "auth_id": "22465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63774,
    "description": "NAD83(CSRS)v6 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003774,
    "auth_name": "EPSG",
    "auth_id": "22607",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63775,
    "description": "NAD83(CSRS)v6 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003775,
    "auth_name": "EPSG",
    "auth_id": "22608",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63776,
    "description": "NAD83(CSRS)v6 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003776,
    "auth_name": "EPSG",
    "auth_id": "22609",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63777,
    "description": "NAD83(CSRS)v6 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003777,
    "auth_name": "EPSG",
    "auth_id": "22610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63778,
    "description": "NAD83(CSRS)v6 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003778,
    "auth_name": "EPSG",
    "auth_id": "22611",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63779,
    "description": "NAD83(CSRS)v6 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003779,
    "auth_name": "EPSG",
    "auth_id": "22612",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63780,
    "description": "NAD83(CSRS)v6 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003780,
    "auth_name": "EPSG",
    "auth_id": "22613",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63781,
    "description": "NAD83(CSRS)v6 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003781,
    "auth_name": "EPSG",
    "auth_id": "22614",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63782,
    "description": "NAD83(CSRS)v6 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003782,
    "auth_name": "EPSG",
    "auth_id": "22615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63783,
    "description": "NAD83(CSRS)v6 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003783,
    "auth_name": "EPSG",
    "auth_id": "22616",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63784,
    "description": "NAD83(CSRS)v6 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003784,
    "auth_name": "EPSG",
    "auth_id": "22617",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63785,
    "description": "NAD83(CSRS)v6 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003785,
    "auth_name": "EPSG",
    "auth_id": "22618",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63786,
    "description": "NAD83(CSRS)v6 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003786,
    "auth_name": "EPSG",
    "auth_id": "22619",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63787,
    "description": "NAD83(CSRS)v6 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003787,
    "auth_name": "EPSG",
    "auth_id": "22620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63788,
    "description": "NAD83(CSRS)v6 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003788,
    "auth_name": "EPSG",
    "auth_id": "22621",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63789,
    "description": "NAD83(CSRS)v6 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003789,
    "auth_name": "EPSG",
    "auth_id": "22622",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63790,
    "description": "NAD83(CSRS)v6 / PEI Stereographic",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "sterea",
    "parameters": "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003790,
    "auth_name": "EPSG",
    "auth_id": "22639",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63791,
    "description": "NAD83(CSRS)v6 / MTM zone 1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-53 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003791,
    "auth_name": "EPSG",
    "auth_id": "22641",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63792,
    "description": "NAD83(CSRS)v6 / MTM zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-56 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003792,
    "auth_name": "EPSG",
    "auth_id": "22642",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63793,
    "description": "NAD83(CSRS)v6 / MTM zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003793,
    "auth_name": "EPSG",
    "auth_id": "22643",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63794,
    "description": "NAD83(CSRS)v6 / MTM zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003794,
    "auth_name": "EPSG",
    "auth_id": "22644",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63795,
    "description": "NAD83(CSRS)v6 / MTM zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003795,
    "auth_name": "EPSG",
    "auth_id": "22645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63796,
    "description": "NAD83(CSRS)v6 / MTM zone 6",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003796,
    "auth_name": "EPSG",
    "auth_id": "22646",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63797,
    "description": "NAD83(CSRS)v6 / MTM zone 8",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003797,
    "auth_name": "EPSG",
    "auth_id": "22648",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63798,
    "description": "NAD83(CSRS)v6 / MTM zone 9",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003798,
    "auth_name": "EPSG",
    "auth_id": "22649",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63799,
    "description": "NAD83(CSRS)v6 / MTM zone 10",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003799,
    "auth_name": "EPSG",
    "auth_id": "22650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63800,
    "description": "NAD83(CSRS)v6 / MTM zone 11",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003800,
    "auth_name": "EPSG",
    "auth_id": "22651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63801,
    "description": "NAD83(CSRS)v6 / MTM zone 12",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-81 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003801,
    "auth_name": "EPSG",
    "auth_id": "22652",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63802,
    "description": "NAD83(CSRS)v6 / MTM zone 13",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-84 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003802,
    "auth_name": "EPSG",
    "auth_id": "22653",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63803,
    "description": "NAD83(CSRS)v6 / MTM zone 14",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-87 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003803,
    "auth_name": "EPSG",
    "auth_id": "22654",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63804,
    "description": "NAD83(CSRS)v6 / MTM zone 15",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-90 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003804,
    "auth_name": "EPSG",
    "auth_id": "22655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63805,
    "description": "NAD83(CSRS)v6 / MTM zone 16",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-93 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003805,
    "auth_name": "EPSG",
    "auth_id": "22656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63806,
    "description": "NAD83(CSRS)v6 / MTM zone 17",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-96 +k=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003806,
    "auth_name": "EPSG",
    "auth_id": "22657",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63807,
    "description": "NAD83(CSRS)v7 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003807,
    "auth_name": "EPSG",
    "auth_id": "22707",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63808,
    "description": "NAD83(CSRS)v7 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003808,
    "auth_name": "EPSG",
    "auth_id": "22708",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63809,
    "description": "NAD83(CSRS)v7 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003809,
    "auth_name": "EPSG",
    "auth_id": "22709",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63810,
    "description": "NAD83(CSRS)v7 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003810,
    "auth_name": "EPSG",
    "auth_id": "22710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63811,
    "description": "NAD83(CSRS)v7 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003811,
    "auth_name": "EPSG",
    "auth_id": "22711",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63812,
    "description": "NAD83(CSRS)v7 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003812,
    "auth_name": "EPSG",
    "auth_id": "22712",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63813,
    "description": "NAD83(CSRS)v7 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003813,
    "auth_name": "EPSG",
    "auth_id": "22713",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63814,
    "description": "NAD83(CSRS)v7 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003814,
    "auth_name": "EPSG",
    "auth_id": "22714",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63815,
    "description": "NAD83(CSRS)v7 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003815,
    "auth_name": "EPSG",
    "auth_id": "22715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63816,
    "description": "NAD83(CSRS)v7 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003816,
    "auth_name": "EPSG",
    "auth_id": "22716",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63817,
    "description": "NAD83(CSRS)v7 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003817,
    "auth_name": "EPSG",
    "auth_id": "22717",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63818,
    "description": "NAD83(CSRS)v7 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003818,
    "auth_name": "EPSG",
    "auth_id": "22718",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63819,
    "description": "NAD83(CSRS)v7 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003819,
    "auth_name": "EPSG",
    "auth_id": "22719",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63820,
    "description": "NAD83(CSRS)v7 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003820,
    "auth_name": "EPSG",
    "auth_id": "22720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63821,
    "description": "NAD83(CSRS)v7 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003821,
    "auth_name": "EPSG",
    "auth_id": "22721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63822,
    "description": "NAD83(CSRS)v7 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003822,
    "auth_name": "EPSG",
    "auth_id": "22722",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63823,
    "description": "NAD83(CSRS)v7 / PEI Stereographic",
    "projection_acronym": "sterea",
    "ellipsoid_acronym": "sterea",
    "parameters": "+proj=sterea +lat_0=47.25 +lon_0=-63 +k=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003823,
    "auth_name": "EPSG",
    "auth_id": "22739",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63824,
    "description": "NAD83(CSRS)v7 / Alberta 3TM ref merid 111 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-111 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003824,
    "auth_name": "EPSG",
    "auth_id": "22762",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63825,
    "description": "NAD83(CSRS)v7 / Alberta 3TM ref merid 114 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-114 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003825,
    "auth_name": "EPSG",
    "auth_id": "22763",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63826,
    "description": "NAD83(CSRS)v7 / Alberta 3TM ref merid 117 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-117 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003826,
    "auth_name": "EPSG",
    "auth_id": "22764",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63827,
    "description": "NAD83(CSRS)v7 / Alberta 3TM ref merid 120 W",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=-120 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520003827,
    "auth_name": "EPSG",
    "auth_id": "22765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 63828,
    "description": "NAD83 / Wyoming Lambert",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=41 +lon_0=-107.5 +lat_1=41 +lat_2=45 +x_0=500000 +y_0=200000 +datum=NAD83 +units=m +no_defs",
    "srid": 520003828,
    "auth_name": "EPSG",
    "auth_id": "32159",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64081,
    "description": "WGS 84 (G2139)",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 520004081,
    "auth_name": "EPSG",
    "auth_id": "9753",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 64082,
    "description": "WGS 84 (G2139)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520004082,
    "auth_name": "EPSG",
    "auth_id": "9754",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 64083,
    "description": "WGS 84 (G2139)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=WGS84 +no_defs",
    "srid": 520004083,
    "auth_name": "EPSG",
    "auth_id": "9755",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64084,
    "description": "ECML14_NB-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004084,
    "auth_name": "EPSG",
    "auth_id": "9758",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64085,
    "description": "ECML14_NB Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=55.05 +lon_0=-1.55 +k=1 +x_0=112242.8512 +y_0=402313.7432 +ellps=GRS80 +units=m +no_defs",
    "srid": 520004085,
    "auth_name": "EPSG",
    "auth_id": "9761",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64086,
    "description": "ECML14_NB Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=55.05 +lon_0=-1.55 +k=1 +x_0=112242.8512 +y_0=402313.7432 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520004086,
    "auth_name": "EPSG",
    "auth_id": "9762",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64087,
    "description": "EWR2-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004087,
    "auth_name": "EPSG",
    "auth_id": "9763",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64088,
    "description": "EWR2 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=51.95 +lon_0=-0.9 +k=1 +x_0=192519.9715 +y_0=146942.6806 +ellps=GRS80 +units=m +no_defs",
    "srid": 520004088,
    "auth_name": "EPSG",
    "auth_id": "9766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64089,
    "description": "EWR2 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=51.95 +lon_0=-0.9 +k=1 +x_0=192519.9715 +y_0=146942.6806 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520004089,
    "auth_name": "EPSG",
    "auth_id": "9767",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64090,
    "description": "RGF93 v2",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520004090,
    "auth_name": "EPSG",
    "auth_id": "9775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 64091,
    "description": "RGF93 v2",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520004091,
    "auth_name": "EPSG",
    "auth_id": "9776",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 64092,
    "description": "RGF93 v2",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520004092,
    "auth_name": "EPSG",
    "auth_id": "9777",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64093,
    "description": "RGF93 v2 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004093,
    "auth_name": "EPSG",
    "auth_id": "9778",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 64094,
    "description": "RGF93 v2 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004094,
    "auth_name": "EPSG",
    "auth_id": "9779",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64095,
    "description": "RGF93 v2b",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520004095,
    "auth_name": "EPSG",
    "auth_id": "9780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 64096,
    "description": "RGF93 v2b",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520004096,
    "auth_name": "EPSG",
    "auth_id": "9781",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 64097,
    "description": "RGF93 v2b",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520004097,
    "auth_name": "EPSG",
    "auth_id": "9782",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64098,
    "description": "RGF93 v2b (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004098,
    "auth_name": "EPSG",
    "auth_id": "9783",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 64099,
    "description": "RGF93 v2b (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004099,
    "auth_name": "EPSG",
    "auth_id": "9784",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64100,
    "description": "RGF93 v2b + NGF-IGN69 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520004100,
    "auth_name": "EPSG",
    "auth_id": "9785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64101,
    "description": "RGF93 v2 / Lambert-93",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004101,
    "auth_name": "EPSG",
    "auth_id": "9793",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64102,
    "description": "RGF93 v2b / Lambert-93",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004102,
    "auth_name": "EPSG",
    "auth_id": "9794",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64103,
    "description": "UCS-2000 / LCS-32 Kyiv region",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004103,
    "auth_name": "EPSG",
    "auth_id": "9821",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64104,
    "description": "RGF93 v2 / CC42",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004104,
    "auth_name": "EPSG",
    "auth_id": "9822",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64105,
    "description": "RGF93 v2 / CC43",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004105,
    "auth_name": "EPSG",
    "auth_id": "9823",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64106,
    "description": "RGF93 v2 / CC44",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=3 +lat_1=43.25 +lat_2=44.75 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004106,
    "auth_name": "EPSG",
    "auth_id": "9824",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64107,
    "description": "RGF93 v2 / CC45",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=3 +lat_1=44.25 +lat_2=45.75 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004107,
    "auth_name": "EPSG",
    "auth_id": "9825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64108,
    "description": "RGF93 v2 / CC46",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=46 +lon_0=3 +lat_1=45.25 +lat_2=46.75 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004108,
    "auth_name": "EPSG",
    "auth_id": "9826",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64109,
    "description": "RGF93 v2 / CC47",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=3 +lat_1=46.25 +lat_2=47.75 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004109,
    "auth_name": "EPSG",
    "auth_id": "9827",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64110,
    "description": "RGF93 v2 / CC48",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=48 +lon_0=3 +lat_1=47.25 +lat_2=48.75 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004110,
    "auth_name": "EPSG",
    "auth_id": "9828",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64111,
    "description": "RGF93 v2 / CC49",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=49 +lon_0=3 +lat_1=48.25 +lat_2=49.75 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004111,
    "auth_name": "EPSG",
    "auth_id": "9829",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64112,
    "description": "RGF93 v2 / CC50",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=50 +lon_0=3 +lat_1=49.25 +lat_2=50.75 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004112,
    "auth_name": "EPSG",
    "auth_id": "9830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64113,
    "description": "UCS-2000 / LCS-01 Crimea",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=34.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004113,
    "auth_name": "EPSG",
    "auth_id": "9831",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64114,
    "description": "UCS-2000 / LCS-05 Vinnytsia",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28.6666666666667 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004114,
    "auth_name": "EPSG",
    "auth_id": "9832",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64115,
    "description": "UCS-2000 / LCS-07 Volyn",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24.8333333333333 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004115,
    "auth_name": "EPSG",
    "auth_id": "9833",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64116,
    "description": "UCS-2000 / LCS-12 Dnipropetrovsk",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=35 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004116,
    "auth_name": "EPSG",
    "auth_id": "9834",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64117,
    "description": "UCS-2000 / LCS-14 Donetsk",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=37.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004117,
    "auth_name": "EPSG",
    "auth_id": "9835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64118,
    "description": "UCS-2000 / LCS-18 Zhytomyr",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=28.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004118,
    "auth_name": "EPSG",
    "auth_id": "9836",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64119,
    "description": "UCS-2000 / LCS-21 Zakarpattia",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=23.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004119,
    "auth_name": "EPSG",
    "auth_id": "9837",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64120,
    "description": "UCS-2000 / LCS-23 Zaporizhzhia",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004120,
    "auth_name": "EPSG",
    "auth_id": "9838",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64121,
    "description": "UCS-2000 / LCS-26 Ivano-Frankivsk",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24.75 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004121,
    "auth_name": "EPSG",
    "auth_id": "9839",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64122,
    "description": "UCS-2000 / LCS-35 Kirovohrad",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=32 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004122,
    "auth_name": "EPSG",
    "auth_id": "9840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64123,
    "description": "UCS-2000 / LCS-44 Luhansk",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=39 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004123,
    "auth_name": "EPSG",
    "auth_id": "9841",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64124,
    "description": "RGF93 v2b / CC42",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=42 +lon_0=3 +lat_1=41.25 +lat_2=42.75 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004124,
    "auth_name": "EPSG",
    "auth_id": "9842",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64125,
    "description": "RGF93 v2b / CC43",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=43 +lon_0=3 +lat_1=42.25 +lat_2=43.75 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004125,
    "auth_name": "EPSG",
    "auth_id": "9843",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64126,
    "description": "RGF93 v2b / CC44",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=44 +lon_0=3 +lat_1=43.25 +lat_2=44.75 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004126,
    "auth_name": "EPSG",
    "auth_id": "9844",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64127,
    "description": "RGF93 v2b / CC45",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=45 +lon_0=3 +lat_1=44.25 +lat_2=45.75 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004127,
    "auth_name": "EPSG",
    "auth_id": "9845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64128,
    "description": "RGF93 v2b / CC46",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=46 +lon_0=3 +lat_1=45.25 +lat_2=46.75 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004128,
    "auth_name": "EPSG",
    "auth_id": "9846",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64129,
    "description": "RGF93 v2b / CC47",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=47 +lon_0=3 +lat_1=46.25 +lat_2=47.75 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004129,
    "auth_name": "EPSG",
    "auth_id": "9847",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64130,
    "description": "RGF93 v2b / CC48",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=48 +lon_0=3 +lat_1=47.25 +lat_2=48.75 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004130,
    "auth_name": "EPSG",
    "auth_id": "9848",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64131,
    "description": "RGF93 v2b / CC49",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=49 +lon_0=3 +lat_1=48.25 +lat_2=49.75 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004131,
    "auth_name": "EPSG",
    "auth_id": "9849",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64132,
    "description": "RGF93 v2b / CC50",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=50 +lon_0=3 +lat_1=49.25 +lat_2=50.75 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004132,
    "auth_name": "EPSG",
    "auth_id": "9850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64133,
    "description": "UCS-2000 / LCS-46 Lviv",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004133,
    "auth_name": "EPSG",
    "auth_id": "9851",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64134,
    "description": "UCS-2000 / LCS-48 Mykolaiv",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31.8333333333333 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004134,
    "auth_name": "EPSG",
    "auth_id": "9852",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64135,
    "description": "UCS-2000 / LCS-51 Odessa",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004135,
    "auth_name": "EPSG",
    "auth_id": "9853",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64136,
    "description": "UCS-2000 / LCS-53 Poltava",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33.8333333333333 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004136,
    "auth_name": "EPSG",
    "auth_id": "9854",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64137,
    "description": "UCS-2000 / LCS-56 Rivne",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004137,
    "auth_name": "EPSG",
    "auth_id": "9855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64138,
    "description": "UCS-2000 / LCS-59 Sumy",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=34.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004138,
    "auth_name": "EPSG",
    "auth_id": "9856",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64139,
    "description": "UCS-2000 / LCS-61 Ternopil",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=25.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004139,
    "auth_name": "EPSG",
    "auth_id": "9857",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64140,
    "description": "UCS-2000 / LCS-63 Kharkiv",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=36.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004140,
    "auth_name": "EPSG",
    "auth_id": "9858",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64141,
    "description": "UCS-2000 / LCS-65 Kherson",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004141,
    "auth_name": "EPSG",
    "auth_id": "9859",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64142,
    "description": "UCS-2000 / LCS-68 Khmelnytsky",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=27 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004142,
    "auth_name": "EPSG",
    "auth_id": "9860",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64143,
    "description": "UCS-2000 / LCS-71 Cherkasy",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=31.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004143,
    "auth_name": "EPSG",
    "auth_id": "9861",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64144,
    "description": "UCS-2000 / LCS-73 Chernivtsi",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=26 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004144,
    "auth_name": "EPSG",
    "auth_id": "9862",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64145,
    "description": "UCS-2000 / LCS-74 Chernihiv",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=32 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004145,
    "auth_name": "EPSG",
    "auth_id": "9863",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64146,
    "description": "UCS-2000 / LCS-80 Kyiv city",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=30.5 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004146,
    "auth_name": "EPSG",
    "auth_id": "9864",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64147,
    "description": "UCS-2000 / LCS-85 Sevastopol",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=300000 +y_0=0 +ellps=krass +units=m +no_defs",
    "srid": 520004147,
    "auth_name": "EPSG",
    "auth_id": "9865",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64148,
    "description": "MRH21-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004148,
    "auth_name": "EPSG",
    "auth_id": "9866",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64149,
    "description": "MRH21 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.3 +lon_0=-1.8 +k=1 +x_0=227286.9881 +y_0=265751.2874 +ellps=GRS80 +units=m +no_defs",
    "srid": 520004149,
    "auth_name": "EPSG",
    "auth_id": "9869",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64150,
    "description": "MRH21 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.3 +lon_0=-1.8 +k=1 +x_0=227286.9881 +y_0=265751.2874 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520004150,
    "auth_name": "EPSG",
    "auth_id": "9870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64151,
    "description": "MOLDOR11-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004151,
    "auth_name": "EPSG",
    "auth_id": "9871",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64152,
    "description": "PNG94 / PNGMG94 zone 57",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=57 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004152,
    "auth_name": "EPSG",
    "auth_id": "9874",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64153,
    "description": "PNG94 / PNGMG94 zone 58",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004153,
    "auth_name": "EPSG",
    "auth_id": "9875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64154,
    "description": "MOLDOR11 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=53.35 +lon_0=-1.9 +k=1 +x_0=226574.2032 +y_0=390894.838 +ellps=GRS80 +units=m +no_defs",
    "srid": 520004154,
    "auth_name": "EPSG",
    "auth_id": "9880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64155,
    "description": "MOLDOR11 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=53.35 +lon_0=-1.9 +k=1 +x_0=226574.2032 +y_0=390894.838 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520004155,
    "auth_name": "EPSG",
    "auth_id": "9881",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64156,
    "description": "ETRS89 + CD Norway depth",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520004156,
    "auth_name": "EPSG",
    "auth_id": "9883",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64157,
    "description": "LUREF",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=intl +units=m +no_defs",
    "srid": 520004157,
    "auth_name": "EPSG",
    "auth_id": "9892",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 64158,
    "description": "LUREF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=intl +towgs84=-189.6806,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598 +no_defs",
    "srid": 520004158,
    "auth_name": "EPSG",
    "auth_id": "9893",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 64159,
    "description": "LUREF / Luxembourg TM (3D)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +towgs84=-189.6806,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598 +units=m +no_defs",
    "srid": 520004159,
    "auth_name": "EPSG",
    "auth_id": "9895",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64160,
    "description": "LUREF / Luxembourg TM + NG95 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49.8333333333333 +lon_0=6.16666666666667 +k=1 +x_0=80000 +y_0=100000 +ellps=intl +towgs84=-189.6806,18.3463,-42.7695,-0.33746,-3.09264,2.53861,0.4598 +units=m +vunits=m +no_defs",
    "srid": 520004160,
    "auth_name": "EPSG",
    "auth_id": "9897",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64161,
    "description": "ETRS89 + Ostend height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=be_ign_hBG18.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520004161,
    "auth_name": "EPSG",
    "auth_id": "9907",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64162,
    "description": "OSGB36 / British National Grid + BI height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +units=m +vunits=m +no_defs",
    "srid": 520004162,
    "auth_name": "EPSG",
    "auth_id": "9920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64163,
    "description": "ETRS89 / ITM + BI height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520004163,
    "auth_name": "EPSG",
    "auth_id": "9922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64167,
    "description": "DB_REF2003 zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs",
    "srid": 520004167,
    "auth_name": "EPSG",
    "auth_id": "9928",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64168,
    "description": "DB_REF2003 zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs",
    "srid": 520004168,
    "auth_name": "EPSG",
    "auth_id": "9929",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64169,
    "description": "DB_REF2003 zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs",
    "srid": 520004169,
    "auth_name": "EPSG",
    "auth_id": "9930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64170,
    "description": "DB_REF2003 zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs",
    "srid": 520004170,
    "auth_name": "EPSG",
    "auth_id": "9931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64171,
    "description": "DB_REF2016 zone 2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs",
    "srid": 520004171,
    "auth_name": "EPSG",
    "auth_id": "9932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64172,
    "description": "DB_REF2016 zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs",
    "srid": 520004172,
    "auth_name": "EPSG",
    "auth_id": "9933",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64173,
    "description": "DB_REF2016 zone 4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs",
    "srid": 520004173,
    "auth_name": "EPSG",
    "auth_id": "9934",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64174,
    "description": "DB_REF2016 zone 5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +vunits=m +no_defs",
    "srid": 520004174,
    "auth_name": "EPSG",
    "auth_id": "9935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64175,
    "description": "EBBWV14-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004175,
    "auth_name": "EPSG",
    "auth_id": "9939",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64176,
    "description": "EBBWV14 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=51.75 +lon_0=-3.1 +k=1 +x_0=106702.326 +y_0=119968.1395 +ellps=GRS80 +units=m +no_defs",
    "srid": 520004176,
    "auth_name": "EPSG",
    "auth_id": "9943",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64177,
    "description": "EBBWV14 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=51.75 +lon_0=-3.1 +k=1 +x_0=106702.326 +y_0=119968.1395 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520004177,
    "auth_name": "EPSG",
    "auth_id": "9944",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64178,
    "description": "Macedonia State Coordinate System truncated",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=21 +k=0.9999 +x_0=500000 +y_0=-4000000 +ellps=bessel +towgs84=521.748,229.489,590.921,4.029,4.488,-15.521,-9.78 +units=m +no_defs",
    "srid": 520004178,
    "auth_name": "EPSG",
    "auth_id": "9945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64179,
    "description": "ISN2004 / LAEA Iceland",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=65 +lon_0=-19 +x_0=1700000 +y_0=1300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520004179,
    "auth_name": "EPSG",
    "auth_id": "9947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64180,
    "description": "ISN93 + ISH2004 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520004180,
    "auth_name": "EPSG",
    "auth_id": "9948",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64181,
    "description": "ISN2004 + ISH2004 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520004181,
    "auth_name": "EPSG",
    "auth_id": "9949",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64182,
    "description": "ISN2016 + ISH2004 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520004182,
    "auth_name": "EPSG",
    "auth_id": "9950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64183,
    "description": "ISN93 / Lambert 1993 + ISH2004 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520004183,
    "auth_name": "EPSG",
    "auth_id": "9951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64184,
    "description": "ISN2004 / Lambert 2004 + ISH2004 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=1700000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520004184,
    "auth_name": "EPSG",
    "auth_id": "9952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64185,
    "description": "ISN2016 / Lambert 2016 + ISH2004 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=2700000 +y_0=300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520004185,
    "auth_name": "EPSG",
    "auth_id": "9953",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64186,
    "description": "HULLEE13-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004186,
    "auth_name": "EPSG",
    "auth_id": "9964",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64187,
    "description": "HULLEE13 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=53.75 +lon_0=-0.95 +k=1 +x_0=140859.7394 +y_0=247512.2812 +ellps=GRS80 +units=m +no_defs",
    "srid": 520004187,
    "auth_name": "EPSG",
    "auth_id": "9967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64188,
    "description": "HULLEE13 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=53.75 +lon_0=-0.95 +k=1 +x_0=140859.7394 +y_0=247512.2812 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520004188,
    "auth_name": "EPSG",
    "auth_id": "9968",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64189,
    "description": "SCM22-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004189,
    "auth_name": "EPSG",
    "auth_id": "9969",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64190,
    "description": "SCM22 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=56.6 +lon_0=-3.85 +k=1 +x_0=108600.972 +y_0=239087.349 +ellps=GRS80 +units=m +no_defs",
    "srid": 520004190,
    "auth_name": "EPSG",
    "auth_id": "9972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64191,
    "description": "SCM22 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=56.6 +lon_0=-3.85 +k=1 +x_0=108600.972 +y_0=239087.349 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520004191,
    "auth_name": "EPSG",
    "auth_id": "9973",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64192,
    "description": "FNL22-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004192,
    "auth_name": "EPSG",
    "auth_id": "9974",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64193,
    "description": "FNL22 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=-3.8 +k=1 +x_0=139618.9493 +y_0=183110.794 +ellps=GRS80 +units=m +no_defs",
    "srid": 520004193,
    "auth_name": "EPSG",
    "auth_id": "9977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64194,
    "description": "FNL22 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=58 +lon_0=-3.8 +k=1 +x_0=139618.9493 +y_0=183110.794 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520004194,
    "auth_name": "EPSG",
    "auth_id": "9978",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 64195,
    "description": "ITRF2020",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520004195,
    "auth_name": "EPSG",
    "auth_id": "9988",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 64196,
    "description": "ITRF2020",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004196,
    "auth_name": "EPSG",
    "auth_id": "9989",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 64197,
    "description": "ITRF2020",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520004197,
    "auth_name": "EPSG",
    "auth_id": "9990",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64198,
    "description": "WGS_1984_California_Teale_Albers_Ft_Intl",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-1219200 +datum=WGS84 +units=ft +no_defs",
    "srid": 520004198,
    "auth_name": "ESRI",
    "auth_id": "102759",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64199,
    "description": "NAD_1983_California_Teale_Albers_Ft_Intl",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-1219200 +ellps=GRS80 +towgs84=0.9956,-1.9013,-0.5215,-0.025915,-0.009426,-0.011599,0.00062 +units=ft +no_defs",
    "srid": 520004199,
    "auth_name": "ESRI",
    "auth_id": "102760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64233,
    "description": "Cassini_Bangladesh_Zone_01_Dinajpur",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=25.5 +lon_0=88.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004233,
    "auth_name": "ESRI",
    "auth_id": "102934",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64234,
    "description": "Cassini_Bangladesh_Zone_02_Rangpur",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=25.5 +lon_0=89.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004234,
    "auth_name": "ESRI",
    "auth_id": "102935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64235,
    "description": "Cassini_Bangladesh_Zone_03_Rajshahi",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=24.5 +lon_0=88.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004235,
    "auth_name": "ESRI",
    "auth_id": "102936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64236,
    "description": "Cassini_Bangladesh_Zone_04_Bogura",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=24.5 +lon_0=89.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004236,
    "auth_name": "ESRI",
    "auth_id": "102937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64237,
    "description": "Cassini_Bangladesh_Zone_05_Pabna",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=24.5 +lon_0=89.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004237,
    "auth_name": "ESRI",
    "auth_id": "102938",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64238,
    "description": "Cassini_Bangladesh_Zone_06_Mymensingh",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=24.5 +lon_0=90.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004238,
    "auth_name": "ESRI",
    "auth_id": "102939",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64239,
    "description": "Cassini_Bangladesh_Zone_07_Dhaka",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=24.5 +lon_0=90.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004239,
    "auth_name": "ESRI",
    "auth_id": "102940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64240,
    "description": "Cassini_Bangladesh_Zone_08_Faridpur",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=23.5 +lon_0=90 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004240,
    "auth_name": "ESRI",
    "auth_id": "102941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64241,
    "description": "Cassini_Bangladesh_Zone_09_Sylhet",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=24.5 +lon_0=92 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004241,
    "auth_name": "ESRI",
    "auth_id": "102942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64242,
    "description": "Cassini_Bangladesh_Zone_10_Kushtia",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=23.5 +lon_0=89.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004242,
    "auth_name": "ESRI",
    "auth_id": "102943",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64243,
    "description": "Cassini_Bangladesh_Zone_11_Joshore",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=23.5 +lon_0=89.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004243,
    "auth_name": "ESRI",
    "auth_id": "102944",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64244,
    "description": "Cassini_Bangladesh_Zone_12_Khulna",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=22.5 +lon_0=89.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004244,
    "auth_name": "ESRI",
    "auth_id": "102945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64245,
    "description": "Cassini_Bangladesh_Zone_13_Barishal",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=22.5 +lon_0=90.5 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004245,
    "auth_name": "ESRI",
    "auth_id": "102946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64246,
    "description": "Cassini_Bangladesh_Zone_14_Cumilla",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=23.5 +lon_0=91 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004246,
    "auth_name": "ESRI",
    "auth_id": "102947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64247,
    "description": "Cassini_Bangladesh_Zone_15_Noakhali",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=23.5 +lon_0=91 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004247,
    "auth_name": "ESRI",
    "auth_id": "102948",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64248,
    "description": "Cassini_Bangladesh_Zone_16_Chottogram",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=22 +lon_0=92 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004248,
    "auth_name": "ESRI",
    "auth_id": "102949",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64249,
    "description": "Cassini_Bangladesh_Zone_17_CHT",
    "projection_acronym": "cass",
    "ellipsoid_acronym": "cass",
    "parameters": "+proj=cass +lat_0=22.75 +lon_0=92.25 +x_0=0 +y_0=0 +a=6377299.36559538 +b=6356098.35900516 +units=ch +no_defs",
    "srid": 520004249,
    "auth_name": "ESRI",
    "auth_id": "102950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64250,
    "description": "LCC_Bangladesh",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=26 +lon_0=90 +lat_1=23.15 +lat_2=28.8 +x_0=2743183.6991 +y_0=914395.233 +datum=WGS84 +units=m +no_defs",
    "srid": 520004250,
    "auth_name": "ESRI",
    "auth_id": "102951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64251,
    "description": "LCC_Gulshan",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=26 +lon_0=90 +lat_1=23.15 +lat_2=28.8 +x_0=2743183.6991 +y_0=914395.233 +ellps=evrst30 +towgs84=283.729,735.942,261.143,0,0,0,0 +units=m +no_defs",
    "srid": 520004251,
    "auth_name": "ESRI",
    "auth_id": "102952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64252,
    "description": "UTM_Bangladesh_(BTM)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=-2000000 +ellps=evrst30 +towgs84=283.729,735.942,261.143,0,0,0,0 +units=m +no_defs",
    "srid": 520004252,
    "auth_name": "ESRI",
    "auth_id": "102953",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64253,
    "description": "BUTM2010",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=0 +datum=WGS84 +units=m +no_defs",
    "srid": 520004253,
    "auth_name": "ESRI",
    "auth_id": "102954",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64254,
    "description": "UTM_Gulshan",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=90 +k=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +towgs84=283.729,735.942,261.143,0,0,0,0 +units=m +no_defs",
    "srid": 520004254,
    "auth_name": "ESRI",
    "auth_id": "102955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64255,
    "description": "AGD_1966_ISG_57_2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=159 +k=0.99994 +x_0=300000 +y_0=5000000 +ellps=aust_SA +towgs84=-117.808,-51.536,137.784,0.303,0.446,0.234,-0.29 +units=m +no_defs",
    "srid": 520004255,
    "auth_name": "ESRI",
    "auth_id": "102961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64260,
    "description": "Moon_2000_North_Pole_Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520004260,
    "auth_name": "ESRI",
    "auth_id": "103877",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64261,
    "description": "Moon_2000_South_Pole_Stereographic",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520004261,
    "auth_name": "ESRI",
    "auth_id": "103878",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64262,
    "description": "Moon_2000_Far_Side_Lambert_Azimuthal_Equal_Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520004262,
    "auth_name": "ESRI",
    "auth_id": "103879",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64263,
    "description": "Moon_2000_Near_Side_Lambert_Azimuthal_Equal_Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520004263,
    "auth_name": "ESRI",
    "auth_id": "103880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64264,
    "description": "Moon_2000_Equidistant_Cylindrical",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520004264,
    "auth_name": "ESRI",
    "auth_id": "103881",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64265,
    "description": "Moon_2000_Sinusoidal",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520004265,
    "auth_name": "ESRI",
    "auth_id": "103882",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64266,
    "description": "Mars_2000_North_Pole_Stereographic_sphere",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520004266,
    "auth_name": "ESRI",
    "auth_id": "103883",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64267,
    "description": "Mars_2000_South_Pole_Stereographic_sphere",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520004267,
    "auth_name": "ESRI",
    "auth_id": "103884",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64268,
    "description": "Mars_2000_Equidistant_Cylindrical_sphere",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520004268,
    "auth_name": "ESRI",
    "auth_id": "103885",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64269,
    "description": "Mars_2000_Sinusoidal_sphere",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520004269,
    "auth_name": "ESRI",
    "auth_id": "103886",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64270,
    "description": "Mars_2000_Winkel_Tripel_sphere",
    "projection_acronym": "wintri",
    "ellipsoid_acronym": "wintri",
    "parameters": "+proj=wintri +lon_0=0 +lat_1=50.4666666666667 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520004270,
    "auth_name": "ESRI",
    "auth_id": "103887",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64271,
    "description": "Phobos_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=11080 +no_defs",
    "srid": 520004271,
    "auth_name": "ESRI",
    "auth_id": "104872",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64272,
    "description": "Callisto_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2410300 +no_defs",
    "srid": 520004272,
    "auth_name": "ESRI",
    "auth_id": "104873",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64273,
    "description": "Europa_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1560800 +no_defs",
    "srid": 520004273,
    "auth_name": "ESRI",
    "auth_id": "104874",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64274,
    "description": "Ganymede_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2631200 +no_defs",
    "srid": 520004274,
    "auth_name": "ESRI",
    "auth_id": "104875",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64275,
    "description": "Io_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1821490 +no_defs",
    "srid": 520004275,
    "auth_name": "ESRI",
    "auth_id": "104876",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64276,
    "description": "Metis_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=21500 +no_defs",
    "srid": 520004276,
    "auth_name": "ESRI",
    "auth_id": "104877",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64277,
    "description": "Aegaeon_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=330 +no_defs",
    "srid": 520004277,
    "auth_name": "ESRI",
    "auth_id": "104878",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64278,
    "description": "Anthe_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=500 +no_defs",
    "srid": 520004278,
    "auth_name": "ESRI",
    "auth_id": "104879",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64279,
    "description": "Pandora_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=40600 +no_defs",
    "srid": 520004279,
    "auth_name": "ESRI",
    "auth_id": "104897",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64280,
    "description": "Phoebe_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=106500 +no_defs",
    "srid": 520004280,
    "auth_name": "ESRI",
    "auth_id": "104898",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64281,
    "description": "Polydeuces_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1300 +no_defs",
    "srid": 520004281,
    "auth_name": "ESRI",
    "auth_id": "104899",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64282,
    "description": "Atlas_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=15100 +no_defs",
    "srid": 520004282,
    "auth_name": "ESRI",
    "auth_id": "104976",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64283,
    "description": "Calypso_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=9600 +no_defs",
    "srid": 520004283,
    "auth_name": "ESRI",
    "auth_id": "104977",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64284,
    "description": "Daphnis_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=3800 +no_defs",
    "srid": 520004284,
    "auth_name": "ESRI",
    "auth_id": "104978",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64285,
    "description": "Dione_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=561400 +no_defs",
    "srid": 520004285,
    "auth_name": "ESRI",
    "auth_id": "104979",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64286,
    "description": "Enceladus_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=252100 +no_defs",
    "srid": 520004286,
    "auth_name": "ESRI",
    "auth_id": "104980",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64287,
    "description": "Epimetheus_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=58200 +no_defs",
    "srid": 520004287,
    "auth_name": "ESRI",
    "auth_id": "104981",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64288,
    "description": "Helene_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=18000 +no_defs",
    "srid": 520004288,
    "auth_name": "ESRI",
    "auth_id": "104982",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64289,
    "description": "Hyperion_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=135000 +no_defs",
    "srid": 520004289,
    "auth_name": "ESRI",
    "auth_id": "104983",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64290,
    "description": "Iapetus_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=745700 +no_defs",
    "srid": 520004290,
    "auth_name": "ESRI",
    "auth_id": "104984",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64291,
    "description": "Janus_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=89200 +no_defs",
    "srid": 520004291,
    "auth_name": "ESRI",
    "auth_id": "104985",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64292,
    "description": "Methone_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1450 +no_defs",
    "srid": 520004292,
    "auth_name": "ESRI",
    "auth_id": "104986",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64293,
    "description": "Mimas_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=198200 +no_defs",
    "srid": 520004293,
    "auth_name": "ESRI",
    "auth_id": "104987",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64294,
    "description": "Pallene_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2230 +no_defs",
    "srid": 520004294,
    "auth_name": "ESRI",
    "auth_id": "104988",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64295,
    "description": "Pan_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=14000 +no_defs",
    "srid": 520004295,
    "auth_name": "ESRI",
    "auth_id": "104989",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64296,
    "description": "Prometheus_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=43100 +no_defs",
    "srid": 520004296,
    "auth_name": "ESRI",
    "auth_id": "104993",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64297,
    "description": "Rhea_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=763500 +no_defs",
    "srid": 520004297,
    "auth_name": "ESRI",
    "auth_id": "104994",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64298,
    "description": "Telesto_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=12400 +no_defs",
    "srid": 520004298,
    "auth_name": "ESRI",
    "auth_id": "104995",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64299,
    "description": "Tethys_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=531000 +no_defs",
    "srid": 520004299,
    "auth_name": "ESRI",
    "auth_id": "104996",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64300,
    "description": "Larissa_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=96000 +no_defs",
    "srid": 520004300,
    "auth_name": "ESRI",
    "auth_id": "104997",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64301,
    "description": "Pluto_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1188300 +no_defs",
    "srid": 520004301,
    "auth_name": "ESRI",
    "auth_id": "104998",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64302,
    "description": "Charon_2015",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=606000 +no_defs",
    "srid": 520004302,
    "auth_name": "ESRI",
    "auth_id": "104999",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64686,
    "description": "Sun (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=695700000 +no_defs",
    "srid": 520004686,
    "auth_name": "IAU_2015",
    "auth_id": "1000",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64687,
    "description": "Borrelly (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=4220 +no_defs",
    "srid": 520004687,
    "auth_name": "IAU_2015",
    "auth_id": "100000500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64688,
    "description": "Borrelly (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004688,
    "auth_name": "IAU_2015",
    "auth_id": "100000510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64689,
    "description": "Borrelly (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004689,
    "auth_name": "IAU_2015",
    "auth_id": "100000515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64690,
    "description": "Borrelly (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004690,
    "auth_name": "IAU_2015",
    "auth_id": "100000520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64691,
    "description": "Borrelly (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004691,
    "auth_name": "IAU_2015",
    "auth_id": "100000525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64692,
    "description": "Borrelly (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004692,
    "auth_name": "IAU_2015",
    "auth_id": "100000530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64693,
    "description": "Borrelly (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004693,
    "auth_name": "IAU_2015",
    "auth_id": "100000535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64694,
    "description": "Borrelly (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004694,
    "auth_name": "IAU_2015",
    "auth_id": "100000540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64695,
    "description": "Borrelly (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004695,
    "auth_name": "IAU_2015",
    "auth_id": "100000545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64696,
    "description": "Borrelly (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004696,
    "auth_name": "IAU_2015",
    "auth_id": "100000550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64697,
    "description": "Borrelly (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004697,
    "auth_name": "IAU_2015",
    "auth_id": "100000555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64698,
    "description": "Borrelly (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004698,
    "auth_name": "IAU_2015",
    "auth_id": "100000560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64699,
    "description": "Borrelly (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004699,
    "auth_name": "IAU_2015",
    "auth_id": "100000565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64700,
    "description": "Borrelly (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004700,
    "auth_name": "IAU_2015",
    "auth_id": "100000570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64701,
    "description": "Borrelly (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004701,
    "auth_name": "IAU_2015",
    "auth_id": "100000575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64702,
    "description": "Borrelly (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004702,
    "auth_name": "IAU_2015",
    "auth_id": "100000580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64703,
    "description": "Borrelly (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520004703,
    "auth_name": "IAU_2015",
    "auth_id": "100000585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64704,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1650 +no_defs",
    "srid": 520004704,
    "auth_name": "IAU_2015",
    "auth_id": "100001200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64705,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004705,
    "auth_name": "IAU_2015",
    "auth_id": "100001210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64706,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004706,
    "auth_name": "IAU_2015",
    "auth_id": "100001215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64707,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004707,
    "auth_name": "IAU_2015",
    "auth_id": "100001220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64708,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004708,
    "auth_name": "IAU_2015",
    "auth_id": "100001225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64709,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004709,
    "auth_name": "IAU_2015",
    "auth_id": "100001230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64710,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004710,
    "auth_name": "IAU_2015",
    "auth_id": "100001235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64711,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004711,
    "auth_name": "IAU_2015",
    "auth_id": "100001240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64712,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004712,
    "auth_name": "IAU_2015",
    "auth_id": "100001245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64713,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004713,
    "auth_name": "IAU_2015",
    "auth_id": "100001250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64714,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004714,
    "auth_name": "IAU_2015",
    "auth_id": "100001255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64715,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004715,
    "auth_name": "IAU_2015",
    "auth_id": "100001260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64716,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004716,
    "auth_name": "IAU_2015",
    "auth_id": "100001265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64717,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004717,
    "auth_name": "IAU_2015",
    "auth_id": "100001270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64718,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004718,
    "auth_name": "IAU_2015",
    "auth_id": "100001275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64719,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004719,
    "auth_name": "IAU_2015",
    "auth_id": "100001280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64720,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520004720,
    "auth_name": "IAU_2015",
    "auth_id": "100001285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64721,
    "description": "Halley (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=8000 +no_defs",
    "srid": 520004721,
    "auth_name": "IAU_2015",
    "auth_id": "100003600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64722,
    "description": "Halley (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=8000 +b=4000 +no_defs",
    "srid": 520004722,
    "auth_name": "IAU_2015",
    "auth_id": "100003601",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64723,
    "description": "Halley (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520004723,
    "auth_name": "IAU_2015",
    "auth_id": "100003602",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 64724,
    "description": "Halley (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004724,
    "auth_name": "IAU_2015",
    "auth_id": "100003610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64725,
    "description": "Halley (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004725,
    "auth_name": "IAU_2015",
    "auth_id": "100003611",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64726,
    "description": "Halley (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004726,
    "auth_name": "IAU_2015",
    "auth_id": "100003615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64727,
    "description": "Halley (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004727,
    "auth_name": "IAU_2015",
    "auth_id": "100003616",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64728,
    "description": "Halley (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004728,
    "auth_name": "IAU_2015",
    "auth_id": "100003620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64729,
    "description": "Halley (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004729,
    "auth_name": "IAU_2015",
    "auth_id": "100003621",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64730,
    "description": "Halley (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004730,
    "auth_name": "IAU_2015",
    "auth_id": "100003625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64731,
    "description": "Halley (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004731,
    "auth_name": "IAU_2015",
    "auth_id": "100003626",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64732,
    "description": "Halley (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004732,
    "auth_name": "IAU_2015",
    "auth_id": "100003630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64733,
    "description": "Halley (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004733,
    "auth_name": "IAU_2015",
    "auth_id": "100003631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64734,
    "description": "Halley (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004734,
    "auth_name": "IAU_2015",
    "auth_id": "100003635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64735,
    "description": "Halley (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004735,
    "auth_name": "IAU_2015",
    "auth_id": "100003636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64736,
    "description": "Halley (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004736,
    "auth_name": "IAU_2015",
    "auth_id": "100003640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64737,
    "description": "Halley (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004737,
    "auth_name": "IAU_2015",
    "auth_id": "100003641",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64738,
    "description": "Halley (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004738,
    "auth_name": "IAU_2015",
    "auth_id": "100003645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64739,
    "description": "Halley (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004739,
    "auth_name": "IAU_2015",
    "auth_id": "100003646",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64740,
    "description": "Halley (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004740,
    "auth_name": "IAU_2015",
    "auth_id": "100003650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64741,
    "description": "Halley (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004741,
    "auth_name": "IAU_2015",
    "auth_id": "100003651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64742,
    "description": "Halley (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004742,
    "auth_name": "IAU_2015",
    "auth_id": "100003655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64743,
    "description": "Halley (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004743,
    "auth_name": "IAU_2015",
    "auth_id": "100003656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64744,
    "description": "Halley (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004744,
    "auth_name": "IAU_2015",
    "auth_id": "100003660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64745,
    "description": "Halley (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004745,
    "auth_name": "IAU_2015",
    "auth_id": "100003661",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64746,
    "description": "Halley (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004746,
    "auth_name": "IAU_2015",
    "auth_id": "100003665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64747,
    "description": "Halley (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004747,
    "auth_name": "IAU_2015",
    "auth_id": "100003666",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64748,
    "description": "Halley (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004748,
    "auth_name": "IAU_2015",
    "auth_id": "100003670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64749,
    "description": "Halley (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004749,
    "auth_name": "IAU_2015",
    "auth_id": "100003671",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64750,
    "description": "Halley (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004750,
    "auth_name": "IAU_2015",
    "auth_id": "100003675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64751,
    "description": "Halley (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004751,
    "auth_name": "IAU_2015",
    "auth_id": "100003676",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64752,
    "description": "Halley (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004752,
    "auth_name": "IAU_2015",
    "auth_id": "100003680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64753,
    "description": "Halley (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004753,
    "auth_name": "IAU_2015",
    "auth_id": "100003681",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64754,
    "description": "Halley (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520004754,
    "auth_name": "IAU_2015",
    "auth_id": "100003685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64755,
    "description": "Halley (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520004755,
    "auth_name": "IAU_2015",
    "auth_id": "100003686",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64756,
    "description": "Hartley 2 (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=580 +no_defs",
    "srid": 520004756,
    "auth_name": "IAU_2015",
    "auth_id": "100004100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64757,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004757,
    "auth_name": "IAU_2015",
    "auth_id": "100004110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64758,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004758,
    "auth_name": "IAU_2015",
    "auth_id": "100004115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64759,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004759,
    "auth_name": "IAU_2015",
    "auth_id": "100004120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64760,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004760,
    "auth_name": "IAU_2015",
    "auth_id": "100004125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64761,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004761,
    "auth_name": "IAU_2015",
    "auth_id": "100004130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64762,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004762,
    "auth_name": "IAU_2015",
    "auth_id": "100004135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64763,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004763,
    "auth_name": "IAU_2015",
    "auth_id": "100004140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64764,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004764,
    "auth_name": "IAU_2015",
    "auth_id": "100004145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64765,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004765,
    "auth_name": "IAU_2015",
    "auth_id": "100004150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64766,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004766,
    "auth_name": "IAU_2015",
    "auth_id": "100004155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64767,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004767,
    "auth_name": "IAU_2015",
    "auth_id": "100004160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64768,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004768,
    "auth_name": "IAU_2015",
    "auth_id": "100004165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64769,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004769,
    "auth_name": "IAU_2015",
    "auth_id": "100004170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64770,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004770,
    "auth_name": "IAU_2015",
    "auth_id": "100004175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64771,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004771,
    "auth_name": "IAU_2015",
    "auth_id": "100004180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64772,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520004772,
    "auth_name": "IAU_2015",
    "auth_id": "100004185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64773,
    "description": "Tempel 1 (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=3000 +no_defs",
    "srid": 520004773,
    "auth_name": "IAU_2015",
    "auth_id": "100009300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64774,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004774,
    "auth_name": "IAU_2015",
    "auth_id": "100009310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64775,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004775,
    "auth_name": "IAU_2015",
    "auth_id": "100009315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64776,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004776,
    "auth_name": "IAU_2015",
    "auth_id": "100009320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64777,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004777,
    "auth_name": "IAU_2015",
    "auth_id": "100009325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64778,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004778,
    "auth_name": "IAU_2015",
    "auth_id": "100009330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64779,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004779,
    "auth_name": "IAU_2015",
    "auth_id": "100009335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64780,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004780,
    "auth_name": "IAU_2015",
    "auth_id": "100009340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64781,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004781,
    "auth_name": "IAU_2015",
    "auth_id": "100009345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64782,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004782,
    "auth_name": "IAU_2015",
    "auth_id": "100009350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64783,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004783,
    "auth_name": "IAU_2015",
    "auth_id": "100009355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64784,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004784,
    "auth_name": "IAU_2015",
    "auth_id": "100009360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64785,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004785,
    "auth_name": "IAU_2015",
    "auth_id": "100009365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64786,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004786,
    "auth_name": "IAU_2015",
    "auth_id": "100009370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64787,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004787,
    "auth_name": "IAU_2015",
    "auth_id": "100009375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64788,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004788,
    "auth_name": "IAU_2015",
    "auth_id": "100009380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64789,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520004789,
    "auth_name": "IAU_2015",
    "auth_id": "100009385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64790,
    "description": "Wild 2 (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1975 +no_defs",
    "srid": 520004790,
    "auth_name": "IAU_2015",
    "auth_id": "100010700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64791,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004791,
    "auth_name": "IAU_2015",
    "auth_id": "100010710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64792,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004792,
    "auth_name": "IAU_2015",
    "auth_id": "100010715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64793,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004793,
    "auth_name": "IAU_2015",
    "auth_id": "100010720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64794,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004794,
    "auth_name": "IAU_2015",
    "auth_id": "100010725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64795,
    "description": "Wild 2 (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004795,
    "auth_name": "IAU_2015",
    "auth_id": "100010730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64796,
    "description": "Wild 2 (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004796,
    "auth_name": "IAU_2015",
    "auth_id": "100010735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64797,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004797,
    "auth_name": "IAU_2015",
    "auth_id": "100010740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64798,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004798,
    "auth_name": "IAU_2015",
    "auth_id": "100010745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64799,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004799,
    "auth_name": "IAU_2015",
    "auth_id": "100010750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64800,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004800,
    "auth_name": "IAU_2015",
    "auth_id": "100010755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64801,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004801,
    "auth_name": "IAU_2015",
    "auth_id": "100010760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64802,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004802,
    "auth_name": "IAU_2015",
    "auth_id": "100010765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64803,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004803,
    "auth_name": "IAU_2015",
    "auth_id": "100010770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64804,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004804,
    "auth_name": "IAU_2015",
    "auth_id": "100010775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64805,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004805,
    "auth_name": "IAU_2015",
    "auth_id": "100010780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64806,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520004806,
    "auth_name": "IAU_2015",
    "auth_id": "100010785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64807,
    "description": "Sun (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004807,
    "auth_name": "IAU_2015",
    "auth_id": "1010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64808,
    "description": "Sun (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004808,
    "auth_name": "IAU_2015",
    "auth_id": "1015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64809,
    "description": "Sun (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004809,
    "auth_name": "IAU_2015",
    "auth_id": "1020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64810,
    "description": "Sun (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004810,
    "auth_name": "IAU_2015",
    "auth_id": "1025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64811,
    "description": "Sun (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004811,
    "auth_name": "IAU_2015",
    "auth_id": "1030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64812,
    "description": "Sun (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004812,
    "auth_name": "IAU_2015",
    "auth_id": "1035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64813,
    "description": "Sun (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004813,
    "auth_name": "IAU_2015",
    "auth_id": "1040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64814,
    "description": "Sun (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004814,
    "auth_name": "IAU_2015",
    "auth_id": "1045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64815,
    "description": "Sun (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004815,
    "auth_name": "IAU_2015",
    "auth_id": "1050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64816,
    "description": "Sun (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004816,
    "auth_name": "IAU_2015",
    "auth_id": "1055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64817,
    "description": "Sun (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004817,
    "auth_name": "IAU_2015",
    "auth_id": "1060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64818,
    "description": "Sun (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004818,
    "auth_name": "IAU_2015",
    "auth_id": "1065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64819,
    "description": "Sun (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004819,
    "auth_name": "IAU_2015",
    "auth_id": "1070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64820,
    "description": "Sun (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004820,
    "auth_name": "IAU_2015",
    "auth_id": "1075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64821,
    "description": "Sun (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004821,
    "auth_name": "IAU_2015",
    "auth_id": "1080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64822,
    "description": "Sun (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520004822,
    "auth_name": "IAU_2015",
    "auth_id": "1085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64823,
    "description": "Mercury (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2440530 +no_defs",
    "srid": 520004823,
    "auth_name": "IAU_2015",
    "auth_id": "19900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64824,
    "description": "Mercury (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=2440530 +b=2438260 +no_defs",
    "srid": 520004824,
    "auth_name": "IAU_2015",
    "auth_id": "19901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64825,
    "description": "Mercury (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520004825,
    "auth_name": "IAU_2015",
    "auth_id": "19902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 64826,
    "description": "Mercury (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004826,
    "auth_name": "IAU_2015",
    "auth_id": "19910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64827,
    "description": "Mercury (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004827,
    "auth_name": "IAU_2015",
    "auth_id": "19911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64828,
    "description": "Mercury (2015) / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004828,
    "auth_name": "IAU_2015",
    "auth_id": "19912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64829,
    "description": "Mercury (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004829,
    "auth_name": "IAU_2015",
    "auth_id": "19915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64830,
    "description": "Mercury (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004830,
    "auth_name": "IAU_2015",
    "auth_id": "19916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64831,
    "description": "Mercury (2015) / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004831,
    "auth_name": "IAU_2015",
    "auth_id": "19917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64832,
    "description": "Mercury (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004832,
    "auth_name": "IAU_2015",
    "auth_id": "19920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64833,
    "description": "Mercury (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004833,
    "auth_name": "IAU_2015",
    "auth_id": "19921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64834,
    "description": "Mercury (2015) / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004834,
    "auth_name": "IAU_2015",
    "auth_id": "19922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64835,
    "description": "Mercury (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004835,
    "auth_name": "IAU_2015",
    "auth_id": "19925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64836,
    "description": "Mercury (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004836,
    "auth_name": "IAU_2015",
    "auth_id": "19926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64837,
    "description": "Mercury (2015) / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004837,
    "auth_name": "IAU_2015",
    "auth_id": "19927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64838,
    "description": "Mercury (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004838,
    "auth_name": "IAU_2015",
    "auth_id": "19930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64839,
    "description": "Mercury (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004839,
    "auth_name": "IAU_2015",
    "auth_id": "19931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64840,
    "description": "Mercury (2015) / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004840,
    "auth_name": "IAU_2015",
    "auth_id": "19932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64841,
    "description": "Mercury (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004841,
    "auth_name": "IAU_2015",
    "auth_id": "19935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64842,
    "description": "Mercury (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004842,
    "auth_name": "IAU_2015",
    "auth_id": "19936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64843,
    "description": "Mercury (2015) / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004843,
    "auth_name": "IAU_2015",
    "auth_id": "19937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64844,
    "description": "Mercury (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004844,
    "auth_name": "IAU_2015",
    "auth_id": "19940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64845,
    "description": "Mercury (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004845,
    "auth_name": "IAU_2015",
    "auth_id": "19941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64846,
    "description": "Mercury (2015) / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004846,
    "auth_name": "IAU_2015",
    "auth_id": "19942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64847,
    "description": "Mercury (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004847,
    "auth_name": "IAU_2015",
    "auth_id": "19945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64848,
    "description": "Mercury (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004848,
    "auth_name": "IAU_2015",
    "auth_id": "19946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64849,
    "description": "Mercury (2015) / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004849,
    "auth_name": "IAU_2015",
    "auth_id": "19947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64850,
    "description": "Mercury (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004850,
    "auth_name": "IAU_2015",
    "auth_id": "19950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64851,
    "description": "Mercury (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004851,
    "auth_name": "IAU_2015",
    "auth_id": "19951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64852,
    "description": "Mercury (2015) / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004852,
    "auth_name": "IAU_2015",
    "auth_id": "19952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64853,
    "description": "Mercury (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004853,
    "auth_name": "IAU_2015",
    "auth_id": "19955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64854,
    "description": "Mercury (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004854,
    "auth_name": "IAU_2015",
    "auth_id": "19956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64855,
    "description": "Mercury (2015) / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004855,
    "auth_name": "IAU_2015",
    "auth_id": "19957",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64856,
    "description": "Mercury (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004856,
    "auth_name": "IAU_2015",
    "auth_id": "19960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64857,
    "description": "Mercury (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004857,
    "auth_name": "IAU_2015",
    "auth_id": "19961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64858,
    "description": "Mercury (2015) / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004858,
    "auth_name": "IAU_2015",
    "auth_id": "19962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64859,
    "description": "Mercury (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004859,
    "auth_name": "IAU_2015",
    "auth_id": "19965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64860,
    "description": "Mercury (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004860,
    "auth_name": "IAU_2015",
    "auth_id": "19966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64861,
    "description": "Mercury (2015) / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004861,
    "auth_name": "IAU_2015",
    "auth_id": "19967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64862,
    "description": "Mercury (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004862,
    "auth_name": "IAU_2015",
    "auth_id": "19970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64863,
    "description": "Mercury (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004863,
    "auth_name": "IAU_2015",
    "auth_id": "19971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64864,
    "description": "Mercury (2015) / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004864,
    "auth_name": "IAU_2015",
    "auth_id": "19972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64865,
    "description": "Mercury (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004865,
    "auth_name": "IAU_2015",
    "auth_id": "19975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64866,
    "description": "Mercury (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004866,
    "auth_name": "IAU_2015",
    "auth_id": "19976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64867,
    "description": "Mercury (2015) / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004867,
    "auth_name": "IAU_2015",
    "auth_id": "19977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64868,
    "description": "Mercury (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004868,
    "auth_name": "IAU_2015",
    "auth_id": "19980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64869,
    "description": "Mercury (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004869,
    "auth_name": "IAU_2015",
    "auth_id": "19981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64870,
    "description": "Mercury (2015) / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004870,
    "auth_name": "IAU_2015",
    "auth_id": "19982",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64871,
    "description": "Mercury (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520004871,
    "auth_name": "IAU_2015",
    "auth_id": "19985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64872,
    "description": "Mercury (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004872,
    "auth_name": "IAU_2015",
    "auth_id": "19986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64873,
    "description": "Mercury (2015) / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520004873,
    "auth_name": "IAU_2015",
    "auth_id": "19987",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64874,
    "description": "Ceres (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=487300 +no_defs",
    "srid": 520004874,
    "auth_name": "IAU_2015",
    "auth_id": "200000100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64875,
    "description": "Ceres (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=487300 +b=446000 +no_defs",
    "srid": 520004875,
    "auth_name": "IAU_2015",
    "auth_id": "200000101",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64876,
    "description": "Ceres (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520004876,
    "auth_name": "IAU_2015",
    "auth_id": "200000102",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 64877,
    "description": "Ceres (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004877,
    "auth_name": "IAU_2015",
    "auth_id": "200000110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64878,
    "description": "Ceres (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004878,
    "auth_name": "IAU_2015",
    "auth_id": "200000111",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64879,
    "description": "Ceres (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004879,
    "auth_name": "IAU_2015",
    "auth_id": "200000115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64880,
    "description": "Ceres (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004880,
    "auth_name": "IAU_2015",
    "auth_id": "200000116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64881,
    "description": "Ceres (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004881,
    "auth_name": "IAU_2015",
    "auth_id": "200000120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64882,
    "description": "Ceres (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004882,
    "auth_name": "IAU_2015",
    "auth_id": "200000121",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64883,
    "description": "Ceres (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004883,
    "auth_name": "IAU_2015",
    "auth_id": "200000125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64884,
    "description": "Ceres (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004884,
    "auth_name": "IAU_2015",
    "auth_id": "200000126",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64885,
    "description": "Ceres (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004885,
    "auth_name": "IAU_2015",
    "auth_id": "200000130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64886,
    "description": "Ceres (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004886,
    "auth_name": "IAU_2015",
    "auth_id": "200000131",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64887,
    "description": "Ceres (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004887,
    "auth_name": "IAU_2015",
    "auth_id": "200000135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64888,
    "description": "Ceres (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004888,
    "auth_name": "IAU_2015",
    "auth_id": "200000136",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64889,
    "description": "Ceres (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004889,
    "auth_name": "IAU_2015",
    "auth_id": "200000140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64890,
    "description": "Ceres (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004890,
    "auth_name": "IAU_2015",
    "auth_id": "200000141",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64891,
    "description": "Ceres (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004891,
    "auth_name": "IAU_2015",
    "auth_id": "200000145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64892,
    "description": "Ceres (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004892,
    "auth_name": "IAU_2015",
    "auth_id": "200000146",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64893,
    "description": "Ceres (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004893,
    "auth_name": "IAU_2015",
    "auth_id": "200000150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64894,
    "description": "Ceres (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004894,
    "auth_name": "IAU_2015",
    "auth_id": "200000151",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64895,
    "description": "Ceres (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004895,
    "auth_name": "IAU_2015",
    "auth_id": "200000155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64896,
    "description": "Ceres (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004896,
    "auth_name": "IAU_2015",
    "auth_id": "200000156",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64897,
    "description": "Ceres (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004897,
    "auth_name": "IAU_2015",
    "auth_id": "200000160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64898,
    "description": "Ceres (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004898,
    "auth_name": "IAU_2015",
    "auth_id": "200000161",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64899,
    "description": "Ceres (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004899,
    "auth_name": "IAU_2015",
    "auth_id": "200000165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64900,
    "description": "Ceres (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004900,
    "auth_name": "IAU_2015",
    "auth_id": "200000166",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64901,
    "description": "Ceres (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004901,
    "auth_name": "IAU_2015",
    "auth_id": "200000170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64902,
    "description": "Ceres (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004902,
    "auth_name": "IAU_2015",
    "auth_id": "200000171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64903,
    "description": "Ceres (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004903,
    "auth_name": "IAU_2015",
    "auth_id": "200000175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64904,
    "description": "Ceres (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004904,
    "auth_name": "IAU_2015",
    "auth_id": "200000176",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64905,
    "description": "Ceres (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004905,
    "auth_name": "IAU_2015",
    "auth_id": "200000180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64906,
    "description": "Ceres (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004906,
    "auth_name": "IAU_2015",
    "auth_id": "200000181",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64907,
    "description": "Ceres (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520004907,
    "auth_name": "IAU_2015",
    "auth_id": "200000185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64908,
    "description": "Ceres (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520004908,
    "auth_name": "IAU_2015",
    "auth_id": "200000186",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64909,
    "description": "Vesta (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=255000 +no_defs",
    "srid": 520004909,
    "auth_name": "IAU_2015",
    "auth_id": "200000400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64910,
    "description": "Vesta (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004910,
    "auth_name": "IAU_2015",
    "auth_id": "200000410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64911,
    "description": "Vesta (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004911,
    "auth_name": "IAU_2015",
    "auth_id": "200000415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64912,
    "description": "Vesta (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004912,
    "auth_name": "IAU_2015",
    "auth_id": "200000420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64913,
    "description": "Vesta (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004913,
    "auth_name": "IAU_2015",
    "auth_id": "200000425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64914,
    "description": "Vesta (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004914,
    "auth_name": "IAU_2015",
    "auth_id": "200000430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64915,
    "description": "Vesta (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004915,
    "auth_name": "IAU_2015",
    "auth_id": "200000435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64916,
    "description": "Vesta (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004916,
    "auth_name": "IAU_2015",
    "auth_id": "200000440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64917,
    "description": "Vesta (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004917,
    "auth_name": "IAU_2015",
    "auth_id": "200000445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64918,
    "description": "Vesta (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004918,
    "auth_name": "IAU_2015",
    "auth_id": "200000450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64919,
    "description": "Vesta (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004919,
    "auth_name": "IAU_2015",
    "auth_id": "200000455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64920,
    "description": "Vesta (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004920,
    "auth_name": "IAU_2015",
    "auth_id": "200000460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64921,
    "description": "Vesta (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004921,
    "auth_name": "IAU_2015",
    "auth_id": "200000465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64922,
    "description": "Vesta (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004922,
    "auth_name": "IAU_2015",
    "auth_id": "200000470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64923,
    "description": "Vesta (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004923,
    "auth_name": "IAU_2015",
    "auth_id": "200000475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64924,
    "description": "Vesta (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004924,
    "auth_name": "IAU_2015",
    "auth_id": "200000480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64925,
    "description": "Vesta (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520004925,
    "auth_name": "IAU_2015",
    "auth_id": "200000485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64926,
    "description": "Psyche (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=113000 +no_defs",
    "srid": 520004926,
    "auth_name": "IAU_2015",
    "auth_id": "200001600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64927,
    "description": "Psyche (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004927,
    "auth_name": "IAU_2015",
    "auth_id": "200001610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64928,
    "description": "Psyche (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004928,
    "auth_name": "IAU_2015",
    "auth_id": "200001615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64929,
    "description": "Psyche (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004929,
    "auth_name": "IAU_2015",
    "auth_id": "200001620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64930,
    "description": "Psyche (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004930,
    "auth_name": "IAU_2015",
    "auth_id": "200001625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64931,
    "description": "Psyche (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004931,
    "auth_name": "IAU_2015",
    "auth_id": "200001630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64932,
    "description": "Psyche (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004932,
    "auth_name": "IAU_2015",
    "auth_id": "200001635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64933,
    "description": "Psyche (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004933,
    "auth_name": "IAU_2015",
    "auth_id": "200001640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64934,
    "description": "Psyche (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004934,
    "auth_name": "IAU_2015",
    "auth_id": "200001645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64935,
    "description": "Psyche (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004935,
    "auth_name": "IAU_2015",
    "auth_id": "200001650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64936,
    "description": "Psyche (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004936,
    "auth_name": "IAU_2015",
    "auth_id": "200001655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64937,
    "description": "Psyche (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004937,
    "auth_name": "IAU_2015",
    "auth_id": "200001660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64938,
    "description": "Psyche (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004938,
    "auth_name": "IAU_2015",
    "auth_id": "200001665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64939,
    "description": "Psyche (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004939,
    "auth_name": "IAU_2015",
    "auth_id": "200001670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64940,
    "description": "Psyche (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004940,
    "auth_name": "IAU_2015",
    "auth_id": "200001675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64941,
    "description": "Psyche (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004941,
    "auth_name": "IAU_2015",
    "auth_id": "200001680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64942,
    "description": "Psyche (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520004942,
    "auth_name": "IAU_2015",
    "auth_id": "200001685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64943,
    "description": "Lutetia (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=52500 +no_defs",
    "srid": 520004943,
    "auth_name": "IAU_2015",
    "auth_id": "200002100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64944,
    "description": "Lutetia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004944,
    "auth_name": "IAU_2015",
    "auth_id": "200002110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64945,
    "description": "Lutetia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004945,
    "auth_name": "IAU_2015",
    "auth_id": "200002115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64946,
    "description": "Lutetia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004946,
    "auth_name": "IAU_2015",
    "auth_id": "200002120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64947,
    "description": "Lutetia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004947,
    "auth_name": "IAU_2015",
    "auth_id": "200002125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64948,
    "description": "Lutetia (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004948,
    "auth_name": "IAU_2015",
    "auth_id": "200002130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64949,
    "description": "Lutetia (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004949,
    "auth_name": "IAU_2015",
    "auth_id": "200002135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64950,
    "description": "Lutetia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004950,
    "auth_name": "IAU_2015",
    "auth_id": "200002140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64951,
    "description": "Lutetia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004951,
    "auth_name": "IAU_2015",
    "auth_id": "200002145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64952,
    "description": "Lutetia (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004952,
    "auth_name": "IAU_2015",
    "auth_id": "200002150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64953,
    "description": "Lutetia (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004953,
    "auth_name": "IAU_2015",
    "auth_id": "200002155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64954,
    "description": "Lutetia (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004954,
    "auth_name": "IAU_2015",
    "auth_id": "200002160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64955,
    "description": "Lutetia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004955,
    "auth_name": "IAU_2015",
    "auth_id": "200002165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64956,
    "description": "Lutetia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004956,
    "auth_name": "IAU_2015",
    "auth_id": "200002170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64957,
    "description": "Lutetia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004957,
    "auth_name": "IAU_2015",
    "auth_id": "200002175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64958,
    "description": "Lutetia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004958,
    "auth_name": "IAU_2015",
    "auth_id": "200002180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64959,
    "description": "Lutetia (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520004959,
    "auth_name": "IAU_2015",
    "auth_id": "200002185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64960,
    "description": "52 Europa (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=157500 +no_defs",
    "srid": 520004960,
    "auth_name": "IAU_2015",
    "auth_id": "200005200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64961,
    "description": "52 Europa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004961,
    "auth_name": "IAU_2015",
    "auth_id": "200005210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64962,
    "description": "52 Europa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004962,
    "auth_name": "IAU_2015",
    "auth_id": "200005215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64963,
    "description": "52 Europa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004963,
    "auth_name": "IAU_2015",
    "auth_id": "200005220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64964,
    "description": "52 Europa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004964,
    "auth_name": "IAU_2015",
    "auth_id": "200005225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64965,
    "description": "52 Europa (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004965,
    "auth_name": "IAU_2015",
    "auth_id": "200005230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64966,
    "description": "52 Europa (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004966,
    "auth_name": "IAU_2015",
    "auth_id": "200005235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64967,
    "description": "52 Europa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004967,
    "auth_name": "IAU_2015",
    "auth_id": "200005240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64968,
    "description": "52 Europa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004968,
    "auth_name": "IAU_2015",
    "auth_id": "200005245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64969,
    "description": "52 Europa (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004969,
    "auth_name": "IAU_2015",
    "auth_id": "200005250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64970,
    "description": "52 Europa (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004970,
    "auth_name": "IAU_2015",
    "auth_id": "200005255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64971,
    "description": "52 Europa (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004971,
    "auth_name": "IAU_2015",
    "auth_id": "200005260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64972,
    "description": "52 Europa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004972,
    "auth_name": "IAU_2015",
    "auth_id": "200005265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64973,
    "description": "52 Europa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004973,
    "auth_name": "IAU_2015",
    "auth_id": "200005270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64974,
    "description": "52 Europa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004974,
    "auth_name": "IAU_2015",
    "auth_id": "200005275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64975,
    "description": "52 Europa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004975,
    "auth_name": "IAU_2015",
    "auth_id": "200005280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64976,
    "description": "52 Europa (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520004976,
    "auth_name": "IAU_2015",
    "auth_id": "200005285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64977,
    "description": "Kleopatra (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=65333.333333 +no_defs",
    "srid": 520004977,
    "auth_name": "IAU_2015",
    "auth_id": "200021600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64978,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004978,
    "auth_name": "IAU_2015",
    "auth_id": "200021610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64979,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004979,
    "auth_name": "IAU_2015",
    "auth_id": "200021615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64980,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004980,
    "auth_name": "IAU_2015",
    "auth_id": "200021620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64981,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004981,
    "auth_name": "IAU_2015",
    "auth_id": "200021625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64982,
    "description": "Kleopatra (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004982,
    "auth_name": "IAU_2015",
    "auth_id": "200021630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64983,
    "description": "Kleopatra (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004983,
    "auth_name": "IAU_2015",
    "auth_id": "200021635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64984,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004984,
    "auth_name": "IAU_2015",
    "auth_id": "200021640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64985,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004985,
    "auth_name": "IAU_2015",
    "auth_id": "200021645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64986,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004986,
    "auth_name": "IAU_2015",
    "auth_id": "200021650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64987,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004987,
    "auth_name": "IAU_2015",
    "auth_id": "200021655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64988,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004988,
    "auth_name": "IAU_2015",
    "auth_id": "200021660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64989,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004989,
    "auth_name": "IAU_2015",
    "auth_id": "200021665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64990,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004990,
    "auth_name": "IAU_2015",
    "auth_id": "200021670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64991,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004991,
    "auth_name": "IAU_2015",
    "auth_id": "200021675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64992,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004992,
    "auth_name": "IAU_2015",
    "auth_id": "200021680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64993,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520004993,
    "auth_name": "IAU_2015",
    "auth_id": "200021685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64994,
    "description": "Mathilde (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=26500 +no_defs",
    "srid": 520004994,
    "auth_name": "IAU_2015",
    "auth_id": "200025300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 64995,
    "description": "Mathilde (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520004995,
    "auth_name": "IAU_2015",
    "auth_id": "200025310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64996,
    "description": "Mathilde (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520004996,
    "auth_name": "IAU_2015",
    "auth_id": "200025315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64997,
    "description": "Mathilde (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520004997,
    "auth_name": "IAU_2015",
    "auth_id": "200025320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64998,
    "description": "Mathilde (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520004998,
    "auth_name": "IAU_2015",
    "auth_id": "200025325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 64999,
    "description": "Mathilde (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520004999,
    "auth_name": "IAU_2015",
    "auth_id": "200025330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65000,
    "description": "Mathilde (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005000,
    "auth_name": "IAU_2015",
    "auth_id": "200025335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65001,
    "description": "Mathilde (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005001,
    "auth_name": "IAU_2015",
    "auth_id": "200025340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65002,
    "description": "Mathilde (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005002,
    "auth_name": "IAU_2015",
    "auth_id": "200025345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65003,
    "description": "Mathilde (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005003,
    "auth_name": "IAU_2015",
    "auth_id": "200025350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65004,
    "description": "Mathilde (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005004,
    "auth_name": "IAU_2015",
    "auth_id": "200025355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65005,
    "description": "Mathilde (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005005,
    "auth_name": "IAU_2015",
    "auth_id": "200025360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65006,
    "description": "Mathilde (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005006,
    "auth_name": "IAU_2015",
    "auth_id": "200025365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65007,
    "description": "Mathilde (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005007,
    "auth_name": "IAU_2015",
    "auth_id": "200025370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65008,
    "description": "Mathilde (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005008,
    "auth_name": "IAU_2015",
    "auth_id": "200025375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65009,
    "description": "Mathilde (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005009,
    "auth_name": "IAU_2015",
    "auth_id": "200025380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65010,
    "description": "Mathilde (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520005010,
    "auth_name": "IAU_2015",
    "auth_id": "200025385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65011,
    "description": "Eros (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=17000 +no_defs",
    "srid": 520005011,
    "auth_name": "IAU_2015",
    "auth_id": "200043300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65012,
    "description": "Eros (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=17000 +b=5500 +no_defs",
    "srid": 520005012,
    "auth_name": "IAU_2015",
    "auth_id": "200043301",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65013,
    "description": "Eros (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520005013,
    "auth_name": "IAU_2015",
    "auth_id": "200043302",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 65014,
    "description": "Eros (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005014,
    "auth_name": "IAU_2015",
    "auth_id": "200043310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65015,
    "description": "Eros (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005015,
    "auth_name": "IAU_2015",
    "auth_id": "200043311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65016,
    "description": "Eros (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005016,
    "auth_name": "IAU_2015",
    "auth_id": "200043315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65017,
    "description": "Eros (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005017,
    "auth_name": "IAU_2015",
    "auth_id": "200043316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65018,
    "description": "Eros (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005018,
    "auth_name": "IAU_2015",
    "auth_id": "200043320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65019,
    "description": "Eros (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005019,
    "auth_name": "IAU_2015",
    "auth_id": "200043321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65020,
    "description": "Eros (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005020,
    "auth_name": "IAU_2015",
    "auth_id": "200043325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65021,
    "description": "Eros (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005021,
    "auth_name": "IAU_2015",
    "auth_id": "200043326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65022,
    "description": "Eros (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005022,
    "auth_name": "IAU_2015",
    "auth_id": "200043330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65023,
    "description": "Eros (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005023,
    "auth_name": "IAU_2015",
    "auth_id": "200043331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65024,
    "description": "Eros (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005024,
    "auth_name": "IAU_2015",
    "auth_id": "200043335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65025,
    "description": "Eros (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005025,
    "auth_name": "IAU_2015",
    "auth_id": "200043336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65026,
    "description": "Eros (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005026,
    "auth_name": "IAU_2015",
    "auth_id": "200043340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65027,
    "description": "Eros (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005027,
    "auth_name": "IAU_2015",
    "auth_id": "200043341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65028,
    "description": "Eros (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005028,
    "auth_name": "IAU_2015",
    "auth_id": "200043345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65029,
    "description": "Eros (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005029,
    "auth_name": "IAU_2015",
    "auth_id": "200043346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65030,
    "description": "Eros (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005030,
    "auth_name": "IAU_2015",
    "auth_id": "200043350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65031,
    "description": "Eros (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005031,
    "auth_name": "IAU_2015",
    "auth_id": "200043351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65032,
    "description": "Eros (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005032,
    "auth_name": "IAU_2015",
    "auth_id": "200043355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65033,
    "description": "Eros (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005033,
    "auth_name": "IAU_2015",
    "auth_id": "200043356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65034,
    "description": "Eros (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005034,
    "auth_name": "IAU_2015",
    "auth_id": "200043360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65035,
    "description": "Eros (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005035,
    "auth_name": "IAU_2015",
    "auth_id": "200043361",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65036,
    "description": "Eros (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005036,
    "auth_name": "IAU_2015",
    "auth_id": "200043365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65037,
    "description": "Eros (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005037,
    "auth_name": "IAU_2015",
    "auth_id": "200043366",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65038,
    "description": "Eros (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005038,
    "auth_name": "IAU_2015",
    "auth_id": "200043370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65039,
    "description": "Eros (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005039,
    "auth_name": "IAU_2015",
    "auth_id": "200043371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65040,
    "description": "Eros (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005040,
    "auth_name": "IAU_2015",
    "auth_id": "200043375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65041,
    "description": "Eros (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005041,
    "auth_name": "IAU_2015",
    "auth_id": "200043376",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65042,
    "description": "Eros (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005042,
    "auth_name": "IAU_2015",
    "auth_id": "200043380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65043,
    "description": "Eros (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005043,
    "auth_name": "IAU_2015",
    "auth_id": "200043381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65044,
    "description": "Eros (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520005044,
    "auth_name": "IAU_2015",
    "auth_id": "200043385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65045,
    "description": "Eros (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520005045,
    "auth_name": "IAU_2015",
    "auth_id": "200043386",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65046,
    "description": "Davida (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=150000 +no_defs",
    "srid": 520005046,
    "auth_name": "IAU_2015",
    "auth_id": "200051100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65047,
    "description": "Davida (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005047,
    "auth_name": "IAU_2015",
    "auth_id": "200051110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65048,
    "description": "Davida (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005048,
    "auth_name": "IAU_2015",
    "auth_id": "200051115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65049,
    "description": "Davida (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005049,
    "auth_name": "IAU_2015",
    "auth_id": "200051120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65050,
    "description": "Davida (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005050,
    "auth_name": "IAU_2015",
    "auth_id": "200051125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65051,
    "description": "Davida (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005051,
    "auth_name": "IAU_2015",
    "auth_id": "200051130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65052,
    "description": "Davida (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005052,
    "auth_name": "IAU_2015",
    "auth_id": "200051135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65053,
    "description": "Davida (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005053,
    "auth_name": "IAU_2015",
    "auth_id": "200051140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65054,
    "description": "Davida (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005054,
    "auth_name": "IAU_2015",
    "auth_id": "200051145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65055,
    "description": "Davida (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005055,
    "auth_name": "IAU_2015",
    "auth_id": "200051150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65056,
    "description": "Davida (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005056,
    "auth_name": "IAU_2015",
    "auth_id": "200051155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65057,
    "description": "Davida (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005057,
    "auth_name": "IAU_2015",
    "auth_id": "200051160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65058,
    "description": "Davida (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005058,
    "auth_name": "IAU_2015",
    "auth_id": "200051165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65059,
    "description": "Davida (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005059,
    "auth_name": "IAU_2015",
    "auth_id": "200051170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65060,
    "description": "Davida (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005060,
    "auth_name": "IAU_2015",
    "auth_id": "200051175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65061,
    "description": "Davida (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005061,
    "auth_name": "IAU_2015",
    "auth_id": "200051180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65062,
    "description": "Davida (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520005062,
    "auth_name": "IAU_2015",
    "auth_id": "200051185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65063,
    "description": "Steins (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2700 +no_defs",
    "srid": 520005063,
    "auth_name": "IAU_2015",
    "auth_id": "200286700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65064,
    "description": "Steins (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005064,
    "auth_name": "IAU_2015",
    "auth_id": "200286710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65065,
    "description": "Steins (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005065,
    "auth_name": "IAU_2015",
    "auth_id": "200286715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65066,
    "description": "Steins (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005066,
    "auth_name": "IAU_2015",
    "auth_id": "200286720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65067,
    "description": "Steins (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005067,
    "auth_name": "IAU_2015",
    "auth_id": "200286725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65068,
    "description": "Steins (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005068,
    "auth_name": "IAU_2015",
    "auth_id": "200286730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65069,
    "description": "Steins (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005069,
    "auth_name": "IAU_2015",
    "auth_id": "200286735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65070,
    "description": "Steins (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005070,
    "auth_name": "IAU_2015",
    "auth_id": "200286740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65071,
    "description": "Steins (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005071,
    "auth_name": "IAU_2015",
    "auth_id": "200286745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65072,
    "description": "Steins (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005072,
    "auth_name": "IAU_2015",
    "auth_id": "200286750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65073,
    "description": "Steins (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005073,
    "auth_name": "IAU_2015",
    "auth_id": "200286755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65074,
    "description": "Steins (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005074,
    "auth_name": "IAU_2015",
    "auth_id": "200286760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65075,
    "description": "Steins (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005075,
    "auth_name": "IAU_2015",
    "auth_id": "200286765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65076,
    "description": "Steins (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005076,
    "auth_name": "IAU_2015",
    "auth_id": "200286770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65077,
    "description": "Steins (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005077,
    "auth_name": "IAU_2015",
    "auth_id": "200286775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65078,
    "description": "Steins (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005078,
    "auth_name": "IAU_2015",
    "auth_id": "200286780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65079,
    "description": "Steins (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520005079,
    "auth_name": "IAU_2015",
    "auth_id": "200286785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65080,
    "description": "Toutatis (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1331.666667 +no_defs",
    "srid": 520005080,
    "auth_name": "IAU_2015",
    "auth_id": "200417900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65081,
    "description": "Toutatis (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005081,
    "auth_name": "IAU_2015",
    "auth_id": "200417910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65082,
    "description": "Toutatis (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005082,
    "auth_name": "IAU_2015",
    "auth_id": "200417915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65083,
    "description": "Toutatis (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005083,
    "auth_name": "IAU_2015",
    "auth_id": "200417920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65084,
    "description": "Toutatis (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005084,
    "auth_name": "IAU_2015",
    "auth_id": "200417925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65085,
    "description": "Toutatis (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005085,
    "auth_name": "IAU_2015",
    "auth_id": "200417930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65086,
    "description": "Toutatis (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005086,
    "auth_name": "IAU_2015",
    "auth_id": "200417935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65087,
    "description": "Toutatis (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005087,
    "auth_name": "IAU_2015",
    "auth_id": "200417940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65088,
    "description": "Toutatis (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005088,
    "auth_name": "IAU_2015",
    "auth_id": "200417945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65089,
    "description": "Toutatis (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005089,
    "auth_name": "IAU_2015",
    "auth_id": "200417950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65090,
    "description": "Toutatis (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005090,
    "auth_name": "IAU_2015",
    "auth_id": "200417955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65091,
    "description": "Toutatis (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005091,
    "auth_name": "IAU_2015",
    "auth_id": "200417960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65092,
    "description": "Toutatis (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005092,
    "auth_name": "IAU_2015",
    "auth_id": "200417965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65093,
    "description": "Toutatis (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005093,
    "auth_name": "IAU_2015",
    "auth_id": "200417970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65094,
    "description": "Toutatis (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005094,
    "auth_name": "IAU_2015",
    "auth_id": "200417975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65095,
    "description": "Toutatis (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005095,
    "auth_name": "IAU_2015",
    "auth_id": "200417980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65096,
    "description": "Toutatis (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520005096,
    "auth_name": "IAU_2015",
    "auth_id": "200417985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65097,
    "description": "Itokawa (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=173 +no_defs",
    "srid": 520005097,
    "auth_name": "IAU_2015",
    "auth_id": "202514300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65098,
    "description": "Itokawa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005098,
    "auth_name": "IAU_2015",
    "auth_id": "202514310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65099,
    "description": "Itokawa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005099,
    "auth_name": "IAU_2015",
    "auth_id": "202514315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65100,
    "description": "Itokawa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005100,
    "auth_name": "IAU_2015",
    "auth_id": "202514320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65101,
    "description": "Itokawa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005101,
    "auth_name": "IAU_2015",
    "auth_id": "202514325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65102,
    "description": "Itokawa (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005102,
    "auth_name": "IAU_2015",
    "auth_id": "202514330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65103,
    "description": "Itokawa (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005103,
    "auth_name": "IAU_2015",
    "auth_id": "202514335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65104,
    "description": "Itokawa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005104,
    "auth_name": "IAU_2015",
    "auth_id": "202514340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65105,
    "description": "Itokawa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005105,
    "auth_name": "IAU_2015",
    "auth_id": "202514345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65106,
    "description": "Itokawa (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005106,
    "auth_name": "IAU_2015",
    "auth_id": "202514350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65107,
    "description": "Itokawa (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005107,
    "auth_name": "IAU_2015",
    "auth_id": "202514355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65108,
    "description": "Itokawa (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005108,
    "auth_name": "IAU_2015",
    "auth_id": "202514360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65109,
    "description": "Itokawa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005109,
    "auth_name": "IAU_2015",
    "auth_id": "202514365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65110,
    "description": "Itokawa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005110,
    "auth_name": "IAU_2015",
    "auth_id": "202514370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65111,
    "description": "Itokawa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005111,
    "auth_name": "IAU_2015",
    "auth_id": "202514375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65112,
    "description": "Itokawa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005112,
    "auth_name": "IAU_2015",
    "auth_id": "202514380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65113,
    "description": "Itokawa (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520005113,
    "auth_name": "IAU_2015",
    "auth_id": "202514385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65114,
    "description": "Ida (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=15650 +no_defs",
    "srid": 520005114,
    "auth_name": "IAU_2015",
    "auth_id": "243101000",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65115,
    "description": "Ida (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005115,
    "auth_name": "IAU_2015",
    "auth_id": "243101010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65116,
    "description": "Ida (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005116,
    "auth_name": "IAU_2015",
    "auth_id": "243101015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65117,
    "description": "Ida (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005117,
    "auth_name": "IAU_2015",
    "auth_id": "243101020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65118,
    "description": "Ida (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005118,
    "auth_name": "IAU_2015",
    "auth_id": "243101025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65119,
    "description": "Ida (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005119,
    "auth_name": "IAU_2015",
    "auth_id": "243101030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65120,
    "description": "Ida (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005120,
    "auth_name": "IAU_2015",
    "auth_id": "243101035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65121,
    "description": "Ida (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005121,
    "auth_name": "IAU_2015",
    "auth_id": "243101040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65122,
    "description": "Ida (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005122,
    "auth_name": "IAU_2015",
    "auth_id": "243101045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65123,
    "description": "Ida (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005123,
    "auth_name": "IAU_2015",
    "auth_id": "243101050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65124,
    "description": "Ida (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005124,
    "auth_name": "IAU_2015",
    "auth_id": "243101055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65125,
    "description": "Ida (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005125,
    "auth_name": "IAU_2015",
    "auth_id": "243101060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65126,
    "description": "Ida (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005126,
    "auth_name": "IAU_2015",
    "auth_id": "243101065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65127,
    "description": "Ida (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005127,
    "auth_name": "IAU_2015",
    "auth_id": "243101070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65128,
    "description": "Ida (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005128,
    "auth_name": "IAU_2015",
    "auth_id": "243101075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65129,
    "description": "Ida (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005129,
    "auth_name": "IAU_2015",
    "auth_id": "243101080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65130,
    "description": "Ida (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520005130,
    "auth_name": "IAU_2015",
    "auth_id": "243101085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65131,
    "description": "Venus (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=6051800 +no_defs",
    "srid": 520005131,
    "auth_name": "IAU_2015",
    "auth_id": "29900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65132,
    "description": "Venus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005132,
    "auth_name": "IAU_2015",
    "auth_id": "29910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65133,
    "description": "Venus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005133,
    "auth_name": "IAU_2015",
    "auth_id": "29915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65134,
    "description": "Venus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005134,
    "auth_name": "IAU_2015",
    "auth_id": "29920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65135,
    "description": "Venus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005135,
    "auth_name": "IAU_2015",
    "auth_id": "29925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65136,
    "description": "Venus (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005136,
    "auth_name": "IAU_2015",
    "auth_id": "29930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65137,
    "description": "Venus (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005137,
    "auth_name": "IAU_2015",
    "auth_id": "29935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65138,
    "description": "Venus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005138,
    "auth_name": "IAU_2015",
    "auth_id": "29940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65139,
    "description": "Venus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005139,
    "auth_name": "IAU_2015",
    "auth_id": "29945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65140,
    "description": "Venus (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005140,
    "auth_name": "IAU_2015",
    "auth_id": "29950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65141,
    "description": "Venus (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005141,
    "auth_name": "IAU_2015",
    "auth_id": "29955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65142,
    "description": "Venus (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005142,
    "auth_name": "IAU_2015",
    "auth_id": "29960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65143,
    "description": "Venus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005143,
    "auth_name": "IAU_2015",
    "auth_id": "29965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65144,
    "description": "Venus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005144,
    "auth_name": "IAU_2015",
    "auth_id": "29970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65145,
    "description": "Venus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005145,
    "auth_name": "IAU_2015",
    "auth_id": "29975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65146,
    "description": "Venus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005146,
    "auth_name": "IAU_2015",
    "auth_id": "29980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65147,
    "description": "Venus (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520005147,
    "auth_name": "IAU_2015",
    "auth_id": "29985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65148,
    "description": "Moon (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1737400 +no_defs",
    "srid": 520005148,
    "auth_name": "IAU_2015",
    "auth_id": "30100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65149,
    "description": "Moon (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005149,
    "auth_name": "IAU_2015",
    "auth_id": "30110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65150,
    "description": "Moon (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005150,
    "auth_name": "IAU_2015",
    "auth_id": "30115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65151,
    "description": "Moon (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005151,
    "auth_name": "IAU_2015",
    "auth_id": "30120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65152,
    "description": "Moon (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005152,
    "auth_name": "IAU_2015",
    "auth_id": "30125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65153,
    "description": "Moon (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005153,
    "auth_name": "IAU_2015",
    "auth_id": "30130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65154,
    "description": "Moon (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005154,
    "auth_name": "IAU_2015",
    "auth_id": "30135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65155,
    "description": "Moon (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005155,
    "auth_name": "IAU_2015",
    "auth_id": "30140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65156,
    "description": "Moon (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005156,
    "auth_name": "IAU_2015",
    "auth_id": "30145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65157,
    "description": "Moon (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005157,
    "auth_name": "IAU_2015",
    "auth_id": "30150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65158,
    "description": "Moon (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005158,
    "auth_name": "IAU_2015",
    "auth_id": "30155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65159,
    "description": "Moon (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005159,
    "auth_name": "IAU_2015",
    "auth_id": "30160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65160,
    "description": "Moon (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005160,
    "auth_name": "IAU_2015",
    "auth_id": "30165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65161,
    "description": "Moon (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005161,
    "auth_name": "IAU_2015",
    "auth_id": "30170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65162,
    "description": "Moon (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005162,
    "auth_name": "IAU_2015",
    "auth_id": "30175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65163,
    "description": "Moon (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005163,
    "auth_name": "IAU_2015",
    "auth_id": "30180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65164,
    "description": "Moon (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520005164,
    "auth_name": "IAU_2015",
    "auth_id": "30185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65165,
    "description": "Earth (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=6378136.6 +no_defs",
    "srid": 520005165,
    "auth_name": "IAU_2015",
    "auth_id": "39900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65166,
    "description": "Earth (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=6378136.6 +b=6356751.9 +no_defs",
    "srid": 520005166,
    "auth_name": "IAU_2015",
    "auth_id": "39901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65167,
    "description": "Earth (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520005167,
    "auth_name": "IAU_2015",
    "auth_id": "39902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 65168,
    "description": "Earth (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005168,
    "auth_name": "IAU_2015",
    "auth_id": "39910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65169,
    "description": "Earth (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005169,
    "auth_name": "IAU_2015",
    "auth_id": "39911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65170,
    "description": "Earth (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005170,
    "auth_name": "IAU_2015",
    "auth_id": "39915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65171,
    "description": "Earth (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005171,
    "auth_name": "IAU_2015",
    "auth_id": "39916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65172,
    "description": "Earth (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005172,
    "auth_name": "IAU_2015",
    "auth_id": "39920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65173,
    "description": "Earth (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005173,
    "auth_name": "IAU_2015",
    "auth_id": "39921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65174,
    "description": "Earth (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005174,
    "auth_name": "IAU_2015",
    "auth_id": "39925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65175,
    "description": "Earth (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005175,
    "auth_name": "IAU_2015",
    "auth_id": "39926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65176,
    "description": "Earth (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005176,
    "auth_name": "IAU_2015",
    "auth_id": "39930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65177,
    "description": "Earth (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005177,
    "auth_name": "IAU_2015",
    "auth_id": "39931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65178,
    "description": "Earth (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005178,
    "auth_name": "IAU_2015",
    "auth_id": "39935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65179,
    "description": "Earth (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005179,
    "auth_name": "IAU_2015",
    "auth_id": "39936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65180,
    "description": "Earth (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005180,
    "auth_name": "IAU_2015",
    "auth_id": "39940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65181,
    "description": "Earth (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005181,
    "auth_name": "IAU_2015",
    "auth_id": "39941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65182,
    "description": "Earth (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005182,
    "auth_name": "IAU_2015",
    "auth_id": "39945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65183,
    "description": "Earth (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005183,
    "auth_name": "IAU_2015",
    "auth_id": "39946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65184,
    "description": "Earth (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005184,
    "auth_name": "IAU_2015",
    "auth_id": "39950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65185,
    "description": "Earth (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005185,
    "auth_name": "IAU_2015",
    "auth_id": "39951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65186,
    "description": "Earth (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005186,
    "auth_name": "IAU_2015",
    "auth_id": "39955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65187,
    "description": "Earth (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005187,
    "auth_name": "IAU_2015",
    "auth_id": "39956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65188,
    "description": "Earth (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005188,
    "auth_name": "IAU_2015",
    "auth_id": "39960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65189,
    "description": "Earth (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005189,
    "auth_name": "IAU_2015",
    "auth_id": "39961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65190,
    "description": "Earth (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005190,
    "auth_name": "IAU_2015",
    "auth_id": "39965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65191,
    "description": "Earth (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005191,
    "auth_name": "IAU_2015",
    "auth_id": "39966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65192,
    "description": "Earth (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005192,
    "auth_name": "IAU_2015",
    "auth_id": "39970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65193,
    "description": "Earth (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005193,
    "auth_name": "IAU_2015",
    "auth_id": "39971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65194,
    "description": "Earth (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005194,
    "auth_name": "IAU_2015",
    "auth_id": "39975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65195,
    "description": "Earth (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005195,
    "auth_name": "IAU_2015",
    "auth_id": "39976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65196,
    "description": "Earth (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005196,
    "auth_name": "IAU_2015",
    "auth_id": "39980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65197,
    "description": "Earth (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005197,
    "auth_name": "IAU_2015",
    "auth_id": "39981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65198,
    "description": "Earth (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520005198,
    "auth_name": "IAU_2015",
    "auth_id": "39985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65199,
    "description": "Earth (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520005199,
    "auth_name": "IAU_2015",
    "auth_id": "39986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65200,
    "description": "Phobos (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=11080 +no_defs",
    "srid": 520005200,
    "auth_name": "IAU_2015",
    "auth_id": "40100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65201,
    "description": "Phobos (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005201,
    "auth_name": "IAU_2015",
    "auth_id": "40110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65202,
    "description": "Phobos (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005202,
    "auth_name": "IAU_2015",
    "auth_id": "40115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65203,
    "description": "Phobos (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005203,
    "auth_name": "IAU_2015",
    "auth_id": "40120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65204,
    "description": "Phobos (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005204,
    "auth_name": "IAU_2015",
    "auth_id": "40125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65205,
    "description": "Phobos (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005205,
    "auth_name": "IAU_2015",
    "auth_id": "40130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65206,
    "description": "Phobos (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005206,
    "auth_name": "IAU_2015",
    "auth_id": "40135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65207,
    "description": "Phobos (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005207,
    "auth_name": "IAU_2015",
    "auth_id": "40140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65208,
    "description": "Phobos (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005208,
    "auth_name": "IAU_2015",
    "auth_id": "40145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65209,
    "description": "Phobos (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005209,
    "auth_name": "IAU_2015",
    "auth_id": "40150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65210,
    "description": "Phobos (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005210,
    "auth_name": "IAU_2015",
    "auth_id": "40155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65211,
    "description": "Phobos (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005211,
    "auth_name": "IAU_2015",
    "auth_id": "40160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65212,
    "description": "Phobos (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005212,
    "auth_name": "IAU_2015",
    "auth_id": "40165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65213,
    "description": "Phobos (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005213,
    "auth_name": "IAU_2015",
    "auth_id": "40170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65214,
    "description": "Phobos (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005214,
    "auth_name": "IAU_2015",
    "auth_id": "40175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65215,
    "description": "Phobos (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005215,
    "auth_name": "IAU_2015",
    "auth_id": "40180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65216,
    "description": "Phobos (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520005216,
    "auth_name": "IAU_2015",
    "auth_id": "40185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65217,
    "description": "Deimos (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=6200 +no_defs",
    "srid": 520005217,
    "auth_name": "IAU_2015",
    "auth_id": "40200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65218,
    "description": "Deimos (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005218,
    "auth_name": "IAU_2015",
    "auth_id": "40210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65219,
    "description": "Deimos (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005219,
    "auth_name": "IAU_2015",
    "auth_id": "40215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65220,
    "description": "Deimos (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005220,
    "auth_name": "IAU_2015",
    "auth_id": "40220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65221,
    "description": "Deimos (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005221,
    "auth_name": "IAU_2015",
    "auth_id": "40225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65222,
    "description": "Deimos (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005222,
    "auth_name": "IAU_2015",
    "auth_id": "40230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65223,
    "description": "Deimos (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005223,
    "auth_name": "IAU_2015",
    "auth_id": "40235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65224,
    "description": "Deimos (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005224,
    "auth_name": "IAU_2015",
    "auth_id": "40240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65225,
    "description": "Deimos (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005225,
    "auth_name": "IAU_2015",
    "auth_id": "40245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65226,
    "description": "Deimos (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005226,
    "auth_name": "IAU_2015",
    "auth_id": "40250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65227,
    "description": "Deimos (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005227,
    "auth_name": "IAU_2015",
    "auth_id": "40255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65228,
    "description": "Deimos (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005228,
    "auth_name": "IAU_2015",
    "auth_id": "40260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65229,
    "description": "Deimos (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005229,
    "auth_name": "IAU_2015",
    "auth_id": "40265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65230,
    "description": "Deimos (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005230,
    "auth_name": "IAU_2015",
    "auth_id": "40270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65231,
    "description": "Deimos (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005231,
    "auth_name": "IAU_2015",
    "auth_id": "40275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65232,
    "description": "Deimos (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005232,
    "auth_name": "IAU_2015",
    "auth_id": "40280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65233,
    "description": "Deimos (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520005233,
    "auth_name": "IAU_2015",
    "auth_id": "40285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65234,
    "description": "Mars (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=3396190 +no_defs",
    "srid": 520005234,
    "auth_name": "IAU_2015",
    "auth_id": "49900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65235,
    "description": "Mars (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=3396190 +b=3376200 +no_defs",
    "srid": 520005235,
    "auth_name": "IAU_2015",
    "auth_id": "49901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65236,
    "description": "Mars (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520005236,
    "auth_name": "IAU_2015",
    "auth_id": "49902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 65237,
    "description": "Mars (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005237,
    "auth_name": "IAU_2015",
    "auth_id": "49910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65238,
    "description": "Mars (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005238,
    "auth_name": "IAU_2015",
    "auth_id": "49911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65239,
    "description": "Mars (2015) / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005239,
    "auth_name": "IAU_2015",
    "auth_id": "49912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65240,
    "description": "Mars (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005240,
    "auth_name": "IAU_2015",
    "auth_id": "49915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65241,
    "description": "Mars (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005241,
    "auth_name": "IAU_2015",
    "auth_id": "49916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65242,
    "description": "Mars (2015) / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005242,
    "auth_name": "IAU_2015",
    "auth_id": "49917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65243,
    "description": "Mars (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005243,
    "auth_name": "IAU_2015",
    "auth_id": "49920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65244,
    "description": "Mars (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005244,
    "auth_name": "IAU_2015",
    "auth_id": "49921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65245,
    "description": "Mars (2015) / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005245,
    "auth_name": "IAU_2015",
    "auth_id": "49922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65246,
    "description": "Mars (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005246,
    "auth_name": "IAU_2015",
    "auth_id": "49925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65247,
    "description": "Mars (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005247,
    "auth_name": "IAU_2015",
    "auth_id": "49926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65248,
    "description": "Mars (2015) / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005248,
    "auth_name": "IAU_2015",
    "auth_id": "49927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65249,
    "description": "Mars (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005249,
    "auth_name": "IAU_2015",
    "auth_id": "49930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65250,
    "description": "Mars (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005250,
    "auth_name": "IAU_2015",
    "auth_id": "49931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65251,
    "description": "Mars (2015) / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005251,
    "auth_name": "IAU_2015",
    "auth_id": "49932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65252,
    "description": "Mars (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005252,
    "auth_name": "IAU_2015",
    "auth_id": "49935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65253,
    "description": "Mars (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005253,
    "auth_name": "IAU_2015",
    "auth_id": "49936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65254,
    "description": "Mars (2015) / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005254,
    "auth_name": "IAU_2015",
    "auth_id": "49937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65255,
    "description": "Mars (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005255,
    "auth_name": "IAU_2015",
    "auth_id": "49940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65256,
    "description": "Mars (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005256,
    "auth_name": "IAU_2015",
    "auth_id": "49941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65257,
    "description": "Mars (2015) / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005257,
    "auth_name": "IAU_2015",
    "auth_id": "49942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65258,
    "description": "Mars (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005258,
    "auth_name": "IAU_2015",
    "auth_id": "49945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65259,
    "description": "Mars (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005259,
    "auth_name": "IAU_2015",
    "auth_id": "49946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65260,
    "description": "Mars (2015) / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005260,
    "auth_name": "IAU_2015",
    "auth_id": "49947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65261,
    "description": "Mars (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005261,
    "auth_name": "IAU_2015",
    "auth_id": "49950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65262,
    "description": "Mars (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005262,
    "auth_name": "IAU_2015",
    "auth_id": "49951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65263,
    "description": "Mars (2015) / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005263,
    "auth_name": "IAU_2015",
    "auth_id": "49952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65264,
    "description": "Mars (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005264,
    "auth_name": "IAU_2015",
    "auth_id": "49955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65265,
    "description": "Mars (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005265,
    "auth_name": "IAU_2015",
    "auth_id": "49956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65266,
    "description": "Mars (2015) / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005266,
    "auth_name": "IAU_2015",
    "auth_id": "49957",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65267,
    "description": "Mars (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005267,
    "auth_name": "IAU_2015",
    "auth_id": "49960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65268,
    "description": "Mars (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005268,
    "auth_name": "IAU_2015",
    "auth_id": "49961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65269,
    "description": "Mars (2015) / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005269,
    "auth_name": "IAU_2015",
    "auth_id": "49962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65270,
    "description": "Mars (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005270,
    "auth_name": "IAU_2015",
    "auth_id": "49965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65271,
    "description": "Mars (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005271,
    "auth_name": "IAU_2015",
    "auth_id": "49966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65272,
    "description": "Mars (2015) / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005272,
    "auth_name": "IAU_2015",
    "auth_id": "49967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65273,
    "description": "Mars (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005273,
    "auth_name": "IAU_2015",
    "auth_id": "49970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65274,
    "description": "Mars (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005274,
    "auth_name": "IAU_2015",
    "auth_id": "49971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65275,
    "description": "Mars (2015) / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005275,
    "auth_name": "IAU_2015",
    "auth_id": "49972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65276,
    "description": "Mars (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005276,
    "auth_name": "IAU_2015",
    "auth_id": "49975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65277,
    "description": "Mars (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005277,
    "auth_name": "IAU_2015",
    "auth_id": "49976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65278,
    "description": "Mars (2015) / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005278,
    "auth_name": "IAU_2015",
    "auth_id": "49977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65279,
    "description": "Mars (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005279,
    "auth_name": "IAU_2015",
    "auth_id": "49980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65280,
    "description": "Mars (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005280,
    "auth_name": "IAU_2015",
    "auth_id": "49981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65281,
    "description": "Mars (2015) / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005281,
    "auth_name": "IAU_2015",
    "auth_id": "49982",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65282,
    "description": "Mars (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520005282,
    "auth_name": "IAU_2015",
    "auth_id": "49985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65283,
    "description": "Mars (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005283,
    "auth_name": "IAU_2015",
    "auth_id": "49986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65284,
    "description": "Mars (2015) / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520005284,
    "auth_name": "IAU_2015",
    "auth_id": "49987",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65285,
    "description": "Io (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1821490 +no_defs",
    "srid": 520005285,
    "auth_name": "IAU_2015",
    "auth_id": "50100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65286,
    "description": "Io (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005286,
    "auth_name": "IAU_2015",
    "auth_id": "50110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65287,
    "description": "Io (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005287,
    "auth_name": "IAU_2015",
    "auth_id": "50115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65288,
    "description": "Io (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005288,
    "auth_name": "IAU_2015",
    "auth_id": "50120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65289,
    "description": "Io (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005289,
    "auth_name": "IAU_2015",
    "auth_id": "50125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65290,
    "description": "Io (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005290,
    "auth_name": "IAU_2015",
    "auth_id": "50130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65291,
    "description": "Io (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005291,
    "auth_name": "IAU_2015",
    "auth_id": "50135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65292,
    "description": "Io (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005292,
    "auth_name": "IAU_2015",
    "auth_id": "50140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65293,
    "description": "Io (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005293,
    "auth_name": "IAU_2015",
    "auth_id": "50145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65294,
    "description": "Io (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005294,
    "auth_name": "IAU_2015",
    "auth_id": "50150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65295,
    "description": "Io (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005295,
    "auth_name": "IAU_2015",
    "auth_id": "50155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65296,
    "description": "Io (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005296,
    "auth_name": "IAU_2015",
    "auth_id": "50160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65297,
    "description": "Io (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005297,
    "auth_name": "IAU_2015",
    "auth_id": "50165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65298,
    "description": "Io (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005298,
    "auth_name": "IAU_2015",
    "auth_id": "50170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65299,
    "description": "Io (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005299,
    "auth_name": "IAU_2015",
    "auth_id": "50175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65300,
    "description": "Io (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005300,
    "auth_name": "IAU_2015",
    "auth_id": "50180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65301,
    "description": "Io (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520005301,
    "auth_name": "IAU_2015",
    "auth_id": "50185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65302,
    "description": "Europa (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1560800 +no_defs",
    "srid": 520005302,
    "auth_name": "IAU_2015",
    "auth_id": "50200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65303,
    "description": "Europa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005303,
    "auth_name": "IAU_2015",
    "auth_id": "50210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65304,
    "description": "Europa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005304,
    "auth_name": "IAU_2015",
    "auth_id": "50215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65305,
    "description": "Europa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005305,
    "auth_name": "IAU_2015",
    "auth_id": "50220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65306,
    "description": "Europa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005306,
    "auth_name": "IAU_2015",
    "auth_id": "50225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65307,
    "description": "Europa (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005307,
    "auth_name": "IAU_2015",
    "auth_id": "50230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65308,
    "description": "Europa (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005308,
    "auth_name": "IAU_2015",
    "auth_id": "50235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65309,
    "description": "Europa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005309,
    "auth_name": "IAU_2015",
    "auth_id": "50240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65310,
    "description": "Europa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005310,
    "auth_name": "IAU_2015",
    "auth_id": "50245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65311,
    "description": "Europa (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005311,
    "auth_name": "IAU_2015",
    "auth_id": "50250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65312,
    "description": "Europa (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005312,
    "auth_name": "IAU_2015",
    "auth_id": "50255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65313,
    "description": "Europa (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005313,
    "auth_name": "IAU_2015",
    "auth_id": "50260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65314,
    "description": "Europa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005314,
    "auth_name": "IAU_2015",
    "auth_id": "50265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65315,
    "description": "Europa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005315,
    "auth_name": "IAU_2015",
    "auth_id": "50270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65316,
    "description": "Europa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005316,
    "auth_name": "IAU_2015",
    "auth_id": "50275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65317,
    "description": "Europa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005317,
    "auth_name": "IAU_2015",
    "auth_id": "50280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65318,
    "description": "Europa (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520005318,
    "auth_name": "IAU_2015",
    "auth_id": "50285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65319,
    "description": "Ganymede (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2631200 +no_defs",
    "srid": 520005319,
    "auth_name": "IAU_2015",
    "auth_id": "50300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65320,
    "description": "Ganymede (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2631200 +no_defs",
    "srid": 520005320,
    "auth_name": "IAU_2015",
    "auth_id": "50301",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65321,
    "description": "Ganymede (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005321,
    "auth_name": "IAU_2015",
    "auth_id": "50310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65322,
    "description": "Ganymede (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005322,
    "auth_name": "IAU_2015",
    "auth_id": "50311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65323,
    "description": "Ganymede (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005323,
    "auth_name": "IAU_2015",
    "auth_id": "50315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65324,
    "description": "Ganymede (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005324,
    "auth_name": "IAU_2015",
    "auth_id": "50316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65325,
    "description": "Ganymede (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005325,
    "auth_name": "IAU_2015",
    "auth_id": "50320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65326,
    "description": "Ganymede (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005326,
    "auth_name": "IAU_2015",
    "auth_id": "50321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65327,
    "description": "Ganymede (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005327,
    "auth_name": "IAU_2015",
    "auth_id": "50325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65328,
    "description": "Ganymede (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005328,
    "auth_name": "IAU_2015",
    "auth_id": "50326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65329,
    "description": "Ganymede (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005329,
    "auth_name": "IAU_2015",
    "auth_id": "50330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65330,
    "description": "Ganymede (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005330,
    "auth_name": "IAU_2015",
    "auth_id": "50331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65331,
    "description": "Ganymede (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005331,
    "auth_name": "IAU_2015",
    "auth_id": "50335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65332,
    "description": "Ganymede (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005332,
    "auth_name": "IAU_2015",
    "auth_id": "50336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65333,
    "description": "Ganymede (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005333,
    "auth_name": "IAU_2015",
    "auth_id": "50340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65334,
    "description": "Ganymede (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005334,
    "auth_name": "IAU_2015",
    "auth_id": "50341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65335,
    "description": "Ganymede (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005335,
    "auth_name": "IAU_2015",
    "auth_id": "50345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65336,
    "description": "Ganymede (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005336,
    "auth_name": "IAU_2015",
    "auth_id": "50346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65337,
    "description": "Ganymede (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005337,
    "auth_name": "IAU_2015",
    "auth_id": "50350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65338,
    "description": "Ganymede (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005338,
    "auth_name": "IAU_2015",
    "auth_id": "50351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65339,
    "description": "Ganymede (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005339,
    "auth_name": "IAU_2015",
    "auth_id": "50355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65340,
    "description": "Ganymede (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005340,
    "auth_name": "IAU_2015",
    "auth_id": "50356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65341,
    "description": "Ganymede (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005341,
    "auth_name": "IAU_2015",
    "auth_id": "50360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65342,
    "description": "Ganymede (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005342,
    "auth_name": "IAU_2015",
    "auth_id": "50361",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65343,
    "description": "Ganymede (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005343,
    "auth_name": "IAU_2015",
    "auth_id": "50365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65344,
    "description": "Ganymede (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005344,
    "auth_name": "IAU_2015",
    "auth_id": "50366",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65345,
    "description": "Ganymede (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005345,
    "auth_name": "IAU_2015",
    "auth_id": "50370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65346,
    "description": "Ganymede (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005346,
    "auth_name": "IAU_2015",
    "auth_id": "50371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65347,
    "description": "Ganymede (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005347,
    "auth_name": "IAU_2015",
    "auth_id": "50375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65348,
    "description": "Ganymede (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005348,
    "auth_name": "IAU_2015",
    "auth_id": "50376",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65349,
    "description": "Ganymede (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005349,
    "auth_name": "IAU_2015",
    "auth_id": "50380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65350,
    "description": "Ganymede (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005350,
    "auth_name": "IAU_2015",
    "auth_id": "50381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65351,
    "description": "Ganymede (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005351,
    "auth_name": "IAU_2015",
    "auth_id": "50385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65352,
    "description": "Ganymede (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520005352,
    "auth_name": "IAU_2015",
    "auth_id": "50386",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65353,
    "description": "Callisto (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2410300 +no_defs",
    "srid": 520005353,
    "auth_name": "IAU_2015",
    "auth_id": "50400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65354,
    "description": "Callisto (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2410300 +no_defs",
    "srid": 520005354,
    "auth_name": "IAU_2015",
    "auth_id": "50401",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65355,
    "description": "Callisto (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005355,
    "auth_name": "IAU_2015",
    "auth_id": "50410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65356,
    "description": "Callisto (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005356,
    "auth_name": "IAU_2015",
    "auth_id": "50411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65357,
    "description": "Callisto (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005357,
    "auth_name": "IAU_2015",
    "auth_id": "50415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65358,
    "description": "Callisto (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005358,
    "auth_name": "IAU_2015",
    "auth_id": "50416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65359,
    "description": "Callisto (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005359,
    "auth_name": "IAU_2015",
    "auth_id": "50420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65360,
    "description": "Callisto (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005360,
    "auth_name": "IAU_2015",
    "auth_id": "50421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65361,
    "description": "Callisto (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005361,
    "auth_name": "IAU_2015",
    "auth_id": "50425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65362,
    "description": "Callisto (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005362,
    "auth_name": "IAU_2015",
    "auth_id": "50426",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65363,
    "description": "Callisto (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005363,
    "auth_name": "IAU_2015",
    "auth_id": "50430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65364,
    "description": "Callisto (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005364,
    "auth_name": "IAU_2015",
    "auth_id": "50431",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65365,
    "description": "Callisto (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005365,
    "auth_name": "IAU_2015",
    "auth_id": "50435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65366,
    "description": "Callisto (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005366,
    "auth_name": "IAU_2015",
    "auth_id": "50436",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65367,
    "description": "Callisto (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005367,
    "auth_name": "IAU_2015",
    "auth_id": "50440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65368,
    "description": "Callisto (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005368,
    "auth_name": "IAU_2015",
    "auth_id": "50441",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65369,
    "description": "Callisto (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005369,
    "auth_name": "IAU_2015",
    "auth_id": "50445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65370,
    "description": "Callisto (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005370,
    "auth_name": "IAU_2015",
    "auth_id": "50446",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65371,
    "description": "Callisto (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005371,
    "auth_name": "IAU_2015",
    "auth_id": "50450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65372,
    "description": "Callisto (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005372,
    "auth_name": "IAU_2015",
    "auth_id": "50451",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65373,
    "description": "Callisto (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005373,
    "auth_name": "IAU_2015",
    "auth_id": "50455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65374,
    "description": "Callisto (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005374,
    "auth_name": "IAU_2015",
    "auth_id": "50456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65375,
    "description": "Callisto (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005375,
    "auth_name": "IAU_2015",
    "auth_id": "50460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65376,
    "description": "Callisto (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005376,
    "auth_name": "IAU_2015",
    "auth_id": "50461",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65377,
    "description": "Callisto (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005377,
    "auth_name": "IAU_2015",
    "auth_id": "50465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65378,
    "description": "Callisto (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005378,
    "auth_name": "IAU_2015",
    "auth_id": "50466",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65379,
    "description": "Callisto (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005379,
    "auth_name": "IAU_2015",
    "auth_id": "50470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65380,
    "description": "Callisto (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005380,
    "auth_name": "IAU_2015",
    "auth_id": "50471",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65381,
    "description": "Callisto (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005381,
    "auth_name": "IAU_2015",
    "auth_id": "50475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65382,
    "description": "Callisto (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005382,
    "auth_name": "IAU_2015",
    "auth_id": "50476",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65383,
    "description": "Callisto (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005383,
    "auth_name": "IAU_2015",
    "auth_id": "50480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65384,
    "description": "Callisto (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005384,
    "auth_name": "IAU_2015",
    "auth_id": "50481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65385,
    "description": "Callisto (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005385,
    "auth_name": "IAU_2015",
    "auth_id": "50485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65386,
    "description": "Callisto (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520005386,
    "auth_name": "IAU_2015",
    "auth_id": "50486",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65387,
    "description": "Amalthea (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=83500 +no_defs",
    "srid": 520005387,
    "auth_name": "IAU_2015",
    "auth_id": "50500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65388,
    "description": "Amalthea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005388,
    "auth_name": "IAU_2015",
    "auth_id": "50510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65389,
    "description": "Amalthea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005389,
    "auth_name": "IAU_2015",
    "auth_id": "50515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65390,
    "description": "Amalthea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005390,
    "auth_name": "IAU_2015",
    "auth_id": "50520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65391,
    "description": "Amalthea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005391,
    "auth_name": "IAU_2015",
    "auth_id": "50525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65392,
    "description": "Amalthea (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005392,
    "auth_name": "IAU_2015",
    "auth_id": "50530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65393,
    "description": "Amalthea (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005393,
    "auth_name": "IAU_2015",
    "auth_id": "50535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65394,
    "description": "Amalthea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005394,
    "auth_name": "IAU_2015",
    "auth_id": "50540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65395,
    "description": "Amalthea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005395,
    "auth_name": "IAU_2015",
    "auth_id": "50545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65396,
    "description": "Amalthea (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005396,
    "auth_name": "IAU_2015",
    "auth_id": "50550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65397,
    "description": "Amalthea (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005397,
    "auth_name": "IAU_2015",
    "auth_id": "50555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65398,
    "description": "Amalthea (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005398,
    "auth_name": "IAU_2015",
    "auth_id": "50560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65399,
    "description": "Amalthea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005399,
    "auth_name": "IAU_2015",
    "auth_id": "50565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65400,
    "description": "Amalthea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005400,
    "auth_name": "IAU_2015",
    "auth_id": "50570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65401,
    "description": "Amalthea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005401,
    "auth_name": "IAU_2015",
    "auth_id": "50575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65402,
    "description": "Amalthea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005402,
    "auth_name": "IAU_2015",
    "auth_id": "50580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65403,
    "description": "Amalthea (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520005403,
    "auth_name": "IAU_2015",
    "auth_id": "50585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65404,
    "description": "Himalia (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=85000 +no_defs",
    "srid": 520005404,
    "auth_name": "IAU_2015",
    "auth_id": "50600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65405,
    "description": "Himalia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005405,
    "auth_name": "IAU_2015",
    "auth_id": "50610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65406,
    "description": "Himalia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005406,
    "auth_name": "IAU_2015",
    "auth_id": "50615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65407,
    "description": "Himalia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005407,
    "auth_name": "IAU_2015",
    "auth_id": "50620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65408,
    "description": "Himalia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005408,
    "auth_name": "IAU_2015",
    "auth_id": "50625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65409,
    "description": "Himalia (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005409,
    "auth_name": "IAU_2015",
    "auth_id": "50630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65410,
    "description": "Himalia (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005410,
    "auth_name": "IAU_2015",
    "auth_id": "50635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65411,
    "description": "Himalia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005411,
    "auth_name": "IAU_2015",
    "auth_id": "50640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65412,
    "description": "Himalia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005412,
    "auth_name": "IAU_2015",
    "auth_id": "50645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65413,
    "description": "Himalia (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005413,
    "auth_name": "IAU_2015",
    "auth_id": "50650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65414,
    "description": "Himalia (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005414,
    "auth_name": "IAU_2015",
    "auth_id": "50655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65415,
    "description": "Himalia (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005415,
    "auth_name": "IAU_2015",
    "auth_id": "50660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65416,
    "description": "Himalia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005416,
    "auth_name": "IAU_2015",
    "auth_id": "50665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65417,
    "description": "Himalia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005417,
    "auth_name": "IAU_2015",
    "auth_id": "50670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65418,
    "description": "Himalia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005418,
    "auth_name": "IAU_2015",
    "auth_id": "50675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65419,
    "description": "Himalia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005419,
    "auth_name": "IAU_2015",
    "auth_id": "50680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65420,
    "description": "Himalia (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520005420,
    "auth_name": "IAU_2015",
    "auth_id": "50685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65421,
    "description": "Elara (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=40000 +no_defs",
    "srid": 520005421,
    "auth_name": "IAU_2015",
    "auth_id": "50700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65422,
    "description": "Elara (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005422,
    "auth_name": "IAU_2015",
    "auth_id": "50710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65423,
    "description": "Elara (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005423,
    "auth_name": "IAU_2015",
    "auth_id": "50715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65424,
    "description": "Elara (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005424,
    "auth_name": "IAU_2015",
    "auth_id": "50720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65425,
    "description": "Elara (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005425,
    "auth_name": "IAU_2015",
    "auth_id": "50725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65426,
    "description": "Elara (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005426,
    "auth_name": "IAU_2015",
    "auth_id": "50730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65427,
    "description": "Elara (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005427,
    "auth_name": "IAU_2015",
    "auth_id": "50735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65428,
    "description": "Elara (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005428,
    "auth_name": "IAU_2015",
    "auth_id": "50740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65429,
    "description": "Elara (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005429,
    "auth_name": "IAU_2015",
    "auth_id": "50745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65430,
    "description": "Elara (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005430,
    "auth_name": "IAU_2015",
    "auth_id": "50750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65431,
    "description": "Elara (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005431,
    "auth_name": "IAU_2015",
    "auth_id": "50755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65432,
    "description": "Elara (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005432,
    "auth_name": "IAU_2015",
    "auth_id": "50760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65433,
    "description": "Elara (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005433,
    "auth_name": "IAU_2015",
    "auth_id": "50765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65434,
    "description": "Elara (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005434,
    "auth_name": "IAU_2015",
    "auth_id": "50770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65435,
    "description": "Elara (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005435,
    "auth_name": "IAU_2015",
    "auth_id": "50775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65436,
    "description": "Elara (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005436,
    "auth_name": "IAU_2015",
    "auth_id": "50780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65437,
    "description": "Elara (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520005437,
    "auth_name": "IAU_2015",
    "auth_id": "50785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65438,
    "description": "Pasiphae (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=18000 +no_defs",
    "srid": 520005438,
    "auth_name": "IAU_2015",
    "auth_id": "50800",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65439,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005439,
    "auth_name": "IAU_2015",
    "auth_id": "50810",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65440,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005440,
    "auth_name": "IAU_2015",
    "auth_id": "50815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65441,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005441,
    "auth_name": "IAU_2015",
    "auth_id": "50820",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65442,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005442,
    "auth_name": "IAU_2015",
    "auth_id": "50825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65443,
    "description": "Pasiphae (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005443,
    "auth_name": "IAU_2015",
    "auth_id": "50830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65444,
    "description": "Pasiphae (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005444,
    "auth_name": "IAU_2015",
    "auth_id": "50835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65445,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005445,
    "auth_name": "IAU_2015",
    "auth_id": "50840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65446,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005446,
    "auth_name": "IAU_2015",
    "auth_id": "50845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65447,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005447,
    "auth_name": "IAU_2015",
    "auth_id": "50850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65448,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005448,
    "auth_name": "IAU_2015",
    "auth_id": "50855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65449,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005449,
    "auth_name": "IAU_2015",
    "auth_id": "50860",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65450,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005450,
    "auth_name": "IAU_2015",
    "auth_id": "50865",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65451,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005451,
    "auth_name": "IAU_2015",
    "auth_id": "50870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65452,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005452,
    "auth_name": "IAU_2015",
    "auth_id": "50875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65453,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005453,
    "auth_name": "IAU_2015",
    "auth_id": "50880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65454,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005454,
    "auth_name": "IAU_2015",
    "auth_id": "50885",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65455,
    "description": "Sinope (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=14000 +no_defs",
    "srid": 520005455,
    "auth_name": "IAU_2015",
    "auth_id": "50900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65456,
    "description": "Sinope (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005456,
    "auth_name": "IAU_2015",
    "auth_id": "50910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65457,
    "description": "Sinope (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005457,
    "auth_name": "IAU_2015",
    "auth_id": "50915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65458,
    "description": "Sinope (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005458,
    "auth_name": "IAU_2015",
    "auth_id": "50920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65459,
    "description": "Sinope (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005459,
    "auth_name": "IAU_2015",
    "auth_id": "50925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65460,
    "description": "Sinope (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005460,
    "auth_name": "IAU_2015",
    "auth_id": "50930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65461,
    "description": "Sinope (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005461,
    "auth_name": "IAU_2015",
    "auth_id": "50935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65462,
    "description": "Sinope (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005462,
    "auth_name": "IAU_2015",
    "auth_id": "50940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65463,
    "description": "Sinope (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005463,
    "auth_name": "IAU_2015",
    "auth_id": "50945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65464,
    "description": "Sinope (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005464,
    "auth_name": "IAU_2015",
    "auth_id": "50950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65465,
    "description": "Sinope (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005465,
    "auth_name": "IAU_2015",
    "auth_id": "50955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65466,
    "description": "Sinope (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005466,
    "auth_name": "IAU_2015",
    "auth_id": "50960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65467,
    "description": "Sinope (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005467,
    "auth_name": "IAU_2015",
    "auth_id": "50965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65468,
    "description": "Sinope (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005468,
    "auth_name": "IAU_2015",
    "auth_id": "50970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65469,
    "description": "Sinope (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005469,
    "auth_name": "IAU_2015",
    "auth_id": "50975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65470,
    "description": "Sinope (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005470,
    "auth_name": "IAU_2015",
    "auth_id": "50980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65471,
    "description": "Sinope (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005471,
    "auth_name": "IAU_2015",
    "auth_id": "50985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65472,
    "description": "Lysithea (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=12000 +no_defs",
    "srid": 520005472,
    "auth_name": "IAU_2015",
    "auth_id": "51000",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65473,
    "description": "Lysithea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005473,
    "auth_name": "IAU_2015",
    "auth_id": "51010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65474,
    "description": "Lysithea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005474,
    "auth_name": "IAU_2015",
    "auth_id": "51015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65475,
    "description": "Lysithea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005475,
    "auth_name": "IAU_2015",
    "auth_id": "51020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65476,
    "description": "Lysithea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005476,
    "auth_name": "IAU_2015",
    "auth_id": "51025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65477,
    "description": "Lysithea (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005477,
    "auth_name": "IAU_2015",
    "auth_id": "51030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65478,
    "description": "Lysithea (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005478,
    "auth_name": "IAU_2015",
    "auth_id": "51035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65479,
    "description": "Lysithea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005479,
    "auth_name": "IAU_2015",
    "auth_id": "51040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65480,
    "description": "Lysithea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005480,
    "auth_name": "IAU_2015",
    "auth_id": "51045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65481,
    "description": "Lysithea (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005481,
    "auth_name": "IAU_2015",
    "auth_id": "51050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65482,
    "description": "Lysithea (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005482,
    "auth_name": "IAU_2015",
    "auth_id": "51055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65483,
    "description": "Lysithea (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005483,
    "auth_name": "IAU_2015",
    "auth_id": "51060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65484,
    "description": "Lysithea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005484,
    "auth_name": "IAU_2015",
    "auth_id": "51065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65485,
    "description": "Lysithea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005485,
    "auth_name": "IAU_2015",
    "auth_id": "51070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65486,
    "description": "Lysithea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005486,
    "auth_name": "IAU_2015",
    "auth_id": "51075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65487,
    "description": "Lysithea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005487,
    "auth_name": "IAU_2015",
    "auth_id": "51080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65488,
    "description": "Lysithea (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520005488,
    "auth_name": "IAU_2015",
    "auth_id": "51085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65489,
    "description": "Carme (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=15000 +no_defs",
    "srid": 520005489,
    "auth_name": "IAU_2015",
    "auth_id": "51100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65490,
    "description": "Carme (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005490,
    "auth_name": "IAU_2015",
    "auth_id": "51110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65491,
    "description": "Carme (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005491,
    "auth_name": "IAU_2015",
    "auth_id": "51115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65492,
    "description": "Carme (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005492,
    "auth_name": "IAU_2015",
    "auth_id": "51120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65493,
    "description": "Carme (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005493,
    "auth_name": "IAU_2015",
    "auth_id": "51125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65494,
    "description": "Carme (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005494,
    "auth_name": "IAU_2015",
    "auth_id": "51130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65495,
    "description": "Carme (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005495,
    "auth_name": "IAU_2015",
    "auth_id": "51135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65496,
    "description": "Carme (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005496,
    "auth_name": "IAU_2015",
    "auth_id": "51140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65497,
    "description": "Carme (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005497,
    "auth_name": "IAU_2015",
    "auth_id": "51145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65498,
    "description": "Carme (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005498,
    "auth_name": "IAU_2015",
    "auth_id": "51150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65499,
    "description": "Carme (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005499,
    "auth_name": "IAU_2015",
    "auth_id": "51155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65500,
    "description": "Carme (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005500,
    "auth_name": "IAU_2015",
    "auth_id": "51160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65501,
    "description": "Carme (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005501,
    "auth_name": "IAU_2015",
    "auth_id": "51165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65502,
    "description": "Carme (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005502,
    "auth_name": "IAU_2015",
    "auth_id": "51170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65503,
    "description": "Carme (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005503,
    "auth_name": "IAU_2015",
    "auth_id": "51175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65504,
    "description": "Carme (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005504,
    "auth_name": "IAU_2015",
    "auth_id": "51180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65505,
    "description": "Carme (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520005505,
    "auth_name": "IAU_2015",
    "auth_id": "51185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65506,
    "description": "Ananke (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=10000 +no_defs",
    "srid": 520005506,
    "auth_name": "IAU_2015",
    "auth_id": "51200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65507,
    "description": "Ananke (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005507,
    "auth_name": "IAU_2015",
    "auth_id": "51210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65508,
    "description": "Ananke (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005508,
    "auth_name": "IAU_2015",
    "auth_id": "51215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65509,
    "description": "Ananke (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005509,
    "auth_name": "IAU_2015",
    "auth_id": "51220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65510,
    "description": "Ananke (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005510,
    "auth_name": "IAU_2015",
    "auth_id": "51225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65511,
    "description": "Ananke (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005511,
    "auth_name": "IAU_2015",
    "auth_id": "51230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65512,
    "description": "Ananke (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005512,
    "auth_name": "IAU_2015",
    "auth_id": "51235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65513,
    "description": "Ananke (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005513,
    "auth_name": "IAU_2015",
    "auth_id": "51240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65514,
    "description": "Ananke (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005514,
    "auth_name": "IAU_2015",
    "auth_id": "51245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65515,
    "description": "Ananke (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005515,
    "auth_name": "IAU_2015",
    "auth_id": "51250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65516,
    "description": "Ananke (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005516,
    "auth_name": "IAU_2015",
    "auth_id": "51255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65517,
    "description": "Ananke (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005517,
    "auth_name": "IAU_2015",
    "auth_id": "51260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65518,
    "description": "Ananke (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005518,
    "auth_name": "IAU_2015",
    "auth_id": "51265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65519,
    "description": "Ananke (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005519,
    "auth_name": "IAU_2015",
    "auth_id": "51270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65520,
    "description": "Ananke (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005520,
    "auth_name": "IAU_2015",
    "auth_id": "51275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65521,
    "description": "Ananke (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005521,
    "auth_name": "IAU_2015",
    "auth_id": "51280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65522,
    "description": "Ananke (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520005522,
    "auth_name": "IAU_2015",
    "auth_id": "51285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65523,
    "description": "Leda (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=5000 +no_defs",
    "srid": 520005523,
    "auth_name": "IAU_2015",
    "auth_id": "51300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65524,
    "description": "Leda (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005524,
    "auth_name": "IAU_2015",
    "auth_id": "51310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65525,
    "description": "Leda (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005525,
    "auth_name": "IAU_2015",
    "auth_id": "51315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65526,
    "description": "Leda (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005526,
    "auth_name": "IAU_2015",
    "auth_id": "51320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65527,
    "description": "Leda (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005527,
    "auth_name": "IAU_2015",
    "auth_id": "51325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65528,
    "description": "Leda (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005528,
    "auth_name": "IAU_2015",
    "auth_id": "51330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65529,
    "description": "Leda (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005529,
    "auth_name": "IAU_2015",
    "auth_id": "51335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65530,
    "description": "Leda (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005530,
    "auth_name": "IAU_2015",
    "auth_id": "51340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65531,
    "description": "Leda (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005531,
    "auth_name": "IAU_2015",
    "auth_id": "51345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65532,
    "description": "Leda (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005532,
    "auth_name": "IAU_2015",
    "auth_id": "51350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65533,
    "description": "Leda (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005533,
    "auth_name": "IAU_2015",
    "auth_id": "51355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65534,
    "description": "Leda (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005534,
    "auth_name": "IAU_2015",
    "auth_id": "51360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65535,
    "description": "Leda (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005535,
    "auth_name": "IAU_2015",
    "auth_id": "51365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65536,
    "description": "Leda (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005536,
    "auth_name": "IAU_2015",
    "auth_id": "51370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65537,
    "description": "Leda (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005537,
    "auth_name": "IAU_2015",
    "auth_id": "51375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65538,
    "description": "Leda (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005538,
    "auth_name": "IAU_2015",
    "auth_id": "51380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65539,
    "description": "Leda (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520005539,
    "auth_name": "IAU_2015",
    "auth_id": "51385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65540,
    "description": "Thebe (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=49300 +no_defs",
    "srid": 520005540,
    "auth_name": "IAU_2015",
    "auth_id": "51400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65541,
    "description": "Thebe (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005541,
    "auth_name": "IAU_2015",
    "auth_id": "51410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65542,
    "description": "Thebe (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005542,
    "auth_name": "IAU_2015",
    "auth_id": "51415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65543,
    "description": "Thebe (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005543,
    "auth_name": "IAU_2015",
    "auth_id": "51420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65544,
    "description": "Thebe (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005544,
    "auth_name": "IAU_2015",
    "auth_id": "51425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65545,
    "description": "Thebe (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005545,
    "auth_name": "IAU_2015",
    "auth_id": "51430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65546,
    "description": "Thebe (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005546,
    "auth_name": "IAU_2015",
    "auth_id": "51435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65547,
    "description": "Thebe (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005547,
    "auth_name": "IAU_2015",
    "auth_id": "51440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65548,
    "description": "Thebe (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005548,
    "auth_name": "IAU_2015",
    "auth_id": "51445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65549,
    "description": "Thebe (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005549,
    "auth_name": "IAU_2015",
    "auth_id": "51450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65550,
    "description": "Thebe (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005550,
    "auth_name": "IAU_2015",
    "auth_id": "51455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65551,
    "description": "Thebe (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005551,
    "auth_name": "IAU_2015",
    "auth_id": "51460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65552,
    "description": "Thebe (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005552,
    "auth_name": "IAU_2015",
    "auth_id": "51465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65553,
    "description": "Thebe (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005553,
    "auth_name": "IAU_2015",
    "auth_id": "51470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65554,
    "description": "Thebe (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005554,
    "auth_name": "IAU_2015",
    "auth_id": "51475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65555,
    "description": "Thebe (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005555,
    "auth_name": "IAU_2015",
    "auth_id": "51480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65556,
    "description": "Thebe (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520005556,
    "auth_name": "IAU_2015",
    "auth_id": "51485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65557,
    "description": "Adrastea (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=8200 +no_defs",
    "srid": 520005557,
    "auth_name": "IAU_2015",
    "auth_id": "51500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65558,
    "description": "Adrastea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005558,
    "auth_name": "IAU_2015",
    "auth_id": "51510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65559,
    "description": "Adrastea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005559,
    "auth_name": "IAU_2015",
    "auth_id": "51515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65560,
    "description": "Adrastea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005560,
    "auth_name": "IAU_2015",
    "auth_id": "51520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65561,
    "description": "Adrastea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005561,
    "auth_name": "IAU_2015",
    "auth_id": "51525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65562,
    "description": "Adrastea (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005562,
    "auth_name": "IAU_2015",
    "auth_id": "51530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65563,
    "description": "Adrastea (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005563,
    "auth_name": "IAU_2015",
    "auth_id": "51535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65564,
    "description": "Adrastea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005564,
    "auth_name": "IAU_2015",
    "auth_id": "51540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65565,
    "description": "Adrastea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005565,
    "auth_name": "IAU_2015",
    "auth_id": "51545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65566,
    "description": "Adrastea (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005566,
    "auth_name": "IAU_2015",
    "auth_id": "51550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65567,
    "description": "Adrastea (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005567,
    "auth_name": "IAU_2015",
    "auth_id": "51555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65568,
    "description": "Adrastea (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005568,
    "auth_name": "IAU_2015",
    "auth_id": "51560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65569,
    "description": "Adrastea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005569,
    "auth_name": "IAU_2015",
    "auth_id": "51565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65570,
    "description": "Adrastea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005570,
    "auth_name": "IAU_2015",
    "auth_id": "51570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65571,
    "description": "Adrastea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005571,
    "auth_name": "IAU_2015",
    "auth_id": "51575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65572,
    "description": "Adrastea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005572,
    "auth_name": "IAU_2015",
    "auth_id": "51580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65573,
    "description": "Adrastea (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520005573,
    "auth_name": "IAU_2015",
    "auth_id": "51585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65574,
    "description": "Metis (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=21500 +no_defs",
    "srid": 520005574,
    "auth_name": "IAU_2015",
    "auth_id": "51600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65575,
    "description": "Metis (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005575,
    "auth_name": "IAU_2015",
    "auth_id": "51610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65576,
    "description": "Metis (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005576,
    "auth_name": "IAU_2015",
    "auth_id": "51615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65577,
    "description": "Metis (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005577,
    "auth_name": "IAU_2015",
    "auth_id": "51620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65578,
    "description": "Metis (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005578,
    "auth_name": "IAU_2015",
    "auth_id": "51625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65579,
    "description": "Metis (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005579,
    "auth_name": "IAU_2015",
    "auth_id": "51630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65580,
    "description": "Metis (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005580,
    "auth_name": "IAU_2015",
    "auth_id": "51635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65581,
    "description": "Metis (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005581,
    "auth_name": "IAU_2015",
    "auth_id": "51640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65582,
    "description": "Metis (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005582,
    "auth_name": "IAU_2015",
    "auth_id": "51645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65583,
    "description": "Metis (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005583,
    "auth_name": "IAU_2015",
    "auth_id": "51650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65584,
    "description": "Metis (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005584,
    "auth_name": "IAU_2015",
    "auth_id": "51655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65585,
    "description": "Metis (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005585,
    "auth_name": "IAU_2015",
    "auth_id": "51660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65586,
    "description": "Metis (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005586,
    "auth_name": "IAU_2015",
    "auth_id": "51665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65587,
    "description": "Metis (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005587,
    "auth_name": "IAU_2015",
    "auth_id": "51670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65588,
    "description": "Metis (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005588,
    "auth_name": "IAU_2015",
    "auth_id": "51675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65589,
    "description": "Metis (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005589,
    "auth_name": "IAU_2015",
    "auth_id": "51680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65590,
    "description": "Metis (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520005590,
    "auth_name": "IAU_2015",
    "auth_id": "51685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65591,
    "description": "Jupiter (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=71492000 +no_defs",
    "srid": 520005591,
    "auth_name": "IAU_2015",
    "auth_id": "59900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65592,
    "description": "Jupiter (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=71492000 +b=66854000 +no_defs",
    "srid": 520005592,
    "auth_name": "IAU_2015",
    "auth_id": "59901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65593,
    "description": "Jupiter (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520005593,
    "auth_name": "IAU_2015",
    "auth_id": "59902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 65594,
    "description": "Jupiter (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005594,
    "auth_name": "IAU_2015",
    "auth_id": "59910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65595,
    "description": "Jupiter (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005595,
    "auth_name": "IAU_2015",
    "auth_id": "59911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65596,
    "description": "Jupiter (2015) / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005596,
    "auth_name": "IAU_2015",
    "auth_id": "59912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65597,
    "description": "Jupiter (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005597,
    "auth_name": "IAU_2015",
    "auth_id": "59915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65598,
    "description": "Jupiter (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005598,
    "auth_name": "IAU_2015",
    "auth_id": "59916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65599,
    "description": "Jupiter (2015) / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005599,
    "auth_name": "IAU_2015",
    "auth_id": "59917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65600,
    "description": "Jupiter (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005600,
    "auth_name": "IAU_2015",
    "auth_id": "59920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65601,
    "description": "Jupiter (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005601,
    "auth_name": "IAU_2015",
    "auth_id": "59921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65602,
    "description": "Jupiter (2015) / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005602,
    "auth_name": "IAU_2015",
    "auth_id": "59922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65603,
    "description": "Jupiter (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005603,
    "auth_name": "IAU_2015",
    "auth_id": "59925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65604,
    "description": "Jupiter (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005604,
    "auth_name": "IAU_2015",
    "auth_id": "59926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65605,
    "description": "Jupiter (2015) / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005605,
    "auth_name": "IAU_2015",
    "auth_id": "59927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65606,
    "description": "Jupiter (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005606,
    "auth_name": "IAU_2015",
    "auth_id": "59930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65607,
    "description": "Jupiter (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005607,
    "auth_name": "IAU_2015",
    "auth_id": "59931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65608,
    "description": "Jupiter (2015) / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005608,
    "auth_name": "IAU_2015",
    "auth_id": "59932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65609,
    "description": "Jupiter (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005609,
    "auth_name": "IAU_2015",
    "auth_id": "59935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65610,
    "description": "Jupiter (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005610,
    "auth_name": "IAU_2015",
    "auth_id": "59936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65611,
    "description": "Jupiter (2015) / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005611,
    "auth_name": "IAU_2015",
    "auth_id": "59937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65612,
    "description": "Jupiter (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005612,
    "auth_name": "IAU_2015",
    "auth_id": "59940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65613,
    "description": "Jupiter (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005613,
    "auth_name": "IAU_2015",
    "auth_id": "59941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65614,
    "description": "Jupiter (2015) / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005614,
    "auth_name": "IAU_2015",
    "auth_id": "59942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65615,
    "description": "Jupiter (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005615,
    "auth_name": "IAU_2015",
    "auth_id": "59945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65616,
    "description": "Jupiter (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005616,
    "auth_name": "IAU_2015",
    "auth_id": "59946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65617,
    "description": "Jupiter (2015) / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005617,
    "auth_name": "IAU_2015",
    "auth_id": "59947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65618,
    "description": "Jupiter (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005618,
    "auth_name": "IAU_2015",
    "auth_id": "59950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65619,
    "description": "Jupiter (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005619,
    "auth_name": "IAU_2015",
    "auth_id": "59951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65620,
    "description": "Jupiter (2015) / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005620,
    "auth_name": "IAU_2015",
    "auth_id": "59952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65621,
    "description": "Jupiter (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005621,
    "auth_name": "IAU_2015",
    "auth_id": "59955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65622,
    "description": "Jupiter (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005622,
    "auth_name": "IAU_2015",
    "auth_id": "59956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65623,
    "description": "Jupiter (2015) / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005623,
    "auth_name": "IAU_2015",
    "auth_id": "59957",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65624,
    "description": "Jupiter (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005624,
    "auth_name": "IAU_2015",
    "auth_id": "59960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65625,
    "description": "Jupiter (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005625,
    "auth_name": "IAU_2015",
    "auth_id": "59961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65626,
    "description": "Jupiter (2015) / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005626,
    "auth_name": "IAU_2015",
    "auth_id": "59962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65627,
    "description": "Jupiter (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005627,
    "auth_name": "IAU_2015",
    "auth_id": "59965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65628,
    "description": "Jupiter (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005628,
    "auth_name": "IAU_2015",
    "auth_id": "59966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65629,
    "description": "Jupiter (2015) / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005629,
    "auth_name": "IAU_2015",
    "auth_id": "59967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65630,
    "description": "Jupiter (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005630,
    "auth_name": "IAU_2015",
    "auth_id": "59970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65631,
    "description": "Jupiter (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005631,
    "auth_name": "IAU_2015",
    "auth_id": "59971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65632,
    "description": "Jupiter (2015) / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005632,
    "auth_name": "IAU_2015",
    "auth_id": "59972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65633,
    "description": "Jupiter (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005633,
    "auth_name": "IAU_2015",
    "auth_id": "59975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65634,
    "description": "Jupiter (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005634,
    "auth_name": "IAU_2015",
    "auth_id": "59976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65635,
    "description": "Jupiter (2015) / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005635,
    "auth_name": "IAU_2015",
    "auth_id": "59977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65636,
    "description": "Jupiter (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005636,
    "auth_name": "IAU_2015",
    "auth_id": "59980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65637,
    "description": "Jupiter (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005637,
    "auth_name": "IAU_2015",
    "auth_id": "59981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65638,
    "description": "Jupiter (2015) / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005638,
    "auth_name": "IAU_2015",
    "auth_id": "59982",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65639,
    "description": "Jupiter (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520005639,
    "auth_name": "IAU_2015",
    "auth_id": "59985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65640,
    "description": "Jupiter (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005640,
    "auth_name": "IAU_2015",
    "auth_id": "59986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65641,
    "description": "Jupiter (2015) / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520005641,
    "auth_name": "IAU_2015",
    "auth_id": "59987",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65642,
    "description": "Mimas (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=198200 +no_defs",
    "srid": 520005642,
    "auth_name": "IAU_2015",
    "auth_id": "60100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65643,
    "description": "Mimas (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005643,
    "auth_name": "IAU_2015",
    "auth_id": "60110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65644,
    "description": "Mimas (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005644,
    "auth_name": "IAU_2015",
    "auth_id": "60115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65645,
    "description": "Mimas (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005645,
    "auth_name": "IAU_2015",
    "auth_id": "60120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65646,
    "description": "Mimas (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005646,
    "auth_name": "IAU_2015",
    "auth_id": "60125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65647,
    "description": "Mimas (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005647,
    "auth_name": "IAU_2015",
    "auth_id": "60130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65648,
    "description": "Mimas (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005648,
    "auth_name": "IAU_2015",
    "auth_id": "60135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65649,
    "description": "Mimas (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005649,
    "auth_name": "IAU_2015",
    "auth_id": "60140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65650,
    "description": "Mimas (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005650,
    "auth_name": "IAU_2015",
    "auth_id": "60145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65651,
    "description": "Mimas (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005651,
    "auth_name": "IAU_2015",
    "auth_id": "60150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65652,
    "description": "Mimas (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005652,
    "auth_name": "IAU_2015",
    "auth_id": "60155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65653,
    "description": "Mimas (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005653,
    "auth_name": "IAU_2015",
    "auth_id": "60160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65654,
    "description": "Mimas (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005654,
    "auth_name": "IAU_2015",
    "auth_id": "60165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65655,
    "description": "Mimas (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005655,
    "auth_name": "IAU_2015",
    "auth_id": "60170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65656,
    "description": "Mimas (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005656,
    "auth_name": "IAU_2015",
    "auth_id": "60175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65657,
    "description": "Mimas (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005657,
    "auth_name": "IAU_2015",
    "auth_id": "60180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65658,
    "description": "Mimas (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520005658,
    "auth_name": "IAU_2015",
    "auth_id": "60185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65659,
    "description": "Enceladus (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=252100 +no_defs",
    "srid": 520005659,
    "auth_name": "IAU_2015",
    "auth_id": "60200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65660,
    "description": "Enceladus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005660,
    "auth_name": "IAU_2015",
    "auth_id": "60210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65661,
    "description": "Enceladus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005661,
    "auth_name": "IAU_2015",
    "auth_id": "60215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65662,
    "description": "Enceladus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005662,
    "auth_name": "IAU_2015",
    "auth_id": "60220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65663,
    "description": "Enceladus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005663,
    "auth_name": "IAU_2015",
    "auth_id": "60225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65664,
    "description": "Enceladus (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005664,
    "auth_name": "IAU_2015",
    "auth_id": "60230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65665,
    "description": "Enceladus (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005665,
    "auth_name": "IAU_2015",
    "auth_id": "60235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65666,
    "description": "Enceladus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005666,
    "auth_name": "IAU_2015",
    "auth_id": "60240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65667,
    "description": "Enceladus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005667,
    "auth_name": "IAU_2015",
    "auth_id": "60245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65668,
    "description": "Enceladus (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005668,
    "auth_name": "IAU_2015",
    "auth_id": "60250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65669,
    "description": "Enceladus (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005669,
    "auth_name": "IAU_2015",
    "auth_id": "60255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65670,
    "description": "Enceladus (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005670,
    "auth_name": "IAU_2015",
    "auth_id": "60260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65671,
    "description": "Enceladus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005671,
    "auth_name": "IAU_2015",
    "auth_id": "60265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65672,
    "description": "Enceladus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005672,
    "auth_name": "IAU_2015",
    "auth_id": "60270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65673,
    "description": "Enceladus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005673,
    "auth_name": "IAU_2015",
    "auth_id": "60275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65674,
    "description": "Enceladus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005674,
    "auth_name": "IAU_2015",
    "auth_id": "60280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65675,
    "description": "Enceladus (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520005675,
    "auth_name": "IAU_2015",
    "auth_id": "60285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65676,
    "description": "Tethys (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=531000 +no_defs",
    "srid": 520005676,
    "auth_name": "IAU_2015",
    "auth_id": "60300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65677,
    "description": "Tethys (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005677,
    "auth_name": "IAU_2015",
    "auth_id": "60310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65678,
    "description": "Tethys (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005678,
    "auth_name": "IAU_2015",
    "auth_id": "60315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65679,
    "description": "Tethys (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005679,
    "auth_name": "IAU_2015",
    "auth_id": "60320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65680,
    "description": "Tethys (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005680,
    "auth_name": "IAU_2015",
    "auth_id": "60325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65681,
    "description": "Tethys (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005681,
    "auth_name": "IAU_2015",
    "auth_id": "60330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65682,
    "description": "Tethys (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005682,
    "auth_name": "IAU_2015",
    "auth_id": "60335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65683,
    "description": "Tethys (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005683,
    "auth_name": "IAU_2015",
    "auth_id": "60340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65684,
    "description": "Tethys (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005684,
    "auth_name": "IAU_2015",
    "auth_id": "60345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65685,
    "description": "Tethys (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005685,
    "auth_name": "IAU_2015",
    "auth_id": "60350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65686,
    "description": "Tethys (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005686,
    "auth_name": "IAU_2015",
    "auth_id": "60355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65687,
    "description": "Tethys (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005687,
    "auth_name": "IAU_2015",
    "auth_id": "60360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65688,
    "description": "Tethys (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005688,
    "auth_name": "IAU_2015",
    "auth_id": "60365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65689,
    "description": "Tethys (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005689,
    "auth_name": "IAU_2015",
    "auth_id": "60370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65690,
    "description": "Tethys (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005690,
    "auth_name": "IAU_2015",
    "auth_id": "60375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65691,
    "description": "Tethys (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005691,
    "auth_name": "IAU_2015",
    "auth_id": "60380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65692,
    "description": "Tethys (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520005692,
    "auth_name": "IAU_2015",
    "auth_id": "60385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65693,
    "description": "Dione (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=561400 +no_defs",
    "srid": 520005693,
    "auth_name": "IAU_2015",
    "auth_id": "60400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65694,
    "description": "Dione (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005694,
    "auth_name": "IAU_2015",
    "auth_id": "60410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65695,
    "description": "Dione (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005695,
    "auth_name": "IAU_2015",
    "auth_id": "60415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65696,
    "description": "Dione (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005696,
    "auth_name": "IAU_2015",
    "auth_id": "60420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65697,
    "description": "Dione (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005697,
    "auth_name": "IAU_2015",
    "auth_id": "60425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65698,
    "description": "Dione (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005698,
    "auth_name": "IAU_2015",
    "auth_id": "60430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65699,
    "description": "Dione (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005699,
    "auth_name": "IAU_2015",
    "auth_id": "60435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65700,
    "description": "Dione (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005700,
    "auth_name": "IAU_2015",
    "auth_id": "60440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65701,
    "description": "Dione (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005701,
    "auth_name": "IAU_2015",
    "auth_id": "60445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65702,
    "description": "Dione (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005702,
    "auth_name": "IAU_2015",
    "auth_id": "60450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65703,
    "description": "Dione (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005703,
    "auth_name": "IAU_2015",
    "auth_id": "60455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65704,
    "description": "Dione (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005704,
    "auth_name": "IAU_2015",
    "auth_id": "60460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65705,
    "description": "Dione (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005705,
    "auth_name": "IAU_2015",
    "auth_id": "60465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65706,
    "description": "Dione (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005706,
    "auth_name": "IAU_2015",
    "auth_id": "60470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65707,
    "description": "Dione (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005707,
    "auth_name": "IAU_2015",
    "auth_id": "60475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65708,
    "description": "Dione (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005708,
    "auth_name": "IAU_2015",
    "auth_id": "60480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65709,
    "description": "Dione (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520005709,
    "auth_name": "IAU_2015",
    "auth_id": "60485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65710,
    "description": "Rhea (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=763500 +no_defs",
    "srid": 520005710,
    "auth_name": "IAU_2015",
    "auth_id": "60500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65711,
    "description": "Rhea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005711,
    "auth_name": "IAU_2015",
    "auth_id": "60510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65712,
    "description": "Rhea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005712,
    "auth_name": "IAU_2015",
    "auth_id": "60515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65713,
    "description": "Rhea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005713,
    "auth_name": "IAU_2015",
    "auth_id": "60520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65714,
    "description": "Rhea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005714,
    "auth_name": "IAU_2015",
    "auth_id": "60525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65715,
    "description": "Rhea (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005715,
    "auth_name": "IAU_2015",
    "auth_id": "60530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65716,
    "description": "Rhea (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005716,
    "auth_name": "IAU_2015",
    "auth_id": "60535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65717,
    "description": "Rhea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005717,
    "auth_name": "IAU_2015",
    "auth_id": "60540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65718,
    "description": "Rhea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005718,
    "auth_name": "IAU_2015",
    "auth_id": "60545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65719,
    "description": "Rhea (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005719,
    "auth_name": "IAU_2015",
    "auth_id": "60550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65720,
    "description": "Rhea (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005720,
    "auth_name": "IAU_2015",
    "auth_id": "60555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65721,
    "description": "Rhea (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005721,
    "auth_name": "IAU_2015",
    "auth_id": "60560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65722,
    "description": "Rhea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005722,
    "auth_name": "IAU_2015",
    "auth_id": "60565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65723,
    "description": "Rhea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005723,
    "auth_name": "IAU_2015",
    "auth_id": "60570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65724,
    "description": "Rhea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005724,
    "auth_name": "IAU_2015",
    "auth_id": "60575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65725,
    "description": "Rhea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005725,
    "auth_name": "IAU_2015",
    "auth_id": "60580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65726,
    "description": "Rhea (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520005726,
    "auth_name": "IAU_2015",
    "auth_id": "60585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65727,
    "description": "Titan (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2575000 +no_defs",
    "srid": 520005727,
    "auth_name": "IAU_2015",
    "auth_id": "60600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65728,
    "description": "Titan (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005728,
    "auth_name": "IAU_2015",
    "auth_id": "60610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65729,
    "description": "Titan (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005729,
    "auth_name": "IAU_2015",
    "auth_id": "60615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65730,
    "description": "Titan (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005730,
    "auth_name": "IAU_2015",
    "auth_id": "60620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65731,
    "description": "Titan (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005731,
    "auth_name": "IAU_2015",
    "auth_id": "60625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65732,
    "description": "Titan (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005732,
    "auth_name": "IAU_2015",
    "auth_id": "60630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65733,
    "description": "Titan (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005733,
    "auth_name": "IAU_2015",
    "auth_id": "60635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65734,
    "description": "Titan (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005734,
    "auth_name": "IAU_2015",
    "auth_id": "60640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65735,
    "description": "Titan (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005735,
    "auth_name": "IAU_2015",
    "auth_id": "60645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65736,
    "description": "Titan (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005736,
    "auth_name": "IAU_2015",
    "auth_id": "60650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65737,
    "description": "Titan (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005737,
    "auth_name": "IAU_2015",
    "auth_id": "60655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65738,
    "description": "Titan (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005738,
    "auth_name": "IAU_2015",
    "auth_id": "60660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65739,
    "description": "Titan (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005739,
    "auth_name": "IAU_2015",
    "auth_id": "60665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65740,
    "description": "Titan (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005740,
    "auth_name": "IAU_2015",
    "auth_id": "60670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65741,
    "description": "Titan (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005741,
    "auth_name": "IAU_2015",
    "auth_id": "60675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65742,
    "description": "Titan (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005742,
    "auth_name": "IAU_2015",
    "auth_id": "60680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65743,
    "description": "Titan (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520005743,
    "auth_name": "IAU_2015",
    "auth_id": "60685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65744,
    "description": "Hyperion (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=135000 +no_defs",
    "srid": 520005744,
    "auth_name": "IAU_2015",
    "auth_id": "60700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65745,
    "description": "Hyperion (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005745,
    "auth_name": "IAU_2015",
    "auth_id": "60710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65746,
    "description": "Hyperion (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005746,
    "auth_name": "IAU_2015",
    "auth_id": "60715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65747,
    "description": "Hyperion (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005747,
    "auth_name": "IAU_2015",
    "auth_id": "60720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65748,
    "description": "Hyperion (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005748,
    "auth_name": "IAU_2015",
    "auth_id": "60725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65749,
    "description": "Hyperion (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005749,
    "auth_name": "IAU_2015",
    "auth_id": "60730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65750,
    "description": "Hyperion (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005750,
    "auth_name": "IAU_2015",
    "auth_id": "60735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65751,
    "description": "Hyperion (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005751,
    "auth_name": "IAU_2015",
    "auth_id": "60740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65752,
    "description": "Hyperion (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005752,
    "auth_name": "IAU_2015",
    "auth_id": "60745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65753,
    "description": "Hyperion (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005753,
    "auth_name": "IAU_2015",
    "auth_id": "60750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65754,
    "description": "Hyperion (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005754,
    "auth_name": "IAU_2015",
    "auth_id": "60755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65755,
    "description": "Hyperion (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005755,
    "auth_name": "IAU_2015",
    "auth_id": "60760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65756,
    "description": "Hyperion (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005756,
    "auth_name": "IAU_2015",
    "auth_id": "60765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65757,
    "description": "Hyperion (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005757,
    "auth_name": "IAU_2015",
    "auth_id": "60770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65758,
    "description": "Hyperion (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005758,
    "auth_name": "IAU_2015",
    "auth_id": "60775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65759,
    "description": "Hyperion (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005759,
    "auth_name": "IAU_2015",
    "auth_id": "60780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65760,
    "description": "Hyperion (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520005760,
    "auth_name": "IAU_2015",
    "auth_id": "60785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65761,
    "description": "Iapetus (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=745700 +no_defs",
    "srid": 520005761,
    "auth_name": "IAU_2015",
    "auth_id": "60800",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65762,
    "description": "Iapetus (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=745700 +b=712100 +no_defs",
    "srid": 520005762,
    "auth_name": "IAU_2015",
    "auth_id": "60801",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65763,
    "description": "Iapetus (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520005763,
    "auth_name": "IAU_2015",
    "auth_id": "60802",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 65764,
    "description": "Iapetus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005764,
    "auth_name": "IAU_2015",
    "auth_id": "60810",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65765,
    "description": "Iapetus (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005765,
    "auth_name": "IAU_2015",
    "auth_id": "60811",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65766,
    "description": "Iapetus (2015) / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005766,
    "auth_name": "IAU_2015",
    "auth_id": "60812",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65767,
    "description": "Iapetus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005767,
    "auth_name": "IAU_2015",
    "auth_id": "60815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65768,
    "description": "Iapetus (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005768,
    "auth_name": "IAU_2015",
    "auth_id": "60816",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65769,
    "description": "Iapetus (2015) / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005769,
    "auth_name": "IAU_2015",
    "auth_id": "60817",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65770,
    "description": "Iapetus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005770,
    "auth_name": "IAU_2015",
    "auth_id": "60820",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65771,
    "description": "Iapetus (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005771,
    "auth_name": "IAU_2015",
    "auth_id": "60821",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65772,
    "description": "Iapetus (2015) / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005772,
    "auth_name": "IAU_2015",
    "auth_id": "60822",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65773,
    "description": "Iapetus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005773,
    "auth_name": "IAU_2015",
    "auth_id": "60825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65774,
    "description": "Iapetus (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005774,
    "auth_name": "IAU_2015",
    "auth_id": "60826",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65775,
    "description": "Iapetus (2015) / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005775,
    "auth_name": "IAU_2015",
    "auth_id": "60827",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65776,
    "description": "Iapetus (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005776,
    "auth_name": "IAU_2015",
    "auth_id": "60830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65777,
    "description": "Iapetus (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005777,
    "auth_name": "IAU_2015",
    "auth_id": "60831",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65778,
    "description": "Iapetus (2015) / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005778,
    "auth_name": "IAU_2015",
    "auth_id": "60832",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65779,
    "description": "Iapetus (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005779,
    "auth_name": "IAU_2015",
    "auth_id": "60835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65780,
    "description": "Iapetus (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005780,
    "auth_name": "IAU_2015",
    "auth_id": "60836",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65781,
    "description": "Iapetus (2015) / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005781,
    "auth_name": "IAU_2015",
    "auth_id": "60837",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65782,
    "description": "Iapetus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005782,
    "auth_name": "IAU_2015",
    "auth_id": "60840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65783,
    "description": "Iapetus (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005783,
    "auth_name": "IAU_2015",
    "auth_id": "60841",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65784,
    "description": "Iapetus (2015) / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005784,
    "auth_name": "IAU_2015",
    "auth_id": "60842",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65785,
    "description": "Iapetus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005785,
    "auth_name": "IAU_2015",
    "auth_id": "60845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65786,
    "description": "Iapetus (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005786,
    "auth_name": "IAU_2015",
    "auth_id": "60846",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65787,
    "description": "Iapetus (2015) / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005787,
    "auth_name": "IAU_2015",
    "auth_id": "60847",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65788,
    "description": "Iapetus (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005788,
    "auth_name": "IAU_2015",
    "auth_id": "60850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65789,
    "description": "Iapetus (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005789,
    "auth_name": "IAU_2015",
    "auth_id": "60851",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65790,
    "description": "Iapetus (2015) / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005790,
    "auth_name": "IAU_2015",
    "auth_id": "60852",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65791,
    "description": "Iapetus (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005791,
    "auth_name": "IAU_2015",
    "auth_id": "60855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65792,
    "description": "Iapetus (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005792,
    "auth_name": "IAU_2015",
    "auth_id": "60856",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65793,
    "description": "Iapetus (2015) / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005793,
    "auth_name": "IAU_2015",
    "auth_id": "60857",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65794,
    "description": "Iapetus (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005794,
    "auth_name": "IAU_2015",
    "auth_id": "60860",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65795,
    "description": "Iapetus (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005795,
    "auth_name": "IAU_2015",
    "auth_id": "60861",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65796,
    "description": "Iapetus (2015) / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005796,
    "auth_name": "IAU_2015",
    "auth_id": "60862",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65797,
    "description": "Iapetus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005797,
    "auth_name": "IAU_2015",
    "auth_id": "60865",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65798,
    "description": "Iapetus (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005798,
    "auth_name": "IAU_2015",
    "auth_id": "60866",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65799,
    "description": "Iapetus (2015) / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005799,
    "auth_name": "IAU_2015",
    "auth_id": "60867",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65800,
    "description": "Iapetus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005800,
    "auth_name": "IAU_2015",
    "auth_id": "60870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65801,
    "description": "Iapetus (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005801,
    "auth_name": "IAU_2015",
    "auth_id": "60871",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65802,
    "description": "Iapetus (2015) / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005802,
    "auth_name": "IAU_2015",
    "auth_id": "60872",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65803,
    "description": "Iapetus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005803,
    "auth_name": "IAU_2015",
    "auth_id": "60875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65804,
    "description": "Iapetus (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005804,
    "auth_name": "IAU_2015",
    "auth_id": "60876",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65805,
    "description": "Iapetus (2015) / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005805,
    "auth_name": "IAU_2015",
    "auth_id": "60877",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65806,
    "description": "Iapetus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005806,
    "auth_name": "IAU_2015",
    "auth_id": "60880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65807,
    "description": "Iapetus (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005807,
    "auth_name": "IAU_2015",
    "auth_id": "60881",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65808,
    "description": "Iapetus (2015) / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005808,
    "auth_name": "IAU_2015",
    "auth_id": "60882",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65809,
    "description": "Iapetus (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520005809,
    "auth_name": "IAU_2015",
    "auth_id": "60885",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65810,
    "description": "Iapetus (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005810,
    "auth_name": "IAU_2015",
    "auth_id": "60886",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65811,
    "description": "Iapetus (2015) / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520005811,
    "auth_name": "IAU_2015",
    "auth_id": "60887",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65812,
    "description": "Phoebe (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=106500 +no_defs",
    "srid": 520005812,
    "auth_name": "IAU_2015",
    "auth_id": "60900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65813,
    "description": "Phoebe (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005813,
    "auth_name": "IAU_2015",
    "auth_id": "60910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65814,
    "description": "Phoebe (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005814,
    "auth_name": "IAU_2015",
    "auth_id": "60915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65815,
    "description": "Phoebe (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005815,
    "auth_name": "IAU_2015",
    "auth_id": "60920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65816,
    "description": "Phoebe (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005816,
    "auth_name": "IAU_2015",
    "auth_id": "60925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65817,
    "description": "Phoebe (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005817,
    "auth_name": "IAU_2015",
    "auth_id": "60930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65818,
    "description": "Phoebe (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005818,
    "auth_name": "IAU_2015",
    "auth_id": "60935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65819,
    "description": "Phoebe (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005819,
    "auth_name": "IAU_2015",
    "auth_id": "60940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65820,
    "description": "Phoebe (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005820,
    "auth_name": "IAU_2015",
    "auth_id": "60945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65821,
    "description": "Phoebe (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005821,
    "auth_name": "IAU_2015",
    "auth_id": "60950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65822,
    "description": "Phoebe (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005822,
    "auth_name": "IAU_2015",
    "auth_id": "60955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65823,
    "description": "Phoebe (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005823,
    "auth_name": "IAU_2015",
    "auth_id": "60960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65824,
    "description": "Phoebe (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005824,
    "auth_name": "IAU_2015",
    "auth_id": "60965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65825,
    "description": "Phoebe (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005825,
    "auth_name": "IAU_2015",
    "auth_id": "60970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65826,
    "description": "Phoebe (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005826,
    "auth_name": "IAU_2015",
    "auth_id": "60975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65827,
    "description": "Phoebe (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005827,
    "auth_name": "IAU_2015",
    "auth_id": "60980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65828,
    "description": "Phoebe (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520005828,
    "auth_name": "IAU_2015",
    "auth_id": "60985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65829,
    "description": "Janus (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=89200 +no_defs",
    "srid": 520005829,
    "auth_name": "IAU_2015",
    "auth_id": "61000",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65830,
    "description": "Janus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005830,
    "auth_name": "IAU_2015",
    "auth_id": "61010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65831,
    "description": "Janus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005831,
    "auth_name": "IAU_2015",
    "auth_id": "61015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65832,
    "description": "Janus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005832,
    "auth_name": "IAU_2015",
    "auth_id": "61020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65833,
    "description": "Janus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005833,
    "auth_name": "IAU_2015",
    "auth_id": "61025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65834,
    "description": "Janus (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005834,
    "auth_name": "IAU_2015",
    "auth_id": "61030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65835,
    "description": "Janus (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005835,
    "auth_name": "IAU_2015",
    "auth_id": "61035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65836,
    "description": "Janus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005836,
    "auth_name": "IAU_2015",
    "auth_id": "61040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65837,
    "description": "Janus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005837,
    "auth_name": "IAU_2015",
    "auth_id": "61045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65838,
    "description": "Janus (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005838,
    "auth_name": "IAU_2015",
    "auth_id": "61050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65839,
    "description": "Janus (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005839,
    "auth_name": "IAU_2015",
    "auth_id": "61055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65840,
    "description": "Janus (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005840,
    "auth_name": "IAU_2015",
    "auth_id": "61060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65841,
    "description": "Janus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005841,
    "auth_name": "IAU_2015",
    "auth_id": "61065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65842,
    "description": "Janus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005842,
    "auth_name": "IAU_2015",
    "auth_id": "61070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65843,
    "description": "Janus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005843,
    "auth_name": "IAU_2015",
    "auth_id": "61075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65844,
    "description": "Janus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005844,
    "auth_name": "IAU_2015",
    "auth_id": "61080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65845,
    "description": "Janus (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520005845,
    "auth_name": "IAU_2015",
    "auth_id": "61085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65846,
    "description": "Epimetheus (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=58200 +no_defs",
    "srid": 520005846,
    "auth_name": "IAU_2015",
    "auth_id": "61100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65847,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005847,
    "auth_name": "IAU_2015",
    "auth_id": "61110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65848,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005848,
    "auth_name": "IAU_2015",
    "auth_id": "61115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65849,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005849,
    "auth_name": "IAU_2015",
    "auth_id": "61120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65850,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005850,
    "auth_name": "IAU_2015",
    "auth_id": "61125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65851,
    "description": "Epimetheus (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005851,
    "auth_name": "IAU_2015",
    "auth_id": "61130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65852,
    "description": "Epimetheus (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005852,
    "auth_name": "IAU_2015",
    "auth_id": "61135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65853,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005853,
    "auth_name": "IAU_2015",
    "auth_id": "61140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65854,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005854,
    "auth_name": "IAU_2015",
    "auth_id": "61145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65855,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005855,
    "auth_name": "IAU_2015",
    "auth_id": "61150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65856,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005856,
    "auth_name": "IAU_2015",
    "auth_id": "61155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65857,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005857,
    "auth_name": "IAU_2015",
    "auth_id": "61160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65858,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005858,
    "auth_name": "IAU_2015",
    "auth_id": "61165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65859,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005859,
    "auth_name": "IAU_2015",
    "auth_id": "61170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65860,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005860,
    "auth_name": "IAU_2015",
    "auth_id": "61175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65861,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005861,
    "auth_name": "IAU_2015",
    "auth_id": "61180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65862,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520005862,
    "auth_name": "IAU_2015",
    "auth_id": "61185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65863,
    "description": "Helene (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=18000 +no_defs",
    "srid": 520005863,
    "auth_name": "IAU_2015",
    "auth_id": "61200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65864,
    "description": "Helene (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005864,
    "auth_name": "IAU_2015",
    "auth_id": "61210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65865,
    "description": "Helene (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005865,
    "auth_name": "IAU_2015",
    "auth_id": "61215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65866,
    "description": "Helene (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005866,
    "auth_name": "IAU_2015",
    "auth_id": "61220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65867,
    "description": "Helene (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005867,
    "auth_name": "IAU_2015",
    "auth_id": "61225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65868,
    "description": "Helene (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005868,
    "auth_name": "IAU_2015",
    "auth_id": "61230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65869,
    "description": "Helene (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005869,
    "auth_name": "IAU_2015",
    "auth_id": "61235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65870,
    "description": "Helene (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005870,
    "auth_name": "IAU_2015",
    "auth_id": "61240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65871,
    "description": "Helene (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005871,
    "auth_name": "IAU_2015",
    "auth_id": "61245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65872,
    "description": "Helene (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005872,
    "auth_name": "IAU_2015",
    "auth_id": "61250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65873,
    "description": "Helene (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005873,
    "auth_name": "IAU_2015",
    "auth_id": "61255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65874,
    "description": "Helene (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005874,
    "auth_name": "IAU_2015",
    "auth_id": "61260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65875,
    "description": "Helene (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005875,
    "auth_name": "IAU_2015",
    "auth_id": "61265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65876,
    "description": "Helene (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005876,
    "auth_name": "IAU_2015",
    "auth_id": "61270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65877,
    "description": "Helene (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005877,
    "auth_name": "IAU_2015",
    "auth_id": "61275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65878,
    "description": "Helene (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005878,
    "auth_name": "IAU_2015",
    "auth_id": "61280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65879,
    "description": "Helene (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520005879,
    "auth_name": "IAU_2015",
    "auth_id": "61285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65880,
    "description": "Telesto (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=12400 +no_defs",
    "srid": 520005880,
    "auth_name": "IAU_2015",
    "auth_id": "61300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65881,
    "description": "Telesto (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005881,
    "auth_name": "IAU_2015",
    "auth_id": "61310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65882,
    "description": "Telesto (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005882,
    "auth_name": "IAU_2015",
    "auth_id": "61315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65883,
    "description": "Telesto (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005883,
    "auth_name": "IAU_2015",
    "auth_id": "61320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65884,
    "description": "Telesto (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005884,
    "auth_name": "IAU_2015",
    "auth_id": "61325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65885,
    "description": "Telesto (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005885,
    "auth_name": "IAU_2015",
    "auth_id": "61330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65886,
    "description": "Telesto (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005886,
    "auth_name": "IAU_2015",
    "auth_id": "61335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65887,
    "description": "Telesto (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005887,
    "auth_name": "IAU_2015",
    "auth_id": "61340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65888,
    "description": "Telesto (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005888,
    "auth_name": "IAU_2015",
    "auth_id": "61345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65889,
    "description": "Telesto (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005889,
    "auth_name": "IAU_2015",
    "auth_id": "61350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65890,
    "description": "Telesto (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005890,
    "auth_name": "IAU_2015",
    "auth_id": "61355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65891,
    "description": "Telesto (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005891,
    "auth_name": "IAU_2015",
    "auth_id": "61360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65892,
    "description": "Telesto (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005892,
    "auth_name": "IAU_2015",
    "auth_id": "61365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65893,
    "description": "Telesto (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005893,
    "auth_name": "IAU_2015",
    "auth_id": "61370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65894,
    "description": "Telesto (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005894,
    "auth_name": "IAU_2015",
    "auth_id": "61375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65895,
    "description": "Telesto (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005895,
    "auth_name": "IAU_2015",
    "auth_id": "61380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65896,
    "description": "Telesto (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520005896,
    "auth_name": "IAU_2015",
    "auth_id": "61385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65897,
    "description": "Calypso (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=9600 +no_defs",
    "srid": 520005897,
    "auth_name": "IAU_2015",
    "auth_id": "61400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65898,
    "description": "Calypso (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005898,
    "auth_name": "IAU_2015",
    "auth_id": "61410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65899,
    "description": "Calypso (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005899,
    "auth_name": "IAU_2015",
    "auth_id": "61415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65900,
    "description": "Calypso (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005900,
    "auth_name": "IAU_2015",
    "auth_id": "61420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65901,
    "description": "Calypso (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005901,
    "auth_name": "IAU_2015",
    "auth_id": "61425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65902,
    "description": "Calypso (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005902,
    "auth_name": "IAU_2015",
    "auth_id": "61430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65903,
    "description": "Calypso (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005903,
    "auth_name": "IAU_2015",
    "auth_id": "61435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65904,
    "description": "Calypso (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005904,
    "auth_name": "IAU_2015",
    "auth_id": "61440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65905,
    "description": "Calypso (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005905,
    "auth_name": "IAU_2015",
    "auth_id": "61445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65906,
    "description": "Calypso (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005906,
    "auth_name": "IAU_2015",
    "auth_id": "61450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65907,
    "description": "Calypso (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005907,
    "auth_name": "IAU_2015",
    "auth_id": "61455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65908,
    "description": "Calypso (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005908,
    "auth_name": "IAU_2015",
    "auth_id": "61460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65909,
    "description": "Calypso (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005909,
    "auth_name": "IAU_2015",
    "auth_id": "61465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65910,
    "description": "Calypso (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005910,
    "auth_name": "IAU_2015",
    "auth_id": "61470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65911,
    "description": "Calypso (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005911,
    "auth_name": "IAU_2015",
    "auth_id": "61475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65912,
    "description": "Calypso (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005912,
    "auth_name": "IAU_2015",
    "auth_id": "61480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65913,
    "description": "Calypso (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520005913,
    "auth_name": "IAU_2015",
    "auth_id": "61485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65914,
    "description": "Atlas (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=15100 +no_defs",
    "srid": 520005914,
    "auth_name": "IAU_2015",
    "auth_id": "61500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65915,
    "description": "Atlas (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005915,
    "auth_name": "IAU_2015",
    "auth_id": "61510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65916,
    "description": "Atlas (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005916,
    "auth_name": "IAU_2015",
    "auth_id": "61515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65917,
    "description": "Atlas (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005917,
    "auth_name": "IAU_2015",
    "auth_id": "61520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65918,
    "description": "Atlas (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005918,
    "auth_name": "IAU_2015",
    "auth_id": "61525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65919,
    "description": "Atlas (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005919,
    "auth_name": "IAU_2015",
    "auth_id": "61530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65920,
    "description": "Atlas (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005920,
    "auth_name": "IAU_2015",
    "auth_id": "61535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65921,
    "description": "Atlas (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005921,
    "auth_name": "IAU_2015",
    "auth_id": "61540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65922,
    "description": "Atlas (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005922,
    "auth_name": "IAU_2015",
    "auth_id": "61545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65923,
    "description": "Atlas (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005923,
    "auth_name": "IAU_2015",
    "auth_id": "61550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65924,
    "description": "Atlas (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005924,
    "auth_name": "IAU_2015",
    "auth_id": "61555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65925,
    "description": "Atlas (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005925,
    "auth_name": "IAU_2015",
    "auth_id": "61560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65926,
    "description": "Atlas (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005926,
    "auth_name": "IAU_2015",
    "auth_id": "61565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65927,
    "description": "Atlas (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005927,
    "auth_name": "IAU_2015",
    "auth_id": "61570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65928,
    "description": "Atlas (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005928,
    "auth_name": "IAU_2015",
    "auth_id": "61575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65929,
    "description": "Atlas (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005929,
    "auth_name": "IAU_2015",
    "auth_id": "61580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65930,
    "description": "Atlas (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520005930,
    "auth_name": "IAU_2015",
    "auth_id": "61585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65931,
    "description": "Prometheus (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=43100 +no_defs",
    "srid": 520005931,
    "auth_name": "IAU_2015",
    "auth_id": "61600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65932,
    "description": "Prometheus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005932,
    "auth_name": "IAU_2015",
    "auth_id": "61610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65933,
    "description": "Prometheus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005933,
    "auth_name": "IAU_2015",
    "auth_id": "61615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65934,
    "description": "Prometheus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005934,
    "auth_name": "IAU_2015",
    "auth_id": "61620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65935,
    "description": "Prometheus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005935,
    "auth_name": "IAU_2015",
    "auth_id": "61625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65936,
    "description": "Prometheus (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005936,
    "auth_name": "IAU_2015",
    "auth_id": "61630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65937,
    "description": "Prometheus (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005937,
    "auth_name": "IAU_2015",
    "auth_id": "61635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65938,
    "description": "Prometheus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005938,
    "auth_name": "IAU_2015",
    "auth_id": "61640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65939,
    "description": "Prometheus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005939,
    "auth_name": "IAU_2015",
    "auth_id": "61645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65940,
    "description": "Prometheus (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005940,
    "auth_name": "IAU_2015",
    "auth_id": "61650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65941,
    "description": "Prometheus (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005941,
    "auth_name": "IAU_2015",
    "auth_id": "61655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65942,
    "description": "Prometheus (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005942,
    "auth_name": "IAU_2015",
    "auth_id": "61660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65943,
    "description": "Prometheus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005943,
    "auth_name": "IAU_2015",
    "auth_id": "61665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65944,
    "description": "Prometheus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005944,
    "auth_name": "IAU_2015",
    "auth_id": "61670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65945,
    "description": "Prometheus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005945,
    "auth_name": "IAU_2015",
    "auth_id": "61675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65946,
    "description": "Prometheus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005946,
    "auth_name": "IAU_2015",
    "auth_id": "61680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65947,
    "description": "Prometheus (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520005947,
    "auth_name": "IAU_2015",
    "auth_id": "61685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65948,
    "description": "Pandora (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=40600 +no_defs",
    "srid": 520005948,
    "auth_name": "IAU_2015",
    "auth_id": "61700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65949,
    "description": "Pandora (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005949,
    "auth_name": "IAU_2015",
    "auth_id": "61710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65950,
    "description": "Pandora (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005950,
    "auth_name": "IAU_2015",
    "auth_id": "61715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65951,
    "description": "Pandora (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005951,
    "auth_name": "IAU_2015",
    "auth_id": "61720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65952,
    "description": "Pandora (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005952,
    "auth_name": "IAU_2015",
    "auth_id": "61725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65953,
    "description": "Pandora (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005953,
    "auth_name": "IAU_2015",
    "auth_id": "61730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65954,
    "description": "Pandora (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005954,
    "auth_name": "IAU_2015",
    "auth_id": "61735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65955,
    "description": "Pandora (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005955,
    "auth_name": "IAU_2015",
    "auth_id": "61740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65956,
    "description": "Pandora (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005956,
    "auth_name": "IAU_2015",
    "auth_id": "61745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65957,
    "description": "Pandora (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005957,
    "auth_name": "IAU_2015",
    "auth_id": "61750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65958,
    "description": "Pandora (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005958,
    "auth_name": "IAU_2015",
    "auth_id": "61755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65959,
    "description": "Pandora (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005959,
    "auth_name": "IAU_2015",
    "auth_id": "61760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65960,
    "description": "Pandora (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005960,
    "auth_name": "IAU_2015",
    "auth_id": "61765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65961,
    "description": "Pandora (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005961,
    "auth_name": "IAU_2015",
    "auth_id": "61770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65962,
    "description": "Pandora (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005962,
    "auth_name": "IAU_2015",
    "auth_id": "61775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65963,
    "description": "Pandora (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005963,
    "auth_name": "IAU_2015",
    "auth_id": "61780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65964,
    "description": "Pandora (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520005964,
    "auth_name": "IAU_2015",
    "auth_id": "61785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65965,
    "description": "Pan (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=14000 +no_defs",
    "srid": 520005965,
    "auth_name": "IAU_2015",
    "auth_id": "61800",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65966,
    "description": "Pan (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005966,
    "auth_name": "IAU_2015",
    "auth_id": "61810",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65967,
    "description": "Pan (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005967,
    "auth_name": "IAU_2015",
    "auth_id": "61815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65968,
    "description": "Pan (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005968,
    "auth_name": "IAU_2015",
    "auth_id": "61820",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65969,
    "description": "Pan (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005969,
    "auth_name": "IAU_2015",
    "auth_id": "61825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65970,
    "description": "Pan (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005970,
    "auth_name": "IAU_2015",
    "auth_id": "61830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65971,
    "description": "Pan (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005971,
    "auth_name": "IAU_2015",
    "auth_id": "61835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65972,
    "description": "Pan (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005972,
    "auth_name": "IAU_2015",
    "auth_id": "61840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65973,
    "description": "Pan (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005973,
    "auth_name": "IAU_2015",
    "auth_id": "61845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65974,
    "description": "Pan (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005974,
    "auth_name": "IAU_2015",
    "auth_id": "61850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65975,
    "description": "Pan (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005975,
    "auth_name": "IAU_2015",
    "auth_id": "61855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65976,
    "description": "Pan (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005976,
    "auth_name": "IAU_2015",
    "auth_id": "61860",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65977,
    "description": "Pan (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005977,
    "auth_name": "IAU_2015",
    "auth_id": "61865",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65978,
    "description": "Pan (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005978,
    "auth_name": "IAU_2015",
    "auth_id": "61870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65979,
    "description": "Pan (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005979,
    "auth_name": "IAU_2015",
    "auth_id": "61875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65980,
    "description": "Pan (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005980,
    "auth_name": "IAU_2015",
    "auth_id": "61880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65981,
    "description": "Pan (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520005981,
    "auth_name": "IAU_2015",
    "auth_id": "61885",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65982,
    "description": "Methone (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1450 +no_defs",
    "srid": 520005982,
    "auth_name": "IAU_2015",
    "auth_id": "63200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 65983,
    "description": "Methone (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005983,
    "auth_name": "IAU_2015",
    "auth_id": "63210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65984,
    "description": "Methone (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005984,
    "auth_name": "IAU_2015",
    "auth_id": "63215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65985,
    "description": "Methone (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005985,
    "auth_name": "IAU_2015",
    "auth_id": "63220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65986,
    "description": "Methone (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005986,
    "auth_name": "IAU_2015",
    "auth_id": "63225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65987,
    "description": "Methone (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005987,
    "auth_name": "IAU_2015",
    "auth_id": "63230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65988,
    "description": "Methone (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005988,
    "auth_name": "IAU_2015",
    "auth_id": "63235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65989,
    "description": "Methone (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005989,
    "auth_name": "IAU_2015",
    "auth_id": "63240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65990,
    "description": "Methone (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005990,
    "auth_name": "IAU_2015",
    "auth_id": "63245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65991,
    "description": "Methone (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005991,
    "auth_name": "IAU_2015",
    "auth_id": "63250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65992,
    "description": "Methone (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005992,
    "auth_name": "IAU_2015",
    "auth_id": "63255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65993,
    "description": "Methone (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005993,
    "auth_name": "IAU_2015",
    "auth_id": "63260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65994,
    "description": "Methone (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005994,
    "auth_name": "IAU_2015",
    "auth_id": "63265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65995,
    "description": "Methone (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005995,
    "auth_name": "IAU_2015",
    "auth_id": "63270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65996,
    "description": "Methone (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005996,
    "auth_name": "IAU_2015",
    "auth_id": "63275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65997,
    "description": "Methone (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005997,
    "auth_name": "IAU_2015",
    "auth_id": "63280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65998,
    "description": "Methone (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520005998,
    "auth_name": "IAU_2015",
    "auth_id": "63285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 65999,
    "description": "Pallene (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=2230 +no_defs",
    "srid": 520005999,
    "auth_name": "IAU_2015",
    "auth_id": "63300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66000,
    "description": "Pallene (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006000,
    "auth_name": "IAU_2015",
    "auth_id": "63310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66001,
    "description": "Pallene (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006001,
    "auth_name": "IAU_2015",
    "auth_id": "63315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66002,
    "description": "Pallene (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006002,
    "auth_name": "IAU_2015",
    "auth_id": "63320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66003,
    "description": "Pallene (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006003,
    "auth_name": "IAU_2015",
    "auth_id": "63325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66004,
    "description": "Pallene (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006004,
    "auth_name": "IAU_2015",
    "auth_id": "63330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66005,
    "description": "Pallene (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006005,
    "auth_name": "IAU_2015",
    "auth_id": "63335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66006,
    "description": "Pallene (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006006,
    "auth_name": "IAU_2015",
    "auth_id": "63340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66007,
    "description": "Pallene (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006007,
    "auth_name": "IAU_2015",
    "auth_id": "63345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66008,
    "description": "Pallene (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006008,
    "auth_name": "IAU_2015",
    "auth_id": "63350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66009,
    "description": "Pallene (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006009,
    "auth_name": "IAU_2015",
    "auth_id": "63355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66010,
    "description": "Pallene (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006010,
    "auth_name": "IAU_2015",
    "auth_id": "63360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66011,
    "description": "Pallene (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006011,
    "auth_name": "IAU_2015",
    "auth_id": "63365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66012,
    "description": "Pallene (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006012,
    "auth_name": "IAU_2015",
    "auth_id": "63370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66013,
    "description": "Pallene (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006013,
    "auth_name": "IAU_2015",
    "auth_id": "63375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66014,
    "description": "Pallene (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006014,
    "auth_name": "IAU_2015",
    "auth_id": "63380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66015,
    "description": "Pallene (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520006015,
    "auth_name": "IAU_2015",
    "auth_id": "63385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66016,
    "description": "Polydeuces (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1300 +no_defs",
    "srid": 520006016,
    "auth_name": "IAU_2015",
    "auth_id": "63400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66017,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006017,
    "auth_name": "IAU_2015",
    "auth_id": "63410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66018,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006018,
    "auth_name": "IAU_2015",
    "auth_id": "63415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66019,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006019,
    "auth_name": "IAU_2015",
    "auth_id": "63420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66020,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006020,
    "auth_name": "IAU_2015",
    "auth_id": "63425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66021,
    "description": "Polydeuces (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006021,
    "auth_name": "IAU_2015",
    "auth_id": "63430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66022,
    "description": "Polydeuces (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006022,
    "auth_name": "IAU_2015",
    "auth_id": "63435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66023,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006023,
    "auth_name": "IAU_2015",
    "auth_id": "63440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66024,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006024,
    "auth_name": "IAU_2015",
    "auth_id": "63445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66025,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006025,
    "auth_name": "IAU_2015",
    "auth_id": "63450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66026,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006026,
    "auth_name": "IAU_2015",
    "auth_id": "63455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66027,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006027,
    "auth_name": "IAU_2015",
    "auth_id": "63460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66028,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006028,
    "auth_name": "IAU_2015",
    "auth_id": "63465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66029,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006029,
    "auth_name": "IAU_2015",
    "auth_id": "63470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66030,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006030,
    "auth_name": "IAU_2015",
    "auth_id": "63475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66031,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006031,
    "auth_name": "IAU_2015",
    "auth_id": "63480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66032,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520006032,
    "auth_name": "IAU_2015",
    "auth_id": "63485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66033,
    "description": "Daphnis (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=3800 +no_defs",
    "srid": 520006033,
    "auth_name": "IAU_2015",
    "auth_id": "63500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66034,
    "description": "Daphnis (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006034,
    "auth_name": "IAU_2015",
    "auth_id": "63510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66035,
    "description": "Daphnis (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006035,
    "auth_name": "IAU_2015",
    "auth_id": "63515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66036,
    "description": "Daphnis (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006036,
    "auth_name": "IAU_2015",
    "auth_id": "63520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66037,
    "description": "Daphnis (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006037,
    "auth_name": "IAU_2015",
    "auth_id": "63525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66038,
    "description": "Daphnis (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006038,
    "auth_name": "IAU_2015",
    "auth_id": "63530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66039,
    "description": "Daphnis (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006039,
    "auth_name": "IAU_2015",
    "auth_id": "63535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66040,
    "description": "Daphnis (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006040,
    "auth_name": "IAU_2015",
    "auth_id": "63540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66041,
    "description": "Daphnis (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006041,
    "auth_name": "IAU_2015",
    "auth_id": "63545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66042,
    "description": "Daphnis (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006042,
    "auth_name": "IAU_2015",
    "auth_id": "63550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66043,
    "description": "Daphnis (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006043,
    "auth_name": "IAU_2015",
    "auth_id": "63555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66044,
    "description": "Daphnis (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006044,
    "auth_name": "IAU_2015",
    "auth_id": "63560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66045,
    "description": "Daphnis (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006045,
    "auth_name": "IAU_2015",
    "auth_id": "63565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66046,
    "description": "Daphnis (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006046,
    "auth_name": "IAU_2015",
    "auth_id": "63570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66047,
    "description": "Daphnis (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006047,
    "auth_name": "IAU_2015",
    "auth_id": "63575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66048,
    "description": "Daphnis (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006048,
    "auth_name": "IAU_2015",
    "auth_id": "63580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66049,
    "description": "Daphnis (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520006049,
    "auth_name": "IAU_2015",
    "auth_id": "63585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66050,
    "description": "Anthe (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=500 +no_defs",
    "srid": 520006050,
    "auth_name": "IAU_2015",
    "auth_id": "64900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66051,
    "description": "Anthe (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006051,
    "auth_name": "IAU_2015",
    "auth_id": "64910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66052,
    "description": "Anthe (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006052,
    "auth_name": "IAU_2015",
    "auth_id": "64915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66053,
    "description": "Anthe (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006053,
    "auth_name": "IAU_2015",
    "auth_id": "64920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66054,
    "description": "Anthe (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006054,
    "auth_name": "IAU_2015",
    "auth_id": "64925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66055,
    "description": "Anthe (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006055,
    "auth_name": "IAU_2015",
    "auth_id": "64930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66056,
    "description": "Anthe (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006056,
    "auth_name": "IAU_2015",
    "auth_id": "64935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66057,
    "description": "Anthe (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006057,
    "auth_name": "IAU_2015",
    "auth_id": "64940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66058,
    "description": "Anthe (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006058,
    "auth_name": "IAU_2015",
    "auth_id": "64945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66059,
    "description": "Anthe (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006059,
    "auth_name": "IAU_2015",
    "auth_id": "64950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66060,
    "description": "Anthe (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006060,
    "auth_name": "IAU_2015",
    "auth_id": "64955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66061,
    "description": "Anthe (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006061,
    "auth_name": "IAU_2015",
    "auth_id": "64960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66062,
    "description": "Anthe (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006062,
    "auth_name": "IAU_2015",
    "auth_id": "64965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66063,
    "description": "Anthe (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006063,
    "auth_name": "IAU_2015",
    "auth_id": "64970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66064,
    "description": "Anthe (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006064,
    "auth_name": "IAU_2015",
    "auth_id": "64975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66065,
    "description": "Anthe (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006065,
    "auth_name": "IAU_2015",
    "auth_id": "64980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66066,
    "description": "Anthe (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520006066,
    "auth_name": "IAU_2015",
    "auth_id": "64985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66067,
    "description": "Aegaeon (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=330 +no_defs",
    "srid": 520006067,
    "auth_name": "IAU_2015",
    "auth_id": "65300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66068,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006068,
    "auth_name": "IAU_2015",
    "auth_id": "65310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66069,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006069,
    "auth_name": "IAU_2015",
    "auth_id": "65315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66070,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006070,
    "auth_name": "IAU_2015",
    "auth_id": "65320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66071,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006071,
    "auth_name": "IAU_2015",
    "auth_id": "65325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66072,
    "description": "Aegaeon (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006072,
    "auth_name": "IAU_2015",
    "auth_id": "65330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66073,
    "description": "Aegaeon (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006073,
    "auth_name": "IAU_2015",
    "auth_id": "65335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66074,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006074,
    "auth_name": "IAU_2015",
    "auth_id": "65340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66075,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006075,
    "auth_name": "IAU_2015",
    "auth_id": "65345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66076,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006076,
    "auth_name": "IAU_2015",
    "auth_id": "65350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66077,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006077,
    "auth_name": "IAU_2015",
    "auth_id": "65355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66078,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006078,
    "auth_name": "IAU_2015",
    "auth_id": "65360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66079,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006079,
    "auth_name": "IAU_2015",
    "auth_id": "65365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66080,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006080,
    "auth_name": "IAU_2015",
    "auth_id": "65370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66081,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006081,
    "auth_name": "IAU_2015",
    "auth_id": "65375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66082,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006082,
    "auth_name": "IAU_2015",
    "auth_id": "65380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66083,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520006083,
    "auth_name": "IAU_2015",
    "auth_id": "65385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66084,
    "description": "Saturn (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=60268000 +no_defs",
    "srid": 520006084,
    "auth_name": "IAU_2015",
    "auth_id": "69900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66085,
    "description": "Saturn (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=60268000 +b=54364000 +no_defs",
    "srid": 520006085,
    "auth_name": "IAU_2015",
    "auth_id": "69901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66086,
    "description": "Saturn (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520006086,
    "auth_name": "IAU_2015",
    "auth_id": "69902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 66087,
    "description": "Saturn (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006087,
    "auth_name": "IAU_2015",
    "auth_id": "69910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66088,
    "description": "Saturn (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006088,
    "auth_name": "IAU_2015",
    "auth_id": "69911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66089,
    "description": "Saturn (2015) / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006089,
    "auth_name": "IAU_2015",
    "auth_id": "69912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66090,
    "description": "Saturn (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006090,
    "auth_name": "IAU_2015",
    "auth_id": "69915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66091,
    "description": "Saturn (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006091,
    "auth_name": "IAU_2015",
    "auth_id": "69916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66092,
    "description": "Saturn (2015) / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006092,
    "auth_name": "IAU_2015",
    "auth_id": "69917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66093,
    "description": "Saturn (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006093,
    "auth_name": "IAU_2015",
    "auth_id": "69920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66094,
    "description": "Saturn (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006094,
    "auth_name": "IAU_2015",
    "auth_id": "69921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66095,
    "description": "Saturn (2015) / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006095,
    "auth_name": "IAU_2015",
    "auth_id": "69922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66096,
    "description": "Saturn (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006096,
    "auth_name": "IAU_2015",
    "auth_id": "69925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66097,
    "description": "Saturn (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006097,
    "auth_name": "IAU_2015",
    "auth_id": "69926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66098,
    "description": "Saturn (2015) / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006098,
    "auth_name": "IAU_2015",
    "auth_id": "69927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66099,
    "description": "Saturn (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006099,
    "auth_name": "IAU_2015",
    "auth_id": "69930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66100,
    "description": "Saturn (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006100,
    "auth_name": "IAU_2015",
    "auth_id": "69931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66101,
    "description": "Saturn (2015) / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006101,
    "auth_name": "IAU_2015",
    "auth_id": "69932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66102,
    "description": "Saturn (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006102,
    "auth_name": "IAU_2015",
    "auth_id": "69935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66103,
    "description": "Saturn (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006103,
    "auth_name": "IAU_2015",
    "auth_id": "69936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66104,
    "description": "Saturn (2015) / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006104,
    "auth_name": "IAU_2015",
    "auth_id": "69937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66105,
    "description": "Saturn (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006105,
    "auth_name": "IAU_2015",
    "auth_id": "69940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66106,
    "description": "Saturn (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006106,
    "auth_name": "IAU_2015",
    "auth_id": "69941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66107,
    "description": "Saturn (2015) / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006107,
    "auth_name": "IAU_2015",
    "auth_id": "69942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66108,
    "description": "Saturn (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006108,
    "auth_name": "IAU_2015",
    "auth_id": "69945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66109,
    "description": "Saturn (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006109,
    "auth_name": "IAU_2015",
    "auth_id": "69946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66110,
    "description": "Saturn (2015) / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006110,
    "auth_name": "IAU_2015",
    "auth_id": "69947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66111,
    "description": "Saturn (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006111,
    "auth_name": "IAU_2015",
    "auth_id": "69950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66112,
    "description": "Saturn (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006112,
    "auth_name": "IAU_2015",
    "auth_id": "69951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66113,
    "description": "Saturn (2015) / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006113,
    "auth_name": "IAU_2015",
    "auth_id": "69952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66114,
    "description": "Saturn (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006114,
    "auth_name": "IAU_2015",
    "auth_id": "69955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66115,
    "description": "Saturn (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006115,
    "auth_name": "IAU_2015",
    "auth_id": "69956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66116,
    "description": "Saturn (2015) / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006116,
    "auth_name": "IAU_2015",
    "auth_id": "69957",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66117,
    "description": "Saturn (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006117,
    "auth_name": "IAU_2015",
    "auth_id": "69960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66118,
    "description": "Saturn (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006118,
    "auth_name": "IAU_2015",
    "auth_id": "69961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66119,
    "description": "Saturn (2015) / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006119,
    "auth_name": "IAU_2015",
    "auth_id": "69962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66120,
    "description": "Saturn (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006120,
    "auth_name": "IAU_2015",
    "auth_id": "69965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66121,
    "description": "Saturn (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006121,
    "auth_name": "IAU_2015",
    "auth_id": "69966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66122,
    "description": "Saturn (2015) / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006122,
    "auth_name": "IAU_2015",
    "auth_id": "69967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66123,
    "description": "Saturn (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006123,
    "auth_name": "IAU_2015",
    "auth_id": "69970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66124,
    "description": "Saturn (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006124,
    "auth_name": "IAU_2015",
    "auth_id": "69971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66125,
    "description": "Saturn (2015) / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006125,
    "auth_name": "IAU_2015",
    "auth_id": "69972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66126,
    "description": "Saturn (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006126,
    "auth_name": "IAU_2015",
    "auth_id": "69975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66127,
    "description": "Saturn (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006127,
    "auth_name": "IAU_2015",
    "auth_id": "69976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66128,
    "description": "Saturn (2015) / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006128,
    "auth_name": "IAU_2015",
    "auth_id": "69977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66129,
    "description": "Saturn (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006129,
    "auth_name": "IAU_2015",
    "auth_id": "69980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66130,
    "description": "Saturn (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006130,
    "auth_name": "IAU_2015",
    "auth_id": "69981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66131,
    "description": "Saturn (2015) / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006131,
    "auth_name": "IAU_2015",
    "auth_id": "69982",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66132,
    "description": "Saturn (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520006132,
    "auth_name": "IAU_2015",
    "auth_id": "69985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66133,
    "description": "Saturn (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006133,
    "auth_name": "IAU_2015",
    "auth_id": "69986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66134,
    "description": "Saturn (2015) / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520006134,
    "auth_name": "IAU_2015",
    "auth_id": "69987",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66135,
    "description": "Ariel (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=578900 +no_defs",
    "srid": 520006135,
    "auth_name": "IAU_2015",
    "auth_id": "70100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66136,
    "description": "Ariel (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006136,
    "auth_name": "IAU_2015",
    "auth_id": "70110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66137,
    "description": "Ariel (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006137,
    "auth_name": "IAU_2015",
    "auth_id": "70115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66138,
    "description": "Ariel (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006138,
    "auth_name": "IAU_2015",
    "auth_id": "70120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66139,
    "description": "Ariel (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006139,
    "auth_name": "IAU_2015",
    "auth_id": "70125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66140,
    "description": "Ariel (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006140,
    "auth_name": "IAU_2015",
    "auth_id": "70130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66141,
    "description": "Ariel (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006141,
    "auth_name": "IAU_2015",
    "auth_id": "70135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66142,
    "description": "Ariel (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006142,
    "auth_name": "IAU_2015",
    "auth_id": "70140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66143,
    "description": "Ariel (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006143,
    "auth_name": "IAU_2015",
    "auth_id": "70145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66144,
    "description": "Ariel (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006144,
    "auth_name": "IAU_2015",
    "auth_id": "70150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66145,
    "description": "Ariel (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006145,
    "auth_name": "IAU_2015",
    "auth_id": "70155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66146,
    "description": "Ariel (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006146,
    "auth_name": "IAU_2015",
    "auth_id": "70160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66147,
    "description": "Ariel (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006147,
    "auth_name": "IAU_2015",
    "auth_id": "70165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66148,
    "description": "Ariel (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006148,
    "auth_name": "IAU_2015",
    "auth_id": "70170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66149,
    "description": "Ariel (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006149,
    "auth_name": "IAU_2015",
    "auth_id": "70175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66150,
    "description": "Ariel (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006150,
    "auth_name": "IAU_2015",
    "auth_id": "70180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66151,
    "description": "Ariel (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520006151,
    "auth_name": "IAU_2015",
    "auth_id": "70185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66152,
    "description": "Umbriel (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=584700 +no_defs",
    "srid": 520006152,
    "auth_name": "IAU_2015",
    "auth_id": "70200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66153,
    "description": "Umbriel (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006153,
    "auth_name": "IAU_2015",
    "auth_id": "70210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66154,
    "description": "Umbriel (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006154,
    "auth_name": "IAU_2015",
    "auth_id": "70215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66155,
    "description": "Umbriel (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006155,
    "auth_name": "IAU_2015",
    "auth_id": "70220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66156,
    "description": "Umbriel (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006156,
    "auth_name": "IAU_2015",
    "auth_id": "70225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66157,
    "description": "Umbriel (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006157,
    "auth_name": "IAU_2015",
    "auth_id": "70230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66158,
    "description": "Umbriel (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006158,
    "auth_name": "IAU_2015",
    "auth_id": "70235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66159,
    "description": "Umbriel (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006159,
    "auth_name": "IAU_2015",
    "auth_id": "70240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66160,
    "description": "Umbriel (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006160,
    "auth_name": "IAU_2015",
    "auth_id": "70245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66161,
    "description": "Umbriel (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006161,
    "auth_name": "IAU_2015",
    "auth_id": "70250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66162,
    "description": "Umbriel (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006162,
    "auth_name": "IAU_2015",
    "auth_id": "70255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66163,
    "description": "Umbriel (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006163,
    "auth_name": "IAU_2015",
    "auth_id": "70260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66164,
    "description": "Umbriel (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006164,
    "auth_name": "IAU_2015",
    "auth_id": "70265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66165,
    "description": "Umbriel (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006165,
    "auth_name": "IAU_2015",
    "auth_id": "70270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66166,
    "description": "Umbriel (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006166,
    "auth_name": "IAU_2015",
    "auth_id": "70275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66167,
    "description": "Umbriel (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006167,
    "auth_name": "IAU_2015",
    "auth_id": "70280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66168,
    "description": "Umbriel (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520006168,
    "auth_name": "IAU_2015",
    "auth_id": "70285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66169,
    "description": "Titania (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=788900 +no_defs",
    "srid": 520006169,
    "auth_name": "IAU_2015",
    "auth_id": "70300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66170,
    "description": "Titania (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006170,
    "auth_name": "IAU_2015",
    "auth_id": "70310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66171,
    "description": "Titania (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006171,
    "auth_name": "IAU_2015",
    "auth_id": "70315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66172,
    "description": "Titania (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006172,
    "auth_name": "IAU_2015",
    "auth_id": "70320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66173,
    "description": "Titania (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006173,
    "auth_name": "IAU_2015",
    "auth_id": "70325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66174,
    "description": "Titania (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006174,
    "auth_name": "IAU_2015",
    "auth_id": "70330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66175,
    "description": "Titania (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006175,
    "auth_name": "IAU_2015",
    "auth_id": "70335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66176,
    "description": "Titania (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006176,
    "auth_name": "IAU_2015",
    "auth_id": "70340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66177,
    "description": "Titania (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006177,
    "auth_name": "IAU_2015",
    "auth_id": "70345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66178,
    "description": "Titania (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006178,
    "auth_name": "IAU_2015",
    "auth_id": "70350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66179,
    "description": "Titania (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006179,
    "auth_name": "IAU_2015",
    "auth_id": "70355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66180,
    "description": "Titania (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006180,
    "auth_name": "IAU_2015",
    "auth_id": "70360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66181,
    "description": "Titania (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006181,
    "auth_name": "IAU_2015",
    "auth_id": "70365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66182,
    "description": "Titania (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006182,
    "auth_name": "IAU_2015",
    "auth_id": "70370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66183,
    "description": "Titania (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006183,
    "auth_name": "IAU_2015",
    "auth_id": "70375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66184,
    "description": "Titania (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006184,
    "auth_name": "IAU_2015",
    "auth_id": "70380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66185,
    "description": "Titania (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520006185,
    "auth_name": "IAU_2015",
    "auth_id": "70385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66186,
    "description": "Oberon (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=761400 +no_defs",
    "srid": 520006186,
    "auth_name": "IAU_2015",
    "auth_id": "70400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66187,
    "description": "Oberon (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006187,
    "auth_name": "IAU_2015",
    "auth_id": "70410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66188,
    "description": "Oberon (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006188,
    "auth_name": "IAU_2015",
    "auth_id": "70415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66189,
    "description": "Oberon (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006189,
    "auth_name": "IAU_2015",
    "auth_id": "70420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66190,
    "description": "Oberon (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006190,
    "auth_name": "IAU_2015",
    "auth_id": "70425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66191,
    "description": "Oberon (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006191,
    "auth_name": "IAU_2015",
    "auth_id": "70430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66192,
    "description": "Oberon (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006192,
    "auth_name": "IAU_2015",
    "auth_id": "70435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66193,
    "description": "Oberon (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006193,
    "auth_name": "IAU_2015",
    "auth_id": "70440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66194,
    "description": "Oberon (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006194,
    "auth_name": "IAU_2015",
    "auth_id": "70445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66195,
    "description": "Oberon (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006195,
    "auth_name": "IAU_2015",
    "auth_id": "70450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66196,
    "description": "Oberon (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006196,
    "auth_name": "IAU_2015",
    "auth_id": "70455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66197,
    "description": "Oberon (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006197,
    "auth_name": "IAU_2015",
    "auth_id": "70460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66198,
    "description": "Oberon (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006198,
    "auth_name": "IAU_2015",
    "auth_id": "70465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66199,
    "description": "Oberon (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006199,
    "auth_name": "IAU_2015",
    "auth_id": "70470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66200,
    "description": "Oberon (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006200,
    "auth_name": "IAU_2015",
    "auth_id": "70475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66201,
    "description": "Oberon (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006201,
    "auth_name": "IAU_2015",
    "auth_id": "70480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66202,
    "description": "Oberon (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520006202,
    "auth_name": "IAU_2015",
    "auth_id": "70485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66203,
    "description": "Miranda (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=235800 +no_defs",
    "srid": 520006203,
    "auth_name": "IAU_2015",
    "auth_id": "70500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66204,
    "description": "Miranda (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006204,
    "auth_name": "IAU_2015",
    "auth_id": "70510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66205,
    "description": "Miranda (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006205,
    "auth_name": "IAU_2015",
    "auth_id": "70515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66206,
    "description": "Miranda (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006206,
    "auth_name": "IAU_2015",
    "auth_id": "70520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66207,
    "description": "Miranda (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006207,
    "auth_name": "IAU_2015",
    "auth_id": "70525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66208,
    "description": "Miranda (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006208,
    "auth_name": "IAU_2015",
    "auth_id": "70530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66209,
    "description": "Miranda (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006209,
    "auth_name": "IAU_2015",
    "auth_id": "70535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66210,
    "description": "Miranda (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006210,
    "auth_name": "IAU_2015",
    "auth_id": "70540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66211,
    "description": "Miranda (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006211,
    "auth_name": "IAU_2015",
    "auth_id": "70545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66212,
    "description": "Miranda (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006212,
    "auth_name": "IAU_2015",
    "auth_id": "70550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66213,
    "description": "Miranda (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006213,
    "auth_name": "IAU_2015",
    "auth_id": "70555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66214,
    "description": "Miranda (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006214,
    "auth_name": "IAU_2015",
    "auth_id": "70560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66215,
    "description": "Miranda (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006215,
    "auth_name": "IAU_2015",
    "auth_id": "70565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66216,
    "description": "Miranda (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006216,
    "auth_name": "IAU_2015",
    "auth_id": "70570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66217,
    "description": "Miranda (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006217,
    "auth_name": "IAU_2015",
    "auth_id": "70575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66218,
    "description": "Miranda (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006218,
    "auth_name": "IAU_2015",
    "auth_id": "70580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66219,
    "description": "Miranda (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520006219,
    "auth_name": "IAU_2015",
    "auth_id": "70585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66220,
    "description": "Cordelia (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=13000 +no_defs",
    "srid": 520006220,
    "auth_name": "IAU_2015",
    "auth_id": "70600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66221,
    "description": "Cordelia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006221,
    "auth_name": "IAU_2015",
    "auth_id": "70610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66222,
    "description": "Cordelia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006222,
    "auth_name": "IAU_2015",
    "auth_id": "70615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66223,
    "description": "Cordelia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006223,
    "auth_name": "IAU_2015",
    "auth_id": "70620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66224,
    "description": "Cordelia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006224,
    "auth_name": "IAU_2015",
    "auth_id": "70625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66225,
    "description": "Cordelia (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006225,
    "auth_name": "IAU_2015",
    "auth_id": "70630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66226,
    "description": "Cordelia (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006226,
    "auth_name": "IAU_2015",
    "auth_id": "70635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66227,
    "description": "Cordelia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006227,
    "auth_name": "IAU_2015",
    "auth_id": "70640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66228,
    "description": "Cordelia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006228,
    "auth_name": "IAU_2015",
    "auth_id": "70645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66229,
    "description": "Cordelia (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006229,
    "auth_name": "IAU_2015",
    "auth_id": "70650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66230,
    "description": "Cordelia (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006230,
    "auth_name": "IAU_2015",
    "auth_id": "70655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66231,
    "description": "Cordelia (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006231,
    "auth_name": "IAU_2015",
    "auth_id": "70660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66232,
    "description": "Cordelia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006232,
    "auth_name": "IAU_2015",
    "auth_id": "70665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66233,
    "description": "Cordelia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006233,
    "auth_name": "IAU_2015",
    "auth_id": "70670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66234,
    "description": "Cordelia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006234,
    "auth_name": "IAU_2015",
    "auth_id": "70675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66235,
    "description": "Cordelia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006235,
    "auth_name": "IAU_2015",
    "auth_id": "70680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66236,
    "description": "Cordelia (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520006236,
    "auth_name": "IAU_2015",
    "auth_id": "70685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66237,
    "description": "Ophelia (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=15000 +no_defs",
    "srid": 520006237,
    "auth_name": "IAU_2015",
    "auth_id": "70700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66238,
    "description": "Ophelia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006238,
    "auth_name": "IAU_2015",
    "auth_id": "70710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66239,
    "description": "Ophelia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006239,
    "auth_name": "IAU_2015",
    "auth_id": "70715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66240,
    "description": "Ophelia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006240,
    "auth_name": "IAU_2015",
    "auth_id": "70720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66241,
    "description": "Ophelia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006241,
    "auth_name": "IAU_2015",
    "auth_id": "70725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66242,
    "description": "Ophelia (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006242,
    "auth_name": "IAU_2015",
    "auth_id": "70730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66243,
    "description": "Ophelia (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006243,
    "auth_name": "IAU_2015",
    "auth_id": "70735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66244,
    "description": "Ophelia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006244,
    "auth_name": "IAU_2015",
    "auth_id": "70740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66245,
    "description": "Ophelia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006245,
    "auth_name": "IAU_2015",
    "auth_id": "70745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66246,
    "description": "Ophelia (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006246,
    "auth_name": "IAU_2015",
    "auth_id": "70750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66247,
    "description": "Ophelia (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006247,
    "auth_name": "IAU_2015",
    "auth_id": "70755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66248,
    "description": "Ophelia (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006248,
    "auth_name": "IAU_2015",
    "auth_id": "70760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66249,
    "description": "Ophelia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006249,
    "auth_name": "IAU_2015",
    "auth_id": "70765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66250,
    "description": "Ophelia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006250,
    "auth_name": "IAU_2015",
    "auth_id": "70770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66251,
    "description": "Ophelia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006251,
    "auth_name": "IAU_2015",
    "auth_id": "70775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66252,
    "description": "Ophelia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006252,
    "auth_name": "IAU_2015",
    "auth_id": "70780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66253,
    "description": "Ophelia (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520006253,
    "auth_name": "IAU_2015",
    "auth_id": "70785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66254,
    "description": "Bianca (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=21000 +no_defs",
    "srid": 520006254,
    "auth_name": "IAU_2015",
    "auth_id": "70800",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66255,
    "description": "Bianca (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006255,
    "auth_name": "IAU_2015",
    "auth_id": "70810",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66256,
    "description": "Bianca (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006256,
    "auth_name": "IAU_2015",
    "auth_id": "70815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66257,
    "description": "Bianca (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006257,
    "auth_name": "IAU_2015",
    "auth_id": "70820",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66258,
    "description": "Bianca (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006258,
    "auth_name": "IAU_2015",
    "auth_id": "70825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66259,
    "description": "Bianca (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006259,
    "auth_name": "IAU_2015",
    "auth_id": "70830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66260,
    "description": "Bianca (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006260,
    "auth_name": "IAU_2015",
    "auth_id": "70835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66261,
    "description": "Bianca (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006261,
    "auth_name": "IAU_2015",
    "auth_id": "70840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66262,
    "description": "Bianca (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006262,
    "auth_name": "IAU_2015",
    "auth_id": "70845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66263,
    "description": "Bianca (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006263,
    "auth_name": "IAU_2015",
    "auth_id": "70850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66264,
    "description": "Bianca (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006264,
    "auth_name": "IAU_2015",
    "auth_id": "70855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66265,
    "description": "Bianca (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006265,
    "auth_name": "IAU_2015",
    "auth_id": "70860",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66266,
    "description": "Bianca (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006266,
    "auth_name": "IAU_2015",
    "auth_id": "70865",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66267,
    "description": "Bianca (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006267,
    "auth_name": "IAU_2015",
    "auth_id": "70870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66268,
    "description": "Bianca (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006268,
    "auth_name": "IAU_2015",
    "auth_id": "70875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66269,
    "description": "Bianca (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006269,
    "auth_name": "IAU_2015",
    "auth_id": "70880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66270,
    "description": "Bianca (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520006270,
    "auth_name": "IAU_2015",
    "auth_id": "70885",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66271,
    "description": "Cressida (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=31000 +no_defs",
    "srid": 520006271,
    "auth_name": "IAU_2015",
    "auth_id": "70900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66272,
    "description": "Cressida (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006272,
    "auth_name": "IAU_2015",
    "auth_id": "70910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66273,
    "description": "Cressida (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006273,
    "auth_name": "IAU_2015",
    "auth_id": "70915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66274,
    "description": "Cressida (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006274,
    "auth_name": "IAU_2015",
    "auth_id": "70920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66275,
    "description": "Cressida (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006275,
    "auth_name": "IAU_2015",
    "auth_id": "70925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66276,
    "description": "Cressida (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006276,
    "auth_name": "IAU_2015",
    "auth_id": "70930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66277,
    "description": "Cressida (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006277,
    "auth_name": "IAU_2015",
    "auth_id": "70935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66278,
    "description": "Cressida (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006278,
    "auth_name": "IAU_2015",
    "auth_id": "70940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66279,
    "description": "Cressida (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006279,
    "auth_name": "IAU_2015",
    "auth_id": "70945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66280,
    "description": "Cressida (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006280,
    "auth_name": "IAU_2015",
    "auth_id": "70950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66281,
    "description": "Cressida (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006281,
    "auth_name": "IAU_2015",
    "auth_id": "70955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66282,
    "description": "Cressida (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006282,
    "auth_name": "IAU_2015",
    "auth_id": "70960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66283,
    "description": "Cressida (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006283,
    "auth_name": "IAU_2015",
    "auth_id": "70965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66284,
    "description": "Cressida (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006284,
    "auth_name": "IAU_2015",
    "auth_id": "70970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66285,
    "description": "Cressida (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006285,
    "auth_name": "IAU_2015",
    "auth_id": "70975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66286,
    "description": "Cressida (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006286,
    "auth_name": "IAU_2015",
    "auth_id": "70980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66287,
    "description": "Cressida (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520006287,
    "auth_name": "IAU_2015",
    "auth_id": "70985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66288,
    "description": "Desdemona (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=27000 +no_defs",
    "srid": 520006288,
    "auth_name": "IAU_2015",
    "auth_id": "71000",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66289,
    "description": "Desdemona (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006289,
    "auth_name": "IAU_2015",
    "auth_id": "71010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66290,
    "description": "Desdemona (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006290,
    "auth_name": "IAU_2015",
    "auth_id": "71015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66291,
    "description": "Desdemona (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006291,
    "auth_name": "IAU_2015",
    "auth_id": "71020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66292,
    "description": "Desdemona (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006292,
    "auth_name": "IAU_2015",
    "auth_id": "71025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66293,
    "description": "Desdemona (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006293,
    "auth_name": "IAU_2015",
    "auth_id": "71030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66294,
    "description": "Desdemona (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006294,
    "auth_name": "IAU_2015",
    "auth_id": "71035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66295,
    "description": "Desdemona (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006295,
    "auth_name": "IAU_2015",
    "auth_id": "71040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66296,
    "description": "Desdemona (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006296,
    "auth_name": "IAU_2015",
    "auth_id": "71045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66297,
    "description": "Desdemona (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006297,
    "auth_name": "IAU_2015",
    "auth_id": "71050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66298,
    "description": "Desdemona (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006298,
    "auth_name": "IAU_2015",
    "auth_id": "71055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66299,
    "description": "Desdemona (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006299,
    "auth_name": "IAU_2015",
    "auth_id": "71060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66300,
    "description": "Desdemona (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006300,
    "auth_name": "IAU_2015",
    "auth_id": "71065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66301,
    "description": "Desdemona (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006301,
    "auth_name": "IAU_2015",
    "auth_id": "71070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66302,
    "description": "Desdemona (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006302,
    "auth_name": "IAU_2015",
    "auth_id": "71075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66303,
    "description": "Desdemona (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006303,
    "auth_name": "IAU_2015",
    "auth_id": "71080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66304,
    "description": "Desdemona (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006304,
    "auth_name": "IAU_2015",
    "auth_id": "71085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66305,
    "description": "Juliet (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=42000 +no_defs",
    "srid": 520006305,
    "auth_name": "IAU_2015",
    "auth_id": "71100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66306,
    "description": "Juliet (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006306,
    "auth_name": "IAU_2015",
    "auth_id": "71110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66307,
    "description": "Juliet (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006307,
    "auth_name": "IAU_2015",
    "auth_id": "71115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66308,
    "description": "Juliet (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006308,
    "auth_name": "IAU_2015",
    "auth_id": "71120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66309,
    "description": "Juliet (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006309,
    "auth_name": "IAU_2015",
    "auth_id": "71125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66310,
    "description": "Juliet (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006310,
    "auth_name": "IAU_2015",
    "auth_id": "71130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66311,
    "description": "Juliet (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006311,
    "auth_name": "IAU_2015",
    "auth_id": "71135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66312,
    "description": "Juliet (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006312,
    "auth_name": "IAU_2015",
    "auth_id": "71140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66313,
    "description": "Juliet (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006313,
    "auth_name": "IAU_2015",
    "auth_id": "71145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66314,
    "description": "Juliet (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006314,
    "auth_name": "IAU_2015",
    "auth_id": "71150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66315,
    "description": "Juliet (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006315,
    "auth_name": "IAU_2015",
    "auth_id": "71155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66316,
    "description": "Juliet (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006316,
    "auth_name": "IAU_2015",
    "auth_id": "71160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66317,
    "description": "Juliet (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006317,
    "auth_name": "IAU_2015",
    "auth_id": "71165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66318,
    "description": "Juliet (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006318,
    "auth_name": "IAU_2015",
    "auth_id": "71170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66319,
    "description": "Juliet (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006319,
    "auth_name": "IAU_2015",
    "auth_id": "71175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66320,
    "description": "Juliet (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006320,
    "auth_name": "IAU_2015",
    "auth_id": "71180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66321,
    "description": "Juliet (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520006321,
    "auth_name": "IAU_2015",
    "auth_id": "71185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66322,
    "description": "Portia (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=54000 +no_defs",
    "srid": 520006322,
    "auth_name": "IAU_2015",
    "auth_id": "71200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66323,
    "description": "Portia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006323,
    "auth_name": "IAU_2015",
    "auth_id": "71210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66324,
    "description": "Portia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006324,
    "auth_name": "IAU_2015",
    "auth_id": "71215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66325,
    "description": "Portia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006325,
    "auth_name": "IAU_2015",
    "auth_id": "71220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66326,
    "description": "Portia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006326,
    "auth_name": "IAU_2015",
    "auth_id": "71225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66327,
    "description": "Portia (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006327,
    "auth_name": "IAU_2015",
    "auth_id": "71230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66328,
    "description": "Portia (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006328,
    "auth_name": "IAU_2015",
    "auth_id": "71235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66329,
    "description": "Portia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006329,
    "auth_name": "IAU_2015",
    "auth_id": "71240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66330,
    "description": "Portia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006330,
    "auth_name": "IAU_2015",
    "auth_id": "71245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66331,
    "description": "Portia (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006331,
    "auth_name": "IAU_2015",
    "auth_id": "71250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66332,
    "description": "Portia (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006332,
    "auth_name": "IAU_2015",
    "auth_id": "71255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66333,
    "description": "Portia (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006333,
    "auth_name": "IAU_2015",
    "auth_id": "71260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66334,
    "description": "Portia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006334,
    "auth_name": "IAU_2015",
    "auth_id": "71265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66335,
    "description": "Portia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006335,
    "auth_name": "IAU_2015",
    "auth_id": "71270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66336,
    "description": "Portia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006336,
    "auth_name": "IAU_2015",
    "auth_id": "71275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66337,
    "description": "Portia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006337,
    "auth_name": "IAU_2015",
    "auth_id": "71280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66338,
    "description": "Portia (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520006338,
    "auth_name": "IAU_2015",
    "auth_id": "71285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66339,
    "description": "Rosalind (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=27000 +no_defs",
    "srid": 520006339,
    "auth_name": "IAU_2015",
    "auth_id": "71300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66340,
    "description": "Rosalind (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006340,
    "auth_name": "IAU_2015",
    "auth_id": "71310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66341,
    "description": "Rosalind (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006341,
    "auth_name": "IAU_2015",
    "auth_id": "71315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66342,
    "description": "Rosalind (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006342,
    "auth_name": "IAU_2015",
    "auth_id": "71320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66343,
    "description": "Rosalind (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006343,
    "auth_name": "IAU_2015",
    "auth_id": "71325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66344,
    "description": "Rosalind (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006344,
    "auth_name": "IAU_2015",
    "auth_id": "71330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66345,
    "description": "Rosalind (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006345,
    "auth_name": "IAU_2015",
    "auth_id": "71335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66346,
    "description": "Rosalind (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006346,
    "auth_name": "IAU_2015",
    "auth_id": "71340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66347,
    "description": "Rosalind (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006347,
    "auth_name": "IAU_2015",
    "auth_id": "71345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66348,
    "description": "Rosalind (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006348,
    "auth_name": "IAU_2015",
    "auth_id": "71350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66349,
    "description": "Rosalind (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006349,
    "auth_name": "IAU_2015",
    "auth_id": "71355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66350,
    "description": "Rosalind (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006350,
    "auth_name": "IAU_2015",
    "auth_id": "71360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66351,
    "description": "Rosalind (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006351,
    "auth_name": "IAU_2015",
    "auth_id": "71365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66352,
    "description": "Rosalind (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006352,
    "auth_name": "IAU_2015",
    "auth_id": "71370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66353,
    "description": "Rosalind (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006353,
    "auth_name": "IAU_2015",
    "auth_id": "71375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66354,
    "description": "Rosalind (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006354,
    "auth_name": "IAU_2015",
    "auth_id": "71380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66355,
    "description": "Rosalind (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520006355,
    "auth_name": "IAU_2015",
    "auth_id": "71385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66356,
    "description": "Belinda (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=33000 +no_defs",
    "srid": 520006356,
    "auth_name": "IAU_2015",
    "auth_id": "71400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66357,
    "description": "Belinda (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006357,
    "auth_name": "IAU_2015",
    "auth_id": "71410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66358,
    "description": "Belinda (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006358,
    "auth_name": "IAU_2015",
    "auth_id": "71415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66359,
    "description": "Belinda (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006359,
    "auth_name": "IAU_2015",
    "auth_id": "71420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66360,
    "description": "Belinda (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006360,
    "auth_name": "IAU_2015",
    "auth_id": "71425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66361,
    "description": "Belinda (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006361,
    "auth_name": "IAU_2015",
    "auth_id": "71430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66362,
    "description": "Belinda (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006362,
    "auth_name": "IAU_2015",
    "auth_id": "71435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66363,
    "description": "Belinda (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006363,
    "auth_name": "IAU_2015",
    "auth_id": "71440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66364,
    "description": "Belinda (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006364,
    "auth_name": "IAU_2015",
    "auth_id": "71445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66365,
    "description": "Belinda (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006365,
    "auth_name": "IAU_2015",
    "auth_id": "71450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66366,
    "description": "Belinda (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006366,
    "auth_name": "IAU_2015",
    "auth_id": "71455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66367,
    "description": "Belinda (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006367,
    "auth_name": "IAU_2015",
    "auth_id": "71460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66368,
    "description": "Belinda (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006368,
    "auth_name": "IAU_2015",
    "auth_id": "71465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66369,
    "description": "Belinda (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006369,
    "auth_name": "IAU_2015",
    "auth_id": "71470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66370,
    "description": "Belinda (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006370,
    "auth_name": "IAU_2015",
    "auth_id": "71475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66371,
    "description": "Belinda (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006371,
    "auth_name": "IAU_2015",
    "auth_id": "71480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66372,
    "description": "Belinda (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520006372,
    "auth_name": "IAU_2015",
    "auth_id": "71485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66373,
    "description": "Puck (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=77000 +no_defs",
    "srid": 520006373,
    "auth_name": "IAU_2015",
    "auth_id": "71500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66374,
    "description": "Puck (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006374,
    "auth_name": "IAU_2015",
    "auth_id": "71510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66375,
    "description": "Puck (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006375,
    "auth_name": "IAU_2015",
    "auth_id": "71515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66376,
    "description": "Puck (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006376,
    "auth_name": "IAU_2015",
    "auth_id": "71520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66377,
    "description": "Puck (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006377,
    "auth_name": "IAU_2015",
    "auth_id": "71525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66378,
    "description": "Puck (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006378,
    "auth_name": "IAU_2015",
    "auth_id": "71530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66379,
    "description": "Puck (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006379,
    "auth_name": "IAU_2015",
    "auth_id": "71535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66380,
    "description": "Puck (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006380,
    "auth_name": "IAU_2015",
    "auth_id": "71540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66381,
    "description": "Puck (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006381,
    "auth_name": "IAU_2015",
    "auth_id": "71545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66382,
    "description": "Puck (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006382,
    "auth_name": "IAU_2015",
    "auth_id": "71550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66383,
    "description": "Puck (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006383,
    "auth_name": "IAU_2015",
    "auth_id": "71555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66384,
    "description": "Puck (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006384,
    "auth_name": "IAU_2015",
    "auth_id": "71560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66385,
    "description": "Puck (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006385,
    "auth_name": "IAU_2015",
    "auth_id": "71565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66386,
    "description": "Puck (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006386,
    "auth_name": "IAU_2015",
    "auth_id": "71570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66387,
    "description": "Puck (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006387,
    "auth_name": "IAU_2015",
    "auth_id": "71575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66388,
    "description": "Puck (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006388,
    "auth_name": "IAU_2015",
    "auth_id": "71580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66389,
    "description": "Puck (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520006389,
    "auth_name": "IAU_2015",
    "auth_id": "71585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66390,
    "description": "Uranus (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=25559000 +no_defs",
    "srid": 520006390,
    "auth_name": "IAU_2015",
    "auth_id": "79900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66391,
    "description": "Uranus (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=25559000 +b=24973000 +no_defs",
    "srid": 520006391,
    "auth_name": "IAU_2015",
    "auth_id": "79901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66392,
    "description": "Uranus (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520006392,
    "auth_name": "IAU_2015",
    "auth_id": "79902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 66393,
    "description": "Uranus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006393,
    "auth_name": "IAU_2015",
    "auth_id": "79910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66394,
    "description": "Uranus (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006394,
    "auth_name": "IAU_2015",
    "auth_id": "79911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66395,
    "description": "Uranus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006395,
    "auth_name": "IAU_2015",
    "auth_id": "79915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66396,
    "description": "Uranus (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006396,
    "auth_name": "IAU_2015",
    "auth_id": "79916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66397,
    "description": "Uranus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006397,
    "auth_name": "IAU_2015",
    "auth_id": "79920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66398,
    "description": "Uranus (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006398,
    "auth_name": "IAU_2015",
    "auth_id": "79921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66399,
    "description": "Uranus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006399,
    "auth_name": "IAU_2015",
    "auth_id": "79925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66400,
    "description": "Uranus (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006400,
    "auth_name": "IAU_2015",
    "auth_id": "79926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66401,
    "description": "Uranus (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006401,
    "auth_name": "IAU_2015",
    "auth_id": "79930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66402,
    "description": "Uranus (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006402,
    "auth_name": "IAU_2015",
    "auth_id": "79931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66403,
    "description": "Uranus (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006403,
    "auth_name": "IAU_2015",
    "auth_id": "79935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66404,
    "description": "Uranus (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006404,
    "auth_name": "IAU_2015",
    "auth_id": "79936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66405,
    "description": "Uranus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006405,
    "auth_name": "IAU_2015",
    "auth_id": "79940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66406,
    "description": "Uranus (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006406,
    "auth_name": "IAU_2015",
    "auth_id": "79941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66407,
    "description": "Uranus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006407,
    "auth_name": "IAU_2015",
    "auth_id": "79945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66408,
    "description": "Uranus (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006408,
    "auth_name": "IAU_2015",
    "auth_id": "79946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66409,
    "description": "Uranus (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006409,
    "auth_name": "IAU_2015",
    "auth_id": "79950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66410,
    "description": "Uranus (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006410,
    "auth_name": "IAU_2015",
    "auth_id": "79951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66411,
    "description": "Uranus (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006411,
    "auth_name": "IAU_2015",
    "auth_id": "79955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66412,
    "description": "Uranus (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006412,
    "auth_name": "IAU_2015",
    "auth_id": "79956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66413,
    "description": "Uranus (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006413,
    "auth_name": "IAU_2015",
    "auth_id": "79960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66414,
    "description": "Uranus (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006414,
    "auth_name": "IAU_2015",
    "auth_id": "79961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66415,
    "description": "Uranus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006415,
    "auth_name": "IAU_2015",
    "auth_id": "79965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66416,
    "description": "Uranus (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006416,
    "auth_name": "IAU_2015",
    "auth_id": "79966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66417,
    "description": "Uranus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006417,
    "auth_name": "IAU_2015",
    "auth_id": "79970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66418,
    "description": "Uranus (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006418,
    "auth_name": "IAU_2015",
    "auth_id": "79971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66419,
    "description": "Uranus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006419,
    "auth_name": "IAU_2015",
    "auth_id": "79975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66420,
    "description": "Uranus (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006420,
    "auth_name": "IAU_2015",
    "auth_id": "79976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66421,
    "description": "Uranus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006421,
    "auth_name": "IAU_2015",
    "auth_id": "79980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66422,
    "description": "Uranus (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006422,
    "auth_name": "IAU_2015",
    "auth_id": "79981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66423,
    "description": "Uranus (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520006423,
    "auth_name": "IAU_2015",
    "auth_id": "79985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66424,
    "description": "Uranus (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520006424,
    "auth_name": "IAU_2015",
    "auth_id": "79986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66425,
    "description": "Triton (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1352600 +no_defs",
    "srid": 520006425,
    "auth_name": "IAU_2015",
    "auth_id": "80100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66426,
    "description": "Triton (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006426,
    "auth_name": "IAU_2015",
    "auth_id": "80110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66427,
    "description": "Triton (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006427,
    "auth_name": "IAU_2015",
    "auth_id": "80115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66428,
    "description": "Triton (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006428,
    "auth_name": "IAU_2015",
    "auth_id": "80120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66429,
    "description": "Triton (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006429,
    "auth_name": "IAU_2015",
    "auth_id": "80125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66430,
    "description": "Triton (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006430,
    "auth_name": "IAU_2015",
    "auth_id": "80130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66431,
    "description": "Triton (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006431,
    "auth_name": "IAU_2015",
    "auth_id": "80135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66432,
    "description": "Triton (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006432,
    "auth_name": "IAU_2015",
    "auth_id": "80140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66433,
    "description": "Triton (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006433,
    "auth_name": "IAU_2015",
    "auth_id": "80145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66434,
    "description": "Triton (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006434,
    "auth_name": "IAU_2015",
    "auth_id": "80150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66435,
    "description": "Triton (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006435,
    "auth_name": "IAU_2015",
    "auth_id": "80155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66436,
    "description": "Triton (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006436,
    "auth_name": "IAU_2015",
    "auth_id": "80160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66437,
    "description": "Triton (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006437,
    "auth_name": "IAU_2015",
    "auth_id": "80165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66438,
    "description": "Triton (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006438,
    "auth_name": "IAU_2015",
    "auth_id": "80170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66439,
    "description": "Triton (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006439,
    "auth_name": "IAU_2015",
    "auth_id": "80175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66440,
    "description": "Triton (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006440,
    "auth_name": "IAU_2015",
    "auth_id": "80180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66441,
    "description": "Triton (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520006441,
    "auth_name": "IAU_2015",
    "auth_id": "80185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66442,
    "description": "Nereid (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=170000 +no_defs",
    "srid": 520006442,
    "auth_name": "IAU_2015",
    "auth_id": "80200",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66443,
    "description": "Nereid (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006443,
    "auth_name": "IAU_2015",
    "auth_id": "80210",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66444,
    "description": "Nereid (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006444,
    "auth_name": "IAU_2015",
    "auth_id": "80215",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66445,
    "description": "Nereid (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006445,
    "auth_name": "IAU_2015",
    "auth_id": "80220",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66446,
    "description": "Nereid (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006446,
    "auth_name": "IAU_2015",
    "auth_id": "80225",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66447,
    "description": "Nereid (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006447,
    "auth_name": "IAU_2015",
    "auth_id": "80230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66448,
    "description": "Nereid (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006448,
    "auth_name": "IAU_2015",
    "auth_id": "80235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66449,
    "description": "Nereid (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006449,
    "auth_name": "IAU_2015",
    "auth_id": "80240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66450,
    "description": "Nereid (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006450,
    "auth_name": "IAU_2015",
    "auth_id": "80245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66451,
    "description": "Nereid (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006451,
    "auth_name": "IAU_2015",
    "auth_id": "80250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66452,
    "description": "Nereid (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006452,
    "auth_name": "IAU_2015",
    "auth_id": "80255",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66453,
    "description": "Nereid (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006453,
    "auth_name": "IAU_2015",
    "auth_id": "80260",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66454,
    "description": "Nereid (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006454,
    "auth_name": "IAU_2015",
    "auth_id": "80265",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66455,
    "description": "Nereid (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006455,
    "auth_name": "IAU_2015",
    "auth_id": "80270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66456,
    "description": "Nereid (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006456,
    "auth_name": "IAU_2015",
    "auth_id": "80275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66457,
    "description": "Nereid (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006457,
    "auth_name": "IAU_2015",
    "auth_id": "80280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66458,
    "description": "Nereid (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520006458,
    "auth_name": "IAU_2015",
    "auth_id": "80285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66459,
    "description": "Naiad (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=29000 +no_defs",
    "srid": 520006459,
    "auth_name": "IAU_2015",
    "auth_id": "80300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66460,
    "description": "Naiad (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=29000 +no_defs",
    "srid": 520006460,
    "auth_name": "IAU_2015",
    "auth_id": "80301",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66461,
    "description": "Naiad (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006461,
    "auth_name": "IAU_2015",
    "auth_id": "80310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66462,
    "description": "Naiad (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006462,
    "auth_name": "IAU_2015",
    "auth_id": "80311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66463,
    "description": "Naiad (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006463,
    "auth_name": "IAU_2015",
    "auth_id": "80315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66464,
    "description": "Naiad (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006464,
    "auth_name": "IAU_2015",
    "auth_id": "80316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66465,
    "description": "Naiad (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006465,
    "auth_name": "IAU_2015",
    "auth_id": "80320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66466,
    "description": "Naiad (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006466,
    "auth_name": "IAU_2015",
    "auth_id": "80321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66467,
    "description": "Naiad (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006467,
    "auth_name": "IAU_2015",
    "auth_id": "80325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66468,
    "description": "Naiad (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006468,
    "auth_name": "IAU_2015",
    "auth_id": "80326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66469,
    "description": "Naiad (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006469,
    "auth_name": "IAU_2015",
    "auth_id": "80330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66470,
    "description": "Naiad (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006470,
    "auth_name": "IAU_2015",
    "auth_id": "80331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66471,
    "description": "Naiad (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006471,
    "auth_name": "IAU_2015",
    "auth_id": "80335",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66472,
    "description": "Naiad (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006472,
    "auth_name": "IAU_2015",
    "auth_id": "80336",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66473,
    "description": "Naiad (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006473,
    "auth_name": "IAU_2015",
    "auth_id": "80340",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66474,
    "description": "Naiad (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006474,
    "auth_name": "IAU_2015",
    "auth_id": "80341",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66475,
    "description": "Naiad (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006475,
    "auth_name": "IAU_2015",
    "auth_id": "80345",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66476,
    "description": "Naiad (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006476,
    "auth_name": "IAU_2015",
    "auth_id": "80346",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66477,
    "description": "Naiad (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006477,
    "auth_name": "IAU_2015",
    "auth_id": "80350",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66478,
    "description": "Naiad (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006478,
    "auth_name": "IAU_2015",
    "auth_id": "80351",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66479,
    "description": "Naiad (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006479,
    "auth_name": "IAU_2015",
    "auth_id": "80355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66480,
    "description": "Naiad (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006480,
    "auth_name": "IAU_2015",
    "auth_id": "80356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66481,
    "description": "Naiad (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006481,
    "auth_name": "IAU_2015",
    "auth_id": "80360",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66482,
    "description": "Naiad (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006482,
    "auth_name": "IAU_2015",
    "auth_id": "80361",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66483,
    "description": "Naiad (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006483,
    "auth_name": "IAU_2015",
    "auth_id": "80365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66484,
    "description": "Naiad (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006484,
    "auth_name": "IAU_2015",
    "auth_id": "80366",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66485,
    "description": "Naiad (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006485,
    "auth_name": "IAU_2015",
    "auth_id": "80370",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66486,
    "description": "Naiad (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006486,
    "auth_name": "IAU_2015",
    "auth_id": "80371",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66487,
    "description": "Naiad (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006487,
    "auth_name": "IAU_2015",
    "auth_id": "80375",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66488,
    "description": "Naiad (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006488,
    "auth_name": "IAU_2015",
    "auth_id": "80376",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66489,
    "description": "Naiad (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006489,
    "auth_name": "IAU_2015",
    "auth_id": "80380",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66490,
    "description": "Naiad (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006490,
    "auth_name": "IAU_2015",
    "auth_id": "80381",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66491,
    "description": "Naiad (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006491,
    "auth_name": "IAU_2015",
    "auth_id": "80385",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66492,
    "description": "Naiad (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520006492,
    "auth_name": "IAU_2015",
    "auth_id": "80386",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66493,
    "description": "Thalassa (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=40000 +no_defs",
    "srid": 520006493,
    "auth_name": "IAU_2015",
    "auth_id": "80400",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66494,
    "description": "Thalassa (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=40000 +no_defs",
    "srid": 520006494,
    "auth_name": "IAU_2015",
    "auth_id": "80401",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66495,
    "description": "Thalassa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006495,
    "auth_name": "IAU_2015",
    "auth_id": "80410",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66496,
    "description": "Thalassa (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006496,
    "auth_name": "IAU_2015",
    "auth_id": "80411",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66497,
    "description": "Thalassa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006497,
    "auth_name": "IAU_2015",
    "auth_id": "80415",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66498,
    "description": "Thalassa (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006498,
    "auth_name": "IAU_2015",
    "auth_id": "80416",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66499,
    "description": "Thalassa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006499,
    "auth_name": "IAU_2015",
    "auth_id": "80420",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66500,
    "description": "Thalassa (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006500,
    "auth_name": "IAU_2015",
    "auth_id": "80421",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66501,
    "description": "Thalassa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006501,
    "auth_name": "IAU_2015",
    "auth_id": "80425",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66502,
    "description": "Thalassa (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006502,
    "auth_name": "IAU_2015",
    "auth_id": "80426",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66503,
    "description": "Thalassa (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006503,
    "auth_name": "IAU_2015",
    "auth_id": "80430",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66504,
    "description": "Thalassa (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006504,
    "auth_name": "IAU_2015",
    "auth_id": "80431",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66505,
    "description": "Thalassa (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006505,
    "auth_name": "IAU_2015",
    "auth_id": "80435",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66506,
    "description": "Thalassa (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006506,
    "auth_name": "IAU_2015",
    "auth_id": "80436",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66507,
    "description": "Thalassa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006507,
    "auth_name": "IAU_2015",
    "auth_id": "80440",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66508,
    "description": "Thalassa (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006508,
    "auth_name": "IAU_2015",
    "auth_id": "80441",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66509,
    "description": "Thalassa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006509,
    "auth_name": "IAU_2015",
    "auth_id": "80445",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66510,
    "description": "Thalassa (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006510,
    "auth_name": "IAU_2015",
    "auth_id": "80446",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66511,
    "description": "Thalassa (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006511,
    "auth_name": "IAU_2015",
    "auth_id": "80450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66512,
    "description": "Thalassa (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006512,
    "auth_name": "IAU_2015",
    "auth_id": "80451",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66513,
    "description": "Thalassa (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006513,
    "auth_name": "IAU_2015",
    "auth_id": "80455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66514,
    "description": "Thalassa (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006514,
    "auth_name": "IAU_2015",
    "auth_id": "80456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66515,
    "description": "Thalassa (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006515,
    "auth_name": "IAU_2015",
    "auth_id": "80460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66516,
    "description": "Thalassa (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006516,
    "auth_name": "IAU_2015",
    "auth_id": "80461",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66517,
    "description": "Thalassa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006517,
    "auth_name": "IAU_2015",
    "auth_id": "80465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66518,
    "description": "Thalassa (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006518,
    "auth_name": "IAU_2015",
    "auth_id": "80466",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66519,
    "description": "Thalassa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006519,
    "auth_name": "IAU_2015",
    "auth_id": "80470",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66520,
    "description": "Thalassa (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006520,
    "auth_name": "IAU_2015",
    "auth_id": "80471",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66521,
    "description": "Thalassa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006521,
    "auth_name": "IAU_2015",
    "auth_id": "80475",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66522,
    "description": "Thalassa (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006522,
    "auth_name": "IAU_2015",
    "auth_id": "80476",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66523,
    "description": "Thalassa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006523,
    "auth_name": "IAU_2015",
    "auth_id": "80480",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66524,
    "description": "Thalassa (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006524,
    "auth_name": "IAU_2015",
    "auth_id": "80481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66525,
    "description": "Thalassa (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006525,
    "auth_name": "IAU_2015",
    "auth_id": "80485",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66526,
    "description": "Thalassa (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520006526,
    "auth_name": "IAU_2015",
    "auth_id": "80486",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66527,
    "description": "Despina (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=74000 +no_defs",
    "srid": 520006527,
    "auth_name": "IAU_2015",
    "auth_id": "80500",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66528,
    "description": "Despina (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=74000 +no_defs",
    "srid": 520006528,
    "auth_name": "IAU_2015",
    "auth_id": "80501",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66529,
    "description": "Despina (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006529,
    "auth_name": "IAU_2015",
    "auth_id": "80510",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66530,
    "description": "Despina (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006530,
    "auth_name": "IAU_2015",
    "auth_id": "80511",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66531,
    "description": "Despina (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006531,
    "auth_name": "IAU_2015",
    "auth_id": "80515",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66532,
    "description": "Despina (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006532,
    "auth_name": "IAU_2015",
    "auth_id": "80516",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66533,
    "description": "Despina (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006533,
    "auth_name": "IAU_2015",
    "auth_id": "80520",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66534,
    "description": "Despina (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006534,
    "auth_name": "IAU_2015",
    "auth_id": "80521",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66535,
    "description": "Despina (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006535,
    "auth_name": "IAU_2015",
    "auth_id": "80525",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66536,
    "description": "Despina (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006536,
    "auth_name": "IAU_2015",
    "auth_id": "80526",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66537,
    "description": "Despina (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006537,
    "auth_name": "IAU_2015",
    "auth_id": "80530",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66538,
    "description": "Despina (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006538,
    "auth_name": "IAU_2015",
    "auth_id": "80531",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66539,
    "description": "Despina (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006539,
    "auth_name": "IAU_2015",
    "auth_id": "80535",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66540,
    "description": "Despina (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006540,
    "auth_name": "IAU_2015",
    "auth_id": "80536",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66541,
    "description": "Despina (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006541,
    "auth_name": "IAU_2015",
    "auth_id": "80540",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66542,
    "description": "Despina (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006542,
    "auth_name": "IAU_2015",
    "auth_id": "80541",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66543,
    "description": "Despina (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006543,
    "auth_name": "IAU_2015",
    "auth_id": "80545",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66544,
    "description": "Despina (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006544,
    "auth_name": "IAU_2015",
    "auth_id": "80546",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66545,
    "description": "Despina (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006545,
    "auth_name": "IAU_2015",
    "auth_id": "80550",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66546,
    "description": "Despina (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006546,
    "auth_name": "IAU_2015",
    "auth_id": "80551",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66547,
    "description": "Despina (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006547,
    "auth_name": "IAU_2015",
    "auth_id": "80555",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66548,
    "description": "Despina (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006548,
    "auth_name": "IAU_2015",
    "auth_id": "80556",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66549,
    "description": "Despina (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006549,
    "auth_name": "IAU_2015",
    "auth_id": "80560",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66550,
    "description": "Despina (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006550,
    "auth_name": "IAU_2015",
    "auth_id": "80561",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66551,
    "description": "Despina (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006551,
    "auth_name": "IAU_2015",
    "auth_id": "80565",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66552,
    "description": "Despina (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006552,
    "auth_name": "IAU_2015",
    "auth_id": "80566",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66553,
    "description": "Despina (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006553,
    "auth_name": "IAU_2015",
    "auth_id": "80570",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66554,
    "description": "Despina (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006554,
    "auth_name": "IAU_2015",
    "auth_id": "80571",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66555,
    "description": "Despina (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006555,
    "auth_name": "IAU_2015",
    "auth_id": "80575",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66556,
    "description": "Despina (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006556,
    "auth_name": "IAU_2015",
    "auth_id": "80576",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66557,
    "description": "Despina (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006557,
    "auth_name": "IAU_2015",
    "auth_id": "80580",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66558,
    "description": "Despina (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006558,
    "auth_name": "IAU_2015",
    "auth_id": "80581",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66559,
    "description": "Despina (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006559,
    "auth_name": "IAU_2015",
    "auth_id": "80585",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66560,
    "description": "Despina (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520006560,
    "auth_name": "IAU_2015",
    "auth_id": "80586",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66561,
    "description": "Galatea (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=79000 +no_defs",
    "srid": 520006561,
    "auth_name": "IAU_2015",
    "auth_id": "80600",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66562,
    "description": "Galatea (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=79000 +no_defs",
    "srid": 520006562,
    "auth_name": "IAU_2015",
    "auth_id": "80601",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66563,
    "description": "Galatea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006563,
    "auth_name": "IAU_2015",
    "auth_id": "80610",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66564,
    "description": "Galatea (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006564,
    "auth_name": "IAU_2015",
    "auth_id": "80611",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66565,
    "description": "Galatea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006565,
    "auth_name": "IAU_2015",
    "auth_id": "80615",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66566,
    "description": "Galatea (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006566,
    "auth_name": "IAU_2015",
    "auth_id": "80616",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66567,
    "description": "Galatea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006567,
    "auth_name": "IAU_2015",
    "auth_id": "80620",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66568,
    "description": "Galatea (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006568,
    "auth_name": "IAU_2015",
    "auth_id": "80621",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66569,
    "description": "Galatea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006569,
    "auth_name": "IAU_2015",
    "auth_id": "80625",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66570,
    "description": "Galatea (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006570,
    "auth_name": "IAU_2015",
    "auth_id": "80626",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66571,
    "description": "Galatea (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006571,
    "auth_name": "IAU_2015",
    "auth_id": "80630",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66572,
    "description": "Galatea (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006572,
    "auth_name": "IAU_2015",
    "auth_id": "80631",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66573,
    "description": "Galatea (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006573,
    "auth_name": "IAU_2015",
    "auth_id": "80635",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66574,
    "description": "Galatea (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006574,
    "auth_name": "IAU_2015",
    "auth_id": "80636",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66575,
    "description": "Galatea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006575,
    "auth_name": "IAU_2015",
    "auth_id": "80640",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66576,
    "description": "Galatea (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006576,
    "auth_name": "IAU_2015",
    "auth_id": "80641",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66577,
    "description": "Galatea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006577,
    "auth_name": "IAU_2015",
    "auth_id": "80645",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66578,
    "description": "Galatea (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006578,
    "auth_name": "IAU_2015",
    "auth_id": "80646",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66579,
    "description": "Galatea (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006579,
    "auth_name": "IAU_2015",
    "auth_id": "80650",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66580,
    "description": "Galatea (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006580,
    "auth_name": "IAU_2015",
    "auth_id": "80651",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66581,
    "description": "Galatea (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006581,
    "auth_name": "IAU_2015",
    "auth_id": "80655",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66582,
    "description": "Galatea (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006582,
    "auth_name": "IAU_2015",
    "auth_id": "80656",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66583,
    "description": "Galatea (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006583,
    "auth_name": "IAU_2015",
    "auth_id": "80660",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66584,
    "description": "Galatea (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006584,
    "auth_name": "IAU_2015",
    "auth_id": "80661",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66585,
    "description": "Galatea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006585,
    "auth_name": "IAU_2015",
    "auth_id": "80665",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66586,
    "description": "Galatea (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006586,
    "auth_name": "IAU_2015",
    "auth_id": "80666",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66587,
    "description": "Galatea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006587,
    "auth_name": "IAU_2015",
    "auth_id": "80670",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66588,
    "description": "Galatea (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006588,
    "auth_name": "IAU_2015",
    "auth_id": "80671",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66589,
    "description": "Galatea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006589,
    "auth_name": "IAU_2015",
    "auth_id": "80675",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66590,
    "description": "Galatea (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006590,
    "auth_name": "IAU_2015",
    "auth_id": "80676",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66591,
    "description": "Galatea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006591,
    "auth_name": "IAU_2015",
    "auth_id": "80680",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66592,
    "description": "Galatea (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006592,
    "auth_name": "IAU_2015",
    "auth_id": "80681",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66593,
    "description": "Galatea (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006593,
    "auth_name": "IAU_2015",
    "auth_id": "80685",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66594,
    "description": "Galatea (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520006594,
    "auth_name": "IAU_2015",
    "auth_id": "80686",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66595,
    "description": "Larissa (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=96000 +no_defs",
    "srid": 520006595,
    "auth_name": "IAU_2015",
    "auth_id": "80700",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66596,
    "description": "Larissa (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=96000 +b=89000 +no_defs",
    "srid": 520006596,
    "auth_name": "IAU_2015",
    "auth_id": "80701",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66597,
    "description": "Larissa (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520006597,
    "auth_name": "IAU_2015",
    "auth_id": "80702",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 66598,
    "description": "Larissa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006598,
    "auth_name": "IAU_2015",
    "auth_id": "80710",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66599,
    "description": "Larissa (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006599,
    "auth_name": "IAU_2015",
    "auth_id": "80711",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66600,
    "description": "Larissa (2015) / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006600,
    "auth_name": "IAU_2015",
    "auth_id": "80712",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66601,
    "description": "Larissa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006601,
    "auth_name": "IAU_2015",
    "auth_id": "80715",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66602,
    "description": "Larissa (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006602,
    "auth_name": "IAU_2015",
    "auth_id": "80716",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66603,
    "description": "Larissa (2015) / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006603,
    "auth_name": "IAU_2015",
    "auth_id": "80717",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66604,
    "description": "Larissa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006604,
    "auth_name": "IAU_2015",
    "auth_id": "80720",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66605,
    "description": "Larissa (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006605,
    "auth_name": "IAU_2015",
    "auth_id": "80721",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66606,
    "description": "Larissa (2015) / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006606,
    "auth_name": "IAU_2015",
    "auth_id": "80722",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66607,
    "description": "Larissa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006607,
    "auth_name": "IAU_2015",
    "auth_id": "80725",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66608,
    "description": "Larissa (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006608,
    "auth_name": "IAU_2015",
    "auth_id": "80726",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66609,
    "description": "Larissa (2015) / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006609,
    "auth_name": "IAU_2015",
    "auth_id": "80727",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66610,
    "description": "Larissa (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006610,
    "auth_name": "IAU_2015",
    "auth_id": "80730",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66611,
    "description": "Larissa (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006611,
    "auth_name": "IAU_2015",
    "auth_id": "80731",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66612,
    "description": "Larissa (2015) / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006612,
    "auth_name": "IAU_2015",
    "auth_id": "80732",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66613,
    "description": "Larissa (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006613,
    "auth_name": "IAU_2015",
    "auth_id": "80735",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66614,
    "description": "Larissa (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006614,
    "auth_name": "IAU_2015",
    "auth_id": "80736",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66615,
    "description": "Larissa (2015) / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006615,
    "auth_name": "IAU_2015",
    "auth_id": "80737",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66616,
    "description": "Larissa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006616,
    "auth_name": "IAU_2015",
    "auth_id": "80740",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66617,
    "description": "Larissa (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006617,
    "auth_name": "IAU_2015",
    "auth_id": "80741",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66618,
    "description": "Larissa (2015) / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006618,
    "auth_name": "IAU_2015",
    "auth_id": "80742",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66619,
    "description": "Larissa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006619,
    "auth_name": "IAU_2015",
    "auth_id": "80745",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66620,
    "description": "Larissa (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006620,
    "auth_name": "IAU_2015",
    "auth_id": "80746",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66621,
    "description": "Larissa (2015) / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006621,
    "auth_name": "IAU_2015",
    "auth_id": "80747",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66622,
    "description": "Larissa (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006622,
    "auth_name": "IAU_2015",
    "auth_id": "80750",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66623,
    "description": "Larissa (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006623,
    "auth_name": "IAU_2015",
    "auth_id": "80751",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66624,
    "description": "Larissa (2015) / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006624,
    "auth_name": "IAU_2015",
    "auth_id": "80752",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66625,
    "description": "Larissa (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006625,
    "auth_name": "IAU_2015",
    "auth_id": "80755",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66626,
    "description": "Larissa (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006626,
    "auth_name": "IAU_2015",
    "auth_id": "80756",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66627,
    "description": "Larissa (2015) / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006627,
    "auth_name": "IAU_2015",
    "auth_id": "80757",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66628,
    "description": "Larissa (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006628,
    "auth_name": "IAU_2015",
    "auth_id": "80760",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66629,
    "description": "Larissa (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006629,
    "auth_name": "IAU_2015",
    "auth_id": "80761",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66630,
    "description": "Larissa (2015) / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006630,
    "auth_name": "IAU_2015",
    "auth_id": "80762",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66631,
    "description": "Larissa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006631,
    "auth_name": "IAU_2015",
    "auth_id": "80765",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66632,
    "description": "Larissa (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006632,
    "auth_name": "IAU_2015",
    "auth_id": "80766",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66633,
    "description": "Larissa (2015) / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006633,
    "auth_name": "IAU_2015",
    "auth_id": "80767",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66634,
    "description": "Larissa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006634,
    "auth_name": "IAU_2015",
    "auth_id": "80770",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66635,
    "description": "Larissa (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006635,
    "auth_name": "IAU_2015",
    "auth_id": "80771",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66636,
    "description": "Larissa (2015) / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006636,
    "auth_name": "IAU_2015",
    "auth_id": "80772",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66637,
    "description": "Larissa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006637,
    "auth_name": "IAU_2015",
    "auth_id": "80775",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66638,
    "description": "Larissa (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006638,
    "auth_name": "IAU_2015",
    "auth_id": "80776",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66639,
    "description": "Larissa (2015) / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006639,
    "auth_name": "IAU_2015",
    "auth_id": "80777",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66640,
    "description": "Larissa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006640,
    "auth_name": "IAU_2015",
    "auth_id": "80780",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66641,
    "description": "Larissa (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006641,
    "auth_name": "IAU_2015",
    "auth_id": "80781",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66642,
    "description": "Larissa (2015) / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006642,
    "auth_name": "IAU_2015",
    "auth_id": "80782",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66643,
    "description": "Larissa (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520006643,
    "auth_name": "IAU_2015",
    "auth_id": "80785",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66644,
    "description": "Larissa (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006644,
    "auth_name": "IAU_2015",
    "auth_id": "80786",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66645,
    "description": "Larissa (2015) / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520006645,
    "auth_name": "IAU_2015",
    "auth_id": "80787",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66646,
    "description": "Proteus (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=208000 +no_defs",
    "srid": 520006646,
    "auth_name": "IAU_2015",
    "auth_id": "80800",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66647,
    "description": "Proteus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006647,
    "auth_name": "IAU_2015",
    "auth_id": "80810",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66648,
    "description": "Proteus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006648,
    "auth_name": "IAU_2015",
    "auth_id": "80815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66649,
    "description": "Proteus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006649,
    "auth_name": "IAU_2015",
    "auth_id": "80820",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66650,
    "description": "Proteus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006650,
    "auth_name": "IAU_2015",
    "auth_id": "80825",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66651,
    "description": "Proteus (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006651,
    "auth_name": "IAU_2015",
    "auth_id": "80830",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66652,
    "description": "Proteus (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006652,
    "auth_name": "IAU_2015",
    "auth_id": "80835",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66653,
    "description": "Proteus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006653,
    "auth_name": "IAU_2015",
    "auth_id": "80840",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66654,
    "description": "Proteus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006654,
    "auth_name": "IAU_2015",
    "auth_id": "80845",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66655,
    "description": "Proteus (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006655,
    "auth_name": "IAU_2015",
    "auth_id": "80850",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66656,
    "description": "Proteus (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006656,
    "auth_name": "IAU_2015",
    "auth_id": "80855",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66657,
    "description": "Proteus (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006657,
    "auth_name": "IAU_2015",
    "auth_id": "80860",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66658,
    "description": "Proteus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006658,
    "auth_name": "IAU_2015",
    "auth_id": "80865",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66659,
    "description": "Proteus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006659,
    "auth_name": "IAU_2015",
    "auth_id": "80870",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66660,
    "description": "Proteus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006660,
    "auth_name": "IAU_2015",
    "auth_id": "80875",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66661,
    "description": "Proteus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006661,
    "auth_name": "IAU_2015",
    "auth_id": "80880",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66662,
    "description": "Proteus (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520006662,
    "auth_name": "IAU_2015",
    "auth_id": "80885",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66663,
    "description": "Neptune (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=24764000 +no_defs",
    "srid": 520006663,
    "auth_name": "IAU_2015",
    "auth_id": "89900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66664,
    "description": "Neptune (2015) / Ographic",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=24764000 +b=24341000 +no_defs",
    "srid": 520006664,
    "auth_name": "IAU_2015",
    "auth_id": "89901",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66665,
    "description": "Neptune (2015) / Ocentric",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "",
    "srid": 520006665,
    "auth_name": "IAU_2015",
    "auth_id": "89902",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geodetic"
  },
  {
    "srs_id": 66666,
    "description": "Neptune (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006666,
    "auth_name": "IAU_2015",
    "auth_id": "89910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66667,
    "description": "Neptune (2015) / Ographic / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006667,
    "auth_name": "IAU_2015",
    "auth_id": "89911",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66668,
    "description": "Neptune (2015) / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006668,
    "auth_name": "IAU_2015",
    "auth_id": "89912",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66669,
    "description": "Neptune (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006669,
    "auth_name": "IAU_2015",
    "auth_id": "89915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66670,
    "description": "Neptune (2015) / Ographic / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006670,
    "auth_name": "IAU_2015",
    "auth_id": "89916",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66671,
    "description": "Neptune (2015) / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006671,
    "auth_name": "IAU_2015",
    "auth_id": "89917",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66672,
    "description": "Neptune (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006672,
    "auth_name": "IAU_2015",
    "auth_id": "89920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66673,
    "description": "Neptune (2015) / Ographic / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006673,
    "auth_name": "IAU_2015",
    "auth_id": "89921",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66674,
    "description": "Neptune (2015) / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006674,
    "auth_name": "IAU_2015",
    "auth_id": "89922",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66675,
    "description": "Neptune (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006675,
    "auth_name": "IAU_2015",
    "auth_id": "89925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66676,
    "description": "Neptune (2015) / Ographic / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006676,
    "auth_name": "IAU_2015",
    "auth_id": "89926",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66677,
    "description": "Neptune (2015) / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006677,
    "auth_name": "IAU_2015",
    "auth_id": "89927",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66678,
    "description": "Neptune (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006678,
    "auth_name": "IAU_2015",
    "auth_id": "89930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66679,
    "description": "Neptune (2015) / Ographic / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006679,
    "auth_name": "IAU_2015",
    "auth_id": "89931",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66680,
    "description": "Neptune (2015) / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006680,
    "auth_name": "IAU_2015",
    "auth_id": "89932",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66681,
    "description": "Neptune (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006681,
    "auth_name": "IAU_2015",
    "auth_id": "89935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66682,
    "description": "Neptune (2015) / Ographic / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006682,
    "auth_name": "IAU_2015",
    "auth_id": "89936",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66683,
    "description": "Neptune (2015) / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006683,
    "auth_name": "IAU_2015",
    "auth_id": "89937",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66684,
    "description": "Neptune (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006684,
    "auth_name": "IAU_2015",
    "auth_id": "89940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66685,
    "description": "Neptune (2015) / Ographic / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006685,
    "auth_name": "IAU_2015",
    "auth_id": "89941",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66686,
    "description": "Neptune (2015) / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006686,
    "auth_name": "IAU_2015",
    "auth_id": "89942",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66687,
    "description": "Neptune (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006687,
    "auth_name": "IAU_2015",
    "auth_id": "89945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66688,
    "description": "Neptune (2015) / Ographic / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006688,
    "auth_name": "IAU_2015",
    "auth_id": "89946",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66689,
    "description": "Neptune (2015) / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006689,
    "auth_name": "IAU_2015",
    "auth_id": "89947",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66690,
    "description": "Neptune (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006690,
    "auth_name": "IAU_2015",
    "auth_id": "89950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66691,
    "description": "Neptune (2015) / Ographic / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006691,
    "auth_name": "IAU_2015",
    "auth_id": "89951",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66692,
    "description": "Neptune (2015) / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006692,
    "auth_name": "IAU_2015",
    "auth_id": "89952",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66693,
    "description": "Neptune (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006693,
    "auth_name": "IAU_2015",
    "auth_id": "89955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66694,
    "description": "Neptune (2015) / Ographic / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006694,
    "auth_name": "IAU_2015",
    "auth_id": "89956",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66695,
    "description": "Neptune (2015) / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006695,
    "auth_name": "IAU_2015",
    "auth_id": "89957",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66696,
    "description": "Neptune (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006696,
    "auth_name": "IAU_2015",
    "auth_id": "89960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66697,
    "description": "Neptune (2015) / Ographic / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006697,
    "auth_name": "IAU_2015",
    "auth_id": "89961",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66698,
    "description": "Neptune (2015) / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006698,
    "auth_name": "IAU_2015",
    "auth_id": "89962",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66699,
    "description": "Neptune (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006699,
    "auth_name": "IAU_2015",
    "auth_id": "89965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66700,
    "description": "Neptune (2015) / Ographic / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006700,
    "auth_name": "IAU_2015",
    "auth_id": "89966",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66701,
    "description": "Neptune (2015) / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006701,
    "auth_name": "IAU_2015",
    "auth_id": "89967",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66702,
    "description": "Neptune (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006702,
    "auth_name": "IAU_2015",
    "auth_id": "89970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66703,
    "description": "Neptune (2015) / Ographic / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006703,
    "auth_name": "IAU_2015",
    "auth_id": "89971",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66704,
    "description": "Neptune (2015) / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006704,
    "auth_name": "IAU_2015",
    "auth_id": "89972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66705,
    "description": "Neptune (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006705,
    "auth_name": "IAU_2015",
    "auth_id": "89975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66706,
    "description": "Neptune (2015) / Ographic / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006706,
    "auth_name": "IAU_2015",
    "auth_id": "89976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66707,
    "description": "Neptune (2015) / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006707,
    "auth_name": "IAU_2015",
    "auth_id": "89977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66708,
    "description": "Neptune (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006708,
    "auth_name": "IAU_2015",
    "auth_id": "89980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66709,
    "description": "Neptune (2015) / Ographic / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006709,
    "auth_name": "IAU_2015",
    "auth_id": "89981",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66710,
    "description": "Neptune (2015) / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006710,
    "auth_name": "IAU_2015",
    "auth_id": "89982",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66711,
    "description": "Neptune (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520006711,
    "auth_name": "IAU_2015",
    "auth_id": "89985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66712,
    "description": "Neptune (2015) / Ographic / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006712,
    "auth_name": "IAU_2015",
    "auth_id": "89986",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66713,
    "description": "Neptune (2015) / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520006713,
    "auth_name": "IAU_2015",
    "auth_id": "89987",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66714,
    "description": "Charon (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=606000 +no_defs",
    "srid": 520006714,
    "auth_name": "IAU_2015",
    "auth_id": "90100",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66715,
    "description": "Charon (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006715,
    "auth_name": "IAU_2015",
    "auth_id": "90110",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66716,
    "description": "Charon (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006716,
    "auth_name": "IAU_2015",
    "auth_id": "90115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66717,
    "description": "Charon (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006717,
    "auth_name": "IAU_2015",
    "auth_id": "90120",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66718,
    "description": "Charon (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006718,
    "auth_name": "IAU_2015",
    "auth_id": "90125",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66719,
    "description": "Charon (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006719,
    "auth_name": "IAU_2015",
    "auth_id": "90130",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66720,
    "description": "Charon (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006720,
    "auth_name": "IAU_2015",
    "auth_id": "90135",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66721,
    "description": "Charon (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006721,
    "auth_name": "IAU_2015",
    "auth_id": "90140",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66722,
    "description": "Charon (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006722,
    "auth_name": "IAU_2015",
    "auth_id": "90145",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66723,
    "description": "Charon (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006723,
    "auth_name": "IAU_2015",
    "auth_id": "90150",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66724,
    "description": "Charon (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006724,
    "auth_name": "IAU_2015",
    "auth_id": "90155",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66725,
    "description": "Charon (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006725,
    "auth_name": "IAU_2015",
    "auth_id": "90160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66726,
    "description": "Charon (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006726,
    "auth_name": "IAU_2015",
    "auth_id": "90165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66727,
    "description": "Charon (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006727,
    "auth_name": "IAU_2015",
    "auth_id": "90170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66728,
    "description": "Charon (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006728,
    "auth_name": "IAU_2015",
    "auth_id": "90175",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66729,
    "description": "Charon (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006729,
    "auth_name": "IAU_2015",
    "auth_id": "90180",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66730,
    "description": "Charon (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520006730,
    "auth_name": "IAU_2015",
    "auth_id": "90185",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66731,
    "description": "Gaspra (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=6100 +no_defs",
    "srid": 520006731,
    "auth_name": "IAU_2015",
    "auth_id": "951101000",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66732,
    "description": "Gaspra (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006732,
    "auth_name": "IAU_2015",
    "auth_id": "951101010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66733,
    "description": "Gaspra (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006733,
    "auth_name": "IAU_2015",
    "auth_id": "951101015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66734,
    "description": "Gaspra (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006734,
    "auth_name": "IAU_2015",
    "auth_id": "951101020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66735,
    "description": "Gaspra (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006735,
    "auth_name": "IAU_2015",
    "auth_id": "951101025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66736,
    "description": "Gaspra (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006736,
    "auth_name": "IAU_2015",
    "auth_id": "951101030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66737,
    "description": "Gaspra (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006737,
    "auth_name": "IAU_2015",
    "auth_id": "951101035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66738,
    "description": "Gaspra (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006738,
    "auth_name": "IAU_2015",
    "auth_id": "951101040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66739,
    "description": "Gaspra (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006739,
    "auth_name": "IAU_2015",
    "auth_id": "951101045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66740,
    "description": "Gaspra (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006740,
    "auth_name": "IAU_2015",
    "auth_id": "951101050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66741,
    "description": "Gaspra (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006741,
    "auth_name": "IAU_2015",
    "auth_id": "951101055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66742,
    "description": "Gaspra (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006742,
    "auth_name": "IAU_2015",
    "auth_id": "951101060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66743,
    "description": "Gaspra (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006743,
    "auth_name": "IAU_2015",
    "auth_id": "951101065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66744,
    "description": "Gaspra (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006744,
    "auth_name": "IAU_2015",
    "auth_id": "951101070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66745,
    "description": "Gaspra (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006745,
    "auth_name": "IAU_2015",
    "auth_id": "951101075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66746,
    "description": "Gaspra (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006746,
    "auth_name": "IAU_2015",
    "auth_id": "951101080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66747,
    "description": "Gaspra (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520006747,
    "auth_name": "IAU_2015",
    "auth_id": "951101085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66748,
    "description": "Pluto (2015) - Sphere / Ocentric",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=1188300 +no_defs",
    "srid": 520006748,
    "auth_name": "IAU_2015",
    "auth_id": "99900",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66749,
    "description": "Pluto (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006749,
    "auth_name": "IAU_2015",
    "auth_id": "99910",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66750,
    "description": "Pluto (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
    "projection_acronym": "eqc",
    "ellipsoid_acronym": "eqc",
    "parameters": "+proj=eqc +lat_ts=0 +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006750,
    "auth_name": "IAU_2015",
    "auth_id": "99915",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66751,
    "description": "Pluto (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006751,
    "auth_name": "IAU_2015",
    "auth_id": "99920",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66752,
    "description": "Pluto (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
    "projection_acronym": "sinu",
    "ellipsoid_acronym": "sinu",
    "parameters": "+proj=sinu +lon_0=180 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006752,
    "auth_name": "IAU_2015",
    "auth_id": "99925",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66753,
    "description": "Pluto (2015) - Sphere / Ocentric / North Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006753,
    "auth_name": "IAU_2015",
    "auth_id": "99930",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66754,
    "description": "Pluto (2015) - Sphere / Ocentric / South Polar",
    "projection_acronym": "stere",
    "ellipsoid_acronym": "stere",
    "parameters": "+proj=stere +lat_0=-90 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006754,
    "auth_name": "IAU_2015",
    "auth_id": "99935",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66755,
    "description": "Pluto (2015) - Sphere / Ocentric / Mollweide, clon = 0",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006755,
    "auth_name": "IAU_2015",
    "auth_id": "99940",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66756,
    "description": "Pluto (2015) - Sphere / Ocentric / Mollweide, clon = 180",
    "projection_acronym": "moll",
    "ellipsoid_acronym": "moll",
    "parameters": "+proj=moll +lon_0=180 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006756,
    "auth_name": "IAU_2015",
    "auth_id": "99945",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66757,
    "description": "Pluto (2015) - Sphere / Ocentric / Robinson, clon = 0",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006757,
    "auth_name": "IAU_2015",
    "auth_id": "99950",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66758,
    "description": "Pluto (2015) - Sphere / Ocentric / Robinson, clon = 180",
    "projection_acronym": "robin",
    "ellipsoid_acronym": "robin",
    "parameters": "+proj=robin +lon_0=180 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006758,
    "auth_name": "IAU_2015",
    "auth_id": "99955",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66759,
    "description": "Pluto (2015) - Sphere / Ocentric / Tranverse Mercator",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=0 +k=1 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006759,
    "auth_name": "IAU_2015",
    "auth_id": "99960",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66760,
    "description": "Pluto (2015) - Sphere / Ocentric / Orthographic, clon = 0",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006760,
    "auth_name": "IAU_2015",
    "auth_id": "99965",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66761,
    "description": "Pluto (2015) - Sphere / Ocentric / Orthographic, clon = 180",
    "projection_acronym": "ortho",
    "ellipsoid_acronym": "ortho",
    "parameters": "+proj=ortho +lat_0=0 +lon_0=180 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006761,
    "auth_name": "IAU_2015",
    "auth_id": "99970",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66762,
    "description": "Pluto (2015) - Sphere / Ocentric / Lambert Conic Conformal",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006762,
    "auth_name": "IAU_2015",
    "auth_id": "99975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66763,
    "description": "Pluto (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
    "projection_acronym": "laea",
    "ellipsoid_acronym": "laea",
    "parameters": "+proj=laea +lat_0=40 +lon_0=0 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006763,
    "auth_name": "IAU_2015",
    "auth_id": "99980",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66764,
    "description": "Pluto (2015) - Sphere / Ocentric / Albers Equal Area",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=40 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520006764,
    "auth_name": "IAU_2015",
    "auth_id": "99985",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66803,
    "description": "WGS 84 longitude-latitude-height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +datum=WGS84 +no_defs",
    "srid": 520006803,
    "auth_name": "OGC",
    "auth_id": "CRS84h",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66806,
    "description": "ETRS89 + MSL UK & Ireland VORF08 depth",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520006806,
    "auth_name": "EPSG",
    "auth_id": "10156",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66807,
    "description": "ETRS89 + CD UK & Ireland VORF08 depth",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520006807,
    "auth_name": "EPSG",
    "auth_id": "10157",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66808,
    "description": "S34J-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520006808,
    "auth_name": "EPSG",
    "auth_id": "10158",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66809,
    "description": "S34J reconstruction east-orientated",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=10.37 +k=1 +x_0=-210327 +y_0=-6034310 +ellps=intl +units=m +no_defs",
    "srid": 520006809,
    "auth_name": "EPSG",
    "auth_id": "10160",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66810,
    "description": "JGD2011 / Japan Plane Rectangular CS I + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=129.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006810,
    "auth_name": "EPSG",
    "auth_id": "10162",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66811,
    "description": "JGD2011 / Japan Plane Rectangular CS II + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=131 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006811,
    "auth_name": "EPSG",
    "auth_id": "10163",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66812,
    "description": "JGD2011 / Japan Plane Rectangular CS III + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=132.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006812,
    "auth_name": "EPSG",
    "auth_id": "10164",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66813,
    "description": "JGD2011 / Japan Plane Rectangular CS IV + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=33 +lon_0=133.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006813,
    "auth_name": "EPSG",
    "auth_id": "10165",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66814,
    "description": "JGD2011 / Japan Plane Rectangular CS V + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=134.333333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006814,
    "auth_name": "EPSG",
    "auth_id": "10166",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66815,
    "description": "JGD2011 / Japan Plane Rectangular CS VI + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=136 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006815,
    "auth_name": "EPSG",
    "auth_id": "10167",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66816,
    "description": "JGD2011 / Japan Plane Rectangular CS VII + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=137.166666666667 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006816,
    "auth_name": "EPSG",
    "auth_id": "10168",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66817,
    "description": "JGD2011 / Japan Plane Rectangular CS VIII + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=138.5 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006817,
    "auth_name": "EPSG",
    "auth_id": "10169",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66818,
    "description": "JGD2011 / Japan Plane Rectangular CS IX + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=36 +lon_0=139.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006818,
    "auth_name": "EPSG",
    "auth_id": "10170",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66819,
    "description": "JGD2011 / Japan Plane Rectangular CS X + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=40 +lon_0=140.833333333333 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006819,
    "auth_name": "EPSG",
    "auth_id": "10171",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66820,
    "description": "JGD2011 / Japan Plane Rectangular CS XI + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=140.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006820,
    "auth_name": "EPSG",
    "auth_id": "10172",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66821,
    "description": "JGD2011 / Japan Plane Rectangular CS XII + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=142.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006821,
    "auth_name": "EPSG",
    "auth_id": "10173",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66822,
    "description": "JGD2011 / Japan Plane Rectangular CS XIII + JGD2011 (vertical) height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=44 +lon_0=144.25 +k=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520006822,
    "auth_name": "EPSG",
    "auth_id": "10174",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66823,
    "description": "DoPw22-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006823,
    "auth_name": "EPSG",
    "auth_id": "10175",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66824,
    "description": "IGS20",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520006824,
    "auth_name": "EPSG",
    "auth_id": "10176",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 66825,
    "description": "IGS20",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006825,
    "auth_name": "EPSG",
    "auth_id": "10177",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66826,
    "description": "IGS20",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006826,
    "auth_name": "EPSG",
    "auth_id": "10178",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66827,
    "description": "DoPw22 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.7 +lon_0=-4.15 +k=1 +x_0=64859.6557 +y_0=122266.5277 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006827,
    "auth_name": "EPSG",
    "auth_id": "10183",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66828,
    "description": "DoPw22 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.7 +lon_0=-4.15 +k=1 +x_0=64859.6557 +y_0=122266.5277 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006828,
    "auth_name": "EPSG",
    "auth_id": "10184",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66829,
    "description": "ShAb07-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006829,
    "auth_name": "EPSG",
    "auth_id": "10185",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66830,
    "description": "ShAb07 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.6 +lon_0=-3.35 +k=1 +x_0=56023.5377 +y_0=24567.6764 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006830,
    "auth_name": "EPSG",
    "auth_id": "10188",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66831,
    "description": "ShAb07 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.6 +lon_0=-3.35 +k=1 +x_0=56023.5377 +y_0=24567.6764 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006831,
    "auth_name": "EPSG",
    "auth_id": "10189",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66833,
    "description": "CNH22-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006833,
    "auth_name": "EPSG",
    "auth_id": "10191",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66834,
    "description": "CNH22 Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=53.25 +lon_0=-3.5 +lat_1=53.1 +lat_2=53.4 +x_0=212548.8756 +y_0=495230.9254 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006834,
    "auth_name": "EPSG",
    "auth_id": "10194",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66835,
    "description": "CNH22 Grid + ODN height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=53.25 +lon_0=-3.5 +lat_1=53.1 +lat_2=53.4 +x_0=212548.8756 +y_0=495230.9254 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006835,
    "auth_name": "EPSG",
    "auth_id": "10195",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66836,
    "description": "CWS13-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006836,
    "auth_name": "EPSG",
    "auth_id": "10196",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66837,
    "description": "CWS13 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.4 +lon_0=-2.9 +k=1 +x_0=199668.0926 +y_0=89354.3229 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006837,
    "auth_name": "EPSG",
    "auth_id": "10199",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66838,
    "description": "CWS13 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.4 +lon_0=-2.9 +k=1 +x_0=199668.0926 +y_0=89354.3229 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006838,
    "auth_name": "EPSG",
    "auth_id": "10200",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66839,
    "description": "DIBA15-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006839,
    "auth_name": "EPSG",
    "auth_id": "10204",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66840,
    "description": "DIBA15 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=51.85 +lon_0=-1.3 +k=1 +x_0=511622.854 +y_0=324737.4633 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006840,
    "auth_name": "EPSG",
    "auth_id": "10207",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66841,
    "description": "DIBA15 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=51.85 +lon_0=-1.3 +k=1 +x_0=511622.854 +y_0=324737.4633 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006841,
    "auth_name": "EPSG",
    "auth_id": "10208",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66842,
    "description": "GWPBS22-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006842,
    "auth_name": "EPSG",
    "auth_id": "10209",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66843,
    "description": "GWPBS22 Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006843,
    "auth_name": "EPSG",
    "auth_id": "10212",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66844,
    "description": "GWPBS22 Grid + ODN height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006844,
    "auth_name": "EPSG",
    "auth_id": "10213",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66845,
    "description": "GWWAB22-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006845,
    "auth_name": "EPSG",
    "auth_id": "10214",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66846,
    "description": "GWWAB22 Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006846,
    "auth_name": "EPSG",
    "auth_id": "10217",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66847,
    "description": "GWWAB22 Grid + ODN height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006847,
    "auth_name": "EPSG",
    "auth_id": "10218",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66848,
    "description": "GWWWA22-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006848,
    "auth_name": "EPSG",
    "auth_id": "10219",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66849,
    "description": "GWWWA22 Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006849,
    "auth_name": "EPSG",
    "auth_id": "10222",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66850,
    "description": "GWWWA22 Grid + ODN height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006850,
    "auth_name": "EPSG",
    "auth_id": "10223",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66851,
    "description": "MALS09-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006851,
    "auth_name": "EPSG",
    "auth_id": "10224",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66852,
    "description": "MALS09 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.2 +lon_0=-1.15 +k=1 +x_0=175262.1809 +y_0=174688.2508 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006852,
    "auth_name": "EPSG",
    "auth_id": "10227",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66853,
    "description": "MALS09 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.2 +lon_0=-1.15 +k=1 +x_0=175262.1809 +y_0=174688.2508 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006853,
    "auth_name": "EPSG",
    "auth_id": "10228",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66854,
    "description": "OxWo08-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006854,
    "auth_name": "EPSG",
    "auth_id": "10229",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66855,
    "description": "OxWo08 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=51.95 +lon_0=-1.7 +k=1 +x_0=134791.6965 +y_0=121872.5056 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006855,
    "auth_name": "EPSG",
    "auth_id": "10235",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66856,
    "description": "OxWo08 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=51.95 +lon_0=-1.7 +k=1 +x_0=134791.6965 +y_0=121872.5056 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006856,
    "auth_name": "EPSG",
    "auth_id": "10236",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66857,
    "description": "SYC20-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006857,
    "auth_name": "EPSG",
    "auth_id": "10237",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66858,
    "description": "SYC20 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.9 +lon_0=-2.6 +k=1 +x_0=110094.4312 +y_0=120623.8396 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006858,
    "auth_name": "EPSG",
    "auth_id": "10240",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66859,
    "description": "SYC20 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.9 +lon_0=-2.6 +k=1 +x_0=110094.4312 +y_0=120623.8396 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006859,
    "auth_name": "EPSG",
    "auth_id": "10241",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66860,
    "description": "Slovenia 1996 + SVS2010 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=si_gurs_SLO-VRP2016-Koper.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006860,
    "auth_name": "EPSG",
    "auth_id": "10245",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66861,
    "description": "Slovenia 1996 / Slovene National Grid + SVS2010 height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=si_gurs_SLO-VRP2016-Koper.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006861,
    "auth_name": "EPSG",
    "auth_id": "10246",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66862,
    "description": "S34S-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520006862,
    "auth_name": "EPSG",
    "auth_id": "10249",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66863,
    "description": "S34S reconstruction east-orientated",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=10.37 +k=1 +x_0=-210327 +y_0=-6034310 +ellps=intl +units=m +no_defs",
    "srid": 520006863,
    "auth_name": "EPSG",
    "auth_id": "10250",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66864,
    "description": "S45B-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=intl +no_defs",
    "srid": 520006864,
    "auth_name": "EPSG",
    "auth_id": "10252",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66865,
    "description": "S45B reconstruction east-orientated",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=55.11171 +lon_0=14.88927 +k=1 +x_0=-50000 +y_0=50000 +ellps=intl +units=m +no_defs",
    "srid": 520006865,
    "auth_name": "EPSG",
    "auth_id": "10254",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66866,
    "description": "GS-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=6377019.27 +rf=300 +no_defs",
    "srid": 520006866,
    "auth_name": "EPSG",
    "auth_id": "10256",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66867,
    "description": "GS reconstruction east-orientated",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=56 +k_0=1 +lat_0=55 +lon_0=10.37775 +x_0=0 +y_0=0 +a=6377019.27 +rf=300 +units=m +no_defs",
    "srid": 520006867,
    "auth_name": "EPSG",
    "auth_id": "10258",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66868,
    "description": "GSB-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=6377019.27 +rf=300 +no_defs",
    "srid": 520006868,
    "auth_name": "EPSG",
    "auth_id": "10260",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66869,
    "description": "GSB reconstruction east-orientated",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=56 +k_0=1 +lat_0=55 +lon_0=14.92775 +x_0=-18831.46 +y_0=5614.621 +a=6377019.27 +rf=300 +units=m +no_defs",
    "srid": 520006869,
    "auth_name": "EPSG",
    "auth_id": "10262",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66870,
    "description": "KK-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=6377019.27 +rf=300 +no_defs",
    "srid": 520006870,
    "auth_name": "EPSG",
    "auth_id": "10265",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66871,
    "description": "KK reconstruction east-orientated",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=56 +k_0=1 +lat_0=55 +lon_0=10.37775 +x_0=0 +y_0=0 +a=6377019.27 +rf=300 +units=m +no_defs",
    "srid": 520006871,
    "auth_name": "EPSG",
    "auth_id": "10266",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66872,
    "description": "Ostenfeld-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=bessel +no_defs",
    "srid": 520006872,
    "auth_name": "EPSG",
    "auth_id": "10268",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66873,
    "description": "Ostenfeld reconstruction",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=54.4685 +lon_0=9.233 +k=1 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 520006873,
    "auth_name": "EPSG",
    "auth_id": "10270",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66874,
    "description": "SMITB20-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006874,
    "auth_name": "EPSG",
    "auth_id": "10272",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66875,
    "description": "SMITB20 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=50.75 +lon_0=-3.85 +k=1 +x_0=110693.666 +y_0=102089.2943 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006875,
    "auth_name": "EPSG",
    "auth_id": "10275",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66876,
    "description": "SMITB20 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=50.75 +lon_0=-3.85 +k=1 +x_0=110693.666 +y_0=102089.2943 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006876,
    "auth_name": "EPSG",
    "auth_id": "10276",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66877,
    "description": "RBEPP12-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006877,
    "auth_name": "EPSG",
    "auth_id": "10277",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66878,
    "description": "RBEPP12 Grid",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=50.85 +lon_0=-3.25 +lat_1=50.3 +lat_2=51.45 +x_0=372382.8292 +y_0=217764.7796 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006878,
    "auth_name": "EPSG",
    "auth_id": "10280",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66879,
    "description": "RBEPP12 Grid + ODN height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=50.85 +lon_0=-3.25 +lat_1=50.3 +lat_2=51.45 +x_0=372382.8292 +y_0=217764.7796 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006879,
    "auth_name": "EPSG",
    "auth_id": "10281",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66880,
    "description": "ETRS89/DREF91/2016",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520006880,
    "auth_name": "EPSG",
    "auth_id": "10282",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 66881,
    "description": "ETRS89/DREF91/2016",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006881,
    "auth_name": "EPSG",
    "auth_id": "10283",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66882,
    "description": "ETRS89/DREF91/2016",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006882,
    "auth_name": "EPSG",
    "auth_id": "10284",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66883,
    "description": "ETRS89/DREF91/2016 / 3-degree Gauss-Kruger zone 3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006883,
    "auth_name": "EPSG",
    "auth_id": "10285",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66884,
    "description": "ETRS89/DREF91/2016 / UTM zone 31N (N-zE)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006884,
    "auth_name": "EPSG",
    "auth_id": "10286",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66885,
    "description": "ETRS89/DREF91/2016 / UTM zone 31N (zE-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=3 +k=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006885,
    "auth_name": "EPSG",
    "auth_id": "10287",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66886,
    "description": "ETRS89/DREF91/2016 / UTM zone 32N (N-zE)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006886,
    "auth_name": "EPSG",
    "auth_id": "10288",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66887,
    "description": "ETRS89/DREF91/2016 / UTM zone 32N (zE-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006887,
    "auth_name": "EPSG",
    "auth_id": "10289",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66888,
    "description": "ETRS89/DREF91/2016 / UTM zone 33N (N-zE)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006888,
    "auth_name": "EPSG",
    "auth_id": "10290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66889,
    "description": "ETRS89/DREF91/2016 / UTM zone 33N (zE-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006889,
    "auth_name": "EPSG",
    "auth_id": "10291",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66890,
    "description": "ETRS89/DREF91/2016 + DHHN2016 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +geoidgrids=de_bkg_gcg2016.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520006890,
    "auth_name": "EPSG",
    "auth_id": "10293",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66891,
    "description": "RGSH2020",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520006891,
    "auth_name": "EPSG",
    "auth_id": "10297",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 66892,
    "description": "RGSH2020",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520006892,
    "auth_name": "EPSG",
    "auth_id": "10298",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66893,
    "description": "RGSH2020",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520006893,
    "auth_name": "EPSG",
    "auth_id": "10299",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66894,
    "description": "RGNC91-93 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006894,
    "auth_name": "EPSG",
    "auth_id": "10300",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66895,
    "description": "LKS-2020",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520006895,
    "auth_name": "EPSG",
    "auth_id": "10303",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 66896,
    "description": "LKS-2020",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006896,
    "auth_name": "EPSG",
    "auth_id": "10304",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66897,
    "description": "LKS-2020",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006897,
    "auth_name": "EPSG",
    "auth_id": "10305",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66898,
    "description": "LKS-2020 / Latvia TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006898,
    "auth_name": "EPSG",
    "auth_id": "10306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66899,
    "description": "RGNC91-93 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006899,
    "auth_name": "EPSG",
    "auth_id": "10307",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66900,
    "description": "RGNC15",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520006900,
    "auth_name": "EPSG",
    "auth_id": "10308",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 66901,
    "description": "RGNC15",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520006901,
    "auth_name": "EPSG",
    "auth_id": "10309",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66902,
    "description": "RGNC15",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520006902,
    "auth_name": "EPSG",
    "auth_id": "10310",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66903,
    "description": "RGNC15 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006903,
    "auth_name": "EPSG",
    "auth_id": "10311",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66904,
    "description": "RGNC15 (lon-lat)",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006904,
    "auth_name": "EPSG",
    "auth_id": "10312",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66905,
    "description": "RGNC15 / Lambert New Caledonia 2015",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.6666666666667 +lat_2=-22.3333333333333 +x_0=2400000 +y_0=2300000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006905,
    "auth_name": "EPSG",
    "auth_id": "10314",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66906,
    "description": "RGNC15 / UTM zone 57S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=57 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006906,
    "auth_name": "EPSG",
    "auth_id": "10315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66907,
    "description": "RGNC15 / UTM zone 58S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=58 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006907,
    "auth_name": "EPSG",
    "auth_id": "10316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66908,
    "description": "RGNC15 / UTM zone 59S",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=59 +south +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006908,
    "auth_name": "EPSG",
    "auth_id": "10317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66909,
    "description": "RGNC15 (lon-lat) + NGNC08 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +vunits=m +no_defs",
    "srid": 520006909,
    "auth_name": "EPSG",
    "auth_id": "10318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 66910,
    "description": "BH_ETRS89",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520006910,
    "auth_name": "EPSG",
    "auth_id": "10326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 66911,
    "description": "BH_ETRS89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520006911,
    "auth_name": "EPSG",
    "auth_id": "10327",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66912,
    "description": "BH_ETRS89",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520006912,
    "auth_name": "EPSG",
    "auth_id": "10328",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66913,
    "description": "BH_ETRS89 / TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006913,
    "auth_name": "EPSG",
    "auth_id": "10329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66914,
    "description": "MAGNA-SIRGAS 2018 / Colombia Far West zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=4.59620322222222 +lon_0=-80.0775077694444 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006914,
    "auth_name": "EPSG",
    "auth_id": "11114",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66915,
    "description": "MAGNA-SIRGAS 2018 / Colombia West zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=4.59620322222222 +lon_0=-77.0775077694444 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006915,
    "auth_name": "EPSG",
    "auth_id": "11115",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66916,
    "description": "MAGNA-SIRGAS 2018 / Colombia Bogota zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=4.59620322222222 +lon_0=-74.0775077694444 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006916,
    "auth_name": "EPSG",
    "auth_id": "11116",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66917,
    "description": "MAGNA-SIRGAS 2018 / Colombia East Central zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=4.59620322222222 +lon_0=-71.0775077694444 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006917,
    "auth_name": "EPSG",
    "auth_id": "11117",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66918,
    "description": "MAGNA-SIRGAS 2018 / Colombia East zone",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=4.59620322222222 +lon_0=-68.0775077694444 +k=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006918,
    "auth_name": "EPSG",
    "auth_id": "11118",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66919,
    "description": "MAGNA-SIRGAS 2018",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520006919,
    "auth_name": "EPSG",
    "auth_id": "20044",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 66920,
    "description": "MAGNA-SIRGAS 2018",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520006920,
    "auth_name": "EPSG",
    "auth_id": "20045",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 66921,
    "description": "MAGNA-SIRGAS 2018",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520006921,
    "auth_name": "EPSG",
    "auth_id": "20046",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66922,
    "description": "RGSH2020 / UTM zone 29N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=29 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006922,
    "auth_name": "EPSG",
    "auth_id": "22229",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66923,
    "description": "RGSH2020 / UTM zone 30N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006923,
    "auth_name": "EPSG",
    "auth_id": "22230",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66924,
    "description": "RGSH2020 / UTM zone 31N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006924,
    "auth_name": "EPSG",
    "auth_id": "22231",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66925,
    "description": "RGSH2020 / UTM zone 32N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006925,
    "auth_name": "EPSG",
    "auth_id": "22232",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66926,
    "description": "NAD83(2011) / ICS83-Freeport (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=42.2 +lat_0=42.2 +lon_0=-89.95 +k_0=1.000029 +x_0=549860.2997206 +y_0=230124.460248921 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006926,
    "auth_name": "EPSG",
    "auth_id": "23301",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66927,
    "description": "NAD83(2011) / ICS83-Rockford (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=41.25 +lon_0=-89.25 +k=1.000029 +x_0=860147.320294641 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006927,
    "auth_name": "EPSG",
    "auth_id": "23302",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66928,
    "description": "NAD83(2011) / ICS83-Aurora (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=41.25 +lon_0=-88.5 +k=1.00003 +x_0=1150012.7000254 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006928,
    "auth_name": "EPSG",
    "auth_id": "23303",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66929,
    "description": "NAD83(2011) / ICS83-Chicago (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=41.25 +lon_0=-87.8 +k=1.000023 +x_0=1449936.499873 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006929,
    "auth_name": "EPSG",
    "auth_id": "23304",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66930,
    "description": "NAD83(2011) / ICS83-Moline (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=41.55 +lat_0=41.55 +lon_0=-90.6 +k_0=1.000024 +x_0=1749860.2997206 +y_0=230124.460248921 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006930,
    "auth_name": "EPSG",
    "auth_id": "23305",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66931,
    "description": "NAD83(2011) / ICS83-Sterling (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=41.55 +lat_0=41.55 +lon_0=-90.05 +k_0=1.00002 +x_0=2050088.9001778 +y_0=230124.460248921 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006931,
    "auth_name": "EPSG",
    "auth_id": "23306",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66932,
    "description": "NAD83(2011) / ICS83-Ottawa (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=41.3 +lat_0=41.3 +lon_0=-89.05 +k_0=1.000023 +x_0=2360071.12014224 +y_0=230124.460248921 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006932,
    "auth_name": "EPSG",
    "auth_id": "23307",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66933,
    "description": "NAD83(2011) / ICS83-Joliet (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=40.55 +lon_0=-88 +k=1.000022 +x_0=2649936.499873 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006933,
    "auth_name": "EPSG",
    "auth_id": "23308",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66934,
    "description": "NAD83(2011) / ICS83-Monmouth (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=40.2 +lon_0=-90.85 +k=1.000024 +x_0=2949860.2997206 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006934,
    "auth_name": "EPSG",
    "auth_id": "23309",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66935,
    "description": "NAD83(2011) / ICS83-Galesburg (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=37.25 +lon_0=-90.1 +k=1.000023 +x_0=70104.1402082804 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006935,
    "auth_name": "EPSG",
    "auth_id": "23310",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66936,
    "description": "NAD83(2011) / ICS83-Peoria (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=37.4 +lon_0=-89.65 +k=1.000023 +x_0=420015.24003048 +y_0=189585.979171958 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006936,
    "auth_name": "EPSG",
    "auth_id": "23311",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66937,
    "description": "NAD83(2011) / ICS83-Eureka (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=37.45 +lon_0=-89.3 +k=1.000025 +x_0=840030.48006096 +y_0=130149.860299721 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006937,
    "auth_name": "EPSG",
    "auth_id": "23312",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66938,
    "description": "NAD83(2011) / ICS83-Bloomington (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=40.5 +lat_0=40.5 +lon_0=-88.85 +k_0=1.000031 +x_0=1150012.7000254 +y_0=530048.26009652 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006938,
    "auth_name": "EPSG",
    "auth_id": "23313",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66939,
    "description": "NAD83(2011) / ICS83-Pontiac (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=40.9 +lat_0=40.9 +lon_0=-88.55 +k_0=1.000025 +x_0=1449936.499873 +y_0=530048.26009652 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006939,
    "auth_name": "EPSG",
    "auth_id": "23314",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66940,
    "description": "NAD83(2011) / ICS83-Watseka (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=40.75 +lat_0=40.75 +lon_0=-87.95 +k_0=1.000024 +x_0=1749860.2997206 +y_0=530048.26009652 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006940,
    "auth_name": "EPSG",
    "auth_id": "23315",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66941,
    "description": "NAD83(2011) / ICS83-Quincy (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=36.75 +lon_0=-91.25 +k=1.000023 +x_0=2050088.9001778 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006941,
    "auth_name": "EPSG",
    "auth_id": "23316",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66942,
    "description": "NAD83(2011) / ICS83-Macomb (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=36.8 +lon_0=-90.6 +k=1.000024 +x_0=2350012.7000254 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006942,
    "auth_name": "EPSG",
    "auth_id": "23317",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66943,
    "description": "NAD83(2011) / ICS83-Lincoln (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=40.15 +lat_0=40.15 +lon_0=-89.8 +k_0=1.000018 +x_0=2670053.34010668 +y_0=530048.26009652 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006943,
    "auth_name": "EPSG",
    "auth_id": "23318",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66944,
    "description": "NAD83(2011) / ICS83-Decatur (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=36.3 +lon_0=-88.8 +k=1.000024 +x_0=2949860.2997206 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006944,
    "auth_name": "EPSG",
    "auth_id": "23319",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66945,
    "description": "NAD83(2011) / ICS83-Champaign (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=40.15 +lat_0=40.15 +lon_0=-88 +k_0=1.000026 +x_0=99974.5999491999 +y_0=860147.320294641 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006945,
    "auth_name": "EPSG",
    "auth_id": "23320",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66946,
    "description": "NAD83(2011) / ICS83-Jacksonville (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=39.65 +lat_0=39.65 +lon_0=-90.6 +k_0=1.000023 +x_0=380086.36017272 +y_0=860147.320294641 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006946,
    "auth_name": "EPSG",
    "auth_id": "23321",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66947,
    "description": "NAD83(2011) / ICS83-Springfield (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=39.75 +lat_0=39.75 +lon_0=-89.65 +k_0=1.000022 +x_0=709880.61976124 +y_0=879959.35991872 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006947,
    "auth_name": "EPSG",
    "auth_id": "23322",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66948,
    "description": "NAD83(2011) / ICS83-Charleston (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=39.65 +lat_0=39.65 +lon_0=-88 +k_0=1.000024 +x_0=1150012.7000254 +y_0=840030.48006096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006948,
    "auth_name": "EPSG",
    "auth_id": "23323",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66949,
    "description": "NAD83(2011) / ICS83-Jerseyville (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=32.85 +lon_0=-90.5 +k=1.000019 +x_0=1449936.499873 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006949,
    "auth_name": "EPSG",
    "auth_id": "23324",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66950,
    "description": "NAD83(2011) / ICS83-Carlinville (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=39.3 +lat_0=39.3 +lon_0=-90.15 +k_0=1.00002 +x_0=1749860.2997206 +y_0=840030.48006096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006950,
    "auth_name": "EPSG",
    "auth_id": "23325",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66951,
    "description": "NAD83(2011) / ICS83-Taylorville (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=33.15 +lon_0=-89.4 +k=1.000023 +x_0=2050088.9001778 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006951,
    "auth_name": "EPSG",
    "auth_id": "23326",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66952,
    "description": "NAD83(2011) / ICS83-Effingham (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=38.95 +lat_0=38.95 +lon_0=-89 +k_0=1.000019 +x_0=2350012.7000254 +y_0=840030.48006096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006952,
    "auth_name": "EPSG",
    "auth_id": "23327",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66953,
    "description": "NAD83(2011) / ICS83-Robinson (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=39.1 +lat_0=39.1 +lon_0=-88 +k_0=1.000017 +x_0=2649936.499873 +y_0=840030.48006096 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006953,
    "auth_name": "EPSG",
    "auth_id": "23328",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66954,
    "description": "NAD83(2011) / ICS83-Belleville (ftUS)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=32.35 +lon_0=-90 +k=1.000016 +x_0=2949860.2997206 +y_0=149961.8999238 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006954,
    "auth_name": "EPSG",
    "auth_id": "23329",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66955,
    "description": "NAD83(2011) / ICS83-Mount Vernon (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=38.45 +lat_0=38.45 +lon_0=-89.15 +k_0=1.000015 +x_0=99974.5999491999 +y_0=1150012.7000254 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006955,
    "auth_name": "EPSG",
    "auth_id": "23330",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66956,
    "description": "NAD83(2011) / ICS83-Olney (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=38.55 +lat_0=38.55 +lon_0=-88.15 +k_0=1.000013 +x_0=380086.36017272 +y_0=1150012.7000254 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006956,
    "auth_name": "EPSG",
    "auth_id": "23331",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66957,
    "description": "NAD83(2011) / ICS83-Carbondale (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=37.9 +lat_0=37.9 +lon_0=-88.95 +k_0=1.000012 +x_0=729997.45999492 +y_0=1150012.7000254 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006957,
    "auth_name": "EPSG",
    "auth_id": "23332",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66958,
    "description": "NAD83(2011) / ICS83-Metropolis (ftUS)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=37.2 +lat_0=37.2 +lon_0=-88.9 +k_0=1.00001 +x_0=1110083.82016764 +y_0=1170129.54025908 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520006958,
    "auth_name": "EPSG",
    "auth_id": "23333",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66959,
    "description": "LTF2004(C)",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_1=44.3791666666667 +k_0=1 +lat_0=45.1833333333333 +lon_0=6.81666666666667 +x_0=150000 +y_0=50000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006959,
    "auth_name": "EPSG",
    "auth_id": "9549",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66960,
    "description": "PANAMA_ITRF08_UTM_17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006960,
    "auth_name": "ESRI",
    "auth_id": "102731",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66961,
    "description": "PANAMA_ITRF08_UTM_18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs",
    "srid": 520006961,
    "auth_name": "ESRI",
    "auth_id": "102732",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66962,
    "description": "Hartebeesthoek94_Lo15_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006962,
    "auth_name": "ESRI",
    "auth_id": "103888",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66963,
    "description": "Hartebeesthoek94_Lo17_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=17 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006963,
    "auth_name": "ESRI",
    "auth_id": "103889",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66964,
    "description": "Hartebeesthoek94_Lo33_(E-N)",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=33 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520006964,
    "auth_name": "ESRI",
    "auth_id": "103890",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66965,
    "description": "California_SRS_Epoch_2017.50_(NAD83)_StatePlane_CA_I_US_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=39.3333333333333 +lon_0=-122 +lat_1=40 +lat_2=41.6666666666667 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 520006965,
    "auth_name": "ESRI",
    "auth_id": "103891",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66966,
    "description": "California_SRS_Epoch_2017.50_(NAD83)_StatePlane_CA_II_US_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=37.6666666666667 +lon_0=-122 +lat_1=38.3333333333333 +lat_2=39.8333333333333 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 520006966,
    "auth_name": "ESRI",
    "auth_id": "103892",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66967,
    "description": "California_SRS_Epoch_2017.50_(NAD83)_StatePlane_CA_III_US_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=37.0666666666667 +lat_2=38.4333333333333 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 520006967,
    "auth_name": "ESRI",
    "auth_id": "103893",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66968,
    "description": "California_SRS_Epoch_2017.50_(NAD83)_StatePlane_CA_IV_US_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=35.3333333333333 +lon_0=-119 +lat_1=36 +lat_2=37.25 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 520006968,
    "auth_name": "ESRI",
    "auth_id": "103894",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66969,
    "description": "California_SRS_Epoch_2017.50_(NAD83)_StatePlane_CA_V_US_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=34.0333333333333 +lat_2=35.4666666666667 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 520006969,
    "auth_name": "ESRI",
    "auth_id": "103895",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66970,
    "description": "California_SRS_Epoch_2017.50_(NAD83)_StatePlane_CA_VI_US_Feet",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=32.1666666666667 +lon_0=-116.25 +lat_1=32.7833333333333 +lat_2=33.8833333333333 +x_0=2000000 +y_0=500000.000000001 +ellps=GRS80 +units=us-ft +no_defs",
    "srid": 520006970,
    "auth_name": "ESRI",
    "auth_id": "103896",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66971,
    "description": "Germany_Zone_1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=3 +k=1 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
    "srid": 520006971,
    "auth_name": "ESRI",
    "auth_id": "103972",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66972,
    "description": "Germany_Zone_2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=6 +k=1 +x_0=2500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 520006972,
    "auth_name": "ESRI",
    "auth_id": "103973",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66973,
    "description": "Germany_Zone_3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=9 +k=1 +x_0=3500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 520006973,
    "auth_name": "ESRI",
    "auth_id": "103974",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66974,
    "description": "Germany_Zone_4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=1 +x_0=4500000 +y_0=0 +ellps=bessel +towgs84=598.1,73.7,418.2,0.202,0.045,-2.455,6.7 +units=m +no_defs",
    "srid": 520006974,
    "auth_name": "ESRI",
    "auth_id": "103975",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66975,
    "description": "Germany_Zone_5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=15 +k=1 +x_0=5500000 +y_0=0 +ellps=bessel +towgs84=597.1,71.4,412.1,0.894,0.068,-1.563,7.58 +units=m +no_defs",
    "srid": 520006975,
    "auth_name": "ESRI",
    "auth_id": "103976",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66976,
    "description": "WGS_1984_UTM_GTM_2010",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=12 +k=0.9996 +x_0=500000 +y_0=500000 +datum=WGS84 +units=m +no_defs",
    "srid": 520006976,
    "auth_name": "ESRI",
    "auth_id": "103977",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66977,
    "description": "GCS_PANAMA08_2011",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520006977,
    "auth_name": "ESRI",
    "auth_id": "104646",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 66978,
    "description": "OSGB36_National_Highways_A01H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999260028821883 +x_0=261910.558703157 +y_0=70975.7620913136 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006978,
    "auth_name": "ESRI",
    "auth_id": "112000",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66979,
    "description": "OSGB36_National_Highways_A02H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999313972680282 +x_0=252927.284354225 +y_0=70979.593633004 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006979,
    "auth_name": "ESRI",
    "auth_id": "112001",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66980,
    "description": "OSGB36_National_Highways_A03H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99936492500576 +x_0=243942.308403333 +y_0=70983.2126911338 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006980,
    "auth_name": "ESRI",
    "auth_id": "112002",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66981,
    "description": "OSGB36_National_Highways_A03H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999389910065825 +x_0=243948.407189748 +y_0=70984.9873380003 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006981,
    "auth_name": "ESRI",
    "auth_id": "112003",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66982,
    "description": "OSGB36_National_Highways_A04H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999414883310307 +x_0=234956.181256649 +y_0=70986.7611456259 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006982,
    "auth_name": "ESRI",
    "auth_id": "112004",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66983,
    "description": "OSGB36_National_Highways_A05H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999464846609941 +x_0=225969.155631124 +y_0=70990.3099549106 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006983,
    "auth_name": "ESRI",
    "auth_id": "112005",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66984,
    "description": "OSGB36_National_Highways_A05H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99948983416814 +x_0=225974.805071869 +y_0=70992.0847792154 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006984,
    "auth_name": "ESRI",
    "auth_id": "112006",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66985,
    "description": "OSGB36_National_Highways_A06H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999515814322282 +x_0=215981.533843434 +y_0=70993.9301059435 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006985,
    "auth_name": "ESRI",
    "auth_id": "112007",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66986,
    "description": "OSGB36_National_Highways_A06H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999540803154722 +x_0=215986.93358427 +y_0=70995.7050207555 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006986,
    "auth_name": "ESRI",
    "auth_id": "112008",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66987,
    "description": "OSGB36_National_Highways_A07H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999563788682652 +x_0=205992.275418417 +y_0=70997.3376442117 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006987,
    "auth_name": "ESRI",
    "auth_id": "112009",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66988,
    "description": "OSGB36_National_Highways_A07H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999588778714495 +x_0=205997.425418427 +y_0=70999.1126442153 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006988,
    "auth_name": "ESRI",
    "auth_id": "112010",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66989,
    "description": "OSGB36_National_Highways_A08H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999612767259319 +x_0=196002.254028371 +y_0=71000.8165102774 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006989,
    "auth_name": "ESRI",
    "auth_id": "112011",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66990,
    "description": "OSGB36_National_Highways_A08H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999637758515672 +x_0=196007.154268481 +y_0=71002.5915972559 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006990,
    "auth_name": "ESRI",
    "auth_id": "112012",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66991,
    "description": "OSGB36_National_Highways_A09H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999661750636116 +x_0=185011.193066174 +y_0=71004.2957172883 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006991,
    "auth_name": "ESRI",
    "auth_id": "112013",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66992,
    "description": "OSGB36_National_Highways_A09H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996867431171 +x_0=185015.818519455 +y_0=71006.0708912503 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006992,
    "auth_name": "ESRI",
    "auth_id": "112014",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66993,
    "description": "OSGB36_National_Highways_A10H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999712738433191 +x_0=173019.291436884 +y_0=71007.9172949061 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006993,
    "auth_name": "ESRI",
    "auth_id": "112015",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66994,
    "description": "OSGB36_National_Highways_A10H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999737732188918 +x_0=173023.617081381 +y_0=71009.6925594109 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006994,
    "auth_name": "ESRI",
    "auth_id": "112016",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66995,
    "description": "OSGB36_National_Highways_A11H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999766731181957 +x_0=159026.318551582 +y_0=71011.7523091972 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006995,
    "auth_name": "ESRI",
    "auth_id": "112017",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66996,
    "description": "OSGB36_National_Highways_A11H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999791726287553 +x_0=159030.294358639 +y_0=71013.5276695809 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006996,
    "auth_name": "ESRI",
    "auth_id": "112018",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66997,
    "description": "OSGB36_National_Highways_A11H3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999816722642982 +x_0=159034.270364498 +y_0=71015.3031187382 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006997,
    "auth_name": "ESRI",
    "auth_id": "112019",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66998,
    "description": "OSGB36_National_Highways_A12H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999816729668208 +x_0=144031.03832328 +y_0=71015.3036177283 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006998,
    "auth_name": "ESRI",
    "auth_id": "112020",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 66999,
    "description": "OSGB36_National_Highways_A12H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999841726023814 +x_0=144034.639234272 +y_0=71017.0790668981 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520006999,
    "auth_name": "ESRI",
    "auth_id": "112021",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67000,
    "description": "OSGB36_National_Highways_A12H3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999866723629314 +x_0=144038.240325321 +y_0=71018.8546048459 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007000,
    "auth_name": "ESRI",
    "auth_id": "112022",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67001,
    "description": "OSGB36_National_Highways_A13H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999864732920049 +x_0=128033.736487859 +y_0=71018.7132081091 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007001,
    "auth_name": "ESRI",
    "auth_id": "112023",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67002,
    "description": "OSGB36_National_Highways_A13H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99988973047578 +x_0=128036.937451307 +y_0=71020.4887425219 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007002,
    "auth_name": "ESRI",
    "auth_id": "112024",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67003,
    "description": "OSGB36_National_Highways_A14H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999913740994384 +x_0=111034.697926722 +y_0=71022.1941693447 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007003,
    "auth_name": "ESRI",
    "auth_id": "112025",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67004,
    "description": "OSGB36_National_Highways_A14H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999938739775363 +x_0=111037.473898269 +y_0=71023.9697907847 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007004,
    "auth_name": "ESRI",
    "auth_id": "112026",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67005,
    "description": "OSGB36_National_Highways_A15H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999966755136649 +x_0=88032.1753716564 +y_0=71025.9596748591 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007005,
    "auth_name": "ESRI",
    "auth_id": "112027",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67006,
    "description": "OSGB36_National_Highways_A15H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999991755243032 +x_0=88034.3762585739 +y_0=71027.7353904403 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007006,
    "auth_name": "ESRI",
    "auth_id": "112028",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67007,
    "description": "OSGB36_National_Highways_A16H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00001177155717 +x_0=54022.1758344197 +y_0=71029.1571156259 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007007,
    "auth_name": "ESRI",
    "auth_id": "112029",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67008,
    "description": "OSGB36_National_Highways_A16H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000036772789 +x_0=54023.5264394632 +y_0=71030.9329111461 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007008,
    "auth_name": "ESRI",
    "auth_id": "112030",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67009,
    "description": "OSGB36_National_Highways_A17H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999980759810937 +x_0=-24009.1113476146 +y_0=71026.9544033599 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007009,
    "auth_name": "ESRI",
    "auth_id": "112031",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67010,
    "description": "OSGB36_National_Highways_A17H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00000576026745 +x_0=-24009.7115979077 +y_0=71028.7301438103 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007010,
    "auth_name": "ESRI",
    "auth_id": "112032",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67011,
    "description": "OSGB36_National_Highways_A18H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99992774418376 +x_0=-58018.9429571512 +y_0=71023.1887923747 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007011,
    "auth_name": "ESRI",
    "auth_id": "112033",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67012,
    "description": "OSGB36_National_Highways_A18H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999952743314832 +x_0=-58020.3934851199 +y_0=71024.9644386812 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007012,
    "auth_name": "ESRI",
    "auth_id": "112034",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67013,
    "description": "OSGB36_National_Highways_A19H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999873734042937 +x_0=-88023.9862501752 +y_0=71019.352542755 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007013,
    "auth_name": "ESRI",
    "auth_id": "112035",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67014,
    "description": "OSGB36_National_Highways_A19H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999898731823705 +x_0=-88026.1869323571 +y_0=71021.1280931517 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007014,
    "auth_name": "ESRI",
    "auth_id": "112036",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67015,
    "description": "OSGB36_National_Highways_A20H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99982572992683 +x_0=-105023.57751484 +y_0=71015.9428909868 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007015,
    "auth_name": "ESRI",
    "auth_id": "112037",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67016,
    "description": "OSGB36_National_Highways_A20H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99985072650745 +x_0=-105026.203202741 +y_0=71017.718356139 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007016,
    "auth_name": "ESRI",
    "auth_id": "112038",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67017,
    "description": "OSGB36_National_Highways_A21H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999770730876833 +x_0=-122020.682266179 +y_0=71012.0364008088 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007017,
    "auth_name": "ESRI",
    "auth_id": "112039",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67018,
    "description": "OSGB36_National_Highways_A21H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999795726082426 +x_0=-122023.732897634 +y_0=71013.8117682951 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007018,
    "auth_name": "ESRI",
    "auth_id": "112040",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67019,
    "description": "OSGB36_National_Highways_A22H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999707739399589 +x_0=-139014.804913381 +y_0=71007.5622219427 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007019,
    "auth_name": "ESRI",
    "auth_id": "112041",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67020,
    "description": "OSGB36_National_Highways_A22H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999732733030336 +x_0=-139018.280413835 +y_0=71009.3374775704 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007020,
    "auth_name": "ESRI",
    "auth_id": "112042",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67021,
    "description": "OSGB36_National_Highways_A23H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999655752413687 +x_0=-156008.502381475 +y_0=71003.8696736202 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007021,
    "auth_name": "ESRI",
    "auth_id": "112043",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67022,
    "description": "OSGB36_National_Highways_A23H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99968074474471 +x_0=-156012.402740298 +y_0=71005.6448369306 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007022,
    "auth_name": "ESRI",
    "auth_id": "112044",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67023,
    "description": "OSGB36_National_Highways_A24H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999612767259319 +x_0=-165001.897523884 +y_0=71000.8165102774 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007023,
    "auth_name": "ESRI",
    "auth_id": "112045",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67024,
    "description": "OSGB36_National_Highways_A24H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999637758515672 +x_0=-165006.022726017 +y_0=71002.5915972559 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007024,
    "auth_name": "ESRI",
    "auth_id": "112046",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67025,
    "description": "OSGB36_National_Highways_A25H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999564788197464 +x_0=-175993.57634226 +y_0=70997.4086380706 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007025,
    "auth_name": "ESRI",
    "auth_id": "112047",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67026,
    "description": "OSGB36_National_Highways_A25H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999589778254297 +x_0=-175997.976346668 +y_0=70999.1836398491 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007026,
    "auth_name": "ESRI",
    "auth_id": "112048",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67027,
    "description": "OSGB36_National_Highways_A26H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999516813741153 +x_0=-185984.284553461 +y_0=70994.0010929879 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007027,
    "auth_name": "ESRI",
    "auth_id": "112049",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67028,
    "description": "OSGB36_National_Highways_A26H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999541802598579 +x_0=-185988.934334942 +y_0=70995.7760095746 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007028,
    "auth_name": "ESRI",
    "auth_id": "112050",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67029,
    "description": "OSGB36_National_Highways_A27H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999466845245835 +x_0=-195973.641905265 +y_0=70990.4519146624 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007029,
    "auth_name": "ESRI",
    "auth_id": "112051",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67030,
    "description": "OSGB36_National_Highways_A27H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999491832854001 +x_0=-195978.541430045 +y_0=70992.2267425163 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007030,
    "auth_name": "ESRI",
    "auth_id": "112052",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67031,
    "description": "OSGB36_National_Highways_A28H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999415882527346 +x_0=-205961.794596858 +y_0=70986.8321183345 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007031,
    "auth_name": "ESRI",
    "auth_id": "112053",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67032,
    "description": "OSGB36_National_Highways_A28H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999440868861396 +x_0=-205966.943834819 +y_0=70988.6068556901 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007032,
    "auth_name": "ESRI",
    "auth_id": "112054",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67033,
    "description": "OSGB36_National_Highways_A29H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999365924122903 +x_0=-214949.380087332 +y_0=70983.283656747 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007033,
    "auth_name": "ESRI",
    "auth_id": "112055",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67034,
    "description": "OSGB36_National_Highways_A30H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999313972680282 +x_0=-223935.619349196 +y_0=70979.593633004 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007034,
    "auth_name": "ESRI",
    "auth_id": "112056",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67035,
    "description": "OSGB36_National_Highways_B15H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999966755136649 +x_0=88032.1753716564 +y_0=111040.584843794 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007035,
    "auth_name": "ESRI",
    "auth_id": "112057",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67036,
    "description": "OSGB36_National_Highways_B15H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999991755243032 +x_0=88034.3762585739 +y_0=111043.360962519 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007036,
    "auth_name": "ESRI",
    "auth_id": "112058",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67037,
    "description": "OSGB36_National_Highways_B15H3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.0000167565995 +x_0=88036.5772555427 +y_0=111046.13722006 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007037,
    "auth_name": "ESRI",
    "auth_id": "112059",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67038,
    "description": "OSGB36_National_Highways_B16H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00001177155717 +x_0=54022.1758344197 +y_0=111045.583659641 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007038,
    "auth_name": "ESRI",
    "auth_id": "112060",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67039,
    "description": "OSGB36_National_Highways_B16H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000036772789 +x_0=54023.5264394632 +y_0=111048.359903341 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007039,
    "auth_name": "ESRI",
    "auth_id": "112061",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67040,
    "description": "OSGB36_National_Highways_B16H3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00006177527098 +x_0=54024.8771120413 +y_0=111051.136285863 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007040,
    "auth_name": "ESRI",
    "auth_id": "112062",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67041,
    "description": "OSGB36_National_Highways_B16H4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00008677900318 +x_0=54026.2278521588 +y_0=111053.912807215 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007041,
    "auth_name": "ESRI",
    "auth_id": "112063",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67042,
    "description": "OSGB36_National_Highways_B17H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999980759810937 +x_0=-24009.1113476146 +y_0=111042.139982718 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007042,
    "auth_name": "ESRI",
    "auth_id": "112064",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67043,
    "description": "OSGB36_National_Highways_B17H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00000576026745 +x_0=-24009.7115979077 +y_0=111044.916140323 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007043,
    "auth_name": "ESRI",
    "auth_id": "112065",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67044,
    "description": "OSGB36_National_Highways_B18H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99992774418376 +x_0=-58018.9429571512 +y_0=111036.252900755 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007044,
    "auth_name": "ESRI",
    "auth_id": "112066",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67045,
    "description": "OSGB36_National_Highways_B18H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999952743314832 +x_0=-58020.3934851199 +y_0=111039.028911178 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007045,
    "auth_name": "ESRI",
    "auth_id": "112067",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67046,
    "description": "OSGB36_National_Highways_B19H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999873734042937 +x_0=-88023.9862501752 +y_0=111030.255383744 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007046,
    "auth_name": "ESRI",
    "auth_id": "112068",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67047,
    "description": "OSGB36_National_Highways_B20H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99982572992683 +x_0=-105023.57751484 +y_0=111024.924801402 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007047,
    "auth_name": "ESRI",
    "auth_id": "112069",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67048,
    "description": "OSGB36_National_Highways_B21H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999770730876833 +x_0=-122020.682266179 +y_0=111018.817471687 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007048,
    "auth_name": "ESRI",
    "auth_id": "112070",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67049,
    "description": "OSGB36_National_Highways_B22H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99970873920231 +x_0=-139014.943941393 +y_0=111011.933651041 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007049,
    "auth_name": "ESRI",
    "auth_id": "112071",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67050,
    "description": "OSGB36_National_Highways_B23H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999655752413687 +x_0=-156008.502381475 +y_0=111006.049771434 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007050,
    "auth_name": "ESRI",
    "auth_id": "112072",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67051,
    "description": "OSGB36_National_Highways_B24H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999613766872086 +x_0=-165002.062525782 +y_0=111001.387517344 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007051,
    "auth_name": "ESRI",
    "auth_id": "112073",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67052,
    "description": "OSGB36_National_Highways_B25H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999564788197464 +x_0=-175993.57634226 +y_0=110995.948715857 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007052,
    "auth_name": "ESRI",
    "auth_id": "112074",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67053,
    "description": "OSGB36_National_Highways_B26H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999516813741153 +x_0=-185984.284553461 +y_0=110990.621427066 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007053,
    "auth_name": "ESRI",
    "auth_id": "112075",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67054,
    "description": "OSGB36_National_Highways_B27H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999466845245835 +x_0=-195973.641905265 +y_0=110985.072711655 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007054,
    "auth_name": "ESRI",
    "auth_id": "112076",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67055,
    "description": "OSGB36_National_Highways_B28H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999415882527346 +x_0=-205961.794596858 +y_0=110979.413593453 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007055,
    "auth_name": "ESRI",
    "auth_id": "112077",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67056,
    "description": "OSGB36_National_Highways_B29H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999366923242045 +x_0=-214949.594983633 +y_0=110973.976945039 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007056,
    "auth_name": "ESRI",
    "auth_id": "112078",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67057,
    "description": "OSGB36_National_Highways_B30H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999314971695549 +x_0=-223935.843217878 +y_0=110968.208023145 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007057,
    "auth_name": "ESRI",
    "auth_id": "112079",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67058,
    "description": "OSGB36_National_Highways_B31H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999261027729297 +x_0=-232920.691532296 +y_0=110962.217854441 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007058,
    "auth_name": "ESRI",
    "auth_id": "112080",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67059,
    "description": "OSGB36_National_Highways_B32H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999206090787045 +x_0=-241904.32807196 +y_0=110956.117421436 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007059,
    "auth_name": "ESRI",
    "auth_id": "112081",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67060,
    "description": "OSGB36_National_Highways_C13H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999865733036811 +x_0=128033.864553868 +y_0=126033.335420214 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007060,
    "auth_name": "ESRI",
    "auth_id": "112082",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67061,
    "description": "OSGB36_National_Highways_C14H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999913740994384 +x_0=111034.697926722 +y_0=126039.386835739 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007061,
    "auth_name": "ESRI",
    "auth_id": "112083",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67062,
    "description": "OSGB36_National_Highways_C14H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999938739775363 +x_0=111037.473898269 +y_0=126042.537938576 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007062,
    "auth_name": "ESRI",
    "auth_id": "112084",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67063,
    "description": "OSGB36_National_Highways_C14H3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99996373980636 +x_0=111040.250008623 +y_0=126045.689198978 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007063,
    "auth_name": "ESRI",
    "auth_id": "112085",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67064,
    "description": "OSGB36_National_Highways_C14H4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999988741087467 +x_0=111043.026257796 +y_0=126048.840616957 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007064,
    "auth_name": "ESRI",
    "auth_id": "112086",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67065,
    "description": "OSGB36_National_Highways_C15H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999966755136649 +x_0=88032.1753716564 +y_0=126046.069282144 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007065,
    "auth_name": "ESRI",
    "auth_id": "112087",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67066,
    "description": "OSGB36_National_Highways_C15H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999991755243032 +x_0=88034.3762585739 +y_0=126049.220552049 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007066,
    "auth_name": "ESRI",
    "auth_id": "112088",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67067,
    "description": "OSGB36_National_Highways_C15H3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.0000167565995 +x_0=88036.5772555427 +y_0=126052.371979527 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007067,
    "auth_name": "ESRI",
    "auth_id": "112089",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67068,
    "description": "OSGB36_National_Highways_C15H4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00004175920614 +x_0=88038.778362571 +y_0=126055.52356459 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007068,
    "auth_name": "ESRI",
    "auth_id": "112090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67069,
    "description": "OSGB36_National_Highways_C15H5",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00006676306306 +x_0=88040.9795796669 +y_0=126058.67530725 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007069,
    "auth_name": "ESRI",
    "auth_id": "112091",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67070,
    "description": "OSGB36_National_Highways_C16H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00001177155717 +x_0=54022.1758344197 +y_0=126051.743613646 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007070,
    "auth_name": "ESRI",
    "auth_id": "112092",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67071,
    "description": "OSGB36_National_Highways_C16H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.000036772789 +x_0=54023.5264394632 +y_0=126054.895025414 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007071,
    "auth_name": "ESRI",
    "auth_id": "112093",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67072,
    "description": "OSGB36_National_Highways_C16H3",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00006177527098 +x_0=54024.8771120413 +y_0=126058.046594763 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007072,
    "auth_name": "ESRI",
    "auth_id": "112094",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67073,
    "description": "OSGB36_National_Highways_C16H4",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00008677900318 +x_0=54026.2278521588 +y_0=126061.198321704 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007073,
    "auth_name": "ESRI",
    "auth_id": "112095",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67074,
    "description": "OSGB36_National_Highways_C17H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999980759810937 +x_0=-24009.1113476146 +y_0=126047.834574977 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007074,
    "auth_name": "ESRI",
    "auth_id": "112096",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67075,
    "description": "OSGB36_National_Highways_C17H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=1.00000576026745 +x_0=-24009.7115979077 +y_0=126050.985889015 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007075,
    "auth_name": "ESRI",
    "auth_id": "112097",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67076,
    "description": "OSGB36_National_Highways_C18H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.99992774418376 +x_0=-58018.9429571512 +y_0=126041.151941397 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007076,
    "auth_name": "ESRI",
    "auth_id": "112098",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67077,
    "description": "OSGB36_National_Highways_C18H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999952743314832 +x_0=-58020.3934851199 +y_0=126044.303088364 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007077,
    "auth_name": "ESRI",
    "auth_id": "112099",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67078,
    "description": "OSGB36_National_Highways_C19H1",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999873734042937 +x_0=-88023.9862501752 +y_0=126034.343949115 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007078,
    "auth_name": "ESRI",
    "auth_id": "112100",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67079,
    "description": "OSGB36_National_Highways_C19H2",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999898731823705 +x_0=-88026.1869323571 +y_0=126037.494925875 +ellps=airy +towgs84=446,-99,544,0.945,0.261,0.435,-20.8927 +units=m +no_defs",
    "srid": 520007079,
    "auth_name": "ESRI",
    "auth_id": "112101",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67096,
    "description": "Borrelly (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=4220 +units=m +no_defs",
    "srid": 520007096,
    "auth_name": "IAU_2015",
    "auth_id": "100000590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67097,
    "description": "Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1650 +units=m +no_defs",
    "srid": 520007097,
    "auth_name": "IAU_2015",
    "auth_id": "100001290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67098,
    "description": "Halley (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=8000 +units=m +no_defs",
    "srid": 520007098,
    "auth_name": "IAU_2015",
    "auth_id": "100003690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67099,
    "description": "Halley (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=8000 +b=4000 +units=m +no_defs",
    "srid": 520007099,
    "auth_name": "IAU_2015",
    "auth_id": "100003691",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67100,
    "description": "Hartley 2 (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=580 +units=m +no_defs",
    "srid": 520007100,
    "auth_name": "IAU_2015",
    "auth_id": "100004190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67101,
    "description": "Tempel 1 (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3000 +units=m +no_defs",
    "srid": 520007101,
    "auth_name": "IAU_2015",
    "auth_id": "100009390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67102,
    "description": "Wild 2 (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1975 +units=m +no_defs",
    "srid": 520007102,
    "auth_name": "IAU_2015",
    "auth_id": "100010790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67103,
    "description": "Sun (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=695700000 +units=m +no_defs",
    "srid": 520007103,
    "auth_name": "IAU_2015",
    "auth_id": "1090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67104,
    "description": "Mercury (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2440530 +units=m +no_defs",
    "srid": 520007104,
    "auth_name": "IAU_2015",
    "auth_id": "19990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67105,
    "description": "Mercury (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520007105,
    "auth_name": "IAU_2015",
    "auth_id": "19991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67106,
    "description": "Mercury (2015) / Ocentric / Mercator",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=2440530 +b=2438260 +units=m +no_defs",
    "srid": 520007106,
    "auth_name": "IAU_2015",
    "auth_id": "19992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67107,
    "description": "Ceres (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=487300 +units=m +no_defs",
    "srid": 520007107,
    "auth_name": "IAU_2015",
    "auth_id": "200000190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67108,
    "description": "Ceres (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=487300 +b=446000 +units=m +no_defs",
    "srid": 520007108,
    "auth_name": "IAU_2015",
    "auth_id": "200000191",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67109,
    "description": "Vesta (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=255000 +units=m +no_defs",
    "srid": 520007109,
    "auth_name": "IAU_2015",
    "auth_id": "200000490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67110,
    "description": "Psyche (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=113000 +units=m +no_defs",
    "srid": 520007110,
    "auth_name": "IAU_2015",
    "auth_id": "200001690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67111,
    "description": "Lutetia (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=52500 +units=m +no_defs",
    "srid": 520007111,
    "auth_name": "IAU_2015",
    "auth_id": "200002190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67112,
    "description": "52 Europa (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=157500 +units=m +no_defs",
    "srid": 520007112,
    "auth_name": "IAU_2015",
    "auth_id": "200005290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67113,
    "description": "Kleopatra (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=65333.333333 +units=m +no_defs",
    "srid": 520007113,
    "auth_name": "IAU_2015",
    "auth_id": "200021690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67114,
    "description": "Mathilde (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=26500 +units=m +no_defs",
    "srid": 520007114,
    "auth_name": "IAU_2015",
    "auth_id": "200025390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67115,
    "description": "Eros (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=17000 +units=m +no_defs",
    "srid": 520007115,
    "auth_name": "IAU_2015",
    "auth_id": "200043390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67116,
    "description": "Eros (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=17000 +b=5500 +units=m +no_defs",
    "srid": 520007116,
    "auth_name": "IAU_2015",
    "auth_id": "200043391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67117,
    "description": "Davida (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=150000 +units=m +no_defs",
    "srid": 520007117,
    "auth_name": "IAU_2015",
    "auth_id": "200051190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67118,
    "description": "Steins (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2700 +units=m +no_defs",
    "srid": 520007118,
    "auth_name": "IAU_2015",
    "auth_id": "200286790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67119,
    "description": "Toutatis (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1331.666667 +units=m +no_defs",
    "srid": 520007119,
    "auth_name": "IAU_2015",
    "auth_id": "200417990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67120,
    "description": "Itokawa (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=173 +units=m +no_defs",
    "srid": 520007120,
    "auth_name": "IAU_2015",
    "auth_id": "202514390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67121,
    "description": "Ida (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15650 +units=m +no_defs",
    "srid": 520007121,
    "auth_name": "IAU_2015",
    "auth_id": "243101090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67122,
    "description": "Venus (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6051800 +units=m +no_defs",
    "srid": 520007122,
    "auth_name": "IAU_2015",
    "auth_id": "29990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67123,
    "description": "Moon (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1737400 +units=m +no_defs",
    "srid": 520007123,
    "auth_name": "IAU_2015",
    "auth_id": "30190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67124,
    "description": "Earth (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6378136.6 +units=m +no_defs",
    "srid": 520007124,
    "auth_name": "IAU_2015",
    "auth_id": "39990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67125,
    "description": "Earth (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6378136.6 +b=6356751.9 +units=m +no_defs",
    "srid": 520007125,
    "auth_name": "IAU_2015",
    "auth_id": "39991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67126,
    "description": "Phobos (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=11080 +units=m +no_defs",
    "srid": 520007126,
    "auth_name": "IAU_2015",
    "auth_id": "40190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67127,
    "description": "Deimos (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6200 +units=m +no_defs",
    "srid": 520007127,
    "auth_name": "IAU_2015",
    "auth_id": "40290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67128,
    "description": "Mars (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3396190 +units=m +no_defs",
    "srid": 520007128,
    "auth_name": "IAU_2015",
    "auth_id": "49990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67129,
    "description": "Mars (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520007129,
    "auth_name": "IAU_2015",
    "auth_id": "49991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67130,
    "description": "Mars (2015) / Ocentric / Mercator",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=3396190 +b=3376200 +units=m +no_defs",
    "srid": 520007130,
    "auth_name": "IAU_2015",
    "auth_id": "49992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67131,
    "description": "Io (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1821490 +units=m +no_defs",
    "srid": 520007131,
    "auth_name": "IAU_2015",
    "auth_id": "50190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67132,
    "description": "Europa (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1560800 +units=m +no_defs",
    "srid": 520007132,
    "auth_name": "IAU_2015",
    "auth_id": "50290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67133,
    "description": "Ganymede (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520007133,
    "auth_name": "IAU_2015",
    "auth_id": "50390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67134,
    "description": "Ganymede (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2631200 +units=m +no_defs",
    "srid": 520007134,
    "auth_name": "IAU_2015",
    "auth_id": "50391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67135,
    "description": "Callisto (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520007135,
    "auth_name": "IAU_2015",
    "auth_id": "50490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67136,
    "description": "Callisto (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2410300 +units=m +no_defs",
    "srid": 520007136,
    "auth_name": "IAU_2015",
    "auth_id": "50491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67137,
    "description": "Amalthea (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=83500 +units=m +no_defs",
    "srid": 520007137,
    "auth_name": "IAU_2015",
    "auth_id": "50590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67138,
    "description": "Himalia (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=85000 +units=m +no_defs",
    "srid": 520007138,
    "auth_name": "IAU_2015",
    "auth_id": "50690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67139,
    "description": "Elara (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520007139,
    "auth_name": "IAU_2015",
    "auth_id": "50790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67140,
    "description": "Pasiphae (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520007140,
    "auth_name": "IAU_2015",
    "auth_id": "50890",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67141,
    "description": "Sinope (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520007141,
    "auth_name": "IAU_2015",
    "auth_id": "50990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67142,
    "description": "Lysithea (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=12000 +units=m +no_defs",
    "srid": 520007142,
    "auth_name": "IAU_2015",
    "auth_id": "51090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67143,
    "description": "Carme (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520007143,
    "auth_name": "IAU_2015",
    "auth_id": "51190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67144,
    "description": "Ananke (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=10000 +units=m +no_defs",
    "srid": 520007144,
    "auth_name": "IAU_2015",
    "auth_id": "51290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67145,
    "description": "Leda (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=5000 +units=m +no_defs",
    "srid": 520007145,
    "auth_name": "IAU_2015",
    "auth_id": "51390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67146,
    "description": "Thebe (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=49300 +units=m +no_defs",
    "srid": 520007146,
    "auth_name": "IAU_2015",
    "auth_id": "51490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67147,
    "description": "Adrastea (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=8200 +units=m +no_defs",
    "srid": 520007147,
    "auth_name": "IAU_2015",
    "auth_id": "51590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67148,
    "description": "Metis (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=21500 +units=m +no_defs",
    "srid": 520007148,
    "auth_name": "IAU_2015",
    "auth_id": "51690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67149,
    "description": "Jupiter (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=71492000 +units=m +no_defs",
    "srid": 520007149,
    "auth_name": "IAU_2015",
    "auth_id": "59990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67150,
    "description": "Jupiter (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520007150,
    "auth_name": "IAU_2015",
    "auth_id": "59991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67151,
    "description": "Jupiter (2015) / Ocentric / Mercator",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=71492000 +b=66854000 +units=m +no_defs",
    "srid": 520007151,
    "auth_name": "IAU_2015",
    "auth_id": "59992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67152,
    "description": "Mimas (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=198200 +units=m +no_defs",
    "srid": 520007152,
    "auth_name": "IAU_2015",
    "auth_id": "60190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67153,
    "description": "Enceladus (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=252100 +units=m +no_defs",
    "srid": 520007153,
    "auth_name": "IAU_2015",
    "auth_id": "60290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67154,
    "description": "Tethys (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=531000 +units=m +no_defs",
    "srid": 520007154,
    "auth_name": "IAU_2015",
    "auth_id": "60390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67155,
    "description": "Dione (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=561400 +units=m +no_defs",
    "srid": 520007155,
    "auth_name": "IAU_2015",
    "auth_id": "60490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67156,
    "description": "Rhea (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=763500 +units=m +no_defs",
    "srid": 520007156,
    "auth_name": "IAU_2015",
    "auth_id": "60590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67157,
    "description": "Titan (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2575000 +units=m +no_defs",
    "srid": 520007157,
    "auth_name": "IAU_2015",
    "auth_id": "60690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67158,
    "description": "Hyperion (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=135000 +units=m +no_defs",
    "srid": 520007158,
    "auth_name": "IAU_2015",
    "auth_id": "60790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67159,
    "description": "Iapetus (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=745700 +units=m +no_defs",
    "srid": 520007159,
    "auth_name": "IAU_2015",
    "auth_id": "60890",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67160,
    "description": "Iapetus (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520007160,
    "auth_name": "IAU_2015",
    "auth_id": "60891",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67161,
    "description": "Iapetus (2015) / Ocentric / Mercator",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=745700 +b=712100 +units=m +no_defs",
    "srid": 520007161,
    "auth_name": "IAU_2015",
    "auth_id": "60892",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67162,
    "description": "Phoebe (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=106500 +units=m +no_defs",
    "srid": 520007162,
    "auth_name": "IAU_2015",
    "auth_id": "60990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67163,
    "description": "Janus (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=89200 +units=m +no_defs",
    "srid": 520007163,
    "auth_name": "IAU_2015",
    "auth_id": "61090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67164,
    "description": "Epimetheus (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=58200 +units=m +no_defs",
    "srid": 520007164,
    "auth_name": "IAU_2015",
    "auth_id": "61190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67165,
    "description": "Helene (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=18000 +units=m +no_defs",
    "srid": 520007165,
    "auth_name": "IAU_2015",
    "auth_id": "61290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67166,
    "description": "Telesto (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=12400 +units=m +no_defs",
    "srid": 520007166,
    "auth_name": "IAU_2015",
    "auth_id": "61390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67167,
    "description": "Calypso (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=9600 +units=m +no_defs",
    "srid": 520007167,
    "auth_name": "IAU_2015",
    "auth_id": "61490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67168,
    "description": "Atlas (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15100 +units=m +no_defs",
    "srid": 520007168,
    "auth_name": "IAU_2015",
    "auth_id": "61590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67169,
    "description": "Prometheus (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=43100 +units=m +no_defs",
    "srid": 520007169,
    "auth_name": "IAU_2015",
    "auth_id": "61690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67170,
    "description": "Pandora (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40600 +units=m +no_defs",
    "srid": 520007170,
    "auth_name": "IAU_2015",
    "auth_id": "61790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67171,
    "description": "Pan (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=14000 +units=m +no_defs",
    "srid": 520007171,
    "auth_name": "IAU_2015",
    "auth_id": "61890",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67172,
    "description": "Methone (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1450 +units=m +no_defs",
    "srid": 520007172,
    "auth_name": "IAU_2015",
    "auth_id": "63290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67173,
    "description": "Pallene (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=2230 +units=m +no_defs",
    "srid": 520007173,
    "auth_name": "IAU_2015",
    "auth_id": "63390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67174,
    "description": "Polydeuces (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1300 +units=m +no_defs",
    "srid": 520007174,
    "auth_name": "IAU_2015",
    "auth_id": "63490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67175,
    "description": "Daphnis (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=3800 +units=m +no_defs",
    "srid": 520007175,
    "auth_name": "IAU_2015",
    "auth_id": "63590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67176,
    "description": "Anthe (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=500 +units=m +no_defs",
    "srid": 520007176,
    "auth_name": "IAU_2015",
    "auth_id": "64990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67177,
    "description": "Aegaeon (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=330 +units=m +no_defs",
    "srid": 520007177,
    "auth_name": "IAU_2015",
    "auth_id": "65390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67178,
    "description": "Saturn (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=60268000 +units=m +no_defs",
    "srid": 520007178,
    "auth_name": "IAU_2015",
    "auth_id": "69990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67179,
    "description": "Saturn (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520007179,
    "auth_name": "IAU_2015",
    "auth_id": "69991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67180,
    "description": "Saturn (2015) / Ocentric / Mercator",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=60268000 +b=54364000 +units=m +no_defs",
    "srid": 520007180,
    "auth_name": "IAU_2015",
    "auth_id": "69992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67181,
    "description": "Ariel (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=578900 +units=m +no_defs",
    "srid": 520007181,
    "auth_name": "IAU_2015",
    "auth_id": "70190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67182,
    "description": "Umbriel (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=584700 +units=m +no_defs",
    "srid": 520007182,
    "auth_name": "IAU_2015",
    "auth_id": "70290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67183,
    "description": "Titania (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=788900 +units=m +no_defs",
    "srid": 520007183,
    "auth_name": "IAU_2015",
    "auth_id": "70390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67184,
    "description": "Oberon (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=761400 +units=m +no_defs",
    "srid": 520007184,
    "auth_name": "IAU_2015",
    "auth_id": "70490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67185,
    "description": "Miranda (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=235800 +units=m +no_defs",
    "srid": 520007185,
    "auth_name": "IAU_2015",
    "auth_id": "70590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67186,
    "description": "Cordelia (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=13000 +units=m +no_defs",
    "srid": 520007186,
    "auth_name": "IAU_2015",
    "auth_id": "70690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67187,
    "description": "Ophelia (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=15000 +units=m +no_defs",
    "srid": 520007187,
    "auth_name": "IAU_2015",
    "auth_id": "70790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67188,
    "description": "Bianca (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=21000 +units=m +no_defs",
    "srid": 520007188,
    "auth_name": "IAU_2015",
    "auth_id": "70890",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67189,
    "description": "Cressida (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=31000 +units=m +no_defs",
    "srid": 520007189,
    "auth_name": "IAU_2015",
    "auth_id": "70990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67190,
    "description": "Desdemona (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520007190,
    "auth_name": "IAU_2015",
    "auth_id": "71090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67191,
    "description": "Juliet (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=42000 +units=m +no_defs",
    "srid": 520007191,
    "auth_name": "IAU_2015",
    "auth_id": "71190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67192,
    "description": "Portia (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=54000 +units=m +no_defs",
    "srid": 520007192,
    "auth_name": "IAU_2015",
    "auth_id": "71290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67193,
    "description": "Rosalind (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=27000 +units=m +no_defs",
    "srid": 520007193,
    "auth_name": "IAU_2015",
    "auth_id": "71390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67194,
    "description": "Belinda (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=33000 +units=m +no_defs",
    "srid": 520007194,
    "auth_name": "IAU_2015",
    "auth_id": "71490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67195,
    "description": "Puck (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=77000 +units=m +no_defs",
    "srid": 520007195,
    "auth_name": "IAU_2015",
    "auth_id": "71590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67196,
    "description": "Uranus (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=25559000 +units=m +no_defs",
    "srid": 520007196,
    "auth_name": "IAU_2015",
    "auth_id": "79990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67197,
    "description": "Uranus (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=25559000 +b=24973000 +units=m +no_defs",
    "srid": 520007197,
    "auth_name": "IAU_2015",
    "auth_id": "79991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67198,
    "description": "Triton (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1352600 +units=m +no_defs",
    "srid": 520007198,
    "auth_name": "IAU_2015",
    "auth_id": "80190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67199,
    "description": "Nereid (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=170000 +units=m +no_defs",
    "srid": 520007199,
    "auth_name": "IAU_2015",
    "auth_id": "80290",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67200,
    "description": "Naiad (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520007200,
    "auth_name": "IAU_2015",
    "auth_id": "80390",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67201,
    "description": "Naiad (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=29000 +units=m +no_defs",
    "srid": 520007201,
    "auth_name": "IAU_2015",
    "auth_id": "80391",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67202,
    "description": "Thalassa (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520007202,
    "auth_name": "IAU_2015",
    "auth_id": "80490",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67203,
    "description": "Thalassa (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=40000 +units=m +no_defs",
    "srid": 520007203,
    "auth_name": "IAU_2015",
    "auth_id": "80491",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67204,
    "description": "Despina (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520007204,
    "auth_name": "IAU_2015",
    "auth_id": "80590",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67205,
    "description": "Despina (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=74000 +units=m +no_defs",
    "srid": 520007205,
    "auth_name": "IAU_2015",
    "auth_id": "80591",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67206,
    "description": "Galatea (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520007206,
    "auth_name": "IAU_2015",
    "auth_id": "80690",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67207,
    "description": "Galatea (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=79000 +units=m +no_defs",
    "srid": 520007207,
    "auth_name": "IAU_2015",
    "auth_id": "80691",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67208,
    "description": "Larissa (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=96000 +units=m +no_defs",
    "srid": 520007208,
    "auth_name": "IAU_2015",
    "auth_id": "80790",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67209,
    "description": "Larissa (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520007209,
    "auth_name": "IAU_2015",
    "auth_id": "80791",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67210,
    "description": "Larissa (2015) / Ocentric / Mercator",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=96000 +b=89000 +units=m +no_defs",
    "srid": 520007210,
    "auth_name": "IAU_2015",
    "auth_id": "80792",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67211,
    "description": "Proteus (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=208000 +units=m +no_defs",
    "srid": 520007211,
    "auth_name": "IAU_2015",
    "auth_id": "80890",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67212,
    "description": "Neptune (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=24764000 +units=m +no_defs",
    "srid": 520007212,
    "auth_name": "IAU_2015",
    "auth_id": "89990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67213,
    "description": "Neptune (2015) / Ographic / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520007213,
    "auth_name": "IAU_2015",
    "auth_id": "89991",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67214,
    "description": "Neptune (2015) / Ocentric / Mercator",
    "projection_acronym": "",
    "ellipsoid_acronym": "",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=24764000 +b=24341000 +units=m +no_defs",
    "srid": 520007214,
    "auth_name": "IAU_2015",
    "auth_id": "89992",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67215,
    "description": "Charon (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=606000 +units=m +no_defs",
    "srid": 520007215,
    "auth_name": "IAU_2015",
    "auth_id": "90190",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67216,
    "description": "Gaspra (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=6100 +units=m +no_defs",
    "srid": 520007216,
    "auth_name": "IAU_2015",
    "auth_id": "951101090",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67217,
    "description": "Pluto (2015) - Sphere / Ocentric / Mercator",
    "projection_acronym": "merc",
    "ellipsoid_acronym": "merc",
    "parameters": "+proj=merc +R_C +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R=1188300 +units=m +no_defs",
    "srid": 520007217,
    "auth_name": "IAU_2015",
    "auth_id": "99990",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67218,
    "description": "Hughes 1980",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +a=6378273 +b=6356889.449 +no_defs",
    "srid": 520007218,
    "auth_name": "EPSG",
    "auth_id": "10345",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 67219,
    "description": "NSIDC Authalic Sphere",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +R=6371228 +no_defs",
    "srid": 520007219,
    "auth_name": "EPSG",
    "auth_id": "10346",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 67224,
    "description": "ETRS89 + Formentera height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520007224,
    "auth_name": "EPSG",
    "auth_id": "10355",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 67225,
    "description": "ETRS89 + Alboran height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520007225,
    "auth_name": "EPSG",
    "auth_id": "10356",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 67226,
    "description": "ETRS89 + Melilla height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +geoidgrids=es_ign_egm08-rednap.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520007226,
    "auth_name": "EPSG",
    "auth_id": "10357",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 67228,
    "description": "KGD2002 + KVD1964 height",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +vunits=m +no_defs",
    "srid": 520007228,
    "auth_name": "EPSG",
    "auth_id": "10365",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 67239,
    "description": "NAD83(CSRS)v8",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=GRS80 +units=m +no_defs",
    "srid": 520007239,
    "auth_name": "EPSG",
    "auth_id": "10412",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 67240,
    "description": "NAD83(CSRS)v8",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520007240,
    "auth_name": "EPSG",
    "auth_id": "10413",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 67241,
    "description": "NAD83(CSRS)v8",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520007241,
    "auth_name": "EPSG",
    "auth_id": "10414",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 67242,
    "description": "GDA94 / ALB94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=117.883333333333 +k=1.0000044 +x_0=50000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007242,
    "auth_name": "EPSG",
    "auth_id": "10448",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67243,
    "description": "GDA94 / BIO94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.25 +k=1.0000022 +x_0=60000 +y_0=2600000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007243,
    "auth_name": "EPSG",
    "auth_id": "10449",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67244,
    "description": "GDA94 / BRO94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=122.333333333333 +k=1.00000298 +x_0=50000 +y_0=2200000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007244,
    "auth_name": "EPSG",
    "auth_id": "10450",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67245,
    "description": "GDA94 / BCG94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.433333333333 +k=0.99999592 +x_0=50000 +y_0=3900000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007245,
    "auth_name": "EPSG",
    "auth_id": "10451",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67246,
    "description": "GDA94 / CARN94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=113.666666666667 +k=0.99999796 +x_0=50000 +y_0=2950000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007246,
    "auth_name": "EPSG",
    "auth_id": "10452",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67247,
    "description": "GDA94 / COL94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.933333333333 +k=1.000019 +x_0=40000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007247,
    "auth_name": "EPSG",
    "auth_id": "10453",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67248,
    "description": "GDA94 / ESP94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=121.883333333333 +k=1.0000055 +x_0=50000 +y_0=3950000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007248,
    "auth_name": "EPSG",
    "auth_id": "10454",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67249,
    "description": "GDA94 / EXM94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114.066666666667 +k=1.00000236 +x_0=50000 +y_0=2650000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007249,
    "auth_name": "EPSG",
    "auth_id": "10455",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67250,
    "description": "GDA94 / GCG94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114.583333333333 +k=1.00000628 +x_0=50000 +y_0=3350000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007250,
    "auth_name": "EPSG",
    "auth_id": "10456",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67251,
    "description": "GDA94 / GOLD94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=121.5 +k=1.00004949 +x_0=60000 +y_0=3700000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007251,
    "auth_name": "EPSG",
    "auth_id": "10457",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67252,
    "description": "GDA94 / JCG94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114.983333333333 +k=1.00000314 +x_0=50000 +y_0=3550000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007252,
    "auth_name": "EPSG",
    "auth_id": "10458",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67253,
    "description": "GDA94 / KALB94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=114.315277777778 +k=1.000014 +x_0=55000 +y_0=3600000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007253,
    "auth_name": "EPSG",
    "auth_id": "10459",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67254,
    "description": "GDA94 / KAR94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=116.933333333333 +k=0.9999989 +x_0=50000 +y_0=2450000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007254,
    "auth_name": "EPSG",
    "auth_id": "10460",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67255,
    "description": "GDA94 / KUN94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=128.75 +k=1.0000165 +x_0=50000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007255,
    "auth_name": "EPSG",
    "auth_id": "10461",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67256,
    "description": "GDA94 / LCG94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.366666666667 +k=1.00000157 +x_0=50000 +y_0=3650000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007256,
    "auth_name": "EPSG",
    "auth_id": "10462",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67257,
    "description": "GDA94 / MRCG94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.166666666667 +k=1.0000055 +x_0=50000 +y_0=3950000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007257,
    "auth_name": "EPSG",
    "auth_id": "10463",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67258,
    "description": "GDA94 / PCG94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=115.816666666667 +k=0.99999906 +x_0=50000 +y_0=3800000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007258,
    "auth_name": "EPSG",
    "auth_id": "10464",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67259,
    "description": "GDA94 / PHG94",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=0 +lon_0=118.6 +k=1.00000135 +x_0=50000 +y_0=2400000 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007259,
    "auth_name": "EPSG",
    "auth_id": "10465",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67260,
    "description": "COV23-IRF",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=GRS80 +no_defs",
    "srid": 520007260,
    "auth_name": "EPSG",
    "auth_id": "10468",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 67261,
    "description": "COV23 Grid",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.4 +lon_0=-1.55 +k=1 +x_0=116887.9989 +y_0=102194.9369 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007261,
    "auth_name": "EPSG",
    "auth_id": "10471",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67262,
    "description": "COV23 Grid + ODN height",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=52.4 +lon_0=-1.55 +k=1 +x_0=116887.9989 +y_0=102194.9369 +ellps=GRS80 +units=m +geoidgrids=uk_os_OSGM15_GB.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520007262,
    "auth_name": "EPSG",
    "auth_id": "10472",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 67263,
    "description": "BBT2000",
    "projection_acronym": "geocent",
    "ellipsoid_acronym": "geocent",
    "parameters": "+proj=geocent +ellps=WGS84 +units=m +no_defs",
    "srid": 520007263,
    "auth_name": "EPSG",
    "auth_id": "10473",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geocentric"
  },
  {
    "srs_id": 67264,
    "description": "BBT2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520007264,
    "auth_name": "EPSG",
    "auth_id": "10474",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic3d"
  },
  {
    "srs_id": 67265,
    "description": "BBT2000",
    "projection_acronym": "longlat",
    "ellipsoid_acronym": "longlat",
    "parameters": "+proj=longlat +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +no_defs",
    "srid": 520007265,
    "auth_name": "EPSG",
    "auth_id": "10475",
    "is_geo": 1,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Geographic2d"
  },
  {
    "srs_id": 67266,
    "description": "BBT2000 / BBT-TM",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=46.9807763055556 +lon_0=11.52849375 +k=1.000121 +x_0=20000 +y_0=100000 +ellps=WGS84 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs",
    "srid": 520007266,
    "auth_name": "EPSG",
    "auth_id": "10477",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67268,
    "description": "NAD83 / TWDB GM",
    "projection_acronym": "aea",
    "ellipsoid_acronym": "aea",
    "parameters": "+proj=aea +lat_0=31.25 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
    "srid": 520007268,
    "auth_name": "EPSG",
    "auth_id": "10481",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67269,
    "description": "RGF93 v2 / Lambert-93 + NGF-IGN69 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520007269,
    "auth_name": "EPSG",
    "auth_id": "10497",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 67270,
    "description": "RGF93 v2 / Lambert-93 + NGF-IGN78 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520007270,
    "auth_name": "EPSG",
    "auth_id": "10498",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 67271,
    "description": "RGF93 v2b / Lambert-93 + NGF-IGN69 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +vunits=m +no_defs",
    "srid": 520007271,
    "auth_name": "EPSG",
    "auth_id": "10499",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 67272,
    "description": "RGF93 v2b / Lambert-93 + NGF-IGN78 height",
    "projection_acronym": "lcc",
    "ellipsoid_acronym": "lcc",
    "parameters": "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +geoidgrids=fr_ign_RAC09.tif +geoid_crs=WGS84 +vunits=m +no_defs",
    "srid": 520007272,
    "auth_name": "EPSG",
    "auth_id": "10500",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Compound"
  },
  {
    "srs_id": 67273,
    "description": "NAD83(CSRS)v8 / UTM zone 7N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=7 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007273,
    "auth_name": "EPSG",
    "auth_id": "22807",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67274,
    "description": "NAD83(CSRS)v8 / UTM zone 8N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=8 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007274,
    "auth_name": "EPSG",
    "auth_id": "22808",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67275,
    "description": "NAD83(CSRS)v8 / UTM zone 9N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=9 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007275,
    "auth_name": "EPSG",
    "auth_id": "22809",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67276,
    "description": "NAD83(CSRS)v8 / UTM zone 10N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=10 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007276,
    "auth_name": "EPSG",
    "auth_id": "22810",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67277,
    "description": "NAD83(CSRS)v8 / UTM zone 11N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=11 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007277,
    "auth_name": "EPSG",
    "auth_id": "22811",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67278,
    "description": "NAD83(CSRS)v8 / UTM zone 12N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=12 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007278,
    "auth_name": "EPSG",
    "auth_id": "22812",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67279,
    "description": "NAD83(CSRS)v8 / UTM zone 13N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=13 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007279,
    "auth_name": "EPSG",
    "auth_id": "22813",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67280,
    "description": "NAD83(CSRS)v8 / UTM zone 14N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007280,
    "auth_name": "EPSG",
    "auth_id": "22814",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67281,
    "description": "NAD83(CSRS)v8 / UTM zone 15N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=15 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007281,
    "auth_name": "EPSG",
    "auth_id": "22815",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67282,
    "description": "NAD83(CSRS)v8 / UTM zone 16N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=16 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007282,
    "auth_name": "EPSG",
    "auth_id": "22816",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67283,
    "description": "NAD83(CSRS)v8 / UTM zone 17N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=17 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007283,
    "auth_name": "EPSG",
    "auth_id": "22817",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67284,
    "description": "NAD83(CSRS)v8 / UTM zone 18N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=18 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007284,
    "auth_name": "EPSG",
    "auth_id": "22818",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67285,
    "description": "NAD83(CSRS)v8 / UTM zone 19N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=19 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007285,
    "auth_name": "EPSG",
    "auth_id": "22819",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67286,
    "description": "NAD83(CSRS)v8 / UTM zone 20N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=20 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007286,
    "auth_name": "EPSG",
    "auth_id": "22820",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67287,
    "description": "NAD83(CSRS)v8 / UTM zone 21N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=21 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007287,
    "auth_name": "EPSG",
    "auth_id": "22821",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67288,
    "description": "NAD83(CSRS)v8 / UTM zone 22N",
    "projection_acronym": "utm",
    "ellipsoid_acronym": "utm",
    "parameters": "+proj=utm +zone=22 +ellps=GRS80 +units=m +no_defs",
    "srid": 520007288,
    "auth_name": "EPSG",
    "auth_id": "22822",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  },
  {
    "srs_id": 67289,
    "description": "NAD_1983_2011_Nebraska_LDP_Douglas-Sarpy_County_Ft_Intl",
    "projection_acronym": "tmerc",
    "ellipsoid_acronym": "tmerc",
    "parameters": "+proj=tmerc +lat_0=41.1833333333333 +lon_0=-96.05 +k=1.0000482 +x_0=40000 +y_0=25000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=ft +no_defs",
    "srid": 520007289,
    "auth_name": "ESRI",
    "auth_id": "103897",
    "is_geo": 0,
    "deprecated": 0,
    "noupdate": null,
    "lat1": null,
    "wkt": null,
    "srs_type": "Projected"
  }
]

export default epsgs;